(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("PHezF", function(module, exports) {

$parcel$export(module.exports, "addExtensionMethods", () => addExtensionMethods);

var $gUaXH = parcelRequire("gUaXH");
var $dtmCD = parcelRequire("dtmCD");

var $8upap = parcelRequire("8upap");
/**
 * @private
 */ function _autoloadDatabaseIntegrations() {
    const carrier = (0, $gUaXH.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    const packageToIntegrationMapping = {
        mongodb () {
            const integration = (0, $8upap.dynamicRequire)(module, './node/integrations/mongo');
            return new integration.Mongo();
        },
        mongoose () {
            const integration = (0, $8upap.dynamicRequire)(module, './node/integrations/mongo');
            return new integration.Mongo();
        },
        mysql () {
            const integration = (0, $8upap.dynamicRequire)(module, './node/integrations/mysql');
            return new integration.Mysql();
        },
        pg () {
            const integration = (0, $8upap.dynamicRequire)(module, './node/integrations/postgres');
            return new integration.Postgres();
        }
    };
    const mappedPackages = Object.keys(packageToIntegrationMapping).filter((moduleName)=>!!(0, $8upap.loadModule)(moduleName)).map((pkg)=>{
        try {
            return packageToIntegrationMapping[pkg]();
        } catch (e) {
            return undefined;
        }
    }).filter((p)=>p);
    if (mappedPackages.length > 0) carrier.__SENTRY__.integrations = [
        ...carrier.__SENTRY__.integrations || [],
        ...mappedPackages
    ];
}
/**
 * This patches the global object and injects the Tracing extensions methods
 */ function addExtensionMethods() {
    (0, $dtmCD.addTracingExtensions)();
    // Detect and automatically load specified integrations.
    if ((0, $8upap.isNodeEnv)()) _autoloadDatabaseIntegrations();
}

});
parcelRegister("gUaXH", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", () => $c4ea612155b0bcfa$export$19eade501500c6c1);
$parcel$export(module.exports, "getCurrentHub", () => $c4ea612155b0bcfa$export$a07cdf6544bbd7c);
$parcel$export(module.exports, "getIsolationScope", () => $c4ea612155b0bcfa$export$68f3af03034c9e90);
$parcel$export(module.exports, "runWithAsyncContext", () => $c4ea612155b0bcfa$export$70d775fb1f267027);

var $5QZE4 = parcelRequire("5QZE4");
var $HgoiY = parcelRequire("HgoiY");
var $cQg0t = parcelRequire("cQg0t");
var $7htw4 = parcelRequire("7htw4");
var $6HS3j = parcelRequire("6HS3j");

var $90wf6 = parcelRequire("90wf6");

var $cEq52 = parcelRequire("cEq52");

var $lRonC = parcelRequire("lRonC");

var $8ZYx3 = parcelRequire("8ZYx3");

var $bxlWE = parcelRequire("bxlWE");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $c4ea612155b0bcfa$export$24a86ef7798177e4 = parseFloat((0, $bxlWE.SDK_VERSION));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $c4ea612155b0bcfa$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $c4ea612155b0bcfa$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $c4ea612155b0bcfa$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $lRonC.Scope)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $lRonC.Scope)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $5QZE4.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $HgoiY.uuid4)();
        const syntheticException = new Error('Sentry syntheticException');
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $HgoiY.uuid4)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $HgoiY.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $c4ea612155b0bcfa$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $cQg0t.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $7htw4.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $c4ea612155b0bcfa$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $c4ea612155b0bcfa$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);
        if ((0, $cEq52.DEBUG_BUILD) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $7htw4.logger).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $7htw4.logger).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod('traceHeaders');
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $8ZYx3.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $90wf6.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $6HS3j.GLOBAL_OBJ).navigator || {};
        const session = (0, $8ZYx3.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === 'ok') (0, $8ZYx3.updateSession)(currentSession, {
            status: 'exited'
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $c4ea612155b0bcfa$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $c4ea612155b0bcfa$export$19eade501500c6c1() {
    (0, $6HS3j.GLOBAL_OBJ).__SENTRY__ = (0, $6HS3j.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $6HS3j.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $c4ea612155b0bcfa$export$4188a14ad302d1bc(hub) {
    const registry = $c4ea612155b0bcfa$export$19eade501500c6c1();
    const oldHub = $c4ea612155b0bcfa$export$bfa8a924a84a76b7(registry);
    $c4ea612155b0bcfa$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $c4ea612155b0bcfa$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $c4ea612155b0bcfa$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $c4ea612155b0bcfa$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $c4ea612155b0bcfa$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $c4ea612155b0bcfa$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $c4ea612155b0bcfa$var$getGlobalHub(registry = $c4ea612155b0bcfa$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$c4ea612155b0bcfa$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $c4ea612155b0bcfa$export$bfa8a924a84a76b7(registry).isOlderThan($c4ea612155b0bcfa$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $c4ea612155b0bcfa$export$849f05434e95d2f2(registry, new $c4ea612155b0bcfa$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $c4ea612155b0bcfa$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $c4ea612155b0bcfa$export$236689a79f5aa020(carrier, parent = $c4ea612155b0bcfa$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$c4ea612155b0bcfa$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $c4ea612155b0bcfa$export$bfa8a924a84a76b7(carrier).isOlderThan($c4ea612155b0bcfa$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $c4ea612155b0bcfa$export$849f05434e95d2f2(carrier, new $c4ea612155b0bcfa$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $c4ea612155b0bcfa$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $c4ea612155b0bcfa$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $c4ea612155b0bcfa$export$70d775fb1f267027(callback, options = {}) {
    const registry = $c4ea612155b0bcfa$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $c4ea612155b0bcfa$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $c4ea612155b0bcfa$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $6HS3j.getGlobalSingleton)('hub', ()=>new $c4ea612155b0bcfa$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $c4ea612155b0bcfa$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("5QZE4", function(module, exports) {

$parcel$export(module.exports, "isError", () => $4431a087fbf663bd$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $4431a087fbf663bd$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $4431a087fbf663bd$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $4431a087fbf663bd$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $4431a087fbf663bd$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $4431a087fbf663bd$export$844ec244b1367d54);
$parcel$export(module.exports, "isParameterizedString", () => $4431a087fbf663bd$export$dbcbffa59149b824);
$parcel$export(module.exports, "isPrimitive", () => $4431a087fbf663bd$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $4431a087fbf663bd$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $4431a087fbf663bd$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $4431a087fbf663bd$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $4431a087fbf663bd$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $4431a087fbf663bd$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $4431a087fbf663bd$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $4431a087fbf663bd$export$c9f5652083b8129d);
$parcel$export(module.exports, "isVueViewModel", () => $4431a087fbf663bd$export$7916fad0ebc23f48);
// eslint-disable-next-line @typescript-eslint/unbound-method
const $4431a087fbf663bd$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$e6127cc7fe7395c3(wat) {
    switch($4431a087fbf663bd$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $4431a087fbf663bd$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$var$isBuiltin(wat, className) {
    return $4431a087fbf663bd$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$9f9636d330b71954(wat) {
    return $4431a087fbf663bd$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$ef9e2056653f0c8e(wat) {
    return $4431a087fbf663bd$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$12e869b2a583f783(wat) {
    return $4431a087fbf663bd$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$844ec244b1367d54(wat) {
    return $4431a087fbf663bd$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$c3825b437cbdea5c(wat) {
    return wat === null || $4431a087fbf663bd$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$53b83ca8eaab0383(wat) {
    return $4431a087fbf663bd$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $4431a087fbf663bd$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $4431a087fbf663bd$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$49841c62b9eff15(wat) {
    return $4431a087fbf663bd$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $4431a087fbf663bd$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$bc2894c7158efbac(wat) {
    return $4431a087fbf663bd$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}

});

parcelRegister("HgoiY", function(module, exports) {

$parcel$export(module.exports, "uuid4", () => $0820bb2e6cc9979f$export$19f53698e68b2496);
$parcel$export(module.exports, "getEventDescription", () => $0820bb2e6cc9979f$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $0820bb2e6cc9979f$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $0820bb2e6cc9979f$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $0820bb2e6cc9979f$export$6de4ffac6a2f1098);
$parcel$export(module.exports, "arrayify", () => $0820bb2e6cc9979f$export$3131421a7d01b4fb);

var $bP4Y8 = parcelRequire("bP4Y8");

var $jP2vU = parcelRequire("jP2vU");

var $6HS3j = parcelRequire("6HS3j");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $0820bb2e6cc9979f$export$19f53698e68b2496() {
    const gbl = (0, $6HS3j.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $0820bb2e6cc9979f$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $0820bb2e6cc9979f$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $0820bb2e6cc9979f$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $0820bb2e6cc9979f$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $0820bb2e6cc9979f$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $0820bb2e6cc9979f$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $0820bb2e6cc9979f$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $0820bb2e6cc9979f$export$d364f2020ab30578(input) {
    const match = input.match($0820bb2e6cc9979f$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $0820bb2e6cc9979f$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $jP2vU.snipLine)(line, 0));
    frame.context_line = (0, $jP2vU.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $jP2vU.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $0820bb2e6cc9979f$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $bP4Y8.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $0820bb2e6cc9979f$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("bP4Y8", function(module, exports) {

$parcel$export(module.exports, "fill", () => $89b84fdfd1cfae9c$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $89b84fdfd1cfae9c$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $89b84fdfd1cfae9c$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $89b84fdfd1cfae9c$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $89b84fdfd1cfae9c$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $89b84fdfd1cfae9c$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $89b84fdfd1cfae9c$export$b0244d5063c0b61b);
$parcel$export(module.exports, "dropUndefinedKeys", () => $89b84fdfd1cfae9c$export$d25f2688db1bb433);

var $eAaWR = parcelRequire("eAaWR");

var $8FmHF = parcelRequire("8FmHF");

var $5QZE4 = parcelRequire("5QZE4");

var $7htw4 = parcelRequire("7htw4");

var $jP2vU = parcelRequire("jP2vU");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $89b84fdfd1cfae9c$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $89b84fdfd1cfae9c$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $89b84fdfd1cfae9c$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $8FmHF.DEBUG_BUILD) && (0, $7htw4.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $89b84fdfd1cfae9c$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $89b84fdfd1cfae9c$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $89b84fdfd1cfae9c$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $89b84fdfd1cfae9c$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $89b84fdfd1cfae9c$export$62ff257738bf57f5(value) {
    if ((0, $5QZE4.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$89b84fdfd1cfae9c$var$getOwnProperties(value)
    };
    else if ((0, $5QZE4.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $89b84fdfd1cfae9c$var$serializeEventTarget(value.target),
            currentTarget: $89b84fdfd1cfae9c$var$serializeEventTarget(value.currentTarget),
            ...$89b84fdfd1cfae9c$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $5QZE4.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $89b84fdfd1cfae9c$var$serializeEventTarget(target) {
    try {
        return (0, $5QZE4.isElement)(target) ? (0, $eAaWR.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $89b84fdfd1cfae9c$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $89b84fdfd1cfae9c$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($89b84fdfd1cfae9c$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $jP2vU.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $jP2vU.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $89b84fdfd1cfae9c$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $89b84fdfd1cfae9c$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $89b84fdfd1cfae9c$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($89b84fdfd1cfae9c$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $89b84fdfd1cfae9c$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($89b84fdfd1cfae9c$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $89b84fdfd1cfae9c$var$isPojo(input) {
    if (!(0, $5QZE4.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $89b84fdfd1cfae9c$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $5QZE4.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("eAaWR", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", () => $a9dceb93bbd7f017$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $a9dceb93bbd7f017$export$1cfafeee2987818b);
$parcel$export(module.exports, "getDomElement", () => $a9dceb93bbd7f017$export$c660c1f3ab49225c);
$parcel$export(module.exports, "getComponentName", () => $a9dceb93bbd7f017$export$26727cfcc4d7e0fc);

var $5QZE4 = parcelRequire("5QZE4");

var $6HS3j = parcelRequire("6HS3j");
// eslint-disable-next-line deprecation/deprecation
const $a9dceb93bbd7f017$var$WINDOW = (0, $6HS3j.getGlobalObject)();
const $a9dceb93bbd7f017$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $a9dceb93bbd7f017$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $a9dceb93bbd7f017$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $a9dceb93bbd7f017$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $a9dceb93bbd7f017$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($a9dceb93bbd7f017$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $5QZE4.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $a9dceb93bbd7f017$export$1cfafeee2987818b() {
    try {
        return $a9dceb93bbd7f017$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a9dceb93bbd7f017$export$c660c1f3ab49225c(selector) {
    if ($a9dceb93bbd7f017$var$WINDOW.document && $a9dceb93bbd7f017$var$WINDOW.document.querySelector) return $a9dceb93bbd7f017$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $a9dceb93bbd7f017$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$a9dceb93bbd7f017$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
        currentElem = currentElem.parentNode;
    }
    return null;
}

});
parcelRegister("6HS3j", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", () => $4e20afe4f778c343$export$f1a6cdb1459e81d1);
$parcel$export(module.exports, "getGlobalObject", () => $4e20afe4f778c343$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $4e20afe4f778c343$export$7e223ec222791509);
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $4e20afe4f778c343$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $4e20afe4f778c343$export$f1a6cdb1459e81d1 = typeof globalThis == 'object' && $4e20afe4f778c343$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == 'object' && $4e20afe4f778c343$var$isGlobalObj(window) || typeof self == 'object' && $4e20afe4f778c343$var$isGlobalObj(self) || typeof $parcel$global == 'object' && $4e20afe4f778c343$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $4e20afe4f778c343$export$256479dc0cea61c4() {
    return $4e20afe4f778c343$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $4e20afe4f778c343$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $4e20afe4f778c343$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});


parcelRegister("8FmHF", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $64f3c3749eafb7b0$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $64f3c3749eafb7b0$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("7htw4", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", () => $54d1043b2228e29f$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "originalConsoleMethods", () => $54d1043b2228e29f$export$77c4ce905194557b);
$parcel$export(module.exports, "consoleSandbox", () => $54d1043b2228e29f$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $54d1043b2228e29f$export$af88d00dbe7f521);

var $8FmHF = parcelRequire("8FmHF");

var $6HS3j = parcelRequire("6HS3j");
/** Prefix for logging strings */ const $54d1043b2228e29f$var$PREFIX = 'Sentry Logger ';
const $54d1043b2228e29f$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $54d1043b2228e29f$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $54d1043b2228e29f$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $6HS3j.GLOBAL_OBJ))) return callback();
    const console = (0, $6HS3j.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($54d1043b2228e29f$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $54d1043b2228e29f$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $54d1043b2228e29f$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $8FmHF.DEBUG_BUILD) $54d1043b2228e29f$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $54d1043b2228e29f$export$cda52e2a8927a2ca(()=>{
                (0, $6HS3j.GLOBAL_OBJ).console[name](`${$54d1043b2228e29f$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $54d1043b2228e29f$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $54d1043b2228e29f$export$af88d00dbe7f521 = $54d1043b2228e29f$var$makeLogger();

});

parcelRegister("jP2vU", function(module, exports) {

$parcel$export(module.exports, "truncate", () => $e6e4baebb92dff28$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $e6e4baebb92dff28$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $e6e4baebb92dff28$export$465e9d514283d4fd);
$parcel$export(module.exports, "stringMatchesSomePattern", () => $e6e4baebb92dff28$export$a7a5ec66062ea5d);

var $5QZE4 = parcelRequire("5QZE4");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $e6e4baebb92dff28$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $e6e4baebb92dff28$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e6e4baebb92dff28$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $5QZE4.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $e6e4baebb92dff28$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $5QZE4.isString)(value)) return false;
    if ((0, $5QZE4.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $5QZE4.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $e6e4baebb92dff28$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$e6e4baebb92dff28$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("cQg0t", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", () => $9596c1ede1884e50$export$7740643b9eeaf0c4);
$parcel$export(module.exports, "timestampInSeconds", () => $9596c1ede1884e50$export$ee52dced521e3e18);
$parcel$export(module.exports, "browserPerformanceTimeOrigin", () => $9596c1ede1884e50$export$baf075a948ffc0bf);

var $6HS3j = parcelRequire("6HS3j");
const $9596c1ede1884e50$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $9596c1ede1884e50$export$7740643b9eeaf0c4() {
    return Date.now() / $9596c1ede1884e50$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $9596c1ede1884e50$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $6HS3j.GLOBAL_OBJ);
    if (!performance || !performance.now) return $9596c1ede1884e50$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $9596c1ede1884e50$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $9596c1ede1884e50$export$ee52dced521e3e18 = $9596c1ede1884e50$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $9596c1ede1884e50$export$c5907b5a8838db13 = $9596c1ede1884e50$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $9596c1ede1884e50$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $9596c1ede1884e50$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $6HS3j.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        $9596c1ede1884e50$export$f9f8cce55af5194c = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $9596c1ede1884e50$export$f9f8cce55af5194c = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            $9596c1ede1884e50$export$f9f8cce55af5194c = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $9596c1ede1884e50$export$f9f8cce55af5194c = 'dateNow';
    return dateNow;
})();

});

parcelRegister("90wf6", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", () => $68ed1fdd5bcea908$export$849dbeeeda01ae98);
const $68ed1fdd5bcea908$export$849dbeeeda01ae98 = 'production';

});

parcelRegister("cEq52", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $935d737b44cdff44$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $935d737b44cdff44$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("lRonC", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $fea1758a069db795$export$775b6bb06e53a214);
$parcel$export(module.exports, "getGlobalScope", () => $fea1758a069db795$export$aa55d5ab8e05984f);

var $5QZE4 = parcelRequire("5QZE4");
var $cQg0t = parcelRequire("cQg0t");
var $HgoiY = parcelRequire("HgoiY");
var $7htw4 = parcelRequire("7htw4");

var $la2Of = parcelRequire("la2Of");

var $8ZYx3 = parcelRequire("8ZYx3");

var $8VfRx = parcelRequire("8VfRx");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $fea1758a069db795$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $fea1758a069db795$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $fea1758a069db795$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $fea1758a069db795$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $fea1758a069db795$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $fea1758a069db795$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $8ZYx3.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $fea1758a069db795$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $5QZE4.isPlainObject)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $fea1758a069db795$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $fea1758a069db795$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $cQg0t.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $8VfRx.applyScopeDataToEvent)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $la2Of.getGlobalEventProcessors)(),
            ...this._eventProcessors
        ];
        return (0, $la2Of.notifyEventProcessors)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $HgoiY.uuid4)();
        if (!this._client) {
            (0, $7htw4.logger).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $HgoiY.uuid4)();
        if (!this._client) {
            (0, $7htw4.logger).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $HgoiY.uuid4)();
        if (!this._client) {
            (0, $7htw4.logger).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $fea1758a069db795$export$aa55d5ab8e05984f() {
    if (!$fea1758a069db795$var$globalScope) $fea1758a069db795$var$globalScope = new $fea1758a069db795$export$775b6bb06e53a214();
    return $fea1758a069db795$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $fea1758a069db795$export$c83048efd17527d6(scope) {
    $fea1758a069db795$var$globalScope = scope;
}
function $fea1758a069db795$var$generatePropagationContext() {
    return {
        traceId: (0, $HgoiY.uuid4)(),
        spanId: (0, $HgoiY.uuid4)().substring(16)
    };
}

});
parcelRegister("la2Of", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventProcessors", () => $f67cb60f8b7520b8$export$3c4238858b85e8ac);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $f67cb60f8b7520b8$export$8e4e25f54d456511);
$parcel$export(module.exports, "notifyEventProcessors", () => $f67cb60f8b7520b8$export$bf2a096c3e883e79);

var $6HS3j = parcelRequire("6HS3j");
var $i7ar8 = parcelRequire("i7ar8");
var $7htw4 = parcelRequire("7htw4");
var $5QZE4 = parcelRequire("5QZE4");

var $cEq52 = parcelRequire("cEq52");
/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $f67cb60f8b7520b8$export$3c4238858b85e8ac() {
    return (0, $6HS3j.getGlobalSingleton)('globalEventProcessors', ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $f67cb60f8b7520b8$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $f67cb60f8b7520b8$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $f67cb60f8b7520b8$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $i7ar8.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $cEq52.DEBUG_BUILD) && processor.id && result === null && (0, $7htw4.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $5QZE4.isThenable)(result)) result.then((final)=>$f67cb60f8b7520b8$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $f67cb60f8b7520b8$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("i7ar8", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", () => $d300f9ef2197f7c0$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $d300f9ef2197f7c0$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $d300f9ef2197f7c0$export$78e43115b553f358);

var $5QZE4 = parcelRequire("5QZE4");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $d300f9ef2197f7c0$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($d300f9ef2197f7c0$var$States || ($d300f9ef2197f7c0$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $d300f9ef2197f7c0$export$1fda8aa4d135f8aa(value) {
    return new $d300f9ef2197f7c0$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $d300f9ef2197f7c0$export$78e43115b553f358(reason) {
    return new $d300f9ef2197f7c0$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $d300f9ef2197f7c0$export$6f292d4960313241 {
    constructor(executor){
        $d300f9ef2197f7c0$export$6f292d4960313241.prototype.__init.call(this);
        $d300f9ef2197f7c0$export$6f292d4960313241.prototype.__init2.call(this);
        $d300f9ef2197f7c0$export$6f292d4960313241.prototype.__init3.call(this);
        $d300f9ef2197f7c0$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $d300f9ef2197f7c0$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $d300f9ef2197f7c0$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $d300f9ef2197f7c0$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($d300f9ef2197f7c0$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($d300f9ef2197f7c0$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $d300f9ef2197f7c0$var$States.PENDING) return;
            if ((0, $5QZE4.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $d300f9ef2197f7c0$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $d300f9ef2197f7c0$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $d300f9ef2197f7c0$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});


parcelRegister("8ZYx3", function(module, exports) {

$parcel$export(module.exports, "makeSession", () => $68d2f9a36f0e7f5b$export$14a186326edbb264);
$parcel$export(module.exports, "updateSession", () => $68d2f9a36f0e7f5b$export$531818e825e774db);
$parcel$export(module.exports, "closeSession", () => $68d2f9a36f0e7f5b$export$56521d9ba90f62ee);

var $cQg0t = parcelRequire("cQg0t");
var $HgoiY = parcelRequire("HgoiY");
var $bP4Y8 = parcelRequire("bP4Y8");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $68d2f9a36f0e7f5b$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $cQg0t.timestampInSeconds)();
    const session = {
        sid: (0, $HgoiY.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$68d2f9a36f0e7f5b$var$sessionToJSON(session)
    };
    if (context) $68d2f9a36f0e7f5b$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $68d2f9a36f0e7f5b$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $cQg0t.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $HgoiY.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $68d2f9a36f0e7f5b$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $68d2f9a36f0e7f5b$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $68d2f9a36f0e7f5b$var$sessionToJSON(session) {
    return (0, $bP4Y8.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});

parcelRegister("8VfRx", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", () => $67eff3964b7008cc$export$43988bc651a80216);
$parcel$export(module.exports, "mergeScopeData", () => $67eff3964b7008cc$export$25ac7e259a513db4);

var $bP4Y8 = parcelRequire("bP4Y8");
var $HgoiY = parcelRequire("HgoiY");

var $iJP5v = parcelRequire("iJP5v");

var $lMAWl = parcelRequire("lMAWl");

var $5NO4E = parcelRequire("5NO4E");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $67eff3964b7008cc$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $67eff3964b7008cc$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $67eff3964b7008cc$var$applySpanToEvent(event, span);
    $67eff3964b7008cc$var$applyFingerprintToEvent(event, fingerprint);
    $67eff3964b7008cc$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $67eff3964b7008cc$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $67eff3964b7008cc$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $67eff3964b7008cc$export$b1a120a2871faa46(data, 'extra', extra);
    $67eff3964b7008cc$export$b1a120a2871faa46(data, 'tags', tags);
    $67eff3964b7008cc$export$b1a120a2871faa46(data, 'user', user);
    $67eff3964b7008cc$export$b1a120a2871faa46(data, 'contexts', contexts);
    $67eff3964b7008cc$export$b1a120a2871faa46(data, 'sdkProcessingMetadata', sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $67eff3964b7008cc$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $67eff3964b7008cc$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $bP4Y8.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $bP4Y8.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $bP4Y8.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $bP4Y8.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $67eff3964b7008cc$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $67eff3964b7008cc$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $67eff3964b7008cc$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $5NO4E.spanToTraceContext)(span),
        ...event.contexts
    };
    const rootSpan = (0, $lMAWl.getRootSpan)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $iJP5v.getDynamicSamplingContextFromSpan)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $5NO4E.spanToJSON)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $67eff3964b7008cc$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $HgoiY.arrayify)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("iJP5v", function(module, exports) {

$parcel$export(module.exports, "getDynamicSamplingContextFromClient", () => $da440eefa7483dd5$export$366bad00d6815eed);
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", () => $da440eefa7483dd5$export$a117f995597e25df);

var $bP4Y8 = parcelRequire("bP4Y8");

var $90wf6 = parcelRequire("90wf6");

var $3WK1v = parcelRequire("3WK1v");

var $lMAWl = parcelRequire("lMAWl");

var $5NO4E = parcelRequire("5NO4E");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $da440eefa7483dd5$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $bP4Y8.dropUndefinedKeys)({
        environment: options.environment || (0, $90wf6.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $da440eefa7483dd5$export$a117f995597e25df(span) {
    const client = (0, $3WK1v.getClient)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $da440eefa7483dd5$export$366bad00d6815eed((0, $5NO4E.spanToJSON)(span).trace_id || '', client, (0, $3WK1v.getCurrentScope)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $lMAWl.getRootSpan)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $5NO4E.spanToJSON)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== 'url') dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $5NO4E.spanIsSampled)(txn));
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}

});
parcelRegister("3WK1v", function(module, exports) {

$parcel$export(module.exports, "captureException", () => $2dfa7d22514dae4c$export$f5282963edea4a68);
$parcel$export(module.exports, "captureEvent", () => $2dfa7d22514dae4c$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "addBreadcrumb", () => $2dfa7d22514dae4c$export$efda9a273d7a036d);
$parcel$export(module.exports, "withScope", () => $2dfa7d22514dae4c$export$ec58d9285c204497);
$parcel$export(module.exports, "getCurrentScope", () => $2dfa7d22514dae4c$export$c7be4b0125a10cba);
$parcel$export(module.exports, "getClient", () => $2dfa7d22514dae4c$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "startSession", () => $2dfa7d22514dae4c$export$c0d84948cecf78d8);
$parcel$export(module.exports, "captureSession", () => $2dfa7d22514dae4c$export$667e7b4d445d566b);

var $7htw4 = parcelRequire("7htw4");
var $HgoiY = parcelRequire("HgoiY");
var $cQg0t = parcelRequire("cQg0t");
var $5QZE4 = parcelRequire("5QZE4");
var $6HS3j = parcelRequire("6HS3j");

var $90wf6 = parcelRequire("90wf6");

var $cEq52 = parcelRequire("cEq52");

var $gUaXH = parcelRequire("gUaXH");

var $8ZYx3 = parcelRequire("8ZYx3");

var $gBF6M = parcelRequire("gBF6M");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $2dfa7d22514dae4c$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $gUaXH.getCurrentHub)().captureException(exception, (0, $gBF6M.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $2dfa7d22514dae4c$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $gUaXH.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $2dfa7d22514dae4c$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $gUaXH.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $2dfa7d22514dae4c$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $gUaXH.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $2dfa7d22514dae4c$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $gUaXH.getCurrentHub)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $2dfa7d22514dae4c$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $gUaXH.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $2dfa7d22514dae4c$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $gUaXH.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $2dfa7d22514dae4c$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $gUaXH.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $2dfa7d22514dae4c$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $gUaXH.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $2dfa7d22514dae4c$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $gUaXH.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $2dfa7d22514dae4c$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $gUaXH.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $2dfa7d22514dae4c$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $gUaXH.getCurrentHub)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $2dfa7d22514dae4c$export$9a4fed82c350c2bd(callback) {
    return (0, $gUaXH.runWithAsyncContext)(()=>{
        return callback((0, $gUaXH.getIsolationScope)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $2dfa7d22514dae4c$export$e57ac09b143d92a2(span, callback) {
    return $2dfa7d22514dae4c$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $2dfa7d22514dae4c$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $gUaXH.getCurrentHub)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $2dfa7d22514dae4c$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $2dfa7d22514dae4c$export$c7be4b0125a10cba();
    const client = $2dfa7d22514dae4c$export$6bb76d6eba7e258c();
    if (!client) (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $HgoiY.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $2dfa7d22514dae4c$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $2dfa7d22514dae4c$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $cQg0t.timestampInSeconds)();
    function finishCheckIn(status) {
        $2dfa7d22514dae4c$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $cQg0t.timestampInSeconds)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn('error');
        throw e;
    }
    if ((0, $5QZE4.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn('ok');
    }, ()=>{
        finishCheckIn('error');
    });
    else finishCheckIn('ok');
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $2dfa7d22514dae4c$export$4909b86c8034bf73(timeout) {
    const client = $2dfa7d22514dae4c$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $2dfa7d22514dae4c$export$8360e631d277ea4d(timeout) {
    const client = $2dfa7d22514dae4c$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $2dfa7d22514dae4c$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $gUaXH.getCurrentHub)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $2dfa7d22514dae4c$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $gUaXH.getCurrentHub)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $2dfa7d22514dae4c$export$3f95c6f800b78024() {
    return !!$2dfa7d22514dae4c$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $2dfa7d22514dae4c$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $gUaXH.getCurrentHub)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $2dfa7d22514dae4c$export$c0d84948cecf78d8(context) {
    const client = $2dfa7d22514dae4c$export$6bb76d6eba7e258c();
    const isolationScope = (0, $gUaXH.getIsolationScope)();
    const currentScope = $2dfa7d22514dae4c$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $90wf6.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $6HS3j.GLOBAL_OBJ).navigator || {};
    const session = (0, $8ZYx3.makeSession)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === 'ok') (0, $8ZYx3.updateSession)(currentSession, {
        status: 'exited'
    });
    $2dfa7d22514dae4c$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $2dfa7d22514dae4c$export$17a5be43989a0bc1() {
    const isolationScope = (0, $gUaXH.getIsolationScope)();
    const currentScope = $2dfa7d22514dae4c$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $8ZYx3.closeSession)(session);
    $2dfa7d22514dae4c$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $2dfa7d22514dae4c$var$_sendSessionUpdate() {
    const isolationScope = (0, $gUaXH.getIsolationScope)();
    const currentScope = $2dfa7d22514dae4c$export$c7be4b0125a10cba();
    const client = $2dfa7d22514dae4c$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $2dfa7d22514dae4c$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $2dfa7d22514dae4c$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $2dfa7d22514dae4c$var$_sendSessionUpdate();
}

});
parcelRegister("gBF6M", function(module, exports) {

$parcel$export(module.exports, "prepareEvent", () => $c16ffd4bab406a01$export$2d67fb380bd11267);
$parcel$export(module.exports, "parseEventHintOrCaptureContext", () => $c16ffd4bab406a01$export$76b5f966996d1653);

var $HgoiY = parcelRequire("HgoiY");
var $cQg0t = parcelRequire("cQg0t");
var $jP2vU = parcelRequire("jP2vU");
var $6HS3j = parcelRequire("6HS3j");
var $jn5uz = parcelRequire("jn5uz");

var $90wf6 = parcelRequire("90wf6");

var $la2Of = parcelRequire("la2Of");

var $lRonC = parcelRequire("lRonC");

var $8VfRx = parcelRequire("8VfRx");

var $5NO4E = parcelRequire("5NO4E");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $c16ffd4bab406a01$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $HgoiY.uuid4)(),
        timestamp: event.timestamp || (0, $cQg0t.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $c16ffd4bab406a01$var$applyClientOptions(prepared, options);
    $c16ffd4bab406a01$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $c16ffd4bab406a01$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $c16ffd4bab406a01$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $HgoiY.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $lRonC.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $8VfRx.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $8VfRx.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $8VfRx.applyScopeDataToEvent)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $la2Of.getGlobalEventProcessors)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $la2Of.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $c16ffd4bab406a01$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $c16ffd4bab406a01$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $c16ffd4bab406a01$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!('environment' in event)) event.environment = 'environment' in options ? environment : (0, $90wf6.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $jP2vU.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $jP2vU.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $jP2vU.truncate)(request.url, maxValueLength);
}
const $c16ffd4bab406a01$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $c16ffd4bab406a01$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $6HS3j.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $c16ffd4bab406a01$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $c16ffd4bab406a01$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $c16ffd4bab406a01$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $c16ffd4bab406a01$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $c16ffd4bab406a01$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $jn5uz.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $jn5uz.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $jn5uz.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $jn5uz.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $jn5uz.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $5NO4E.spanToJSON)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $jn5uz.normalize)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $c16ffd4bab406a01$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $lRonC.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $c16ffd4bab406a01$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($c16ffd4bab406a01$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($c16ffd4bab406a01$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $c16ffd4bab406a01$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $lRonC.Scope) || typeof hint === 'function';
}
const $c16ffd4bab406a01$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'requestSession',
    'propagationContext'
];
function $c16ffd4bab406a01$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$c16ffd4bab406a01$var$captureContextKeys.includes(key));
}

});
parcelRegister("jn5uz", function(module, exports) {

$parcel$export(module.exports, "normalize", () => $e1a46ce691765a57$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $e1a46ce691765a57$export$23fbbb20bed71033);

var $5QZE4 = parcelRequire("5QZE4");

var $8GdYS = parcelRequire("8GdYS");

var $bP4Y8 = parcelRequire("bP4Y8");

var $6Iopj = parcelRequire("6Iopj");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e1a46ce691765a57$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $e1a46ce691765a57$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $e1a46ce691765a57$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $e1a46ce691765a57$export$a3295358bff77e(object, depth);
    if ($e1a46ce691765a57$var$jsonSize(normalized) > maxSize) return $e1a46ce691765a57$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $e1a46ce691765a57$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $8GdYS.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $5QZE4.isNaN)(value)) return value;
    const stringified = $e1a46ce691765a57$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $e1a46ce691765a57$export$588732934346abbf('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $bP4Y8.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $e1a46ce691765a57$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $e1a46ce691765a57$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $5QZE4.isVueViewModel)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $5QZE4.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        if (typeof value === 'function') return `[Function: ${(0, $6Iopj.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $e1a46ce691765a57$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $e1a46ce691765a57$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $e1a46ce691765a57$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e1a46ce691765a57$var$jsonSize(value) {
    return $e1a46ce691765a57$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $e1a46ce691765a57$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}

});
parcelRegister("8GdYS", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", () => $651d1743a990a360$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $651d1743a990a360$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("6Iopj", function(module, exports) {

$parcel$export(module.exports, "createStackParser", () => $4e39c8ebcb5dcbe2$export$a5739666fb2d03d4);
$parcel$export(module.exports, "stackParserFromStackParserOptions", () => $4e39c8ebcb5dcbe2$export$1d5cf88b347146d4);
$parcel$export(module.exports, "getFunctionName", () => $4e39c8ebcb5dcbe2$export$aad197c7121a6651);

var $emUan = parcelRequire("emUan");
const $4e39c8ebcb5dcbe2$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $4e39c8ebcb5dcbe2$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $4e39c8ebcb5dcbe2$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $4e39c8ebcb5dcbe2$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $4e39c8ebcb5dcbe2$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($4e39c8ebcb5dcbe2$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $4e39c8ebcb5dcbe2$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $4e39c8ebcb5dcbe2$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $4e39c8ebcb5dcbe2$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $4e39c8ebcb5dcbe2$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $4e39c8ebcb5dcbe2$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($4e39c8ebcb5dcbe2$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($4e39c8ebcb5dcbe2$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    }
    return localStack.slice(0, $4e39c8ebcb5dcbe2$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || '?'
        }));
}
const $4e39c8ebcb5dcbe2$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $4e39c8ebcb5dcbe2$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $4e39c8ebcb5dcbe2$var$defaultFunctionName;
        return fn.name || $4e39c8ebcb5dcbe2$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $4e39c8ebcb5dcbe2$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $4e39c8ebcb5dcbe2$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $emUan.node)(getModule)
    ];
}

});
parcelRegister("emUan", function(module, exports) {

$parcel$export(module.exports, "node", () => $a75eb0382444770c$export$35059013cd4a06db);
/**
 * Does this filename look like it's part of the app code?
 */ function $a75eb0382444770c$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith('/') && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith('.') && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes('node_modules/');
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $a75eb0382444770c$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf('.');
                if (functionName[methodStart - 1] === '.') methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf('.Module');
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === '<anonymous>') {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || '<anonymous>';
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === 'native';
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $a75eb0382444770c$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});



parcelRegister("5NO4E", function(module, exports) {

$parcel$export(module.exports, "TRACE_FLAG_NONE", () => $43985f001f6f055c$export$208d5b368507fb8b);
$parcel$export(module.exports, "TRACE_FLAG_SAMPLED", () => $43985f001f6f055c$export$eb571cd9b5d98de8);
$parcel$export(module.exports, "spanToTraceContext", () => $43985f001f6f055c$export$46c6fbd1d265ebf0);
$parcel$export(module.exports, "spanToJSON", () => $43985f001f6f055c$export$92d8c23565496537);
$parcel$export(module.exports, "spanToTraceHeader", () => $43985f001f6f055c$export$7e9f8ae9e4a328ab);
$parcel$export(module.exports, "spanIsSampled", () => $43985f001f6f055c$export$5caecac1caaf3a71);
$parcel$export(module.exports, "spanTimeInputToSeconds", () => $43985f001f6f055c$export$3f7581298f56c6d7);

var $bP4Y8 = parcelRequire("bP4Y8");
var $lS7eK = parcelRequire("lS7eK");
var $cQg0t = parcelRequire("cQg0t");
// These are aligned with OpenTelemetry trace flags
const $43985f001f6f055c$export$208d5b368507fb8b = 0x0;
const $43985f001f6f055c$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $43985f001f6f055c$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $43985f001f6f055c$export$92d8c23565496537(span);
    return (0, $bP4Y8.dropUndefinedKeys)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $43985f001f6f055c$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $43985f001f6f055c$export$5caecac1caaf3a71(span);
    return (0, $lS7eK.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $43985f001f6f055c$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $43985f001f6f055c$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $43985f001f6f055c$var$ensureTimestampInSeconds(input.getTime());
    return (0, $cQg0t.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $43985f001f6f055c$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $43985f001f6f055c$export$92d8c23565496537(span) {
    if ($43985f001f6f055c$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === 'function') // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $43985f001f6f055c$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $43985f001f6f055c$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $43985f001f6f055c$export$eb571cd9b5d98de8);
}

});
parcelRegister("lS7eK", function(module, exports) {

$parcel$export(module.exports, "TRACEPARENT_REGEXP", () => $fec4413c5c229d86$export$394a210812ba3012);
$parcel$export(module.exports, "extractTraceparentData", () => $fec4413c5c229d86$export$8e9a29865c0a1226);
$parcel$export(module.exports, "tracingContextFromHeaders", () => $fec4413c5c229d86$export$ca5c066532785b6e);
$parcel$export(module.exports, "propagationContextFromHeaders", () => $fec4413c5c229d86$export$261f383d16a93e39);
$parcel$export(module.exports, "generateSentryTraceHeader", () => $fec4413c5c229d86$export$f35d907436da45cf);

var $9I0DN = parcelRequire("9I0DN");

var $HgoiY = parcelRequire("HgoiY");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $fec4413c5c229d86$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $fec4413c5c229d86$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($fec4413c5c229d86$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $fec4413c5c229d86$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $fec4413c5c229d86$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $9I0DN.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $HgoiY.uuid4)(),
            spanId: (0, $HgoiY.uuid4)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $HgoiY.uuid4)(),
            parentSpanId: parentSpanId || (0, $HgoiY.uuid4)().substring(16),
            spanId: (0, $HgoiY.uuid4)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $fec4413c5c229d86$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $fec4413c5c229d86$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $9I0DN.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $HgoiY.uuid4)(),
        spanId: (0, $HgoiY.uuid4)().substring(16)
    };
    else return {
        traceId: traceId || (0, $HgoiY.uuid4)(),
        parentSpanId: parentSpanId || (0, $HgoiY.uuid4)().substring(16),
        spanId: (0, $HgoiY.uuid4)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $fec4413c5c229d86$export$f35d907436da45cf(traceId = (0, $HgoiY.uuid4)(), spanId = (0, $HgoiY.uuid4)().substring(16), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}

});
parcelRegister("9I0DN", function(module, exports) {

$parcel$export(module.exports, "BAGGAGE_HEADER_NAME", () => $7118b85cc7face33$export$9ca9946bd449ac06);
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", () => $7118b85cc7face33$export$5b96ee2c8421f107);
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", () => $7118b85cc7face33$export$56766feef403f365);

var $8FmHF = parcelRequire("8FmHF");

var $5QZE4 = parcelRequire("5QZE4");

var $7htw4 = parcelRequire("7htw4");
const $7118b85cc7face33$export$9ca9946bd449ac06 = 'baggage';
const $7118b85cc7face33$export$6e69537d67fa20f = 'sentry-';
const $7118b85cc7face33$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $7118b85cc7face33$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $7118b85cc7face33$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $5QZE4.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $7118b85cc7face33$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $7118b85cc7face33$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($7118b85cc7face33$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($7118b85cc7face33$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $7118b85cc7face33$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$7118b85cc7face33$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $7118b85cc7face33$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $7118b85cc7face33$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $7118b85cc7face33$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $7118b85cc7face33$export$bdd844ddb2def819) {
            (0, $8FmHF.DEBUG_BUILD) && (0, $7htw4.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

});





parcelRegister("lMAWl", function(module, exports) {

$parcel$export(module.exports, "getRootSpan", () => $fdbabc346cde48ce$export$c4c6a79b1260ca1b);
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $fdbabc346cde48ce$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}

});




parcelRegister("bxlWE", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", () => $8663cc950bc5605c$export$31499a9cd224b78c);
const $8663cc950bc5605c$export$31499a9cd224b78c = '7.120.4';

});


parcelRegister("dtmCD", function(module, exports) {

$parcel$export(module.exports, "startIdleTransaction", () => $9cef8812405bf153$export$479dbd817e392a4f);
$parcel$export(module.exports, "addTracingExtensions", () => $9cef8812405bf153$export$653d0ef2bad9cdf9);

var $7htw4 = parcelRequire("7htw4");

var $cEq52 = parcelRequire("cEq52");

var $gUaXH = parcelRequire("gUaXH");

var $5NO4E = parcelRequire("5NO4E");

var $3i1wA = parcelRequire("3i1wA");

var $jVs0C = parcelRequire("jVs0C");

var $1fiFu = parcelRequire("1fiFu");

var $htdtT = parcelRequire("htdtT");
/** Returns all trace headers that are currently on the top scope. */ // eslint-disable-next-line deprecation/deprecation
function $9cef8812405bf153$var$traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const span = scope.getSpan();
    return span ? {
        'sentry-trace': (0, $5NO4E.spanToTraceHeader)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $9cef8812405bf153$var$_startTransaction(// eslint-disable-next-line deprecation/deprecation
transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || 'sentry';
    const transactionInstrumenter = transactionContext.instrumenter || 'sentry';
    if (configInstrumenter !== transactionInstrumenter) {
        (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $htdtT.Transaction)(transactionContext, this);
    transaction = (0, $1fiFu.sampleTransaction)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $9cef8812405bf153$export$479dbd817e392a4f(// eslint-disable-next-line deprecation/deprecation
hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval, delayAutoFinishUntilSignal = false) {
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $jVs0C.IdleTransaction)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, $1fiFu.sampleTransaction)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $9cef8812405bf153$export$653d0ef2bad9cdf9() {
    const carrier = (0, $gUaXH.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $9cef8812405bf153$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $9cef8812405bf153$var$traceHeaders;
    (0, $3i1wA.registerErrorInstrumentation)();
}

});
parcelRegister("3i1wA", function(module, exports) {

$parcel$export(module.exports, "registerErrorInstrumentation", () => $26543c4661b2770c$export$637857c1d87b640c);

var $fsa46 = parcelRequire("fsa46");
var $5bX8i = parcelRequire("5bX8i");
var $7htw4 = parcelRequire("7htw4");

var $cEq52 = parcelRequire("cEq52");

var $ki8Su = parcelRequire("ki8Su");
let $26543c4661b2770c$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $26543c4661b2770c$export$637857c1d87b640c() {
    if ($26543c4661b2770c$var$errorsInstrumented) return;
    $26543c4661b2770c$var$errorsInstrumented = true;
    (0, $fsa46.addGlobalErrorInstrumentationHandler)($26543c4661b2770c$var$errorCallback);
    (0, $5bX8i.addGlobalUnhandledRejectionInstrumentationHandler)($26543c4661b2770c$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $26543c4661b2770c$var$errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = (0, $ki8Su.getActiveTransaction)();
    if (activeTransaction) {
        const status = 'internal_error';
        (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$26543c4661b2770c$var$errorCallback.tag = 'sentry_tracingErrorCallback';

});
parcelRegister("fsa46", function(module, exports) {

$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", () => $b401474715fe56c0$export$55b5c3ba2194f0c6);

var $6HS3j = parcelRequire("6HS3j");

var $l5g2K = parcelRequire("l5g2K");
let $b401474715fe56c0$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $b401474715fe56c0$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $l5g2K.addHandler)(type, handler);
    (0, $l5g2K.maybeInstrument)(type, $b401474715fe56c0$var$instrumentError);
}
function $b401474715fe56c0$var$instrumentError() {
    $b401474715fe56c0$var$_oldOnErrorHandler = (0, $6HS3j.GLOBAL_OBJ).onerror;
    (0, $6HS3j.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $l5g2K.triggerHandlers)('error', handlerData);
        if ($b401474715fe56c0$var$_oldOnErrorHandler && !$b401474715fe56c0$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $b401474715fe56c0$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $6HS3j.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});
parcelRegister("l5g2K", function(module, exports) {

$parcel$export(module.exports, "addHandler", () => $f5968277b08509e3$export$a4e09611e30da72e);
$parcel$export(module.exports, "maybeInstrument", () => $f5968277b08509e3$export$e18d6c5462c01368);
$parcel$export(module.exports, "triggerHandlers", () => $f5968277b08509e3$export$b18c893e424d3127);

var $8FmHF = parcelRequire("8FmHF");

var $7htw4 = parcelRequire("7htw4");

var $6Iopj = parcelRequire("6Iopj");
// We keep the handlers globally
const $f5968277b08509e3$var$handlers = {};
const $f5968277b08509e3$var$instrumented = {};
/** Add a handler function. */ function $f5968277b08509e3$export$a4e09611e30da72e(type, handler) {
    $f5968277b08509e3$var$handlers[type] = $f5968277b08509e3$var$handlers[type] || [];
    $f5968277b08509e3$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $f5968277b08509e3$export$b17eab759a1cb5fe() {
    Object.keys($f5968277b08509e3$var$handlers).forEach((key)=>{
        $f5968277b08509e3$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $f5968277b08509e3$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$f5968277b08509e3$var$instrumented[type]) {
        instrumentFn();
        $f5968277b08509e3$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $f5968277b08509e3$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $f5968277b08509e3$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $8FmHF.DEBUG_BUILD) && (0, $7htw4.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $6Iopj.getFunctionName)(handler)}\nError:`, e);
    }
}

});


parcelRegister("5bX8i", function(module, exports) {

$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", () => $3c7bd95e794e060c$export$8bf4fc6858821a4e);

var $6HS3j = parcelRequire("6HS3j");

var $l5g2K = parcelRequire("l5g2K");
let $3c7bd95e794e060c$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $3c7bd95e794e060c$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $l5g2K.addHandler)(type, handler);
    (0, $l5g2K.maybeInstrument)(type, $3c7bd95e794e060c$var$instrumentUnhandledRejection);
}
function $3c7bd95e794e060c$var$instrumentUnhandledRejection() {
    $3c7bd95e794e060c$var$_oldOnUnhandledRejectionHandler = (0, $6HS3j.GLOBAL_OBJ).onunhandledrejection;
    (0, $6HS3j.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $l5g2K.triggerHandlers)('unhandledrejection', handlerData);
        if ($3c7bd95e794e060c$var$_oldOnUnhandledRejectionHandler && !$3c7bd95e794e060c$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $3c7bd95e794e060c$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $6HS3j.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRegister("ki8Su", function(module, exports) {

$parcel$export(module.exports, "getActiveTransaction", () => $ec5c60089c625009$export$a7feb32fdd923295);
$parcel$export(module.exports, "extractTraceparentData", () => $ec5c60089c625009$export$8e9a29865c0a1226);

var $lS7eK = parcelRequire("lS7eK");

var $gUaXH = parcelRequire("gUaXH");
/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $ec5c60089c625009$export$a7feb32fdd923295(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = maybeHub || (0, $gUaXH.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ const $ec5c60089c625009$export$8e9a29865c0a1226 = (0, $lS7eK.extractTraceparentData);

});


parcelRegister("jVs0C", function(module, exports) {

$parcel$export(module.exports, "TRACING_DEFAULTS", () => $e819112de2b9f6c6$export$809a2b7987fd5306);
$parcel$export(module.exports, "IdleTransaction", () => $e819112de2b9f6c6$export$b279e6bd7040371f);

var $7htw4 = parcelRequire("7htw4");
var $cQg0t = parcelRequire("cQg0t");

var $cEq52 = parcelRequire("cEq52");

var $5NO4E = parcelRequire("5NO4E");

var $chdgs = parcelRequire("chdgs");

var $htdtT = parcelRequire("htdtT");
const $e819112de2b9f6c6$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $e819112de2b9f6c6$var$FINISH_REASON_TAG = 'finishReason';
const $e819112de2b9f6c6$var$IDLE_TRANSACTION_FINISH_REASONS = [
    'heartbeatFailed',
    'idleTimeout',
    'documentHidden',
    'finalTimeout',
    'externalFinish',
    'cancelled'
];
/**
 * @inheritDoc
 */ class $e819112de2b9f6c6$export$370d6113c18ba86c extends (0, $chdgs.SpanRecorder) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanContext().spanId !== this.transactionSpanId) {
            // We patch span.end() to pop an activity after setting an endTimestamp.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const originalEnd = span.end;
            span.end = (...rest)=>{
                this._popActivity(span.spanContext().spanId);
                return originalEnd.apply(span, rest);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if ((0, $5NO4E.spanToJSON)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $e819112de2b9f6c6$export$b279e6bd7040371f extends (0, $htdtT.Transaction) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, // eslint-disable-next-line deprecation/deprecation
    _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $e819112de2b9f6c6$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $e819112de2b9f6c6$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $e819112de2b9f6c6$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $e819112de2b9f6c6$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(this);
        }
        if (!delayAutoFinishUntilSignal) this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus('deadline_exceeded');
                this._finishReason = $e819112de2b9f6c6$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.end();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ end(endTimestamp) {
        const endTimestampInS = (0, $5NO4E.spanTimeInputToSeconds)(endTimestamp);
        this._finished = true;
        this.activities = {};
        // eslint-disable-next-line deprecation/deprecation
        if (this.op === 'ui.action.click') this.setAttribute($e819112de2b9f6c6$var$FINISH_REASON_TAG, this._finishReason);
        // eslint-disable-next-line deprecation/deprecation
        if (this.spanRecorder) {
            (0, $cEq52.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
            (0, $7htw4.logger).log('[Tracing] finishing IdleTransaction', new Date(endTimestampInS * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestampInS);
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanContext().spanId === this.spanContext().spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!(0, $5NO4E.spanToJSON)(span).timestamp) {
                    span.setStatus('cancelled');
                    span.end(endTimestampInS);
                    (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
                }
                const { start_timestamp: startTime, timestamp: endTime } = (0, $5NO4E.spanToJSON)(span);
                const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                if (0, $cEq52.DEBUG_BUILD) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $7htw4.logger).log('[Tracing] discarding Span since it happened after Transaction was finished', stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $7htw4.logger).log('[Tracing] discarding Span since it finished after Transaction final timeout', stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).log('[Tracing] flushing IdleTransaction');
        } else (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).log('[Tracing] No active IdleTransaction');
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = this._idleHub.getScope();
            // eslint-disable-next-line deprecation/deprecation
            if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
            scope.setSpan(undefined);
        }
        return super.end(endTimestamp);
    }
    /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder = new $e819112de2b9f6c6$export$370d6113c18ba86c(pushActivity, popActivity, this.spanContext().spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).log('Starting heartbeat');
            this._pingHeartbeat();
        }
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $e819112de2b9f6c6$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.end(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ sendAutoFinishSignal() {
        if (!this._autoFinishAllowed) {
            (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).log('[Tracing] Received finish signal for idle transaction.');
            this._restartIdleTimeout();
            this._autoFinishAllowed = true;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $e819112de2b9f6c6$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.end(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).log('[Tracing] new activities count', Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).log('[Tracing] new activities count', Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $cQg0t.timestampInSeconds)();
            if (this._idleTimeoutCanceledPermanently) {
                if (this._autoFinishAllowed) {
                    this._finishReason = $e819112de2b9f6c6$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                    this.end(endTimestamp);
                }
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join('');
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            if (this._autoFinishAllowed) {
                (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).log('[Tracing] Transaction finished because of no change for 3 heart beats');
                this.setStatus('deadline_exceeded');
                this._finishReason = $e819112de2b9f6c6$var$IDLE_TRANSACTION_FINISH_REASONS[0];
                this.end();
            }
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}

});
parcelRegister("chdgs", function(module, exports) {

$parcel$export(module.exports, "SpanRecorder", () => $8f015c96e068ddf8$export$10c95c129cd0d4fe);
$parcel$export(module.exports, "Span", () => $8f015c96e068ddf8$export$5f1714a13ed34c01);

var $HgoiY = parcelRequire("HgoiY");
var $cQg0t = parcelRequire("cQg0t");
var $7htw4 = parcelRequire("7htw4");
var $bP4Y8 = parcelRequire("bP4Y8");

var $cEq52 = parcelRequire("cEq52");

var $3oItx = parcelRequire("3oItx");

var $2Y7aX = parcelRequire("2Y7aX");

var $lMAWl = parcelRequire("lMAWl");

var $5NO4E = parcelRequire("5NO4E");

var $9JbAT = parcelRequire("9JbAT");
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $8f015c96e068ddf8$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
        span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $8f015c96e068ddf8$export$5f1714a13ed34c01 {
    /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */ /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */ /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */ /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $HgoiY.uuid4)();
        this._spanId = spanContext.spanId || (0, $HgoiY.uuid4)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $cQg0t.timestampInSeconds)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? {
            ...spanContext.tags
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? {
            ...spanContext.data
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || 'sentry';
        this._attributes = {};
        this.setAttributes({
            [(0, $2Y7aX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanContext.origin || 'manual',
            [(0, $2Y7aX.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: spanContext.op,
            ...spanContext.attributes
        });
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        if (spanContext.exclusiveTime !== undefined) this._exclusiveTime = spanContext.exclusiveTime;
        this._measurements = spanContext.measurements ? {
            ...spanContext.measurements
        } : {};
    }
    // This rule conflicts with another eslint rule :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name || '';
    }
    /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set name(name) {
        this.updateName(name);
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get description() {
        return this._name;
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set description(description) {
        this._name = description;
    }
    /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ get traceId() {
        return this._traceId;
    }
    /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ set traceId(traceId) {
        this._traceId = traceId;
    }
    /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ get spanId() {
        return this._spanId;
    }
    /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ set spanId(spanId) {
        this._spanId = spanId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ set parentSpanId(string) {
        this._parentSpanId = string;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ get parentSpanId() {
        return this._parentSpanId;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ get sampled() {
        return this._sampled;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ set sampled(sampled) {
        this._sampled = sampled;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ get attributes() {
        return this._attributes;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ set attributes(attributes) {
        this._attributes = attributes;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ get startTimestamp() {
        return this._startTime;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ set startTimestamp(startTime) {
        this._startTime = startTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ get endTimestamp() {
        return this._endTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ set endTimestamp(endTime) {
        this._endTime = endTime;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ get status() {
        return this._status;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ set status(status) {
        this._status = status;
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ get op() {
        return this._attributes[0, $2Y7aX.SEMANTIC_ATTRIBUTE_SENTRY_OP];
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ set op(op) {
        this.setAttribute((0, $2Y7aX.SEMANTIC_ATTRIBUTE_SENTRY_OP), op);
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ get origin() {
        return this._attributes[0, $2Y7aX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN];
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ set origin(origin) {
        this.setAttribute((0, $2Y7aX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), origin);
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $5NO4E.TRACE_FLAG_SAMPLED) : (0, $5NO4E.TRACE_FLAG_NONE)
        };
    }
    /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startChild(spanContext) {
        const childSpan = new $8f015c96e068ddf8$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this._spanId,
            sampled: this._sampled,
            traceId: this._traceId
        });
        // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder = this.spanRecorder;
        // eslint-disable-next-line deprecation/deprecation
        if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder.add(childSpan);
        const rootSpan = (0, $lMAWl.getRootSpan)(this);
        // TODO: still set span.transaction here until we have a more permanent solution
        // Probably similarly to the weakmap we hold in node-experimental
        // eslint-disable-next-line deprecation/deprecation
        childSpan.transaction = rootSpan;
        if ((0, $cEq52.DEBUG_BUILD) && rootSpan) {
            const opStr = spanContext && spanContext.op || '< unknown op >';
            const nameStr = (0, $5NO4E.spanToJSON)(childSpan).description || '< unknown name >';
            const idStr = rootSpan.spanContext().spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            (0, $7htw4.logger).log(logMessage);
            this._logMessage = logMessage;
        }
        return childSpan;
    }
    /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ setTag(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setData(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ setHttpStatus(httpStatus) {
        (0, $9JbAT.setHttpStatus)(this, httpStatus);
        return this;
    }
    /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ setName(name) {
        this.updateName(name);
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ isSuccess() {
        return this._status === 'ok';
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ finish(endTimestamp) {
        return this.end(endTimestamp);
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        const rootSpan = (0, $lMAWl.getRootSpan)(this);
        if ((0, $cEq52.DEBUG_BUILD) && // Don't call this for transactions
        rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
            const logMessage = this._logMessage;
            if (logMessage) (0, $7htw4.logger).log(logMessage.replace('Starting', 'Finishing'));
        }
        this._endTime = (0, $5NO4E.spanTimeInputToSeconds)(endTimestamp);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ toTraceparent() {
        return (0, $5NO4E.spanToTraceHeader)(this);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ toContext() {
        return (0, $bP4Y8.dropUndefinedKeys)({
            data: this._getData(),
            description: this._name,
            endTimestamp: this._endTime,
            // eslint-disable-next-line deprecation/deprecation
            op: this.op,
            parentSpanId: this._parentSpanId,
            sampled: this._sampled,
            spanId: this._spanId,
            startTimestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            traceId: this._traceId
        });
    }
    /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ updateWithContext(spanContext) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data || {};
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        this._endTime = spanContext.endTimestamp;
        // eslint-disable-next-line deprecation/deprecation
        this.op = spanContext.op;
        this._parentSpanId = spanContext.parentSpanId;
        this._sampled = spanContext.sampled;
        this._spanId = spanContext.spanId || this._spanId;
        this._startTime = spanContext.startTimestamp || this._startTime;
        this._status = spanContext.status;
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags || {};
        this._traceId = spanContext.traceId || this._traceId;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ getTraceContext() {
        return (0, $5NO4E.spanToTraceContext)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $bP4Y8.dropUndefinedKeys)({
            data: this._getData(),
            description: this._name,
            op: this._attributes[0, $2Y7aX.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $2Y7aX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            _metrics_summary: (0, $3oItx.getMetricSummaryJsonForSpan)(this),
            profile_id: this._attributes[0, $2Y7aX.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._exclusiveTime,
            measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ toJSON() {
        return this.getSpanJSON();
    }
    /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ _getData() {
        // eslint-disable-next-line deprecation/deprecation
        const { data: data, _attributes: attributes } = this;
        const hasData = Object.keys(data).length > 0;
        const hasAttributes = Object.keys(attributes).length > 0;
        if (!hasData && !hasAttributes) return undefined;
        if (hasData && hasAttributes) return {
            ...data,
            ...attributes
        };
        return hasData ? data : attributes;
    }
}

});
parcelRegister("3oItx", function(module, exports) {

$parcel$export(module.exports, "getMetricSummaryJsonForSpan", () => $27961ce52b7be41f$export$2e7205e45c58797d);

var $bP4Y8 = parcelRequire("bP4Y8");




var $4DAh4 = parcelRequire("4DAh4");
/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ let $27961ce52b7be41f$var$SPAN_METRIC_SUMMARY;
function $27961ce52b7be41f$var$getMetricStorageForSpan(span) {
    return $27961ce52b7be41f$var$SPAN_METRIC_SUMMARY ? $27961ce52b7be41f$var$SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $27961ce52b7be41f$export$2e7205e45c58797d(span) {
    const storage = $27961ce52b7be41f$var$getMetricStorageForSpan(span);
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, $bP4Y8.dropUndefinedKeys)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function $27961ce52b7be41f$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = (0, $4DAh4.getActiveSpan)();
    if (span) {
        const storage = $27961ce52b7be41f$var$getMetricStorageForSpan(span) || new Map();
        const exportKey = `${metricType}:${sanitizedName}@${unit}`;
        const bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            const [, summary] = bucketItem;
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }
            ]);
        } else storage.set(bucketKey, [
            exportKey,
            {
                min: value,
                max: value,
                count: 1,
                sum: value,
                tags: tags
            }
        ]);
        if (!$27961ce52b7be41f$var$SPAN_METRIC_SUMMARY) $27961ce52b7be41f$var$SPAN_METRIC_SUMMARY = new WeakMap();
        $27961ce52b7be41f$var$SPAN_METRIC_SUMMARY.set(span, storage);
    }
}

});
parcelRegister("4DAh4", function(module, exports) {

$parcel$export(module.exports, "startSpan", () => $3606f142dfccb1dc$export$a1bd95187356f372);
$parcel$export(module.exports, "startInactiveSpan", () => $3606f142dfccb1dc$export$63dbba021a6b4047);
$parcel$export(module.exports, "getActiveSpan", () => $3606f142dfccb1dc$export$1be426a8e585c83e);
$parcel$export(module.exports, "getCapturedScopesOnSpan", () => $3606f142dfccb1dc$export$c08fbc656a245d03);

var $lS7eK = parcelRequire("lS7eK");
var $7htw4 = parcelRequire("7htw4");
var $bP4Y8 = parcelRequire("bP4Y8");

var $cEq52 = parcelRequire("cEq52");

var $gUaXH = parcelRequire("gUaXH");

var $5NO4E = parcelRequire("5NO4E");



var $iJP5v = parcelRequire("iJP5v");

var $3WK1v = parcelRequire("3WK1v");

var $9kSVd = parcelRequire("9kSVd");

var $3qQZ3 = parcelRequire("3qQZ3");
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function $3606f142dfccb1dc$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}, // eslint-disable-next-line @typescript-eslint/no-empty-function
afterFinish = ()=>{}) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $gUaXH.getCurrentHub)();
    const scope = (0, $3WK1v.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    const parentSpan = scope.getSpan();
    const spanContext = $3606f142dfccb1dc$var$normalizeContext(context);
    const activeSpan = $3606f142dfccb1dc$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, $9kSVd.handleCallbackErrors)(()=>callback(activeSpan), (error)=>{
        activeSpan && activeSpan.setStatus('internal_error');
        onError(error, activeSpan);
    }, ()=>{
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $3606f142dfccb1dc$export$a1bd95187356f372(context, callback) {
    const spanContext = $3606f142dfccb1dc$var$normalizeContext(context);
    return (0, $gUaXH.runWithAsyncContext)(()=>{
        return (0, $3WK1v.withScope)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $gUaXH.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $3606f142dfccb1dc$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0, $9kSVd.handleCallbackErrors)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    const { status: status } = (0, $5NO4E.spanToJSON)(activeSpan);
                    if (!status || status === 'ok') activeSpan.setStatus('internal_error');
                }
            }, ()=>activeSpan && activeSpan.end());
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const $3606f142dfccb1dc$export$cb9e396e6b90b703 = $3606f142dfccb1dc$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $3606f142dfccb1dc$export$c10292ad04b92aea(context, callback) {
    const spanContext = $3606f142dfccb1dc$var$normalizeContext(context);
    return (0, $gUaXH.runWithAsyncContext)(()=>{
        return (0, $3WK1v.withScope)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $gUaXH.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $3606f142dfccb1dc$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            }
            return (0, $9kSVd.handleCallbackErrors)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    const { status: status } = (0, $5NO4E.spanToJSON)(activeSpan);
                    if (!status || status === 'ok') activeSpan.setStatus('internal_error');
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $3606f142dfccb1dc$export$63dbba021a6b4047(context) {
    if (!(0, $3qQZ3.hasTracingEnabled)()) return undefined;
    const spanContext = $3606f142dfccb1dc$var$normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $gUaXH.getCurrentHub)();
    const parentSpan = context.scope ? context.scope.getSpan() : $3606f142dfccb1dc$export$1be426a8e585c83e();
    const shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return undefined;
    const scope = context.scope || (0, $3WK1v.getCurrentScope)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    const temporaryScope = scope.clone();
    return $3606f142dfccb1dc$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function $3606f142dfccb1dc$export$1be426a8e585c83e() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $3WK1v.getCurrentScope)().getSpan();
}
const $3606f142dfccb1dc$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ const currentScope = (0, $3WK1v.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $lS7eK.tracingContextFromHeaders)(sentryTrace, baggage);
    currentScope.setPropagationContext(propagationContext);
    if ((0, $cEq52.DEBUG_BUILD) && traceparentData) (0, $7htw4.logger).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    const transactionContext = {
        ...traceparentData,
        metadata: (0, $bP4Y8.dropUndefinedKeys)({
            dynamicSamplingContext: dynamicSamplingContext
        })
    };
    if (!callback) return transactionContext;
    return (0, $gUaXH.runWithAsyncContext)(()=>{
        return callback(transactionContext);
    });
};
function $3606f142dfccb1dc$var$createChildSpanOrTransaction(// eslint-disable-next-line deprecation/deprecation
hub, { parentSpan: parentSpan, spanContext: spanContext, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $3qQZ3.hasTracingEnabled)()) return undefined;
    const isolationScope = (0, $gUaXH.getIsolationScope)();
    let span;
    if (parentSpan && !forceTransaction) // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
    else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $iJP5v.getDynamicSamplingContextFromSpan)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const sampled = (0, $5NO4E.spanIsSampled)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    $3606f142dfccb1dc$var$setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function $3606f142dfccb1dc$var$normalizeContext(context) {
    if (context.startTime) {
        const ctx = {
            ...context
        };
        ctx.startTimestamp = (0, $5NO4E.spanTimeInputToSeconds)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
const $3606f142dfccb1dc$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $3606f142dfccb1dc$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
function $3606f142dfccb1dc$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, $bP4Y8.addNonEnumerableProperty)(span, $3606f142dfccb1dc$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $bP4Y8.addNonEnumerableProperty)(span, $3606f142dfccb1dc$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $3606f142dfccb1dc$export$c08fbc656a245d03(span) {
    return {
        scope: span[$3606f142dfccb1dc$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$3606f142dfccb1dc$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}

});
parcelRegister("9kSVd", function(module, exports) {

$parcel$export(module.exports, "handleCallbackErrors", () => $6cc095a8dfcad8ad$export$18ce21a8b7efd7e9);

var $5QZE4 = parcelRequire("5QZE4");
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $6cc095a8dfcad8ad$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $6cc095a8dfcad8ad$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $6cc095a8dfcad8ad$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $5QZE4.isThenable)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}

});

parcelRegister("3qQZ3", function(module, exports) {

$parcel$export(module.exports, "hasTracingEnabled", () => $27fce64c83dee28f$export$5008da00b1b6dee6);

var $3WK1v = parcelRequire("3WK1v");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $27fce64c83dee28f$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const client = (0, $3WK1v.getClient)();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}

});



parcelRegister("2Y7aX", function(module, exports) {

$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", () => $2296c04c99eaa4ca$export$d7a7d984b0791405);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", () => $2296c04c99eaa4ca$export$ccfe0a40627cc34b);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", () => $2296c04c99eaa4ca$export$1a413bd9a88fdb09);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", () => $2296c04c99eaa4ca$export$cca8dd30f57f805e);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", () => $2296c04c99eaa4ca$export$1efec95406bbe327);
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $2296c04c99eaa4ca$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $2296c04c99eaa4ca$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $2296c04c99eaa4ca$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $2296c04c99eaa4ca$export$cca8dd30f57f805e = 'sentry.origin';
/**
 * The id of the profile that this span occured in.
 */ const $2296c04c99eaa4ca$export$1efec95406bbe327 = 'profile_id';

});

parcelRegister("9JbAT", function(module, exports) {

$parcel$export(module.exports, "SpanStatus", () => $71514f5fada0e3ce$export$beb8e6a823e89c5d);
$parcel$export(module.exports, "spanStatusfromHttpCode", () => $71514f5fada0e3ce$export$ac65c70d78fcdb55);
$parcel$export(module.exports, "setHttpStatus", () => $71514f5fada0e3ce$export$2ad6630ec8164254);
/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var $71514f5fada0e3ce$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = 'ok';
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = 'deadline_exceeded';
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = 'unauthenticated';
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = 'permission_denied';
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = 'not_found';
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = 'resource_exhausted';
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = 'invalid_argument';
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = 'unimplemented';
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = 'unavailable';
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = 'internal_error';
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = 'unknown_error';
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = 'cancelled';
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = 'already_exists';
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = 'failed_precondition';
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = 'aborted';
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = 'out_of_range';
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = 'data_loss';
    SpanStatus["DataLoss"] = DataLoss;
})($71514f5fada0e3ce$export$beb8e6a823e89c5d || ($71514f5fada0e3ce$export$beb8e6a823e89c5d = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $71514f5fada0e3ce$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return 'ok';
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return 'unauthenticated';
        case 403:
            return 'permission_denied';
        case 404:
            return 'not_found';
        case 409:
            return 'already_exists';
        case 413:
            return 'failed_precondition';
        case 429:
            return 'resource_exhausted';
        default:
            return 'invalid_argument';
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return 'unimplemented';
        case 503:
            return 'unavailable';
        case 504:
            return 'deadline_exceeded';
        default:
            return 'internal_error';
    }
    return 'unknown_error';
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ const $71514f5fada0e3ce$export$ac65c70d78fcdb55 = $71514f5fada0e3ce$export$5fd4dc48a2131589;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $71514f5fada0e3ce$export$2ad6630ec8164254(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag('http.status_code', String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData('http.response.status_code', httpStatus);
    const spanStatus = $71514f5fada0e3ce$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus !== 'unknown_error') span.setStatus(spanStatus);
}

});


parcelRegister("htdtT", function(module, exports) {

$parcel$export(module.exports, "Transaction", () => $cb7f9a312d79f6b4$export$febc5573c75cefb0);

var $bP4Y8 = parcelRequire("bP4Y8");
var $7htw4 = parcelRequire("7htw4");

var $cEq52 = parcelRequire("cEq52");

var $gUaXH = parcelRequire("gUaXH");

var $3oItx = parcelRequire("3oItx");

var $2Y7aX = parcelRequire("2Y7aX");

var $5NO4E = parcelRequire("5NO4E");

var $iJP5v = parcelRequire("iJP5v");

var $chdgs = parcelRequire("chdgs");

var $4DAh4 = parcelRequire("4DAh4");
/** JSDoc */ class $cb7f9a312d79f6b4$export$febc5573c75cefb0 extends (0, $chdgs.Span) {
    /**
   * The reference to the current hub.
   */ // eslint-disable-next-line deprecation/deprecation
    // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(transactionContext, hub){
        super(transactionContext);
        this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        this._hub = hub || (0, $gUaXH.getCurrentHub)();
        this._name = transactionContext.name || '';
        this._metadata = {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.metadata
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    // This sadly conflicts with the getter/setter ordering :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name;
    }
    /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ set name(newName) {
        // eslint-disable-next-line deprecation/deprecation
        this.setName(newName);
    }
    /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ get metadata() {
        // We merge attributes in for backwards compatibility
        return {
            // Defaults
            // eslint-disable-next-line deprecation/deprecation
            source: 'custom',
            spanMetadata: {},
            // Legacy metadata
            ...this._metadata,
            // From attributes
            ...this._attributes[0, $2Y7aX.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] && {
                source: this._attributes[0, $2Y7aX.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]
            },
            ...this._attributes[0, $2Y7aX.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] && {
                sampleRate: this._attributes[0, $2Y7aX.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]
            }
        };
    }
    /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ set metadata(metadata) {
        this._metadata = metadata;
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ setName(name, source = 'custom') {
        this._name = name;
        this.setAttribute((0, $2Y7aX.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
    }
    /** @inheritdoc */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new (0, $chdgs.SpanRecorder)(maxlen);
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ setMeasurement(name, value, unit = '') {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ setMetadata(newMetadata) {
        this._metadata = {
            ...this._metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ end(endTimestamp) {
        const timestampInS = (0, $5NO4E.spanTimeInputToSeconds)(endTimestamp);
        const transaction = this._finishTransaction(timestampInS);
        if (!transaction) return undefined;
        // eslint-disable-next-line deprecation/deprecation
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        // eslint-disable-next-line deprecation/deprecation
        const spanContext = super.toContext();
        return (0, $bP4Y8.dropUndefinedKeys)({
            ...spanContext,
            name: this._name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        // eslint-disable-next-line deprecation/deprecation
        super.updateWithContext(transactionContext);
        this._name = transactionContext.name || '';
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ getDynamicSamplingContext() {
        return (0, $iJP5v.getDynamicSamplingContextFromSpan)(this);
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ // eslint-disable-next-line deprecation/deprecation
    setHub(hub) {
        this._hub = hub;
    }
    /**
   * Get the profile id of the transaction.
   */ getProfileId() {
        if (this._contexts !== undefined && this._contexts['profile'] !== undefined) return this._contexts['profile'].profile_id;
        return undefined;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this._endTime !== undefined) return undefined;
        if (!this._name) {
            (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        // just sets the end timestamp
        super.end(endTimestamp);
        // eslint-disable-next-line deprecation/deprecation
        const client = this._hub.getClient();
        if (client && client.emit) client.emit('finishTransaction', this);
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
            if (client) client.recordDroppedEvent('sample_rate', 'transaction');
            return undefined;
        }
        // eslint-disable-next-line deprecation/deprecation
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((span)=>span !== this && (0, $5NO4E.spanToJSON)(span).timestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            const endTimes = finishedSpans.map((span)=>(0, $5NO4E.spanToJSON)(span).timestamp).filter(Boolean);
            this._endTime = endTimes.reduce((prev, current)=>{
                return prev > current ? prev : current;
            });
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $4DAh4.getCapturedScopesOnSpan)(this);
        // eslint-disable-next-line deprecation/deprecation
        const { metadata: metadata } = this;
        // eslint-disable-next-line deprecation/deprecation
        const { source: source } = metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: (0, $5NO4E.spanToTraceContext)(this)
            },
            // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
            spans: finishedSpans,
            start_timestamp: this._startTime,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                ...metadata,
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $bP4Y8.dropUndefinedKeys)({
                    dynamicSamplingContext: (0, $iJP5v.getDynamicSamplingContextFromSpan)(this)
                })
            },
            _metrics_summary: (0, $3oItx.getMetricSummaryJsonForSpan)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        // eslint-disable-next-line deprecation/deprecation
        (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);
        return transaction;
    }
}

});


parcelRegister("1fiFu", function(module, exports) {

$parcel$export(module.exports, "sampleTransaction", () => $0e85ac4609e3131b$export$b3258c3993bc9b71);
$parcel$export(module.exports, "isValidSampleRate", () => $0e85ac4609e3131b$export$2603c8d332a51c42);

var $7htw4 = parcelRequire("7htw4");
var $5QZE4 = parcelRequire("5QZE4");

var $cEq52 = parcelRequire("cEq52");

var $2Y7aX = parcelRequire("2Y7aX");

var $3qQZ3 = parcelRequire("3qQZ3");

var $5NO4E = parcelRequire("5NO4E");
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $0e85ac4609e3131b$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $3qQZ3.hasTracingEnabled)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, $2Y7aX.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, $2Y7aX.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, $2Y7aX.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, $2Y7aX.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$0e85ac4609e3131b$export$2603c8d332a51c42(sampleRate)) {
        (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).warn('[Tracing] Discarding transaction because of invalid sample rate.');
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, $cEq52.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
    (0, $7htw4.logger).log(`[Tracing] starting ${transaction.op} transaction - ${(0, $5NO4E.spanToJSON)(transaction).description}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $0e85ac4609e3131b$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $5QZE4.isNaN)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
        (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}

});


parcelRegister("8upap", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire);
$parcel$export(module.exports, "loadModule", () => loadModule);

var $7eDcu = parcelRequire("7eDcu");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $7eDcu.isBrowserBundle)() && Object.prototype.toString.call(0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, 'process');
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("7eDcu", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", () => $54483f9c35a67705$export$2928c40372e623c0);
$parcel$export(module.exports, "getSDKSource", () => $54483f9c35a67705$export$8ad33f488b1ab046);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $54483f9c35a67705$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $54483f9c35a67705$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});



parcelRegister("iUSsr", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

parcelRegister("YChVI", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("krIeN", function(module, exports) {
!function webpackUniversalModuleDefinition(t, e) {
    var n, r;
    module.exports = e();
}(window, function() {
    return function(o) {
        function webpackJsonpCallback(t) {
            for(var e, n, r = t[0], i = t[1], s = 0, a = []; s < r.length; s++)n = r[s], u[n] && a.push(u[n][0]), u[n] = 0;
            for(e in i)Object.prototype.hasOwnProperty.call(i, e) && (o[e] = i[e]);
            for(c && c(t); a.length;)a.shift()();
        }
        var n = {}, u = {
            0: 0
        };
        function __webpack_require__(t) {
            if (n[t]) return n[t].exports;
            var e = n[t] = {
                i: t,
                l: !1,
                exports: {}
            };
            return o[t].call(e.exports, e, e.exports, __webpack_require__), e.l = !0, e.exports;
        }
        __webpack_require__.e = function requireEnsure(i) {
            var t = [], n = u[i];
            if (0 !== n) {
                if (n) t.push(n[2]);
                else {
                    var e = new Promise(function(t, e) {
                        n = u[i] = [
                            t,
                            e
                        ];
                    });
                    t.push(n[2] = e);
                    var r, s = document.createElement("script");
                    s.charset = "utf-8", s.timeout = 120, __webpack_require__.nc && s.setAttribute("nonce", __webpack_require__.nc), s.src = function jsonpScriptSrc(t) {
                        return __webpack_require__.p + "tf-" + (({})[t] || t) + "-" + ({
                            1: "2aa33b10e0e549020c12"
                        })[t] + ".js";
                    }(i);
                    var a = new Error;
                    r = function(t) {
                        s.onerror = s.onload = null, clearTimeout(o);
                        var e = u[i];
                        if (0 !== e) {
                            if (e) {
                                var n = t && ("load" === t.type ? "missing" : t.type), r = t && t.target && t.target.src;
                                a.message = "Loading chunk " + i + " failed.\n(" + n + ": " + r + ")", a.name = "ChunkLoadError", a.type = n, a.request = r, e[1](a);
                            }
                            u[i] = void 0;
                        }
                    };
                    var o = setTimeout(function() {
                        r({
                            type: "timeout",
                            target: s
                        });
                    }, 12e4);
                    s.onerror = s.onload = r, document.head.appendChild(s);
                }
            }
            return Promise.all(t);
        }, __webpack_require__.m = o, __webpack_require__.c = n, __webpack_require__.d = function(t, e, n) {
            __webpack_require__.o(t, e) || Object.defineProperty(t, e, {
                enumerable: !0,
                get: n
            });
        }, __webpack_require__.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, __webpack_require__.t = function(e, t) {
            if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (__webpack_require__.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var r in e)__webpack_require__.d(n, r, (function(t) {
                return e[t];
            }).bind(null, r));
            return n;
        }, __webpack_require__.n = function(t) {
            var e = t && t.__esModule ? function getDefault() {
                return t.default;
            } : function getModuleExports() {
                return t;
            };
            return __webpack_require__.d(e, "a", e), e;
        }, __webpack_require__.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, __webpack_require__.p = "", __webpack_require__.oe = function(t) {
            throw console.error(t), t;
        };
        var t = window.webpackJsonp = window.webpackJsonp || [], e = t.push.bind(t);
        t.push = webpackJsonpCallback, t = t.slice();
        for(var r = 0; r < t.length; r++)webpackJsonpCallback(t[r]);
        var c = e;
        return __webpack_require__(__webpack_require__.s = 127);
    }([
        function(L, t, e) {
            (function(M) {
                (function() {
                    "use strict";
                    var o, e = "Sugar", f = 1, d = 2, t = !(!Object.defineProperty || !Object.defineProperties), h = function getGlobal() {
                        return testGlobal(void 0 !== M && M) || testGlobal("undefined" != typeof window && window);
                    }(), p = !1, m = {}, y = {}, i = t ? Object.defineProperty : function definePropertyShim(t, e, n) {
                        t[e] = n.value;
                    }, u = getNewChainableClass("Chainable");
                    function testGlobal(t) {
                        return t && t.Object === Object ? t : null;
                    }
                    function createNamespace(u) {
                        var c = "Object" === u, l = getNewChainableClass(u);
                        function defineWithOptionCollect(t, i, s) {
                            setProperty(l, t, function(t, e, n) {
                                var r = collectDefineOptions(t, e, n);
                                return function defineMethods(r, t, i, s, a) {
                                    g(t, function(t, e) {
                                        var n = t;
                                        s && (n = wrapMethodWithArguments(t)), a && (n.flags = a), i & d && !t.instance && setProperty(n, "instance", function wrapInstanceMethod(t, e) {
                                            return e ? wrapMethodWithArguments(t, !0) : function wrapInstanceMethodFixed(i) {
                                                switch(i.length){
                                                    case 0:
                                                    case 1:
                                                        return function() {
                                                            return i(this);
                                                        };
                                                    case 2:
                                                        return function(t) {
                                                            return i(this, t);
                                                        };
                                                    case 3:
                                                        return function(t, e) {
                                                            return i(this, t, e);
                                                        };
                                                    case 4:
                                                        return function(t, e, n) {
                                                            return i(this, t, e, n);
                                                        };
                                                    case 5:
                                                        return function(t, e, n, r) {
                                                            return i(this, t, e, n, r);
                                                        };
                                                }
                                            }(t);
                                        }(t, s)), i & f && setProperty(n, "static", !0), setMethod(r, e, n), r.active && r.extend(e);
                                    });
                                }(l, r.methods, i, s, r.last), l;
                            });
                        }
                        return defineWithOptionCollect("defineStatic", f), defineWithOptionCollect("defineInstance", d), defineWithOptionCollect("defineInstanceAndStatic", d | f), defineWithOptionCollect("defineStaticWithArguments", f, !0), defineWithOptionCollect("defineInstanceWithArguments", d, !0), setProperty(l, "defineStaticPolyfill", function(t, e, n) {
                            var r = collectDefineOptions(t, e, n);
                            return extendNative(h[u], r.methods, !0, r.last), l;
                        }), setProperty(l, "defineInstancePolyfill", function(t, e, n) {
                            var r = collectDefineOptions(t, e, n);
                            return extendNative(h[u].prototype, r.methods, !0, r.last), g(r.methods, function(t, e) {
                                defineChainableMethod(l, e, t);
                            }), l;
                        }), setProperty(l, "alias", function(t, e) {
                            var n = "string" == typeof e ? l[e] : e;
                            return setMethod(l, t, n), l;
                        }), setProperty(l, "extend", function(s) {
                            var n, r = h[u], i = r.prototype, a = {}, o = {};
                            function arrayOptionExists(t, e) {
                                var n = s[t];
                                if (n) {
                                    for(var r, i = 0; r = n[i]; i++)if (r === e) return !0;
                                }
                                return !1;
                            }
                            function canExtend(t, e, n) {
                                return !function objectRestricted(t, e) {
                                    return c && e === i && (!p || "get" === t || "set" === t);
                                }(t, n) && !function disallowedByFlags(t, e, n) {
                                    if (!e[t] || !n) return !1;
                                    for(var r = 0; r < n.length; r++)if (!1 === s[n[r]]) return !0;
                                }(t, n, e.flags) && !function methodIsExcepted(t) {
                                    return arrayOptionExists("except", t);
                                }(t);
                            }
                            if (n = (s = s || {}).methods, !function namespaceIsExcepted() {
                                return arrayOptionExists("except", r) || function arrayOptionExcludes(t, e) {
                                    return s[t] && !arrayOptionExists(t, e);
                                }("namespaces", r);
                            }()) return c && "boolean" == typeof s.objectPrototype && (p = s.objectPrototype), g(n || l, function(t, e) {
                                n && (t = l[e = t]), hasOwn(t, "instance") && canExtend(e, t, i) && (o[e] = t.instance), hasOwn(t, "static") && canExtend(e, t, r) && (a[e] = t);
                            }), extendNative(r, a), extendNative(i, o), n || setProperty(l, "active", !0), l;
                        }), m[u] = l, y["[object " + u + "]"] = l, mapNativeToChainable(u), function mapObjectChainablesToNamespace(n) {
                            g(o.Object && o.Object.prototype, function(t, e) {
                                "function" == typeof t && setObjectChainableOnNamespace(n, e, t);
                            });
                        }(l), o[u] = l;
                    }
                    function toString() {
                        return e;
                    }
                    function collectDefineOptions(t, e, n) {
                        var r;
                        return {
                            last: "string" == typeof t ? ((r = {})[t] = e, n) : (r = t, e),
                            methods: r
                        };
                    }
                    function wrapMethodWithArguments(i, s) {
                        var a = i.length - 1 - (s ? 1 : 0);
                        return function() {
                            var t, e = [], n = [];
                            s && e.push(this), t = Math.max(arguments.length, a);
                            for(var r = 0; r < t; r++)r < a ? e.push(arguments[r]) : n.push(arguments[r]);
                            return e.push(n), i.apply(this, e);
                        };
                    }
                    function extendNative(n, t, r, i) {
                        g(t, function(t, e) {
                            r && !i && n[e] || setProperty(n, e, t);
                        });
                    }
                    function setMethod(t, e, n) {
                        (t[e] = n).instance && defineChainableMethod(t, e, n.instance);
                    }
                    function getNewChainableClass(t) {
                        var n = function SugarChainable(t, e) {
                            if (!(this instanceof n)) return new n(t, e);
                            this.constructor !== n && (t = this.constructor.apply(t, arguments)), this.raw = t;
                        };
                        return setProperty(n, "toString", function() {
                            return e + t;
                        }), setProperty(n.prototype, "valueOf", function() {
                            return this.raw;
                        }), n;
                    }
                    function defineChainableMethod(t, e, n) {
                        var r, i, s, a = function wrapWithChainableResult(t) {
                            return function() {
                                return new u(t.apply(this.raw, arguments));
                            };
                        }(n);
                        i = (r = (s = u.prototype)[e]) && r !== Object.prototype[e], r && r.disambiguate || (s[e] = i ? function disambiguateMethod(n) {
                            function Ed() {
                                var t, e = this.raw;
                                return null != e && (t = y[classToString(e)]), new (t = t || o.Object)(e)[n].apply(this, arguments);
                            }
                            return Ed.disambiguate = !0, Ed;
                        }(e) : a), t.prototype[e] = a, t === o.Object && function mapObjectChainableToAllNamespaces(e, n) {
                            g(m, function(t) {
                                setObjectChainableOnNamespace(t, e, n);
                            });
                        }(e, a);
                    }
                    function setObjectChainableOnNamespace(t, e, n) {
                        var r = t.prototype;
                        hasOwn(r, e) || (r[e] = n);
                    }
                    function mapNativeToChainable(t, e) {
                        var n = m[t], r = h[t].prototype;
                        !e && s && (e = s(r)), g(e, function(t) {
                            if (!function nativeMethodProhibited(t) {
                                return "constructor" === t || "valueOf" === t || "__proto__" === t;
                            }(t)) {
                                try {
                                    var e = r[t];
                                    if ("function" != typeof e) return;
                                } catch (t) {
                                    return;
                                }
                                defineChainableMethod(n, t, e);
                            }
                        });
                    }
                    var s = Object.getOwnPropertyNames, n = Object.prototype.toString, r = Object.prototype.hasOwnProperty, g = function(t, e) {
                        for(var n in t)if (hasOwn(t, n) && !1 === e.call(t, t[n], n, t)) break;
                    };
                    function setProperty(t, e, n, r) {
                        i(t, e, {
                            value: n,
                            enumerable: !!r,
                            configurable: !0,
                            writable: !0
                        });
                    }
                    function classToString(t) {
                        return n.call(t);
                    }
                    function hasOwn(t, e) {
                        return !!t && r.call(t, e);
                    }
                    function getOwn(t, e) {
                        if (hasOwn(t, e)) return t[e];
                    }
                    !function setupGlobal() {
                        if (!(o = h[e])) {
                            if (o = function(n) {
                                return g(o, function(t, e) {
                                    hasOwn(m, e) && t.extend(n);
                                }), o;
                            }, L.exports) L.exports = o;
                            else try {
                                h[e] = o;
                            } catch (t) {}
                            g("Object Number String Array Date RegExp Function".split(" "), function(t) {
                                createNamespace(t);
                            }), function setGlobalProperties() {
                                setProperty(o, "VERSION", "2.0.6"), setProperty(o, "extend", o), setProperty(o, "toString", toString), setProperty(o, "createNamespace", createNamespace), setProperty(o, "util", {
                                    hasOwn: hasOwn,
                                    getOwn: getOwn,
                                    setProperty: setProperty,
                                    classToString: classToString,
                                    defineProperty: i,
                                    forEachProperty: g,
                                    mapNativeToChainable: mapNativeToChainable
                                });
                            }();
                        }
                    }();
                    var a, c, l, b = !("0" in Object("a")), v = "	\n\v\f\r \xa0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u2028\u2029\u3000\uFEFF", O = ".", _ = ",", C = o.Object, w = o.Array, x = o.Date, k = o.String, j = (o.Number, o.Function);
                    o.RegExp;
                    function isClass(t, e, n) {
                        return (n = n || classToString(t)) === "[object " + e + "]";
                    }
                    function wrapNamespace(r) {
                        return function(t, e, n) {
                            t[r](e, n);
                        };
                    }
                    wrapNamespace("alias"), wrapNamespace("defineStatic"), wrapNamespace("defineInstance");
                    var S = wrapNamespace("defineStaticPolyfill"), P = wrapNamespace("defineInstancePolyfill");
                    wrapNamespace("defineInstanceAndStatic"), wrapNamespace("defineInstanceWithArguments");
                    function assertCallable(t) {
                        if (!c(t)) throw new TypeError("Function is not callable");
                    }
                    function isDefined(t) {
                        return void 0 !== t;
                    }
                    function isObjectType(t, e) {
                        return !!t && "object" === (e || typeof t);
                    }
                    function isPrimitive(t, e) {
                        return e = e || typeof t, null == t || "string" === e || "number" === e || "boolean" === e;
                    }
                    function isPlainObject(t, e) {
                        return isObjectType(t) && isClass(t, "Object", e) && function hasValidPlainObjectPrototype(t) {
                            var e = "toString" in t, n = "constructor" in t;
                            return !n && !e || n && !hasOwn(t, "constructor") && hasOwn(t.constructor.prototype, "isPrototypeOf");
                        }(t) && function hasOwnEnumeratedProperties(t) {
                            var e = Object.prototype;
                            for(var n in t){
                                var r = t[n];
                                if (!hasOwn(t, n) && r !== e[n]) return !1;
                            }
                            return !0;
                        }(t);
                    }
                    function isArrayIndex(t) {
                        return t >>> 0 == t && 4294967295 != t;
                    }
                    function iterateOverSparseArray(t, e, n, r) {
                        for(var i, s = getSparseArrayIndexes(t, n, r), a = 0, o = s.length; a < o; a++)i = s[a], e.call(t, t[i], i, t);
                        return t;
                    }
                    function getSparseArrayIndexes(t, r, e, n) {
                        var i, s = [];
                        for(i in t)isArrayIndex(i) && (e || (n ? i <= r : r <= i)) && s.push(+i);
                        return s.sort(function(t, e) {
                            var n = r < t;
                            return n != r < e ? n ? -1 : 1 : t - e;
                        }), s;
                    }
                    function spaceSplit(t) {
                        return t.split(" ");
                    }
                    function forEach(t, e) {
                        for(var n = 0, r = t.length; n < r; n++){
                            if (!(n in t)) return iterateOverSparseArray(t, e, n);
                            e(t[n], n);
                        }
                    }
                    var E, T = Math.trunc || function(t) {
                        return 0 !== t && isFinite(t) ? t < 0 ? F(t) : R(t) : t;
                    };
                    function padNumber(t, e, n, r, i) {
                        var s = N(t).toString(r || 10);
                        return s = function repeatString(t, e) {
                            var n = "";
                            t = t.toString();
                            for(; 0 < e;)1 & e && (n += t), (e >>= 1) && (t += t);
                            return n;
                        }(i || "0", e - s.replace(/\.\d+/, "").length) + s, (n || t < 0) && (s = (t < 0 ? "-" : "+") + s), s;
                    }
                    var N = Math.abs, F = (Math.pow, Math.min, Math.max, Math.ceil), R = Math.floor, D = (Math.round, String.fromCharCode);
                    (function privatePropertyAccessor(t) {
                        var n = "_sugar_" + t;
                        return function(t, e) {
                            return 1 < arguments.length ? (setProperty(t, n, e), t) : t[n];
                        };
                    })("utc");
                    !function buildClassChecks() {
                        var n = {};
                        function addKnownType(t) {
                            n["[object " + t + "]"] = !0;
                        }
                        function buildClassCheck(t, e) {
                            return e && isClass(new e, "Object") ? function getConstructorClassCheck(t) {
                                var e = String(t);
                                return function(t) {
                                    return String(t.constructor) === e;
                                };
                            }(e) : function getToStringClassCheck(n) {
                                return function(t, e) {
                                    return isClass(t, n, e);
                                };
                            }(t);
                        }
                        function buildPrimitiveClassCheck(n) {
                            var r = n.toLowerCase();
                            return function(t) {
                                var e = typeof t;
                                return e === r || "object" == e && isClass(t, n);
                            };
                        }
                        !function addCoreTypes() {
                            var t = spaceSplit("Boolean Number String Date RegExp Function Array Error Set Map");
                            buildPrimitiveClassCheck(t[0]), buildPrimitiveClassCheck(t[1]), a = buildPrimitiveClassCheck(t[2]), buildClassCheck(t[3]), buildClassCheck(t[4]), c = buildClassCheck(t[5]), l = Array.isArray || buildClassCheck(t[6]), buildClassCheck(t[7]), buildClassCheck(t[8], "undefined" != typeof Set && Set), buildClassCheck(t[9], "undefined" != typeof Map && Map), addKnownType("Arguments"), addKnownType(t[0]), addKnownType(t[1]), addKnownType(t[2]), addKnownType(t[3]), addKnownType(t[4]), addKnownType(t[6]);
                        }(), function addArrayTypes() {
                            forEach(spaceSplit("Int8 Uint8 Uint8Clamped Int16 Uint16 Int32 Uint32 Float32 Float64"), function(t) {
                                addKnownType(t + "Array");
                            });
                        }();
                    }(), function buildFullWidthNumber() {
                        var t = O, e = _, n = "";
                        E = {};
                        for(var r, i = 0; i <= 9; i++)n += r = D(i + 65296), E[r] = D(i + 48);
                        E[e] = "", E["\uFF0E"] = t, E[t] = t, function allCharsReg(t) {
                            return RegExp("[" + t + "]", "g");
                        }(n + "\uFF0E" + e + t), n;
                    }();
                    var I = [
                        "valueOf",
                        "toString",
                        "constructor",
                        "isPrototypeOf",
                        "hasOwnProperty",
                        "toLocaleString",
                        "propertyIsEnumerable"
                    ];
                    function arrayIndexOf(t, e, n, r) {
                        var i, s, a, o = t.length;
                        for(a = r ? -1 : 1, i = r ? o - 1 : 0, (n = T(n)) || 0 === n || (n = i), n < 0 && (n = o + n), (!r && n < 0 || r && o <= n) && (n = i), s = n; r && 0 <= s || !r && s < o;){
                            if (!(s in t)) return sparseIndexOf(t, e, n, r);
                            if (isArrayIndex(s) && t[s] === e) return s;
                            s += a;
                        }
                        return -1;
                    }
                    function sparseIndexOf(t, e, n, r) {
                        var i, s = getSparseArrayIndexes(t, n, !1, r);
                        for(s.sort(function(t, e) {
                            return r ? e - t : t - e;
                        }); void 0 !== (i = s.shift());)if (t[i] === e) return +i;
                        return -1;
                    }
                    function arrayReduce(t, e, n, r) {
                        var i, s, a = t.length, o = 0, u = isDefined(n);
                        if (assertCallable(e), 0 == a && !u) throw new TypeError("Reduce called on empty array with no initial value");
                        for(u ? i = n : (i = t[r ? a - 1 : o], o++); o < a;)(s = r ? a - o - 1 : o) in t && (i = e(i, t[s], s, t)), o++;
                        return i;
                    }
                    !function buildDontEnumFix() {
                        if (!({
                            toString: 1
                        }).propertyIsEnumerable("toString")) {
                            var i = g;
                            g = function(t, e) {
                                i(t, e);
                                for(var n, r = 0; (n = I[r]) && (!hasOwn(t, n) || !1 !== e.call(t, t[n], n, t)); r++);
                            };
                        }
                    }(), function buildChainableNativeMethodsFix() {
                        Object.getOwnPropertyNames || !function defineNativeMethodsOnChainable() {
                            var r = "FullYear,Month,Date,Hours,Minutes,Seconds,Milliseconds".split(",");
                            function addDateTokens(t, e) {
                                for(var n = 0; n < r.length; n++)e.push(t + r[n]);
                            }
                            g({
                                Function: "apply,call",
                                RegExp: "compile,exec,test",
                                Number: "toExponential,toFixed,toLocaleString,toPrecision",
                                Object: "hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString",
                                Array: "concat,join,pop,push,reverse,shift,slice,sort,splice,toLocaleString,unshift",
                                Date: "getTime,getTimezoneOffset,setTime,toDateString,toGMTString,toLocaleDateString,toLocaleString,toLocaleTimeString,toTimeString,toUTCString",
                                String: "anchor,big,blink,bold,charAt,charCodeAt,concat,fixed,fontcolor,fontsize,indexOf,italics,lastIndexOf,link,localeCompare,match,replace,search,slice,small,split,strike,sub,substr,substring,sup,toLocaleLowerCase,toLocaleUpperCase,toLowerCase,toUpperCase"
                            }, function(t, e) {
                                var n = t.split(",");
                                "Date" === e && (addDateTokens("get", n), addDateTokens("set", n), addDateTokens("getUTC", n), addDateTokens("setUTC", n)), n.push("toString"), mapNativeToChainable(e, n);
                            });
                        }();
                    }(), S(C, {
                        keys: function(t) {
                            var n = [];
                            return function assertNonNull(t) {
                                if (null == t) throw new TypeError("Object required");
                            }(t), g(function coercePrimitiveToObject(t) {
                                return isPrimitive(t) && (t = Object(t)), b && a(t) && function forceStringCoercion(t) {
                                    var e, n = 0;
                                    for(; e = t.charAt(n);)t[n++] = e;
                                }(t), t;
                            }(t), function(t, e) {
                                n.push(e);
                            }), n;
                        }
                    }), S(w, {
                        isArray: function(t) {
                            return l(t);
                        }
                    }), P(w, {
                        every: function(t) {
                            var e = arguments[1], n = this.length, r = 0;
                            for(assertCallable(t); r < n;){
                                if (r in this && !t.call(e, this[r], r, this)) return !1;
                                r++;
                            }
                            return !0;
                        },
                        some: function(t) {
                            var e = arguments[1], n = this.length, r = 0;
                            for(assertCallable(t); r < n;){
                                if (r in this && t.call(e, this[r], r, this)) return !0;
                                r++;
                            }
                            return !1;
                        },
                        map: function(t) {
                            var e = arguments[1], n = this.length, r = 0, i = new Array(n);
                            for(assertCallable(t); r < n;)r in this && (i[r] = t.call(e, this[r], r, this)), r++;
                            return i;
                        },
                        filter: function(t) {
                            var e = arguments[1], n = this.length, r = 0, i = [];
                            for(assertCallable(t); r < n;)r in this && t.call(e, this[r], r, this) && i.push(this[r]), r++;
                            return i;
                        },
                        indexOf: function(t) {
                            var e = arguments[1];
                            return a(this) ? this.indexOf(t, e) : arrayIndexOf(this, t, e);
                        },
                        lastIndexOf: function(t) {
                            var e = arguments[1];
                            return a(this) ? this.lastIndexOf(t, e) : arrayIndexOf(this, t, e, !0);
                        },
                        forEach: function(t) {
                            var e = arguments[1], n = this.length, r = 0;
                            for(assertCallable(t); r < n;)r in this && t.call(e, this[r], r, this), r++;
                        },
                        reduce: function(t) {
                            return arrayReduce(this, t, arguments[1]);
                        },
                        reduceRight: function(t) {
                            return arrayReduce(this, t, arguments[1], !0);
                        }
                    });
                    var A = RegExp("^[" + v + "]+|[" + v + "]+$", "g");
                    P(k, {
                        trim: function() {
                            return this.toString().replace(A, "");
                        }
                    }), P(j, {
                        bind: function(r) {
                            for(var i = [], t = 1, e = arguments.length; t < e; t++)i.push(arguments[t]);
                            var n, s = this;
                            return assertCallable(this), (n = function() {
                                for(var t = [], e = 0, n = arguments.length; e < n; e++)t.push(arguments[e]);
                                return s.apply(s.prototype && this instanceof s ? this : r, i.concat(t));
                            }).prototype = this.prototype, n;
                        }
                    }), S(x, {
                        now: function() {
                            return (new Date).getTime();
                        }
                    }), P(x, {
                        toISOString: function() {
                            return padNumber(this.getUTCFullYear(), 4) + "-" + padNumber(this.getUTCMonth() + 1, 2) + "-" + padNumber(this.getUTCDate(), 2) + "T" + padNumber(this.getUTCHours(), 2) + ":" + padNumber(this.getUTCMinutes(), 2) + ":" + padNumber(this.getUTCSeconds(), 2) + "." + padNumber(this.getUTCMilliseconds(), 3) + "Z";
                        },
                        toJSON: function(t) {
                            return this.toISOString(t);
                        }
                    }, !function hasISOSupport() {
                        var t = new Date(Date.UTC(2e3, 0));
                        return !!t.toISOString && "2000-01-01T00:00:00.000Z" === t.toISOString();
                    }());
                }).call(this);
            }).call(this, e(94));
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "defaultsBool", function() {
                return i;
            }), n.d(e, "defaultsStr", function() {
                return s;
            }), n.d(e, "defaultsNb", function() {
                return a;
            }), n.d(e, "defaultsArr", function() {
                return o;
            }), n.d(e, "defaultsFn", function() {
                return u;
            });
            var r = n(3), i = function defaultsBool(t, e) {
                return Object(r.isBoolean)(t) ? t : e;
            }, s = function defaultsStr(t, e) {
                return Object(r.isString)(t) ? t : e;
            }, a = function defaultsNb(t, e) {
                return isNaN(t) ? e : t;
            }, o = function defaultsArr(t, e) {
                return Object(r.isArray)(t) ? t : e;
            }, u = function defaultsFn(t, e) {
                return Object(r.isFn)(t) ? t : e;
            };
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "getText", function() {
                return o;
            }), n.d(e, "getFirstTextNode", function() {
                return u;
            }), n.d(e, "createElm", function() {
                return c;
            }), n.d(e, "removeElm", function() {
                return l;
            }), n.d(e, "createText", function() {
                return f;
            }), n.d(e, "hasClass", function() {
                return d;
            }), n.d(e, "addClass", function() {
                return h;
            }), n.d(e, "removeClass", function() {
                return p;
            }), n.d(e, "createOpt", function() {
                return m;
            }), n.d(e, "createCheckItem", function() {
                return y;
            }), n.d(e, "elm", function() {
                return g;
            }), n.d(e, "tag", function() {
                return b;
            });
            var r = n(9), s = n(3), i = n(8), a = r.root.document, o = function getText(t) {
                return Object(s.isUndef)(t.textContent) ? Object(i.trim)(t.innerText) : Object(i.trim)(t.textContent);
            }, u = function getFirstTextNode(t) {
                for(var e = 0; e < t.childNodes.length; e++){
                    var n = t.childNodes[e];
                    if (3 === n.nodeType) return n.data;
                }
            }, c = function createElm(t) {
                var e = arguments.length <= 0 ? void 0 : t;
                if (!Object(s.isString)(e)) return null;
                for(var n = a.createElement(e), r = 0; r < arguments.length; r++){
                    var i = r < 0 || arguments.length <= r ? void 0 : arguments[r];
                    Object(s.isArray)(i) && 2 === i.length && n.setAttribute(i[0], i[1]);
                }
                return n;
            }, l = function removeElm(t) {
                return t.parentNode.removeChild(t);
            }, f = function createText(t) {
                return a.createTextNode(t);
            }, d = function hasClass(t, e) {
                return !Object(s.isUndef)(t) && (supportsClassList() ? t.classList.contains(e) : t.className.match(new RegExp("(\\s|^)" + e + "(\\s|$)")));
            }, h = function addClass(t, e) {
                Object(s.isUndef)(t) || (supportsClassList() ? t.classList.add(e) : "" === t.className ? t.className = e : d(t, e) || (t.className += " " + e));
            }, p = function removeClass(t, e) {
                if (!Object(s.isUndef)(t)) {
                    if (supportsClassList()) t.classList.remove(e);
                    else {
                        var n = new RegExp("(\\s|^)" + e + "(\\s|$)", "g");
                        t.className = t.className.replace(n, "");
                    }
                }
            }, m = function createOpt(t, e, n) {
                var r = !!n ? c("option", [
                    "value",
                    e
                ], [
                    "selected",
                    "true"
                ]) : c("option", [
                    "value",
                    e
                ]);
                return r.appendChild(f(t)), r;
            }, y = function createCheckItem(t, e, n, r) {
                var i = 3 < arguments.length && void 0 !== r ? r : [], s = c("li"), a = c("label", [
                    "for",
                    t
                ]), o = c("input", [
                    "id",
                    t
                ], [
                    "name",
                    t
                ], [
                    "type",
                    "checkbox"
                ], [
                    "value",
                    e
                ], i);
                return a.appendChild(o), a.appendChild(f(n)), s.appendChild(a), s.label = a, s.check = o, s;
            }, g = function elm(t) {
                return a.getElementById(t);
            }, b = function tag(t, e) {
                return t.getElementsByTagName(e);
            };
            function supportsClassList() {
                return a.documentElement.classList;
            }
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "EMPTY_FN", function() {
                return r;
            }), n.d(e, "isObj", function() {
                return i;
            }), n.d(e, "isFn", function() {
                return s;
            }), n.d(e, "isArray", function() {
                return a;
            }), n.d(e, "isString", function() {
                return o;
            }), n.d(e, "isNumber", function() {
                return u;
            }), n.d(e, "isBoolean", function() {
                return c;
            }), n.d(e, "isUndef", function() {
                return l;
            }), n.d(e, "isNull", function() {
                return f;
            }), n.d(e, "isEmpty", function() {
                return d;
            });
            var r = function EMPTY_FN() {}, i = function isObj(t) {
                return "[object Object]" === Object.prototype.toString.call(t);
            }, s = function isFn(t) {
                return "[object Function]" === Object.prototype.toString.call(t);
            }, a = function isArray(t) {
                return "[object Array]" === Object.prototype.toString.call(t);
            }, o = function isString(t) {
                return "[object String]" === Object.prototype.toString.call(t);
            }, u = function isNumber(t) {
                return "[object Number]" === Object.prototype.toString.call(t);
            }, c = function isBoolean(t) {
                return "[object Boolean]" === Object.prototype.toString.call(t);
            }, l = function isUndef(t) {
                return void 0 === t;
            }, f = function isNull(t) {
                return null === t;
            }, d = function isEmpty(t) {
                return l(t) || f(t) || 0 === t.length;
            };
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "INPUT", function() {
                return r;
            }), n.d(e, "SELECT", function() {
                return i;
            }), n.d(e, "MULTIPLE", function() {
                return s;
            }), n.d(e, "CHECKLIST", function() {
                return a;
            }), n.d(e, "NONE", function() {
                return o;
            }), n.d(e, "ENTER_KEY", function() {
                return u;
            }), n.d(e, "TAB_KEY", function() {
                return c;
            }), n.d(e, "ESC_KEY", function() {
                return l;
            }), n.d(e, "UP_ARROW_KEY", function() {
                return f;
            }), n.d(e, "DOWN_ARROW_KEY", function() {
                return d;
            }), n.d(e, "HEADER_TAG", function() {
                return h;
            }), n.d(e, "CELL_TAG", function() {
                return p;
            }), n.d(e, "STRING", function() {
                return m;
            }), n.d(e, "NUMBER", function() {
                return y;
            }), n.d(e, "FORMATTED_NUMBER", function() {
                return g;
            }), n.d(e, "DATE", function() {
                return b;
            }), n.d(e, "IP_ADDRESS", function() {
                return v;
            }), n.d(e, "AUTO_FILTER_DELAY", function() {
                return O;
            });
            var r = "input", i = "select", s = "multiple", a = "checklist", o = "none", u = 13, c = 9, l = 27, f = 38, d = 40, h = "TH", p = "TD", m = "string", y = "number", g = "formatted-number", b = "date", v = "ipaddress", O = 750;
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "addEvt", function() {
                return i;
            }), n.d(e, "removeEvt", function() {
                return s;
            }), n.d(e, "stopEvt", function() {
                return a;
            }), n.d(e, "cancelEvt", function() {
                return o;
            }), n.d(e, "targetEvt", function() {
                return u;
            }), n.d(e, "keyCode", function() {
                return c;
            }), n.d(e, "isKeyPressed", function() {
                return l;
            }), n.d(e, "bound", function() {
                return bound;
            });
            var r = n(9), i = function addEvt(t, e, n, r) {
                t.addEventListener ? t.addEventListener(e, n, r) : t.attachEvent ? t.attachEvent("on" + e, n) : t["on" + e] = n;
            }, s = function removeEvt(t, e, n, r) {
                t.removeEventListener ? t.removeEventListener(e, n, r) : t.detachEvent ? t.detachEvent("on" + e, n) : t["on" + e] = null;
            }, a = function stopEvt(t) {
                (t = t || r.root.event).stopPropagation ? t.stopPropagation() : t.cancelBubble = !0;
            }, o = function cancelEvt(t) {
                (t = t || r.root.event).preventDefault ? t.preventDefault() : t.returnValue = !1;
            }, u = function targetEvt(t) {
                return (t = t || r.root.event).target || t.srcElement;
            }, c = function keyCode(t) {
                return t.charCode ? t.charCode : t.keyCode ? t.keyCode : t.which ? t.which : 0;
            }, l = function isKeyPressed(t, e) {
                return -1 !== (1 < arguments.length && void 0 !== e ? e : []).indexOf(c(t));
            };
            function bound(t, e) {
                var n = "".concat(t.name, "_bound");
                return e[n] || (e[n] = t.bind(e)), e[n];
            }
        },
        function(t, e, n) {
            "use strict";
            n(182)();
        },
        function(t, e, n) {
            "use strict";
            n(267)();
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "trim", function() {
                return r;
            }), n.d(e, "isEmpty", function() {
                return i;
            }), n.d(e, "rgxEsc", function() {
                return u;
            }), n.d(e, "matchCase", function() {
                return s;
            }), n.d(e, "contains", function() {
                return a;
            }), n.d(e, "toCamelCase", function() {
                return c;
            }), n.d(e, "uuid", function() {
                return l;
            });
            var o = n(88), r = function trim(t) {
                return t.trim ? t.trim() : t.replace(/^\s*|\s*$/g, "");
            }, i = function isEmpty(t) {
                return "" === r(t);
            }, u = function rgxEsc(t) {
                return String(t).replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
            }, s = function matchCase(t, e) {
                return 1 < arguments.length && void 0 !== e && e ? t : t.toLowerCase();
            }, a = function contains(t, e, n, r, i) {
                var s = 2 < arguments.length && void 0 !== n && n, a = 3 < arguments.length && void 0 !== r && r ? "g" : "gi";
                return 4 < arguments.length && void 0 !== i && i && (t = Object(o.remove)(t), e = Object(o.remove)(e)), (s ? new RegExp("(^\\s*)" + u(t) + "(\\s*$)", a) : new RegExp(u(t), a)).test(e);
            }, c = function toCamelCase(t) {
                return (0 < arguments.length && void 0 !== t ? t : "").replace(/^([A-Z])|[\s-_]+(\w)/g, function(t, e, n) {
                    return n ? n.toUpperCase() : e.toLowerCase();
                });
            }, l = function uuid() {
                function hq() {
                    return Math.random().toString(16).slice(-4);
                }
                return hq() + hq() + "-" + hq() + "-" + hq() + "-" + hq() + "-" + hq() + hq() + hq();
            };
        },
        function(t, n, r) {
            "use strict";
            r.r(n), (function(t) {
                function _typeof(t) {
                    return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(t) {
                        return typeof t;
                    } : function _typeof(t) {
                        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                    })(t);
                }
                r.d(n, "root", function() {
                    return e;
                });
                var e = "object" === ("undefined" == typeof self ? "undefined" : _typeof(self)) && self.self === self && self || "object" === (void 0 === t ? "undefined" : _typeof(t)) && t.global === t && t || void 0;
            }).call(this, r(94));
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "Feature", function() {
                return s;
            });
            var r = n(8);
            function _defineProperties(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            var i = "Not implemented.", s = function() {
                function Feature(t, e) {
                    var n = this;
                    !function _classCallCheck(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, Feature), e.meta = e.meta || {}, this.tf = t, this.feature = e.meta.altName || e.meta.name || Object(r.toCamelCase)(e.name), this.enabled = t[this.feature], this.config = t.config(), this.emitter = t.emitter, this.initialized = !1, this.emitter.on([
                        "destroy"
                    ], function() {
                        return n.destroy();
                    });
                }
                return function _createClass(t, e, n) {
                    return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
                }(Feature, [
                    {
                        key: "init",
                        value: function init() {
                            throw new Error(i);
                        }
                    },
                    {
                        key: "reset",
                        value: function reset() {
                            this.enable(), this.init();
                        }
                    },
                    {
                        key: "destroy",
                        value: function destroy() {
                            throw new Error(i);
                        }
                    },
                    {
                        key: "enable",
                        value: function enable() {
                            this.enabled = !0;
                        }
                    },
                    {
                        key: "disable",
                        value: function disable() {
                            this.enabled = !1;
                        }
                    },
                    {
                        key: "isEnabled",
                        value: function isEnabled() {
                            return !0 === this.enabled;
                        }
                    }
                ]), Feature;
            }();
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(14).localeManager;
            r.Date.defineStatic({
                addLocale: function(t, e) {
                    return i.add(t, e);
                }
            }), t.exports = r.Date.addLocale;
        },
        function(t, e, n) {
            "use strict";
            var r, i, s, a, o, u, c, l, f, d, h, p = n(142), m = n(32), y = n(98), g = n(52), b = n(143);
            !function buildClassChecks() {
                var n = {};
                function addKnownType(t) {
                    n["[object " + t + "]"] = !0;
                }
                function buildClassCheck(t, e) {
                    return e && y(new e, "Object") ? function getConstructorClassCheck(t) {
                        var e = String(t);
                        return function(t) {
                            return String(t.constructor) === e;
                        };
                    }(e) : function getToStringClassCheck(n) {
                        return function(t, e) {
                            return y(t, n, e);
                        };
                    }(t);
                }
                function buildPrimitiveClassCheck(n) {
                    var r = n.toLowerCase();
                    return function(t) {
                        var e = typeof t;
                        return e === r || "object" == e && y(t, n);
                    };
                }
                !function addCoreTypes() {
                    var t = g(p);
                    i = buildPrimitiveClassCheck(t[0]), s = buildPrimitiveClassCheck(t[1]), a = buildPrimitiveClassCheck(t[2]), o = buildClassCheck(t[3]), u = buildClassCheck(t[4]), c = buildClassCheck(t[5]), l = Array.isArray || buildClassCheck(t[6]), h = buildClassCheck(t[7]), f = buildClassCheck(t[8], "undefined" != typeof Set && Set), d = buildClassCheck(t[9], "undefined" != typeof Map && Map), addKnownType("Arguments"), addKnownType(t[0]), addKnownType(t[1]), addKnownType(t[2]), addKnownType(t[3]), addKnownType(t[4]), addKnownType(t[6]);
                }(), function addArrayTypes() {
                    m(g("Int8 Uint8 Uint8Clamped Int16 Uint16 Int32 Uint32 Float32 Float64"), function(t) {
                        addKnownType(t + "Array");
                    });
                }(), r = function(t, e) {
                    return function isKnownType(t) {
                        return n[t];
                    }(e) || b(t, e);
                };
            }(), t.exports = {
                isSerializable: r,
                isBoolean: i,
                isNumber: s,
                isString: a,
                isDate: o,
                isRegExp: u,
                isFunction: c,
                isArray: l,
                isSet: f,
                isMap: d,
                isError: h
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = {
                HOURS_INDEX: 3,
                DAY_INDEX: 4,
                WEEK_INDEX: 5,
                MONTH_INDEX: 6,
                YEAR_INDEX: 7
            };
        },
        function(t, e, n) {
            "use strict";
            var r, i, s = n(129), a = n(95), o = n(133);
            !function buildLocales() {
                function LocaleManager(t) {
                    this.locales = {}, this.add(t);
                }
                LocaleManager.prototype = {
                    get: function(t, e) {
                        var n = this.locales[t];
                        return !n && s[t] ? n = this.add(t, s[t]) : !n && t && (n = this.locales[t.slice(0, 2)]), n || !1 === e ? n : this.current;
                    },
                    getAll: function() {
                        return this.locales;
                    },
                    set: function(t) {
                        var e = this.get(t, !1);
                        if (!e) throw new TypeError("Invalid Locale: " + t);
                        return this.current = e;
                    },
                    add: function(t, e) {
                        e ? e.code = t : t = (e = t).code;
                        var n = e.compiledFormats ? e : o(e);
                        return this.locales[t] = n, this.current || (this.current = n), n;
                    },
                    remove: function(t) {
                        return this.current.code === t && (this.current = this.get("en")), delete this.locales[t];
                    }
                }, r = o(a), i = new LocaleManager(r);
            }(), t.exports = {
                English: r,
                localeManager: i
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = {
                abs: Math.abs,
                pow: Math.pow,
                min: Math.min,
                max: Math.max,
                ceil: Math.ceil,
                floor: Math.floor,
                round: Math.round
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            t.exports = {
                hasOwn: r.util.hasOwn,
                getOwn: r.util.getOwn,
                setProperty: r.util.setProperty,
                classToString: r.util.classToString,
                defineProperty: r.util.defineProperty,
                forEachProperty: r.util.forEachProperty,
                mapNativeToChainable: r.util.mapNativeToChainable
            };
        },
        function(t, e, n) {
            "use strict";
            n(323)();
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "LEFT", function() {
                return r;
            }), n.d(e, "RIGHT", function() {
                return c;
            }), n.d(e, "CENTER", function() {
                return l;
            }), n.d(e, "Toolbar", function() {
                return f;
            });
            var i = n(10), s = n(2), a = n(1), o = n(3);
            function _typeof(t) {
                return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(t) {
                    return typeof t;
                } : function _typeof(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function _defineProperties(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function _setPrototypeOf(t, e) {
                return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(t, e) {
                    return t.__proto__ = e, t;
                })(t, e);
            }
            function _createSuper(r) {
                var i = function _isNativeReflectConstruct() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
                    } catch (t) {
                        return !1;
                    }
                }();
                return function _createSuperInternal() {
                    var t, e = _getPrototypeOf(r);
                    if (i) {
                        var n = _getPrototypeOf(this).constructor;
                        t = Reflect.construct(e, arguments, n);
                    } else t = e.apply(this, arguments);
                    return function _possibleConstructorReturn(t, e) {
                        return !e || "object" !== _typeof(e) && "function" != typeof e ? function _assertThisInitialized(t) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }(t) : e;
                    }(this, t);
                };
            }
            function _getPrototypeOf(t) {
                return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                })(t);
            }
            var u = [
                "initializing-feature",
                "initializing-extension"
            ], r = "left", c = "right", l = "center", f = function() {
                !function _inherits(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && _setPrototypeOf(t, e);
                }(Toolbar, i["Feature"]);
                var r = _createSuper(Toolbar);
                function Toolbar(t) {
                    var n;
                    !function _classCallCheck(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, Toolbar);
                    var e = (n = r.call(this, t, Toolbar)).config.toolbar || {};
                    return n.contCssClass = Object(a.defaultsStr)(e.container_css_class, "inf"), n.lContCssClass = Object(a.defaultsStr)(e.left_cont_css_class, "ldiv"), n.rContCssClass = Object(a.defaultsStr)(e.right_cont_css_class, "rdiv"), n.cContCssClass = Object(a.defaultsStr)(e.center_cont_css_class, "mdiv"), n.tgtId = Object(a.defaultsStr)(e.target_id, null), n.cont = null, n.lCont = null, n.rCont = null, n.cCont = null, n.innerCont = {
                        left: null,
                        center: null,
                        right: null
                    }, n.emitter.on(u, function(t, e) {
                        return n.init(e);
                    }), n.enabled = !0, n;
                }
                return function _createClass(t, e, n) {
                    return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
                }(Toolbar, [
                    {
                        key: "init",
                        value: function init(t) {
                            if (!this.initialized && !t) {
                                var e = this.tf, n = Object(s.createElm)("div");
                                if (n.className = this.contCssClass, this.tgtId) Object(s.elm)(this.tgtId).appendChild(n);
                                else if (e.gridLayout) {
                                    var r = e.Mod.gridLayout;
                                    r.tblMainCont.appendChild(n), n.className = r.infDivCssClass;
                                } else {
                                    var i = Object(s.createElm)("caption");
                                    i.appendChild(n), e.dom().insertBefore(i, e.dom().firstChild);
                                }
                                this.cont = n, this.lCont = this.createContainer(n, this.lContCssClass), this.rCont = this.createContainer(n, this.rContCssClass), this.cCont = this.createContainer(n, this.cContCssClass), this.innerCont = {
                                    left: this.lCont,
                                    center: this.cCont,
                                    right: this.rCont
                                }, this.initialized = !0, Object(o.isUndef)(e.help) && (e.Mod.help.enable(), this.emitter.emit("init-help", e));
                            }
                        }
                    },
                    {
                        key: "container",
                        value: function container(t, e) {
                            var n = 0 < arguments.length && void 0 !== t ? t : c, r = 1 < arguments.length ? e : void 0, i = this.innerCont[n];
                            return r && i.appendChild(r), i;
                        }
                    },
                    {
                        key: "createContainer",
                        value: function createContainer(t, e) {
                            var n = Object(s.createElm)("div", [
                                "class",
                                e
                            ]);
                            return t.appendChild(n), n;
                        }
                    },
                    {
                        key: "destroy",
                        value: function destroy() {
                            if (this.initialized) {
                                var t = this.tf;
                                Object(s.removeElm)(this.cont), this.cont = null;
                                var e = t.dom(), n = Object(s.tag)(e, "caption");
                                [].forEach.call(n, function(t) {
                                    return Object(s.removeElm)(t);
                                }), this.initialized = !1;
                            }
                        }
                    }
                ]), Toolbar;
            }();
            f.meta = {
                alwaysInstantiate: !0
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(121);
            t.exports = function Range(t, e) {
                this.start = r(t), this.end = r(e);
            };
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "has", function() {
                return r;
            });
            var a = n(8), r = function has(t, e, n) {
                for(var r = Boolean(n), i = 0, s = t.length; i < s; i++)if (Object(a.matchCase)(t[i].toString(), r) === e) return !0;
                return !1;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(16).forEachProperty;
            t.exports = function defineOnPrototype(t, e) {
                var n = t.prototype;
                r(e, function(t, e) {
                    n[e] = t;
                });
            };
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "parse", function() {
                return r;
            });
            var s = n(3), r = function parse(t, e) {
                var n = 1 < arguments.length && void 0 !== e ? e : ".";
                if (Object(s.isNumber)(t)) return t;
                var r = new RegExp("[^0-9-" + n + "]", [
                    "g"
                ]), i = parseFloat(("" + t).replace(/\((.*)\)/, "-$1").replace(r, "").replace(n, "."));
                return isNaN(i) ? 0 : i;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(25);
            t.exports = function callDateGet(t, e) {
                return t["get" + (r(t) ? "UTC" : "") + e]();
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(23);
            t.exports = function getWeekday(t) {
                return r(t, "Day");
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(148);
            t.exports = r("utc");
        },
        function(t, e, n) {
            "use strict";
            var r = n(15), i = r.ceil, s = r.floor, a = Math.trunc || function(t) {
                return 0 !== t && isFinite(t) ? t < 0 ? i(t) : s(t) : t;
            };
            t.exports = a;
        },
        function(t, e, n) {
            "use strict";
            var r = n(65);
            t.exports = function createDate(t, e, n) {
                return r(null, t, e, n).date;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            t.exports = {
                sugarObject: r.Object,
                sugarArray: r.Array,
                sugarDate: r.Date,
                sugarString: r.String,
                sugarNumber: r.Number,
                sugarFunction: r.Function,
                sugarRegExp: r.RegExp
            };
        },
        function(t, e, n) {
            "use strict";
            var a = n(39), o = n(40), u = n(24), r = n(12), i = n(15), c = r.isNumber, l = i.abs;
            t.exports = function setWeekday(t, e, n) {
                if (c(e)) {
                    var r = u(t);
                    if (n) {
                        var i = 0 < n ? 1 : -1, s = e % 7 - r;
                        s && s / l(s) != i && (e += 7 * i);
                    }
                    return a(t, o(t) + e - r), t.getTime();
                }
            };
        },
        function(t, e, n) {
            "use strict";
            n(399)();
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "ignoreCase", function() {
                return r;
            }), n.d(e, "numSortAsc", function() {
                return i;
            }), n.d(e, "numSortDesc", function() {
                return s;
            }), n.d(e, "dateSortAsc", function() {
                return u;
            }), n.d(e, "dateSortDesc", function() {
                return c;
            }), n.d(e, "sortNumberStr", function() {
                return l;
            }), n.d(e, "sortDateStr", function() {
                return f;
            });
            var a = n(22), o = n(47), r = function ignoreCase(t, e) {
                var n = t.toLowerCase(), r = e.toLowerCase();
                return n < r ? -1 : r < n ? 1 : 0;
            }, i = function numSortAsc(t, e) {
                return t - e;
            }, s = function numSortDesc(t, e) {
                return e - t;
            }, u = function dateSortAsc(t, e) {
                return t.getTime() - e.getTime();
            }, c = function dateSortDesc(t, e) {
                return e.getTime() - t.getTime();
            }, l = function sortNumberStr(i, t) {
                var s = 1 < arguments.length && void 0 !== t ? t : ",";
                return function(t, e) {
                    var n = Object(a.parse)(t, s), r = Object(a.parse)(e, s);
                    return i(n, r);
                };
            }, f = function sortDateStr(i, t) {
                var s = 1 < arguments.length && void 0 !== t ? t : "en-us";
                return function(t, e) {
                    var n = o.Date.create(t, s), r = o.Date.create(e, s);
                    return i(n, r);
                };
            };
        },
        function(t, e, n) {
            "use strict";
            var i = n(138);
            t.exports = function forEach(t, e) {
                for(var n = 0, r = t.length; n < r; n++){
                    if (!(n in t)) return i(t, e, n);
                    e(t[n], n);
                }
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = function isDefined(t) {
                return void 0 !== t;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(100), i = [
                {
                    name: "millisecond",
                    method: "Milliseconds",
                    multiplier: 1,
                    start: 0,
                    end: 999
                },
                {
                    name: "second",
                    method: "Seconds",
                    multiplier: 1e3,
                    start: 0,
                    end: 59
                },
                {
                    name: "minute",
                    method: "Minutes",
                    multiplier: 6e4,
                    start: 0,
                    end: 59
                },
                {
                    name: "hour",
                    method: "Hours",
                    multiplier: 36e5,
                    start: 0,
                    end: 23
                },
                {
                    name: "day",
                    alias: "date",
                    method: "Date",
                    ambiguous: !0,
                    multiplier: 864e5,
                    start: 1,
                    end: function(t) {
                        return r(t);
                    }
                },
                {
                    name: "week",
                    method: "ISOWeek",
                    ambiguous: !0,
                    multiplier: 6048e5
                },
                {
                    name: "month",
                    method: "Month",
                    ambiguous: !0,
                    multiplier: 26298e5,
                    start: 0,
                    end: 11
                },
                {
                    name: "year",
                    method: "FullYear",
                    ambiguous: !0,
                    multiplier: 315576e5,
                    start: 0
                }
            ];
            t.exports = i;
        },
        function(t, e, n) {
            "use strict";
            var r = n(23);
            t.exports = function getYear(t) {
                return r(t, "FullYear");
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(23);
            t.exports = function getMonth(t) {
                return r(t, "Month");
            };
        },
        function(t, e, n) {
            "use strict";
            var a = n(33), r = n(12), o = n(38), u = n(106), c = r.isFunction;
            t.exports = function setUnitAndLowerToEdge(r, t, i, s) {
                return u(t, function(t, e) {
                    var n = s ? t.end : t.start;
                    return c(n) && (n = n(r)), o(r, t.method, n), !a(i) || i < e;
                }), r;
            };
        },
        function(t, e, n) {
            "use strict";
            var i = n(25), s = n(23);
            t.exports = function callDateSet(t, e, n, r) {
                r && n === s(t, e, n) || t["set" + (i(t) ? "UTC" : "") + e](n);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(38);
            t.exports = function setDate(t, e) {
                r(t, "Date", e);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(23);
            t.exports = function getDate(t) {
                return r(t, "Date");
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(25);
            t.exports = function cloneDate(t) {
                var e = new Date(t.getTime());
                return r(e, !!r(t)), e;
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = function isUndefined(t) {
                return void 0 === t;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(13), i = r.HOURS_INDEX, s = r.DAY_INDEX, a = r.WEEK_INDEX, o = r.MONTH_INDEX;
            t.exports = function getLowerUnitIndex(t) {
                return t === o ? s : t === a ? i : t - 1;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(66);
            t.exports = function getNewDate() {
                return r("newDateInternal")();
            };
        },
        function(t, e, n) {
            "use strict";
            var s = n(54);
            t.exports = function advanceDate(t, e, n, r) {
                var i = {};
                return i[e] = n, s(t, i, r, 1);
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = function dateIsValid(t) {
                return !isNaN(t.getTime());
            };
        },
        function(t, e, n) {
            "use strict";
            n(128), n(387), t.exports = n(0);
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "BaseDropdown", function() {
                return i;
            });
            var r = n(10), d = n(31), h = n(3), p = n(4);
            function _typeof(t) {
                return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(t) {
                    return typeof t;
                } : function _typeof(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function _defineProperties(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function _setPrototypeOf(t, e) {
                return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(t, e) {
                    return t.__proto__ = e, t;
                })(t, e);
            }
            function _createSuper(r) {
                var i = function _isNativeReflectConstruct() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
                    } catch (t) {
                        return !1;
                    }
                }();
                return function _createSuperInternal() {
                    var t, e = _getPrototypeOf(r);
                    if (i) {
                        var n = _getPrototypeOf(this).constructor;
                        t = Reflect.construct(e, arguments, n);
                    } else t = e.apply(this, arguments);
                    return function _possibleConstructorReturn(t, e) {
                        return !e || "object" !== _typeof(e) && "function" != typeof e ? function _assertThisInitialized(t) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }(t) : e;
                    }(this, t);
                };
            }
            function _getPrototypeOf(t) {
                return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                })(t);
            }
            var i = function() {
                !function _inherits(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && _setPrototypeOf(t, e);
                }(BaseDropdown, r["Feature"]);
                var i = _createSuper(BaseDropdown);
                function BaseDropdown(t, e) {
                    var n;
                    !function _classCallCheck(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, BaseDropdown);
                    var r = (n = i.call(this, t, e)).config;
                    return n.customSorter = Object(h.isObj)(r.filter_options_sorter) && Object(h.isArray)(r.filter_options_sorter.col) && Object(h.isArray)(r.filter_options_sorter.comparer) ? r.filter_options_sorter : null, n.isCustom = !1, n.opts = [], n.optsTxt = [], n.excludedOpts = [], n;
                }
                return function _createClass(t, e, n) {
                    return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
                }(BaseDropdown, [
                    {
                        key: "sortOptions",
                        value: function sortOptions(t, e) {
                            var n = 1 < arguments.length && void 0 !== e ? e : [], r = this.tf;
                            if (r.isCustomOptions(t) || !r.sortSlc || Object(h.isArray)(r.sortSlc) && -1 === r.sortSlc.indexOf(t)) return n;
                            var i, s = r.caseSensitive, a = -1 !== r.sortFilterOptionsDesc.indexOf(t);
                            if (this.customSorter && -1 !== this.customSorter.col.indexOf(t)) {
                                var o = this.customSorter.col.indexOf(t);
                                i = this.customSorter.comparer[o];
                            } else if (r.hasType(t, [
                                p.NUMBER,
                                p.FORMATTED_NUMBER
                            ])) {
                                var u = r.getDecimal(t), c = a ? d.numSortDesc : d.numSortAsc;
                                i = Object(d.sortNumberStr)(c, u);
                            } else if (r.hasType(t, [
                                p.DATE
                            ])) {
                                var l = r.feature("dateType").getLocale(t), f = a ? d.dateSortDesc : d.dateSortAsc;
                                i = Object(d.sortDateStr)(f, l);
                            } else if (i = s ? void 0 : d.ignoreCase, a) return n.sort(i).reverse();
                            return n.sort(i);
                        }
                    },
                    {
                        key: "refreshFilters",
                        value: function refreshFilters(t) {
                            var n = this;
                            t.forEach(function(t) {
                                var e = n.getValues(t);
                                n.build(t, n.tf.linkedFilters), n.selectOptions(t, e);
                            });
                        }
                    },
                    {
                        key: "isValidLinkedValue",
                        value: function isValidLinkedValue(t, e) {
                            var n = this.tf;
                            if (n.disableExcludedOptions) return !0;
                            if (n.paging) {
                                if (!Object(h.isEmpty)(e) && n.isRowValid(t)) return !0;
                            } else if (n.isRowDisplayed(t)) return !0;
                            return !1;
                        }
                    },
                    {
                        key: "linkFilters",
                        value: function linkFilters() {
                            var t = this.tf;
                            t.linkedFilters && t.activeFilterId && this.refreshAll();
                        }
                    }
                ]), BaseDropdown;
            }();
        },
        function(t, e, n) {
            "use strict";
            var r = n(16).forEachProperty;
            t.exports = function simpleMerge(n, t) {
                return r(t, function(t, e) {
                    n[e] = t;
                }), n;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(49);
            t.exports = function simpleClone(t) {
                return r({}, t);
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = {
                HALF_WIDTH_ZERO: 48,
                FULL_WIDTH_ZERO: 65296,
                HALF_WIDTH_PERIOD: ".",
                FULL_WIDTH_PERIOD: "\uFF0E",
                HALF_WIDTH_COMMA: ",",
                OPEN_BRACE: "{",
                CLOSE_BRACE: "}"
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = function spaceSplit(t) {
                return t.split(" ");
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = function tzOffset(t) {
                return t.getTimezoneOffset();
            };
        },
        function(t, e, n) {
            "use strict";
            var h = n(34), r = n(13), p = n(26), m = n(39), y = n(40), g = n(36), i = n(44), b = n(29), s = n(15), v = n(23), a = n(12), O = n(162), _ = n(43), C = n(163), w = n(164), x = n(55), k = r.DAY_INDEX, j = r.WEEK_INDEX, S = r.MONTH_INDEX, P = r.YEAR_INDEX, E = s.round, T = a.isNumber;
            t.exports = function updateDate(o, u, t, c, l, f, e) {
                var d;
                function setUnit(t, e, n, r) {
                    var i, s, a = n.method;
                    !function setUpperUnit(t, e) {
                        l && !d && (d = "weekday" === t ? j : C(e));
                    }(t, r), function setSpecificity(t) {
                        t > u.specificity || (u.specificity = t);
                    }(r), (s = e % 1) && (function handleFraction(t, e, n) {
                        if (e) {
                            var r = h[_(e)], i = E(t.multiplier / r.multiplier * n);
                            u[r.name] = i;
                        }
                    }(n, r, s), e = p(e)), "weekday" !== t ? (i = r === S && 28 < y(o), !c || n.ambiguous ? (c && (r === j && (e *= 7, a = h[k].method), e = e * c + v(o, a)), w(o, a, e, c), i && function monthHasShifted(t, e) {
                        return e < 0 && (e = e % 12 + 12), e % 12 !== g(t);
                    }(o, e) && m(o, 0)) : o.setTime(o.getTime() + e * c * n.multiplier)) : c || b(o, e, f);
                }
                if (T(u) && c) u = {
                    millisecond: u
                };
                else if (T(u)) return o.setTime(u), o;
                return x(u, setUnit), t && u.specificity && O(o, u.specificity), function canDisambiguate() {
                    if (d && !(P < d)) switch(l){
                        case -1:
                            return o >= (e || i());
                        case 1:
                            return o <= (e || i());
                    }
                }() && function disambiguateHigherUnit() {
                    var t = h[d];
                    c = l, setUnit(t.name, 1, t, d);
                }(), o;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(13), a = n(33), o = n(167), u = n(64), c = r.DAY_INDEX;
            t.exports = function iterateOverDateParams(i, s, t, e) {
                function run(t, e, n) {
                    var r = o(i, t);
                    a(r) && s(t, r, e, n);
                }
                u(function(t, e) {
                    var n = run(t.name, t, e);
                    return !1 !== n && e === c && (n = run("weekday", t, e)), n;
                }, t, e);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(14), i = n(13), s = n(110), a = n(43), o = n(37), u = i.WEEK_INDEX, c = r.localeManager;
            t.exports = function moveToEndOfUnit(t, e, n, r) {
                return e === u && s(t, c.get(n).getFirstDayOfWeek()), o(t, a(e), r, !0);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(14), i = n(13), s = n(43), a = n(67), o = n(37), u = i.WEEK_INDEX, c = r.localeManager;
            t.exports = function moveToBeginningOfUnit(t, e, n) {
                return e === u && a(t, c.get(n).getFirstDayOfWeek()), o(t, s(e));
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(183), i = n(185), s = r.defineInstance;
            t.exports = function defineInstanceSimilar(t, e, n, r) {
                s(t, i(e, n), r);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(400);
            t.exports = function rangeIsValid(t) {
                return r(t.start) && r(t.end) && typeof t.start == typeof t.end;
            };
        },
        function(t, e, n) {
            "use strict";
            n.r(e);
            var a = n(9).root.document;
            e.default = {
                write: function write(t, e, n) {
                    var r = "";
                    n && (r = "; expires=" + (r = new Date((new Date).getTime() + 36e5 * n)).toGMTString()), a.cookie = t + "=" + escape(e) + r;
                },
                read: function read(t) {
                    var e = "", n = t + "=";
                    if (0 < a.cookie.length) {
                        var r = a.cookie, i = r.indexOf(n);
                        if (-1 !== i) {
                            i += n.length;
                            var s = r.indexOf(";", i);
                            -1 === s && (s = r.length), e = unescape(r.substring(i, s));
                        }
                    }
                    return e;
                },
                remove: function remove(t) {
                    this.write(t, "", -1);
                }
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(131), i = n(49), s = n(50);
            t.exports = function getEnglishVariant(t) {
                return i(s(r), t);
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = {
                ISO_FIRST_DAY_OF_WEEK: 1,
                ISO_FIRST_DAY_OF_WEEK_YEAR: 4
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = function isObjectType(t, e) {
                return !!t && "object" === (e || typeof t);
            };
        },
        function(t, e, n) {
            "use strict";
            var i = n(34), r = n(13), s = n(42), a = r.YEAR_INDEX;
            t.exports = function iterateOverDateUnits(t, e, n) {
                n = n || 0, s(e) && (e = a);
                for(var r = e; n <= r && !1 !== t(i[r], r); r--);
            };
        },
        function(t, e, n) {
            "use strict";
            var y = n(104), g = n(157), r = n(14), i = n(13), b = n(25), v = n(26), O = n(32), _ = n(53), C = n(33), w = n(105), x = n(44), k = n(54), j = n(29), S = n(49), P = n(45), E = n(42), s = n(12), T = n(46), N = n(50), F = n(63), R = n(56), D = n(169), a = n(16), I = n(57), A = n(55), M = n(170), L = n(171), H = s.isNumber, z = s.isString, B = s.isDate, W = a.getOwn, U = r.English, V = r.localeManager, Y = i.DAY_INDEX, K = i.WEEK_INDEX, G = i.MONTH_INDEX, q = i.YEAR_INDEX;
            t.exports = function getExtendedDate(i, t, e, n) {
                var a, o, u, s, c, l, f, d, h, r, p, m;
                function parseFormatValues(i, t) {
                    var s = p || {};
                    return O(t.to, function(t, e) {
                        var n, r = i[e + 1];
                        r && (n = function parseIrregular(t, e) {
                            if ("utc" === e) return 1;
                            if ("year" === e) {
                                var n = t.match(g);
                                if (n) return M(n[1], a, f);
                            }
                        }(r, t), E(n) && (n = u.parseValue(r, t)), s[t] = n);
                    }), s;
                }
                function cloneDateByFlag(t, e) {
                    return b(t) && !C(h) && (h = !0), b(t) && !C(r) && (r = !0), e && (t = new Date(t.getTime())), t;
                }
                function afterDateSet(t) {
                    s.push(t);
                }
                function handleAmpm(t) {
                    1 === t && o.hour < 12 ? o.hour += 12 : 0 === t && 12 === o.hour && (o.hour = 0);
                }
                function handleTimezoneOffset(t, e) {
                    b(a, !0), t < 0 && (e *= -1);
                    var n = 60 * t + (e || 0);
                    n && (o.minute = (o.minute || 0) - n);
                }
                function handleUnitlessShift() {
                    C(o.month) ? o.unit = q : C(o.weekday) && (o.unit = K);
                }
                function handleUnitlessNum(t) {
                    C(o.weekday) ? setOrdinalWeekday(t) : C(o.month) && (o.date = o.num);
                }
                function handleMidday(t) {
                    o.hour = t % 24, 23 < t && afterDateSet(function() {
                        P(a, "date", v(t / 24));
                    });
                }
                function handleRelativeDay() {
                    w(a), E(o.unit) && (o.unit = Y, o.num = o.day, delete o.day);
                }
                function handleRelativeUnit(t) {
                    var e;
                    e = C(o.num) ? o.num : C(o.edge) && E(o.shift) ? 0 : 1, C(o.weekday) && (t === G ? (setOrdinalWeekday(e), e = 1) : (k(a, {
                        weekday: o.weekday
                    }, !0), delete o.weekday)), o.half && (e *= o.half), C(o.shift) ? e *= o.shift : o.sign && (e *= o.sign), C(o.day) && (e += o.day, delete o.day), function separateAbsoluteUnits(i) {
                        var s;
                        A(o, function(t, e, n, r) {
                            if (i <= r) return a.setTime(NaN), !1;
                            r < i && ((s = s || {})[t] = e, D(o, t));
                        }), s && (afterDateSet(function() {
                            k(a, s, !0, 0, !1, l), p && S(p, s);
                        }), o.edge && (handleEdge(o.edge, s), delete o.edge));
                    }(t), o[U.units[t]] = e, c = !0;
                }
                function handleEdge(e, i) {
                    var n, s = i.unit;
                    s || L(i, function(t, e, n, r) {
                        "weekday" === t && C(i.month) || (s = r);
                    }), s === G && C(i.weekday) && (n = i.weekday, delete i.weekday), afterDateSet(function() {
                        var t;
                        e < 0 ? I(a, s, d) : 0 < e && (1 === e && I(a, t = Y), R(a, s, d, t)), C(n) && (j(a, n, -e), w(a));
                    }), i.specificity = s === G ? Y : s - 1;
                }
                function setOrdinalWeekday(t) {
                    o.weekday = 7 * (t - 1) + o.weekday, o.date = 1, l = 1;
                }
                return s = [], function setupOptions(t) {
                    t = z(t) ? {
                        locale: t
                    } : t || {}, f = +!!W(t, "future") - +!!W(t, "past"), d = W(t, "locale"), h = W(t, "fromUTC"), r = W(t, "setUTC"), p = W(t, "params"), m = W(t, "clone");
                }(e), a = i && t ? cloneDateByFlag(i, !0) : x(), b(a, h), z(t) ? a = function parseStringDate(t) {
                    t = t.toLowerCase(), u = V.get(d);
                    for(var e, n, r = 0; e = u.compiledFormats[r]; r++)if (n = t.match(e.reg)) {
                        if (u.cacheFormat(e, r), o = parseFormatValues(n, e), C(o.timestamp)) {
                            a.setTime(o.timestamp);
                            break;
                        }
                        C(o.ampm) && handleAmpm(o.ampm), (o.utc || C(o.tzHour)) && handleTimezoneOffset(o.tzHour, o.tzMinute), C(o.shift) && E(o.unit) && handleUnitlessShift(), C(o.num) && E(o.unit) && handleUnitlessNum(o.num), o.midday && handleMidday(o.midday), C(o.day) && handleRelativeDay(o.day), C(o.unit) && handleRelativeUnit(o.unit), o.edge && handleEdge(o.edge, o);
                        break;
                    }
                    return o ? c ? k(a, o, !1, 1) : k(a, o, !0, 0, f, l, i) : (a = new Date(t), h && T(a) && a.setTime(a.getTime() + _(a) * y)), function fireCallbacks() {
                        O(s, function(t) {
                            t.call();
                        });
                    }(), a;
                }(t) : B(t) ? a = cloneDateByFlag(t, m || n) : F(t) ? (o = N(t), k(a, o, !0)) : !H(t) && null !== t || a.setTime(t), b(a, !!r), {
                    set: o,
                    date: a
                };
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(158), i = n(28), s = n(160), a = i.sugarDate;
            t.exports = s(a, r);
        },
        function(t, e, n) {
            "use strict";
            var r = n(29), i = n(24), s = n(15).floor;
            t.exports = function moveToBeginningOfWeek(t, e) {
                return r(t, 7 * s((i(t) - e) / 7) + e), t;
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = function simpleCapitalize(t) {
                return t.charAt(0).toUpperCase() + t.slice(1);
            };
        },
        function(t, e, n) {
            "use strict";
            var a = n(26), o = n(41), u = n(45);
            t.exports = function getTimeDistanceForUnit(t, e, n) {
                var r, i, s = t < e;
                if (s || (i = e, e = t, t = i), r = e - t, 1 < n.multiplier && (r = a(r / n.multiplier)), n.ambiguous) for(t = o(t), r && (r -= 1, u(t, n.name, r)); t < e && (u(t, n.name, 1), !(e < t));)r += 1;
                return s ? -r : r;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(15), a = n(298), o = r.abs;
            t.exports = function padNumber(t, e, n, r, i) {
                var s = o(t).toString(r || 10);
                return s = a(i || "0", e - s.replace(/\.\d+/, "").length) + s, (n || t < 0) && (s = (t < 0 ? "-" : "+") + s), s;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(62), a = n(39), o = n(40), u = n(41), c = n(42), l = n(110), f = n(67), d = n(108), h = r.ISO_FIRST_DAY_OF_WEEK, p = r.ISO_FIRST_DAY_OF_WEEK_YEAR;
            t.exports = function getWeekNumber(t, e, n, r) {
                var i, s = 0;
                for(c(n) && (n = h), c(r) && (r = p), i = l(u(t), n), d(i, n, r), e && t < i && (i = f(u(t), n), d(i, n, r)); i <= t;)a(i, o(i) + 7), s++;
                return s;
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = "year|month|week|day|hour|minute|second|millisecond";
        },
        function(t, e, n) {
            "use strict";
            var r = n(12), p = n(59), m = n(124), y = n(402), g = n(403), b = n(404), v = n(126), O = r.isNumber, _ = r.isString, C = r.isDate, w = r.isFunction;
            t.exports = function rangeEvery(t, e, n, r) {
                var i, s, a, o, u = t.start, c = t.end, l = c < u, f = u, d = 0, h = [];
                if (!p(t)) return n ? NaN : [];
                for(w(e) && (r = e, e = null), e = e || 1, O(u) ? (s = b(u, e), i = function() {
                    return y(f, e, s);
                }) : _(u) ? i = function() {
                    return g(f, e);
                } : C(u) && (a = v(e), e = a[0], o = a[1], i = function() {
                    return m(f, e, o);
                }), l && 0 < e && (e *= -1); l ? c <= f : f <= c;)n || h.push(f), r && r(f, d, t), f = i(), d++;
                return n ? d - 1 : h;
            };
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "DateType", function() {
                return s;
            });
            var r = n(47), i = (n(422), n(10)), o = n(3), u = n(4), c = n(9);
            function _typeof(t) {
                return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(t) {
                    return typeof t;
                } : function _typeof(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function _defineProperties(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function _setPrototypeOf(t, e) {
                return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(t, e) {
                    return t.__proto__ = e, t;
                })(t, e);
            }
            function _createSuper(r) {
                var i = function _isNativeReflectConstruct() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
                    } catch (t) {
                        return !1;
                    }
                }();
                return function _createSuperInternal() {
                    var t, e = _getPrototypeOf(r);
                    if (i) {
                        var n = _getPrototypeOf(this).constructor;
                        t = Reflect.construct(e, arguments, n);
                    } else t = e.apply(this, arguments);
                    return function _possibleConstructorReturn(t, e) {
                        return !e || "object" !== _typeof(e) && "function" != typeof e ? function _assertThisInitialized(t) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }(t) : e;
                    }(this, t);
                };
            }
            function _getPrototypeOf(t) {
                return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                })(t);
            }
            var s = function() {
                !function _inherits(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && _setPrototypeOf(t, e);
                }(DateType, i["Feature"]);
                var n = _createSuper(DateType);
                function DateType(t) {
                    var e;
                    return function _classCallCheck(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, DateType), (e = n.call(this, t, DateType)).locale = t.locale, e.datetime = r.Date, e.enable(), e;
                }
                return function _createClass(t, e, n) {
                    return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
                }(DateType, [
                    {
                        key: "init",
                        value: function init() {
                            var n = this;
                            this.initialized || (this.datetime.setLocale(this.locale), this.addConfigFormats(this.tf.colTypes), this.emitter.on([
                                "add-date-type-formats"
                            ], function(t, e) {
                                return n.addConfigFormats(e);
                            }), this.emitter.emit("date-type-initialized", this.tf, this), this.initialized = !0);
                        }
                    },
                    {
                        key: "parse",
                        value: function parse(t, e) {
                            return this.datetime.create(t, e);
                        }
                    },
                    {
                        key: "isValid",
                        value: function isValid(t, e) {
                            return this.datetime.isValid(this.parse(t, e));
                        }
                    },
                    {
                        key: "getOptions",
                        value: function getOptions(t, e) {
                            var n = (e = e || this.tf.colTypes)[t];
                            return Object(o.isObj)(n) ? n : {};
                        }
                    },
                    {
                        key: "getLocale",
                        value: function getLocale(t) {
                            return this.getOptions(t).locale || this.locale;
                        }
                    },
                    {
                        key: "addConfigFormats",
                        value: function addConfigFormats(t) {
                            var s = this, a = 0 < arguments.length && void 0 !== t ? t : [];
                            a.forEach(function(t, e) {
                                var n = s.getOptions(e, a);
                                if (n.type === u.DATE && n.hasOwnProperty("format")) {
                                    var r = s.datetime.getLocale(n.locale || s.locale), i = Object(o.isArray)(n.format) ? n.format : [
                                        n.format
                                    ];
                                    try {
                                        i.forEach(function(t) {
                                            r.addFormat(t);
                                        });
                                    } catch (t) {
                                        c.root.console.error(t);
                                    }
                                }
                            });
                        }
                    },
                    {
                        key: "destroy",
                        value: function destroy() {
                            var n = this;
                            this.initialized && (this.emitter.off([
                                "add-date-type-formats"
                            ], function(t, e) {
                                return n.addConfigFormats(e);
                            }), this.initialized = !1);
                        }
                    }
                ]), DateType;
            }();
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "Help", function() {
                return r;
            });
            var i = n(10), o = n(2), u = n(5), s = n(4), a = n(9), c = n(3), l = n(1), f = n(18);
            function _typeof(t) {
                return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(t) {
                    return typeof t;
                } : function _typeof(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function _defineProperties(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function _setPrototypeOf(t, e) {
                return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(t, e) {
                    return t.__proto__ = e, t;
                })(t, e);
            }
            function _createSuper(r) {
                var i = function _isNativeReflectConstruct() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
                    } catch (t) {
                        return !1;
                    }
                }();
                return function _createSuperInternal() {
                    var t, e = _getPrototypeOf(r);
                    if (i) {
                        var n = _getPrototypeOf(this).constructor;
                        t = Reflect.construct(e, arguments, n);
                    } else t = e.apply(this, arguments);
                    return function _possibleConstructorReturn(t, e) {
                        return !e || "object" !== _typeof(e) && "function" != typeof e ? function _assertThisInitialized(t) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }(t) : e;
                    }(this, t);
                };
            }
            function _getPrototypeOf(t) {
                return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                })(t);
            }
            var d = "https://www.tablefilter.com/", r = function() {
                !function _inherits(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && _setPrototypeOf(t, e);
                }(Help, i["Feature"]);
                var r = _createSuper(Help);
                function Help(t) {
                    var e;
                    !function _classCallCheck(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, Help);
                    var n = (e = r.call(this, t, Help)).config.help_instructions || {};
                    return e.tgtId = Object(l.defaultsStr)(n.target_id, null), e.contTgtId = Object(l.defaultsStr)(n.container_target_id, null), e.instrText = Object(c.isEmpty)(n.text) ? 'Use the filters above each column to filter and limit table data. Advanced searches can be performed by using the following operators: <br /><b>&lt;</b>, <b>&lt;=</b>, <b>&gt;</b>, <b>&gt;=</b>, <b>=</b>, <b>*</b>, <b>!</b>, <b>{</b>, <b>}</b>, <b>||</b>,<b>&amp;&amp;</b>, <b>[empty]</b>, <b>[nonempty]</b>, <b>rgx:</b><br/><a href="https://github.com/koalyptus/TableFilter/wiki/4.-Filter-operators" target="_blank">Learn more</a><hr/>' : n.text, e.instrHtml = Object(l.defaultsStr)(n.html, null), e.btnText = Object(l.defaultsStr)(n.btn_text, "?"), e.btnHtml = Object(l.defaultsStr)(n.btn_html, null), e.btnCssClass = Object(l.defaultsStr)(n.btn_css_class, "helpBtn"), e.contCssClass = Object(l.defaultsStr)(n.container_css_class, "helpCont"), e.btn = null, e.cont = null, e.contAdjustLeftPosition = Object(l.defaultsNb)(n.container_adjust_left_position, 25), e.boundMouseup = null, e.defaultHtml = '<div class="helpFooter"><h4>TableFilter v' + t.version + '</h4><a href="' + d + '" target="_blank">' + d + "</a><br/><span>&copy;2015-" + t.year + ' Max Guglielmi</span><div align="center" style="margin-top:8px;"><a href="javascript:void(0);" class="close">Close</a></div></div>', e.toolbarPosition = Object(l.defaultsStr)(n.toolbar_position, f.RIGHT), e.emitter.on([
                        "init-help"
                    ], function() {
                        return e.init();
                    }), e;
                }
                return function _createClass(t, e, n) {
                    return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
                }(Help, [
                    {
                        key: "onMouseup",
                        value: function onMouseup(t) {
                            for(var e = Object(u.targetEvt)(t); e && e !== this.cont && e !== this.btn;)e = e.parentNode;
                            e !== this.cont && e !== this.btn && this.toggle();
                        }
                    },
                    {
                        key: "init",
                        value: function init() {
                            var t = this;
                            if (!this.initialized) {
                                this.emitter.emit("initializing-feature", this, !Object(c.isNull)(this.tgtId));
                                var e = this.tf, n = Object(o.createElm)("span"), r = Object(o.createElm)("div");
                                this.boundMouseup = this.onMouseup.bind(this), (this.tgtId ? Object(o.elm)(this.tgtId) : e.feature("toolbar").container(this.toolbarPosition)).appendChild(n);
                                var i = this.contTgtId ? Object(o.elm)(this.contTgtId) : n;
                                if (this.btnHtml) {
                                    n.innerHTML = this.btnHtml;
                                    var s = n.firstChild;
                                    Object(u.addEvt)(s, "click", function() {
                                        return t.toggle();
                                    }), i.appendChild(r);
                                } else {
                                    i.appendChild(r);
                                    var a = Object(o.createElm)("a", [
                                        "href",
                                        "javascript:void(0);"
                                    ]);
                                    a.className = this.btnCssClass, a.appendChild(Object(o.createText)(this.btnText)), n.appendChild(a), Object(u.addEvt)(a, "click", function() {
                                        return t.toggle();
                                    });
                                }
                                this.instrHtml ? (this.contTgtId && i.appendChild(r), r.innerHTML = this.instrHtml, this.contTgtId || (r.className = this.contCssClass)) : (r.innerHTML = this.instrText, r.className = this.contCssClass), r.innerHTML += this.defaultHtml, Object(u.addEvt)(r, "click", function() {
                                    return t.toggle();
                                }), this.cont = r, this.btn = n, this.initialized = !0, this.emitter.emit("feature-initialized", this);
                            }
                        }
                    },
                    {
                        key: "toggle",
                        value: function toggle() {
                            if (this.isEnabled()) {
                                Object(u.removeEvt)(a.root, "mouseup", this.boundMouseup);
                                var t = this.cont.style.display;
                                "" === t || t === s.NONE ? (this.cont.style.display = "inline", 0 < this.tf.dom().scrollLeft && (this.cont.style.left = "".concat(this.btn.offsetLeft - this.tf.dom().scrollLeft + this.contAdjustLeftPosition, "px")), Object(u.addEvt)(a.root, "mouseup", this.boundMouseup)) : (this.cont.style.display = s.NONE, this.cont.style.left = "");
                            }
                        }
                    },
                    {
                        key: "destroy",
                        value: function destroy() {
                            this.initialized && (Object(o.removeElm)(this.btn), this.btn = null, Object(o.removeElm)(this.cont), this.cont = null, this.boundMouseup = null, this.initialized = !1);
                        }
                    }
                ]), Help;
            }();
            r.meta = {
                alwaysInstantiate: !0
            };
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "State", function() {
                return r;
            });
            var i = n(10), s = n(92), a = n(93), o = n(8), u = n(3), c = n(1);
            function _typeof(t) {
                return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(t) {
                    return typeof t;
                } : function _typeof(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function _defineProperties(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function _setPrototypeOf(t, e) {
                return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(t, e) {
                    return t.__proto__ = e, t;
                })(t, e);
            }
            function _createSuper(r) {
                var i = function _isNativeReflectConstruct() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
                    } catch (t) {
                        return !1;
                    }
                }();
                return function _createSuperInternal() {
                    var t, e = _getPrototypeOf(r);
                    if (i) {
                        var n = _getPrototypeOf(this).constructor;
                        t = Reflect.construct(e, arguments, n);
                    } else t = e.apply(this, arguments);
                    return function _possibleConstructorReturn(t, e) {
                        return !e || "object" !== _typeof(e) && "function" != typeof e ? function _assertThisInitialized(t) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }(t) : e;
                    }(this, t);
                };
            }
            function _getPrototypeOf(t) {
                return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                })(t);
            }
            var r = function() {
                !function _inherits(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && _setPrototypeOf(t, e);
                }(State, i["Feature"]);
                var r = _createSuper(State);
                function State(t) {
                    var e;
                    !function _classCallCheck(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, State);
                    var n = (e = r.call(this, t, State)).config.state || {};
                    return e.enableHash = !0 === n || Object(u.isArray)(n.types) && -1 !== n.types.indexOf("hash"), e.enableLocalStorage = Object(u.isArray)(n.types) && -1 !== n.types.indexOf("local_storage"), e.enableCookie = Object(u.isArray)(n.types) && -1 !== n.types.indexOf("cookie"), e.persistFilters = Object(c.defaultsBool)(n.filters, !0), e.persistPageNumber = Boolean(n.page_number), e.persistPageLength = Boolean(n.page_length), e.persistSort = Boolean(n.sort), e.persistColsVisibility = Boolean(n.columns_visibility), e.persistFiltersVisibility = Boolean(n.filters_visibility), e.cookieDuration = Object(c.defaultsNb)(parseInt(n.cookie_duration, 10), 87600), e.enableStorage = e.enableLocalStorage || e.enableCookie, e.storage = null, e.hash = null, e.pageNb = null, e.pageLength = null, e.sort = null, e.hiddenCols = null, e.filtersVisibility = null, e.state = {}, e.prfxCol = "col_", e.pageNbKey = "page", e.pageLengthKey = "page_length", e.filtersVisKey = "filters_visibility", e;
                }
                return function _createClass(t, e, n) {
                    return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
                }(State, [
                    {
                        key: "init",
                        value: function init() {
                            var i = this;
                            this.initialized || (this.emitter.on([
                                "after-filtering"
                            ], function() {
                                return i.update();
                            }), this.emitter.on([
                                "after-page-change",
                                "after-clearing-filters"
                            ], function(t, e) {
                                return i.updatePage(e);
                            }), this.emitter.on([
                                "after-page-length-change"
                            ], function(t, e) {
                                return i.updatePageLength(e);
                            }), this.emitter.on([
                                "column-sorted"
                            ], function(t, e, n) {
                                return i.updateSort(e, n);
                            }), this.emitter.on([
                                "sort-initialized"
                            ], function() {
                                return i._syncSort();
                            }), this.emitter.on([
                                "columns-visibility-initialized"
                            ], function() {
                                return i._syncColsVisibility();
                            }), this.emitter.on([
                                "column-shown",
                                "column-hidden"
                            ], function(t, e, n, r) {
                                return i.updateColsVisibility(r);
                            }), this.emitter.on([
                                "filters-visibility-initialized"
                            ], function() {
                                return i._syncFiltersVisibility();
                            }), this.emitter.on([
                                "filters-toggled"
                            ], function(t, e, n) {
                                return i.updateFiltersVisibility(n);
                            }), this.enableHash && (this.hash = new s.Hash(this), this.hash.init()), this.enableStorage && (this.storage = new a.Storage(this), this.storage.init()), this.initialized = !0);
                        }
                    },
                    {
                        key: "update",
                        value: function update() {
                            var r = this;
                            if (this.isEnabled()) {
                                var i = this.state, t = this.tf;
                                if (this.persistFilters) t.getFiltersValue().forEach(function(t, e) {
                                    var n = "".concat(r.prfxCol).concat(e);
                                    Object(u.isString)(t) && Object(o.isEmpty)(t) ? i.hasOwnProperty(n) && (i[n].flt = void 0) : (i[n] = i[n] || {}, i[n].flt = t);
                                });
                                if (this.persistPageNumber && (Object(u.isNull)(this.pageNb) ? i[this.pageNbKey] = void 0 : i[this.pageNbKey] = this.pageNb), this.persistPageLength && (Object(u.isNull)(this.pageLength) ? i[this.pageLengthKey] = void 0 : i[this.pageLengthKey] = this.pageLength), this.persistSort && !Object(u.isNull)(this.sort)) {
                                    Object.keys(i).forEach(function(t) {
                                        -1 !== t.indexOf(r.prfxCol) && i[t] && (i[t].sort = void 0);
                                    });
                                    var e = "".concat(this.prfxCol).concat(this.sort.column);
                                    i[e] = i[e] || {}, i[e].sort = {
                                        descending: this.sort.descending
                                    };
                                }
                                this.persistColsVisibility && (Object(u.isNull)(this.hiddenCols) || (Object.keys(i).forEach(function(t) {
                                    -1 !== t.indexOf(r.prfxCol) && i[t] && (i[t].hidden = void 0);
                                }), this.hiddenCols.forEach(function(t) {
                                    var e = "".concat(r.prfxCol).concat(t);
                                    i[e] = i[e] || {}, i[e].hidden = !0;
                                }))), this.persistFiltersVisibility && (Object(u.isNull)(this.filtersVisibility) ? i[this.filtersVisKey] = void 0 : i[this.filtersVisKey] = this.filtersVisibility), this.emitter.emit("state-changed", t, i);
                            }
                        }
                    },
                    {
                        key: "updatePage",
                        value: function updatePage(t) {
                            this.pageNb = t, this.update();
                        }
                    },
                    {
                        key: "updatePageLength",
                        value: function updatePageLength(t) {
                            this.pageLength = t, this.update();
                        }
                    },
                    {
                        key: "updateSort",
                        value: function updateSort(t, e) {
                            this.sort = {
                                column: t,
                                descending: e
                            }, this.update();
                        }
                    },
                    {
                        key: "updateColsVisibility",
                        value: function updateColsVisibility(t) {
                            this.hiddenCols = t, this.update();
                        }
                    },
                    {
                        key: "updateFiltersVisibility",
                        value: function updateFiltersVisibility(t) {
                            this.filtersVisibility = t, this.update();
                        }
                    },
                    {
                        key: "override",
                        value: function override(t) {
                            this.state = t, this.emitter.emit("state-changed", this.tf, t);
                        }
                    },
                    {
                        key: "sync",
                        value: function sync() {
                            var t = this.state, e = this.tf;
                            if (this._syncFilters(), this.persistPageNumber) {
                                var n = t[this.pageNbKey];
                                this.emitter.emit("change-page", e, n);
                            }
                            if (this.persistPageLength) {
                                var r = t[this.pageLengthKey];
                                this.emitter.emit("change-page-results", e, r);
                            }
                            this._syncSort(), this._syncColsVisibility(), this._syncFiltersVisibility();
                        }
                    },
                    {
                        key: "overrideAndSync",
                        value: function overrideAndSync(t) {
                            this.disable(), this.override(t), this.sync(), this.enable();
                        }
                    },
                    {
                        key: "_syncFilters",
                        value: function _syncFilters() {
                            var r = this;
                            if (this.persistFilters) {
                                var i = this.state, s = this.tf;
                                s.eachCol(function(t) {
                                    return s.setFilterValue(t, "");
                                }), Object.keys(i).forEach(function(t) {
                                    if (-1 !== t.indexOf(r.prfxCol)) {
                                        var e = parseInt(t.replace(r.prfxCol, ""), 10), n = i[t].flt;
                                        s.setFilterValue(e, n);
                                    }
                                }), s.filter();
                            }
                        }
                    },
                    {
                        key: "_syncSort",
                        value: function _syncSort() {
                            var r = this;
                            if (this.persistSort) {
                                var i = this.state, s = this.tf;
                                Object.keys(i).forEach(function(t) {
                                    if (-1 !== t.indexOf(r.prfxCol)) {
                                        var e = parseInt(t.replace(r.prfxCol, ""), 10);
                                        if (!Object(u.isUndef)(i[t].sort)) {
                                            var n = i[t].sort;
                                            r.emitter.emit("sort", s, e, n.descending);
                                        }
                                    }
                                });
                            }
                        }
                    },
                    {
                        key: "_syncColsVisibility",
                        value: function _syncColsVisibility() {
                            var n = this;
                            if (this.persistColsVisibility) {
                                var r = this.state, e = this.tf, i = [];
                                Object.keys(r).forEach(function(t) {
                                    if (-1 !== t.indexOf(n.prfxCol)) {
                                        var e = parseInt(t.replace(n.prfxCol, ""), 10);
                                        Object(u.isUndef)(r[t].hidden) || i.push(e);
                                    }
                                }), i.forEach(function(t) {
                                    n.emitter.emit("hide-column", e, t);
                                });
                            }
                        }
                    },
                    {
                        key: "_syncFiltersVisibility",
                        value: function _syncFiltersVisibility() {
                            if (this.persistFiltersVisibility) {
                                var t = this.state, e = this.tf, n = t[this.filtersVisKey];
                                this.filtersVisibility = n, this.emitter.emit("show-filters", e, n);
                            }
                        }
                    },
                    {
                        key: "destroy",
                        value: function destroy() {
                            var i = this;
                            this.initialized && (this.state = {}, this.emitter.off([
                                "after-filtering"
                            ], function() {
                                return i.update();
                            }), this.emitter.off([
                                "after-page-change",
                                "after-clearing-filters"
                            ], function(t, e) {
                                return i.updatePage(e);
                            }), this.emitter.off([
                                "after-page-length-change"
                            ], function(t, e) {
                                return i.updatePageLength(e);
                            }), this.emitter.off([
                                "column-sorted"
                            ], function(t, e, n) {
                                return i.updateSort(e, n);
                            }), this.emitter.off([
                                "sort-initialized"
                            ], function() {
                                return i._syncSort();
                            }), this.emitter.off([
                                "columns-visibility-initialized"
                            ], function() {
                                return i._syncColsVisibility();
                            }), this.emitter.off([
                                "column-shown",
                                "column-hidden"
                            ], function(t, e, n, r) {
                                return i.updateColsVisibility(r);
                            }), this.emitter.off([
                                "filters-visibility-initialized"
                            ], function() {
                                return i._syncFiltersVisibility();
                            }), this.emitter.off([
                                "filters-toggled"
                            ], function(t, e, n) {
                                return i.updateFiltersVisibility(n);
                            }), this.enableHash && (this.hash.destroy(), this.hash = null), this.enableStorage && (this.storage.destroy(), this.storage = null), this.initialized = !1);
                        }
                    }
                ]), State;
            }();
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "GridLayout", function() {
                return r;
            });
            var i = n(10), d = n(2), h = n(5), p = n(8), m = n(4), s = n(1);
            function _typeof(t) {
                return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(t) {
                    return typeof t;
                } : function _typeof(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function _defineProperties(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function _setPrototypeOf(t, e) {
                return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(t, e) {
                    return t.__proto__ = e, t;
                })(t, e);
            }
            function _createSuper(r) {
                var i = function _isNativeReflectConstruct() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
                    } catch (t) {
                        return !1;
                    }
                }();
                return function _createSuperInternal() {
                    var t, e = _getPrototypeOf(r);
                    if (i) {
                        var n = _getPrototypeOf(this).constructor;
                        t = Reflect.construct(e, arguments, n);
                    } else t = e.apply(this, arguments);
                    return function _possibleConstructorReturn(t, e) {
                        return !e || "object" !== _typeof(e) && "function" != typeof e ? function _assertThisInitialized(t) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }(t) : e;
                    }(this, t);
                };
            }
            function _getPrototypeOf(t) {
                return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                })(t);
            }
            var r = function() {
                !function _inherits(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && _setPrototypeOf(t, e);
                }(GridLayout, i["Feature"]);
                var r = _createSuper(GridLayout);
                function GridLayout(t) {
                    var e;
                    !function _classCallCheck(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, GridLayout);
                    var n = (e = r.call(this, t, GridLayout)).config.grid_layout || {};
                    return e.width = Object(s.defaultsStr)(n.width, null), e.height = Object(s.defaultsStr)(n.height, null), e.mainContCssClass = Object(s.defaultsStr)(n.cont_css_class, "grd_Cont"), e.contCssClass = Object(s.defaultsStr)(n.tbl_cont_css_class, "grd_tblCont"), e.headContCssClass = Object(s.defaultsStr)(n.tbl_head_css_class, "grd_headTblCont"), e.infDivCssClass = Object(s.defaultsStr)(n.inf_grid_css_class, "grd_inf"), e.headRowIndex = Object(s.defaultsNb)(n.headers_row_index, 0), e.headRows = Object(s.defaultsArr)(n.headers_rows, [
                        0
                    ]), e.filters = Object(s.defaultsBool)(n.filters, !0), e.noHeaders = Boolean(n.no_headers), e.defaultColWidth = Object(s.defaultsStr)(n.default_col_width, "100px"), e.colElms = [], e.prfxGridFltTd = "_td_", e.prfxGridTh = "tblHeadTh_", e.sourceTblHtml = t.dom().outerHTML, e.tblHasColTag = 0 < Object(d.tag)(t.dom(), "col").length, e.tblMainCont = null, e.tblCont = null, e.headTblCont = null, e.headTbl = null, t.fltGrid = e.filters, e;
                }
                return function _createClass(t, e, n) {
                    return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
                }(GridLayout, [
                    {
                        key: "init",
                        value: function init() {
                            var n = this, t = this.tf, e = t.dom();
                            if (!this.initialized) {
                                this.setOverrides(), this.setDefaultColWidths(), this.tblMainCont = this.createContainer("div", this.mainContCssClass), this.width && (this.tblMainCont.style.width = this.width), e.parentNode.insertBefore(this.tblMainCont, e), this.tblCont = this.createContainer("div", this.contCssClass), this.setConfigWidth(this.tblCont), this.height && (this.tblCont.style.height = this.height), e.parentNode.insertBefore(this.tblCont, e);
                                var r = Object(d.removeElm)(e);
                                if (this.tblCont.appendChild(r), "" === e.style.width) {
                                    var i = this.initialTableWidth();
                                    e.style.width = (Object(p.contains)("%", i) ? e.clientWidth : i) + "px";
                                }
                                var s = Object(d.removeElm)(this.tblCont);
                                this.tblMainCont.appendChild(s), this.headTblCont = this.createContainer("div", this.headContCssClass), this.headTbl = Object(d.createElm)("table");
                                var a = Object(d.createElm)("tHead"), o = e.rows[this.headRowIndex], u = this.getSortTriggerIds(o), c = this.createFiltersRow();
                                this.setHeadersRow(a), this.headTbl.appendChild(a), 0 === t.filtersRowIndex ? a.insertBefore(c, o) : a.appendChild(c), this.headTblCont.appendChild(this.headTbl), this.tblCont.parentNode.insertBefore(this.headTblCont, this.tblCont);
                                var l = Object(d.tag)(e, "thead");
                                0 < l.length && e.removeChild(l[0]), this.headTbl.style.tableLayout = "fixed", e.style.tableLayout = "fixed", t.setColWidths(this.headTbl), this.headTbl.style.width = e.style.width, Object(h.addEvt)(this.tblCont, "scroll", function(t) {
                                    var e = Object(h.targetEvt)(t).scrollLeft;
                                    n.headTblCont.scrollLeft = e;
                                });
                                var f = t.extension("sort");
                                f && (f.asyncSort = !0, f.triggerIds = u), this.setColumnElements(), t.popupFilters && (c.style.display = m.NONE), this.initialized = !0;
                            }
                        }
                    },
                    {
                        key: "setOverrides",
                        value: function setOverrides() {
                            var t = this.tf;
                            t.refRow = 0, t.headersRow = 0, t.filtersRowIndex = 1;
                        }
                    },
                    {
                        key: "setDefaultColWidths",
                        value: function setDefaultColWidths() {
                            var r = this, i = this.tf;
                            0 < i.colWidths.length || (i.eachCol(function(t) {
                                var e, n = i.dom().rows[i.getHeadersRowIndex()].cells[t];
                                e = "" !== n.width ? n.width : "" !== n.style.width ? parseInt(n.style.width, 10) : r.defaultColWidth, i.colWidths[t] = e;
                            }), i.setColWidths());
                        }
                    },
                    {
                        key: "initialTableWidth",
                        value: function initialTableWidth() {
                            var t, e = this.tf.dom();
                            return t = "" !== e.width ? e.width : "" !== e.style.width ? e.style.width : e.clientWidth, parseInt(t, 10);
                        }
                    },
                    {
                        key: "createContainer",
                        value: function createContainer(t, e) {
                            var n = Object(d.createElm)(t);
                            return n.className = e, n;
                        }
                    },
                    {
                        key: "createFiltersRow",
                        value: function createFiltersRow() {
                            var r = this, i = this.tf, s = Object(d.createElm)("tr");
                            return this.filters && i.fltGrid && (i.externalFltIds = [], i.eachCol(function(t) {
                                var e = "".concat(i.prfxFlt + t + r.prfxGridFltTd + i.id), n = Object(d.createElm)(i.fltCellTag, [
                                    "id",
                                    e
                                ]);
                                s.appendChild(n), i.externalFltIds[t] = e;
                            })), s;
                        }
                    },
                    {
                        key: "setColumnElements",
                        value: function setColumnElements() {
                            var t = this.tf, e = Object(d.tag)(t.dom(), "col");
                            this.tblHasColTag = 0 < e.length;
                            for(var n = t.getCellsNb() - 1; 0 <= n; n--){
                                var r = void 0;
                                this.tblHasColTag ? r = e[n] : (r = Object(d.createElm)("col"), t.dom().insertBefore(r, t.dom().firstChild)), r.style.width = t.colWidths[n], this.colElms[n] = r;
                            }
                            this.tblHasColTag = !0;
                        }
                    },
                    {
                        key: "setHeadersRow",
                        value: function setHeadersRow(t) {
                            if (this.noHeaders) t.appendChild(Object(d.createElm)("tr"));
                            else for(var e = 0; e < this.headRows.length; e++){
                                var n = this.tf.dom().rows[this.headRows[e]];
                                t.appendChild(n);
                            }
                        }
                    },
                    {
                        key: "setConfigWidth",
                        value: function setConfigWidth(t) {
                            this.width && (-1 !== this.width.indexOf("%") ? t.style.width = "100%" : t.style.width = this.width);
                        }
                    },
                    {
                        key: "getSortTriggerIds",
                        value: function getSortTriggerIds(r) {
                            var i = this, s = this.tf, a = [];
                            return s.eachCol(function(t) {
                                var e = r.cells[t], n = e.getAttribute("id");
                                n && "" !== n || (n = "".concat(i.prfxGridTh + t, "_").concat(s.id), e.setAttribute("id", n)), a.push(n);
                            }), a;
                        }
                    },
                    {
                        key: "destroy",
                        value: function destroy() {
                            var t = this.tf, e = t.dom();
                            if (this.initialized) {
                                var n = Object(d.removeElm)(e);
                                this.tblMainCont.parentNode.insertBefore(n, this.tblMainCont), Object(d.removeElm)(this.tblMainCont), this.tblMainCont = null, this.headTblCont = null, this.headTbl = null, this.tblCont = null, e.outerHTML = this.sourceTblHtml, this.tf.tbl = Object(d.elm)(t.id), this.initialized = !1;
                            }
                        }
                    }
                ]), GridLayout;
            }();
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "Loader", function() {
                return r;
            });
            var i = n(10), s = n(2), a = n(3), o = n(9), u = n(4), c = n(1);
            function _typeof(t) {
                return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(t) {
                    return typeof t;
                } : function _typeof(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function _defineProperties(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function _setPrototypeOf(t, e) {
                return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(t, e) {
                    return t.__proto__ = e, t;
                })(t, e);
            }
            function _createSuper(r) {
                var i = function _isNativeReflectConstruct() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
                    } catch (t) {
                        return !1;
                    }
                }();
                return function _createSuperInternal() {
                    var t, e = _getPrototypeOf(r);
                    if (i) {
                        var n = _getPrototypeOf(this).constructor;
                        t = Reflect.construct(e, arguments, n);
                    } else t = e.apply(this, arguments);
                    return function _possibleConstructorReturn(t, e) {
                        return !e || "object" !== _typeof(e) && "function" != typeof e ? function _assertThisInitialized(t) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }(t) : e;
                    }(this, t);
                };
            }
            function _getPrototypeOf(t) {
                return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                })(t);
            }
            var l = [
                "before-filtering",
                "before-populating-filter",
                "before-page-change",
                "before-clearing-filters",
                "before-page-length-change",
                "before-reset-page",
                "before-reset-page-length",
                "before-loading-extensions",
                "before-loading-themes"
            ], f = [
                "after-filtering",
                "after-populating-filter",
                "after-page-change",
                "after-clearing-filters",
                "after-page-length-change",
                "after-reset-page",
                "after-reset-page-length",
                "after-loading-extensions",
                "after-loading-themes"
            ], r = function() {
                !function _inherits(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && _setPrototypeOf(t, e);
                }(Loader, i["Feature"]);
                var r = _createSuper(Loader);
                function Loader(t) {
                    var e;
                    !function _classCallCheck(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, Loader);
                    var n = (e = r.call(this, t, Loader)).config.loader || {};
                    return e.targetId = Object(c.defaultsStr)(n.target_id, null), e.cont = null, e.text = Object(c.defaultsStr)(n.text, "Loading..."), e.html = Object(c.defaultsStr)(n.html, null), e.cssClass = Object(c.defaultsStr)(n.css_class, "loader"), e.closeDelay = 250, e.onShow = Object(c.defaultsFn)(n.on_show_loader, a.EMPTY_FN), e.onHide = Object(c.defaultsFn)(n.on_hide_loader, a.EMPTY_FN), e;
                }
                return function _createClass(t, e, n) {
                    return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
                }(Loader, [
                    {
                        key: "init",
                        value: function init() {
                            var t = this;
                            if (!this.initialized) {
                                var e = this.tf, n = this.emitter, r = Object(s.createElm)("div");
                                r.className = this.cssClass;
                                var i = this.targetId ? Object(s.elm)(this.targetId) : e.dom().parentNode;
                                this.targetId ? i.appendChild(r) : i.insertBefore(r, e.dom()), this.cont = r, this.html ? this.cont.innerHTML = this.html : this.cont.appendChild(Object(s.createText)(this.text)), this.show(u.NONE), n.on(l, function() {
                                    return t.show("");
                                }), n.on(f, function() {
                                    return t.show(u.NONE);
                                }), this.initialized = !0;
                            }
                        }
                    },
                    {
                        key: "show",
                        value: function show(t) {
                            if (this.isEnabled()) {
                                var e = t === u.NONE ? this.closeDelay : 1;
                                o.root.setTimeout((function displayLoader() {
                                    this.cont && (t !== u.NONE && this.onShow(this), (this.cont.style.display = t) === u.NONE && this.onHide(this));
                                }).bind(this), e);
                            }
                        }
                    },
                    {
                        key: "destroy",
                        value: function destroy() {
                            var t = this;
                            if (this.initialized) {
                                var e = this.emitter;
                                Object(s.removeElm)(this.cont), this.cont = null, e.off(l, function() {
                                    return t.show("");
                                }), e.off(f, function() {
                                    return t.show(u.NONE);
                                }), this.initialized = !1;
                            }
                        }
                    }
                ]), Loader;
            }();
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "HighlightKeyword", function() {
                return i;
            });
            var h = n(2), o = n(3), d = n(8), r = n(1);
            function _defineProperties(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            var i = function() {
                function HighlightKeyword(t) {
                    !function _classCallCheck(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, HighlightKeyword);
                    var e = t.config();
                    this.highlightCssClass = Object(r.defaultsStr)(e.highlight_css_class, "keyword"), this.tf = t, this.emitter = t.emitter;
                }
                return function _createClass(t, e, n) {
                    return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
                }(HighlightKeyword, [
                    {
                        key: "init",
                        value: function init() {
                            var r = this;
                            this.emitter.on([
                                "before-filtering",
                                "destroy"
                            ], function() {
                                return r.unhighlightAll();
                            }), this.emitter.on([
                                "highlight-keyword"
                            ], function(t, e, n) {
                                return r._processTerm(e, n);
                            });
                        }
                    },
                    {
                        key: "highlight",
                        value: function highlight(t, e, n) {
                            if (t.hasChildNodes) for(var r = t.childNodes, i = 0; i < r.length; i++)this.highlight(r[i], e, n);
                            if (3 === t.nodeType) {
                                var s = t.nodeValue.toLowerCase().indexOf(e.toLowerCase());
                                if (-1 !== s) {
                                    var a = t.parentNode;
                                    if (a && a.className !== n) {
                                        var o = t.nodeValue, u = Object(h.createText)(o.substr(0, s)), c = o.substr(s, e.length), l = Object(h.createText)(o.substr(s + e.length)), f = Object(h.createText)(c), d = Object(h.createElm)("span");
                                        d.className = n, d.appendChild(f), a.insertBefore(u, t), a.insertBefore(d, t), a.insertBefore(l, t), a.removeChild(t);
                                    }
                                }
                            }
                        }
                    },
                    {
                        key: "unhighlight",
                        value: function unhighlight(t, e) {
                            for(var n = this.tf.dom().querySelectorAll(".".concat(e)), r = 0; r < n.length; r++){
                                var i = n[r], s = Object(h.getText)(i);
                                if (Object(o.isNull)(t) || -1 !== s.toLowerCase().indexOf(t.toLowerCase())) {
                                    var a = i.parentNode;
                                    a.replaceChild(Object(h.createText)(s), i), a.normalize();
                                }
                            }
                        }
                    },
                    {
                        key: "unhighlightAll",
                        value: function unhighlightAll() {
                            this.tf.highlightKeywords && this.unhighlight(null, this.highlightCssClass);
                        }
                    },
                    {
                        key: "destroy",
                        value: function destroy() {
                            var r = this;
                            this.emitter.off([
                                "before-filtering",
                                "destroy"
                            ], function() {
                                return r.unhighlightAll();
                            }), this.emitter.off([
                                "highlight-keyword"
                            ], function(t, e, n) {
                                return r._processTerm(e, n);
                            });
                        }
                    },
                    {
                        key: "_processTerm",
                        value: function _processTerm(t, e) {
                            var n = this.tf, r = new RegExp(Object(d.rgxEsc)(n.lkOperator)), i = new RegExp(n.eqOperator), s = new RegExp(n.stOperator), a = new RegExp(n.enOperator), o = new RegExp(n.leOperator), u = new RegExp(n.geOperator), c = new RegExp(n.lwOperator), l = new RegExp(n.grOperator), f = new RegExp(n.dfOperator);
                            e = e.replace(r, "").replace(i, "").replace(s, "").replace(a, ""), (o.test(e) || u.test(e) || c.test(e) || l.test(e) || f.test(e)) && (e = Object(h.getText)(t)), "" !== e && this.highlight(t, e, this.highlightCssClass);
                        }
                    }
                ]), HighlightKeyword;
            }();
            i.meta = {
                name: "highlightKeyword",
                altName: "highlightKeywords"
            };
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "PopupFilter", function() {
                return r;
            });
            var i = n(10), s = n(3), o = n(2), u = n(5), a = n(4), c = n(9), l = n(1);
            function _typeof(t) {
                return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(t) {
                    return typeof t;
                } : function _typeof(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function _defineProperties(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function _setPrototypeOf(t, e) {
                return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(t, e) {
                    return t.__proto__ = e, t;
                })(t, e);
            }
            function _createSuper(r) {
                var i = function _isNativeReflectConstruct() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
                    } catch (t) {
                        return !1;
                    }
                }();
                return function _createSuperInternal() {
                    var t, e = _getPrototypeOf(r);
                    if (i) {
                        var n = _getPrototypeOf(this).constructor;
                        t = Reflect.construct(e, arguments, n);
                    } else t = e.apply(this, arguments);
                    return function _possibleConstructorReturn(t, e) {
                        return !e || "object" !== _typeof(e) && "function" != typeof e ? function _assertThisInitialized(t) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }(t) : e;
                    }(this, t);
                };
            }
            function _getPrototypeOf(t) {
                return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                })(t);
            }
            var r = function() {
                !function _inherits(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && _setPrototypeOf(t, e);
                }(PopupFilter, i["Feature"]);
                var r = _createSuper(PopupFilter);
                function PopupFilter(t) {
                    var e;
                    !function _classCallCheck(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, PopupFilter);
                    var n = (e = r.call(this, t, PopupFilter)).config.popup_filters || {};
                    return e.closeOnFiltering = Object(l.defaultsBool)(n.close_on_filtering, !0), e.iconPath = Object(l.defaultsStr)(n.image, t.themesPath + "icn_filter.gif"), e.activeIconPath = Object(l.defaultsStr)(n.image_active, t.themesPath + "icn_filterActive.gif"), e.iconHtml = Object(l.defaultsStr)(n.image_html, '<img src="' + e.iconPath + '" alt="Column filter" />'), e.placeholderCssClass = Object(l.defaultsStr)(n.placeholder_css_class, "popUpPlaceholder"), e.containerCssClass = Object(l.defaultsStr)(n.div_css_class, "popUpFilter"), e.adjustToContainer = Object(l.defaultsBool)(n.adjust_to_container, !0), e.onBeforeOpen = Object(l.defaultsFn)(n.on_before_popup_filter_open, s.EMPTY_FN), e.onAfterOpen = Object(l.defaultsFn)(n.on_after_popup_filter_open, s.EMPTY_FN), e.onBeforeClose = Object(l.defaultsFn)(n.on_before_popup_filter_close, s.EMPTY_FN), e.onAfterClose = Object(l.defaultsFn)(n.on_after_popup_filter_close, s.EMPTY_FN), e.fltSpans = [], e.fltIcons = [], e.filtersCache = null, e.fltElms = Object(l.defaultsArr)(e.filtersCache, []), e.prfxDiv = "popup_", e.activeFilterIdx = -1, e;
                }
                return function _createClass(t, e, n) {
                    return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
                }(PopupFilter, [
                    {
                        key: "onClick",
                        value: function onClick(t) {
                            var e = Object(u.targetEvt)(t).parentNode, n = parseInt(e.getAttribute("ci"), 10);
                            if (this.closeAll(n), this.toggle(n), this.adjustToContainer) {
                                var r = this.fltElms[n], i = .95 * this.tf.getHeaderElement(n).clientWidth;
                                r.style.width = parseInt(i, 10) + "px";
                            }
                            Object(u.cancelEvt)(t), Object(u.stopEvt)(t);
                        }
                    },
                    {
                        key: "onMouseup",
                        value: function onMouseup(t) {
                            if (-1 !== this.activeFilterIdx) {
                                var e = Object(u.targetEvt)(t), n = this.fltElms[this.activeFilterIdx];
                                if (this.fltIcons[this.activeFilterIdx] !== e) {
                                    for(; e && e !== n;)e = e.parentNode;
                                    e !== n && this.close(this.activeFilterIdx);
                                }
                            }
                        }
                    },
                    {
                        key: "init",
                        value: function init() {
                            var n = this;
                            if (!this.initialized) {
                                var t = this.tf;
                                t.externalFltIds = [
                                    ""
                                ], t.filtersRowIndex = 0, t.headersRow <= 1 && isNaN(t.config().headers_row_index) && (t.headersRow = 0), t.gridLayout && (t.headersRow--, this.buildIcons()), this.emitter.on([
                                    "before-filtering"
                                ], function() {
                                    return n.setIconsState();
                                }), this.emitter.on([
                                    "after-filtering"
                                ], function() {
                                    return n.closeAll();
                                }), this.emitter.on([
                                    "cell-processed"
                                ], function(t, e) {
                                    return n.changeState(e, !0);
                                }), this.emitter.on([
                                    "filters-row-inserted"
                                ], function() {
                                    return n.buildIcons();
                                }), this.emitter.on([
                                    "before-filter-init"
                                ], function(t, e) {
                                    return n.build(e);
                                }), this.initialized = !0;
                            }
                        }
                    },
                    {
                        key: "reset",
                        value: function reset() {
                            this.enable(), this.init(), this.buildIcons(), this.buildAll();
                        }
                    },
                    {
                        key: "buildIcons",
                        value: function buildIcons() {
                            var n = this, r = this.tf;
                            r.headersRow++, r.eachCol(function(t) {
                                var e = Object(o.createElm)("span", [
                                    "ci",
                                    t
                                ]);
                                e.innerHTML = n.iconHtml, r.getHeaderElement(t).appendChild(e), Object(u.addEvt)(e, "click", function(t) {
                                    return n.onClick(t);
                                }), n.fltSpans[t] = e, n.fltIcons[t] = e.firstChild;
                            }, function(t) {
                                return r.getFilterType(t) === a.NONE;
                            });
                        }
                    },
                    {
                        key: "buildAll",
                        value: function buildAll() {
                            for(var t = 0; t < this.filtersCache.length; t++)this.build(t, this.filtersCache[t]);
                        }
                    },
                    {
                        key: "build",
                        value: function build(t, e) {
                            var n = this.tf, r = "".concat(this.prfxDiv).concat(n.id, "_").concat(t), i = Object(o.createElm)("div", [
                                "class",
                                this.placeholderCssClass
                            ]), s = e || Object(o.createElm)("div", [
                                "id",
                                r
                            ], [
                                "class",
                                this.containerCssClass
                            ]);
                            n.externalFltIds[t] = s.id, i.appendChild(s);
                            var a = n.getHeaderElement(t);
                            a.insertBefore(i, a.firstChild), Object(u.addEvt)(s, "click", function(t) {
                                return Object(u.stopEvt)(t);
                            }), this.fltElms[t] = s;
                        }
                    },
                    {
                        key: "toggle",
                        value: function toggle(t) {
                            this.isOpen(t) ? this.close(t) : this.open(t);
                        }
                    },
                    {
                        key: "open",
                        value: function open(t) {
                            var e = this, n = this.tf, r = this.fltElms[t];
                            if (this.onBeforeOpen(this, r, t), r.style.display = "block", this.activeFilterIdx = t, Object(u.addEvt)(c.root, "mouseup", function(t) {
                                return e.onMouseup(t);
                            }), n.getFilterType(t) === a.INPUT) {
                                var i = n.getFilterElement(t);
                                i && i.focus();
                            }
                            this.onAfterOpen(this, r, t);
                        }
                    },
                    {
                        key: "close",
                        value: function close(t) {
                            var e = this, n = this.fltElms[t];
                            this.onBeforeClose(this, n, t), n.style.display = a.NONE, this.activeFilterIdx === t && (this.activeFilterIdx = -1), Object(u.removeEvt)(c.root, "mouseup", function(t) {
                                return e.onMouseup(t);
                            }), this.onAfterClose(this, n, t);
                        }
                    },
                    {
                        key: "isOpen",
                        value: function isOpen(t) {
                            return "block" === this.fltElms[t].style.display;
                        }
                    },
                    {
                        key: "closeAll",
                        value: function closeAll(t) {
                            if (!Object(s.isUndef)(t) || this.closeOnFiltering) {
                                for(var e = 0; e < this.fltElms.length; e++)if (e !== t) {
                                    var n = this.tf.getFilterType(e);
                                    (n === a.CHECKLIST || n === a.MULTIPLE) && Object(s.isUndef)(t) || this.close(e);
                                }
                            }
                        }
                    },
                    {
                        key: "setIconsState",
                        value: function setIconsState() {
                            for(var t = 0; t < this.fltIcons.length; t++)this.changeState(t, !1);
                        }
                    },
                    {
                        key: "changeState",
                        value: function changeState(t, e) {
                            var n = this.fltIcons[t];
                            n && (n.src = e ? this.activeIconPath : this.iconPath);
                        }
                    },
                    {
                        key: "destroy",
                        value: function destroy() {
                            var n = this;
                            if (this.initialized) {
                                this.filtersCache = [];
                                for(var t = 0; t < this.fltElms.length; t++){
                                    var e = this.fltElms[t], r = e.parentNode, i = this.fltSpans[t], s = this.fltIcons[t];
                                    e && (Object(o.removeElm)(e), this.filtersCache[t] = e), e = null, r && Object(o.removeElm)(r), r = null, i && Object(o.removeElm)(i), i = null, s && Object(o.removeElm)(s), s = null;
                                }
                                this.fltElms = [], this.fltSpans = [], this.fltIcons = [], this.tf.externalFltIds = [], this.emitter.off([
                                    "before-filtering"
                                ], function() {
                                    return n.setIconsState();
                                }), this.emitter.off([
                                    "after-filtering"
                                ], function() {
                                    return n.closeAll();
                                }), this.emitter.off([
                                    "cell-processed"
                                ], function(t, e) {
                                    return n.changeState(e, !0);
                                }), this.emitter.off([
                                    "filters-row-inserted"
                                ], function() {
                                    return n.buildIcons();
                                }), this.emitter.off([
                                    "before-filter-init"
                                ], function(t, e) {
                                    return n.build(e);
                                }), this.initialized = !1;
                            }
                        }
                    }
                ]), PopupFilter;
            }();
            r.meta = {
                altName: "popupFilters"
            };
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "MarkActiveColumns", function() {
                return r;
            });
            var i = n(10), s = n(2), a = n(3), o = n(1);
            function _typeof(t) {
                return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(t) {
                    return typeof t;
                } : function _typeof(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function _defineProperties(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function _setPrototypeOf(t, e) {
                return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(t, e) {
                    return t.__proto__ = e, t;
                })(t, e);
            }
            function _createSuper(r) {
                var i = function _isNativeReflectConstruct() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
                    } catch (t) {
                        return !1;
                    }
                }();
                return function _createSuperInternal() {
                    var t, e = _getPrototypeOf(r);
                    if (i) {
                        var n = _getPrototypeOf(this).constructor;
                        t = Reflect.construct(e, arguments, n);
                    } else t = e.apply(this, arguments);
                    return function _possibleConstructorReturn(t, e) {
                        return !e || "object" !== _typeof(e) && "function" != typeof e ? function _assertThisInitialized(t) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }(t) : e;
                    }(this, t);
                };
            }
            function _getPrototypeOf(t) {
                return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                })(t);
            }
            var r = function() {
                !function _inherits(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && _setPrototypeOf(t, e);
                }(MarkActiveColumns, i["Feature"]);
                var r = _createSuper(MarkActiveColumns);
                function MarkActiveColumns(t) {
                    var e;
                    !function _classCallCheck(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, MarkActiveColumns);
                    var n = (e = r.call(this, t, MarkActiveColumns)).config.mark_active_columns || {};
                    return e.headerCssClass = Object(o.defaultsStr)(n.header_css_class, "activeHeader"), e.cellCssClass = Object(o.defaultsStr)(n.cell_css_class, "activeCell"), e.highlightColumn = Boolean(n.highlight_column), e.onBeforeActiveColumn = Object(o.defaultsFn)(n.on_before_active_column, a.EMPTY_FN), e.onAfterActiveColumn = Object(o.defaultsFn)(n.on_after_active_column, a.EMPTY_FN), e;
                }
                return function _createClass(t, e, n) {
                    return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
                }(MarkActiveColumns, [
                    {
                        key: "init",
                        value: function init() {
                            var n = this;
                            this.initialized || (this.emitter.on([
                                "before-filtering"
                            ], function() {
                                return n.clearActiveColumns();
                            }), this.emitter.on([
                                "cell-processed"
                            ], function(t, e) {
                                return n.markActiveColumn(e);
                            }), this.initialized = !0);
                        }
                    },
                    {
                        key: "clearActiveColumns",
                        value: function clearActiveColumns() {
                            var e = this, n = this.tf;
                            n.eachCol(function(t) {
                                Object(s.removeClass)(n.getHeaderElement(t), e.headerCssClass), e.highlightColumn && e.eachColumnCell(t, function(t) {
                                    return Object(s.removeClass)(t, e.cellCssClass);
                                });
                            });
                        }
                    },
                    {
                        key: "markActiveColumn",
                        value: function markActiveColumn(t) {
                            var e = this, n = this.tf.getHeaderElement(t);
                            Object(s.hasClass)(n, this.headerCssClass) || (this.onBeforeActiveColumn(this, t), Object(s.addClass)(n, this.headerCssClass), this.highlightColumn && this.eachColumnCell(t, function(t) {
                                return Object(s.addClass)(t, e.cellCssClass);
                            }), this.onAfterActiveColumn(this, t));
                        }
                    },
                    {
                        key: "eachColumnCell",
                        value: function eachColumnCell(t, e, n) {
                            var r = 1 < arguments.length && void 0 !== e ? e : a.EMPTY_FN, i = 2 < arguments.length && void 0 !== n ? n : this.tf.dom();
                            [].forEach.call(i.querySelectorAll("tbody td:nth-child(".concat(t + 1, ")")), r);
                        }
                    },
                    {
                        key: "destroy",
                        value: function destroy() {
                            var n = this;
                            this.initialized && (this.clearActiveColumns(), this.emitter.off([
                                "before-filtering"
                            ], function() {
                                return n.clearActiveColumns();
                            }), this.emitter.off([
                                "cell-processed"
                            ], function(t, e) {
                                return n.markActiveColumn(e);
                            }), this.initialized = !1);
                        }
                    }
                ]), MarkActiveColumns;
            }();
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "RowsCounter", function() {
                return r;
            });
            var i = n(10), a = n(2), o = n(3), s = n(1), u = n(18);
            function _typeof(t) {
                return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(t) {
                    return typeof t;
                } : function _typeof(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function _defineProperties(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function _setPrototypeOf(t, e) {
                return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(t, e) {
                    return t.__proto__ = e, t;
                })(t, e);
            }
            function _createSuper(r) {
                var i = function _isNativeReflectConstruct() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
                    } catch (t) {
                        return !1;
                    }
                }();
                return function _createSuperInternal() {
                    var t, e = _getPrototypeOf(r);
                    if (i) {
                        var n = _getPrototypeOf(this).constructor;
                        t = Reflect.construct(e, arguments, n);
                    } else t = e.apply(this, arguments);
                    return function _possibleConstructorReturn(t, e) {
                        return !e || "object" !== _typeof(e) && "function" != typeof e ? function _assertThisInitialized(t) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }(t) : e;
                    }(this, t);
                };
            }
            function _getPrototypeOf(t) {
                return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                })(t);
            }
            var r = function() {
                !function _inherits(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && _setPrototypeOf(t, e);
                }(RowsCounter, i["Feature"]);
                var r = _createSuper(RowsCounter);
                function RowsCounter(t) {
                    var e;
                    !function _classCallCheck(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, RowsCounter);
                    var n = (e = r.call(this, t, RowsCounter)).config.rows_counter || {};
                    return e.targetId = Object(s.defaultsStr)(n.target_id, null), e.container = null, e.label = null, e.text = Object(s.defaultsStr)(n.text, "Rows: "), e.fromToTextSeparator = Object(s.defaultsStr)(n.separator, "-"), e.overText = Object(s.defaultsStr)(n.over_text, " / "), e.cssClass = Object(s.defaultsStr)(n.css_class, "tot"), e.toolbarPosition = Object(s.defaultsStr)(n.toolbar_position, u.LEFT), e.onBeforeRefreshCounter = Object(s.defaultsFn)(n.on_before_refresh_counter, o.EMPTY_FN), e.onAfterRefreshCounter = Object(s.defaultsFn)(n.on_after_refresh_counter, o.EMPTY_FN), e;
                }
                return function _createClass(t, e, n) {
                    return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
                }(RowsCounter, [
                    {
                        key: "init",
                        value: function init() {
                            var t = this;
                            if (!this.initialized) {
                                this.emitter.emit("initializing-feature", this, !Object(o.isNull)(this.targetId));
                                var e = this.tf, n = Object(a.createElm)("div");
                                n.className = this.cssClass;
                                var r = Object(a.createElm)("span"), i = Object(a.createElm)("span");
                                i.appendChild(Object(a.createText)(this.text));
                                var s = this.targetId ? Object(a.elm)(this.targetId) : e.feature("toolbar").container(this.toolbarPosition);
                                this.targetId ? (s.appendChild(i), s.appendChild(r)) : (n.appendChild(i), n.appendChild(r), s.appendChild(n)), this.container = n, this.label = r, this.emitter.on([
                                    "after-filtering",
                                    "grouped-by-page"
                                ], function() {
                                    return t.refresh(e.getValidRowsNb());
                                }), this.emitter.on([
                                    "rows-changed"
                                ], function() {
                                    return t.refresh();
                                }), this.initialized = !0, this.refresh(), this.emitter.emit("feature-initialized", this);
                            }
                        }
                    },
                    {
                        key: "refresh",
                        value: function refresh(t) {
                            if (this.initialized && this.isEnabled()) {
                                var e, n = this.tf;
                                if (this.onBeforeRefreshCounter(n, this.label), n.paging) {
                                    var r = n.feature("paging");
                                    if (r) {
                                        var i = n.getValidRowsNb(), s = parseInt(r.startPagingRow, 10) + (0 < i ? 1 : 0), a = s + r.pageLength - 1 <= i ? s + r.pageLength - 1 : i;
                                        e = s + this.fromToTextSeparator + a + this.overText + i;
                                    }
                                } else e = t && "" !== t ? t : n.getFilterableRowsNb() - n.nbHiddenRows;
                                this.label.innerHTML = e, this.onAfterRefreshCounter(n, this.label, e);
                            }
                        }
                    },
                    {
                        key: "destroy",
                        value: function destroy() {
                            var t = this;
                            this.initialized && (!this.targetId && this.container ? Object(a.removeElm)(this.container) : Object(a.elm)(this.targetId).innerHTML = "", this.label = null, this.container = null, this.emitter.off([
                                "after-filtering",
                                "grouped-by-page"
                            ], function() {
                                return t.refresh(tf.getValidRowsNb());
                            }), this.emitter.off([
                                "rows-changed"
                            ], function() {
                                return t.refresh();
                            }), this.initialized = !1);
                        }
                    }
                ]), RowsCounter;
            }();
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "StatusBar", function() {
                return r;
            });
            var i = n(10), s = n(9), o = n(2), u = n(3), a = n(1), c = n(18);
            function _typeof(t) {
                return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(t) {
                    return typeof t;
                } : function _typeof(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function _defineProperties(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function _setPrototypeOf(t, e) {
                return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(t, e) {
                    return t.__proto__ = e, t;
                })(t, e);
            }
            function _createSuper(r) {
                var i = function _isNativeReflectConstruct() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
                    } catch (t) {
                        return !1;
                    }
                }();
                return function _createSuperInternal() {
                    var t, e = _getPrototypeOf(r);
                    if (i) {
                        var n = _getPrototypeOf(this).constructor;
                        t = Reflect.construct(e, arguments, n);
                    } else t = e.apply(this, arguments);
                    return function _possibleConstructorReturn(t, e) {
                        return !e || "object" !== _typeof(e) && "function" != typeof e ? function _assertThisInitialized(t) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }(t) : e;
                    }(this, t);
                };
            }
            function _getPrototypeOf(t) {
                return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                })(t);
            }
            var l = [
                "after-filtering",
                "after-populating-filter",
                "after-page-change",
                "after-clearing-filters",
                "after-page-length-change",
                "after-reset-page",
                "after-reset-page-length",
                "after-loading-extensions",
                "after-loading-themes"
            ], r = function() {
                !function _inherits(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && _setPrototypeOf(t, e);
                }(StatusBar, i["Feature"]);
                var r = _createSuper(StatusBar);
                function StatusBar(t) {
                    var e;
                    !function _classCallCheck(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, StatusBar);
                    var n = (e = r.call(this, t, StatusBar)).config.status_bar || {};
                    return e.targetId = Object(a.defaultsStr)(n.target_id, null), e.container = null, e.msgContainer = null, e.labelContainer = null, e.text = Object(a.defaultsStr)(n.text, ""), e.cssClass = Object(a.defaultsStr)(n.css_class, "status"), e.delay = 250, e.onBeforeShowMsg = Object(a.defaultsFn)(n.on_before_show_msg, u.EMPTY_FN), e.onAfterShowMsg = Object(a.defaultsFn)(n.on_after_show_msg, u.EMPTY_FN), e.msgFilter = Object(a.defaultsStr)(n.msg_filter, "Filtering data..."), e.msgPopulate = Object(a.defaultsStr)(n.msg_populate, "Populating filter..."), e.msgPopulateCheckList = Object(a.defaultsStr)(n.msg_populate_checklist, "Populating list..."), e.msgChangePage = Object(a.defaultsStr)(n.msg_change_page, "Collecting paging data..."), e.msgClear = Object(a.defaultsStr)(n.msg_clear, "Clearing filters..."), e.msgChangeResults = Object(a.defaultsStr)(n.msg_change_results, "Changing results per page..."), e.msgResetPage = Object(a.defaultsStr)(n.msg_reset_page, "Re-setting page..."), e.msgResetPageLength = Object(a.defaultsStr)(n.msg_reset_page_length, "Re-setting page length..."), e.msgSort = Object(a.defaultsStr)(n.msg_sort, "Sorting data..."), e.msgLoadExtensions = Object(a.defaultsStr)(n.msg_load_extensions, "Loading extensions..."), e.msgLoadThemes = Object(a.defaultsStr)(n.msg_load_themes, "Loading theme(s)..."), e.toolbarPosition = Object(a.defaultsStr)(n.toolbar_position, c.LEFT), e;
                }
                return function _createClass(t, e, n) {
                    return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
                }(StatusBar, [
                    {
                        key: "init",
                        value: function init() {
                            var t = this;
                            if (!this.initialized) {
                                var e = this.tf, n = this.emitter;
                                n.emit("initializing-feature", this, !Object(u.isNull)(this.targetId));
                                var r = Object(o.createElm)("div");
                                r.className = this.cssClass;
                                var i = Object(o.createElm)("span"), s = Object(o.createElm)("span");
                                s.appendChild(Object(o.createText)(this.text));
                                var a = this.targetId ? Object(o.elm)(this.targetId) : e.feature("toolbar").container(this.toolbarPosition);
                                this.targetId ? (a.appendChild(s), a.appendChild(i)) : (r.appendChild(s), r.appendChild(i), a.appendChild(r)), this.container = r, this.msgContainer = i, this.labelContainer = s, n.on([
                                    "before-filtering"
                                ], function() {
                                    return t.message(t.msgFilter);
                                }), n.on([
                                    "before-populating-filter"
                                ], function() {
                                    return t.message(t.msgPopulate);
                                }), n.on([
                                    "before-page-change"
                                ], function() {
                                    return t.message(t.msgChangePage);
                                }), n.on([
                                    "before-clearing-filters"
                                ], function() {
                                    return t.message(t.msgClear);
                                }), n.on([
                                    "before-page-length-change"
                                ], function() {
                                    return t.message(t.msgChangeResults);
                                }), n.on([
                                    "before-reset-page"
                                ], function() {
                                    return t.message(t.msgResetPage);
                                }), n.on([
                                    "before-reset-page-length"
                                ], function() {
                                    return t.message(t.msgResetPageLength);
                                }), n.on([
                                    "before-loading-extensions"
                                ], function() {
                                    return t.message(t.msgLoadExtensions);
                                }), n.on([
                                    "before-loading-themes"
                                ], function() {
                                    return t.message(t.msgLoadThemes);
                                }), n.on(l, function() {
                                    return t.message("");
                                }), this.initialized = !0, n.emit("feature-initialized", this);
                            }
                        }
                    },
                    {
                        key: "message",
                        value: function message(t) {
                            var e = this, n = 0 < arguments.length && void 0 !== t ? t : "";
                            if (this.isEnabled()) {
                                this.onBeforeShowMsg(this.tf, n);
                                var r = "" === n ? this.delay : 1;
                                s.root.setTimeout(function() {
                                    e.initialized && (e.msgContainer.innerHTML = n, e.onAfterShowMsg(e.tf, n));
                                }, r);
                            }
                        }
                    },
                    {
                        key: "destroy",
                        value: function destroy() {
                            var t = this;
                            if (this.initialized) {
                                var e = this.emitter;
                                this.container.innerHTML = "", this.targetId || Object(o.removeElm)(this.container), this.labelContainer = null, this.msgContainer = null, this.container = null, e.off([
                                    "before-filtering"
                                ], function() {
                                    return t.message(t.msgFilter);
                                }), e.off([
                                    "before-populating-filter"
                                ], function() {
                                    return t.message(t.msgPopulate);
                                }), e.off([
                                    "before-page-change"
                                ], function() {
                                    return t.message(t.msgChangePage);
                                }), e.off([
                                    "before-clearing-filters"
                                ], function() {
                                    return t.message(t.msgClear);
                                }), e.off([
                                    "before-page-length-change"
                                ], function() {
                                    return t.message(t.msgChangeResults);
                                }), e.off([
                                    "before-reset-page"
                                ], function() {
                                    return t.message(t.msgResetPage);
                                }), e.off([
                                    "before-reset-page-length"
                                ], function() {
                                    return t.message(t.msgResetPageLength);
                                }), e.off([
                                    "before-loading-extensions"
                                ], function() {
                                    return t.message(t.msgLoadExtensions);
                                }), e.off([
                                    "before-loading-themes"
                                ], function() {
                                    return t.message(t.msgLoadThemes);
                                }), e.off(l, function() {
                                    return t.message("");
                                }), this.initialized = !1;
                            }
                        }
                    }
                ]), StatusBar;
            }();
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "ClearButton", function() {
                return r;
            });
            var i = n(10), s = n(2), a = n(5), o = n(1), u = n(3), c = n(18);
            function _typeof(t) {
                return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(t) {
                    return typeof t;
                } : function _typeof(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function _defineProperties(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function _setPrototypeOf(t, e) {
                return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(t, e) {
                    return t.__proto__ = e, t;
                })(t, e);
            }
            function _createSuper(r) {
                var i = function _isNativeReflectConstruct() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
                    } catch (t) {
                        return !1;
                    }
                }();
                return function _createSuperInternal() {
                    var t, e = _getPrototypeOf(r);
                    if (i) {
                        var n = _getPrototypeOf(this).constructor;
                        t = Reflect.construct(e, arguments, n);
                    } else t = e.apply(this, arguments);
                    return function _possibleConstructorReturn(t, e) {
                        return !e || "object" !== _typeof(e) && "function" != typeof e ? function _assertThisInitialized(t) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }(t) : e;
                    }(this, t);
                };
            }
            function _getPrototypeOf(t) {
                return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                })(t);
            }
            var r = function() {
                !function _inherits(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && _setPrototypeOf(t, e);
                }(ClearButton, i["Feature"]);
                var r = _createSuper(ClearButton);
                function ClearButton(t) {
                    var e;
                    !function _classCallCheck(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, ClearButton);
                    var n = (e = r.call(this, t, ClearButton)).config.btn_reset || {};
                    return e.targetId = Object(o.defaultsStr)(n.target_id, null), e.text = Object(o.defaultsStr)(n.text, null), e.cssClass = Object(o.defaultsStr)(n.css_class, "reset"), e.tooltip = n.tooltip || "Clear filters", e.html = Object(o.defaultsStr)(n.html, !t.enableIcons || e.text ? null : '<input type="button" value="" class="' + e.cssClass + '" title="' + e.tooltip + '" />'), e.toolbarPosition = Object(o.defaultsStr)(n.toolbar_position, c.RIGHT), e.container = null, e.element = null, e;
                }
                return function _createClass(t, e, n) {
                    return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
                }(ClearButton, [
                    {
                        key: "onClick",
                        value: function onClick() {
                            this.isEnabled() && this.tf.clearFilters();
                        }
                    },
                    {
                        key: "init",
                        value: function init() {
                            var t = this, e = this.tf;
                            if (!this.initialized) {
                                this.emitter.emit("initializing-feature", this, !Object(u.isNull)(this.targetId));
                                var n = Object(s.createElm)("span");
                                if ((this.targetId ? Object(s.elm)(this.targetId) : e.feature("toolbar").container(this.toolbarPosition)).appendChild(n), this.html) {
                                    n.innerHTML = this.html;
                                    var r = n.firstChild;
                                    Object(a.addEvt)(r, "click", function() {
                                        return t.onClick();
                                    });
                                } else {
                                    var i = Object(s.createElm)("a", [
                                        "href",
                                        "javascript:void(0);"
                                    ]);
                                    i.className = this.cssClass, i.appendChild(Object(s.createText)(this.text)), n.appendChild(i), Object(a.addEvt)(i, "click", function() {
                                        return t.onClick();
                                    });
                                }
                                this.element = n.firstChild, this.container = n, this.initialized = !0, this.emitter.emit("feature-initialized", this);
                            }
                        }
                    },
                    {
                        key: "destroy",
                        value: function destroy() {
                            this.initialized && (Object(s.removeElm)(this.element), Object(s.removeElm)(this.container), this.element = null, this.container = null, this.initialized = !1);
                        }
                    }
                ]), ClearButton;
            }();
            r.meta = {
                altName: "btnReset"
            };
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "AlternateRows", function() {
                return r;
            });
            var i = n(10), s = n(2), a = n(1), o = n(5);
            function _typeof(t) {
                return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(t) {
                    return typeof t;
                } : function _typeof(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function _defineProperties(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function _setPrototypeOf(t, e) {
                return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(t, e) {
                    return t.__proto__ = e, t;
                })(t, e);
            }
            function _createSuper(r) {
                var i = function _isNativeReflectConstruct() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
                    } catch (t) {
                        return !1;
                    }
                }();
                return function _createSuperInternal() {
                    var t, e = _getPrototypeOf(r);
                    if (i) {
                        var n = _getPrototypeOf(this).constructor;
                        t = Reflect.construct(e, arguments, n);
                    } else t = e.apply(this, arguments);
                    return function _possibleConstructorReturn(t, e) {
                        return !e || "object" !== _typeof(e) && "function" != typeof e ? function _assertThisInitialized(t) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }(t) : e;
                    }(this, t);
                };
            }
            function _getPrototypeOf(t) {
                return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                })(t);
            }
            var r = function() {
                !function _inherits(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && _setPrototypeOf(t, e);
                }(AlternateRows, i["Feature"]);
                var r = _createSuper(AlternateRows);
                function AlternateRows(t) {
                    var e;
                    !function _classCallCheck(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, AlternateRows);
                    var n = (e = r.call(this, t, AlternateRows)).config;
                    return e.evenCss = Object(a.defaultsStr)(n.even_row_css_class, "even"), e.oddCss = Object(a.defaultsStr)(n.odd_row_css_class, "odd"), e;
                }
                return function _createClass(t, e, n) {
                    return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
                }(AlternateRows, [
                    {
                        key: "init",
                        value: function init() {
                            this.initialized || (this.processAll(), this.emitter.on([
                                "row-processed",
                                "row-paged"
                            ], Object(o.bound)(this.processRowHandler, this)), this.emitter.on([
                                "column-sorted",
                                "rows-changed"
                            ], Object(o.bound)(this.processAll, this)), this.initialized = !0);
                        }
                    },
                    {
                        key: "processAll",
                        value: function processAll() {
                            if (this.isEnabled()) for(var t = this.tf.getValidRows(!0), e = t.length, n = 0, r = 0; r < e; r++){
                                var i = t[r];
                                this.setRowBg(i, n), n++;
                            }
                        }
                    },
                    {
                        key: "processRow",
                        value: function processRow(t, e, n) {
                            n ? this.setRowBg(t, e) : this.removeRowBg(t);
                        }
                    },
                    {
                        key: "setRowBg",
                        value: function setRowBg(t, e) {
                            if (this.isEnabled() && !isNaN(t)) {
                                var n = this.tf.dom().rows, r = isNaN(e) ? t : e;
                                this.removeRowBg(t), Object(s.addClass)(n[t], r % 2 ? this.evenCss : this.oddCss);
                            }
                        }
                    },
                    {
                        key: "removeRowBg",
                        value: function removeRowBg(t) {
                            if (!isNaN(t)) {
                                var e = this.tf.dom().rows;
                                Object(s.removeClass)(e[t], this.oddCss), Object(s.removeClass)(e[t], this.evenCss);
                            }
                        }
                    },
                    {
                        key: "processRowHandler",
                        value: function processRowHandler(t, e, n, r) {
                            this.processRow(e, n, r);
                        }
                    },
                    {
                        key: "destroy",
                        value: function destroy() {
                            var n = this;
                            this.initialized && (this.tf.eachRow(0)(function(t, e) {
                                return n.removeRowBg(e);
                            }), this.emitter.off([
                                "row-processed",
                                "row-paged"
                            ], Object(o.bound)(this.processRowHandler, this)), this.emitter.off([
                                "column-sorted",
                                "rows-changed"
                            ], Object(o.bound)(this.processAll, this)), this.initialized = !1);
                        }
                    }
                ]), AlternateRows;
            }();
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "NoResults", function() {
                return r;
            });
            var i = n(10), s = n(2), a = n(3), o = n(4), u = n(1);
            function _typeof(t) {
                return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(t) {
                    return typeof t;
                } : function _typeof(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function _defineProperties(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function _setPrototypeOf(t, e) {
                return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(t, e) {
                    return t.__proto__ = e, t;
                })(t, e);
            }
            function _createSuper(r) {
                var i = function _isNativeReflectConstruct() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
                    } catch (t) {
                        return !1;
                    }
                }();
                return function _createSuperInternal() {
                    var t, e = _getPrototypeOf(r);
                    if (i) {
                        var n = _getPrototypeOf(this).constructor;
                        t = Reflect.construct(e, arguments, n);
                    } else t = e.apply(this, arguments);
                    return function _possibleConstructorReturn(t, e) {
                        return !e || "object" !== _typeof(e) && "function" != typeof e ? function _assertThisInitialized(t) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }(t) : e;
                    }(this, t);
                };
            }
            function _getPrototypeOf(t) {
                return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                })(t);
            }
            var r = function() {
                !function _inherits(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && _setPrototypeOf(t, e);
                }(NoResults, i["Feature"]);
                var r = _createSuper(NoResults);
                function NoResults(t) {
                    var e;
                    !function _classCallCheck(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, NoResults);
                    var n = (e = r.call(this, t, NoResults)).config.no_results_message || {};
                    return e.content = Object(u.defaultsStr)(n.content, "No results"), e.customContainer = Object(u.defaultsStr)(n.custom_container, null), e.customContainerId = Object(u.defaultsStr)(n.custom_container_id, null), e.isExternal = !Object(a.isEmpty)(e.customContainer) || !Object(a.isEmpty)(e.customContainerId), e.cssClass = Object(u.defaultsStr)(n.css_class, "no-results"), e.cont = null, e.onBeforeShow = Object(u.defaultsFn)(n.on_before_show_msg, a.EMPTY_FN), e.onAfterShow = Object(u.defaultsFn)(n.on_after_show_msg, a.EMPTY_FN), e.onBeforeHide = Object(u.defaultsFn)(n.on_before_hide_msg, a.EMPTY_FN), e.onAfterHide = Object(u.defaultsFn)(n.on_after_hide_msg, a.EMPTY_FN), e;
                }
                return function _createClass(t, e, n) {
                    return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
                }(NoResults, [
                    {
                        key: "init",
                        value: function init() {
                            var t = this;
                            if (!this.initialized) {
                                var e = this.tf, n = this.customContainer || Object(s.elm)(this.customContainerId) || e.dom(), r = Object(s.createElm)("div");
                                r.className = this.cssClass, r.innerHTML = this.content, this.isExternal ? n.appendChild(r) : n.parentNode.insertBefore(r, n.nextSibling), this.cont = r, this.emitter.on([
                                    "initialized",
                                    "after-filtering"
                                ], function() {
                                    return t.toggle();
                                }), this.initialized = !0;
                            }
                        }
                    },
                    {
                        key: "toggle",
                        value: function toggle() {
                            0 < this.tf.getValidRowsNb() ? this.hide() : this.show();
                        }
                    },
                    {
                        key: "show",
                        value: function show() {
                            this.initialized && this.isEnabled() && (this.onBeforeShow(this.tf, this), this.setWidth(), this.cont.style.display = "block", this.onAfterShow(this.tf, this));
                        }
                    },
                    {
                        key: "hide",
                        value: function hide() {
                            this.initialized && this.isEnabled() && (this.onBeforeHide(this.tf, this), this.cont.style.display = o.NONE, this.onAfterHide(this.tf, this));
                        }
                    },
                    {
                        key: "setWidth",
                        value: function setWidth() {
                            if (this.initialized && !this.isExternal && this.isEnabled()) {
                                var t = this.tf;
                                if (t.gridLayout) {
                                    var e = t.feature("gridLayout");
                                    this.cont.style.width = e.headTbl.clientWidth + "px";
                                } else this.cont.style.width = (t.dom().tHead ? t.dom().tHead.clientWidth : t.dom().tBodies[0].clientWidth) + "px";
                            }
                        }
                    },
                    {
                        key: "destroy",
                        value: function destroy() {
                            var t = this;
                            this.initialized && (Object(s.removeElm)(this.cont), this.cont = null, this.emitter.off([
                                "after-filtering"
                            ], function() {
                                return t.toggle();
                            }), this.initialized = !1);
                        }
                    }
                ]), NoResults;
            }();
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "Paging", function() {
                return i;
            });
            var r = n(10), y = n(2), g = n(3), b = n(5), v = n(4), o = n(1), f = n(18);
            function _typeof(t) {
                return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(t) {
                    return typeof t;
                } : function _typeof(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function _defineProperties(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function _setPrototypeOf(t, e) {
                return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(t, e) {
                    return t.__proto__ = e, t;
                })(t, e);
            }
            function _createSuper(r) {
                var i = function _isNativeReflectConstruct() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
                    } catch (t) {
                        return !1;
                    }
                }();
                return function _createSuperInternal() {
                    var t, e = _getPrototypeOf(r);
                    if (i) {
                        var n = _getPrototypeOf(this).constructor;
                        t = Reflect.construct(e, arguments, n);
                    } else t = e.apply(this, arguments);
                    return function _possibleConstructorReturn(t, e) {
                        return !e || "object" !== _typeof(e) && "function" != typeof e ? _assertThisInitialized(t) : e;
                    }(this, t);
                };
            }
            function _assertThisInitialized(t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            }
            function _getPrototypeOf(t) {
                return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                })(t);
            }
            var i = function() {
                !function _inherits(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && _setPrototypeOf(t, e);
                }(Paging, r["Feature"]);
                var a = _createSuper(Paging);
                function Paging(e) {
                    var t;
                    !function _classCallCheck(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, Paging);
                    var n = (t = a.call(this, e, Paging)).config.paging || {};
                    t.btnCssClass = Object(o.defaultsStr)(n.btn_css_class, "pgInp"), t.pageSlc = null, t.pageLengthSlc = null, t.tgtId = Object(o.defaultsStr)(n.target_id, null), t.pageLength = Object(o.defaultsNb)(n.length, 10), t.pageLengthTgtId = Object(o.defaultsStr)(n.results_per_page_target_id, null), t.pgSlcCssClass = Object(o.defaultsStr)(n.slc_css_class, "pgSlc"), t.pgInpCssClass = Object(o.defaultsStr)(n.inp_css_class, "pgNbInp"), t.resultsPerPage = Object(o.defaultsArr)(n.results_per_page, null), t.hasResultsPerPage = Object(g.isArray)(t.resultsPerPage), t.resultsSlcCssClass = Object(o.defaultsStr)(n.results_slc_css_class, "rspg"), t.resultsSpanCssClass = Object(o.defaultsStr)(n.results_span_css_class, "rspgSpan"), t.startPagingRow = 0, t.nbPages = 0, t.currentPageNb = 1, t.btnNextPageText = Object(o.defaultsStr)(n.btn_next_page_text, ">"), t.btnPrevPageText = Object(o.defaultsStr)(n.btn_prev_page_text, "<"), t.btnLastPageText = Object(o.defaultsStr)(n.btn_last_page_text, ">|"), t.btnFirstPageText = Object(o.defaultsStr)(n.btn_first_page_text, "|<"), t.btnNextPageHtml = Object(o.defaultsStr)(n.btn_next_page_html, e.enableIcons ? '<input type="button" value="" class="' + t.btnCssClass + ' nextPage" title="Next page" />' : null), t.btnPrevPageHtml = Object(o.defaultsStr)(n.btn_prev_page_html, e.enableIcons ? '<input type="button" value="" class="' + t.btnCssClass + ' previousPage" title="Previous page" />' : null), t.btnFirstPageHtml = Object(o.defaultsStr)(n.btn_first_page_html, e.enableIcons ? '<input type="button" value="" class="' + t.btnCssClass + ' firstPage" title="First page" />' : null), t.btnLastPageHtml = Object(o.defaultsStr)(n.btn_last_page_html, e.enableIcons ? '<input type="button" value="" class="' + t.btnCssClass + ' lastPage" title="Last page" />' : null), t.pageText = Object(o.defaultsStr)(n.page_text, " Page "), t.ofText = Object(o.defaultsStr)(n.of_text, " of "), t.nbPgSpanCssClass = Object(o.defaultsStr)(n.nb_pages_css_class, "nbpg"), t.hasBtns = Object(o.defaultsBool)(n.btns, !0), t.pageSelectorType = Object(o.defaultsStr)(n.page_selector_type, v.SELECT), t.toolbarPosition = Object(o.defaultsStr)(n.toolbar_position, f.CENTER), t.onBeforeChangePage = Object(o.defaultsFn)(n.on_before_change_page, g.EMPTY_FN), t.onAfterChangePage = Object(o.defaultsFn)(n.on_after_change_page, g.EMPTY_FN), t.slcResultsTxt = null, t.btnNextCont = null, t.btnPrevCont = null, t.btnLastCont = null, t.btnFirstCont = null, t.pgCont = null, t.pgBefore = null, t.pgAfter = null;
                    var r = e.refRow, i = e.getRowsNb(!0);
                    t.nbPages = Math.ceil((i - r) / t.pageLength);
                    var s = _assertThisInitialized(t);
                    return t.evt = {
                        slcIndex: function slcIndex() {
                            return s.pageSelectorType === v.SELECT ? s.pageSlc.options.selectedIndex : parseInt(s.pageSlc.value, 10) - 1;
                        },
                        nbOpts: function nbOpts() {
                            return s.pageSelectorType === v.SELECT ? parseInt(s.pageSlc.options.length, 10) - 1 : s.nbPages - 1;
                        },
                        next: function next() {
                            var t = s.evt.slcIndex() < s.evt.nbOpts() ? s.evt.slcIndex() + 1 : 0;
                            s.changePage(t);
                        },
                        prev: function prev() {
                            var t = 0 < s.evt.slcIndex() ? s.evt.slcIndex() - 1 : s.evt.nbOpts();
                            s.changePage(t);
                        },
                        last: function last() {
                            s.changePage(s.evt.nbOpts());
                        },
                        first: function first() {
                            s.changePage(0);
                        },
                        _detectKey: function _detectKey(t) {
                            Object(b.isKeyPressed)(t, [
                                v.ENTER_KEY
                            ]) && (e.sorted ? (e.filter(), s.changePage(s.evt.slcIndex())) : s.changePage(), this.blur());
                        },
                        slcPagesChange: null,
                        nextEvt: null,
                        prevEvt: null,
                        lastEvt: null,
                        firstEvt: null
                    }, t;
                }
                return function _createClass(t, e, n) {
                    return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
                }(Paging, [
                    {
                        key: "init",
                        value: function init() {
                            var t, n = this, e = this.tf, r = this.evt;
                            if (!this.initialized) {
                                this.emitter.emit("initializing-feature", this, !Object(g.isNull)(this.tgtId)), this.hasResultsPerPage && (this.resultsPerPage.length < 2 ? this.hasResultsPerPage = !1 : (this.pageLength = this.resultsPerPage[1][0], this.setResultsPerPage())), r.slcPagesChange = function(t) {
                                    var e = t.target;
                                    n.changePage(e.selectedIndex);
                                }, this.pageSelectorType === v.SELECT && ((t = Object(y.createElm)(v.SELECT)).className = this.pgSlcCssClass, Object(b.addEvt)(t, "change", r.slcPagesChange)), this.pageSelectorType === v.INPUT && ((t = Object(y.createElm)(v.INPUT, [
                                    "value",
                                    this.currentPageNb
                                ])).className = this.pgInpCssClass, Object(b.addEvt)(t, "keypress", r._detectKey));
                                var i = Object(y.createElm)("span"), s = Object(y.createElm)("span"), a = Object(y.createElm)("span"), o = Object(y.createElm)("span");
                                if (this.hasBtns) {
                                    if (this.btnNextPageHtml) i.innerHTML = this.btnNextPageHtml, Object(b.addEvt)(i, "click", r.next);
                                    else {
                                        var u = Object(y.createElm)(v.INPUT, [
                                            "type",
                                            "button"
                                        ], [
                                            "value",
                                            this.btnNextPageText
                                        ], [
                                            "title",
                                            "Next"
                                        ]);
                                        u.className = this.btnCssClass, Object(b.addEvt)(u, "click", r.next), i.appendChild(u);
                                    }
                                    if (this.btnPrevPageHtml) s.innerHTML = this.btnPrevPageHtml, Object(b.addEvt)(s, "click", r.prev);
                                    else {
                                        var c = Object(y.createElm)(v.INPUT, [
                                            "type",
                                            "button"
                                        ], [
                                            "value",
                                            this.btnPrevPageText
                                        ], [
                                            "title",
                                            "Previous"
                                        ]);
                                        c.className = this.btnCssClass, Object(b.addEvt)(c, "click", r.prev), s.appendChild(c);
                                    }
                                    if (this.btnLastPageHtml) a.innerHTML = this.btnLastPageHtml, Object(b.addEvt)(a, "click", r.last);
                                    else {
                                        var l = Object(y.createElm)(v.INPUT, [
                                            "type",
                                            "button"
                                        ], [
                                            "value",
                                            this.btnLastPageText
                                        ], [
                                            "title",
                                            "Last"
                                        ]);
                                        l.className = this.btnCssClass, Object(b.addEvt)(l, "click", r.last), a.appendChild(l);
                                    }
                                    if (this.btnFirstPageHtml) o.innerHTML = this.btnFirstPageHtml, Object(b.addEvt)(o, "click", r.first);
                                    else {
                                        var f = Object(y.createElm)(v.INPUT, [
                                            "type",
                                            "button"
                                        ], [
                                            "value",
                                            this.btnFirstPageText
                                        ], [
                                            "title",
                                            "First"
                                        ]);
                                        f.className = this.btnCssClass, Object(b.addEvt)(f, "click", r.first), o.appendChild(f);
                                    }
                                }
                                var d = this.tgtId ? Object(y.elm)(this.tgtId) : e.feature("toolbar").container(this.toolbarPosition);
                                d.appendChild(o), d.appendChild(s);
                                var h = Object(y.createElm)("span");
                                h.appendChild(Object(y.createText)(this.pageText)), h.className = this.nbPgSpanCssClass, d.appendChild(h), d.appendChild(t);
                                var p = Object(y.createElm)("span");
                                p.appendChild(Object(y.createText)(this.ofText)), p.className = this.nbPgSpanCssClass, d.appendChild(p);
                                var m = Object(y.createElm)("span");
                                m.className = this.nbPgSpanCssClass, m.appendChild(Object(y.createText)(" " + this.nbPages + " ")), d.appendChild(m), d.appendChild(i), d.appendChild(a), this.btnNextCont = i, this.btnPrevCont = s, this.btnLastCont = a, this.btnFirstCont = o, this.pgCont = m, this.pgBefore = h, this.pgAfter = p, this.pageSlc = t, this.setPagingInfo(), e.fltGrid || (e.validateAllRows(), this.setPagingInfo(e.validRowsIndex)), this.emitter.on([
                                    "after-filtering"
                                ], Object(b.bound)(this.resetPagingInfo, this)), this.emitter.on([
                                    "change-page"
                                ], Object(b.bound)(this.changePageHandler, this)), this.emitter.on([
                                    "change-page-results"
                                ], Object(b.bound)(this.changePageResultsHandler, this)), this.initialized = !0, this.emitter.emit("feature-initialized", this);
                            }
                        }
                    },
                    {
                        key: "reset",
                        value: function reset(t) {
                            var e = 0 < arguments.length && void 0 !== t && t;
                            this.enable(), this.init(), e && this.tf.filter();
                        }
                    },
                    {
                        key: "resetPagingInfo",
                        value: function resetPagingInfo() {
                            this.startPagingRow = 0, this.currentPageNb = 1, this.setPagingInfo(this.tf.validRowsIndex);
                        }
                    },
                    {
                        key: "setPagingInfo",
                        value: function setPagingInfo(t) {
                            var e = this.tf, n = this.tgtId ? Object(y.elm)(this.tgtId) : e.feature("toolbar").container(this.toolbarPosition);
                            if (e.validRowsIndex = t || e.getValidRows(!0), this.nbPages = Math.ceil(e.validRowsIndex.length / this.pageLength), this.pgCont.innerHTML = this.nbPages, this.pageSelectorType === v.SELECT && (this.pageSlc.innerHTML = ""), 0 < this.nbPages) {
                                if (n.style.visibility = "visible", this.pageSelectorType === v.SELECT) for(var r = 0; r < this.nbPages; r++){
                                    var i = Object(y.createOpt)(r + 1, r * this.pageLength, !1);
                                    this.pageSlc.options[r] = i;
                                }
                                else this.pageSlc.value = this.currentPageNb;
                            } else n.style.visibility = "hidden";
                            this.groupByPage(e.validRowsIndex);
                        }
                    },
                    {
                        key: "groupByPage",
                        value: function groupByPage(t) {
                            var e = this.tf, n = e.dom().rows, r = parseInt(this.startPagingRow, 10), i = r + parseInt(this.pageLength, 10);
                            t && (e.validRowsIndex = t);
                            for(var s = 0, a = e.getValidRowsNb(!0); s < a; s++){
                                var o = e.validRowsIndex[s], u = n[o], c = u.getAttribute("validRow"), l = !1;
                                r <= s && s < i ? (Object(g.isNull)(c) || Boolean("true" === c)) && (l = (u.style.display = "", true)) : u.style.display = v.NONE, this.emitter.emit("row-paged", e, o, s, l);
                            }
                            this.emitter.emit("grouped-by-page", e, this);
                        }
                    },
                    {
                        key: "getPage",
                        value: function getPage() {
                            return this.currentPageNb;
                        }
                    },
                    {
                        key: "setPage",
                        value: function setPage(t) {
                            if (this.tf.isInitialized() && this.isEnabled()) {
                                var e = this.evt, n = _typeof(t);
                                if ("string" === n) switch(t.toLowerCase()){
                                    case "next":
                                        e.next();
                                        break;
                                    case "previous":
                                        e.prev();
                                        break;
                                    case "last":
                                        e.last();
                                        break;
                                    case "first":
                                        e.first();
                                        break;
                                    default:
                                        e.next();
                                }
                                else "number" === n && this.changePage(t - 1);
                            }
                        }
                    },
                    {
                        key: "setResultsPerPage",
                        value: function setResultsPerPage() {
                            var e = this, t = this.tf, n = this.evt;
                            if (!this.pageLengthSlc && this.resultsPerPage) {
                                n.slcResultsChange = function(t) {
                                    e.onChangeResultsPerPage(), t.target.blur();
                                };
                                var r = Object(y.createElm)(v.SELECT);
                                r.className = this.resultsSlcCssClass;
                                var i = this.resultsPerPage[0], s = this.resultsPerPage[1], a = Object(y.createElm)("span");
                                a.className = this.resultsSpanCssClass;
                                var o = this.pageLengthTgtId ? Object(y.elm)(this.pageLengthTgtId) : t.feature("toolbar").container(f.RIGHT);
                                a.appendChild(Object(y.createText)(i));
                                var u = t.feature("help");
                                u && u.btn ? (u.btn.parentNode.insertBefore(a, u.btn), u.btn.parentNode.insertBefore(r, u.btn)) : (o.appendChild(a), o.appendChild(r));
                                for(var c = 0; c < s.length; c++){
                                    var l = new Option(s[c], s[c], !1, !1);
                                    r.options[c] = l;
                                }
                                Object(b.addEvt)(r, "change", n.slcResultsChange), this.slcResultsTxt = a, this.pageLengthSlc = r;
                            }
                        }
                    },
                    {
                        key: "removeResultsPerPage",
                        value: function removeResultsPerPage() {
                            this.tf.isInitialized() && this.pageLengthSlc && this.resultsPerPage && (this.pageLengthSlc && Object(y.removeElm)(this.pageLengthSlc), this.slcResultsTxt && Object(y.removeElm)(this.slcResultsTxt), this.pageLengthSlc = null, this.slcResultsTxt = null);
                        }
                    },
                    {
                        key: "changePage",
                        value: function changePage(t) {
                            var e = this.tf;
                            this.isEnabled() && (this.emitter.emit("before-page-change", e, t + 1), null === t && (t = this.pageSelectorType === v.SELECT ? this.pageSlc.options.selectedIndex : this.pageSlc.value - 1), 0 <= t && t <= this.nbPages - 1 && (this.onBeforeChangePage(this, t + 1), this.currentPageNb = parseInt(t, 10) + 1, this.pageSelectorType === v.SELECT ? this.pageSlc.options[t].selected = !0 : this.pageSlc.value = this.currentPageNb, this.startPagingRow = this.pageSelectorType === v.SELECT ? this.pageSlc.value : t * this.pageLength, this.groupByPage(), this.onAfterChangePage(this, t + 1)), this.emitter.emit("after-page-change", e, t + 1));
                        }
                    },
                    {
                        key: "changeResultsPerPage",
                        value: function changeResultsPerPage(t) {
                            this.isEnabled() && !isNaN(t) && (this.pageLengthSlc.value = t, this.onChangeResultsPerPage());
                        }
                    },
                    {
                        key: "onChangeResultsPerPage",
                        value: function onChangeResultsPerPage() {
                            var t = this.tf;
                            if (this.isEnabled() && 0 !== t.getValidRowsNb()) {
                                var e = this.pageLengthSlc, n = this.pageSelectorType, r = this.pageSlc, i = this.emitter;
                                i.emit("before-page-length-change", t);
                                var s = e.selectedIndex, a = n === v.SELECT ? r.selectedIndex : parseInt(r.value - 1, 10);
                                if (this.pageLength = parseInt(e.options[s].value, 10), this.startPagingRow = this.pageLength * a, !isNaN(this.pageLength) && (this.startPagingRow >= t.nbFilterableRows && (this.startPagingRow = t.nbFilterableRows - this.pageLength), this.setPagingInfo(), n === v.SELECT)) {
                                    var o = r.options.length - 1 <= a ? r.options.length - 1 : a;
                                    r.options[o].selected = !0;
                                }
                                i.emit("after-page-length-change", t, this.pageLength);
                            }
                        }
                    },
                    {
                        key: "resetPage",
                        value: function resetPage() {
                            var t = this.tf;
                            if (this.isEnabled()) {
                                this.emitter.emit("before-reset-page", t);
                                var e = t.feature("store").getPageNb();
                                "" !== e && this.changePage(e - 1), this.emitter.emit("after-reset-page", t, e);
                            }
                        }
                    },
                    {
                        key: "resetPageLength",
                        value: function resetPageLength() {
                            var t = this.tf;
                            if (this.isEnabled()) {
                                this.emitter.emit("before-reset-page-length", t);
                                var e = t.feature("store").getPageLength();
                                "" !== e && (this.pageLengthSlc.options[e].selected = !0, this.changeResultsPerPage()), this.emitter.emit("after-reset-page-length", t, e);
                            }
                        }
                    },
                    {
                        key: "changePageHandler",
                        value: function changePageHandler(t, e) {
                            this.setPage(e);
                        }
                    },
                    {
                        key: "changePageResultsHandler",
                        value: function changePageResultsHandler(t, e) {
                            this.changeResultsPerPage(e);
                        }
                    },
                    {
                        key: "destroy",
                        value: function destroy() {
                            if (this.initialized) {
                                var t = this.evt;
                                this.pageSlc && (this.pageSelectorType === v.SELECT ? Object(b.removeEvt)(this.pageSlc, "change", t.slcPagesChange) : this.pageSelectorType === v.INPUT && Object(b.removeEvt)(this.pageSlc, "keypress", t._detectKey), Object(y.removeElm)(this.pageSlc)), this.btnNextCont && (Object(b.removeEvt)(this.btnNextCont, "click", t.next), Object(y.removeElm)(this.btnNextCont), this.btnNextCont = null), this.btnPrevCont && (Object(b.removeEvt)(this.btnPrevCont, "click", t.prev), Object(y.removeElm)(this.btnPrevCont), this.btnPrevCont = null), this.btnLastCont && (Object(b.removeEvt)(this.btnLastCont, "click", t.last), Object(y.removeElm)(this.btnLastCont), this.btnLastCont = null), this.btnFirstCont && (Object(b.removeEvt)(this.btnFirstCont, "click", t.first), Object(y.removeElm)(this.btnFirstCont), this.btnFirstCont = null), this.pgBefore && (Object(y.removeElm)(this.pgBefore), this.pgBefore = null), this.pgAfter && (Object(y.removeElm)(this.pgAfter), this.pgAfter = null), this.pgCont && (Object(y.removeElm)(this.pgCont), this.pgCont = null), this.hasResultsPerPage && this.removeResultsPerPage(), this.emitter.off([
                                    "after-filtering"
                                ], Object(b.bound)(this.resetPagingInfo, this)), this.emitter.off([
                                    "change-page"
                                ], Object(b.bound)(this.changePageHandler, this)), this.emitter.off([
                                    "change-page-results"
                                ], Object(b.bound)(this.changePageResultsHandler, this)), this.pageSlc = null, this.nbPages = 0, this.initialized = !1;
                            }
                        }
                    }
                ]), Paging;
            }();
        },
        function(t, e) {
            e.remove = function removeDiacritics(t) {
                return t.replace(/[^\u0000-\u007e]/g, function(t) {
                    return r[t] || t;
                });
            };
            for(var n = [
                {
                    base: " ",
                    chars: "\xa0"
                },
                {
                    base: "0",
                    chars: "\u07C0"
                },
                {
                    base: "A",
                    chars: "\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
                },
                {
                    base: "AA",
                    chars: "\uA732"
                },
                {
                    base: "AE",
                    chars: "\xc6\u01FC\u01E2"
                },
                {
                    base: "AO",
                    chars: "\uA734"
                },
                {
                    base: "AU",
                    chars: "\uA736"
                },
                {
                    base: "AV",
                    chars: "\uA738\uA73A"
                },
                {
                    base: "AY",
                    chars: "\uA73C"
                },
                {
                    base: "B",
                    chars: "\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0181"
                },
                {
                    base: "C",
                    chars: "\u24B8\uFF23\uA73E\u1E08\u0106C\u0108\u010A\u010C\xc7\u0187\u023B"
                },
                {
                    base: "D",
                    chars: "\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018A\u0189\u1D05\uA779"
                },
                {
                    base: "Dh",
                    chars: "\xd0"
                },
                {
                    base: "DZ",
                    chars: "\u01F1\u01C4"
                },
                {
                    base: "Dz",
                    chars: "\u01F2\u01C5"
                },
                {
                    base: "E",
                    chars: "\u025B\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E\u1D07"
                },
                {
                    base: "F",
                    chars: "\uA77C\u24BB\uFF26\u1E1E\u0191\uA77B"
                },
                {
                    base: "G",
                    chars: "\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E\u0262"
                },
                {
                    base: "H",
                    chars: "\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
                },
                {
                    base: "I",
                    chars: "\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
                },
                {
                    base: "J",
                    chars: "\u24BF\uFF2A\u0134\u0248\u0237"
                },
                {
                    base: "K",
                    chars: "\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
                },
                {
                    base: "L",
                    chars: "\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
                },
                {
                    base: "LJ",
                    chars: "\u01C7"
                },
                {
                    base: "Lj",
                    chars: "\u01C8"
                },
                {
                    base: "M",
                    chars: "\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C\u03FB"
                },
                {
                    base: "N",
                    chars: "\uA7A4\u0220\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u019D\uA790\u1D0E"
                },
                {
                    base: "NJ",
                    chars: "\u01CA"
                },
                {
                    base: "Nj",
                    chars: "\u01CB"
                },
                {
                    base: "O",
                    chars: "\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
                },
                {
                    base: "OE",
                    chars: "\u0152"
                },
                {
                    base: "OI",
                    chars: "\u01A2"
                },
                {
                    base: "OO",
                    chars: "\uA74E"
                },
                {
                    base: "OU",
                    chars: "\u0222"
                },
                {
                    base: "P",
                    chars: "\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
                },
                {
                    base: "Q",
                    chars: "\u24C6\uFF31\uA756\uA758\u024A"
                },
                {
                    base: "R",
                    chars: "\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
                },
                {
                    base: "S",
                    chars: "\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
                },
                {
                    base: "T",
                    chars: "\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
                },
                {
                    base: "Th",
                    chars: "\xde"
                },
                {
                    base: "TZ",
                    chars: "\uA728"
                },
                {
                    base: "U",
                    chars: "\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
                },
                {
                    base: "V",
                    chars: "\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
                },
                {
                    base: "VY",
                    chars: "\uA760"
                },
                {
                    base: "W",
                    chars: "\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
                },
                {
                    base: "X",
                    chars: "\u24CD\uFF38\u1E8A\u1E8C"
                },
                {
                    base: "Y",
                    chars: "\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
                },
                {
                    base: "Z",
                    chars: "\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
                },
                {
                    base: "a",
                    chars: "\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250\u0251"
                },
                {
                    base: "aa",
                    chars: "\uA733"
                },
                {
                    base: "ae",
                    chars: "\xe6\u01FD\u01E3"
                },
                {
                    base: "ao",
                    chars: "\uA735"
                },
                {
                    base: "au",
                    chars: "\uA737"
                },
                {
                    base: "av",
                    chars: "\uA739\uA73B"
                },
                {
                    base: "ay",
                    chars: "\uA73D"
                },
                {
                    base: "b",
                    chars: "\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253\u0182"
                },
                {
                    base: "c",
                    chars: "\uFF43\u24D2\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
                },
                {
                    base: "d",
                    chars: "\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\u018B\u13E7\u0501\uA7AA"
                },
                {
                    base: "dh",
                    chars: "\xf0"
                },
                {
                    base: "dz",
                    chars: "\u01F3\u01C6"
                },
                {
                    base: "e",
                    chars: "\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u01DD"
                },
                {
                    base: "f",
                    chars: "\u24D5\uFF46\u1E1F\u0192"
                },
                {
                    base: "ff",
                    chars: "\uFB00"
                },
                {
                    base: "fi",
                    chars: "\uFB01"
                },
                {
                    base: "fl",
                    chars: "\uFB02"
                },
                {
                    base: "ffi",
                    chars: "\uFB03"
                },
                {
                    base: "ffl",
                    chars: "\uFB04"
                },
                {
                    base: "g",
                    chars: "\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\uA77F\u1D79"
                },
                {
                    base: "h",
                    chars: "\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
                },
                {
                    base: "hv",
                    chars: "\u0195"
                },
                {
                    base: "i",
                    chars: "\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
                },
                {
                    base: "j",
                    chars: "\u24D9\uFF4A\u0135\u01F0\u0249"
                },
                {
                    base: "k",
                    chars: "\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
                },
                {
                    base: "l",
                    chars: "\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747\u026D"
                },
                {
                    base: "lj",
                    chars: "\u01C9"
                },
                {
                    base: "m",
                    chars: "\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
                },
                {
                    base: "n",
                    chars: "\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5\u043B\u0509"
                },
                {
                    base: "nj",
                    chars: "\u01CC"
                },
                {
                    base: "o",
                    chars: "\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\uA74B\uA74D\u0275\u0254\u1D11"
                },
                {
                    base: "oe",
                    chars: "\u0153"
                },
                {
                    base: "oi",
                    chars: "\u01A3"
                },
                {
                    base: "oo",
                    chars: "\uA74F"
                },
                {
                    base: "ou",
                    chars: "\u0223"
                },
                {
                    base: "p",
                    chars: "\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755\u03C1"
                },
                {
                    base: "q",
                    chars: "\u24E0\uFF51\u024B\uA757\uA759"
                },
                {
                    base: "r",
                    chars: "\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
                },
                {
                    base: "s",
                    chars: "\u24E2\uFF53\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B\u0282"
                },
                {
                    base: "ss",
                    chars: "\xdf"
                },
                {
                    base: "t",
                    chars: "\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
                },
                {
                    base: "th",
                    chars: "\xfe"
                },
                {
                    base: "tz",
                    chars: "\uA729"
                },
                {
                    base: "u",
                    chars: "\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
                },
                {
                    base: "v",
                    chars: "\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
                },
                {
                    base: "vy",
                    chars: "\uA761"
                },
                {
                    base: "w",
                    chars: "\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
                },
                {
                    base: "x",
                    chars: "\u24E7\uFF58\u1E8B\u1E8D"
                },
                {
                    base: "y",
                    chars: "\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
                },
                {
                    base: "z",
                    chars: "\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
                }
            ], r = {}, i = 0; i < n.length; i += 1)for(var s = n[i].chars, a = 0; a < s.length; a += 1)r[s[a]] = n[i].base;
            e.replacementList = n, e.diacriticsMap = r;
        },
        function(t, e, n) {
            "use strict";
            function _defineProperties(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            n.r(e), n.d(e, "Emitter", function() {
                return r;
            });
            var r = function() {
                function Emitter() {
                    !function _classCallCheck(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, Emitter), this.events = {};
                }
                return function _createClass(t, e, n) {
                    return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
                }(Emitter, [
                    {
                        key: "on",
                        value: function on(t, e) {
                            var n = this;
                            t.forEach(function(t) {
                                n.events[t] = n.events[t] || [], n.events[t].push(e);
                            });
                        }
                    },
                    {
                        key: "off",
                        value: function off(t, e) {
                            var n = this;
                            t.forEach(function(t) {
                                t in n.events && n.events[t].splice(n.events[t].indexOf(e), 1);
                            });
                        }
                    },
                    {
                        key: "emit",
                        value: function emit(t) {
                            if (t in this.events) for(var e = 0; e < this.events[t].length; e++)this.events[t][e].apply(this, [].slice.call(arguments, 1));
                        }
                    }
                ]), Emitter;
            }();
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "Dropdown", function() {
                return r;
            });
            var i = n(48), f = n(2), d = n(20), h = n(8), c = n(5), p = n(4), s = n(1);
            function _typeof(t) {
                return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(t) {
                    return typeof t;
                } : function _typeof(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function _defineProperties(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function _setPrototypeOf(t, e) {
                return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(t, e) {
                    return t.__proto__ = e, t;
                })(t, e);
            }
            function _createSuper(r) {
                var i = function _isNativeReflectConstruct() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
                    } catch (t) {
                        return !1;
                    }
                }();
                return function _createSuperInternal() {
                    var t, e = _getPrototypeOf(r);
                    if (i) {
                        var n = _getPrototypeOf(this).constructor;
                        t = Reflect.construct(e, arguments, n);
                    } else t = e.apply(this, arguments);
                    return function _possibleConstructorReturn(t, e) {
                        return !e || "object" !== _typeof(e) && "function" != typeof e ? function _assertThisInitialized(t) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }(t) : e;
                    }(this, t);
                };
            }
            function _getPrototypeOf(t) {
                return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                })(t);
            }
            var r = function() {
                !function _inherits(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && _setPrototypeOf(t, e);
                }(Dropdown, i["BaseDropdown"]);
                var r = _createSuper(Dropdown);
                function Dropdown(t) {
                    var e;
                    !function _classCallCheck(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, Dropdown);
                    var n = (e = r.call(this, t, Dropdown)).config;
                    return e.enableSlcResetFilter = Object(s.defaultsBool)(n.enable_slc_reset_filter, !0), e.nonEmptyText = Object(s.defaultsStr)(n.non_empty_text, "(Non empty)"), e.multipleSlcTooltip = Object(s.defaultsStr)(n.multiple_slc_tooltip, "Use Ctrl/Cmd key for multiple selections"), e;
                }
                return function _createClass(t, e, n) {
                    return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
                }(Dropdown, [
                    {
                        key: "onSlcFocus",
                        value: function onSlcFocus(t) {
                            var e = Object(c.targetEvt)(t), n = this.tf;
                            if (n.loadFltOnDemand && "0" === e.getAttribute("filled")) {
                                var r = e.getAttribute("ct");
                                this.build(r);
                            }
                            this.emitter.emit("filter-focus", n, e);
                        }
                    },
                    {
                        key: "onSlcChange",
                        value: function onSlcChange() {
                            this.tf.onSlcChange && this.tf.filter();
                        }
                    },
                    {
                        key: "refreshAll",
                        value: function refreshAll() {
                            var t = this.tf.getFiltersByType(p.SELECT, !0), e = this.tf.getFiltersByType(p.MULTIPLE, !0), n = t.concat(e);
                            this.refreshFilters(n);
                        }
                    },
                    {
                        key: "init",
                        value: function init(t, e, n) {
                            var i = this, r = this.tf, s = r.getFilterType(t), a = e ? r.externalFltIds[t] : null, o = Object(f.createElm)(p.SELECT, [
                                "id",
                                r.buildFilterId(t)
                            ], [
                                "ct",
                                t
                            ], [
                                "filled",
                                "0"
                            ]);
                            if (s === p.MULTIPLE && (o.multiple = p.MULTIPLE, o.title = this.multipleSlcTooltip), o.className = s.toLowerCase() === p.SELECT ? r.fltCssClass : r.fltMultiCssClass, a ? Object(f.elm)(a).appendChild(o) : n.appendChild(o), r.fltIds.push(o.id), r.loadFltOnDemand) {
                                var u = Object(f.createOpt)(r.getClearFilterText(t), "");
                                o.appendChild(u);
                            } else this.build(t);
                            Object(c.addEvt)(o, "change", function() {
                                return i.onSlcChange();
                            }), Object(c.addEvt)(o, "focus", function(t) {
                                return i.onSlcFocus(t);
                            }), this.emitter.on([
                                "build-select-filter"
                            ], function(t, e, n, r) {
                                return i.build(e, n, r);
                            }), this.emitter.on([
                                "select-options"
                            ], function(t, e, n) {
                                return i.selectOptions(e, n);
                            }), this.emitter.on([
                                "rows-changed"
                            ], function() {
                                return i.refreshAll();
                            }), this.emitter.on([
                                "after-filtering"
                            ], function() {
                                return i.linkFilters();
                            }), this.initialized = !0;
                        }
                    },
                    {
                        key: "build",
                        value: function build(i, t) {
                            var s = this, a = 1 < arguments.length && void 0 !== t && t, o = this.tf;
                            i = Number(i), this.emitter.emit("before-populating-filter", o, i), this.opts = [], this.optsTxt = [];
                            var n, e = o.getFilterElement(i);
                            if (this.isCustom = o.isCustomOptions(i), this.isCustom) {
                                var r = o.getCustomOptions(i);
                                this.opts = r[0], this.optsTxt = r[1];
                            }
                            var u = o.getActiveFilterId();
                            a && u && (n = o.getColumnIndexFromFilterId(u));
                            var c = null, l = null;
                            a && o.disableExcludedOptions && (c = [], l = []), o.eachRow()(function(t) {
                                var e = o.getCellValue(t.cells[i]), n = Object(h.matchCase)(e, o.caseSensitive);
                                if (Object(d.has)(s.opts, n, o.caseSensitive) || s.opts.push(e), a && o.disableExcludedOptions) {
                                    var r = l[i];
                                    r = r || o.getVisibleColumnValues(i), Object(d.has)(r, n, o.caseSensitive) || Object(d.has)(c, n, o.caseSensitive) || c.push(e);
                                }
                            }, function(t, e) {
                                return -1 !== o.excludeRows.indexOf(e) || !(t.cells.length === o.nbCells && !s.isCustom) || !(!a || s.isValidLinkedValue(e, n)) || void 0;
                            }), this.opts = this.sortOptions(i, this.opts), c = c && this.sortOptions(i, c), this.addOptions(i, e, a, c), this.emitter.emit("after-populating-filter", o, i, e);
                        }
                    },
                    {
                        key: "addOptions",
                        value: function addOptions(t, e, n, r) {
                            var i = this.tf, s = e.value;
                            e.innerHTML = "", e = this.addFirstOption(e);
                            for(var a = 0; a < this.opts.length; a++)if ("" !== this.opts[a]) {
                                var o = this.opts[a], u = this.isCustom ? this.optsTxt[a] : o, c = !1;
                                n && i.disableExcludedOptions && Object(d.has)(r, Object(h.matchCase)(o, i.caseSensitive), i.caseSensitive) && (c = !0);
                                var l = void 0;
                                l = i.loadFltOnDemand && s === this.opts[a] && i.getFilterType(t) === p.SELECT ? Object(f.createOpt)(u, o, !0) : Object(f.createOpt)(u, o, !1), c && (l.disabled = !0), e.appendChild(l);
                            }
                            e.setAttribute("filled", "1");
                        }
                    },
                    {
                        key: "addFirstOption",
                        value: function addFirstOption(t) {
                            var e = this.tf, n = e.getColumnIndexFromFilterId(t.id), r = Object(f.createOpt)(this.enableSlcResetFilter ? e.getClearFilterText(n) : "", "");
                            if (this.enableSlcResetFilter || (r.style.display = p.NONE), t.appendChild(r), e.enableEmptyOption) {
                                var i = Object(f.createOpt)(e.emptyText, e.emOperator);
                                t.appendChild(i);
                            }
                            if (e.enableNonEmptyOption) {
                                var s = Object(f.createOpt)(e.nonEmptyText, e.nmOperator);
                                t.appendChild(s);
                            }
                            return t;
                        }
                    },
                    {
                        key: "selectOptions",
                        value: function selectOptions(t, e) {
                            var n = 1 < arguments.length && void 0 !== e ? e : [], r = this.tf;
                            if (0 !== n.length) {
                                var i = r.getFilterElement(t);
                                [].forEach.call(i.options, function(t) {
                                    "" !== n[0] && "" !== t.value || (t.selected = !1), "" !== t.value && Object(d.has)(n, t.value, !0) && (t.selected = !0);
                                });
                            }
                        }
                    },
                    {
                        key: "getValues",
                        value: function getValues(t) {
                            var e = this.tf.getFilterElement(t), n = [];
                            return e.selectedOptions ? [].forEach.call(e.selectedOptions, function(t) {
                                return n.push(t.value);
                            }) : [].forEach.call(e.options, function(t) {
                                t.selected && n.push(t.value);
                            }), n;
                        }
                    },
                    {
                        key: "destroy",
                        value: function destroy() {
                            var r = this;
                            this.emitter.off([
                                "build-select-filter"
                            ], function(t, e, n) {
                                return r.build(t, e, n);
                            }), this.emitter.off([
                                "select-options"
                            ], function(t, e, n) {
                                return r.selectOptions(e, n);
                            }), this.emitter.off([
                                "rows-changed"
                            ], function() {
                                return r.refreshAll();
                            }), this.emitter.off([
                                "after-filtering"
                            ], function() {
                                return r.linkFilters();
                            }), this.initialized = !1;
                        }
                    }
                ]), Dropdown;
            }();
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "CheckList", function() {
                return r;
            });
            var i = n(48), b = n(2), d = n(20), v = n(8), f = n(5), s = n(3), h = n(4), a = n(1);
            function _typeof(t) {
                return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(t) {
                    return typeof t;
                } : function _typeof(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function _defineProperties(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function _setPrototypeOf(t, e) {
                return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(t, e) {
                    return t.__proto__ = e, t;
                })(t, e);
            }
            function _createSuper(r) {
                var i = function _isNativeReflectConstruct() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
                    } catch (t) {
                        return !1;
                    }
                }();
                return function _createSuperInternal() {
                    var t, e = _getPrototypeOf(r);
                    if (i) {
                        var n = _getPrototypeOf(this).constructor;
                        t = Reflect.construct(e, arguments, n);
                    } else t = e.apply(this, arguments);
                    return function _possibleConstructorReturn(t, e) {
                        return !e || "object" !== _typeof(e) && "function" != typeof e ? function _assertThisInitialized(t) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }(t) : e;
                    }(this, t);
                };
            }
            function _getPrototypeOf(t) {
                return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                })(t);
            }
            var r = function() {
                !function _inherits(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && _setPrototypeOf(t, e);
                }(CheckList, i["BaseDropdown"]);
                var r = _createSuper(CheckList);
                function CheckList(t) {
                    var e;
                    !function _classCallCheck(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, CheckList);
                    var n = (e = r.call(this, t, CheckList)).config;
                    return e.containers = [], e.containerCssClass = Object(a.defaultsStr)(n.div_checklist_css_class, "div_checklist"), e.filterCssClass = Object(a.defaultsStr)(n.checklist_css_class, "flt_checklist"), e.itemCssClass = Object(a.defaultsStr)(n.checklist_item_css_class, "flt_checklist_item"), e.selectedItemCssClass = Object(a.defaultsStr)(n.checklist_selected_item_css_class, "flt_checklist_slc_item"), e.activateText = Object(a.defaultsStr)(n.activate_checklist_text, "Click to load filter data"), e.disabledItemCssClass = Object(a.defaultsStr)(n.checklist_item_disabled_css_class, "flt_checklist_item_disabled"), e.enableResetOption = Object(a.defaultsBool)(n.enable_checklist_reset_filter, !0), e.prfx = "chkdiv_", e;
                }
                return function _createClass(t, e, n) {
                    return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
                }(CheckList, [
                    {
                        key: "optionClick",
                        value: function optionClick(t) {
                            var e = Object(f.targetEvt)(t), n = this.tf;
                            this.emitter.emit("filter-focus", n, e), this.setItemOption(e), n.filter();
                        }
                    },
                    {
                        key: "onCheckListClick",
                        value: function onCheckListClick(t) {
                            var e = this, n = Object(f.targetEvt)(t);
                            if (this.tf.loadFltOnDemand && "0" === n.getAttribute("filled")) {
                                var r = n.getAttribute("ct"), i = this.containers[r];
                                this.build(r), Object(f.removeEvt)(i, "click", function(t) {
                                    return e.onCheckListClick(t);
                                });
                            }
                        }
                    },
                    {
                        key: "refreshAll",
                        value: function refreshAll() {
                            var t = this.tf.getFiltersByType(h.CHECKLIST, !0);
                            this.refreshFilters(t);
                        }
                    },
                    {
                        key: "init",
                        value: function init(t, e, n) {
                            var r = this, i = this.tf, s = e ? i.externalFltIds[t] : null, a = Object(b.createElm)("div", [
                                "id",
                                "".concat(this.prfx).concat(t, "_").concat(i.id)
                            ], [
                                "ct",
                                t
                            ], [
                                "filled",
                                "0"
                            ]);
                            a.className = this.containerCssClass, s ? Object(b.elm)(s).appendChild(a) : n.appendChild(a), this.containers[t] = a, i.fltIds.push(i.buildFilterId(t)), i.loadFltOnDemand ? (Object(f.addEvt)(a, "click", function(t) {
                                return r.onCheckListClick(t);
                            }), a.appendChild(Object(b.createText)(this.activateText))) : this.build(t), this.emitter.on([
                                "build-checklist-filter"
                            ], function(t, e, n) {
                                return r.build(e, n);
                            }), this.emitter.on([
                                "select-checklist-options"
                            ], function(t, e, n) {
                                return r.selectOptions(e, n);
                            }), this.emitter.on([
                                "rows-changed"
                            ], function() {
                                return r.refreshAll();
                            }), this.emitter.on([
                                "after-filtering"
                            ], function() {
                                return r.linkFilters();
                            }), this.initialized = !0;
                        }
                    },
                    {
                        key: "build",
                        value: function build(i, t) {
                            var s = this, a = 1 < arguments.length && void 0 !== t && t, o = this.tf;
                            i = Number(i), this.emitter.emit("before-populating-filter", o, i), this.opts = [], this.optsTxt = [];
                            var e = this.containers[i], n = Object(b.createElm)("ul", [
                                "id",
                                o.fltIds[i]
                            ], [
                                "colIndex",
                                i
                            ]);
                            n.className = this.filterCssClass;
                            var r, u = o.caseSensitive;
                            if (this.isCustom = o.isCustomOptions(i), this.isCustom) {
                                var c = o.getCustomOptions(i);
                                this.opts = c[0], this.optsTxt = c[1];
                            }
                            var l = o.getActiveFilterId();
                            a && l && (r = o.getColumnIndexFromFilterId(l));
                            var f = [];
                            a && o.disableExcludedOptions && (this.excludedOpts = []), e.innerHTML = "", o.eachRow()(function(t) {
                                var e = o.getCellValue(t.cells[i]), n = Object(v.matchCase)(e, u);
                                Object(d.has)(s.opts, n, u) || s.opts.push(e);
                                var r = f[i];
                                a && o.disableExcludedOptions && (r = r || o.getVisibleColumnValues(i), Object(d.has)(r, n, u) || Object(d.has)(s.excludedOpts, n, u) || s.excludedOpts.push(e));
                            }, function(t, e) {
                                return -1 !== o.excludeRows.indexOf(e) || !(t.cells.length === o.nbCells && !s.isCustom) || !(!a || s.isValidLinkedValue(e, r)) || void 0;
                            }), this.opts = this.sortOptions(i, this.opts), this.excludedOpts && (this.excludedOpts = this.sortOptions(i, this.excludedOpts)), this.addChecks(i, n), o.loadFltOnDemand && (e.innerHTML = ""), e.appendChild(n), e.setAttribute("filled", "1"), this.emitter.emit("after-populating-filter", o, i, e);
                        }
                    },
                    {
                        key: "addChecks",
                        value: function addChecks(t, e) {
                            for(var n = this, r = this.tf, i = this.addTChecks(t, e), s = 0; s < this.opts.length; s++){
                                var a = this.opts[s], o = this.isCustom ? this.optsTxt[s] : a, u = r.fltIds[t], c = s + i, l = Object(b.createCheckItem)("".concat(u, "_").concat(c), a, o, [
                                    "data-idx",
                                    c
                                ]);
                                l.className = this.itemCssClass, r.linkedFilters && r.disableExcludedOptions && Object(d.has)(this.excludedOpts, Object(v.matchCase)(a, r.caseSensitive), r.caseSensitive) ? (Object(b.addClass)(l, this.disabledItemCssClass), l.check.disabled = !0, l.disabled = !0) : Object(f.addEvt)(l.check, "click", function(t) {
                                    return n.optionClick(t);
                                }), e.appendChild(l), "" === a && (l.style.display = h.NONE);
                            }
                        }
                    },
                    {
                        key: "addTChecks",
                        value: function addTChecks(t, e) {
                            var n = this, r = this.tf, i = 1, s = r.fltIds[t], a = Object(b.createCheckItem)("".concat(s, "_0"), "", r.getClearFilterText(t), [
                                "data-idx",
                                0
                            ]);
                            if (a.className = this.itemCssClass, e.appendChild(a), Object(f.addEvt)(a.check, "click", function(t) {
                                return n.optionClick(t);
                            }), this.enableResetOption || (a.style.display = h.NONE), r.enableEmptyOption) {
                                var o = Object(b.createCheckItem)("".concat(s, "_1"), r.emOperator, r.emptyText, [
                                    "data-idx",
                                    1
                                ]);
                                o.className = this.itemCssClass, e.appendChild(o), Object(f.addEvt)(o.check, "click", function(t) {
                                    return n.optionClick(t);
                                }), i++;
                            }
                            if (r.enableNonEmptyOption) {
                                var u = Object(b.createCheckItem)("".concat(s, "_2"), r.nmOperator, r.nonEmptyText, [
                                    "data-idx",
                                    2
                                ]);
                                u.className = this.itemCssClass, e.appendChild(u), Object(f.addEvt)(u.check, "click", function(t) {
                                    return n.optionClick(t);
                                }), i++;
                            }
                            return i;
                        }
                    },
                    {
                        key: "setItemOption",
                        value: function setItemOption(t) {
                            var r = this;
                            if (t) {
                                var e = this.tf, n = t.value, i = t.dataset.idx, s = e.getColumnIndexFromFilterId(t.id), a = e.getFilterElement(parseInt(s, 10)), o = a.childNodes, u = o[i], c = a.getAttribute("value") || "", l = a.getAttribute("indexes") || "";
                                if (t.checked) {
                                    if ("" === n) l.split(e.separator).forEach(function(t) {
                                        t = Number(t);
                                        var e = o[t], n = Object(b.tag)(e, "input")[0];
                                        n && 0 < t && (n.checked = !1, Object(b.removeClass)(e, r.selectedItemCssClass));
                                    }), a.setAttribute("value", ""), a.setAttribute("indexes", "");
                                    else {
                                        var f = l + i + e.separator, d = Object(v.trim)(c + " " + n + " " + e.orOperator);
                                        a.setAttribute("value", d), a.setAttribute("indexes", f);
                                        var h = Object(b.tag)(o[0], "input")[0];
                                        h && (h.checked = !1);
                                    }
                                    Object(b.removeClass)(o[0], this.selectedItemCssClass), Object(b.addClass)(u, this.selectedItemCssClass);
                                } else {
                                    var p = new RegExp(Object(v.rgxEsc)(n + " " + e.orOperator)), m = c.replace(p, ""), y = new RegExp(Object(v.rgxEsc)(i + e.separator)), g = l.replace(y, "");
                                    a.setAttribute("value", Object(v.trim)(m)), a.setAttribute("indexes", g), Object(b.removeClass)(u, this.selectedItemCssClass);
                                }
                            }
                        }
                    },
                    {
                        key: "selectOptions",
                        value: function selectOptions(t, e) {
                            var r = this, i = 1 < arguments.length && void 0 !== e ? e : [], s = this.tf, n = s.getFilterElement(t);
                            if (n && 0 !== i.length) {
                                var a = Object(b.tag)(n, "li");
                                n.setAttribute("value", ""), n.setAttribute("indexes", ""), [].forEach.call(a, function(t) {
                                    var e = Object(b.tag)(t, "input")[0], n = Object(v.matchCase)(e.value, s.caseSensitive);
                                    "" !== n && Object(d.has)(i, n, s.caseSensitive) ? e.checked = !0 : -1 !== i.indexOf(s.nmOperator) && n === Object(v.matchCase)(s.nonEmptyText, s.caseSensitive) ? e.checked = !0 : -1 !== i.indexOf(s.emOperator) && n === Object(v.matchCase)(s.emptyText, s.caseSensitive) ? e.checked = !0 : e.checked = !1, r.setItemOption(e);
                                });
                            }
                        }
                    },
                    {
                        key: "getValues",
                        value: function getValues(t) {
                            var e = this.tf, n = e.getFilterElement(t);
                            if (!n) return [];
                            var r = n.getAttribute("value"), i = Object(s.isEmpty)(r) ? "" : r;
                            return i = (i = i.substr(0, i.length - 3)).split(" " + e.orOperator + " ");
                        }
                    },
                    {
                        key: "destroy",
                        value: function destroy() {
                            var r = this;
                            this.emitter.off([
                                "build-checklist-filter"
                            ], function(t, e, n) {
                                return r.build(e, n);
                            }), this.emitter.off([
                                "select-checklist-options"
                            ], function(t, e, n) {
                                return r.selectOptions(e, n);
                            }), this.emitter.off([
                                "rows-changed"
                            ], function() {
                                return r.refreshAll();
                            }), this.emitter.off([
                                "after-filtering"
                            ], function() {
                                return r.linkFilters();
                            }), this.initialized = !1;
                        }
                    }
                ]), CheckList;
            }();
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "hasHashChange", function() {
                return c;
            }), n.d(e, "Hash", function() {
                return l;
            });
            var r = n(5), i = n(9);
            function _defineProperties(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            var s = i.root.JSON, a = i.root.location, o = i.root.decodeURIComponent, u = i.root.encodeURIComponent, c = function hasHashChange() {
                var t = i.root.documentMode;
                return "onhashchange" in i.root && (void 0 === t || 7 < t);
            }, l = function() {
                function Hash(t) {
                    !function _classCallCheck(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, Hash), this.state = t, this.lastHash = null, this.emitter = t.emitter, this.boundSync = null;
                }
                return function _createClass(t, e, n) {
                    return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
                }(Hash, [
                    {
                        key: "init",
                        value: function init() {
                            var n = this;
                            c() && (this.lastHash = a.hash, this.boundSync = this.sync.bind(this), this.emitter.on([
                                "state-changed"
                            ], function(t, e) {
                                return n.update(e);
                            }), this.emitter.on([
                                "initialized"
                            ], this.boundSync), Object(r.addEvt)(i.root, "hashchange", this.boundSync));
                        }
                    },
                    {
                        key: "update",
                        value: function update(t) {
                            var e = "#".concat(u(s.stringify(t)));
                            this.lastHash !== e && (a.hash = e, this.lastHash = e);
                        }
                    },
                    {
                        key: "parse",
                        value: function parse(t) {
                            return -1 === t.indexOf("#") ? null : (t = t.substr(1), s.parse(o(t)));
                        }
                    },
                    {
                        key: "sync",
                        value: function sync() {
                            var t = this.parse(a.hash);
                            t && this.state.overrideAndSync(t);
                        }
                    },
                    {
                        key: "destroy",
                        value: function destroy() {
                            var n = this;
                            this.emitter.off([
                                "state-changed"
                            ], function(t, e) {
                                return n.update(e);
                            }), this.emitter.off([
                                "initialized"
                            ], this.boundSync), Object(r.removeEvt)(i.root, "hashchange", this.boundSync), this.state = null, this.lastHash = null, this.emitter = null;
                        }
                    }
                ]), Hash;
            }();
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "hasStorage", function() {
                return u;
            }), n.d(e, "Storage", function() {
                return c;
            });
            var r = n(60), i = n(9);
            function _defineProperties(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            var s = i.root.JSON, a = i.root.localStorage, o = i.root.location, u = function hasStorage() {
                return "Storage" in i.root;
            }, c = function() {
                function Storage(t) {
                    !function _classCallCheck(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, Storage), this.state = t, this.tf = t.tf, this.enableLocalStorage = t.enableLocalStorage && u(), this.enableCookie = t.enableCookie && !this.enableLocalStorage, this.emitter = t.emitter, this.duration = t.cookieDuration;
                }
                return function _createClass(t, e, n) {
                    return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
                }(Storage, [
                    {
                        key: "init",
                        value: function init() {
                            var n = this;
                            this.emitter.on([
                                "state-changed"
                            ], function(t, e) {
                                return n.save(e);
                            }), this.emitter.on([
                                "initialized"
                            ], function() {
                                return n.sync();
                            });
                        }
                    },
                    {
                        key: "save",
                        value: function save(t) {
                            this.enableLocalStorage ? a[this.getKey()] = s.stringify(t) : r.default.write(this.getKey(), s.stringify(t), this.duration);
                        }
                    },
                    {
                        key: "retrieve",
                        value: function retrieve() {
                            var t = null;
                            return (t = this.enableLocalStorage ? a[this.getKey()] : r.default.read(this.getKey())) ? s.parse(t) : null;
                        }
                    },
                    {
                        key: "remove",
                        value: function remove() {
                            this.enableLocalStorage ? a.removeItem(this.getKey()) : r.default.remove(this.getKey());
                        }
                    },
                    {
                        key: "sync",
                        value: function sync() {
                            var t = this.retrieve();
                            t && this.state.overrideAndSync(t);
                        }
                    },
                    {
                        key: "getKey",
                        value: function getKey() {
                            return s.stringify({
                                key: "".concat(this.tf.prfxTf, "_").concat(this.tf.id),
                                path: o.pathname
                            });
                        }
                    },
                    {
                        key: "destroy",
                        value: function destroy() {
                            var n = this;
                            this.emitter.off([
                                "state-changed"
                            ], function(t, e) {
                                return n.save(e);
                            }), this.emitter.off([
                                "initialized"
                            ], function() {
                                return n.sync();
                            }), this.remove(), this.state = null, this.emitter = null;
                        }
                    }
                ]), Storage;
            }();
        },
        function(t, e) {
            var n;
            n = function() {
                return this;
            }();
            try {
                n = n || new Function("return this")();
            } catch (t) {
                "object" == typeof window && (n = window);
            }
            t.exports = n;
        },
        function(t, e, n) {
            "use strict";
            var r = n(61)({
                mdy: !0,
                firstDayOfWeek: 0,
                firstDayOfWeekYear: 1,
                short: "{MM}/{dd}/{yyyy}",
                medium: "{Month} {d}, {yyyy}",
                long: "{Month} {d}, {yyyy} {time}",
                full: "{Weekday}, {Month} {d}, {yyyy} {time}",
                stamp: "{Dow} {Mon} {d} {yyyy} {time}",
                time: "{h}:{mm} {TT}"
            });
            t.exports = r;
        },
        function(t, e, n) {
            "use strict";
            t.exports = {
                year: {
                    base: "yyyy|ayy",
                    requiresSuffix: !0
                },
                month: {
                    base: "MM",
                    requiresSuffix: !0
                },
                date: {
                    base: "dd",
                    requiresSuffix: !0
                },
                hour: {
                    base: "hh",
                    requiresSuffixOr: ":"
                },
                minute: {
                    base: "mm"
                },
                second: {
                    base: "ss"
                },
                num: {
                    src: "\\d+",
                    requiresNumerals: !0
                }
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = function map(t, e) {
                for(var n = [], r = 0, i = t.length; r < i; r++)r in t && n.push(e(t[r], r));
                return n;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(16).classToString;
            t.exports = function isClass(t, e, n) {
                return (n = n || r(t)) === "[object " + e + "]";
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = function getRegNonCapturing(t, e) {
                return 1 < t.length && (t = "(?:" + t + ")"), e && (t += "?"), t;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(35), i = n(36), s = n(23);
            t.exports = function getDaysInMonth(t) {
                return 32 - s(new Date(r(t), i(t), 32), "Date");
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = String.fromCharCode;
        },
        function(t, e, n) {
            "use strict";
            var r = n(15), i = r.abs, s = r.pow, a = r.round;
            t.exports = function withPrecision(t, e, n) {
                var r = s(10, i(e || 0));
                return e < 0 && (r = 1 / r), (n = n || a)(t * r) / r;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(15), s = n(64), a = r.abs;
            t.exports = function getAdjustedUnit(t, n) {
                var r = 0, i = 0;
                return s(function(t, e) {
                    if (1 <= (i = a(n(t)))) return r = e, !1;
                }), [
                    i,
                    r,
                    t
                ];
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = 6e4;
        },
        function(t, e, n) {
            "use strict";
            var r = n(13), i = n(37), s = r.HOURS_INDEX;
            t.exports = function resetTime(t) {
                return i(t, s);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(34), i = n(43);
            t.exports = function walkUnitDown(t, e) {
                for(; 0 <= t && !1 !== e(r[t], t);)t = i(t);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(62), i = n(40), s = n(39), a = n(165), o = n(35), u = n(36), c = n(166), l = n(41), f = n(24), d = n(29), h = n(12), p = n(108), m = h.isNumber, y = r.ISO_FIRST_DAY_OF_WEEK, g = r.ISO_FIRST_DAY_OF_WEEK_YEAR;
            t.exports = function setISOWeekNumber(t, e) {
                if (m(e)) {
                    var n = l(t), r = f(t);
                    p(n, y, g), s(n, i(n) + 7 * (e - 1)), a(t, o(n)), c(t, u(n)), s(t, i(n)), d(t, r || 7);
                }
                return t.getTime();
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(13), i = n(39), s = n(37), a = n(67), o = r.MONTH_INDEX;
            t.exports = function moveToFirstDayOfWeekYear(t, e, n) {
                s(t, o), i(t, n), a(t, e);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(168);
            t.exports = function getDateParamKey(t, e) {
                return r(t, e) || r(t, e + "s") || "day" === e && r(t, "date");
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(29), i = n(24), s = n(15).ceil;
            t.exports = function moveToEndOfWeek(t, e) {
                var n = e - 1;
                return r(t, 7 * s((i(t) - n) / 7) + n), t;
            };
        },
        function(t, e, n) {
            "use strict";
            var p = n(104), m = n(34), r = n(13), y = n(25), g = n(53), b = n(41), v = n(33), O = n(45), _ = n(46), C = n(56), w = n(65), x = n(57), k = r.MONTH_INDEX;
            t.exports = function compareDate(t, e, n, r, i) {
                var s, a, o, u, c, l, f, d = 0, h = 0;
                return y(t) && ((i = i || {}).fromUTC = !0, i.setUTC = !0), l = w(null, e, i, !0), 0 < n && (d = h = n, o = !0), !!_(l.date) && (l.set && l.set.specificity && ((v(l.set.edge) || v(l.set.shift)) && (a = !0, x(l.date, l.set.specificity, r)), c = a || l.set.specificity === k ? C(b(l.date), l.set.specificity, r).getTime() : function addSpecificUnit() {
                    var t = m[l.set.specificity];
                    return O(b(l.date), t.name, 1).getTime() - 1;
                }(), !o && v(l.set.sign) && l.set.specificity && (h = -(d = 50))), f = t.getTime(), u = l.date.getTime(), c = c || u, (s = function getTimezoneShift() {
                    return l.set && l.set.specificity ? 0 : (g(l.date) - g(t)) * p;
                }()) && (u -= s, c -= s), u - d <= f && f <= c + h);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(54), i = n(113);
            t.exports = function advanceDateWithArgs(t, e, n) {
                return e = i(e, !0), r(t, e[0], e[1], n);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(12), a = n(50), o = n(63), u = n(276), c = n(277), l = r.isNumber, f = r.isString;
            t.exports = function collectUpdateDateArguments(t, e) {
                var n, r, i = t[0], s = t[1];
                return e && f(i) ? (n = u(i), r = s) : l(i) && l(s) ? n = c(t) : (n = o(i) ? a(i) : i, r = s), [
                    n,
                    r
                ];
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(115), i = n(295), s = n(118), a = i.dateFormatMatcher;
            t.exports = function dateFormat(t, e, n) {
                return s(t), e = r[e] || e || "{long}", a(e, t, n);
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = {
                ISO8601: "{yyyy}-{MM}-{dd}T{HH}:{mm}:{ss}.{SSS}{Z}",
                RFC1123: "{Dow}, {dd} {Mon} {yyyy} {HH}:{mm}:{ss} {ZZ}",
                RFC1036: "{Weekday}, {dd}-{Mon}-{yy} {HH}:{mm}:{ss} {ZZ}"
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(23);
            t.exports = function getHours(t) {
                return r(t, "Hours");
            };
        },
        function(t, e, n) {
            "use strict";
            var i = n(25), s = n(26), a = n(53), o = n(70), u = n(15).abs;
            t.exports = function getUTCOffset(t, e) {
                var n, r = i(t) ? 0 : a(t);
                return n = !0 === e ? ":" : "", !r && e ? "Z" : o(s(-r / 60), 2, !0) + n + o(u(r % 60), 2);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(46);
            t.exports = function assertDateIsValid(t) {
                if (!r(t)) throw new TypeError("Date is not valid");
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(14), i = n(317), s = n(36), a = n(33), o = n(44), u = n(318), c = n(24), l = n(46), f = n(12), d = n(111), h = f.isString, p = r.English;
            t.exports = function fullCompareDate(t, e, n) {
                var r;
                if (l(t)) {
                    if (h(e)) switch(e = i(e).toLowerCase(), !0){
                        case "future" === e:
                            return t.getTime() > o().getTime();
                        case "past" === e:
                            return t.getTime() < o().getTime();
                        case "today" === e:
                            return u(t);
                        case "tomorrow" === e:
                            return u(t, 1);
                        case "yesterday" === e:
                            return u(t, -1);
                        case "weekday" === e:
                            return 0 < c(t) && c(t) < 6;
                        case "weekend" === e:
                            return 0 === c(t) || 6 === c(t);
                        case a(r = p.weekdayMap[e]):
                            return c(t) === r;
                        case a(r = p.monthMap[e]):
                            return s(t) === r;
                    }
                    return d(t, e, n);
                }
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(14), c = n(114), i = n(12), l = n(118), f = n(364), d = i.isFunction, h = r.localeManager;
            t.exports = function dateRelative(t, e, n, r) {
                var i, s, a, o, u;
                return l(t), u = d(n) ? n : (o = n, r), i = f(t, e), u && (s = u.apply(t, i.concat(h.get(o)))) ? c(t, s, o) : (0 === i[1] && (i[1] = 1, i[0] = 1), a = e ? "duration" : 0 < i[2] ? "future" : "past", h.get(o).getRelativeFormat(i, a));
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(12), i = n(122), s = r.isDate;
            t.exports = function cloneRangeMember(t) {
                return s(t) ? new Date(t.getTime()) : i(t);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(12).isDate;
            t.exports = function getRangeMemberPrimitiveValue(t) {
                return null == t ? t : r(t) ? t.getTime() : t.valueOf();
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(12), i = n(28), s = r.isDate, a = i.sugarDate;
            t.exports = function getDateForRange(t) {
                return s(t) ? t : null == t ? new Date : a.create ? a.create(t) : new Date(t);
            };
        },
        function(t, e, n) {
            "use strict";
            var s = n(125), a = n(38), o = n(23);
            t.exports = function incrementDate(t, e, n) {
                var r, i = s[n];
                return i ? r = new Date(t.getTime() + e * i) : (r = new Date(t), a(r, n, o(t, n) + e)), r;
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = {
                Hours: 36e5,
                Minutes: 6e4,
                Seconds: 1e3,
                Milliseconds: 1
            };
        },
        function(t, e, n) {
            "use strict";
            var i = n(393), r = n(12), s = n(68), a = r.isNumber;
            t.exports = function getDateIncrementObject(t) {
                var e, n, r;
                return a(t) ? [
                    t,
                    "Milliseconds"
                ] : (n = +(e = t.match(i))[1] || 1, (r = s(e[2].toLowerCase())).match(/hour|minute|second/i) ? r += "s" : "Year" === r ? r = "FullYear" : "Week" === r ? (r = "Date", n *= 7) : "Day" === r && (r = "Date"), [
                    n,
                    r
                ]);
            };
        },
        function(t, e, s) {
            "use strict";
            s.r(e), s.d(e, "TableFilter", function() {
                return r;
            });
            var u = s(5), l = s(2), Y = s(8), K = s(3), G = s(22), a = s(1), n = s(9), o = s(89), c = s(90), f = s(91), d = s(74), h = s(75), p = s(76), m = s(77), y = s(78), g = s(79), b = s(80), v = s(81), O = s(82), _ = s(83), C = s(84), w = s(85), x = s(86), k = s(87), j = s(18), q = s(4);
            function _typeof(t) {
                return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(t) {
                    return typeof t;
                } : function _typeof(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function _defineProperties(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            var S = n.root.document, P = [
                d.DateType,
                h.Help,
                p.State,
                v.MarkActiveColumns,
                m.GridLayout,
                y.Loader,
                g.HighlightKeyword,
                b.PopupFilter,
                O.RowsCounter,
                _.StatusBar,
                C.ClearButton,
                w.AlternateRows,
                x.NoResults,
                k.Paging,
                j.Toolbar
            ], r = function() {
                function TableFilter() {
                    var e, r = this;
                    !function _classCallCheck(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, TableFilter), this.id = null, this.version = "0.7.2", this.year = (new Date).getFullYear(), this.tbl = null, this.refRow = null, this.headersRow = null, this.cfg = {}, this.nbFilterableRows = 0, this.nbCells = null, this.hasConfig = !1, this.initialized = !1;
                    for(var t = arguments.length, n = new Array(t), i = 0; i < t; i++)n[i] = arguments[i];
                    if (n.forEach(function(t) {
                        "object" === _typeof(t) && "TABLE" === t.nodeName ? (r.tbl = t, r.id = t.id || "tf_".concat(Object(Y.uuid)()), r.tbl.id = r.id) : Object(K.isString)(t) ? (r.id = t, r.tbl = Object(l.elm)(t)) : Object(K.isNumber)(t) ? e = t : Object(K.isObj)(t) && (r.cfg = t, r.hasConfig = !0);
                    }), !this.tbl || "TABLE" !== this.tbl.nodeName) throw new Error("Could not instantiate TableFilter: HTML table\n                DOM element not found.");
                    if (0 === this.getRowsNb(!0)) throw new Error("Could not instantiate TableFilter: HTML table\n                requires at least 1 row.");
                    var s = this.cfg;
                    this.emitter = new o.Emitter, this.refRow = Object(K.isUndef)(e) ? 2 : e + 1, this.filterTypes = [].map.call((this.dom().rows[this.refRow] || this.dom().rows[0]).cells, function(t, e) {
                        var n = r.cfg["col_".concat(e)];
                        return n ? n.toLowerCase() : q.INPUT;
                    }), this.basePath = Object(a.defaultsStr)(s.base_path, "tablefilter/"), this.fltGrid = Object(a.defaultsBool)(s.grid, !0), this.gridLayout = Object(K.isObj)(s.grid_layout) || Boolean(s.grid_layout), this.filtersRowIndex = Object(a.defaultsNb)(s.filters_row_index, 0), this.headersRow = Object(a.defaultsNb)(s.headers_row_index, 0 === this.filtersRowIndex ? 1 : 0), this.fltCellTag = Object(a.defaultsStr)(s.filters_cell_tag, q.CELL_TAG), this.fltIds = [], this.validRowsIndex = [], this.stylePath = this.getStylePath(), this.stylesheet = this.getStylesheetPath(), this.stylesheetId = this.id + "_style", this.fltsRowCssClass = Object(a.defaultsStr)(s.flts_row_css_class, "fltrow"), this.enableIcons = Object(a.defaultsBool)(s.enable_icons, !0), this.alternateRows = Boolean(s.alternate_rows), this.colWidths = Object(a.defaultsArr)(s.col_widths, []), this.defaultColWidth = Object(a.defaultsNb)(s.default_col_width, 100), this.fltCssClass = Object(a.defaultsStr)(s.flt_css_class, "flt"), this.fltMultiCssClass = Object(a.defaultsStr)(s.flt_multi_css_class, "flt_multi"), this.fltSmallCssClass = Object(a.defaultsStr)(s.flt_small_css_class, "flt_s"), this.singleFltCssClass = Object(a.defaultsStr)((s.single_filter || {}).css_class, "single_flt"), this.enterKey = Object(a.defaultsBool)(s.enter_key, !0), this.onBeforeFilter = Object(a.defaultsFn)(s.on_before_filter, K.EMPTY_FN), this.onAfterFilter = Object(a.defaultsFn)(s.on_after_filter, K.EMPTY_FN), this.caseSensitive = Boolean(s.case_sensitive), this.hasExactMatchByCol = Object(K.isArray)(s.columns_exact_match), this.exactMatchByCol = this.hasExactMatchByCol ? s.columns_exact_match : [], this.exactMatch = Boolean(s.exact_match), this.ignoreDiacritics = s.ignore_diacritics, this.linkedFilters = Boolean(s.linked_filters), this.disableExcludedOptions = Boolean(s.disable_excluded_options), this.activeFilterId = null, this.hasExcludedRows = Boolean(Object(K.isArray)(s.exclude_rows) && 0 < s.exclude_rows.length), this.excludeRows = Object(a.defaultsArr)(s.exclude_rows, []), this.externalFltIds = Object(a.defaultsArr)(s.external_flt_ids, []), this.onFiltersLoaded = Object(a.defaultsFn)(s.on_filters_loaded, K.EMPTY_FN), this.singleFlt = Object(K.isObj)(s.single_filter) || Boolean(s.single_filter), this.singleFltExcludeCols = Object(K.isObj)(s.single_filter) && Object(K.isArray)(s.single_filter.exclude_cols) ? s.single_filter.exclude_cols : [], this.onRowValidated = Object(a.defaultsFn)(s.on_row_validated, K.EMPTY_FN), this.cellParser = Object(K.isObj)(s.cell_parser) && Object(K.isFn)(s.cell_parser.parse) && Object(K.isArray)(s.cell_parser.cols) ? s.cell_parser : {
                        cols: [],
                        parse: K.EMPTY_FN
                    }, this.watermark = s.watermark || "", this.isWatermarkArray = Object(K.isArray)(this.watermark), this.help = Object(K.isUndef)(s.help_instructions) ? void 0 : Object(K.isObj)(s.help_instructions) || Boolean(s.help_instructions), this.popupFilters = Object(K.isObj)(s.popup_filters) || Boolean(s.popup_filters), this.markActiveColumns = Object(K.isObj)(s.mark_active_columns) || Boolean(s.mark_active_columns), this.clearFilterText = Object(K.isArray)(s.clear_filter_text) ? s.clear_filter_text : Object(a.defaultsStr)(s.clear_filter_text, "Clear"), this.enableEmptyOption = Boolean(s.enable_empty_option), this.emptyText = Object(a.defaultsStr)(s.empty_text, "(Empty)"), this.enableNonEmptyOption = Boolean(s.enable_non_empty_option), this.nonEmptyText = Object(a.defaultsStr)(s.non_empty_text, "(Non empty)"), this.onSlcChange = Object(a.defaultsBool)(s.on_change, !0), this.sortSlc = !!Object(K.isUndef)(s.sort_select) || Object(a.defaultsArr)(s.sort_select, Boolean(s.sort_select)), this.sortFilterOptionsAsc = Object(a.defaultsArr)(s.sort_filter_options_asc, []), this.sortFilterOptionsDesc = Object(a.defaultsArr)(s.sort_filter_options_desc, []), this.loadFltOnDemand = Boolean(s.load_filters_on_demand), this.hasCustomOptions = Object(K.isObj)(s.custom_options), this.customOptions = s.custom_options, this.rgxOperator = Object(a.defaultsStr)(s.regexp_operator, "rgx:"), this.emOperator = Object(a.defaultsStr)(s.empty_operator, "[empty]"), this.nmOperator = Object(a.defaultsStr)(s.nonempty_operator, "[nonempty]"), this.orOperator = Object(a.defaultsStr)(s.or_operator, "||"), this.anOperator = Object(a.defaultsStr)(s.and_operator, "&&"), this.grOperator = Object(a.defaultsStr)(s.greater_operator, ">"), this.lwOperator = Object(a.defaultsStr)(s.lower_operator, "<"), this.leOperator = Object(a.defaultsStr)(s.lower_equal_operator, "<="), this.geOperator = Object(a.defaultsStr)(s.greater_equal_operator, ">="), this.dfOperator = Object(a.defaultsStr)(s.different_operator, "!"), this.lkOperator = Object(a.defaultsStr)(s.like_operator, "*"), this.eqOperator = Object(a.defaultsStr)(s.equal_operator, "="), this.stOperator = Object(a.defaultsStr)(s.start_with_operator, "{"), this.enOperator = Object(a.defaultsStr)(s.end_with_operator, "}"), this.separator = Object(a.defaultsStr)(s.separator, ","), this.rowsCounter = Object(K.isObj)(s.rows_counter) || Boolean(s.rows_counter), this.statusBar = Object(K.isObj)(s.status_bar) || Boolean(s.status_bar), this.loader = Object(K.isObj)(s.loader) || Boolean(s.loader), this.displayBtn = Boolean(s.btn), this.btnText = Object(a.defaultsStr)(s.btn_text, this.enableIcons ? "" : "Go"), this.btnCssClass = Object(a.defaultsStr)(s.btn_css_class, this.enableIcons ? "btnflt_icon" : "btnflt"), this.btnReset = Object(K.isObj)(s.btn_reset) || Boolean(s.btn_reset), this.onBeforeReset = Object(a.defaultsFn)(s.on_before_reset, K.EMPTY_FN), this.onAfterReset = Object(a.defaultsFn)(s.on_after_reset, K.EMPTY_FN), this.paging = Object(K.isObj)(s.paging) || Boolean(s.paging), this.nbHiddenRows = 0, this.autoFilter = Object(K.isObj)(s.auto_filter) || Boolean(s.auto_filter), this.autoFilterDelay = Object(K.isObj)(s.auto_filter) && Object(K.isNumber)(s.auto_filter.delay) ? s.auto_filter.delay : q.AUTO_FILTER_DELAY, this.isUserTyping = null, this.autoFilterTimer = null, this.highlightKeywords = Boolean(s.highlight_keywords), this.noResults = Object(K.isObj)(s.no_results_message) || Boolean(s.no_results_message), this.state = Object(K.isObj)(s.state) || Boolean(s.state), this.dateType = !0, this.locale = Object(a.defaultsStr)(s.locale, "en"), this.thousandsSeparator = Object(a.defaultsStr)(s.thousands_separator, ","), this.decimalSeparator = Object(a.defaultsStr)(s.decimal_separator, "."), this.colTypes = Object(K.isArray)(s.col_types) ? s.col_types : [], this.prfxTf = "TF", this.prfxFlt = "flt", this.prfxValButton = "btn", this.prfxResponsive = "resp", this.stickyCssClass = "sticky", this.extensions = Object(a.defaultsArr)(s.extensions, []), this.enableDefaultTheme = Boolean(s.enable_default_theme), this.hasThemes = this.enableDefaultTheme || Object(K.isArray)(s.themes), this.themes = Object(a.defaultsArr)(s.themes, []), this.themesPath = this.getThemesPath(), this.responsive = Boolean(s.responsive), this.toolbar = Object(K.isObj)(s.toolbar) || Boolean(s.toolbar), this.stickyHeaders = Boolean(s.sticky_headers), this.Mod = {}, this.ExtRegistry = {}, this.instantiateFeatures(P);
                }
                return function _createClass(t, e, n) {
                    return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
                }(TableFilter, [
                    {
                        key: "init",
                        value: function init() {
                            var n = this;
                            if (!this.initialized) {
                                this.import(this.stylesheetId, this.getStylesheetPath(), null, "link");
                                var t, e = this.Mod;
                                if (this.loadThemes(), this.initFeatures([
                                    d.DateType,
                                    h.Help,
                                    p.State,
                                    v.MarkActiveColumns,
                                    m.GridLayout,
                                    y.Loader,
                                    g.HighlightKeyword,
                                    b.PopupFilter
                                ]), this.fltGrid) {
                                    var r = this._insertFiltersRow();
                                    this.nbCells = this.getCellsNb(this.refRow), this.nbFilterableRows = this.getRowsNb();
                                    for(var i = this.singleFlt ? 1 : this.nbCells, s = 0; s < i; s++){
                                        this.emitter.emit("before-filter-init", this, s);
                                        var a = Object(l.createElm)(this.fltCellTag), o = this.getFilterType(s);
                                        this.singleFlt && (a.colSpan = this.nbCells), this.gridLayout || r.appendChild(a), t = s === i - 1 && this.displayBtn ? this.fltSmallCssClass : this.fltCssClass, this.singleFlt && (o = q.INPUT, t = this.singleFltCssClass), o === q.SELECT || o === q.MULTIPLE ? (e.dropdown = e.dropdown || new c.Dropdown(this), e.dropdown.init(s, this.isExternalFlt(), a)) : o === q.CHECKLIST ? (e.checkList = e.checkList || new f.CheckList(this), e.checkList.init(s, this.isExternalFlt(), a)) : this._buildInputFilter(s, t, a), s === i - 1 && this.displayBtn && this._buildSubmitButton(this.isExternalFlt() ? Object(l.elm)(this.externalFltIds[s]) : a), this.emitter.emit("after-filter-init", this, s);
                                    }
                                    this.emitter.on([
                                        "filter-focus"
                                    ], function(t, e) {
                                        return n.setActiveFilterId(e.id);
                                    });
                                } else this._initNoFilters();
                                this.hasExcludedRows && (this.emitter.on([
                                    "after-filtering"
                                ], function() {
                                    return n.setExcludeRows();
                                }), this.setExcludeRows()), this.initFeatures([
                                    O.RowsCounter,
                                    _.StatusBar,
                                    C.ClearButton,
                                    w.AlternateRows,
                                    x.NoResults,
                                    k.Paging,
                                    j.Toolbar
                                ]), this.setColWidths(), this.gridLayout || (Object(l.addClass)(this.dom(), this.prfxTf), this.responsive && Object(l.addClass)(this.dom(), this.prfxResponsive), 0 < this.colWidths.length && this.setFixedLayout(), this.stickyHeaders && this.dom().tHead && Object(l.addClass)(this.dom(), this.stickyCssClass)), this.initExtensions(), this.initialized = !0, this.onFiltersLoaded(this), this.emitter.emit("initialized", this);
                            }
                        }
                    },
                    {
                        key: "detectKey",
                        value: function detectKey(t) {
                            this.enterKey && (Object(u.isKeyPressed)(t, [
                                q.ENTER_KEY
                            ]) ? (this.filter(), Object(u.cancelEvt)(t), Object(u.stopEvt)(t)) : (this.isUserTyping = !0, n.root.clearInterval(this.autoFilterTimer), this.autoFilterTimer = null));
                        }
                    },
                    {
                        key: "onKeyUp",
                        value: function onKeyUp(t) {
                            if (this.autoFilter) {
                                if (this.isUserTyping = !1, Object(u.isKeyPressed)(t, [
                                    q.ENTER_KEY,
                                    q.TAB_KEY,
                                    q.ESC_KEY,
                                    q.UP_ARROW_KEY,
                                    q.DOWN_ARROW_KEY
                                ])) n.root.clearInterval(this.autoFilterTimer), this.autoFilterTimer = null;
                                else {
                                    if (null !== this.autoFilterTimer) return;
                                    this.autoFilterTimer = n.root.setInterval((function filter() {
                                        n.root.clearInterval(this.autoFilterTimer), this.autoFilterTimer = null, this.isUserTyping || (this.filter(), this.isUserTyping = null);
                                    }).bind(this), this.autoFilterDelay);
                                }
                            }
                        }
                    },
                    {
                        key: "onKeyDown",
                        value: function onKeyDown() {
                            this.autoFilter && (this.isUserTyping = !0);
                        }
                    },
                    {
                        key: "onInpFocus",
                        value: function onInpFocus(t) {
                            var e = Object(u.targetEvt)(t);
                            this.emitter.emit("filter-focus", this, e);
                        }
                    },
                    {
                        key: "onInpBlur",
                        value: function onInpBlur() {
                            this.autoFilter && (this.isUserTyping = !1, n.root.clearInterval(this.autoFilterTimer)), this.emitter.emit("filter-blur", this);
                        }
                    },
                    {
                        key: "_insertFiltersRow",
                        value: function _insertFiltersRow() {
                            if (!this.gridLayout) {
                                var t, e = Object(l.tag)(this.dom(), "thead");
                                return (t = 0 < e.length ? e[0].insertRow(this.filtersRowIndex) : this.dom().insertRow(this.filtersRowIndex)).className = this.fltsRowCssClass, this.isExternalFlt() && (t.style.display = q.NONE), this.emitter.emit("filters-row-inserted", this, t), t;
                            }
                        }
                    },
                    {
                        key: "_initNoFilters",
                        value: function _initNoFilters() {
                            this.fltGrid || (this.refRow = 0 < this.refRow ? this.refRow - 1 : 0, this.nbFilterableRows = this.getRowsNb());
                        }
                    },
                    {
                        key: "_buildInputFilter",
                        value: function _buildInputFilter(t, e, n) {
                            var r = this, i = this.getFilterType(t), s = this.isExternalFlt() ? this.externalFltIds[t] : null, a = i === q.INPUT ? "text" : "hidden", o = Object(l.createElm)(q.INPUT, [
                                "id",
                                this.buildFilterId(t)
                            ], [
                                "type",
                                a
                            ], [
                                "ct",
                                t
                            ]);
                            "hidden" != a && this.watermark && o.setAttribute("placeholder", this.isWatermarkArray ? this.watermark[t] || "" : this.watermark), o.className = e || this.fltCssClass, Object(u.addEvt)(o, "focus", function(t) {
                                return r.onInpFocus(t);
                            }), s ? Object(l.elm)(s).appendChild(o) : n.appendChild(o), this.fltIds.push(o.id), Object(u.addEvt)(o, "keypress", function(t) {
                                return r.detectKey(t);
                            }), Object(u.addEvt)(o, "keydown", function() {
                                return r.onKeyDown();
                            }), Object(u.addEvt)(o, "keyup", function(t) {
                                return r.onKeyUp(t);
                            }), Object(u.addEvt)(o, "blur", function() {
                                return r.onInpBlur();
                            });
                        }
                    },
                    {
                        key: "_buildSubmitButton",
                        value: function _buildSubmitButton(t) {
                            var e = this, n = Object(l.createElm)(q.INPUT, [
                                "type",
                                "button"
                            ], [
                                "value",
                                this.btnText
                            ]);
                            n.className = this.btnCssClass, t.appendChild(n), Object(u.addEvt)(n, "click", function() {
                                return e.filter();
                            });
                        }
                    },
                    {
                        key: "instantiateFeatures",
                        value: function instantiateFeatures(t) {
                            var o = this;
                            (0 < arguments.length && void 0 !== t ? t : []).forEach(function(t) {
                                var e = t;
                                e.meta = e.meta || {
                                    name: null,
                                    altName: null
                                }, e.meta.name = Object(Y.toCamelCase)(e.name);
                                var n = e.meta, r = n.name, i = n.altName, s = n.alwaysInstantiate, a = i || r;
                                o.hasConfig && !0 !== o[a] && !Boolean(s) || (o.Mod[r] = o.Mod[r] || new e(o));
                            });
                        }
                    },
                    {
                        key: "initFeatures",
                        value: function initFeatures(t) {
                            var i = this;
                            (0 < arguments.length && void 0 !== t ? t : []).forEach(function(t) {
                                var e = t.meta, n = e.name, r = e.altName;
                                !0 === i[r || n] && i.Mod[n] && i.Mod[n].init();
                            });
                        }
                    },
                    {
                        key: "feature",
                        value: function feature(t) {
                            return this.Mod[t];
                        }
                    },
                    {
                        key: "initExtensions",
                        value: function initExtensions() {
                            var e = this, t = this.extensions;
                            0 !== t.length && (s.p = this.basePath, this.emitter.emit("before-loading-extensions", this), t.forEach(function(t) {
                                e.loadExtension(t);
                            }), this.emitter.emit("after-loading-extensions", this));
                        }
                    },
                    {
                        key: "loadExtension",
                        value: function loadExtension(n) {
                            var r = this;
                            if (n && n.name && !this.hasExtension(n.name)) {
                                var e, i = n.name, t = n.path;
                                e = i && t ? n.path + i : (i = i.replace(".js", ""), "extensions/{}/{}".replace(/{}/g, i)), s.e(1).then(function() {
                                    var t = [
                                        s(440)("./" + e)
                                    ];
                                    (function(t) {
                                        var e = new t.default(r, n);
                                        e.init(), r.ExtRegistry[i] = e;
                                    }).apply(null, t);
                                }).catch(s.oe);
                            }
                        }
                    },
                    {
                        key: "extension",
                        value: function extension(t) {
                            return this.ExtRegistry[t];
                        }
                    },
                    {
                        key: "hasExtension",
                        value: function hasExtension(t) {
                            return !Object(K.isEmpty)(this.ExtRegistry[t]);
                        }
                    },
                    {
                        key: "registerExtension",
                        value: function registerExtension(t, e) {
                            this.ExtRegistry[e] = t;
                        }
                    },
                    {
                        key: "destroyExtensions",
                        value: function destroyExtensions() {
                            var e = this.ExtRegistry;
                            Object.keys(e).forEach(function(t) {
                                e[t].destroy(), e[t] = void 0;
                            });
                        }
                    },
                    {
                        key: "loadThemes",
                        value: function loadThemes() {
                            var s = this;
                            if (this.hasThemes) {
                                var t = this.themes;
                                if (this.emitter.emit("before-loading-themes", this), this.enableDefaultTheme) this.themes.push({
                                    name: "default"
                                });
                                t.forEach(function(t, e) {
                                    var n = t.name, r = t.path, i = s.prfxTf + n;
                                    n && !r ? r = s.themesPath + n + "/" + n + ".css" : !n && t.path && (n = "theme{0}".replace("{0}", e)), s.isImported(r, "link") || s.import(i, r, null, "link");
                                }), this.loader = !0, this.emitter.emit("after-loading-themes", this);
                            }
                        }
                    },
                    {
                        key: "getStylesheet",
                        value: function getStylesheet(t) {
                            var e = 0 < arguments.length && void 0 !== t ? t : "default";
                            return Object(l.elm)(this.prfxTf + e);
                        }
                    },
                    {
                        key: "destroy",
                        value: function destroy() {
                            var n = this;
                            if (this.initialized) {
                                var t = this.emitter;
                                this.isExternalFlt() && !this.popupFilters && this.removeExternalFlts(), this.destroyExtensions(), this.validateAllRows(), t.emit("destroy", this), this.fltGrid && !this.gridLayout && this.dom().deleteRow(this.filtersRowIndex), this.hasExcludedRows && t.off([
                                    "after-filtering"
                                ], function() {
                                    return n.setExcludeRows();
                                }), this.emitter.off([
                                    "filter-focus"
                                ], function(t, e) {
                                    return n.setActiveFilterId(e.id);
                                }), Object(l.removeClass)(this.dom(), this.prfxTf), Object(l.removeClass)(this.dom(), this.prfxResponsive), this.dom().tHead && Object(l.removeClass)(this.dom().tHead, this.stickyCssClass), this.nbHiddenRows = 0, this.validRowsIndex = [], this.fltIds = [], this.initialized = !1;
                            }
                        }
                    },
                    {
                        key: "removeExternalFlts",
                        value: function removeExternalFlts() {
                            this.isExternalFlt() && this.externalFltIds.forEach(function(t) {
                                var e = Object(l.elm)(t);
                                e && (e.innerHTML = "");
                            });
                        }
                    },
                    {
                        key: "isCustomOptions",
                        value: function isCustomOptions(t) {
                            return this.hasCustomOptions && -1 !== this.customOptions.cols.indexOf(t);
                        }
                    },
                    {
                        key: "getCustomOptions",
                        value: function getCustomOptions(t) {
                            if (!Object(K.isEmpty)(t) && this.isCustomOptions(t)) {
                                for(var e = this.customOptions, n = [], r = [], i = e.cols.indexOf(t), s = e.values[i], a = e.texts[i], o = e.sorts[i], u = 0, c = s.length; u < c; u++)r.push(s[u]), a[u] ? n.push(a[u]) : n.push(s[u]);
                                return o && (r.sort(), n.sort()), [
                                    r,
                                    n
                                ];
                            }
                        }
                    },
                    {
                        key: "filter",
                        value: function filter() {
                            var v = this;
                            if (this.fltGrid && this.initialized) {
                                var O = this.emitter;
                                this.onBeforeFilter(this), O.emit("before-filtering", this);
                                var _ = 0;
                                this.validRowsIndex = [];
                                var C = this.getFiltersValue();
                                this.eachRow()(function(t, e) {
                                    t.style.display = "";
                                    for(var n = t.cells, r = n.length, i = [], s = !0, a = !1, o = 0; o < r; o++){
                                        var u = C[v.singleFlt ? 0 : o];
                                        if ("" !== u) {
                                            var c = Object(Y.matchCase)(v.getCellValue(n[o]), v.caseSensitive), l = u.toString().split(v.orOperator), f = 1 < l.length, d = u.toString().split(v.anOperator), h = 1 < d.length;
                                            if (Object(K.isArray)(u) || f || h) {
                                                for(var p = void 0, m = void 0, y = !1, g = 0, b = (m = Object(K.isArray)(u) ? u : f ? l : d).length; g < b && (p = Object(Y.trim)(m[g]), (y = v._match(p, c, n[o])) && O.emit("highlight-keyword", v, n[o], p), !(f && y || h && !y)) && (!Object(K.isArray)(u) || !y); g++);
                                                i[o] = y;
                                            } else i[o] = v._match(Object(Y.trim)(u), c, n[o]), i[o] && O.emit("highlight-keyword", v, n[o], u);
                                            i[o] || (s = !1), v.singleFlt && -1 === v.singleFltExcludeCols.indexOf(o) && i[o] && (a = !0), O.emit("cell-processed", v, o, n[o]);
                                        }
                                    }
                                    a && (s = !0), v.validateRow(e, s), s || _++, O.emit("row-processed", v, e, v.validRowsIndex.length - 1, s);
                                }, function(t) {
                                    return t.cells.length !== v.nbCells;
                                }), this.nbHiddenRows = _, this.onAfterFilter(this), O.emit("after-filtering", this, C);
                            }
                        }
                    },
                    {
                        key: "_match",
                        value: function _match(t, e, n) {
                            var r, i = n.cellIndex, s = this.getDecimal(i), a = new RegExp(this.leOperator), o = new RegExp(this.geOperator), u = new RegExp(this.lwOperator), c = new RegExp(this.grOperator), l = new RegExp(this.dfOperator), f = new RegExp(Object(Y.rgxEsc)(this.lkOperator)), d = new RegExp(this.eqOperator), h = new RegExp(this.stOperator), p = new RegExp(this.enOperator), m = this.emOperator, y = this.nmOperator, g = new RegExp(Object(Y.rgxEsc)(this.rgxOperator));
                            t = Object(Y.matchCase)(t, this.caseSensitive);
                            var b = !1, v = u.test(t), O = a.test(t), _ = c.test(t), C = o.test(t), w = l.test(t), x = d.test(t), k = f.test(t), j = h.test(t), S = p.test(t), P = m === t, E = y === t, T = g.test(t);
                            if (this.hasType(i, [
                                q.DATE
                            ])) {
                                var N, F, R = this.Mod.dateType, D = R.isValid.bind(R), I = R.parse.bind(R), A = R.getLocale(i), M = v && D(t.replace(u, ""), A), L = O && D(t.replace(a, ""), A), H = _ && D(t.replace(c, ""), A), z = C && D(t.replace(o, ""), A), B = w && D(t.replace(l, ""), A), W = x && D(t.replace(d, ""), A);
                                N = I(e, A), b = L ? N <= (F = I(t.replace(a, ""), A)) : M ? N < (F = I(t.replace(u, ""), A)) : z ? (F = I(t.replace(o, ""), A)) <= N : H ? (F = I(t.replace(c, ""), A)) < N : B ? (F = I(t.replace(l, ""), A), N.toString() !== F.toString()) : W ? (F = I(t.replace(d, ""), A), N.toString() === F.toString()) : f.test(t) ? Object(Y.contains)(t.replace(f, ""), e, !1, this.caseSensitive) : D(t) ? (F = I(t, A), N.toString() === F.toString()) : P ? !n.hasChildNodes() || Object(K.isEmpty)(e) : E ? n.hasChildNodes() && !Object(K.isEmpty)(e) : Object(Y.contains)(t, e, this.isExactMatch(i), this.caseSensitive);
                            } else if (r = Object(G.parse)(e, s) || Number(e), T) try {
                                var U = t.replace(g, "");
                                b = new RegExp(U).test(e);
                            } catch (t) {
                                b = !1;
                            }
                            else if (O) b = r <= Object(G.parse)(t.replace(a, ""), s);
                            else if (C) b = r >= Object(G.parse)(t.replace(o, ""), s);
                            else if (v) b = r < Object(G.parse)(t.replace(u, ""), s);
                            else if (_) b = r > Object(G.parse)(t.replace(c, ""), s);
                            else if (w) b = !Object(Y.contains)(t.replace(l, ""), e, !1, this.caseSensitive);
                            else if (k) b = Object(Y.contains)(t.replace(f, ""), e, !1, this.caseSensitive);
                            else if (x) b = Object(Y.contains)(t.replace(d, ""), e, !0, this.caseSensitive);
                            else if (j) b = 0 === e.indexOf(t.replace(h, ""));
                            else if (S) {
                                var V = t.replace(p, "");
                                b = e.lastIndexOf(V, e.length - 1) === e.length - 1 - (V.length - 1) && -1 < e.lastIndexOf(V, e.length - 1);
                            } else b = P ? !n.hasChildNodes() || Object(K.isEmpty)(e) : E ? n.hasChildNodes() && !Object(K.isEmpty)(e) : r && this.hasType(i, [
                                q.NUMBER,
                                q.FORMATTED_NUMBER
                            ]) && !this.singleFlt ? r === (t = Object(G.parse)(t, s) || t) || Object(Y.contains)(t.toString(), r.toString(), this.isExactMatch(i), this.caseSensitive) : Object(Y.contains)(t, e, this.isExactMatch(i), this.caseSensitive, this.ignoresDiacritics(i));
                            return b;
                        }
                    },
                    {
                        key: "getColumnData",
                        value: function getColumnData(t, e, n) {
                            var r = 1 < arguments.length && void 0 !== e && e, i = 2 < arguments.length && void 0 !== n ? n : [];
                            return this.getColValues(t, r, !0, i);
                        }
                    },
                    {
                        key: "getColumnValues",
                        value: function getColumnValues(t, e, n) {
                            var r = 1 < arguments.length && void 0 !== e && e, i = 2 < arguments.length && void 0 !== n ? n : [];
                            return this.getColValues(t, r, !1, i);
                        }
                    },
                    {
                        key: "getColValues",
                        value: function getColValues(s, t, e, n) {
                            var a = this, r = 1 < arguments.length && void 0 !== t && t, o = 3 < arguments.length && void 0 !== n ? n : [], u = [], c = 2 < arguments.length && void 0 !== e && e ? this.getCellData.bind(this) : this.getCellValue.bind(this);
                            return r && u.push(this.getHeadersText()[s]), this.eachRow()(function(t, e) {
                                var n = -1 !== o.indexOf(e), r = t.cells;
                                if (r.length === a.nbCells && !n) {
                                    var i = c(r[s]);
                                    u.push(i);
                                }
                            }), u;
                        }
                    },
                    {
                        key: "getFilterValue",
                        value: function getFilterValue(t) {
                            if (this.fltGrid) {
                                var e = "", n = this.getFilterElement(t);
                                if (!n) return e;
                                var r = this.getFilterType(t);
                                return r !== q.MULTIPLE && r !== q.CHECKLIST ? e = n.value : r === q.MULTIPLE ? e = this.feature("dropdown").getValues(t) : r === q.CHECKLIST && (e = this.feature("checkList").getValues(t)), (Object(K.isArray)(e) && 0 === e.length || 1 === e.length && "" === e[0]) && (e = ""), e;
                            }
                        }
                    },
                    {
                        key: "getFiltersValue",
                        value: function getFiltersValue() {
                            var r = this;
                            if (this.fltGrid) {
                                var i = [];
                                return this.fltIds.forEach(function(t, e) {
                                    var n = r.getFilterValue(e);
                                    Object(K.isArray)(n) ? i.push(n) : i.push(Object(Y.trim)(n));
                                }), i;
                            }
                        }
                    },
                    {
                        key: "getFilterId",
                        value: function getFilterId(t) {
                            if (this.fltGrid) return this.fltIds[t];
                        }
                    },
                    {
                        key: "getFiltersByType",
                        value: function getFiltersByType(t, e) {
                            if (this.fltGrid) {
                                for(var n = [], r = 0, i = this.fltIds.length; r < i; r++)if (this.getFilterType(r) === t.toLowerCase()) {
                                    var s = e ? r : this.fltIds[r];
                                    n.push(s);
                                }
                                return n;
                            }
                        }
                    },
                    {
                        key: "getFilterElement",
                        value: function getFilterElement(t) {
                            return Object(l.elm)(this.fltIds[t]);
                        }
                    },
                    {
                        key: "getCellsNb",
                        value: function getCellsNb(t) {
                            var e = 0 < arguments.length && void 0 !== t ? t : 0, n = this.dom().rows[0 <= e ? e : 0];
                            return n ? n.cells.length : 0;
                        }
                    },
                    {
                        key: "getRowsNb",
                        value: function getRowsNb(t) {
                            var e = this.getWorkingRows().length;
                            return this.dom().tHead ? t ? e + this.dom().querySelectorAll("thead > tr").length : e : t ? e : e - this.refRow;
                        }
                    },
                    {
                        key: "getWorkingRows",
                        value: function getWorkingRows() {
                            return S.querySelectorAll("table#".concat(this.id, " > tbody > tr"));
                        }
                    },
                    {
                        key: "getCellValue",
                        value: function getCellValue(t) {
                            var e = t.cellIndex, n = this.cellParser;
                            return -1 !== n.cols.indexOf(e) ? n.parse(this, t, e) : Object(l.getText)(t);
                        }
                    },
                    {
                        key: "getCellData",
                        value: function getCellData(t) {
                            var e = t.cellIndex, n = this.getCellValue(t);
                            if (this.hasType(e, [
                                q.FORMATTED_NUMBER
                            ])) return Object(G.parse)(n, this.getDecimal(e));
                            if (this.hasType(e, [
                                q.NUMBER
                            ])) return Number(n);
                            if (this.hasType(e, [
                                q.DATE
                            ])) {
                                var r = this.Mod.dateType;
                                return r.parse(n, r.getLocale(e));
                            }
                            return n;
                        }
                    },
                    {
                        key: "getData",
                        value: function getData(t, e) {
                            var n = 0 < arguments.length && void 0 !== t && t, r = 1 < arguments.length && void 0 !== e && e;
                            return this.getTableData(n, r, !0);
                        }
                    },
                    {
                        key: "getValues",
                        value: function getValues(t, e) {
                            var n = 0 < arguments.length && void 0 !== t && t, r = 1 < arguments.length && void 0 !== e && e;
                            return this.getTableData(n, r, !1);
                        }
                    },
                    {
                        key: "getTableData",
                        value: function getTableData(t, e, n) {
                            var o = this, r = 0 < arguments.length && void 0 !== t && t, u = 1 < arguments.length && void 0 !== e && e, c = [], l = 2 < arguments.length && void 0 !== n && n ? this.getCellData.bind(this) : this.getCellValue.bind(this);
                            if (r) {
                                var i = this.getHeadersText(u);
                                c.push([
                                    this.getHeadersRowIndex(),
                                    i
                                ]);
                            }
                            return this.eachRow()(function(t, e) {
                                for(var n = [
                                    e,
                                    []
                                ], r = t.cells, i = 0, s = r.length; i < s; i++)if (!(u && o.hasExtension("colsVisibility") && o.extension("colsVisibility").isColHidden(i))) {
                                    var a = l(r[i]);
                                    n[1].push(a);
                                }
                                c.push(n);
                            }), c;
                        }
                    },
                    {
                        key: "getFilteredData",
                        value: function getFilteredData(t, e) {
                            var n = 0 < arguments.length && void 0 !== t && t, r = 1 < arguments.length && void 0 !== e && e;
                            return this.filteredData(n, r, !0);
                        }
                    },
                    {
                        key: "getFilteredValues",
                        value: function getFilteredValues(t, e) {
                            var n = 0 < arguments.length && void 0 !== t && t, r = 1 < arguments.length && void 0 !== e && e;
                            return this.filteredData(n, r, !1);
                        }
                    },
                    {
                        key: "filteredData",
                        value: function filteredData() {
                            var t = 0 < arguments.length && void 0 !== arguments[0] && arguments[0], e = 1 < arguments.length && void 0 !== arguments[1] && arguments[1], n = 2 < arguments.length && void 0 !== arguments[2] && arguments[2];
                            if (0 === this.validRowsIndex.length) return [];
                            var r = this.dom().rows, filteredData = [], i = n ? this.getCellData.bind(this) : this.getCellValue.bind(this);
                            if (t) {
                                var s = this.getHeadersText(e);
                                filteredData.push([
                                    this.getHeadersRowIndex(),
                                    s
                                ]);
                            }
                            for(var a = this.getValidRows(!0), o = 0; o < a.length; o++){
                                for(var u = [
                                    this.validRowsIndex[o],
                                    []
                                ], c = r[this.validRowsIndex[o]].cells, l = 0; l < c.length; l++)if (!(e && this.hasExtension("colsVisibility") && this.extension("colsVisibility").isColHidden(l))) {
                                    var f = i(c[l]);
                                    u[1].push(f);
                                }
                                filteredData.push(u);
                            }
                            return filteredData;
                        }
                    },
                    {
                        key: "getFilteredColumnData",
                        value: function getFilteredColumnData(t, e, n) {
                            var r = 1 < arguments.length && void 0 !== e && e, i = 2 < arguments.length && void 0 !== n ? n : [];
                            return this.getFilteredDataCol(t, r, !0, i, !1);
                        }
                    },
                    {
                        key: "getVisibleColumnData",
                        value: function getVisibleColumnData(t, e, n) {
                            var r = 1 < arguments.length && void 0 !== e && e, i = 2 < arguments.length && void 0 !== n ? n : [];
                            return this.getFilteredDataCol(t, r, !0, i, !0);
                        }
                    },
                    {
                        key: "getFilteredColumnValues",
                        value: function getFilteredColumnValues(t, e, n) {
                            var r = 1 < arguments.length && void 0 !== e && e, i = 2 < arguments.length && void 0 !== n ? n : [];
                            return this.getFilteredDataCol(t, r, !1, i, !1);
                        }
                    },
                    {
                        key: "getVisibleColumnValues",
                        value: function getVisibleColumnValues(t, e, n) {
                            var r = 1 < arguments.length && void 0 !== e && e, i = 2 < arguments.length && void 0 !== n ? n : [];
                            return this.getFilteredDataCol(t, r, !1, i, !0);
                        }
                    },
                    {
                        key: "getFilteredDataCol",
                        value: function getFilteredDataCol(e, t, n, r, i) {
                            var s = this, a = 1 < arguments.length && void 0 !== t && t, o = 2 < arguments.length && void 0 !== n && n, u = 3 < arguments.length && void 0 !== r ? r : [], c = !(4 < arguments.length && void 0 !== i) || i;
                            if (Object(K.isUndef)(e)) return [];
                            var l = this.dom().rows, f = o ? this.getCellData.bind(this) : this.getCellValue.bind(this), d = this.getValidRows(!0).filter(function(t) {
                                return -1 === u.indexOf(t) && (!c || "none" !== s.getRowDisplay(l[t]));
                            }).map(function(t) {
                                return f(l[t].cells[e]);
                            });
                            return a && d.unshift(this.getHeadersText()[e]), d;
                        }
                    },
                    {
                        key: "getRowDisplay",
                        value: function getRowDisplay(t) {
                            return t.style.display;
                        }
                    },
                    {
                        key: "validateRow",
                        value: function validateRow(t, e) {
                            var n = this.dom().rows[t];
                            if (n && Object(K.isBoolean)(e)) {
                                -1 !== this.excludeRows.indexOf(t) && (e = !0);
                                var r = e ? "" : q.NONE, i = e ? "true" : "false";
                                n.style.display = r, this.paging && n.setAttribute("validRow", i), e && (-1 === this.validRowsIndex.indexOf(t) && this.validRowsIndex.push(t), this.onRowValidated(this, t), this.emitter.emit("row-validated", this, t));
                            }
                        }
                    },
                    {
                        key: "validateAllRows",
                        value: function validateAllRows() {
                            if (this.initialized) {
                                this.validRowsIndex = [];
                                for(var t = this.refRow; t < this.nbFilterableRows; t++)this.validateRow(t, !0);
                            }
                        }
                    },
                    {
                        key: "setFilterValue",
                        value: function setFilterValue(t, e) {
                            var n = 1 < arguments.length && void 0 !== e ? e : "";
                            if (this.fltGrid) {
                                var r = this.getFilterElement(t), i = this.getFilterType(t);
                                if (r) {
                                    if (i === q.MULTIPLE) {
                                        var s = Object(K.isArray)(n) ? n : n.split(" " + this.orOperator + " ");
                                        this.loadFltOnDemand && !this.initialized && this.emitter.emit("build-select-filter", this, t, this.linkedFilters, this.isExternalFlt()), this.emitter.emit("select-options", this, t, s);
                                    } else if (i === q.CHECKLIST) {
                                        var a = [];
                                        this.loadFltOnDemand && !this.initialized && this.emitter.emit("build-checklist-filter", this, t, this.linkedFilters), a = Object(K.isArray)(n) ? n : (n = Object(Y.matchCase)(n, this.caseSensitive)).split(" " + this.orOperator + " "), this.emitter.emit("select-checklist-options", this, t, a);
                                    } else this.loadFltOnDemand && !this.initialized && this.emitter.emit("build-select-filter", this, t, this.linkedFilters, this.isExternalFlt()), r.value = n;
                                }
                            }
                        }
                    },
                    {
                        key: "setFixedLayout",
                        value: function setFixedLayout(t) {
                            var e = 0 < arguments.length && void 0 !== t ? t : this.dom(), n = this.colWidths, r = e.clientWidth;
                            if (0 < n.length) {
                                var i = this.defaultColWidth;
                                r = n.reduce(function(t, e) {
                                    return parseInt(t || i, 10) + parseInt(e || i, 10);
                                });
                            }
                            e.style.width = "".concat(r, "px"), e.style.tableLayout = "fixed";
                        }
                    },
                    {
                        key: "setColWidths",
                        value: function setColWidths(t) {
                            var e = 0 < arguments.length && void 0 !== t ? t : this.dom(), n = this.colWidths;
                            if (0 !== n.length) {
                                var r = Object(l.tag)(e, "col"), i = 0 < r.length, s = i ? null : S.createDocumentFragment();
                                this.eachCol(function(t) {
                                    var e;
                                    i ? e = r[t] : (e = Object(l.createElm)("col"), s.appendChild(e)), e.style.width = n[t];
                                }), i || e.insertBefore(s, e.firstChild);
                            }
                        }
                    },
                    {
                        key: "setExcludeRows",
                        value: function setExcludeRows() {
                            var e = this;
                            this.hasExcludedRows && this.excludeRows.forEach(function(t) {
                                return e.validateRow(t, !0);
                            });
                        }
                    },
                    {
                        key: "clearFilters",
                        value: function clearFilters() {
                            if (this.fltGrid) {
                                this.emitter.emit("before-clearing-filters", this), this.onBeforeReset(this, this.getFiltersValue());
                                for(var t = 0, e = this.fltIds.length; t < e; t++)this.setFilterValue(t, "");
                                this.filter(), this.onAfterReset(this), this.emitter.emit("after-clearing-filters", this);
                            }
                        }
                    },
                    {
                        key: "getActiveFilterId",
                        value: function getActiveFilterId() {
                            return this.activeFilterId;
                        }
                    },
                    {
                        key: "setActiveFilterId",
                        value: function setActiveFilterId(t) {
                            this.activeFilterId = t;
                        }
                    },
                    {
                        key: "getColumnIndexFromFilterId",
                        value: function getColumnIndexFromFilterId(t) {
                            var e = (0 < arguments.length && void 0 !== t ? t : "").split("_")[0];
                            return e = e.split(this.prfxFlt)[1], parseInt(e, 10);
                        }
                    },
                    {
                        key: "buildFilterId",
                        value: function buildFilterId(t) {
                            return "".concat(this.prfxFlt).concat(t, "_").concat(this.id);
                        }
                    },
                    {
                        key: "isExternalFlt",
                        value: function isExternalFlt() {
                            return 0 < this.externalFltIds.length;
                        }
                    },
                    {
                        key: "getStylePath",
                        value: function getStylePath() {
                            return Object(a.defaultsStr)(this.config.style_path, this.basePath + "style/");
                        }
                    },
                    {
                        key: "getStylesheetPath",
                        value: function getStylesheetPath() {
                            return Object(a.defaultsStr)(this.config.stylesheet, this.getStylePath() + "tablefilter.css");
                        }
                    },
                    {
                        key: "getThemesPath",
                        value: function getThemesPath() {
                            return Object(a.defaultsStr)(this.config.themes_path, this.getStylePath() + "themes/");
                        }
                    },
                    {
                        key: "activateFilter",
                        value: function activateFilter(t) {
                            Object(K.isUndef)(t) || this.setActiveFilterId(this.getFilterId(t));
                        }
                    },
                    {
                        key: "isExactMatch",
                        value: function isExactMatch(t) {
                            var e = this.getFilterType(t);
                            return this.exactMatchByCol[t] || this.exactMatch || e !== q.INPUT;
                        }
                    },
                    {
                        key: "isRowValid",
                        value: function isRowValid(t) {
                            return -1 !== this.getValidRows().indexOf(t);
                        }
                    },
                    {
                        key: "isRowDisplayed",
                        value: function isRowDisplayed(t) {
                            var e = this.dom().rows[t];
                            return "" === this.getRowDisplay(e);
                        }
                    },
                    {
                        key: "ignoresDiacritics",
                        value: function ignoresDiacritics(t) {
                            var e = this.ignoreDiacritics;
                            return Object(K.isArray)(e) ? e[t] : Boolean(e);
                        }
                    },
                    {
                        key: "getClearFilterText",
                        value: function getClearFilterText(t) {
                            var e = this.clearFilterText;
                            return Object(K.isArray)(e) ? e[t] : e;
                        }
                    },
                    {
                        key: "eachCol",
                        value: function eachCol(t, e, n) {
                            for(var r = 0 < arguments.length && void 0 !== t ? t : K.EMPTY_FN, i = 1 < arguments.length && void 0 !== e ? e : K.EMPTY_FN, s = 2 < arguments.length && void 0 !== n ? n : K.EMPTY_FN, a = this.getCellsNb(this.refRow), o = 0; o < a; o++)if (!0 !== i(o)) {
                                if (!0 === s(o)) break;
                                r(o);
                            }
                        }
                    },
                    {
                        key: "eachRow",
                        value: function eachRow(t) {
                            var a = this, o = 0 < arguments.length && void 0 !== t ? t : this.refRow;
                            return function() {
                                for(var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : K.EMPTY_FN, e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : K.EMPTY_FN, n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : K.EMPTY_FN, r = a.dom().rows, i = a.getRowsNb(!0), s = o; s < i; s++)if (!0 !== e(r[s], s)) {
                                    if (!0 === n(r[s], s)) break;
                                    t(r[s], s);
                                }
                            };
                        }
                    },
                    {
                        key: "isImported",
                        value: function isImported(t, e) {
                            for(var n = 1 < arguments.length && void 0 !== e ? e : "script", r = !1, i = "script" === n ? "src" : "href", s = Object(l.tag)(S, n), a = 0, o = s.length; a < o; a++)if (!Object(K.isUndef)(s[a][i]) && s[a][i].match(t)) {
                                r = !0;
                                break;
                            }
                            return r;
                        }
                    },
                    {
                        key: "import",
                        value: function _import(t, e, n, r) {
                            var i = this, s = 3 < arguments.length && void 0 !== r ? r : "script";
                            if (!this.isImported(e, s)) {
                                var a, o = this, u = !1, c = Object(l.tag)(S, "head")[0];
                                (a = "link" === s.toLowerCase() ? Object(l.createElm)("link", [
                                    "id",
                                    t
                                ], [
                                    "type",
                                    "text/css"
                                ], [
                                    "rel",
                                    "stylesheet"
                                ], [
                                    "href",
                                    e
                                ]) : Object(l.createElm)("script", [
                                    "id",
                                    t
                                ], [
                                    "type",
                                    "text/javascript"
                                ], [
                                    "src",
                                    e
                                ])).onload = a.onreadystatechange = function() {
                                    u || i.readyState && "loaded" !== i.readyState && "complete" !== i.readyState || (u = !0, "function" == typeof n && n.call(null, o));
                                }, a.onerror = function() {
                                    throw new Error("TableFilter could not load: ".concat(e));
                                }, c.appendChild(a);
                            }
                        }
                    },
                    {
                        key: "isInitialized",
                        value: function isInitialized() {
                            return this.initialized;
                        }
                    },
                    {
                        key: "getFiltersId",
                        value: function getFiltersId() {
                            return this.fltIds || [];
                        }
                    },
                    {
                        key: "getValidRows",
                        value: function getValidRows(t) {
                            var e = this;
                            return t && (this.validRowsIndex = [], this.eachRow()(function(t) {
                                e.paging ? "true" !== t.getAttribute("validRow") && null !== t.getAttribute("validRow") || e.validRowsIndex.push(t.rowIndex) : e.getRowDisplay(t) !== q.NONE && e.validRowsIndex.push(t.rowIndex);
                            })), this.validRowsIndex;
                        }
                    },
                    {
                        key: "getFiltersRowIndex",
                        value: function getFiltersRowIndex() {
                            return this.filtersRowIndex;
                        }
                    },
                    {
                        key: "getHeadersRowIndex",
                        value: function getHeadersRowIndex() {
                            return this.headersRow;
                        }
                    },
                    {
                        key: "getStartRowIndex",
                        value: function getStartRowIndex() {
                            return this.refRow;
                        }
                    },
                    {
                        key: "getLastRowIndex",
                        value: function getLastRowIndex() {
                            return this.getRowsNb(!0) - 1;
                        }
                    },
                    {
                        key: "hasType",
                        value: function hasType(t, e) {
                            var n = 1 < arguments.length && void 0 !== e ? e : [];
                            if (0 === this.colTypes.length) return !1;
                            var r = this.colTypes[t];
                            return Object(K.isObj)(r) && (r = r.type), -1 !== n.indexOf(r);
                        }
                    },
                    {
                        key: "getHeaderElement",
                        value: function getHeaderElement(t) {
                            var e, n = this.gridLayout ? this.Mod.gridLayout.headTbl : this.dom(), r = Object(l.tag)(n, "thead"), i = this.getHeadersRowIndex();
                            return 0 === r.length && (e = n.rows[i].cells[t]), 1 === r.length && (e = r[0].rows[i].cells[t]), e;
                        }
                    },
                    {
                        key: "getHeadersText",
                        value: function getHeadersText(t) {
                            var r = this, e = 0 < arguments.length && void 0 !== t && t, i = [];
                            return this.eachCol(function(t) {
                                var e = r.getHeaderElement(t), n = Object(l.getFirstTextNode)(e);
                                i.push(n);
                            }, function(t) {
                                return !(!e || !r.hasExtension("colsVisibility")) && r.extension("colsVisibility").isColHidden(t);
                            }), i;
                        }
                    },
                    {
                        key: "getFilterType",
                        value: function getFilterType(t) {
                            return this.filterTypes[t];
                        }
                    },
                    {
                        key: "getFilterableRowsNb",
                        value: function getFilterableRowsNb() {
                            return this.getRowsNb(!1);
                        }
                    },
                    {
                        key: "getValidRowsNb",
                        value: function getValidRowsNb(t) {
                            var e = 0 < arguments.length && void 0 !== t && t;
                            return this.getValidRows(e).length;
                        }
                    },
                    {
                        key: "dom",
                        value: function dom() {
                            return this.tbl;
                        }
                    },
                    {
                        key: "getDecimal",
                        value: function getDecimal(t) {
                            var e = this.decimalSeparator;
                            if (this.hasType(t, [
                                q.FORMATTED_NUMBER
                            ])) {
                                var n = this.colTypes[t];
                                n.hasOwnProperty("decimal") && (e = n.decimal);
                            }
                            return e;
                        }
                    },
                    {
                        key: "config",
                        value: function config() {
                            return this.cfg;
                        }
                    }
                ]), TableFilter;
            }();
        },
        function(t, e, n) {
            "use strict";
            n(11), n(156), n(175), n(177), n(178), n(179), n(180), n(181), n(186), n(187), n(188), n(189), n(190), n(191), n(192), n(193), n(194), n(195), n(196), n(197), n(198), n(199), n(200), n(201), n(202), n(203), n(204), n(205), n(206), n(207), n(208), n(209), n(210), n(211), n(212), n(213), n(214), n(215), n(216), n(217), n(218), n(219), n(220), n(221), n(222), n(223), n(224), n(225), n(226), n(227), n(228), n(229), n(230), n(231), n(232), n(233), n(234), n(235), n(236), n(237), n(238), n(239), n(240), n(241), n(242), n(243), n(244), n(245), n(246), n(247), n(248), n(249), n(250), n(251), n(252), n(253), n(254), n(255), n(256), n(257), n(258), n(259), n(260), n(261), n(262), n(263), n(264), n(265), n(266), n(268), n(269), n(270), n(271), n(272), n(273), n(274), n(275), n(278), n(279), n(280), n(281), n(282), n(283), n(284), n(285), n(286), n(287), n(288), n(289), n(290), n(291), n(292), n(293), n(294), n(306), n(308), n(309), n(310), n(311), n(312), n(313), n(314), n(315), n(316), n(319), n(320), n(321), n(322), n(324), n(325), n(326), n(327), n(328), n(329), n(330), n(331), n(332), n(333), n(334), n(335), n(336), n(337), n(338), n(339), n(340), n(341), n(342), n(343), n(345), n(346), n(347), n(348), n(349), n(350), n(351), n(352), n(353), n(354), n(355), n(356), n(357), n(358), n(359), n(360), n(361), n(362), n(363), n(365), n(366), n(368), n(369), n(370), n(371), n(372), n(373), n(374), n(375), n(376), n(377), n(378), n(379), n(380), n(381), n(382), n(383), n(384), n(385), n(386), t.exports = n(0);
        },
        function(t, e, n) {
            "use strict";
            var r = n(130), i = {
                "en-US": n(95),
                "en-GB": r,
                "en-AU": r,
                "en-CA": n(132)
            };
            t.exports = i;
        },
        function(t, e, n) {
            "use strict";
            var r = n(61)({
                short: "{dd}/{MM}/{yyyy}",
                medium: "{d} {Month} {yyyy}",
                long: "{d} {Month} {yyyy} {H}:{mm}",
                full: "{Weekday}, {d} {Month}, {yyyy} {time}",
                stamp: "{Dow} {d} {Mon} {yyyy} {time}"
            });
            t.exports = r;
        },
        function(t, e, n) {
            "use strict";
            t.exports = {
                code: "en",
                plural: !0,
                timeMarkers: "at",
                ampm: "AM|A.M.|a,PM|P.M.|p",
                units: "millisecond:|s,second:|s,minute:|s,hour:|s,day:|s,week:|s,month:|s,year:|s",
                months: "Jan:uary|,Feb:ruary|,Mar:ch|,Apr:il|,May,Jun:e|,Jul:y|,Aug:ust|,Sep:tember|t|,Oct:ober|,Nov:ember|,Dec:ember|",
                weekdays: "Sun:day|,Mon:day|,Tue:sday|,Wed:nesday|,Thu:rsday|,Fri:day|,Sat:urday|+weekend",
                numerals: "zero,one|first,two|second,three|third,four:|th,five|fifth,six:|th,seven:|th,eight:|h,nin:e|th,ten:|th",
                articles: "a,an,the",
                tokens: "the,st|nd|rd|th,of|in,a|an,on",
                time: "{H}:{mm}",
                past: "{num} {unit} {sign}",
                future: "{num} {unit} {sign}",
                duration: "{num} {unit}",
                modifiers: [
                    {
                        name: "half",
                        src: "half",
                        value: .5
                    },
                    {
                        name: "midday",
                        src: "noon",
                        value: 12
                    },
                    {
                        name: "midday",
                        src: "midnight",
                        value: 24
                    },
                    {
                        name: "day",
                        src: "yesterday",
                        value: -1
                    },
                    {
                        name: "day",
                        src: "today|tonight",
                        value: 0
                    },
                    {
                        name: "day",
                        src: "tomorrow",
                        value: 1
                    },
                    {
                        name: "sign",
                        src: "ago|before",
                        value: -1
                    },
                    {
                        name: "sign",
                        src: "from now|after|from|in|later",
                        value: 1
                    },
                    {
                        name: "edge",
                        src: "first day|first|beginning",
                        value: -2
                    },
                    {
                        name: "edge",
                        src: "last day",
                        value: 1
                    },
                    {
                        name: "edge",
                        src: "end|last",
                        value: 2
                    },
                    {
                        name: "shift",
                        src: "last",
                        value: -1
                    },
                    {
                        name: "shift",
                        src: "the|this",
                        value: 0
                    },
                    {
                        name: "shift",
                        src: "next",
                        value: 1
                    }
                ],
                parse: [
                    "(?:just)? now",
                    "{shift} {unit:5-7}",
                    "{months?} {year}",
                    "{midday} {4?} {day|weekday}",
                    "{months},?[-.\\/\\s]?{year?}",
                    "{edge} of (?:day)? {day|weekday}",
                    "{0} {num}{1?} {weekday} {2} {months},? {year?}",
                    "{shift?} {day?} {weekday?} (?:at)? {midday}",
                    "{sign?} {3?} {half} {3?} {unit:3-4|unit:7} {sign?}",
                    "{0?} {edge} {weekday?} {2} {shift?} {unit:4-7?} {months?},? {year?}"
                ],
                timeParse: [
                    "{day|weekday}",
                    "{shift} {unit:5?} {weekday}",
                    "{0?} {date}{1?} {2?} {months?}",
                    "{weekday} {2?} {shift} {unit:5}",
                    "{0?} {num} {2?} {months}\\.?,? {year?}",
                    "{num?} {unit:4-5} {sign} {day|weekday}",
                    "{0|months} {date?}{1?} of {shift} {unit:6-7}",
                    "{0?} {num}{1?} {weekday} of {shift} {unit:6}",
                    "{year?}[-.\\/\\s]?{months}[-.\\/\\s]{date}",
                    "{date}[-.\\/\\s]{months}(?:[-.\\/\\s]{year|yy})?",
                    "{weekday?}\\.?,? {months}\\.?,? {date}{1?},? {year?}",
                    "{weekday?}\\.?,? {date} {months} {year}"
                ],
                timeFrontParse: [
                    "{sign} {num} {unit}",
                    "{num} {unit} {sign}",
                    "{4?} {day|weekday}"
                ]
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(61)({
                short: "{yyyy}-{MM}-{dd}",
                medium: "{d} {Month}, {yyyy}",
                long: "{d} {Month}, {yyyy} {H}:{mm}",
                full: "{Weekday}, {d} {Month}, {yyyy} {time}",
                stamp: "{Dow} {d} {Mon} {yyyy} {time}"
            });
            t.exports = r;
        },
        function(t, e, n) {
            "use strict";
            var r = n(134), i = n(62), l = n(135), s = n(136), a = n(96), o = n(97), f = n(137), d = n(32), u = n(33), h = n(141), c = n(12), p = n(15), m = n(42), y = n(49), g = n(146), b = n(147), v = n(99), O = n(16), _ = n(64), C = n(150), w = n(152), x = n(154), k = n(155), j = O.hasOwn, S = O.getOwn, P = O.forEachProperty, E = w.fullWidthNumberMap, T = w.fullWidthNumbers, N = p.pow, F = p.max, R = i.ISO_FIRST_DAY_OF_WEEK, D = i.ISO_FIRST_DAY_OF_WEEK_YEAR, I = c.isString, A = c.isFunction;
            t.exports = function getNewLocale(t) {
                function Locale(t) {
                    this.init(t);
                }
                return Locale.prototype = {
                    getMonthName: function(t, e) {
                        return this.monthSuffix ? t + 1 + this.monthSuffix : b(this.months, t, e, 12);
                    },
                    getWeekdayName: function(t, e) {
                        return b(this.weekdays, t, e, 7);
                    },
                    parseValue: function(t, e) {
                        var n = this[e + "Map"];
                        return j(n, t) ? n[t] : this.parseNumber(t, e);
                    },
                    parseNumber: function(t, e) {
                        var n;
                        return j(this.numeralMap, t) && (n = this.numeralMap[t]), isNaN(n) && (n = this.parseRegularNumerals(t)), isNaN(n) && (n = this.parseIrregularNumerals(t)), "month" === e && (n -= 1), n;
                    },
                    parseRegularNumerals: function(t) {
                        return +(t = t.replace(/^−/, "-").replace(/,/, "."));
                    },
                    parseIrregularNumerals: function(t) {
                        for(var e, n, r, i, s, a = 1, o = 0, u = (s = t.split("")).length - 1; r = s[u]; u--)i = S(this.numeralMap, r), m(i) && (i = S(E, r) || 0), (n = 0 < i && i % 10 == 0) ? (e && (o += a), u ? a = i : o += i) : (o += i * a, a *= 10), e = n;
                        return o;
                    },
                    getOrdinal: function(t) {
                        return this.ordinalSuffix || g(t);
                    },
                    getRelativeFormat: function(t, e) {
                        return this.convertAdjustedToFormat(t, e);
                    },
                    getDuration: function(t) {
                        return this.convertAdjustedToFormat(x(F(0, t)), "duration");
                    },
                    getFirstDayOfWeek: function() {
                        var t = this.firstDayOfWeek;
                        return u(t) ? t : R;
                    },
                    getFirstDayOfWeekYear: function() {
                        return this.firstDayOfWeekYear || D;
                    },
                    convertAdjustedToFormat: function(t, e) {
                        var n, r, i, s = t[0], a = t[1], o = t[2], u = this[e] || this.relative;
                        return A(u) ? u.call(this, s, a, o, e) : (i = this.plural && 1 !== s ? 1 : 0, r = this.units[8 * i + a] || this.units[a], n = this[0 < o ? "fromNow" : "ago"], u.replace(/\{(.*?)\}/g, function(t, e) {
                            switch(e){
                                case "num":
                                    return s;
                                case "unit":
                                    return r;
                                case "sign":
                                    return n;
                            }
                        }));
                    },
                    cacheFormat: function(t, e) {
                        this.compiledFormats.splice(e, 1), this.compiledFormats.unshift(t);
                    },
                    addFormat: function(t) {
                        var e, u, c = this;
                        function getTokenSrc(t) {
                            var e, n, r, i = t.match(/\?$/), s = t.match(/^(\d+)\??$/), a = t.match(/(\d)(?:-(\d))?/), o = t.replace(/[^a-z]+$/i, "");
                            return (r = S(c.parsingAliases, o)) ? (n = formatToSrc(r), i && (n = v(n, !0)), n) : (s ? n = c.tokens[s[1]] : (r = S(l, o)) ? (n = r.src, o = r.param || o) : (r = S(c.parsingTokens, o) || S(c, o), o = o.replace(/s$/, ""), r = r || S(c.parsingTokens, o) || S(c, o + "s"), I(r) ? (n = r, e = c[o + "Suffix"]) : ("weekday" === o && "ko" === c.code && (r = f(r, function(t) {
                                return 1 < t.length;
                            })), a && (r = f(r, function(t, e) {
                                var n = e % (c.units ? 8 : r.length);
                                return n >= a[1] && n <= (a[2] || a[1]);
                            })), n = C(r))), n ? (n = s ? v(n) : (u.push(o), "(" + n + ")"), e && (n = k(o, n, e)), i && (n += "?"), n) : "");
                        }
                        function formatToSrc(t) {
                            return t = (t = t.replace(/ /g, " ?")).replace(/\{([^,]+?)\}/g, function(t, e) {
                                var n = e.split("|");
                                return 1 < n.length ? v(o(n, getTokenSrc).join("|")) : getTokenSrc(e);
                            });
                        }
                        !function parseInputFormat() {
                            u = [], e = formatToSrc(t);
                        }(), c.addRawFormat(e, u);
                    },
                    addRawFormat: function(t, e) {
                        this.compiledFormats.unshift({
                            reg: RegExp("^ *" + t + " *$", "i"),
                            to: e
                        });
                    },
                    init: function(t) {
                        var c = this;
                        function buildValueArray(t, s, a, o) {
                            var e, n = t, u = [];
                            c[n] || (n += "s"), a || (a = {}, e = !0), function forAllAlternates(t, r) {
                                d(c[t], function(t, n) {
                                    forEachAlternate(t, function(t, e) {
                                        r(t, e, n);
                                    });
                                });
                            }(n, function(t, e, n) {
                                var r, i = e * s + n;
                                r = o ? o(n) : n, a[t] = r, a[t.toLowerCase()] = r, u[i] = t;
                            }), c[n] = u, e && (c[t + "Map"] = a);
                        }
                        function forEachAlternate(t, e) {
                            var n = o(t.split("+"), function(t) {
                                return t.replace(/(.+):(.+)$/, function(t, e, n) {
                                    return o(n.split("|"), function(t) {
                                        return e + t;
                                    }).join("|");
                                });
                            }).join("|");
                            d(n.split("|"), e);
                        }
                        function addFormatSet(t, e, n) {
                            d(c[t], function(t) {
                                e && (t = getFormatWithTime(t, n)), c.addFormat(t);
                            });
                        }
                        function getFormatWithTime(t, e) {
                            return e ? function getTimeBefore() {
                                return v("{time}[,\\s\\u3000]", !0);
                            }() + t : t + function getTimeAfter() {
                                var t, e = ",?[\\s\\u3000]";
                                (t = C(c.timeMarkers)) && (e += "| (?:" + t + ") ");
                                return e = v(e, c.timeMarkerOptional), v(e + "{time}{tzOffset}", !0);
                            }();
                        }
                        !function initFormats() {
                            c.compiledFormats = [], c.parsingAliases = {}, c.parsingTokens = {};
                        }(), function initDefinition() {
                            y(c, t);
                        }(), function initArrayFields() {
                            d(r, function(t) {
                                var e = c[t];
                                I(e) ? c[t] = h(e) : e || (c[t] = []);
                            });
                        }(), buildValueArray("month", 12), buildValueArray("weekday", 7), buildValueArray("unit", 8), buildValueArray("ampm", 2), function buildNumerals() {
                            var t = {};
                            buildValueArray("numeral", 10, t), buildValueArray("article", 1, t, function() {
                                return 1;
                            }), buildValueArray("placeholder", 4, t, function(t) {
                                return N(10, t + 1);
                            }), c.numeralMap = t;
                        }(), function buildTimeFormats() {
                            c.parsingAliases.time = function getTimeFormat(t) {
                                var e, n;
                                n = function getTimeSeparatorSrc() {
                                    return c.timeSeparator ? "[:" + c.timeSeparator + "]" : ":";
                                }(), e = c.ampmFront ? "{ampm?} {hour} (?:{minute} (?::?{second})?)?" : c.ampm.length ? "{hour}(?:" + n + "{minute?}(?:" + n + "{second?})? {ampm?}| {ampm})" : "{hour}(?:" + n + "{minute?}(?:" + n + "{second?})?)";
                                return e;
                            }(), c.parsingAliases.tzOffset = "(?:{Z}|{GMT?}(?:{tzHour}(?::?{tzMinute}(?: \\([\\w\\s]+\\))?)?)?)?";
                        }(), function buildParsingTokens() {
                            P(a, function(t, e) {
                                var n, r = t.base ? function getCoreTokensForBase(t) {
                                    return o(t.split("|"), function(t) {
                                        return l[t].src;
                                    }).join("|");
                                }(t.base) : t.src;
                                (t.requiresNumerals || c.numeralUnits) && (r += function getNumeralSrc() {
                                    var t, e = "";
                                    t = c.numerals.concat(c.placeholders).concat(c.articles), c.allowsFullWidth && (t = t.concat(T.split("")));
                                    t.length && (e = "|(?:" + C(t) + ")+");
                                    return e;
                                }()), (n = c[e + "s"]) && n.length && (r += "|" + C(n)), c.parsingTokens[e] = r;
                            });
                        }(), function buildTimeSuffixes() {
                            _(function(t, e) {
                                var n = c.timeSuffixes[e];
                                n && (c[(t.alias || t.name) + "Suffix"] = n);
                            });
                        }(), function buildModifiers() {
                            d(c.modifiers, function(i) {
                                var s, a = i.name, t = a + "Map";
                                s = c[t] || {}, forEachAlternate(i.src, function(t, e) {
                                    var n = S(c.parsingTokens, a), r = i.value;
                                    s[t] = r, c.parsingTokens[a] = n ? n + "|" + t : t, "sign" === i.name && 0 === e && (c[1 === r ? "fromNow" : "ago"] = t);
                                }), c[t] = s;
                            });
                        }(), function addCoreFormats() {
                            d(s, function(t) {
                                var e = t.src;
                                t.localeCheck && !t.localeCheck(c) || (t.mdy && c.mdy && (e = t.mdy), t.time ? (c.addFormat(getFormatWithTime(e, !0)), c.addFormat(getFormatWithTime(e))) : c.addFormat(e));
                            }), c.addFormat("{time}");
                        }(), function addLocaleFormats() {
                            addFormatSet("parse"), addFormatSet("timeParse", !0), addFormatSet("timeFrontParse", !0, !0);
                        }();
                    }
                }, new Locale(t);
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = [
                "months",
                "weekdays",
                "units",
                "numerals",
                "placeholders",
                "articles",
                "tokens",
                "timeMarkers",
                "ampm",
                "timeSuffixes",
                "parse",
                "timeParse",
                "timeFrontParse",
                "modifiers"
            ];
        },
        function(t, e, n) {
            "use strict";
            t.exports = {
                yyyy: {
                    param: "year",
                    src: "[-\u2212+]?\\d{4,6}"
                },
                yy: {
                    param: "year",
                    src: "\\d{2}"
                },
                y: {
                    param: "year",
                    src: "\\d"
                },
                ayy: {
                    param: "year",
                    src: "'\\d{2}"
                },
                MM: {
                    param: "month",
                    src: "(?:1[012]|0?[1-9])"
                },
                dd: {
                    param: "date",
                    src: "(?:3[01]|[12][0-9]|0?[1-9])"
                },
                hh: {
                    param: "hour",
                    src: "(?:2[0-4]|[01]?[0-9])"
                },
                mm: {
                    param: "minute",
                    src: "[0-5]\\d"
                },
                ss: {
                    param: "second",
                    src: "[0-5]\\d(?:[,.]\\d+)?"
                },
                tzHour: {
                    src: "[-\u2212+](?:2[0-4]|[01]?[0-9])"
                },
                tzMinute: {
                    src: "[0-5]\\d"
                },
                iyyyy: {
                    param: "year",
                    src: "(?:[-\u2212+]?\\d{4}|[-\u2212+]\\d{5,6})"
                },
                ihh: {
                    param: "hour",
                    src: "(?:2[0-4]|[01][0-9])(?:[,.]\\d+)?"
                },
                imm: {
                    param: "minute",
                    src: "[0-5]\\d(?:[,.]\\d+)?"
                },
                GMT: {
                    param: "utc",
                    src: "GMT"
                },
                Z: {
                    param: "utc",
                    src: "Z"
                },
                timestamp: {
                    src: "\\d+"
                }
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = [
                {
                    src: "{MM}[-.\\/]{yyyy}"
                },
                {
                    time: !0,
                    src: "{dd}[-\\/]{MM}(?:[-\\/]{yyyy|yy|y})?",
                    mdy: "{MM}[-\\/]{dd}(?:[-\\/]{yyyy|yy|y})?"
                },
                {
                    time: !0,
                    src: "{dd}\\.{MM}(?:\\.{yyyy|yy|y})?",
                    mdy: "{MM}\\.{dd}(?:\\.{yyyy|yy|y})?",
                    localeCheck: function(t) {
                        return "." !== t.timeSeparator;
                    }
                },
                {
                    time: !0,
                    src: "{yyyy}[-.\\/]{MM}(?:[-.\\/]{dd})?"
                },
                {
                    src: "\\\\/Date\\({timestamp}(?:[-+]\\d{4,4})?\\)\\\\/"
                },
                {
                    src: "{iyyyy}(?:-?{MM}(?:-?{dd}(?:T{ihh}(?::?{imm}(?::?{ss})?)?)?)?)?{tzOffset?}"
                }
            ];
        },
        function(t, e, n) {
            "use strict";
            t.exports = function filter(t, e) {
                for(var n = [], r = 0, i = t.length; r < i; r++){
                    var s = t[r];
                    r in t && e(s, r) && n.push(s);
                }
                return n;
            };
        },
        function(t, e, n) {
            "use strict";
            var u = n(139);
            t.exports = function iterateOverSparseArray(t, e, n, r) {
                for(var i, s = u(t, n, r), a = 0, o = s.length; a < o; a++)i = s[a], e.call(t, t[i], i, t);
                return t;
            };
        },
        function(t, e, n) {
            "use strict";
            var a = n(140);
            t.exports = function getSparseArrayIndexes(t, r, e, n) {
                var i, s = [];
                for(i in t)a(i) && (e || (n ? i <= r : r <= i)) && s.push(+i);
                return s.sort(function(t, e) {
                    var n = r < t;
                    return n != r < e ? n ? -1 : 1 : t - e;
                }), s;
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = function isArrayIndex(t) {
                return t >>> 0 == t && 4294967295 != t;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(51).HALF_WIDTH_COMMA;
            t.exports = function commaSplit(t) {
                return t.split(r);
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = "Boolean Number String Date RegExp Function Array Error Set Map";
        },
        function(t, e, n) {
            "use strict";
            var r = n(98), i = n(63), s = n(144), a = n(145);
            t.exports = function isPlainObject(t, e) {
                return i(t) && r(t, "Object", e) && a(t) && s(t);
            };
        },
        function(t, e, n) {
            "use strict";
            var i = n(16).hasOwn;
            t.exports = function hasOwnEnumeratedProperties(t) {
                var e = Object.prototype;
                for(var n in t){
                    var r = t[n];
                    if (!i(t, n) && r !== e[n]) return !1;
                }
                return !0;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(16).hasOwn;
            t.exports = function hasValidPlainObjectPrototype(t) {
                var e = "constructor" in t;
                return !e && !("toString" in t) || e && !r(t, "constructor") && r(t.constructor.prototype, "isPrototypeOf");
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = function getOrdinalSuffix(t) {
                if (11 <= t && t <= 13) return "th";
                switch(t % 10){
                    case 1:
                        return "st";
                    case 2:
                        return "nd";
                    case 3:
                        return "rd";
                    default:
                        return "th";
                }
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = function getArrayWithOffset(t, e, n, r) {
                var i;
                return 1 < n && (i = t[e + (n - 1) * r]), i || t[e];
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(149), i = n(16).setProperty;
            t.exports = function privatePropertyAccessor(t) {
                var n = r + t;
                return function(t, e) {
                    return 1 < arguments.length ? (i(t, n, e), t) : t[n];
                };
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = "_sugar_";
        },
        function(t, e, n) {
            "use strict";
            var r = n(97), i = n(151);
            t.exports = function arrayToRegAlternates(t) {
                var e = t.join("");
                return t && t.length ? e.length === t.length ? "[" + e + "]" : r(t, i).join("|") : "";
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(12).isString;
            t.exports = function escapeRegExp(t) {
                return r(t) || (t = String(t)), t.replace(/([\\/'*+?|()[\]{}.^$-])/g, "\\$1");
            };
        },
        function(t, e, n) {
            "use strict";
            var a, o, u, r = n(51), c = n(101), l = n(153), f = r.HALF_WIDTH_ZERO, d = r.FULL_WIDTH_ZERO, h = r.HALF_WIDTH_PERIOD, p = r.FULL_WIDTH_PERIOD, m = r.HALF_WIDTH_COMMA;
            !function buildFullWidthNumber() {
                var t = p, e = h, n = m, r = "";
                o = {};
                for(var i, s = 0; s <= 9; s++)r += i = c(s + d), o[i] = c(s + f);
                o[n] = "", o[t] = e, o[e] = e, a = l(r + t + n + e), u = r;
            }(), t.exports = {
                fullWidthNumberReg: a,
                fullWidthNumberMap: o,
                fullWidthNumbers: u
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = function allCharsReg(t) {
                return RegExp("[" + t + "]", "g");
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(26), i = n(102), s = n(103);
            t.exports = function getAdjustedUnitForNumber(e) {
                return s(e, function(t) {
                    return r(i(e / t.multiplier, 1));
                });
            };
        },
        function(t, e, n) {
            "use strict";
            var i = n(96), s = n(99);
            t.exports = function getParsingTokenWithSuffix(t, e, n) {
                var r = i[t];
                return r.requiresSuffix ? e = s(e + s(n)) : r.requiresSuffixOr ? e += s(r.requiresSuffixOr + "|" + n) : e += s(n, !0), e;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(27);
            n(172), r.Date.defineStatic({
                create: function(t, e) {
                    return i(t, e);
                }
            }), t.exports = r.Date.create;
        },
        function(t, e, n) {
            "use strict";
            t.exports = /^'?(\d{1,2})$/;
        },
        function(t, e, n) {
            "use strict";
            var r = {
                newDateInternal: n(159)
            };
            t.exports = r;
        },
        function(t, e, n) {
            "use strict";
            t.exports = function defaultNewDate() {
                return new Date;
            };
        },
        function(t, e, n) {
            "use strict";
            var s = n(50), a = n(161), o = n(16).forEachProperty;
            t.exports = function defineOptionsAccessor(t, r) {
                var i = s(r);
                function getOption(t) {
                    return i[t];
                }
                return a(t, "getOption", getOption), a(t, "setOption", function setOption(t, e) {
                    var n;
                    1 === arguments.length ? n = t : (n = {})[t] = e, o(n, function(t, e) {
                        null === t && (t = r[e]), i[e] = t;
                    });
                }), getOption;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(16).setProperty;
            t.exports = function defineAccessor(t, e, n) {
                r(t, e, n);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(43), i = n(37);
            t.exports = function resetLowerUnits(t, e) {
                return i(t, r(e));
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(13), i = r.DAY_INDEX, s = r.MONTH_INDEX;
            t.exports = function getHigherUnitIndex(t) {
                return t === i ? s : t + 1;
            };
        },
        function(t, e, n) {
            "use strict";
            var i = n(38), s = n(107);
            t.exports = function callDateSetWithWeek(t, e, n, r) {
                "ISOWeek" === e ? s(t, n) : i(t, e, n, r);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(38);
            t.exports = function setYear(t, e) {
                r(t, "FullYear", e);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(38);
            t.exports = function setMonth(t, e) {
                r(t, "Month", e);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(109), i = n(16).getOwn;
            t.exports = function getDateParam(t, e) {
                return i(t, r(t, e));
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(16).hasOwn;
            t.exports = function getOwnKey(t, e) {
                if (r(t, e)) return e;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(109);
            t.exports = function deleteDateParam(t, e) {
                delete t[r(t, e)];
            };
        },
        function(t, e, n) {
            "use strict";
            var s = n(35), a = n(15).abs;
            t.exports = function getYearFromAbbreviation(t, e, n) {
                var r, i = +t;
                return i += i < 50 ? 2e3 : 1900, n && (r = i - s(e)) / a(r) !== n && (i += 100 * n), i;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(13), i = n(55), s = r.DAY_INDEX, a = r.YEAR_INDEX;
            t.exports = function iterateOverHigherDateParams(t, e) {
                i(t, e, a, s);
            };
        },
        function(t, e, n) {
            "use strict";
            n(173)();
        },
        function(t, e, n) {
            "use strict";
            var r = n(27), i = n(28), s = n(174), a = i.sugarDate;
            t.exports = function setDateChainableConstructor() {
                s(a, r);
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = function setChainableConstructor(t, e) {
                t.prototype.constructor = function() {
                    return e.apply(this, arguments);
                };
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(14), s = n(176), a = i.localeManager;
            r.Date.defineStatic({
                getAllLocaleCodes: function() {
                    return s(a.getAll());
                }
            }), t.exports = r.Date.getAllLocaleCodes;
        },
        function(t, e, n) {
            "use strict";
            t.exports = function getKeys(t) {
                return Object.keys(t);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(14).localeManager;
            r.Date.defineStatic({
                getAllLocales: function() {
                    return i.getAll();
                }
            }), t.exports = r.Date.getAllLocales;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(14).localeManager;
            r.Date.defineStatic({
                getLocale: function(t) {
                    return i.get(t, !t);
                }
            }), t.exports = r.Date.getLocale;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(14).localeManager;
            r.Date.defineStatic({
                removeLocale: function(t) {
                    return i.remove(t);
                }
            }), t.exports = r.Date.removeLocale;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(14).localeManager;
            r.Date.defineStatic({
                setLocale: function(t) {
                    return i.set(t);
                }
            }), t.exports = r.Date.setLocale;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.day;
        },
        function(t, e, n) {
            "use strict";
            var r = n(34), a = n(27), i = n(15), o = n(45), s = n(28), u = n(58), c = s.sugarNumber, l = i.round;
            t.exports = function buildNumberUnitMethods() {
                u(c, r, function(t, e) {
                    var n, r, i, s = e.name;
                    n = function(t) {
                        return l(t * e.multiplier);
                    }, r = function(t, e, n) {
                        return o(a(e, n, !0), s, t);
                    }, i = function(t, e, n) {
                        return o(a(e, n, !0), s, -t);
                    }, t[s] = n, t[s + "s"] = n, t[s + "Before"] = i, t[s + "sBefore"] = i, t[s + "Ago"] = i, t[s + "sAgo"] = i, t[s + "After"] = r, t[s + "sAfter"] = r, t[s + "FromNow"] = r, t[s + "sFromNow"] = r;
                });
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(184);
            t.exports = {
                alias: r("alias"),
                defineStatic: r("defineStatic"),
                defineInstance: r("defineInstance"),
                defineStaticPolyfill: r("defineStaticPolyfill"),
                defineInstancePolyfill: r("defineInstancePolyfill"),
                defineInstanceAndStatic: r("defineInstanceAndStatic"),
                defineInstanceWithArguments: r("defineInstanceWithArguments")
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = function wrapNamespace(r) {
                return function(t, e, n) {
                    t[r](e, n);
                };
            };
        },
        function(t, e, n) {
            "use strict";
            var i = n(32), s = n(52), a = n(12).isString;
            t.exports = function collectSimilarMethods(t, n) {
                var r = {};
                return a(t) && (t = s(t)), i(t, function(t, e) {
                    n(r, t, e);
                }), r;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.dayAfter;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.dayAgo;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.dayBefore;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.dayFromNow;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.days;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.daysAfter;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.daysAgo;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.daysBefore;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.daysFromNow;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(14).localeManager;
            r.Number.defineInstance({
                duration: function(t, e) {
                    return i.get(e).getDuration(t);
                }
            }), t.exports = r.Number.duration;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.hour;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.hourAfter;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.hourAgo;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.hourBefore;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.hourFromNow;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.hours;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.hoursAfter;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.hoursAgo;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.hoursBefore;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.hoursFromNow;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.millisecond;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.millisecondAfter;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.millisecondAgo;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.millisecondBefore;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.millisecondFromNow;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.milliseconds;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.millisecondsAfter;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.millisecondsAgo;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.millisecondsBefore;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.millisecondsFromNow;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.minute;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.minuteAfter;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.minuteAgo;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.minuteBefore;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.minuteFromNow;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.minutes;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.minutesAfter;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.minutesAgo;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.minutesBefore;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.minutesFromNow;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.month;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.monthAfter;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.monthAgo;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.monthBefore;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.monthFromNow;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.months;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.monthsAfter;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.monthsAgo;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.monthsBefore;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.monthsFromNow;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.second;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.secondAfter;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.secondAgo;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.secondBefore;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.secondFromNow;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.seconds;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.secondsAfter;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.secondsAgo;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.secondsBefore;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.secondsFromNow;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.week;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.weekAfter;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.weekAgo;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.weekBefore;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.weekFromNow;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.weeks;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.weeksAfter;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.weeksAgo;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.weeksBefore;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.weeksFromNow;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.year;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.yearAfter;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.yearAgo;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.yearBefore;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.yearFromNow;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.years;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.yearsAfter;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.yearsAgo;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.yearsBefore;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(6), t.exports = r.Number.yearsFromNow;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.addDays;
        },
        function(t, e, n) {
            "use strict";
            var r = n(34), i = n(13), s = n(32), a = n(27), o = n(111), u = n(45), c = n(56), l = n(28), f = n(68), d = n(57), h = n(58), p = n(69), m = l.sugarDate, y = i.HOURS_INDEX, g = i.DAY_INDEX;
            t.exports = function buildDateUnitMethods() {
                h(m, r, function(t, r, n) {
                    var i = r.name, e = f(i);
                    g < n && s([
                        "Last",
                        "This",
                        "Next"
                    ], function(n) {
                        t["is" + n + e] = function(t, e) {
                            return o(t, n + " " + i, 0, e, {
                                locale: "en"
                            });
                        };
                    }), y < n && (t["beginningOf" + e] = function(t, e) {
                        return d(t, n, e);
                    }, t["endOf" + e] = function(t, e) {
                        return c(t, n, e);
                    }), t["add" + e + "s"] = function(t, e, n) {
                        return u(t, i, e, n);
                    };
                    t[i + "sAgo"] = t[i + "sUntil"] = function(t, e, n) {
                        return p(a(e, n, !0), t, r);
                    }, t[i + "sSince"] = t[i + "sFromNow"] = function(t, e, n) {
                        return p(t, a(e, n, !0), r);
                    };
                });
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.addHours;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.addMilliseconds;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.addMinutes;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.addMonths;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.addSeconds;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.addWeeks;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.addYears;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(112);
            r.Date.defineInstanceWithArguments({
                advance: function(t, e) {
                    return i(t, e, 1);
                }
            }), t.exports = r.Date.advance;
        },
        function(t, e, n) {
            "use strict";
            var i = n(42);
            t.exports = function getDateParamsFromString(t) {
                var e, n, r = {};
                return (e = t.match(/^(-?\d*[\d.]\d*)?\s?(\w+?)s?$/i)) && (i(n) && (n = e[1] ? +e[1] : 1), r[e[2].toLowerCase()] = n), r;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(13), s = n(33), a = n(106), o = r.YEAR_INDEX;
            t.exports = function collectDateParamsFromArguments(n) {
                var r = {}, i = 0;
                return a(o, function(t) {
                    var e = n[i++];
                    s(e) && (r[t.name] = e);
                }), r;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.beginningOfDay;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(105), s = n(24), a = n(29);
            r.Date.defineInstance({
                beginningOfISOWeek: function(t) {
                    var e = s(t);
                    return 0 === e ? e = -6 : 1 !== e && (e = 1), a(t, e), i(t);
                }
            }), t.exports = r.Date.beginningOfISOWeek;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.beginningOfMonth;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.beginningOfWeek;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.beginningOfYear;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(41);
            r.Date.defineInstance({
                clone: function(t) {
                    return i(t);
                }
            }), t.exports = r.Date.clone;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.daysAgo;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.daysFromNow;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(100);
            r.Date.defineInstance({
                daysInMonth: function(t) {
                    return i(t);
                }
            }), t.exports = r.Date.daysInMonth;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.daysSince;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.daysUntil;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.endOfDay;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(13), s = n(24), a = n(29), o = n(56), u = i.DAY_INDEX;
            r.Date.defineInstance({
                endOfISOWeek: function(t) {
                    return 0 !== s(t) && a(t, 7), o(t, u);
                }
            }), t.exports = r.Date.endOfISOWeek;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.endOfMonth;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.endOfWeek;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.endOfYear;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(114);
            r.Date.defineInstance({
                format: function(t, e, n) {
                    return i(t, e, n);
                }
            }), t.exports = r.Date.format;
        },
        function(t, e, n) {
            "use strict";
            var i, r, s, a = n(14), o = n(296), u = n(115), c = n(32), l = n(70), f = n(52), d = n(28), h = n(16), p = n(302), m = n(58), y = a.localeManager, g = h.hasOwn, b = h.getOwn, v = h.forEachProperty, O = d.sugarDate;
            !function buildDateFormatTokens() {
                function addFormats(e, t, n) {
                    t && c(f(t), function(t) {
                        e[t] = n;
                    });
                }
                function buildLowercase(n) {
                    return function(t, e) {
                        return n(t, e).toLowerCase();
                    };
                }
                function buildPadded(n, r) {
                    return function(t, e) {
                        return l(n(t, e), r);
                    };
                }
                function buildTwoDigits(n) {
                    return function(t, e) {
                        return n(t, e) % 100;
                    };
                }
                function buildAlias(n) {
                    return function(t, e) {
                        return s(n, t, e);
                    };
                }
                function buildAlternate(n, r) {
                    function bCa(t, e) {
                        return n.get(t, e, r);
                    }
                    addFormats(i, n.ldml + r, bCa), n.lowerToken && (i[n.lowerToken + r] = buildLowercase(bCa));
                }
                function getIdentityFormat(r) {
                    return function(t, e) {
                        var n = y.get(e);
                        return s(n[r], t, e);
                    };
                }
                i = {}, r = {}, c(o, function(t) {
                    var e, n = t.get;
                    t.lowerToken && (i[t.lowerToken] = buildLowercase(n)), t.ordinalToken && (i[t.ordinalToken] = function buildOrdinal(r) {
                        return function(t, e) {
                            var n = r(t, e);
                            return n + y.get(e).getOrdinal(n);
                        };
                    }(n)), t.ldmlPaddedToken && (i[t.ldmlPaddedToken] = buildPadded(n, t.ldmlPaddedToken.length)), t.ldmlTwoDigitToken && (i[t.ldmlTwoDigitToken] = buildPadded(buildTwoDigits(n), 2)), t.strfTwoDigitToken && (r[t.strfTwoDigitToken] = buildPadded(buildTwoDigits(n), 2)), t.strfPadding && (e = buildPadded(n, t.strfPadding)), t.alias && (n = buildAlias(t.alias)), t.allowAlternates && function buildAlternates(t) {
                        for(var e = 1; e <= 5; e++)buildAlternate(t, e);
                    }(t), addFormats(i, t.ldml, n), addFormats(r, t.strf, e || n);
                }), v(u, function(t, e) {
                    addFormats(i, e, buildAlias(t));
                }), m(O, "short medium long full", function(t, e) {
                    var n = getIdentityFormat(e);
                    addFormats(i, e, n), t[e] = n;
                }), addFormats(i, "time", getIdentityFormat("time")), addFormats(i, "stamp", getIdentityFormat("stamp"));
            }(), function buildDateFormatMatcher() {
                s = p(function getLdml(t, e, n) {
                    return b(i, e)(t, n);
                }, function getStrf(t, e, n) {
                    return b(r, e)(t, n);
                }, function checkDateToken(t, e) {
                    return g(i, t) || g(r, e);
                });
            }(), t.exports = {
                ldmlTokens: i,
                strfTokens: r,
                dateFormatMatcher: s
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(297), i = n(14), s = n(13), a = n(26), o = n(40), u = n(35), c = n(116), l = n(36), f = n(41), d = n(70), h = n(24), p = n(23), m = n(15), y = n(299), g = n(117), b = n(300), v = n(71), O = n(301), _ = n(37), C = i.localeManager, w = s.MONTH_INDEX, x = m.ceil, k = [
                {
                    ldml: "Dow",
                    strf: "a",
                    lowerToken: "dow",
                    get: function(t, e) {
                        return C.get(e).getWeekdayName(h(t), 2);
                    }
                },
                {
                    ldml: "Weekday",
                    strf: "A",
                    lowerToken: "weekday",
                    allowAlternates: !0,
                    get: function(t, e, n) {
                        return C.get(e).getWeekdayName(h(t), n);
                    }
                },
                {
                    ldml: "Mon",
                    strf: "b h",
                    lowerToken: "mon",
                    get: function(t, e) {
                        return C.get(e).getMonthName(l(t), 2);
                    }
                },
                {
                    ldml: "Month",
                    strf: "B",
                    lowerToken: "month",
                    allowAlternates: !0,
                    get: function(t, e, n) {
                        return C.get(e).getMonthName(l(t), n);
                    }
                },
                {
                    strf: "C",
                    get: function(t) {
                        return u(t).toString().slice(0, 2);
                    }
                },
                {
                    ldml: "d date day",
                    strf: "d",
                    strfPadding: 2,
                    ldmlPaddedToken: "dd",
                    ordinalToken: "do",
                    get: function(t) {
                        return o(t);
                    }
                },
                {
                    strf: "e",
                    get: function(t) {
                        return d(o(t), 2, !1, 10, " ");
                    }
                },
                {
                    ldml: "H 24hr",
                    strf: "H",
                    strfPadding: 2,
                    ldmlPaddedToken: "HH",
                    get: function(t) {
                        return c(t);
                    }
                },
                {
                    ldml: "h hours 12hr",
                    strf: "I",
                    strfPadding: 2,
                    ldmlPaddedToken: "hh",
                    get: function(t) {
                        return c(t) % 12 || 12;
                    }
                },
                {
                    ldml: "D",
                    strf: "j",
                    strfPadding: 3,
                    ldmlPaddedToken: "DDD",
                    get: function(t) {
                        var e = _(f(t), w);
                        return b(t, e) + 1;
                    }
                },
                {
                    ldml: "M",
                    strf: "m",
                    strfPadding: 2,
                    ordinalToken: "Mo",
                    ldmlPaddedToken: "MM",
                    get: function(t) {
                        return l(t) + 1;
                    }
                },
                {
                    ldml: "m minutes",
                    strf: "M",
                    strfPadding: 2,
                    ldmlPaddedToken: "mm",
                    get: function(t) {
                        return p(t, "Minutes");
                    }
                },
                {
                    ldml: "Q",
                    get: function(t) {
                        return x((l(t) + 1) / 3);
                    }
                },
                {
                    ldml: "TT",
                    strf: "p",
                    get: function(t, e) {
                        return O(t, e);
                    }
                },
                {
                    ldml: "tt",
                    strf: "P",
                    get: function(t, e) {
                        return O(t, e).toLowerCase();
                    }
                },
                {
                    ldml: "T",
                    lowerToken: "t",
                    get: function(t, e) {
                        return O(t, e).charAt(0);
                    }
                },
                {
                    ldml: "s seconds",
                    strf: "S",
                    strfPadding: 2,
                    ldmlPaddedToken: "ss",
                    get: function(t) {
                        return p(t, "Seconds");
                    }
                },
                {
                    ldml: "S ms",
                    strfPadding: 3,
                    ldmlPaddedToken: "SSS",
                    get: function(t) {
                        return p(t, "Milliseconds");
                    }
                },
                {
                    ldml: "e",
                    strf: "u",
                    ordinalToken: "eo",
                    get: function(t) {
                        return h(t) || 7;
                    }
                },
                {
                    strf: "U",
                    strfPadding: 2,
                    get: function(t) {
                        return v(t, !1, 0);
                    }
                },
                {
                    ldml: "W",
                    strf: "V",
                    strfPadding: 2,
                    ordinalToken: "Wo",
                    ldmlPaddedToken: "WW",
                    get: function(t) {
                        return v(t, !0);
                    }
                },
                {
                    strf: "w",
                    get: function(t) {
                        return h(t);
                    }
                },
                {
                    ldml: "w",
                    ordinalToken: "wo",
                    ldmlPaddedToken: "ww",
                    get: function(t, e) {
                        var n = C.get(e), r = n.getFirstDayOfWeek(e), i = n.getFirstDayOfWeekYear(e);
                        return v(t, !0, r, i);
                    }
                },
                {
                    strf: "W",
                    strfPadding: 2,
                    get: function(t) {
                        return v(t, !1);
                    }
                },
                {
                    ldmlPaddedToken: "gggg",
                    ldmlTwoDigitToken: "gg",
                    get: function(t, e) {
                        return y(t, e);
                    }
                },
                {
                    strf: "G",
                    strfPadding: 4,
                    strfTwoDigitToken: "g",
                    ldmlPaddedToken: "GGGG",
                    ldmlTwoDigitToken: "GG",
                    get: function(t, e) {
                        return y(t, e, !0);
                    }
                },
                {
                    ldml: "year",
                    ldmlPaddedToken: "yyyy",
                    ldmlTwoDigitToken: "yy",
                    strf: "Y",
                    strfPadding: 4,
                    strfTwoDigitToken: "y",
                    get: function(t) {
                        return u(t);
                    }
                },
                {
                    ldml: "ZZ",
                    strf: "z",
                    get: function(t) {
                        return g(t);
                    }
                },
                {
                    ldml: "X",
                    get: function(t) {
                        return a(t.getTime() / 1e3);
                    }
                },
                {
                    ldml: "x",
                    get: function(t) {
                        return t.getTime();
                    }
                },
                {
                    ldml: "Z",
                    get: function(t) {
                        return g(t, !0);
                    }
                },
                {
                    ldml: "z",
                    strf: "Z",
                    get: function(t) {
                        var e = t.toString().match(r);
                        return e ? e[1] : "";
                    }
                },
                {
                    strf: "D",
                    alias: "%m/%d/%y"
                },
                {
                    strf: "F",
                    alias: "%Y-%m-%d"
                },
                {
                    strf: "r",
                    alias: "%I:%M:%S %p"
                },
                {
                    strf: "R",
                    alias: "%H:%M"
                },
                {
                    strf: "T",
                    alias: "%H:%M:%S"
                },
                {
                    strf: "x",
                    alias: "{short}"
                },
                {
                    strf: "X",
                    alias: "{time}"
                },
                {
                    strf: "c",
                    alias: "{stamp}"
                }
            ];
            t.exports = k;
        },
        function(t, e, n) {
            "use strict";
            t.exports = /\(([-+]\d{2,4}|\w{3,5})\)$/;
        },
        function(t, e, n) {
            "use strict";
            t.exports = function repeatString(t, e) {
                var n = "";
                for(t = t.toString(); 0 < e;)1 & e && (n += t), (e >>= 1) && (t += t);
                return n;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(14), c = n(35), l = n(36), f = n(71), d = r.localeManager;
            t.exports = function getWeekYear(t, e, n) {
                var r, i, s, a, o, u;
                return r = c(t), 0 !== (i = l(t)) && 11 !== i || (n || (s = (u = d.get(e)).getFirstDayOfWeek(e), a = u.getFirstDayOfWeekYear(e)), o = f(t, !1, s, a), 0 === i && 0 === o ? r -= 1 : 11 === i && 1 === o && (r += 1)), r;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(34), i = n(13), s = n(69), a = i.DAY_INDEX;
            t.exports = function getDaysSince(t, e) {
                return s(t, e, r[a]);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(14), i = n(26), s = n(116), a = r.localeManager;
            t.exports = function getMeridiemToken(t, e) {
                var n = s(t);
                return a.get(e).ampm[i(n / 12)] || "";
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(303), i = n(51), s = n(304), o = i.OPEN_BRACE, u = i.CLOSE_BRACE;
            t.exports = function createFormatMatcher(c, l, f) {
                var i = r, a = s(function compile(t) {
                    var e, n = [], r = 0;
                    i.lastIndex = 0;
                    for(; e = i.exec(t);)getSubstring(n, t, r, e.index), getToken(n, e), r = i.lastIndex;
                    return getSubstring(n, t, r, t.length), n;
                });
                function getToken(t, e) {
                    var n, r, i, s, a = e[2], o = e[3], u = e[5];
                    e[4] && l ? (r = u, n = l) : a ? (r = a, n = c) : i = o && l ? o : e[1] || e[0], n && (function assertPassesPrecheck(t, e, n) {
                        if (t && !t(e, n)) throw new TypeError("Invalid token " + (e || n) + " in format string");
                    }(f, a, u), s = function(t, e) {
                        return n(t, r, e);
                    }), t.push(s || function getLiteral(t) {
                        return function() {
                            return t;
                        };
                    }(i));
                }
                function getSubstring(t, e, n, r) {
                    if (n < r) {
                        var i = e.slice(n, r);
                        assertNoUnmatched(i, o), assertNoUnmatched(i, u), t.push(function() {
                            return i;
                        });
                    }
                }
                function assertNoUnmatched(t, e) {
                    if (-1 !== t.indexOf(e)) throw new TypeError("Unmatched " + e + " in format string");
                }
                return function(t, e, n) {
                    for(var r = a(t), i = "", s = 0; s < r.length; s++)i += r[s](e, n);
                    return i;
                };
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = /([{}])\1|{([^}]*)}|(%)%|(%(\w*))/g;
        },
        function(t, e, n) {
            "use strict";
            var i = n(305), s = n(16).hasOwn;
            t.exports = function memoizeFunction(e) {
                var n = {}, r = 0;
                return function(t) {
                    return s(n, t) ? n[t] : (r === i && (n = {}, r = 0), r++, n[t] = e(t));
                };
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = 1e3;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(307);
            r.Date.defineInstance({
                get: function(t, e, n) {
                    return i(t, e, n);
                }
            }), t.exports = r.Date.get;
        },
        function(t, e, n) {
            "use strict";
            var i = n(65);
            t.exports = function createDateWithContext(t, e, n, r) {
                return i(t, e, n, r).date;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(71);
            r.Date.defineInstance({
                getISOWeek: function(t) {
                    return i(t, !0);
                }
            }), t.exports = r.Date.getISOWeek;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(117);
            r.Date.defineInstance({
                getUTCOffset: function(t, e) {
                    return i(t, e);
                }
            }), t.exports = r.Date.getUTCOffset;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            r.Date.defineInstance({
                getUTCWeekday: function(t) {
                    return t.getUTCDay();
                }
            }), t.exports = r.Date.getUTCWeekday;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(24);
            r.Date.defineInstance({
                getWeekday: function(t) {
                    return i(t);
                }
            }), t.exports = r.Date.getWeekday;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.hoursAgo;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.hoursFromNow;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.hoursSince;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.hoursUntil;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(119);
            r.Date.defineInstance({
                is: function(t, e, n) {
                    return i(t, e, n);
                }
            }), t.exports = r.Date.is;
        },
        function(t, e, n) {
            "use strict";
            t.exports = function trim(t) {
                return t.trim();
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(39), i = n(40), s = n(35), a = n(36), o = n(44);
            t.exports = function compareDay(t, e) {
                var n = o();
                return e && r(n, i(n) + e), s(t) === s(n) && a(t) === a(n) && i(t) === i(n);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(27);
            r.Date.defineInstance({
                isAfter: function(t, e, n) {
                    return t.getTime() > i(e).getTime() - (n || 0);
                }
            }), t.exports = r.Date.isAfter;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(27);
            r.Date.defineInstance({
                isBefore: function(t, e, n) {
                    return t.getTime() < i(e).getTime() + (n || 0);
                }
            }), t.exports = r.Date.isBefore;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), c = n(27), i = n(15), l = i.min, f = i.max;
            r.Date.defineInstance({
                isBetween: function(t, e, n, r) {
                    var i = t.getTime(), s = c(e).getTime(), a = c(n).getTime(), o = l(s, a), u = f(s, a);
                    return o - (r = r || 0) <= i && i <= u + r;
                }
            }), t.exports = r.Date.isBetween;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(17), t.exports = r.Date.isFriday;
        },
        function(t, e, n) {
            "use strict";
            var r = n(14), i = n(52), s = n(119), a = n(28), o = n(58), u = r.English, c = a.sugarDate;
            t.exports = function buildRelativeAliases() {
                var t = i("Today Yesterday Tomorrow Weekday Weekend Future Past"), e = u.weekdays.slice(0, 7), n = u.months.slice(0, 12), r = t.concat(e).concat(n);
                o(c, r, function(t, e) {
                    t["is" + e] = function(t) {
                        return s(t, e);
                    };
                });
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(17), t.exports = r.Date.isFuture;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.isLastMonth;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.isLastWeek;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.isLastYear;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(35);
            r.Date.defineInstance({
                isLeapYear: function(t) {
                    var e = i(t);
                    return e % 4 == 0 && e % 100 != 0 || e % 400 == 0;
                }
            }), t.exports = r.Date.isLeapYear;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(17), t.exports = r.Date.isMonday;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.isNextMonth;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.isNextWeek;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.isNextYear;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(17), t.exports = r.Date.isPast;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(17), t.exports = r.Date.isSaturday;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(17), t.exports = r.Date.isSunday;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.isThisMonth;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.isThisWeek;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.isThisYear;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(17), t.exports = r.Date.isThursday;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(17), t.exports = r.Date.isToday;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(17), t.exports = r.Date.isTomorrow;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(17), t.exports = r.Date.isTuesday;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(344);
            r.Date.defineInstance({
                isUTC: function(t) {
                    return i(t);
                }
            }), t.exports = r.Date.isUTC;
        },
        function(t, e, n) {
            "use strict";
            var r = n(25), i = n(53);
            t.exports = function isUTC(t) {
                return !!r(t) || 0 === i(t);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(46);
            r.Date.defineInstance({
                isValid: function(t) {
                    return i(t);
                }
            }), t.exports = r.Date.isValid;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(17), t.exports = r.Date.isWednesday;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(17), t.exports = r.Date.isWeekday;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(17), t.exports = r.Date.isWeekend;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(17), t.exports = r.Date.isYesterday;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            r.Date.defineInstance({
                iso: function(t) {
                    return t.toISOString();
                }
            }), t.exports = r.Date.iso;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.millisecondsAgo;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.millisecondsFromNow;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.millisecondsSince;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.millisecondsUntil;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.minutesAgo;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.minutesFromNow;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.minutesSince;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.minutesUntil;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.monthsAgo;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.monthsFromNow;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.monthsSince;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.monthsUntil;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(120);
            r.Date.defineInstance({
                relative: function(t, e, n) {
                    return i(t, null, e, n);
                }
            }), t.exports = r.Date.relative;
        },
        function(t, e, n) {
            "use strict";
            var r = n(44), i = n(15), s = n(103), a = n(69), o = i.abs;
            t.exports = function getAdjustedUnitForDate(e, n) {
                return n || (n = r()) < e && (n = new Date(n.getTime() - 10)), s(e - n, function(t) {
                    return o(a(e, n, t));
                });
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(27), s = n(120);
            r.Date.defineInstance({
                relativeTo: function(t, e, n) {
                    return s(t, i(e), n);
                }
            }), t.exports = r.Date.relativeTo;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(13), s = n(57), a = n(367), o = i.DAY_INDEX;
            r.Date.defineInstance({
                reset: function(t, e, n) {
                    var r = e ? a(e) : o;
                    return s(t, r, n), t;
                }
            }), t.exports = r.Date.reset;
        },
        function(t, e, n) {
            "use strict";
            var r = n(55);
            t.exports = function getUnitIndexForParamName(t) {
                var i, e = {};
                return e[t] = 1, r(e, function(t, e, n, r) {
                    return i = r, !1;
                }), i;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(112);
            r.Date.defineInstanceWithArguments({
                rewind: function(t, e) {
                    return i(t, e, -1);
                }
            }), t.exports = r.Date.rewind;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.secondsAgo;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.secondsFromNow;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.secondsSince;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.secondsUntil;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(54), s = n(113);
            r.Date.defineInstanceWithArguments({
                set: function(t, e) {
                    return e = s(e), i(t, e[0], e[1]);
                }
            }), t.exports = r.Date.set;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(107);
            r.Date.defineInstance({
                setISOWeek: function(t, e) {
                    return i(t, e);
                }
            }), t.exports = r.Date.setISOWeek;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(25);
            r.Date.defineInstance({
                setUTC: function(t, e) {
                    return i(t, e);
                }
            }), t.exports = r.Date.setUTC;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(29);
            r.Date.defineInstance({
                setWeekday: function(t, e) {
                    return i(t, e);
                }
            }), t.exports = r.Date.setWeekday;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.weeksAgo;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.weeksFromNow;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.weeksSince;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.weeksUntil;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.yearsAgo;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.yearsFromNow;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.yearsSince;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(7), t.exports = r.Date.yearsUntil;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(66);
            t.exports = r.Date.getOption;
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            n(66);
            t.exports = r.Date.setOption;
        },
        function(t, e, n) {
            "use strict";
            n(388), n(394), n(396), n(397), n(398), n(407), n(408), n(409), n(410), n(411), n(412), n(413), n(414), n(415), n(417), n(418), n(419), n(420), n(421), t.exports = n(0);
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), i = n(389);
            r.Date.defineStatic({
                range: i
            }), t.exports = r.Date.range;
        },
        function(t, e, n) {
            "use strict";
            var r = n(19), i = n(12), s = n(123), a = n(390), o = i.isString;
            t.exports = function(t, e) {
                return 1 === arguments.length && o(t) ? a(t) : new r(s(t), s(e));
            };
        },
        function(t, e, n) {
            "use strict";
            var o = n(19), r = n(391), u = n(124), c = n(123), i = n(28), l = n(126), f = i.sugarDate, d = r.RANGE_REG_FROM_TO, h = r.RANGE_REG_REAR_DURATION, p = r.RANGE_REG_FRONT_DURATION;
            t.exports = function createDateRangeFromString(t) {
                var e, n, r, i, s, a;
                return f.get && (e = t.match(d)) ? (s = c(e[1].replace("from", "at")), a = f.get(s, e[2]), new o(s, a)) : ((e = t.match(p)) && (r = e[1], n = e[2]), (e = t.match(h)) && (n = e[1], r = e[2]), n && r ? (s = c(n), i = l(r), a = u(s, i[0], i[1])) : s = t, new o(c(s), c(a)));
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(392);
            t.exports = {
                RANGE_REG_FROM_TO: /(?:from)?\s*(.+)\s+(?:to|until)\s+(.+)$/i,
                RANGE_REG_REAR_DURATION: RegExp("(.+)\\s*for\\s*" + r, "i"),
                RANGE_REG_FRONT_DURATION: RegExp("(?:for)?\\s*" + r + "\\s*(?:starting)?\\s(?:at\\s)?(.+)", "i")
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(72);
            t.exports = "((?:\\d+)?\\s*(?:" + r + "))s?";
        },
        function(t, e, n) {
            "use strict";
            var r = n(72);
            t.exports = RegExp("(\\d+)?\\s*(" + r + ")s?", "i");
        },
        function(t, e, n) {
            "use strict";
            var r = n(19), i = n(395);
            n(21)(r, {
                clamp: function(t) {
                    return i(this, t);
                }
            });
        },
        function(t, e, n) {
            "use strict";
            var a = n(121);
            t.exports = function rangeClamp(t, e) {
                var n = t.start, r = t.end, i = r < n ? r : n, s = r < n ? n : r;
                return a(e < i ? i : s < e ? s : e);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(19);
            n(21)(r, {
                clone: function() {
                    return new r(this.start, this.end);
                }
            });
        },
        function(t, e, n) {
            "use strict";
            var r = n(19);
            n(21)(r, {
                contains: function(t) {
                    return null != t && (t.start && t.end ? t.start >= this.start && t.start <= this.end && t.end >= this.start && t.end <= this.end : t >= this.start && t <= this.end);
                }
            });
        },
        function(t, e, n) {
            "use strict";
            n(30);
        },
        function(t, e, n) {
            "use strict";
            var a = n(125), r = n(72), i = n(19), o = n(26), u = n(32), c = n(73), l = n(68), f = n(21);
            t.exports = function buildDateRangeUnits() {
                var s = {};
                u(r.split("|"), function(t, e) {
                    var n, r, i = t + "s";
                    r = e < 4 ? function() {
                        return c(this, t, !0);
                    } : (n = a[l(i)], function() {
                        return o((this.end - this.start) / n);
                    }), s[i] = r;
                }), f(i, s);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(401), i = n(122);
            t.exports = function isValidRangeMember(t) {
                var e = i(t);
                return (!!e || 0 === e) && r(t);
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = function valueIsNotInfinite(t) {
                return t !== -1 / 0 && t !== 1 / 0;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(102);
            t.exports = function incrementNumber(t, e, n) {
                return r(t + e, n);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(101);
            t.exports = function incrementString(t, e) {
                return r(t.charCodeAt(0) + e);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(15), i = n(405), s = r.max;
            t.exports = function getGreaterPrecision(t, e) {
                return s(i(t), i(e));
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(406);
            t.exports = function getPrecision(t) {
                var e = r(t.toString());
                return e[1] ? e[1].length : 0;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(51).HALF_WIDTH_PERIOD;
            t.exports = function periodSplit(t) {
                return t.split(r);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(19), i = n(73);
            n(21)(r, {
                every: function(t, e) {
                    return i(this, t, !1, e);
                }
            });
        },
        function(t, e, n) {
            "use strict";
            n(30);
        },
        function(t, e, n) {
            "use strict";
            var r = n(19);
            n(21)(r, {
                intersect: function(t) {
                    return t.start > this.end || t.end < this.start ? new r(NaN, NaN) : new r(this.start > t.start ? this.start : t.start, this.end < t.end ? this.end : t.end);
                }
            });
        },
        function(t, e, n) {
            "use strict";
            var r = n(19), i = n(59);
            n(21)(r, {
                isValid: function() {
                    return i(this);
                }
            });
        },
        function(t, e, n) {
            "use strict";
            n(30);
        },
        function(t, e, n) {
            "use strict";
            n(30);
        },
        function(t, e, n) {
            "use strict";
            n(30);
        },
        function(t, e, n) {
            "use strict";
            n(30);
        },
        function(t, e, n) {
            "use strict";
            var r = n(19), i = n(15), s = n(59), a = n(21), o = n(416), u = i.abs;
            a(r, {
                span: function() {
                    var t = o(this.end) - o(this.start);
                    return s(this) ? u(t) + 1 : NaN;
                }
            });
        },
        function(t, e, n) {
            "use strict";
            var r = n(12).isString;
            t.exports = function getRangeMemberNumericValue(t) {
                return r(t) ? t.charCodeAt(0) : t;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(19), i = n(73);
            n(21)(r, {
                toArray: function() {
                    return i(this);
                }
            });
        },
        function(t, e, n) {
            "use strict";
            var r = n(19), i = n(59);
            n(21)(r, {
                toString: function() {
                    return i(this) ? this.start + ".." + this.end : "Invalid Range";
                }
            });
        },
        function(t, e, n) {
            "use strict";
            var r = n(19);
            n(21)(r, {
                union: function(t) {
                    return new r(this.start < t.start ? this.start : t.start, this.end > t.end ? this.end : t.end);
                }
            });
        },
        function(t, e, n) {
            "use strict";
            n(30);
        },
        function(t, e, n) {
            "use strict";
            n(30);
        },
        function(t, e, n) {
            "use strict";
            n(423), n(424), n(425), n(426), n(427), n(428), n(429), n(430), n(431), n(432), n(433), n(434), n(435), n(436), n(437), n(438), n(439), t.exports = n(0);
        },
        function(t, e, n) {
            "use strict";
            n(11)("ca", {
                plural: !0,
                units: "milisegon:|s,segon:|s,minut:|s,hor:a|es,di:a|es,setman:a|es,mes:|os,any:|s",
                months: "gen:er|,febr:er|,mar:\xe7|,abr:il|,mai:g|,jun:y|,jul:iol|,ag:ost|,set:embre|,oct:ubre|,nov:embre|,des:embre|",
                weekdays: "diumenge|dg,dilluns|dl,dimarts|dt,dimecres|dc,dijous|dj,divendres|dv,dissabte|ds",
                numerals: "zero,un,dos,tres,quatre,cinc,sis,set,vuit,nou,deu",
                tokens: "el,la,de",
                short: "{dd}/{MM}/{yyyy}",
                medium: "{d} {month} {yyyy}",
                long: "{d} {month} {yyyy} {time}",
                full: "{weekday} {d} {month} {yyyy} {time}",
                stamp: "{dow} {d} {mon} {yyyy} {time}",
                time: "{H}:{mm}",
                past: "{sign} {num} {unit}",
                future: "{sign} {num} {unit}",
                duration: "{num} {unit}",
                timeMarkers: "a las",
                ampm: "am,pm",
                modifiers: [
                    {
                        name: "day",
                        src: "abans d'ahir",
                        value: -2
                    },
                    {
                        name: "day",
                        src: "ahir",
                        value: -1
                    },
                    {
                        name: "day",
                        src: "avui",
                        value: 0
                    },
                    {
                        name: "day",
                        src: "dem\xe0|dema",
                        value: 1
                    },
                    {
                        name: "sign",
                        src: "fa",
                        value: -1
                    },
                    {
                        name: "sign",
                        src: "en",
                        value: 1
                    },
                    {
                        name: "shift",
                        src: "passat",
                        value: -1
                    },
                    {
                        name: "shift",
                        src: "el proper|la propera",
                        value: 1
                    }
                ],
                parse: [
                    "{sign} {num} {unit}",
                    "{num} {unit} {sign}",
                    "{0?}{1?} {unit:5-7} {shift}",
                    "{0?}{1?} {shift} {unit:5-7}"
                ],
                timeParse: [
                    "{shift} {weekday}",
                    "{weekday} {shift}",
                    "{date?} {2?} {months}\\.? {2?} {year?}"
                ]
            });
        },
        function(t, e, n) {
            "use strict";
            n(11)("da", {
                plural: !0,
                units: "millisekund:|er,sekund:|er,minut:|ter,tim:e|er,dag:|e,ug:e|er|en,m\xe5ned:|er|en+maaned:|er|en,\xe5r:||et+aar:||et",
                months: "jan:uar|,feb:ruar|,mar:ts|,apr:il|,maj,jun:i|,jul:i|,aug:ust|,sep:tember|,okt:ober|,nov:ember|,dec:ember|",
                weekdays: "s\xf8n:dag|+son:dag|,man:dag|,tir:sdag|,ons:dag|,tor:sdag|,fre:dag|,l\xf8r:dag|+lor:dag|",
                numerals: "nul,en|et,to,tre,fire,fem,seks,syv,otte,ni,ti",
                tokens: "den,for",
                articles: "den",
                short: "{dd}-{MM}-{yyyy}",
                medium: "{d}. {month} {yyyy}",
                long: "{d}. {month} {yyyy} {time}",
                full: "{weekday} d. {d}. {month} {yyyy} {time}",
                stamp: "{dow} {d} {mon} {yyyy} {time}",
                time: "{H}:{mm}",
                past: "{num} {unit} {sign}",
                future: "{sign} {num} {unit}",
                duration: "{num} {unit}",
                ampm: "am,pm",
                modifiers: [
                    {
                        name: "day",
                        src: "forg\xe5rs|i forg\xe5rs|forgaars|i forgaars",
                        value: -2
                    },
                    {
                        name: "day",
                        src: "i g\xe5r|ig\xe5r|i gaar|igaar",
                        value: -1
                    },
                    {
                        name: "day",
                        src: "i dag|idag",
                        value: 0
                    },
                    {
                        name: "day",
                        src: "i morgen|imorgen",
                        value: 1
                    },
                    {
                        name: "day",
                        src: "over morgon|overmorgen|i over morgen|i overmorgen|iovermorgen",
                        value: 2
                    },
                    {
                        name: "sign",
                        src: "siden",
                        value: -1
                    },
                    {
                        name: "sign",
                        src: "om",
                        value: 1
                    },
                    {
                        name: "shift",
                        src: "i sidste|sidste",
                        value: -1
                    },
                    {
                        name: "shift",
                        src: "denne",
                        value: 0
                    },
                    {
                        name: "shift",
                        src: "n\xe6ste|naeste",
                        value: 1
                    }
                ],
                parse: [
                    "{months} {year?}",
                    "{num} {unit} {sign}",
                    "{sign} {num} {unit}",
                    "{1?} {num} {unit} {sign}",
                    "{shift} {unit:5-7}"
                ],
                timeParse: [
                    "{day|weekday}",
                    "{date} {months?}\\.? {year?}"
                ],
                timeFrontParse: [
                    "{shift} {weekday}",
                    "{0?} {weekday?},? {date}\\.? {months?}\\.? {year?}"
                ]
            });
        },
        function(t, e, n) {
            "use strict";
            n(11)("de", {
                plural: !0,
                units: "Millisekunde:|n,Sekunde:|n,Minute:|n,Stunde:|n,Tag:|en,Woche:|n,Monat:|en,Jahr:|en|e",
                months: "Jan:uar|,Feb:ruar|,M:\xe4r|\xe4rz|ar|arz,Apr:il|,Mai,Juni,Juli,Aug:ust|,Sept:ember|,Okt:ober|,Nov:ember|,Dez:ember|",
                weekdays: "So:nntag|,Mo:ntag|,Di:enstag|,Mi:ttwoch|,Do:nnerstag|,Fr:eitag|,Sa:mstag|",
                numerals: "null,ein:|e|er|en|em,zwei,drei,vier,fuenf,sechs,sieben,acht,neun,zehn",
                tokens: "der",
                short: "{dd}.{MM}.{yyyy}",
                medium: "{d}. {Month} {yyyy}",
                long: "{d}. {Month} {yyyy} {time}",
                full: "{Weekday}, {d}. {Month} {yyyy} {time}",
                stamp: "{Dow} {d} {Mon} {yyyy} {time}",
                time: "{H}:{mm}",
                past: "{sign} {num} {unit}",
                future: "{sign} {num} {unit}",
                duration: "{num} {unit}",
                timeMarkers: "um",
                ampm: "am,pm",
                modifiers: [
                    {
                        name: "day",
                        src: "vorgestern",
                        value: -2
                    },
                    {
                        name: "day",
                        src: "gestern",
                        value: -1
                    },
                    {
                        name: "day",
                        src: "heute",
                        value: 0
                    },
                    {
                        name: "day",
                        src: "morgen",
                        value: 1
                    },
                    {
                        name: "day",
                        src: "\xfcbermorgen|ubermorgen|uebermorgen",
                        value: 2
                    },
                    {
                        name: "sign",
                        src: "vor:|her",
                        value: -1
                    },
                    {
                        name: "sign",
                        src: "in",
                        value: 1
                    },
                    {
                        name: "shift",
                        src: "letzte:|r|n|s",
                        value: -1
                    },
                    {
                        name: "shift",
                        src: "n\xe4chste:|r|n|s+nachste:|r|n|s+naechste:|r|n|s+kommende:n|r",
                        value: 1
                    }
                ],
                parse: [
                    "{months} {year?}",
                    "{sign} {num} {unit}",
                    "{num} {unit} {sign}",
                    "{shift} {unit:5-7}"
                ],
                timeParse: [
                    "{shift?} {day|weekday}",
                    "{weekday?},? {date}\\.? {months?}\\.? {year?}"
                ],
                timeFrontParse: [
                    "{shift} {weekday}",
                    "{weekday?},? {date}\\.? {months?}\\.? {year?}"
                ]
            });
        },
        function(t, e, n) {
            "use strict";
            n(11)("es", {
                plural: !0,
                units: "milisegundo:|s,segundo:|s,minuto:|s,hora:|s,d\xeda|d\xedas|dia|dias,semana:|s,mes:|es,a\xf1o|a\xf1os|ano|anos",
                months: "ene:ro|,feb:rero|,mar:zo|,abr:il|,may:o|,jun:io|,jul:io|,ago:sto|,sep:tiembre|,oct:ubre|,nov:iembre|,dic:iembre|",
                weekdays: "dom:ingo|,lun:es|,mar:tes|,mi\xe9:rcoles|+mie:rcoles|,jue:ves|,vie:rnes|,s\xe1b:ado|+sab:ado|",
                numerals: "cero,uno,dos,tres,cuatro,cinco,seis,siete,ocho,nueve,diez",
                tokens: "el,la,de",
                short: "{dd}/{MM}/{yyyy}",
                medium: "{d} de {Month} de {yyyy}",
                long: "{d} de {Month} de {yyyy} {time}",
                full: "{weekday}, {d} de {month} de {yyyy} {time}",
                stamp: "{dow} {d} {mon} {yyyy} {time}",
                time: "{H}:{mm}",
                past: "{sign} {num} {unit}",
                future: "{sign} {num} {unit}",
                duration: "{num} {unit}",
                timeMarkers: "a las",
                ampm: "am,pm",
                modifiers: [
                    {
                        name: "day",
                        src: "anteayer",
                        value: -2
                    },
                    {
                        name: "day",
                        src: "ayer",
                        value: -1
                    },
                    {
                        name: "day",
                        src: "hoy",
                        value: 0
                    },
                    {
                        name: "day",
                        src: "ma\xf1ana|manana",
                        value: 1
                    },
                    {
                        name: "sign",
                        src: "hace",
                        value: -1
                    },
                    {
                        name: "sign",
                        src: "dentro de",
                        value: 1
                    },
                    {
                        name: "shift",
                        src: "pasad:o|a",
                        value: -1
                    },
                    {
                        name: "shift",
                        src: "pr\xf3ximo|pr\xf3xima|proximo|proxima",
                        value: 1
                    }
                ],
                parse: [
                    "{months} {2?} {year?}",
                    "{sign} {num} {unit}",
                    "{num} {unit} {sign}",
                    "{0?}{1?} {unit:5-7} {shift}",
                    "{0?}{1?} {shift} {unit:5-7}"
                ],
                timeParse: [
                    "{shift?} {day|weekday} {shift?}",
                    "{date} {2?} {months?}\\.? {2?} {year?}"
                ],
                timeFrontParse: [
                    "{shift?} {weekday} {shift?}",
                    "{date} {2?} {months?}\\.? {2?} {year?}"
                ]
            });
        },
        function(t, e, n) {
            "use strict";
            n(11)("fi", {
                plural: !0,
                units: "millisekun:ti|tia|nin|teja|tina,sekun:ti|tia|nin|teja|tina,minuut:ti|tia|in|teja|tina,tun:ti|tia|nin|teja|tina,p\xe4iv:\xe4|\xe4\xe4|\xe4n|i\xe4|\xe4n\xe4,viik:ko|koa|on|olla|koja|kona,kuukau:si|tta|den+kuussa,vuo:si|tta|den|sia|tena|nna",
                months: "tammi:kuuta||kuu,helmi:kuuta||kuu,maalis:kuuta||kuu,huhti:kuuta||kuu,touko:kuuta||kuu,kes\xe4:kuuta||kuu,hein\xe4:kuuta||kuu,elo:kuuta||kuu,syys:kuuta||kuu,loka:kuuta||kuu,marras:kuuta||kuu,joulu:kuuta||kuu",
                weekdays: "su:nnuntai||nnuntaina,ma:anantai||anantaina,ti:istai||istaina,ke:skiviikko||skiviikkona,to:rstai||rstaina,pe:rjantai||rjantaina,la:uantai||uantaina",
                numerals: "nolla,yksi|ensimm\xe4inen,kaksi|toinen,kolm:e|as,nelj\xe4:|s,vii:si|des,kuu:si|des,seitsem\xe4:n|s,kahdeksa:n|s,yhdeks\xe4:n|s,kymmene:n|s",
                short: "{d}.{M}.{yyyy}",
                medium: "{d}. {month} {yyyy}",
                long: "{d}. {month} {yyyy} klo {time}",
                full: "{weekday} {d}. {month} {yyyy} klo {time}",
                stamp: "{dow} {d} {mon} {yyyy} {time}",
                time: "{H}.{mm}",
                timeMarkers: "klo,kello",
                timeSeparator: ".",
                ordinalSuffix: ".",
                relative: function(e, n, t, r) {
                    var i = this.units;
                    function numberWithUnit(t) {
                        return e + " " + i[8 * t + n];
                    }
                    function baseUnit() {
                        return numberWithUnit(1 === e ? 0 : 1);
                    }
                    switch(r){
                        case "duration":
                            return baseUnit();
                        case "past":
                            return baseUnit() + " sitten";
                        case "future":
                            return numberWithUnit(2) + " kuluttua";
                    }
                },
                modifiers: [
                    {
                        name: "day",
                        src: "toissa p\xe4iv\xe4n\xe4",
                        value: -2
                    },
                    {
                        name: "day",
                        src: "eilen|eilist\xe4",
                        value: -1
                    },
                    {
                        name: "day",
                        src: "t\xe4n\xe4\xe4n",
                        value: 0
                    },
                    {
                        name: "day",
                        src: "huomenna|huomista",
                        value: 1
                    },
                    {
                        name: "day",
                        src: "ylihuomenna|ylihuomista",
                        value: 2
                    },
                    {
                        name: "sign",
                        src: "sitten|aiemmin",
                        value: -1
                    },
                    {
                        name: "sign",
                        src: "p\xe4\xe4st\xe4|kuluttua|my\xf6hemmin",
                        value: 1
                    },
                    {
                        name: "edge",
                        src: "lopussa",
                        value: 2
                    },
                    {
                        name: "edge",
                        src: "ensimm\xe4inen|ensimm\xe4isen\xe4",
                        value: -2
                    },
                    {
                        name: "shift",
                        src: "edel:linen|lisen\xe4",
                        value: -1
                    },
                    {
                        name: "shift",
                        src: "viime",
                        value: -1
                    },
                    {
                        name: "shift",
                        src: "t\xe4:ll\xe4|ss\xe4|n\xe4|m\xe4",
                        value: 0
                    },
                    {
                        name: "shift",
                        src: "seuraava|seuraavana|tuleva|tulevana|ensi",
                        value: 1
                    }
                ],
                parse: [
                    "{months} {year?}",
                    "{shift} {unit:5-7}"
                ],
                timeParse: [
                    "{shift?} {day|weekday}",
                    "{weekday?},? {date}\\.? {months?}\\.? {year?}"
                ],
                timeFrontParse: [
                    "{shift?} {day|weekday}",
                    "{num?} {unit} {sign}",
                    "{weekday?},? {date}\\.? {months?}\\.? {year?}"
                ]
            });
        },
        function(t, e, n) {
            "use strict";
            n(11)("fr", {
                plural: !0,
                units: "milliseconde:|s,seconde:|s,minute:|s,heure:|s,jour:|s,semaine:|s,mois,an:|s|n\xe9e|nee",
                months: "janv:ier|,f\xe9vr:ier|+fevr:ier|,mars,avr:il|,mai,juin,juil:let|,ao\xfbt,sept:embre|,oct:obre|,nov:embre|,d\xe9c:embre|+dec:embre|",
                weekdays: "dim:anche|,lun:di|,mar:di|,mer:credi|,jeu:di|,ven:dredi|,sam:edi|",
                numerals: "z\xe9ro,un:|e,deux,trois,quatre,cinq,six,sept,huit,neuf,dix",
                tokens: "l'|la|le,er",
                short: "{dd}/{MM}/{yyyy}",
                medium: "{d} {month} {yyyy}",
                long: "{d} {month} {yyyy} {time}",
                full: "{weekday} {d} {month} {yyyy} {time}",
                stamp: "{dow} {d} {mon} {yyyy} {time}",
                time: "{H}:{mm}",
                past: "{sign} {num} {unit}",
                future: "{sign} {num} {unit}",
                duration: "{num} {unit}",
                timeMarkers: "\xe0",
                ampm: "am,pm",
                modifiers: [
                    {
                        name: "day",
                        src: "hier",
                        value: -1
                    },
                    {
                        name: "day",
                        src: "aujourd'hui",
                        value: 0
                    },
                    {
                        name: "day",
                        src: "demain",
                        value: 1
                    },
                    {
                        name: "sign",
                        src: "il y a",
                        value: -1
                    },
                    {
                        name: "sign",
                        src: "dans|d'ici",
                        value: 1
                    },
                    {
                        name: "shift",
                        src: "derni:\xe8r|er|\xe8re|ere",
                        value: -1
                    },
                    {
                        name: "shift",
                        src: "prochain:|e",
                        value: 1
                    }
                ],
                parse: [
                    "{months} {year?}",
                    "{sign} {num} {unit}",
                    "{0?} {unit:5-7} {shift}"
                ],
                timeParse: [
                    "{day|weekday} {shift?}",
                    "{weekday?},? {0?} {date}{1?} {months}\\.? {year?}"
                ],
                timeFrontParse: [
                    "{0?} {weekday} {shift}",
                    "{weekday?},? {0?} {date}{1?} {months}\\.? {year?}"
                ]
            });
        },
        function(t, e, n) {
            "use strict";
            n(11)("it", {
                plural: !0,
                units: "millisecond:o|i,second:o|i,minut:o|i,or:a|e,giorn:o|i,settiman:a|e,mes:e|i,ann:o|i",
                months: "gen:naio|,feb:braio|,mar:zo|,apr:ile|,mag:gio|,giu:gno|,lug:lio|,ago:sto|,set:tembre|,ott:obre|,nov:embre|,dic:embre|",
                weekdays: "dom:enica|,lun:ed\xec||edi,mar:ted\xec||tedi,mer:coled\xec||coledi,gio:ved\xec||vedi,ven:erd\xec||erdi,sab:ato|",
                numerals: "zero,un:|a|o|',due,tre,quattro,cinque,sei,sette,otto,nove,dieci",
                tokens: "l'|la|il",
                short: "{dd}/{MM}/{yyyy}",
                medium: "{d} {month} {yyyy}",
                long: "{d} {month} {yyyy} {time}",
                full: "{weekday}, {d} {month} {yyyy} {time}",
                stamp: "{dow} {d} {mon} {yyyy} {time}",
                time: "{H}:{mm}",
                past: "{num} {unit} {sign}",
                future: "{num} {unit} {sign}",
                duration: "{num} {unit}",
                timeMarkers: "alle",
                ampm: "am,pm",
                modifiers: [
                    {
                        name: "day",
                        src: "ieri",
                        value: -1
                    },
                    {
                        name: "day",
                        src: "oggi",
                        value: 0
                    },
                    {
                        name: "day",
                        src: "domani",
                        value: 1
                    },
                    {
                        name: "day",
                        src: "dopodomani",
                        value: 2
                    },
                    {
                        name: "sign",
                        src: "fa",
                        value: -1
                    },
                    {
                        name: "sign",
                        src: "da adesso",
                        value: 1
                    },
                    {
                        name: "shift",
                        src: "scors:o|a",
                        value: -1
                    },
                    {
                        name: "shift",
                        src: "prossim:o|a",
                        value: 1
                    }
                ],
                parse: [
                    "{months} {year?}",
                    "{num} {unit} {sign}",
                    "{0?} {unit:5-7} {shift}",
                    "{0?} {shift} {unit:5-7}"
                ],
                timeParse: [
                    "{day|weekday} {shift?}",
                    "{weekday?},? {date} {months?}\\.? {year?}"
                ],
                timeFrontParse: [
                    "{day|weekday} {shift?}",
                    "{weekday?},? {date} {months?}\\.? {year?}"
                ]
            });
        },
        function(t, e, n) {
            "use strict";
            n(11)("ja", {
                ampmFront: !0,
                numeralUnits: !0,
                allowsFullWidth: !0,
                timeMarkerOptional: !0,
                firstDayOfWeek: 0,
                firstDayOfWeekYear: 1,
                units: "\u30DF\u30EA\u79D2,\u79D2,\u5206,\u6642\u9593,\u65E5,\u9031\u9593|\u9031,\u30F6\u6708|\u30F5\u6708|\u6708,\u5E74|\u5E74\u5EA6",
                weekdays: "\u65E5:\u66DC\u65E5||\u66DC,\u6708:\u66DC\u65E5||\u66DC,\u706B:\u66DC\u65E5||\u66DC,\u6C34:\u66DC\u65E5||\u66DC,\u6728:\u66DC\u65E5||\u66DC,\u91D1:\u66DC\u65E5||\u66DC,\u571F:\u66DC\u65E5||\u66DC",
                numerals: "\u3007,\u4E00,\u4E8C,\u4E09,\u56DB,\u4E94,\u516D,\u4E03,\u516B,\u4E5D",
                placeholders: "\u5341,\u767E,\u5343,\u4E07",
                timeSuffixes: ",\u79D2,\u5206,\u6642,\u65E5,,\u6708,\u5E74\u5EA6?",
                short: "{yyyy}/{MM}/{dd}",
                medium: "{yyyy}\u5E74{M}\u6708{d}\u65E5",
                long: "{yyyy}\u5E74{M}\u6708{d}\u65E5{time}",
                full: "{yyyy}\u5E74{M}\u6708{d}\u65E5{time} {weekday}",
                stamp: "{yyyy}\u5E74{M}\u6708{d}\u65E5 {H}:{mm} {dow}",
                time: "{tt}{h}\u6642{mm}\u5206",
                past: "{num}{unit}{sign}",
                future: "{num}{unit}{sign}",
                duration: "{num}{unit}",
                ampm: "\u5348\u524D,\u5348\u5F8C",
                modifiers: [
                    {
                        name: "day",
                        src: "\u4E00\u6628\u3005\u65E5|\u524D\u3005\u3005\u65E5",
                        value: -3
                    },
                    {
                        name: "day",
                        src: "\u4E00\u6628\u65E5|\u304A\u3068\u3068\u3044|\u524D\u3005\u65E5",
                        value: -2
                    },
                    {
                        name: "day",
                        src: "\u6628\u65E5|\u524D\u65E5",
                        value: -1
                    },
                    {
                        name: "day",
                        src: "\u4ECA\u65E5|\u5F53\u65E5|\u672C\u65E5",
                        value: 0
                    },
                    {
                        name: "day",
                        src: "\u660E\u65E5|\u7FCC\u65E5|\u6B21\u65E5",
                        value: 1
                    },
                    {
                        name: "day",
                        src: "\u660E\u5F8C\u65E5|\u7FCC\u3005\u65E5",
                        value: 2
                    },
                    {
                        name: "day",
                        src: "\u660E\u3005\u5F8C\u65E5|\u7FCC\u3005\u3005\u65E5",
                        value: 3
                    },
                    {
                        name: "sign",
                        src: "\u524D",
                        value: -1
                    },
                    {
                        name: "sign",
                        src: "\u5F8C",
                        value: 1
                    },
                    {
                        name: "edge",
                        src: "\u59CB|\u521D\u65E5|\u982D",
                        value: -2
                    },
                    {
                        name: "edge",
                        src: "\u672B|\u5C3B",
                        value: 2
                    },
                    {
                        name: "edge",
                        src: "\u672B\u65E5",
                        value: 1
                    },
                    {
                        name: "shift",
                        src: "\u4E00\u6628\u3005|\u524D\u3005\u3005",
                        value: -3
                    },
                    {
                        name: "shift",
                        src: "\u4E00\u6628|\u524D\u3005|\u5148\u3005",
                        value: -2
                    },
                    {
                        name: "shift",
                        src: "\u5148|\u6628|\u53BB|\u524D",
                        value: -1
                    },
                    {
                        name: "shift",
                        src: "\u4ECA|\u672C|\u5F53",
                        value: 0
                    },
                    {
                        name: "shift",
                        src: "\u6765|\u660E|\u7FCC|\u6B21",
                        value: 1
                    },
                    {
                        name: "shift",
                        src: "\u660E\u5F8C|\u7FCC\u3005|\u6B21\u3005|\u518D\u6765|\u3055\u6765",
                        value: 2
                    },
                    {
                        name: "shift",
                        src: "\u660E\u3005\u5F8C|\u7FCC\u3005\u3005",
                        value: 3
                    }
                ],
                parse: [
                    "{month}{edge}",
                    "{num}{unit}{sign}",
                    "{year?}{month}",
                    "{year}"
                ],
                timeParse: [
                    "{day|weekday}",
                    "{shift}{unit:5}{weekday?}",
                    "{shift}{unit:7}{month}{edge}",
                    "{shift}{unit:7}{month?}{date?}",
                    "{shift}{unit:6}{edge?}{date?}",
                    "{year?}{month?}{date}"
                ]
            });
        },
        function(t, e, n) {
            "use strict";
            n(11)("ko", {
                ampmFront: !0,
                numeralUnits: !0,
                units: "\uBC00\uB9AC\uCD08,\uCD08,\uBD84,\uC2DC\uAC04,\uC77C,\uC8FC,\uAC1C\uC6D4|\uB2EC,\uB144|\uD574",
                weekdays: "\uC77C:\uC694\uC77C|,\uC6D4:\uC694\uC77C|,\uD654:\uC694\uC77C|,\uC218:\uC694\uC77C|,\uBAA9:\uC694\uC77C|,\uAE08:\uC694\uC77C|,\uD1A0:\uC694\uC77C|",
                numerals: "\uC601|\uC81C\uB85C,\uC77C|\uD55C,\uC774,\uC0BC,\uC0AC,\uC624,\uC721,\uCE60,\uD314,\uAD6C,\uC2ED",
                short: "{yyyy}.{MM}.{dd}",
                medium: "{yyyy}\uB144 {M}\uC6D4 {d}\uC77C",
                long: "{yyyy}\uB144 {M}\uC6D4 {d}\uC77C {time}",
                full: "{yyyy}\uB144 {M}\uC6D4 {d}\uC77C {weekday} {time}",
                stamp: "{yyyy}\uB144 {M}\uC6D4 {d}\uC77C {H}:{mm} {dow}",
                time: "{tt} {h}\uC2DC {mm}\uBD84",
                past: "{num}{unit} {sign}",
                future: "{num}{unit} {sign}",
                duration: "{num}{unit}",
                timeSuffixes: ",\uCD08,\uBD84,\uC2DC,\uC77C,,\uC6D4,\uB144",
                ampm: "\uC624\uC804,\uC624\uD6C4",
                modifiers: [
                    {
                        name: "day",
                        src: "\uADF8\uC800\uAED8",
                        value: -2
                    },
                    {
                        name: "day",
                        src: "\uC5B4\uC81C",
                        value: -1
                    },
                    {
                        name: "day",
                        src: "\uC624\uB298",
                        value: 0
                    },
                    {
                        name: "day",
                        src: "\uB0B4\uC77C",
                        value: 1
                    },
                    {
                        name: "day",
                        src: "\uBAA8\uB808",
                        value: 2
                    },
                    {
                        name: "sign",
                        src: "\uC804",
                        value: -1
                    },
                    {
                        name: "sign",
                        src: "\uD6C4",
                        value: 1
                    },
                    {
                        name: "shift",
                        src: "\uC9C0\uB09C|\uC791",
                        value: -1
                    },
                    {
                        name: "shift",
                        src: "\uC774\uBC88|\uC62C",
                        value: 0
                    },
                    {
                        name: "shift",
                        src: "\uB2E4\uC74C|\uB0B4",
                        value: 1
                    }
                ],
                parse: [
                    "{num}{unit} {sign}",
                    "{shift?} {unit:5-7}",
                    "{year?} {month}",
                    "{year}"
                ],
                timeParse: [
                    "{day|weekday}",
                    "{shift} {unit:5?} {weekday}",
                    "{year?} {month?} {date} {weekday?}"
                ]
            });
        },
        function(t, e, n) {
            "use strict";
            n(11)("nl", {
                plural: !0,
                units: "milliseconde:|n,seconde:|n,minu:ut|ten,uur,dag:|en,we:ek|ken,maand:|en,jaar",
                months: "jan:uari|,feb:ruari|,maart|mrt,apr:il|,mei,jun:i|,jul:i|,aug:ustus|,sep:tember|,okt:ober|,nov:ember|,dec:ember|",
                weekdays: "zondag|zo,maandag|ma,dinsdag|di,woensdag|wo|woe,donderdag|do,vrijdag|vr|vrij,zaterdag|za",
                numerals: "nul,een,twee,drie,vier,vijf,zes,zeven,acht,negen,tien",
                short: "{dd}-{MM}-{yyyy}",
                medium: "{d} {month} {yyyy}",
                long: "{d} {Month} {yyyy} {time}",
                full: "{weekday} {d} {Month} {yyyy} {time}",
                stamp: "{dow} {d} {Mon} {yyyy} {time}",
                time: "{H}:{mm}",
                past: "{num} {unit} {sign}",
                future: "{num} {unit} {sign}",
                duration: "{num} {unit}",
                timeMarkers: "'s,om",
                modifiers: [
                    {
                        name: "day",
                        src: "gisteren",
                        value: -1
                    },
                    {
                        name: "day",
                        src: "vandaag",
                        value: 0
                    },
                    {
                        name: "day",
                        src: "morgen",
                        value: 1
                    },
                    {
                        name: "day",
                        src: "overmorgen",
                        value: 2
                    },
                    {
                        name: "sign",
                        src: "geleden",
                        value: -1
                    },
                    {
                        name: "sign",
                        src: "vanaf nu",
                        value: 1
                    },
                    {
                        name: "shift",
                        src: "laatste|vorige|afgelopen",
                        value: -1
                    },
                    {
                        name: "shift",
                        src: "volgend:|e",
                        value: 1
                    }
                ],
                parse: [
                    "{months} {year?}",
                    "{num} {unit} {sign}",
                    "{0?} {unit:5-7} {shift}",
                    "{0?} {shift} {unit:5-7}"
                ],
                timeParse: [
                    "{shift?} {day|weekday}",
                    "{weekday?},? {date} {months?}\\.? {year?}"
                ],
                timeFrontParse: [
                    "{shift?} {day|weekday}",
                    "{weekday?},? {date} {months?}\\.? {year?}"
                ]
            });
        },
        function(t, e, n) {
            "use strict";
            n(11)("no", {
                plural: !0,
                units: "millisekund:|er,sekund:|er,minutt:|er,tim:e|er,dag:|er,uk:e|er|en,m\xe5ned:|er|en+maaned:|er|en,\xe5r:||et+aar:||et",
                months: "januar,februar,mars,april,mai,juni,juli,august,september,oktober,november,desember",
                weekdays: "s\xf8ndag|sondag,mandag,tirsdag,onsdag,torsdag,fredag,l\xf8rdag|lordag",
                numerals: "en|et,to,tre,fire,fem,seks,sju|syv,\xe5tte,ni,ti",
                tokens: "den,for",
                articles: "den",
                short: "d. {d}. {month} {yyyy}",
                long: "den {d}. {month} {yyyy} {H}:{mm}",
                full: "{Weekday} den {d}. {month} {yyyy} {H}:{mm}:{ss}",
                past: "{num} {unit} {sign}",
                future: "{sign} {num} {unit}",
                duration: "{num} {unit}",
                ampm: "am,pm",
                modifiers: [
                    {
                        name: "day",
                        src: "forg\xe5rs|i forg\xe5rs|forgaars|i forgaars",
                        value: -2
                    },
                    {
                        name: "day",
                        src: "i g\xe5r|ig\xe5r|i gaar|igaar",
                        value: -1
                    },
                    {
                        name: "day",
                        src: "i dag|idag",
                        value: 0
                    },
                    {
                        name: "day",
                        src: "i morgen|imorgen",
                        value: 1
                    },
                    {
                        name: "day",
                        src: "overimorgen|overmorgen|over i morgen",
                        value: 2
                    },
                    {
                        name: "sign",
                        src: "siden",
                        value: -1
                    },
                    {
                        name: "sign",
                        src: "om",
                        value: 1
                    },
                    {
                        name: "shift",
                        src: "i siste|siste",
                        value: -1
                    },
                    {
                        name: "shift",
                        src: "denne",
                        value: 0
                    },
                    {
                        name: "shift",
                        src: "neste",
                        value: 1
                    }
                ],
                parse: [
                    "{num} {unit} {sign}",
                    "{sign} {num} {unit}",
                    "{1?} {num} {unit} {sign}",
                    "{shift} {unit:5-7}"
                ],
                timeParse: [
                    "{date} {month}",
                    "{shift} {weekday}",
                    "{0?} {weekday?},? {date?} {month}\\.? {year}"
                ]
            });
        },
        function(t, e, n) {
            "use strict";
            n(11)("pl", {
                plural: !0,
                units: "milisekund:a|y|,sekund:a|y|,minut:a|y|,godzin:a|y|,dzie\u0144|dni|dni,tydzie\u0144|tygodnie|tygodni,miesi\u0105c|miesi\u0105ce|miesi\u0119cy,rok|lata|lat",
                months: "sty:cznia||cze\u0144,lut:ego||y,mar:ca||zec,kwi:etnia||ecie\u0144,maj:a|,cze:rwca||rwiec,lip:ca||iec,sie:rpnia||rpie\u0144,wrz:e\u015Bnia||esie\u0144,pa\u017A:dziernika||dziernik,lis:topada||topad,gru:dnia||dzie\u0144",
                weekdays: "nie:dziela||dziel\u0119,pon:iedzia\u0142ek|,wt:orek|,\u015Br:oda||od\u0119,czw:artek|,pi\u0105tek|pt,sobota|sb|sobot\u0119",
                numerals: "zero,jeden|jedn\u0105,dwa|dwie,trzy,cztery,pi\u0119\u0107,sze\u015B\u0107,siedem,osiem,dziewi\u0119\u0107,dziesi\u0119\u0107",
                tokens: "w|we,roku",
                short: "{dd}.{MM}.{yyyy}",
                medium: "{d} {month} {yyyy}",
                long: "{d} {month} {yyyy} {time}",
                full: "{weekday}, {d} {month} {yyyy} {time}",
                stamp: "{dow} {d} {mon} {yyyy} {time}",
                time: "{H}:{mm}",
                timeMarkers: "o",
                ampm: "am,pm",
                modifiers: [
                    {
                        name: "day",
                        src: "przedwczoraj",
                        value: -2
                    },
                    {
                        name: "day",
                        src: "wczoraj",
                        value: -1
                    },
                    {
                        name: "day",
                        src: "dzisiaj|dzi\u015B",
                        value: 0
                    },
                    {
                        name: "day",
                        src: "jutro",
                        value: 1
                    },
                    {
                        name: "day",
                        src: "pojutrze",
                        value: 2
                    },
                    {
                        name: "sign",
                        src: "temu|przed",
                        value: -1
                    },
                    {
                        name: "sign",
                        src: "za",
                        value: 1
                    },
                    {
                        name: "shift",
                        src: "zesz\u0142y|zesz\u0142a|ostatni|ostatnia",
                        value: -1
                    },
                    {
                        name: "shift",
                        src: "nast\u0119pny|nast\u0119pna|nast\u0119pnego|przysz\u0142y|przysz\u0142a|przysz\u0142ego",
                        value: 1
                    }
                ],
                relative: function(t, e, n, r) {
                    var i;
                    if (4 === e) {
                        if (1 === t && "past" === r) return "wczoraj";
                        if (1 === t && "future" === r) return "jutro";
                        if (2 === t && "past" === r) return "przedwczoraj";
                        if (2 === t && "future" === r) return "pojutrze";
                    }
                    var s = +t.toFixed(0).slice(-1), a = +t.toFixed(0).slice(-2);
                    switch(!0){
                        case 1 === t:
                            i = 0;
                            break;
                        case 12 <= a && a <= 14:
                            i = 2;
                            break;
                        case 2 <= s && s <= 4:
                            i = 1;
                            break;
                        default:
                            i = 2;
                    }
                    var o = this.units[8 * i + e], u = t + " ";
                    switch("past" !== r && "future" !== r || 1 !== t || (o = o.replace(/a$/, "\u0119")), o = u + o, r){
                        case "duration":
                            return o;
                        case "past":
                            return o + " temu";
                        case "future":
                            return "za " + o;
                    }
                },
                parse: [
                    "{num} {unit} {sign}",
                    "{sign} {num} {unit}",
                    "{months} {year?}",
                    "{shift} {unit:5-7}",
                    "{0} {shift?} {weekday}"
                ],
                timeFrontParse: [
                    "{day|weekday}",
                    "{date} {months} {year?} {1?}",
                    "{0?} {shift?} {weekday}"
                ]
            });
        },
        function(t, e, n) {
            "use strict";
            n(11)("pt", {
                plural: !0,
                units: "milisegundo:|s,segundo:|s,minuto:|s,hora:|s,dia:|s,semana:|s,m\xeas|m\xeases|mes|meses,ano:|s",
                months: "jan:eiro|,fev:ereiro|,mar:\xe7o|,abr:il|,mai:o|,jun:ho|,jul:ho|,ago:sto|,set:embro|,out:ubro|,nov:embro|,dez:embro|",
                weekdays: "dom:ingo|,seg:unda-feira|,ter:\xe7a-feira|,qua:rta-feira|,qui:nta-feira|,sex:ta-feira|,s\xe1b:ado||ado",
                numerals: "zero,um:|a,dois|duas,tr\xeas|tres,quatro,cinco,seis,sete,oito,nove,dez",
                tokens: "a,de",
                short: "{dd}/{MM}/{yyyy}",
                medium: "{d} de {Month} de {yyyy}",
                long: "{d} de {Month} de {yyyy} {time}",
                full: "{Weekday}, {d} de {Month} de {yyyy} {time}",
                stamp: "{Dow} {d} {Mon} {yyyy} {time}",
                time: "{H}:{mm}",
                past: "{num} {unit} {sign}",
                future: "{sign} {num} {unit}",
                duration: "{num} {unit}",
                timeMarkers: "\xe0s",
                ampm: "am,pm",
                modifiers: [
                    {
                        name: "day",
                        src: "anteontem",
                        value: -2
                    },
                    {
                        name: "day",
                        src: "ontem",
                        value: -1
                    },
                    {
                        name: "day",
                        src: "hoje",
                        value: 0
                    },
                    {
                        name: "day",
                        src: "amanh:\xe3|a",
                        value: 1
                    },
                    {
                        name: "sign",
                        src: "atr\xe1s|atras|h\xe1|ha",
                        value: -1
                    },
                    {
                        name: "sign",
                        src: "daqui a",
                        value: 1
                    },
                    {
                        name: "shift",
                        src: "passad:o|a",
                        value: -1
                    },
                    {
                        name: "shift",
                        src: "pr\xf3ximo|pr\xf3xima|proximo|proxima",
                        value: 1
                    }
                ],
                parse: [
                    "{months} {1?} {year?}",
                    "{num} {unit} {sign}",
                    "{sign} {num} {unit}",
                    "{0?} {unit:5-7} {shift}",
                    "{0?} {shift} {unit:5-7}"
                ],
                timeParse: [
                    "{shift?} {day|weekday}",
                    "{0?} {shift} {weekday}",
                    "{date} {1?} {months?} {1?} {year?}"
                ],
                timeFrontParse: [
                    "{shift?} {day|weekday}",
                    "{date} {1?} {months?} {1?} {year?}"
                ]
            });
        },
        function(t, e, n) {
            "use strict";
            n(11)("ru", {
                firstDayOfWeekYear: 1,
                units: "\u043C\u0438\u043B\u043B\u0438\u0441\u0435\u043A\u0443\u043D\u0434:\u0430|\u0443|\u044B|,\u0441\u0435\u043A\u0443\u043D\u0434:\u0430|\u0443|\u044B|,\u043C\u0438\u043D\u0443\u0442:\u0430|\u0443|\u044B|,\u0447\u0430\u0441:||\u0430|\u043E\u0432,\u0434\u0435\u043D\u044C|\u0434\u0435\u043D\u044C|\u0434\u043D\u044F|\u0434\u043D\u0435\u0439,\u043D\u0435\u0434\u0435\u043B:\u044F|\u044E|\u0438|\u044C|\u0435,\u043C\u0435\u0441\u044F\u0446:||\u0430|\u0435\u0432|\u0435,\u0433\u043E\u0434|\u0433\u043E\u0434|\u0433\u043E\u0434\u0430|\u043B\u0435\u0442|\u0433\u043E\u0434\u0443",
                months: "\u044F\u043D\u0432:\u0430\u0440\u044F||.|\u0430\u0440\u044C,\u0444\u0435\u0432:\u0440\u0430\u043B\u044F||\u0440.|\u0440\u0430\u043B\u044C,\u043C\u0430\u0440:\u0442\u0430||\u0442,\u0430\u043F\u0440:\u0435\u043B\u044F||.|\u0435\u043B\u044C,\u043C\u0430\u044F|\u043C\u0430\u0439,\u0438\u044E\u043D:\u044F||\u044C,\u0438\u044E\u043B:\u044F||\u044C,\u0430\u0432\u0433:\u0443\u0441\u0442\u0430||.|\u0443\u0441\u0442,\u0441\u0435\u043D:\u0442\u044F\u0431\u0440\u044F||\u0442.|\u0442\u044F\u0431\u0440\u044C,\u043E\u043A\u0442:\u044F\u0431\u0440\u044F||.|\u044F\u0431\u0440\u044C,\u043D\u043E\u044F:\u0431\u0440\u044F||\u0431\u0440\u044C,\u0434\u0435\u043A:\u0430\u0431\u0440\u044F||.|\u0430\u0431\u0440\u044C",
                weekdays: "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435|\u0432\u0441,\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A|\u043F\u043D,\u0432\u0442\u043E\u0440\u043D\u0438\u043A|\u0432\u0442,\u0441\u0440\u0435\u0434\u0430|\u0441\u0440,\u0447\u0435\u0442\u0432\u0435\u0440\u0433|\u0447\u0442,\u043F\u044F\u0442\u043D\u0438\u0446\u0430|\u043F\u0442,\u0441\u0443\u0431\u0431\u043E\u0442\u0430|\u0441\u0431",
                numerals: "\u043D\u043E\u043B\u044C,\u043E\u0434:\u0438\u043D|\u043D\u0443,\u0434\u0432:\u0430|\u0435,\u0442\u0440\u0438,\u0447\u0435\u0442\u044B\u0440\u0435,\u043F\u044F\u0442\u044C,\u0448\u0435\u0441\u0442\u044C,\u0441\u0435\u043C\u044C,\u0432\u043E\u0441\u0435\u043C\u044C,\u0434\u0435\u0432\u044F\u0442\u044C,\u0434\u0435\u0441\u044F\u0442\u044C",
                tokens: "\u0432|\u043D\u0430,\u0433\\.?(?:\u043E\u0434\u0430)?",
                short: "{dd}.{MM}.{yyyy}",
                medium: "{d} {month} {yyyy} \u0433.",
                long: "{d} {month} {yyyy} \u0433., {time}",
                full: "{weekday}, {d} {month} {yyyy} \u0433., {time}",
                stamp: "{dow} {d} {mon} {yyyy} {time}",
                time: "{H}:{mm}",
                timeMarkers: "\u0432",
                ampm: " \u0443\u0442\u0440\u0430, \u0432\u0435\u0447\u0435\u0440\u0430",
                modifiers: [
                    {
                        name: "day",
                        src: "\u043F\u043E\u0437\u0430\u0432\u0447\u0435\u0440\u0430",
                        value: -2
                    },
                    {
                        name: "day",
                        src: "\u0432\u0447\u0435\u0440\u0430",
                        value: -1
                    },
                    {
                        name: "day",
                        src: "\u0441\u0435\u0433\u043E\u0434\u043D\u044F",
                        value: 0
                    },
                    {
                        name: "day",
                        src: "\u0437\u0430\u0432\u0442\u0440\u0430",
                        value: 1
                    },
                    {
                        name: "day",
                        src: "\u043F\u043E\u0441\u043B\u0435\u0437\u0430\u0432\u0442\u0440\u0430",
                        value: 2
                    },
                    {
                        name: "sign",
                        src: "\u043D\u0430\u0437\u0430\u0434",
                        value: -1
                    },
                    {
                        name: "sign",
                        src: "\u0447\u0435\u0440\u0435\u0437",
                        value: 1
                    },
                    {
                        name: "shift",
                        src: "\u043F\u0440\u043E\u0448\u043B:\u044B\u0439|\u043E\u0439|\u043E\u043C",
                        value: -1
                    },
                    {
                        name: "shift",
                        src: "\u0441\u043B\u0435\u0434\u0443\u044E\u0449:\u0438\u0439|\u0435\u0439|\u0435\u043C",
                        value: 1
                    }
                ],
                relative: function(t, e, n, r) {
                    var i, s, a = t.toString().slice(-1);
                    switch(!0){
                        case 11 <= t && t <= 15:
                            s = 3;
                            break;
                        case 1 == a:
                            s = 1;
                            break;
                        case 2 <= a && a <= 4:
                            s = 2;
                            break;
                        default:
                            s = 3;
                    }
                    switch(i = t + " " + this.units[8 * s + e], r){
                        case "duration":
                            return i;
                        case "past":
                            return i + " \u043D\u0430\u0437\u0430\u0434";
                        case "future":
                            return "\u0447\u0435\u0440\u0435\u0437 " + i;
                    }
                },
                parse: [
                    "{num} {unit} {sign}",
                    "{sign} {num} {unit}",
                    "{months} {year?}",
                    "{0?} {shift} {unit:5-7}"
                ],
                timeParse: [
                    "{day|weekday}",
                    "{0?} {shift} {weekday}",
                    "{date} {months?} {year?} {1?}"
                ],
                timeFrontParse: [
                    "{0?} {shift} {weekday}",
                    "{date} {months?} {year?} {1?}"
                ]
            });
        },
        function(t, e, n) {
            "use strict";
            n(11)("sv", {
                plural: !0,
                units: "millisekund:|er,sekund:|er,minut:|er,timm:e|ar,dag:|ar,veck:a|or|an,m\xe5nad:|er|en+manad:|er|en,\xe5r:||et+ar:||et",
                months: "jan:uari|,feb:ruari|,mar:s|,apr:il|,maj,jun:i|,jul:i|,aug:usti|,sep:tember|,okt:ober|,nov:ember|,dec:ember|",
                weekdays: "s\xf6n:dag|+son:dag|,m\xe5n:dag||dagen+man:dag||dagen,tis:dag|,ons:dag|,tor:sdag|,fre:dag|,l\xf6r:dag||dag",
                numerals: "noll,en|ett,tv\xe5|tva,tre,fyra,fem,sex,sju,\xe5tta|atta,nio,tio",
                tokens: "den,f\xf6r|for",
                articles: "den",
                short: "{yyyy}-{MM}-{dd}",
                medium: "{d} {month} {yyyy}",
                long: "{d} {month} {yyyy} {time}",
                full: "{weekday} {d} {month} {yyyy} {time}",
                stamp: "{dow} {d} {mon} {yyyy} {time}",
                time: "{H}:{mm}",
                past: "{num} {unit} {sign}",
                future: "{sign} {num} {unit}",
                duration: "{num} {unit}",
                ampm: "am,pm",
                modifiers: [
                    {
                        name: "day",
                        src: "f\xf6rrg\xe5r|i f\xf6rrg\xe5r|if\xf6rrg\xe5r|forrgar|i forrgar|iforrgar",
                        value: -2
                    },
                    {
                        name: "day",
                        src: "g\xe5r|i g\xe5r|ig\xe5r|gar|i gar|igar",
                        value: -1
                    },
                    {
                        name: "day",
                        src: "dag|i dag|idag",
                        value: 0
                    },
                    {
                        name: "day",
                        src: "morgon|i morgon|imorgon",
                        value: 1
                    },
                    {
                        name: "day",
                        src: "\xf6ver morgon|\xf6vermorgon|i \xf6ver morgon|i \xf6vermorgon|i\xf6vermorgon|over morgon|overmorgon|i over morgon|i overmorgon|iovermorgon",
                        value: 2
                    },
                    {
                        name: "sign",
                        src: "sedan|sen",
                        value: -1
                    },
                    {
                        name: "sign",
                        src: "om",
                        value: 1
                    },
                    {
                        name: "shift",
                        src: "i f\xf6rra|f\xf6rra|i forra|forra",
                        value: -1
                    },
                    {
                        name: "shift",
                        src: "denna",
                        value: 0
                    },
                    {
                        name: "shift",
                        src: "n\xe4sta|nasta",
                        value: 1
                    }
                ],
                parse: [
                    "{months} {year?}",
                    "{num} {unit} {sign}",
                    "{sign} {num} {unit}",
                    "{1?} {num} {unit} {sign}",
                    "{shift} {unit:5-7}"
                ],
                timeParse: [
                    "{day|weekday}",
                    "{shift} {weekday}",
                    "{0?} {weekday?},? {date} {months?}\\.? {year?}"
                ],
                timeFrontParse: [
                    "{day|weekday}",
                    "{shift} {weekday}",
                    "{0?} {weekday?},? {date} {months?}\\.? {year?}"
                ]
            });
        },
        function(t, e, n) {
            "use strict";
            n(11)("zh-CN", {
                ampmFront: !0,
                numeralUnits: !0,
                allowsFullWidth: !0,
                timeMarkerOptional: !0,
                units: "\u6BEB\u79D2,\u79D2\u949F,\u5206\u949F,\u5C0F\u65F6,\u5929,\u4E2A\u661F\u671F|\u5468,\u4E2A\u6708,\u5E74",
                weekdays: "\u661F\u671F\u65E5|\u65E5|\u5468\u65E5|\u661F\u671F\u5929,\u661F\u671F\u4E00|\u4E00|\u5468\u4E00,\u661F\u671F\u4E8C|\u4E8C|\u5468\u4E8C,\u661F\u671F\u4E09|\u4E09|\u5468\u4E09,\u661F\u671F\u56DB|\u56DB|\u5468\u56DB,\u661F\u671F\u4E94|\u4E94|\u5468\u4E94,\u661F\u671F\u516D|\u516D|\u5468\u516D",
                numerals: "\u3007,\u4E00,\u4E8C,\u4E09,\u56DB,\u4E94,\u516D,\u4E03,\u516B,\u4E5D",
                placeholders: "\u5341,\u767E,\u5343,\u4E07",
                short: "{yyyy}-{MM}-{dd}",
                medium: "{yyyy}\u5E74{M}\u6708{d}\u65E5",
                long: "{yyyy}\u5E74{M}\u6708{d}\u65E5{time}",
                full: "{yyyy}\u5E74{M}\u6708{d}\u65E5{weekday}{time}",
                stamp: "{yyyy}\u5E74{M}\u6708{d}\u65E5{H}:{mm}{dow}",
                time: "{tt}{h}\u70B9{mm}\u5206",
                past: "{num}{unit}{sign}",
                future: "{num}{unit}{sign}",
                duration: "{num}{unit}",
                timeSuffixes: ",\u79D2,\u5206\u949F?,\u70B9|\u65F6,\u65E5|\u53F7,,\u6708,\u5E74",
                ampm: "\u4E0A\u5348,\u4E0B\u5348",
                modifiers: [
                    {
                        name: "day",
                        src: "\u5927\u524D\u5929",
                        value: -3
                    },
                    {
                        name: "day",
                        src: "\u524D\u5929",
                        value: -2
                    },
                    {
                        name: "day",
                        src: "\u6628\u5929",
                        value: -1
                    },
                    {
                        name: "day",
                        src: "\u4ECA\u5929",
                        value: 0
                    },
                    {
                        name: "day",
                        src: "\u660E\u5929",
                        value: 1
                    },
                    {
                        name: "day",
                        src: "\u540E\u5929",
                        value: 2
                    },
                    {
                        name: "day",
                        src: "\u5927\u540E\u5929",
                        value: 3
                    },
                    {
                        name: "sign",
                        src: "\u524D",
                        value: -1
                    },
                    {
                        name: "sign",
                        src: "\u540E",
                        value: 1
                    },
                    {
                        name: "shift",
                        src: "\u4E0A|\u53BB",
                        value: -1
                    },
                    {
                        name: "shift",
                        src: "\u8FD9",
                        value: 0
                    },
                    {
                        name: "shift",
                        src: "\u4E0B|\u660E",
                        value: 1
                    }
                ],
                parse: [
                    "{num}{unit}{sign}",
                    "{shift}{unit:5-7}",
                    "{year?}{month}",
                    "{year}"
                ],
                timeParse: [
                    "{day|weekday}",
                    "{shift}{weekday}",
                    "{year?}{month?}{date}"
                ]
            });
        },
        function(t, e, n) {
            "use strict";
            n(11)("zh-TW", {
                ampmFront: !0,
                numeralUnits: !0,
                allowsFullWidth: !0,
                timeMarkerOptional: !0,
                units: "\u6BEB\u79D2,\u79D2\u9418,\u5206\u9418,\u5C0F\u6642,\u5929,\u500B\u661F\u671F|\u9031,\u500B\u6708,\u5E74",
                weekdays: "\u661F\u671F\u65E5|\u65E5|\u9031\u65E5|\u661F\u671F\u5929,\u661F\u671F\u4E00|\u4E00|\u9031\u4E00,\u661F\u671F\u4E8C|\u4E8C|\u9031\u4E8C,\u661F\u671F\u4E09|\u4E09|\u9031\u4E09,\u661F\u671F\u56DB|\u56DB|\u9031\u56DB,\u661F\u671F\u4E94|\u4E94|\u9031\u4E94,\u661F\u671F\u516D|\u516D|\u9031\u516D",
                numerals: "\u3007,\u4E00,\u4E8C,\u4E09,\u56DB,\u4E94,\u516D,\u4E03,\u516B,\u4E5D",
                placeholders: "\u5341,\u767E,\u5343,\u4E07",
                short: "{yyyy}/{MM}/{dd}",
                medium: "{yyyy}\u5E74{M}\u6708{d}\u65E5",
                long: "{yyyy}\u5E74{M}\u6708{d}\u65E5{time}",
                full: "{yyyy}\u5E74{M}\u6708{d}\u65E5{weekday}{time}",
                stamp: "{yyyy}\u5E74{M}\u6708{d}\u65E5{H}:{mm}{dow}",
                time: "{tt}{h}\u9EDE{mm}\u5206",
                past: "{num}{unit}{sign}",
                future: "{num}{unit}{sign}",
                duration: "{num}{unit}",
                timeSuffixes: ",\u79D2,\u5206\u9418?,\u9EDE|\u6642,\u65E5|\u865F,,\u6708,\u5E74",
                ampm: "\u4E0A\u5348,\u4E0B\u5348",
                modifiers: [
                    {
                        name: "day",
                        src: "\u5927\u524D\u5929",
                        value: -3
                    },
                    {
                        name: "day",
                        src: "\u524D\u5929",
                        value: -2
                    },
                    {
                        name: "day",
                        src: "\u6628\u5929",
                        value: -1
                    },
                    {
                        name: "day",
                        src: "\u4ECA\u5929",
                        value: 0
                    },
                    {
                        name: "day",
                        src: "\u660E\u5929",
                        value: 1
                    },
                    {
                        name: "day",
                        src: "\u5F8C\u5929",
                        value: 2
                    },
                    {
                        name: "day",
                        src: "\u5927\u5F8C\u5929",
                        value: 3
                    },
                    {
                        name: "sign",
                        src: "\u524D",
                        value: -1
                    },
                    {
                        name: "sign",
                        src: "\u5F8C",
                        value: 1
                    },
                    {
                        name: "shift",
                        src: "\u4E0A|\u53BB",
                        value: -1
                    },
                    {
                        name: "shift",
                        src: "\u9019",
                        value: 0
                    },
                    {
                        name: "shift",
                        src: "\u4E0B|\u660E",
                        value: 1
                    }
                ],
                parse: [
                    "{num}{unit}{sign}",
                    "{shift}{unit:5-7}",
                    "{year?}{month}",
                    "{year}"
                ],
                timeParse: [
                    "{day|weekday}",
                    "{shift}{weekday}",
                    "{year?}{month?}{date}"
                ]
            });
        }
    ]);
});

});

parcelRegister("1ISRg", function(module, exports) {

$parcel$export(module.exports, "default", () => $1414742b55b279f2$export$2e2bcd8739ae039);
// noinspection JSUnusedGlobalSymbols

var $exbAN = parcelRequire("exbAN");

var $aa4j7 = parcelRequire("aa4j7");

var $5hw4O = parcelRequire("5hw4O");

var $lSH1h = parcelRequire("lSH1h");

var $gIIrM = parcelRequire("gIIrM");

var $f1dSb = parcelRequire("f1dSb");
class $1414742b55b279f2$export$2e2bcd8739ae039 {
    static init() {
        $(()=>{
            (0, $exbAN.default).init();
            (0, $aa4j7.default).init();
            (0, $5hw4O.default).init();
            (0, $gIIrM.default).init();
            (0, $f1dSb.default).init();
        });
    }
    static change_site(site_id) {
        if (!(0, $lSH1h.default).int(site_id)) return;
        document.cookie = `site=${site_id}; path=/; max-age=${31536000}`;
        location.reload();
    }
}

});
parcelRegister("exbAN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a94d23c6e0852e8c$export$2e2bcd8739ae039);

var $gSvKi = parcelRequire("gSvKi");

var $lSH1h = parcelRequire("lSH1h");
class $a94d23c6e0852e8c$export$2e2bcd8739ae039 {
    static init() {
        this.date_picker();
        this.time_picker();
        this.datetime_picker();
        this.daterange_picker();
    }
    static date_picker() {
        $('input.__date').each((index, element)=>{
            const option = {
                locale: {
                    format: 'YYYY-MM-DD',
                    daysOfWeek: [
                        "\u65E5",
                        "\u6708",
                        "\u706B",
                        "\u6C34",
                        "\u6728",
                        "\u91D1",
                        "\u571F"
                    ],
                    monthNames: [
                        "1\u6708",
                        "2\u6708",
                        "3\u6708",
                        "4\u6708",
                        "5\u6708",
                        "6\u6708",
                        "7\u6708",
                        "8\u6708",
                        "9\u6708",
                        "10\u6708",
                        "11\u6708",
                        "12\u6708"
                    ]
                },
                autoUpdateInput: false,
                autoApply: true,
                singleDatePicker: true,
                minYear: 2022
            };
            const min_date = $(element).data('min-date');
            if ((0, $lSH1h.default).filled(min_date)) option.minDate = min_date;
            $(element).daterangepicker(option);
            $(element).on('apply.daterangepicker', function(event, picker) {
                $(this).val(picker.startDate.format('YYYY-MM-DD'));
                this.dispatchEvent(new Event('change'));
            });
        });
    }
    static time_picker() {
        $('input.__time').each((index, element)=>{
            $(element).daterangepicker({
                timePicker: true,
                timePicker24Hour: true,
                timePickerIncrement: 15,
                singleDatePicker: true,
                locale: {
                    format: 'HH:mm',
                    applyLabel: "\u9069\u7528",
                    cancelLabel: "\u30AD\u30E3\u30F3\u30BB\u30EB"
                }
            }).on('show.daterangepicker', function(_, picker) {
                picker.container.find('.calendar-table').hide();
            });
        });
    }
    static datetime_picker() {
        const picker = $('input.__datetime');
        const option = {
            locale: {
                format: 'YYYY-MM-DD HH:mm',
                daysOfWeek: [
                    "\u65E5",
                    "\u6708",
                    "\u706B",
                    "\u6C34",
                    "\u6728",
                    "\u91D1",
                    "\u571F"
                ],
                monthNames: [
                    "1\u6708",
                    "2\u6708",
                    "3\u6708",
                    "4\u6708",
                    "5\u6708",
                    "6\u6708",
                    "7\u6708",
                    "8\u6708",
                    "9\u6708",
                    "10\u6708",
                    "11\u6708",
                    "12\u6708"
                ],
                cancelLabel: "\u30AD\u30E3\u30F3\u30BB\u30EB",
                applyLabel: "\u9069\u7528"
            },
            autoUpdateInput: false,
            singleDatePicker: true,
            timePicker: true,
            timePicker24Hour: true,
            minYear: 2022
        };
        const min_date = picker.data('min-date');
        if ((0, $lSH1h.default).filled(min_date)) option.minDate = min_date;
        picker.daterangepicker(option);
        picker.on('apply.daterangepicker', function(event, picker) {
            $(this).val(picker.startDate.format('YYYY-MM-DD HH:mm'));
            this.dispatchEvent(new Event('change'));
        });
    }
    static daterange_picker() {
        $('input.__daterange').each((index, element)=>{
            // noinspection NonAsciiCharacters
            $(element).daterangepicker({
                startDate: $(element).data('start'),
                endDate: $(element).data('end'),
                ranges: {
                    "\u4ECA\u65E5": [
                        (0, (/*@__PURE__*/$parcel$interopDefault($gSvKi)))(),
                        (0, (/*@__PURE__*/$parcel$interopDefault($gSvKi)))()
                    ],
                    "\u6628\u65E5": [
                        (0, (/*@__PURE__*/$parcel$interopDefault($gSvKi)))().subtract(1, 'day'),
                        (0, (/*@__PURE__*/$parcel$interopDefault($gSvKi)))().subtract(1, 'day')
                    ],
                    "\u4ECA\u9031": [
                        (0, (/*@__PURE__*/$parcel$interopDefault($gSvKi)))().startOf('week'),
                        (0, (/*@__PURE__*/$parcel$interopDefault($gSvKi)))().endOf('week')
                    ],
                    "\u5148\u9031": [
                        (0, (/*@__PURE__*/$parcel$interopDefault($gSvKi)))().subtract(1, 'week').startOf('week'),
                        (0, (/*@__PURE__*/$parcel$interopDefault($gSvKi)))().subtract(1, 'week').endOf('week')
                    ],
                    "\u4ECA\u6708": [
                        (0, (/*@__PURE__*/$parcel$interopDefault($gSvKi)))().startOf('month'),
                        (0, (/*@__PURE__*/$parcel$interopDefault($gSvKi)))().endOf('month')
                    ],
                    "\u5148\u6708": [
                        (0, (/*@__PURE__*/$parcel$interopDefault($gSvKi)))().subtract(1, 'month').startOf('month'),
                        (0, (/*@__PURE__*/$parcel$interopDefault($gSvKi)))().subtract(1, 'month').endOf('month')
                    ]
                },
                'alwaysShowCalendars': true,
                locale: {
                    format: 'YYYY-MM-DD',
                    customRangeLabel: "\u671F\u9593\u6307\u5B9A",
                    applyLabel: "\u9069\u7528",
                    cancelLabel: "\u30AD\u30E3\u30F3\u30BB\u30EB",
                    daysOfWeek: [
                        "\u65E5",
                        "\u6708",
                        "\u706B",
                        "\u6C34",
                        "\u6728",
                        "\u91D1",
                        "\u571F"
                    ],
                    monthNames: [
                        "1\u6708",
                        "2\u6708",
                        "3\u6708",
                        "4\u6708",
                        "5\u6708",
                        "6\u6708",
                        "7\u6708",
                        "8\u6708",
                        "9\u6708",
                        "10\u6708",
                        "11\u6708",
                        "12\u6708"
                    ]
                },
                minYear: 2022
            });
        });
    }
}

});
parcelRegister("gSvKi", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(this, function() {
    "use strict";
    var e, i;
    function c() {
        return e.apply(null, arguments);
    }
    function o(e) {
        return e instanceof Array || "[object Array]" === Object.prototype.toString.call(e);
    }
    function u(e) {
        return null != e && "[object Object]" === Object.prototype.toString.call(e);
    }
    function l(e) {
        return void 0 === e;
    }
    function h(e) {
        return "number" == typeof e || "[object Number]" === Object.prototype.toString.call(e);
    }
    function d(e) {
        return e instanceof Date || "[object Date]" === Object.prototype.toString.call(e);
    }
    function f(e, t) {
        var n, s = [];
        for(n = 0; n < e.length; ++n)s.push(t(e[n], n));
        return s;
    }
    function m(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
    }
    function _(e, t) {
        for(var n in t)m(t, n) && (e[n] = t[n]);
        return m(t, "toString") && (e.toString = t.toString), m(t, "valueOf") && (e.valueOf = t.valueOf), e;
    }
    function y(e, t, n, s) {
        return Tt(e, t, n, s, !0).utc();
    }
    function g(e) {
        return null == e._pf && (e._pf = {
            empty: !1,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: !1,
            invalidMonth: null,
            invalidFormat: !1,
            userInvalidated: !1,
            iso: !1,
            parsedDateParts: [],
            meridiem: null,
            rfc2822: !1,
            weekdayMismatch: !1
        }), e._pf;
    }
    function v(e) {
        if (null == e._isValid) {
            var t = g(e), n = i.call(t.parsedDateParts, function(e) {
                return null != e;
            }), s = !isNaN(e._d.getTime()) && t.overflow < 0 && !t.empty && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && n);
            if (e._strict && (s = s && 0 === t.charsLeftOver && 0 === t.unusedTokens.length && void 0 === t.bigHour), null != Object.isFrozen && Object.isFrozen(e)) return s;
            e._isValid = s;
        }
        return e._isValid;
    }
    function p(e) {
        var t = y(NaN);
        return null != e ? _(g(t), e) : g(t).userInvalidated = !0, t;
    }
    i = Array.prototype.some ? Array.prototype.some : function(e) {
        for(var t = Object(this), n = t.length >>> 0, s = 0; s < n; s++)if (s in t && e.call(this, t[s], s, t)) return !0;
        return !1;
    };
    var r = c.momentProperties = [];
    function w(e, t) {
        var n, s, i;
        if (l(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), l(t._i) || (e._i = t._i), l(t._f) || (e._f = t._f), l(t._l) || (e._l = t._l), l(t._strict) || (e._strict = t._strict), l(t._tzm) || (e._tzm = t._tzm), l(t._isUTC) || (e._isUTC = t._isUTC), l(t._offset) || (e._offset = t._offset), l(t._pf) || (e._pf = g(t)), l(t._locale) || (e._locale = t._locale), 0 < r.length) for(n = 0; n < r.length; n++)l(i = t[s = r[n]]) || (e[s] = i);
        return e;
    }
    var t = !1;
    function M(e) {
        w(this, e), this._d = new Date(null != e._d ? e._d.getTime() : NaN), this.isValid() || (this._d = new Date(NaN)), !1 === t && (t = !0, c.updateOffset(this), t = !1);
    }
    function k(e) {
        return e instanceof M || null != e && null != e._isAMomentObject;
    }
    function S(e) {
        return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
    }
    function D(e) {
        var t = +e, n = 0;
        return 0 !== t && isFinite(t) && (n = S(t)), n;
    }
    function a(e, t, n) {
        var s, i = Math.min(e.length, t.length), r = Math.abs(e.length - t.length), a = 0;
        for(s = 0; s < i; s++)(n && e[s] !== t[s] || !n && D(e[s]) !== D(t[s])) && a++;
        return a + r;
    }
    function Y(e) {
        !1 === c.suppressDeprecationWarnings && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + e);
    }
    function n(i, r) {
        var a = !0;
        return _(function() {
            if (null != c.deprecationHandler && c.deprecationHandler(null, i), a) {
                for(var e, t = [], n = 0; n < arguments.length; n++){
                    if (e = "", "object" == typeof arguments[n]) {
                        for(var s in e += "\n[" + n + "] ", arguments[0])e += s + ": " + arguments[0][s] + ", ";
                        e = e.slice(0, -2);
                    } else e = arguments[n];
                    t.push(e);
                }
                Y(i + "\nArguments: " + Array.prototype.slice.call(t).join("") + "\n" + (new Error).stack), a = !1;
            }
            return r.apply(this, arguments);
        }, r);
    }
    var s, O = {};
    function T(e, t) {
        null != c.deprecationHandler && c.deprecationHandler(e, t), O[e] || (Y(t), O[e] = !0);
    }
    function b(e) {
        return e instanceof Function || "[object Function]" === Object.prototype.toString.call(e);
    }
    function x(e, t) {
        var n, s = _({}, e);
        for(n in t)m(t, n) && (u(e[n]) && u(t[n]) ? (s[n] = {}, _(s[n], e[n]), _(s[n], t[n])) : null != t[n] ? s[n] = t[n] : delete s[n]);
        for(n in e)m(e, n) && !m(t, n) && u(e[n]) && (s[n] = _({}, s[n]));
        return s;
    }
    function P(e) {
        null != e && this.set(e);
    }
    c.suppressDeprecationWarnings = !1, c.deprecationHandler = null, s = Object.keys ? Object.keys : function(e) {
        var t, n = [];
        for(t in e)m(e, t) && n.push(t);
        return n;
    };
    var W = {};
    function C(e, t) {
        var n = e.toLowerCase();
        W[n] = W[n + "s"] = W[t] = e;
    }
    function H(e) {
        return "string" == typeof e ? W[e] || W[e.toLowerCase()] : void 0;
    }
    function R(e) {
        var t, n, s = {};
        for(n in e)m(e, n) && (t = H(n)) && (s[t] = e[n]);
        return s;
    }
    var U = {};
    function F(e, t) {
        U[e] = t;
    }
    function L(e, t, n) {
        var s = "" + Math.abs(e), i = t - s.length;
        return (0 <= e ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, i)).toString().substr(1) + s;
    }
    var N = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, G = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, V = {}, E = {};
    function I(e, t, n, s) {
        var i = s;
        "string" == typeof s && (i = function() {
            return this[s]();
        }), e && (E[e] = i), t && (E[t[0]] = function() {
            return L(i.apply(this, arguments), t[1], t[2]);
        }), n && (E[n] = function() {
            return this.localeData().ordinal(i.apply(this, arguments), e);
        });
    }
    function A(e, t) {
        return e.isValid() ? (t = j(t, e.localeData()), V[t] = V[t] || function(s) {
            var e, i, t, r = s.match(N);
            for(e = 0, i = r.length; e < i; e++)E[r[e]] ? r[e] = E[r[e]] : r[e] = (t = r[e]).match(/\[[\s\S]/) ? t.replace(/^\[|\]$/g, "") : t.replace(/\\/g, "");
            return function(e) {
                var t, n = "";
                for(t = 0; t < i; t++)n += b(r[t]) ? r[t].call(e, s) : r[t];
                return n;
            };
        }(t), V[t](e)) : e.localeData().invalidDate();
    }
    function j(e, t) {
        var n = 5;
        function s(e) {
            return t.longDateFormat(e) || e;
        }
        for(G.lastIndex = 0; 0 <= n && G.test(e);)e = e.replace(G, s), G.lastIndex = 0, n -= 1;
        return e;
    }
    var Z = /\d/, z = /\d\d/, $ = /\d{3}/, q = /\d{4}/, J = /[+-]?\d{6}/, B = /\d\d?/, Q = /\d\d\d\d?/, X = /\d\d\d\d\d\d?/, K = /\d{1,3}/, ee = /\d{1,4}/, te = /[+-]?\d{1,6}/, ne = /\d+/, se = /[+-]?\d+/, ie = /Z|[+-]\d\d:?\d\d/gi, re = /Z|[+-]\d\d(?::?\d\d)?/gi, ae = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, oe = {};
    function ue(e, n, s) {
        oe[e] = b(n) ? n : function(e, t) {
            return e && s ? s : n;
        };
    }
    function le(e, t) {
        return m(oe, e) ? oe[e](t._strict, t._locale) : new RegExp(he(e.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(e, t, n, s, i) {
            return t || n || s || i;
        })));
    }
    function he(e) {
        return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    var de = {};
    function ce(e, n) {
        var t, s = n;
        for("string" == typeof e && (e = [
            e
        ]), h(n) && (s = function(e, t) {
            t[n] = D(e);
        }), t = 0; t < e.length; t++)de[e[t]] = s;
    }
    function fe(e, i) {
        ce(e, function(e, t, n, s) {
            n._w = n._w || {}, i(e, n._w, n, s);
        });
    }
    var me = 0, _e = 1, ye = 2, ge = 3, ve = 4, pe = 5, we = 6, Me = 7, ke = 8;
    function Se(e) {
        return De(e) ? 366 : 365;
    }
    function De(e) {
        return e % 4 == 0 && e % 100 != 0 || e % 400 == 0;
    }
    I("Y", 0, 0, function() {
        var e = this.year();
        return e <= 9999 ? "" + e : "+" + e;
    }), I(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    }), I(0, [
        "YYYY",
        4
    ], 0, "year"), I(0, [
        "YYYYY",
        5
    ], 0, "year"), I(0, [
        "YYYYYY",
        6,
        !0
    ], 0, "year"), C("year", "y"), F("year", 1), ue("Y", se), ue("YY", B, z), ue("YYYY", ee, q), ue("YYYYY", te, J), ue("YYYYYY", te, J), ce([
        "YYYYY",
        "YYYYYY"
    ], me), ce("YYYY", function(e, t) {
        t[me] = 2 === e.length ? c.parseTwoDigitYear(e) : D(e);
    }), ce("YY", function(e, t) {
        t[me] = c.parseTwoDigitYear(e);
    }), ce("Y", function(e, t) {
        t[me] = parseInt(e, 10);
    }), c.parseTwoDigitYear = function(e) {
        return D(e) + (68 < D(e) ? 1900 : 2e3);
    };
    var Ye, Oe = Te("FullYear", !0);
    function Te(t, n) {
        return function(e) {
            return null != e ? (xe(this, t, e), c.updateOffset(this, n), this) : be(this, t);
        };
    }
    function be(e, t) {
        return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + t]() : NaN;
    }
    function xe(e, t, n) {
        e.isValid() && !isNaN(n) && ("FullYear" === t && De(e.year()) && 1 === e.month() && 29 === e.date() ? e._d["set" + (e._isUTC ? "UTC" : "") + t](n, e.month(), Pe(n, e.month())) : e._d["set" + (e._isUTC ? "UTC" : "") + t](n));
    }
    function Pe(e, t) {
        if (isNaN(e) || isNaN(t)) return NaN;
        var n, s = (t % (n = 12) + n) % n;
        return e += (t - s) / 12, 1 === s ? De(e) ? 29 : 28 : 31 - s % 7 % 2;
    }
    Ye = Array.prototype.indexOf ? Array.prototype.indexOf : function(e) {
        var t;
        for(t = 0; t < this.length; ++t)if (this[t] === e) return t;
        return -1;
    }, I("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    }), I("MMM", 0, 0, function(e) {
        return this.localeData().monthsShort(this, e);
    }), I("MMMM", 0, 0, function(e) {
        return this.localeData().months(this, e);
    }), C("month", "M"), F("month", 8), ue("M", B), ue("MM", B, z), ue("MMM", function(e, t) {
        return t.monthsShortRegex(e);
    }), ue("MMMM", function(e, t) {
        return t.monthsRegex(e);
    }), ce([
        "M",
        "MM"
    ], function(e, t) {
        t[_e] = D(e) - 1;
    }), ce([
        "MMM",
        "MMMM"
    ], function(e, t, n, s) {
        var i = n._locale.monthsParse(e, s, n._strict);
        null != i ? t[_e] = i : g(n).invalidMonth = e;
    });
    var We = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, Ce = "January_February_March_April_May_June_July_August_September_October_November_December".split("_");
    var He = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_");
    function Re(e, t) {
        var n;
        if (!e.isValid()) return e;
        if ("string" == typeof t) {
            if (/^\d+$/.test(t)) t = D(t);
            else if (!h(t = e.localeData().monthsParse(t))) return e;
        }
        return n = Math.min(e.date(), Pe(e.year(), t)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, n), e;
    }
    function Ue(e) {
        return null != e ? (Re(this, e), c.updateOffset(this, !0), this) : be(this, "Month");
    }
    var Fe = ae;
    var Le = ae;
    function Ne() {
        function e(e, t) {
            return t.length - e.length;
        }
        var t, n, s = [], i = [], r = [];
        for(t = 0; t < 12; t++)n = y([
            2e3,
            t
        ]), s.push(this.monthsShort(n, "")), i.push(this.months(n, "")), r.push(this.months(n, "")), r.push(this.monthsShort(n, ""));
        for(s.sort(e), i.sort(e), r.sort(e), t = 0; t < 12; t++)s[t] = he(s[t]), i[t] = he(i[t]);
        for(t = 0; t < 24; t++)r[t] = he(r[t]);
        this._monthsRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._monthsShortStrictRegex = new RegExp("^(" + s.join("|") + ")", "i");
    }
    function Ge(e) {
        var t;
        if (e < 100 && 0 <= e) {
            var n = Array.prototype.slice.call(arguments);
            n[0] = e + 400, t = new Date(Date.UTC.apply(null, n)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e);
        } else t = new Date(Date.UTC.apply(null, arguments));
        return t;
    }
    function Ve(e, t, n) {
        var s = 7 + t - n;
        return -((7 + Ge(e, 0, s).getUTCDay() - t) % 7) + s - 1;
    }
    function Ee(e, t, n, s, i) {
        var r, a, o = 1 + 7 * (t - 1) + (7 + n - s) % 7 + Ve(e, s, i);
        return a = o <= 0 ? Se(r = e - 1) + o : o > Se(e) ? (r = e + 1, o - Se(e)) : (r = e, o), {
            year: r,
            dayOfYear: a
        };
    }
    function Ie(e, t, n) {
        var s, i, r = Ve(e.year(), t, n), a = Math.floor((e.dayOfYear() - r - 1) / 7) + 1;
        return a < 1 ? s = a + Ae(i = e.year() - 1, t, n) : a > Ae(e.year(), t, n) ? (s = a - Ae(e.year(), t, n), i = e.year() + 1) : (i = e.year(), s = a), {
            week: s,
            year: i
        };
    }
    function Ae(e, t, n) {
        var s = Ve(e, t, n), i = Ve(e + 1, t, n);
        return (Se(e) - s + i) / 7;
    }
    I("w", [
        "ww",
        2
    ], "wo", "week"), I("W", [
        "WW",
        2
    ], "Wo", "isoWeek"), C("week", "w"), C("isoWeek", "W"), F("week", 5), F("isoWeek", 5), ue("w", B), ue("ww", B, z), ue("W", B), ue("WW", B, z), fe([
        "w",
        "ww",
        "W",
        "WW"
    ], function(e, t, n, s) {
        t[s.substr(0, 1)] = D(e);
    });
    function je(e, t) {
        return e.slice(t, 7).concat(e.slice(0, t));
    }
    I("d", 0, "do", "day"), I("dd", 0, 0, function(e) {
        return this.localeData().weekdaysMin(this, e);
    }), I("ddd", 0, 0, function(e) {
        return this.localeData().weekdaysShort(this, e);
    }), I("dddd", 0, 0, function(e) {
        return this.localeData().weekdays(this, e);
    }), I("e", 0, 0, "weekday"), I("E", 0, 0, "isoWeekday"), C("day", "d"), C("weekday", "e"), C("isoWeekday", "E"), F("day", 11), F("weekday", 11), F("isoWeekday", 11), ue("d", B), ue("e", B), ue("E", B), ue("dd", function(e, t) {
        return t.weekdaysMinRegex(e);
    }), ue("ddd", function(e, t) {
        return t.weekdaysShortRegex(e);
    }), ue("dddd", function(e, t) {
        return t.weekdaysRegex(e);
    }), fe([
        "dd",
        "ddd",
        "dddd"
    ], function(e, t, n, s) {
        var i = n._locale.weekdaysParse(e, s, n._strict);
        null != i ? t.d = i : g(n).invalidWeekday = e;
    }), fe([
        "d",
        "e",
        "E"
    ], function(e, t, n, s) {
        t[s] = D(e);
    });
    var Ze = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_");
    var ze = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_");
    var $e = "Su_Mo_Tu_We_Th_Fr_Sa".split("_");
    var qe = ae;
    var Je = ae;
    var Be = ae;
    function Qe() {
        function e(e, t) {
            return t.length - e.length;
        }
        var t, n, s, i, r, a = [], o = [], u = [], l = [];
        for(t = 0; t < 7; t++)n = y([
            2e3,
            1
        ]).day(t), s = this.weekdaysMin(n, ""), i = this.weekdaysShort(n, ""), r = this.weekdays(n, ""), a.push(s), o.push(i), u.push(r), l.push(s), l.push(i), l.push(r);
        for(a.sort(e), o.sort(e), u.sort(e), l.sort(e), t = 0; t < 7; t++)o[t] = he(o[t]), u[t] = he(u[t]), l[t] = he(l[t]);
        this._weekdaysRegex = new RegExp("^(" + l.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp("^(" + u.join("|") + ")", "i"), this._weekdaysShortStrictRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._weekdaysMinStrictRegex = new RegExp("^(" + a.join("|") + ")", "i");
    }
    function Xe() {
        return this.hours() % 12 || 12;
    }
    function Ke(e, t) {
        I(e, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), t);
        });
    }
    function et(e, t) {
        return t._meridiemParse;
    }
    I("H", [
        "HH",
        2
    ], 0, "hour"), I("h", [
        "hh",
        2
    ], 0, Xe), I("k", [
        "kk",
        2
    ], 0, function() {
        return this.hours() || 24;
    }), I("hmm", 0, 0, function() {
        return "" + Xe.apply(this) + L(this.minutes(), 2);
    }), I("hmmss", 0, 0, function() {
        return "" + Xe.apply(this) + L(this.minutes(), 2) + L(this.seconds(), 2);
    }), I("Hmm", 0, 0, function() {
        return "" + this.hours() + L(this.minutes(), 2);
    }), I("Hmmss", 0, 0, function() {
        return "" + this.hours() + L(this.minutes(), 2) + L(this.seconds(), 2);
    }), Ke("a", !0), Ke("A", !1), C("hour", "h"), F("hour", 13), ue("a", et), ue("A", et), ue("H", B), ue("h", B), ue("k", B), ue("HH", B, z), ue("hh", B, z), ue("kk", B, z), ue("hmm", Q), ue("hmmss", X), ue("Hmm", Q), ue("Hmmss", X), ce([
        "H",
        "HH"
    ], ge), ce([
        "k",
        "kk"
    ], function(e, t, n) {
        var s = D(e);
        t[ge] = 24 === s ? 0 : s;
    }), ce([
        "a",
        "A"
    ], function(e, t, n) {
        n._isPm = n._locale.isPM(e), n._meridiem = e;
    }), ce([
        "h",
        "hh"
    ], function(e, t, n) {
        t[ge] = D(e), g(n).bigHour = !0;
    }), ce("hmm", function(e, t, n) {
        var s = e.length - 2;
        t[ge] = D(e.substr(0, s)), t[ve] = D(e.substr(s)), g(n).bigHour = !0;
    }), ce("hmmss", function(e, t, n) {
        var s = e.length - 4, i = e.length - 2;
        t[ge] = D(e.substr(0, s)), t[ve] = D(e.substr(s, 2)), t[pe] = D(e.substr(i)), g(n).bigHour = !0;
    }), ce("Hmm", function(e, t, n) {
        var s = e.length - 2;
        t[ge] = D(e.substr(0, s)), t[ve] = D(e.substr(s));
    }), ce("Hmmss", function(e, t, n) {
        var s = e.length - 4, i = e.length - 2;
        t[ge] = D(e.substr(0, s)), t[ve] = D(e.substr(s, 2)), t[pe] = D(e.substr(i));
    });
    var tt, nt = Te("Hours", !0), st = {
        calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L"
        },
        longDateFormat: {
            LTS: "h:mm:ss A",
            LT: "h:mm A",
            L: "MM/DD/YYYY",
            LL: "MMMM D, YYYY",
            LLL: "MMMM D, YYYY h:mm A",
            LLLL: "dddd, MMMM D, YYYY h:mm A"
        },
        invalidDate: "Invalid date",
        ordinal: "%d",
        dayOfMonthOrdinalParse: /\d{1,2}/,
        relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        },
        months: Ce,
        monthsShort: He,
        week: {
            dow: 0,
            doy: 6
        },
        weekdays: Ze,
        weekdaysMin: $e,
        weekdaysShort: ze,
        meridiemParse: /[ap]\.?m?\.?/i
    }, it = {}, rt = {};
    function at(e) {
        return e ? e.toLowerCase().replace("_", "-") : e;
    }
    function ot(e) {
        var t = null;
        if (!it[e] && true && module && module.exports) try {
            t = tt._abbr, require("./locale/" + e), ut(t);
        } catch (e) {}
        return it[e];
    }
    function ut(e, t) {
        var n;
        return e && ((n = l(t) ? ht(e) : lt(e, t)) ? tt = n : "undefined" != typeof console && console.warn && console.warn("Locale " + e + " not found. Did you forget to load it?")), tt._abbr;
    }
    function lt(e, t) {
        if (null === t) return delete it[e], null;
        var n, s = st;
        if (t.abbr = e, null != it[e]) T("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."), s = it[e]._config;
        else if (null != t.parentLocale) {
            if (null != it[t.parentLocale]) s = it[t.parentLocale]._config;
            else {
                if (null == (n = ot(t.parentLocale))) return rt[t.parentLocale] || (rt[t.parentLocale] = []), rt[t.parentLocale].push({
                    name: e,
                    config: t
                }), null;
                s = n._config;
            }
        }
        return it[e] = new P(x(s, t)), rt[e] && rt[e].forEach(function(e) {
            lt(e.name, e.config);
        }), ut(e), it[e];
    }
    function ht(e) {
        var t;
        if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e) return tt;
        if (!o(e)) {
            if (t = ot(e)) return t;
            e = [
                e
            ];
        }
        return function(e) {
            for(var t, n, s, i, r = 0; r < e.length;){
                for(t = (i = at(e[r]).split("-")).length, n = (n = at(e[r + 1])) ? n.split("-") : null; 0 < t;){
                    if (s = ot(i.slice(0, t).join("-"))) return s;
                    if (n && n.length >= t && a(i, n, !0) >= t - 1) break;
                    t--;
                }
                r++;
            }
            return tt;
        }(e);
    }
    function dt(e) {
        var t, n = e._a;
        return n && -2 === g(e).overflow && (t = n[_e] < 0 || 11 < n[_e] ? _e : n[ye] < 1 || n[ye] > Pe(n[me], n[_e]) ? ye : n[ge] < 0 || 24 < n[ge] || 24 === n[ge] && (0 !== n[ve] || 0 !== n[pe] || 0 !== n[we]) ? ge : n[ve] < 0 || 59 < n[ve] ? ve : n[pe] < 0 || 59 < n[pe] ? pe : n[we] < 0 || 999 < n[we] ? we : -1, g(e)._overflowDayOfYear && (t < me || ye < t) && (t = ye), g(e)._overflowWeeks && -1 === t && (t = Me), g(e)._overflowWeekday && -1 === t && (t = ke), g(e).overflow = t), e;
    }
    function ct(e, t, n) {
        return null != e ? e : null != t ? t : n;
    }
    function ft(e) {
        var t, n, s, i, r, a = [];
        if (!e._d) {
            var o, u;
            for(o = e, u = new Date(c.now()), s = o._useUTC ? [
                u.getUTCFullYear(),
                u.getUTCMonth(),
                u.getUTCDate()
            ] : [
                u.getFullYear(),
                u.getMonth(),
                u.getDate()
            ], e._w && null == e._a[ye] && null == e._a[_e] && function(e) {
                var t, n, s, i, r, a, o, u;
                if (null != (t = e._w).GG || null != t.W || null != t.E) r = 1, a = 4, n = ct(t.GG, e._a[me], Ie(bt(), 1, 4).year), s = ct(t.W, 1), ((i = ct(t.E, 1)) < 1 || 7 < i) && (u = !0);
                else {
                    r = e._locale._week.dow, a = e._locale._week.doy;
                    var l = Ie(bt(), r, a);
                    n = ct(t.gg, e._a[me], l.year), s = ct(t.w, l.week), null != t.d ? ((i = t.d) < 0 || 6 < i) && (u = !0) : null != t.e ? (i = t.e + r, (t.e < 0 || 6 < t.e) && (u = !0)) : i = r;
                }
                s < 1 || s > Ae(n, r, a) ? g(e)._overflowWeeks = !0 : null != u ? g(e)._overflowWeekday = !0 : (o = Ee(n, s, i, r, a), e._a[me] = o.year, e._dayOfYear = o.dayOfYear);
            }(e), null != e._dayOfYear && (r = ct(e._a[me], s[me]), (e._dayOfYear > Se(r) || 0 === e._dayOfYear) && (g(e)._overflowDayOfYear = !0), n = Ge(r, 0, e._dayOfYear), e._a[_e] = n.getUTCMonth(), e._a[ye] = n.getUTCDate()), t = 0; t < 3 && null == e._a[t]; ++t)e._a[t] = a[t] = s[t];
            for(; t < 7; t++)e._a[t] = a[t] = null == e._a[t] ? 2 === t ? 1 : 0 : e._a[t];
            24 === e._a[ge] && 0 === e._a[ve] && 0 === e._a[pe] && 0 === e._a[we] && (e._nextDay = !0, e._a[ge] = 0), e._d = (e._useUTC ? Ge : function(e, t, n, s, i, r, a) {
                var o;
                return e < 100 && 0 <= e ? (o = new Date(e + 400, t, n, s, i, r, a), isFinite(o.getFullYear()) && o.setFullYear(e)) : o = new Date(e, t, n, s, i, r, a), o;
            }).apply(null, a), i = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), null != e._tzm && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[ge] = 24), e._w && void 0 !== e._w.d && e._w.d !== i && (g(e).weekdayMismatch = !0);
        }
    }
    var mt = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/, _t = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/, yt = /Z|[+-]\d\d(?::?\d\d)?/, gt = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            !1
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            !1
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            !1
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ]
    ], vt = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], pt = /^\/?Date\((\-?\d+)/i;
    function wt(e) {
        var t, n, s, i, r, a, o = e._i, u = mt.exec(o) || _t.exec(o);
        if (u) {
            for(g(e).iso = !0, t = 0, n = gt.length; t < n; t++)if (gt[t][1].exec(u[1])) {
                i = gt[t][0], s = !1 !== gt[t][2];
                break;
            }
            if (null == i) return void (e._isValid = !1);
            if (u[3]) {
                for(t = 0, n = vt.length; t < n; t++)if (vt[t][1].exec(u[3])) {
                    r = (u[2] || " ") + vt[t][0];
                    break;
                }
                if (null == r) return void (e._isValid = !1);
            }
            if (!s && null != r) return void (e._isValid = !1);
            if (u[4]) {
                if (!yt.exec(u[4])) return void (e._isValid = !1);
                a = "Z";
            }
            e._f = i + (r || "") + (a || ""), Yt(e);
        } else e._isValid = !1;
    }
    var Mt = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
    function kt(e, t, n, s, i, r) {
        var a = [
            function(e) {
                var t = parseInt(e, 10);
                if (t <= 49) return 2e3 + t;
                if (t <= 999) return 1900 + t;
                return t;
            }(e),
            He.indexOf(t),
            parseInt(n, 10),
            parseInt(s, 10),
            parseInt(i, 10)
        ];
        return r && a.push(parseInt(r, 10)), a;
    }
    var St = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    function Dt(e) {
        var t, n, s, i = Mt.exec(e._i.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, ""));
        if (i) {
            var r = kt(i[4], i[3], i[2], i[5], i[6], i[7]);
            if (t = i[1], n = r, s = e, t && ze.indexOf(t) !== new Date(n[0], n[1], n[2]).getDay() && (g(s).weekdayMismatch = !0, s._isValid = !1, true)) return;
            e._a = r, e._tzm = function(e, t, n) {
                if (e) return St[e];
                if (t) return 0;
                var s = parseInt(n, 10), i = s % 100;
                return (s - i) / 100 * 60 + i;
            }(i[8], i[9], i[10]), e._d = Ge.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), g(e).rfc2822 = !0;
        } else e._isValid = !1;
    }
    function Yt(e) {
        if (e._f !== c.ISO_8601) {
            if (e._f !== c.RFC_2822) {
                e._a = [], g(e).empty = !0;
                var t, n, s, i, r, a, o, u, l = "" + e._i, h = l.length, d = 0;
                for(s = j(e._f, e._locale).match(N) || [], t = 0; t < s.length; t++)i = s[t], (n = (l.match(le(i, e)) || [])[0]) && (0 < (r = l.substr(0, l.indexOf(n))).length && g(e).unusedInput.push(r), l = l.slice(l.indexOf(n) + n.length), d += n.length), E[i] ? (n ? g(e).empty = !1 : g(e).unusedTokens.push(i), a = i, u = e, null != (o = n) && m(de, a) && de[a](o, u._a, u, a)) : e._strict && !n && g(e).unusedTokens.push(i);
                g(e).charsLeftOver = h - d, 0 < l.length && g(e).unusedInput.push(l), e._a[ge] <= 12 && !0 === g(e).bigHour && 0 < e._a[ge] && (g(e).bigHour = void 0), g(e).parsedDateParts = e._a.slice(0), g(e).meridiem = e._meridiem, e._a[ge] = function(e, t, n) {
                    var s;
                    if (null == n) return t;
                    return null != e.meridiemHour ? e.meridiemHour(t, n) : (null != e.isPM && ((s = e.isPM(n)) && t < 12 && (t += 12), s || 12 !== t || (t = 0)), t);
                }(e._locale, e._a[ge], e._meridiem), ft(e), dt(e);
            } else Dt(e);
        } else wt(e);
    }
    function Ot(e) {
        var t, n, s, i, r = e._i, a = e._f;
        return e._locale = e._locale || ht(e._l), null === r || void 0 === a && "" === r ? p({
            nullInput: !0
        }) : ("string" == typeof r && (e._i = r = e._locale.preparse(r)), k(r) ? new M(dt(r)) : (d(r) ? e._d = r : o(a) ? function(e) {
            var t, n, s, i, r;
            if (0 === e._f.length) return g(e).invalidFormat = !0, e._d = new Date(NaN);
            for(i = 0; i < e._f.length; i++)r = 0, t = w({}, e), null != e._useUTC && (t._useUTC = e._useUTC), t._f = e._f[i], Yt(t), v(t) && (r += g(t).charsLeftOver, r += 10 * g(t).unusedTokens.length, g(t).score = r, (null == s || r < s) && (s = r, n = t));
            _(e, n || t);
        }(e) : a ? Yt(e) : l(n = (t = e)._i) ? t._d = new Date(c.now()) : d(n) ? t._d = new Date(n.valueOf()) : "string" == typeof n ? (s = t, null === (i = pt.exec(s._i)) ? (wt(s), !1 === s._isValid && (delete s._isValid, Dt(s), !1 === s._isValid && (delete s._isValid, c.createFromInputFallback(s)))) : s._d = new Date(+i[1])) : o(n) ? (t._a = f(n.slice(0), function(e) {
            return parseInt(e, 10);
        }), ft(t)) : u(n) ? function(e) {
            if (!e._d) {
                var t = R(e._i);
                e._a = f([
                    t.year,
                    t.month,
                    t.day || t.date,
                    t.hour,
                    t.minute,
                    t.second,
                    t.millisecond
                ], function(e) {
                    return e && parseInt(e, 10);
                }), ft(e);
            }
        }(t) : h(n) ? t._d = new Date(n) : c.createFromInputFallback(t), v(e) || (e._d = null), e));
    }
    function Tt(e, t, n, s, i) {
        var r, a = {};
        return !0 !== n && !1 !== n || (s = n, n = void 0), (u(e) && function(e) {
            if (Object.getOwnPropertyNames) return 0 === Object.getOwnPropertyNames(e).length;
            var t;
            for(t in e)if (e.hasOwnProperty(t)) return !1;
            return !0;
        }(e) || o(e) && 0 === e.length) && (e = void 0), a._isAMomentObject = !0, a._useUTC = a._isUTC = i, a._l = n, a._i = e, a._f = t, a._strict = s, (r = new M(dt(Ot(a))))._nextDay && (r.add(1, "d"), r._nextDay = void 0), r;
    }
    function bt(e, t, n, s) {
        return Tt(e, t, n, s, !1);
    }
    c.createFromInputFallback = n("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(e) {
        e._d = new Date(e._i + (e._useUTC ? " UTC" : ""));
    }), c.ISO_8601 = function() {}, c.RFC_2822 = function() {};
    var xt = n("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var e = bt.apply(null, arguments);
        return this.isValid() && e.isValid() ? e < this ? this : e : p();
    }), Pt = n("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var e = bt.apply(null, arguments);
        return this.isValid() && e.isValid() ? this < e ? this : e : p();
    });
    function Wt(e, t) {
        var n, s;
        if (1 === t.length && o(t[0]) && (t = t[0]), !t.length) return bt();
        for(n = t[0], s = 1; s < t.length; ++s)t[s].isValid() && !t[s][e](n) || (n = t[s]);
        return n;
    }
    var Ct = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function Ht(e) {
        var t = R(e), n = t.year || 0, s = t.quarter || 0, i = t.month || 0, r = t.week || t.isoWeek || 0, a = t.day || 0, o = t.hour || 0, u = t.minute || 0, l = t.second || 0, h = t.millisecond || 0;
        this._isValid = function(e) {
            for(var t in e)if (-1 === Ye.call(Ct, t) || null != e[t] && isNaN(e[t])) return !1;
            for(var n = !1, s = 0; s < Ct.length; ++s)if (e[Ct[s]]) {
                if (n) return !1;
                parseFloat(e[Ct[s]]) !== D(e[Ct[s]]) && (n = !0);
            }
            return !0;
        }(t), this._milliseconds = +h + 1e3 * l + 6e4 * u + 1e3 * o * 3600, this._days = +a + 7 * r, this._months = +i + 3 * s + 12 * n, this._data = {}, this._locale = ht(), this._bubble();
    }
    function Rt(e) {
        return e instanceof Ht;
    }
    function Ut(e) {
        return e < 0 ? -1 * Math.round(-1 * e) : Math.round(e);
    }
    function Ft(e, n) {
        I(e, 0, 0, function() {
            var e = this.utcOffset(), t = "+";
            return e < 0 && (e = -e, t = "-"), t + L(~~(e / 60), 2) + n + L(~~e % 60, 2);
        });
    }
    Ft("Z", ":"), Ft("ZZ", ""), ue("Z", re), ue("ZZ", re), ce([
        "Z",
        "ZZ"
    ], function(e, t, n) {
        n._useUTC = !0, n._tzm = Nt(re, e);
    });
    var Lt = /([\+\-]|\d\d)/gi;
    function Nt(e, t) {
        var n = (t || "").match(e);
        if (null === n) return null;
        var s = ((n[n.length - 1] || []) + "").match(Lt) || [
            "-",
            0,
            0
        ], i = 60 * s[1] + D(s[2]);
        return 0 === i ? 0 : "+" === s[0] ? i : -i;
    }
    function Gt(e, t) {
        var n, s;
        return t._isUTC ? (n = t.clone(), s = (k(e) || d(e) ? e.valueOf() : bt(e).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + s), c.updateOffset(n, !1), n) : bt(e).local();
    }
    function Vt(e) {
        return 15 * -Math.round(e._d.getTimezoneOffset() / 15);
    }
    function Et() {
        return !!this.isValid() && this._isUTC && 0 === this._offset;
    }
    c.updateOffset = function() {};
    var It = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/, At = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function jt(e, t) {
        var n, s, i, r = e, a = null;
        return Rt(e) ? r = {
            ms: e._milliseconds,
            d: e._days,
            M: e._months
        } : h(e) ? (r = {}, t ? r[t] = e : r.milliseconds = e) : (a = It.exec(e)) ? (n = "-" === a[1] ? -1 : 1, r = {
            y: 0,
            d: D(a[ye]) * n,
            h: D(a[ge]) * n,
            m: D(a[ve]) * n,
            s: D(a[pe]) * n,
            ms: D(Ut(1e3 * a[we])) * n
        }) : (a = At.exec(e)) ? (n = "-" === a[1] ? -1 : 1, r = {
            y: Zt(a[2], n),
            M: Zt(a[3], n),
            w: Zt(a[4], n),
            d: Zt(a[5], n),
            h: Zt(a[6], n),
            m: Zt(a[7], n),
            s: Zt(a[8], n)
        }) : null == r ? r = {} : "object" == typeof r && ("from" in r || "to" in r) && (i = function(e, t) {
            var n;
            if (!e.isValid() || !t.isValid()) return {
                milliseconds: 0,
                months: 0
            };
            t = Gt(t, e), e.isBefore(t) ? n = zt(e, t) : ((n = zt(t, e)).milliseconds = -n.milliseconds, n.months = -n.months);
            return n;
        }(bt(r.from), bt(r.to)), (r = {}).ms = i.milliseconds, r.M = i.months), s = new Ht(r), Rt(e) && m(e, "_locale") && (s._locale = e._locale), s;
    }
    function Zt(e, t) {
        var n = e && parseFloat(e.replace(",", "."));
        return (isNaN(n) ? 0 : n) * t;
    }
    function zt(e, t) {
        var n = {};
        return n.months = t.month() - e.month() + 12 * (t.year() - e.year()), e.clone().add(n.months, "M").isAfter(t) && --n.months, n.milliseconds = +t - +e.clone().add(n.months, "M"), n;
    }
    function $t(s, i) {
        return function(e, t) {
            var n;
            return null === t || isNaN(+t) || (T(i, "moment()." + i + "(period, number) is deprecated. Please use moment()." + i + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."), n = e, e = t, t = n), qt(this, jt(e = "string" == typeof e ? +e : e, t), s), this;
        };
    }
    function qt(e, t, n, s) {
        var i = t._milliseconds, r = Ut(t._days), a = Ut(t._months);
        e.isValid() && (s = null == s || s, a && Re(e, be(e, "Month") + a * n), r && xe(e, "Date", be(e, "Date") + r * n), i && e._d.setTime(e._d.valueOf() + i * n), s && c.updateOffset(e, r || a));
    }
    jt.fn = Ht.prototype, jt.invalid = function() {
        return jt(NaN);
    };
    var Jt = $t(1, "add"), Bt = $t(-1, "subtract");
    function Qt(e, t) {
        var n = 12 * (t.year() - e.year()) + (t.month() - e.month()), s = e.clone().add(n, "months");
        return -(n + (t - s < 0 ? (t - s) / (s - e.clone().add(n - 1, "months")) : (t - s) / (e.clone().add(n + 1, "months") - s))) || 0;
    }
    function Xt(e) {
        var t;
        return void 0 === e ? this._locale._abbr : (null != (t = ht(e)) && (this._locale = t), this);
    }
    c.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", c.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    var Kt = n("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(e) {
        return void 0 === e ? this.localeData() : this.locale(e);
    });
    function en() {
        return this._locale;
    }
    var tn = 126227808e5;
    function nn(e, t) {
        return (e % t + t) % t;
    }
    function sn(e, t, n) {
        return e < 100 && 0 <= e ? new Date(e + 400, t, n) - tn : new Date(e, t, n).valueOf();
    }
    function rn(e, t, n) {
        return e < 100 && 0 <= e ? Date.UTC(e + 400, t, n) - tn : Date.UTC(e, t, n);
    }
    function an(e, t) {
        I(0, [
            e,
            e.length
        ], 0, t);
    }
    function on(e, t, n, s, i) {
        var r;
        return null == e ? Ie(this, s, i).year : ((r = Ae(e, s, i)) < t && (t = r), (function(e, t, n, s, i) {
            var r = Ee(e, t, n, s, i), a = Ge(r.year, 0, r.dayOfYear);
            return this.year(a.getUTCFullYear()), this.month(a.getUTCMonth()), this.date(a.getUTCDate()), this;
        }).call(this, e, t, n, s, i));
    }
    I(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    }), I(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    }), an("gggg", "weekYear"), an("ggggg", "weekYear"), an("GGGG", "isoWeekYear"), an("GGGGG", "isoWeekYear"), C("weekYear", "gg"), C("isoWeekYear", "GG"), F("weekYear", 1), F("isoWeekYear", 1), ue("G", se), ue("g", se), ue("GG", B, z), ue("gg", B, z), ue("GGGG", ee, q), ue("gggg", ee, q), ue("GGGGG", te, J), ue("ggggg", te, J), fe([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(e, t, n, s) {
        t[s.substr(0, 2)] = D(e);
    }), fe([
        "gg",
        "GG"
    ], function(e, t, n, s) {
        t[s] = c.parseTwoDigitYear(e);
    }), I("Q", 0, "Qo", "quarter"), C("quarter", "Q"), F("quarter", 7), ue("Q", Z), ce("Q", function(e, t) {
        t[_e] = 3 * (D(e) - 1);
    }), I("D", [
        "DD",
        2
    ], "Do", "date"), C("date", "D"), F("date", 9), ue("D", B), ue("DD", B, z), ue("Do", function(e, t) {
        return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
    }), ce([
        "D",
        "DD"
    ], ye), ce("Do", function(e, t) {
        t[ye] = D(e.match(B)[0]);
    });
    var un = Te("Date", !0);
    I("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear"), C("dayOfYear", "DDD"), F("dayOfYear", 4), ue("DDD", K), ue("DDDD", $), ce([
        "DDD",
        "DDDD"
    ], function(e, t, n) {
        n._dayOfYear = D(e);
    }), I("m", [
        "mm",
        2
    ], 0, "minute"), C("minute", "m"), F("minute", 14), ue("m", B), ue("mm", B, z), ce([
        "m",
        "mm"
    ], ve);
    var ln = Te("Minutes", !1);
    I("s", [
        "ss",
        2
    ], 0, "second"), C("second", "s"), F("second", 15), ue("s", B), ue("ss", B, z), ce([
        "s",
        "ss"
    ], pe);
    var hn, dn = Te("Seconds", !1);
    for(I("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    }), I(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    }), I(0, [
        "SSS",
        3
    ], 0, "millisecond"), I(0, [
        "SSSS",
        4
    ], 0, function() {
        return 10 * this.millisecond();
    }), I(0, [
        "SSSSS",
        5
    ], 0, function() {
        return 100 * this.millisecond();
    }), I(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return 1e3 * this.millisecond();
    }), I(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return 1e4 * this.millisecond();
    }), I(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return 1e5 * this.millisecond();
    }), I(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return 1e6 * this.millisecond();
    }), C("millisecond", "ms"), F("millisecond", 16), ue("S", K, Z), ue("SS", K, z), ue("SSS", K, $), hn = "SSSS"; hn.length <= 9; hn += "S")ue(hn, ne);
    function cn(e, t) {
        t[we] = D(1e3 * ("0." + e));
    }
    for(hn = "S"; hn.length <= 9; hn += "S")ce(hn, cn);
    var fn = Te("Milliseconds", !1);
    I("z", 0, 0, "zoneAbbr"), I("zz", 0, 0, "zoneName");
    var mn = M.prototype;
    function _n(e) {
        return e;
    }
    mn.add = Jt, mn.calendar = function(e, t) {
        var n = e || bt(), s = Gt(n, this).startOf("day"), i = c.calendarFormat(this, s) || "sameElse", r = t && (b(t[i]) ? t[i].call(this, n) : t[i]);
        return this.format(r || this.localeData().calendar(i, this, bt(n)));
    }, mn.clone = function() {
        return new M(this);
    }, mn.diff = function(e, t, n) {
        var s, i, r;
        if (!this.isValid()) return NaN;
        if (!(s = Gt(e, this)).isValid()) return NaN;
        switch(i = 6e4 * (s.utcOffset() - this.utcOffset()), t = H(t)){
            case "year":
                r = Qt(this, s) / 12;
                break;
            case "month":
                r = Qt(this, s);
                break;
            case "quarter":
                r = Qt(this, s) / 3;
                break;
            case "second":
                r = (this - s) / 1e3;
                break;
            case "minute":
                r = (this - s) / 6e4;
                break;
            case "hour":
                r = (this - s) / 36e5;
                break;
            case "day":
                r = (this - s - i) / 864e5;
                break;
            case "week":
                r = (this - s - i) / 6048e5;
                break;
            default:
                r = this - s;
        }
        return n ? r : S(r);
    }, mn.endOf = function(e) {
        var t;
        if (void 0 === (e = H(e)) || "millisecond" === e || !this.isValid()) return this;
        var n = this._isUTC ? rn : sn;
        switch(e){
            case "year":
                t = n(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                t = n(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                t = n(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                t = n(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                t = n(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                t = n(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                t = this._d.valueOf(), t += 36e5 - nn(t + (this._isUTC ? 0 : 6e4 * this.utcOffset()), 36e5) - 1;
                break;
            case "minute":
                t = this._d.valueOf(), t += 6e4 - nn(t, 6e4) - 1;
                break;
            case "second":
                t = this._d.valueOf(), t += 1e3 - nn(t, 1e3) - 1;
                break;
        }
        return this._d.setTime(t), c.updateOffset(this, !0), this;
    }, mn.format = function(e) {
        e || (e = this.isUtc() ? c.defaultFormatUtc : c.defaultFormat);
        var t = A(this, e);
        return this.localeData().postformat(t);
    }, mn.from = function(e, t) {
        return this.isValid() && (k(e) && e.isValid() || bt(e).isValid()) ? jt({
            to: this,
            from: e
        }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
    }, mn.fromNow = function(e) {
        return this.from(bt(), e);
    }, mn.to = function(e, t) {
        return this.isValid() && (k(e) && e.isValid() || bt(e).isValid()) ? jt({
            from: this,
            to: e
        }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
    }, mn.toNow = function(e) {
        return this.to(bt(), e);
    }, mn.get = function(e) {
        return b(this[e = H(e)]) ? this[e]() : this;
    }, mn.invalidAt = function() {
        return g(this).overflow;
    }, mn.isAfter = function(e, t) {
        var n = k(e) ? e : bt(e);
        return !(!this.isValid() || !n.isValid()) && ("millisecond" === (t = H(t) || "millisecond") ? this.valueOf() > n.valueOf() : n.valueOf() < this.clone().startOf(t).valueOf());
    }, mn.isBefore = function(e, t) {
        var n = k(e) ? e : bt(e);
        return !(!this.isValid() || !n.isValid()) && ("millisecond" === (t = H(t) || "millisecond") ? this.valueOf() < n.valueOf() : this.clone().endOf(t).valueOf() < n.valueOf());
    }, mn.isBetween = function(e, t, n, s) {
        var i = k(e) ? e : bt(e), r = k(t) ? t : bt(t);
        return !!(this.isValid() && i.isValid() && r.isValid()) && ("(" === (s = s || "()")[0] ? this.isAfter(i, n) : !this.isBefore(i, n)) && (")" === s[1] ? this.isBefore(r, n) : !this.isAfter(r, n));
    }, mn.isSame = function(e, t) {
        var n, s = k(e) ? e : bt(e);
        return !(!this.isValid() || !s.isValid()) && ("millisecond" === (t = H(t) || "millisecond") ? this.valueOf() === s.valueOf() : (n = s.valueOf(), this.clone().startOf(t).valueOf() <= n && n <= this.clone().endOf(t).valueOf()));
    }, mn.isSameOrAfter = function(e, t) {
        return this.isSame(e, t) || this.isAfter(e, t);
    }, mn.isSameOrBefore = function(e, t) {
        return this.isSame(e, t) || this.isBefore(e, t);
    }, mn.isValid = function() {
        return v(this);
    }, mn.lang = Kt, mn.locale = Xt, mn.localeData = en, mn.max = Pt, mn.min = xt, mn.parsingFlags = function() {
        return _({}, g(this));
    }, mn.set = function(e, t) {
        if ("object" == typeof e) for(var n = function(e) {
            var t = [];
            for(var n in e)t.push({
                unit: n,
                priority: U[n]
            });
            return t.sort(function(e, t) {
                return e.priority - t.priority;
            }), t;
        }(e = R(e)), s = 0; s < n.length; s++)this[n[s].unit](e[n[s].unit]);
        else if (b(this[e = H(e)])) return this[e](t);
        return this;
    }, mn.startOf = function(e) {
        var t;
        if (void 0 === (e = H(e)) || "millisecond" === e || !this.isValid()) return this;
        var n = this._isUTC ? rn : sn;
        switch(e){
            case "year":
                t = n(this.year(), 0, 1);
                break;
            case "quarter":
                t = n(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                t = n(this.year(), this.month(), 1);
                break;
            case "week":
                t = n(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                t = n(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                t = n(this.year(), this.month(), this.date());
                break;
            case "hour":
                t = this._d.valueOf(), t -= nn(t + (this._isUTC ? 0 : 6e4 * this.utcOffset()), 36e5);
                break;
            case "minute":
                t = this._d.valueOf(), t -= nn(t, 6e4);
                break;
            case "second":
                t = this._d.valueOf(), t -= nn(t, 1e3);
                break;
        }
        return this._d.setTime(t), c.updateOffset(this, !0), this;
    }, mn.subtract = Bt, mn.toArray = function() {
        var e = this;
        return [
            e.year(),
            e.month(),
            e.date(),
            e.hour(),
            e.minute(),
            e.second(),
            e.millisecond()
        ];
    }, mn.toObject = function() {
        var e = this;
        return {
            years: e.year(),
            months: e.month(),
            date: e.date(),
            hours: e.hours(),
            minutes: e.minutes(),
            seconds: e.seconds(),
            milliseconds: e.milliseconds()
        };
    }, mn.toDate = function() {
        return new Date(this.valueOf());
    }, mn.toISOString = function(e) {
        if (!this.isValid()) return null;
        var t = !0 !== e, n = t ? this.clone().utc() : this;
        return n.year() < 0 || 9999 < n.year() ? A(n, t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ") : b(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3).toISOString().replace("Z", A(n, "Z")) : A(n, t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }, mn.inspect = function() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var e = "moment", t = "";
        this.isLocal() || (e = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone", t = "Z");
        var n = "[" + e + '("]', s = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", i = t + '[")]';
        return this.format(n + s + "-MM-DD[T]HH:mm:ss.SSS" + i);
    }, mn.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
    }, mn.toString = function() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }, mn.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
    }, mn.valueOf = function() {
        return this._d.valueOf() - 6e4 * (this._offset || 0);
    }, mn.creationData = function() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }, mn.year = Oe, mn.isLeapYear = function() {
        return De(this.year());
    }, mn.weekYear = function(e) {
        return on.call(this, e, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }, mn.isoWeekYear = function(e) {
        return on.call(this, e, this.isoWeek(), this.isoWeekday(), 1, 4);
    }, mn.quarter = mn.quarters = function(e) {
        return null == e ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (e - 1) + this.month() % 3);
    }, mn.month = Ue, mn.daysInMonth = function() {
        return Pe(this.year(), this.month());
    }, mn.week = mn.weeks = function(e) {
        var t = this.localeData().week(this);
        return null == e ? t : this.add(7 * (e - t), "d");
    }, mn.isoWeek = mn.isoWeeks = function(e) {
        var t = Ie(this, 1, 4).week;
        return null == e ? t : this.add(7 * (e - t), "d");
    }, mn.weeksInYear = function() {
        var e = this.localeData()._week;
        return Ae(this.year(), e.dow, e.doy);
    }, mn.isoWeeksInYear = function() {
        return Ae(this.year(), 1, 4);
    }, mn.date = un, mn.day = mn.days = function(e) {
        if (!this.isValid()) return null != e ? this : NaN;
        var t, n, s = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        return null != e ? (t = e, n = this.localeData(), e = "string" != typeof t ? t : isNaN(t) ? "number" == typeof (t = n.weekdaysParse(t)) ? t : null : parseInt(t, 10), this.add(e - s, "d")) : s;
    }, mn.weekday = function(e) {
        if (!this.isValid()) return null != e ? this : NaN;
        var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return null == e ? t : this.add(e - t, "d");
    }, mn.isoWeekday = function(e) {
        if (!this.isValid()) return null != e ? this : NaN;
        if (null == e) return this.day() || 7;
        var t, n, s = (t = e, n = this.localeData(), "string" == typeof t ? n.weekdaysParse(t) % 7 || 7 : isNaN(t) ? null : t);
        return this.day(this.day() % 7 ? s : s - 7);
    }, mn.dayOfYear = function(e) {
        var t = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return null == e ? t : this.add(e - t, "d");
    }, mn.hour = mn.hours = nt, mn.minute = mn.minutes = ln, mn.second = mn.seconds = dn, mn.millisecond = mn.milliseconds = fn, mn.utcOffset = function(e, t, n) {
        var s, i = this._offset || 0;
        if (!this.isValid()) return null != e ? this : NaN;
        if (null == e) return this._isUTC ? i : Vt(this);
        if ("string" == typeof e) {
            if (null === (e = Nt(re, e))) return this;
        } else Math.abs(e) < 16 && !n && (e *= 60);
        return !this._isUTC && t && (s = Vt(this)), this._offset = e, this._isUTC = !0, null != s && this.add(s, "m"), i !== e && (!t || this._changeInProgress ? qt(this, jt(e - i, "m"), 1, !1) : this._changeInProgress || (this._changeInProgress = !0, c.updateOffset(this, !0), this._changeInProgress = null)), this;
    }, mn.utc = function(e) {
        return this.utcOffset(0, e);
    }, mn.local = function(e) {
        return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(Vt(this), "m")), this;
    }, mn.parseZone = function() {
        if (null != this._tzm) this.utcOffset(this._tzm, !1, !0);
        else if ("string" == typeof this._i) {
            var e = Nt(ie, this._i);
            null != e ? this.utcOffset(e) : this.utcOffset(0, !0);
        }
        return this;
    }, mn.hasAlignedHourOffset = function(e) {
        return !!this.isValid() && (e = e ? bt(e).utcOffset() : 0, (this.utcOffset() - e) % 60 == 0);
    }, mn.isDST = function() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }, mn.isLocal = function() {
        return !!this.isValid() && !this._isUTC;
    }, mn.isUtcOffset = function() {
        return !!this.isValid() && this._isUTC;
    }, mn.isUtc = Et, mn.isUTC = Et, mn.zoneAbbr = function() {
        return this._isUTC ? "UTC" : "";
    }, mn.zoneName = function() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }, mn.dates = n("dates accessor is deprecated. Use date instead.", un), mn.months = n("months accessor is deprecated. Use month instead", Ue), mn.years = n("years accessor is deprecated. Use year instead", Oe), mn.zone = n("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", function(e, t) {
        return null != e ? ("string" != typeof e && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
    }), mn.isDSTShifted = n("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", function() {
        if (!l(this._isDSTShifted)) return this._isDSTShifted;
        var e = {};
        if (w(e, this), (e = Ot(e))._a) {
            var t = e._isUTC ? y(e._a) : bt(e._a);
            this._isDSTShifted = this.isValid() && 0 < a(e._a, t.toArray());
        } else this._isDSTShifted = !1;
        return this._isDSTShifted;
    });
    var yn = P.prototype;
    function gn(e, t, n, s) {
        var i = ht(), r = y().set(s, t);
        return i[n](r, e);
    }
    function vn(e, t, n) {
        if (h(e) && (t = e, e = void 0), e = e || "", null != t) return gn(e, t, n, "month");
        var s, i = [];
        for(s = 0; s < 12; s++)i[s] = gn(e, s, n, "month");
        return i;
    }
    function pn(e, t, n, s) {
        t = ("boolean" == typeof e ? h(t) && (n = t, t = void 0) : (t = e, e = !1, h(n = t) && (n = t, t = void 0)), t || "");
        var i, r = ht(), a = e ? r._week.dow : 0;
        if (null != n) return gn(t, (n + a) % 7, s, "day");
        var o = [];
        for(i = 0; i < 7; i++)o[i] = gn(t, (i + a) % 7, s, "day");
        return o;
    }
    yn.calendar = function(e, t, n) {
        var s = this._calendar[e] || this._calendar.sameElse;
        return b(s) ? s.call(t, n) : s;
    }, yn.longDateFormat = function(e) {
        var t = this._longDateFormat[e], n = this._longDateFormat[e.toUpperCase()];
        return t || !n ? t : (this._longDateFormat[e] = n.replace(/MMMM|MM|DD|dddd/g, function(e) {
            return e.slice(1);
        }), this._longDateFormat[e]);
    }, yn.invalidDate = function() {
        return this._invalidDate;
    }, yn.ordinal = function(e) {
        return this._ordinal.replace("%d", e);
    }, yn.preparse = _n, yn.postformat = _n, yn.relativeTime = function(e, t, n, s) {
        var i = this._relativeTime[n];
        return b(i) ? i(e, t, n, s) : i.replace(/%d/i, e);
    }, yn.pastFuture = function(e, t) {
        var n = this._relativeTime[0 < e ? "future" : "past"];
        return b(n) ? n(t) : n.replace(/%s/i, t);
    }, yn.set = function(e) {
        var t, n;
        for(n in e)b(t = e[n]) ? this[n] = t : this["_" + n] = t;
        this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }, yn.months = function(e, t) {
        return e ? o(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || We).test(t) ? "format" : "standalone"][e.month()] : o(this._months) ? this._months : this._months.standalone;
    }, yn.monthsShort = function(e, t) {
        return e ? o(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[We.test(t) ? "format" : "standalone"][e.month()] : o(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
    }, yn.monthsParse = function(e, t, n) {
        var s, i, r;
        if (this._monthsParseExact) return (function(e, t, n) {
            var s, i, r, a = e.toLocaleLowerCase();
            if (!this._monthsParse) for(this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], s = 0; s < 12; ++s)r = y([
                2e3,
                s
            ]), this._shortMonthsParse[s] = this.monthsShort(r, "").toLocaleLowerCase(), this._longMonthsParse[s] = this.months(r, "").toLocaleLowerCase();
            return n ? "MMM" === t ? -1 !== (i = Ye.call(this._shortMonthsParse, a)) ? i : null : -1 !== (i = Ye.call(this._longMonthsParse, a)) ? i : null : "MMM" === t ? -1 !== (i = Ye.call(this._shortMonthsParse, a)) ? i : -1 !== (i = Ye.call(this._longMonthsParse, a)) ? i : null : -1 !== (i = Ye.call(this._longMonthsParse, a)) ? i : -1 !== (i = Ye.call(this._shortMonthsParse, a)) ? i : null;
        }).call(this, e, t, n);
        for(this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), s = 0; s < 12; s++){
            if (i = y([
                2e3,
                s
            ]), n && !this._longMonthsParse[s] && (this._longMonthsParse[s] = new RegExp("^" + this.months(i, "").replace(".", "") + "$", "i"), this._shortMonthsParse[s] = new RegExp("^" + this.monthsShort(i, "").replace(".", "") + "$", "i")), n || this._monthsParse[s] || (r = "^" + this.months(i, "") + "|^" + this.monthsShort(i, ""), this._monthsParse[s] = new RegExp(r.replace(".", ""), "i")), n && "MMMM" === t && this._longMonthsParse[s].test(e)) return s;
            if (n && "MMM" === t && this._shortMonthsParse[s].test(e)) return s;
            if (!n && this._monthsParse[s].test(e)) return s;
        }
    }, yn.monthsRegex = function(e) {
        return this._monthsParseExact ? (m(this, "_monthsRegex") || Ne.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (m(this, "_monthsRegex") || (this._monthsRegex = Le), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
    }, yn.monthsShortRegex = function(e) {
        return this._monthsParseExact ? (m(this, "_monthsRegex") || Ne.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (m(this, "_monthsShortRegex") || (this._monthsShortRegex = Fe), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
    }, yn.week = function(e) {
        return Ie(e, this._week.dow, this._week.doy).week;
    }, yn.firstDayOfYear = function() {
        return this._week.doy;
    }, yn.firstDayOfWeek = function() {
        return this._week.dow;
    }, yn.weekdays = function(e, t) {
        var n = o(this._weekdays) ? this._weekdays : this._weekdays[e && !0 !== e && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
        return !0 === e ? je(n, this._week.dow) : e ? n[e.day()] : n;
    }, yn.weekdaysMin = function(e) {
        return !0 === e ? je(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
    }, yn.weekdaysShort = function(e) {
        return !0 === e ? je(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
    }, yn.weekdaysParse = function(e, t, n) {
        var s, i, r;
        if (this._weekdaysParseExact) return (function(e, t, n) {
            var s, i, r, a = e.toLocaleLowerCase();
            if (!this._weekdaysParse) for(this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], s = 0; s < 7; ++s)r = y([
                2e3,
                1
            ]).day(s), this._minWeekdaysParse[s] = this.weekdaysMin(r, "").toLocaleLowerCase(), this._shortWeekdaysParse[s] = this.weekdaysShort(r, "").toLocaleLowerCase(), this._weekdaysParse[s] = this.weekdays(r, "").toLocaleLowerCase();
            return n ? "dddd" === t ? -1 !== (i = Ye.call(this._weekdaysParse, a)) ? i : null : "ddd" === t ? -1 !== (i = Ye.call(this._shortWeekdaysParse, a)) ? i : null : -1 !== (i = Ye.call(this._minWeekdaysParse, a)) ? i : null : "dddd" === t ? -1 !== (i = Ye.call(this._weekdaysParse, a)) ? i : -1 !== (i = Ye.call(this._shortWeekdaysParse, a)) ? i : -1 !== (i = Ye.call(this._minWeekdaysParse, a)) ? i : null : "ddd" === t ? -1 !== (i = Ye.call(this._shortWeekdaysParse, a)) ? i : -1 !== (i = Ye.call(this._weekdaysParse, a)) ? i : -1 !== (i = Ye.call(this._minWeekdaysParse, a)) ? i : null : -1 !== (i = Ye.call(this._minWeekdaysParse, a)) ? i : -1 !== (i = Ye.call(this._weekdaysParse, a)) ? i : -1 !== (i = Ye.call(this._shortWeekdaysParse, a)) ? i : null;
        }).call(this, e, t, n);
        for(this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), s = 0; s < 7; s++){
            if (i = y([
                2e3,
                1
            ]).day(s), n && !this._fullWeekdaysParse[s] && (this._fullWeekdaysParse[s] = new RegExp("^" + this.weekdays(i, "").replace(".", "\\.?") + "$", "i"), this._shortWeekdaysParse[s] = new RegExp("^" + this.weekdaysShort(i, "").replace(".", "\\.?") + "$", "i"), this._minWeekdaysParse[s] = new RegExp("^" + this.weekdaysMin(i, "").replace(".", "\\.?") + "$", "i")), this._weekdaysParse[s] || (r = "^" + this.weekdays(i, "") + "|^" + this.weekdaysShort(i, "") + "|^" + this.weekdaysMin(i, ""), this._weekdaysParse[s] = new RegExp(r.replace(".", ""), "i")), n && "dddd" === t && this._fullWeekdaysParse[s].test(e)) return s;
            if (n && "ddd" === t && this._shortWeekdaysParse[s].test(e)) return s;
            if (n && "dd" === t && this._minWeekdaysParse[s].test(e)) return s;
            if (!n && this._weekdaysParse[s].test(e)) return s;
        }
    }, yn.weekdaysRegex = function(e) {
        return this._weekdaysParseExact ? (m(this, "_weekdaysRegex") || Qe.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (m(this, "_weekdaysRegex") || (this._weekdaysRegex = qe), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
    }, yn.weekdaysShortRegex = function(e) {
        return this._weekdaysParseExact ? (m(this, "_weekdaysRegex") || Qe.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (m(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Je), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
    }, yn.weekdaysMinRegex = function(e) {
        return this._weekdaysParseExact ? (m(this, "_weekdaysRegex") || Qe.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (m(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Be), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
    }, yn.isPM = function(e) {
        return "p" === (e + "").toLowerCase().charAt(0);
    }, yn.meridiem = function(e, t, n) {
        return 11 < e ? n ? "pm" : "PM" : n ? "am" : "AM";
    }, ut("en", {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(e) {
            var t = e % 10;
            return e + (1 === D(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
        }
    }), c.lang = n("moment.lang is deprecated. Use moment.locale instead.", ut), c.langData = n("moment.langData is deprecated. Use moment.localeData instead.", ht);
    var wn = Math.abs;
    function Mn(e, t, n, s) {
        var i = jt(t, n);
        return e._milliseconds += s * i._milliseconds, e._days += s * i._days, e._months += s * i._months, e._bubble();
    }
    function kn(e) {
        return e < 0 ? Math.floor(e) : Math.ceil(e);
    }
    function Sn(e) {
        return 4800 * e / 146097;
    }
    function Dn(e) {
        return 146097 * e / 4800;
    }
    function Yn(e) {
        return function() {
            return this.as(e);
        };
    }
    var On = Yn("ms"), Tn = Yn("s"), bn = Yn("m"), xn = Yn("h"), Pn = Yn("d"), Wn = Yn("w"), Cn = Yn("M"), Hn = Yn("Q"), Rn = Yn("y");
    function Un(e) {
        return function() {
            return this.isValid() ? this._data[e] : NaN;
        };
    }
    var Fn = Un("milliseconds"), Ln = Un("seconds"), Nn = Un("minutes"), Gn = Un("hours"), Vn = Un("days"), En = Un("months"), In = Un("years");
    var An = Math.round, jn = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        M: 11
    };
    var Zn = Math.abs;
    function zn(e) {
        return (0 < e) - (e < 0) || +e;
    }
    function $n() {
        if (!this.isValid()) return this.localeData().invalidDate();
        var e, t, n = Zn(this._milliseconds) / 1e3, s = Zn(this._days), i = Zn(this._months);
        t = S((e = S(n / 60)) / 60), n %= 60, e %= 60;
        var r = S(i / 12), a = i %= 12, o = s, u = t, l = e, h = n ? n.toFixed(3).replace(/\.?0+$/, "") : "", d = this.asSeconds();
        if (!d) return "P0D";
        var c = d < 0 ? "-" : "", f = zn(this._months) !== zn(d) ? "-" : "", m = zn(this._days) !== zn(d) ? "-" : "", _ = zn(this._milliseconds) !== zn(d) ? "-" : "";
        return c + "P" + (r ? f + r + "Y" : "") + (a ? f + a + "M" : "") + (o ? m + o + "D" : "") + (u || l || h ? "T" : "") + (u ? _ + u + "H" : "") + (l ? _ + l + "M" : "") + (h ? _ + h + "S" : "");
    }
    var qn = Ht.prototype;
    return qn.isValid = function() {
        return this._isValid;
    }, qn.abs = function() {
        var e = this._data;
        return this._milliseconds = wn(this._milliseconds), this._days = wn(this._days), this._months = wn(this._months), e.milliseconds = wn(e.milliseconds), e.seconds = wn(e.seconds), e.minutes = wn(e.minutes), e.hours = wn(e.hours), e.months = wn(e.months), e.years = wn(e.years), this;
    }, qn.add = function(e, t) {
        return Mn(this, e, t, 1);
    }, qn.subtract = function(e, t) {
        return Mn(this, e, t, -1);
    }, qn.as = function(e) {
        if (!this.isValid()) return NaN;
        var t, n, s = this._milliseconds;
        if ("month" === (e = H(e)) || "quarter" === e || "year" === e) switch(t = this._days + s / 864e5, n = this._months + Sn(t), e){
            case "month":
                return n;
            case "quarter":
                return n / 3;
            case "year":
                return n / 12;
        }
        else switch(t = this._days + Math.round(Dn(this._months)), e){
            case "week":
                return t / 7 + s / 6048e5;
            case "day":
                return t + s / 864e5;
            case "hour":
                return 24 * t + s / 36e5;
            case "minute":
                return 1440 * t + s / 6e4;
            case "second":
                return 86400 * t + s / 1e3;
            case "millisecond":
                return Math.floor(864e5 * t) + s;
            default:
                throw new Error("Unknown unit " + e);
        }
    }, qn.asMilliseconds = On, qn.asSeconds = Tn, qn.asMinutes = bn, qn.asHours = xn, qn.asDays = Pn, qn.asWeeks = Wn, qn.asMonths = Cn, qn.asQuarters = Hn, qn.asYears = Rn, qn.valueOf = function() {
        return this.isValid() ? this._milliseconds + 864e5 * this._days + this._months % 12 * 2592e6 + 31536e6 * D(this._months / 12) : NaN;
    }, qn._bubble = function() {
        var e, t, n, s, i, r = this._milliseconds, a = this._days, o = this._months, u = this._data;
        return 0 <= r && 0 <= a && 0 <= o || r <= 0 && a <= 0 && o <= 0 || (r += 864e5 * kn(Dn(o) + a), o = a = 0), u.milliseconds = r % 1e3, e = S(r / 1e3), u.seconds = e % 60, t = S(e / 60), u.minutes = t % 60, n = S(t / 60), u.hours = n % 24, o += i = S(Sn(a += S(n / 24))), a -= kn(Dn(i)), s = S(o / 12), o %= 12, u.days = a, u.months = o, u.years = s, this;
    }, qn.clone = function() {
        return jt(this);
    }, qn.get = function(e) {
        return e = H(e), this.isValid() ? this[e + "s"]() : NaN;
    }, qn.milliseconds = Fn, qn.seconds = Ln, qn.minutes = Nn, qn.hours = Gn, qn.days = Vn, qn.weeks = function() {
        return S(this.days() / 7);
    }, qn.months = En, qn.years = In, qn.humanize = function(e) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var t, n, s, i, r, a, o, u, l, h, d, c = this.localeData(), f = (n = !e, s = c, i = jt(t = this).abs(), r = An(i.as("s")), a = An(i.as("m")), o = An(i.as("h")), u = An(i.as("d")), l = An(i.as("M")), h = An(i.as("y")), (d = r <= jn.ss && [
            "s",
            r
        ] || r < jn.s && [
            "ss",
            r
        ] || a <= 1 && [
            "m"
        ] || a < jn.m && [
            "mm",
            a
        ] || o <= 1 && [
            "h"
        ] || o < jn.h && [
            "hh",
            o
        ] || u <= 1 && [
            "d"
        ] || u < jn.d && [
            "dd",
            u
        ] || l <= 1 && [
            "M"
        ] || l < jn.M && [
            "MM",
            l
        ] || h <= 1 && [
            "y"
        ] || [
            "yy",
            h
        ])[2] = n, d[3] = 0 < +t, d[4] = s, (function(e, t, n, s, i) {
            return i.relativeTime(t || 1, !!n, e, s);
        }).apply(null, d));
        return e && (f = c.pastFuture(+this, f)), c.postformat(f);
    }, qn.toISOString = $n, qn.toString = $n, qn.toJSON = $n, qn.locale = Xt, qn.localeData = en, qn.toIsoString = n("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", $n), qn.lang = Kt, I("X", 0, 0, "unix"), I("x", 0, 0, "valueOf"), ue("x", se), ue("X", /[+-]?\d+(\.\d{1,3})?/), ce("X", function(e, t, n) {
        n._d = new Date(1e3 * parseFloat(e, 10));
    }), ce("x", function(e, t, n) {
        n._d = new Date(D(e));
    }), c.version = "2.24.0", e = bt, c.fn = mn, c.min = function() {
        return Wt("isBefore", [].slice.call(arguments, 0));
    }, c.max = function() {
        return Wt("isAfter", [].slice.call(arguments, 0));
    }, c.now = function() {
        return Date.now ? Date.now() : +new Date;
    }, c.utc = y, c.unix = function(e) {
        return bt(1e3 * e);
    }, c.months = function(e, t) {
        return vn(e, t, "months");
    }, c.isDate = d, c.locale = ut, c.invalid = p, c.duration = jt, c.isMoment = k, c.weekdays = function(e, t, n) {
        return pn(e, t, n, "weekdays");
    }, c.parseZone = function() {
        return bt.apply(null, arguments).parseZone();
    }, c.localeData = ht, c.isDuration = Rt, c.monthsShort = function(e, t) {
        return vn(e, t, "monthsShort");
    }, c.weekdaysMin = function(e, t, n) {
        return pn(e, t, n, "weekdaysMin");
    }, c.defineLocale = lt, c.updateLocale = function(e, t) {
        if (null != t) {
            var n, s, i = st;
            null != (s = ot(e)) && (i = s._config), (n = new P(t = x(i, t))).parentLocale = it[e], it[e] = n, ut(e);
        } else null != it[e] && (null != it[e].parentLocale ? it[e] = it[e].parentLocale : null != it[e] && delete it[e]);
        return it[e];
    }, c.locales = function() {
        return s(it);
    }, c.weekdaysShort = function(e, t, n) {
        return pn(e, t, n, "weekdaysShort");
    }, c.normalizeUnits = H, c.relativeTimeRounding = function(e) {
        return void 0 === e ? An : "function" == typeof e && (An = e, !0);
    }, c.relativeTimeThreshold = function(e, t) {
        return void 0 !== jn[e] && (void 0 === t ? jn[e] : (jn[e] = t, "s" === e && (jn.ss = t - 1), !0));
    }, c.calendarFormat = function(e, t) {
        var n = e.diff(t, "days", !0);
        return n < -6 ? "sameElse" : n < -1 ? "lastWeek" : n < 0 ? "lastDay" : n < 1 ? "sameDay" : n < 2 ? "nextDay" : n < 7 ? "nextWeek" : "sameElse";
    }, c.prototype = mn, c.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    }, c;
});

});

parcelRegister("lSH1h", function(module, exports) {

$parcel$export(module.exports, "default", () => $fee002e8306f1072$export$2e2bcd8739ae039);
// noinspection JSUnusedGlobalSymbols

var $jhwMH = parcelRequire("jhwMH");

var $hA9uH = parcelRequire("hA9uH");
class $fee002e8306f1072$export$2e2bcd8739ae039 {
    static bool(value, numeric = false) {
        return numeric ? !!(0, $hA9uH.default).string(value).match(/^[01]$/) : typeof value === 'boolean';
    }
    static int(value, zero = true) {
        const pattern = /^-?\d+$/;
        if (typeof value !== 'string' && typeof value !== 'number' || !(0, $hA9uH.default).string(value).match(pattern)) return false;
        return !zero && Number(value) === 0 ? false : !!(0, $hA9uH.default).string(value).match(pattern);
    }
    static float(value, zero = true) {
        const pattern = /^-?\d+(\.\d+)?$/;
        if (typeof value !== 'string' && typeof value !== 'number' || !(0, $hA9uH.default).string(value).match(pattern)) return false;
        return !zero && Number(value) === 0 ? false : !!(0, $hA9uH.default).string(value).match(pattern);
    }
    static filled(value) {
        return [
            'number',
            'string'
        ].includes(typeof value) && !(0, $hA9uH.default).string(value).match(/^[　\s]*$/);
    }
    static date(value) {
        if (typeof value !== 'string') return false;
        return !!value.match(/^\d+-\d+-\d+$/) && $jhwMH(value).isValid();
    }
    static datetime(value) {
        if (typeof value !== 'string') return false;
        return !!value.match(/^\d+-\d+-\d+ \d+:\d+:\d+$/) && $jhwMH(value).isValid();
    }
    static time(value) {
        if (typeof value !== 'string') return false;
        return !!value.match(/^\d+:\d+$/) && $jhwMH(`2000-01-01 ${value}`).isValid();
    }
    static email(value) {
        if (typeof value !== 'string') return false;
        //https://developer.mozilla.org/en-US/docs/Web/HTML/Element/Input/email#Validation
        // noinspection RegExpSimplifiable
        return !!value.match(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/);
    }
    static object(value) {
        return typeof value === 'object' && value !== null;
    }
}

});
parcelRegister("jhwMH", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("hA9uH", function(module, exports) {

$parcel$export(module.exports, "default", () => $cccd29c6d79db9b1$export$2e2bcd8739ae039);
// noinspection JSUnusedGlobalSymbols
class $cccd29c6d79db9b1$export$2e2bcd8739ae039 {
    static unit = {
        millisecond: 1000,
        second_in_day: 86400,
        second_in_minute: 60,
        minute_in_hour: 60,
        hour_in_day: 24
    };
    static string(value) {
        return typeof value === 'string' || typeof value === 'number' ? String(value) : '';
    }
    static escape_html(string) {
        return string.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
    }
}

});



parcelRegister("aa4j7", function(module, exports) {

$parcel$export(module.exports, "default", () => $765e2de7188570e7$export$2e2bcd8739ae039);

var $aspqD = parcelRequire("aspqD");

var $lSH1h = parcelRequire("lSH1h");
class $765e2de7188570e7$export$2e2bcd8739ae039 {
    static init() {
        this.select_picker();
        this.file_image();
        this.file_input();
        this.text_editor();
        this.limit_number_input();
    }
    static select_picker(list) {
        if (list === undefined) list = $('select.__select');
        list.each((index, element)=>{
            new (0, (/*@__PURE__*/$parcel$interopDefault($aspqD)))(element, {
                plugins: [
                    'dropdown_input'
                ],
                allowEmptyOption: true,
                showEmptyOptionInDropdown: true,
                maxOptions: 100000
            });
        });
    }
    static file_image() {
        const input_image = $('input.__image_select[type="file"]');
        input_image.each((index, input)=>{
            const preview = $(input).data('preview');
            if (!(0, $lSH1h.default).filled(preview)) return;
            const tag = document.querySelector(preview);
            if (!tag) return;
            const original = tag.src;
            input.addEventListener('change', function() {
                //@ts-ignore
                tag.src = this.files.length > 0 ? URL.createObjectURL(this.files[0]) : original;
                tag.parentNode.href = tag.src;
            });
        });
    }
    static file_input() {
        $('input[type="file"]:not([class="__image_select"])').jfilestyle({
            text: "\u30D5\u30A1\u30A4\u30EB\u9078\u629E",
            badge: true,
            input: false
        });
    }
    static text_editor() {
        if ($('.__editor').length === 0) return;
        $('.__editor').each((index, element)=>{
            ClassicEditor.create(element, {
                width: 'auto',
                image: {
                    resizeUnit: 'px'
                },
                link: {
                    decorators: {
                        isExternal: {
                            mode: 'manual',
                            label: 'Open in a new tab',
                            attributes: {
                                target: '_blank'
                            }
                        }
                    }
                }
            }).then((editor)=>{
                $(element).data('editor', editor);
            });
        });
    }
    static limit_number_input() {
        $('input[type="number"]').each((index, element)=>{
            element.addEventListener('input', function() {
                if (this.maxLength > 0) this.value = this.value.slice(0, this.maxLength);
            });
        });
    }
}

});
parcelRegister("aspqD", function(module, exports) {
/**
* Tom Select v2.4.3
* Licensed under the Apache License, Version 2.0 (the "License");
*/ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    /**
	 * MicroEvent - to make any js object an event emitter
	 *
	 * - pure javascript - server compatible, browser compatible
	 * - dont rely on the browser doms
	 * - super simple - you get it immediatly, no mistery, no magic involved
	 *
	 * @author Jerome Etienne (https://github.com/jeromeetienne)
	 */ /**
	 * Execute callback for each event in space separated list of event names
	 *
	 */ function forEvents(events, callback) {
        events.split(/\s+/).forEach((event)=>{
            callback(event);
        });
    }
    class MicroEvent {
        constructor(){
            this._events = {};
        }
        on(events, fct) {
            forEvents(events, (event)=>{
                const event_array = this._events[event] || [];
                event_array.push(fct);
                this._events[event] = event_array;
            });
        }
        off(events, fct) {
            var n = arguments.length;
            if (n === 0) {
                this._events = {};
                return;
            }
            forEvents(events, (event)=>{
                if (n === 1) {
                    delete this._events[event];
                    return;
                }
                const event_array = this._events[event];
                if (event_array === undefined) return;
                event_array.splice(event_array.indexOf(fct), 1);
                this._events[event] = event_array;
            });
        }
        trigger(events, ...args) {
            var self = this;
            forEvents(events, (event)=>{
                const event_array = self._events[event];
                if (event_array === undefined) return;
                event_array.forEach((fct)=>{
                    fct.apply(self, args);
                });
            });
        }
    }
    /**
	 * microplugin.js
	 * Copyright (c) 2013 Brian Reavis & contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 * @author Brian Reavis <brian@thirdroute.com>
	 */ function MicroPlugin(Interface) {
        Interface.plugins = {};
        return class extends Interface {
            constructor(...args){
                super(...args);
                this.plugins = {
                    names: [],
                    settings: {},
                    requested: {},
                    loaded: {}
                };
            }
            /**
	     * Registers a plugin.
	     *
	     * @param {function} fn
	     */ static define(name, fn) {
                Interface.plugins[name] = {
                    'name': name,
                    'fn': fn
                };
            }
            /**
	     * Initializes the listed plugins (with options).
	     * Acceptable formats:
	     *
	     * List (without options):
	     *   ['a', 'b', 'c']
	     *
	     * List (with options):
	     *   [{'name': 'a', options: {}}, {'name': 'b', options: {}}]
	     *
	     * Hash (with options):
	     *   {'a': { ... }, 'b': { ... }, 'c': { ... }}
	     *
	     * @param {array|object} plugins
	     */ initializePlugins(plugins) {
                var key, name;
                const self = this;
                const queue = [];
                if (Array.isArray(plugins)) plugins.forEach((plugin)=>{
                    if (typeof plugin === 'string') queue.push(plugin);
                    else {
                        self.plugins.settings[plugin.name] = plugin.options;
                        queue.push(plugin.name);
                    }
                });
                else if (plugins) {
                    for(key in plugins)if (plugins.hasOwnProperty(key)) {
                        self.plugins.settings[key] = plugins[key];
                        queue.push(key);
                    }
                }
                while(name = queue.shift())self.require(name);
            }
            loadPlugin(name) {
                var self = this;
                var plugins = self.plugins;
                var plugin = Interface.plugins[name];
                if (!Interface.plugins.hasOwnProperty(name)) throw new Error('Unable to find "' + name + '" plugin');
                plugins.requested[name] = true;
                plugins.loaded[name] = plugin.fn.apply(self, [
                    self.plugins.settings[name] || {}
                ]);
                plugins.names.push(name);
            }
            /**
	     * Initializes a plugin.
	     *
	     */ require(name) {
                var self = this;
                var plugins = self.plugins;
                if (!self.plugins.loaded.hasOwnProperty(name)) {
                    if (plugins.requested[name]) throw new Error('Plugin has circular dependency ("' + name + '")');
                    self.loadPlugin(name);
                }
                return plugins.loaded[name];
            }
        };
    }
    /**
	 * Convert array of strings to a regular expression
	 *	ex ['ab','a'] => (?:ab|a)
	 * 	ex ['a','b'] => [ab]
	 */ const arrayToPattern = (chars)=>{
        chars = chars.filter(Boolean);
        if (chars.length < 2) return chars[0] || '';
        return maxValueLength(chars) == 1 ? '[' + chars.join('') + ']' : '(?:' + chars.join('|') + ')';
    };
    const sequencePattern = (array)=>{
        if (!hasDuplicates(array)) return array.join('');
        let pattern = '';
        let prev_char_count = 0;
        const prev_pattern = ()=>{
            if (prev_char_count > 1) pattern += '{' + prev_char_count + '}';
        };
        array.forEach((char, i)=>{
            if (char === array[i - 1]) {
                prev_char_count++;
                return;
            }
            prev_pattern();
            pattern += char;
            prev_char_count = 1;
        });
        prev_pattern();
        return pattern;
    };
    /**
	 * Convert array of strings to a regular expression
	 *	ex ['ab','a'] => (?:ab|a)
	 * 	ex ['a','b'] => [ab]
	 */ const setToPattern = (chars)=>{
        let array = Array.from(chars);
        return arrayToPattern(array);
    };
    /**
	 * https://stackoverflow.com/questions/7376598/in-javascript-how-do-i-check-if-an-array-has-duplicate-values
	 */ const hasDuplicates = (array)=>{
        return new Set(array).size !== array.length;
    };
    /**
	 * https://stackoverflow.com/questions/63006601/why-does-u-throw-an-invalid-escape-error
	 */ const escape_regex = (str)=>{
        return (str + '').replace(/([\$\(\)\*\+\.\?\[\]\^\{\|\}\\])/gu, '\\$1');
    };
    /**
	 * Return the max length of array values
	 */ const maxValueLength = (array)=>{
        return array.reduce((longest, value)=>Math.max(longest, unicodeLength(value)), 0);
    };
    const unicodeLength = (str)=>{
        return Array.from(str).length;
    };
    /**
	 * Get all possible combinations of substrings that add up to the given string
	 * https://stackoverflow.com/questions/30169587/find-all-the-combination-of-substrings-that-add-up-to-the-given-string
	 */ const allSubstrings = (input)=>{
        if (input.length === 1) return [
            [
                input
            ]
        ];
        let result = [];
        const start = input.substring(1);
        const suba = allSubstrings(start);
        suba.forEach(function(subresult) {
            let tmp = subresult.slice(0);
            tmp[0] = input.charAt(0) + tmp[0];
            result.push(tmp);
            tmp = subresult.slice(0);
            tmp.unshift(input.charAt(0));
            result.push(tmp);
        });
        return result;
    };
    const code_points = [
        [
            0,
            65535
        ]
    ];
    const accent_pat = "[\u0300-\u036F\xb7\u02BE\u02BC]";
    let unicode_map;
    let multi_char_reg;
    const max_char_length = 3;
    const latin_convert = {};
    const latin_condensed = {
        '/': "\u2044\u2215",
        '0': "\u07C0",
        "a": "\u2C65\u0250\u0251",
        "aa": "\uA733",
        "ae": "\xe6\u01FD\u01E3",
        "ao": "\uA735",
        "au": "\uA737",
        "av": "\uA739\uA73B",
        "ay": "\uA73D",
        "b": "\u0180\u0253\u0183",
        "c": "\uA73F\u0188\u023C\u2184",
        "d": "\u0111\u0257\u0256\u1D05\u018C\uABB7\u0501\u0266",
        "e": "\u025B\u01DD\u1D07\u0247",
        "f": "\uA77C\u0192",
        "g": "\u01E5\u0260\uA7A1\u1D79\uA77F\u0262",
        "h": "\u0127\u2C68\u2C76\u0265",
        "i": "\u0268\u0131",
        "j": "\u0249\u0237",
        "k": "\u0199\u2C6A\uA741\uA743\uA745\uA7A3",
        "l": "\u0142\u019A\u026B\u2C61\uA749\uA747\uA781\u026D",
        "m": "\u0271\u026F\u03FB",
        "n": "\uA7A5\u019E\u0272\uA791\u1D0E\u043B\u0509",
        "o": "\xf8\u01FF\u0254\u0275\uA74B\uA74D\u1D11",
        "oe": "\u0153",
        "oi": "\u01A3",
        "oo": "\uA74F",
        "ou": "\u0223",
        "p": "\u01A5\u1D7D\uA751\uA753\uA755\u03C1",
        "q": "\uA757\uA759\u024B",
        "r": "\u024D\u027D\uA75B\uA7A7\uA783",
        "s": "\xdf\u023F\uA7A9\uA785\u0282",
        "t": "\u0167\u01AD\u0288\u2C66\uA787",
        "th": "\xfe",
        "tz": "\uA729",
        "u": "\u0289",
        "v": "\u028B\uA75F\u028C",
        "vy": "\uA761",
        "w": "\u2C73",
        "y": "\u01B4\u024F\u1EFF",
        "z": "\u01B6\u0225\u0240\u2C6C\uA763",
        "hv": "\u0195"
    };
    for(let latin in latin_condensed){
        let unicode = latin_condensed[latin] || '';
        for(let i = 0; i < unicode.length; i++){
            let char = unicode.substring(i, i + 1);
            latin_convert[char] = latin;
        }
    }
    const convert_pat = new RegExp(Object.keys(latin_convert).join('|') + '|' + accent_pat, 'gu');
    /**
	 * Initialize the unicode_map from the give code point ranges
	 */ const initialize = (_code_points)=>{
        if (unicode_map !== undefined) return;
        unicode_map = generateMap(code_points);
    };
    /**
	 * Helper method for normalize a string
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize
	 */ const normalize = (str, form = 'NFKD')=>str.normalize(form);
    /**
	 * Remove accents without reordering string
	 * calling str.normalize('NFKD') on \u{594}\u{595}\u{596} becomes \u{596}\u{594}\u{595}
	 * via https://github.com/krisk/Fuse/issues/133#issuecomment-318692703
	 */ const asciifold = (str)=>{
        return Array.from(str).reduce(/**
	     * @param {string} result
	     * @param {string} char
	     */ (result, char)=>{
            return result + _asciifold(char);
        }, '');
    };
    const _asciifold = (str)=>{
        str = normalize(str).toLowerCase().replace(convert_pat, (/** @type {string} */ char)=>{
            return latin_convert[char] || '';
        });
        //return str;
        return normalize(str, 'NFC');
    };
    /**
	 * Generate a list of unicode variants from the list of code points
	 */ function* generator(code_points) {
        for (const [code_point_min, code_point_max] of code_points)for(let i = code_point_min; i <= code_point_max; i++){
            let composed = String.fromCharCode(i);
            let folded = asciifold(composed);
            if (folded == composed.toLowerCase()) continue;
            // skip when folded is a string longer than 3 characters long
            // bc the resulting regex patterns will be long
            // eg:
            // folded صلى الله عليه وسلم length 18 code point 65018
            // folded جل جلاله length 8 code point 65019
            if (folded.length > max_char_length) continue;
            if (folded.length == 0) continue;
            yield {
                folded: folded,
                composed: composed,
                code_point: i
            };
        }
    }
    /**
	 * Generate a unicode map from the list of code points
	 */ const generateSets = (code_points)=>{
        const unicode_sets = {};
        const addMatching = (folded, to_add)=>{
            /** @type {Set<string>} */ const folded_set = unicode_sets[folded] || new Set();
            const patt = new RegExp('^' + setToPattern(folded_set) + '$', 'iu');
            if (to_add.match(patt)) return;
            folded_set.add(escape_regex(to_add));
            unicode_sets[folded] = folded_set;
        };
        for (let value of generator(code_points)){
            addMatching(value.folded, value.folded);
            addMatching(value.folded, value.composed);
        }
        return unicode_sets;
    };
    /**
	 * Generate a unicode map from the list of code points
	 * ae => (?:(?:ae|Æ|Ǽ|Ǣ)|(?:A|Ⓐ|Ａ...)(?:E|ɛ|Ⓔ...))
	 */ const generateMap = (code_points)=>{
        const unicode_sets = generateSets(code_points);
        const unicode_map = {};
        let multi_char = [];
        for(let folded in unicode_sets){
            let set = unicode_sets[folded];
            if (set) unicode_map[folded] = setToPattern(set);
            if (folded.length > 1) multi_char.push(escape_regex(folded));
        }
        multi_char.sort((a, b)=>b.length - a.length);
        const multi_char_patt = arrayToPattern(multi_char);
        multi_char_reg = new RegExp('^' + multi_char_patt, 'u');
        return unicode_map;
    };
    /**
	 * Map each element of an array from its folded value to all possible unicode matches
	 */ const mapSequence = (strings, min_replacement = 1)=>{
        let chars_replaced = 0;
        strings = strings.map((str)=>{
            if (unicode_map[str]) chars_replaced += str.length;
            return unicode_map[str] || str;
        });
        if (chars_replaced >= min_replacement) return sequencePattern(strings);
        return '';
    };
    /**
	 * Convert a short string and split it into all possible patterns
	 * Keep a pattern only if min_replacement is met
	 *
	 * 'abc'
	 * 		=> [['abc'],['ab','c'],['a','bc'],['a','b','c']]
	 *		=> ['abc-pattern','ab-c-pattern'...]
	 */ const substringsToPattern = (str, min_replacement = 1)=>{
        min_replacement = Math.max(min_replacement, str.length - 1);
        return arrayToPattern(allSubstrings(str).map((sub_pat)=>{
            return mapSequence(sub_pat, min_replacement);
        }));
    };
    /**
	 * Convert an array of sequences into a pattern
	 * [{start:0,end:3,length:3,substr:'iii'}...] => (?:iii...)
	 */ const sequencesToPattern = (sequences, all = true)=>{
        let min_replacement = sequences.length > 1 ? 1 : 0;
        return arrayToPattern(sequences.map((sequence)=>{
            let seq = [];
            const len = all ? sequence.length() : sequence.length() - 1;
            for(let j = 0; j < len; j++)seq.push(substringsToPattern(sequence.substrs[j] || '', min_replacement));
            return sequencePattern(seq);
        }));
    };
    /**
	 * Return true if the sequence is already in the sequences
	 */ const inSequences = (needle_seq, sequences)=>{
        for (const seq of sequences){
            if (seq.start != needle_seq.start || seq.end != needle_seq.end) continue;
            if (seq.substrs.join('') !== needle_seq.substrs.join('')) continue;
            let needle_parts = needle_seq.parts;
            const filter = (part)=>{
                for (const needle_part of needle_parts){
                    if (needle_part.start === part.start && needle_part.substr === part.substr) return false;
                    if (part.length == 1 || needle_part.length == 1) continue;
                    // check for overlapping parts
                    // a = ['::=','==']
                    // b = ['::','===']
                    // a = ['r','sm']
                    // b = ['rs','m']
                    if (part.start < needle_part.start && part.end > needle_part.start) return true;
                    if (needle_part.start < part.start && needle_part.end > part.start) return true;
                }
                return false;
            };
            let filtered = seq.parts.filter(filter);
            if (filtered.length > 0) continue;
            return true;
        }
        return false;
    };
    class Sequence {
        parts;
        substrs;
        start;
        end;
        constructor(){
            this.parts = [];
            this.substrs = [];
            this.start = 0;
            this.end = 0;
        }
        add(part) {
            if (part) {
                this.parts.push(part);
                this.substrs.push(part.substr);
                this.start = Math.min(part.start, this.start);
                this.end = Math.max(part.end, this.end);
            }
        }
        last() {
            return this.parts[this.parts.length - 1];
        }
        length() {
            return this.parts.length;
        }
        clone(position, last_piece) {
            let clone = new Sequence();
            let parts = JSON.parse(JSON.stringify(this.parts));
            let last_part = parts.pop();
            for (const part of parts)clone.add(part);
            let last_substr = last_piece.substr.substring(0, position - last_part.start);
            let clone_last_len = last_substr.length;
            clone.add({
                start: last_part.start,
                end: last_part.start + clone_last_len,
                length: clone_last_len,
                substr: last_substr
            });
            return clone;
        }
    }
    /**
	 * Expand a regular expression pattern to include unicode variants
	 * 	eg /a/ becomes /aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐɑAⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ/
	 *
	 * Issue:
	 *  ﺊﺋ [ 'ﺊ = \\u{fe8a}', 'ﺋ = \\u{fe8b}' ]
	 *	becomes:	ئئ [ 'ي = \\u{64a}', 'ٔ = \\u{654}', 'ي = \\u{64a}', 'ٔ = \\u{654}' ]
	 *
	 *	İĲ = IIJ = ⅡJ
	 *
	 * 	1/2/4
	 */ const getPattern = (str)=>{
        initialize();
        str = asciifold(str);
        let pattern = '';
        let sequences = [
            new Sequence()
        ];
        for(let i = 0; i < str.length; i++){
            let substr = str.substring(i);
            let match = substr.match(multi_char_reg);
            const char = str.substring(i, i + 1);
            const match_str = match ? match[0] : null;
            // loop through sequences
            // add either the char or multi_match
            let overlapping = [];
            let added_types = new Set();
            for (const sequence of sequences){
                const last_piece = sequence.last();
                if (!last_piece || last_piece.length == 1 || last_piece.end <= i) {
                    // if we have a multi match
                    if (match_str) {
                        const len = match_str.length;
                        sequence.add({
                            start: i,
                            end: i + len,
                            length: len,
                            substr: match_str
                        });
                        added_types.add('1');
                    } else {
                        sequence.add({
                            start: i,
                            end: i + 1,
                            length: 1,
                            substr: char
                        });
                        added_types.add('2');
                    }
                } else if (match_str) {
                    let clone = sequence.clone(i, last_piece);
                    const len = match_str.length;
                    clone.add({
                        start: i,
                        end: i + len,
                        length: len,
                        substr: match_str
                    });
                    overlapping.push(clone);
                } else // don't add char
                // adding would create invalid patterns: 234 => [2,34,4]
                added_types.add('3');
            }
            // if we have overlapping
            if (overlapping.length > 0) {
                // ['ii','iii'] before ['i','i','iii']
                overlapping = overlapping.sort((a, b)=>{
                    return a.length() - b.length();
                });
                for (let clone of overlapping){
                    // don't add if we already have an equivalent sequence
                    if (inSequences(clone, sequences)) continue;
                    sequences.push(clone);
                }
                continue;
            }
            // if we haven't done anything unique
            // clean up the patterns
            // helps keep patterns smaller
            // if str = 'r₨㎧aarss', pattern will be 446 instead of 655
            if (i > 0 && added_types.size == 1 && !added_types.has('3')) {
                pattern += sequencesToPattern(sequences, false);
                let new_seq = new Sequence();
                const old_seq = sequences[0];
                if (old_seq) new_seq.add(old_seq.last());
                sequences = [
                    new_seq
                ];
            }
        }
        pattern += sequencesToPattern(sequences, true);
        return pattern;
    };
    /**
	 * A property getter resolving dot-notation
	 * @param  {Object}  obj     The root object to fetch property on
	 * @param  {String}  name    The optionally dotted property name to fetch
	 * @return {Object}          The resolved property value
	 */ const getAttr = (obj, name)=>{
        if (!obj) return;
        return obj[name];
    };
    /**
	 * A property getter resolving dot-notation
	 * @param  {Object}  obj     The root object to fetch property on
	 * @param  {String}  name    The optionally dotted property name to fetch
	 * @return {Object}          The resolved property value
	 */ const getAttrNesting = (obj, name)=>{
        if (!obj) return;
        var part, names = name.split(".");
        while((part = names.shift()) && (obj = obj[part]));
        return obj;
    };
    /**
	 * Calculates how close of a match the
	 * given value is against a search token.
	 *
	 */ const scoreValue = (value, token, weight)=>{
        var score, pos;
        if (!value) return 0;
        value = value + '';
        if (token.regex == null) return 0;
        pos = value.search(token.regex);
        if (pos === -1) return 0;
        score = token.string.length / value.length;
        if (pos === 0) score += 0.5;
        return score * weight;
    };
    /**
	 * Cast object property to an array if it exists and has a value
	 *
	 */ const propToArray = (obj, key)=>{
        var value = obj[key];
        if (typeof value == 'function') return value;
        if (value && !Array.isArray(value)) obj[key] = [
            value
        ];
    };
    /**
	 * Iterates over arrays and hashes.
	 *
	 * ```
	 * iterate(this.items, function(item, id) {
	 *    // invoked for each item
	 * });
	 * ```
	 *
	 */ const iterate$1 = (object, callback)=>{
        if (Array.isArray(object)) object.forEach(callback);
        else {
            for(var key in object)if (object.hasOwnProperty(key)) callback(object[key], key);
        }
    };
    const cmp = (a, b)=>{
        if (typeof a === 'number' && typeof b === 'number') return a > b ? 1 : a < b ? -1 : 0;
        a = asciifold(a + '').toLowerCase();
        b = asciifold(b + '').toLowerCase();
        if (a > b) return 1;
        if (b > a) return -1;
        return 0;
    };
    /**
	 * sifter.js
	 * Copyright (c) 2013–2020 Brian Reavis & contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 * @author Brian Reavis <brian@thirdroute.com>
	 */ class Sifter {
        items;
        settings;
        /**
	     * Textually searches arrays and hashes of objects
	     * by property (or multiple properties). Designed
	     * specifically for autocomplete.
	     *
	     */ constructor(items, settings){
            this.items = items;
            this.settings = settings || {
                diacritics: true
            };
        }
        /**
	     * Splits a search string into an array of individual
	     * regexps to be used to match results.
	     *
	     */ tokenize(query, respect_word_boundaries, weights) {
            if (!query || !query.length) return [];
            const tokens = [];
            const words = query.split(/\s+/);
            var field_regex;
            if (weights) field_regex = new RegExp('^(' + Object.keys(weights).map(escape_regex).join('|') + ')\:(.*)$');
            words.forEach((word)=>{
                let field_match;
                let field = null;
                let regex = null;
                // look for "field:query" tokens
                if (field_regex && (field_match = word.match(field_regex))) {
                    field = field_match[1];
                    word = field_match[2];
                }
                if (word.length > 0) {
                    if (this.settings.diacritics) regex = getPattern(word) || null;
                    else regex = escape_regex(word);
                    if (regex && respect_word_boundaries) regex = "\\b" + regex;
                }
                tokens.push({
                    string: word,
                    regex: regex ? new RegExp(regex, 'iu') : null,
                    field: field
                });
            });
            return tokens;
        }
        /**
	     * Returns a function to be used to score individual results.
	     *
	     * Good matches will have a higher score than poor matches.
	     * If an item is not a match, 0 will be returned by the function.
	     *
	     * @returns {T.ScoreFn}
	     */ getScoreFunction(query, options) {
            var search = this.prepareSearch(query, options);
            return this._getScoreFunction(search);
        }
        /**
	     * @returns {T.ScoreFn}
	     *
	     */ _getScoreFunction(search) {
            const tokens = search.tokens, token_count = tokens.length;
            if (!token_count) return function() {
                return 0;
            };
            const fields = search.options.fields, weights = search.weights, field_count = fields.length, getAttrFn = search.getAttrFn;
            if (!field_count) return function() {
                return 1;
            };
            /**
	         * Calculates the score of an object
	         * against the search query.
	         *
	         */ const scoreObject = function() {
                if (field_count === 1) return function(token, data) {
                    const field = fields[0].field;
                    return scoreValue(getAttrFn(data, field), token, weights[field] || 1);
                };
                return function(token, data) {
                    var sum = 0;
                    // is the token specific to a field?
                    if (token.field) {
                        const value = getAttrFn(data, token.field);
                        if (!token.regex && value) sum += 1 / field_count;
                        else sum += scoreValue(value, token, 1);
                    } else iterate$1(weights, (weight, field)=>{
                        sum += scoreValue(getAttrFn(data, field), token, weight);
                    });
                    return sum / field_count;
                };
            }();
            if (token_count === 1) return function(data) {
                return scoreObject(tokens[0], data);
            };
            if (search.options.conjunction === 'and') return function(data) {
                var score, sum = 0;
                for (let token of tokens){
                    score = scoreObject(token, data);
                    if (score <= 0) return 0;
                    sum += score;
                }
                return sum / token_count;
            };
            else return function(data) {
                var sum = 0;
                iterate$1(tokens, (token)=>{
                    sum += scoreObject(token, data);
                });
                return sum / token_count;
            };
        }
        /**
	     * Returns a function that can be used to compare two
	     * results, for sorting purposes. If no sorting should
	     * be performed, `null` will be returned.
	     *
	     * @return function(a,b)
	     */ getSortFunction(query, options) {
            var search = this.prepareSearch(query, options);
            return this._getSortFunction(search);
        }
        _getSortFunction(search) {
            var implicit_score, sort_flds = [];
            const self = this, options = search.options, sort = !search.query && options.sort_empty ? options.sort_empty : options.sort;
            if (typeof sort == 'function') return sort.bind(this);
            /**
	         * Fetches the specified sort field value
	         * from a search result item.
	         *
	         */ const get_field = function(name, result) {
                if (name === '$score') return result.score;
                return search.getAttrFn(self.items[result.id], name);
            };
            // parse options
            if (sort) {
                for (let s of sort)if (search.query || s.field !== '$score') sort_flds.push(s);
            }
            // the "$score" field is implied to be the primary
            // sort field, unless it's manually specified
            if (search.query) {
                implicit_score = true;
                for (let fld of sort_flds)if (fld.field === '$score') {
                    implicit_score = false;
                    break;
                }
                if (implicit_score) sort_flds.unshift({
                    field: '$score',
                    direction: 'desc'
                });
            // without a search.query, all items will have the same score
            } else sort_flds = sort_flds.filter((fld)=>fld.field !== '$score');
            // build function
            const sort_flds_count = sort_flds.length;
            if (!sort_flds_count) return null;
            return function(a, b) {
                var result, field;
                for (let sort_fld of sort_flds){
                    field = sort_fld.field;
                    let multiplier = sort_fld.direction === 'desc' ? -1 : 1;
                    result = multiplier * cmp(get_field(field, a), get_field(field, b));
                    if (result) return result;
                }
                return 0;
            };
        }
        /**
	     * Parses a search query and returns an object
	     * with tokens and fields ready to be populated
	     * with results.
	     *
	     */ prepareSearch(query, optsUser) {
            const weights = {};
            var options = Object.assign({}, optsUser);
            propToArray(options, 'sort');
            propToArray(options, 'sort_empty');
            // convert fields to new format
            if (options.fields) {
                propToArray(options, 'fields');
                const fields = [];
                options.fields.forEach((field)=>{
                    if (typeof field == 'string') field = {
                        field: field,
                        weight: 1
                    };
                    fields.push(field);
                    weights[field.field] = 'weight' in field ? field.weight : 1;
                });
                options.fields = fields;
            }
            return {
                options: options,
                query: query.toLowerCase().trim(),
                tokens: this.tokenize(query, options.respect_word_boundaries, weights),
                total: 0,
                items: [],
                weights: weights,
                getAttrFn: options.nesting ? getAttrNesting : getAttr
            };
        }
        /**
	     * Searches through all items and returns a sorted array of matches.
	     *
	     */ search(query, options) {
            var self = this, score, search;
            search = this.prepareSearch(query, options);
            options = search.options;
            query = search.query;
            // generate result scoring function
            const fn_score = options.score || self._getScoreFunction(search);
            // perform search and sort
            if (query.length) iterate$1(self.items, (item, id)=>{
                score = fn_score(item);
                if (options.filter === false || score > 0) search.items.push({
                    'score': score,
                    'id': id
                });
            });
            else iterate$1(self.items, (_, id)=>{
                search.items.push({
                    'score': 1,
                    'id': id
                });
            });
            const fn_sort = self._getSortFunction(search);
            if (fn_sort) search.items.sort(fn_sort);
            // apply limits
            search.total = search.items.length;
            if (typeof options.limit === 'number') search.items = search.items.slice(0, options.limit);
            return search;
        }
    }
    /**
	 * Converts a scalar to its best string representation
	 * for hash keys and HTML attribute values.
	 *
	 * Transformations:
	 *   'str'     -> 'str'
	 *   null      -> ''
	 *   undefined -> ''
	 *   true      -> '1'
	 *   false     -> '0'
	 *   0         -> '0'
	 *   1         -> '1'
	 *
	 */ const hash_key = (value)=>{
        if (typeof value === 'undefined' || value === null) return null;
        return get_hash(value);
    };
    const get_hash = (value)=>{
        if (typeof value === 'boolean') return value ? '1' : '0';
        return value + '';
    };
    /**
	 * Escapes a string for use within HTML.
	 *
	 */ const escape_html = (str)=>{
        return (str + '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    };
    /**
	 * use setTimeout if timeout > 0 
	 */ const timeout = (fn, timeout)=>{
        if (timeout > 0) return window.setTimeout(fn, timeout);
        fn.call(null);
        return null;
    };
    /**
	 * Debounce the user provided load function
	 *
	 */ const loadDebounce = (fn, delay)=>{
        var timeout;
        return function(value, callback) {
            var self = this;
            if (timeout) {
                self.loading = Math.max(self.loading - 1, 0);
                clearTimeout(timeout);
            }
            timeout = setTimeout(function() {
                timeout = null;
                self.loadedSearches[value] = true;
                fn.call(self, value, callback);
            }, delay);
        };
    };
    /**
	 * Debounce all fired events types listed in `types`
	 * while executing the provided `fn`.
	 *
	 */ const debounce_events = (self, types, fn)=>{
        var type;
        var trigger = self.trigger;
        var event_args = {};
        // override trigger method
        self.trigger = function() {
            var type = arguments[0];
            if (types.indexOf(type) !== -1) event_args[type] = arguments;
            else return trigger.apply(self, arguments);
        };
        // invoke provided function
        fn.apply(self, []);
        self.trigger = trigger;
        // trigger queued events
        for (type of types)if (type in event_args) trigger.apply(self, event_args[type]);
    };
    /**
	 * Determines the current selection within a text input control.
	 * Returns an object containing:
	 *   - start
	 *   - length
	 *
	 * Note: "selectionStart, selectionEnd ... apply only to inputs of types text, search, URL, tel and password"
	 * 	- https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
	 */ const getSelection = (input)=>{
        return {
            start: input.selectionStart || 0,
            length: (input.selectionEnd || 0) - (input.selectionStart || 0)
        };
    };
    /**
	 * Prevent default
	 *
	 */ const preventDefault = (evt, stop = false)=>{
        if (evt) {
            evt.preventDefault();
            if (stop) evt.stopPropagation();
        }
    };
    /**
	 * Add event helper
	 *
	 */ const addEvent = (target, type, callback, options)=>{
        target.addEventListener(type, callback, options);
    };
    /**
	 * Return true if the requested key is down
	 * Will return false if more than one control character is pressed ( when [ctrl+shift+a] != [ctrl+a] )
	 * The current evt may not always set ( eg calling advanceSelection() )
	 *
	 */ const isKeyDown = (key_name, evt)=>{
        if (!evt) return false;
        if (!evt[key_name]) return false;
        var count = (evt.altKey ? 1 : 0) + (evt.ctrlKey ? 1 : 0) + (evt.shiftKey ? 1 : 0) + (evt.metaKey ? 1 : 0);
        if (count === 1) return true;
        return false;
    };
    /**
	 * Get the id of an element
	 * If the id attribute is not set, set the attribute with the given id
	 *
	 */ const getId = (el, id)=>{
        const existing_id = el.getAttribute('id');
        if (existing_id) return existing_id;
        el.setAttribute('id', id);
        return id;
    };
    /**
	 * Returns a string with backslashes added before characters that need to be escaped.
	 */ const addSlashes = (str)=>{
        return str.replace(/[\\"']/g, '\\$&');
    };
    /**
	 *
	 */ const append = (parent, node)=>{
        if (node) parent.append(node);
    };
    /**
	 * Iterates over arrays and hashes.
	 *
	 * ```
	 * iterate(this.items, function(item, id) {
	 *    // invoked for each item
	 * });
	 * ```
	 *
	 */ const iterate = (object, callback)=>{
        if (Array.isArray(object)) object.forEach(callback);
        else {
            for(var key in object)if (object.hasOwnProperty(key)) callback(object[key], key);
        }
    };
    /**
	 * Return a dom element from either a dom query string, jQuery object, a dom element or html string
	 * https://stackoverflow.com/questions/494143/creating-a-new-dom-element-from-an-html-string-using-built-in-dom-methods-or-pro/35385518#35385518
	 *
	 * param query should be {}
	 */ const getDom = (query)=>{
        if (query.jquery) return query[0];
        if (query instanceof HTMLElement) return query;
        if (isHtmlString(query)) {
            var tpl = document.createElement('template');
            tpl.innerHTML = query.trim(); // Never return a text node of whitespace as the result
            return tpl.content.firstChild;
        }
        return document.querySelector(query);
    };
    const isHtmlString = (arg)=>{
        if (typeof arg === 'string' && arg.indexOf('<') > -1) return true;
        return false;
    };
    const escapeQuery = (query)=>{
        return query.replace(/['"\\]/g, '\\$&');
    };
    /**
	 * Dispatch an event
	 *
	 */ const triggerEvent = (dom_el, event_name)=>{
        var event = document.createEvent('HTMLEvents');
        event.initEvent(event_name, true, false);
        dom_el.dispatchEvent(event);
    };
    /**
	 * Apply CSS rules to a dom element
	 *
	 */ const applyCSS = (dom_el, css)=>{
        Object.assign(dom_el.style, css);
    };
    /**
	 * Add css classes
	 *
	 */ const addClasses = (elmts, ...classes)=>{
        var norm_classes = classesArray(classes);
        elmts = castAsArray(elmts);
        elmts.map((el)=>{
            norm_classes.map((cls)=>{
                el.classList.add(cls);
            });
        });
    };
    /**
	 * Remove css classes
	 *
	 */ const removeClasses = (elmts, ...classes)=>{
        var norm_classes = classesArray(classes);
        elmts = castAsArray(elmts);
        elmts.map((el)=>{
            norm_classes.map((cls)=>{
                el.classList.remove(cls);
            });
        });
    };
    /**
	 * Return arguments
	 *
	 */ const classesArray = (args)=>{
        var classes = [];
        iterate(args, (_classes)=>{
            if (typeof _classes === 'string') _classes = _classes.trim().split(/[\t\n\f\r\s]/);
            if (Array.isArray(_classes)) classes = classes.concat(_classes);
        });
        return classes.filter(Boolean);
    };
    /**
	 * Create an array from arg if it's not already an array
	 *
	 */ const castAsArray = (arg)=>{
        if (!Array.isArray(arg)) arg = [
            arg
        ];
        return arg;
    };
    /**
	 * Get the closest node to the evt.target matching the selector
	 * Stops at wrapper
	 *
	 */ const parentMatch = (target, selector, wrapper)=>{
        if (wrapper && !wrapper.contains(target)) return;
        while(target && target.matches){
            if (target.matches(selector)) return target;
            target = target.parentNode;
        }
    };
    /**
	 * Get the first or last item from an array
	 *
	 * > 0 - right (last)
	 * <= 0 - left (first)
	 *
	 */ const getTail = (list, direction = 0)=>{
        if (direction > 0) return list[list.length - 1];
        return list[0];
    };
    /**
	 * Return true if an object is empty
	 *
	 */ const isEmptyObject = (obj)=>{
        return Object.keys(obj).length === 0;
    };
    /**
	 * Get the index of an element amongst sibling nodes of the same type
	 *
	 */ const nodeIndex = (el, amongst)=>{
        if (!el) return -1;
        amongst = amongst || el.nodeName;
        var i = 0;
        while(el = el.previousElementSibling)if (el.matches(amongst)) i++;
        return i;
    };
    /**
	 * Set attributes of an element
	 *
	 */ const setAttr = (el, attrs)=>{
        iterate(attrs, (val, attr)=>{
            if (val == null) el.removeAttribute(attr);
            else el.setAttribute(attr, '' + val);
        });
    };
    /**
	 * Replace a node
	 */ const replaceNode = (existing, replacement)=>{
        if (existing.parentNode) existing.parentNode.replaceChild(replacement, existing);
    };
    /**
	 * highlight v3 | MIT license | Johann Burkard <jb@eaio.com>
	 * Highlights arbitrary terms in a node.
	 *
	 * - Modified by Marshal <beatgates@gmail.com> 2011-6-24 (added regex)
	 * - Modified by Brian Reavis <brian@thirdroute.com> 2012-8-27 (cleanup)
	 */ const highlight = (element, regex)=>{
        if (regex === null) return;
        // convet string to regex
        if (typeof regex === 'string') {
            if (!regex.length) return;
            regex = new RegExp(regex, 'i');
        }
        // Wrap matching part of text node with highlighting <span>, e.g.
        // Soccer  ->  <span class="highlight">Soc</span>cer  for regex = /soc/i
        const highlightText = (node)=>{
            var match = node.data.match(regex);
            if (match && node.data.length > 0) {
                var spannode = document.createElement('span');
                spannode.className = 'highlight';
                var middlebit = node.splitText(match.index);
                middlebit.splitText(match[0].length);
                var middleclone = middlebit.cloneNode(true);
                spannode.appendChild(middleclone);
                replaceNode(middlebit, spannode);
                return 1;
            }
            return 0;
        };
        // Recurse element node, looking for child text nodes to highlight, unless element
        // is childless, <script>, <style>, or already highlighted: <span class="hightlight">
        const highlightChildren = (node)=>{
            if (node.nodeType === 1 && node.childNodes && !/(script|style)/i.test(node.tagName) && (node.className !== 'highlight' || node.tagName !== 'SPAN')) Array.from(node.childNodes).forEach((element)=>{
                highlightRecursive(element);
            });
        };
        const highlightRecursive = (node)=>{
            if (node.nodeType === 3) return highlightText(node);
            highlightChildren(node);
            return 0;
        };
        highlightRecursive(element);
    };
    /**
	 * removeHighlight fn copied from highlight v5 and
	 * edited to remove with(), pass js strict mode, and use without jquery
	 */ const removeHighlight = (el)=>{
        var elements = el.querySelectorAll("span.highlight");
        Array.prototype.forEach.call(elements, function(el) {
            var parent = el.parentNode;
            parent.replaceChild(el.firstChild, el);
            parent.normalize();
        });
    };
    const KEY_A = 65;
    const KEY_RETURN = 13;
    const KEY_ESC = 27;
    const KEY_LEFT = 37;
    const KEY_UP = 38;
    const KEY_RIGHT = 39;
    const KEY_DOWN = 40;
    const KEY_BACKSPACE = 8;
    const KEY_DELETE = 46;
    const KEY_TAB = 9;
    const IS_MAC = typeof navigator === 'undefined' ? false : /Mac/.test(navigator.userAgent);
    const KEY_SHORTCUT = IS_MAC ? 'metaKey' : 'ctrlKey'; // ctrl key or apple key for ma
    var defaults = {
        options: [],
        optgroups: [],
        plugins: [],
        delimiter: ',',
        splitOn: null,
        // regexp or string for splitting up values from a paste command
        persist: true,
        diacritics: true,
        create: null,
        createOnBlur: false,
        createFilter: null,
        highlight: true,
        openOnFocus: true,
        shouldOpen: null,
        maxOptions: 50,
        maxItems: null,
        hideSelected: null,
        duplicates: false,
        addPrecedence: false,
        selectOnTab: false,
        preload: null,
        allowEmptyOption: false,
        //closeAfterSelect: false,
        refreshThrottle: 300,
        loadThrottle: 300,
        loadingClass: 'loading',
        dataAttr: null,
        //'data-data',
        optgroupField: 'optgroup',
        valueField: 'value',
        labelField: 'text',
        disabledField: 'disabled',
        optgroupLabelField: 'label',
        optgroupValueField: 'value',
        lockOptgroupOrder: false,
        sortField: '$order',
        searchField: [
            'text'
        ],
        searchConjunction: 'and',
        mode: null,
        wrapperClass: 'ts-wrapper',
        controlClass: 'ts-control',
        dropdownClass: 'ts-dropdown',
        dropdownContentClass: 'ts-dropdown-content',
        itemClass: 'item',
        optionClass: 'option',
        dropdownParent: null,
        controlInput: '<input type="text" autocomplete="off" size="1" />',
        copyClassesToDropdown: false,
        placeholder: null,
        hidePlaceholder: null,
        shouldLoad: function(query) {
            return query.length > 0;
        },
        /*
	  load                 : null, // function(query, callback) { ... }
	  score                : null, // function(search) { ... }
	  onInitialize         : null, // function() { ... }
	  onChange             : null, // function(value) { ... }
	  onItemAdd            : null, // function(value, $item) { ... }
	  onItemRemove         : null, // function(value) { ... }
	  onClear              : null, // function() { ... }
	  onOptionAdd          : null, // function(value, data) { ... }
	  onOptionRemove       : null, // function(value) { ... }
	  onOptionClear        : null, // function() { ... }
	  onOptionGroupAdd     : null, // function(id, data) { ... }
	  onOptionGroupRemove  : null, // function(id) { ... }
	  onOptionGroupClear   : null, // function() { ... }
	  onDropdownOpen       : null, // function(dropdown) { ... }
	  onDropdownClose      : null, // function(dropdown) { ... }
	  onType               : null, // function(str) { ... }
	  onDelete             : null, // function(values) { ... }
	  */ render: {
        }
    };
    function getSettings(input, settings_user) {
        var settings = Object.assign({}, defaults, settings_user);
        var attr_data = settings.dataAttr;
        var field_label = settings.labelField;
        var field_value = settings.valueField;
        var field_disabled = settings.disabledField;
        var field_optgroup = settings.optgroupField;
        var field_optgroup_label = settings.optgroupLabelField;
        var field_optgroup_value = settings.optgroupValueField;
        var tag_name = input.tagName.toLowerCase();
        var placeholder = input.getAttribute('placeholder') || input.getAttribute('data-placeholder');
        if (!placeholder && !settings.allowEmptyOption) {
            let option = input.querySelector('option[value=""]');
            if (option) placeholder = option.textContent;
        }
        var settings_element = {
            placeholder: placeholder,
            options: [],
            optgroups: [],
            items: [],
            maxItems: null
        };
        /**
	   * Initialize from a <select> element.
	   *
	   */ var init_select = ()=>{
            var tagName;
            var options = settings_element.options;
            var optionsMap = {};
            var group_count = 1;
            let $order = 0;
            var readData = (el)=>{
                var data = Object.assign({}, el.dataset); // get plain object from DOMStringMap
                var json = attr_data && data[attr_data];
                if (typeof json === 'string' && json.length) data = Object.assign(data, JSON.parse(json));
                return data;
            };
            var addOption = (option, group)=>{
                var value = hash_key(option.value);
                if (value == null) return;
                if (!value && !settings.allowEmptyOption) return;
                // if the option already exists, it's probably been
                // duplicated in another optgroup. in this case, push
                // the current group to the "optgroup" property on the
                // existing option so that it's rendered in both places.
                if (optionsMap.hasOwnProperty(value)) {
                    if (group) {
                        var arr = optionsMap[value][field_optgroup];
                        if (!arr) optionsMap[value][field_optgroup] = group;
                        else if (!Array.isArray(arr)) optionsMap[value][field_optgroup] = [
                            arr,
                            group
                        ];
                        else arr.push(group);
                    }
                } else {
                    var option_data = readData(option);
                    option_data[field_label] = option_data[field_label] || option.textContent;
                    option_data[field_value] = option_data[field_value] || value;
                    option_data[field_disabled] = option_data[field_disabled] || option.disabled;
                    option_data[field_optgroup] = option_data[field_optgroup] || group;
                    option_data.$option = option;
                    option_data.$order = option_data.$order || ++$order;
                    optionsMap[value] = option_data;
                    options.push(option_data);
                }
                if (option.selected) settings_element.items.push(value);
            };
            var addGroup = (optgroup)=>{
                var id, optgroup_data;
                optgroup_data = readData(optgroup);
                optgroup_data[field_optgroup_label] = optgroup_data[field_optgroup_label] || optgroup.getAttribute('label') || '';
                optgroup_data[field_optgroup_value] = optgroup_data[field_optgroup_value] || group_count++;
                optgroup_data[field_disabled] = optgroup_data[field_disabled] || optgroup.disabled;
                optgroup_data.$order = optgroup_data.$order || ++$order;
                settings_element.optgroups.push(optgroup_data);
                id = optgroup_data[field_optgroup_value];
                iterate(optgroup.children, (option)=>{
                    addOption(option, id);
                });
            };
            settings_element.maxItems = input.hasAttribute('multiple') ? null : 1;
            iterate(input.children, (child)=>{
                tagName = child.tagName.toLowerCase();
                if (tagName === 'optgroup') addGroup(child);
                else if (tagName === 'option') addOption(child);
            });
        };
        /**
	   * Initialize from a <input type="text"> element.
	   *
	   */ var init_textbox = ()=>{
            const data_raw = input.getAttribute(attr_data);
            if (!data_raw) {
                var value = input.value.trim() || '';
                if (!settings.allowEmptyOption && !value.length) return;
                const values = value.split(settings.delimiter);
                iterate(values, (value)=>{
                    const option = {};
                    option[field_label] = value;
                    option[field_value] = value;
                    settings_element.options.push(option);
                });
                settings_element.items = values;
            } else {
                settings_element.options = JSON.parse(data_raw);
                iterate(settings_element.options, (opt)=>{
                    settings_element.items.push(opt[field_value]);
                });
            }
        };
        if (tag_name === 'select') init_select();
        else init_textbox();
        return Object.assign({}, defaults, settings_element, settings_user);
    }
    var instance_i = 0;
    class TomSelect1 extends MicroPlugin(MicroEvent) {
        constructor(input_arg, user_settings){
            super();
            this.order = 0;
            this.isOpen = false;
            this.isDisabled = false;
            this.isReadOnly = false;
            this.isInvalid = false;
            // @deprecated 1.8
            this.isValid = true;
            this.isLocked = false;
            this.isFocused = false;
            this.isInputHidden = false;
            this.isSetup = false;
            this.ignoreFocus = false;
            this.ignoreHover = false;
            this.hasOptions = false;
            this.lastValue = '';
            this.caretPos = 0;
            this.loading = 0;
            this.loadedSearches = {};
            this.activeOption = null;
            this.activeItems = [];
            this.optgroups = {};
            this.options = {};
            this.userOptions = {};
            this.items = [];
            this.refreshTimeout = null;
            instance_i++;
            var dir;
            var input = getDom(input_arg);
            if (input.tomselect) throw new Error('Tom Select already initialized on this element');
            input.tomselect = this;
            // detect rtl environment
            var computedStyle = window.getComputedStyle && window.getComputedStyle(input, null);
            dir = computedStyle.getPropertyValue('direction');
            // setup default state
            const settings = getSettings(input, user_settings);
            this.settings = settings;
            this.input = input;
            this.tabIndex = input.tabIndex || 0;
            this.is_select_tag = input.tagName.toLowerCase() === 'select';
            this.rtl = /rtl/i.test(dir);
            this.inputId = getId(input, 'tomselect-' + instance_i);
            this.isRequired = input.required;
            // search system
            this.sifter = new Sifter(this.options, {
                diacritics: settings.diacritics
            });
            // option-dependent defaults
            settings.mode = settings.mode || (settings.maxItems === 1 ? 'single' : 'multi');
            if (typeof settings.hideSelected !== 'boolean') settings.hideSelected = settings.mode === 'multi';
            if (typeof settings.hidePlaceholder !== 'boolean') settings.hidePlaceholder = settings.mode !== 'multi';
            // set up createFilter callback
            var filter = settings.createFilter;
            if (typeof filter !== 'function') {
                if (typeof filter === 'string') filter = new RegExp(filter);
                if (filter instanceof RegExp) settings.createFilter = (input)=>filter.test(input);
                else settings.createFilter = (value)=>{
                    return this.settings.duplicates || !this.options[value];
                };
            }
            this.initializePlugins(settings.plugins);
            this.setupCallbacks();
            this.setupTemplates();
            // Create all elements
            const wrapper = getDom('<div>');
            const control = getDom('<div>');
            const dropdown = this._render('dropdown');
            const dropdown_content = getDom(`<div role="listbox" tabindex="-1">`);
            const classes = this.input.getAttribute('class') || '';
            const inputMode = settings.mode;
            var control_input;
            addClasses(wrapper, settings.wrapperClass, classes, inputMode);
            addClasses(control, settings.controlClass);
            append(wrapper, control);
            addClasses(dropdown, settings.dropdownClass, inputMode);
            if (settings.copyClassesToDropdown) addClasses(dropdown, classes);
            addClasses(dropdown_content, settings.dropdownContentClass);
            append(dropdown, dropdown_content);
            getDom(settings.dropdownParent || wrapper).appendChild(dropdown);
            // default controlInput
            if (isHtmlString(settings.controlInput)) {
                control_input = getDom(settings.controlInput);
                // set attributes
                var attrs = [
                    'autocorrect',
                    'autocapitalize',
                    'autocomplete',
                    'spellcheck'
                ];
                iterate(attrs, (attr)=>{
                    if (input.getAttribute(attr)) setAttr(control_input, {
                        [attr]: input.getAttribute(attr)
                    });
                });
                control_input.tabIndex = -1;
                control.appendChild(control_input);
                this.focus_node = control_input;
            // dom element
            } else if (settings.controlInput) {
                control_input = getDom(settings.controlInput);
                this.focus_node = control_input;
            } else {
                control_input = getDom('<input/>');
                this.focus_node = control;
            }
            this.wrapper = wrapper;
            this.dropdown = dropdown;
            this.dropdown_content = dropdown_content;
            this.control = control;
            this.control_input = control_input;
            this.setup();
        }
        /**
	   * set up event bindings.
	   *
	   */ setup() {
            const self = this;
            const settings = self.settings;
            const control_input = self.control_input;
            const dropdown = self.dropdown;
            const dropdown_content = self.dropdown_content;
            const wrapper = self.wrapper;
            const control = self.control;
            const input = self.input;
            const focus_node = self.focus_node;
            const passive_event = {
                passive: true
            };
            const listboxId = self.inputId + '-ts-dropdown';
            setAttr(dropdown_content, {
                id: listboxId
            });
            setAttr(focus_node, {
                role: 'combobox',
                'aria-haspopup': 'listbox',
                'aria-expanded': 'false',
                'aria-controls': listboxId
            });
            const control_id = getId(focus_node, self.inputId + '-ts-control');
            const query = "label[for='" + escapeQuery(self.inputId) + "']";
            const label = document.querySelector(query);
            const label_click = self.focus.bind(self);
            if (label) {
                addEvent(label, 'click', label_click);
                setAttr(label, {
                    for: control_id
                });
                const label_id = getId(label, self.inputId + '-ts-label');
                setAttr(focus_node, {
                    'aria-labelledby': label_id
                });
                setAttr(dropdown_content, {
                    'aria-labelledby': label_id
                });
            }
            wrapper.style.width = input.style.width;
            if (self.plugins.names.length) {
                const classes_plugins = 'plugin-' + self.plugins.names.join(' plugin-');
                addClasses([
                    wrapper,
                    dropdown
                ], classes_plugins);
            }
            if ((settings.maxItems === null || settings.maxItems > 1) && self.is_select_tag) setAttr(input, {
                multiple: 'multiple'
            });
            if (settings.placeholder) setAttr(control_input, {
                placeholder: settings.placeholder
            });
            // if splitOn was not passed in, construct it from the delimiter to allow pasting universally
            if (!settings.splitOn && settings.delimiter) settings.splitOn = new RegExp('\\s*' + escape_regex(settings.delimiter) + '+\\s*');
            // debounce user defined load() if loadThrottle > 0
            // after initializePlugins() so plugins can create/modify user defined loaders
            if (settings.load && settings.loadThrottle) settings.load = loadDebounce(settings.load, settings.loadThrottle);
            addEvent(dropdown, 'mousemove', ()=>{
                self.ignoreHover = false;
            });
            addEvent(dropdown, 'mouseenter', (e)=>{
                var target_match = parentMatch(e.target, '[data-selectable]', dropdown);
                if (target_match) self.onOptionHover(e, target_match);
            }, {
                capture: true
            });
            // clicking on an option should select it
            addEvent(dropdown, 'click', (evt)=>{
                const option = parentMatch(evt.target, '[data-selectable]');
                if (option) {
                    self.onOptionSelect(evt, option);
                    preventDefault(evt, true);
                }
            });
            addEvent(control, 'click', (evt)=>{
                var target_match = parentMatch(evt.target, '[data-ts-item]', control);
                if (target_match && self.onItemSelect(evt, target_match)) {
                    preventDefault(evt, true);
                    return;
                }
                // retain focus (see control_input mousedown)
                if (control_input.value != '') return;
                self.onClick();
                preventDefault(evt, true);
            });
            // keydown on focus_node for arrow_down/arrow_up
            addEvent(focus_node, 'keydown', (e)=>self.onKeyDown(e));
            // keypress and input/keyup
            addEvent(control_input, 'keypress', (e)=>self.onKeyPress(e));
            addEvent(control_input, 'input', (e)=>self.onInput(e));
            addEvent(focus_node, 'blur', (e)=>self.onBlur(e));
            addEvent(focus_node, 'focus', (e)=>self.onFocus(e));
            addEvent(control_input, 'paste', (e)=>self.onPaste(e));
            const doc_mousedown = (evt)=>{
                // blur if target is outside of this instance
                // dropdown is not always inside wrapper
                const target = evt.composedPath()[0];
                if (!wrapper.contains(target) && !dropdown.contains(target)) {
                    if (self.isFocused) self.blur();
                    self.inputState();
                    return;
                }
                // retain focus by preventing native handling. if the
                // event target is the input it should not be modified.
                // otherwise, text selection within the input won't work.
                // Fixes bug #212 which is no covered by tests
                if (target == control_input && self.isOpen) evt.stopPropagation();
                else preventDefault(evt, true);
            };
            const win_scroll = ()=>{
                if (self.isOpen) self.positionDropdown();
            };
            addEvent(document, 'mousedown', doc_mousedown);
            addEvent(window, 'scroll', win_scroll, passive_event);
            addEvent(window, 'resize', win_scroll, passive_event);
            this._destroy = ()=>{
                document.removeEventListener('mousedown', doc_mousedown);
                window.removeEventListener('scroll', win_scroll);
                window.removeEventListener('resize', win_scroll);
                if (label) label.removeEventListener('click', label_click);
            };
            // store original html and tab index so that they can be
            // restored when the destroy() method is called.
            this.revertSettings = {
                innerHTML: input.innerHTML,
                tabIndex: input.tabIndex
            };
            input.tabIndex = -1;
            input.insertAdjacentElement('afterend', self.wrapper);
            self.sync(false);
            settings.items = [];
            delete settings.optgroups;
            delete settings.options;
            addEvent(input, 'invalid', ()=>{
                if (self.isValid) {
                    self.isValid = false;
                    self.isInvalid = true;
                    self.refreshState();
                }
            });
            self.updateOriginalInput();
            self.refreshItems();
            self.close(false);
            self.inputState();
            self.isSetup = true;
            if (input.disabled) self.disable();
            else if (input.readOnly) self.setReadOnly(true);
            else self.enable(); //sets tabIndex
            self.on('change', this.onChange);
            addClasses(input, 'tomselected', 'ts-hidden-accessible');
            self.trigger('initialize');
            // preload options
            if (settings.preload === true) self.preload();
        }
        /**
	   * Register options and optgroups
	   *
	   */ setupOptions(options = [], optgroups = []) {
            // build options table
            this.addOptions(options);
            // build optgroup table
            iterate(optgroups, (optgroup)=>{
                this.registerOptionGroup(optgroup);
            });
        }
        /**
	   * Sets up default rendering functions.
	   */ setupTemplates() {
            var self = this;
            var field_label = self.settings.labelField;
            var field_optgroup = self.settings.optgroupLabelField;
            var templates = {
                'optgroup': (data)=>{
                    let optgroup = document.createElement('div');
                    optgroup.className = 'optgroup';
                    optgroup.appendChild(data.options);
                    return optgroup;
                },
                'optgroup_header': (data, escape)=>{
                    return '<div class="optgroup-header">' + escape(data[field_optgroup]) + '</div>';
                },
                'option': (data, escape)=>{
                    return '<div>' + escape(data[field_label]) + '</div>';
                },
                'item': (data, escape)=>{
                    return '<div>' + escape(data[field_label]) + '</div>';
                },
                'option_create': (data, escape)=>{
                    return '<div class="create">Add <strong>' + escape(data.input) + '</strong>&hellip;</div>';
                },
                'no_results': ()=>{
                    return '<div class="no-results">No results found</div>';
                },
                'loading': ()=>{
                    return '<div class="spinner"></div>';
                },
                'not_loading': ()=>{},
                'dropdown': ()=>{
                    return '<div></div>';
                }
            };
            self.settings.render = Object.assign({}, templates, self.settings.render);
        }
        /**
	   * Maps fired events to callbacks provided
	   * in the settings used when creating the control.
	   */ setupCallbacks() {
            var key, fn;
            var callbacks = {
                'initialize': 'onInitialize',
                'change': 'onChange',
                'item_add': 'onItemAdd',
                'item_remove': 'onItemRemove',
                'item_select': 'onItemSelect',
                'clear': 'onClear',
                'option_add': 'onOptionAdd',
                'option_remove': 'onOptionRemove',
                'option_clear': 'onOptionClear',
                'optgroup_add': 'onOptionGroupAdd',
                'optgroup_remove': 'onOptionGroupRemove',
                'optgroup_clear': 'onOptionGroupClear',
                'dropdown_open': 'onDropdownOpen',
                'dropdown_close': 'onDropdownClose',
                'type': 'onType',
                'load': 'onLoad',
                'focus': 'onFocus',
                'blur': 'onBlur'
            };
            for(key in callbacks){
                fn = this.settings[callbacks[key]];
                if (fn) this.on(key, fn);
            }
        }
        /**
	   * Sync the Tom Select instance with the original input or select
	   *
	   */ sync(get_settings = true) {
            const self = this;
            const settings = get_settings ? getSettings(self.input, {
                delimiter: self.settings.delimiter
            }) : self.settings;
            self.setupOptions(settings.options, settings.optgroups);
            self.setValue(settings.items || [], true); // silent prevents recursion
            self.lastQuery = null; // so updated options will be displayed in dropdown
        }
        /**
	   * Triggered when the main control element
	   * has a click event.
	   *
	   */ onClick() {
            var self = this;
            if (self.activeItems.length > 0) {
                self.clearActiveItems();
                self.focus();
                return;
            }
            if (self.isFocused && self.isOpen) self.blur();
            else self.focus();
        }
        /**
	   * @deprecated v1.7
	   *
	   */ onMouseDown() {}
        /**
	   * Triggered when the value of the control has been changed.
	   * This should propagate the event to the original DOM
	   * input / select element.
	   */ onChange() {
            triggerEvent(this.input, 'input');
            triggerEvent(this.input, 'change');
        }
        /**
	   * Triggered on <input> paste.
	   *
	   */ onPaste(e) {
            var self = this;
            if (self.isInputHidden || self.isLocked) {
                preventDefault(e);
                return;
            }
            // If a regex or string is included, this will split the pasted
            // input and create Items for each separate value
            if (!self.settings.splitOn) return;
            // Wait for pasted text to be recognized in value
            setTimeout(()=>{
                var pastedText = self.inputValue();
                if (!pastedText.match(self.settings.splitOn)) return;
                var splitInput = pastedText.trim().split(self.settings.splitOn);
                iterate(splitInput, (piece)=>{
                    const hash = hash_key(piece);
                    if (hash) {
                        if (this.options[piece]) self.addItem(piece);
                        else self.createItem(piece);
                    }
                });
            }, 0);
        }
        /**
	   * Triggered on <input> keypress.
	   *
	   */ onKeyPress(e) {
            var self = this;
            if (self.isLocked) {
                preventDefault(e);
                return;
            }
            var character = String.fromCharCode(e.keyCode || e.which);
            if (self.settings.create && self.settings.mode === 'multi' && character === self.settings.delimiter) {
                self.createItem();
                preventDefault(e);
                return;
            }
        }
        /**
	   * Triggered on <input> keydown.
	   *
	   */ onKeyDown(e) {
            var self = this;
            self.ignoreHover = true;
            if (self.isLocked) {
                if (e.keyCode !== KEY_TAB) preventDefault(e);
                return;
            }
            switch(e.keyCode){
                // ctrl+A: select all
                case KEY_A:
                    if (isKeyDown(KEY_SHORTCUT, e)) {
                        if (self.control_input.value == '') {
                            preventDefault(e);
                            self.selectAll();
                            return;
                        }
                    }
                    break;
                // esc: close dropdown
                case KEY_ESC:
                    if (self.isOpen) {
                        preventDefault(e, true);
                        self.close();
                    }
                    self.clearActiveItems();
                    return;
                // down: open dropdown or move selection down
                case KEY_DOWN:
                    if (!self.isOpen && self.hasOptions) self.open();
                    else if (self.activeOption) {
                        let next = self.getAdjacent(self.activeOption, 1);
                        if (next) self.setActiveOption(next);
                    }
                    preventDefault(e);
                    return;
                // up: move selection up
                case KEY_UP:
                    if (self.activeOption) {
                        let prev = self.getAdjacent(self.activeOption, -1);
                        if (prev) self.setActiveOption(prev);
                    }
                    preventDefault(e);
                    return;
                // return: select active option
                case KEY_RETURN:
                    if (self.canSelect(self.activeOption)) {
                        self.onOptionSelect(e, self.activeOption);
                        preventDefault(e);
                    // if the option_create=null, the dropdown might be closed
                    } else if (self.settings.create && self.createItem()) preventDefault(e);
                    else if (document.activeElement == self.control_input && self.isOpen) preventDefault(e);
                    return;
                // left: modifiy item selection to the left
                case KEY_LEFT:
                    self.advanceSelection(-1, e);
                    return;
                // right: modifiy item selection to the right
                case KEY_RIGHT:
                    self.advanceSelection(1, e);
                    return;
                // tab: select active option and/or create item
                case KEY_TAB:
                    if (self.settings.selectOnTab) {
                        if (self.canSelect(self.activeOption)) {
                            self.onOptionSelect(e, self.activeOption);
                            // prevent default [tab] behaviour of jump to the next field
                            // if select isFull, then the dropdown won't be open and [tab] will work normally
                            preventDefault(e);
                        }
                        if (self.settings.create && self.createItem()) preventDefault(e);
                    }
                    return;
                // delete|backspace: delete items
                case KEY_BACKSPACE:
                case KEY_DELETE:
                    self.deleteSelection(e);
                    return;
            }
            // don't enter text in the control_input when active items are selected
            if (self.isInputHidden && !isKeyDown(KEY_SHORTCUT, e)) preventDefault(e);
        }
        /**
	   * Triggered on <input> keyup.
	   *
	   */ onInput(e) {
            if (this.isLocked) return;
            const value = this.inputValue();
            if (this.lastValue === value) return;
            this.lastValue = value;
            if (value == '') {
                this._onInput();
                return;
            }
            if (this.refreshTimeout) window.clearTimeout(this.refreshTimeout);
            this.refreshTimeout = timeout(()=>{
                this.refreshTimeout = null;
                this._onInput();
            }, this.settings.refreshThrottle);
        }
        _onInput() {
            const value = this.lastValue;
            if (this.settings.shouldLoad.call(this, value)) this.load(value);
            this.refreshOptions();
            this.trigger('type', value);
        }
        /**
	   * Triggered when the user rolls over
	   * an option in the autocomplete dropdown menu.
	   *
	   */ onOptionHover(evt, option) {
            if (this.ignoreHover) return;
            this.setActiveOption(option, false);
        }
        /**
	   * Triggered on <input> focus.
	   *
	   */ onFocus(e) {
            var self = this;
            var wasFocused = self.isFocused;
            if (self.isDisabled || self.isReadOnly) {
                self.blur();
                preventDefault(e);
                return;
            }
            if (self.ignoreFocus) return;
            self.isFocused = true;
            if (self.settings.preload === 'focus') self.preload();
            if (!wasFocused) self.trigger('focus');
            if (!self.activeItems.length) {
                self.inputState();
                self.refreshOptions(!!self.settings.openOnFocus);
            }
            self.refreshState();
        }
        /**
	   * Triggered on <input> blur.
	   *
	   */ onBlur(e) {
            if (document.hasFocus() === false) return;
            var self = this;
            if (!self.isFocused) return;
            self.isFocused = false;
            self.ignoreFocus = false;
            var deactivate = ()=>{
                self.close();
                self.setActiveItem();
                self.setCaret(self.items.length);
                self.trigger('blur');
            };
            if (self.settings.create && self.settings.createOnBlur) self.createItem(null, deactivate);
            else deactivate();
        }
        /**
	   * Triggered when the user clicks on an option
	   * in the autocomplete dropdown menu.
	   *
	   */ onOptionSelect(evt, option) {
            var value, self = this;
            // should not be possible to trigger a option under a disabled optgroup
            if (option.parentElement && option.parentElement.matches('[data-disabled]')) return;
            if (option.classList.contains('create')) self.createItem(null, ()=>{
                if (self.settings.closeAfterSelect) self.close();
            });
            else {
                value = option.dataset.value;
                if (typeof value !== 'undefined') {
                    self.lastQuery = null;
                    self.addItem(value);
                    if (self.settings.closeAfterSelect) self.close();
                    if (!self.settings.hideSelected && evt.type && /click/.test(evt.type)) self.setActiveOption(option);
                }
            }
        }
        /**
	   * Return true if the given option can be selected
	   *
	   */ canSelect(option) {
            if (this.isOpen && option && this.dropdown_content.contains(option)) return true;
            return false;
        }
        /**
	   * Triggered when the user clicks on an item
	   * that has been selected.
	   *
	   */ onItemSelect(evt, item) {
            var self = this;
            if (!self.isLocked && self.settings.mode === 'multi') {
                preventDefault(evt);
                self.setActiveItem(item, evt);
                return true;
            }
            return false;
        }
        /**
	   * Determines whether or not to invoke
	   * the user-provided option provider / loader
	   *
	   * Note, there is a subtle difference between
	   * this.canLoad() and this.settings.shouldLoad();
	   *
	   *	- settings.shouldLoad() is a user-input validator.
	   *	When false is returned, the not_loading template
	   *	will be added to the dropdown
	   *
	   *	- canLoad() is lower level validator that checks
	   * 	the Tom Select instance. There is no inherent user
	   *	feedback when canLoad returns false
	   *
	   */ canLoad(value) {
            if (!this.settings.load) return false;
            if (this.loadedSearches.hasOwnProperty(value)) return false;
            return true;
        }
        /**
	   * Invokes the user-provided option provider / loader.
	   *
	   */ load(value) {
            const self = this;
            if (!self.canLoad(value)) return;
            addClasses(self.wrapper, self.settings.loadingClass);
            self.loading++;
            const callback = self.loadCallback.bind(self);
            self.settings.load.call(self, value, callback);
        }
        /**
	   * Invoked by the user-provided option provider
	   *
	   */ loadCallback(options, optgroups) {
            const self = this;
            self.loading = Math.max(self.loading - 1, 0);
            self.lastQuery = null;
            self.clearActiveOption(); // when new results load, focus should be on first option
            self.setupOptions(options, optgroups);
            self.refreshOptions(self.isFocused && !self.isInputHidden);
            if (!self.loading) removeClasses(self.wrapper, self.settings.loadingClass);
            self.trigger('load', options, optgroups);
        }
        preload() {
            var classList = this.wrapper.classList;
            if (classList.contains('preloaded')) return;
            classList.add('preloaded');
            this.load('');
        }
        /**
	   * Sets the input field of the control to the specified value.
	   *
	   */ setTextboxValue(value = '') {
            var input = this.control_input;
            var changed = input.value !== value;
            if (changed) {
                input.value = value;
                triggerEvent(input, 'update');
                this.lastValue = value;
            }
        }
        /**
	   * Returns the value of the control. If multiple items
	   * can be selected (e.g. <select multiple>), this returns
	   * an array. If only one item can be selected, this
	   * returns a string.
	   *
	   */ getValue() {
            if (this.is_select_tag && this.input.hasAttribute('multiple')) return this.items;
            return this.items.join(this.settings.delimiter);
        }
        /**
	   * Resets the selected items to the given value.
	   *
	   */ setValue(value, silent) {
            var events = silent ? [] : [
                'change'
            ];
            debounce_events(this, events, ()=>{
                this.clear(silent);
                this.addItems(value, silent);
            });
        }
        /**
	   * Resets the number of max items to the given value
	   *
	   */ setMaxItems(value) {
            if (value === 0) value = null; //reset to unlimited items.
            this.settings.maxItems = value;
            this.refreshState();
        }
        /**
	   * Sets the selected item.
	   *
	   */ setActiveItem(item, e) {
            var self = this;
            var eventName;
            var i, begin, end, swap;
            var last;
            if (self.settings.mode === 'single') return;
            // clear the active selection
            if (!item) {
                self.clearActiveItems();
                if (self.isFocused) self.inputState();
                return;
            }
            // modify selection
            eventName = e && e.type.toLowerCase();
            if (eventName === 'click' && isKeyDown('shiftKey', e) && self.activeItems.length) {
                last = self.getLastActive();
                begin = Array.prototype.indexOf.call(self.control.children, last);
                end = Array.prototype.indexOf.call(self.control.children, item);
                if (begin > end) {
                    swap = begin;
                    begin = end;
                    end = swap;
                }
                for(i = begin; i <= end; i++){
                    item = self.control.children[i];
                    if (self.activeItems.indexOf(item) === -1) self.setActiveItemClass(item);
                }
                preventDefault(e);
            } else if (eventName === 'click' && isKeyDown(KEY_SHORTCUT, e) || eventName === 'keydown' && isKeyDown('shiftKey', e)) {
                if (item.classList.contains('active')) self.removeActiveItem(item);
                else self.setActiveItemClass(item);
            } else {
                self.clearActiveItems();
                self.setActiveItemClass(item);
            }
            // ensure control has focus
            self.inputState();
            if (!self.isFocused) self.focus();
        }
        /**
	   * Set the active and last-active classes
	   *
	   */ setActiveItemClass(item) {
            const self = this;
            const last_active = self.control.querySelector('.last-active');
            if (last_active) removeClasses(last_active, 'last-active');
            addClasses(item, 'active last-active');
            self.trigger('item_select', item);
            if (self.activeItems.indexOf(item) == -1) self.activeItems.push(item);
        }
        /**
	   * Remove active item
	   *
	   */ removeActiveItem(item) {
            var idx = this.activeItems.indexOf(item);
            this.activeItems.splice(idx, 1);
            removeClasses(item, 'active');
        }
        /**
	   * Clears all the active items
	   *
	   */ clearActiveItems() {
            removeClasses(this.activeItems, 'active');
            this.activeItems = [];
        }
        /**
	   * Sets the selected item in the dropdown menu
	   * of available options.
	   *
	   */ setActiveOption(option, scroll = true) {
            if (option === this.activeOption) return;
            this.clearActiveOption();
            if (!option) return;
            this.activeOption = option;
            setAttr(this.focus_node, {
                'aria-activedescendant': option.getAttribute('id')
            });
            setAttr(option, {
                'aria-selected': 'true'
            });
            addClasses(option, 'active');
            if (scroll) this.scrollToOption(option);
        }
        /**
	   * Sets the dropdown_content scrollTop to display the option
	   *
	   */ scrollToOption(option, behavior) {
            if (!option) return;
            const content = this.dropdown_content;
            const height_menu = content.clientHeight;
            const scrollTop = content.scrollTop || 0;
            const height_item = option.offsetHeight;
            const y = option.getBoundingClientRect().top - content.getBoundingClientRect().top + scrollTop;
            if (y + height_item > height_menu + scrollTop) this.scroll(y - height_menu + height_item, behavior);
            else if (y < scrollTop) this.scroll(y, behavior);
        }
        /**
	   * Scroll the dropdown to the given position
	   *
	   */ scroll(scrollTop, behavior) {
            const content = this.dropdown_content;
            if (behavior) content.style.scrollBehavior = behavior;
            content.scrollTop = scrollTop;
            content.style.scrollBehavior = '';
        }
        /**
	   * Clears the active option
	   *
	   */ clearActiveOption() {
            if (this.activeOption) {
                removeClasses(this.activeOption, 'active');
                setAttr(this.activeOption, {
                    'aria-selected': null
                });
            }
            this.activeOption = null;
            setAttr(this.focus_node, {
                'aria-activedescendant': null
            });
        }
        /**
	   * Selects all items (CTRL + A).
	   */ selectAll() {
            const self = this;
            if (self.settings.mode === 'single') return;
            const activeItems = self.controlChildren();
            if (!activeItems.length) return;
            self.inputState();
            self.close();
            self.activeItems = activeItems;
            iterate(activeItems, (item)=>{
                self.setActiveItemClass(item);
            });
        }
        /**
	   * Determines if the control_input should be in a hidden or visible state
	   *
	   */ inputState() {
            var self = this;
            if (!self.control.contains(self.control_input)) return;
            setAttr(self.control_input, {
                placeholder: self.settings.placeholder
            });
            if (self.activeItems.length > 0 || !self.isFocused && self.settings.hidePlaceholder && self.items.length > 0) {
                self.setTextboxValue();
                self.isInputHidden = true;
            } else {
                if (self.settings.hidePlaceholder && self.items.length > 0) setAttr(self.control_input, {
                    placeholder: ''
                });
                self.isInputHidden = false;
            }
            self.wrapper.classList.toggle('input-hidden', self.isInputHidden);
        }
        /**
	   * Get the input value
	   */ inputValue() {
            return this.control_input.value.trim();
        }
        /**
	   * Gives the control focus.
	   */ focus() {
            var self = this;
            if (self.isDisabled || self.isReadOnly) return;
            self.ignoreFocus = true;
            if (self.control_input.offsetWidth) self.control_input.focus();
            else self.focus_node.focus();
            setTimeout(()=>{
                self.ignoreFocus = false;
                self.onFocus();
            }, 0);
        }
        /**
	   * Forces the control out of focus.
	   *
	   */ blur() {
            this.focus_node.blur();
            this.onBlur();
        }
        /**
	   * Returns a function that scores an object
	   * to show how good of a match it is to the
	   * provided query.
	   *
	   * @return {function}
	   */ getScoreFunction(query) {
            return this.sifter.getScoreFunction(query, this.getSearchOptions());
        }
        /**
	   * Returns search options for sifter (the system
	   * for scoring and sorting results).
	   *
	   * @see https://github.com/orchidjs/sifter.js
	   * @return {object}
	   */ getSearchOptions() {
            var settings = this.settings;
            var sort = settings.sortField;
            if (typeof settings.sortField === 'string') sort = [
                {
                    field: settings.sortField
                }
            ];
            return {
                fields: settings.searchField,
                conjunction: settings.searchConjunction,
                sort: sort,
                nesting: settings.nesting
            };
        }
        /**
	   * Searches through available options and returns
	   * a sorted array of matches.
	   *
	   */ search(query) {
            var result, calculateScore;
            var self = this;
            var options = this.getSearchOptions();
            // validate user-provided result scoring function
            if (self.settings.score) {
                calculateScore = self.settings.score.call(self, query);
                if (typeof calculateScore !== 'function') throw new Error('Tom Select "score" setting must be a function that returns a function');
            }
            // perform search
            if (query !== self.lastQuery) {
                self.lastQuery = query;
                result = self.sifter.search(query, Object.assign(options, {
                    score: calculateScore
                }));
                self.currentResults = result;
            } else result = Object.assign({}, self.currentResults);
            // filter out selected items
            if (self.settings.hideSelected) result.items = result.items.filter((item)=>{
                let hashed = hash_key(item.id);
                return !(hashed && self.items.indexOf(hashed) !== -1);
            });
            return result;
        }
        /**
	   * Refreshes the list of available options shown
	   * in the autocomplete dropdown menu.
	   *
	   */ refreshOptions(triggerDropdown = true) {
            var i, j, k, n, optgroup, optgroups, html, has_create_option, active_group;
            var create;
            const groups = {};
            const groups_order = [];
            var self = this;
            var query = self.inputValue();
            const same_query = query === self.lastQuery || query == '' && self.lastQuery == null;
            var results = self.search(query);
            var active_option = null;
            var show_dropdown = self.settings.shouldOpen || false;
            var dropdown_content = self.dropdown_content;
            if (same_query) {
                active_option = self.activeOption;
                if (active_option) active_group = active_option.closest('[data-group]');
            }
            // build markup
            n = results.items.length;
            if (typeof self.settings.maxOptions === 'number') n = Math.min(n, self.settings.maxOptions);
            if (n > 0) show_dropdown = true;
            // get fragment for group and the position of the group in group_order
            const getGroupFragment = (optgroup, order)=>{
                let group_order_i = groups[optgroup];
                if (group_order_i !== undefined) {
                    let order_group = groups_order[group_order_i];
                    if (order_group !== undefined) return [
                        group_order_i,
                        order_group.fragment
                    ];
                }
                let group_fragment = document.createDocumentFragment();
                group_order_i = groups_order.length;
                groups_order.push({
                    fragment: group_fragment,
                    order: order,
                    optgroup: optgroup
                });
                return [
                    group_order_i,
                    group_fragment
                ];
            };
            // render and group available options individually
            for(i = 0; i < n; i++){
                // get option dom element
                let item = results.items[i];
                if (!item) continue;
                let opt_value = item.id;
                let option = self.options[opt_value];
                if (option === undefined) continue;
                let opt_hash = get_hash(opt_value);
                let option_el = self.getOption(opt_hash, true);
                // toggle 'selected' class
                if (!self.settings.hideSelected) option_el.classList.toggle('selected', self.items.includes(opt_hash));
                optgroup = option[self.settings.optgroupField] || '';
                optgroups = Array.isArray(optgroup) ? optgroup : [
                    optgroup
                ];
                for(j = 0, k = optgroups && optgroups.length; j < k; j++){
                    optgroup = optgroups[j];
                    let order = option.$order;
                    let self_optgroup = self.optgroups[optgroup];
                    if (self_optgroup === undefined) optgroup = '';
                    else order = self_optgroup.$order;
                    const [group_order_i, group_fragment] = getGroupFragment(optgroup, order);
                    // nodes can only have one parent, so if the option is in mutple groups, we need a clone
                    if (j > 0) {
                        option_el = option_el.cloneNode(true);
                        setAttr(option_el, {
                            id: option.$id + '-clone-' + j,
                            'aria-selected': null
                        });
                        option_el.classList.add('ts-cloned');
                        removeClasses(option_el, 'active');
                        // make sure we keep the activeOption in the same group
                        if (self.activeOption && self.activeOption.dataset.value == opt_value) {
                            if (active_group && active_group.dataset.group === optgroup.toString()) active_option = option_el;
                        }
                    }
                    group_fragment.appendChild(option_el);
                    if (optgroup != '') groups[optgroup] = group_order_i;
                }
            }
            // sort optgroups
            if (self.settings.lockOptgroupOrder) groups_order.sort((a, b)=>{
                return a.order - b.order;
            });
            // render optgroup headers & join groups
            html = document.createDocumentFragment();
            iterate(groups_order, (group_order)=>{
                let group_fragment = group_order.fragment;
                let optgroup = group_order.optgroup;
                if (!group_fragment || !group_fragment.children.length) return;
                let group_heading = self.optgroups[optgroup];
                if (group_heading !== undefined) {
                    let group_options = document.createDocumentFragment();
                    let header = self.render('optgroup_header', group_heading);
                    append(group_options, header);
                    append(group_options, group_fragment);
                    let group_html = self.render('optgroup', {
                        group: group_heading,
                        options: group_options
                    });
                    append(html, group_html);
                } else append(html, group_fragment);
            });
            dropdown_content.innerHTML = '';
            append(dropdown_content, html);
            // highlight matching terms inline
            if (self.settings.highlight) {
                removeHighlight(dropdown_content);
                if (results.query.length && results.tokens.length) iterate(results.tokens, (tok)=>{
                    highlight(dropdown_content, tok.regex);
                });
            }
            // helper method for adding templates to dropdown
            var add_template = (template)=>{
                let content = self.render(template, {
                    input: query
                });
                if (content) {
                    show_dropdown = true;
                    dropdown_content.insertBefore(content, dropdown_content.firstChild);
                }
                return content;
            };
            // add loading message
            if (self.loading) add_template('loading');
            else if (!self.settings.shouldLoad.call(self, query)) add_template('not_loading');
            else if (results.items.length === 0) add_template('no_results');
            // add create option
            has_create_option = self.canCreate(query);
            if (has_create_option) create = add_template('option_create');
            // activate
            self.hasOptions = results.items.length > 0 || has_create_option;
            if (show_dropdown) {
                if (results.items.length > 0) {
                    if (!active_option && self.settings.mode === 'single' && self.items[0] != undefined) active_option = self.getOption(self.items[0]);
                    if (!dropdown_content.contains(active_option)) {
                        let active_index = 0;
                        if (create && !self.settings.addPrecedence) active_index = 1;
                        active_option = self.selectable()[active_index];
                    }
                } else if (create) active_option = create;
                if (triggerDropdown && !self.isOpen) {
                    self.open();
                    self.scrollToOption(active_option, 'auto');
                }
                self.setActiveOption(active_option);
            } else {
                self.clearActiveOption();
                if (triggerDropdown && self.isOpen) self.close(false); // if create_option=null, we want the dropdown to close but not reset the textbox value
            }
        }
        /**
	   * Return list of selectable options
	   *
	   */ selectable() {
            return this.dropdown_content.querySelectorAll('[data-selectable]');
        }
        /**
	   * Adds an available option. If it already exists,
	   * nothing will happen. Note: this does not refresh
	   * the options list dropdown (use `refreshOptions`
	   * for that).
	   *
	   * Usage:
	   *
	   *   this.addOption(data)
	   *
	   */ addOption(data, user_created = false) {
            const self = this;
            // @deprecated 1.7.7
            // use addOptions( array, user_created ) for adding multiple options
            if (Array.isArray(data)) {
                self.addOptions(data, user_created);
                return false;
            }
            const key = hash_key(data[self.settings.valueField]);
            if (key === null || self.options.hasOwnProperty(key)) return false;
            data.$order = data.$order || ++self.order;
            data.$id = self.inputId + '-opt-' + data.$order;
            self.options[key] = data;
            self.lastQuery = null;
            if (user_created) {
                self.userOptions[key] = user_created;
                self.trigger('option_add', key, data);
            }
            return key;
        }
        /**
	   * Add multiple options
	   *
	   */ addOptions(data, user_created = false) {
            iterate(data, (dat)=>{
                this.addOption(dat, user_created);
            });
        }
        /**
	   * @deprecated 1.7.7
	   */ registerOption(data) {
            return this.addOption(data);
        }
        /**
	   * Registers an option group to the pool of option groups.
	   *
	   * @return {boolean|string}
	   */ registerOptionGroup(data) {
            var key = hash_key(data[this.settings.optgroupValueField]);
            if (key === null) return false;
            data.$order = data.$order || ++this.order;
            this.optgroups[key] = data;
            return key;
        }
        /**
	   * Registers a new optgroup for options
	   * to be bucketed into.
	   *
	   */ addOptionGroup(id, data) {
            var hashed_id;
            data[this.settings.optgroupValueField] = id;
            if (hashed_id = this.registerOptionGroup(data)) this.trigger('optgroup_add', hashed_id, data);
        }
        /**
	   * Removes an existing option group.
	   *
	   */ removeOptionGroup(id) {
            if (this.optgroups.hasOwnProperty(id)) {
                delete this.optgroups[id];
                this.clearCache();
                this.trigger('optgroup_remove', id);
            }
        }
        /**
	   * Clears all existing option groups.
	   */ clearOptionGroups() {
            this.optgroups = {};
            this.clearCache();
            this.trigger('optgroup_clear');
        }
        /**
	   * Updates an option available for selection. If
	   * it is visible in the selected items or options
	   * dropdown, it will be re-rendered automatically.
	   *
	   */ updateOption(value, data) {
            const self = this;
            var item_new;
            var index_item;
            const value_old = hash_key(value);
            const value_new = hash_key(data[self.settings.valueField]);
            // sanity checks
            if (value_old === null) return;
            const data_old = self.options[value_old];
            if (data_old == undefined) return;
            if (typeof value_new !== 'string') throw new Error('Value must be set in option data');
            const option = self.getOption(value_old);
            const item = self.getItem(value_old);
            data.$order = data.$order || data_old.$order;
            delete self.options[value_old];
            // invalidate render cache
            // don't remove existing node yet, we'll remove it after replacing it
            self.uncacheValue(value_new);
            self.options[value_new] = data;
            // update the option if it's in the dropdown
            if (option) {
                if (self.dropdown_content.contains(option)) {
                    const option_new = self._render('option', data);
                    replaceNode(option, option_new);
                    if (self.activeOption === option) self.setActiveOption(option_new);
                }
                option.remove();
            }
            // update the item if we have one
            if (item) {
                index_item = self.items.indexOf(value_old);
                if (index_item !== -1) self.items.splice(index_item, 1, value_new);
                item_new = self._render('item', data);
                if (item.classList.contains('active')) addClasses(item_new, 'active');
                replaceNode(item, item_new);
            }
            // invalidate last query because we might have updated the sortField
            self.lastQuery = null;
        }
        /**
	   * Removes a single option.
	   *
	   */ removeOption(value, silent) {
            const self = this;
            value = get_hash(value);
            self.uncacheValue(value);
            delete self.userOptions[value];
            delete self.options[value];
            self.lastQuery = null;
            self.trigger('option_remove', value);
            self.removeItem(value, silent);
        }
        /**
	   * Clears all options.
	   */ clearOptions(filter) {
            const boundFilter = (filter || this.clearFilter).bind(this);
            this.loadedSearches = {};
            this.userOptions = {};
            this.clearCache();
            const selected = {};
            iterate(this.options, (option, key)=>{
                if (boundFilter(option, key)) selected[key] = option;
            });
            this.options = this.sifter.items = selected;
            this.lastQuery = null;
            this.trigger('option_clear');
        }
        /**
	   * Used by clearOptions() to decide whether or not an option should be removed
	   * Return true to keep an option, false to remove
	   *
	   */ clearFilter(option, value) {
            if (this.items.indexOf(value) >= 0) return true;
            return false;
        }
        /**
	   * Returns the dom element of the option
	   * matching the given value.
	   *
	   */ getOption(value, create = false) {
            const hashed = hash_key(value);
            if (hashed === null) return null;
            const option = this.options[hashed];
            if (option != undefined) {
                if (option.$div) return option.$div;
                if (create) return this._render('option', option);
            }
            return null;
        }
        /**
	   * Returns the dom element of the next or previous dom element of the same type
	   * Note: adjacent options may not be adjacent DOM elements (optgroups)
	   *
	   */ getAdjacent(option, direction, type = 'option') {
            var self = this, all;
            if (!option) return null;
            if (type == 'item') all = self.controlChildren();
            else all = self.dropdown_content.querySelectorAll('[data-selectable]');
            for(let i = 0; i < all.length; i++){
                if (all[i] != option) continue;
                if (direction > 0) return all[i + 1];
                return all[i - 1];
            }
            return null;
        }
        /**
	   * Returns the dom element of the item
	   * matching the given value.
	   *
	   */ getItem(item) {
            if (typeof item == 'object') return item;
            var value = hash_key(item);
            return value !== null ? this.control.querySelector(`[data-value="${addSlashes(value)}"]`) : null;
        }
        /**
	   * "Selects" multiple items at once. Adds them to the list
	   * at the current caret position.
	   *
	   */ addItems(values, silent) {
            var self = this;
            var items = Array.isArray(values) ? values : [
                values
            ];
            items = items.filter((x)=>self.items.indexOf(x) === -1);
            const last_item = items[items.length - 1];
            items.forEach((item)=>{
                self.isPending = item !== last_item;
                self.addItem(item, silent);
            });
        }
        /**
	   * "Selects" an item. Adds it to the list
	   * at the current caret position.
	   *
	   */ addItem(value, silent) {
            var events = silent ? [] : [
                'change',
                'dropdown_close'
            ];
            debounce_events(this, events, ()=>{
                var item, wasFull;
                const self = this;
                const inputMode = self.settings.mode;
                const hashed = hash_key(value);
                if (hashed && self.items.indexOf(hashed) !== -1) {
                    if (inputMode === 'single') self.close();
                    if (inputMode === 'single' || !self.settings.duplicates) return;
                }
                if (hashed === null || !self.options.hasOwnProperty(hashed)) return;
                if (inputMode === 'single') self.clear(silent);
                if (inputMode === 'multi' && self.isFull()) return;
                item = self._render('item', self.options[hashed]);
                if (self.control.contains(item)) // duplicates
                item = item.cloneNode(true);
                wasFull = self.isFull();
                self.items.splice(self.caretPos, 0, hashed);
                self.insertAtCaret(item);
                if (self.isSetup) {
                    // update menu / remove the option (if this is not one item being added as part of series)
                    if (!self.isPending && self.settings.hideSelected) {
                        let option = self.getOption(hashed);
                        let next = self.getAdjacent(option, 1);
                        if (next) self.setActiveOption(next);
                    }
                    // refreshOptions after setActiveOption(),
                    // otherwise setActiveOption() will be called by refreshOptions() with the wrong value
                    if (!self.isPending && !self.settings.closeAfterSelect) self.refreshOptions(self.isFocused && inputMode !== 'single');
                    // hide the menu if the maximum number of items have been selected or no options are left
                    if (self.settings.closeAfterSelect != false && self.isFull()) self.close();
                    else if (!self.isPending) self.positionDropdown();
                    self.trigger('item_add', hashed, item);
                    if (!self.isPending) self.updateOriginalInput({
                        silent: silent
                    });
                }
                if (!self.isPending || !wasFull && self.isFull()) {
                    self.inputState();
                    self.refreshState();
                }
            });
        }
        /**
	   * Removes the selected item matching
	   * the provided value.
	   *
	   */ removeItem(item = null, silent) {
            const self = this;
            item = self.getItem(item);
            if (!item) return;
            var i, idx;
            const value = item.dataset.value;
            i = nodeIndex(item);
            item.remove();
            if (item.classList.contains('active')) {
                idx = self.activeItems.indexOf(item);
                self.activeItems.splice(idx, 1);
                removeClasses(item, 'active');
            }
            self.items.splice(i, 1);
            self.lastQuery = null;
            if (!self.settings.persist && self.userOptions.hasOwnProperty(value)) self.removeOption(value, silent);
            if (i < self.caretPos) self.setCaret(self.caretPos - 1);
            self.updateOriginalInput({
                silent: silent
            });
            self.refreshState();
            self.positionDropdown();
            self.trigger('item_remove', value, item);
        }
        /**
	   * Invokes the `create` method provided in the
	   * TomSelect options that should provide the data
	   * for the new item, given the user input.
	   *
	   * Once this completes, it will be added
	   * to the item list.
	   *
	   */ createItem(input = null, callback = ()=>{}) {
            // triggerDropdown parameter @deprecated 2.1.1
            if (arguments.length === 3) callback = arguments[2];
            if (typeof callback != 'function') callback = ()=>{};
            var self = this;
            var caret = self.caretPos;
            var output;
            input = input || self.inputValue();
            if (!self.canCreate(input)) {
                callback();
                return false;
            }
            self.lock();
            var created = false;
            var create = (data)=>{
                self.unlock();
                if (!data || typeof data !== 'object') return callback();
                var value = hash_key(data[self.settings.valueField]);
                if (typeof value !== 'string') return callback();
                self.setTextboxValue();
                self.addOption(data, true);
                self.setCaret(caret);
                self.addItem(value);
                callback(data);
                created = true;
            };
            if (typeof self.settings.create === 'function') output = self.settings.create.call(this, input, create);
            else output = {
                [self.settings.labelField]: input,
                [self.settings.valueField]: input
            };
            if (!created) create(output);
            return true;
        }
        /**
	   * Re-renders the selected item lists.
	   */ refreshItems() {
            var self = this;
            self.lastQuery = null;
            if (self.isSetup) self.addItems(self.items);
            self.updateOriginalInput();
            self.refreshState();
        }
        /**
	   * Updates all state-dependent attributes
	   * and CSS classes.
	   */ refreshState() {
            const self = this;
            self.refreshValidityState();
            const isFull = self.isFull();
            const isLocked = self.isLocked;
            self.wrapper.classList.toggle('rtl', self.rtl);
            const wrap_classList = self.wrapper.classList;
            wrap_classList.toggle('focus', self.isFocused);
            wrap_classList.toggle('disabled', self.isDisabled);
            wrap_classList.toggle('readonly', self.isReadOnly);
            wrap_classList.toggle('required', self.isRequired);
            wrap_classList.toggle('invalid', !self.isValid);
            wrap_classList.toggle('locked', isLocked);
            wrap_classList.toggle('full', isFull);
            wrap_classList.toggle('input-active', self.isFocused && !self.isInputHidden);
            wrap_classList.toggle('dropdown-active', self.isOpen);
            wrap_classList.toggle('has-options', isEmptyObject(self.options));
            wrap_classList.toggle('has-items', self.items.length > 0);
        }
        /**
	   * Update the `required` attribute of both input and control input.
	   *
	   * The `required` property needs to be activated on the control input
	   * for the error to be displayed at the right place. `required` also
	   * needs to be temporarily deactivated on the input since the input is
	   * hidden and can't show errors.
	   */ refreshValidityState() {
            var self = this;
            if (!self.input.validity) return;
            self.isValid = self.input.validity.valid;
            self.isInvalid = !self.isValid;
        }
        /**
	   * Determines whether or not more items can be added
	   * to the control without exceeding the user-defined maximum.
	   *
	   * @returns {boolean}
	   */ isFull() {
            return this.settings.maxItems !== null && this.items.length >= this.settings.maxItems;
        }
        /**
	   * Refreshes the original <select> or <input>
	   * element to reflect the current state.
	   *
	   */ updateOriginalInput(opts = {}) {
            const self = this;
            var option, label;
            const empty_option = self.input.querySelector('option[value=""]');
            if (self.is_select_tag) {
                const selected = [];
                const has_selected = self.input.querySelectorAll('option:checked').length;
                function AddSelected(option_el, value, label) {
                    if (!option_el) option_el = getDom('<option value="' + escape_html(value) + '">' + escape_html(label) + '</option>');
                    // don't move empty option from top of list
                    // fixes bug in firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1725293
                    if (option_el != empty_option) self.input.append(option_el);
                    selected.push(option_el);
                    // marking empty option as selected can break validation
                    // fixes https://github.com/orchidjs/tom-select/issues/303
                    if (option_el != empty_option || has_selected > 0) option_el.selected = true;
                    return option_el;
                }
                // unselect all selected options
                self.input.querySelectorAll('option:checked').forEach((option_el)=>{
                    option_el.selected = false;
                });
                // nothing selected?
                if (self.items.length == 0 && self.settings.mode == 'single') AddSelected(empty_option, "", "");
                else self.items.forEach((value)=>{
                    option = self.options[value];
                    label = option[self.settings.labelField] || '';
                    if (selected.includes(option.$option)) {
                        const reuse_opt = self.input.querySelector(`option[value="${addSlashes(value)}"]:not(:checked)`);
                        AddSelected(reuse_opt, value, label);
                    } else option.$option = AddSelected(option.$option, value, label);
                });
            } else self.input.value = self.getValue();
            if (self.isSetup) {
                if (!opts.silent) self.trigger('change', self.getValue());
            }
        }
        /**
	   * Shows the autocomplete dropdown containing
	   * the available options.
	   */ open() {
            var self = this;
            if (self.isLocked || self.isOpen || self.settings.mode === 'multi' && self.isFull()) return;
            self.isOpen = true;
            setAttr(self.focus_node, {
                'aria-expanded': 'true'
            });
            self.refreshState();
            applyCSS(self.dropdown, {
                visibility: 'hidden',
                display: 'block'
            });
            self.positionDropdown();
            applyCSS(self.dropdown, {
                visibility: 'visible',
                display: 'block'
            });
            self.focus();
            self.trigger('dropdown_open', self.dropdown);
        }
        /**
	   * Closes the autocomplete dropdown menu.
	   */ close(setTextboxValue = true) {
            var self = this;
            var trigger = self.isOpen;
            if (setTextboxValue) {
                // before blur() to prevent form onchange event
                self.setTextboxValue();
                if (self.settings.mode === 'single' && self.items.length) self.inputState();
            }
            self.isOpen = false;
            setAttr(self.focus_node, {
                'aria-expanded': 'false'
            });
            applyCSS(self.dropdown, {
                display: 'none'
            });
            if (self.settings.hideSelected) self.clearActiveOption();
            self.refreshState();
            if (trigger) self.trigger('dropdown_close', self.dropdown);
        }
        /**
	   * Calculates and applies the appropriate
	   * position of the dropdown if dropdownParent = 'body'.
	   * Otherwise, position is determined by css
	   */ positionDropdown() {
            if (this.settings.dropdownParent !== 'body') return;
            var context = this.control;
            var rect = context.getBoundingClientRect();
            var top = context.offsetHeight + rect.top + window.scrollY;
            var left = rect.left + window.scrollX;
            applyCSS(this.dropdown, {
                width: rect.width + 'px',
                top: top + 'px',
                left: left + 'px'
            });
        }
        /**
	   * Resets / clears all selected items
	   * from the control.
	   *
	   */ clear(silent) {
            var self = this;
            if (!self.items.length) return;
            var items = self.controlChildren();
            iterate(items, (item)=>{
                self.removeItem(item, true);
            });
            self.inputState();
            if (!silent) self.updateOriginalInput();
            self.trigger('clear');
        }
        /**
	   * A helper method for inserting an element
	   * at the current caret position.
	   *
	   */ insertAtCaret(el) {
            const self = this;
            const caret = self.caretPos;
            const target = self.control;
            target.insertBefore(el, target.children[caret] || null);
            self.setCaret(caret + 1);
        }
        /**
	   * Removes the current selected item(s).
	   *
	   */ deleteSelection(e) {
            var direction, selection, caret, tail;
            var self = this;
            direction = e && e.keyCode === KEY_BACKSPACE ? -1 : 1;
            selection = getSelection(self.control_input);
            // determine items that will be removed
            const rm_items = [];
            if (self.activeItems.length) {
                tail = getTail(self.activeItems, direction);
                caret = nodeIndex(tail);
                if (direction > 0) caret++;
                iterate(self.activeItems, (item)=>rm_items.push(item));
            } else if ((self.isFocused || self.settings.mode === 'single') && self.items.length) {
                const items = self.controlChildren();
                let rm_item;
                if (direction < 0 && selection.start === 0 && selection.length === 0) rm_item = items[self.caretPos - 1];
                else if (direction > 0 && selection.start === self.inputValue().length) rm_item = items[self.caretPos];
                if (rm_item !== undefined) rm_items.push(rm_item);
            }
            if (!self.shouldDelete(rm_items, e)) return false;
            preventDefault(e, true);
            // perform removal
            if (typeof caret !== 'undefined') self.setCaret(caret);
            while(rm_items.length)self.removeItem(rm_items.pop());
            self.inputState();
            self.positionDropdown();
            self.refreshOptions(false);
            return true;
        }
        /**
	   * Return true if the items should be deleted
	   */ shouldDelete(items, evt) {
            const values = items.map((item)=>item.dataset.value);
            // allow the callback to abort
            if (!values.length || typeof this.settings.onDelete === 'function' && this.settings.onDelete(values, evt) === false) return false;
            return true;
        }
        /**
	   * Selects the previous / next item (depending on the `direction` argument).
	   *
	   * > 0 - right
	   * < 0 - left
	   *
	   */ advanceSelection(direction, e) {
            var last_active, adjacent, self = this;
            if (self.rtl) direction *= -1;
            if (self.inputValue().length) return;
            // add or remove to active items
            if (isKeyDown(KEY_SHORTCUT, e) || isKeyDown('shiftKey', e)) {
                last_active = self.getLastActive(direction);
                if (last_active) {
                    if (!last_active.classList.contains('active')) adjacent = last_active;
                    else adjacent = self.getAdjacent(last_active, direction, 'item');
                } else if (direction > 0) adjacent = self.control_input.nextElementSibling;
                else adjacent = self.control_input.previousElementSibling;
                if (adjacent) {
                    if (adjacent.classList.contains('active')) self.removeActiveItem(last_active);
                    self.setActiveItemClass(adjacent); // mark as last_active !! after removeActiveItem() on last_active
                }
            // move caret to the left or right
            } else self.moveCaret(direction);
        }
        moveCaret(direction) {}
        /**
	   * Get the last active item
	   *
	   */ getLastActive(direction) {
            let last_active = this.control.querySelector('.last-active');
            if (last_active) return last_active;
            var result = this.control.querySelectorAll('.active');
            if (result) return getTail(result, direction);
        }
        /**
	   * Moves the caret to the specified index.
	   *
	   * The input must be moved by leaving it in place and moving the
	   * siblings, due to the fact that focus cannot be restored once lost
	   * on mobile webkit devices
	   *
	   */ setCaret(new_pos) {
            this.caretPos = this.items.length;
        }
        /**
	   * Return list of item dom elements
	   *
	   */ controlChildren() {
            return Array.from(this.control.querySelectorAll('[data-ts-item]'));
        }
        /**
	   * Disables user input on the control. Used while
	   * items are being asynchronously created.
	   */ lock() {
            this.setLocked(true);
        }
        /**
	   * Re-enables user input on the control.
	   */ unlock() {
            this.setLocked(false);
        }
        /**
	   * Disable or enable user input on the control
	   */ setLocked(lock = this.isReadOnly || this.isDisabled) {
            this.isLocked = lock;
            this.refreshState();
        }
        /**
	   * Disables user input on the control completely.
	   * While disabled, it cannot receive focus.
	   */ disable() {
            this.setDisabled(true);
            this.close();
        }
        /**
	   * Enables the control so that it can respond
	   * to focus and user input.
	   */ enable() {
            this.setDisabled(false);
        }
        setDisabled(disabled) {
            this.focus_node.tabIndex = disabled ? -1 : this.tabIndex;
            this.isDisabled = disabled;
            this.input.disabled = disabled;
            this.control_input.disabled = disabled;
            this.setLocked();
        }
        setReadOnly(isReadOnly) {
            this.isReadOnly = isReadOnly;
            this.input.readOnly = isReadOnly;
            this.control_input.readOnly = isReadOnly;
            this.setLocked();
        }
        /**
	   * Completely destroys the control and
	   * unbinds all event listeners so that it can
	   * be garbage collected.
	   */ destroy() {
            var self = this;
            var revertSettings = self.revertSettings;
            self.trigger('destroy');
            self.off();
            self.wrapper.remove();
            self.dropdown.remove();
            self.input.innerHTML = revertSettings.innerHTML;
            self.input.tabIndex = revertSettings.tabIndex;
            removeClasses(self.input, 'tomselected', 'ts-hidden-accessible');
            self._destroy();
            delete self.input.tomselect;
        }
        /**
	   * A helper method for rendering "item" and
	   * "option" templates, given the data.
	   *
	   */ render(templateName, data) {
            var id, html;
            const self = this;
            if (typeof this.settings.render[templateName] !== 'function') return null;
            // render markup
            html = self.settings.render[templateName].call(this, data, escape_html);
            if (!html) return null;
            html = getDom(html);
            // add mandatory attributes
            if (templateName === 'option' || templateName === 'option_create') {
                if (data[self.settings.disabledField]) setAttr(html, {
                    'aria-disabled': 'true'
                });
                else setAttr(html, {
                    'data-selectable': ''
                });
            } else if (templateName === 'optgroup') {
                id = data.group[self.settings.optgroupValueField];
                setAttr(html, {
                    'data-group': id
                });
                if (data.group[self.settings.disabledField]) setAttr(html, {
                    'data-disabled': ''
                });
            }
            if (templateName === 'option' || templateName === 'item') {
                const value = get_hash(data[self.settings.valueField]);
                setAttr(html, {
                    'data-value': value
                });
                // make sure we have some classes if a template is overwritten
                if (templateName === 'item') {
                    addClasses(html, self.settings.itemClass);
                    setAttr(html, {
                        'data-ts-item': ''
                    });
                } else {
                    addClasses(html, self.settings.optionClass);
                    setAttr(html, {
                        role: 'option',
                        id: data.$id
                    });
                    // update cache
                    data.$div = html;
                    self.options[value] = data;
                }
            }
            return html;
        }
        /**
	   * Type guarded rendering
	   *
	   */ _render(templateName, data) {
            const html = this.render(templateName, data);
            if (html == null) throw 'HTMLElement expected';
            return html;
        }
        /**
	   * Clears the render cache for a template. If
	   * no template is given, clears all render
	   * caches.
	   *
	   */ clearCache() {
            iterate(this.options, (option)=>{
                if (option.$div) {
                    option.$div.remove();
                    delete option.$div;
                }
            });
        }
        /**
	   * Removes a value from item and option caches
	   *
	   */ uncacheValue(value) {
            const option_el = this.getOption(value);
            if (option_el) option_el.remove();
        }
        /**
	   * Determines whether or not to display the
	   * create item prompt, given a user input.
	   *
	   */ canCreate(input) {
            return this.settings.create && input.length > 0 && this.settings.createFilter.call(this, input);
        }
        /**
	   * Wraps this.`method` so that `new_fn` can be invoked 'before', 'after', or 'instead' of the original method
	   *
	   * this.hook('instead','onKeyDown',function( arg1, arg2 ...){
	   *
	   * });
	   */ hook(when, method, new_fn) {
            var self = this;
            var orig_method = self[method];
            self[method] = function() {
                var result, result_new;
                if (when === 'after') result = orig_method.apply(self, arguments);
                result_new = new_fn.apply(self, arguments);
                if (when === 'instead') return result_new;
                if (when === 'before') result = orig_method.apply(self, arguments);
                return result;
            };
        }
    }
    /**
	 * Plugin: "change_listener" (Tom Select)
	 * Copyright (c) contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function change_listener() {
        addEvent(this.input, 'change', ()=>{
            this.sync();
        });
    }
    /**
	 * Plugin: "checkbox_options" (Tom Select)
	 * Copyright (c) contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function checkbox_options(userOptions) {
        var self = this;
        var orig_onOptionSelect = self.onOptionSelect;
        self.settings.hideSelected = false;
        const cbOptions = Object.assign({
            // so that the user may add different ones as well
            className: "tomselect-checkbox",
            // the following default to the historic plugin's values
            checkedClassNames: undefined,
            uncheckedClassNames: undefined
        }, userOptions);
        var UpdateChecked = function UpdateChecked(checkbox, toCheck) {
            if (toCheck) {
                checkbox.checked = true;
                if (cbOptions.uncheckedClassNames) checkbox.classList.remove(...cbOptions.uncheckedClassNames);
                if (cbOptions.checkedClassNames) checkbox.classList.add(...cbOptions.checkedClassNames);
            } else {
                checkbox.checked = false;
                if (cbOptions.checkedClassNames) checkbox.classList.remove(...cbOptions.checkedClassNames);
                if (cbOptions.uncheckedClassNames) checkbox.classList.add(...cbOptions.uncheckedClassNames);
            }
        };
        // update the checkbox for an option
        var UpdateCheckbox = function UpdateCheckbox(option) {
            setTimeout(()=>{
                var checkbox = option.querySelector('input.' + cbOptions.className);
                if (checkbox instanceof HTMLInputElement) UpdateChecked(checkbox, option.classList.contains('selected'));
            }, 1);
        };
        // add checkbox to option template
        self.hook('after', 'setupTemplates', ()=>{
            var orig_render_option = self.settings.render.option;
            self.settings.render.option = (data, escape_html)=>{
                var rendered = getDom(orig_render_option.call(self, data, escape_html));
                var checkbox = document.createElement('input');
                if (cbOptions.className) checkbox.classList.add(cbOptions.className);
                checkbox.addEventListener('click', function(evt) {
                    preventDefault(evt);
                });
                checkbox.type = 'checkbox';
                const hashed = hash_key(data[self.settings.valueField]);
                UpdateChecked(checkbox, !!(hashed && self.items.indexOf(hashed) > -1));
                rendered.prepend(checkbox);
                return rendered;
            };
        });
        // uncheck when item removed
        self.on('item_remove', (value)=>{
            var option = self.getOption(value);
            if (option) {
                // if dropdown hasn't been opened yet, the option won't exist
                option.classList.remove('selected'); // selected class won't be removed yet
                UpdateCheckbox(option);
            }
        });
        // check when item added
        self.on('item_add', (value)=>{
            var option = self.getOption(value);
            if (option) // if dropdown hasn't been opened yet, the option won't exist
            UpdateCheckbox(option);
        });
        // remove items when selected option is clicked
        self.hook('instead', 'onOptionSelect', (evt, option)=>{
            if (option.classList.contains('selected')) {
                option.classList.remove('selected');
                self.removeItem(option.dataset.value);
                self.refreshOptions();
                preventDefault(evt, true);
                return;
            }
            orig_onOptionSelect.call(self, evt, option);
            UpdateCheckbox(option);
        });
    }
    /**
	 * Plugin: "dropdown_header" (Tom Select)
	 * Copyright (c) contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function clear_button(userOptions) {
        const self = this;
        const options = Object.assign({
            className: 'clear-button',
            title: 'Clear All',
            html: (data)=>{
                return `<div class="${data.className}" title="${data.title}">&#10799;</div>`;
            }
        }, userOptions);
        self.on('initialize', ()=>{
            var button = getDom(options.html(options));
            button.addEventListener('click', (evt)=>{
                if (self.isLocked) return;
                self.clear();
                if (self.settings.mode === 'single' && self.settings.allowEmptyOption) self.addItem('');
                evt.preventDefault();
                evt.stopPropagation();
            });
            self.control.appendChild(button);
        });
    }
    /**
	 * Plugin: "drag_drop" (Tom Select)
	 * Copyright (c) contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ const insertAfter = (referenceNode, newNode)=>{
        var _referenceNode$parent;
        (_referenceNode$parent = referenceNode.parentNode) == null || _referenceNode$parent.insertBefore(newNode, referenceNode.nextSibling);
    };
    const insertBefore = (referenceNode, newNode)=>{
        var _referenceNode$parent2;
        (_referenceNode$parent2 = referenceNode.parentNode) == null || _referenceNode$parent2.insertBefore(newNode, referenceNode);
    };
    const isBefore = (referenceNode, newNode)=>{
        do {
            var _newNode;
            newNode = (_newNode = newNode) == null ? void 0 : _newNode.previousElementSibling;
            if (referenceNode == newNode) return true;
        }while (newNode && newNode.previousElementSibling);
        return false;
    };
    function drag_drop() {
        var self = this;
        if (self.settings.mode !== 'multi') return;
        var orig_lock = self.lock;
        var orig_unlock = self.unlock;
        let sortable = true;
        let drag_item;
        /**
	   * Add draggable attribute to item
	   */ self.hook('after', 'setupTemplates', ()=>{
            var orig_render_item = self.settings.render.item;
            self.settings.render.item = (data, escape)=>{
                const item = getDom(orig_render_item.call(self, data, escape));
                setAttr(item, {
                    'draggable': 'true'
                });
                // prevent doc_mousedown (see tom-select.ts)
                const mousedown = (evt)=>{
                    if (!sortable) preventDefault(evt);
                    evt.stopPropagation();
                };
                const dragStart = (evt)=>{
                    drag_item = item;
                    setTimeout(()=>{
                        item.classList.add('ts-dragging');
                    }, 0);
                };
                const dragOver = (evt)=>{
                    evt.preventDefault();
                    item.classList.add('ts-drag-over');
                    moveitem(item, drag_item);
                };
                const dragLeave = ()=>{
                    item.classList.remove('ts-drag-over');
                };
                const moveitem = (targetitem, dragitem)=>{
                    if (dragitem === undefined) return;
                    if (isBefore(dragitem, item)) insertAfter(targetitem, dragitem);
                    else insertBefore(targetitem, dragitem);
                };
                const dragend = ()=>{
                    var _drag_item;
                    document.querySelectorAll('.ts-drag-over').forEach((el)=>el.classList.remove('ts-drag-over'));
                    (_drag_item = drag_item) == null || _drag_item.classList.remove('ts-dragging');
                    drag_item = undefined;
                    var values = [];
                    self.control.querySelectorAll(`[data-value]`).forEach((el)=>{
                        if (el.dataset.value) {
                            let value = el.dataset.value;
                            if (value) values.push(value);
                        }
                    });
                    self.setValue(values);
                };
                addEvent(item, 'mousedown', mousedown);
                addEvent(item, 'dragstart', dragStart);
                addEvent(item, 'dragenter', dragOver);
                addEvent(item, 'dragover', dragOver);
                addEvent(item, 'dragleave', dragLeave);
                addEvent(item, 'dragend', dragend);
                return item;
            };
        });
        self.hook('instead', 'lock', ()=>{
            sortable = false;
            return orig_lock.call(self);
        });
        self.hook('instead', 'unlock', ()=>{
            sortable = true;
            return orig_unlock.call(self);
        });
    }
    /**
	 * Plugin: "dropdown_header" (Tom Select)
	 * Copyright (c) contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function dropdown_header(userOptions) {
        const self = this;
        const options = Object.assign({
            title: 'Untitled',
            headerClass: 'dropdown-header',
            titleRowClass: 'dropdown-header-title',
            labelClass: 'dropdown-header-label',
            closeClass: 'dropdown-header-close',
            html: (data)=>{
                return '<div class="' + data.headerClass + '">' + '<div class="' + data.titleRowClass + '">' + '<span class="' + data.labelClass + '">' + data.title + '</span>' + '<a class="' + data.closeClass + '">&times;</a>' + '</div>' + '</div>';
            }
        }, userOptions);
        self.on('initialize', ()=>{
            var header = getDom(options.html(options));
            var close_link = header.querySelector('.' + options.closeClass);
            if (close_link) close_link.addEventListener('click', (evt)=>{
                preventDefault(evt, true);
                self.close();
            });
            self.dropdown.insertBefore(header, self.dropdown.firstChild);
        });
    }
    /**
	 * Plugin: "dropdown_input" (Tom Select)
	 * Copyright (c) contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function caret_position() {
        var self = this;
        /**
	   * Moves the caret to the specified index.
	   *
	   * The input must be moved by leaving it in place and moving the
	   * siblings, due to the fact that focus cannot be restored once lost
	   * on mobile webkit devices
	   *
	   */ self.hook('instead', 'setCaret', (new_pos)=>{
            if (self.settings.mode === 'single' || !self.control.contains(self.control_input)) new_pos = self.items.length;
            else {
                new_pos = Math.max(0, Math.min(self.items.length, new_pos));
                if (new_pos != self.caretPos && !self.isPending) self.controlChildren().forEach((child, j)=>{
                    if (j < new_pos) self.control_input.insertAdjacentElement('beforebegin', child);
                    else self.control.appendChild(child);
                });
            }
            self.caretPos = new_pos;
        });
        self.hook('instead', 'moveCaret', (direction)=>{
            if (!self.isFocused) return;
            // move caret before or after selected items
            const last_active = self.getLastActive(direction);
            if (last_active) {
                const idx = nodeIndex(last_active);
                self.setCaret(direction > 0 ? idx + 1 : idx);
                self.setActiveItem();
                removeClasses(last_active, 'last-active');
            // move caret left or right of current position
            } else self.setCaret(self.caretPos + direction);
        });
    }
    /**
	 * Plugin: "dropdown_input" (Tom Select)
	 * Copyright (c) contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function dropdown_input() {
        const self = this;
        self.settings.shouldOpen = true; // make sure the input is shown even if there are no options to display in the dropdown
        self.hook('before', 'setup', ()=>{
            self.focus_node = self.control;
            addClasses(self.control_input, 'dropdown-input');
            const div = getDom('<div class="dropdown-input-wrap">');
            div.append(self.control_input);
            self.dropdown.insertBefore(div, self.dropdown.firstChild);
            // set a placeholder in the select control
            const placeholder = getDom('<input class="items-placeholder" tabindex="-1" />');
            placeholder.placeholder = self.settings.placeholder || '';
            self.control.append(placeholder);
        });
        self.on('initialize', ()=>{
            // set tabIndex on control to -1, otherwise [shift+tab] will put focus right back on control_input
            self.control_input.addEventListener('keydown', (evt)=>{
                //addEvent(self.control_input,'keydown' as const,(evt:KeyboardEvent) =>{
                switch(evt.keyCode){
                    case KEY_ESC:
                        if (self.isOpen) {
                            preventDefault(evt, true);
                            self.close();
                        }
                        self.clearActiveItems();
                        return;
                    case KEY_TAB:
                        self.focus_node.tabIndex = -1;
                        break;
                }
                return self.onKeyDown.call(self, evt);
            });
            self.on('blur', ()=>{
                self.focus_node.tabIndex = self.isDisabled ? -1 : self.tabIndex;
            });
            // give the control_input focus when the dropdown is open
            self.on('dropdown_open', ()=>{
                self.control_input.focus();
            });
            // prevent onBlur from closing when focus is on the control_input
            const orig_onBlur = self.onBlur;
            self.hook('instead', 'onBlur', (evt)=>{
                if (evt && evt.relatedTarget == self.control_input) return;
                return orig_onBlur.call(self);
            });
            addEvent(self.control_input, 'blur', ()=>self.onBlur());
            // return focus to control to allow further keyboard input
            self.hook('before', 'close', ()=>{
                if (!self.isOpen) return;
                self.focus_node.focus({
                    preventScroll: true
                });
            });
        });
    }
    /**
	 * Plugin: "input_autogrow" (Tom Select)
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function input_autogrow() {
        var self = this;
        self.on('initialize', ()=>{
            var test_input = document.createElement('span');
            var control = self.control_input;
            test_input.style.cssText = 'position:absolute; top:-99999px; left:-99999px; width:auto; padding:0; white-space:pre; ';
            self.wrapper.appendChild(test_input);
            var transfer_styles = [
                'letterSpacing',
                'fontSize',
                'fontFamily',
                'fontWeight',
                'textTransform'
            ];
            for (const style_name of transfer_styles)// @ts-ignore TS7015 https://stackoverflow.com/a/50506154/697576
            test_input.style[style_name] = control.style[style_name];
            /**
	     * Set the control width
	     *
	     */ var resize = ()=>{
                test_input.textContent = control.value;
                control.style.width = test_input.clientWidth + 'px';
            };
            resize();
            self.on('update item_add item_remove', resize);
            addEvent(control, 'input', resize);
            addEvent(control, 'keyup', resize);
            addEvent(control, 'blur', resize);
            addEvent(control, 'update', resize);
        });
    }
    /**
	 * Plugin: "input_autogrow" (Tom Select)
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function no_backspace_delete() {
        var self = this;
        var orig_deleteSelection = self.deleteSelection;
        this.hook('instead', 'deleteSelection', (evt)=>{
            if (self.activeItems.length) return orig_deleteSelection.call(self, evt);
            return false;
        });
    }
    /**
	 * Plugin: "no_active_items" (Tom Select)
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function no_active_items() {
        this.hook('instead', 'setActiveItem', ()=>{});
        this.hook('instead', 'selectAll', ()=>{});
    }
    /**
	 * Plugin: "optgroup_columns" (Tom Select.js)
	 * Copyright (c) contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function optgroup_columns() {
        var self = this;
        var orig_keydown = self.onKeyDown;
        self.hook('instead', 'onKeyDown', (evt)=>{
            var index, option, options, optgroup;
            if (!self.isOpen || !(evt.keyCode === KEY_LEFT || evt.keyCode === KEY_RIGHT)) return orig_keydown.call(self, evt);
            self.ignoreHover = true;
            optgroup = parentMatch(self.activeOption, '[data-group]');
            index = nodeIndex(self.activeOption, '[data-selectable]');
            if (!optgroup) return;
            if (evt.keyCode === KEY_LEFT) optgroup = optgroup.previousSibling;
            else optgroup = optgroup.nextSibling;
            if (!optgroup) return;
            options = optgroup.querySelectorAll('[data-selectable]');
            option = options[Math.min(options.length - 1, index)];
            if (option) self.setActiveOption(option);
        });
    }
    /**
	 * Plugin: "remove_button" (Tom Select)
	 * Copyright (c) contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function remove_button(userOptions) {
        const options = Object.assign({
            label: '&times;',
            title: 'Remove',
            className: 'remove',
            append: true
        }, userOptions);
        //options.className = 'remove-single';
        var self = this;
        // override the render method to add remove button to each item
        if (!options.append) return;
        var html = '<a href="javascript:void(0)" class="' + options.className + '" tabindex="-1" title="' + escape_html(options.title) + '">' + options.label + '</a>';
        self.hook('after', 'setupTemplates', ()=>{
            var orig_render_item = self.settings.render.item;
            self.settings.render.item = (data, escape)=>{
                var item = getDom(orig_render_item.call(self, data, escape));
                var close_button = getDom(html);
                item.appendChild(close_button);
                addEvent(close_button, 'mousedown', (evt)=>{
                    preventDefault(evt, true);
                });
                addEvent(close_button, 'click', (evt)=>{
                    if (self.isLocked) return;
                    // propagating will trigger the dropdown to show for single mode
                    preventDefault(evt, true);
                    if (self.isLocked) return;
                    if (!self.shouldDelete([
                        item
                    ], evt)) return;
                    self.removeItem(item);
                    self.refreshOptions(false);
                    self.inputState();
                });
                return item;
            };
        });
    }
    /**
	 * Plugin: "restore_on_backspace" (Tom Select)
	 * Copyright (c) contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function restore_on_backspace(userOptions) {
        const self = this;
        const options = Object.assign({
            text: (option)=>{
                return option[self.settings.labelField];
            }
        }, userOptions);
        self.on('item_remove', function(value) {
            if (!self.isFocused) return;
            if (self.control_input.value.trim() === '') {
                var option = self.options[value];
                if (option) self.setTextboxValue(options.text.call(self, option));
            }
        });
    }
    /**
	 * Plugin: "restore_on_backspace" (Tom Select)
	 * Copyright (c) contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 */ function virtual_scroll() {
        const self = this;
        const orig_canLoad = self.canLoad;
        const orig_clearActiveOption = self.clearActiveOption;
        const orig_loadCallback = self.loadCallback;
        var pagination = {};
        var dropdown_content;
        var loading_more = false;
        var load_more_opt;
        var default_values = [];
        if (!self.settings.shouldLoadMore) // return true if additional results should be loaded
        self.settings.shouldLoadMore = ()=>{
            const scroll_percent = dropdown_content.clientHeight / (dropdown_content.scrollHeight - dropdown_content.scrollTop);
            if (scroll_percent > 0.9) return true;
            if (self.activeOption) {
                var selectable = self.selectable();
                var index = Array.from(selectable).indexOf(self.activeOption);
                if (index >= selectable.length - 2) return true;
            }
            return false;
        };
        if (!self.settings.firstUrl) throw 'virtual_scroll plugin requires a firstUrl() method';
        // in order for virtual scrolling to work,
        // options need to be ordered the same way they're returned from the remote data source
        self.settings.sortField = [
            {
                field: '$order'
            },
            {
                field: '$score'
            }
        ];
        // can we load more results for given query?
        const canLoadMore = (query)=>{
            if (typeof self.settings.maxOptions === 'number' && dropdown_content.children.length >= self.settings.maxOptions) return false;
            if (query in pagination && pagination[query]) return true;
            return false;
        };
        const clearFilter = (option, value)=>{
            if (self.items.indexOf(value) >= 0 || default_values.indexOf(value) >= 0) return true;
            return false;
        };
        // set the next url that will be
        self.setNextUrl = (value, next_url)=>{
            pagination[value] = next_url;
        };
        // getUrl() to be used in settings.load()
        self.getUrl = (query)=>{
            if (query in pagination) {
                const next_url = pagination[query];
                pagination[query] = false;
                return next_url;
            }
            // if the user goes back to a previous query
            // we need to load the first page again
            self.clearPagination();
            return self.settings.firstUrl.call(self, query);
        };
        // clear pagination
        self.clearPagination = ()=>{
            pagination = {};
        };
        // don't clear the active option (and cause unwanted dropdown scroll)
        // while loading more results
        self.hook('instead', 'clearActiveOption', ()=>{
            if (loading_more) return;
            return orig_clearActiveOption.call(self);
        });
        // override the canLoad method
        self.hook('instead', 'canLoad', (query)=>{
            // first time the query has been seen
            if (!(query in pagination)) return orig_canLoad.call(self, query);
            return canLoadMore(query);
        });
        // wrap the load
        self.hook('instead', 'loadCallback', (options, optgroups)=>{
            if (!loading_more) self.clearOptions(clearFilter);
            else if (load_more_opt) {
                const first_option = options[0];
                if (first_option !== undefined) load_more_opt.dataset.value = first_option[self.settings.valueField];
            }
            orig_loadCallback.call(self, options, optgroups);
            loading_more = false;
        });
        // add templates to dropdown
        //	loading_more if we have another url in the queue
        //	no_more_results if we don't have another url in the queue
        self.hook('after', 'refreshOptions', ()=>{
            const query = self.lastValue;
            var option;
            if (canLoadMore(query)) {
                option = self.render('loading_more', {
                    query: query
                });
                if (option) {
                    option.setAttribute('data-selectable', ''); // so that navigating dropdown with [down] keypresses can navigate to this node
                    load_more_opt = option;
                }
            } else if (query in pagination && !dropdown_content.querySelector('.no-results')) option = self.render('no_more_results', {
                query: query
            });
            if (option) {
                addClasses(option, self.settings.optionClass);
                dropdown_content.append(option);
            }
        });
        // add scroll listener and default templates
        self.on('initialize', ()=>{
            default_values = Object.keys(self.options);
            dropdown_content = self.dropdown_content;
            // default templates
            self.settings.render = Object.assign({}, {
                loading_more: ()=>{
                    return `<div class="loading-more-results">Loading more results ... </div>`;
                },
                no_more_results: ()=>{
                    return `<div class="no-more-results">No more results</div>`;
                }
            }, self.settings.render);
            // watch dropdown content scroll position
            dropdown_content.addEventListener('scroll', ()=>{
                if (!self.settings.shouldLoadMore.call(self)) return;
                // !important: this will get checked again in load() but we still need to check here otherwise loading_more will be set to true
                if (!canLoadMore(self.lastValue)) return;
                // don't call load() too much
                if (loading_more) return;
                loading_more = true;
                self.load.call(self, self.lastValue);
            });
        });
    }
    TomSelect1.define('change_listener', change_listener);
    TomSelect1.define('checkbox_options', checkbox_options);
    TomSelect1.define('clear_button', clear_button);
    TomSelect1.define('drag_drop', drag_drop);
    TomSelect1.define('dropdown_header', dropdown_header);
    TomSelect1.define('caret_position', caret_position);
    TomSelect1.define('dropdown_input', dropdown_input);
    TomSelect1.define('input_autogrow', input_autogrow);
    TomSelect1.define('no_backspace_delete', no_backspace_delete);
    TomSelect1.define('no_active_items', no_active_items);
    TomSelect1.define('optgroup_columns', optgroup_columns);
    TomSelect1.define('remove_button', remove_button);
    TomSelect1.define('restore_on_backspace', restore_on_backspace);
    TomSelect1.define('virtual_scroll', virtual_scroll);
    return TomSelect1;
});
var $79d03e7a40edeffe$var$tomSelect = function(el, opts) {
    return new TomSelect(el, opts);
};

});


parcelRegister("5hw4O", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d876c08b0323d61$export$2e2bcd8739ae039);

var $lw7ns = parcelRequire("lw7ns");
class $3d876c08b0323d61$export$2e2bcd8739ae039 {
    static init() {
        this.gallery();
        this.lazyload();
    }
    static gallery() {
        const gallery = $('.__gallery');
        if (gallery.length === 0) return;
        gallery.magnificPopup({
            type: 'image',
            zoom: {
                enabled: true,
                easing: 'ease-in-out'
            },
            gallery: {
                enabled: true,
                tPrev: "\u524D",
                tNext: "\u6B21",
                tCounter: '%curr% / %total%',
                preload: [
                    1,
                    1
                ]
            },
            image: {
                titleSrc: 'title',
                tError: "\u753B\u50CF\u304C\u3042\u308A\u307E\u305B\u3093"
            }
        });
        gallery.on('mouseenter', (event)=>{
            document.createElement('img').src = event.currentTarget.href;
        });
    }
    static lazyload() {
        if (lazyload) lazyload();
    }
    static slider(parameter = {}) {
        $(parameter.element || '.splide').each(function() {
            const updateHeight = (newIndex)=>{
                const slide = slider.Components.Slides.getAt(typeof newIndex === 'number' ? newIndex : slider.index).slide;
                slide.parentElement.parentElement.style.height = slide.firstElementChild.offsetHeight + 'px';
            };
            const slider = new (0, $lw7ns.default)(this, {
                perPage: parameter.perPage && parameter.perPage.pc || 1,
                arrows: parameter.arrows && parameter.arrows.pc || false,
                pagination: parameter.pagination && parameter.pagination.pc || false,
                padding: parameter.padding || 0,
                drag: parameter.drag && parameter.drag.pc,
                autoplay: parameter.autoplay,
                interval: parameter.interval,
                type: parameter.type || 'slide',
                rewind: parameter.rewind,
                breakpoints: {
                    767: {
                        perPage: parameter.perPage && parameter.perPage.sp || 1,
                        arrows: parameter.arrows && parameter.arrows.sp || false,
                        pagination: parameter.pagination && parameter.pagination.sp || false,
                        drag: parameter.drag && parameter.drag.sp
                    }
                }
            }).mount();
            if (parameter.dynamicHeight) {
                slider.on('move resize', updateHeight);
                updateHeight();
            }
        });
    }
    static slider_manual(element, parameter) {
        return new (0, $lw7ns.default)(element, parameter);
    }
}

});
parcelRegister("lw7ns", function(module, exports) {

$parcel$export(module.exports, "default", () => $faa24f22a5163ec6$export$24494c7438c070bf);
function $faa24f22a5163ec6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $faa24f22a5163ec6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $faa24f22a5163ec6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $faa24f22a5163ec6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ var $faa24f22a5163ec6$var$MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var $faa24f22a5163ec6$var$CREATED = 1;
var $faa24f22a5163ec6$var$MOUNTED = 2;
var $faa24f22a5163ec6$var$IDLE = 3;
var $faa24f22a5163ec6$var$MOVING = 4;
var $faa24f22a5163ec6$var$SCROLLING = 5;
var $faa24f22a5163ec6$var$DRAGGING = 6;
var $faa24f22a5163ec6$var$DESTROYED = 7;
var $faa24f22a5163ec6$var$STATES = {
    CREATED: $faa24f22a5163ec6$var$CREATED,
    MOUNTED: $faa24f22a5163ec6$var$MOUNTED,
    IDLE: $faa24f22a5163ec6$var$IDLE,
    MOVING: $faa24f22a5163ec6$var$MOVING,
    SCROLLING: $faa24f22a5163ec6$var$SCROLLING,
    DRAGGING: $faa24f22a5163ec6$var$DRAGGING,
    DESTROYED: $faa24f22a5163ec6$var$DESTROYED
};
function $faa24f22a5163ec6$var$empty(array) {
    array.length = 0;
}
function $faa24f22a5163ec6$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $faa24f22a5163ec6$var$apply(func) {
    return func.bind.apply(func, [
        null
    ].concat($faa24f22a5163ec6$var$slice(arguments, 1)));
}
var $faa24f22a5163ec6$var$nextTick = setTimeout;
var $faa24f22a5163ec6$var$noop = function noop() {};
function $faa24f22a5163ec6$var$raf(func) {
    return requestAnimationFrame(func);
}
function $faa24f22a5163ec6$var$typeOf(type, subject) {
    return typeof subject === type;
}
function $faa24f22a5163ec6$var$isObject(subject) {
    return !$faa24f22a5163ec6$var$isNull(subject) && $faa24f22a5163ec6$var$typeOf("object", subject);
}
var $faa24f22a5163ec6$var$isArray = Array.isArray;
var $faa24f22a5163ec6$var$isFunction = $faa24f22a5163ec6$var$apply($faa24f22a5163ec6$var$typeOf, "function");
var $faa24f22a5163ec6$var$isString = $faa24f22a5163ec6$var$apply($faa24f22a5163ec6$var$typeOf, "string");
var $faa24f22a5163ec6$var$isUndefined = $faa24f22a5163ec6$var$apply($faa24f22a5163ec6$var$typeOf, "undefined");
function $faa24f22a5163ec6$var$isNull(subject) {
    return subject === null;
}
function $faa24f22a5163ec6$var$isHTMLElement(subject) {
    try {
        return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
    } catch (e) {
        return false;
    }
}
function $faa24f22a5163ec6$var$toArray(value) {
    return $faa24f22a5163ec6$var$isArray(value) ? value : [
        value
    ];
}
function $faa24f22a5163ec6$var$forEach(values, iteratee) {
    $faa24f22a5163ec6$var$toArray(values).forEach(iteratee);
}
function $faa24f22a5163ec6$var$includes(array, value) {
    return array.indexOf(value) > -1;
}
function $faa24f22a5163ec6$var$push(array, items) {
    array.push.apply(array, $faa24f22a5163ec6$var$toArray(items));
    return array;
}
function $faa24f22a5163ec6$var$toggleClass(elm, classes, add) {
    if (elm) $faa24f22a5163ec6$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
function $faa24f22a5163ec6$var$addClass(elm, classes) {
    $faa24f22a5163ec6$var$toggleClass(elm, $faa24f22a5163ec6$var$isString(classes) ? classes.split(" ") : classes, true);
}
function $faa24f22a5163ec6$var$append(parent, children) {
    $faa24f22a5163ec6$var$forEach(children, parent.appendChild.bind(parent));
}
function $faa24f22a5163ec6$var$before(nodes, ref) {
    $faa24f22a5163ec6$var$forEach(nodes, function(node) {
        var parent = (ref || node).parentNode;
        if (parent) parent.insertBefore(node, ref);
    });
}
function $faa24f22a5163ec6$var$matches(elm, selector) {
    return $faa24f22a5163ec6$var$isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function $faa24f22a5163ec6$var$children(parent, selector) {
    var children2 = parent ? $faa24f22a5163ec6$var$slice(parent.children) : [];
    return selector ? children2.filter(function(child) {
        return $faa24f22a5163ec6$var$matches(child, selector);
    }) : children2;
}
function $faa24f22a5163ec6$var$child(parent, selector) {
    return selector ? $faa24f22a5163ec6$var$children(parent, selector)[0] : parent.firstElementChild;
}
var $faa24f22a5163ec6$var$ownKeys = Object.keys;
function $faa24f22a5163ec6$var$forOwn(object, iteratee, right) {
    if (object) (right ? $faa24f22a5163ec6$var$ownKeys(object).reverse() : $faa24f22a5163ec6$var$ownKeys(object)).forEach(function(key) {
        key !== "__proto__" && iteratee(object[key], key);
    });
    return object;
}
function $faa24f22a5163ec6$var$assign(object) {
    $faa24f22a5163ec6$var$slice(arguments, 1).forEach(function(source) {
        $faa24f22a5163ec6$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $faa24f22a5163ec6$var$merge(object) {
    $faa24f22a5163ec6$var$slice(arguments, 1).forEach(function(source) {
        $faa24f22a5163ec6$var$forOwn(source, function(value, key) {
            if ($faa24f22a5163ec6$var$isArray(value)) object[key] = value.slice();
            else if ($faa24f22a5163ec6$var$isObject(value)) object[key] = $faa24f22a5163ec6$var$merge({}, $faa24f22a5163ec6$var$isObject(object[key]) ? object[key] : {}, value);
            else object[key] = value;
        });
    });
    return object;
}
function $faa24f22a5163ec6$var$omit(object, keys) {
    $faa24f22a5163ec6$var$forEach(keys || $faa24f22a5163ec6$var$ownKeys(object), function(key) {
        delete object[key];
    });
}
function $faa24f22a5163ec6$var$removeAttribute(elms, attrs) {
    $faa24f22a5163ec6$var$forEach(elms, function(elm) {
        $faa24f22a5163ec6$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $faa24f22a5163ec6$var$setAttribute(elms, attrs, value) {
    if ($faa24f22a5163ec6$var$isObject(attrs)) $faa24f22a5163ec6$var$forOwn(attrs, function(value2, name) {
        $faa24f22a5163ec6$var$setAttribute(elms, name, value2);
    });
    else $faa24f22a5163ec6$var$forEach(elms, function(elm) {
        $faa24f22a5163ec6$var$isNull(value) || value === "" ? $faa24f22a5163ec6$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
function $faa24f22a5163ec6$var$create(tag, attrs, parent) {
    var elm = document.createElement(tag);
    if (attrs) $faa24f22a5163ec6$var$isString(attrs) ? $faa24f22a5163ec6$var$addClass(elm, attrs) : $faa24f22a5163ec6$var$setAttribute(elm, attrs);
    parent && $faa24f22a5163ec6$var$append(parent, elm);
    return elm;
}
function $faa24f22a5163ec6$var$style(elm, prop, value) {
    if ($faa24f22a5163ec6$var$isUndefined(value)) return getComputedStyle(elm)[prop];
    if (!$faa24f22a5163ec6$var$isNull(value)) elm.style[prop] = "" + value;
}
function $faa24f22a5163ec6$var$display(elm, display2) {
    $faa24f22a5163ec6$var$style(elm, "display", display2);
}
function $faa24f22a5163ec6$var$focus(elm) {
    elm["setActive"] && elm["setActive"]() || elm.focus({
        preventScroll: true
    });
}
function $faa24f22a5163ec6$var$getAttribute(elm, attr) {
    return elm.getAttribute(attr);
}
function $faa24f22a5163ec6$var$hasClass(elm, className) {
    return elm && elm.classList.contains(className);
}
function $faa24f22a5163ec6$var$rect(target) {
    return target.getBoundingClientRect();
}
function $faa24f22a5163ec6$var$remove(nodes) {
    $faa24f22a5163ec6$var$forEach(nodes, function(node) {
        if (node && node.parentNode) node.parentNode.removeChild(node);
    });
}
function $faa24f22a5163ec6$var$parseHtml(html) {
    return $faa24f22a5163ec6$var$child(new DOMParser().parseFromString(html, "text/html").body);
}
function $faa24f22a5163ec6$var$prevent(e, stopPropagation) {
    e.preventDefault();
    if (stopPropagation) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
}
function $faa24f22a5163ec6$var$query(parent, selector) {
    return parent && parent.querySelector(selector);
}
function $faa24f22a5163ec6$var$queryAll(parent, selector) {
    return selector ? $faa24f22a5163ec6$var$slice(parent.querySelectorAll(selector)) : [];
}
function $faa24f22a5163ec6$var$removeClass(elm, classes) {
    $faa24f22a5163ec6$var$toggleClass(elm, classes, false);
}
function $faa24f22a5163ec6$var$timeOf(e) {
    return e.timeStamp;
}
function $faa24f22a5163ec6$var$unit(value) {
    return $faa24f22a5163ec6$var$isString(value) ? value : value ? value + "px" : "";
}
var $faa24f22a5163ec6$var$PROJECT_CODE = "splide";
var $faa24f22a5163ec6$var$DATA_ATTRIBUTE = "data-" + $faa24f22a5163ec6$var$PROJECT_CODE;
function $faa24f22a5163ec6$var$assert(condition, message) {
    if (!condition) throw new Error("[" + $faa24f22a5163ec6$var$PROJECT_CODE + "] " + (message || ""));
}
var $faa24f22a5163ec6$var$min = Math.min, $faa24f22a5163ec6$var$max = Math.max, $faa24f22a5163ec6$var$floor = Math.floor, $faa24f22a5163ec6$var$ceil = Math.ceil, $faa24f22a5163ec6$var$abs = Math.abs;
function $faa24f22a5163ec6$var$approximatelyEqual(x, y, epsilon) {
    return $faa24f22a5163ec6$var$abs(x - y) < epsilon;
}
function $faa24f22a5163ec6$var$between(number, x, y, exclusive) {
    var minimum = $faa24f22a5163ec6$var$min(x, y);
    var maximum = $faa24f22a5163ec6$var$max(x, y);
    return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function $faa24f22a5163ec6$var$clamp(number, x, y) {
    var minimum = $faa24f22a5163ec6$var$min(x, y);
    var maximum = $faa24f22a5163ec6$var$max(x, y);
    return $faa24f22a5163ec6$var$min($faa24f22a5163ec6$var$max(minimum, number), maximum);
}
function $faa24f22a5163ec6$var$sign(x) {
    return +(x > 0) - +(x < 0);
}
function $faa24f22a5163ec6$var$camelToKebab(string) {
    return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function $faa24f22a5163ec6$var$format(string, replacements) {
    $faa24f22a5163ec6$var$forEach(replacements, function(replacement) {
        string = string.replace("%s", "" + replacement);
    });
    return string;
}
function $faa24f22a5163ec6$var$pad(number) {
    return number < 10 ? "0" + number : "" + number;
}
var $faa24f22a5163ec6$var$ids = {};
function $faa24f22a5163ec6$var$uniqueId(prefix) {
    return "" + prefix + $faa24f22a5163ec6$var$pad($faa24f22a5163ec6$var$ids[prefix] = ($faa24f22a5163ec6$var$ids[prefix] || 0) + 1);
}
function $faa24f22a5163ec6$export$c473e36ef1bda729() {
    var listeners = [];
    function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    }
    function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    }
    function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    }
    function forEachEvent(targets, events, iteratee) {
        $faa24f22a5163ec6$var$forEach(targets, function(target) {
            target && $faa24f22a5163ec6$var$forEach(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    }
    function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $faa24f22a5163ec6$var$empty(listeners);
    }
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $faa24f22a5163ec6$export$d300dc1a2634364b = "mounted";
var $faa24f22a5163ec6$export$d8dac49b4532735a = "ready";
var $faa24f22a5163ec6$export$2aa493d7c3275167 = "move";
var $faa24f22a5163ec6$export$fe5802204b967f0d = "moved";
var $faa24f22a5163ec6$export$5adb665701eda1ce = "click";
var $faa24f22a5163ec6$export$92e3eae133acac4c = "active";
var $faa24f22a5163ec6$export$6bcbb81035c12cea = "inactive";
var $faa24f22a5163ec6$export$6a5b3445e4066a53 = "visible";
var $faa24f22a5163ec6$export$8c5c7a21d54563e9 = "hidden";
var $faa24f22a5163ec6$export$7f4701ac5e05e39f = "refresh";
var $faa24f22a5163ec6$export$db40ab7c0855fa5c = "updated";
var $faa24f22a5163ec6$export$7e019dae5103a285 = "resize";
var $faa24f22a5163ec6$export$d637eba1e9e28482 = "resized";
var $faa24f22a5163ec6$export$e84bf5065c9087ac = "drag";
var $faa24f22a5163ec6$export$8e9f636d2c722196 = "dragging";
var $faa24f22a5163ec6$export$90ea576bd3fdeb60 = "dragged";
var $faa24f22a5163ec6$export$49801896908b5e33 = "scroll";
var $faa24f22a5163ec6$export$ff8164bff3202b9 = "scrolled";
var $faa24f22a5163ec6$export$6cbac5b662a31e1b = "overflow";
var $faa24f22a5163ec6$export$88c4cf7419e470cd = "destroy";
var $faa24f22a5163ec6$export$8647f6b043e04e9d = "arrows:mounted";
var $faa24f22a5163ec6$export$d467f9343b961f75 = "arrows:updated";
var $faa24f22a5163ec6$export$bf89a4e4349c9778 = "pagination:mounted";
var $faa24f22a5163ec6$export$eb2019082ed6de0b = "pagination:updated";
var $faa24f22a5163ec6$export$84015c33508f94ec = "navigation:mounted";
var $faa24f22a5163ec6$export$23663268a31b79e2 = "autoplay:play";
var $faa24f22a5163ec6$export$185723258309b608 = "autoplay:playing";
var $faa24f22a5163ec6$export$16a1e4f3d0368265 = "autoplay:pause";
var $faa24f22a5163ec6$export$9f64346e17f0ec8e = "lazyload:loaded";
var $faa24f22a5163ec6$export$6d5af59619d10e6a = "sk";
var $faa24f22a5163ec6$export$f0af896383d5adff = "sh";
var $faa24f22a5163ec6$export$28dea85f216954dc = "ei";
function $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $faa24f22a5163ec6$export$c473e36ef1bda729();
    function on(events, callback) {
        binder.bind(bus, $faa24f22a5163ec6$var$toArray(events).join(" "), function(e) {
            callback.apply(callback, $faa24f22a5163ec6$var$isArray(e.detail) ? e.detail : []);
        });
    }
    function emit(event) {
        binder.dispatch(bus, event, $faa24f22a5163ec6$var$slice(arguments, 1));
    }
    if (Splide2) Splide2.event.on($faa24f22a5163ec6$export$88c4cf7419e470cd, binder.destroy);
    return $faa24f22a5163ec6$var$assign(binder, {
        bus: bus,
        on: on,
        off: $faa24f22a5163ec6$var$apply(binder.unbind, bus),
        emit: emit
    });
}
function $faa24f22a5163ec6$export$46ad21b25b6dccf0(interval, onInterval, onUpdate, limit) {
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $faa24f22a5163ec6$var$min((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            id = $faa24f22a5163ec6$var$raf(update);
        }
    }
    function start(resume) {
        resume || cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        id = $faa24f22a5163ec6$var$raf(update);
    }
    function pause() {
        paused = true;
    }
    function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    }
    function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    }
    function set(time) {
        interval = time;
    }
    function isPaused() {
        return paused;
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $faa24f22a5163ec6$export$7254cc27399e90bd(initialState) {
    var state = initialState;
    function set(value) {
        state = value;
    }
    function is(states) {
        return $faa24f22a5163ec6$var$includes($faa24f22a5163ec6$var$toArray(states), state);
    }
    return {
        set: set,
        is: is
    };
}
function $faa24f22a5163ec6$export$efff0f5979573c99(func, duration) {
    var interval = $faa24f22a5163ec6$export$46ad21b25b6dccf0(duration || 0, func, null, 1);
    return function() {
        interval.isPaused() && interval.start();
    };
}
function $faa24f22a5163ec6$var$Media(Splide2, Components2, options) {
    var state = Splide2.state;
    var breakpoints = options.breakpoints || {};
    var reducedMotion = options.reducedMotion || {};
    var binder = $faa24f22a5163ec6$export$c473e36ef1bda729();
    var queries = [];
    function setup() {
        var isMin = options.mediaQuery === "min";
        $faa24f22a5163ec6$var$ownKeys(breakpoints).sort(function(n, m) {
            return isMin ? +n - +m : +m - +n;
        }).forEach(function(key) {
            register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
        });
        register(reducedMotion, $faa24f22a5163ec6$var$MEDIA_PREFERS_REDUCED_MOTION);
        update();
    }
    function destroy(completely) {
        if (completely) binder.destroy();
    }
    function register(options2, query) {
        var queryList = matchMedia(query);
        binder.bind(queryList, "change", update);
        queries.push([
            options2,
            queryList
        ]);
    }
    function update() {
        var destroyed = state.is($faa24f22a5163ec6$var$DESTROYED);
        var direction = options.direction;
        var merged = queries.reduce(function(merged2, entry) {
            return $faa24f22a5163ec6$var$merge(merged2, entry[1].matches ? entry[0] : {});
        }, {});
        $faa24f22a5163ec6$var$omit(options);
        set(merged);
        if (options.destroy) Splide2.destroy(options.destroy === "completely");
        else if (destroyed) {
            destroy(true);
            Splide2.mount();
        } else direction !== options.direction && Splide2.refresh();
    }
    function reduce(enable) {
        if (matchMedia($faa24f22a5163ec6$var$MEDIA_PREFERS_REDUCED_MOTION).matches) enable ? $faa24f22a5163ec6$var$merge(options, reducedMotion) : $faa24f22a5163ec6$var$omit(options, $faa24f22a5163ec6$var$ownKeys(reducedMotion));
    }
    function set(opts, base, notify) {
        $faa24f22a5163ec6$var$merge(options, opts);
        base && $faa24f22a5163ec6$var$merge(Object.getPrototypeOf(options), opts);
        if (notify || !state.is($faa24f22a5163ec6$var$CREATED)) Splide2.emit($faa24f22a5163ec6$export$db40ab7c0855fa5c, options);
    }
    return {
        setup: setup,
        destroy: destroy,
        reduce: reduce,
        set: set
    };
}
var $faa24f22a5163ec6$var$ARROW = "Arrow";
var $faa24f22a5163ec6$var$ARROW_LEFT = $faa24f22a5163ec6$var$ARROW + "Left";
var $faa24f22a5163ec6$var$ARROW_RIGHT = $faa24f22a5163ec6$var$ARROW + "Right";
var $faa24f22a5163ec6$var$ARROW_UP = $faa24f22a5163ec6$var$ARROW + "Up";
var $faa24f22a5163ec6$var$ARROW_DOWN = $faa24f22a5163ec6$var$ARROW + "Down";
var $faa24f22a5163ec6$export$373e92e0788ff06e = "ltr";
var $faa24f22a5163ec6$export$850f7749a2909601 = "rtl";
var $faa24f22a5163ec6$export$97170d9824b89709 = "ttb";
var $faa24f22a5163ec6$var$ORIENTATION_MAP = {
    width: [
        "height"
    ],
    left: [
        "top",
        "right"
    ],
    right: [
        "bottom",
        "left"
    ],
    x: [
        "y"
    ],
    X: [
        "Y"
    ],
    Y: [
        "X"
    ],
    ArrowLeft: [
        $faa24f22a5163ec6$var$ARROW_UP,
        $faa24f22a5163ec6$var$ARROW_RIGHT
    ],
    ArrowRight: [
        $faa24f22a5163ec6$var$ARROW_DOWN,
        $faa24f22a5163ec6$var$ARROW_LEFT
    ]
};
function $faa24f22a5163ec6$var$Direction(Splide2, Components2, options) {
    function resolve(prop, axisOnly, direction) {
        direction = direction || options.direction;
        var index = direction === $faa24f22a5163ec6$export$850f7749a2909601 && !axisOnly ? 1 : direction === $faa24f22a5163ec6$export$97170d9824b89709 ? 0 : -1;
        return $faa24f22a5163ec6$var$ORIENTATION_MAP[prop] && $faa24f22a5163ec6$var$ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
            var replacement = $faa24f22a5163ec6$var$ORIENTATION_MAP[match.toLowerCase()][index] || match;
            return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
        });
    }
    function orient(value) {
        return value * (options.direction === $faa24f22a5163ec6$export$850f7749a2909601 ? 1 : -1);
    }
    return {
        resolve: resolve,
        orient: orient
    };
}
var $faa24f22a5163ec6$var$ROLE = "role";
var $faa24f22a5163ec6$var$TAB_INDEX = "tabindex";
var $faa24f22a5163ec6$var$DISABLED = "disabled";
var $faa24f22a5163ec6$var$ARIA_PREFIX = "aria-";
var $faa24f22a5163ec6$var$ARIA_CONTROLS = $faa24f22a5163ec6$var$ARIA_PREFIX + "controls";
var $faa24f22a5163ec6$var$ARIA_CURRENT = $faa24f22a5163ec6$var$ARIA_PREFIX + "current";
var $faa24f22a5163ec6$var$ARIA_SELECTED = $faa24f22a5163ec6$var$ARIA_PREFIX + "selected";
var $faa24f22a5163ec6$var$ARIA_LABEL = $faa24f22a5163ec6$var$ARIA_PREFIX + "label";
var $faa24f22a5163ec6$var$ARIA_LABELLEDBY = $faa24f22a5163ec6$var$ARIA_PREFIX + "labelledby";
var $faa24f22a5163ec6$var$ARIA_HIDDEN = $faa24f22a5163ec6$var$ARIA_PREFIX + "hidden";
var $faa24f22a5163ec6$var$ARIA_ORIENTATION = $faa24f22a5163ec6$var$ARIA_PREFIX + "orientation";
var $faa24f22a5163ec6$var$ARIA_ROLEDESCRIPTION = $faa24f22a5163ec6$var$ARIA_PREFIX + "roledescription";
var $faa24f22a5163ec6$var$ARIA_LIVE = $faa24f22a5163ec6$var$ARIA_PREFIX + "live";
var $faa24f22a5163ec6$var$ARIA_BUSY = $faa24f22a5163ec6$var$ARIA_PREFIX + "busy";
var $faa24f22a5163ec6$var$ARIA_ATOMIC = $faa24f22a5163ec6$var$ARIA_PREFIX + "atomic";
var $faa24f22a5163ec6$var$ALL_ATTRIBUTES = [
    $faa24f22a5163ec6$var$ROLE,
    $faa24f22a5163ec6$var$TAB_INDEX,
    $faa24f22a5163ec6$var$DISABLED,
    $faa24f22a5163ec6$var$ARIA_CONTROLS,
    $faa24f22a5163ec6$var$ARIA_CURRENT,
    $faa24f22a5163ec6$var$ARIA_LABEL,
    $faa24f22a5163ec6$var$ARIA_LABELLEDBY,
    $faa24f22a5163ec6$var$ARIA_HIDDEN,
    $faa24f22a5163ec6$var$ARIA_ORIENTATION,
    $faa24f22a5163ec6$var$ARIA_ROLEDESCRIPTION
];
var $faa24f22a5163ec6$var$CLASS_PREFIX = $faa24f22a5163ec6$var$PROJECT_CODE + "__";
var $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX = "is-";
var $faa24f22a5163ec6$export$93b21159ad85c843 = $faa24f22a5163ec6$var$PROJECT_CODE;
var $faa24f22a5163ec6$export$7738b09ac0a98952 = $faa24f22a5163ec6$var$CLASS_PREFIX + "track";
var $faa24f22a5163ec6$export$19cc2a5451235cae = $faa24f22a5163ec6$var$CLASS_PREFIX + "list";
var $faa24f22a5163ec6$export$8d922915837a38d3 = $faa24f22a5163ec6$var$CLASS_PREFIX + "slide";
var $faa24f22a5163ec6$export$2c1ba4a4f1aa4947 = $faa24f22a5163ec6$export$8d922915837a38d3 + "--clone";
var $faa24f22a5163ec6$export$e9ba7e444ba60a12 = $faa24f22a5163ec6$export$8d922915837a38d3 + "__container";
var $faa24f22a5163ec6$export$a26cbd955fecf11e = $faa24f22a5163ec6$var$CLASS_PREFIX + "arrows";
var $faa24f22a5163ec6$export$516e7d18e13a2dca = $faa24f22a5163ec6$var$CLASS_PREFIX + "arrow";
var $faa24f22a5163ec6$export$58ea3db24c33b76 = $faa24f22a5163ec6$export$516e7d18e13a2dca + "--prev";
var $faa24f22a5163ec6$export$4885afd7098a65c2 = $faa24f22a5163ec6$export$516e7d18e13a2dca + "--next";
var $faa24f22a5163ec6$export$cbf8e5a0ab95eda3 = $faa24f22a5163ec6$var$CLASS_PREFIX + "pagination";
var $faa24f22a5163ec6$export$52f2cca6a5eee805 = $faa24f22a5163ec6$export$cbf8e5a0ab95eda3 + "__page";
var $faa24f22a5163ec6$export$4c82dc32b1c4ace5 = $faa24f22a5163ec6$var$CLASS_PREFIX + "progress";
var $faa24f22a5163ec6$export$2c9b091c749f4409 = $faa24f22a5163ec6$export$4c82dc32b1c4ace5 + "__bar";
var $faa24f22a5163ec6$export$a29701deef84b825 = $faa24f22a5163ec6$var$CLASS_PREFIX + "toggle";
var $faa24f22a5163ec6$export$d9d247d51b430dbb = $faa24f22a5163ec6$export$a29701deef84b825 + "__play";
var $faa24f22a5163ec6$export$3529f201a419925b = $faa24f22a5163ec6$export$a29701deef84b825 + "__pause";
var $faa24f22a5163ec6$export$3e5381ee3fab8374 = $faa24f22a5163ec6$var$CLASS_PREFIX + "spinner";
var $faa24f22a5163ec6$export$bb78d7c200da8960 = $faa24f22a5163ec6$var$CLASS_PREFIX + "sr";
var $faa24f22a5163ec6$export$7761661e2d5b9388 = $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX + "initialized";
var $faa24f22a5163ec6$export$72d36ecf3758cb4b = $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX + "active";
var $faa24f22a5163ec6$export$e423ac4972f5e196 = $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX + "prev";
var $faa24f22a5163ec6$export$457a2d20827a2779 = $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX + "next";
var $faa24f22a5163ec6$export$53ca4621bbab9a = $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX + "visible";
var $faa24f22a5163ec6$export$d22ec4ccb7996ba2 = $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX + "loading";
var $faa24f22a5163ec6$export$b6f202a162a09100 = $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX + "focus-in";
var $faa24f22a5163ec6$export$cd908cd1dd625e29 = $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX + "overflow";
var $faa24f22a5163ec6$export$49f9eaea10ebf193 = [
    $faa24f22a5163ec6$export$72d36ecf3758cb4b,
    $faa24f22a5163ec6$export$53ca4621bbab9a,
    $faa24f22a5163ec6$export$e423ac4972f5e196,
    $faa24f22a5163ec6$export$457a2d20827a2779,
    $faa24f22a5163ec6$export$d22ec4ccb7996ba2,
    $faa24f22a5163ec6$export$b6f202a162a09100,
    $faa24f22a5163ec6$export$cd908cd1dd625e29
];
var $faa24f22a5163ec6$export$ba41d43e4a419565 = {
    slide: $faa24f22a5163ec6$export$8d922915837a38d3,
    clone: $faa24f22a5163ec6$export$2c1ba4a4f1aa4947,
    arrows: $faa24f22a5163ec6$export$a26cbd955fecf11e,
    arrow: $faa24f22a5163ec6$export$516e7d18e13a2dca,
    prev: $faa24f22a5163ec6$export$58ea3db24c33b76,
    next: $faa24f22a5163ec6$export$4885afd7098a65c2,
    pagination: $faa24f22a5163ec6$export$cbf8e5a0ab95eda3,
    page: $faa24f22a5163ec6$export$52f2cca6a5eee805,
    spinner: $faa24f22a5163ec6$export$3e5381ee3fab8374
};
function $faa24f22a5163ec6$var$closest(from, selector) {
    if ($faa24f22a5163ec6$var$isFunction(from.closest)) return from.closest(selector);
    var elm = from;
    while(elm && elm.nodeType === 1){
        if ($faa24f22a5163ec6$var$matches(elm, selector)) break;
        elm = elm.parentElement;
    }
    return elm;
}
var $faa24f22a5163ec6$var$FRICTION = 5;
var $faa24f22a5163ec6$var$LOG_INTERVAL = 200;
var $faa24f22a5163ec6$var$POINTER_DOWN_EVENTS = "touchstart mousedown";
var $faa24f22a5163ec6$var$POINTER_MOVE_EVENTS = "touchmove mousemove";
var $faa24f22a5163ec6$var$POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function $faa24f22a5163ec6$var$Elements(Splide2, Components2, options) {
    var _EventInterface = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
    var root = Splide2.root;
    var i18n = options.i18n;
    var elements = {};
    var slides = [];
    var rootClasses = [];
    var trackClasses = [];
    var track;
    var list;
    var isUsingKey;
    function setup() {
        collect();
        init();
        update();
    }
    function mount() {
        on($faa24f22a5163ec6$export$7f4701ac5e05e39f, destroy);
        on($faa24f22a5163ec6$export$7f4701ac5e05e39f, setup);
        on($faa24f22a5163ec6$export$db40ab7c0855fa5c, update);
        bind(document, $faa24f22a5163ec6$var$POINTER_DOWN_EVENTS + " keydown", function(e) {
            isUsingKey = e.type === "keydown";
        }, {
            capture: true
        });
        bind(root, "focusin", function() {
            $faa24f22a5163ec6$var$toggleClass(root, $faa24f22a5163ec6$export$b6f202a162a09100, !!isUsingKey);
        });
    }
    function destroy(completely) {
        var attrs = $faa24f22a5163ec6$var$ALL_ATTRIBUTES.concat("style");
        $faa24f22a5163ec6$var$empty(slides);
        $faa24f22a5163ec6$var$removeClass(root, rootClasses);
        $faa24f22a5163ec6$var$removeClass(track, trackClasses);
        $faa24f22a5163ec6$var$removeAttribute([
            track,
            list
        ], attrs);
        $faa24f22a5163ec6$var$removeAttribute(root, completely ? attrs : [
            "style",
            $faa24f22a5163ec6$var$ARIA_ROLEDESCRIPTION
        ]);
    }
    function update() {
        $faa24f22a5163ec6$var$removeClass(root, rootClasses);
        $faa24f22a5163ec6$var$removeClass(track, trackClasses);
        rootClasses = getClasses($faa24f22a5163ec6$export$93b21159ad85c843);
        trackClasses = getClasses($faa24f22a5163ec6$export$7738b09ac0a98952);
        $faa24f22a5163ec6$var$addClass(root, rootClasses);
        $faa24f22a5163ec6$var$addClass(track, trackClasses);
        $faa24f22a5163ec6$var$setAttribute(root, $faa24f22a5163ec6$var$ARIA_LABEL, options.label);
        $faa24f22a5163ec6$var$setAttribute(root, $faa24f22a5163ec6$var$ARIA_LABELLEDBY, options.labelledby);
    }
    function collect() {
        track = find("." + $faa24f22a5163ec6$export$7738b09ac0a98952);
        list = $faa24f22a5163ec6$var$child(track, "." + $faa24f22a5163ec6$export$19cc2a5451235cae);
        $faa24f22a5163ec6$var$assert(track && list, "A track/list element is missing.");
        $faa24f22a5163ec6$var$push(slides, $faa24f22a5163ec6$var$children(list, "." + $faa24f22a5163ec6$export$8d922915837a38d3 + ":not(." + $faa24f22a5163ec6$export$2c1ba4a4f1aa4947 + ")"));
        $faa24f22a5163ec6$var$forOwn({
            arrows: $faa24f22a5163ec6$export$a26cbd955fecf11e,
            pagination: $faa24f22a5163ec6$export$cbf8e5a0ab95eda3,
            prev: $faa24f22a5163ec6$export$58ea3db24c33b76,
            next: $faa24f22a5163ec6$export$4885afd7098a65c2,
            bar: $faa24f22a5163ec6$export$2c9b091c749f4409,
            toggle: $faa24f22a5163ec6$export$a29701deef84b825
        }, function(className, key) {
            elements[key] = find("." + className);
        });
        $faa24f22a5163ec6$var$assign(elements, {
            root: root,
            track: track,
            list: list,
            slides: slides
        });
    }
    function init() {
        var id = root.id || $faa24f22a5163ec6$var$uniqueId($faa24f22a5163ec6$var$PROJECT_CODE);
        var role = options.role;
        root.id = id;
        track.id = track.id || id + "-track";
        list.id = list.id || id + "-list";
        if (!$faa24f22a5163ec6$var$getAttribute(root, $faa24f22a5163ec6$var$ROLE) && root.tagName !== "SECTION" && role) $faa24f22a5163ec6$var$setAttribute(root, $faa24f22a5163ec6$var$ROLE, role);
        $faa24f22a5163ec6$var$setAttribute(root, $faa24f22a5163ec6$var$ARIA_ROLEDESCRIPTION, i18n.carousel);
        $faa24f22a5163ec6$var$setAttribute(list, $faa24f22a5163ec6$var$ROLE, "presentation");
    }
    function find(selector) {
        var elm = $faa24f22a5163ec6$var$query(root, selector);
        return elm && $faa24f22a5163ec6$var$closest(elm, "." + $faa24f22a5163ec6$export$93b21159ad85c843) === root ? elm : void 0;
    }
    function getClasses(base) {
        return [
            base + "--" + options.type,
            base + "--" + options.direction,
            options.drag && base + "--draggable",
            options.isNavigation && base + "--nav",
            base === $faa24f22a5163ec6$export$93b21159ad85c843 && $faa24f22a5163ec6$export$72d36ecf3758cb4b
        ];
    }
    return $faa24f22a5163ec6$var$assign(elements, {
        setup: setup,
        mount: mount,
        destroy: destroy
    });
}
var $faa24f22a5163ec6$export$e5a58a5ee5b54c22 = "slide";
var $faa24f22a5163ec6$export$f42383286ed1223d = "loop";
var $faa24f22a5163ec6$export$742b62a5690c060 = "fade";
function $faa24f22a5163ec6$var$Slide$1(Splide2, index, slideIndex, slide) {
    var event = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
    var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
    var resolve = Components.Direction.resolve;
    var styles = $faa24f22a5163ec6$var$getAttribute(slide, "style");
    var label = $faa24f22a5163ec6$var$getAttribute(slide, $faa24f22a5163ec6$var$ARIA_LABEL);
    var isClone = slideIndex > -1;
    var container = $faa24f22a5163ec6$var$child(slide, "." + $faa24f22a5163ec6$export$e9ba7e444ba60a12);
    var destroyed;
    function mount() {
        if (!isClone) {
            slide.id = root.id + "-slide" + $faa24f22a5163ec6$var$pad(index + 1);
            $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ROLE, pagination ? "tabpanel" : "group");
            $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ARIA_ROLEDESCRIPTION, i18n.slide);
            $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ARIA_LABEL, label || $faa24f22a5163ec6$var$format(i18n.slideLabel, [
                index + 1,
                Splide2.length
            ]));
        }
        listen();
    }
    function listen() {
        bind(slide, "click", $faa24f22a5163ec6$var$apply(emit, $faa24f22a5163ec6$export$5adb665701eda1ce, self));
        bind(slide, "keydown", $faa24f22a5163ec6$var$apply(emit, $faa24f22a5163ec6$export$6d5af59619d10e6a, self));
        on([
            $faa24f22a5163ec6$export$fe5802204b967f0d,
            $faa24f22a5163ec6$export$f0af896383d5adff,
            $faa24f22a5163ec6$export$ff8164bff3202b9
        ], update);
        on($faa24f22a5163ec6$export$84015c33508f94ec, initNavigation);
        if (updateOnMove) on($faa24f22a5163ec6$export$2aa493d7c3275167, onMove);
    }
    function destroy() {
        destroyed = true;
        event.destroy();
        $faa24f22a5163ec6$var$removeClass(slide, $faa24f22a5163ec6$export$49f9eaea10ebf193);
        $faa24f22a5163ec6$var$removeAttribute(slide, $faa24f22a5163ec6$var$ALL_ATTRIBUTES);
        $faa24f22a5163ec6$var$setAttribute(slide, "style", styles);
        $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ARIA_LABEL, label || "");
    }
    function initNavigation() {
        var controls = Splide2.splides.map(function(target) {
            var Slide2 = target.splide.Components.Slides.getAt(index);
            return Slide2 ? Slide2.slide.id : "";
        }).join(" ");
        $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ARIA_LABEL, $faa24f22a5163ec6$var$format(i18n.slideX, (isClone ? slideIndex : index) + 1));
        $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ARIA_CONTROLS, controls);
        $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ROLE, slideFocus ? "button" : "");
        slideFocus && $faa24f22a5163ec6$var$removeAttribute(slide, $faa24f22a5163ec6$var$ARIA_ROLEDESCRIPTION);
    }
    function onMove() {
        if (!destroyed) update();
    }
    function update() {
        if (!destroyed) {
            var curr = Splide2.index;
            updateActivity();
            updateVisibility();
            $faa24f22a5163ec6$var$toggleClass(slide, $faa24f22a5163ec6$export$e423ac4972f5e196, index === curr - 1);
            $faa24f22a5163ec6$var$toggleClass(slide, $faa24f22a5163ec6$export$457a2d20827a2779, index === curr + 1);
        }
    }
    function updateActivity() {
        var active = isActive();
        if (active !== $faa24f22a5163ec6$var$hasClass(slide, $faa24f22a5163ec6$export$72d36ecf3758cb4b)) {
            $faa24f22a5163ec6$var$toggleClass(slide, $faa24f22a5163ec6$export$72d36ecf3758cb4b, active);
            $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ARIA_CURRENT, isNavigation && active || "");
            emit(active ? $faa24f22a5163ec6$export$92e3eae133acac4c : $faa24f22a5163ec6$export$6bcbb81035c12cea, self);
        }
    }
    function updateVisibility() {
        var visible = isVisible();
        var hidden = !visible && (!isActive() || isClone);
        if (!Splide2.state.is([
            $faa24f22a5163ec6$var$MOVING,
            $faa24f22a5163ec6$var$SCROLLING
        ])) $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ARIA_HIDDEN, hidden || "");
        $faa24f22a5163ec6$var$setAttribute($faa24f22a5163ec6$var$queryAll(slide, options.focusableNodes || ""), $faa24f22a5163ec6$var$TAB_INDEX, hidden ? -1 : "");
        if (slideFocus) $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$TAB_INDEX, hidden ? -1 : 0);
        if (visible !== $faa24f22a5163ec6$var$hasClass(slide, $faa24f22a5163ec6$export$53ca4621bbab9a)) {
            $faa24f22a5163ec6$var$toggleClass(slide, $faa24f22a5163ec6$export$53ca4621bbab9a, visible);
            emit(visible ? $faa24f22a5163ec6$export$6a5b3445e4066a53 : $faa24f22a5163ec6$export$8c5c7a21d54563e9, self);
        }
        if (!visible && document.activeElement === slide) {
            var Slide2 = Components.Slides.getAt(Splide2.index);
            Slide2 && $faa24f22a5163ec6$var$focus(Slide2.slide);
        }
    }
    function style$1(prop, value, useContainer) {
        $faa24f22a5163ec6$var$style(useContainer && container || slide, prop, value);
    }
    function isActive() {
        var curr = Splide2.index;
        return curr === index || options.cloneStatus && curr === slideIndex;
    }
    function isVisible() {
        if (Splide2.is($faa24f22a5163ec6$export$742b62a5690c060)) return isActive();
        var trackRect = $faa24f22a5163ec6$var$rect(Components.Elements.track);
        var slideRect = $faa24f22a5163ec6$var$rect(slide);
        var left = resolve("left", true);
        var right = resolve("right", true);
        return $faa24f22a5163ec6$var$floor(trackRect[left]) <= $faa24f22a5163ec6$var$ceil(slideRect[left]) && $faa24f22a5163ec6$var$floor(slideRect[right]) <= $faa24f22a5163ec6$var$ceil(trackRect[right]);
    }
    function isWithin(from, distance) {
        var diff = $faa24f22a5163ec6$var$abs(from - index);
        if (!isClone && (options.rewind || Splide2.is($faa24f22a5163ec6$export$f42383286ed1223d))) diff = $faa24f22a5163ec6$var$min(diff, Splide2.length - diff);
        return diff <= distance;
    }
    var self = {
        index: index,
        slideIndex: slideIndex,
        slide: slide,
        container: container,
        isClone: isClone,
        mount: mount,
        destroy: destroy,
        update: update,
        style: style$1,
        isWithin: isWithin
    };
    return self;
}
function $faa24f22a5163ec6$var$Slides(Splide2, Components2, options) {
    var _EventInterface2 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
    var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
    var Slides2 = [];
    function mount() {
        init();
        on($faa24f22a5163ec6$export$7f4701ac5e05e39f, destroy);
        on($faa24f22a5163ec6$export$7f4701ac5e05e39f, init);
    }
    function init() {
        slides.forEach(function(slide, index) {
            register(slide, index, -1);
        });
    }
    function destroy() {
        forEach$1(function(Slide2) {
            Slide2.destroy();
        });
        $faa24f22a5163ec6$var$empty(Slides2);
    }
    function update() {
        forEach$1(function(Slide2) {
            Slide2.update();
        });
    }
    function register(slide, index, slideIndex) {
        var object = $faa24f22a5163ec6$var$Slide$1(Splide2, index, slideIndex, slide);
        object.mount();
        Slides2.push(object);
        Slides2.sort(function(Slide1, Slide2) {
            return Slide1.index - Slide2.index;
        });
    }
    function get(excludeClones) {
        return excludeClones ? filter(function(Slide2) {
            return !Slide2.isClone;
        }) : Slides2;
    }
    function getIn(page) {
        var Controller = Components2.Controller;
        var index = Controller.toIndex(page);
        var max = Controller.hasFocus() ? 1 : options.perPage;
        return filter(function(Slide2) {
            return $faa24f22a5163ec6$var$between(Slide2.index, index, index + max - 1);
        });
    }
    function getAt(index) {
        return filter(index)[0];
    }
    function add(items, index) {
        $faa24f22a5163ec6$var$forEach(items, function(slide) {
            if ($faa24f22a5163ec6$var$isString(slide)) slide = $faa24f22a5163ec6$var$parseHtml(slide);
            if ($faa24f22a5163ec6$var$isHTMLElement(slide)) {
                var ref = slides[index];
                ref ? $faa24f22a5163ec6$var$before(slide, ref) : $faa24f22a5163ec6$var$append(list, slide);
                $faa24f22a5163ec6$var$addClass(slide, options.classes.slide);
                observeImages(slide, $faa24f22a5163ec6$var$apply(emit, $faa24f22a5163ec6$export$7e019dae5103a285));
            }
        });
        emit($faa24f22a5163ec6$export$7f4701ac5e05e39f);
    }
    function remove$1(matcher) {
        $faa24f22a5163ec6$var$remove(filter(matcher).map(function(Slide2) {
            return Slide2.slide;
        }));
        emit($faa24f22a5163ec6$export$7f4701ac5e05e39f);
    }
    function forEach$1(iteratee, excludeClones) {
        get(excludeClones).forEach(iteratee);
    }
    function filter(matcher) {
        return Slides2.filter($faa24f22a5163ec6$var$isFunction(matcher) ? matcher : function(Slide2) {
            return $faa24f22a5163ec6$var$isString(matcher) ? $faa24f22a5163ec6$var$matches(Slide2.slide, matcher) : $faa24f22a5163ec6$var$includes($faa24f22a5163ec6$var$toArray(matcher), Slide2.index);
        });
    }
    function style(prop, value, useContainer) {
        forEach$1(function(Slide2) {
            Slide2.style(prop, value, useContainer);
        });
    }
    function observeImages(elm, callback) {
        var images = $faa24f22a5163ec6$var$queryAll(elm, "img");
        var length = images.length;
        if (length) images.forEach(function(img) {
            bind(img, "load error", function() {
                if (!--length) callback();
            });
        });
        else callback();
    }
    function getLength(excludeClones) {
        return excludeClones ? slides.length : Slides2.length;
    }
    function isEnough() {
        return Slides2.length > options.perPage;
    }
    return {
        mount: mount,
        destroy: destroy,
        update: update,
        register: register,
        get: get,
        getIn: getIn,
        getAt: getAt,
        add: add,
        remove: remove$1,
        forEach: forEach$1,
        filter: filter,
        style: style,
        getLength: getLength,
        isEnough: isEnough
    };
}
function $faa24f22a5163ec6$var$Layout(Splide2, Components2, options) {
    var _EventInterface3 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
    var Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
    var getAt = Slides.getAt, styleSlides = Slides.style;
    var vertical;
    var rootRect;
    var overflow;
    function mount() {
        init();
        bind(window, "resize load", $faa24f22a5163ec6$export$efff0f5979573c99($faa24f22a5163ec6$var$apply(emit, $faa24f22a5163ec6$export$7e019dae5103a285)));
        on([
            $faa24f22a5163ec6$export$db40ab7c0855fa5c,
            $faa24f22a5163ec6$export$7f4701ac5e05e39f
        ], init);
        on($faa24f22a5163ec6$export$7e019dae5103a285, resize);
    }
    function init() {
        vertical = options.direction === $faa24f22a5163ec6$export$97170d9824b89709;
        $faa24f22a5163ec6$var$style(root, "maxWidth", $faa24f22a5163ec6$var$unit(options.width));
        $faa24f22a5163ec6$var$style(track, resolve("paddingLeft"), cssPadding(false));
        $faa24f22a5163ec6$var$style(track, resolve("paddingRight"), cssPadding(true));
        resize(true);
    }
    function resize(force) {
        var newRect = $faa24f22a5163ec6$var$rect(root);
        if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
            $faa24f22a5163ec6$var$style(track, "height", cssTrackHeight());
            styleSlides(resolve("marginRight"), $faa24f22a5163ec6$var$unit(options.gap));
            styleSlides("width", cssSlideWidth());
            styleSlides("height", cssSlideHeight(), true);
            rootRect = newRect;
            emit($faa24f22a5163ec6$export$d637eba1e9e28482);
            if (overflow !== (overflow = isOverflow())) {
                $faa24f22a5163ec6$var$toggleClass(root, $faa24f22a5163ec6$export$cd908cd1dd625e29, overflow);
                emit($faa24f22a5163ec6$export$6cbac5b662a31e1b, overflow);
            }
        }
    }
    function cssPadding(right) {
        var padding = options.padding;
        var prop = resolve(right ? "right" : "left");
        return padding && $faa24f22a5163ec6$var$unit(padding[prop] || ($faa24f22a5163ec6$var$isObject(padding) ? 0 : padding)) || "0px";
    }
    function cssTrackHeight() {
        var height = "";
        if (vertical) {
            height = cssHeight();
            $faa24f22a5163ec6$var$assert(height, "height or heightRatio is missing.");
            height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
        }
        return height;
    }
    function cssHeight() {
        return $faa24f22a5163ec6$var$unit(options.height || $faa24f22a5163ec6$var$rect(list).width * options.heightRatio);
    }
    function cssSlideWidth() {
        return options.autoWidth ? null : $faa24f22a5163ec6$var$unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
    }
    function cssSlideHeight() {
        return $faa24f22a5163ec6$var$unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
    }
    function cssSlideSize() {
        var gap = $faa24f22a5163ec6$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    }
    function listSize() {
        return $faa24f22a5163ec6$var$rect(list)[resolve("width")];
    }
    function slideSize(index, withoutGap) {
        var Slide = getAt(index || 0);
        return Slide ? $faa24f22a5163ec6$var$rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
    }
    function totalSize(index, withoutGap) {
        var Slide = getAt(index);
        if (Slide) {
            var right = $faa24f22a5163ec6$var$rect(Slide.slide)[resolve("right")];
            var left = $faa24f22a5163ec6$var$rect(list)[resolve("left")];
            return $faa24f22a5163ec6$var$abs(right - left) + (withoutGap ? 0 : getGap());
        }
        return 0;
    }
    function sliderSize(withoutGap) {
        return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
    }
    function getGap() {
        var Slide = getAt(0);
        return Slide && parseFloat($faa24f22a5163ec6$var$style(Slide.slide, resolve("marginRight"))) || 0;
    }
    function getPadding(right) {
        return parseFloat($faa24f22a5163ec6$var$style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
    }
    function isOverflow() {
        return Splide2.is($faa24f22a5163ec6$export$742b62a5690c060) || sliderSize(true) > listSize();
    }
    return {
        mount: mount,
        resize: resize,
        listSize: listSize,
        slideSize: slideSize,
        sliderSize: sliderSize,
        totalSize: totalSize,
        getPadding: getPadding,
        isOverflow: isOverflow
    };
}
var $faa24f22a5163ec6$var$MULTIPLIER = 2;
function $faa24f22a5163ec6$var$Clones(Splide2, Components2, options) {
    var event = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2);
    var on = event.on;
    var Elements = Components2.Elements, Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var clones = [];
    var cloneCount;
    function mount() {
        on($faa24f22a5163ec6$export$7f4701ac5e05e39f, remount);
        on([
            $faa24f22a5163ec6$export$db40ab7c0855fa5c,
            $faa24f22a5163ec6$export$7e019dae5103a285
        ], observe);
        if (cloneCount = computeCloneCount()) {
            generate(cloneCount);
            Components2.Layout.resize(true);
        }
    }
    function remount() {
        destroy();
        mount();
    }
    function destroy() {
        $faa24f22a5163ec6$var$remove(clones);
        $faa24f22a5163ec6$var$empty(clones);
        event.destroy();
    }
    function observe() {
        var count = computeCloneCount();
        if (cloneCount !== count) {
            if (cloneCount < count || !count) event.emit($faa24f22a5163ec6$export$7f4701ac5e05e39f);
        }
    }
    function generate(count) {
        var slides = Slides.get().slice();
        var length = slides.length;
        if (length) {
            while(slides.length < count)$faa24f22a5163ec6$var$push(slides, slides);
            $faa24f22a5163ec6$var$push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide, index) {
                var isHead = index < count;
                var clone = cloneDeep(Slide.slide, index);
                isHead ? $faa24f22a5163ec6$var$before(clone, slides[0].slide) : $faa24f22a5163ec6$var$append(Elements.list, clone);
                $faa24f22a5163ec6$var$push(clones, clone);
                Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
            });
        }
    }
    function cloneDeep(elm, index) {
        var clone = elm.cloneNode(true);
        $faa24f22a5163ec6$var$addClass(clone, options.classes.clone);
        clone.id = Splide2.root.id + "-clone" + $faa24f22a5163ec6$var$pad(index + 1);
        return clone;
    }
    function computeCloneCount() {
        var clones2 = options.clones;
        if (!Splide2.is($faa24f22a5163ec6$export$f42383286ed1223d)) clones2 = 0;
        else if ($faa24f22a5163ec6$var$isUndefined(clones2)) {
            var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
            var fixedCount = fixedSize && $faa24f22a5163ec6$var$ceil($faa24f22a5163ec6$var$rect(Elements.track)[resolve("width")] / fixedSize);
            clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * $faa24f22a5163ec6$var$MULTIPLIER;
        }
        return clones2;
    }
    return {
        mount: mount,
        destroy: destroy
    };
}
function $faa24f22a5163ec6$var$Move(Splide2, Components2, options) {
    var _EventInterface4 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
    var set = Splide2.state.set;
    var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
    var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
    var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
    var Transition;
    function mount() {
        Transition = Components2.Transition;
        on([
            $faa24f22a5163ec6$export$d300dc1a2634364b,
            $faa24f22a5163ec6$export$d637eba1e9e28482,
            $faa24f22a5163ec6$export$db40ab7c0855fa5c,
            $faa24f22a5163ec6$export$7f4701ac5e05e39f
        ], reposition);
    }
    function reposition() {
        if (!Components2.Controller.isBusy()) {
            Components2.Scroll.cancel();
            jump(Splide2.index);
            Components2.Slides.update();
        }
    }
    function move(dest, index, prev, callback) {
        if (dest !== index && canShift(dest > prev)) {
            cancel();
            translate(shift(getPosition(), dest > prev), true);
        }
        set($faa24f22a5163ec6$var$MOVING);
        emit($faa24f22a5163ec6$export$2aa493d7c3275167, index, prev, dest);
        Transition.start(index, function() {
            set($faa24f22a5163ec6$var$IDLE);
            emit($faa24f22a5163ec6$export$fe5802204b967f0d, index, prev, dest);
            callback && callback();
        });
    }
    function jump(index) {
        translate(toPosition(index, true));
    }
    function translate(position, preventLoop) {
        if (!Splide2.is($faa24f22a5163ec6$export$742b62a5690c060)) {
            var destination = preventLoop ? position : loop(position);
            $faa24f22a5163ec6$var$style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
            position !== destination && emit($faa24f22a5163ec6$export$f0af896383d5adff);
        }
    }
    function loop(position) {
        if (Splide2.is($faa24f22a5163ec6$export$f42383286ed1223d)) {
            var index = toIndex(position);
            var exceededMax = index > Components2.Controller.getEnd();
            var exceededMin = index < 0;
            if (exceededMin || exceededMax) position = shift(position, exceededMax);
        }
        return position;
    }
    function shift(position, backwards) {
        var excess = position - getLimit(backwards);
        var size = sliderSize();
        position -= orient(size * ($faa24f22a5163ec6$var$ceil($faa24f22a5163ec6$var$abs(excess) / size) || 1)) * (backwards ? 1 : -1);
        return position;
    }
    function cancel() {
        translate(getPosition(), true);
        Transition.cancel();
    }
    function toIndex(position) {
        var Slides = Components2.Slides.get();
        var index = 0;
        var minDistance = Infinity;
        for(var i = 0; i < Slides.length; i++){
            var slideIndex = Slides[i].index;
            var distance = $faa24f22a5163ec6$var$abs(toPosition(slideIndex, true) - position);
            if (distance <= minDistance) {
                minDistance = distance;
                index = slideIndex;
            } else break;
        }
        return index;
    }
    function toPosition(index, trimming) {
        var position = orient(totalSize(index - 1) - offset(index));
        return trimming ? trim(position) : position;
    }
    function getPosition() {
        var left = resolve("left");
        return $faa24f22a5163ec6$var$rect(list)[left] - $faa24f22a5163ec6$var$rect(track)[left] + orient(getPadding(false));
    }
    function trim(position) {
        if (options.trimSpace && Splide2.is($faa24f22a5163ec6$export$e5a58a5ee5b54c22)) position = $faa24f22a5163ec6$var$clamp(position, 0, orient(sliderSize(true) - listSize()));
        return position;
    }
    function offset(index) {
        var focus = options.focus;
        return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
    }
    function getLimit(max) {
        return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
    }
    function canShift(backwards) {
        var shifted = orient(shift(getPosition(), backwards));
        return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - $faa24f22a5163ec6$var$rect(track)[resolve("width")];
    }
    function exceededLimit(max, position) {
        position = $faa24f22a5163ec6$var$isUndefined(position) ? getPosition() : position;
        var exceededMin = max !== true && orient(position) < orient(getLimit(false));
        var exceededMax = max !== false && orient(position) > orient(getLimit(true));
        return exceededMin || exceededMax;
    }
    return {
        mount: mount,
        move: move,
        jump: jump,
        translate: translate,
        shift: shift,
        cancel: cancel,
        toIndex: toIndex,
        toPosition: toPosition,
        getPosition: getPosition,
        getLimit: getLimit,
        exceededLimit: exceededLimit,
        reposition: reposition
    };
}
function $faa24f22a5163ec6$var$Controller(Splide2, Components2, options) {
    var _EventInterface5 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, toPosition = Move.toPosition;
    var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
    var omitEnd = options.omitEnd;
    var isLoop = Splide2.is($faa24f22a5163ec6$export$f42383286ed1223d);
    var isSlide = Splide2.is($faa24f22a5163ec6$export$e5a58a5ee5b54c22);
    var getNext = $faa24f22a5163ec6$var$apply(getAdjacent, false);
    var getPrev = $faa24f22a5163ec6$var$apply(getAdjacent, true);
    var currIndex = options.start || 0;
    var endIndex;
    var prevIndex = currIndex;
    var slideCount;
    var perMove;
    var perPage;
    function mount() {
        init();
        on([
            $faa24f22a5163ec6$export$db40ab7c0855fa5c,
            $faa24f22a5163ec6$export$7f4701ac5e05e39f,
            $faa24f22a5163ec6$export$28dea85f216954dc
        ], init);
        on($faa24f22a5163ec6$export$d637eba1e9e28482, onResized);
    }
    function init() {
        slideCount = getLength(true);
        perMove = options.perMove;
        perPage = options.perPage;
        endIndex = getEnd();
        var index = $faa24f22a5163ec6$var$clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
        if (index !== currIndex) {
            currIndex = index;
            Move.reposition();
        }
    }
    function onResized() {
        if (endIndex !== getEnd()) emit($faa24f22a5163ec6$export$28dea85f216954dc);
    }
    function go(control, allowSameIndex, callback) {
        if (!isBusy()) {
            var dest = parse(control);
            var index = loop(dest);
            if (index > -1 && (allowSameIndex || index !== currIndex)) {
                setIndex(index);
                Move.move(dest, index, prevIndex, callback);
            }
        }
    }
    function scroll(destination, duration, snap, callback) {
        Components2.Scroll.scroll(destination, duration, snap, function() {
            var index = loop(Move.toIndex(getPosition()));
            setIndex(omitEnd ? $faa24f22a5163ec6$var$min(index, endIndex) : index);
            callback && callback();
        });
    }
    function parse(control) {
        var index = currIndex;
        if ($faa24f22a5163ec6$var$isString(control)) {
            var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
            if (indicator === "+" || indicator === "-") index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
            else if (indicator === ">") index = number ? toIndex(+number) : getNext(true);
            else if (indicator === "<") index = getPrev(true);
        } else index = isLoop ? control : $faa24f22a5163ec6$var$clamp(control, 0, endIndex);
        return index;
    }
    function getAdjacent(prev, destination) {
        var number = perMove || (hasFocus() ? 1 : perPage);
        var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
        if (dest === -1 && isSlide) {
            if (!$faa24f22a5163ec6$var$approximatelyEqual(getPosition(), getLimit(!prev), 1)) return prev ? 0 : endIndex;
        }
        return destination ? dest : loop(dest);
    }
    function computeDestIndex(dest, from, snapPage) {
        if (isEnough() || hasFocus()) {
            var index = computeMovableDestIndex(dest);
            if (index !== dest) {
                from = dest;
                dest = index;
                snapPage = false;
            }
            if (dest < 0 || dest > endIndex) {
                if (!perMove && ($faa24f22a5163ec6$var$between(0, dest, from, true) || $faa24f22a5163ec6$var$between(endIndex, from, dest, true))) dest = toIndex(toPage(dest));
                else {
                    if (isLoop) dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
                    else if (options.rewind) dest = dest < 0 ? endIndex : 0;
                    else dest = -1;
                }
            } else if (snapPage && dest !== from) dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        } else dest = -1;
        return dest;
    }
    function computeMovableDestIndex(dest) {
        if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
            var position = getPosition();
            while(position === toPosition(dest, true) && $faa24f22a5163ec6$var$between(dest, 0, Splide2.length - 1, !options.rewind))dest < currIndex ? --dest : ++dest;
        }
        return dest;
    }
    function loop(index) {
        return isLoop ? (index + slideCount) % slideCount || 0 : index;
    }
    function getEnd() {
        var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
        while(omitEnd && end-- > 0)if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
            end++;
            break;
        }
        return $faa24f22a5163ec6$var$clamp(end, 0, slideCount - 1);
    }
    function toIndex(page) {
        return $faa24f22a5163ec6$var$clamp(hasFocus() ? page : perPage * page, 0, endIndex);
    }
    function toPage(index) {
        return hasFocus() ? $faa24f22a5163ec6$var$min(index, endIndex) : $faa24f22a5163ec6$var$floor((index >= endIndex ? slideCount - 1 : index) / perPage);
    }
    function toDest(destination) {
        var closest = Move.toIndex(destination);
        return isSlide ? $faa24f22a5163ec6$var$clamp(closest, 0, endIndex) : closest;
    }
    function setIndex(index) {
        if (index !== currIndex) {
            prevIndex = currIndex;
            currIndex = index;
        }
    }
    function getIndex(prev) {
        return prev ? prevIndex : currIndex;
    }
    function hasFocus() {
        return !$faa24f22a5163ec6$var$isUndefined(options.focus) || options.isNavigation;
    }
    function isBusy() {
        return Splide2.state.is([
            $faa24f22a5163ec6$var$MOVING,
            $faa24f22a5163ec6$var$SCROLLING
        ]) && !!options.waitForTransition;
    }
    return {
        mount: mount,
        go: go,
        scroll: scroll,
        getNext: getNext,
        getPrev: getPrev,
        getAdjacent: getAdjacent,
        getEnd: getEnd,
        setIndex: setIndex,
        getIndex: getIndex,
        toIndex: toIndex,
        toPage: toPage,
        toDest: toDest,
        hasFocus: hasFocus,
        isBusy: isBusy
    };
}
var $faa24f22a5163ec6$var$XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var $faa24f22a5163ec6$var$PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var $faa24f22a5163ec6$var$SIZE = 40;
function $faa24f22a5163ec6$var$Arrows(Splide2, Components2, options) {
    var event = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2);
    var on = event.on, bind = event.bind, emit = event.emit;
    var classes = options.classes, i18n = options.i18n;
    var Elements = Components2.Elements, Controller = Components2.Controller;
    var placeholder = Elements.arrows, track = Elements.track;
    var wrapper = placeholder;
    var prev = Elements.prev;
    var next = Elements.next;
    var created;
    var wrapperClasses;
    var arrows = {};
    function mount() {
        init();
        on($faa24f22a5163ec6$export$db40ab7c0855fa5c, remount);
    }
    function remount() {
        destroy();
        mount();
    }
    function init() {
        var enabled = options.arrows;
        if (enabled && !(prev && next)) createArrows();
        if (prev && next) {
            $faa24f22a5163ec6$var$assign(arrows, {
                prev: prev,
                next: next
            });
            $faa24f22a5163ec6$var$display(wrapper, enabled ? "" : "none");
            $faa24f22a5163ec6$var$addClass(wrapper, wrapperClasses = $faa24f22a5163ec6$export$a26cbd955fecf11e + "--" + options.direction);
            if (enabled) {
                listen();
                update();
                $faa24f22a5163ec6$var$setAttribute([
                    prev,
                    next
                ], $faa24f22a5163ec6$var$ARIA_CONTROLS, track.id);
                emit($faa24f22a5163ec6$export$8647f6b043e04e9d, prev, next);
            }
        }
    }
    function destroy() {
        event.destroy();
        $faa24f22a5163ec6$var$removeClass(wrapper, wrapperClasses);
        if (created) {
            $faa24f22a5163ec6$var$remove(placeholder ? [
                prev,
                next
            ] : wrapper);
            prev = next = null;
        } else $faa24f22a5163ec6$var$removeAttribute([
            prev,
            next
        ], $faa24f22a5163ec6$var$ALL_ATTRIBUTES);
    }
    function listen() {
        on([
            $faa24f22a5163ec6$export$d300dc1a2634364b,
            $faa24f22a5163ec6$export$fe5802204b967f0d,
            $faa24f22a5163ec6$export$7f4701ac5e05e39f,
            $faa24f22a5163ec6$export$ff8164bff3202b9,
            $faa24f22a5163ec6$export$28dea85f216954dc
        ], update);
        bind(next, "click", $faa24f22a5163ec6$var$apply(go, ">"));
        bind(prev, "click", $faa24f22a5163ec6$var$apply(go, "<"));
    }
    function go(control) {
        Controller.go(control, true);
    }
    function createArrows() {
        wrapper = placeholder || $faa24f22a5163ec6$var$create("div", classes.arrows);
        prev = createArrow(true);
        next = createArrow(false);
        created = true;
        $faa24f22a5163ec6$var$append(wrapper, [
            prev,
            next
        ]);
        !placeholder && $faa24f22a5163ec6$var$before(wrapper, track);
    }
    function createArrow(prev2) {
        var arrow = "<button class=\"" + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + "\" type=\"button\"><svg xmlns=\"" + $faa24f22a5163ec6$var$XML_NAME_SPACE + "\" viewBox=\"0 0 " + $faa24f22a5163ec6$var$SIZE + " " + $faa24f22a5163ec6$var$SIZE + "\" width=\"" + $faa24f22a5163ec6$var$SIZE + "\" height=\"" + $faa24f22a5163ec6$var$SIZE + "\" focusable=\"false\"><path d=\"" + (options.arrowPath || $faa24f22a5163ec6$var$PATH) + "\" />";
        return $faa24f22a5163ec6$var$parseHtml(arrow);
    }
    function update() {
        if (prev && next) {
            var index = Splide2.index;
            var prevIndex = Controller.getPrev();
            var nextIndex = Controller.getNext();
            var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
            var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
            prev.disabled = prevIndex < 0;
            next.disabled = nextIndex < 0;
            $faa24f22a5163ec6$var$setAttribute(prev, $faa24f22a5163ec6$var$ARIA_LABEL, prevLabel);
            $faa24f22a5163ec6$var$setAttribute(next, $faa24f22a5163ec6$var$ARIA_LABEL, nextLabel);
            emit($faa24f22a5163ec6$export$d467f9343b961f75, prev, next, prevIndex, nextIndex);
        }
    }
    return {
        arrows: arrows,
        mount: mount,
        destroy: destroy,
        update: update
    };
}
var $faa24f22a5163ec6$var$INTERVAL_DATA_ATTRIBUTE = $faa24f22a5163ec6$var$DATA_ATTRIBUTE + "-interval";
function $faa24f22a5163ec6$var$Autoplay(Splide2, Components2, options) {
    var _EventInterface6 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
    var interval = $faa24f22a5163ec6$export$46ad21b25b6dccf0(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
    var isPaused = interval.isPaused;
    var Elements = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
    var autoplay = options.autoplay;
    var hovered;
    var focused;
    var stopped = autoplay === "pause";
    function mount() {
        if (autoplay) {
            listen();
            toggle && $faa24f22a5163ec6$var$setAttribute(toggle, $faa24f22a5163ec6$var$ARIA_CONTROLS, Elements.track.id);
            stopped || play();
            update();
        }
    }
    function listen() {
        if (options.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (options.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (toggle) bind(toggle, "click", function() {
            stopped ? play() : pause(true);
        });
        on([
            $faa24f22a5163ec6$export$2aa493d7c3275167,
            $faa24f22a5163ec6$export$49801896908b5e33,
            $faa24f22a5163ec6$export$7f4701ac5e05e39f
        ], interval.rewind);
        on($faa24f22a5163ec6$export$2aa493d7c3275167, onMove);
    }
    function play() {
        if (isPaused() && Components2.Slides.isEnough()) {
            interval.start(!options.resetProgress);
            focused = hovered = stopped = false;
            update();
            emit($faa24f22a5163ec6$export$23663268a31b79e2);
        }
    }
    function pause(stop) {
        if (stop === void 0) stop = true;
        stopped = !!stop;
        update();
        if (!isPaused()) {
            interval.pause();
            emit($faa24f22a5163ec6$export$16a1e4f3d0368265);
        }
    }
    function autoToggle() {
        if (!stopped) hovered || focused ? pause(false) : play();
    }
    function update() {
        if (toggle) {
            $faa24f22a5163ec6$var$toggleClass(toggle, $faa24f22a5163ec6$export$72d36ecf3758cb4b, !stopped);
            $faa24f22a5163ec6$var$setAttribute(toggle, $faa24f22a5163ec6$var$ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
        }
    }
    function onAnimationFrame(rate) {
        var bar = Elements.bar;
        bar && $faa24f22a5163ec6$var$style(bar, "width", rate * 100 + "%");
        emit($faa24f22a5163ec6$export$185723258309b608, rate);
    }
    function onMove(index) {
        var Slide = Components2.Slides.getAt(index);
        interval.set(Slide && +$faa24f22a5163ec6$var$getAttribute(Slide.slide, $faa24f22a5163ec6$var$INTERVAL_DATA_ATTRIBUTE) || options.interval);
    }
    return {
        mount: mount,
        destroy: interval.cancel,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}
function $faa24f22a5163ec6$var$Cover(Splide2, Components2, options) {
    var _EventInterface7 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface7.on;
    function mount() {
        if (options.cover) {
            on($faa24f22a5163ec6$export$9f64346e17f0ec8e, $faa24f22a5163ec6$var$apply(toggle, true));
            on([
                $faa24f22a5163ec6$export$d300dc1a2634364b,
                $faa24f22a5163ec6$export$db40ab7c0855fa5c,
                $faa24f22a5163ec6$export$7f4701ac5e05e39f
            ], $faa24f22a5163ec6$var$apply(cover, true));
        }
    }
    function cover(cover2) {
        Components2.Slides.forEach(function(Slide) {
            var img = $faa24f22a5163ec6$var$child(Slide.container || Slide.slide, "img");
            if (img && img.src) toggle(cover2, img, Slide);
        });
    }
    function toggle(cover2, img, Slide) {
        Slide.style("background", cover2 ? "center/cover no-repeat url(\"" + img.src + "\")" : "", true);
        $faa24f22a5163ec6$var$display(img, cover2 ? "none" : "");
    }
    return {
        mount: mount,
        destroy: $faa24f22a5163ec6$var$apply(cover, false)
    };
}
var $faa24f22a5163ec6$var$BOUNCE_DIFF_THRESHOLD = 10;
var $faa24f22a5163ec6$var$BOUNCE_DURATION = 600;
var $faa24f22a5163ec6$var$FRICTION_FACTOR = 0.6;
var $faa24f22a5163ec6$var$BASE_VELOCITY = 1.5;
var $faa24f22a5163ec6$var$MIN_DURATION = 800;
function $faa24f22a5163ec6$var$Scroll(Splide2, Components2, options) {
    var _EventInterface8 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
    var set = Splide2.state.set;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, exceededLimit = Move.exceededLimit, translate = Move.translate;
    var isSlide = Splide2.is($faa24f22a5163ec6$export$e5a58a5ee5b54c22);
    var interval;
    var callback;
    var friction = 1;
    function mount() {
        on($faa24f22a5163ec6$export$2aa493d7c3275167, clear);
        on([
            $faa24f22a5163ec6$export$db40ab7c0855fa5c,
            $faa24f22a5163ec6$export$7f4701ac5e05e39f
        ], cancel);
    }
    function scroll(destination, duration, snap, onScrolled, noConstrain) {
        var from = getPosition();
        clear();
        if (snap && (!isSlide || !exceededLimit())) {
            var size = Components2.Layout.sliderSize();
            var offset = $faa24f22a5163ec6$var$sign(destination) * size * $faa24f22a5163ec6$var$floor($faa24f22a5163ec6$var$abs(destination) / size) || 0;
            destination = Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
        }
        var noDistance = $faa24f22a5163ec6$var$approximatelyEqual(from, destination, 1);
        friction = 1;
        duration = noDistance ? 0 : duration || $faa24f22a5163ec6$var$max($faa24f22a5163ec6$var$abs(destination - from) / $faa24f22a5163ec6$var$BASE_VELOCITY, $faa24f22a5163ec6$var$MIN_DURATION);
        callback = onScrolled;
        interval = $faa24f22a5163ec6$export$46ad21b25b6dccf0(duration, onEnd, $faa24f22a5163ec6$var$apply(update, from, destination, noConstrain), 1);
        set($faa24f22a5163ec6$var$SCROLLING);
        emit($faa24f22a5163ec6$export$49801896908b5e33);
        interval.start();
    }
    function onEnd() {
        set($faa24f22a5163ec6$var$IDLE);
        callback && callback();
        emit($faa24f22a5163ec6$export$ff8164bff3202b9);
    }
    function update(from, to, noConstrain, rate) {
        var position = getPosition();
        var target = from + (to - from) * easing(rate);
        var diff = (target - position) * friction;
        translate(position + diff);
        if (isSlide && !noConstrain && exceededLimit()) {
            friction *= $faa24f22a5163ec6$var$FRICTION_FACTOR;
            if ($faa24f22a5163ec6$var$abs(diff) < $faa24f22a5163ec6$var$BOUNCE_DIFF_THRESHOLD) scroll(getLimit(exceededLimit(true)), $faa24f22a5163ec6$var$BOUNCE_DURATION, false, callback, true);
        }
    }
    function clear() {
        if (interval) interval.cancel();
    }
    function cancel() {
        if (interval && !interval.isPaused()) {
            clear();
            onEnd();
        }
    }
    function easing(t) {
        var easingFunc = options.easingFunc;
        return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
    }
    return {
        mount: mount,
        destroy: clear,
        scroll: scroll,
        cancel: cancel
    };
}
var $faa24f22a5163ec6$var$SCROLL_LISTENER_OPTIONS = {
    passive: false,
    capture: true
};
function $faa24f22a5163ec6$var$Drag(Splide2, Components2, options) {
    var _EventInterface9 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
    var state = Splide2.state;
    var Move = Components2.Move, Scroll = Components2.Scroll, Controller = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
    var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
    var getPosition = Move.getPosition, exceededLimit = Move.exceededLimit;
    var basePosition;
    var baseEvent;
    var prevBaseEvent;
    var isFree;
    var dragging;
    var exceeded = false;
    var clickPrevented;
    var disabled;
    var target;
    function mount() {
        bind(track, $faa24f22a5163ec6$var$POINTER_MOVE_EVENTS, $faa24f22a5163ec6$var$noop, $faa24f22a5163ec6$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $faa24f22a5163ec6$var$POINTER_UP_EVENTS, $faa24f22a5163ec6$var$noop, $faa24f22a5163ec6$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $faa24f22a5163ec6$var$POINTER_DOWN_EVENTS, onPointerDown, $faa24f22a5163ec6$var$SCROLL_LISTENER_OPTIONS);
        bind(track, "click", onClick, {
            capture: true
        });
        bind(track, "dragstart", $faa24f22a5163ec6$var$prevent);
        on([
            $faa24f22a5163ec6$export$d300dc1a2634364b,
            $faa24f22a5163ec6$export$db40ab7c0855fa5c
        ], init);
    }
    function init() {
        var drag = options.drag;
        disable(!drag);
        isFree = drag === "free";
    }
    function onPointerDown(e) {
        clickPrevented = false;
        if (!disabled) {
            var isTouch = isTouchEvent(e);
            if (isDraggable(e.target) && (isTouch || !e.button)) {
                if (!Controller.isBusy()) {
                    target = isTouch ? track : window;
                    dragging = state.is([
                        $faa24f22a5163ec6$var$MOVING,
                        $faa24f22a5163ec6$var$SCROLLING
                    ]);
                    prevBaseEvent = null;
                    bind(target, $faa24f22a5163ec6$var$POINTER_MOVE_EVENTS, onPointerMove, $faa24f22a5163ec6$var$SCROLL_LISTENER_OPTIONS);
                    bind(target, $faa24f22a5163ec6$var$POINTER_UP_EVENTS, onPointerUp, $faa24f22a5163ec6$var$SCROLL_LISTENER_OPTIONS);
                    Move.cancel();
                    Scroll.cancel();
                    save(e);
                } else $faa24f22a5163ec6$var$prevent(e, true);
            }
        }
    }
    function onPointerMove(e) {
        if (!state.is($faa24f22a5163ec6$var$DRAGGING)) {
            state.set($faa24f22a5163ec6$var$DRAGGING);
            emit($faa24f22a5163ec6$export$e84bf5065c9087ac);
        }
        if (e.cancelable) {
            if (dragging) {
                Move.translate(basePosition + constrain(diffCoord(e)));
                var expired = diffTime(e) > $faa24f22a5163ec6$var$LOG_INTERVAL;
                var hasExceeded = exceeded !== (exceeded = exceededLimit());
                if (expired || hasExceeded) save(e);
                clickPrevented = true;
                emit($faa24f22a5163ec6$export$8e9f636d2c722196);
                $faa24f22a5163ec6$var$prevent(e);
            } else if (isSliderDirection(e)) {
                dragging = shouldStart(e);
                $faa24f22a5163ec6$var$prevent(e);
            }
        }
    }
    function onPointerUp(e) {
        if (state.is($faa24f22a5163ec6$var$DRAGGING)) {
            state.set($faa24f22a5163ec6$var$IDLE);
            emit($faa24f22a5163ec6$export$90ea576bd3fdeb60);
        }
        if (dragging) {
            move(e);
            $faa24f22a5163ec6$var$prevent(e);
        }
        unbind(target, $faa24f22a5163ec6$var$POINTER_MOVE_EVENTS, onPointerMove);
        unbind(target, $faa24f22a5163ec6$var$POINTER_UP_EVENTS, onPointerUp);
        dragging = false;
    }
    function onClick(e) {
        if (!disabled && clickPrevented) $faa24f22a5163ec6$var$prevent(e, true);
    }
    function save(e) {
        prevBaseEvent = baseEvent;
        baseEvent = e;
        basePosition = getPosition();
    }
    function move(e) {
        var velocity = computeVelocity(e);
        var destination = computeDestination(velocity);
        var rewind = options.rewind && options.rewindByDrag;
        reduce(false);
        if (isFree) Controller.scroll(destination, 0, options.snap);
        else if (Splide2.is($faa24f22a5163ec6$export$742b62a5690c060)) Controller.go(orient($faa24f22a5163ec6$var$sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
        else if (Splide2.is($faa24f22a5163ec6$export$e5a58a5ee5b54c22) && exceeded && rewind) Controller.go(exceededLimit(true) ? ">" : "<");
        else Controller.go(Controller.toDest(destination), true);
        reduce(true);
    }
    function shouldStart(e) {
        var thresholds = options.dragMinThreshold;
        var isObj = $faa24f22a5163ec6$var$isObject(thresholds);
        var mouse = isObj && thresholds.mouse || 0;
        var touch = (isObj ? thresholds.touch : +thresholds) || 10;
        return $faa24f22a5163ec6$var$abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
    }
    function isSliderDirection(e) {
        return $faa24f22a5163ec6$var$abs(diffCoord(e)) > $faa24f22a5163ec6$var$abs(diffCoord(e, true));
    }
    function computeVelocity(e) {
        if (Splide2.is($faa24f22a5163ec6$export$f42383286ed1223d) || !exceeded) {
            var time = diffTime(e);
            if (time && time < $faa24f22a5163ec6$var$LOG_INTERVAL) return diffCoord(e) / time;
        }
        return 0;
    }
    function computeDestination(velocity) {
        return getPosition() + $faa24f22a5163ec6$var$sign(velocity) * $faa24f22a5163ec6$var$min($faa24f22a5163ec6$var$abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
    }
    function diffCoord(e, orthogonal) {
        return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
    }
    function diffTime(e) {
        return $faa24f22a5163ec6$var$timeOf(e) - $faa24f22a5163ec6$var$timeOf(getBaseEvent(e));
    }
    function getBaseEvent(e) {
        return baseEvent === e && prevBaseEvent || baseEvent;
    }
    function coordOf(e, orthogonal) {
        return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
    }
    function constrain(diff) {
        return diff / (exceeded && Splide2.is($faa24f22a5163ec6$export$e5a58a5ee5b54c22) ? $faa24f22a5163ec6$var$FRICTION : 1);
    }
    function isDraggable(target2) {
        var noDrag = options.noDrag;
        return !$faa24f22a5163ec6$var$matches(target2, "." + $faa24f22a5163ec6$export$52f2cca6a5eee805 + ", ." + $faa24f22a5163ec6$export$516e7d18e13a2dca) && (!noDrag || !$faa24f22a5163ec6$var$matches(target2, noDrag));
    }
    function isTouchEvent(e) {
        return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
    }
    function isDragging() {
        return dragging;
    }
    function disable(value) {
        disabled = value;
    }
    return {
        mount: mount,
        disable: disable,
        isDragging: isDragging
    };
}
var $faa24f22a5163ec6$var$NORMALIZATION_MAP = {
    Spacebar: " ",
    Right: $faa24f22a5163ec6$var$ARROW_RIGHT,
    Left: $faa24f22a5163ec6$var$ARROW_LEFT,
    Up: $faa24f22a5163ec6$var$ARROW_UP,
    Down: $faa24f22a5163ec6$var$ARROW_DOWN
};
function $faa24f22a5163ec6$var$normalizeKey(key) {
    key = $faa24f22a5163ec6$var$isString(key) ? key : key.key;
    return $faa24f22a5163ec6$var$NORMALIZATION_MAP[key] || key;
}
var $faa24f22a5163ec6$var$KEYBOARD_EVENT = "keydown";
function $faa24f22a5163ec6$var$Keyboard(Splide2, Components2, options) {
    var _EventInterface10 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
    var root = Splide2.root;
    var resolve = Components2.Direction.resolve;
    var target;
    var disabled;
    function mount() {
        init();
        on($faa24f22a5163ec6$export$db40ab7c0855fa5c, destroy);
        on($faa24f22a5163ec6$export$db40ab7c0855fa5c, init);
        on($faa24f22a5163ec6$export$2aa493d7c3275167, onMove);
    }
    function init() {
        var keyboard = options.keyboard;
        if (keyboard) {
            target = keyboard === "global" ? window : root;
            bind(target, $faa24f22a5163ec6$var$KEYBOARD_EVENT, onKeydown);
        }
    }
    function destroy() {
        unbind(target, $faa24f22a5163ec6$var$KEYBOARD_EVENT);
    }
    function disable(value) {
        disabled = value;
    }
    function onMove() {
        var _disabled = disabled;
        disabled = true;
        $faa24f22a5163ec6$var$nextTick(function() {
            disabled = _disabled;
        });
    }
    function onKeydown(e) {
        if (!disabled) {
            var key = $faa24f22a5163ec6$var$normalizeKey(e);
            if (key === resolve($faa24f22a5163ec6$var$ARROW_LEFT)) Splide2.go("<");
            else if (key === resolve($faa24f22a5163ec6$var$ARROW_RIGHT)) Splide2.go(">");
        }
    }
    return {
        mount: mount,
        destroy: destroy,
        disable: disable
    };
}
var $faa24f22a5163ec6$var$SRC_DATA_ATTRIBUTE = $faa24f22a5163ec6$var$DATA_ATTRIBUTE + "-lazy";
var $faa24f22a5163ec6$var$SRCSET_DATA_ATTRIBUTE = $faa24f22a5163ec6$var$SRC_DATA_ATTRIBUTE + "-srcset";
var $faa24f22a5163ec6$var$IMAGE_SELECTOR = "[" + $faa24f22a5163ec6$var$SRC_DATA_ATTRIBUTE + "], [" + $faa24f22a5163ec6$var$SRCSET_DATA_ATTRIBUTE + "]";
function $faa24f22a5163ec6$var$LazyLoad(Splide2, Components2, options) {
    var _EventInterface11 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
    var isSequential = options.lazyLoad === "sequential";
    var events = [
        $faa24f22a5163ec6$export$fe5802204b967f0d,
        $faa24f22a5163ec6$export$ff8164bff3202b9
    ];
    var entries = [];
    function mount() {
        if (options.lazyLoad) {
            init();
            on($faa24f22a5163ec6$export$7f4701ac5e05e39f, init);
        }
    }
    function init() {
        $faa24f22a5163ec6$var$empty(entries);
        register();
        if (isSequential) loadNext();
        else {
            off(events);
            on(events, check);
            check();
        }
    }
    function register() {
        Components2.Slides.forEach(function(Slide) {
            $faa24f22a5163ec6$var$queryAll(Slide.slide, $faa24f22a5163ec6$var$IMAGE_SELECTOR).forEach(function(img) {
                var src = $faa24f22a5163ec6$var$getAttribute(img, $faa24f22a5163ec6$var$SRC_DATA_ATTRIBUTE);
                var srcset = $faa24f22a5163ec6$var$getAttribute(img, $faa24f22a5163ec6$var$SRCSET_DATA_ATTRIBUTE);
                if (src !== img.src || srcset !== img.srcset) {
                    var className = options.classes.spinner;
                    var parent = img.parentElement;
                    var spinner = $faa24f22a5163ec6$var$child(parent, "." + className) || $faa24f22a5163ec6$var$create("span", className, parent);
                    entries.push([
                        img,
                        Slide,
                        spinner
                    ]);
                    img.src || $faa24f22a5163ec6$var$display(img, "none");
                }
            });
        });
    }
    function check() {
        entries = entries.filter(function(data) {
            var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
            return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
        });
        entries.length || off(events);
    }
    function load(data) {
        var img = data[0];
        $faa24f22a5163ec6$var$addClass(data[1].slide, $faa24f22a5163ec6$export$d22ec4ccb7996ba2);
        bind(img, "load error", $faa24f22a5163ec6$var$apply(onLoad, data));
        $faa24f22a5163ec6$var$setAttribute(img, "src", $faa24f22a5163ec6$var$getAttribute(img, $faa24f22a5163ec6$var$SRC_DATA_ATTRIBUTE));
        $faa24f22a5163ec6$var$setAttribute(img, "srcset", $faa24f22a5163ec6$var$getAttribute(img, $faa24f22a5163ec6$var$SRCSET_DATA_ATTRIBUTE));
        $faa24f22a5163ec6$var$removeAttribute(img, $faa24f22a5163ec6$var$SRC_DATA_ATTRIBUTE);
        $faa24f22a5163ec6$var$removeAttribute(img, $faa24f22a5163ec6$var$SRCSET_DATA_ATTRIBUTE);
    }
    function onLoad(data, e) {
        var img = data[0], Slide = data[1];
        $faa24f22a5163ec6$var$removeClass(Slide.slide, $faa24f22a5163ec6$export$d22ec4ccb7996ba2);
        if (e.type !== "error") {
            $faa24f22a5163ec6$var$remove(data[2]);
            $faa24f22a5163ec6$var$display(img, "");
            emit($faa24f22a5163ec6$export$9f64346e17f0ec8e, img, Slide);
            emit($faa24f22a5163ec6$export$7e019dae5103a285);
        }
        isSequential && loadNext();
    }
    function loadNext() {
        entries.length && load(entries.shift());
    }
    return {
        mount: mount,
        destroy: $faa24f22a5163ec6$var$apply($faa24f22a5163ec6$var$empty, entries),
        check: check
    };
}
function $faa24f22a5163ec6$var$Pagination(Splide2, Components2, options) {
    var event = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Slides = Components2.Slides, Elements = Components2.Elements, Controller = Components2.Controller;
    var hasFocus = Controller.hasFocus, getIndex = Controller.getIndex, go = Controller.go;
    var resolve = Components2.Direction.resolve;
    var placeholder = Elements.pagination;
    var items = [];
    var list;
    var paginationClasses;
    function mount() {
        destroy();
        on([
            $faa24f22a5163ec6$export$db40ab7c0855fa5c,
            $faa24f22a5163ec6$export$7f4701ac5e05e39f,
            $faa24f22a5163ec6$export$28dea85f216954dc
        ], mount);
        var enabled = options.pagination;
        placeholder && $faa24f22a5163ec6$var$display(placeholder, enabled ? "" : "none");
        if (enabled) {
            on([
                $faa24f22a5163ec6$export$2aa493d7c3275167,
                $faa24f22a5163ec6$export$49801896908b5e33,
                $faa24f22a5163ec6$export$ff8164bff3202b9
            ], update);
            createPagination();
            update();
            emit($faa24f22a5163ec6$export$bf89a4e4349c9778, {
                list: list,
                items: items
            }, getAt(Splide2.index));
        }
    }
    function destroy() {
        if (list) {
            $faa24f22a5163ec6$var$remove(placeholder ? $faa24f22a5163ec6$var$slice(list.children) : list);
            $faa24f22a5163ec6$var$removeClass(list, paginationClasses);
            $faa24f22a5163ec6$var$empty(items);
            list = null;
        }
        event.destroy();
    }
    function createPagination() {
        var length = Splide2.length;
        var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
        var max = hasFocus() ? Controller.getEnd() + 1 : $faa24f22a5163ec6$var$ceil(length / perPage);
        list = placeholder || $faa24f22a5163ec6$var$create("ul", classes.pagination, Elements.track.parentElement);
        $faa24f22a5163ec6$var$addClass(list, paginationClasses = $faa24f22a5163ec6$export$cbf8e5a0ab95eda3 + "--" + getDirection());
        $faa24f22a5163ec6$var$setAttribute(list, $faa24f22a5163ec6$var$ROLE, "tablist");
        $faa24f22a5163ec6$var$setAttribute(list, $faa24f22a5163ec6$var$ARIA_LABEL, i18n.select);
        $faa24f22a5163ec6$var$setAttribute(list, $faa24f22a5163ec6$var$ARIA_ORIENTATION, getDirection() === $faa24f22a5163ec6$export$97170d9824b89709 ? "vertical" : "");
        for(var i = 0; i < max; i++){
            var li = $faa24f22a5163ec6$var$create("li", null, list);
            var button = $faa24f22a5163ec6$var$create("button", {
                class: classes.page,
                type: "button"
            }, li);
            var controls = Slides.getIn(i).map(function(Slide) {
                return Slide.slide.id;
            });
            var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
            bind(button, "click", $faa24f22a5163ec6$var$apply(onClick, i));
            if (options.paginationKeyboard) bind(button, "keydown", $faa24f22a5163ec6$var$apply(onKeydown, i));
            $faa24f22a5163ec6$var$setAttribute(li, $faa24f22a5163ec6$var$ROLE, "presentation");
            $faa24f22a5163ec6$var$setAttribute(button, $faa24f22a5163ec6$var$ROLE, "tab");
            $faa24f22a5163ec6$var$setAttribute(button, $faa24f22a5163ec6$var$ARIA_CONTROLS, controls.join(" "));
            $faa24f22a5163ec6$var$setAttribute(button, $faa24f22a5163ec6$var$ARIA_LABEL, $faa24f22a5163ec6$var$format(text, i + 1));
            $faa24f22a5163ec6$var$setAttribute(button, $faa24f22a5163ec6$var$TAB_INDEX, -1);
            items.push({
                li: li,
                button: button,
                page: i
            });
        }
    }
    function onClick(page) {
        go(">" + page, true);
    }
    function onKeydown(page, e) {
        var length = items.length;
        var key = $faa24f22a5163ec6$var$normalizeKey(e);
        var dir = getDirection();
        var nextPage = -1;
        if (key === resolve($faa24f22a5163ec6$var$ARROW_RIGHT, false, dir)) nextPage = ++page % length;
        else if (key === resolve($faa24f22a5163ec6$var$ARROW_LEFT, false, dir)) nextPage = (--page + length) % length;
        else if (key === "Home") nextPage = 0;
        else if (key === "End") nextPage = length - 1;
        var item = items[nextPage];
        if (item) {
            $faa24f22a5163ec6$var$focus(item.button);
            go(">" + nextPage);
            $faa24f22a5163ec6$var$prevent(e, true);
        }
    }
    function getDirection() {
        return options.paginationDirection || options.direction;
    }
    function getAt(index) {
        return items[Controller.toPage(index)];
    }
    function update() {
        var prev = getAt(getIndex(true));
        var curr = getAt(getIndex());
        if (prev) {
            var button = prev.button;
            $faa24f22a5163ec6$var$removeClass(button, $faa24f22a5163ec6$export$72d36ecf3758cb4b);
            $faa24f22a5163ec6$var$removeAttribute(button, $faa24f22a5163ec6$var$ARIA_SELECTED);
            $faa24f22a5163ec6$var$setAttribute(button, $faa24f22a5163ec6$var$TAB_INDEX, -1);
        }
        if (curr) {
            var _button = curr.button;
            $faa24f22a5163ec6$var$addClass(_button, $faa24f22a5163ec6$export$72d36ecf3758cb4b);
            $faa24f22a5163ec6$var$setAttribute(_button, $faa24f22a5163ec6$var$ARIA_SELECTED, true);
            $faa24f22a5163ec6$var$setAttribute(_button, $faa24f22a5163ec6$var$TAB_INDEX, "");
        }
        emit($faa24f22a5163ec6$export$eb2019082ed6de0b, {
            list: list,
            items: items
        }, prev, curr);
    }
    return {
        items: items,
        mount: mount,
        destroy: destroy,
        getAt: getAt,
        update: update
    };
}
var $faa24f22a5163ec6$var$TRIGGER_KEYS = [
    " ",
    "Enter"
];
function $faa24f22a5163ec6$var$Sync(Splide2, Components2, options) {
    var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
    var events = [];
    function mount() {
        Splide2.splides.forEach(function(target) {
            if (!target.isParent) {
                sync(Splide2, target.splide);
                sync(target.splide, Splide2);
            }
        });
        if (isNavigation) navigate();
    }
    function destroy() {
        events.forEach(function(event) {
            event.destroy();
        });
        $faa24f22a5163ec6$var$empty(events);
    }
    function remount() {
        destroy();
        mount();
    }
    function sync(splide, target) {
        var event = $faa24f22a5163ec6$export$f188226459c8a3ff(splide);
        event.on($faa24f22a5163ec6$export$2aa493d7c3275167, function(index, prev, dest) {
            target.go(target.is($faa24f22a5163ec6$export$f42383286ed1223d) ? dest : index);
        });
        events.push(event);
    }
    function navigate() {
        var event = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2);
        var on = event.on;
        on($faa24f22a5163ec6$export$5adb665701eda1ce, onClick);
        on($faa24f22a5163ec6$export$6d5af59619d10e6a, onKeydown);
        on([
            $faa24f22a5163ec6$export$d300dc1a2634364b,
            $faa24f22a5163ec6$export$db40ab7c0855fa5c
        ], update);
        events.push(event);
        event.emit($faa24f22a5163ec6$export$84015c33508f94ec, Splide2.splides);
    }
    function update() {
        $faa24f22a5163ec6$var$setAttribute(Components2.Elements.list, $faa24f22a5163ec6$var$ARIA_ORIENTATION, options.direction === $faa24f22a5163ec6$export$97170d9824b89709 ? "vertical" : "");
    }
    function onClick(Slide) {
        Splide2.go(Slide.index);
    }
    function onKeydown(Slide, e) {
        if ($faa24f22a5163ec6$var$includes($faa24f22a5163ec6$var$TRIGGER_KEYS, $faa24f22a5163ec6$var$normalizeKey(e))) {
            onClick(Slide);
            $faa24f22a5163ec6$var$prevent(e);
        }
    }
    return {
        setup: $faa24f22a5163ec6$var$apply(Components2.Media.set, {
            slideFocus: $faa24f22a5163ec6$var$isUndefined(slideFocus) ? isNavigation : slideFocus
        }, true),
        mount: mount,
        destroy: destroy,
        remount: remount
    };
}
function $faa24f22a5163ec6$var$Wheel(Splide2, Components2, options) {
    var _EventInterface12 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), bind = _EventInterface12.bind;
    var lastTime = 0;
    function mount() {
        if (options.wheel) bind(Components2.Elements.track, "wheel", onWheel, $faa24f22a5163ec6$var$SCROLL_LISTENER_OPTIONS);
    }
    function onWheel(e) {
        if (e.cancelable) {
            var deltaY = e.deltaY;
            var backwards = deltaY < 0;
            var timeStamp = $faa24f22a5163ec6$var$timeOf(e);
            var _min = options.wheelMinThreshold || 0;
            var sleep = options.wheelSleep || 0;
            if ($faa24f22a5163ec6$var$abs(deltaY) > _min && timeStamp - lastTime > sleep) {
                Splide2.go(backwards ? "<" : ">");
                lastTime = timeStamp;
            }
            shouldPrevent(backwards) && $faa24f22a5163ec6$var$prevent(e);
        }
    }
    function shouldPrevent(backwards) {
        return !options.releaseWheel || Splide2.state.is($faa24f22a5163ec6$var$MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
    }
    return {
        mount: mount
    };
}
var $faa24f22a5163ec6$var$SR_REMOVAL_DELAY = 90;
function $faa24f22a5163ec6$var$Live(Splide2, Components2, options) {
    var _EventInterface13 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface13.on;
    var track = Components2.Elements.track;
    var enabled = options.live && !options.isNavigation;
    var sr = $faa24f22a5163ec6$var$create("span", $faa24f22a5163ec6$export$bb78d7c200da8960);
    var interval = $faa24f22a5163ec6$export$46ad21b25b6dccf0($faa24f22a5163ec6$var$SR_REMOVAL_DELAY, $faa24f22a5163ec6$var$apply(toggle, false));
    function mount() {
        if (enabled) {
            disable(!Components2.Autoplay.isPaused());
            $faa24f22a5163ec6$var$setAttribute(track, $faa24f22a5163ec6$var$ARIA_ATOMIC, true);
            sr.textContent = "\u2026";
            on($faa24f22a5163ec6$export$23663268a31b79e2, $faa24f22a5163ec6$var$apply(disable, true));
            on($faa24f22a5163ec6$export$16a1e4f3d0368265, $faa24f22a5163ec6$var$apply(disable, false));
            on([
                $faa24f22a5163ec6$export$fe5802204b967f0d,
                $faa24f22a5163ec6$export$ff8164bff3202b9
            ], $faa24f22a5163ec6$var$apply(toggle, true));
        }
    }
    function toggle(active) {
        $faa24f22a5163ec6$var$setAttribute(track, $faa24f22a5163ec6$var$ARIA_BUSY, active);
        if (active) {
            $faa24f22a5163ec6$var$append(track, sr);
            interval.start();
        } else {
            $faa24f22a5163ec6$var$remove(sr);
            interval.cancel();
        }
    }
    function destroy() {
        $faa24f22a5163ec6$var$removeAttribute(track, [
            $faa24f22a5163ec6$var$ARIA_LIVE,
            $faa24f22a5163ec6$var$ARIA_ATOMIC,
            $faa24f22a5163ec6$var$ARIA_BUSY
        ]);
        $faa24f22a5163ec6$var$remove(sr);
    }
    function disable(disabled) {
        if (enabled) $faa24f22a5163ec6$var$setAttribute(track, $faa24f22a5163ec6$var$ARIA_LIVE, disabled ? "off" : "polite");
    }
    return {
        mount: mount,
        disable: disable,
        destroy: destroy
    };
}
var $faa24f22a5163ec6$var$ComponentConstructors = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Media: $faa24f22a5163ec6$var$Media,
    Direction: $faa24f22a5163ec6$var$Direction,
    Elements: $faa24f22a5163ec6$var$Elements,
    Slides: $faa24f22a5163ec6$var$Slides,
    Layout: $faa24f22a5163ec6$var$Layout,
    Clones: $faa24f22a5163ec6$var$Clones,
    Move: $faa24f22a5163ec6$var$Move,
    Controller: $faa24f22a5163ec6$var$Controller,
    Arrows: $faa24f22a5163ec6$var$Arrows,
    Autoplay: $faa24f22a5163ec6$var$Autoplay,
    Cover: $faa24f22a5163ec6$var$Cover,
    Scroll: $faa24f22a5163ec6$var$Scroll,
    Drag: $faa24f22a5163ec6$var$Drag,
    Keyboard: $faa24f22a5163ec6$var$Keyboard,
    LazyLoad: $faa24f22a5163ec6$var$LazyLoad,
    Pagination: $faa24f22a5163ec6$var$Pagination,
    Sync: $faa24f22a5163ec6$var$Sync,
    Wheel: $faa24f22a5163ec6$var$Wheel,
    Live: $faa24f22a5163ec6$var$Live
});
var $faa24f22a5163ec6$var$I18N = {
    prev: "Previous slide",
    next: "Next slide",
    first: "Go to first slide",
    last: "Go to last slide",
    slideX: "Go to slide %s",
    pageX: "Go to page %s",
    play: "Start autoplay",
    pause: "Pause autoplay",
    carousel: "carousel",
    slide: "slide",
    select: "Select a slide to show",
    slideLabel: "%s of %s"
};
var $faa24f22a5163ec6$export$f484e977a69c6ba6 = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: true,
    arrows: true,
    pagination: true,
    paginationKeyboard: true,
    interval: 5e3,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: true,
    direction: "ltr",
    trimSpace: true,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: true,
    classes: $faa24f22a5163ec6$export$ba41d43e4a419565,
    i18n: $faa24f22a5163ec6$var$I18N,
    reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
    }
};
function $faa24f22a5163ec6$var$Fade(Splide2, Components2, options) {
    var Slides = Components2.Slides;
    function mount() {
        $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2).on([
            $faa24f22a5163ec6$export$d300dc1a2634364b,
            $faa24f22a5163ec6$export$7f4701ac5e05e39f
        ], init);
    }
    function init() {
        Slides.forEach(function(Slide) {
            Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
        });
    }
    function start(index, done) {
        Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
        $faa24f22a5163ec6$var$nextTick(done);
    }
    return {
        mount: mount,
        start: start,
        cancel: $faa24f22a5163ec6$var$noop
    };
}
function $faa24f22a5163ec6$var$Slide(Splide2, Components2, options) {
    var Move = Components2.Move, Controller = Components2.Controller, Scroll = Components2.Scroll;
    var list = Components2.Elements.list;
    var transition = $faa24f22a5163ec6$var$apply($faa24f22a5163ec6$var$style, list, "transition");
    var endCallback;
    function mount() {
        $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2).bind(list, "transitionend", function(e) {
            if (e.target === list && endCallback) {
                cancel();
                endCallback();
            }
        });
    }
    function start(index, done) {
        var destination = Move.toPosition(index, true);
        var position = Move.getPosition();
        var speed = getSpeed(index);
        if ($faa24f22a5163ec6$var$abs(destination - position) >= 1 && speed >= 1) {
            if (options.useScroll) Scroll.scroll(destination, speed, false, done);
            else {
                transition("transform " + speed + "ms " + options.easing);
                Move.translate(destination, true);
                endCallback = done;
            }
        } else {
            Move.jump(index);
            done();
        }
    }
    function cancel() {
        transition("");
        Scroll.cancel();
    }
    function getSpeed(index) {
        var rewindSpeed = options.rewindSpeed;
        if (Splide2.is($faa24f22a5163ec6$export$e5a58a5ee5b54c22) && rewindSpeed) {
            var prev = Controller.getIndex(true);
            var end = Controller.getEnd();
            if (prev === 0 && index >= end || prev >= end && index === 0) return rewindSpeed;
        }
        return options.speed;
    }
    return {
        mount: mount,
        start: start,
        cancel: cancel
    };
}
var $faa24f22a5163ec6$var$_Splide = /*#__PURE__*/ function() {
    function _Splide(target, options) {
        this.event = $faa24f22a5163ec6$export$f188226459c8a3ff();
        this.Components = {};
        this.state = $faa24f22a5163ec6$export$7254cc27399e90bd($faa24f22a5163ec6$var$CREATED);
        this.splides = [];
        this._o = {};
        this._E = {};
        var root = $faa24f22a5163ec6$var$isString(target) ? $faa24f22a5163ec6$var$query(document, target) : target;
        $faa24f22a5163ec6$var$assert(root, root + " is invalid.");
        this.root = root;
        options = $faa24f22a5163ec6$var$merge({
            label: $faa24f22a5163ec6$var$getAttribute(root, $faa24f22a5163ec6$var$ARIA_LABEL) || "",
            labelledby: $faa24f22a5163ec6$var$getAttribute(root, $faa24f22a5163ec6$var$ARIA_LABELLEDBY) || ""
        }, $faa24f22a5163ec6$export$f484e977a69c6ba6, _Splide.defaults, options || {});
        try {
            $faa24f22a5163ec6$var$merge(options, JSON.parse($faa24f22a5163ec6$var$getAttribute(root, $faa24f22a5163ec6$var$DATA_ATTRIBUTE)));
        } catch (e) {
            $faa24f22a5163ec6$var$assert(false, "Invalid JSON");
        }
        this._o = Object.create($faa24f22a5163ec6$var$merge({}, options));
    }
    var _proto = _Splide.prototype;
    _proto.mount = function mount(Extensions, Transition) {
        var _this = this;
        var state = this.state, Components2 = this.Components;
        $faa24f22a5163ec6$var$assert(state.is([
            $faa24f22a5163ec6$var$CREATED,
            $faa24f22a5163ec6$var$DESTROYED
        ]), "Already mounted!");
        state.set($faa24f22a5163ec6$var$CREATED);
        this._C = Components2;
        this._T = Transition || this._T || (this.is($faa24f22a5163ec6$export$742b62a5690c060) ? $faa24f22a5163ec6$var$Fade : $faa24f22a5163ec6$var$Slide);
        this._E = Extensions || this._E;
        var Constructors = $faa24f22a5163ec6$var$assign({}, $faa24f22a5163ec6$var$ComponentConstructors, this._E, {
            Transition: this._T
        });
        $faa24f22a5163ec6$var$forOwn(Constructors, function(Component, key) {
            var component = Component(_this, Components2, _this._o);
            Components2[key] = component;
            component.setup && component.setup();
        });
        $faa24f22a5163ec6$var$forOwn(Components2, function(component) {
            component.mount && component.mount();
        });
        this.emit($faa24f22a5163ec6$export$d300dc1a2634364b);
        $faa24f22a5163ec6$var$addClass(this.root, $faa24f22a5163ec6$export$7761661e2d5b9388);
        state.set($faa24f22a5163ec6$var$IDLE);
        this.emit($faa24f22a5163ec6$export$d8dac49b4532735a);
        return this;
    };
    _proto.sync = function sync(splide) {
        this.splides.push({
            splide: splide
        });
        splide.splides.push({
            splide: this,
            isParent: true
        });
        if (this.state.is($faa24f22a5163ec6$var$IDLE)) {
            this._C.Sync.remount();
            splide.Components.Sync.remount();
        }
        return this;
    };
    _proto.go = function go(control) {
        this._C.Controller.go(control);
        return this;
    };
    _proto.on = function on(events, callback) {
        this.event.on(events, callback);
        return this;
    };
    _proto.off = function off(events) {
        this.event.off(events);
        return this;
    };
    _proto.emit = function emit(event) {
        var _this$event;
        (_this$event = this.event).emit.apply(_this$event, [
            event
        ].concat($faa24f22a5163ec6$var$slice(arguments, 1)));
        return this;
    };
    _proto.add = function add(slides, index) {
        this._C.Slides.add(slides, index);
        return this;
    };
    _proto.remove = function remove(matcher) {
        this._C.Slides.remove(matcher);
        return this;
    };
    _proto.is = function is(type) {
        return this._o.type === type;
    };
    _proto.refresh = function refresh() {
        this.emit($faa24f22a5163ec6$export$7f4701ac5e05e39f);
        return this;
    };
    _proto.destroy = function destroy(completely) {
        if (completely === void 0) completely = true;
        var event = this.event, state = this.state;
        if (state.is($faa24f22a5163ec6$var$CREATED)) $faa24f22a5163ec6$export$f188226459c8a3ff(this).on($faa24f22a5163ec6$export$d8dac49b4532735a, this.destroy.bind(this, completely));
        else {
            $faa24f22a5163ec6$var$forOwn(this._C, function(component) {
                component.destroy && component.destroy(completely);
            }, true);
            event.emit($faa24f22a5163ec6$export$88c4cf7419e470cd);
            event.destroy();
            completely && $faa24f22a5163ec6$var$empty(this.splides);
            state.set($faa24f22a5163ec6$var$DESTROYED);
        }
        return this;
    };
    $faa24f22a5163ec6$var$_createClass(_Splide, [
        {
            key: "options",
            get: function get() {
                return this._o;
            },
            set: function set(options) {
                this._C.Media.set(options, true, true);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._C.Slides.getLength(true);
            }
        },
        {
            key: "index",
            get: function get() {
                return this._C.Controller.getIndex();
            }
        }
    ]);
    return _Splide;
}();
var $faa24f22a5163ec6$export$24494c7438c070bf = $faa24f22a5163ec6$var$_Splide;
$faa24f22a5163ec6$export$24494c7438c070bf.defaults = {};
$faa24f22a5163ec6$export$24494c7438c070bf.STATES = $faa24f22a5163ec6$var$STATES;
var $faa24f22a5163ec6$var$CLASS_RENDERED = "is-rendered";
var $faa24f22a5163ec6$var$RENDERER_DEFAULT_CONFIG = {
    listTag: "ul",
    slideTag: "li"
};
var $faa24f22a5163ec6$var$Style = /*#__PURE__*/ function() {
    function Style(id, options) {
        this.styles = {};
        this.id = id;
        this.options = options;
    }
    var _proto2 = Style.prototype;
    _proto2.rule = function rule(selector, prop, value, breakpoint) {
        breakpoint = breakpoint || "default";
        var selectors = this.styles[breakpoint] = this.styles[breakpoint] || {};
        var styles = selectors[selector] = selectors[selector] || {};
        styles[prop] = value;
    };
    _proto2.build = function build() {
        var _this2 = this;
        var css = "";
        if (this.styles.default) css += this.buildSelectors(this.styles.default);
        Object.keys(this.styles).sort(function(n, m) {
            return _this2.options.mediaQuery === "min" ? +n - +m : +m - +n;
        }).forEach(function(breakpoint) {
            if (breakpoint !== "default") {
                css += "@media screen and (max-width: " + breakpoint + "px) {";
                css += _this2.buildSelectors(_this2.styles[breakpoint]);
                css += "}";
            }
        });
        return css;
    };
    _proto2.buildSelectors = function buildSelectors(selectors) {
        var _this3 = this;
        var css = "";
        $faa24f22a5163ec6$var$forOwn(selectors, function(styles, selector) {
            selector = ("#" + _this3.id + " " + selector).trim();
            css += selector + " {";
            $faa24f22a5163ec6$var$forOwn(styles, function(value, prop) {
                if (value || value === 0) css += prop + ": " + value + ";";
            });
            css += "}";
        });
        return css;
    };
    return Style;
}();
var $faa24f22a5163ec6$export$c0daaea79e41d7df = /*#__PURE__*/ function() {
    function SplideRenderer(contents, options, config, defaults) {
        this.slides = [];
        this.options = {};
        this.breakpoints = [];
        $faa24f22a5163ec6$var$merge($faa24f22a5163ec6$export$f484e977a69c6ba6, defaults || {});
        $faa24f22a5163ec6$var$merge($faa24f22a5163ec6$var$merge(this.options, $faa24f22a5163ec6$export$f484e977a69c6ba6), options || {});
        this.contents = contents;
        this.config = $faa24f22a5163ec6$var$assign({}, $faa24f22a5163ec6$var$RENDERER_DEFAULT_CONFIG, config || {});
        this.id = this.config.id || $faa24f22a5163ec6$var$uniqueId("splide");
        this.Style = new $faa24f22a5163ec6$var$Style(this.id, this.options);
        this.Direction = $faa24f22a5163ec6$var$Direction(null, null, this.options);
        $faa24f22a5163ec6$var$assert(this.contents.length, "Provide at least 1 content.");
        this.init();
    }
    SplideRenderer.clean = function clean(splide) {
        var _EventInterface14 = $faa24f22a5163ec6$export$f188226459c8a3ff(splide), on = _EventInterface14.on;
        var root = splide.root;
        var clones = $faa24f22a5163ec6$var$queryAll(root, "." + $faa24f22a5163ec6$export$2c1ba4a4f1aa4947);
        on($faa24f22a5163ec6$export$d300dc1a2634364b, function() {
            $faa24f22a5163ec6$var$remove($faa24f22a5163ec6$var$child(root, "style"));
        });
        $faa24f22a5163ec6$var$remove(clones);
    };
    var _proto3 = SplideRenderer.prototype;
    _proto3.init = function init() {
        this.parseBreakpoints();
        this.initSlides();
        this.registerRootStyles();
        this.registerTrackStyles();
        this.registerSlideStyles();
        this.registerListStyles();
    };
    _proto3.initSlides = function initSlides() {
        var _this4 = this;
        $faa24f22a5163ec6$var$push(this.slides, this.contents.map(function(content, index) {
            content = $faa24f22a5163ec6$var$isString(content) ? {
                html: content
            } : content;
            content.styles = content.styles || {};
            content.attrs = content.attrs || {};
            _this4.cover(content);
            var classes = _this4.options.classes.slide + " " + (index === 0 ? $faa24f22a5163ec6$export$72d36ecf3758cb4b : "");
            $faa24f22a5163ec6$var$assign(content.attrs, {
                class: (classes + " " + (content.attrs.class || "")).trim(),
                style: _this4.buildStyles(content.styles)
            });
            return content;
        }));
        if (this.isLoop()) this.generateClones(this.slides);
    };
    _proto3.registerRootStyles = function registerRootStyles() {
        var _this5 = this;
        this.breakpoints.forEach(function(_ref2) {
            var width = _ref2[0], options = _ref2[1];
            _this5.Style.rule(" ", "max-width", $faa24f22a5163ec6$var$unit(options.width), width);
        });
    };
    _proto3.registerTrackStyles = function registerTrackStyles() {
        var _this6 = this;
        var Style2 = this.Style;
        var selector = "." + $faa24f22a5163ec6$export$7738b09ac0a98952;
        this.breakpoints.forEach(function(_ref3) {
            var width = _ref3[0], options = _ref3[1];
            Style2.rule(selector, _this6.resolve("paddingLeft"), _this6.cssPadding(options, false), width);
            Style2.rule(selector, _this6.resolve("paddingRight"), _this6.cssPadding(options, true), width);
            Style2.rule(selector, "height", _this6.cssTrackHeight(options), width);
        });
    };
    _proto3.registerListStyles = function registerListStyles() {
        var _this7 = this;
        var Style2 = this.Style;
        var selector = "." + $faa24f22a5163ec6$export$19cc2a5451235cae;
        this.breakpoints.forEach(function(_ref4) {
            var width = _ref4[0], options = _ref4[1];
            Style2.rule(selector, "transform", _this7.buildTranslate(options), width);
            if (!_this7.cssSlideHeight(options)) Style2.rule(selector, "aspect-ratio", _this7.cssAspectRatio(options), width);
        });
    };
    _proto3.registerSlideStyles = function registerSlideStyles() {
        var _this8 = this;
        var Style2 = this.Style;
        var selector = "." + $faa24f22a5163ec6$export$8d922915837a38d3;
        this.breakpoints.forEach(function(_ref5) {
            var width = _ref5[0], options = _ref5[1];
            Style2.rule(selector, "width", _this8.cssSlideWidth(options), width);
            Style2.rule(selector, "height", _this8.cssSlideHeight(options) || "100%", width);
            Style2.rule(selector, _this8.resolve("marginRight"), $faa24f22a5163ec6$var$unit(options.gap) || "0px", width);
            Style2.rule(selector + " > img", "display", options.cover ? "none" : "inline", width);
        });
    };
    _proto3.buildTranslate = function buildTranslate(options) {
        var _this$Direction = this.Direction, resolve = _this$Direction.resolve, orient = _this$Direction.orient;
        var values = [];
        values.push(this.cssOffsetClones(options));
        values.push(this.cssOffsetGaps(options));
        if (this.isCenter(options)) {
            values.push(this.buildCssValue(orient(-50), "%"));
            values.push.apply(values, this.cssOffsetCenter(options));
        }
        return values.filter(Boolean).map(function(value) {
            return "translate" + resolve("X") + "(" + value + ")";
        }).join(" ");
    };
    _proto3.cssOffsetClones = function cssOffsetClones(options) {
        var _this$Direction2 = this.Direction, resolve = _this$Direction2.resolve, orient = _this$Direction2.orient;
        var cloneCount = this.getCloneCount();
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue.value, unit2 = _this$parseCssValue.unit;
            return this.buildCssValue(orient(value) * cloneCount, unit2);
        }
        var percent = 100 * cloneCount / options.perPage;
        return orient(percent) + "%";
    };
    _proto3.cssOffsetCenter = function cssOffsetCenter(options) {
        var _this$Direction3 = this.Direction, resolve = _this$Direction3.resolve, orient = _this$Direction3.orient;
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue2 = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue2.value, unit2 = _this$parseCssValue2.unit;
            return [
                this.buildCssValue(orient(value / 2), unit2)
            ];
        }
        var values = [];
        var perPage = options.perPage, gap = options.gap;
        values.push(orient(50 / perPage) + "%");
        if (gap) {
            var _this$parseCssValue3 = this.parseCssValue(gap), _value = _this$parseCssValue3.value, _unit = _this$parseCssValue3.unit;
            var gapOffset = (_value / perPage - _value) / 2;
            values.push(this.buildCssValue(orient(gapOffset), _unit));
        }
        return values;
    };
    _proto3.cssOffsetGaps = function cssOffsetGaps(options) {
        var cloneCount = this.getCloneCount();
        if (cloneCount && options.gap) {
            var orient = this.Direction.orient;
            var _this$parseCssValue4 = this.parseCssValue(options.gap), value = _this$parseCssValue4.value, unit2 = _this$parseCssValue4.unit;
            if (this.isFixedWidth(options)) return this.buildCssValue(orient(value * cloneCount), unit2);
            var perPage = options.perPage;
            var gaps = cloneCount / perPage;
            return this.buildCssValue(orient(gaps * value), unit2);
        }
        return "";
    };
    _proto3.resolve = function resolve(prop) {
        return $faa24f22a5163ec6$var$camelToKebab(this.Direction.resolve(prop));
    };
    _proto3.cssPadding = function cssPadding(options, right) {
        var padding = options.padding;
        var prop = this.Direction.resolve(right ? "right" : "left", true);
        return padding && $faa24f22a5163ec6$var$unit(padding[prop] || ($faa24f22a5163ec6$var$isObject(padding) ? 0 : padding)) || "0px";
    };
    _proto3.cssTrackHeight = function cssTrackHeight(options) {
        var height = "";
        if (this.isVertical()) {
            height = this.cssHeight(options);
            $faa24f22a5163ec6$var$assert(height, '"height" is missing.');
            height = "calc(" + height + " - " + this.cssPadding(options, false) + " - " + this.cssPadding(options, true) + ")";
        }
        return height;
    };
    _proto3.cssHeight = function cssHeight(options) {
        return $faa24f22a5163ec6$var$unit(options.height);
    };
    _proto3.cssSlideWidth = function cssSlideWidth(options) {
        return options.autoWidth ? "" : $faa24f22a5163ec6$var$unit(options.fixedWidth) || (this.isVertical() ? "" : this.cssSlideSize(options));
    };
    _proto3.cssSlideHeight = function cssSlideHeight(options) {
        return $faa24f22a5163ec6$var$unit(options.fixedHeight) || (this.isVertical() ? options.autoHeight ? "" : this.cssSlideSize(options) : this.cssHeight(options));
    };
    _proto3.cssSlideSize = function cssSlideSize(options) {
        var gap = $faa24f22a5163ec6$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    };
    _proto3.cssAspectRatio = function cssAspectRatio(options) {
        var heightRatio = options.heightRatio;
        return heightRatio ? "" + 1 / heightRatio : "";
    };
    _proto3.buildCssValue = function buildCssValue(value, unit2) {
        return "" + value + unit2;
    };
    _proto3.parseCssValue = function parseCssValue(value) {
        if ($faa24f22a5163ec6$var$isString(value)) {
            var number = parseFloat(value) || 0;
            var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
            return {
                value: number,
                unit: unit2
            };
        }
        return {
            value: value,
            unit: "px"
        };
    };
    _proto3.parseBreakpoints = function parseBreakpoints() {
        var _this9 = this;
        var breakpoints = this.options.breakpoints;
        this.breakpoints.push([
            "default",
            this.options
        ]);
        if (breakpoints) $faa24f22a5163ec6$var$forOwn(breakpoints, function(options, width) {
            _this9.breakpoints.push([
                width,
                $faa24f22a5163ec6$var$merge($faa24f22a5163ec6$var$merge({}, _this9.options), options)
            ]);
        });
    };
    _proto3.isFixedWidth = function isFixedWidth(options) {
        return !!options[this.Direction.resolve("fixedWidth")];
    };
    _proto3.isLoop = function isLoop() {
        return this.options.type === $faa24f22a5163ec6$export$f42383286ed1223d;
    };
    _proto3.isCenter = function isCenter(options) {
        if (options.focus === "center") {
            if (this.isLoop()) return true;
            if (this.options.type === $faa24f22a5163ec6$export$e5a58a5ee5b54c22) return !this.options.trimSpace;
        }
        return false;
    };
    _proto3.isVertical = function isVertical() {
        return this.options.direction === $faa24f22a5163ec6$export$97170d9824b89709;
    };
    _proto3.buildClasses = function buildClasses() {
        var options = this.options;
        return [
            $faa24f22a5163ec6$export$93b21159ad85c843,
            $faa24f22a5163ec6$export$93b21159ad85c843 + "--" + options.type,
            $faa24f22a5163ec6$export$93b21159ad85c843 + "--" + options.direction,
            options.drag && $faa24f22a5163ec6$export$93b21159ad85c843 + "--draggable",
            options.isNavigation && $faa24f22a5163ec6$export$93b21159ad85c843 + "--nav",
            $faa24f22a5163ec6$export$72d36ecf3758cb4b,
            !this.config.hidden && $faa24f22a5163ec6$var$CLASS_RENDERED
        ].filter(Boolean).join(" ");
    };
    _proto3.buildAttrs = function buildAttrs(attrs) {
        var attr = "";
        $faa24f22a5163ec6$var$forOwn(attrs, function(value, key) {
            attr += value ? " " + $faa24f22a5163ec6$var$camelToKebab(key) + "=\"" + value + "\"" : "";
        });
        return attr.trim();
    };
    _proto3.buildStyles = function buildStyles(styles) {
        var style = "";
        $faa24f22a5163ec6$var$forOwn(styles, function(value, key) {
            style += " " + $faa24f22a5163ec6$var$camelToKebab(key) + ":" + value + ";";
        });
        return style.trim();
    };
    _proto3.renderSlides = function renderSlides() {
        var _this10 = this;
        var tag = this.config.slideTag;
        return this.slides.map(function(content) {
            return "<" + tag + " " + _this10.buildAttrs(content.attrs) + ">" + (content.html || "") + "</" + tag + ">";
        }).join("");
    };
    _proto3.cover = function cover(content) {
        var styles = content.styles, _content$html = content.html, html = _content$html === void 0 ? "" : _content$html;
        if (this.options.cover && !this.options.lazyLoad) {
            var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);
            if (src && src[2]) styles.background = "center/cover no-repeat url('" + src[2] + "')";
        }
    };
    _proto3.generateClones = function generateClones(contents) {
        var classes = this.options.classes;
        var count = this.getCloneCount();
        var slides = contents.slice();
        while(slides.length < count)$faa24f22a5163ec6$var$push(slides, slides);
        $faa24f22a5163ec6$var$push(slides.slice(-count).reverse(), slides.slice(0, count)).forEach(function(content, index) {
            var attrs = $faa24f22a5163ec6$var$assign({}, content.attrs, {
                class: content.attrs.class + " " + classes.clone
            });
            var clone = $faa24f22a5163ec6$var$assign({}, content, {
                attrs: attrs
            });
            index < count ? contents.unshift(clone) : contents.push(clone);
        });
    };
    _proto3.getCloneCount = function getCloneCount() {
        if (this.isLoop()) {
            var options = this.options;
            if (options.clones) return options.clones;
            var perPage = $faa24f22a5163ec6$var$max.apply(void 0, this.breakpoints.map(function(_ref6) {
                var options2 = _ref6[1];
                return options2.perPage;
            }));
            return perPage * ((options.flickMaxPages || 1) + 1);
        }
        return 0;
    };
    _proto3.renderArrows = function renderArrows() {
        var html = "";
        html += "<div class=\"" + this.options.classes.arrows + "\">";
        html += this.renderArrow(true);
        html += this.renderArrow(false);
        html += "</div>";
        return html;
    };
    _proto3.renderArrow = function renderArrow(prev) {
        var _this$options = this.options, classes = _this$options.classes, i18n = _this$options.i18n;
        var attrs = {
            class: classes.arrow + " " + (prev ? classes.prev : classes.next),
            type: "button",
            ariaLabel: prev ? i18n.prev : i18n.next
        };
        return "<button " + this.buildAttrs(attrs) + "><svg xmlns=\"" + $faa24f22a5163ec6$var$XML_NAME_SPACE + "\" viewBox=\"0 0 " + $faa24f22a5163ec6$var$SIZE + " " + $faa24f22a5163ec6$var$SIZE + "\" width=\"" + $faa24f22a5163ec6$var$SIZE + "\" height=\"" + $faa24f22a5163ec6$var$SIZE + "\"><path d=\"" + (this.options.arrowPath || $faa24f22a5163ec6$var$PATH) + "\" /></svg></button>";
    };
    _proto3.html = function html() {
        var _this$config = this.config, rootClass = _this$config.rootClass, listTag = _this$config.listTag, arrows = _this$config.arrows, beforeTrack = _this$config.beforeTrack, afterTrack = _this$config.afterTrack, slider = _this$config.slider, beforeSlider = _this$config.beforeSlider, afterSlider = _this$config.afterSlider;
        var html = "";
        html += "<div id=\"" + this.id + "\" class=\"" + this.buildClasses() + " " + (rootClass || "") + "\">";
        html += "<style>" + this.Style.build() + "</style>";
        if (slider) {
            html += beforeSlider || "";
            html += "<div class=\"splide__slider\">";
        }
        html += beforeTrack || "";
        if (arrows) html += this.renderArrows();
        html += "<div class=\"splide__track\">";
        html += "<" + listTag + " class=\"splide__list\">";
        html += this.renderSlides();
        html += "</" + listTag + ">";
        html += "</div>";
        html += afterTrack || "";
        if (slider) {
            html += "</div>";
            html += afterSlider || "";
        }
        html += "</div>";
        return html;
    };
    return SplideRenderer;
}();

});


parcelRegister("gIIrM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2c33baf44df8cbb$export$2e2bcd8739ae039);

var $lSH1h = parcelRequire("lSH1h");

var $jdFcE = parcelRequire("jdFcE");
class $c2c33baf44df8cbb$export$2e2bcd8739ae039 {
    static init() {
        $('input[type="submit"], button[type="submit"]').on('click', function() {
            this.form.setAttribute('__action', $(this).data('action') || 'submit');
            if ($(this).data('confirm') !== null) this.form.setAttribute('__confirm', $(this).data('confirm') || "\u66F4\u65B0\u3057\u307E\u3059\u304B\uFF1F");
        });
    }
    static form_post(form, callback) {
        try {
            if (form.getAttribute('__confirm') && !confirm(form.getAttribute('__confirm'))) return false;
            $('.__editor').each((index, element)=>{
                $(element).data('editor').updateSourceElement();
            });
            const data = new FormData(form);
            data.set('__action', form.getAttribute('__action') || 'submit');
            $c2c33baf44df8cbb$export$2e2bcd8739ae039.post(form.action || location.pathname, data, callback);
        } catch (exception) {
            console.error(exception.message);
        }
        return false;
    }
    static post(url, data, callback) {
        (async ()=>{
            try {
                let response = await $.ajax({
                    url: url,
                    method: 'POST',
                    data: data,
                    contentType: false,
                    processData: false
                });
                if (typeof response !== 'object') response = {
                    message: null,
                    success: false
                };
                if (typeof response.success !== 'boolean') response.success = false;
                if (!response.success) (0, $jdFcE.default).warning(response.message);
                else if ((0, $lSH1h.default).filled(response.message)) (0, $jdFcE.default).success(response.message);
                if (typeof callback === 'function') // noinspection JSUnresolvedVariable
                callback(response.success, response.payload);
            } catch (exception) {
                let error = exception.message !== undefined ? exception.message : `HTTP ${exception.status} : \u{30A8}\u{30E9}\u{30FC}\u{304C}\u{767A}\u{751F}\u{3057}\u{307E}\u{3057}\u{305F}`;
                (0, $jdFcE.default).error(error);
            }
        })();
    }
}

});
parcelRegister("jdFcE", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfdf31470e8752da$export$2e2bcd8739ae039);

var $ld9cC = parcelRequire("ld9cC");
class $dfdf31470e8752da$export$2e2bcd8739ae039 {
    static _notify_layout = {
        layout: 2,
        position: 'topRight',
        progressBar: false,
        transitionOutMobile: 'fadeOutUp',
        animateInside: false
    };
    static success(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($ld9cC))).success(Object.assign(this._notify_layout, {
            message: message,
            timeout: 5000,
            close: false
        }));
    }
    static info(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($ld9cC))).info(Object.assign(this._notify_layout, {
            message: message,
            timeout: 5000,
            close: false
        }));
    }
    static warning(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($ld9cC))).warning(Object.assign(this._notify_layout, {
            message: message,
            timeout: false,
            close: true
        }));
        console.warn(`[Warning] ${message}`);
    }
    static error(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($ld9cC))).error(Object.assign(this._notify_layout, {
            message: message,
            timeout: false,
            close: true
        }));
        console.error(`[Error] ${message}`);
    }
}

});
parcelRegister("ld9cC", function(module, exports) {
/*
* iziToast | v1.4.0
* http://izitoast.marcelodolce.com
* by Marcelo Dolce.
*/ (function(root, factory) {
    if (typeof define === 'function' && define.amd) define([], factory(root));
    else module.exports = factory(root);
})(typeof $parcel$global !== 'undefined' ? $parcel$global : window || module.exports.window || module.exports.global, function(root) {
    'use strict';
    //
    // Variables
    //
    var $iziToast = {}, PLUGIN_NAME = 'iziToast', BODY = document.querySelector('body'), ISMOBILE = /Mobi/.test(navigator.userAgent) ? true : false, ISCHROME = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor), ISFIREFOX = typeof InstallTrigger !== 'undefined', ACCEPTSTOUCH = 'ontouchstart' in document.documentElement, POSITIONS = [
        'bottomRight',
        'bottomLeft',
        'bottomCenter',
        'topRight',
        'topLeft',
        'topCenter',
        'center'
    ], THEMES = {
        info: {
            color: 'blue',
            icon: 'ico-info'
        },
        success: {
            color: 'green',
            icon: 'ico-success'
        },
        warning: {
            color: 'orange',
            icon: 'ico-warning'
        },
        error: {
            color: 'red',
            icon: 'ico-error'
        },
        question: {
            color: 'yellow',
            icon: 'ico-question'
        }
    }, MOBILEWIDTH = 568, CONFIG = {};
    $iziToast.children = {};
    // Default settings
    var defaults = {
        id: null,
        class: '',
        title: '',
        titleColor: '',
        titleSize: '',
        titleLineHeight: '',
        message: '',
        messageColor: '',
        messageSize: '',
        messageLineHeight: '',
        backgroundColor: '',
        theme: 'light',
        color: '',
        icon: '',
        iconText: '',
        iconColor: '',
        iconUrl: null,
        image: '',
        imageWidth: 50,
        maxWidth: null,
        zindex: null,
        layout: 1,
        balloon: false,
        close: true,
        closeOnEscape: false,
        closeOnClick: false,
        displayMode: 0,
        position: 'bottomRight',
        target: '',
        targetFirst: true,
        timeout: 5000,
        rtl: false,
        animateInside: true,
        drag: true,
        pauseOnHover: true,
        resetOnHover: false,
        progressBar: true,
        progressBarColor: '',
        progressBarEasing: 'linear',
        overlay: false,
        overlayClose: false,
        overlayColor: 'rgba(0, 0, 0, 0.6)',
        transitionIn: 'fadeInUp',
        transitionOut: 'fadeOut',
        transitionInMobile: 'fadeInUp',
        transitionOutMobile: 'fadeOutDown',
        buttons: {},
        inputs: {},
        onOpening: function() {},
        onOpened: function() {},
        onClosing: function() {},
        onClosed: function() {}
    };
    //
    // Methods
    //
    /**
	 * Polyfill for remove() method
	 */ if (!('remove' in Element.prototype)) Element.prototype.remove = function() {
        if (this.parentNode) this.parentNode.removeChild(this);
    };
    /*
     * Polyfill for CustomEvent for IE >= 9
     * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
     */ if (typeof window.CustomEvent !== 'function') {
        var CustomEventPolyfill = function(event, params) {
            params = params || {
                bubbles: false,
                cancelable: false,
                detail: undefined
            };
            var evt = document.createEvent('CustomEvent');
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        };
        CustomEventPolyfill.prototype = window.Event.prototype;
        window.CustomEvent = CustomEventPolyfill;
    }
    /**
	 * A simple forEach() implementation for Arrays, Objects and NodeLists
	 * @private
	 * @param {Array|Object|NodeList} collection Collection of items to iterate
	 * @param {Function} callback Callback function for each iteration
	 * @param {Array|Object|NodeList} scope Object/NodeList/Array that forEach is iterating over (aka `this`)
	 */ var forEach = function(collection, callback, scope) {
        if (Object.prototype.toString.call(collection) === '[object Object]') {
            for(var prop in collection)if (Object.prototype.hasOwnProperty.call(collection, prop)) callback.call(scope, collection[prop], prop, collection);
        } else {
            if (collection) for(var i = 0, len = collection.length; i < len; i++)callback.call(scope, collection[i], i, collection);
        }
    };
    /**
	 * Merge defaults with user options
	 * @private
	 * @param {Object} defaults Default settings
	 * @param {Object} options User options
	 * @returns {Object} Merged values of defaults and options
	 */ var extend = function(defaults, options) {
        var extended = {};
        forEach(defaults, function(value, prop) {
            extended[prop] = defaults[prop];
        });
        forEach(options, function(value, prop) {
            extended[prop] = options[prop];
        });
        return extended;
    };
    /**
	 * Create a fragment DOM elements
	 * @private
	 */ var createFragElem = function(htmlStr) {
        var frag = document.createDocumentFragment(), temp = document.createElement('div');
        temp.innerHTML = htmlStr;
        while(temp.firstChild)frag.appendChild(temp.firstChild);
        return frag;
    };
    /**
	 * Generate new ID
	 * @private
	 */ var generateId = function(params) {
        var newId = btoa(encodeURIComponent(params));
        return newId.replace(/=/g, "");
    };
    /**
	 * Check if is a color
	 * @private
	 */ var isColor = function(color) {
        if (color.substring(0, 1) == '#' || color.substring(0, 3) == 'rgb' || color.substring(0, 3) == 'hsl') return true;
        else return false;
    };
    /**
	 * Check if is a Base64 string
	 * @private
	 */ var isBase64 = function(str) {
        try {
            return btoa(atob(str)) == str;
        } catch (err) {
            return false;
        }
    };
    /**
	 * Drag method of toasts
	 * @private
	 */ var drag = function() {
        return {
            move: function(toast, instance, settings, xpos) {
                var opacity, opacityRange = 0.3, distance = 180;
                if (xpos !== 0) {
                    toast.classList.add(PLUGIN_NAME + '-dragged');
                    toast.style.transform = 'translateX(' + xpos + 'px)';
                    if (xpos > 0) {
                        opacity = (distance - xpos) / distance;
                        if (opacity < opacityRange) instance.hide(extend(settings, {
                            transitionOut: 'fadeOutRight',
                            transitionOutMobile: 'fadeOutRight'
                        }), toast, 'drag');
                    } else {
                        opacity = (distance + xpos) / distance;
                        if (opacity < opacityRange) instance.hide(extend(settings, {
                            transitionOut: 'fadeOutLeft',
                            transitionOutMobile: 'fadeOutLeft'
                        }), toast, 'drag');
                    }
                    toast.style.opacity = opacity;
                    if (opacity < opacityRange) {
                        if (ISCHROME || ISFIREFOX) toast.style.left = xpos + 'px';
                        toast.parentNode.style.opacity = opacityRange;
                        this.stopMoving(toast, null);
                    }
                }
            },
            startMoving: function(toast, instance, settings, e) {
                e = e || window.event;
                var posX = ACCEPTSTOUCH ? e.touches[0].clientX : e.clientX, toastLeft = toast.style.transform.replace('px)', '');
                toastLeft = toastLeft.replace('translateX(', '');
                var offsetX = posX - toastLeft;
                if (settings.transitionIn) toast.classList.remove(settings.transitionIn);
                if (settings.transitionInMobile) toast.classList.remove(settings.transitionInMobile);
                toast.style.transition = '';
                if (ACCEPTSTOUCH) document.ontouchmove = function(e) {
                    e.preventDefault();
                    e = e || window.event;
                    var posX = e.touches[0].clientX, finalX = posX - offsetX;
                    drag.move(toast, instance, settings, finalX);
                };
                else document.onmousemove = function(e) {
                    e.preventDefault();
                    e = e || window.event;
                    var posX = e.clientX, finalX = posX - offsetX;
                    drag.move(toast, instance, settings, finalX);
                };
            },
            stopMoving: function(toast, e) {
                if (ACCEPTSTOUCH) document.ontouchmove = function() {};
                else document.onmousemove = function() {};
                toast.style.opacity = '';
                toast.style.transform = '';
                if (toast.classList.contains(PLUGIN_NAME + '-dragged')) {
                    toast.classList.remove(PLUGIN_NAME + '-dragged');
                    toast.style.transition = 'transform 0.4s ease, opacity 0.4s ease';
                    setTimeout(function() {
                        toast.style.transition = '';
                    }, 400);
                }
            }
        };
    }();
    $iziToast.setSetting = function(ref, option, value) {
        $iziToast.children[ref][option] = value;
    };
    $iziToast.getSetting = function(ref, option) {
        return $iziToast.children[ref][option];
    };
    /**
	 * Destroy the current initialization.
	 * @public
	 */ $iziToast.destroy = function() {
        forEach(document.querySelectorAll('.' + PLUGIN_NAME + '-overlay'), function(element, index) {
            element.remove();
        });
        forEach(document.querySelectorAll('.' + PLUGIN_NAME + '-wrapper'), function(element, index) {
            element.remove();
        });
        forEach(document.querySelectorAll('.' + PLUGIN_NAME), function(element, index) {
            element.remove();
        });
        this.children = {};
        // Remove event listeners
        document.removeEventListener(PLUGIN_NAME + '-opened', {}, false);
        document.removeEventListener(PLUGIN_NAME + '-opening', {}, false);
        document.removeEventListener(PLUGIN_NAME + '-closing', {}, false);
        document.removeEventListener(PLUGIN_NAME + '-closed', {}, false);
        document.removeEventListener('keyup', {}, false);
        // Reset variables
        CONFIG = {};
    };
    /**
	 * Initialize Plugin
	 * @public
	 * @param {Object} options User settings
	 */ $iziToast.settings = function(options) {
        // Destroy any existing initializations
        $iziToast.destroy();
        CONFIG = options;
        defaults = extend(defaults, options || {});
    };
    /**
	 * Building themes functions.
	 * @public
	 * @param {Object} options User settings
	 */ forEach(THEMES, function(theme, name) {
        $iziToast[name] = function(options) {
            var settings = extend(CONFIG, options || {});
            settings = extend(theme, settings || {});
            this.show(settings);
        };
    });
    /**
	 * Do the calculation to move the progress bar
	 * @private
	 */ $iziToast.progress = function(options, $toast, callback) {
        var that = this, ref = $toast.getAttribute('data-iziToast-ref'), settings = extend(this.children[ref], options || {}), $elem = $toast.querySelector('.' + PLUGIN_NAME + '-progressbar div');
        return {
            start: function() {
                if (typeof settings.time.REMAINING == 'undefined') {
                    $toast.classList.remove(PLUGIN_NAME + '-reseted');
                    if ($elem !== null) {
                        $elem.style.transition = 'width ' + settings.timeout + 'ms ' + settings.progressBarEasing;
                        $elem.style.width = '0%';
                    }
                    settings.time.START = new Date().getTime();
                    settings.time.END = settings.time.START + settings.timeout;
                    settings.time.TIMER = setTimeout(function() {
                        clearTimeout(settings.time.TIMER);
                        if (!$toast.classList.contains(PLUGIN_NAME + '-closing')) {
                            that.hide(settings, $toast, 'timeout');
                            if (typeof callback === 'function') callback.apply(that);
                        }
                    }, settings.timeout);
                    that.setSetting(ref, 'time', settings.time);
                }
            },
            pause: function() {
                if (typeof settings.time.START !== 'undefined' && !$toast.classList.contains(PLUGIN_NAME + '-paused') && !$toast.classList.contains(PLUGIN_NAME + '-reseted')) {
                    $toast.classList.add(PLUGIN_NAME + '-paused');
                    settings.time.REMAINING = settings.time.END - new Date().getTime();
                    clearTimeout(settings.time.TIMER);
                    that.setSetting(ref, 'time', settings.time);
                    if ($elem !== null) {
                        var computedStyle = window.getComputedStyle($elem), propertyWidth = computedStyle.getPropertyValue('width');
                        $elem.style.transition = 'none';
                        $elem.style.width = propertyWidth;
                    }
                    if (typeof callback === 'function') setTimeout(function() {
                        callback.apply(that);
                    }, 10);
                }
            },
            resume: function() {
                if (typeof settings.time.REMAINING !== 'undefined') {
                    $toast.classList.remove(PLUGIN_NAME + '-paused');
                    if ($elem !== null) {
                        $elem.style.transition = 'width ' + settings.time.REMAINING + 'ms ' + settings.progressBarEasing;
                        $elem.style.width = '0%';
                    }
                    settings.time.END = new Date().getTime() + settings.time.REMAINING;
                    settings.time.TIMER = setTimeout(function() {
                        clearTimeout(settings.time.TIMER);
                        if (!$toast.classList.contains(PLUGIN_NAME + '-closing')) {
                            that.hide(settings, $toast, 'timeout');
                            if (typeof callback === 'function') callback.apply(that);
                        }
                    }, settings.time.REMAINING);
                    that.setSetting(ref, 'time', settings.time);
                } else this.start();
            },
            reset: function() {
                clearTimeout(settings.time.TIMER);
                delete settings.time.REMAINING;
                that.setSetting(ref, 'time', settings.time);
                $toast.classList.add(PLUGIN_NAME + '-reseted');
                $toast.classList.remove(PLUGIN_NAME + '-paused');
                if ($elem !== null) {
                    $elem.style.transition = 'none';
                    $elem.style.width = '100%';
                }
                if (typeof callback === 'function') setTimeout(function() {
                    callback.apply(that);
                }, 10);
            }
        };
    };
    /**
	 * Close the specific Toast
	 * @public
	 * @param {Object} options User settings
	 */ $iziToast.hide = function(options, $toast, closedBy) {
        if (typeof $toast != 'object') $toast = document.querySelector($toast);
        var that = this, settings = extend(this.children[$toast.getAttribute('data-iziToast-ref')], options || {});
        settings.closedBy = closedBy || null;
        delete settings.time.REMAINING;
        $toast.classList.add(PLUGIN_NAME + '-closing');
        // Overlay
        (function() {
            var $overlay = document.querySelector('.' + PLUGIN_NAME + '-overlay');
            if ($overlay !== null) {
                var refs = $overlay.getAttribute('data-iziToast-ref');
                refs = refs.split(',');
                var index = refs.indexOf(String(settings.ref));
                if (index !== -1) refs.splice(index, 1);
                $overlay.setAttribute('data-iziToast-ref', refs.join());
                if (refs.length === 0) {
                    $overlay.classList.remove('fadeIn');
                    $overlay.classList.add('fadeOut');
                    setTimeout(function() {
                        $overlay.remove();
                    }, 700);
                }
            }
        })();
        if (settings.transitionIn) $toast.classList.remove(settings.transitionIn);
        if (settings.transitionInMobile) $toast.classList.remove(settings.transitionInMobile);
        if (ISMOBILE || window.innerWidth <= MOBILEWIDTH) {
            if (settings.transitionOutMobile) $toast.classList.add(settings.transitionOutMobile);
        } else if (settings.transitionOut) $toast.classList.add(settings.transitionOut);
        var H = $toast.parentNode.offsetHeight;
        $toast.parentNode.style.height = H + 'px';
        $toast.style.pointerEvents = 'none';
        if (!ISMOBILE || window.innerWidth > MOBILEWIDTH) $toast.parentNode.style.transitionDelay = '0.2s';
        try {
            var event = new CustomEvent(PLUGIN_NAME + '-closing', {
                detail: settings,
                bubbles: true,
                cancelable: true
            });
            document.dispatchEvent(event);
        } catch (ex) {
            console.warn(ex);
        }
        setTimeout(function() {
            $toast.parentNode.style.height = '0px';
            $toast.parentNode.style.overflow = '';
            setTimeout(function() {
                delete that.children[settings.ref];
                $toast.parentNode.remove();
                try {
                    var event = new CustomEvent(PLUGIN_NAME + '-closed', {
                        detail: settings,
                        bubbles: true,
                        cancelable: true
                    });
                    document.dispatchEvent(event);
                } catch (ex) {
                    console.warn(ex);
                }
                if (typeof settings.onClosed !== 'undefined') settings.onClosed.apply(null, [
                    settings,
                    $toast,
                    closedBy
                ]);
            }, 1000);
        }, 200);
        if (typeof settings.onClosing !== 'undefined') settings.onClosing.apply(null, [
            settings,
            $toast,
            closedBy
        ]);
    };
    /**
	 * Create and show the Toast
	 * @public
	 * @param {Object} options User settings
	 */ $iziToast.show = function(options) {
        var that = this;
        // Merge user options with defaults
        var settings = extend(CONFIG, options || {});
        settings = extend(defaults, settings);
        settings.time = {};
        if (settings.id === null) settings.id = generateId(settings.title + settings.message + settings.color);
        if (settings.displayMode === 1 || settings.displayMode == 'once') try {
            if (document.querySelectorAll('.' + PLUGIN_NAME + '#' + settings.id).length > 0) return false;
        } catch (exc) {
            console.warn('[' + PLUGIN_NAME + '] Could not find an element with this selector: ' + '#' + settings.id + '. Try to set an valid id.');
        }
        if (settings.displayMode === 2 || settings.displayMode == 'replace') try {
            forEach(document.querySelectorAll('.' + PLUGIN_NAME + '#' + settings.id), function(element, index) {
                that.hide(settings, element, 'replaced');
            });
        } catch (exc) {
            console.warn('[' + PLUGIN_NAME + '] Could not find an element with this selector: ' + '#' + settings.id + '. Try to set an valid id.');
        }
        settings.ref = new Date().getTime() + Math.floor(Math.random() * 10000000 + 1);
        $iziToast.children[settings.ref] = settings;
        var $DOM = {
            body: document.querySelector('body'),
            overlay: document.createElement('div'),
            toast: document.createElement('div'),
            toastBody: document.createElement('div'),
            toastTexts: document.createElement('div'),
            toastCapsule: document.createElement('div'),
            cover: document.createElement('div'),
            buttons: document.createElement('div'),
            inputs: document.createElement('div'),
            icon: !settings.iconUrl ? document.createElement('i') : document.createElement('img'),
            wrapper: null
        };
        $DOM.toast.setAttribute('data-iziToast-ref', settings.ref);
        $DOM.toast.appendChild($DOM.toastBody);
        $DOM.toastCapsule.appendChild($DOM.toast);
        // CSS Settings
        (function() {
            $DOM.toast.classList.add(PLUGIN_NAME);
            $DOM.toast.classList.add(PLUGIN_NAME + '-opening');
            $DOM.toastCapsule.classList.add(PLUGIN_NAME + '-capsule');
            $DOM.toastBody.classList.add(PLUGIN_NAME + '-body');
            $DOM.toastTexts.classList.add(PLUGIN_NAME + '-texts');
            if (ISMOBILE || window.innerWidth <= MOBILEWIDTH) {
                if (settings.transitionInMobile) $DOM.toast.classList.add(settings.transitionInMobile);
            } else if (settings.transitionIn) $DOM.toast.classList.add(settings.transitionIn);
            if (settings.class) {
                var classes = settings.class.split(' ');
                forEach(classes, function(value, index) {
                    $DOM.toast.classList.add(value);
                });
            }
            if (settings.id) $DOM.toast.id = settings.id;
            if (settings.rtl) {
                $DOM.toast.classList.add(PLUGIN_NAME + '-rtl');
                $DOM.toast.setAttribute('dir', 'rtl');
            }
            if (settings.layout > 1) $DOM.toast.classList.add(PLUGIN_NAME + '-layout' + settings.layout);
            if (settings.balloon) $DOM.toast.classList.add(PLUGIN_NAME + '-balloon');
            if (settings.maxWidth) {
                if (!isNaN(settings.maxWidth)) $DOM.toast.style.maxWidth = settings.maxWidth + 'px';
                else $DOM.toast.style.maxWidth = settings.maxWidth;
            }
            if (settings.theme !== '' || settings.theme !== 'light') $DOM.toast.classList.add(PLUGIN_NAME + '-theme-' + settings.theme);
            if (settings.color) {
                if (isColor(settings.color)) $DOM.toast.style.background = settings.color;
                else $DOM.toast.classList.add(PLUGIN_NAME + '-color-' + settings.color);
            }
            if (settings.backgroundColor) {
                $DOM.toast.style.background = settings.backgroundColor;
                if (settings.balloon) $DOM.toast.style.borderColor = settings.backgroundColor;
            }
        })();
        // Cover image
        (function() {
            if (settings.image) {
                $DOM.cover.classList.add(PLUGIN_NAME + '-cover');
                $DOM.cover.style.width = settings.imageWidth + 'px';
                if (isBase64(settings.image.replace(/ /g, ''))) $DOM.cover.style.backgroundImage = 'url(data:image/png;base64,' + settings.image.replace(/ /g, '') + ')';
                else $DOM.cover.style.backgroundImage = 'url(' + settings.image + ')';
                if (settings.rtl) $DOM.toastBody.style.marginRight = settings.imageWidth + 10 + 'px';
                else $DOM.toastBody.style.marginLeft = settings.imageWidth + 10 + 'px';
                $DOM.toast.appendChild($DOM.cover);
            }
        })();
        // Button close
        (function() {
            if (settings.close) {
                $DOM.buttonClose = document.createElement('button');
                $DOM.buttonClose.type = 'button';
                $DOM.buttonClose.classList.add(PLUGIN_NAME + '-close');
                $DOM.buttonClose.addEventListener('click', function(e) {
                    var button = e.target;
                    that.hide(settings, $DOM.toast, 'button');
                });
                $DOM.toast.appendChild($DOM.buttonClose);
            } else if (settings.rtl) $DOM.toast.style.paddingLeft = '18px';
            else $DOM.toast.style.paddingRight = '18px';
        })();
        // Progress Bar & Timeout
        (function() {
            if (settings.progressBar) {
                $DOM.progressBar = document.createElement('div');
                $DOM.progressBarDiv = document.createElement('div');
                $DOM.progressBar.classList.add(PLUGIN_NAME + '-progressbar');
                $DOM.progressBarDiv.style.background = settings.progressBarColor;
                $DOM.progressBar.appendChild($DOM.progressBarDiv);
                $DOM.toast.appendChild($DOM.progressBar);
            }
            if (settings.timeout) {
                if (settings.pauseOnHover && !settings.resetOnHover) {
                    $DOM.toast.addEventListener('mouseenter', function(e) {
                        that.progress(settings, $DOM.toast).pause();
                    });
                    $DOM.toast.addEventListener('mouseleave', function(e) {
                        that.progress(settings, $DOM.toast).resume();
                    });
                }
                if (settings.resetOnHover) {
                    $DOM.toast.addEventListener('mouseenter', function(e) {
                        that.progress(settings, $DOM.toast).reset();
                    });
                    $DOM.toast.addEventListener('mouseleave', function(e) {
                        that.progress(settings, $DOM.toast).start();
                    });
                }
            }
        })();
        // Icon
        (function() {
            if (settings.iconUrl) {
                $DOM.icon.setAttribute('class', PLUGIN_NAME + '-icon');
                $DOM.icon.setAttribute('src', settings.iconUrl);
            } else if (settings.icon) {
                $DOM.icon.setAttribute('class', PLUGIN_NAME + '-icon ' + settings.icon);
                if (settings.iconText) $DOM.icon.appendChild(document.createTextNode(settings.iconText));
                if (settings.iconColor) $DOM.icon.style.color = settings.iconColor;
            }
            if (settings.icon || settings.iconUrl) {
                if (settings.rtl) $DOM.toastBody.style.paddingRight = '33px';
                else $DOM.toastBody.style.paddingLeft = '33px';
                $DOM.toastBody.appendChild($DOM.icon);
            }
        })();
        // Title & Message
        (function() {
            if (settings.title.length > 0) {
                $DOM.strong = document.createElement('strong');
                $DOM.strong.classList.add(PLUGIN_NAME + '-title');
                $DOM.strong.appendChild(createFragElem(settings.title));
                $DOM.toastTexts.appendChild($DOM.strong);
                if (settings.titleColor) $DOM.strong.style.color = settings.titleColor;
                if (settings.titleSize) {
                    if (!isNaN(settings.titleSize)) $DOM.strong.style.fontSize = settings.titleSize + 'px';
                    else $DOM.strong.style.fontSize = settings.titleSize;
                }
                if (settings.titleLineHeight) {
                    if (!isNaN(settings.titleSize)) $DOM.strong.style.lineHeight = settings.titleLineHeight + 'px';
                    else $DOM.strong.style.lineHeight = settings.titleLineHeight;
                }
            }
            if (settings.message.length > 0) {
                $DOM.p = document.createElement('p');
                $DOM.p.classList.add(PLUGIN_NAME + '-message');
                $DOM.p.appendChild(createFragElem(settings.message));
                $DOM.toastTexts.appendChild($DOM.p);
                if (settings.messageColor) $DOM.p.style.color = settings.messageColor;
                if (settings.messageSize) {
                    if (!isNaN(settings.titleSize)) $DOM.p.style.fontSize = settings.messageSize + 'px';
                    else $DOM.p.style.fontSize = settings.messageSize;
                }
                if (settings.messageLineHeight) {
                    if (!isNaN(settings.titleSize)) $DOM.p.style.lineHeight = settings.messageLineHeight + 'px';
                    else $DOM.p.style.lineHeight = settings.messageLineHeight;
                }
            }
            if (settings.title.length > 0 && settings.message.length > 0) {
                if (settings.rtl) $DOM.strong.style.marginLeft = '10px';
                else if (settings.layout !== 2 && !settings.rtl) $DOM.strong.style.marginRight = '10px';
            }
        })();
        $DOM.toastBody.appendChild($DOM.toastTexts);
        // Inputs
        var $inputs;
        (function() {
            if (settings.inputs.length > 0) {
                $DOM.inputs.classList.add(PLUGIN_NAME + '-inputs');
                forEach(settings.inputs, function(value, index) {
                    $DOM.inputs.appendChild(createFragElem(value[0]));
                    $inputs = $DOM.inputs.childNodes;
                    $inputs[index].classList.add(PLUGIN_NAME + '-inputs-child');
                    if (value[3]) setTimeout(function() {
                        $inputs[index].focus();
                    }, 300);
                    $inputs[index].addEventListener(value[1], function(e) {
                        var ts = value[2];
                        return ts(that, $DOM.toast, this, e);
                    });
                });
                $DOM.toastBody.appendChild($DOM.inputs);
            }
        })();
        // Buttons
        (function() {
            if (settings.buttons.length > 0) {
                $DOM.buttons.classList.add(PLUGIN_NAME + '-buttons');
                forEach(settings.buttons, function(value, index) {
                    $DOM.buttons.appendChild(createFragElem(value[0]));
                    var $btns = $DOM.buttons.childNodes;
                    $btns[index].classList.add(PLUGIN_NAME + '-buttons-child');
                    if (value[2]) setTimeout(function() {
                        $btns[index].focus();
                    }, 300);
                    $btns[index].addEventListener('click', function(e) {
                        e.preventDefault();
                        var ts = value[1];
                        return ts(that, $DOM.toast, this, e, $inputs);
                    });
                });
            }
            $DOM.toastBody.appendChild($DOM.buttons);
        })();
        if (settings.message.length > 0 && (settings.inputs.length > 0 || settings.buttons.length > 0)) $DOM.p.style.marginBottom = '0';
        if (settings.inputs.length > 0 || settings.buttons.length > 0) {
            if (settings.rtl) $DOM.toastTexts.style.marginLeft = '10px';
            else $DOM.toastTexts.style.marginRight = '10px';
            if (settings.inputs.length > 0 && settings.buttons.length > 0) {
                if (settings.rtl) $DOM.inputs.style.marginLeft = '8px';
                else $DOM.inputs.style.marginRight = '8px';
            }
        }
        // Wrap
        (function() {
            $DOM.toastCapsule.style.visibility = 'hidden';
            setTimeout(function() {
                var H = $DOM.toast.offsetHeight;
                var style = $DOM.toast.currentStyle || window.getComputedStyle($DOM.toast);
                var marginTop = style.marginTop;
                marginTop = marginTop.split('px');
                marginTop = parseInt(marginTop[0]);
                var marginBottom = style.marginBottom;
                marginBottom = marginBottom.split('px');
                marginBottom = parseInt(marginBottom[0]);
                $DOM.toastCapsule.style.visibility = '';
                $DOM.toastCapsule.style.height = H + marginBottom + marginTop + 'px';
                setTimeout(function() {
                    $DOM.toastCapsule.style.height = 'auto';
                    if (settings.target) $DOM.toastCapsule.style.overflow = 'visible';
                }, 500);
                if (settings.timeout) that.progress(settings, $DOM.toast).start();
            }, 100);
        })();
        // Target
        (function() {
            var position = settings.position;
            if (settings.target) {
                $DOM.wrapper = document.querySelector(settings.target);
                $DOM.wrapper.classList.add(PLUGIN_NAME + '-target');
                if (settings.targetFirst) $DOM.wrapper.insertBefore($DOM.toastCapsule, $DOM.wrapper.firstChild);
                else $DOM.wrapper.appendChild($DOM.toastCapsule);
            } else {
                if (POSITIONS.indexOf(settings.position) == -1) {
                    console.warn('[' + PLUGIN_NAME + "] Incorrect position.\nIt can be \u203A " + POSITIONS);
                    return;
                }
                if (ISMOBILE || window.innerWidth <= MOBILEWIDTH) {
                    if (settings.position == 'bottomLeft' || settings.position == 'bottomRight' || settings.position == 'bottomCenter') position = PLUGIN_NAME + '-wrapper-bottomCenter';
                    else if (settings.position == 'topLeft' || settings.position == 'topRight' || settings.position == 'topCenter') position = PLUGIN_NAME + '-wrapper-topCenter';
                    else position = PLUGIN_NAME + '-wrapper-center';
                } else position = PLUGIN_NAME + '-wrapper-' + position;
                $DOM.wrapper = document.querySelector('.' + PLUGIN_NAME + '-wrapper.' + position);
                if (!$DOM.wrapper) {
                    $DOM.wrapper = document.createElement('div');
                    $DOM.wrapper.classList.add(PLUGIN_NAME + '-wrapper');
                    $DOM.wrapper.classList.add(position);
                    document.body.appendChild($DOM.wrapper);
                }
                if (settings.position == 'topLeft' || settings.position == 'topCenter' || settings.position == 'topRight') $DOM.wrapper.insertBefore($DOM.toastCapsule, $DOM.wrapper.firstChild);
                else $DOM.wrapper.appendChild($DOM.toastCapsule);
            }
            if (!isNaN(settings.zindex)) $DOM.wrapper.style.zIndex = settings.zindex;
            else console.warn('[' + PLUGIN_NAME + '] Invalid zIndex.');
        })();
        // Overlay
        (function() {
            if (settings.overlay) {
                if (document.querySelector('.' + PLUGIN_NAME + '-overlay.fadeIn') !== null) {
                    $DOM.overlay = document.querySelector('.' + PLUGIN_NAME + '-overlay');
                    $DOM.overlay.setAttribute('data-iziToast-ref', $DOM.overlay.getAttribute('data-iziToast-ref') + ',' + settings.ref);
                    if (!isNaN(settings.zindex) && settings.zindex !== null) $DOM.overlay.style.zIndex = settings.zindex - 1;
                } else {
                    $DOM.overlay.classList.add(PLUGIN_NAME + '-overlay');
                    $DOM.overlay.classList.add('fadeIn');
                    $DOM.overlay.style.background = settings.overlayColor;
                    $DOM.overlay.setAttribute('data-iziToast-ref', settings.ref);
                    if (!isNaN(settings.zindex) && settings.zindex !== null) $DOM.overlay.style.zIndex = settings.zindex - 1;
                    document.querySelector('body').appendChild($DOM.overlay);
                }
                if (settings.overlayClose) {
                    $DOM.overlay.removeEventListener('click', {});
                    $DOM.overlay.addEventListener('click', function(e) {
                        that.hide(settings, $DOM.toast, 'overlay');
                    });
                } else $DOM.overlay.removeEventListener('click', {});
            }
        })();
        // Inside animations
        (function() {
            if (settings.animateInside) {
                $DOM.toast.classList.add(PLUGIN_NAME + '-animateInside');
                var animationTimes = [
                    200,
                    100,
                    300
                ];
                if (settings.transitionIn == 'bounceInLeft' || settings.transitionIn == 'bounceInRight') animationTimes = [
                    400,
                    200,
                    400
                ];
                if (settings.title.length > 0) setTimeout(function() {
                    $DOM.strong.classList.add('slideIn');
                }, animationTimes[0]);
                if (settings.message.length > 0) setTimeout(function() {
                    $DOM.p.classList.add('slideIn');
                }, animationTimes[1]);
                if (settings.icon || settings.iconUrl) setTimeout(function() {
                    $DOM.icon.classList.add('revealIn');
                }, animationTimes[2]);
                var counter = 150;
                if (settings.buttons.length > 0 && $DOM.buttons) setTimeout(function() {
                    forEach($DOM.buttons.childNodes, function(element, index) {
                        setTimeout(function() {
                            element.classList.add('revealIn');
                        }, counter);
                        counter = counter + 150;
                    });
                }, settings.inputs.length > 0 ? 150 : 0);
                if (settings.inputs.length > 0 && $DOM.inputs) {
                    counter = 150;
                    forEach($DOM.inputs.childNodes, function(element, index) {
                        setTimeout(function() {
                            element.classList.add('revealIn');
                        }, counter);
                        counter = counter + 150;
                    });
                }
            }
        })();
        settings.onOpening.apply(null, [
            settings,
            $DOM.toast
        ]);
        try {
            var event = new CustomEvent(PLUGIN_NAME + '-opening', {
                detail: settings,
                bubbles: true,
                cancelable: true
            });
            document.dispatchEvent(event);
        } catch (ex) {
            console.warn(ex);
        }
        setTimeout(function() {
            $DOM.toast.classList.remove(PLUGIN_NAME + '-opening');
            $DOM.toast.classList.add(PLUGIN_NAME + '-opened');
            try {
                var event = new CustomEvent(PLUGIN_NAME + '-opened', {
                    detail: settings,
                    bubbles: true,
                    cancelable: true
                });
                document.dispatchEvent(event);
            } catch (ex) {
                console.warn(ex);
            }
            settings.onOpened.apply(null, [
                settings,
                $DOM.toast
            ]);
        }, 1000);
        if (settings.drag) {
            if (ACCEPTSTOUCH) {
                $DOM.toast.addEventListener('touchstart', function(e) {
                    drag.startMoving(this, that, settings, e);
                }, false);
                $DOM.toast.addEventListener('touchend', function(e) {
                    drag.stopMoving(this, e);
                }, false);
            } else {
                $DOM.toast.addEventListener('mousedown', function(e) {
                    e.preventDefault();
                    drag.startMoving(this, that, settings, e);
                }, false);
                $DOM.toast.addEventListener('mouseup', function(e) {
                    e.preventDefault();
                    drag.stopMoving(this, e);
                }, false);
            }
        }
        if (settings.closeOnEscape) document.addEventListener('keyup', function(evt) {
            evt = evt || window.event;
            if (evt.keyCode == 27) that.hide(settings, $DOM.toast, 'esc');
        });
        if (settings.closeOnClick) $DOM.toast.addEventListener('click', function(evt) {
            that.hide(settings, $DOM.toast, 'toast');
        });
        that.toast = $DOM.toast;
    };
    return $iziToast;
});

});



parcelRegister("f1dSb", function(module, exports) {

$parcel$export(module.exports, "default", () => $aef1b5e4efa07008$export$2e2bcd8739ae039);

var $92Ocn = parcelRequire("92Ocn");

var $254a8 = parcelRequire("254a8");

var $fa4m4 = parcelRequire("fa4m4");

var $lSH1h = parcelRequire("lSH1h");
class $aef1b5e4efa07008$export$2e2bcd8739ae039 {
    static init() {
        this._sorter();
        this._filter();
        this._order();
        this._cell_link();
        this._sortable();
    }
    static _sorter() {
        const list = $('table.__sorter');
        if (list.length === 0) return;
        list.each((index, element)=>{
            const table = $(element);
            const column = (0, $lSH1h.default).int(table.data('sort-column')) ? Number(table.data('sort-column')) : 0;
            const order = table.data('sort-order') === 0 ? 0 : 1;
            // noinspection JSUnusedGlobalSymbols
            table.tablesorter({
                sortList: [
                    [
                        column,
                        order
                    ]
                ],
                sortInitialOrder: 'desc',
                textExtraction: (node)=>{
                    const value = $(node).attr('data-sort');
                    return typeof value !== 'undefined' ? value : $(node).text();
                }
            });
        });
    }
    static _filter() {
        $('table.__table-filter').each((index, element)=>{
            const table_filter = new (0, (/*@__PURE__*/$parcel$interopDefault($254a8)))(element, {
                auto_filter: {
                    delay: 100
                },
                single_filter: true
            });
            // noinspection JSUnresolvedFunction
            table_filter.init();
            element.querySelector('input').placeholder = "\u7D5E\u308A\u8FBC\u307F";
        });
    }
    static _order() {
        const table_order = $('table.__sorter_remote');
        if (table_order.length === 0) return;
        const key = table_order.data('order-key') || 'order';
        const key_reverse = table_order.data('order-key-reverse') || 'reverse';
        const key_page = table_order.data('order-key-page') || 'page';
        const match = new RegExp(`\\b${key}=([\\w.]+)`).exec(location.search);
        let ordered = match !== null ? match[1] : undefined;
        const reversed = !location.search.match(new RegExp(`\\b${key_reverse}=0`));
        // noinspection JSCheckFunctionSignatures
        table_order.find('thead th').each((index, element)=>{
            const cell = $(element);
            const name = cell.data('order');
            if (!name) return;
            if (ordered === undefined) ordered = name;
            cell.addClass('tablesorter-header');
            if (name === ordered) cell.addClass(reversed ? 'tablesorter-headerDesc' : 'tablesorter-headerAsc');
            cell.on('click', ()=>{
                if (!(0, $lSH1h.default).filled(name)) throw new (0, $fa4m4.ArgumentError)('No name given to sort');
                const reverse = !cell.hasClass('tablesorter-headerDesc');
                cell.parent().find('th').each((index, element)=>{
                    const cell = $(element);
                    cell.removeClass('tablesorter-headerAsc');
                    cell.removeClass('tablesorter-headerDesc');
                });
                if (reverse) {
                    cell.removeClass('tablesorter-headerAsc');
                    cell.addClass('tablesorter-headerDesc');
                } else {
                    cell.removeClass('tablesorter-headerDesc');
                    cell.addClass('tablesorter-headerAsc');
                }
                const query = location.search.replace(new RegExp(`[&?]${key}=[\\w.]*`), '').replace(new RegExp(`[&?]${key_reverse}=[01]`), '').replace(new RegExp(`[&?]${key_page}=\\d*`), '');
                const connector = query === '' ? '?' : '&';
                location.search = `${query}${connector}${key}=${name}&${key_reverse}=${reverse ? 1 : 0}`;
            });
        });
    }
    static _cell_link() {
        $('table.__list tbody tr').each((index, row)=>{
            const link = $(row).data('href');
            if (!link) return;
            const target = $(row).data('href-target');
            const row_element = $(row);
            // noinspection JSCheckFunctionSignatures
            row_element.find('> td:not(.__no_link)').each((index2, cell)=>{
                if (cell.firstChild && cell.firstChild.nodeName === 'A') {
                    $(cell.firstChild).addClass('inline-block');
                    return;
                }
                const cell_element = $(cell);
                const anchor = document.createElement('a');
                if (target) anchor.target = target;
                anchor.href = link;
                cell_element.contents().appendTo(anchor);
                $(anchor).appendTo(cell_element);
            });
        });
    }
    static _sortable() {
        $('.__sortable').each((index, element)=>{
            new (0, $92Ocn.default)(element, {
                draggable: '.__sortable > *:not(.__sortable_disabled)'
            });
        });
    }
}

});
parcelRegister("92Ocn", function(module, exports) {

$parcel$export(module.exports, "default", () => $695b3d6025d5e530$export$2e2bcd8739ae039);
/**!
 * Sortable 1.15.6
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */ function $695b3d6025d5e530$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $695b3d6025d5e530$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $695b3d6025d5e530$var$ownKeys(Object(source), true).forEach(function(key) {
            $695b3d6025d5e530$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $695b3d6025d5e530$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $695b3d6025d5e530$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $695b3d6025d5e530$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $695b3d6025d5e530$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $695b3d6025d5e530$var$_typeof(obj);
}
function $695b3d6025d5e530$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $695b3d6025d5e530$var$_extends() {
    $695b3d6025d5e530$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $695b3d6025d5e530$var$_extends.apply(this, arguments);
}
function $695b3d6025d5e530$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $695b3d6025d5e530$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $695b3d6025d5e530$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $695b3d6025d5e530$var$_toConsumableArray(arr) {
    return $695b3d6025d5e530$var$_arrayWithoutHoles(arr) || $695b3d6025d5e530$var$_iterableToArray(arr) || $695b3d6025d5e530$var$_unsupportedIterableToArray(arr) || $695b3d6025d5e530$var$_nonIterableSpread();
}
function $695b3d6025d5e530$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $695b3d6025d5e530$var$_arrayLikeToArray(arr);
}
function $695b3d6025d5e530$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $695b3d6025d5e530$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $695b3d6025d5e530$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $695b3d6025d5e530$var$_arrayLikeToArray(o, minLen);
}
function $695b3d6025d5e530$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $695b3d6025d5e530$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $695b3d6025d5e530$var$version = "1.15.6";
function $695b3d6025d5e530$var$userAgent(pattern) {
    if (typeof window !== 'undefined' && window.navigator) return !!/*@__PURE__*/ navigator.userAgent.match(pattern);
}
var $695b3d6025d5e530$var$IE11OrLess = $695b3d6025d5e530$var$userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var $695b3d6025d5e530$var$Edge = $695b3d6025d5e530$var$userAgent(/Edge/i);
var $695b3d6025d5e530$var$FireFox = $695b3d6025d5e530$var$userAgent(/firefox/i);
var $695b3d6025d5e530$var$Safari = $695b3d6025d5e530$var$userAgent(/safari/i) && !$695b3d6025d5e530$var$userAgent(/chrome/i) && !$695b3d6025d5e530$var$userAgent(/android/i);
var $695b3d6025d5e530$var$IOS = $695b3d6025d5e530$var$userAgent(/iP(ad|od|hone)/i);
var $695b3d6025d5e530$var$ChromeForAndroid = $695b3d6025d5e530$var$userAgent(/chrome/i) && $695b3d6025d5e530$var$userAgent(/android/i);
var $695b3d6025d5e530$var$captureMode = {
    capture: false,
    passive: false
};
function $695b3d6025d5e530$var$on(el, event, fn) {
    el.addEventListener(event, fn, !$695b3d6025d5e530$var$IE11OrLess && $695b3d6025d5e530$var$captureMode);
}
function $695b3d6025d5e530$var$off(el, event, fn) {
    el.removeEventListener(event, fn, !$695b3d6025d5e530$var$IE11OrLess && $695b3d6025d5e530$var$captureMode);
}
function $695b3d6025d5e530$var$matches(/**HTMLElement*/ el, /**String*/ selector) {
    if (!selector) return;
    selector[0] === '>' && (selector = selector.substring(1));
    if (el) try {
        if (el.matches) return el.matches(selector);
        else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    } catch (_) {
        return false;
    }
    return false;
}
function $695b3d6025d5e530$var$getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function $695b3d6025d5e530$var$closest(/**HTMLElement*/ el, /**String*/ selector, /**HTMLElement*/ ctx, includeCTX) {
    if (el) {
        ctx = ctx || document;
        do {
            if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && $695b3d6025d5e530$var$matches(el, selector) : $695b3d6025d5e530$var$matches(el, selector)) || includeCTX && el === ctx) return el;
            if (el === ctx) break;
        /* jshint boss:true */ }while (el = $695b3d6025d5e530$var$getParentOrHost(el));
    }
    return null;
}
var $695b3d6025d5e530$var$R_SPACE = /\s+/g;
function $695b3d6025d5e530$var$toggleClass(el, name, state) {
    if (el && name) {
        if (el.classList) el.classList[state ? 'add' : 'remove'](name);
        else {
            var className = (' ' + el.className + ' ').replace($695b3d6025d5e530$var$R_SPACE, ' ').replace(' ' + name + ' ', ' ');
            el.className = (className + (state ? ' ' + name : '')).replace($695b3d6025d5e530$var$R_SPACE, ' ');
        }
    }
}
function $695b3d6025d5e530$var$css(el, prop, val) {
    var style = el && el.style;
    if (style) {
        if (val === void 0) {
            if (document.defaultView && document.defaultView.getComputedStyle) val = document.defaultView.getComputedStyle(el, '');
            else if (el.currentStyle) val = el.currentStyle;
            return prop === void 0 ? val : val[prop];
        } else {
            if (!(prop in style) && prop.indexOf('webkit') === -1) prop = '-webkit-' + prop;
            style[prop] = val + (typeof val === 'string' ? '' : 'px');
        }
    }
}
function $695b3d6025d5e530$var$matrix(el, selfOnly) {
    var appliedTransforms = '';
    if (typeof el === 'string') appliedTransforms = el;
    else do {
        var transform = $695b3d6025d5e530$var$css(el, 'transform');
        if (transform && transform !== 'none') appliedTransforms = transform + ' ' + appliedTransforms;
    /* jshint boss:true */ }while (!selfOnly && (el = el.parentNode));
    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    /*jshint -W056 */ return matrixFn && new matrixFn(appliedTransforms);
}
function $695b3d6025d5e530$var$find(ctx, tagName, iterator) {
    if (ctx) {
        var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
        if (iterator) for(; i < n; i++)iterator(list[i], i);
        return list;
    }
    return [];
}
function $695b3d6025d5e530$var$getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;
    if (scrollingElement) return scrollingElement;
    else return document.documentElement;
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */ function $695b3d6025d5e530$var$getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;
    if (el !== window && el.parentNode && el !== $695b3d6025d5e530$var$getWindowScrollingElement()) {
        elRect = el.getBoundingClientRect();
        top = elRect.top;
        left = elRect.left;
        bottom = elRect.bottom;
        right = elRect.right;
        height = elRect.height;
        width = elRect.width;
    } else {
        top = 0;
        left = 0;
        bottom = window.innerHeight;
        right = window.innerWidth;
        height = window.innerHeight;
        width = window.innerWidth;
    }
    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
        // Adjust for translate()
        container = container || el.parentNode;
        // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
        // Not needed on <= IE11
        if (!$695b3d6025d5e530$var$IE11OrLess) {
            do if (container && container.getBoundingClientRect && ($695b3d6025d5e530$var$css(container, 'transform') !== 'none' || relativeToNonStaticParent && $695b3d6025d5e530$var$css(container, 'position') !== 'static')) {
                var containerRect = container.getBoundingClientRect();
                // Set relative to edges of padding box of container
                top -= containerRect.top + parseInt($695b3d6025d5e530$var$css(container, 'border-top-width'));
                left -= containerRect.left + parseInt($695b3d6025d5e530$var$css(container, 'border-left-width'));
                bottom = top + elRect.height;
                right = left + elRect.width;
                break;
            }
            while (container = container.parentNode);
        }
    }
    if (undoScale && el !== window) {
        // Adjust for scale()
        var elMatrix = $695b3d6025d5e530$var$matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
        if (elMatrix) {
            top /= scaleY;
            left /= scaleX;
            width /= scaleX;
            height /= scaleY;
            bottom = top + height;
            right = left + width;
        }
    }
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        width: width,
        height: height
    };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */ function $695b3d6025d5e530$var$isScrolledPast(el, elSide, parentSide) {
    var parent = $695b3d6025d5e530$var$getParentAutoScrollElement(el, true), elSideVal = $695b3d6025d5e530$var$getRect(el)[elSide];
    /* jshint boss:true */ while(parent){
        var parentSideVal = $695b3d6025d5e530$var$getRect(parent)[parentSide], visible = void 0;
        if (parentSide === 'top' || parentSide === 'left') visible = elSideVal >= parentSideVal;
        else visible = elSideVal <= parentSideVal;
        if (!visible) return parent;
        if (parent === $695b3d6025d5e530$var$getWindowScrollingElement()) break;
        parent = $695b3d6025d5e530$var$getParentAutoScrollElement(parent, false);
    }
    return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */ function $695b3d6025d5e530$var$getChild(el, childNum, options, includeDragEl) {
    var currentChild = 0, i = 0, children = el.children;
    while(i < children.length){
        if (children[i].style.display !== 'none' && children[i] !== $695b3d6025d5e530$export$31b3ca70d8f57423.ghost && (includeDragEl || children[i] !== $695b3d6025d5e530$export$31b3ca70d8f57423.dragged) && $695b3d6025d5e530$var$closest(children[i], options.draggable, el, false)) {
            if (currentChild === childNum) return children[i];
            currentChild++;
        }
        i++;
    }
    return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */ function $695b3d6025d5e530$var$lastChild(el, selector) {
    var last = el.lastElementChild;
    while(last && (last === $695b3d6025d5e530$export$31b3ca70d8f57423.ghost || $695b3d6025d5e530$var$css(last, 'display') === 'none' || selector && !$695b3d6025d5e530$var$matches(last, selector)))last = last.previousElementSibling;
    return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */ function $695b3d6025d5e530$var$index(el, selector) {
    var index = 0;
    if (!el || !el.parentNode) return -1;
    /* jshint boss:true */ while(el = el.previousElementSibling)if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== $695b3d6025d5e530$export$31b3ca70d8f57423.clone && (!selector || $695b3d6025d5e530$var$matches(el, selector))) index++;
    return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */ function $695b3d6025d5e530$var$getRelativeScrollOffset(el) {
    var offsetLeft = 0, offsetTop = 0, winScroller = $695b3d6025d5e530$var$getWindowScrollingElement();
    if (el) do {
        var elMatrix = $695b3d6025d5e530$var$matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
    }while (el !== winScroller && (el = el.parentNode));
    return [
        offsetLeft,
        offsetTop
    ];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */ function $695b3d6025d5e530$var$indexOfObject(arr, obj) {
    for(var i in arr){
        if (!arr.hasOwnProperty(i)) continue;
        for(var key in obj){
            if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
        }
    }
    return -1;
}
function $695b3d6025d5e530$var$getParentAutoScrollElement(el, includeSelf) {
    // skip to window
    if (!el || !el.getBoundingClientRect) return $695b3d6025d5e530$var$getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;
    do // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = $695b3d6025d5e530$var$css(elem);
        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
            if (!elem.getBoundingClientRect || elem === document.body) return $695b3d6025d5e530$var$getWindowScrollingElement();
            if (gotSelf || includeSelf) return elem;
            gotSelf = true;
        }
    }
    while (elem = elem.parentNode);
    return $695b3d6025d5e530$var$getWindowScrollingElement();
}
function $695b3d6025d5e530$var$extend(dst, src) {
    if (dst && src) {
        for(var key in src)if (src.hasOwnProperty(key)) dst[key] = src[key];
    }
    return dst;
}
function $695b3d6025d5e530$var$isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var $695b3d6025d5e530$var$_throttleTimeout;
function $695b3d6025d5e530$var$throttle(callback, ms) {
    return function() {
        if (!$695b3d6025d5e530$var$_throttleTimeout) {
            var args = arguments, _this = this;
            if (args.length === 1) callback.call(_this, args[0]);
            else callback.apply(_this, args);
            $695b3d6025d5e530$var$_throttleTimeout = setTimeout(function() {
                $695b3d6025d5e530$var$_throttleTimeout = void 0;
            }, ms);
        }
    };
}
function $695b3d6025d5e530$var$cancelThrottle() {
    clearTimeout($695b3d6025d5e530$var$_throttleTimeout);
    $695b3d6025d5e530$var$_throttleTimeout = void 0;
}
function $695b3d6025d5e530$var$scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
}
function $695b3d6025d5e530$var$clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;
    if (Polymer && Polymer.dom) return Polymer.dom(el).cloneNode(true);
    else if ($) return $(el).clone(true)[0];
    else return el.cloneNode(true);
}
function $695b3d6025d5e530$var$setRect(el, rect) {
    $695b3d6025d5e530$var$css(el, 'position', 'absolute');
    $695b3d6025d5e530$var$css(el, 'top', rect.top);
    $695b3d6025d5e530$var$css(el, 'left', rect.left);
    $695b3d6025d5e530$var$css(el, 'width', rect.width);
    $695b3d6025d5e530$var$css(el, 'height', rect.height);
}
function $695b3d6025d5e530$var$unsetRect(el) {
    $695b3d6025d5e530$var$css(el, 'position', '');
    $695b3d6025d5e530$var$css(el, 'top', '');
    $695b3d6025d5e530$var$css(el, 'left', '');
    $695b3d6025d5e530$var$css(el, 'width', '');
    $695b3d6025d5e530$var$css(el, 'height', '');
}
function $695b3d6025d5e530$var$getChildContainingRectFromElement(container, options, ghostEl) {
    var rect = {};
    Array.from(container.children).forEach(function(child) {
        var _rect$left, _rect$top, _rect$right, _rect$bottom;
        if (!$695b3d6025d5e530$var$closest(child, options.draggable, container, false) || child.animated || child === ghostEl) return;
        var childRect = $695b3d6025d5e530$var$getRect(child);
        rect.left = Math.min((_rect$left = rect.left) !== null && _rect$left !== void 0 ? _rect$left : Infinity, childRect.left);
        rect.top = Math.min((_rect$top = rect.top) !== null && _rect$top !== void 0 ? _rect$top : Infinity, childRect.top);
        rect.right = Math.max((_rect$right = rect.right) !== null && _rect$right !== void 0 ? _rect$right : -Infinity, childRect.right);
        rect.bottom = Math.max((_rect$bottom = rect.bottom) !== null && _rect$bottom !== void 0 ? _rect$bottom : -Infinity, childRect.bottom);
    });
    rect.width = rect.right - rect.left;
    rect.height = rect.bottom - rect.top;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
var $695b3d6025d5e530$var$expando = 'Sortable' + new Date().getTime();
function $695b3d6025d5e530$var$AnimationStateManager() {
    var animationStates = [], animationCallbackId;
    return {
        captureAnimationState: function captureAnimationState() {
            animationStates = [];
            if (!this.options.animation) return;
            var children = [].slice.call(this.el.children);
            children.forEach(function(child) {
                if ($695b3d6025d5e530$var$css(child, 'display') === 'none' || child === $695b3d6025d5e530$export$31b3ca70d8f57423.ghost) return;
                animationStates.push({
                    target: child,
                    rect: $695b3d6025d5e530$var$getRect(child)
                });
                var fromRect = $695b3d6025d5e530$var$_objectSpread2({}, animationStates[animationStates.length - 1].rect);
                // If animating: compensate for current animation
                if (child.thisAnimationDuration) {
                    var childMatrix = $695b3d6025d5e530$var$matrix(child, true);
                    if (childMatrix) {
                        fromRect.top -= childMatrix.f;
                        fromRect.left -= childMatrix.e;
                    }
                }
                child.fromRect = fromRect;
            });
        },
        addAnimationState: function addAnimationState(state) {
            animationStates.push(state);
        },
        removeAnimationState: function removeAnimationState(target) {
            animationStates.splice($695b3d6025d5e530$var$indexOfObject(animationStates, {
                target: target
            }), 1);
        },
        animateAll: function animateAll(callback) {
            var _this = this;
            if (!this.options.animation) {
                clearTimeout(animationCallbackId);
                if (typeof callback === 'function') callback();
                return;
            }
            var animating = false, animationTime = 0;
            animationStates.forEach(function(state) {
                var time = 0, target = state.target, fromRect = target.fromRect, toRect = $695b3d6025d5e530$var$getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = $695b3d6025d5e530$var$matrix(target, true);
                if (targetMatrix) {
                    // Compensate for current animation
                    toRect.top -= targetMatrix.f;
                    toRect.left -= targetMatrix.e;
                }
                target.toRect = toRect;
                if (target.thisAnimationDuration) // Could also check if animatingRect is between fromRect and toRect
                {
                    if ($695b3d6025d5e530$var$isRectEqual(prevFromRect, toRect) && !$695b3d6025d5e530$var$isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
                    (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) // If returning to same place as started from animation and on same axis
                    time = $695b3d6025d5e530$var$calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                }
                // if fromRect != toRect: animate
                if (!$695b3d6025d5e530$var$isRectEqual(toRect, fromRect)) {
                    target.prevFromRect = fromRect;
                    target.prevToRect = toRect;
                    if (!time) time = _this.options.animation;
                    _this.animate(target, animatingRect, toRect, time);
                }
                if (time) {
                    animating = true;
                    animationTime = Math.max(animationTime, time);
                    clearTimeout(target.animationResetTimer);
                    target.animationResetTimer = setTimeout(function() {
                        target.animationTime = 0;
                        target.prevFromRect = null;
                        target.fromRect = null;
                        target.prevToRect = null;
                        target.thisAnimationDuration = null;
                    }, time);
                    target.thisAnimationDuration = time;
                }
            });
            clearTimeout(animationCallbackId);
            if (!animating) {
                if (typeof callback === 'function') callback();
            } else animationCallbackId = setTimeout(function() {
                if (typeof callback === 'function') callback();
            }, animationTime);
            animationStates = [];
        },
        animate: function animate(target, currentRect, toRect, duration) {
            if (duration) {
                $695b3d6025d5e530$var$css(target, 'transition', '');
                $695b3d6025d5e530$var$css(target, 'transform', '');
                var elMatrix = $695b3d6025d5e530$var$matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                target.animatingX = !!translateX;
                target.animatingY = !!translateY;
                $695b3d6025d5e530$var$css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
                this.forRepaintDummy = $695b3d6025d5e530$var$repaint(target); // repaint
                $695b3d6025d5e530$var$css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
                $695b3d6025d5e530$var$css(target, 'transform', 'translate3d(0,0,0)');
                typeof target.animated === 'number' && clearTimeout(target.animated);
                target.animated = setTimeout(function() {
                    $695b3d6025d5e530$var$css(target, 'transition', '');
                    $695b3d6025d5e530$var$css(target, 'transform', '');
                    target.animated = false;
                    target.animatingX = false;
                    target.animatingY = false;
                }, duration);
            }
        }
    };
}
function $695b3d6025d5e530$var$repaint(target) {
    return target.offsetWidth;
}
function $695b3d6025d5e530$var$calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var $695b3d6025d5e530$var$plugins = [];
var $695b3d6025d5e530$var$defaults = {
    initializeByDefault: true
};
var $695b3d6025d5e530$var$PluginManager = {
    mount: function mount(plugin) {
        // Set default static properties
        for(var option in $695b3d6025d5e530$var$defaults)if ($695b3d6025d5e530$var$defaults.hasOwnProperty(option) && !(option in plugin)) plugin[option] = $695b3d6025d5e530$var$defaults[option];
        $695b3d6025d5e530$var$plugins.forEach(function(p) {
            if (p.pluginName === plugin.pluginName) throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
        });
        $695b3d6025d5e530$var$plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
        var _this = this;
        this.eventCanceled = false;
        evt.cancel = function() {
            _this.eventCanceled = true;
        };
        var eventNameGlobal = eventName + 'Global';
        $695b3d6025d5e530$var$plugins.forEach(function(plugin) {
            if (!sortable[plugin.pluginName]) return;
            // Fire global events if it exists in this sortable
            if (sortable[plugin.pluginName][eventNameGlobal]) sortable[plugin.pluginName][eventNameGlobal]($695b3d6025d5e530$var$_objectSpread2({
                sortable: sortable
            }, evt));
            // Only fire plugin event if plugin is enabled in this sortable,
            // and plugin has event defined
            if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) sortable[plugin.pluginName][eventName]($695b3d6025d5e530$var$_objectSpread2({
                sortable: sortable
            }, evt));
        });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
        $695b3d6025d5e530$var$plugins.forEach(function(plugin) {
            var pluginName = plugin.pluginName;
            if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
            var initialized = new plugin(sortable, el, sortable.options);
            initialized.sortable = sortable;
            initialized.options = sortable.options;
            sortable[pluginName] = initialized;
            // Add default options from plugin
            $695b3d6025d5e530$var$_extends(defaults, initialized.defaults);
        });
        for(var option in sortable.options){
            if (!sortable.options.hasOwnProperty(option)) continue;
            var modified = this.modifyOption(sortable, option, sortable.options[option]);
            if (typeof modified !== 'undefined') sortable.options[option] = modified;
        }
    },
    getEventProperties: function getEventProperties(name, sortable) {
        var eventProperties = {};
        $695b3d6025d5e530$var$plugins.forEach(function(plugin) {
            if (typeof plugin.eventProperties !== 'function') return;
            $695b3d6025d5e530$var$_extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
        });
        return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
        var modifiedValue;
        $695b3d6025d5e530$var$plugins.forEach(function(plugin) {
            // Plugin must exist on the Sortable
            if (!sortable[plugin.pluginName]) return;
            // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
            if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        });
        return modifiedValue;
    }
};
function $695b3d6025d5e530$var$dispatchEvent(_ref) {
    var sortable = _ref.sortable, rootEl = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex = _ref.oldIndex, newIndex = _ref.newIndex, oldDraggableIndex = _ref.oldDraggableIndex, newDraggableIndex = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl && rootEl[$695b3d6025d5e530$var$expando];
    if (!sortable) return;
    var evt, options = sortable.options, onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1);
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$695b3d6025d5e530$var$IE11OrLess && !$695b3d6025d5e530$var$Edge) evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent('Event');
        evt.initEvent(name, true, true);
    }
    evt.to = toEl || rootEl;
    evt.from = fromEl || rootEl;
    evt.item = targetEl || rootEl;
    evt.clone = cloneEl;
    evt.oldIndex = oldIndex;
    evt.newIndex = newIndex;
    evt.oldDraggableIndex = oldDraggableIndex;
    evt.newDraggableIndex = newDraggableIndex;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
    var allEventProperties = $695b3d6025d5e530$var$_objectSpread2($695b3d6025d5e530$var$_objectSpread2({}, extraEventProperties), $695b3d6025d5e530$var$PluginManager.getEventProperties(name, sortable));
    for(var option in allEventProperties)evt[option] = allEventProperties[option];
    if (rootEl) rootEl.dispatchEvent(evt);
    if (options[onName]) options[onName].call(sortable, evt);
}
var $695b3d6025d5e530$var$_excluded = [
    "evt"
];
var $695b3d6025d5e530$var$pluginEvent = function pluginEvent(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, originalEvent = _ref.evt, data = $695b3d6025d5e530$var$_objectWithoutProperties(_ref, $695b3d6025d5e530$var$_excluded);
    $695b3d6025d5e530$var$PluginManager.pluginEvent.bind($695b3d6025d5e530$export$31b3ca70d8f57423)(eventName, sortable, $695b3d6025d5e530$var$_objectSpread2({
        dragEl: $695b3d6025d5e530$var$dragEl,
        parentEl: $695b3d6025d5e530$var$parentEl,
        ghostEl: $695b3d6025d5e530$var$ghostEl,
        rootEl: $695b3d6025d5e530$var$rootEl,
        nextEl: $695b3d6025d5e530$var$nextEl,
        lastDownEl: $695b3d6025d5e530$var$lastDownEl,
        cloneEl: $695b3d6025d5e530$var$cloneEl,
        cloneHidden: $695b3d6025d5e530$var$cloneHidden,
        dragStarted: $695b3d6025d5e530$var$moved,
        putSortable: $695b3d6025d5e530$var$putSortable,
        activeSortable: $695b3d6025d5e530$export$31b3ca70d8f57423.active,
        originalEvent: originalEvent,
        oldIndex: $695b3d6025d5e530$var$oldIndex,
        oldDraggableIndex: $695b3d6025d5e530$var$oldDraggableIndex,
        newIndex: $695b3d6025d5e530$var$newIndex,
        newDraggableIndex: $695b3d6025d5e530$var$newDraggableIndex,
        hideGhostForTarget: $695b3d6025d5e530$var$_hideGhostForTarget,
        unhideGhostForTarget: $695b3d6025d5e530$var$_unhideGhostForTarget,
        cloneNowHidden: function cloneNowHidden() {
            $695b3d6025d5e530$var$cloneHidden = true;
        },
        cloneNowShown: function cloneNowShown() {
            $695b3d6025d5e530$var$cloneHidden = false;
        },
        dispatchSortableEvent: function dispatchSortableEvent(name) {
            $695b3d6025d5e530$var$_dispatchEvent({
                sortable: sortable,
                name: name,
                originalEvent: originalEvent
            });
        }
    }, data));
};
function $695b3d6025d5e530$var$_dispatchEvent(info) {
    $695b3d6025d5e530$var$dispatchEvent($695b3d6025d5e530$var$_objectSpread2({
        putSortable: $695b3d6025d5e530$var$putSortable,
        cloneEl: $695b3d6025d5e530$var$cloneEl,
        targetEl: $695b3d6025d5e530$var$dragEl,
        rootEl: $695b3d6025d5e530$var$rootEl,
        oldIndex: $695b3d6025d5e530$var$oldIndex,
        oldDraggableIndex: $695b3d6025d5e530$var$oldDraggableIndex,
        newIndex: $695b3d6025d5e530$var$newIndex,
        newDraggableIndex: $695b3d6025d5e530$var$newDraggableIndex
    }, info));
}
var $695b3d6025d5e530$var$dragEl, $695b3d6025d5e530$var$parentEl, $695b3d6025d5e530$var$ghostEl, $695b3d6025d5e530$var$rootEl, $695b3d6025d5e530$var$nextEl, $695b3d6025d5e530$var$lastDownEl, $695b3d6025d5e530$var$cloneEl, $695b3d6025d5e530$var$cloneHidden, $695b3d6025d5e530$var$oldIndex, $695b3d6025d5e530$var$newIndex, $695b3d6025d5e530$var$oldDraggableIndex, $695b3d6025d5e530$var$newDraggableIndex, $695b3d6025d5e530$var$activeGroup, $695b3d6025d5e530$var$putSortable, $695b3d6025d5e530$var$awaitingDragStarted = false, $695b3d6025d5e530$var$ignoreNextClick = false, $695b3d6025d5e530$var$sortables = [], $695b3d6025d5e530$var$tapEvt, $695b3d6025d5e530$var$touchEvt, $695b3d6025d5e530$var$lastDx, $695b3d6025d5e530$var$lastDy, $695b3d6025d5e530$var$tapDistanceLeft, $695b3d6025d5e530$var$tapDistanceTop, $695b3d6025d5e530$var$moved, $695b3d6025d5e530$var$lastTarget, $695b3d6025d5e530$var$lastDirection, $695b3d6025d5e530$var$pastFirstInvertThresh = false, $695b3d6025d5e530$var$isCircumstantialInvert = false, $695b3d6025d5e530$var$targetMoveDistance, // For positioning ghost absolutely
$695b3d6025d5e530$var$ghostRelativeParent, $695b3d6025d5e530$var$ghostRelativeParentInitialScroll = [], // (left, top)
$695b3d6025d5e530$var$_silent = false, $695b3d6025d5e530$var$savedInputChecked = [];
/** @const */ var $695b3d6025d5e530$var$documentExists = typeof document !== 'undefined', $695b3d6025d5e530$var$PositionGhostAbsolutely = $695b3d6025d5e530$var$IOS, $695b3d6025d5e530$var$CSSFloatProperty = $695b3d6025d5e530$var$Edge || $695b3d6025d5e530$var$IE11OrLess ? 'cssFloat' : 'float', // This will not pass for IE9, because IE9 DnD only works on anchors
$695b3d6025d5e530$var$supportDraggable = $695b3d6025d5e530$var$documentExists && !$695b3d6025d5e530$var$ChromeForAndroid && !$695b3d6025d5e530$var$IOS && 'draggable' in document.createElement('div'), $695b3d6025d5e530$var$supportCssPointerEvents = function() {
    if (!$695b3d6025d5e530$var$documentExists) return;
    // false when <= IE11
    if ($695b3d6025d5e530$var$IE11OrLess) return false;
    var el = document.createElement('x');
    el.style.cssText = 'pointer-events:auto';
    return el.style.pointerEvents === 'auto';
}(), $695b3d6025d5e530$var$_detectDirection = function _detectDirection(el, options) {
    var elCSS = $695b3d6025d5e530$var$css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = $695b3d6025d5e530$var$getChild(el, 0, options), child2 = $695b3d6025d5e530$var$getChild(el, 1, options), firstChildCSS = child1 && $695b3d6025d5e530$var$css(child1), secondChildCSS = child2 && $695b3d6025d5e530$var$css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + $695b3d6025d5e530$var$getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + $695b3d6025d5e530$var$getRect(child2).width;
    if (elCSS.display === 'flex') return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
    if (elCSS.display === 'grid') return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
        var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
        return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
    }
    return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[$695b3d6025d5e530$var$CSSFloatProperty] === 'none' || child2 && elCSS[$695b3d6025d5e530$var$CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
}, $695b3d6025d5e530$var$_dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, /**
   * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
   * @param  {Number} x      X position
   * @param  {Number} y      Y position
   * @return {HTMLElement}   Element of the first found nearest Sortable
   */ $695b3d6025d5e530$var$_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
    var ret;
    $695b3d6025d5e530$var$sortables.some(function(sortable) {
        var threshold = sortable[$695b3d6025d5e530$var$expando].options.emptyInsertThreshold;
        if (!threshold || $695b3d6025d5e530$var$lastChild(sortable)) return;
        var rect = $695b3d6025d5e530$var$getRect(sortable), insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
        if (insideHorizontally && insideVertically) return ret = sortable;
    });
    return ret;
}, $695b3d6025d5e530$var$_prepareGroup = function _prepareGroup(options) {
    function toFn(value, pull) {
        return function(to, from, dragEl, evt) {
            var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
            if (value == null && (pull || sameGroup)) // Default pull value
            // Default pull and put value if same group
            return true;
            else if (value == null || value === false) return false;
            else if (pull && value === 'clone') return value;
            else if (typeof value === 'function') return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
            else {
                var otherGroup = (pull ? to : from).options.group.name;
                return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
            }
        };
    }
    var group = {};
    var originalGroup = options.group;
    if (!originalGroup || $695b3d6025d5e530$var$_typeof(originalGroup) != 'object') originalGroup = {
        name: originalGroup
    };
    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
}, $695b3d6025d5e530$var$_hideGhostForTarget = function _hideGhostForTarget() {
    if (!$695b3d6025d5e530$var$supportCssPointerEvents && $695b3d6025d5e530$var$ghostEl) $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, 'display', 'none');
}, $695b3d6025d5e530$var$_unhideGhostForTarget = function _unhideGhostForTarget() {
    if (!$695b3d6025d5e530$var$supportCssPointerEvents && $695b3d6025d5e530$var$ghostEl) $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, 'display', '');
};
// #1184 fix - Prevent click event on fallback if dragged but item not changed position
if ($695b3d6025d5e530$var$documentExists && !$695b3d6025d5e530$var$ChromeForAndroid) document.addEventListener('click', function(evt) {
    if ($695b3d6025d5e530$var$ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        $695b3d6025d5e530$var$ignoreNextClick = false;
        return false;
    }
}, true);
var $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
    if ($695b3d6025d5e530$var$dragEl) {
        evt = evt.touches ? evt.touches[0] : evt;
        var nearest = $695b3d6025d5e530$var$_detectNearestEmptySortable(evt.clientX, evt.clientY);
        if (nearest) {
            // Create imitation event
            var event = {};
            for(var i in evt)if (evt.hasOwnProperty(i)) event[i] = evt[i];
            event.target = event.rootEl = nearest;
            event.preventDefault = void 0;
            event.stopPropagation = void 0;
            nearest[$695b3d6025d5e530$var$expando]._onDragOver(event);
        }
    }
};
var $695b3d6025d5e530$var$_checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
    if ($695b3d6025d5e530$var$dragEl) $695b3d6025d5e530$var$dragEl.parentNode[$695b3d6025d5e530$var$expando]._isOutsideThisEl(evt.target);
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */ function $695b3d6025d5e530$export$31b3ca70d8f57423(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) throw "Sortable: `el` must be an HTMLElement, not ".concat(({}).toString.call(el));
    this.el = el; // root element
    this.options = options = $695b3d6025d5e530$var$_extends({}, options);
    // Export instance
    el[$695b3d6025d5e530$var$expando] = this;
    var defaults = {
        group: null,
        sort: true,
        disabled: false,
        store: null,
        handle: null,
        draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
        swapThreshold: 1,
        // percentage; 0 <= x <= 1
        invertSwap: false,
        // invert always
        invertedSwapThreshold: null,
        // will be set to same as swapThreshold if default
        removeCloneOnHide: true,
        direction: function direction() {
            return $695b3d6025d5e530$var$_detectDirection(el, this.options);
        },
        ghostClass: 'sortable-ghost',
        chosenClass: 'sortable-chosen',
        dragClass: 'sortable-drag',
        ignore: 'a, img',
        filter: null,
        preventOnFilter: true,
        animation: 0,
        easing: null,
        setData: function setData(dataTransfer, dragEl) {
            dataTransfer.setData('Text', dragEl.textContent);
        },
        dropBubble: false,
        dragoverBubble: false,
        dataIdAttr: 'data-id',
        delay: 0,
        delayOnTouchOnly: false,
        touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
        forceFallback: false,
        fallbackClass: 'sortable-fallback',
        fallbackOnBody: false,
        fallbackTolerance: 0,
        fallbackOffset: {
            x: 0,
            y: 0
        },
        // Disabled on Safari: #1571; Enabled on Safari IOS: #2244
        supportPointer: $695b3d6025d5e530$export$31b3ca70d8f57423.supportPointer !== false && 'PointerEvent' in window && (!$695b3d6025d5e530$var$Safari || $695b3d6025d5e530$var$IOS),
        emptyInsertThreshold: 5
    };
    $695b3d6025d5e530$var$PluginManager.initializePlugins(this, el, defaults);
    // Set default options
    for(var name in defaults)!(name in options) && (options[name] = defaults[name]);
    $695b3d6025d5e530$var$_prepareGroup(options);
    // Bind all private methods
    for(var fn in this)if (fn.charAt(0) === '_' && typeof this[fn] === 'function') this[fn] = this[fn].bind(this);
    // Setup drag mode
    this.nativeDraggable = options.forceFallback ? false : $695b3d6025d5e530$var$supportDraggable;
    if (this.nativeDraggable) // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
    // Bind events
    if (options.supportPointer) $695b3d6025d5e530$var$on(el, 'pointerdown', this._onTapStart);
    else {
        $695b3d6025d5e530$var$on(el, 'mousedown', this._onTapStart);
        $695b3d6025d5e530$var$on(el, 'touchstart', this._onTapStart);
    }
    if (this.nativeDraggable) {
        $695b3d6025d5e530$var$on(el, 'dragover', this);
        $695b3d6025d5e530$var$on(el, 'dragenter', this);
    }
    $695b3d6025d5e530$var$sortables.push(this.el);
    // Restore sorting
    options.store && options.store.get && this.sort(options.store.get(this) || []);
    // Add animation state manager
    $695b3d6025d5e530$var$_extends(this, $695b3d6025d5e530$var$AnimationStateManager());
}
$695b3d6025d5e530$export$31b3ca70d8f57423.prototype = /** @lends Sortable.prototype */ {
    constructor: $695b3d6025d5e530$export$31b3ca70d8f57423,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
        if (!this.el.contains(target) && target !== this.el) $695b3d6025d5e530$var$lastTarget = null;
    },
    _getDirection: function _getDirection(evt, target) {
        return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, $695b3d6025d5e530$var$dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart(/** Event|TouchEvent */ evt) {
        if (!evt.cancelable) return;
        var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
        $695b3d6025d5e530$var$_saveInputCheckedState(el);
        // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
        if ($695b3d6025d5e530$var$dragEl) return;
        if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) return; // only left button and enabled
        // cancel dnd if original target is content editable
        if (originalTarget.isContentEditable) return;
        // Safari ignores further event handling after mousedown
        if (!this.nativeDraggable && $695b3d6025d5e530$var$Safari && target && target.tagName.toUpperCase() === 'SELECT') return;
        target = $695b3d6025d5e530$var$closest(target, options.draggable, el, false);
        if (target && target.animated) return;
        if ($695b3d6025d5e530$var$lastDownEl === target) // Ignoring duplicate `down`
        return;
        // Get the index of the dragged element within its parent
        $695b3d6025d5e530$var$oldIndex = $695b3d6025d5e530$var$index(target);
        $695b3d6025d5e530$var$oldDraggableIndex = $695b3d6025d5e530$var$index(target, options.draggable);
        // Check filter
        if (typeof filter === 'function') {
            if (filter.call(this, evt, target, this)) {
                $695b3d6025d5e530$var$_dispatchEvent({
                    sortable: _this,
                    rootEl: originalTarget,
                    name: 'filter',
                    targetEl: target,
                    toEl: el,
                    fromEl: el
                });
                $695b3d6025d5e530$var$pluginEvent('filter', _this, {
                    evt: evt
                });
                preventOnFilter && evt.preventDefault();
                return; // cancel dnd
            }
        } else if (filter) {
            filter = filter.split(',').some(function(criteria) {
                criteria = $695b3d6025d5e530$var$closest(originalTarget, criteria.trim(), el, false);
                if (criteria) {
                    $695b3d6025d5e530$var$_dispatchEvent({
                        sortable: _this,
                        rootEl: criteria,
                        name: 'filter',
                        targetEl: target,
                        fromEl: el,
                        toEl: el
                    });
                    $695b3d6025d5e530$var$pluginEvent('filter', _this, {
                        evt: evt
                    });
                    return true;
                }
            });
            if (filter) {
                preventOnFilter && evt.preventDefault();
                return; // cancel dnd
            }
        }
        if (options.handle && !$695b3d6025d5e530$var$closest(originalTarget, options.handle, el, false)) return;
        // Prepare `dragstart`
        this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart(/** Event */ evt, /** Touch */ touch, /** HTMLElement */ target) {
        var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
        if (target && !$695b3d6025d5e530$var$dragEl && target.parentNode === el) {
            var dragRect = $695b3d6025d5e530$var$getRect(target);
            $695b3d6025d5e530$var$rootEl = el;
            $695b3d6025d5e530$var$dragEl = target;
            $695b3d6025d5e530$var$parentEl = $695b3d6025d5e530$var$dragEl.parentNode;
            $695b3d6025d5e530$var$nextEl = $695b3d6025d5e530$var$dragEl.nextSibling;
            $695b3d6025d5e530$var$lastDownEl = target;
            $695b3d6025d5e530$var$activeGroup = options.group;
            $695b3d6025d5e530$export$31b3ca70d8f57423.dragged = $695b3d6025d5e530$var$dragEl;
            $695b3d6025d5e530$var$tapEvt = {
                target: $695b3d6025d5e530$var$dragEl,
                clientX: (touch || evt).clientX,
                clientY: (touch || evt).clientY
            };
            $695b3d6025d5e530$var$tapDistanceLeft = $695b3d6025d5e530$var$tapEvt.clientX - dragRect.left;
            $695b3d6025d5e530$var$tapDistanceTop = $695b3d6025d5e530$var$tapEvt.clientY - dragRect.top;
            this._lastX = (touch || evt).clientX;
            this._lastY = (touch || evt).clientY;
            $695b3d6025d5e530$var$dragEl.style['will-change'] = 'all';
            dragStartFn = function dragStartFn() {
                $695b3d6025d5e530$var$pluginEvent('delayEnded', _this, {
                    evt: evt
                });
                if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) {
                    _this._onDrop();
                    return;
                }
                // Delayed drag has been triggered
                // we can re-enable the events: touchmove/mousemove
                _this._disableDelayedDragEvents();
                if (!$695b3d6025d5e530$var$FireFox && _this.nativeDraggable) $695b3d6025d5e530$var$dragEl.draggable = true;
                // Bind the events: dragstart/dragend
                _this._triggerDragStart(evt, touch);
                // Drag start event
                $695b3d6025d5e530$var$_dispatchEvent({
                    sortable: _this,
                    name: 'choose',
                    originalEvent: evt
                });
                // Chosen item
                $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, options.chosenClass, true);
            };
            // Disable "draggable"
            options.ignore.split(',').forEach(function(criteria) {
                $695b3d6025d5e530$var$find($695b3d6025d5e530$var$dragEl, criteria.trim(), $695b3d6025d5e530$var$_disableDraggable);
            });
            $695b3d6025d5e530$var$on(ownerDocument, 'dragover', $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent);
            $695b3d6025d5e530$var$on(ownerDocument, 'mousemove', $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent);
            $695b3d6025d5e530$var$on(ownerDocument, 'touchmove', $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent);
            if (options.supportPointer) {
                $695b3d6025d5e530$var$on(ownerDocument, 'pointerup', _this._onDrop);
                // Native D&D triggers pointercancel
                !this.nativeDraggable && $695b3d6025d5e530$var$on(ownerDocument, 'pointercancel', _this._onDrop);
            } else {
                $695b3d6025d5e530$var$on(ownerDocument, 'mouseup', _this._onDrop);
                $695b3d6025d5e530$var$on(ownerDocument, 'touchend', _this._onDrop);
                $695b3d6025d5e530$var$on(ownerDocument, 'touchcancel', _this._onDrop);
            }
            // Make dragEl draggable (must be before delay for FireFox)
            if ($695b3d6025d5e530$var$FireFox && this.nativeDraggable) {
                this.options.touchStartThreshold = 4;
                $695b3d6025d5e530$var$dragEl.draggable = true;
            }
            $695b3d6025d5e530$var$pluginEvent('delayStart', this, {
                evt: evt
            });
            // Delay is impossible for native DnD in Edge or IE
            if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !($695b3d6025d5e530$var$Edge || $695b3d6025d5e530$var$IE11OrLess))) {
                if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) {
                    this._onDrop();
                    return;
                }
                // If the user moves the pointer or let go the click or touch
                // before the delay has been reached:
                // disable the delayed drag
                if (options.supportPointer) {
                    $695b3d6025d5e530$var$on(ownerDocument, 'pointerup', _this._disableDelayedDrag);
                    $695b3d6025d5e530$var$on(ownerDocument, 'pointercancel', _this._disableDelayedDrag);
                } else {
                    $695b3d6025d5e530$var$on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
                    $695b3d6025d5e530$var$on(ownerDocument, 'touchend', _this._disableDelayedDrag);
                    $695b3d6025d5e530$var$on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
                }
                $695b3d6025d5e530$var$on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
                $695b3d6025d5e530$var$on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
                options.supportPointer && $695b3d6025d5e530$var$on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
                _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
            } else dragStartFn();
        }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(/** TouchEvent|PointerEvent **/ e) {
        var touch = e.touches ? e.touches[0] : e;
        if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) this._disableDelayedDrag();
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
        $695b3d6025d5e530$var$dragEl && $695b3d6025d5e530$var$_disableDraggable($695b3d6025d5e530$var$dragEl);
        clearTimeout(this._dragStartTimer);
        this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
        var ownerDocument = this.el.ownerDocument;
        $695b3d6025d5e530$var$off(ownerDocument, 'mouseup', this._disableDelayedDrag);
        $695b3d6025d5e530$var$off(ownerDocument, 'touchend', this._disableDelayedDrag);
        $695b3d6025d5e530$var$off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
        $695b3d6025d5e530$var$off(ownerDocument, 'pointerup', this._disableDelayedDrag);
        $695b3d6025d5e530$var$off(ownerDocument, 'pointercancel', this._disableDelayedDrag);
        $695b3d6025d5e530$var$off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
        $695b3d6025d5e530$var$off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
        $695b3d6025d5e530$var$off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart(/** Event */ evt, /** Touch */ touch) {
        touch = touch || evt.pointerType == 'touch' && evt;
        if (!this.nativeDraggable || touch) {
            if (this.options.supportPointer) $695b3d6025d5e530$var$on(document, 'pointermove', this._onTouchMove);
            else if (touch) $695b3d6025d5e530$var$on(document, 'touchmove', this._onTouchMove);
            else $695b3d6025d5e530$var$on(document, 'mousemove', this._onTouchMove);
        } else {
            $695b3d6025d5e530$var$on($695b3d6025d5e530$var$dragEl, 'dragend', this);
            $695b3d6025d5e530$var$on($695b3d6025d5e530$var$rootEl, 'dragstart', this._onDragStart);
        }
        try {
            if (document.selection) $695b3d6025d5e530$var$_nextTick(function() {
                document.selection.empty();
            });
            else window.getSelection().removeAllRanges();
        } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {
        $695b3d6025d5e530$var$awaitingDragStarted = false;
        if ($695b3d6025d5e530$var$rootEl && $695b3d6025d5e530$var$dragEl) {
            $695b3d6025d5e530$var$pluginEvent('dragStarted', this, {
                evt: evt
            });
            if (this.nativeDraggable) $695b3d6025d5e530$var$on(document, 'dragover', $695b3d6025d5e530$var$_checkOutsideTargetEl);
            var options = this.options;
            // Apply effect
            !fallback && $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, options.dragClass, false);
            $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, options.ghostClass, true);
            $695b3d6025d5e530$export$31b3ca70d8f57423.active = this;
            fallback && this._appendGhost();
            // Drag start event
            $695b3d6025d5e530$var$_dispatchEvent({
                sortable: this,
                name: 'start',
                originalEvent: evt
            });
        } else this._nulling();
    },
    _emulateDragOver: function _emulateDragOver() {
        if ($695b3d6025d5e530$var$touchEvt) {
            this._lastX = $695b3d6025d5e530$var$touchEvt.clientX;
            this._lastY = $695b3d6025d5e530$var$touchEvt.clientY;
            $695b3d6025d5e530$var$_hideGhostForTarget();
            var target = document.elementFromPoint($695b3d6025d5e530$var$touchEvt.clientX, $695b3d6025d5e530$var$touchEvt.clientY);
            var parent = target;
            while(target && target.shadowRoot){
                target = target.shadowRoot.elementFromPoint($695b3d6025d5e530$var$touchEvt.clientX, $695b3d6025d5e530$var$touchEvt.clientY);
                if (target === parent) break;
                parent = target;
            }
            $695b3d6025d5e530$var$dragEl.parentNode[$695b3d6025d5e530$var$expando]._isOutsideThisEl(target);
            if (parent) do {
                if (parent[$695b3d6025d5e530$var$expando]) {
                    var inserted = void 0;
                    inserted = parent[$695b3d6025d5e530$var$expando]._onDragOver({
                        clientX: $695b3d6025d5e530$var$touchEvt.clientX,
                        clientY: $695b3d6025d5e530$var$touchEvt.clientY,
                        target: target,
                        rootEl: parent
                    });
                    if (inserted && !this.options.dragoverBubble) break;
                }
                target = parent; // store last element
            }while (parent = $695b3d6025d5e530$var$getParentOrHost(parent));
            $695b3d6025d5e530$var$_unhideGhostForTarget();
        }
    },
    _onTouchMove: function _onTouchMove(/**TouchEvent*/ evt) {
        if ($695b3d6025d5e530$var$tapEvt) {
            var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = $695b3d6025d5e530$var$ghostEl && $695b3d6025d5e530$var$matrix($695b3d6025d5e530$var$ghostEl, true), scaleX = $695b3d6025d5e530$var$ghostEl && ghostMatrix && ghostMatrix.a, scaleY = $695b3d6025d5e530$var$ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = $695b3d6025d5e530$var$PositionGhostAbsolutely && $695b3d6025d5e530$var$ghostRelativeParent && $695b3d6025d5e530$var$getRelativeScrollOffset($695b3d6025d5e530$var$ghostRelativeParent), dx = (touch.clientX - $695b3d6025d5e530$var$tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - $695b3d6025d5e530$var$ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - $695b3d6025d5e530$var$tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - $695b3d6025d5e530$var$ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);
            // only set the status to dragging, when we are actually dragging
            if (!$695b3d6025d5e530$export$31b3ca70d8f57423.active && !$695b3d6025d5e530$var$awaitingDragStarted) {
                if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) return;
                this._onDragStart(evt, true);
            }
            if ($695b3d6025d5e530$var$ghostEl) {
                if (ghostMatrix) {
                    ghostMatrix.e += dx - ($695b3d6025d5e530$var$lastDx || 0);
                    ghostMatrix.f += dy - ($695b3d6025d5e530$var$lastDy || 0);
                } else ghostMatrix = {
                    a: 1,
                    b: 0,
                    c: 0,
                    d: 1,
                    e: dx,
                    f: dy
                };
                var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, 'webkitTransform', cssMatrix);
                $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, 'mozTransform', cssMatrix);
                $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, 'msTransform', cssMatrix);
                $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, 'transform', cssMatrix);
                $695b3d6025d5e530$var$lastDx = dx;
                $695b3d6025d5e530$var$lastDy = dy;
                $695b3d6025d5e530$var$touchEvt = touch;
            }
            evt.cancelable && evt.preventDefault();
        }
    },
    _appendGhost: function _appendGhost() {
        // Bug if using scale(): https://stackoverflow.com/questions/2637058
        // Not being adjusted for
        if (!$695b3d6025d5e530$var$ghostEl) {
            var container = this.options.fallbackOnBody ? document.body : $695b3d6025d5e530$var$rootEl, rect = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$dragEl, true, $695b3d6025d5e530$var$PositionGhostAbsolutely, true, container), options = this.options;
            // Position absolutely
            if ($695b3d6025d5e530$var$PositionGhostAbsolutely) {
                // Get relatively positioned parent
                $695b3d6025d5e530$var$ghostRelativeParent = container;
                while($695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostRelativeParent, 'position') === 'static' && $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostRelativeParent, 'transform') === 'none' && $695b3d6025d5e530$var$ghostRelativeParent !== document)$695b3d6025d5e530$var$ghostRelativeParent = $695b3d6025d5e530$var$ghostRelativeParent.parentNode;
                if ($695b3d6025d5e530$var$ghostRelativeParent !== document.body && $695b3d6025d5e530$var$ghostRelativeParent !== document.documentElement) {
                    if ($695b3d6025d5e530$var$ghostRelativeParent === document) $695b3d6025d5e530$var$ghostRelativeParent = $695b3d6025d5e530$var$getWindowScrollingElement();
                    rect.top += $695b3d6025d5e530$var$ghostRelativeParent.scrollTop;
                    rect.left += $695b3d6025d5e530$var$ghostRelativeParent.scrollLeft;
                } else $695b3d6025d5e530$var$ghostRelativeParent = $695b3d6025d5e530$var$getWindowScrollingElement();
                $695b3d6025d5e530$var$ghostRelativeParentInitialScroll = $695b3d6025d5e530$var$getRelativeScrollOffset($695b3d6025d5e530$var$ghostRelativeParent);
            }
            $695b3d6025d5e530$var$ghostEl = $695b3d6025d5e530$var$dragEl.cloneNode(true);
            $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$ghostEl, options.ghostClass, false);
            $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$ghostEl, options.fallbackClass, true);
            $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$ghostEl, options.dragClass, true);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, 'transition', '');
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, 'transform', '');
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, 'box-sizing', 'border-box');
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, 'margin', 0);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, 'top', rect.top);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, 'left', rect.left);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, 'width', rect.width);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, 'height', rect.height);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, 'opacity', '0.8');
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, 'position', $695b3d6025d5e530$var$PositionGhostAbsolutely ? 'absolute' : 'fixed');
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, 'zIndex', '100000');
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, 'pointerEvents', 'none');
            $695b3d6025d5e530$export$31b3ca70d8f57423.ghost = $695b3d6025d5e530$var$ghostEl;
            container.appendChild($695b3d6025d5e530$var$ghostEl);
            // Set transform-origin
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, 'transform-origin', $695b3d6025d5e530$var$tapDistanceLeft / parseInt($695b3d6025d5e530$var$ghostEl.style.width) * 100 + '% ' + $695b3d6025d5e530$var$tapDistanceTop / parseInt($695b3d6025d5e530$var$ghostEl.style.height) * 100 + '%');
        }
    },
    _onDragStart: function _onDragStart(/**Event*/ evt, /**boolean*/ fallback) {
        var _this = this;
        var dataTransfer = evt.dataTransfer;
        var options = _this.options;
        $695b3d6025d5e530$var$pluginEvent('dragStart', this, {
            evt: evt
        });
        if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) {
            this._onDrop();
            return;
        }
        $695b3d6025d5e530$var$pluginEvent('setupClone', this);
        if (!$695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) {
            $695b3d6025d5e530$var$cloneEl = $695b3d6025d5e530$var$clone($695b3d6025d5e530$var$dragEl);
            $695b3d6025d5e530$var$cloneEl.removeAttribute("id");
            $695b3d6025d5e530$var$cloneEl.draggable = false;
            $695b3d6025d5e530$var$cloneEl.style['will-change'] = '';
            this._hideClone();
            $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$cloneEl, this.options.chosenClass, false);
            $695b3d6025d5e530$export$31b3ca70d8f57423.clone = $695b3d6025d5e530$var$cloneEl;
        }
        // #1143: IFrame support workaround
        _this.cloneId = $695b3d6025d5e530$var$_nextTick(function() {
            $695b3d6025d5e530$var$pluginEvent('clone', _this);
            if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) return;
            if (!_this.options.removeCloneOnHide) $695b3d6025d5e530$var$rootEl.insertBefore($695b3d6025d5e530$var$cloneEl, $695b3d6025d5e530$var$dragEl);
            _this._hideClone();
            $695b3d6025d5e530$var$_dispatchEvent({
                sortable: _this,
                name: 'clone'
            });
        });
        !fallback && $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, options.dragClass, true);
        // Set proper drop events
        if (fallback) {
            $695b3d6025d5e530$var$ignoreNextClick = true;
            _this._loopId = setInterval(_this._emulateDragOver, 50);
        } else {
            // Undo what was set in _prepareDragStart before drag started
            $695b3d6025d5e530$var$off(document, 'mouseup', _this._onDrop);
            $695b3d6025d5e530$var$off(document, 'touchend', _this._onDrop);
            $695b3d6025d5e530$var$off(document, 'touchcancel', _this._onDrop);
            if (dataTransfer) {
                dataTransfer.effectAllowed = 'move';
                options.setData && options.setData.call(_this, dataTransfer, $695b3d6025d5e530$var$dragEl);
            }
            $695b3d6025d5e530$var$on(document, 'drop', _this);
            // #1276 fix:
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$dragEl, 'transform', 'translateZ(0)');
        }
        $695b3d6025d5e530$var$awaitingDragStarted = true;
        _this._dragStartId = $695b3d6025d5e530$var$_nextTick(_this._dragStarted.bind(_this, fallback, evt));
        $695b3d6025d5e530$var$on(document, 'selectstart', _this);
        $695b3d6025d5e530$var$moved = true;
        window.getSelection().removeAllRanges();
        if ($695b3d6025d5e530$var$Safari) $695b3d6025d5e530$var$css(document.body, 'user-select', 'none');
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver(/**Event*/ evt) {
        var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = $695b3d6025d5e530$export$31b3ca70d8f57423.active, isOwner = $695b3d6025d5e530$var$activeGroup === group, canSort = options.sort, fromSortable = $695b3d6025d5e530$var$putSortable || activeSortable, vertical, _this = this, completedFired = false;
        if ($695b3d6025d5e530$var$_silent) return;
        function dragOverEvent(name, extra) {
            $695b3d6025d5e530$var$pluginEvent(name, _this, $695b3d6025d5e530$var$_objectSpread2({
                evt: evt,
                isOwner: isOwner,
                axis: vertical ? 'vertical' : 'horizontal',
                revert: revert,
                dragRect: dragRect,
                targetRect: targetRect,
                canSort: canSort,
                fromSortable: fromSortable,
                target: target,
                completed: completed,
                onMove: function onMove(target, after) {
                    return $695b3d6025d5e530$var$_onMove($695b3d6025d5e530$var$rootEl, el, $695b3d6025d5e530$var$dragEl, dragRect, target, $695b3d6025d5e530$var$getRect(target), evt, after);
                },
                changed: changed
            }, extra));
        }
        // Capture animation state
        function capture() {
            dragOverEvent('dragOverAnimationCapture');
            _this.captureAnimationState();
            if (_this !== fromSortable) fromSortable.captureAnimationState();
        }
        // Return invocation when dragEl is inserted (or completed)
        function completed(insertion) {
            dragOverEvent('dragOverCompleted', {
                insertion: insertion
            });
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                else activeSortable._showClone(_this);
                if (_this !== fromSortable) {
                    // Set ghost class to new sortable's ghost class
                    $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, $695b3d6025d5e530$var$putSortable ? $695b3d6025d5e530$var$putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                    $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, options.ghostClass, true);
                }
                if ($695b3d6025d5e530$var$putSortable !== _this && _this !== $695b3d6025d5e530$export$31b3ca70d8f57423.active) $695b3d6025d5e530$var$putSortable = _this;
                else if (_this === $695b3d6025d5e530$export$31b3ca70d8f57423.active && $695b3d6025d5e530$var$putSortable) $695b3d6025d5e530$var$putSortable = null;
                // Animation
                if (fromSortable === _this) _this._ignoreWhileAnimating = target;
                _this.animateAll(function() {
                    dragOverEvent('dragOverAnimationComplete');
                    _this._ignoreWhileAnimating = null;
                });
                if (_this !== fromSortable) {
                    fromSortable.animateAll();
                    fromSortable._ignoreWhileAnimating = null;
                }
            }
            // Null lastTarget if it is not inside a previously swapped element
            if (target === $695b3d6025d5e530$var$dragEl && !$695b3d6025d5e530$var$dragEl.animated || target === el && !target.animated) $695b3d6025d5e530$var$lastTarget = null;
            // no bubbling and not fallback
            if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                $695b3d6025d5e530$var$dragEl.parentNode[$695b3d6025d5e530$var$expando]._isOutsideThisEl(evt.target);
                // Do not detect for empty insert if already inserted
                !insertion && $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent(evt);
            }
            !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
            return completedFired = true;
        }
        // Call when dragEl has been inserted
        function changed() {
            $695b3d6025d5e530$var$newIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl);
            $695b3d6025d5e530$var$newDraggableIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl, options.draggable);
            $695b3d6025d5e530$var$_dispatchEvent({
                sortable: _this,
                name: 'change',
                toEl: el,
                newIndex: $695b3d6025d5e530$var$newIndex,
                newDraggableIndex: $695b3d6025d5e530$var$newDraggableIndex,
                originalEvent: evt
            });
        }
        if (evt.preventDefault !== void 0) evt.cancelable && evt.preventDefault();
        target = $695b3d6025d5e530$var$closest(target, options.draggable, el, true);
        dragOverEvent('dragOver');
        if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) return completedFired;
        if ($695b3d6025d5e530$var$dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) return completed(false);
        $695b3d6025d5e530$var$ignoreNextClick = false;
        if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = $695b3d6025d5e530$var$parentEl !== $695b3d6025d5e530$var$rootEl // Reverting item into the original list
        ) : $695b3d6025d5e530$var$putSortable === this || (this.lastPutMode = $695b3d6025d5e530$var$activeGroup.checkPull(this, activeSortable, $695b3d6025d5e530$var$dragEl, evt)) && group.checkPut(this, activeSortable, $695b3d6025d5e530$var$dragEl, evt))) {
            vertical = this._getDirection(evt, target) === 'vertical';
            dragRect = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$dragEl);
            dragOverEvent('dragOverValid');
            if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) return completedFired;
            if (revert) {
                $695b3d6025d5e530$var$parentEl = $695b3d6025d5e530$var$rootEl; // actualization
                capture();
                this._hideClone();
                dragOverEvent('revert');
                if (!$695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) {
                    if ($695b3d6025d5e530$var$nextEl) $695b3d6025d5e530$var$rootEl.insertBefore($695b3d6025d5e530$var$dragEl, $695b3d6025d5e530$var$nextEl);
                    else $695b3d6025d5e530$var$rootEl.appendChild($695b3d6025d5e530$var$dragEl);
                }
                return completed(true);
            }
            var elLastChild = $695b3d6025d5e530$var$lastChild(el, options.draggable);
            if (!elLastChild || $695b3d6025d5e530$var$_ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                // Insert to end of list
                // If already at end of list: Do not insert
                if (elLastChild === $695b3d6025d5e530$var$dragEl) return completed(false);
                // if there is a last element, it is the target
                if (elLastChild && el === evt.target) target = elLastChild;
                if (target) targetRect = $695b3d6025d5e530$var$getRect(target);
                if ($695b3d6025d5e530$var$_onMove($695b3d6025d5e530$var$rootEl, el, $695b3d6025d5e530$var$dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                    capture();
                    if (elLastChild && elLastChild.nextSibling) // the last draggable element is not the last node
                    el.insertBefore($695b3d6025d5e530$var$dragEl, elLastChild.nextSibling);
                    else el.appendChild($695b3d6025d5e530$var$dragEl);
                    $695b3d6025d5e530$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (elLastChild && $695b3d6025d5e530$var$_ghostIsFirst(evt, vertical, this)) {
                // Insert to start of list
                var firstChild = $695b3d6025d5e530$var$getChild(el, 0, options, true);
                if (firstChild === $695b3d6025d5e530$var$dragEl) return completed(false);
                target = firstChild;
                targetRect = $695b3d6025d5e530$var$getRect(target);
                if ($695b3d6025d5e530$var$_onMove($695b3d6025d5e530$var$rootEl, el, $695b3d6025d5e530$var$dragEl, dragRect, target, targetRect, evt, false) !== false) {
                    capture();
                    el.insertBefore($695b3d6025d5e530$var$dragEl, firstChild);
                    $695b3d6025d5e530$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (target.parentNode === el) {
                targetRect = $695b3d6025d5e530$var$getRect(target);
                var direction = 0, targetBeforeFirstSwap, differentLevel = $695b3d6025d5e530$var$dragEl.parentNode !== el, differentRowCol = !$695b3d6025d5e530$var$_dragElInRowColumn($695b3d6025d5e530$var$dragEl.animated && $695b3d6025d5e530$var$dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? 'top' : 'left', scrolledPastTop = $695b3d6025d5e530$var$isScrolledPast(target, 'top', 'top') || $695b3d6025d5e530$var$isScrolledPast($695b3d6025d5e530$var$dragEl, 'top', 'top'), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
                if ($695b3d6025d5e530$var$lastTarget !== target) {
                    targetBeforeFirstSwap = targetRect[side1];
                    $695b3d6025d5e530$var$pastFirstInvertThresh = false;
                    $695b3d6025d5e530$var$isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                }
                direction = $695b3d6025d5e530$var$_getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, $695b3d6025d5e530$var$isCircumstantialInvert, $695b3d6025d5e530$var$lastTarget === target);
                var sibling;
                if (direction !== 0) {
                    // Check if target is beside dragEl in respective direction (ignoring hidden elements)
                    var dragIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl);
                    do {
                        dragIndex -= direction;
                        sibling = $695b3d6025d5e530$var$parentEl.children[dragIndex];
                    }while (sibling && ($695b3d6025d5e530$var$css(sibling, 'display') === 'none' || sibling === $695b3d6025d5e530$var$ghostEl));
                }
                // If dragEl is already beside target: Do not insert
                if (direction === 0 || sibling === target) return completed(false);
                $695b3d6025d5e530$var$lastTarget = target;
                $695b3d6025d5e530$var$lastDirection = direction;
                var nextSibling = target.nextElementSibling, after = false;
                after = direction === 1;
                var moveVector = $695b3d6025d5e530$var$_onMove($695b3d6025d5e530$var$rootEl, el, $695b3d6025d5e530$var$dragEl, dragRect, target, targetRect, evt, after);
                if (moveVector !== false) {
                    if (moveVector === 1 || moveVector === -1) after = moveVector === 1;
                    $695b3d6025d5e530$var$_silent = true;
                    setTimeout($695b3d6025d5e530$var$_unsilent, 30);
                    capture();
                    if (after && !nextSibling) el.appendChild($695b3d6025d5e530$var$dragEl);
                    else target.parentNode.insertBefore($695b3d6025d5e530$var$dragEl, after ? nextSibling : target);
                    // Undo chrome's scroll adjustment (has no effect on other browsers)
                    if (scrolledPastTop) $695b3d6025d5e530$var$scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                    $695b3d6025d5e530$var$parentEl = $695b3d6025d5e530$var$dragEl.parentNode; // actualization
                    // must be done before animation
                    if (targetBeforeFirstSwap !== undefined && !$695b3d6025d5e530$var$isCircumstantialInvert) $695b3d6025d5e530$var$targetMoveDistance = Math.abs(targetBeforeFirstSwap - $695b3d6025d5e530$var$getRect(target)[side1]);
                    changed();
                    return completed(true);
                }
            }
            if (el.contains($695b3d6025d5e530$var$dragEl)) return completed(false);
        }
        return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
        $695b3d6025d5e530$var$off(document, 'mousemove', this._onTouchMove);
        $695b3d6025d5e530$var$off(document, 'touchmove', this._onTouchMove);
        $695b3d6025d5e530$var$off(document, 'pointermove', this._onTouchMove);
        $695b3d6025d5e530$var$off(document, 'dragover', $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent);
        $695b3d6025d5e530$var$off(document, 'mousemove', $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent);
        $695b3d6025d5e530$var$off(document, 'touchmove', $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
        var ownerDocument = this.el.ownerDocument;
        $695b3d6025d5e530$var$off(ownerDocument, 'mouseup', this._onDrop);
        $695b3d6025d5e530$var$off(ownerDocument, 'touchend', this._onDrop);
        $695b3d6025d5e530$var$off(ownerDocument, 'pointerup', this._onDrop);
        $695b3d6025d5e530$var$off(ownerDocument, 'pointercancel', this._onDrop);
        $695b3d6025d5e530$var$off(ownerDocument, 'touchcancel', this._onDrop);
        $695b3d6025d5e530$var$off(document, 'selectstart', this);
    },
    _onDrop: function _onDrop(/**Event*/ evt) {
        var el = this.el, options = this.options;
        // Get the index of the dragged element within its parent
        $695b3d6025d5e530$var$newIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl);
        $695b3d6025d5e530$var$newDraggableIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl, options.draggable);
        $695b3d6025d5e530$var$pluginEvent('drop', this, {
            evt: evt
        });
        $695b3d6025d5e530$var$parentEl = $695b3d6025d5e530$var$dragEl && $695b3d6025d5e530$var$dragEl.parentNode;
        // Get again after plugin event
        $695b3d6025d5e530$var$newIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl);
        $695b3d6025d5e530$var$newDraggableIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl, options.draggable);
        if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) {
            this._nulling();
            return;
        }
        $695b3d6025d5e530$var$awaitingDragStarted = false;
        $695b3d6025d5e530$var$isCircumstantialInvert = false;
        $695b3d6025d5e530$var$pastFirstInvertThresh = false;
        clearInterval(this._loopId);
        clearTimeout(this._dragStartTimer);
        $695b3d6025d5e530$var$_cancelNextTick(this.cloneId);
        $695b3d6025d5e530$var$_cancelNextTick(this._dragStartId);
        // Unbind events
        if (this.nativeDraggable) {
            $695b3d6025d5e530$var$off(document, 'drop', this);
            $695b3d6025d5e530$var$off(el, 'dragstart', this._onDragStart);
        }
        this._offMoveEvents();
        this._offUpEvents();
        if ($695b3d6025d5e530$var$Safari) $695b3d6025d5e530$var$css(document.body, 'user-select', '');
        $695b3d6025d5e530$var$css($695b3d6025d5e530$var$dragEl, 'transform', '');
        if (evt) {
            if ($695b3d6025d5e530$var$moved) {
                evt.cancelable && evt.preventDefault();
                !options.dropBubble && evt.stopPropagation();
            }
            $695b3d6025d5e530$var$ghostEl && $695b3d6025d5e530$var$ghostEl.parentNode && $695b3d6025d5e530$var$ghostEl.parentNode.removeChild($695b3d6025d5e530$var$ghostEl);
            if ($695b3d6025d5e530$var$rootEl === $695b3d6025d5e530$var$parentEl || $695b3d6025d5e530$var$putSortable && $695b3d6025d5e530$var$putSortable.lastPutMode !== 'clone') // Remove clone(s)
            $695b3d6025d5e530$var$cloneEl && $695b3d6025d5e530$var$cloneEl.parentNode && $695b3d6025d5e530$var$cloneEl.parentNode.removeChild($695b3d6025d5e530$var$cloneEl);
            if ($695b3d6025d5e530$var$dragEl) {
                if (this.nativeDraggable) $695b3d6025d5e530$var$off($695b3d6025d5e530$var$dragEl, 'dragend', this);
                $695b3d6025d5e530$var$_disableDraggable($695b3d6025d5e530$var$dragEl);
                $695b3d6025d5e530$var$dragEl.style['will-change'] = '';
                // Remove classes
                // ghostClass is added in dragStarted
                if ($695b3d6025d5e530$var$moved && !$695b3d6025d5e530$var$awaitingDragStarted) $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, $695b3d6025d5e530$var$putSortable ? $695b3d6025d5e530$var$putSortable.options.ghostClass : this.options.ghostClass, false);
                $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, this.options.chosenClass, false);
                // Drag stop event
                $695b3d6025d5e530$var$_dispatchEvent({
                    sortable: this,
                    name: 'unchoose',
                    toEl: $695b3d6025d5e530$var$parentEl,
                    newIndex: null,
                    newDraggableIndex: null,
                    originalEvent: evt
                });
                if ($695b3d6025d5e530$var$rootEl !== $695b3d6025d5e530$var$parentEl) {
                    if ($695b3d6025d5e530$var$newIndex >= 0) {
                        // Add event
                        $695b3d6025d5e530$var$_dispatchEvent({
                            rootEl: $695b3d6025d5e530$var$parentEl,
                            name: 'add',
                            toEl: $695b3d6025d5e530$var$parentEl,
                            fromEl: $695b3d6025d5e530$var$rootEl,
                            originalEvent: evt
                        });
                        // Remove event
                        $695b3d6025d5e530$var$_dispatchEvent({
                            sortable: this,
                            name: 'remove',
                            toEl: $695b3d6025d5e530$var$parentEl,
                            originalEvent: evt
                        });
                        // drag from one list and drop into another
                        $695b3d6025d5e530$var$_dispatchEvent({
                            rootEl: $695b3d6025d5e530$var$parentEl,
                            name: 'sort',
                            toEl: $695b3d6025d5e530$var$parentEl,
                            fromEl: $695b3d6025d5e530$var$rootEl,
                            originalEvent: evt
                        });
                        $695b3d6025d5e530$var$_dispatchEvent({
                            sortable: this,
                            name: 'sort',
                            toEl: $695b3d6025d5e530$var$parentEl,
                            originalEvent: evt
                        });
                    }
                    $695b3d6025d5e530$var$putSortable && $695b3d6025d5e530$var$putSortable.save();
                } else {
                    if ($695b3d6025d5e530$var$newIndex !== $695b3d6025d5e530$var$oldIndex) {
                        if ($695b3d6025d5e530$var$newIndex >= 0) {
                            // drag & drop within the same list
                            $695b3d6025d5e530$var$_dispatchEvent({
                                sortable: this,
                                name: 'update',
                                toEl: $695b3d6025d5e530$var$parentEl,
                                originalEvent: evt
                            });
                            $695b3d6025d5e530$var$_dispatchEvent({
                                sortable: this,
                                name: 'sort',
                                toEl: $695b3d6025d5e530$var$parentEl,
                                originalEvent: evt
                            });
                        }
                    }
                }
                if ($695b3d6025d5e530$export$31b3ca70d8f57423.active) {
                    /* jshint eqnull:true */ if ($695b3d6025d5e530$var$newIndex == null || $695b3d6025d5e530$var$newIndex === -1) {
                        $695b3d6025d5e530$var$newIndex = $695b3d6025d5e530$var$oldIndex;
                        $695b3d6025d5e530$var$newDraggableIndex = $695b3d6025d5e530$var$oldDraggableIndex;
                    }
                    $695b3d6025d5e530$var$_dispatchEvent({
                        sortable: this,
                        name: 'end',
                        toEl: $695b3d6025d5e530$var$parentEl,
                        originalEvent: evt
                    });
                    // Save sorting
                    this.save();
                }
            }
        }
        this._nulling();
    },
    _nulling: function _nulling() {
        $695b3d6025d5e530$var$pluginEvent('nulling', this);
        $695b3d6025d5e530$var$rootEl = $695b3d6025d5e530$var$dragEl = $695b3d6025d5e530$var$parentEl = $695b3d6025d5e530$var$ghostEl = $695b3d6025d5e530$var$nextEl = $695b3d6025d5e530$var$cloneEl = $695b3d6025d5e530$var$lastDownEl = $695b3d6025d5e530$var$cloneHidden = $695b3d6025d5e530$var$tapEvt = $695b3d6025d5e530$var$touchEvt = $695b3d6025d5e530$var$moved = $695b3d6025d5e530$var$newIndex = $695b3d6025d5e530$var$newDraggableIndex = $695b3d6025d5e530$var$oldIndex = $695b3d6025d5e530$var$oldDraggableIndex = $695b3d6025d5e530$var$lastTarget = $695b3d6025d5e530$var$lastDirection = $695b3d6025d5e530$var$putSortable = $695b3d6025d5e530$var$activeGroup = $695b3d6025d5e530$export$31b3ca70d8f57423.dragged = $695b3d6025d5e530$export$31b3ca70d8f57423.ghost = $695b3d6025d5e530$export$31b3ca70d8f57423.clone = $695b3d6025d5e530$export$31b3ca70d8f57423.active = null;
        $695b3d6025d5e530$var$savedInputChecked.forEach(function(el) {
            el.checked = true;
        });
        $695b3d6025d5e530$var$savedInputChecked.length = $695b3d6025d5e530$var$lastDx = $695b3d6025d5e530$var$lastDy = 0;
    },
    handleEvent: function handleEvent(/**Event*/ evt) {
        switch(evt.type){
            case 'drop':
            case 'dragend':
                this._onDrop(evt);
                break;
            case 'dragenter':
            case 'dragover':
                if ($695b3d6025d5e530$var$dragEl) {
                    this._onDragOver(evt);
                    $695b3d6025d5e530$var$_globalDragOver(evt);
                }
                break;
            case 'selectstart':
                evt.preventDefault();
                break;
        }
    },
    /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */ toArray: function toArray() {
        var order = [], el, children = this.el.children, i = 0, n = children.length, options = this.options;
        for(; i < n; i++){
            el = children[i];
            if ($695b3d6025d5e530$var$closest(el, options.draggable, this.el, false)) order.push(el.getAttribute(options.dataIdAttr) || $695b3d6025d5e530$var$_generateId(el));
        }
        return order;
    },
    /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */ sort: function sort(order, useAnimation) {
        var items = {}, rootEl = this.el;
        this.toArray().forEach(function(id, i) {
            var el = rootEl.children[i];
            if ($695b3d6025d5e530$var$closest(el, this.options.draggable, rootEl, false)) items[id] = el;
        }, this);
        useAnimation && this.captureAnimationState();
        order.forEach(function(id) {
            if (items[id]) {
                rootEl.removeChild(items[id]);
                rootEl.appendChild(items[id]);
            }
        });
        useAnimation && this.animateAll();
    },
    /**
   * Save the current sorting
   */ save: function save() {
        var store = this.options.store;
        store && store.set && store.set(this);
    },
    /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */ closest: function closest$1(el, selector) {
        return $695b3d6025d5e530$var$closest(el, selector || this.options.draggable, this.el, false);
    },
    /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */ option: function option(name, value) {
        var options = this.options;
        if (value === void 0) return options[name];
        else {
            var modifiedValue = $695b3d6025d5e530$var$PluginManager.modifyOption(this, name, value);
            if (typeof modifiedValue !== 'undefined') options[name] = modifiedValue;
            else options[name] = value;
            if (name === 'group') $695b3d6025d5e530$var$_prepareGroup(options);
        }
    },
    /**
   * Destroy
   */ destroy: function destroy() {
        $695b3d6025d5e530$var$pluginEvent('destroy', this);
        var el = this.el;
        el[$695b3d6025d5e530$var$expando] = null;
        $695b3d6025d5e530$var$off(el, 'mousedown', this._onTapStart);
        $695b3d6025d5e530$var$off(el, 'touchstart', this._onTapStart);
        $695b3d6025d5e530$var$off(el, 'pointerdown', this._onTapStart);
        if (this.nativeDraggable) {
            $695b3d6025d5e530$var$off(el, 'dragover', this);
            $695b3d6025d5e530$var$off(el, 'dragenter', this);
        }
        // Remove draggable attributes
        Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function(el) {
            el.removeAttribute('draggable');
        });
        this._onDrop();
        this._disableDelayedDragEvents();
        $695b3d6025d5e530$var$sortables.splice($695b3d6025d5e530$var$sortables.indexOf(this.el), 1);
        this.el = el = null;
    },
    _hideClone: function _hideClone() {
        if (!$695b3d6025d5e530$var$cloneHidden) {
            $695b3d6025d5e530$var$pluginEvent('hideClone', this);
            if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) return;
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$cloneEl, 'display', 'none');
            if (this.options.removeCloneOnHide && $695b3d6025d5e530$var$cloneEl.parentNode) $695b3d6025d5e530$var$cloneEl.parentNode.removeChild($695b3d6025d5e530$var$cloneEl);
            $695b3d6025d5e530$var$cloneHidden = true;
        }
    },
    _showClone: function _showClone(putSortable) {
        if (putSortable.lastPutMode !== 'clone') {
            this._hideClone();
            return;
        }
        if ($695b3d6025d5e530$var$cloneHidden) {
            $695b3d6025d5e530$var$pluginEvent('showClone', this);
            if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) return;
            // show clone at dragEl or original position
            if ($695b3d6025d5e530$var$dragEl.parentNode == $695b3d6025d5e530$var$rootEl && !this.options.group.revertClone) $695b3d6025d5e530$var$rootEl.insertBefore($695b3d6025d5e530$var$cloneEl, $695b3d6025d5e530$var$dragEl);
            else if ($695b3d6025d5e530$var$nextEl) $695b3d6025d5e530$var$rootEl.insertBefore($695b3d6025d5e530$var$cloneEl, $695b3d6025d5e530$var$nextEl);
            else $695b3d6025d5e530$var$rootEl.appendChild($695b3d6025d5e530$var$cloneEl);
            if (this.options.group.revertClone) this.animate($695b3d6025d5e530$var$dragEl, $695b3d6025d5e530$var$cloneEl);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$cloneEl, 'display', '');
            $695b3d6025d5e530$var$cloneHidden = false;
        }
    }
};
function $695b3d6025d5e530$var$_globalDragOver(/**Event*/ evt) {
    if (evt.dataTransfer) evt.dataTransfer.dropEffect = 'move';
    evt.cancelable && evt.preventDefault();
}
function $695b3d6025d5e530$var$_onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt, sortable = fromEl[$695b3d6025d5e530$var$expando], onMoveFn = sortable.options.onMove, retVal;
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$695b3d6025d5e530$var$IE11OrLess && !$695b3d6025d5e530$var$Edge) evt = new CustomEvent('move', {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent('Event');
        evt.initEvent('move', true, true);
    }
    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || $695b3d6025d5e530$var$getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);
    if (onMoveFn) retVal = onMoveFn.call(sortable, evt, originalEvent);
    return retVal;
}
function $695b3d6025d5e530$var$_disableDraggable(el) {
    el.draggable = false;
}
function $695b3d6025d5e530$var$_unsilent() {
    $695b3d6025d5e530$var$_silent = false;
}
function $695b3d6025d5e530$var$_ghostIsFirst(evt, vertical, sortable) {
    var firstElRect = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$getChild(sortable.el, 0, sortable.options, true));
    var childContainingRect = $695b3d6025d5e530$var$getChildContainingRectFromElement(sortable.el, sortable.options, $695b3d6025d5e530$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX < childContainingRect.left - spacer || evt.clientY < firstElRect.top && evt.clientX < firstElRect.right : evt.clientY < childContainingRect.top - spacer || evt.clientY < firstElRect.bottom && evt.clientX < firstElRect.left;
}
function $695b3d6025d5e530$var$_ghostIsLast(evt, vertical, sortable) {
    var lastElRect = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$lastChild(sortable.el, sortable.options.draggable));
    var childContainingRect = $695b3d6025d5e530$var$getChildContainingRectFromElement(sortable.el, sortable.options, $695b3d6025d5e530$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX > childContainingRect.right + spacer || evt.clientY > lastElRect.bottom && evt.clientX > lastElRect.left : evt.clientY > childContainingRect.bottom + spacer || evt.clientX > lastElRect.right && evt.clientY > lastElRect.top;
}
function $695b3d6025d5e530$var$_getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
    if (!invertSwap) {
        // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
        if (isLastTarget && $695b3d6025d5e530$var$targetMoveDistance < targetLength * swapThreshold) {
            // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
            // check if past first invert threshold on side opposite of lastDirection
            if (!$695b3d6025d5e530$var$pastFirstInvertThresh && ($695b3d6025d5e530$var$lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) // past first invert threshold, do not restrict inverted threshold to dragEl shadow
            $695b3d6025d5e530$var$pastFirstInvertThresh = true;
            if (!$695b3d6025d5e530$var$pastFirstInvertThresh) {
                // dragEl shadow (target move distance shadow)
                if ($695b3d6025d5e530$var$lastDirection === 1 ? mouseOnAxis < targetS1 + $695b3d6025d5e530$var$targetMoveDistance // over dragEl shadow
                 : mouseOnAxis > targetS2 - $695b3d6025d5e530$var$targetMoveDistance) return -$695b3d6025d5e530$var$lastDirection;
            } else invert = true;
        } else {
            // Regular
            if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) return $695b3d6025d5e530$var$_getInsertDirection(target);
        }
    }
    invert = invert || invertSwap;
    if (invert) {
        // Invert of regular
        if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
    return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */ function $695b3d6025d5e530$var$_getInsertDirection(target) {
    if ($695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl) < $695b3d6025d5e530$var$index(target)) return 1;
    else return -1;
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */ function $695b3d6025d5e530$var$_generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
    while(i--)sum += str.charCodeAt(i);
    return sum.toString(36);
}
function $695b3d6025d5e530$var$_saveInputCheckedState(root) {
    $695b3d6025d5e530$var$savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName('input');
    var idx = inputs.length;
    while(idx--){
        var el = inputs[idx];
        el.checked && $695b3d6025d5e530$var$savedInputChecked.push(el);
    }
}
function $695b3d6025d5e530$var$_nextTick(fn) {
    return setTimeout(fn, 0);
}
function $695b3d6025d5e530$var$_cancelNextTick(id) {
    return clearTimeout(id);
}
// Fixed #973:
if ($695b3d6025d5e530$var$documentExists) $695b3d6025d5e530$var$on(document, 'touchmove', function(evt) {
    if (($695b3d6025d5e530$export$31b3ca70d8f57423.active || $695b3d6025d5e530$var$awaitingDragStarted) && evt.cancelable) evt.preventDefault();
});
// Export utils
$695b3d6025d5e530$export$31b3ca70d8f57423.utils = {
    on: $695b3d6025d5e530$var$on,
    off: $695b3d6025d5e530$var$off,
    css: $695b3d6025d5e530$var$css,
    find: $695b3d6025d5e530$var$find,
    is: function is(el, selector) {
        return !!$695b3d6025d5e530$var$closest(el, selector, el, false);
    },
    extend: $695b3d6025d5e530$var$extend,
    throttle: $695b3d6025d5e530$var$throttle,
    closest: $695b3d6025d5e530$var$closest,
    toggleClass: $695b3d6025d5e530$var$toggleClass,
    clone: $695b3d6025d5e530$var$clone,
    index: $695b3d6025d5e530$var$index,
    nextTick: $695b3d6025d5e530$var$_nextTick,
    cancelNextTick: $695b3d6025d5e530$var$_cancelNextTick,
    detectDirection: $695b3d6025d5e530$var$_detectDirection,
    getChild: $695b3d6025d5e530$var$getChild,
    expando: $695b3d6025d5e530$var$expando
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */ $695b3d6025d5e530$export$31b3ca70d8f57423.get = function(element) {
    return element[$695b3d6025d5e530$var$expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */ $695b3d6025d5e530$export$31b3ca70d8f57423.mount = function() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins[0].constructor === Array) plugins = plugins[0];
    plugins.forEach(function(plugin) {
        if (!plugin.prototype || !plugin.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not ".concat(({}).toString.call(plugin));
        if (plugin.utils) $695b3d6025d5e530$export$31b3ca70d8f57423.utils = $695b3d6025d5e530$var$_objectSpread2($695b3d6025d5e530$var$_objectSpread2({}, $695b3d6025d5e530$export$31b3ca70d8f57423.utils), plugin.utils);
        $695b3d6025d5e530$var$PluginManager.mount(plugin);
    });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */ $695b3d6025d5e530$export$31b3ca70d8f57423.create = function(el, options) {
    return new $695b3d6025d5e530$export$31b3ca70d8f57423(el, options);
};
// Export
$695b3d6025d5e530$export$31b3ca70d8f57423.version = $695b3d6025d5e530$var$version;
var $695b3d6025d5e530$var$autoScrolls = [], $695b3d6025d5e530$var$scrollEl, $695b3d6025d5e530$var$scrollRootEl, $695b3d6025d5e530$var$scrolling = false, $695b3d6025d5e530$var$lastAutoScrollX, $695b3d6025d5e530$var$lastAutoScrollY, $695b3d6025d5e530$var$touchEvt$1, $695b3d6025d5e530$var$pointerElemChangedInterval;
function $695b3d6025d5e530$var$AutoScrollPlugin() {
    function AutoScroll() {
        this.defaults = {
            scroll: true,
            forceAutoScrollFallback: false,
            scrollSensitivity: 30,
            scrollSpeed: 10,
            bubbleScroll: true
        };
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === '_' && typeof this[fn] === 'function') this[fn] = this[fn].bind(this);
    }
    AutoScroll.prototype = {
        dragStarted: function dragStarted(_ref) {
            var originalEvent = _ref.originalEvent;
            if (this.sortable.nativeDraggable) $695b3d6025d5e530$var$on(document, 'dragover', this._handleAutoScroll);
            else {
                if (this.options.supportPointer) $695b3d6025d5e530$var$on(document, 'pointermove', this._handleFallbackAutoScroll);
                else if (originalEvent.touches) $695b3d6025d5e530$var$on(document, 'touchmove', this._handleFallbackAutoScroll);
                else $695b3d6025d5e530$var$on(document, 'mousemove', this._handleFallbackAutoScroll);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref2) {
            var originalEvent = _ref2.originalEvent;
            // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
            if (!this.options.dragOverBubble && !originalEvent.rootEl) this._handleAutoScroll(originalEvent);
        },
        drop: function drop() {
            if (this.sortable.nativeDraggable) $695b3d6025d5e530$var$off(document, 'dragover', this._handleAutoScroll);
            else {
                $695b3d6025d5e530$var$off(document, 'pointermove', this._handleFallbackAutoScroll);
                $695b3d6025d5e530$var$off(document, 'touchmove', this._handleFallbackAutoScroll);
                $695b3d6025d5e530$var$off(document, 'mousemove', this._handleFallbackAutoScroll);
            }
            $695b3d6025d5e530$var$clearPointerElemChangedInterval();
            $695b3d6025d5e530$var$clearAutoScrolls();
            $695b3d6025d5e530$var$cancelThrottle();
        },
        nulling: function nulling() {
            $695b3d6025d5e530$var$touchEvt$1 = $695b3d6025d5e530$var$scrollRootEl = $695b3d6025d5e530$var$scrollEl = $695b3d6025d5e530$var$scrolling = $695b3d6025d5e530$var$pointerElemChangedInterval = $695b3d6025d5e530$var$lastAutoScrollX = $695b3d6025d5e530$var$lastAutoScrollY = null;
            $695b3d6025d5e530$var$autoScrolls.length = 0;
        },
        _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
            this._handleAutoScroll(evt, true);
        },
        _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
            var _this = this;
            var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x, y);
            $695b3d6025d5e530$var$touchEvt$1 = evt;
            // IE does not seem to have native autoscroll,
            // Edge's autoscroll seems too conditional,
            // MACOS Safari does not have autoscroll,
            // Firefox and Chrome are good
            if (fallback || this.options.forceAutoScrollFallback || $695b3d6025d5e530$var$Edge || $695b3d6025d5e530$var$IE11OrLess || $695b3d6025d5e530$var$Safari) {
                $695b3d6025d5e530$var$autoScroll(evt, this.options, elem, fallback);
                // Listener for pointer element change
                var ogElemScroller = $695b3d6025d5e530$var$getParentAutoScrollElement(elem, true);
                if ($695b3d6025d5e530$var$scrolling && (!$695b3d6025d5e530$var$pointerElemChangedInterval || x !== $695b3d6025d5e530$var$lastAutoScrollX || y !== $695b3d6025d5e530$var$lastAutoScrollY)) {
                    $695b3d6025d5e530$var$pointerElemChangedInterval && $695b3d6025d5e530$var$clearPointerElemChangedInterval();
                    // Detect for pointer elem change, emulating native DnD behaviour
                    $695b3d6025d5e530$var$pointerElemChangedInterval = setInterval(function() {
                        var newElem = $695b3d6025d5e530$var$getParentAutoScrollElement(document.elementFromPoint(x, y), true);
                        if (newElem !== ogElemScroller) {
                            ogElemScroller = newElem;
                            $695b3d6025d5e530$var$clearAutoScrolls();
                        }
                        $695b3d6025d5e530$var$autoScroll(evt, _this.options, newElem, fallback);
                    }, 10);
                    $695b3d6025d5e530$var$lastAutoScrollX = x;
                    $695b3d6025d5e530$var$lastAutoScrollY = y;
                }
            } else {
                // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
                if (!this.options.bubbleScroll || $695b3d6025d5e530$var$getParentAutoScrollElement(elem, true) === $695b3d6025d5e530$var$getWindowScrollingElement()) {
                    $695b3d6025d5e530$var$clearAutoScrolls();
                    return;
                }
                $695b3d6025d5e530$var$autoScroll(evt, this.options, $695b3d6025d5e530$var$getParentAutoScrollElement(elem, false), false);
            }
        }
    };
    return $695b3d6025d5e530$var$_extends(AutoScroll, {
        pluginName: 'scroll',
        initializeByDefault: true
    });
}
function $695b3d6025d5e530$var$clearAutoScrolls() {
    $695b3d6025d5e530$var$autoScrolls.forEach(function(autoScroll) {
        clearInterval(autoScroll.pid);
    });
    $695b3d6025d5e530$var$autoScrolls = [];
}
function $695b3d6025d5e530$var$clearPointerElemChangedInterval() {
    clearInterval($695b3d6025d5e530$var$pointerElemChangedInterval);
}
var $695b3d6025d5e530$var$autoScroll = $695b3d6025d5e530$var$throttle(function(evt, options, rootEl, isFallback) {
    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
    if (!options.scroll) return;
    var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = $695b3d6025d5e530$var$getWindowScrollingElement();
    var scrollThisInstance = false, scrollCustomFn;
    // New scroll root, set scrollEl
    if ($695b3d6025d5e530$var$scrollRootEl !== rootEl) {
        $695b3d6025d5e530$var$scrollRootEl = rootEl;
        $695b3d6025d5e530$var$clearAutoScrolls();
        $695b3d6025d5e530$var$scrollEl = options.scroll;
        scrollCustomFn = options.scrollFn;
        if ($695b3d6025d5e530$var$scrollEl === true) $695b3d6025d5e530$var$scrollEl = $695b3d6025d5e530$var$getParentAutoScrollElement(rootEl, true);
    }
    var layersOut = 0;
    var currentParent = $695b3d6025d5e530$var$scrollEl;
    do {
        var el = currentParent, rect = $695b3d6025d5e530$var$getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = $695b3d6025d5e530$var$css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
        if (el === winScroller) {
            canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
            canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
        } else {
            canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
            canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
        }
        var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
        var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
        if (!$695b3d6025d5e530$var$autoScrolls[layersOut]) {
            for(var i = 0; i <= layersOut; i++)if (!$695b3d6025d5e530$var$autoScrolls[i]) $695b3d6025d5e530$var$autoScrolls[i] = {};
        }
        if ($695b3d6025d5e530$var$autoScrolls[layersOut].vx != vx || $695b3d6025d5e530$var$autoScrolls[layersOut].vy != vy || $695b3d6025d5e530$var$autoScrolls[layersOut].el !== el) {
            $695b3d6025d5e530$var$autoScrolls[layersOut].el = el;
            $695b3d6025d5e530$var$autoScrolls[layersOut].vx = vx;
            $695b3d6025d5e530$var$autoScrolls[layersOut].vy = vy;
            clearInterval($695b3d6025d5e530$var$autoScrolls[layersOut].pid);
            if (vx != 0 || vy != 0) {
                scrollThisInstance = true;
                /* jshint loopfunc:true */ $695b3d6025d5e530$var$autoScrolls[layersOut].pid = setInterval((function() {
                    // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
                    if (isFallback && this.layer === 0) $695b3d6025d5e530$export$31b3ca70d8f57423.active._onTouchMove($695b3d6025d5e530$var$touchEvt$1); // To move ghost if it is positioned absolutely
                    var scrollOffsetY = $695b3d6025d5e530$var$autoScrolls[this.layer].vy ? $695b3d6025d5e530$var$autoScrolls[this.layer].vy * speed : 0;
                    var scrollOffsetX = $695b3d6025d5e530$var$autoScrolls[this.layer].vx ? $695b3d6025d5e530$var$autoScrolls[this.layer].vx * speed : 0;
                    if (typeof scrollCustomFn === 'function') {
                        if (scrollCustomFn.call($695b3d6025d5e530$export$31b3ca70d8f57423.dragged.parentNode[$695b3d6025d5e530$var$expando], scrollOffsetX, scrollOffsetY, evt, $695b3d6025d5e530$var$touchEvt$1, $695b3d6025d5e530$var$autoScrolls[this.layer].el) !== 'continue') return;
                    }
                    $695b3d6025d5e530$var$scrollBy($695b3d6025d5e530$var$autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                }).bind({
                    layer: layersOut
                }), 24);
            }
        }
        layersOut++;
    }while (options.bubbleScroll && currentParent !== winScroller && (currentParent = $695b3d6025d5e530$var$getParentAutoScrollElement(currentParent, false)));
    $695b3d6025d5e530$var$scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);
var $695b3d6025d5e530$var$drop = function drop(_ref) {
    var originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, dragEl = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();
    if (toSortable && !toSortable.el.contains(target)) {
        dispatchSortableEvent('spill');
        this.onSpill({
            dragEl: dragEl,
            putSortable: putSortable
        });
    }
};
function $695b3d6025d5e530$var$Revert() {}
$695b3d6025d5e530$var$Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
        var oldDraggableIndex = _ref2.oldDraggableIndex;
        this.startIndex = oldDraggableIndex;
    },
    onSpill: function onSpill(_ref3) {
        var dragEl = _ref3.dragEl, putSortable = _ref3.putSortable;
        this.sortable.captureAnimationState();
        if (putSortable) putSortable.captureAnimationState();
        var nextSibling = $695b3d6025d5e530$var$getChild(this.sortable.el, this.startIndex, this.options);
        if (nextSibling) this.sortable.el.insertBefore(dragEl, nextSibling);
        else this.sortable.el.appendChild(dragEl);
        this.sortable.animateAll();
        if (putSortable) putSortable.animateAll();
    },
    drop: $695b3d6025d5e530$var$drop
};
$695b3d6025d5e530$var$_extends($695b3d6025d5e530$var$Revert, {
    pluginName: 'revertOnSpill'
});
function $695b3d6025d5e530$var$Remove() {}
$695b3d6025d5e530$var$Remove.prototype = {
    onSpill: function onSpill(_ref4) {
        var dragEl = _ref4.dragEl, putSortable = _ref4.putSortable;
        var parentSortable = putSortable || this.sortable;
        parentSortable.captureAnimationState();
        dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
        parentSortable.animateAll();
    },
    drop: $695b3d6025d5e530$var$drop
};
$695b3d6025d5e530$var$_extends($695b3d6025d5e530$var$Remove, {
    pluginName: 'removeOnSpill'
});
var $695b3d6025d5e530$var$lastSwapEl;
function $695b3d6025d5e530$export$bdb5f0a1b77546f4() {
    function Swap() {
        this.defaults = {
            swapClass: 'sortable-swap-highlight'
        };
    }
    Swap.prototype = {
        dragStart: function dragStart(_ref) {
            var dragEl = _ref.dragEl;
            $695b3d6025d5e530$var$lastSwapEl = dragEl;
        },
        dragOverValid: function dragOverValid(_ref2) {
            var completed = _ref2.completed, target = _ref2.target, onMove = _ref2.onMove, activeSortable = _ref2.activeSortable, changed = _ref2.changed, cancel = _ref2.cancel;
            if (!activeSortable.options.swap) return;
            var el = this.sortable.el, options = this.options;
            if (target && target !== el) {
                var prevSwapEl = $695b3d6025d5e530$var$lastSwapEl;
                if (onMove(target) !== false) {
                    $695b3d6025d5e530$var$toggleClass(target, options.swapClass, true);
                    $695b3d6025d5e530$var$lastSwapEl = target;
                } else $695b3d6025d5e530$var$lastSwapEl = null;
                if (prevSwapEl && prevSwapEl !== $695b3d6025d5e530$var$lastSwapEl) $695b3d6025d5e530$var$toggleClass(prevSwapEl, options.swapClass, false);
            }
            changed();
            completed(true);
            cancel();
        },
        drop: function drop(_ref3) {
            var activeSortable = _ref3.activeSortable, putSortable = _ref3.putSortable, dragEl = _ref3.dragEl;
            var toSortable = putSortable || this.sortable;
            var options = this.options;
            $695b3d6025d5e530$var$lastSwapEl && $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$lastSwapEl, options.swapClass, false);
            if ($695b3d6025d5e530$var$lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
                if (dragEl !== $695b3d6025d5e530$var$lastSwapEl) {
                    toSortable.captureAnimationState();
                    if (toSortable !== activeSortable) activeSortable.captureAnimationState();
                    $695b3d6025d5e530$var$swapNodes(dragEl, $695b3d6025d5e530$var$lastSwapEl);
                    toSortable.animateAll();
                    if (toSortable !== activeSortable) activeSortable.animateAll();
                }
            }
        },
        nulling: function nulling() {
            $695b3d6025d5e530$var$lastSwapEl = null;
        }
    };
    return $695b3d6025d5e530$var$_extends(Swap, {
        pluginName: 'swap',
        eventProperties: function eventProperties() {
            return {
                swapItem: $695b3d6025d5e530$var$lastSwapEl
            };
        }
    });
}
function $695b3d6025d5e530$var$swapNodes(n1, n2) {
    var p1 = n1.parentNode, p2 = n2.parentNode, i1, i2;
    if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
    i1 = $695b3d6025d5e530$var$index(n1);
    i2 = $695b3d6025d5e530$var$index(n2);
    if (p1.isEqualNode(p2) && i1 < i2) i2++;
    p1.insertBefore(n2, p1.children[i1]);
    p2.insertBefore(n1, p2.children[i2]);
}
var $695b3d6025d5e530$var$multiDragElements = [], $695b3d6025d5e530$var$multiDragClones = [], $695b3d6025d5e530$var$lastMultiDragSelect, // for selection with modifier key down (SHIFT)
$695b3d6025d5e530$var$multiDragSortable, $695b3d6025d5e530$var$initialFolding = false, // Initial multi-drag fold when drag started
$695b3d6025d5e530$var$folding = false, // Folding any other time
$695b3d6025d5e530$var$dragStarted = false, $695b3d6025d5e530$var$dragEl$1, $695b3d6025d5e530$var$clonesFromRect, $695b3d6025d5e530$var$clonesHidden;
function $695b3d6025d5e530$export$18e5d2a5d1df842d() {
    function MultiDrag(sortable) {
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === '_' && typeof this[fn] === 'function') this[fn] = this[fn].bind(this);
        if (!sortable.options.avoidImplicitDeselect) {
            if (sortable.options.supportPointer) $695b3d6025d5e530$var$on(document, 'pointerup', this._deselectMultiDrag);
            else {
                $695b3d6025d5e530$var$on(document, 'mouseup', this._deselectMultiDrag);
                $695b3d6025d5e530$var$on(document, 'touchend', this._deselectMultiDrag);
            }
        }
        $695b3d6025d5e530$var$on(document, 'keydown', this._checkKeyDown);
        $695b3d6025d5e530$var$on(document, 'keyup', this._checkKeyUp);
        this.defaults = {
            selectedClass: 'sortable-selected',
            multiDragKey: null,
            avoidImplicitDeselect: false,
            setData: function setData(dataTransfer, dragEl) {
                var data = '';
                if ($695b3d6025d5e530$var$multiDragElements.length && $695b3d6025d5e530$var$multiDragSortable === sortable) $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement, i) {
                    data += (!i ? '' : ', ') + multiDragElement.textContent;
                });
                else data = dragEl.textContent;
                dataTransfer.setData('Text', data);
            }
        };
    }
    MultiDrag.prototype = {
        multiDragKeyDown: false,
        isMultiDrag: false,
        delayStartGlobal: function delayStartGlobal(_ref) {
            var dragged = _ref.dragEl;
            $695b3d6025d5e530$var$dragEl$1 = dragged;
        },
        delayEnded: function delayEnded() {
            this.isMultiDrag = ~$695b3d6025d5e530$var$multiDragElements.indexOf($695b3d6025d5e530$var$dragEl$1);
        },
        setupClone: function setupClone(_ref2) {
            var sortable = _ref2.sortable, cancel = _ref2.cancel;
            if (!this.isMultiDrag) return;
            for(var i = 0; i < $695b3d6025d5e530$var$multiDragElements.length; i++){
                $695b3d6025d5e530$var$multiDragClones.push($695b3d6025d5e530$var$clone($695b3d6025d5e530$var$multiDragElements[i]));
                $695b3d6025d5e530$var$multiDragClones[i].sortableIndex = $695b3d6025d5e530$var$multiDragElements[i].sortableIndex;
                $695b3d6025d5e530$var$multiDragClones[i].draggable = false;
                $695b3d6025d5e530$var$multiDragClones[i].style['will-change'] = '';
                $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$multiDragClones[i], this.options.selectedClass, false);
                $695b3d6025d5e530$var$multiDragElements[i] === $695b3d6025d5e530$var$dragEl$1 && $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$multiDragClones[i], this.options.chosenClass, false);
            }
            sortable._hideClone();
            cancel();
        },
        clone: function clone(_ref3) {
            var sortable = _ref3.sortable, rootEl = _ref3.rootEl, dispatchSortableEvent = _ref3.dispatchSortableEvent, cancel = _ref3.cancel;
            if (!this.isMultiDrag) return;
            if (!this.options.removeCloneOnHide) {
                if ($695b3d6025d5e530$var$multiDragElements.length && $695b3d6025d5e530$var$multiDragSortable === sortable) {
                    $695b3d6025d5e530$var$insertMultiDragClones(true, rootEl);
                    dispatchSortableEvent('clone');
                    cancel();
                }
            }
        },
        showClone: function showClone(_ref4) {
            var cloneNowShown = _ref4.cloneNowShown, rootEl = _ref4.rootEl, cancel = _ref4.cancel;
            if (!this.isMultiDrag) return;
            $695b3d6025d5e530$var$insertMultiDragClones(false, rootEl);
            $695b3d6025d5e530$var$multiDragClones.forEach(function(clone) {
                $695b3d6025d5e530$var$css(clone, 'display', '');
            });
            cloneNowShown();
            $695b3d6025d5e530$var$clonesHidden = false;
            cancel();
        },
        hideClone: function hideClone(_ref5) {
            var _this = this;
            var sortable = _ref5.sortable, cloneNowHidden = _ref5.cloneNowHidden, cancel = _ref5.cancel;
            if (!this.isMultiDrag) return;
            $695b3d6025d5e530$var$multiDragClones.forEach(function(clone) {
                $695b3d6025d5e530$var$css(clone, 'display', 'none');
                if (_this.options.removeCloneOnHide && clone.parentNode) clone.parentNode.removeChild(clone);
            });
            cloneNowHidden();
            $695b3d6025d5e530$var$clonesHidden = true;
            cancel();
        },
        dragStartGlobal: function dragStartGlobal(_ref6) {
            var sortable = _ref6.sortable;
            if (!this.isMultiDrag && $695b3d6025d5e530$var$multiDragSortable) $695b3d6025d5e530$var$multiDragSortable.multiDrag._deselectMultiDrag();
            $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.sortableIndex = $695b3d6025d5e530$var$index(multiDragElement);
            });
            // Sort multi-drag elements
            $695b3d6025d5e530$var$multiDragElements = $695b3d6025d5e530$var$multiDragElements.sort(function(a, b) {
                return a.sortableIndex - b.sortableIndex;
            });
            $695b3d6025d5e530$var$dragStarted = true;
        },
        dragStarted: function dragStarted(_ref7) {
            var _this2 = this;
            var sortable = _ref7.sortable;
            if (!this.isMultiDrag) return;
            if (this.options.sort) {
                // Capture rects,
                // hide multi drag elements (by positioning them absolute),
                // set multi drag elements rects to dragRect,
                // show multi drag elements,
                // animate to rects,
                // unset rects & remove from DOM
                sortable.captureAnimationState();
                if (this.options.animation) {
                    $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $695b3d6025d5e530$var$dragEl$1) return;
                        $695b3d6025d5e530$var$css(multiDragElement, 'position', 'absolute');
                    });
                    var dragRect = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$dragEl$1, false, true, true);
                    $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $695b3d6025d5e530$var$dragEl$1) return;
                        $695b3d6025d5e530$var$setRect(multiDragElement, dragRect);
                    });
                    $695b3d6025d5e530$var$folding = true;
                    $695b3d6025d5e530$var$initialFolding = true;
                }
            }
            sortable.animateAll(function() {
                $695b3d6025d5e530$var$folding = false;
                $695b3d6025d5e530$var$initialFolding = false;
                if (_this2.options.animation) $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                    $695b3d6025d5e530$var$unsetRect(multiDragElement);
                });
                // Remove all auxiliary multidrag items from el, if sorting enabled
                if (_this2.options.sort) $695b3d6025d5e530$var$removeMultiDragElements();
            });
        },
        dragOver: function dragOver(_ref8) {
            var target = _ref8.target, completed = _ref8.completed, cancel = _ref8.cancel;
            if ($695b3d6025d5e530$var$folding && ~$695b3d6025d5e530$var$multiDragElements.indexOf(target)) {
                completed(false);
                cancel();
            }
        },
        revert: function revert(_ref9) {
            var fromSortable = _ref9.fromSortable, rootEl = _ref9.rootEl, sortable = _ref9.sortable, dragRect = _ref9.dragRect;
            if ($695b3d6025d5e530$var$multiDragElements.length > 1) {
                // Setup unfold animation
                $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                    sortable.addAnimationState({
                        target: multiDragElement,
                        rect: $695b3d6025d5e530$var$folding ? $695b3d6025d5e530$var$getRect(multiDragElement) : dragRect
                    });
                    $695b3d6025d5e530$var$unsetRect(multiDragElement);
                    multiDragElement.fromRect = dragRect;
                    fromSortable.removeAnimationState(multiDragElement);
                });
                $695b3d6025d5e530$var$folding = false;
                $695b3d6025d5e530$var$insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref10) {
            var sortable = _ref10.sortable, isOwner = _ref10.isOwner, insertion = _ref10.insertion, activeSortable = _ref10.activeSortable, parentEl = _ref10.parentEl, putSortable = _ref10.putSortable;
            var options = this.options;
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                $695b3d6025d5e530$var$initialFolding = false;
                // If leaving sort:false root, or already folding - Fold to new location
                if (options.animation && $695b3d6025d5e530$var$multiDragElements.length > 1 && ($695b3d6025d5e530$var$folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
                    // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
                    var dragRectAbsolute = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$dragEl$1, false, true, true);
                    $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $695b3d6025d5e530$var$dragEl$1) return;
                        $695b3d6025d5e530$var$setRect(multiDragElement, dragRectAbsolute);
                        // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
                        // while folding, and so that we can capture them again because old sortable will no longer be fromSortable
                        parentEl.appendChild(multiDragElement);
                    });
                    $695b3d6025d5e530$var$folding = true;
                }
                // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out
                if (!isOwner) {
                    // Only remove if not folding (folding will remove them anyways)
                    if (!$695b3d6025d5e530$var$folding) $695b3d6025d5e530$var$removeMultiDragElements();
                    if ($695b3d6025d5e530$var$multiDragElements.length > 1) {
                        var clonesHiddenBefore = $695b3d6025d5e530$var$clonesHidden;
                        activeSortable._showClone(sortable);
                        // Unfold animation for clones if showing from hidden
                        if (activeSortable.options.animation && !$695b3d6025d5e530$var$clonesHidden && clonesHiddenBefore) $695b3d6025d5e530$var$multiDragClones.forEach(function(clone) {
                            activeSortable.addAnimationState({
                                target: clone,
                                rect: $695b3d6025d5e530$var$clonesFromRect
                            });
                            clone.fromRect = $695b3d6025d5e530$var$clonesFromRect;
                            clone.thisAnimationDuration = null;
                        });
                    } else activeSortable._showClone(sortable);
                }
            }
        },
        dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
            var dragRect = _ref11.dragRect, isOwner = _ref11.isOwner, activeSortable = _ref11.activeSortable;
            $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.thisAnimationDuration = null;
            });
            if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
                $695b3d6025d5e530$var$clonesFromRect = $695b3d6025d5e530$var$_extends({}, dragRect);
                var dragMatrix = $695b3d6025d5e530$var$matrix($695b3d6025d5e530$var$dragEl$1, true);
                $695b3d6025d5e530$var$clonesFromRect.top -= dragMatrix.f;
                $695b3d6025d5e530$var$clonesFromRect.left -= dragMatrix.e;
            }
        },
        dragOverAnimationComplete: function dragOverAnimationComplete() {
            if ($695b3d6025d5e530$var$folding) {
                $695b3d6025d5e530$var$folding = false;
                $695b3d6025d5e530$var$removeMultiDragElements();
            }
        },
        drop: function drop(_ref12) {
            var evt = _ref12.originalEvent, rootEl = _ref12.rootEl, parentEl = _ref12.parentEl, sortable = _ref12.sortable, dispatchSortableEvent = _ref12.dispatchSortableEvent, oldIndex = _ref12.oldIndex, putSortable = _ref12.putSortable;
            var toSortable = putSortable || this.sortable;
            if (!evt) return;
            var options = this.options, children = parentEl.children;
            // Multi-drag selection
            if (!$695b3d6025d5e530$var$dragStarted) {
                if (options.multiDragKey && !this.multiDragKeyDown) this._deselectMultiDrag();
                $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl$1, options.selectedClass, !~$695b3d6025d5e530$var$multiDragElements.indexOf($695b3d6025d5e530$var$dragEl$1));
                if (!~$695b3d6025d5e530$var$multiDragElements.indexOf($695b3d6025d5e530$var$dragEl$1)) {
                    $695b3d6025d5e530$var$multiDragElements.push($695b3d6025d5e530$var$dragEl$1);
                    $695b3d6025d5e530$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: 'select',
                        targetEl: $695b3d6025d5e530$var$dragEl$1,
                        originalEvent: evt
                    });
                    // Modifier activated, select from last to dragEl
                    if (evt.shiftKey && $695b3d6025d5e530$var$lastMultiDragSelect && sortable.el.contains($695b3d6025d5e530$var$lastMultiDragSelect)) {
                        var lastIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$lastMultiDragSelect), currentIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl$1);
                        if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) (function() {
                            // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                            // (but previous selection existed)
                            var n, i;
                            if (currentIndex > lastIndex) {
                                i = lastIndex;
                                n = currentIndex;
                            } else {
                                i = currentIndex;
                                n = lastIndex + 1;
                            }
                            var filter = options.filter;
                            for(; i < n; i++){
                                if (~$695b3d6025d5e530$var$multiDragElements.indexOf(children[i])) continue;
                                // Check if element is draggable
                                if (!$695b3d6025d5e530$var$closest(children[i], options.draggable, parentEl, false)) continue;
                                // Check if element is filtered
                                var filtered = filter && (typeof filter === 'function' ? filter.call(sortable, evt, children[i], sortable) : filter.split(',').some(function(criteria) {
                                    return $695b3d6025d5e530$var$closest(children[i], criteria.trim(), parentEl, false);
                                }));
                                if (filtered) continue;
                                $695b3d6025d5e530$var$toggleClass(children[i], options.selectedClass, true);
                                $695b3d6025d5e530$var$multiDragElements.push(children[i]);
                                $695b3d6025d5e530$var$dispatchEvent({
                                    sortable: sortable,
                                    rootEl: rootEl,
                                    name: 'select',
                                    targetEl: children[i],
                                    originalEvent: evt
                                });
                            }
                        })();
                    } else $695b3d6025d5e530$var$lastMultiDragSelect = $695b3d6025d5e530$var$dragEl$1;
                    $695b3d6025d5e530$var$multiDragSortable = toSortable;
                } else {
                    $695b3d6025d5e530$var$multiDragElements.splice($695b3d6025d5e530$var$multiDragElements.indexOf($695b3d6025d5e530$var$dragEl$1), 1);
                    $695b3d6025d5e530$var$lastMultiDragSelect = null;
                    $695b3d6025d5e530$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: 'deselect',
                        targetEl: $695b3d6025d5e530$var$dragEl$1,
                        originalEvent: evt
                    });
                }
            }
            // Multi-drag drop
            if ($695b3d6025d5e530$var$dragStarted && this.isMultiDrag) {
                $695b3d6025d5e530$var$folding = false;
                // Do not "unfold" after around dragEl if reverted
                if ((parentEl[$695b3d6025d5e530$var$expando].options.sort || parentEl !== rootEl) && $695b3d6025d5e530$var$multiDragElements.length > 1) {
                    var dragRect = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$dragEl$1), multiDragIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl$1, ':not(.' + this.options.selectedClass + ')');
                    if (!$695b3d6025d5e530$var$initialFolding && options.animation) $695b3d6025d5e530$var$dragEl$1.thisAnimationDuration = null;
                    toSortable.captureAnimationState();
                    if (!$695b3d6025d5e530$var$initialFolding) {
                        if (options.animation) {
                            $695b3d6025d5e530$var$dragEl$1.fromRect = dragRect;
                            $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                                multiDragElement.thisAnimationDuration = null;
                                if (multiDragElement !== $695b3d6025d5e530$var$dragEl$1) {
                                    var rect = $695b3d6025d5e530$var$folding ? $695b3d6025d5e530$var$getRect(multiDragElement) : dragRect;
                                    multiDragElement.fromRect = rect;
                                    // Prepare unfold animation
                                    toSortable.addAnimationState({
                                        target: multiDragElement,
                                        rect: rect
                                    });
                                }
                            });
                        }
                        // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
                        // properly they must all be removed
                        $695b3d6025d5e530$var$removeMultiDragElements();
                        $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                            if (children[multiDragIndex]) parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                            else parentEl.appendChild(multiDragElement);
                            multiDragIndex++;
                        });
                        // If initial folding is done, the elements may have changed position because they are now
                        // unfolding around dragEl, even though dragEl may not have his index changed, so update event
                        // must be fired here as Sortable will not.
                        if (oldIndex === $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl$1)) {
                            var update = false;
                            $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                                if (multiDragElement.sortableIndex !== $695b3d6025d5e530$var$index(multiDragElement)) {
                                    update = true;
                                    return;
                                }
                            });
                            if (update) {
                                dispatchSortableEvent('update');
                                dispatchSortableEvent('sort');
                            }
                        }
                    }
                    // Must be done after capturing individual rects (scroll bar)
                    $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                        $695b3d6025d5e530$var$unsetRect(multiDragElement);
                    });
                    toSortable.animateAll();
                }
                $695b3d6025d5e530$var$multiDragSortable = toSortable;
            }
            // Remove clones if necessary
            if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') $695b3d6025d5e530$var$multiDragClones.forEach(function(clone) {
                clone.parentNode && clone.parentNode.removeChild(clone);
            });
        },
        nullingGlobal: function nullingGlobal() {
            this.isMultiDrag = $695b3d6025d5e530$var$dragStarted = false;
            $695b3d6025d5e530$var$multiDragClones.length = 0;
        },
        destroyGlobal: function destroyGlobal() {
            this._deselectMultiDrag();
            $695b3d6025d5e530$var$off(document, 'pointerup', this._deselectMultiDrag);
            $695b3d6025d5e530$var$off(document, 'mouseup', this._deselectMultiDrag);
            $695b3d6025d5e530$var$off(document, 'touchend', this._deselectMultiDrag);
            $695b3d6025d5e530$var$off(document, 'keydown', this._checkKeyDown);
            $695b3d6025d5e530$var$off(document, 'keyup', this._checkKeyUp);
        },
        _deselectMultiDrag: function _deselectMultiDrag(evt) {
            if (typeof $695b3d6025d5e530$var$dragStarted !== "undefined" && $695b3d6025d5e530$var$dragStarted) return;
            // Only deselect if selection is in this sortable
            if ($695b3d6025d5e530$var$multiDragSortable !== this.sortable) return;
            // Only deselect if target is not item in this sortable
            if (evt && $695b3d6025d5e530$var$closest(evt.target, this.options.draggable, this.sortable.el, false)) return;
            // Only deselect if left click
            if (evt && evt.button !== 0) return;
            while($695b3d6025d5e530$var$multiDragElements.length){
                var el = $695b3d6025d5e530$var$multiDragElements[0];
                $695b3d6025d5e530$var$toggleClass(el, this.options.selectedClass, false);
                $695b3d6025d5e530$var$multiDragElements.shift();
                $695b3d6025d5e530$var$dispatchEvent({
                    sortable: this.sortable,
                    rootEl: this.sortable.el,
                    name: 'deselect',
                    targetEl: el,
                    originalEvent: evt
                });
            }
        },
        _checkKeyDown: function _checkKeyDown(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = true;
        },
        _checkKeyUp: function _checkKeyUp(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = false;
        }
    };
    return $695b3d6025d5e530$var$_extends(MultiDrag, {
        // Static methods & properties
        pluginName: 'multiDrag',
        utils: {
            /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */ select: function select(el) {
                var sortable = el.parentNode[$695b3d6025d5e530$var$expando];
                if (!sortable || !sortable.options.multiDrag || ~$695b3d6025d5e530$var$multiDragElements.indexOf(el)) return;
                if ($695b3d6025d5e530$var$multiDragSortable && $695b3d6025d5e530$var$multiDragSortable !== sortable) {
                    $695b3d6025d5e530$var$multiDragSortable.multiDrag._deselectMultiDrag();
                    $695b3d6025d5e530$var$multiDragSortable = sortable;
                }
                $695b3d6025d5e530$var$toggleClass(el, sortable.options.selectedClass, true);
                $695b3d6025d5e530$var$multiDragElements.push(el);
            },
            /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */ deselect: function deselect(el) {
                var sortable = el.parentNode[$695b3d6025d5e530$var$expando], index = $695b3d6025d5e530$var$multiDragElements.indexOf(el);
                if (!sortable || !sortable.options.multiDrag || !~index) return;
                $695b3d6025d5e530$var$toggleClass(el, sortable.options.selectedClass, false);
                $695b3d6025d5e530$var$multiDragElements.splice(index, 1);
            }
        },
        eventProperties: function eventProperties() {
            var _this3 = this;
            var oldIndicies = [], newIndicies = [];
            $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                oldIndicies.push({
                    multiDragElement: multiDragElement,
                    index: multiDragElement.sortableIndex
                });
                // multiDragElements will already be sorted if folding
                var newIndex;
                if ($695b3d6025d5e530$var$folding && multiDragElement !== $695b3d6025d5e530$var$dragEl$1) newIndex = -1;
                else if ($695b3d6025d5e530$var$folding) newIndex = $695b3d6025d5e530$var$index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
                else newIndex = $695b3d6025d5e530$var$index(multiDragElement);
                newIndicies.push({
                    multiDragElement: multiDragElement,
                    index: newIndex
                });
            });
            return {
                items: $695b3d6025d5e530$var$_toConsumableArray($695b3d6025d5e530$var$multiDragElements),
                clones: [].concat($695b3d6025d5e530$var$multiDragClones),
                oldIndicies: oldIndicies,
                newIndicies: newIndicies
            };
        },
        optionListeners: {
            multiDragKey: function multiDragKey(key) {
                key = key.toLowerCase();
                if (key === 'ctrl') key = 'Control';
                else if (key.length > 1) key = key.charAt(0).toUpperCase() + key.substr(1);
                return key;
            }
        }
    });
}
function $695b3d6025d5e530$var$insertMultiDragElements(clonesInserted, rootEl) {
    $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement, i) {
        var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(multiDragElement, target);
        else rootEl.appendChild(multiDragElement);
    });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */ function $695b3d6025d5e530$var$insertMultiDragClones(elementsInserted, rootEl) {
    $695b3d6025d5e530$var$multiDragClones.forEach(function(clone, i) {
        var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(clone, target);
        else rootEl.appendChild(clone);
    });
}
function $695b3d6025d5e530$var$removeMultiDragElements() {
    $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
        if (multiDragElement === $695b3d6025d5e530$var$dragEl$1) return;
        multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
    });
}
$695b3d6025d5e530$export$31b3ca70d8f57423.mount(new $695b3d6025d5e530$var$AutoScrollPlugin());
$695b3d6025d5e530$export$31b3ca70d8f57423.mount($695b3d6025d5e530$var$Remove, $695b3d6025d5e530$var$Revert);
var $695b3d6025d5e530$export$2e2bcd8739ae039 = $695b3d6025d5e530$export$31b3ca70d8f57423;

});

parcelRegister("254a8", function(module, exports) {
'use strict';

module.exports = (parcelRequire("krIeN")).TableFilter;

});

parcelRegister("fa4m4", function(module, exports) {

$parcel$export(module.exports, "InternalError", () => $b09b2afdbfd1a9ea$export$a782d6d01910de24);
$parcel$export(module.exports, "ArgumentError", () => $b09b2afdbfd1a9ea$export$46daa3843b07109f);
// noinspection JSUnusedGlobalSymbols
class $b09b2afdbfd1a9ea$var$BaseError extends Error {
    _name;
}
class $b09b2afdbfd1a9ea$export$a782d6d01910de24 extends $b09b2afdbfd1a9ea$var$BaseError {
    //https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
    _name = 'InternalError';
}
class $b09b2afdbfd1a9ea$export$46daa3843b07109f extends $b09b2afdbfd1a9ea$export$a782d6d01910de24 {
    _name = 'ArgumentError';
}
class $b09b2afdbfd1a9ea$export$fbf8ee4f2cc312c5 extends $b09b2afdbfd1a9ea$var$BaseError {
    _name = 'ExternalError';
}

});



parcelRegister("84Cg4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e0c5fbcc05188b7$export$2e2bcd8739ae039);
// noinspection JSUnusedGlobalSymbols

var $l1pQ8 = parcelRequire("l1pQ8");
class $5e0c5fbcc05188b7$export$2e2bcd8739ae039 {
    static init() {
        const option = (0, $l1pQ8.default).defaults;
        option.elements.bar.borderWidth = 1;
        option.maintainAspectRatio = false;
        option.responsive = true;
        option.interaction.intersect = false;
        option.interaction.mode = 'index';
        option.plugins.title.display = true;
        this._purchase();
        this._product();
    }
    static _purchase() {
        $.get(`/index/data/purchase${location.search}`, (data)=>{
            data.type = 'bar';
            data.options.scales = {
                x: {
                    stacked: true
                },
                y: {
                    stacked: true,
                    ticks: {
                        precision: 0,
                        callback: (value)=>`${value.toLocaleString()}\u{5186}`
                    }
                }
            };
            data.options.plugins.tooltip = {
                callbacks: {
                    label: (context)=>`${context.dataset.label} : ${context.parsed.y.toLocaleString()}\u{5186}`,
                    footer: (items)=>{
                        let total = 0;
                        for (const bar of items)total += bar.raw;
                        return `\u{5408}\u{8A08} : ${total.toLocaleString()}\u{5186}`;
                    }
                }
            };
            new (0, $l1pQ8.default)($('#graph_purchase'), data);
        });
    }
    static _product() {
        $.get(`/index/data/product${location.search}`, (data)=>{
            data.type = 'bar';
            data.options.scales = {
                x: {
                    stacked: true
                },
                y: {
                    stacked: true,
                    position: 'left',
                    ticks: {
                        precision: 0,
                        callback: (value)=>`${value.toLocaleString()}\u{500B}`
                    }
                },
                y1: {
                    stacked: true,
                    position: 'right',
                    ticks: {
                        precision: 0,
                        callback: (value)=>`${value.toLocaleString()}\u{5186}`
                    }
                }
            };
            data.options.plugins.tooltip = {
                callbacks: {
                    label: (context)=>{
                        const value = `${context.dataset.label} : ${context.parsed.y.toLocaleString()}`;
                        return value + (context.dataset.stack === 'count' ? "\u500B" : "\u5186");
                    },
                    footer: (items)=>{
                        let price = 0;
                        let count = 0;
                        for (const bar of items)if (bar.dataset.stack === 'count') count += bar.raw;
                        else price += bar.raw;
                        return `\u{5408}\u{8A08} : ${price.toLocaleString()}\u{5186}\u{3001}${count.toLocaleString()}\u{500B}`;
                    }
                }
            };
            new (0, $l1pQ8.default)($('#graph_product'), data);
        });
    }
    static reset(form) {
        form.customer_rank.value = '';
        form.subscription_rank.value = '';
        form.sex.value = '';
        form.product.value = '';
        form.submit();
    }
}

});
parcelRegister("l1pQ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $849afbc45c43fd19$export$2e2bcd8739ae039);

var $lDl6b = parcelRequire("lDl6b");
(0, $lDl6b.Chart).register(...(0, $lDl6b.registerables));
var $849afbc45c43fd19$export$2e2bcd8739ae039 = (0, $lDl6b.Chart);

});
parcelRegister("lDl6b", function(module, exports) {

$parcel$export(module.exports, "Chart", () => $b19b9e41583580fc$export$acaa6426d77a227e);
$parcel$export(module.exports, "registerables", () => $b19b9e41583580fc$export$e8959e79e3af550f);
/*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */ 
var $h1WWF = parcelRequire("h1WWF");
class $b19b9e41583580fc$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $h1WWF.r).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, 'progress');
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, 'complete');
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), 'complete');
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $b19b9e41583580fc$export$a424a0aa8f687495 = new $b19b9e41583580fc$var$Animator();
const $b19b9e41583580fc$var$transparent = 'transparent';
const $b19b9e41583580fc$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $h1WWF.c)(from || $b19b9e41583580fc$var$transparent);
        const c1 = c0.valid && (0, $h1WWF.c)(to || $b19b9e41583580fc$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $b19b9e41583580fc$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $h1WWF.a)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $h1WWF.a)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $b19b9e41583580fc$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $h1WWF.e)[cfg.easing] || (0, $h1WWF.e).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $h1WWF.a)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $h1WWF.a)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? 'res' : 'rej';
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
const $b19b9e41583580fc$var$numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
const $b19b9e41583580fc$var$colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
(0, $h1WWF.d).set('animation', {
    delay: undefined,
    duration: 1000,
    easing: 'easeOutQuart',
    fn: undefined,
    from: undefined,
    loop: undefined,
    to: undefined,
    type: undefined
});
const $b19b9e41583580fc$var$animationOptions = Object.keys((0, $h1WWF.d).animation);
(0, $h1WWF.d).describe('animation', {
    _fallback: false,
    _indexable: false,
    _scriptable: (name)=>name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
});
(0, $h1WWF.d).set('animations', {
    colors: {
        type: 'color',
        properties: $b19b9e41583580fc$var$colors
    },
    numbers: {
        type: 'number',
        properties: $b19b9e41583580fc$var$numbers
    }
});
(0, $h1WWF.d).describe('animations', {
    _fallback: 'animation'
});
(0, $h1WWF.d).set('transitions', {
    active: {
        animation: {
            duration: 400
        }
    },
    resize: {
        animation: {
            duration: 0
        }
    },
    show: {
        animations: {
            colors: {
                from: 'transparent'
            },
            visible: {
                type: 'boolean',
                duration: 0
            }
        }
    },
    hide: {
        animations: {
            colors: {
                to: 'transparent'
            },
            visible: {
                type: 'boolean',
                easing: 'linear',
                fn: (v)=>v | 0
            }
        }
    }
});
class $b19b9e41583580fc$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $h1WWF.i)(config)) return;
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $h1WWF.i)(cfg)) return;
            const resolved = {};
            for (const option of $b19b9e41583580fc$var$animationOptions)resolved[option] = cfg[option];
            ((0, $h1WWF.b)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $b19b9e41583580fc$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $b19b9e41583580fc$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === '$') continue;
            if (prop === 'options') {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $b19b9e41583580fc$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $b19b9e41583580fc$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $b19b9e41583580fc$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $b19b9e41583580fc$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $b19b9e41583580fc$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $b19b9e41583580fc$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $b19b9e41583580fc$var$scaleClip(xScale, allowedOverflow);
    const y = $b19b9e41583580fc$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $b19b9e41583580fc$var$toClip(value) {
    let t, r, b, l;
    if ((0, $h1WWF.i)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $b19b9e41583580fc$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $b19b9e41583580fc$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === 'single';
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $h1WWF.g)(otherValue) && (singleMode || value === 0 || (0, $h1WWF.s)(value) === (0, $h1WWF.s)(otherValue))) value += otherValue;
    }
    return value;
}
function $b19b9e41583580fc$var$convertObjectDataToArray(data) {
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            x: key,
            y: data[key]
        };
    }
    return adata;
}
function $b19b9e41583580fc$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $b19b9e41583580fc$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $b19b9e41583580fc$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $b19b9e41583580fc$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $b19b9e41583580fc$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $b19b9e41583580fc$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $b19b9e41583580fc$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $b19b9e41583580fc$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $b19b9e41583580fc$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $b19b9e41583580fc$var$getLastIndexInStack(stack, vScale, false, meta.type);
    }
}
function $b19b9e41583580fc$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $b19b9e41583580fc$var$createDatasetContext(parent, index) {
    return (0, $h1WWF.h)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: 'default',
        type: 'dataset'
    });
}
function $b19b9e41583580fc$var$createDataContext(parent, index, element) {
    return (0, $h1WWF.h)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: 'default',
        type: 'data'
    });
}
function $b19b9e41583580fc$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
    }
}
const $b19b9e41583580fc$var$isDirectUpdateMode = (mode)=>mode === 'reset' || mode === 'none';
const $b19b9e41583580fc$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $b19b9e41583580fc$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $b19b9e41583580fc$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $b19b9e41583580fc$export$75572ec5c55b4048 {
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $b19b9e41583580fc$var$isStacked(meta.vScale, meta);
        this.addElements();
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $b19b9e41583580fc$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === 'x' ? x : axis === 'r' ? r : y;
        const xid = meta.xAxisID = (0, $h1WWF.v)(dataset.xAxisID, $b19b9e41583580fc$var$getFirstScaleId(chart, 'x'));
        const yid = meta.yAxisID = (0, $h1WWF.v)(dataset.yAxisID, $b19b9e41583580fc$var$getFirstScaleId(chart, 'y'));
        const rid = meta.rAxisID = (0, $h1WWF.v)(dataset.rAxisID, $b19b9e41583580fc$var$getFirstScaleId(chart, 'r'));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update('reset');
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $h1WWF.u)(this._data, this);
        if (meta._stacked) $b19b9e41583580fc$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $h1WWF.i)(data)) this._data = $b19b9e41583580fc$var$convertObjectDataToArray(data);
        else if (_data !== data) {
            if (_data) {
                (0, $h1WWF.u)(_data, this);
                const meta = this._cachedMeta;
                $b19b9e41583580fc$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $h1WWF.l)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $b19b9e41583580fc$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $b19b9e41583580fc$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) $b19b9e41583580fc$var$updateStacks(this, meta._parsed);
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $h1WWF.b)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $h1WWF.i)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $b19b9e41583580fc$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $h1WWF.f)(item, xAxisKey), index),
                y: yScale.parse((0, $h1WWF.f)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $b19b9e41583580fc$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]
        };
        return $b19b9e41583580fc$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $b19b9e41583580fc$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $b19b9e41583580fc$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $b19b9e41583580fc$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $h1WWF.g)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $h1WWF.g)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
            value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || 'default');
        meta._clip = $b19b9e41583580fc$var$toClip((0, $h1WWF.v)(this.options.clip, $b19b9e41583580fc$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? 'active' : 'default';
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $b19b9e41583580fc$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $b19b9e41583580fc$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = 'default', index) {
        const active = mode === 'active';
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + '-' + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $h1WWF.j)(index);
        if (cached) return $b19b9e41583580fc$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            'hover',
            elementType,
            ''
        ] : [
            elementType,
            ''
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $h1WWF.d).elements[elementType]);
        const context = ()=>this.getContext(index, active);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($b19b9e41583580fc$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $b19b9e41583580fc$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $b19b9e41583580fc$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($b19b9e41583580fc$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$b19b9e41583580fc$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, 'reset');
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $b19b9e41583580fc$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            '_insertElements',
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            '_removeElements',
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            '_removeElements',
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            '_removeElements',
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            '_insertElements',
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            '_insertElements',
            0,
            arguments.length
        ]);
    }
}
$b19b9e41583580fc$export$75572ec5c55b4048.defaults = {};
$b19b9e41583580fc$export$75572ec5c55b4048.prototype.datasetElementType = null;
$b19b9e41583580fc$export$75572ec5c55b4048.prototype.dataElementType = null;
function $b19b9e41583580fc$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $h1WWF._)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $b19b9e41583580fc$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $b19b9e41583580fc$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $h1WWF.j)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $b19b9e41583580fc$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $h1WWF.k)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $b19b9e41583580fc$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $b19b9e41583580fc$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $b19b9e41583580fc$var$parseValue(entry, item, vScale, i) {
    if ((0, $h1WWF.b)(entry)) $b19b9e41583580fc$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $b19b9e41583580fc$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($b19b9e41583580fc$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $b19b9e41583580fc$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $b19b9e41583580fc$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $h1WWF.s)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $b19b9e41583580fc$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $b19b9e41583580fc$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $b19b9e41583580fc$var$borderProps(properties);
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$b19b9e41583580fc$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$b19b9e41583580fc$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $b19b9e41583580fc$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $b19b9e41583580fc$var$swap(edge, a, b);
        edge = $b19b9e41583580fc$var$startEnd(edge, b, a);
    } else edge = $b19b9e41583580fc$var$startEnd(edge, a, b);
    return edge;
}
function $b19b9e41583580fc$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $b19b9e41583580fc$var$startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function $b19b9e41583580fc$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $b19b9e41583580fc$export$e97d5dc64e999004 extends $b19b9e41583580fc$export$75572ec5c55b4048 {
    parsePrimitiveData(meta, data, start, count) {
        return $b19b9e41583580fc$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $b19b9e41583580fc$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $h1WWF.f)(obj, iAxisKey), i);
            parsed.push($b19b9e41583580fc$var$parseValue((0, $h1WWF.f)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $b19b9e41583580fc$var$isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === 'reset';
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $h1WWF.k)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $b19b9e41583580fc$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
            const options = properties.options || bars[i].options;
            $b19b9e41583580fc$var$setBorderSkipped(properties, options, stack, index);
            $b19b9e41583580fc$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const skipNull = (meta)=>{
            const parsed = meta.controller.getParsed(dataIndex);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $h1WWF.k)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $b19b9e41583580fc$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $b19b9e41583580fc$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $h1WWF.s)(value) !== (0, $h1WWF.s)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $h1WWF.k)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $b19b9e41583580fc$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $h1WWF.s)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $h1WWF.v)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === 'flex' ? $b19b9e41583580fc$var$computeFlexCategoryTraits(index, ruler, options, stackCount) : $b19b9e41583580fc$var$computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null) rects[i].draw(this._ctx);
    }
}
$b19b9e41583580fc$export$e97d5dc64e999004.id = 'bar';
$b19b9e41583580fc$export$e97d5dc64e999004.defaults = {
    datasetElementType: false,
    dataElementType: 'bar',
    categoryPercentage: 0.8,
    barPercentage: 0.9,
    grouped: true,
    animations: {
        numbers: {
            type: 'number',
            properties: [
                'x',
                'y',
                'base',
                'width',
                'height'
            ]
        }
    }
};
$b19b9e41583580fc$export$e97d5dc64e999004.overrides = {
    scales: {
        _index_: {
            type: 'category',
            offset: true,
            grid: {
                offset: true
            }
        },
        _value_: {
            type: 'linear',
            beginAtZero: true
        }
    }
};
class $b19b9e41583580fc$export$19b5c4773f17abe extends $b19b9e41583580fc$export$75572ec5c55b4048 {
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $h1WWF.v)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $h1WWF.v)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: meta.label,
            value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== 'active') values.radius = 0;
        values.radius += (0, $h1WWF.v)(parsed && parsed._custom, radius);
        return values;
    }
}
$b19b9e41583580fc$export$19b5c4773f17abe.id = 'bubble';
$b19b9e41583580fc$export$19b5c4773f17abe.defaults = {
    datasetElementType: false,
    dataElementType: 'point',
    animations: {
        numbers: {
            type: 'number',
            properties: [
                'x',
                'y',
                'borderWidth',
                'radius'
            ]
        }
    }
};
$b19b9e41583580fc$export$19b5c4773f17abe.overrides = {
    scales: {
        x: {
            type: 'linear'
        },
        y: {
            type: 'linear'
        }
    },
    plugins: {
        tooltip: {
            callbacks: {
                title () {
                    return '';
                }
            }
        }
    }
};
function $b19b9e41583580fc$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $h1WWF.T)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $h1WWF.p)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $h1WWF.p)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $h1WWF.H), startY, endY);
        const minX = calcMin((0, $h1WWF.P), startX, endX);
        const minY = calcMin((0, $h1WWF.P) + (0, $h1WWF.H), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $b19b9e41583580fc$export$e04603e7d8b77172 extends $b19b9e41583580fc$export$75572ec5c55b4048 {
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $h1WWF.i)(data[start])) {
                const { key: key = 'value' } = this._parsing;
                getter = (i)=>+(0, $h1WWF.f)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $h1WWF.t)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $h1WWF.t)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $h1WWF.T);
        let max = -(0, $h1WWF.T);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i)) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $h1WWF.m)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $b19b9e41583580fc$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $h1WWF.n)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $h1WWF.T));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $h1WWF.T) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $h1WWF.o)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== 'inner') max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $h1WWF.v)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
$b19b9e41583580fc$export$e04603e7d8b77172.id = 'doughnut';
$b19b9e41583580fc$export$e04603e7d8b77172.defaults = {
    datasetElementType: false,
    dataElementType: 'arc',
    animation: {
        animateRotate: true,
        animateScale: false
    },
    animations: {
        numbers: {
            type: 'number',
            properties: [
                'circumference',
                'endAngle',
                'innerRadius',
                'outerRadius',
                'startAngle',
                'x',
                'y',
                'offset',
                'borderWidth',
                'spacing'
            ]
        }
    },
    cutout: '50%',
    rotation: 0,
    circumference: 360,
    radius: '100%',
    spacing: 0,
    indexAxis: 'r'
};
$b19b9e41583580fc$export$e04603e7d8b77172.descriptors = {
    _scriptable: (name)=>name !== 'spacing',
    _indexable: (name)=>name !== 'spacing'
};
$b19b9e41583580fc$export$e04603e7d8b77172.overrides = {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    const data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        const { labels: { pointStyle: pointStyle } } = chart.legend.options;
                        return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        },
        tooltip: {
            callbacks: {
                title () {
                    return '';
                },
                label (tooltipItem) {
                    let dataLabel = tooltipItem.label;
                    const value = ': ' + tooltipItem.formattedValue;
                    if ((0, $h1WWF.b)(dataLabel)) {
                        dataLabel = dataLabel.slice();
                        dataLabel[0] += value;
                    } else dataLabel += value;
                    return dataLabel;
                }
            }
        }
    }
};
class $b19b9e41583580fc$export$3c9b5d28c11cbfd0 extends $b19b9e41583580fc$export$75572ec5c55b4048 {
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $h1WWF.q)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $h1WWF.w)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $h1WWF.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $h1WWF.k)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
$b19b9e41583580fc$export$3c9b5d28c11cbfd0.id = 'line';
$b19b9e41583580fc$export$3c9b5d28c11cbfd0.defaults = {
    datasetElementType: 'line',
    dataElementType: 'point',
    showLine: true,
    spanGaps: false
};
$b19b9e41583580fc$export$3c9b5d28c11cbfd0.overrides = {
    scales: {
        _index_: {
            type: 'category'
        },
        _value_: {
            type: 'linear'
        }
    }
};
class $b19b9e41583580fc$export$2a270b3a0d973c85 extends $b19b9e41583580fc$export$75572ec5c55b4048 {
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $h1WWF.o)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $h1WWF.y).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $h1WWF.P);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $h1WWF.t)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
$b19b9e41583580fc$export$2a270b3a0d973c85.id = 'polarArea';
$b19b9e41583580fc$export$2a270b3a0d973c85.defaults = {
    dataElementType: 'arc',
    animation: {
        animateRotate: true,
        animateScale: true
    },
    animations: {
        numbers: {
            type: 'number',
            properties: [
                'x',
                'y',
                'startAngle',
                'endAngle',
                'innerRadius',
                'outerRadius'
            ]
        }
    },
    indexAxis: 'r',
    startAngle: 0
};
$b19b9e41583580fc$export$2a270b3a0d973c85.overrides = {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    const data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        const { labels: { pointStyle: pointStyle } } = chart.legend.options;
                        return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        },
        tooltip: {
            callbacks: {
                title () {
                    return '';
                },
                label (context) {
                    return context.chart.data.labels[context.dataIndex] + ': ' + context.formattedValue;
                }
            }
        }
    },
    scales: {
        r: {
            type: 'radialLinear',
            angleLines: {
                display: false
            },
            beginAtZero: true,
            grid: {
                circular: true
            },
            pointLabels: {
                display: false
            },
            startAngle: 0
        }
    }
};
class $b19b9e41583580fc$export$b21a3f1286706191 extends $b19b9e41583580fc$export$e04603e7d8b77172 {
}
$b19b9e41583580fc$export$b21a3f1286706191.id = 'pie';
$b19b9e41583580fc$export$b21a3f1286706191.defaults = {
    cutout: 0,
    rotation: 0,
    circumference: 360,
    radius: '100%'
};
class $b19b9e41583580fc$export$48dbc6ac651bf8be extends $b19b9e41583580fc$export$75572ec5c55b4048 {
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: '' + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $h1WWF.y).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== 'resize') {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === 'reset';
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
$b19b9e41583580fc$export$48dbc6ac651bf8be.id = 'radar';
$b19b9e41583580fc$export$48dbc6ac651bf8be.defaults = {
    datasetElementType: 'line',
    dataElementType: 'point',
    indexAxis: 'r',
    showLine: true,
    elements: {
        line: {
            fill: 'start'
        }
    }
};
$b19b9e41583580fc$export$48dbc6ac651bf8be.overrides = {
    aspectRatio: 1,
    scales: {
        r: {
            type: 'radialLinear'
        }
    }
};
class $b19b9e41583580fc$export$db77ccec0bb4ccac {
    constructor(){
        this.x = undefined;
        this.y = undefined;
        this.active = false;
        this.options = undefined;
        this.$animations = undefined;
    }
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $h1WWF.x)(this.x) && (0, $h1WWF.x)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
$b19b9e41583580fc$export$db77ccec0bb4ccac.defaults = {};
$b19b9e41583580fc$export$db77ccec0bb4ccac.defaultRoutes = undefined;
const $b19b9e41583580fc$var$formatters = {
    values (value) {
        return (0, $h1WWF.b)(value) ? value : '' + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = 'scientific';
            delta = $b19b9e41583580fc$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = (0, $h1WWF.z)(Math.abs(delta));
        const numDecimal = Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return (0, $h1WWF.o)(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const remain = tickValue / Math.pow(10, Math.floor((0, $h1WWF.z)(tickValue)));
        if (remain === 1 || remain === 2 || remain === 5) return $b19b9e41583580fc$var$formatters.numeric.call(this, tickValue, index, ticks);
        return '';
    }
};
function $b19b9e41583580fc$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $b19b9e41583580fc$export$27c7467594ef87bd = {
    formatters: $b19b9e41583580fc$var$formatters
};
(0, $h1WWF.d).set('scale', {
    display: true,
    offset: false,
    reverse: false,
    beginAtZero: false,
    bounds: 'ticks',
    grace: 0,
    grid: {
        display: true,
        lineWidth: 1,
        drawBorder: true,
        drawOnChartArea: true,
        drawTicks: true,
        tickLength: 8,
        tickWidth: (_ctx, options)=>options.lineWidth,
        tickColor: (_ctx, options)=>options.color,
        offset: false,
        borderDash: [],
        borderDashOffset: 0.0,
        borderWidth: 1
    },
    title: {
        display: false,
        text: '',
        padding: {
            top: 4,
            bottom: 4
        }
    },
    ticks: {
        minRotation: 0,
        maxRotation: 50,
        mirror: false,
        textStrokeWidth: 0,
        textStrokeColor: '',
        padding: 3,
        display: true,
        autoSkip: true,
        autoSkipPadding: 3,
        labelOffset: 0,
        callback: $b19b9e41583580fc$export$27c7467594ef87bd.formatters.values,
        minor: {},
        major: {},
        align: 'center',
        crossAlign: 'near',
        showLabelBackdrop: false,
        backdropColor: 'rgba(255, 255, 255, 0.75)',
        backdropPadding: 2
    }
});
(0, $h1WWF.d).route('scale.ticks', 'color', '', 'color');
(0, $h1WWF.d).route('scale.grid', 'color', '', 'borderColor');
(0, $h1WWF.d).route('scale.grid', 'borderColor', '', 'borderColor');
(0, $h1WWF.d).route('scale.title', 'color', '', 'color');
(0, $h1WWF.d).describe('scale', {
    _fallback: false,
    _scriptable: (name)=>!name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
    _indexable: (name)=>name !== 'borderDash' && name !== 'tickBorderDash'
});
(0, $h1WWF.d).describe('scales', {
    _fallback: 'scale'
});
(0, $h1WWF.d).describe('scale.ticks', {
    _scriptable: (name)=>name !== 'backdropPadding' && name !== 'callback',
    _indexable: (name)=>name !== 'backdropPadding'
});
function $b19b9e41583580fc$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const ticksLimit = tickOpts.maxTicksLimit || $b19b9e41583580fc$var$determineMaxTicks(scale);
    const majorIndices = tickOpts.major.enabled ? $b19b9e41583580fc$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $b19b9e41583580fc$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $b19b9e41583580fc$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $b19b9e41583580fc$var$skip(ticks, newTicks, spacing, (0, $h1WWF.k)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$b19b9e41583580fc$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $b19b9e41583580fc$var$skip(ticks, newTicks, spacing, last, (0, $h1WWF.k)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $b19b9e41583580fc$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $b19b9e41583580fc$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $b19b9e41583580fc$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $b19b9e41583580fc$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $h1WWF.A)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $b19b9e41583580fc$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $b19b9e41583580fc$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $b19b9e41583580fc$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $h1WWF.v)(majorStart, 0);
    const end = Math.min((0, $h1WWF.v)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $b19b9e41583580fc$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $b19b9e41583580fc$var$reverseAlign = (align)=>align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const $b19b9e41583580fc$var$offsetFromEdge = (scale, edge, offset)=>edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
function $b19b9e41583580fc$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $b19b9e41583580fc$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $b19b9e41583580fc$var$garbageCollect(caches, length) {
    (0, $h1WWF.Q)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $b19b9e41583580fc$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $b19b9e41583580fc$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $h1WWF.O)(options.font, fallback);
    const padding = (0, $h1WWF.K)(options.padding);
    const lines = (0, $h1WWF.b)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $b19b9e41583580fc$var$createScaleContext(parent, scale) {
    return (0, $h1WWF.h)(parent, {
        scale: scale,
        type: 'scale'
    });
}
function $b19b9e41583580fc$var$createTickContext(parent, index, tick) {
    return (0, $h1WWF.h)(parent, {
        tick: tick,
        index: index,
        type: 'tick'
    });
}
function $b19b9e41583580fc$var$titleAlign(align, position, reverse) {
    let ret = (0, $h1WWF.R)(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') ret = $b19b9e41583580fc$var$reverseAlign(ret);
    return ret;
}
function $b19b9e41583580fc$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $h1WWF.S)(align, left, right);
        if ((0, $h1WWF.i)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $b19b9e41583580fc$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $h1WWF.i)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === 'center') titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $b19b9e41583580fc$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $h1WWF.S)(align, bottom, top);
        rotation = position === 'left' ? -(0, $h1WWF.H) : (0, $h1WWF.H);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $b19b9e41583580fc$export$d60cfc58d3c358b6 extends $b19b9e41583580fc$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $h1WWF.B)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $h1WWF.B)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $h1WWF.B)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $h1WWF.B)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $h1WWF.B)(_userMin, _suggestedMin),
            max: (0, $h1WWF.B)(_userMax, _suggestedMax),
            minDefined: (0, $h1WWF.g)(_userMin),
            maxDefined: (0, $h1WWF.g)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $h1WWF.B)(min, (0, $h1WWF.B)(max, min)),
            max: (0, $h1WWF.B)(max, (0, $h1WWF.B)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $h1WWF.C)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $h1WWF.D)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $b19b9e41583580fc$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
            this.ticks = $b19b9e41583580fc$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $h1WWF.C)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $h1WWF.C)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $h1WWF.C)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $h1WWF.C)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks('beforeDataLimits');
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks('afterDataLimits');
    }
    beforeBuildTicks() {
        this._callHooks('beforeBuildTicks');
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks('afterBuildTicks');
    }
    beforeTickToLabelConversion() {
        (0, $h1WWF.C)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $h1WWF.C)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $h1WWF.C)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $h1WWF.C)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = this.ticks.length;
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $h1WWF.E)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $b19b9e41583580fc$var$getTickMarkLength(options.grid) - tickOpts.padding - $b19b9e41583580fc$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $h1WWF.F)(Math.min(Math.asin((0, $h1WWF.E)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $h1WWF.E)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $h1WWF.E)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $h1WWF.C)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $h1WWF.C)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $b19b9e41583580fc$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $b19b9e41583580fc$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $b19b9e41583580fc$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $h1WWF.t)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== 'top' && this.axis === 'x';
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === 'start') paddingRight = last.width;
            else if (align === 'end') paddingLeft = first.width;
            else if (align !== 'inner') {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === 'start') {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === 'end') {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $h1WWF.C)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === 'top' || position === 'bottom' || axis === 'x';
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $h1WWF.k)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $b19b9e41583580fc$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; ++i){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $h1WWF.k)(label) && !(0, $h1WWF.b)(label)) {
                width = (0, $h1WWF.G)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $h1WWF.b)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $h1WWF.k)(nestedLabel) && !(0, $h1WWF.b)(nestedLabel)) {
                    width = (0, $h1WWF.G)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $b19b9e41583580fc$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $h1WWF.I)(this._alignToPixels ? (0, $h1WWF.J)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $b19b9e41583580fc$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $b19b9e41583580fc$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $h1WWF.t)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== 'auto') return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $b19b9e41583580fc$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = grid.setContext(this.getContext());
        const axisWidth = borderOpts.drawBorder ? borderOpts.borderWidth : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $h1WWF.J)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === 'top') {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === 'bottom') {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === 'left') {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === 'right') {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === 'x') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $h1WWF.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === 'y') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $h1WWF.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $h1WWF.v)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const optsAtIndex = grid.setContext(this.getContext(i));
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndex.borderDash || [];
            const borderDashOffset = optsAtIndex.borderDashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $b19b9e41583580fc$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $h1WWF.J)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $b19b9e41583580fc$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $h1WWF.t)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = 'middle';
        if (position === 'top') {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'bottom') {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'left') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === 'right') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === 'x') {
            if (position === 'center') y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $h1WWF.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === 'y') {
            if (position === 'center') x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $h1WWF.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === 'y') {
            if (align === 'start') textBaseline = 'top';
            else if (align === 'end') textBaseline = 'bottom';
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $h1WWF.b)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === 'inner') {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? 'right' : 'left';
                    else if (i === 0) tickTextAlign = !this.options.reverse ? 'left' : 'right';
                    else tickTextAlign = 'center';
                }
                if (position === 'top') {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $h1WWF.K)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = y + textOffset - labelPadding.top;
                let left = x - labelPadding.left;
                switch(textBaseline){
                    case 'middle':
                        top -= height / 2;
                        break;
                    case 'bottom':
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case 'center':
                        left -= width / 2;
                        break;
                    case 'right':
                        left -= width;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                rotation: rotation,
                label: label,
                font: font,
                color: color,
                strokeColor: strokeColor,
                strokeWidth: strokeWidth,
                textOffset: textOffset,
                textAlign: tickTextAlign,
                textBaseline: textBaseline,
                translation: [
                    x,
                    y
                ],
                backdrop: backdrop
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $h1WWF.t)(this.labelRotation);
        if (rotation) return position === 'top' ? 'left' : 'right';
        let align = 'center';
        if (ticks.align === 'start') align = 'left';
        else if (ticks.align === 'end') align = 'right';
        else if (ticks.align === 'inner') align = 'inner';
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === 'left') {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x = this.left;
                }
            }
        } else if (position === 'right') {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x = this.right;
                }
            }
        } else textAlign = 'right';
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === 'left' || position === 'right') return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === 'top' || position === 'bottom') return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { grid: grid } } = this;
        const borderOpts = grid.setContext(this.getContext());
        const axisWidth = grid.drawBorder ? borderOpts.borderWidth : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $h1WWF.J)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $h1WWF.J)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $h1WWF.J)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $h1WWF.J)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.borderWidth;
        ctx.strokeStyle = borderOpts.borderColor;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $h1WWF.L)(ctx, area);
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        let i, ilen;
        for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            const tickFont = item.font;
            const label = item.label;
            if (item.backdrop) {
                ctx.fillStyle = item.backdrop.color;
                ctx.fillRect(item.backdrop.left, item.backdrop.top, item.backdrop.width, item.backdrop.height);
            }
            let y = item.textOffset;
            (0, $h1WWF.M)(ctx, label, 0, y, tickFont, item);
        }
        if (area) (0, $h1WWF.N)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $h1WWF.O)(title.font);
        const padding = (0, $h1WWF.K)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === 'bottom' || position === 'center' || (0, $h1WWF.i)(position)) {
            offset += padding.bottom;
            if ((0, $h1WWF.b)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $b19b9e41583580fc$var$titleArgs(this, offset, position, align);
        (0, $h1WWF.M)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $b19b9e41583580fc$var$titleAlign(align, position, reverse),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $h1WWF.v)(opts.grid && opts.grid.z, -1);
        if (!this._isVisible() || this.draw !== $b19b9e41583580fc$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: gz + 1,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + 'AxisID';
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $h1WWF.O)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $b19b9e41583580fc$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($b19b9e41583580fc$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + '.' + id;
        if (!id) throw new Error('class does not have id: ' + item);
        if (id in items) return scope;
        items[id] = item;
        $b19b9e41583580fc$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $h1WWF.d).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $h1WWF.d)[scope]) {
            delete (0, $h1WWF.d)[scope][id];
            if (this.override) delete (0, $h1WWF.U)[id];
        }
    }
}
function $b19b9e41583580fc$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $h1WWF.V)(Object.create(null), [
        parentScope ? (0, $h1WWF.d).get(parentScope) : {},
        (0, $h1WWF.d).get(scope),
        item.defaults
    ]);
    (0, $h1WWF.d).set(scope, itemDefaults);
    if (item.defaultRoutes) $b19b9e41583580fc$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $h1WWF.d).describe(scope, item.descriptors);
}
function $b19b9e41583580fc$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split('.');
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        const parts = routes[property].split('.');
        const targetName = parts.pop();
        const targetScope = parts.join('.');
        (0, $h1WWF.d).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $b19b9e41583580fc$var$isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}
class $b19b9e41583580fc$var$Registry {
    constructor(){
        this.controllers = new $b19b9e41583580fc$var$TypedRegistry($b19b9e41583580fc$export$75572ec5c55b4048, 'datasets', true);
        this.elements = new $b19b9e41583580fc$var$TypedRegistry($b19b9e41583580fc$export$db77ccec0bb4ccac, 'elements');
        this.plugins = new $b19b9e41583580fc$var$TypedRegistry(Object, 'plugins');
        this.scales = new $b19b9e41583580fc$var$TypedRegistry($b19b9e41583580fc$export$d60cfc58d3c358b6, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each('register', args);
    }
    remove(...args) {
        this._each('unregister', args);
    }
    addControllers(...args) {
        this._each('register', args, this.controllers);
    }
    addElements(...args) {
        this._each('register', args, this.elements);
    }
    addPlugins(...args) {
        this._each('register', args, this.plugins);
    }
    addScales(...args) {
        this._each('register', args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, 'controller');
    }
    getElement(id) {
        return this._get(id, this.elements, 'element');
    }
    getPlugin(id) {
        return this._get(id, this.plugins, 'plugin');
    }
    getScale(id) {
        return this._get(id, this.scales, 'scale');
    }
    removeControllers(...args) {
        this._each('unregister', args, this.controllers);
    }
    removeElements(...args) {
        this._each('unregister', args, this.elements);
    }
    removePlugins(...args) {
        this._each('unregister', args, this.plugins);
    }
    removeScales(...args) {
        this._each('unregister', args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $h1WWF.Q)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $h1WWF.W)(method);
        (0, $h1WWF.C)(component['before' + camelMethod], [], component);
        registry[method](component);
        (0, $h1WWF.C)(component['after' + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + '.');
        return item;
    }
}
var $b19b9e41583580fc$export$4bb7493d241fd8a5 = new $b19b9e41583580fc$var$Registry();
class $b19b9e41583580fc$export$b2f2bae6713db87 extends $b19b9e41583580fc$export$75572ec5c55b4048 {
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $h1WWF.q)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $h1WWF.w)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = $b19b9e41583580fc$export$4bb7493d241fd8a5.getElement('line');
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $h1WWF.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $h1WWF.k)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
$b19b9e41583580fc$export$b2f2bae6713db87.id = 'scatter';
$b19b9e41583580fc$export$b2f2bae6713db87.defaults = {
    datasetElementType: false,
    dataElementType: 'point',
    showLine: false,
    fill: false
};
$b19b9e41583580fc$export$b2f2bae6713db87.overrides = {
    interaction: {
        mode: 'point'
    },
    plugins: {
        tooltip: {
            callbacks: {
                title () {
                    return '';
                },
                label (item) {
                    return '(' + item.label + ', ' + item.formattedValue + ')';
                }
            }
        }
    },
    scales: {
        x: {
            type: 'linear'
        },
        y: {
            type: 'linear'
        }
    }
};
var $b19b9e41583580fc$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $b19b9e41583580fc$export$e97d5dc64e999004,
    BubbleController: $b19b9e41583580fc$export$19b5c4773f17abe,
    DoughnutController: $b19b9e41583580fc$export$e04603e7d8b77172,
    LineController: $b19b9e41583580fc$export$3c9b5d28c11cbfd0,
    PolarAreaController: $b19b9e41583580fc$export$2a270b3a0d973c85,
    PieController: $b19b9e41583580fc$export$b21a3f1286706191,
    RadarController: $b19b9e41583580fc$export$48dbc6ac651bf8be,
    ScatterController: $b19b9e41583580fc$export$b2f2bae6713db87
});
function $b19b9e41583580fc$var$abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
class $b19b9e41583580fc$var$DateAdapter {
    constructor(options){
        this.options = options || {};
    }
    init(chartOptions) {}
    formats() {
        return $b19b9e41583580fc$var$abstract();
    }
    parse(value, format) {
        return $b19b9e41583580fc$var$abstract();
    }
    format(timestamp, format) {
        return $b19b9e41583580fc$var$abstract();
    }
    add(timestamp, amount, unit) {
        return $b19b9e41583580fc$var$abstract();
    }
    diff(a, b, unit) {
        return $b19b9e41583580fc$var$abstract();
    }
    startOf(timestamp, unit, weekday) {
        return $b19b9e41583580fc$var$abstract();
    }
    endOf(timestamp, unit) {
        return $b19b9e41583580fc$var$abstract();
    }
}
$b19b9e41583580fc$var$DateAdapter.override = function(members) {
    Object.assign($b19b9e41583580fc$var$DateAdapter.prototype, members);
};
var $b19b9e41583580fc$export$f32766ea09ec8bc4 = {
    _date: $b19b9e41583580fc$var$DateAdapter
};
function $b19b9e41583580fc$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $h1WWF.Y) : (0, $h1WWF.Z);
        if (!intersect) return lookupMethod(data, axis, value);
        else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $b19b9e41583580fc$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $b19b9e41583580fc$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $b19b9e41583580fc$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf('x') !== -1;
    const useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $b19b9e41583580fc$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $h1WWF.$)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $b19b9e41583580fc$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $b19b9e41583580fc$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition);
        const { angle: angle } = (0, $h1WWF.a0)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $h1WWF.p)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $b19b9e41583580fc$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $b19b9e41583580fc$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $b19b9e41583580fc$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $b19b9e41583580fc$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $b19b9e41583580fc$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === 'r' && !intersect ? $b19b9e41583580fc$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $b19b9e41583580fc$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $b19b9e41583580fc$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    let intersectsItem = false;
    $b19b9e41583580fc$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $b19b9e41583580fc$export$a13296960cae0384 = {
    evaluateInteractionItems: $b19b9e41583580fc$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $h1WWF.X)(e, chart);
            const axis = options.axis || 'x';
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $b19b9e41583580fc$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $b19b9e41583580fc$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $h1WWF.X)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $b19b9e41583580fc$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $b19b9e41583580fc$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $h1WWF.X)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $b19b9e41583580fc$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $h1WWF.X)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $b19b9e41583580fc$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $h1WWF.X)(e, chart);
            return $b19b9e41583580fc$var$getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $h1WWF.X)(e, chart);
            return $b19b9e41583580fc$var$getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};
const $b19b9e41583580fc$var$STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function $b19b9e41583580fc$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $b19b9e41583580fc$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$b19b9e41583580fc$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $b19b9e41583580fc$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $b19b9e41583580fc$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $b19b9e41583580fc$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$b19b9e41583580fc$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $b19b9e41583580fc$var$setLayoutDims(layouts, params) {
    const stacks = $b19b9e41583580fc$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $b19b9e41583580fc$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $b19b9e41583580fc$var$wrapBoxes(boxes);
    const fullSize = $b19b9e41583580fc$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $b19b9e41583580fc$var$sortByWeight($b19b9e41583580fc$var$filterByPosition(layoutBoxes, 'left'), true);
    const right = $b19b9e41583580fc$var$sortByWeight($b19b9e41583580fc$var$filterByPosition(layoutBoxes, 'right'));
    const top = $b19b9e41583580fc$var$sortByWeight($b19b9e41583580fc$var$filterByPosition(layoutBoxes, 'top'), true);
    const bottom = $b19b9e41583580fc$var$sortByWeight($b19b9e41583580fc$var$filterByPosition(layoutBoxes, 'bottom'));
    const centerHorizontal = $b19b9e41583580fc$var$filterDynamicPositionByAxis(layoutBoxes, 'x');
    const centerVertical = $b19b9e41583580fc$var$filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $b19b9e41583580fc$var$filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $b19b9e41583580fc$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $b19b9e41583580fc$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $b19b9e41583580fc$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $h1WWF.i)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $b19b9e41583580fc$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $b19b9e41583580fc$var$getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    const newHeight = Math.max(0, params.outerHeight - $b19b9e41583580fc$var$getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $b19b9e41583580fc$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function $b19b9e41583580fc$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function $b19b9e41583580fc$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $b19b9e41583580fc$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $b19b9e41583580fc$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $b19b9e41583580fc$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $b19b9e41583580fc$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $b19b9e41583580fc$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $h1WWF.j)(stack.start)) y = stack.start;
            if (box.fullSize) $b19b9e41583580fc$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $b19b9e41583580fc$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $h1WWF.j)(stack.start)) x = stack.start;
            if (box.fullSize) $b19b9e41583580fc$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $b19b9e41583580fc$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
(0, $h1WWF.d).set('layout', {
    autoPadding: true,
    padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }
});
var $b19b9e41583580fc$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $h1WWF.K)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $b19b9e41583580fc$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $h1WWF.Q)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === 'function') box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $b19b9e41583580fc$var$updateMaxPadding(maxPadding, (0, $h1WWF.K)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $b19b9e41583580fc$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $b19b9e41583580fc$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $b19b9e41583580fc$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($b19b9e41583580fc$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $b19b9e41583580fc$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $b19b9e41583580fc$var$handleMaxPadding(chartArea);
        $b19b9e41583580fc$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $b19b9e41583580fc$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $h1WWF.Q)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $b19b9e41583580fc$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $b19b9e41583580fc$export$a40a96b24b46cf35 extends $b19b9e41583580fc$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext('2d') || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $b19b9e41583580fc$var$EXPANDO_KEY = '$chartjs';
const $b19b9e41583580fc$var$EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
const $b19b9e41583580fc$var$isNullOrEmpty = (value)=>value === null || value === '';
function $b19b9e41583580fc$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute('height');
    const renderWidth = canvas.getAttribute('width');
    canvas[$b19b9e41583580fc$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if ($b19b9e41583580fc$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $h1WWF.a3)(canvas, 'width');
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($b19b9e41583580fc$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $h1WWF.a3)(canvas, 'height');
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $b19b9e41583580fc$var$eventListenerOptions = (0, $h1WWF.a5) ? {
    passive: true
} : false;
function $b19b9e41583580fc$var$addListener(node, type, listener) {
    node.addEventListener(type, listener, $b19b9e41583580fc$var$eventListenerOptions);
}
function $b19b9e41583580fc$var$removeListener(chart, type, listener) {
    chart.canvas.removeEventListener(type, listener, $b19b9e41583580fc$var$eventListenerOptions);
}
function $b19b9e41583580fc$var$fromNativeEvent(event, chart) {
    const type = $b19b9e41583580fc$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $h1WWF.X)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $b19b9e41583580fc$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $b19b9e41583580fc$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $b19b9e41583580fc$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$b19b9e41583580fc$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $b19b9e41583580fc$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $b19b9e41583580fc$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$b19b9e41583580fc$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $b19b9e41583580fc$var$drpListeningCharts = new Map();
let $b19b9e41583580fc$var$oldDevicePixelRatio = 0;
function $b19b9e41583580fc$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $b19b9e41583580fc$var$oldDevicePixelRatio) return;
    $b19b9e41583580fc$var$oldDevicePixelRatio = dpr;
    $b19b9e41583580fc$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $b19b9e41583580fc$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$b19b9e41583580fc$var$drpListeningCharts.size) window.addEventListener('resize', $b19b9e41583580fc$var$onWindowResize);
    $b19b9e41583580fc$var$drpListeningCharts.set(chart, resize);
}
function $b19b9e41583580fc$var$unlistenDevicePixelRatioChanges(chart) {
    $b19b9e41583580fc$var$drpListeningCharts.delete(chart);
    if (!$b19b9e41583580fc$var$drpListeningCharts.size) window.removeEventListener('resize', $b19b9e41583580fc$var$onWindowResize);
}
function $b19b9e41583580fc$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $h1WWF.a2)(canvas);
    if (!container) return;
    const resize = (0, $h1WWF.a4)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $b19b9e41583580fc$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $b19b9e41583580fc$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === 'resize') $b19b9e41583580fc$var$unlistenDevicePixelRatioChanges(chart);
}
function $b19b9e41583580fc$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $h1WWF.a4)((event)=>{
        if (chart.ctx !== null) listener($b19b9e41583580fc$var$fromNativeEvent(event, chart));
    }, chart, (args)=>{
        const event = args[0];
        return [
            event,
            event.offsetX,
            event.offsetY
        ];
    });
    $b19b9e41583580fc$var$addListener(canvas, type, proxy);
    return proxy;
}
class $b19b9e41583580fc$export$f02da7f882cf6b2e extends $b19b9e41583580fc$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext('2d');
        if (context && context.canvas === canvas) {
            $b19b9e41583580fc$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$b19b9e41583580fc$var$EXPANDO_KEY]) return false;
        const initial = canvas[$b19b9e41583580fc$var$EXPANDO_KEY].initial;
        [
            'height',
            'width'
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $h1WWF.k)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$b19b9e41583580fc$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $b19b9e41583580fc$var$createAttachObserver,
            detach: $b19b9e41583580fc$var$createDetachObserver,
            resize: $b19b9e41583580fc$var$createResizeObserver
        };
        const handler = handlers[type] || $b19b9e41583580fc$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $b19b9e41583580fc$var$releaseObserver,
            detach: $b19b9e41583580fc$var$releaseObserver,
            resize: $b19b9e41583580fc$var$releaseObserver
        };
        const handler = handlers[type] || $b19b9e41583580fc$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $h1WWF.a1)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = (0, $h1WWF.a2)(canvas);
        return !!(container && container.isConnected);
    }
}
function $b19b9e41583580fc$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $h1WWF.a6)() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return $b19b9e41583580fc$export$a40a96b24b46cf35;
    return $b19b9e41583580fc$export$f02da7f882cf6b2e;
}
class $b19b9e41583580fc$var$PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        if (hook === 'beforeInit') {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, 'install');
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === 'afterDestroy') {
            this._notify(descriptors, chart, 'stop');
            this._notify(this._init, chart, 'uninstall');
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $h1WWF.C)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $h1WWF.k)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $h1WWF.v)(config.options && config.options.plugins, {});
        const plugins = $b19b9e41583580fc$var$allPlugins(config);
        return options === false && !all ? [] : $b19b9e41583580fc$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
        this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
}
function $b19b9e41583580fc$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($b19b9e41583580fc$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($b19b9e41583580fc$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $b19b9e41583580fc$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $b19b9e41583580fc$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $b19b9e41583580fc$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $b19b9e41583580fc$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $b19b9e41583580fc$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $b19b9e41583580fc$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $h1WWF.d).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function $b19b9e41583580fc$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === '_index_') axis = indexAxis;
    else if (id === '_value_') axis = indexAxis === 'x' ? 'y' : 'x';
    return axis;
}
function $b19b9e41583580fc$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function $b19b9e41583580fc$var$axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') return 'x';
    if (position === 'left' || position === 'right') return 'y';
}
function $b19b9e41583580fc$var$determineAxis(id, scaleOptions) {
    if (id === 'x' || id === 'y') return id;
    return scaleOptions.axis || $b19b9e41583580fc$var$axisFromPosition(scaleOptions.position) || id.charAt(0).toLowerCase();
}
function $b19b9e41583580fc$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $h1WWF.U)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $b19b9e41583580fc$var$getIndexAxis(config.type, options);
    const firstIDs = Object.create(null);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $h1WWF.i)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $b19b9e41583580fc$var$determineAxis(id, scaleConf);
        const defaultId = $b19b9e41583580fc$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        firstIDs[axis] = firstIDs[axis] || id;
        scales[id] = (0, $h1WWF.ac)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $b19b9e41583580fc$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $h1WWF.U)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $b19b9e41583580fc$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + 'AxisID'] || firstIDs[axis] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $h1WWF.ac)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $h1WWF.ac)(scale, [
            (0, $h1WWF.d).scales[scale.type],
            (0, $h1WWF.d).scale
        ]);
    });
    return scales;
}
function $b19b9e41583580fc$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $h1WWF.v)(options.plugins, {});
    options.scales = $b19b9e41583580fc$var$mergeScaleConfig(config, options);
}
function $b19b9e41583580fc$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $b19b9e41583580fc$var$initConfig(config) {
    config = config || {};
    config.data = $b19b9e41583580fc$var$initData(config.data);
    $b19b9e41583580fc$var$initOptions(config);
    return config;
}
const $b19b9e41583580fc$var$keyCache = new Map();
const $b19b9e41583580fc$var$keysCached = new Set();
function $b19b9e41583580fc$var$cachedKeys(cacheKey, generate) {
    let keys = $b19b9e41583580fc$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $b19b9e41583580fc$var$keyCache.set(cacheKey, keys);
        $b19b9e41583580fc$var$keysCached.add(keys);
    }
    return keys;
}
const $b19b9e41583580fc$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $h1WWF.f)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $b19b9e41583580fc$var$Config {
    constructor(config){
        this._config = $b19b9e41583580fc$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $b19b9e41583580fc$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $b19b9e41583580fc$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $b19b9e41583580fc$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $b19b9e41583580fc$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $b19b9e41583580fc$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ''
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $b19b9e41583580fc$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$b19b9e41583580fc$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$b19b9e41583580fc$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$b19b9e41583580fc$var$addIfFound(scopes, (0, $h1WWF.U)[type] || {}, key));
            keys.forEach((key)=>$b19b9e41583580fc$var$addIfFound(scopes, (0, $h1WWF.d), key));
            keys.forEach((key)=>$b19b9e41583580fc$var$addIfFound(scopes, (0, $h1WWF.a7), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($b19b9e41583580fc$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $h1WWF.U)[type] || {},
            (0, $h1WWF.d).datasets[type] || {},
            {
                type: type
            },
            (0, $h1WWF.d),
            (0, $h1WWF.a7)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ''
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $b19b9e41583580fc$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($b19b9e41583580fc$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $h1WWF.a8)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $h1WWF.a9)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ''
    ], descriptorDefaults) {
        const { resolver: resolver } = $b19b9e41583580fc$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $h1WWF.i)(context) ? (0, $h1WWF.a9)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $b19b9e41583580fc$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $h1WWF.aa)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes('hover'))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $b19b9e41583580fc$var$hasFunction = (value)=>(0, $h1WWF.i)(value) && Object.getOwnPropertyNames(value).reduce((acc, key)=>acc || (0, $h1WWF.a8)(value[key]), false);
function $b19b9e41583580fc$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $h1WWF.ab)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $h1WWF.a8)(value) || $b19b9e41583580fc$var$hasFunction(value)) || indexable && (0, $h1WWF.b)(value)) return true;
    }
    return false;
}
var $b19b9e41583580fc$var$version = "3.9.1";
const $b19b9e41583580fc$var$KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function $b19b9e41583580fc$var$positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || $b19b9e41583580fc$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function $b19b9e41583580fc$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $b19b9e41583580fc$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    (0, $h1WWF.C)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $b19b9e41583580fc$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $h1WWF.C)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $b19b9e41583580fc$var$getCanvas(item) {
    if ((0, $h1WWF.a6)() && typeof item === 'string') item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $b19b9e41583580fc$var$instances = {};
const $b19b9e41583580fc$var$getChart = (key)=>{
    const canvas = $b19b9e41583580fc$var$getCanvas(key);
    return Object.values($b19b9e41583580fc$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $b19b9e41583580fc$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $b19b9e41583580fc$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') return null;
    if (isClick) return lastEvent;
    return e;
}
class $b19b9e41583580fc$export$acaa6426d77a227e {
    constructor(item, userConfig){
        const config = this.config = new $b19b9e41583580fc$var$Config(userConfig);
        const initialCanvas = $b19b9e41583580fc$var$getCanvas(item);
        const existingChart = $b19b9e41583580fc$var$getChart(initialCanvas);
        if (existingChart) throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $b19b9e41583580fc$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $h1WWF.ad)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $b19b9e41583580fc$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $h1WWF.ae)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $b19b9e41583580fc$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $b19b9e41583580fc$export$a424a0aa8f687495.listen(this, 'complete', $b19b9e41583580fc$var$onAnimationsComplete);
        $b19b9e41583580fc$export$a424a0aa8f687495.listen(this, 'progress', $b19b9e41583580fc$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $h1WWF.k)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    _initialize() {
        this.notifyPlugins('beforeInit');
        if (this.options.responsive) this.resize();
        else (0, $h1WWF.af)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins('afterInit');
        return this;
    }
    clear() {
        (0, $h1WWF.ag)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $b19b9e41583580fc$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$b19b9e41583580fc$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? 'resize' : 'attach';
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $h1WWF.af)(this, newRatio, true)) return;
        this.notifyPlugins('resize', {
            size: newSize
        });
        (0, $h1WWF.C)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $h1WWF.Q)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $b19b9e41583580fc$var$determineAxis(id, scaleOptions);
            const isRadial = axis === 'r';
            const isHorizontal = axis === 'x';
            return {
                options: scaleOptions,
                dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
            };
        }));
        (0, $h1WWF.Q)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $b19b9e41583580fc$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $h1WWF.v)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $b19b9e41583580fc$var$positionIsHorizontal(scaleOptions.position, axis) !== $b19b9e41583580fc$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $b19b9e41583580fc$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $h1WWF.Q)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $h1WWF.Q)(scales, (scale)=>{
            $b19b9e41583580fc$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $b19b9e41583580fc$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($b19b9e41583580fc$var$compare2Level('order', 'index'));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $b19b9e41583580fc$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = '' + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $b19b9e41583580fc$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $h1WWF.d).datasets[type];
                Object.assign(ControllerClass.prototype, {
                    dataElementType: $b19b9e41583580fc$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $b19b9e41583580fc$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $h1WWF.Q)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins('reset');
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins('beforeUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins('beforeElementsUpdate');
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $h1WWF.Q)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins('afterUpdate', {
            mode: mode
        });
        this._layers.sort($b19b9e41583580fc$var$compare2Level('z', '_idx'));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $h1WWF.Q)(this.scales, (scale)=>{
            $b19b9e41583580fc$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $h1WWF.ah)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === '_removeElements' ? -count : count;
            $b19b9e41583580fc$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + ',' + c.splice(1).join(',')));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $h1WWF.ah)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(',')).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins('beforeLayout', {
            cancelable: true
        }) === false) return;
        $b19b9e41583580fc$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $h1WWF.Q)(this.boxes, (box)=>{
            if (noArea && box.position === 'chartArea') return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins('afterLayout');
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins('beforeDatasetsUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $h1WWF.a8)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins('afterDatasetsUpdate', {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetUpdate', args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetUpdate', args);
    }
    render() {
        if (this.notifyPlugins('beforeRender', {
            cancelable: true
        }) === false) return;
        if ($b19b9e41583580fc$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$b19b9e41583580fc$export$a424a0aa8f687495.running(this)) $b19b9e41583580fc$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $b19b9e41583580fc$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resize(width, height);
            this._resizeBeforeDraw = null;
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins('beforeDraw', {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins('afterDraw');
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins('beforeDatasetsDraw', {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins('afterDatasetsDraw');
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const clip = meta._clip;
        const useClip = !clip.disabled;
        const area = this.chartArea;
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetDraw', args) === false) return;
        if (useClip) (0, $h1WWF.L)(ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? this.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
        });
        meta.controller.draw();
        if (useClip) (0, $h1WWF.N)(ctx);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetDraw', args);
    }
    isPointInArea(point) {
        return (0, $h1WWF.$)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $b19b9e41583580fc$export$a13296960cae0384.modes[mode];
        if (typeof method === 'function') return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $h1WWF.h)(null, {
            chart: this,
            type: 'chart'
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? 'show' : 'hide';
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $h1WWF.j)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $b19b9e41583580fc$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins('beforeDestroy');
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $h1WWF.ag)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        this.notifyPlugins('destroy');
        delete $b19b9e41583580fc$var$instances[this.id];
        this.notifyPlugins('afterDestroy');
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $h1WWF.Q)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove('attach', attached);
            this.attached = true;
            this.resize();
            _add('resize', listener);
            _add('detach', detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove('resize', listener);
            this._stop();
            this._resize(0, 0);
            _add('attach', attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $h1WWF.Q)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $h1WWF.Q)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? 'set' : 'remove';
        let meta, item, i, ilen;
        if (mode === 'dataset') {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller['_' + prefix + 'DatasetHoverStyle']();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('No dataset found at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $h1WWF.ai)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins('afterEvent', args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $h1WWF.aj)(e);
        const lastEvent = $b19b9e41583580fc$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $h1WWF.C)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $h1WWF.C)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $h1WWF.ai)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
const $b19b9e41583580fc$var$invalidatePlugins = ()=>(0, $h1WWF.Q)($b19b9e41583580fc$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
const $b19b9e41583580fc$var$enumerable = true;
Object.defineProperties($b19b9e41583580fc$export$acaa6426d77a227e, {
    defaults: {
        enumerable: $b19b9e41583580fc$var$enumerable,
        value: (0, $h1WWF.d)
    },
    instances: {
        enumerable: $b19b9e41583580fc$var$enumerable,
        value: $b19b9e41583580fc$var$instances
    },
    overrides: {
        enumerable: $b19b9e41583580fc$var$enumerable,
        value: (0, $h1WWF.U)
    },
    registry: {
        enumerable: $b19b9e41583580fc$var$enumerable,
        value: $b19b9e41583580fc$export$4bb7493d241fd8a5
    },
    version: {
        enumerable: $b19b9e41583580fc$var$enumerable,
        value: $b19b9e41583580fc$var$version
    },
    getChart: {
        enumerable: $b19b9e41583580fc$var$enumerable,
        value: $b19b9e41583580fc$var$getChart
    },
    register: {
        enumerable: $b19b9e41583580fc$var$enumerable,
        value: (...items)=>{
            $b19b9e41583580fc$export$4bb7493d241fd8a5.add(...items);
            $b19b9e41583580fc$var$invalidatePlugins();
        }
    },
    unregister: {
        enumerable: $b19b9e41583580fc$var$enumerable,
        value: (...items)=>{
            $b19b9e41583580fc$export$4bb7493d241fd8a5.remove(...items);
            $b19b9e41583580fc$var$invalidatePlugins();
        }
    }
});
function $b19b9e41583580fc$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $h1WWF.H), startAngle - (0, $h1WWF.H));
    ctx.closePath();
    ctx.clip();
}
function $b19b9e41583580fc$var$toRadiusCorners(value) {
    return (0, $h1WWF.al)(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
function $b19b9e41583580fc$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $b19b9e41583580fc$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $h1WWF.E)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $h1WWF.E)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $h1WWF.E)(o.innerEnd, 0, innerLimit)
    };
}
function $b19b9e41583580fc$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
function $b19b9e41583580fc$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $h1WWF.P)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $b19b9e41583580fc$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerEndAdjustedAngle);
        if (outerEnd > 0) {
            const pCenter = $b19b9e41583580fc$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $h1WWF.H));
        }
        const p4 = $b19b9e41583580fc$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        if (innerEnd > 0) {
            const pCenter = $b19b9e41583580fc$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $h1WWF.H), innerEndAdjustedAngle + Math.PI);
        }
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, startAngle + innerStart / innerRadius, true);
        if (innerStart > 0) {
            const pCenter = $b19b9e41583580fc$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $h1WWF.H));
        }
        const p8 = $b19b9e41583580fc$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        if (outerStart > 0) {
            const pCenter = $b19b9e41583580fc$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $h1WWF.H), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $b19b9e41583580fc$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $b19b9e41583580fc$var$pathArc(ctx, element, offset, spacing, startAngle + (0, $h1WWF.T), circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) {
            endAngle = startAngle + circumference % (0, $h1WWF.T);
            if (circumference % (0, $h1WWF.T) === 0) endAngle += (0, $h1WWF.T);
        }
    }
    $b19b9e41583580fc$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $b19b9e41583580fc$var$drawFullCircleBorders(ctx, element, inner) {
    const { x: x, y: y, startAngle: startAngle, pixelMargin: pixelMargin, fullCircles: fullCircles } = element;
    const outerRadius = Math.max(element.outerRadius - pixelMargin, 0);
    const innerRadius = element.innerRadius + pixelMargin;
    let i;
    if (inner) $b19b9e41583580fc$var$clipArc(ctx, element, startAngle + (0, $h1WWF.T));
    ctx.beginPath();
    ctx.arc(x, y, innerRadius, startAngle + (0, $h1WWF.T), startAngle, true);
    for(i = 0; i < fullCircles; ++i)ctx.stroke();
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle, startAngle + (0, $h1WWF.T));
    for(i = 0; i < fullCircles; ++i)ctx.stroke();
}
function $b19b9e41583580fc$var$drawBorder(ctx, element, offset, spacing, endAngle, circular) {
    const { options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle } = options;
    const inner = options.borderAlign === 'inner';
    if (!borderWidth) return;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    if (element.fullCircles) $b19b9e41583580fc$var$drawFullCircleBorders(ctx, element, inner);
    if (inner) $b19b9e41583580fc$var$clipArc(ctx, element, endAngle);
    $b19b9e41583580fc$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.stroke();
}
class $b19b9e41583580fc$export$d48203c759d6a1fc extends $b19b9e41583580fc$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $h1WWF.a0)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const rAdjust = this.options.spacing / 2;
        const _circumference = (0, $h1WWF.v)(circumference, endAngle - startAngle);
        const betweenAngles = _circumference >= (0, $h1WWF.T) || (0, $h1WWF.p)(angle, startAngle, endAngle);
        const withinRadius = (0, $h1WWF.ak)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            'x',
            'y',
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 2;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
        this.fullCircles = circumference > (0, $h1WWF.T) ? Math.floor(circumference / (0, $h1WWF.T)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        let radiusOffset = 0;
        if (offset) {
            radiusOffset = offset / 2;
            const halfAngle = (this.startAngle + this.endAngle) / 2;
            ctx.translate(Math.cos(halfAngle) * radiusOffset, Math.sin(halfAngle) * radiusOffset);
            if (this.circumference >= (0, $h1WWF.P)) radiusOffset = offset;
        }
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        const endAngle = $b19b9e41583580fc$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $b19b9e41583580fc$var$drawBorder(ctx, this, radiusOffset, spacing, endAngle, circular);
        ctx.restore();
    }
}
$b19b9e41583580fc$export$d48203c759d6a1fc.id = 'arc';
$b19b9e41583580fc$export$d48203c759d6a1fc.defaults = {
    borderAlign: 'center',
    borderColor: '#fff',
    borderJoinStyle: undefined,
    borderRadius: 0,
    borderWidth: 2,
    offset: 0,
    spacing: 0,
    angle: undefined,
    circular: true
};
$b19b9e41583580fc$export$d48203c759d6a1fc.defaultRoutes = {
    backgroundColor: 'backgroundColor'
};
function $b19b9e41583580fc$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $h1WWF.v)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $h1WWF.v)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $h1WWF.v)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $h1WWF.v)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $h1WWF.v)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $h1WWF.v)(style.borderColor, options.borderColor);
}
function $b19b9e41583580fc$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $b19b9e41583580fc$var$getLineMethod(options) {
    if (options.stepped) return 0, $h1WWF.as;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $h1WWF.at;
    return $b19b9e41583580fc$var$lineTo;
}
function $b19b9e41583580fc$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $b19b9e41583580fc$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $b19b9e41583580fc$var$pathVars(points, segment, params);
    const lineMethod = $b19b9e41583580fc$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $b19b9e41583580fc$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $b19b9e41583580fc$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $b19b9e41583580fc$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? $b19b9e41583580fc$var$fastPathSegment : $b19b9e41583580fc$var$pathSegment;
}
function $b19b9e41583580fc$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $h1WWF.ap;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $h1WWF.aq;
    return 0, $h1WWF.ar;
}
function $b19b9e41583580fc$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $b19b9e41583580fc$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $b19b9e41583580fc$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $b19b9e41583580fc$var$_getSegmentMethod(line);
    for (const segment of segments){
        $b19b9e41583580fc$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $b19b9e41583580fc$var$usePath2D = typeof Path2D === 'function';
function $b19b9e41583580fc$var$draw(ctx, line, start, count) {
    if ($b19b9e41583580fc$var$usePath2D && !line.options.segment) $b19b9e41583580fc$var$strokePathWithCache(ctx, line, start, count);
    else $b19b9e41583580fc$var$strokePathDirect(ctx, line, start, count);
}
class $b19b9e41583580fc$export$55e463fa7bcd3469 extends $b19b9e41583580fc$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $h1WWF.am)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $h1WWF.an)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $h1WWF.ao)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $b19b9e41583580fc$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $b19b9e41583580fc$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $b19b9e41583580fc$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $b19b9e41583580fc$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
$b19b9e41583580fc$export$55e463fa7bcd3469.id = 'line';
$b19b9e41583580fc$export$55e463fa7bcd3469.defaults = {
    borderCapStyle: 'butt',
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: 'miter',
    borderWidth: 3,
    capBezierPoints: true,
    cubicInterpolationMode: 'default',
    fill: false,
    spanGaps: false,
    stepped: false,
    tension: 0
};
$b19b9e41583580fc$export$55e463fa7bcd3469.defaultRoutes = {
    backgroundColor: 'backgroundColor',
    borderColor: 'borderColor'
};
$b19b9e41583580fc$export$55e463fa7bcd3469.descriptors = {
    _scriptable: true,
    _indexable: (name)=>name !== 'borderDash' && name !== 'fill'
};
function $b19b9e41583580fc$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $b19b9e41583580fc$export$bd159b522b230b7a extends $b19b9e41583580fc$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $b19b9e41583580fc$var$inRange$1(this, mouseX, 'x', useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $b19b9e41583580fc$var$inRange$1(this, mouseY, 'y', useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $h1WWF.$)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $h1WWF.au)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        return options.radius + options.hitRadius;
    }
}
$b19b9e41583580fc$export$bd159b522b230b7a.id = 'point';
$b19b9e41583580fc$export$bd159b522b230b7a.defaults = {
    borderWidth: 1,
    hitRadius: 1,
    hoverBorderWidth: 1,
    hoverRadius: 4,
    pointStyle: 'circle',
    radius: 3,
    rotation: 0
};
$b19b9e41583580fc$export$bd159b522b230b7a.defaultRoutes = {
    backgroundColor: 'backgroundColor',
    borderColor: 'borderColor'
};
function $b19b9e41583580fc$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $b19b9e41583580fc$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $h1WWF.E)(value, min, max);
}
function $b19b9e41583580fc$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $h1WWF.aw)(value);
    return {
        t: $b19b9e41583580fc$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $b19b9e41583580fc$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $b19b9e41583580fc$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $b19b9e41583580fc$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $b19b9e41583580fc$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        'enableBorderRadius'
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $h1WWF.ax)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $h1WWF.i)(value);
    return {
        topLeft: $b19b9e41583580fc$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $b19b9e41583580fc$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $b19b9e41583580fc$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $b19b9e41583580fc$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $b19b9e41583580fc$var$boundingRects(bar) {
    const bounds = $b19b9e41583580fc$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $b19b9e41583580fc$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $b19b9e41583580fc$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $b19b9e41583580fc$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $b19b9e41583580fc$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $h1WWF.ak)(x, bounds.left, bounds.right)) && (skipY || (0, $h1WWF.ak)(y, bounds.top, bounds.bottom));
}
function $b19b9e41583580fc$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $b19b9e41583580fc$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $b19b9e41583580fc$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $b19b9e41583580fc$export$a16ed71bf4b07672 extends $b19b9e41583580fc$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $b19b9e41583580fc$var$boundingRects(this);
        const addRectPath = $b19b9e41583580fc$var$hasRadius(outer.radius) ? (0, $h1WWF.av) : $b19b9e41583580fc$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $b19b9e41583580fc$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $b19b9e41583580fc$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill('evenodd');
        }
        ctx.beginPath();
        addRectPath(ctx, $b19b9e41583580fc$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $b19b9e41583580fc$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $b19b9e41583580fc$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $b19b9e41583580fc$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            'x',
            'y',
            'base',
            'horizontal'
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === 'x' ? this.width / 2 : this.height / 2;
    }
}
$b19b9e41583580fc$export$a16ed71bf4b07672.id = 'bar';
$b19b9e41583580fc$export$a16ed71bf4b07672.defaults = {
    borderSkipped: 'start',
    borderWidth: 0,
    borderRadius: 0,
    inflateAmount: 'auto',
    pointStyle: undefined
};
$b19b9e41583580fc$export$a16ed71bf4b07672.defaultRoutes = {
    backgroundColor: 'backgroundColor',
    borderColor: 'borderColor'
};
var $b19b9e41583580fc$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $b19b9e41583580fc$export$d48203c759d6a1fc,
    LineElement: $b19b9e41583580fc$export$55e463fa7bcd3469,
    PointElement: $b19b9e41583580fc$export$bd159b522b230b7a,
    BarElement: $b19b9e41583580fc$export$a16ed71bf4b07672
});
function $b19b9e41583580fc$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $b19b9e41583580fc$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $h1WWF.k)(minIndex) && !(0, $h1WWF.k)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $b19b9e41583580fc$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            value: data
        });
    }
}
function $b19b9e41583580fc$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $b19b9e41583580fc$var$cleanDecimatedDataset(dataset);
    });
}
function $b19b9e41583580fc$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $h1WWF.E)((0, $h1WWF.Z)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $h1WWF.E)((0, $h1WWF.Z)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $b19b9e41583580fc$export$be17f937e9aa7533 = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $b19b9e41583580fc$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $h1WWF.a)([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $b19b9e41583580fc$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $b19b9e41583580fc$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $h1WWF.k)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = $b19b9e41583580fc$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = $b19b9e41583580fc$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $b19b9e41583580fc$var$cleanDecimatedData(chart);
    }
};
function $b19b9e41583580fc$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $b19b9e41583580fc$var$_findSegmentEnd(start, end, points);
        const bounds = $b19b9e41583580fc$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $h1WWF.ao)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $b19b9e41583580fc$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $h1WWF.ay)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $b19b9e41583580fc$var$_getEdge(bounds, subBounds, 'start', Math.max)
                },
                end: {
                    [property]: $b19b9e41583580fc$var$_getEdge(bounds, subBounds, 'end', Math.min)
                }
            });
        }
    }
    return parts;
}
function $b19b9e41583580fc$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === 'angle') {
        start = (0, $h1WWF.az)(start);
        end = (0, $h1WWF.az)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $b19b9e41583580fc$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $b19b9e41583580fc$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $b19b9e41583580fc$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $b19b9e41583580fc$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $b19b9e41583580fc$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $h1WWF.b)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $b19b9e41583580fc$var$_pointsFromSegments(boundary, line);
    return points.length ? new $b19b9e41583580fc$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $b19b9e41583580fc$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $b19b9e41583580fc$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $h1WWF.g)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $b19b9e41583580fc$var$_decodeFill(line, index, count) {
    const fill = $b19b9e41583580fc$var$parseFillOption(line);
    if ((0, $h1WWF.i)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $h1WWF.g)(target) && Math.floor(target) === target) return $b19b9e41583580fc$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function $b19b9e41583580fc$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $b19b9e41583580fc$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === 'start') pixel = scale.bottom;
    else if (fill === 'end') pixel = scale.top;
    else if ((0, $h1WWF.i)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $b19b9e41583580fc$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === 'start') value = startValue;
    else if (fill === 'end') value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $h1WWF.i)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $b19b9e41583580fc$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $h1WWF.v)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return 'origin';
    return fill;
}
function $b19b9e41583580fc$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $b19b9e41583580fc$var$getLinesBelow(scale, index);
    linesBelow.push($b19b9e41583580fc$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$b19b9e41583580fc$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $b19b9e41583580fc$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $b19b9e41583580fc$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas('line');
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $b19b9e41583580fc$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $b19b9e41583580fc$var$findPoint(line, sourcePoint, 'x');
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $b19b9e41583580fc$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $h1WWF.ak)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $b19b9e41583580fc$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $h1WWF.T)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $b19b9e41583580fc$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $h1WWF.g)(fill)) return $b19b9e41583580fc$var$getLineByIndex(chart, fill);
    if (fill === 'stack') return $b19b9e41583580fc$var$_buildStackLine(source);
    if (fill === 'shape') return true;
    const boundary = $b19b9e41583580fc$var$computeBoundary(source);
    if (boundary instanceof $b19b9e41583580fc$var$simpleArc) return boundary;
    return $b19b9e41583580fc$var$_createBoundaryLine(boundary, line);
}
function $b19b9e41583580fc$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $b19b9e41583580fc$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $b19b9e41583580fc$var$computeCircularBoundary(source);
    return $b19b9e41583580fc$var$computeLinearBoundary(source);
}
function $b19b9e41583580fc$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $b19b9e41583580fc$var$_getTargetPixel(fill, scale);
    if ((0, $h1WWF.g)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $b19b9e41583580fc$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $b19b9e41583580fc$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $b19b9e41583580fc$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $b19b9e41583580fc$var$_drawfill(ctx, source, area) {
    const target = $b19b9e41583580fc$var$_getTarget(source);
    const { line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    if (target && line.points.length) {
        (0, $h1WWF.L)(ctx, area);
        $b19b9e41583580fc$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis
        });
        (0, $h1WWF.N)(ctx);
    }
}
function $b19b9e41583580fc$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale } = cfg;
    const property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    if (property === 'x' && below !== above) {
        $b19b9e41583580fc$var$clipVertical(ctx, target, area.top);
        $b19b9e41583580fc$var$fill(ctx, {
            line: line,
            target: target,
            color: above,
            scale: scale,
            property: property
        });
        ctx.restore();
        ctx.save();
        $b19b9e41583580fc$var$clipVertical(ctx, target, area.bottom);
    }
    $b19b9e41583580fc$var$fill(ctx, {
        line: line,
        target: target,
        color: below,
        scale: scale,
        property: property
    });
    ctx.restore();
}
function $b19b9e41583580fc$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$b19b9e41583580fc$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $b19b9e41583580fc$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale } = cfg;
    const segments = $b19b9e41583580fc$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $b19b9e41583580fc$var$clipBounds(ctx, scale, notShape && $b19b9e41583580fc$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $b19b9e41583580fc$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $b19b9e41583580fc$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? 'evenodd' : 'nonzero');
        ctx.restore();
    }
}
function $b19b9e41583580fc$var$clipBounds(ctx, scale, bounds) {
    const { top: top, bottom: bottom } = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === 'x') {
        ctx.beginPath();
        ctx.rect(start, top, end - start, bottom - top);
        ctx.clip();
    }
}
function $b19b9e41583580fc$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $b19b9e41583580fc$export$d19ba4d812bed757 = {
    id: 'filler',
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $b19b9e41583580fc$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $b19b9e41583580fc$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $b19b9e41583580fc$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === 'beforeDraw';
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $b19b9e41583580fc$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($b19b9e41583580fc$var$_shouldApplyFill(source)) $b19b9e41583580fc$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$b19b9e41583580fc$var$_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') return;
        $b19b9e41583580fc$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};
const $b19b9e41583580fc$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $b19b9e41583580fc$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $b19b9e41583580fc$var$Legend extends $b19b9e41583580fc$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $h1WWF.C)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $h1WWF.O)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $b19b9e41583580fc$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $h1WWF.aA)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $h1WWF.S)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $h1WWF.S)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $h1WWF.S)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $h1WWF.S)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $h1WWF.L)(ctx, this);
            this._draw();
            (0, $h1WWF.N)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $h1WWF.d).color;
        const rtlHelper = (0, $h1WWF.aA)(opts.rtl, this.left, this.width);
        const labelFont = (0, $h1WWF.O)(labelOpts.font);
        const { color: fontColor, padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $b19b9e41583580fc$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $h1WWF.v)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $h1WWF.v)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $h1WWF.v)(legendItem.lineCap, 'butt');
            ctx.lineDashOffset = (0, $h1WWF.v)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $h1WWF.v)(legendItem.lineJoin, 'miter');
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $h1WWF.v)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $h1WWF.v)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $h1WWF.aE)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $h1WWF.ax)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $h1WWF.av)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $h1WWF.M)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $h1WWF.S)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $h1WWF.S)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $h1WWF.aB)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor || fontColor;
            ctx.fillStyle = legendItem.fontColor || fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $h1WWF.S)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $h1WWF.S)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $h1WWF.aC)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else cursor.y += lineHeight;
        });
        (0, $h1WWF.aD)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $h1WWF.O)(titleOpts.font);
        const titlePadding = (0, $h1WWF.K)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $h1WWF.aA)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $h1WWF.S)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $h1WWF.S)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $h1WWF.S)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $h1WWF.R)(position));
        ctx.textBaseline = 'middle';
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $h1WWF.M)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $h1WWF.O)(titleOpts.font);
        const titlePadding = (0, $h1WWF.K)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $h1WWF.ak)(x, this.left, this.right) && (0, $h1WWF.ak)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $h1WWF.ak)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $h1WWF.ak)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$b19b9e41583580fc$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === 'mousemove' || e.type === 'mouseout') {
            const previous = this._hoveredItem;
            const sameItem = $b19b9e41583580fc$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $h1WWF.C)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $h1WWF.C)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $h1WWF.C)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $b19b9e41583580fc$var$isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === 'click' || type === 'mouseup')) return true;
    return false;
}
var $b19b9e41583580fc$export$ed247974535929c7 = {
    id: 'legend',
    _element: $b19b9e41583580fc$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $b19b9e41583580fc$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $b19b9e41583580fc$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $b19b9e41583580fc$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $b19b9e41583580fc$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $b19b9e41583580fc$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $h1WWF.K)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: 0,
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith('on'),
        labels: {
            _scriptable: (name)=>![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name)
        }
    }
};
class $b19b9e41583580fc$var$Title extends $b19b9e41583580fc$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $h1WWF.b)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $h1WWF.K)(opts.padding);
        const textSize = lineCount * (0, $h1WWF.O)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $h1WWF.S)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === 'left') {
                titleX = left + offset;
                titleY = (0, $h1WWF.S)(align, bottom, top);
                rotation = (0, $h1WWF.P) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $h1WWF.S)(align, top, bottom);
                rotation = (0, $h1WWF.P) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $h1WWF.O)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $h1WWF.M)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $h1WWF.R)(opts.align),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $b19b9e41583580fc$var$createTitle(chart, titleOpts) {
    const title = new $b19b9e41583580fc$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $b19b9e41583580fc$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $b19b9e41583580fc$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $b19b9e41583580fc$export$f99233281efd08a0 = {
    id: 'title',
    _element: $b19b9e41583580fc$var$Title,
    start (chart, _args, options) {
        $b19b9e41583580fc$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $b19b9e41583580fc$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $b19b9e41583580fc$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $b19b9e41583580fc$var$map = new WeakMap();
var $b19b9e41583580fc$export$d5c56664638992a4 = {
    id: 'subtitle',
    start (chart, _args, options) {
        const title = new $b19b9e41583580fc$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $b19b9e41583580fc$export$1ecca0613f5e56d2.configure(chart, title, options);
        $b19b9e41583580fc$export$1ecca0613f5e56d2.addBox(chart, title);
        $b19b9e41583580fc$var$map.set(chart, title);
    },
    stop (chart) {
        $b19b9e41583580fc$export$1ecca0613f5e56d2.removeBox(chart, $b19b9e41583580fc$var$map.get(chart));
        $b19b9e41583580fc$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $b19b9e41583580fc$var$map.get(chart);
        $b19b9e41583580fc$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $b19b9e41583580fc$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let x = 0;
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                x += pos.x;
                y += pos.y;
                ++count;
            }
        }
        return {
            x: x / count,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $h1WWF.aG)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $b19b9e41583580fc$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $h1WWF.b)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $b19b9e41583580fc$var$splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
    return str;
}
function $b19b9e41583580fc$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $b19b9e41583580fc$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $h1WWF.O)(options.bodyFont);
    const titleFont = (0, $h1WWF.O)(options.titleFont);
    const footerFont = (0, $h1WWF.O)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $h1WWF.K)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $h1WWF.Q)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $h1WWF.Q)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $h1WWF.Q)(body, (bodyItem)=>{
        (0, $h1WWF.Q)(bodyItem.before, maxLineWidth);
        (0, $h1WWF.Q)(bodyItem.lines, maxLineWidth);
        (0, $h1WWF.Q)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $h1WWF.Q)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $b19b9e41583580fc$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return 'top';
    else if (y > chart.height - height / 2) return 'bottom';
    return 'center';
}
function $b19b9e41583580fc$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) return true;
    if (xAlign === 'right' && x - width - caret < 0) return true;
}
function $b19b9e41583580fc$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = 'center';
    if (yAlign === 'center') xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    else if (x <= width / 2) xAlign = 'left';
    else if (x >= chartWidth - width / 2) xAlign = 'right';
    if ($b19b9e41583580fc$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = 'center';
    return xAlign;
}
function $b19b9e41583580fc$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $b19b9e41583580fc$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $b19b9e41583580fc$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $b19b9e41583580fc$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === 'right') x -= width;
    else if (xAlign === 'center') x -= width / 2;
    return x;
}
function $b19b9e41583580fc$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === 'top') y += paddingAndSize;
    else if (yAlign === 'bottom') y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $b19b9e41583580fc$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $h1WWF.ax)(cornerRadius);
    let x = $b19b9e41583580fc$var$alignX(size, xAlign);
    const y = $b19b9e41583580fc$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') x += paddingAndSize;
        else if (xAlign === 'right') x -= paddingAndSize;
    } else if (xAlign === 'left') x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === 'right') x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $h1WWF.E)(x, 0, chart.width - size.width),
        y: (0, $h1WWF.E)(y, 0, chart.height - size.height)
    };
}
function $b19b9e41583580fc$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $h1WWF.K)(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $b19b9e41583580fc$var$getBeforeAfterBodyLines(callback) {
    return $b19b9e41583580fc$var$pushOrConcat([], $b19b9e41583580fc$var$splitNewlines(callback));
}
function $b19b9e41583580fc$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $h1WWF.h)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: 'tooltip'
    });
}
function $b19b9e41583580fc$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
class $b19b9e41583580fc$var$Tooltip extends $b19b9e41583580fc$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart || config._chart;
        this._chart = this.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $b19b9e41583580fc$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $b19b9e41583580fc$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = callbacks.beforeTitle.apply(this, [
            context
        ]);
        const title = callbacks.title.apply(this, [
            context
        ]);
        const afterTitle = callbacks.afterTitle.apply(this, [
            context
        ]);
        let lines = [];
        lines = $b19b9e41583580fc$var$pushOrConcat(lines, $b19b9e41583580fc$var$splitNewlines(beforeTitle));
        lines = $b19b9e41583580fc$var$pushOrConcat(lines, $b19b9e41583580fc$var$splitNewlines(title));
        lines = $b19b9e41583580fc$var$pushOrConcat(lines, $b19b9e41583580fc$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $b19b9e41583580fc$var$getBeforeAfterBodyLines(options.callbacks.beforeBody.apply(this, [
            tooltipItems
        ]));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $h1WWF.Q)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $b19b9e41583580fc$var$overrideCallbacks(callbacks, context);
            $b19b9e41583580fc$var$pushOrConcat(bodyItem.before, $b19b9e41583580fc$var$splitNewlines(scoped.beforeLabel.call(this, context)));
            $b19b9e41583580fc$var$pushOrConcat(bodyItem.lines, scoped.label.call(this, context));
            $b19b9e41583580fc$var$pushOrConcat(bodyItem.after, $b19b9e41583580fc$var$splitNewlines(scoped.afterLabel.call(this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $b19b9e41583580fc$var$getBeforeAfterBodyLines(options.callbacks.afterBody.apply(this, [
            tooltipItems
        ]));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = callbacks.beforeFooter.apply(this, [
            tooltipItems
        ]);
        const footer = callbacks.footer.apply(this, [
            tooltipItems
        ]);
        const afterFooter = callbacks.afterFooter.apply(this, [
            tooltipItems
        ]);
        let lines = [];
        lines = $b19b9e41583580fc$var$pushOrConcat(lines, $b19b9e41583580fc$var$splitNewlines(beforeFooter));
        lines = $b19b9e41583580fc$var$pushOrConcat(lines, $b19b9e41583580fc$var$splitNewlines(footer));
        lines = $b19b9e41583580fc$var$pushOrConcat(lines, $b19b9e41583580fc$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($b19b9e41583580fc$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $h1WWF.Q)(tooltipItems, (context)=>{
            const scoped = $b19b9e41583580fc$var$overrideCallbacks(options.callbacks, context);
            labelColors.push(scoped.labelColor.call(this, context));
            labelPointStyles.push(scoped.labelPointStyle.call(this, context));
            labelTextColors.push(scoped.labelTextColor.call(this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $b19b9e41583580fc$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $b19b9e41583580fc$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $b19b9e41583580fc$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $b19b9e41583580fc$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $h1WWF.ax)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === 'center') {
            y2 = ptY + height / 2;
            if (xAlign === 'left') {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === 'left') x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === 'right') x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === 'top') {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $h1WWF.aA)(options.rtl, this.x, this.width);
            pt.x = $b19b9e41583580fc$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = 'middle';
            titleFont = (0, $h1WWF.O)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColors = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $h1WWF.O)(options.bodyFont);
        const colorX = $b19b9e41583580fc$var$getAlignedX(this, 'left', options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $h1WWF.au)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColors.borderColor;
            ctx.fillStyle = labelColors.backgroundColor;
            (0, $h1WWF.au)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $h1WWF.i)(labelColors.borderWidth) ? Math.max(...Object.values(labelColors.borderWidth)) : labelColors.borderWidth || 1;
            ctx.strokeStyle = labelColors.borderColor;
            ctx.setLineDash(labelColors.borderDash || []);
            ctx.lineDashOffset = labelColors.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth - boxPadding);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - boxPadding - 2);
            const borderRadius = (0, $h1WWF.ax)(labelColors.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $h1WWF.av)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColors.backgroundColor;
                ctx.beginPath();
                (0, $h1WWF.av)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColors.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $h1WWF.O)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $h1WWF.aA)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = bodyFont.string;
        pt.x = $b19b9e41583580fc$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $h1WWF.Q)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $h1WWF.Q)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $h1WWF.Q)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $h1WWF.Q)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $h1WWF.aA)(options.rtl, this.x, this.width);
            pt.x = $b19b9e41583580fc$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = 'middle';
            footerFont = (0, $h1WWF.O)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $h1WWF.ax)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === 'top') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === 'bottom') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $b19b9e41583580fc$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $b19b9e41583580fc$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $b19b9e41583580fc$var$determineAlignment(chart, options, positionAndSize);
            const point = $b19b9e41583580fc$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $h1WWF.K)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $h1WWF.aB)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $h1WWF.aD)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('Cannot find a dataset at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $h1WWF.ai)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $h1WWF.ai)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $b19b9e41583580fc$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
$b19b9e41583580fc$var$Tooltip.positioners = $b19b9e41583580fc$var$positioners;
var $b19b9e41583580fc$export$28c660c63b792dea = {
    id: 'tooltip',
    _element: $b19b9e41583580fc$var$Tooltip,
    positioners: $b19b9e41583580fc$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $b19b9e41583580fc$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', args) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: {
            beforeTitle: (0, $h1WWF.aF),
            title (tooltipItems) {
                if (tooltipItems.length > 0) {
                    const item = tooltipItems[0];
                    const labels = item.chart.data.labels;
                    const labelCount = labels ? labels.length : 0;
                    if (this && this.options && this.options.mode === 'dataset') return item.dataset.label || '';
                    else if (item.label) return item.label;
                    else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
                }
                return '';
            },
            afterTitle: (0, $h1WWF.aF),
            beforeBody: (0, $h1WWF.aF),
            beforeLabel: (0, $h1WWF.aF),
            label (tooltipItem) {
                if (this && this.options && this.options.mode === 'dataset') return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
                let label = tooltipItem.dataset.label || '';
                if (label) label += ': ';
                const value = tooltipItem.formattedValue;
                if (!(0, $h1WWF.k)(value)) label += value;
                return label;
            },
            labelColor (tooltipItem) {
                const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
                const options = meta.controller.getStyle(tooltipItem.dataIndex);
                return {
                    borderColor: options.borderColor,
                    backgroundColor: options.backgroundColor,
                    borderWidth: options.borderWidth,
                    borderDash: options.borderDash,
                    borderDashOffset: options.borderDashOffset,
                    borderRadius: 0
                };
            },
            labelTextColor () {
                return this.options.bodyColor;
            },
            labelPointStyle (tooltipItem) {
                const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
                const options = meta.controller.getStyle(tooltipItem.dataIndex);
                return {
                    pointStyle: options.pointStyle,
                    rotation: options.rotation
                };
            },
            afterLabel: (0, $h1WWF.aF),
            afterBody: (0, $h1WWF.aF),
            beforeFooter: (0, $h1WWF.aF),
            footer: (0, $h1WWF.aF),
            afterFooter: (0, $h1WWF.aF)
        }
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: (name)=>name !== 'filter' && name !== 'itemSort' && name !== 'external',
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};
var $b19b9e41583580fc$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Decimation: $b19b9e41583580fc$export$be17f937e9aa7533,
    Filler: $b19b9e41583580fc$export$d19ba4d812bed757,
    Legend: $b19b9e41583580fc$export$ed247974535929c7,
    SubTitle: $b19b9e41583580fc$export$d5c56664638992a4,
    Title: $b19b9e41583580fc$export$f99233281efd08a0,
    Tooltip: $b19b9e41583580fc$export$28c660c63b792dea
});
const $b19b9e41583580fc$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $b19b9e41583580fc$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $b19b9e41583580fc$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $b19b9e41583580fc$var$validIndex = (index, max)=>index === null ? null : (0, $h1WWF.E)(Math.round(index), 0, max);
class $b19b9e41583580fc$export$29e663ba4d09fe7 extends $b19b9e41583580fc$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $h1WWF.k)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $b19b9e41583580fc$var$findOrAddLabel(labels, raw, (0, $h1WWF.v)(index, raw), this._addedLabels);
        return $b19b9e41583580fc$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === 'ticks') {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        const labels = this.getLabels();
        if (value >= 0 && value < labels.length) return labels[value];
        return value;
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== 'number') value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
$b19b9e41583580fc$export$29e663ba4d09fe7.id = 'category';
$b19b9e41583580fc$export$29e663ba4d09fe7.defaults = {
    ticks: {
        callback: $b19b9e41583580fc$export$29e663ba4d09fe7.prototype.getLabelForValue
    }
};
function $b19b9e41583580fc$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $h1WWF.k)(min);
    const maxDefined = !(0, $h1WWF.k)(max);
    const countDefined = !(0, $h1WWF.k)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $h1WWF.aI)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $h1WWF.aI)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $h1WWF.k)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $h1WWF.aJ)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $h1WWF.aK)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $h1WWF.aL)(spacing), (0, $h1WWF.aL)(niceMin));
    factor = Math.pow(10, (0, $h1WWF.k)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $h1WWF.aK)(Math.round((niceMin + j * spacing) * factor) / factor, min, $b19b9e41583580fc$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j)ticks.push({
        value: Math.round((niceMin + j * spacing) * factor) / factor
    });
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $h1WWF.aK)(ticks[ticks.length - 1].value, max, $b19b9e41583580fc$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $b19b9e41583580fc$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $h1WWF.t)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $b19b9e41583580fc$var$LinearScaleBase extends $b19b9e41583580fc$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $h1WWF.k)(raw)) return null;
        if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $h1WWF.s)(min);
            const maxSign = (0, $h1WWF.s)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = 1;
            if (max >= Number.MAX_SAFE_INTEGER || min <= Number.MIN_SAFE_INTEGER) offset = Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $b19b9e41583580fc$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === 'ticks') (0, $h1WWF.aH)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $h1WWF.o)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $b19b9e41583580fc$export$e7f4e5e8656f0b93 extends $b19b9e41583580fc$var$LinearScaleBase {
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $h1WWF.g)(min) ? min : 0;
        this.max = (0, $h1WWF.g)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $h1WWF.t)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
$b19b9e41583580fc$export$e7f4e5e8656f0b93.id = 'linear';
$b19b9e41583580fc$export$e7f4e5e8656f0b93.defaults = {
    ticks: {
        callback: $b19b9e41583580fc$export$27c7467594ef87bd.formatters.numeric
    }
};
function $b19b9e41583580fc$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, Math.floor((0, $h1WWF.z)(tickVal)));
    return remain === 1;
}
function $b19b9e41583580fc$var$generateTicks(generationOptions, dataRange) {
    const endExp = Math.floor((0, $h1WWF.z)(dataRange.max));
    const endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
    const ticks = [];
    let tickVal = (0, $h1WWF.B)(generationOptions.min, Math.pow(10, Math.floor((0, $h1WWF.z)(dataRange.min))));
    let exp = Math.floor((0, $h1WWF.z)(tickVal));
    let significand = Math.floor(tickVal / Math.pow(10, exp));
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    do {
        ticks.push({
            value: tickVal,
            major: $b19b9e41583580fc$var$isMajor(tickVal)
        });
        ++significand;
        if (significand === 10) {
            significand = 1;
            ++exp;
            precision = exp >= 0 ? 1 : precision;
        }
        tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
    }while (exp < endExp || exp === endExp && significand < endSignificand);
    const lastTick = (0, $h1WWF.B)(generationOptions.max, tickVal);
    ticks.push({
        value: lastTick,
        major: $b19b9e41583580fc$var$isMajor(tickVal)
    });
    return ticks;
}
class $b19b9e41583580fc$export$85295eaf7cb3ac3e extends $b19b9e41583580fc$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $b19b9e41583580fc$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $h1WWF.g)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $h1WWF.g)(min) ? Math.max(0, min) : null;
        this.max = (0, $h1WWF.g)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        const exp = (v, m)=>Math.pow(10, Math.floor((0, $h1WWF.z)(v)) + m);
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin(exp(min, -1));
                setMax(exp(max, 1));
            }
        }
        if (min <= 0) setMin(exp(max, -1));
        if (max <= 0) setMax(exp(min, 1));
        if (this._zero && this.min !== this._suggestedMin && min === exp(this.min, 0)) setMin(exp(min, -1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $b19b9e41583580fc$var$generateTicks(generationOptions, this);
        if (opts.bounds === 'ticks') (0, $h1WWF.aH)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? '0' : (0, $h1WWF.o)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $h1WWF.z)(start);
        this._valueRange = (0, $h1WWF.z)(this.max) - (0, $h1WWF.z)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $h1WWF.z)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
$b19b9e41583580fc$export$85295eaf7cb3ac3e.id = 'logarithmic';
$b19b9e41583580fc$export$85295eaf7cb3ac3e.defaults = {
    ticks: {
        callback: $b19b9e41583580fc$export$27c7467594ef87bd.formatters.logarithmic,
        major: {
            enabled: true
        }
    }
};
function $b19b9e41583580fc$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $h1WWF.K)(tickOpts.backdropPadding);
        return (0, $h1WWF.v)(tickOpts.font && tickOpts.font.size, (0, $h1WWF.d).font.size) + padding.height;
    }
    return 0;
}
function $b19b9e41583580fc$var$measureLabelSize(ctx, font, label) {
    label = (0, $h1WWF.b)(label) ? label : [
        label
    ];
    return {
        w: (0, $h1WWF.aM)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $b19b9e41583580fc$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $b19b9e41583580fc$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $h1WWF.P) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $h1WWF.O)(opts.font);
        const textSize = $b19b9e41583580fc$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $h1WWF.az)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $h1WWF.F)(angleRadians));
        const hLimits = $b19b9e41583580fc$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $b19b9e41583580fc$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $b19b9e41583580fc$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $b19b9e41583580fc$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $b19b9e41583580fc$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $b19b9e41583580fc$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const extra = $b19b9e41583580fc$var$getTickBackdropHeight(opts) / 2;
    const outerDistance = scale.drawingArea;
    const additionalAngle = opts.pointLabels.centerPointLabels ? (0, $h1WWF.P) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + padding[i], additionalAngle);
        const angle = Math.round((0, $h1WWF.F)((0, $h1WWF.az)(pointLabelPosition.angle + (0, $h1WWF.H))));
        const size = labelSizes[i];
        const y = $b19b9e41583580fc$var$yForAngle(pointLabelPosition.y, size.h, angle);
        const textAlign = $b19b9e41583580fc$var$getTextAlignForAngle(angle);
        const left = $b19b9e41583580fc$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
        items.push({
            x: pointLabelPosition.x,
            y: y,
            textAlign: textAlign,
            left: left,
            top: y,
            right: left + size.w,
            bottom: y + size.h
        });
    }
    return items;
}
function $b19b9e41583580fc$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return 'center';
    else if (angle < 180) return 'left';
    return 'right';
}
function $b19b9e41583580fc$var$leftForTextAlign(x, w, align) {
    if (align === 'right') x -= w;
    else if (align === 'center') x -= w / 2;
    return x;
}
function $b19b9e41583580fc$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $b19b9e41583580fc$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        const plFont = (0, $h1WWF.O)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign, left: left, top: top, right: right, bottom: bottom } = scale._pointLabelItems[i];
        const { backdropColor: backdropColor } = optsAtIndex;
        if (!(0, $h1WWF.k)(backdropColor)) {
            const borderRadius = (0, $h1WWF.ax)(optsAtIndex.borderRadius);
            const padding = (0, $h1WWF.K)(optsAtIndex.backdropPadding);
            ctx.fillStyle = backdropColor;
            const backdropLeft = left - padding.left;
            const backdropTop = top - padding.top;
            const backdropWidth = right - left + padding.width;
            const backdropHeight = bottom - top + padding.height;
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                (0, $h1WWF.av)(ctx, {
                    x: backdropLeft,
                    y: backdropTop,
                    w: backdropWidth,
                    h: backdropHeight,
                    radius: borderRadius
                });
                ctx.fill();
            } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
        }
        (0, $h1WWF.M)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function $b19b9e41583580fc$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $h1WWF.T));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $b19b9e41583580fc$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(gridLineOpts.borderDash);
    ctx.lineDashOffset = gridLineOpts.borderDashOffset;
    ctx.beginPath();
    $b19b9e41583580fc$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $b19b9e41583580fc$var$createPointLabelContext(parent, index, label) {
    return (0, $h1WWF.h)(parent, {
        label: label,
        index: index,
        type: 'pointLabel'
    });
}
class $b19b9e41583580fc$export$cfafc36d95386d38 extends $b19b9e41583580fc$var$LinearScaleBase {
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, $h1WWF.K)($b19b9e41583580fc$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $h1WWF.g)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $h1WWF.g)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $b19b9e41583580fc$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $b19b9e41583580fc$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $h1WWF.C)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : '';
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $b19b9e41583580fc$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $h1WWF.T) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $h1WWF.az)(index * angleMultiplier + (0, $h1WWF.t)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $h1WWF.k)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $h1WWF.k)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $b19b9e41583580fc$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $h1WWF.H) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $b19b9e41583580fc$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $b19b9e41583580fc$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const optsAtIndex = grid.setContext(this.getContext(index - 1));
                $b19b9e41583580fc$var$drawRadiusLine(this, optsAtIndex, offset, labelCount);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $h1WWF.O)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $h1WWF.K)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $h1WWF.M)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
$b19b9e41583580fc$export$cfafc36d95386d38.id = 'radialLinear';
$b19b9e41583580fc$export$cfafc36d95386d38.defaults = {
    display: true,
    animate: true,
    position: 'chartArea',
    angleLines: {
        display: true,
        lineWidth: 1,
        borderDash: [],
        borderDashOffset: 0.0
    },
    grid: {
        circular: false
    },
    startAngle: 0,
    ticks: {
        showLabelBackdrop: true,
        callback: $b19b9e41583580fc$export$27c7467594ef87bd.formatters.numeric
    },
    pointLabels: {
        backdropColor: undefined,
        backdropPadding: 2,
        display: true,
        font: {
            size: 10
        },
        callback (label) {
            return label;
        },
        padding: 5,
        centerPointLabels: false
    }
};
$b19b9e41583580fc$export$cfafc36d95386d38.defaultRoutes = {
    'angleLines.color': 'borderColor',
    'pointLabels.color': 'color',
    'ticks.color': 'color'
};
$b19b9e41583580fc$export$cfafc36d95386d38.descriptors = {
    angleLines: {
        _fallback: 'grid'
    }
};
const $b19b9e41583580fc$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $b19b9e41583580fc$var$UNITS = Object.keys($b19b9e41583580fc$var$INTERVALS);
function $b19b9e41583580fc$var$sorter(a, b) {
    return a - b;
}
function $b19b9e41583580fc$var$parse(scale, input) {
    if ((0, $h1WWF.k)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === 'function') value = parser(value);
    if (!(0, $h1WWF.g)(value)) value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === 'week' && ((0, $h1WWF.x)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $b19b9e41583580fc$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $b19b9e41583580fc$var$UNITS.length;
    for(let i = $b19b9e41583580fc$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $b19b9e41583580fc$var$INTERVALS[$b19b9e41583580fc$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $b19b9e41583580fc$var$UNITS[i];
    }
    return $b19b9e41583580fc$var$UNITS[ilen - 1];
}
function $b19b9e41583580fc$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $b19b9e41583580fc$var$UNITS.length - 1; i >= $b19b9e41583580fc$var$UNITS.indexOf(minUnit); i--){
        const unit = $b19b9e41583580fc$var$UNITS[i];
        if ($b19b9e41583580fc$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $b19b9e41583580fc$var$UNITS[minUnit ? $b19b9e41583580fc$var$UNITS.indexOf(minUnit) : 0];
}
function $b19b9e41583580fc$var$determineMajorUnit(unit) {
    for(let i = $b19b9e41583580fc$var$UNITS.indexOf(unit) + 1, ilen = $b19b9e41583580fc$var$UNITS.length; i < ilen; ++i){
        if ($b19b9e41583580fc$var$INTERVALS[$b19b9e41583580fc$var$UNITS[i]].common) return $b19b9e41583580fc$var$UNITS[i];
    }
}
function $b19b9e41583580fc$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $h1WWF.aO)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $b19b9e41583580fc$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $b19b9e41583580fc$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $b19b9e41583580fc$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $b19b9e41583580fc$export$a894c72689ff3ec extends $b19b9e41583580fc$export$d60cfc58d3c358b6 {
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = 'day';
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $b19b9e41583580fc$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $h1WWF.ac)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $b19b9e41583580fc$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || 'day';
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') _applyBounds(this.getMinMax(false));
        }
        min = (0, $h1WWF.g)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $h1WWF.g)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === 'ticks' && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $h1WWF.aN)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $b19b9e41583580fc$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $b19b9e41583580fc$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : $b19b9e41583580fc$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $b19b9e41583580fc$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $h1WWF.E)(start, 0, limit);
        end = (0, $h1WWF.E)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $b19b9e41583580fc$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $h1WWF.v)(timeOpts.stepSize, 1);
        const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $h1WWF.x)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
        const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$b19b9e41583580fc$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === 'ticks' || count === 1) $b19b9e41583580fc$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort((a, b)=>a - b).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        const label = this._adapter.format(time, format || (major ? majorFormat : minorFormat));
        const formatter = options.ticks.callback;
        return formatter ? (0, $h1WWF.C)(formatter, [
            label,
            index,
            ticks
        ], this) : label;
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $h1WWF.t)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $b19b9e41583580fc$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($b19b9e41583580fc$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $h1WWF._)(values.sort($b19b9e41583580fc$var$sorter));
    }
}
$b19b9e41583580fc$export$a894c72689ff3ec.id = 'time';
$b19b9e41583580fc$export$a894c72689ff3ec.defaults = {
    bounds: 'data',
    adapters: {},
    time: {
        parser: false,
        unit: false,
        round: false,
        isoWeekday: false,
        minUnit: 'millisecond',
        displayFormats: {}
    },
    ticks: {
        source: 'auto',
        major: {
            enabled: false
        }
    }
};
function $b19b9e41583580fc$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $h1WWF.Z)(table, 'pos', val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $h1WWF.Z)(table, 'time', val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $b19b9e41583580fc$export$85df64a8eb6dc986 extends $b19b9e41583580fc$export$a894c72689ff3ec {
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $b19b9e41583580fc$var$interpolate(table, this.min);
        this._tableRange = $b19b9e41583580fc$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($b19b9e41583580fc$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $b19b9e41583580fc$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
$b19b9e41583580fc$export$85df64a8eb6dc986.id = 'timeseries';
$b19b9e41583580fc$export$85df64a8eb6dc986.defaults = $b19b9e41583580fc$export$a894c72689ff3ec.defaults;
var $b19b9e41583580fc$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $b19b9e41583580fc$export$29e663ba4d09fe7,
    LinearScale: $b19b9e41583580fc$export$e7f4e5e8656f0b93,
    LogarithmicScale: $b19b9e41583580fc$export$85295eaf7cb3ac3e,
    RadialLinearScale: $b19b9e41583580fc$export$cfafc36d95386d38,
    TimeScale: $b19b9e41583580fc$export$a894c72689ff3ec,
    TimeSeriesScale: $b19b9e41583580fc$export$85df64a8eb6dc986
});
const $b19b9e41583580fc$export$e8959e79e3af550f = [
    $b19b9e41583580fc$export$a6506504f799c5d5,
    $b19b9e41583580fc$export$7a5d735b2ab6389d,
    $b19b9e41583580fc$export$8b3ca321c77fdea6,
    $b19b9e41583580fc$export$bcac1c16f1530ec2
];

});
parcelRegister("h1WWF", function(module, exports) {

$parcel$export(module.exports, "aF", () => $226be6ef00b0445d$export$cf2f7c5792f80b46);
$parcel$export(module.exports, "ad", () => $226be6ef00b0445d$export$4c3d22f3d993c33f);
$parcel$export(module.exports, "k", () => $226be6ef00b0445d$export$342063e11d6c3cad);
$parcel$export(module.exports, "b", () => $226be6ef00b0445d$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "i", () => $226be6ef00b0445d$export$23f2a1d2818174ef);
$parcel$export(module.exports, "g", () => $226be6ef00b0445d$export$39b482c5e57630a8);
$parcel$export(module.exports, "B", () => $226be6ef00b0445d$export$ef35774e6d314e91);
$parcel$export(module.exports, "v", () => $226be6ef00b0445d$export$90a7f3efeed30595);
$parcel$export(module.exports, "m", () => $226be6ef00b0445d$export$953cecd6e717a553);
$parcel$export(module.exports, "n", () => $226be6ef00b0445d$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "C", () => $226be6ef00b0445d$export$e7094788287c5e9b);
$parcel$export(module.exports, "Q", () => $226be6ef00b0445d$export$3722cfe417b6ed86);
$parcel$export(module.exports, "ai", () => $226be6ef00b0445d$export$f38c853ae54ed474);
$parcel$export(module.exports, "V", () => $226be6ef00b0445d$export$e7c866399fa523f5);
$parcel$export(module.exports, "ac", () => $226be6ef00b0445d$export$2219238a014317b0);
$parcel$export(module.exports, "f", () => $226be6ef00b0445d$export$2d1720544b23b823);
$parcel$export(module.exports, "W", () => $226be6ef00b0445d$export$71cec2538cb2c617);
$parcel$export(module.exports, "j", () => $226be6ef00b0445d$export$35e795649ee09318);
$parcel$export(module.exports, "a8", () => $226be6ef00b0445d$export$c3950d9923825c02);
$parcel$export(module.exports, "ah", () => $226be6ef00b0445d$export$995eb9fca571757);
$parcel$export(module.exports, "aj", () => $226be6ef00b0445d$export$3b513254972cfc9c);
$parcel$export(module.exports, "P", () => $226be6ef00b0445d$export$56c0d5a1e737357d);
$parcel$export(module.exports, "T", () => $226be6ef00b0445d$export$971d5caa766a69d7);
$parcel$export(module.exports, "H", () => $226be6ef00b0445d$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "z", () => $226be6ef00b0445d$export$df995fae86a55f06);
$parcel$export(module.exports, "s", () => $226be6ef00b0445d$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "aI", () => $226be6ef00b0445d$export$b9a6b53f9be3734);
$parcel$export(module.exports, "aK", () => $226be6ef00b0445d$export$23ebac1979863676);
$parcel$export(module.exports, "A", () => $226be6ef00b0445d$export$ebd11618f299a286);
$parcel$export(module.exports, "x", () => $226be6ef00b0445d$export$d141bba7fdc215a3);
$parcel$export(module.exports, "aJ", () => $226be6ef00b0445d$export$a05254e7c3aeba6e);
$parcel$export(module.exports, "aH", () => $226be6ef00b0445d$export$a33b77bbdbb8366c);
$parcel$export(module.exports, "t", () => $226be6ef00b0445d$export$625550452a3fa3ec);
$parcel$export(module.exports, "F", () => $226be6ef00b0445d$export$d66501df72047452);
$parcel$export(module.exports, "aL", () => $226be6ef00b0445d$export$91477dc880baac21);
$parcel$export(module.exports, "a0", () => $226be6ef00b0445d$export$34aec0b863436764);
$parcel$export(module.exports, "aG", () => $226be6ef00b0445d$export$53a70dd1ebbae346);
$parcel$export(module.exports, "az", () => $226be6ef00b0445d$export$3d12bd131bb975d1);
$parcel$export(module.exports, "p", () => $226be6ef00b0445d$export$ffb5f4729a158638);
$parcel$export(module.exports, "E", () => $226be6ef00b0445d$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "I", () => $226be6ef00b0445d$export$9bb611d729802a56);
$parcel$export(module.exports, "ak", () => $226be6ef00b0445d$export$21579262ef46735b);
$parcel$export(module.exports, "aO", () => $226be6ef00b0445d$export$c03999cb2f36933f);
$parcel$export(module.exports, "Z", () => $226be6ef00b0445d$export$dc98b0b04f4c7758);
$parcel$export(module.exports, "Y", () => $226be6ef00b0445d$export$8743009a87fcb00f);
$parcel$export(module.exports, "aN", () => $226be6ef00b0445d$export$faec65b429be379);
$parcel$export(module.exports, "l", () => $226be6ef00b0445d$export$882b5998b3b9117c);
$parcel$export(module.exports, "u", () => $226be6ef00b0445d$export$3b14a55fb2447963);
$parcel$export(module.exports, "_", () => $226be6ef00b0445d$export$71511d61b312f219);
$parcel$export(module.exports, "r", () => $226be6ef00b0445d$export$43caf9889c228507);
$parcel$export(module.exports, "a4", () => $226be6ef00b0445d$export$efca4cbe5dd06740);
$parcel$export(module.exports, "ae", () => $226be6ef00b0445d$export$f787f51d84a910ad);
$parcel$export(module.exports, "R", () => $226be6ef00b0445d$export$db202ddc8be9136);
$parcel$export(module.exports, "S", () => $226be6ef00b0445d$export$25ce5a424b770e84);
$parcel$export(module.exports, "aC", () => $226be6ef00b0445d$export$890c4ad488842ce7);
$parcel$export(module.exports, "q", () => $226be6ef00b0445d$export$9e5f44173e64f162);
$parcel$export(module.exports, "w", () => $226be6ef00b0445d$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "e", () => $226be6ef00b0445d$export$f1e1789686576879);
$parcel$export(module.exports, "c", () => $226be6ef00b0445d$export$db3b6bfb95261072);
$parcel$export(module.exports, "U", () => $226be6ef00b0445d$export$3a6d5c9ae78a2c08);
$parcel$export(module.exports, "a7", () => $226be6ef00b0445d$export$a93c5207d687da10);
$parcel$export(module.exports, "d", () => $226be6ef00b0445d$export$4368d992c4eafac0);
$parcel$export(module.exports, "G", () => $226be6ef00b0445d$export$2329c99376c9d0a4);
$parcel$export(module.exports, "aM", () => $226be6ef00b0445d$export$9f4f30ee63539e24);
$parcel$export(module.exports, "J", () => $226be6ef00b0445d$export$b4171a6734a65d42);
$parcel$export(module.exports, "ag", () => $226be6ef00b0445d$export$ee7c8ad385a60b7b);
$parcel$export(module.exports, "au", () => $226be6ef00b0445d$export$1fbe638ecf81657e);
$parcel$export(module.exports, "aE", () => $226be6ef00b0445d$export$158acd800e1ef08b);
$parcel$export(module.exports, "$", () => $226be6ef00b0445d$export$3d8c2f653ac9d0b9);
$parcel$export(module.exports, "L", () => $226be6ef00b0445d$export$61196ced6d74a310);
$parcel$export(module.exports, "N", () => $226be6ef00b0445d$export$a07804094c3ecf2d);
$parcel$export(module.exports, "as", () => $226be6ef00b0445d$export$6554612db691658e);
$parcel$export(module.exports, "at", () => $226be6ef00b0445d$export$493d36ec626b6698);
$parcel$export(module.exports, "M", () => $226be6ef00b0445d$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "av", () => $226be6ef00b0445d$export$d66dc83d8cfc8dd);
$parcel$export(module.exports, "al", () => $226be6ef00b0445d$export$ab83b03e4111b1d0);
$parcel$export(module.exports, "aw", () => $226be6ef00b0445d$export$92108d983e8ee699);
$parcel$export(module.exports, "ax", () => $226be6ef00b0445d$export$9fa96a7d116ea3ce);
$parcel$export(module.exports, "K", () => $226be6ef00b0445d$export$3466f893ebf79586);
$parcel$export(module.exports, "O", () => $226be6ef00b0445d$export$c4ce752e73470fba);
$parcel$export(module.exports, "a", () => $226be6ef00b0445d$export$407448d2b89b1813);
$parcel$export(module.exports, "D", () => $226be6ef00b0445d$export$96f57966bedc81b4);
$parcel$export(module.exports, "h", () => $226be6ef00b0445d$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "aa", () => $226be6ef00b0445d$export$7910e0436ed8d1de);
$parcel$export(module.exports, "a9", () => $226be6ef00b0445d$export$a9c996f45e5784d0);
$parcel$export(module.exports, "ab", () => $226be6ef00b0445d$export$555508cbc6add439);
$parcel$export(module.exports, "y", () => $226be6ef00b0445d$export$4a5767248b18ef41);
$parcel$export(module.exports, "am", () => $226be6ef00b0445d$export$1a82df3d29112e01);
$parcel$export(module.exports, "a6", () => $226be6ef00b0445d$export$2e2af4578d910ddf);
$parcel$export(module.exports, "a2", () => $226be6ef00b0445d$export$ce26c07117d59d6a);
$parcel$export(module.exports, "X", () => $226be6ef00b0445d$export$78acf4525d8a74c4);
$parcel$export(module.exports, "a1", () => $226be6ef00b0445d$export$3c2fa207a37baaea);
$parcel$export(module.exports, "af", () => $226be6ef00b0445d$export$c9170ad7d4cd7e57);
$parcel$export(module.exports, "a5", () => $226be6ef00b0445d$export$a8550f7dbe79f93a);
$parcel$export(module.exports, "a3", () => $226be6ef00b0445d$export$6559d589eb85fbb6);
$parcel$export(module.exports, "ar", () => $226be6ef00b0445d$export$d24c54395ce0c509);
$parcel$export(module.exports, "ap", () => $226be6ef00b0445d$export$2f6ca3d3b1f80bf5);
$parcel$export(module.exports, "aq", () => $226be6ef00b0445d$export$8a5498727ef6be21);
$parcel$export(module.exports, "o", () => $226be6ef00b0445d$export$ae1af26003f05816);
$parcel$export(module.exports, "aA", () => $226be6ef00b0445d$export$91c6e00c14e7e6fd);
$parcel$export(module.exports, "aB", () => $226be6ef00b0445d$export$9d398bebfec1c039);
$parcel$export(module.exports, "aD", () => $226be6ef00b0445d$export$24baa2b76016ce0e);
$parcel$export(module.exports, "ay", () => $226be6ef00b0445d$export$28f7fcd39efa255);
$parcel$export(module.exports, "ao", () => $226be6ef00b0445d$export$7a38258bbe170828);
$parcel$export(module.exports, "an", () => $226be6ef00b0445d$export$306ddfe3a8403e2);
/*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */ function $226be6ef00b0445d$export$cf2f7c5792f80b46() {}
const $226be6ef00b0445d$export$4c3d22f3d993c33f = function() {
    let id = 0;
    return function() {
        return id++;
    };
}();
function $226be6ef00b0445d$export$342063e11d6c3cad(value) {
    return value === null || typeof value === 'undefined';
}
function $226be6ef00b0445d$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') return true;
    return false;
}
function $226be6ef00b0445d$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
const $226be6ef00b0445d$export$39b482c5e57630a8 = (value)=>(typeof value === 'number' || value instanceof Number) && isFinite(+value);
function $226be6ef00b0445d$export$ef35774e6d314e91(value, defaultValue) {
    return $226be6ef00b0445d$export$39b482c5e57630a8(value) ? value : defaultValue;
}
function $226be6ef00b0445d$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
const $226be6ef00b0445d$export$953cecd6e717a553 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : value / dimension;
const $226be6ef00b0445d$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
function $226be6ef00b0445d$export$e7094788287c5e9b(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
}
function $226be6ef00b0445d$export$3722cfe417b6ed86(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($226be6ef00b0445d$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($226be6ef00b0445d$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
function $226be6ef00b0445d$export$f38c853ae54ed474(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
function $226be6ef00b0445d$export$738ab4df8bf92ae9(source) {
    if ($226be6ef00b0445d$export$8b22cf2602fb60ce(source)) return source.map($226be6ef00b0445d$export$738ab4df8bf92ae9);
    if ($226be6ef00b0445d$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $226be6ef00b0445d$export$738ab4df8bf92ae9(source[keys[k]]);
        return target;
    }
    return source;
}
function $226be6ef00b0445d$var$isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
function $226be6ef00b0445d$export$d377dcb2b61d6c4e(key, target, source, options) {
    if (!$226be6ef00b0445d$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($226be6ef00b0445d$export$23f2a1d2818174ef(tval) && $226be6ef00b0445d$export$23f2a1d2818174ef(sval)) $226be6ef00b0445d$export$e7c866399fa523f5(tval, sval, options);
    else target[key] = $226be6ef00b0445d$export$738ab4df8bf92ae9(sval);
}
function $226be6ef00b0445d$export$e7c866399fa523f5(target, source, options) {
    const sources = $226be6ef00b0445d$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$226be6ef00b0445d$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $226be6ef00b0445d$export$d377dcb2b61d6c4e;
    for(let i = 0; i < ilen; ++i){
        source = sources[i];
        if (!$226be6ef00b0445d$export$23f2a1d2818174ef(source)) continue;
        const keys = Object.keys(source);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, source, options);
    }
    return target;
}
function $226be6ef00b0445d$export$2219238a014317b0(target, source) {
    return $226be6ef00b0445d$export$e7c866399fa523f5(target, source, {
        merger: $226be6ef00b0445d$export$667d3bf0c5f83305
    });
}
function $226be6ef00b0445d$export$667d3bf0c5f83305(key, target, source) {
    if (!$226be6ef00b0445d$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($226be6ef00b0445d$export$23f2a1d2818174ef(tval) && $226be6ef00b0445d$export$23f2a1d2818174ef(sval)) $226be6ef00b0445d$export$2219238a014317b0(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $226be6ef00b0445d$export$738ab4df8bf92ae9(sval);
}
function $226be6ef00b0445d$export$317a3d46287192d8(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
const $226be6ef00b0445d$var$keyResolvers = {
    '': (v)=>v,
    x: (o)=>o.x,
    y: (o)=>o.y
};
function $226be6ef00b0445d$export$2d1720544b23b823(obj, key) {
    const resolver = $226be6ef00b0445d$var$keyResolvers[key] || ($226be6ef00b0445d$var$keyResolvers[key] = $226be6ef00b0445d$var$_getKeyResolver(key));
    return resolver(obj);
}
function $226be6ef00b0445d$var$_getKeyResolver(key) {
    const keys = $226be6ef00b0445d$export$1ee57be6f6687d2c(key);
    return (obj)=>{
        for (const k of keys){
            if (k === '') break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $226be6ef00b0445d$export$1ee57be6f6687d2c(key) {
    const parts = key.split('.');
    const keys = [];
    let tmp = '';
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith('\\')) tmp = tmp.slice(0, -1) + '.';
        else {
            keys.push(tmp);
            tmp = '';
        }
    }
    return keys;
}
function $226be6ef00b0445d$export$71cec2538cb2c617(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $226be6ef00b0445d$export$35e795649ee09318 = (value)=>typeof value !== 'undefined';
const $226be6ef00b0445d$export$c3950d9923825c02 = (value)=>typeof value === 'function';
const $226be6ef00b0445d$export$995eb9fca571757 = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
function $226be6ef00b0445d$export$3b513254972cfc9c(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}
const $226be6ef00b0445d$export$56c0d5a1e737357d = Math.PI;
const $226be6ef00b0445d$export$971d5caa766a69d7 = 2 * $226be6ef00b0445d$export$56c0d5a1e737357d;
const $226be6ef00b0445d$export$8c78c7c36408ea29 = $226be6ef00b0445d$export$971d5caa766a69d7 + $226be6ef00b0445d$export$56c0d5a1e737357d;
const $226be6ef00b0445d$export$d29e374196577086 = Number.POSITIVE_INFINITY;
const $226be6ef00b0445d$export$2ec5befb9e6c97d4 = $226be6ef00b0445d$export$56c0d5a1e737357d / 180;
const $226be6ef00b0445d$export$7f8ddf7c7c20b3cd = $226be6ef00b0445d$export$56c0d5a1e737357d / 2;
const $226be6ef00b0445d$export$53c86fa97d611818 = $226be6ef00b0445d$export$56c0d5a1e737357d / 4;
const $226be6ef00b0445d$export$39c1cc7c062529d4 = $226be6ef00b0445d$export$56c0d5a1e737357d * 2 / 3;
const $226be6ef00b0445d$export$df995fae86a55f06 = Math.log10;
const $226be6ef00b0445d$export$2408f22a0fab9ae5 = Math.sign;
function $226be6ef00b0445d$export$b9a6b53f9be3734(range) {
    const roundedRange = Math.round(range);
    range = $226be6ef00b0445d$export$23ebac1979863676(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($226be6ef00b0445d$export$df995fae86a55f06(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
function $226be6ef00b0445d$export$ebd11618f299a286(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
function $226be6ef00b0445d$export$d141bba7fdc215a3(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function $226be6ef00b0445d$export$23ebac1979863676(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
function $226be6ef00b0445d$export$a05254e7c3aeba6e(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
function $226be6ef00b0445d$export$a33b77bbdbb8366c(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $226be6ef00b0445d$export$625550452a3fa3ec(degrees) {
    return degrees * ($226be6ef00b0445d$export$56c0d5a1e737357d / 180);
}
function $226be6ef00b0445d$export$d66501df72047452(radians) {
    return radians * (180 / $226be6ef00b0445d$export$56c0d5a1e737357d);
}
function $226be6ef00b0445d$export$91477dc880baac21(x) {
    if (!$226be6ef00b0445d$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
function $226be6ef00b0445d$export$34aec0b863436764(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $226be6ef00b0445d$export$56c0d5a1e737357d) angle += $226be6ef00b0445d$export$971d5caa766a69d7;
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $226be6ef00b0445d$export$53a70dd1ebbae346(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
function $226be6ef00b0445d$export$7a0bdf7d4a91ea88(a, b) {
    return (a - b + $226be6ef00b0445d$export$8c78c7c36408ea29) % $226be6ef00b0445d$export$971d5caa766a69d7 - $226be6ef00b0445d$export$56c0d5a1e737357d;
}
function $226be6ef00b0445d$export$3d12bd131bb975d1(a) {
    return (a % $226be6ef00b0445d$export$971d5caa766a69d7 + $226be6ef00b0445d$export$971d5caa766a69d7) % $226be6ef00b0445d$export$971d5caa766a69d7;
}
function $226be6ef00b0445d$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $226be6ef00b0445d$export$3d12bd131bb975d1(angle);
    const s = $226be6ef00b0445d$export$3d12bd131bb975d1(start);
    const e = $226be6ef00b0445d$export$3d12bd131bb975d1(end);
    const angleToStart = $226be6ef00b0445d$export$3d12bd131bb975d1(s - a);
    const angleToEnd = $226be6ef00b0445d$export$3d12bd131bb975d1(e - a);
    const startToAngle = $226be6ef00b0445d$export$3d12bd131bb975d1(a - s);
    const endToAngle = $226be6ef00b0445d$export$3d12bd131bb975d1(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
function $226be6ef00b0445d$export$a9c23c6ac3fc3eca(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
function $226be6ef00b0445d$export$9bb611d729802a56(value) {
    return $226be6ef00b0445d$export$a9c23c6ac3fc3eca(value, -32768, 32767);
}
function $226be6ef00b0445d$export$21579262ef46735b(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $226be6ef00b0445d$export$c03999cb2f36933f(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
const $226be6ef00b0445d$export$dc98b0b04f4c7758 = (table, key, value, last)=>$226be6ef00b0445d$export$c03999cb2f36933f(table, value, last ? (index)=>table[index][key] <= value : (index)=>table[index][key] < value);
const $226be6ef00b0445d$export$8743009a87fcb00f = (table, key, value)=>$226be6ef00b0445d$export$c03999cb2f36933f(table, value, (index)=>table[index][key] >= value);
function $226be6ef00b0445d$export$faec65b429be379(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $226be6ef00b0445d$var$arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function $226be6ef00b0445d$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $226be6ef00b0445d$var$arrayEvents.forEach((key)=>{
        const method = '_onData' + $226be6ef00b0445d$export$71cec2538cb2c617(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === 'function') object[method](...args);
                });
                return res;
            }
        });
    });
}
function $226be6ef00b0445d$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $226be6ef00b0445d$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
function $226be6ef00b0445d$export$71511d61b312f219(items) {
    const set = new Set();
    let i, ilen;
    for(i = 0, ilen = items.length; i < ilen; ++i)set.add(items[i]);
    if (set.size === ilen) return items;
    return Array.from(set);
}
function $226be6ef00b0445d$export$a17c37559e1db147(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
const $226be6ef00b0445d$export$43caf9889c228507 = function() {
    if (typeof window === 'undefined') return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
function $226be6ef00b0445d$export$efca4cbe5dd06740(fn, thisArg, updateFn) {
    const updateArgs = updateFn || ((args)=>Array.prototype.slice.call(args));
    let ticking = false;
    let args = [];
    return function(...rest) {
        args = updateArgs(rest);
        if (!ticking) {
            ticking = true;
            $226be6ef00b0445d$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, args);
            });
        }
    };
}
function $226be6ef00b0445d$export$f787f51d84a910ad(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
const $226be6ef00b0445d$export$db202ddc8be9136 = (align)=>align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
const $226be6ef00b0445d$export$25ce5a424b770e84 = (align, start, end)=>align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
const $226be6ef00b0445d$export$890c4ad488842ce7 = (align, left, right, rtl)=>{
    const check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
function $226be6ef00b0445d$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, _parsed: _parsed } = meta;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) start = $226be6ef00b0445d$export$a9c23c6ac3fc3eca(Math.min($226be6ef00b0445d$export$dc98b0b04f4c7758(_parsed, iScale.axis, min).lo, animationsDisabled ? pointCount : $226be6ef00b0445d$export$dc98b0b04f4c7758(points, axis, iScale.getPixelForValue(min)).lo), 0, pointCount - 1);
        if (maxDefined) count = $226be6ef00b0445d$export$a9c23c6ac3fc3eca(Math.max($226be6ef00b0445d$export$dc98b0b04f4c7758(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $226be6ef00b0445d$export$dc98b0b04f4c7758(points, axis, iScale.getPixelForValue(max), true).hi + 1), start, pointCount) - start;
        else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
function $226be6ef00b0445d$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $226be6ef00b0445d$var$atEdge = (t)=>t === 0 || t === 1;
const $226be6ef00b0445d$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $226be6ef00b0445d$export$971d5caa766a69d7 / p));
const $226be6ef00b0445d$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $226be6ef00b0445d$export$971d5caa766a69d7 / p) + 1;
const $226be6ef00b0445d$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $226be6ef00b0445d$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $226be6ef00b0445d$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($226be6ef00b0445d$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$226be6ef00b0445d$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$226be6ef00b0445d$var$atEdge(t) ? t : $226be6ef00b0445d$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$226be6ef00b0445d$var$atEdge(t) ? t : $226be6ef00b0445d$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $226be6ef00b0445d$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $226be6ef00b0445d$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $226be6ef00b0445d$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $226be6ef00b0445d$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $226be6ef00b0445d$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $226be6ef00b0445d$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
/*!
 * @kurkle/color v0.2.1
 * https://github.com/kurkle/color#readme
 * (c) 2022 Jukka Kurkela
 * Released under the MIT License
 */ function $226be6ef00b0445d$var$round(v) {
    return v + 0.5 | 0;
}
const $226be6ef00b0445d$var$lim = (v, l, h)=>Math.max(Math.min(v, h), l);
function $226be6ef00b0445d$var$p2b(v) {
    return $226be6ef00b0445d$var$lim($226be6ef00b0445d$var$round(v * 2.55), 0, 255);
}
function $226be6ef00b0445d$var$n2b(v) {
    return $226be6ef00b0445d$var$lim($226be6ef00b0445d$var$round(v * 255), 0, 255);
}
function $226be6ef00b0445d$var$b2n(v) {
    return $226be6ef00b0445d$var$lim($226be6ef00b0445d$var$round(v / 2.55) / 100, 0, 1);
}
function $226be6ef00b0445d$var$n2p(v) {
    return $226be6ef00b0445d$var$lim($226be6ef00b0445d$var$round(v * 100), 0, 100);
}
const $226be6ef00b0445d$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $226be6ef00b0445d$var$hex = [
    ...'0123456789ABCDEF'
];
const $226be6ef00b0445d$var$h1 = (b)=>$226be6ef00b0445d$var$hex[b & 0xF];
const $226be6ef00b0445d$var$h2 = (b)=>$226be6ef00b0445d$var$hex[(b & 0xF0) >> 4] + $226be6ef00b0445d$var$hex[b & 0xF];
const $226be6ef00b0445d$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $226be6ef00b0445d$var$isShort = (v)=>$226be6ef00b0445d$var$eq(v.r) && $226be6ef00b0445d$var$eq(v.g) && $226be6ef00b0445d$var$eq(v.b) && $226be6ef00b0445d$var$eq(v.a);
function $226be6ef00b0445d$var$hexParse(str) {
    var len = str.length;
    var ret;
    if (str[0] === '#') {
        if (len === 4 || len === 5) ret = {
            r: 255 & $226be6ef00b0445d$var$map$1[str[1]] * 17,
            g: 255 & $226be6ef00b0445d$var$map$1[str[2]] * 17,
            b: 255 & $226be6ef00b0445d$var$map$1[str[3]] * 17,
            a: len === 5 ? $226be6ef00b0445d$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $226be6ef00b0445d$var$map$1[str[1]] << 4 | $226be6ef00b0445d$var$map$1[str[2]],
            g: $226be6ef00b0445d$var$map$1[str[3]] << 4 | $226be6ef00b0445d$var$map$1[str[4]],
            b: $226be6ef00b0445d$var$map$1[str[5]] << 4 | $226be6ef00b0445d$var$map$1[str[6]],
            a: len === 9 ? $226be6ef00b0445d$var$map$1[str[7]] << 4 | $226be6ef00b0445d$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $226be6ef00b0445d$var$alpha = (a, f)=>a < 255 ? f(a) : '';
function $226be6ef00b0445d$var$hexString(v) {
    var f = $226be6ef00b0445d$var$isShort(v) ? $226be6ef00b0445d$var$h1 : $226be6ef00b0445d$var$h2;
    return v ? '#' + f(v.r) + f(v.g) + f(v.b) + $226be6ef00b0445d$var$alpha(v.a, f) : undefined;
}
const $226be6ef00b0445d$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $226be6ef00b0445d$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $226be6ef00b0445d$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $226be6ef00b0445d$var$hwb2rgbn(h, w, b) {
    const rgb = $226be6ef00b0445d$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $226be6ef00b0445d$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $226be6ef00b0445d$var$rgb2hsl(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $226be6ef00b0445d$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $226be6ef00b0445d$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($226be6ef00b0445d$var$n2b);
}
function $226be6ef00b0445d$var$hsl2rgb(h, s, l) {
    return $226be6ef00b0445d$var$calln($226be6ef00b0445d$var$hsl2rgbn, h, s, l);
}
function $226be6ef00b0445d$var$hwb2rgb(h, w, b) {
    return $226be6ef00b0445d$var$calln($226be6ef00b0445d$var$hwb2rgbn, h, w, b);
}
function $226be6ef00b0445d$var$hsv2rgb(h, s, v) {
    return $226be6ef00b0445d$var$calln($226be6ef00b0445d$var$hsv2rgbn, h, s, v);
}
function $226be6ef00b0445d$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $226be6ef00b0445d$var$hueParse(str) {
    const m = $226be6ef00b0445d$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $226be6ef00b0445d$var$p2b(+m[5]) : $226be6ef00b0445d$var$n2b(+m[5]);
    const h = $226be6ef00b0445d$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === 'hwb') v = $226be6ef00b0445d$var$hwb2rgb(h, p1, p2);
    else if (m[1] === 'hsv') v = $226be6ef00b0445d$var$hsv2rgb(h, p1, p2);
    else v = $226be6ef00b0445d$var$hsl2rgb(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $226be6ef00b0445d$var$rotate(v, deg) {
    var h = $226be6ef00b0445d$var$rgb2hsl(v);
    h[0] = $226be6ef00b0445d$var$hue(h[0] + deg);
    h = $226be6ef00b0445d$var$hsl2rgb(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $226be6ef00b0445d$var$hslString(v) {
    if (!v) return;
    const a = $226be6ef00b0445d$var$rgb2hsl(v);
    const h = a[0];
    const s = $226be6ef00b0445d$var$n2p(a[1]);
    const l = $226be6ef00b0445d$var$n2p(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$226be6ef00b0445d$var$b2n(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $226be6ef00b0445d$var$map = {
    x: 'dark',
    Z: 'light',
    Y: 're',
    X: 'blu',
    W: 'gr',
    V: 'medium',
    U: 'slate',
    A: 'ee',
    T: 'ol',
    S: 'or',
    B: 'ra',
    C: 'lateg',
    D: 'ights',
    R: 'in',
    Q: 'turquois',
    E: 'hi',
    P: 'ro',
    O: 'al',
    N: 'le',
    M: 'de',
    L: 'yello',
    F: 'en',
    K: 'ch',
    G: 'arks',
    H: 'ea',
    I: 'ightg',
    J: 'wh'
};
const $226be6ef00b0445d$var$names$1 = {
    OiceXe: 'f0f8ff',
    antiquewEte: 'faebd7',
    aqua: 'ffff',
    aquamarRe: '7fffd4',
    azuY: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '0',
    blanKedOmond: 'ffebcd',
    Xe: 'ff',
    XeviTet: '8a2be2',
    bPwn: 'a52a2a',
    burlywood: 'deb887',
    caMtXe: '5f9ea0',
    KartYuse: '7fff00',
    KocTate: 'd2691e',
    cSO: 'ff7f50',
    cSnflowerXe: '6495ed',
    cSnsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: 'ffff',
    xXe: '8b',
    xcyan: '8b8b',
    xgTMnPd: 'b8860b',
    xWay: 'a9a9a9',
    xgYF: '6400',
    xgYy: 'a9a9a9',
    xkhaki: 'bdb76b',
    xmagFta: '8b008b',
    xTivegYF: '556b2f',
    xSange: 'ff8c00',
    xScEd: '9932cc',
    xYd: '8b0000',
    xsOmon: 'e9967a',
    xsHgYF: '8fbc8f',
    xUXe: '483d8b',
    xUWay: '2f4f4f',
    xUgYy: '2f4f4f',
    xQe: 'ced1',
    xviTet: '9400d3',
    dAppRk: 'ff1493',
    dApskyXe: 'bfff',
    dimWay: '696969',
    dimgYy: '696969',
    dodgerXe: '1e90ff',
    fiYbrick: 'b22222',
    flSOwEte: 'fffaf0',
    foYstWAn: '228b22',
    fuKsia: 'ff00ff',
    gaRsbSo: 'dcdcdc',
    ghostwEte: 'f8f8ff',
    gTd: 'ffd700',
    gTMnPd: 'daa520',
    Way: '808080',
    gYF: '8000',
    gYFLw: 'adff2f',
    gYy: '808080',
    honeyMw: 'f0fff0',
    hotpRk: 'ff69b4',
    RdianYd: 'cd5c5c',
    Rdigo: '4b0082',
    ivSy: 'fffff0',
    khaki: 'f0e68c',
    lavFMr: 'e6e6fa',
    lavFMrXsh: 'fff0f5',
    lawngYF: '7cfc00',
    NmoncEffon: 'fffacd',
    ZXe: 'add8e6',
    ZcSO: 'f08080',
    Zcyan: 'e0ffff',
    ZgTMnPdLw: 'fafad2',
    ZWay: 'd3d3d3',
    ZgYF: '90ee90',
    ZgYy: 'd3d3d3',
    ZpRk: 'ffb6c1',
    ZsOmon: 'ffa07a',
    ZsHgYF: '20b2aa',
    ZskyXe: '87cefa',
    ZUWay: '778899',
    ZUgYy: '778899',
    ZstAlXe: 'b0c4de',
    ZLw: 'ffffe0',
    lime: 'ff00',
    limegYF: '32cd32',
    lRF: 'faf0e6',
    magFta: 'ff00ff',
    maPon: '800000',
    VaquamarRe: '66cdaa',
    VXe: 'cd',
    VScEd: 'ba55d3',
    VpurpN: '9370db',
    VsHgYF: '3cb371',
    VUXe: '7b68ee',
    VsprRggYF: 'fa9a',
    VQe: '48d1cc',
    VviTetYd: 'c71585',
    midnightXe: '191970',
    mRtcYam: 'f5fffa',
    mistyPse: 'ffe4e1',
    moccasR: 'ffe4b5',
    navajowEte: 'ffdead',
    navy: '80',
    Tdlace: 'fdf5e6',
    Tive: '808000',
    TivedBb: '6b8e23',
    Sange: 'ffa500',
    SangeYd: 'ff4500',
    ScEd: 'da70d6',
    pOegTMnPd: 'eee8aa',
    pOegYF: '98fb98',
    pOeQe: 'afeeee',
    pOeviTetYd: 'db7093',
    papayawEp: 'ffefd5',
    pHKpuff: 'ffdab9',
    peru: 'cd853f',
    pRk: 'ffc0cb',
    plum: 'dda0dd',
    powMrXe: 'b0e0e6',
    purpN: '800080',
    YbeccapurpN: '663399',
    Yd: 'ff0000',
    Psybrown: 'bc8f8f',
    PyOXe: '4169e1',
    saddNbPwn: '8b4513',
    sOmon: 'fa8072',
    sandybPwn: 'f4a460',
    sHgYF: '2e8b57',
    sHshell: 'fff5ee',
    siFna: 'a0522d',
    silver: 'c0c0c0',
    skyXe: '87ceeb',
    UXe: '6a5acd',
    UWay: '708090',
    UgYy: '708090',
    snow: 'fffafa',
    sprRggYF: 'ff7f',
    stAlXe: '4682b4',
    tan: 'd2b48c',
    teO: '8080',
    tEstN: 'd8bfd8',
    tomato: 'ff6347',
    Qe: '40e0d0',
    viTet: 'ee82ee',
    JHt: 'f5deb3',
    wEte: 'ffffff',
    wEtesmoke: 'f5f5f5',
    Lw: 'ffff00',
    LwgYF: '9acd32'
};
function $226be6ef00b0445d$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($226be6ef00b0445d$var$names$1);
    const tkeys = Object.keys($226be6ef00b0445d$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $226be6ef00b0445d$var$map[k]);
        }
        k = parseInt($226be6ef00b0445d$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $226be6ef00b0445d$var$names;
function $226be6ef00b0445d$var$nameParse(str) {
    if (!$226be6ef00b0445d$var$names) {
        $226be6ef00b0445d$var$names = $226be6ef00b0445d$var$unpack();
        $226be6ef00b0445d$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $226be6ef00b0445d$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $226be6ef00b0445d$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $226be6ef00b0445d$var$rgbParse(str) {
    const m = $226be6ef00b0445d$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $226be6ef00b0445d$var$p2b(v) : $226be6ef00b0445d$var$lim(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $226be6ef00b0445d$var$p2b(r) : $226be6ef00b0445d$var$lim(r, 0, 255));
    g = 255 & (m[4] ? $226be6ef00b0445d$var$p2b(g) : $226be6ef00b0445d$var$lim(g, 0, 255));
    b = 255 & (m[6] ? $226be6ef00b0445d$var$p2b(b) : $226be6ef00b0445d$var$lim(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $226be6ef00b0445d$var$rgbString(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$226be6ef00b0445d$var$b2n(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $226be6ef00b0445d$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $226be6ef00b0445d$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $226be6ef00b0445d$var$interpolate(rgb1, rgb2, t) {
    const r = $226be6ef00b0445d$var$from($226be6ef00b0445d$var$b2n(rgb1.r));
    const g = $226be6ef00b0445d$var$from($226be6ef00b0445d$var$b2n(rgb1.g));
    const b = $226be6ef00b0445d$var$from($226be6ef00b0445d$var$b2n(rgb1.b));
    return {
        r: $226be6ef00b0445d$var$n2b($226be6ef00b0445d$var$to(r + t * ($226be6ef00b0445d$var$from($226be6ef00b0445d$var$b2n(rgb2.r)) - r))),
        g: $226be6ef00b0445d$var$n2b($226be6ef00b0445d$var$to(g + t * ($226be6ef00b0445d$var$from($226be6ef00b0445d$var$b2n(rgb2.g)) - g))),
        b: $226be6ef00b0445d$var$n2b($226be6ef00b0445d$var$to(b + t * ($226be6ef00b0445d$var$from($226be6ef00b0445d$var$b2n(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $226be6ef00b0445d$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $226be6ef00b0445d$var$rgb2hsl(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $226be6ef00b0445d$var$hsl2rgb(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $226be6ef00b0445d$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $226be6ef00b0445d$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $226be6ef00b0445d$var$n2b(input[3]);
        }
    } else {
        v = $226be6ef00b0445d$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $226be6ef00b0445d$var$n2b(v.a);
    }
    return v;
}
function $226be6ef00b0445d$var$functionParse(str) {
    if (str.charAt(0) === 'r') return $226be6ef00b0445d$var$rgbParse(str);
    return $226be6ef00b0445d$var$hueParse(str);
}
class $226be6ef00b0445d$var$Color {
    constructor(input){
        if (input instanceof $226be6ef00b0445d$var$Color) return input;
        const type = typeof input;
        let v;
        if (type === 'object') v = $226be6ef00b0445d$var$fromObject(input);
        else if (type === 'string') v = $226be6ef00b0445d$var$hexParse(input) || $226be6ef00b0445d$var$nameParse(input) || $226be6ef00b0445d$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $226be6ef00b0445d$var$clone(this._rgb);
        if (v) v.a = $226be6ef00b0445d$var$b2n(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $226be6ef00b0445d$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $226be6ef00b0445d$var$rgbString(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $226be6ef00b0445d$var$hexString(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $226be6ef00b0445d$var$hslString(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $226be6ef00b0445d$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $226be6ef00b0445d$var$Color(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $226be6ef00b0445d$var$n2b(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $226be6ef00b0445d$var$round(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $226be6ef00b0445d$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $226be6ef00b0445d$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $226be6ef00b0445d$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $226be6ef00b0445d$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $226be6ef00b0445d$var$rotate(this._rgb, deg);
        return this;
    }
}
function $226be6ef00b0445d$var$index_esm(input) {
    return new $226be6ef00b0445d$var$Color(input);
}
function $226be6ef00b0445d$export$2ed0fc6709e59212(value) {
    if (value && typeof value === 'object') {
        const type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function $226be6ef00b0445d$export$db3b6bfb95261072(value) {
    return $226be6ef00b0445d$export$2ed0fc6709e59212(value) ? value : $226be6ef00b0445d$var$index_esm(value);
}
function $226be6ef00b0445d$export$f96d196f7728bb5(value) {
    return $226be6ef00b0445d$export$2ed0fc6709e59212(value) ? value : $226be6ef00b0445d$var$index_esm(value).saturate(0.5).darken(0.1).hexString();
}
const $226be6ef00b0445d$export$3a6d5c9ae78a2c08 = Object.create(null);
const $226be6ef00b0445d$export$a93c5207d687da10 = Object.create(null);
function $226be6ef00b0445d$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split('.');
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $226be6ef00b0445d$var$set(root, scope, values) {
    if (typeof scope === 'string') return $226be6ef00b0445d$export$e7c866399fa523f5($226be6ef00b0445d$var$getScope$1(root, scope), values);
    return $226be6ef00b0445d$export$e7c866399fa523f5($226be6ef00b0445d$var$getScope$1(root, ''), scope);
}
class $226be6ef00b0445d$var$Defaults {
    constructor(_descriptors){
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$226be6ef00b0445d$export$f96d196f7728bb5(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$226be6ef00b0445d$export$f96d196f7728bb5(options.borderColor);
        this.hoverColor = (ctx, options)=>$226be6ef00b0445d$export$f96d196f7728bb5(options.color);
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
    }
    set(scope, values) {
        return $226be6ef00b0445d$var$set(this, scope, values);
    }
    get(scope) {
        return $226be6ef00b0445d$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $226be6ef00b0445d$var$set($226be6ef00b0445d$export$a93c5207d687da10, scope, values);
    }
    override(scope, values) {
        return $226be6ef00b0445d$var$set($226be6ef00b0445d$export$3a6d5c9ae78a2c08, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $226be6ef00b0445d$var$getScope$1(this, scope);
        const targetScopeObject = $226be6ef00b0445d$var$getScope$1(this, targetScope);
        const privateName = '_' + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($226be6ef00b0445d$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $226be6ef00b0445d$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
}
var $226be6ef00b0445d$export$4368d992c4eafac0 = new $226be6ef00b0445d$var$Defaults({
    _scriptable: (name)=>!name.startsWith('on'),
    _indexable: (name)=>name !== 'events',
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
});
function $226be6ef00b0445d$export$9d0e2d13d04f7070(font) {
    if (!font || $226be6ef00b0445d$export$342063e11d6c3cad(font.size) || $226be6ef00b0445d$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
function $226be6ef00b0445d$export$2329c99376c9d0a4(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
function $226be6ef00b0445d$export$9f4f30ee63539e24(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        if (thing !== undefined && thing !== null && $226be6ef00b0445d$export$8b22cf2602fb60ce(thing) !== true) longest = $226be6ef00b0445d$export$2329c99376c9d0a4(ctx, data, gc, longest, thing);
        else if ($226be6ef00b0445d$export$8b22cf2602fb60ce(thing)) for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            if (nestedThing !== undefined && nestedThing !== null && !$226be6ef00b0445d$export$8b22cf2602fb60ce(nestedThing)) longest = $226be6ef00b0445d$export$2329c99376c9d0a4(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
function $226be6ef00b0445d$export$b4171a6734a65d42(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
function $226be6ef00b0445d$export$ee7c8ad385a60b7b(canvas, ctx) {
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $226be6ef00b0445d$export$1fbe638ecf81657e(ctx, options, x, y) {
    $226be6ef00b0445d$export$158acd800e1ef08b(ctx, options, x, y, null);
}
function $226be6ef00b0445d$export$158acd800e1ef08b(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $226be6ef00b0445d$export$2ec5befb9e6c97d4;
    if (style && typeof style === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $226be6ef00b0445d$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $226be6ef00b0445d$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case 'triangle':
            ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += $226be6ef00b0445d$export$39c1cc7c062529d4;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += $226be6ef00b0445d$export$39c1cc7c062529d4;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $226be6ef00b0445d$export$53c86fa97d611818) * size;
            yOffset = Math.sin(rad + $226be6ef00b0445d$export$53c86fa97d611818) * size;
            ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - $226be6ef00b0445d$export$56c0d5a1e737357d, rad - $226be6ef00b0445d$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - $226be6ef00b0445d$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + $226be6ef00b0445d$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + $226be6ef00b0445d$export$7f8ddf7c7c20b3cd, rad + $226be6ef00b0445d$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $226be6ef00b0445d$export$53c86fa97d611818;
        case 'rectRot':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + yOffset, y - xOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += $226be6ef00b0445d$export$53c86fa97d611818;
        case 'cross':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case 'star':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            rad += $226be6ef00b0445d$export$53c86fa97d611818;
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
function $226be6ef00b0445d$export$3d8c2f653ac9d0b9(point, area, margin) {
    margin = margin || 0.5;
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $226be6ef00b0445d$export$61196ced6d74a310(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $226be6ef00b0445d$export$a07804094c3ecf2d(ctx) {
    ctx.restore();
}
function $226be6ef00b0445d$export$6554612db691658e(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === 'middle') {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
function $226be6ef00b0445d$export$493d36ec626b6698(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $226be6ef00b0445d$export$3a1a48c8f6ef640e(ctx, text, x, y, font, opts = {}) {
    const lines = $226be6ef00b0445d$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $226be6ef00b0445d$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$226be6ef00b0445d$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $226be6ef00b0445d$var$decorateText(ctx, x, y, line, opts);
        y += font.lineHeight;
    }
    ctx.restore();
}
function $226be6ef00b0445d$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$226be6ef00b0445d$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $226be6ef00b0445d$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $226be6ef00b0445d$export$d66dc83d8cfc8dd(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, -$226be6ef00b0445d$export$7f8ddf7c7c20b3cd, $226be6ef00b0445d$export$56c0d5a1e737357d, true);
    ctx.lineTo(x, y + h - radius.bottomLeft);
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $226be6ef00b0445d$export$56c0d5a1e737357d, $226be6ef00b0445d$export$7f8ddf7c7c20b3cd, true);
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $226be6ef00b0445d$export$7f8ddf7c7c20b3cd, 0, true);
    ctx.lineTo(x + w, y + radius.topRight);
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$226be6ef00b0445d$export$7f8ddf7c7c20b3cd, true);
    ctx.lineTo(x + radius.topLeft, y);
}
const $226be6ef00b0445d$var$LINE_HEIGHT = new RegExp(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
const $226be6ef00b0445d$var$FONT_STYLE = new RegExp(/^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/);
function $226be6ef00b0445d$export$fef3dfd9bad05307(value, size) {
    const matches = ('' + value).match($226be6ef00b0445d$var$LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
const $226be6ef00b0445d$var$numberOrZero = (v)=>+v || 0;
function $226be6ef00b0445d$export$ab83b03e4111b1d0(value, props) {
    const ret = {};
    const objProps = $226be6ef00b0445d$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $226be6ef00b0445d$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$226be6ef00b0445d$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $226be6ef00b0445d$var$numberOrZero(read(prop));
    return ret;
}
function $226be6ef00b0445d$export$92108d983e8ee699(value) {
    return $226be6ef00b0445d$export$ab83b03e4111b1d0(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
function $226be6ef00b0445d$export$9fa96a7d116ea3ce(value) {
    return $226be6ef00b0445d$export$ab83b03e4111b1d0(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
function $226be6ef00b0445d$export$3466f893ebf79586(value) {
    const obj = $226be6ef00b0445d$export$92108d983e8ee699(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
function $226be6ef00b0445d$export$c4ce752e73470fba(options, fallback) {
    options = options || {};
    fallback = fallback || $226be6ef00b0445d$export$4368d992c4eafac0.font;
    let size = $226be6ef00b0445d$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === 'string') size = parseInt(size, 10);
    let style = $226be6ef00b0445d$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !('' + style).match($226be6ef00b0445d$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = '';
    }
    const font = {
        family: $226be6ef00b0445d$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $226be6ef00b0445d$export$fef3dfd9bad05307($226be6ef00b0445d$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $226be6ef00b0445d$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ''
    };
    font.string = $226be6ef00b0445d$export$9d0e2d13d04f7070(font);
    return font;
}
function $226be6ef00b0445d$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $226be6ef00b0445d$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
function $226be6ef00b0445d$export$96f57966bedc81b4(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $226be6ef00b0445d$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $226be6ef00b0445d$export$dda1d9f60106f0e9(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
function $226be6ef00b0445d$export$7910e0436ed8d1de(scopes, prefixes = [
    ''
], rootScopes = scopes, fallback, getTarget = ()=>scopes[0]) {
    if (!$226be6ef00b0445d$export$35e795649ee09318(fallback)) fallback = $226be6ef00b0445d$var$_resolve('_fallback', scopes);
    const cache = {
        [Symbol.toStringTag]: 'Object',
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: rootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$226be6ef00b0445d$export$7910e0436ed8d1de([
                scope,
                ...scopes
            ], prefixes, rootScopes, fallback)
    };
    return new Proxy(cache, {
        deleteProperty (target, prop) {
            delete target[prop];
            delete target._keys;
            delete scopes[0][prop];
            return true;
        },
        get (target, prop) {
            return $226be6ef00b0445d$var$_cached(target, prop, ()=>$226be6ef00b0445d$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        has (target, prop) {
            return $226be6ef00b0445d$var$getKeysFromAllScopes(target).includes(prop);
        },
        ownKeys (target) {
            return $226be6ef00b0445d$var$getKeysFromAllScopes(target);
        },
        set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value;
            delete target._keys;
            return true;
        }
    });
}
function $226be6ef00b0445d$export$a9c996f45e5784d0(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $226be6ef00b0445d$export$555508cbc6add439(proxy, descriptorDefaults),
        setContext: (ctx)=>$226be6ef00b0445d$export$a9c996f45e5784d0(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$226be6ef00b0445d$export$a9c996f45e5784d0(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        deleteProperty (target, prop) {
            delete target[prop];
            delete proxy[prop];
            return true;
        },
        get (target, prop, receiver) {
            return $226be6ef00b0445d$var$_cached(target, prop, ()=>$226be6ef00b0445d$var$_resolveWithContext(target, prop, receiver));
        },
        getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        set (target, prop, value) {
            proxy[prop] = value;
            delete target[prop];
            return true;
        }
    });
}
function $226be6ef00b0445d$export$555508cbc6add439(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $226be6ef00b0445d$export$c3950d9923825c02(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $226be6ef00b0445d$export$c3950d9923825c02(_indexable) ? _indexable : ()=>_indexable
    };
}
const $226be6ef00b0445d$var$readKey = (prefix, name)=>prefix ? prefix + $226be6ef00b0445d$export$71cec2538cb2c617(name) : name;
const $226be6ef00b0445d$var$needsSubResolver = (prop, value)=>$226be6ef00b0445d$export$23f2a1d2818174ef(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $226be6ef00b0445d$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop)) return target[prop];
    const value = resolve();
    target[prop] = value;
    return value;
}
function $226be6ef00b0445d$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop];
    if ($226be6ef00b0445d$export$c3950d9923825c02(value) && descriptors.isScriptable(prop)) value = $226be6ef00b0445d$var$_resolveScriptable(prop, value, target, receiver);
    if ($226be6ef00b0445d$export$8b22cf2602fb60ce(value) && value.length) value = $226be6ef00b0445d$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($226be6ef00b0445d$var$needsSubResolver(prop, value)) value = $226be6ef00b0445d$export$a9c996f45e5784d0(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $226be6ef00b0445d$var$_resolveScriptable(prop, value, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    _stack.add(prop);
    value = value(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($226be6ef00b0445d$var$needsSubResolver(prop, value)) value = $226be6ef00b0445d$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $226be6ef00b0445d$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if ($226be6ef00b0445d$export$35e795649ee09318(_context.index) && isIndexable(prop)) value = value[_context.index % value.length];
    else if ($226be6ef00b0445d$export$23f2a1d2818174ef(value[0])) {
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $226be6ef00b0445d$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($226be6ef00b0445d$export$a9c996f45e5784d0(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $226be6ef00b0445d$var$resolveFallback(fallback, prop, value) {
    return $226be6ef00b0445d$export$c3950d9923825c02(fallback) ? fallback(prop, value) : fallback;
}
const $226be6ef00b0445d$var$getScope = (key, parent)=>key === true ? parent : typeof key === 'string' ? $226be6ef00b0445d$export$2d1720544b23b823(parent, key) : undefined;
function $226be6ef00b0445d$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $226be6ef00b0445d$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $226be6ef00b0445d$var$resolveFallback(scope._fallback, key, value);
            if ($226be6ef00b0445d$export$35e795649ee09318(fallback) && fallback !== key && fallback !== parentFallback) return fallback;
        } else if (scope === false && $226be6ef00b0445d$export$35e795649ee09318(parentFallback) && key !== parentFallback) return null;
    }
    return false;
}
function $226be6ef00b0445d$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $226be6ef00b0445d$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $226be6ef00b0445d$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if ($226be6ef00b0445d$export$35e795649ee09318(fallback) && fallback !== prop) {
        key = $226be6ef00b0445d$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $226be6ef00b0445d$export$7910e0436ed8d1de(Array.from(set), [
        ''
    ], rootScopes, fallback, ()=>$226be6ef00b0445d$var$subGetTarget(resolver, prop, value));
}
function $226be6ef00b0445d$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $226be6ef00b0445d$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $226be6ef00b0445d$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($226be6ef00b0445d$export$8b22cf2602fb60ce(target) && $226be6ef00b0445d$export$23f2a1d2818174ef(value)) return value;
    return target;
}
function $226be6ef00b0445d$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $226be6ef00b0445d$var$_resolve($226be6ef00b0445d$var$readKey(prefix, prop), scopes);
        if ($226be6ef00b0445d$export$35e795649ee09318(value)) return $226be6ef00b0445d$var$needsSubResolver(prop, value) ? $226be6ef00b0445d$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $226be6ef00b0445d$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if ($226be6ef00b0445d$export$35e795649ee09318(value)) return value;
    }
}
function $226be6ef00b0445d$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $226be6ef00b0445d$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $226be6ef00b0445d$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith('_')))set.add(key);
    return Array.from(set);
}
function $226be6ef00b0445d$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = 'r' } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($226be6ef00b0445d$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $226be6ef00b0445d$var$EPSILON = Number.EPSILON || 1e-14;
const $226be6ef00b0445d$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $226be6ef00b0445d$var$getValueAxis = (indexAxis)=>indexAxis === 'x' ? 'y' : 'x';
function $226be6ef00b0445d$export$1a8f5705751d8277(firstPoint, middlePoint, afterPoint, t) {
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $226be6ef00b0445d$export$53a70dd1ebbae346(current, previous);
    const d12 = $226be6ef00b0445d$export$53a70dd1ebbae346(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01;
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
function $226be6ef00b0445d$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $226be6ef00b0445d$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $226be6ef00b0445d$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($226be6ef00b0445d$export$23ebac1979863676(deltaK[i], 0, $226be6ef00b0445d$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $226be6ef00b0445d$var$monotoneCompute(points, mK, indexAxis = 'x') {
    const valueAxis = $226be6ef00b0445d$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $226be6ef00b0445d$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $226be6ef00b0445d$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
function $226be6ef00b0445d$export$e171bab687b50e0(points, indexAxis = 'x') {
    const valueAxis = $226be6ef00b0445d$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    let i, pointBefore, pointCurrent;
    let pointAfter = $226be6ef00b0445d$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $226be6ef00b0445d$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $226be6ef00b0445d$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $226be6ef00b0445d$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $226be6ef00b0445d$var$monotoneAdjust(points, deltaK, mK);
    $226be6ef00b0445d$var$monotoneCompute(points, mK, indexAxis);
}
function $226be6ef00b0445d$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $226be6ef00b0445d$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $226be6ef00b0445d$export$3d8c2f653ac9d0b9(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $226be6ef00b0445d$export$3d8c2f653ac9d0b9(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $226be6ef00b0445d$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $226be6ef00b0445d$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $226be6ef00b0445d$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $226be6ef00b0445d$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
function $226be6ef00b0445d$export$1a82df3d29112e01(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === 'monotone') $226be6ef00b0445d$export$e171bab687b50e0(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $226be6ef00b0445d$export$1a8f5705751d8277(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $226be6ef00b0445d$var$capBezierPoints(points, area);
}
function $226be6ef00b0445d$export$2e2af4578d910ddf() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
function $226be6ef00b0445d$export$ce26c07117d59d6a(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
    return parent;
}
function $226be6ef00b0445d$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $226be6ef00b0445d$var$getComputedStyle = (element)=>window.getComputedStyle(element, null);
function $226be6ef00b0445d$export$527e9aa3390079e9(el, property) {
    return $226be6ef00b0445d$var$getComputedStyle(el).getPropertyValue(property);
}
const $226be6ef00b0445d$var$positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function $226be6ef00b0445d$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? '-' + suffix : '';
    for(let i = 0; i < 4; i++){
        const pos = $226be6ef00b0445d$var$positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $226be6ef00b0445d$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
function $226be6ef00b0445d$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($226be6ef00b0445d$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
function $226be6ef00b0445d$export$78acf4525d8a74c4(evt, chart) {
    if ('native' in evt) return evt;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $226be6ef00b0445d$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === 'border-box';
    const paddings = $226be6ef00b0445d$var$getPositionedStyle(style, 'padding');
    const borders = $226be6ef00b0445d$var$getPositionedStyle(style, 'border', 'width');
    const { x: x, y: y, box: box } = $226be6ef00b0445d$var$getCanvasPosition(evt, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $226be6ef00b0445d$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = $226be6ef00b0445d$export$ce26c07117d59d6a(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect();
            const containerStyle = $226be6ef00b0445d$var$getComputedStyle(container);
            const containerBorder = $226be6ef00b0445d$var$getPositionedStyle(containerStyle, 'border', 'width');
            const containerPadding = $226be6ef00b0445d$var$getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $226be6ef00b0445d$var$parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = $226be6ef00b0445d$var$parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $226be6ef00b0445d$export$d29e374196577086,
        maxHeight: maxHeight || $226be6ef00b0445d$export$d29e374196577086
    };
}
const $226be6ef00b0445d$var$round1 = (v)=>Math.round(v * 10) / 10;
function $226be6ef00b0445d$export$3c2fa207a37baaea(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $226be6ef00b0445d$var$getComputedStyle(canvas);
    const margins = $226be6ef00b0445d$var$getPositionedStyle(style, 'margin');
    const maxWidth = $226be6ef00b0445d$var$parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || $226be6ef00b0445d$export$d29e374196577086;
    const maxHeight = $226be6ef00b0445d$var$parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || $226be6ef00b0445d$export$d29e374196577086;
    const containerSize = $226be6ef00b0445d$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === 'content-box') {
        const borders = $226be6ef00b0445d$var$getPositionedStyle(style, 'border', 'width');
        const paddings = $226be6ef00b0445d$var$getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height - margins.height);
    width = $226be6ef00b0445d$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $226be6ef00b0445d$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) height = $226be6ef00b0445d$var$round1(width / 2);
    return {
        width: width,
        height: height
    };
}
function $226be6ef00b0445d$export$c9170ad7d4cd7e57(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = deviceHeight / pixelRatio;
    chart.width = deviceWidth / pixelRatio;
    const canvas = chart.canvas;
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
const $226be6ef00b0445d$export$a8550f7dbe79f93a = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        window.addEventListener('test', null, options);
        window.removeEventListener('test', null, options);
    } catch (e) {}
    return passiveSupported;
}();
function $226be6ef00b0445d$export$6559d589eb85fbb6(element, property) {
    const value = $226be6ef00b0445d$export$527e9aa3390079e9(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
function $226be6ef00b0445d$export$d24c54395ce0c509(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
function $226be6ef00b0445d$export$2f6ca3d3b1f80bf5(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
function $226be6ef00b0445d$export$8a5498727ef6be21(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $226be6ef00b0445d$export$d24c54395ce0c509(p1, cp1, t);
    const b = $226be6ef00b0445d$export$d24c54395ce0c509(cp1, cp2, t);
    const c = $226be6ef00b0445d$export$d24c54395ce0c509(cp2, p2, t);
    const d = $226be6ef00b0445d$export$d24c54395ce0c509(a, b, t);
    const e = $226be6ef00b0445d$export$d24c54395ce0c509(b, c, t);
    return $226be6ef00b0445d$export$d24c54395ce0c509(d, e, t);
}
const $226be6ef00b0445d$var$intlCache = new Map();
function $226be6ef00b0445d$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $226be6ef00b0445d$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $226be6ef00b0445d$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $226be6ef00b0445d$export$ae1af26003f05816(num, locale, options) {
    return $226be6ef00b0445d$var$getNumberFormat(locale, options).format(num);
}
const $226be6ef00b0445d$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === 'center') return align;
            return align === 'right' ? 'left' : 'right';
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $226be6ef00b0445d$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $226be6ef00b0445d$export$91c6e00c14e7e6fd(rtl, rectX, width) {
    return rtl ? $226be6ef00b0445d$var$getRightToLeftAdapter(rectX, width) : $226be6ef00b0445d$var$getLeftToRightAdapter();
}
function $226be6ef00b0445d$export$9d398bebfec1c039(ctx, direction) {
    let style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function $226be6ef00b0445d$export$24baa2b76016ce0e(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}
function $226be6ef00b0445d$var$propertyFn(property) {
    if (property === 'angle') return {
        between: $226be6ef00b0445d$export$ffb5f4729a158638,
        compare: $226be6ef00b0445d$export$7a0bdf7d4a91ea88,
        normalize: $226be6ef00b0445d$export$3d12bd131bb975d1
    };
    return {
        between: $226be6ef00b0445d$export$21579262ef46735b,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $226be6ef00b0445d$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $226be6ef00b0445d$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $226be6ef00b0445d$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $226be6ef00b0445d$export$28f7fcd39efa255(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $226be6ef00b0445d$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $226be6ef00b0445d$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($226be6ef00b0445d$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($226be6ef00b0445d$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $226be6ef00b0445d$export$7a38258bbe170828(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $226be6ef00b0445d$export$28f7fcd39efa255(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $226be6ef00b0445d$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $226be6ef00b0445d$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $226be6ef00b0445d$export$306ddfe3a8403e2(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $226be6ef00b0445d$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $226be6ef00b0445d$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $226be6ef00b0445d$var$splitByStyles(line, $226be6ef00b0445d$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $226be6ef00b0445d$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $226be6ef00b0445d$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $226be6ef00b0445d$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $226be6ef00b0445d$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $226be6ef00b0445d$var$readStyle(segmentOptions.setContext($226be6ef00b0445d$export$dda1d9f60106f0e9(chartContext, {
                type: 'segment',
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($226be6ef00b0445d$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $226be6ef00b0445d$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $226be6ef00b0445d$var$styleChanged(style, prevStyle) {
    return prevStyle && JSON.stringify(style) !== JSON.stringify(prevStyle);
}

});




parcelRegister("cAZeM", function(module, exports) {

$parcel$export(module.exports, "default", () => $92b8594686d05b9b$export$2e2bcd8739ae039);
// noinspection JSUnusedGlobalSymbols

var $jdFcE = parcelRequire("jdFcE");
class $92b8594686d05b9b$export$2e2bcd8739ae039 {
    static info(message, run) {
        this._take('info', message, run);
    }
    static debug(message, run) {
        this._take('debug', message, run);
    }
    static _take(type, message, run) {
        try {
            const stack = new Error().stack;
            if (stack === undefined) console.log(message);
            else console[type](`${message} : ${stack.split(/\n/)[2].replace(/^\s*at /, '')}`);
        } catch (exception) {
            //Do not let exceptions get out of Log class
            console.error(`Error printing error stack : ${exception.stack}`);
        }
        try {
            if (typeof run === 'function') {
                const start = new Date().getTime();
                const result = run();
                const end = new Date().getTime();
                console[type](Math.ceil((end - start) / 10) / 100 + 's');
                return result;
            }
        } catch (exception) {
            console.error(exception.message);
            console.error(exception.stack);
            (0, $jdFcE.default).error(exception.message);
        }
    }
}

});

parcelRegister("2S3Qm", function(module, exports) {

$parcel$export(module.exports, "default", () => $21739b28303d5870$export$2e2bcd8739ae039);
// noinspection JSUnusedGlobalSymbols

var $fa4m4 = parcelRequire("fa4m4");

var $hA9uH = parcelRequire("hA9uH");

var $lSH1h = parcelRequire("lSH1h");

var $jdFcE = parcelRequire("jdFcE");
class $21739b28303d5870$export$2e2bcd8739ae039 {
    static _indicator = null;
    static indicator(on) {
        if (this._indicator === null) {
            this._indicator = document.createElement('div');
            this._indicator.className = 'loader loader-bouncing';
            document.body.appendChild(this._indicator);
        }
        if (on) $(this._indicator).addClass('is-active');
        else $(this._indicator).removeClass('is-active');
    }
    static reload(success, url, wait = 2) {
        if (success === false) return;
        setTimeout(()=>(0, $lSH1h.default).filled(url) ? location.href = url : location.reload(), wait * (0, $hA9uH.default).unit.millisecond);
    }
    static modal() {
        $('[data-remodal-id]').remodal({
            hashTracking: false
        });
    }
    static post(url, data, callback, timeout_second = 10) {
        (async ()=>{
            const result = {
                message: "(\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u6307\u5B9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093)",
                success: false
            };
            try {
                const response = await $.ajax({
                    method: 'POST',
                    url: url,
                    data: data,
                    timeout: timeout_second * (0, $hA9uH.default).unit.millisecond
                });
                // noinspection JSUnresolvedVariable
                result.success = response.success;
                // noinspection JSUnresolvedVariable
                if (!response.success) // noinspection JSUnresolvedVariable
                throw new (0, $fa4m4.InternalError)(response.message || result.message);
                result.message = response.message;
            } catch (exception) {
                switch(exception.statusText){
                    case 'timeout':
                        result.message = "\u51E6\u7406\u304C\u30BF\u30A4\u30E0\u30A2\u30A6\u30C8\u3057\u307E\u3057\u305F";
                        break;
                    default:
                        result.message = exception.message || exception.statusText;
                        if (result.message === 'error') result.message = "\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F";
                        break;
                }
                result.success = false;
            } finally{
                if (result.message !== null) {
                    if (result.success) (0, $jdFcE.default).success(result.message);
                    else (0, $jdFcE.default).warning(result.message);
                }
                if (callback !== undefined) callback(result.success, result.message);
            }
        })();
    }
    static flip(selector) {
        const type = $(selector).attr('type');
        $(selector).attr('type', type === 'password' ? 'text' : 'password');
    }
    static _max_mobile_width = 767;
    static is_mobile() {
        return window.matchMedia(`(max-width: ${this._max_mobile_width}px)`).matches;
    }
    static _offset = 20;
    static scroll() {
        $('a').each((index, element)=>{
            const link = element.getAttribute('href');
            if (!link) return;
            const path = link.replace(RegExp(`^${location.pathname}`), '');
            if (!path.match(/^#/)) return;
            $(element).on('click', function(event) {
                event.preventDefault();
                let area = document.querySelector(this.dataset.scroll);
                if (!area) area = document;
                const target = area.querySelector(path);
                window.scrollTo({
                    top: target.getBoundingClientRect().top + window.pageYOffset - ($21739b28303d5870$export$2e2bcd8739ae039.is_mobile() ? 70 : 130),
                    behavior: 'smooth'
                });
            });
        });
        if (location.hash.match(/^#./)) {
            if ($(location.hash).length > 0) $('html, body').animate({
                scrollTop: $(location.hash).offset().top - this._offset
            }, 'fast');
        }
    }
    static autokana(type, output, katakana = true) {
        $.fn.autoKana(type, output, {
            katakana: katakana
        });
    }
    static modal_open(id) {
        $(`[data-remodal-id=${id}]`).remodal({
            hashTracking: false
        }).open();
    }
    static modal_close(id) {
        $(`[data-remodal-id=${id}]`).remodal({
            hashTracking: false
        }).close();
    }
}

});


var $7htw4 = parcelRequire("7htw4");
var $HgoiY = parcelRequire("HgoiY");
var $jP2vU = parcelRequire("jP2vU");

var $cEq52 = parcelRequire("cEq52");

var $HgoiY = parcelRequire("HgoiY");
var $7htw4 = parcelRequire("7htw4");

var $cEq52 = parcelRequire("cEq52");

var $la2Of = parcelRequire("la2Of");

var $3WK1v = parcelRequire("3WK1v");

var $gUaXH = parcelRequire("gUaXH");
const $73f29a8c00de1619$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $73f29a8c00de1619$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $73f29a8c00de1619$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') integrations = (0, $HgoiY.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $73f29a8c00de1619$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $73f29a8c00de1619$var$findIndex(finalIntegrations, (integration)=>integration.name === 'Debug');
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $73f29a8c00de1619$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $73f29a8c00de1619$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $73f29a8c00de1619$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $73f29a8c00de1619$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($73f29a8c00de1619$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $la2Of.addGlobalEventProcessor), (0, $gUaXH.getCurrentHub));
        $73f29a8c00de1619$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = (event, hint)=>callback(event, hint, client);
        processor.id = integration.name;
        client.addEventProcessor(processor);
    }
    (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $73f29a8c00de1619$export$2d8f5188773bcddd(integration) {
    const client = (0, $3WK1v.getClient)();
    if (!client || !client.addIntegration) {
        (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $73f29a8c00de1619$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $73f29a8c00de1619$export$afa219bf23651160(name, fn) {
    const ConvertedIntegration = function ConvertedIntegration(...args) {
        return fn(...args);
    };
    ConvertedIntegration.id = name;
    return ConvertedIntegration;
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $73f29a8c00de1619$export$2323046b9414659f(fn) {
    return fn;
}


// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $7074340826553a9d$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $7074340826553a9d$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $7074340826553a9d$var$INTEGRATION_NAME = 'InboundFilters';
const $7074340826553a9d$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $7074340826553a9d$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $7074340826553a9d$var$_mergeOptions(options, clientOptions);
            return $7074340826553a9d$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $7074340826553a9d$export$cb3c5c2ceb9818ba = (0, $73f29a8c00de1619$export$2323046b9414659f)($7074340826553a9d$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $7074340826553a9d$export$2ffbb5359dcc6be4 = (0, $73f29a8c00de1619$export$afa219bf23651160)($7074340826553a9d$var$INTEGRATION_NAME, $7074340826553a9d$export$cb3c5c2ceb9818ba);
function $7074340826553a9d$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $7074340826553a9d$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $7074340826553a9d$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $7074340826553a9d$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $7074340826553a9d$var$_isSentryError(event)) {
        (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $HgoiY.getEventDescription)(event)}`);
        return true;
    }
    if ($7074340826553a9d$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $HgoiY.getEventDescription)(event)}`);
        return true;
    }
    if ($7074340826553a9d$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $HgoiY.getEventDescription)(event)}`);
        return true;
    }
    if ($7074340826553a9d$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $HgoiY.getEventDescription)(event)}.\nUrl: ${$7074340826553a9d$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$7074340826553a9d$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $HgoiY.getEventDescription)(event)}.\nUrl: ${$7074340826553a9d$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $7074340826553a9d$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $7074340826553a9d$var$_getPossibleEventMessages(event).some((message)=>(0, $jP2vU.stringMatchesSomePattern)(message, ignoreErrors));
}
function $7074340826553a9d$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $jP2vU.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $7074340826553a9d$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $7074340826553a9d$var$_getEventFilterUrl(event);
    return !url ? false : (0, $jP2vU.stringMatchesSomePattern)(url, denyUrls);
}
function $7074340826553a9d$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $7074340826553a9d$var$_getEventFilterUrl(event);
    return !url ? true : (0, $jP2vU.stringMatchesSomePattern)(url, allowUrls);
}
function $7074340826553a9d$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $cEq52.DEBUG_BUILD) && possibleMessages.length === 0) (0, $7htw4.logger).error(`Could not extract message for event ${(0, $HgoiY.getEventDescription)(event)}`);
    return possibleMessages;
}
function $7074340826553a9d$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $7074340826553a9d$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $7074340826553a9d$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $7074340826553a9d$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).error(`Cannot extract url for event ${(0, $HgoiY.getEventDescription)(event)}`);
        return null;
    }
}


var $bP4Y8 = parcelRequire("bP4Y8");

var $3WK1v = parcelRequire("3WK1v");

let $009f5c88bbd2ff13$var$originalFunctionToString;
const $009f5c88bbd2ff13$var$INTEGRATION_NAME = 'FunctionToString';
const $009f5c88bbd2ff13$var$SETUP_CLIENTS = new WeakMap();
const $009f5c88bbd2ff13$var$_functionToStringIntegration = ()=>{
    return {
        name: $009f5c88bbd2ff13$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $009f5c88bbd2ff13$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $bP4Y8.getOriginalFunction)(this);
                    const context = $009f5c88bbd2ff13$var$SETUP_CLIENTS.has((0, $3WK1v.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $009f5c88bbd2ff13$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $009f5c88bbd2ff13$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $009f5c88bbd2ff13$export$7918117e9202e4fb = (0, $73f29a8c00de1619$export$2323046b9414659f)($009f5c88bbd2ff13$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $009f5c88bbd2ff13$export$da4704525c20ae79 = (0, $73f29a8c00de1619$export$afa219bf23651160)($009f5c88bbd2ff13$var$INTEGRATION_NAME, $009f5c88bbd2ff13$export$7918117e9202e4fb);


var $7htw4 = parcelRequire("7htw4");

var $cEq52 = parcelRequire("cEq52");

var $3WK1v = parcelRequire("3WK1v");

var $gUaXH = parcelRequire("gUaXH");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $ec20e29fc539f943$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $cEq52.DEBUG_BUILD) (0, $7htw4.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $7htw4.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $3WK1v.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $ec20e29fc539f943$export$ecb76f41d43c0e43(client);
    $ec20e29fc539f943$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $ec20e29fc539f943$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $gUaXH.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $ec20e29fc539f943$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}


var $gUaXH = parcelRequire("gUaXH");
var $bP4Y8 = parcelRequire("bP4Y8");
var $8FmHF = parcelRequire("8FmHF");

var $7htw4 = parcelRequire("7htw4");
/** Regular expression used to parse a Dsn. */ const $0aaaa6c30c5fe7e9$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $0aaaa6c30c5fe7e9$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $0aaaa6c30c5fe7e9$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $0aaaa6c30c5fe7e9$export$b892860177f70a30(str) {
    const match = $0aaaa6c30c5fe7e9$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $7htw4.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $0aaaa6c30c5fe7e9$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $0aaaa6c30c5fe7e9$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $0aaaa6c30c5fe7e9$var$validateDsn(dsn) {
    if (!(0, $8FmHF.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $7htw4.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $7htw4.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$0aaaa6c30c5fe7e9$var$isValidProtocol(protocol)) {
        (0, $7htw4.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $7htw4.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $0aaaa6c30c5fe7e9$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $0aaaa6c30c5fe7e9$export$b892860177f70a30(from) : $0aaaa6c30c5fe7e9$var$dsnFromComponents(from);
    if (!components || !$0aaaa6c30c5fe7e9$var$validateDsn(components)) return undefined;
    return components;
}


const $da298c0570fc4a2c$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $da298c0570fc4a2c$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $da298c0570fc4a2c$var$_getIngestEndpoint(dsn) {
    return `${$da298c0570fc4a2c$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $da298c0570fc4a2c$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $bP4Y8.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $da298c0570fc4a2c$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $da298c0570fc4a2c$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$da298c0570fc4a2c$var$_getIngestEndpoint(dsn)}?${$da298c0570fc4a2c$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $da298c0570fc4a2c$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $0aaaa6c30c5fe7e9$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$da298c0570fc4a2c$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $0aaaa6c30c5fe7e9$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}


var $3WK1v = parcelRequire("3WK1v");

var $6Iopj = parcelRequire("6Iopj");
var $8FmHF = parcelRequire("8FmHF");

var $7htw4 = parcelRequire("7htw4");

var $6HS3j = parcelRequire("6HS3j");
// eslint-disable-next-line deprecation/deprecation
const $66e623382a10017c$var$WINDOW = (0, $6HS3j.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $66e623382a10017c$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $66e623382a10017c$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $66e623382a10017c$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $66e623382a10017c$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $66e623382a10017c$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $66e623382a10017c$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $66e623382a10017c$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$66e623382a10017c$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($66e623382a10017c$export$18cf36ed71d733e7($66e623382a10017c$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $66e623382a10017c$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $66e623382a10017c$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $8FmHF.DEBUG_BUILD) && (0, $7htw4.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $66e623382a10017c$export$531055a6c684a70a() {
    return 'ReportingObserver' in $66e623382a10017c$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $66e623382a10017c$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$66e623382a10017c$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}


var $7htw4 = parcelRequire("7htw4");
var $bP4Y8 = parcelRequire("bP4Y8");



var $6HS3j = parcelRequire("6HS3j");

var $6HS3j = parcelRequire("6HS3j");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $ff8778bf2763efe5$var$WINDOW = (0, $6HS3j.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $ff8778bf2763efe5$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $ff8778bf2763efe5$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = 'history' in $ff8778bf2763efe5$var$WINDOW && !!$ff8778bf2763efe5$var$WINDOW.history.pushState && !!$ff8778bf2763efe5$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



var $l5g2K = parcelRequire("l5g2K");
const $3d019c6a05cabdc5$var$WINDOW = (0, $6HS3j.GLOBAL_OBJ);
let $3d019c6a05cabdc5$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $3d019c6a05cabdc5$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $l5g2K.addHandler)(type, handler);
    (0, $l5g2K.maybeInstrument)(type, $3d019c6a05cabdc5$var$instrumentHistory);
}
function $3d019c6a05cabdc5$var$instrumentHistory() {
    if (!(0, $ff8778bf2763efe5$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $3d019c6a05cabdc5$var$WINDOW.onpopstate;
    $3d019c6a05cabdc5$var$WINDOW.onpopstate = function(...args) {
        const to = $3d019c6a05cabdc5$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $3d019c6a05cabdc5$var$lastHref;
        $3d019c6a05cabdc5$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $l5g2K.triggerHandlers)('history', handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $3d019c6a05cabdc5$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $3d019c6a05cabdc5$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $l5g2K.triggerHandlers)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $bP4Y8.fill)($3d019c6a05cabdc5$var$WINDOW.history, 'pushState', historyReplacementFunction);
    (0, $bP4Y8.fill)($3d019c6a05cabdc5$var$WINDOW.history, 'replaceState', historyReplacementFunction);
}



var $bxlWE = parcelRequire("bxlWE");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $5a854423af031358$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $bxlWE.SDK_VERSION)
            })),
        version: (0, $bxlWE.SDK_VERSION)
    };
    options._metadata = metadata;
}


var $7htw4 = parcelRequire("7htw4");
var $HgoiY = parcelRequire("HgoiY");
var $5QZE4 = parcelRequire("5QZE4");
var $i7ar8 = parcelRequire("i7ar8");

var $jn5uz = parcelRequire("jn5uz");

var $bP4Y8 = parcelRequire("bP4Y8");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $e49341fc8a37f226$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $e49341fc8a37f226$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $e49341fc8a37f226$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $e49341fc8a37f226$export$604a45d95a155e2b(envelope, types) {
    return $e49341fc8a37f226$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $e49341fc8a37f226$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $e49341fc8a37f226$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $e49341fc8a37f226$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === 'string' ? $e49341fc8a37f226$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $jn5uz.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $e49341fc8a37f226$var$concatBuffers(parts);
}
function $e49341fc8a37f226$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $e49341fc8a37f226$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $e49341fc8a37f226$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === 'string' ? $e49341fc8a37f226$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $bP4Y8.dropUndefinedKeys)({
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $e49341fc8a37f226$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    statsd: 'metric_bucket'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $e49341fc8a37f226$export$b11169581eeaf237(type) {
    return $e49341fc8a37f226$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $e49341fc8a37f226$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $e49341fc8a37f226$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $0aaaa6c30c5fe7e9$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $bP4Y8.dropUndefinedKeys)({
                ...dynamicSamplingContext
            })
        }
    };
}

/** An error emitted by Sentry SDKs and related utilities. */ class $c6fd45cff0488a2d$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = 'warn'){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}




var $cEq52 = parcelRequire("cEq52");

/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $ed6d689869770b05$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $ed6d689869770b05$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $e49341fc8a37f226$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $0aaaa6c30c5fe7e9$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $e49341fc8a37f226$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $ed6d689869770b05$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $e49341fc8a37f226$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $ed6d689869770b05$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $e49341fc8a37f226$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $e49341fc8a37f226$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}



var $3WK1v = parcelRequire("3WK1v");

var $gUaXH = parcelRequire("gUaXH");



var $bP4Y8 = parcelRequire("bP4Y8");
/**
 * Generate bucket key from metric properties.
 */ function $37de77f77bb4f32a$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $bP4Y8.dropUndefinedKeys)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $37de77f77bb4f32a$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $37de77f77bb4f32a$export$66decd709db01dc8(metricBucketItems) {
    let out = '';
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(',')}` : '';
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function $37de77f77bb4f32a$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, '_');
}
/** Sanitizes metric keys */ function $37de77f77bb4f32a$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, '_');
}
function $37de77f77bb4f32a$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, '');
}
const $37de77f77bb4f32a$var$tagValueReplacements = [
    [
        '\n',
        '\\n'
    ],
    [
        '\r',
        '\\r'
    ],
    [
        '\t',
        '\\t'
    ],
    [
        '\\',
        '\\\\'
    ],
    [
        '|',
        "\\u{7c}"
    ],
    [
        ',',
        "\\u{2c}"
    ]
];
function $37de77f77bb4f32a$var$getCharOrReplacement(input) {
    for (const [search, replacement] of $37de77f77bb4f32a$var$tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function $37de77f77bb4f32a$var$sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + $37de77f77bb4f32a$var$getCharOrReplacement(char), '');
}
/**
 * Sanitizes tags.
 */ function $37de77f77bb4f32a$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = $37de77f77bb4f32a$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $37de77f77bb4f32a$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}


/**
 * Create envelope from a metric aggregate.
 */ function $c01a5628f602ed21$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $0aaaa6c30c5fe7e9$export$44d472fbb931a776)(dsn);
    const item = $c01a5628f602ed21$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $e49341fc8a37f226$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $c01a5628f602ed21$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $37de77f77bb4f32a$export$66decd709db01dc8)(metricBucketItems);
    const metricHeaders = {
        type: 'statsd',
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}



var $8ZYx3 = parcelRequire("8ZYx3");

var $iJP5v = parcelRequire("iJP5v");

var $gBF6M = parcelRequire("gBF6M");
const $640fc7d84f5323a0$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $640fc7d84f5323a0$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $0aaaa6c30c5fe7e9$export$128827c3562ec0cb)(options.dsn);
        else (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $da298c0570fc4a2c$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $HgoiY.checkOrSetAlreadyCaught)(exception)) {
            (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).log($640fc7d84f5323a0$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $5QZE4.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $5QZE4.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $HgoiY.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).log($640fc7d84f5323a0$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === 'string')) (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).warn('Discarded session because of missing or non-string release');
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $8ZYx3.updateSession)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $i7ar8.resolvedSyncPromise)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $73f29a8c00de1619$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $73f29a8c00de1619$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $ed6d689869770b05$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $e49341fc8a37f226$export$d650323442802f6f)(env, (0, $e49341fc8a37f226$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $ed6d689869770b05$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === 'number' ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $c01a5628f602ed21$export$f23eb96e33154901)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $73f29a8c00de1619$export$51abed9797baa598)(this, integrations);
        (0, $73f29a8c00de1619$export$35abcfd71227c6ca)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $8ZYx3.updateSession)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $i7ar8.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $gUaXH.getIsolationScope)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        return (0, $gBF6M.prepareEvent)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $iJP5v.getDynamicSamplingContextFromClient)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $cEq52.DEBUG_BUILD) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === 'log') (0, $7htw4.logger).log(sentryError.message);
                else (0, $7htw4.logger).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $640fc7d84f5323a0$var$isTransactionEvent(event);
        const isError = $640fc7d84f5323a0$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            this.recordDroppedEvent('sample_rate', 'error', event);
            return (0, $i7ar8.rejectedSyncPromise)(new (0, $c6fd45cff0488a2d$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, 'log'));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory, event);
                throw new (0, $c6fd45cff0488a2d$export$5949942ba2a7c0e2)('An event processor returned `null`, will not send event.', 'log');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $640fc7d84f5323a0$var$processBeforeSend(options, prepared, hint);
            return $640fc7d84f5323a0$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw new (0, $c6fd45cff0488a2d$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $c6fd45cff0488a2d$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $c6fd45cff0488a2d$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).error('Error while sending event:', reason);
        });
        else (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).error('Transport disabled');
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $640fc7d84f5323a0$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $5QZE4.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $5QZE4.isPlainObject)(event) && event !== null) throw new (0, $c6fd45cff0488a2d$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $c6fd45cff0488a2d$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $5QZE4.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, $c6fd45cff0488a2d$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $640fc7d84f5323a0$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($640fc7d84f5323a0$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($640fc7d84f5323a0$var$isTransactionEvent(event) && beforeSendTransaction) {
        if (event.spans) {
            // We store the # of spans before processing in SDK metadata,
            // so we can compare it afterwards to determine how many spans were dropped
            const spanCountBefore = event.spans.length;
            event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                spanCountBeforeProcessing: spanCountBefore
            };
        }
        return beforeSendTransaction(event, hint);
    }
    return event;
}
function $640fc7d84f5323a0$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $640fc7d84f5323a0$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $640fc7d84f5323a0$export$9aac0b9f77928fbf(callback) {
    const client = (0, $3WK1v.getClient)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}



var $7eDcu = parcelRequire("7eDcu");
var $7htw4 = parcelRequire("7htw4");

var $cQg0t = parcelRequire("cQg0t");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $6aa03ff1f717d06a$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $cQg0t.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $e49341fc8a37f226$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $01ed1ffdc00026d9$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



var $3WK1v = parcelRequire("3WK1v");

var $5QZE4 = parcelRequire("5QZE4");
var $jn5uz = parcelRequire("jn5uz");
var $HgoiY = parcelRequire("HgoiY");
var $i7ar8 = parcelRequire("i7ar8");
var $bP4Y8 = parcelRequire("bP4Y8");
/**
 * This function creates an exception from a JavaScript Error
 */ function $36956b5a37b0d668$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $36956b5a37b0d668$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $36956b5a37b0d668$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
/**
 * @hidden
 */ function $36956b5a37b0d668$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $3WK1v.getClient)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $5QZE4.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $36956b5a37b0d668$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $jn5uz.normalizeToSize)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $36956b5a37b0d668$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $36956b5a37b0d668$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $36956b5a37b0d668$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $36956b5a37b0d668$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const popSize = $36956b5a37b0d668$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $36956b5a37b0d668$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $36956b5a37b0d668$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($36956b5a37b0d668$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $36956b5a37b0d668$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $36956b5a37b0d668$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $36956b5a37b0d668$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $HgoiY.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $i7ar8.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $36956b5a37b0d668$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $36956b5a37b0d668$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $i7ar8.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $36956b5a37b0d668$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $5QZE4.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $36956b5a37b0d668$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $5QZE4.isDOMError)(exception) || (0, $5QZE4.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $36956b5a37b0d668$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $5QZE4.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $36956b5a37b0d668$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $HgoiY.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $5QZE4.isError)(exception)) // we have a real Error object, do nothing
    return $36956b5a37b0d668$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $5QZE4.isPlainObject)(exception) || (0, $5QZE4.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $36956b5a37b0d668$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $HgoiY.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $36956b5a37b0d668$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $HgoiY.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $HgoiY.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $36956b5a37b0d668$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $36956b5a37b0d668$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $5QZE4.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $36956b5a37b0d668$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $bP4Y8.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $5QZE4.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $5QZE4.isEvent)(exception)) {
        const className = $36956b5a37b0d668$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $36956b5a37b0d668$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}




var $3WK1v = parcelRequire("3WK1v");

var $6HS3j = parcelRequire("6HS3j");
var $bP4Y8 = parcelRequire("bP4Y8");
var $HgoiY = parcelRequire("HgoiY");
const $b69ee834d2d8bdf6$export$56d8a8a25bd48b81 = (0, $6HS3j.GLOBAL_OBJ);
let $b69ee834d2d8bdf6$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $b69ee834d2d8bdf6$export$b79738ab10c590b2() {
    return $b69ee834d2d8bdf6$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $b69ee834d2d8bdf6$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $b69ee834d2d8bdf6$var$ignoreOnError++;
    setTimeout(()=>{
        $b69ee834d2d8bdf6$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $b69ee834d2d8bdf6$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $bP4Y8.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$b69ee834d2d8bdf6$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $b69ee834d2d8bdf6$export$1265a142ff5ba165();
            (0, $3WK1v.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $HgoiY.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $HgoiY.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $3WK1v.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $bP4Y8.markFunctionWrapped)(sentryWrapped, fn);
    (0, $bP4Y8.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



/**
 * Creates an envelope from a user feedback.
 */ function $23d98c5976bbbe60$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $0aaaa6c30c5fe7e9$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $23d98c5976bbbe60$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $e49341fc8a37f226$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $23d98c5976bbbe60$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $7b33da84303847bc$export$1df9218a526d318d extends (0, $640fc7d84f5323a0$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $7eDcu.getSDKSource)();
        (0, $5a854423af031358$export$b9f95b027256052c)(options, 'browser', [
            'browser'
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).document) (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $36956b5a37b0d668$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = 'info', hint) {
        return (0, $36956b5a37b0d668$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $01ed1ffdc00026d9$export$16a28057038b10ef) && (0, $7htw4.logger).warn('SDK not enabled, will not capture user feedback.');
            return;
        }
        const envelope = (0, $23d98c5976bbbe60$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $01ed1ffdc00026d9$export$16a28057038b10ef) && (0, $7htw4.logger).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $01ed1ffdc00026d9$export$16a28057038b10ef) && (0, $7htw4.logger).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $01ed1ffdc00026d9$export$16a28057038b10ef) && (0, $7htw4.logger).log('Sending outcomes:', outcomes);
        const envelope = (0, $6aa03ff1f717d06a$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $0aaaa6c30c5fe7e9$export$44d472fbb931a776)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}





var $3WK1v = parcelRequire("3WK1v");

var $7htw4 = parcelRequire("7htw4");

var $bP4Y8 = parcelRequire("bP4Y8");

var $6HS3j = parcelRequire("6HS3j");

var $l5g2K = parcelRequire("l5g2K");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $f7aa85832e3a3d95$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $l5g2K.addHandler)(type, handler);
    (0, $l5g2K.maybeInstrument)(type, $f7aa85832e3a3d95$var$instrumentConsole);
}
function $f7aa85832e3a3d95$var$instrumentConsole() {
    if (!('console' in (0, $6HS3j.GLOBAL_OBJ))) return;
    (0, $7htw4.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $6HS3j.GLOBAL_OBJ).console)) return;
        (0, $bP4Y8.fill)((0, $6HS3j.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $7htw4.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $l5g2K.triggerHandlers)('console', handlerData);
                const log = (0, $7htw4.originalConsoleMethods)[level];
                log && log.apply((0, $6HS3j.GLOBAL_OBJ).console, args);
            };
        });
    });
}


var $HgoiY = parcelRequire("HgoiY");

var $bP4Y8 = parcelRequire("bP4Y8");

var $6HS3j = parcelRequire("6HS3j");

var $l5g2K = parcelRequire("l5g2K");
const $5ebfc0024cb31bca$var$WINDOW = (0, $6HS3j.GLOBAL_OBJ);
const $5ebfc0024cb31bca$var$DEBOUNCE_DURATION = 1000;
let $5ebfc0024cb31bca$var$debounceTimerID;
let $5ebfc0024cb31bca$var$lastCapturedEventType;
let $5ebfc0024cb31bca$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $5ebfc0024cb31bca$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $l5g2K.addHandler)(type, handler);
    (0, $l5g2K.maybeInstrument)(type, $5ebfc0024cb31bca$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $5ebfc0024cb31bca$export$3014bbf0af0e1d4a() {
    if (!$5ebfc0024cb31bca$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $l5g2K.triggerHandlers).bind(null, 'dom');
    const globalDOMEventHandler = $5ebfc0024cb31bca$var$makeDOMEventHandler(triggerDOMHandler, true);
    $5ebfc0024cb31bca$var$WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
    $5ebfc0024cb31bca$var$WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $5ebfc0024cb31bca$var$WINDOW[target] && $5ebfc0024cb31bca$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $bP4Y8.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $5ebfc0024cb31bca$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $bP4Y8.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $5ebfc0024cb31bca$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $5ebfc0024cb31bca$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $5ebfc0024cb31bca$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $5ebfc0024cb31bca$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $5ebfc0024cb31bca$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $5ebfc0024cb31bca$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($5ebfc0024cb31bca$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $bP4Y8.addNonEnumerableProperty)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $bP4Y8.addNonEnumerableProperty)(target, '_sentryId', (0, $HgoiY.uuid4)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$5ebfc0024cb31bca$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $5ebfc0024cb31bca$var$lastCapturedEventType = event.type;
            $5ebfc0024cb31bca$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($5ebfc0024cb31bca$var$debounceTimerID);
        $5ebfc0024cb31bca$var$debounceTimerID = $5ebfc0024cb31bca$var$WINDOW.setTimeout(()=>{
            $5ebfc0024cb31bca$var$lastCapturedEventTargetId = undefined;
            $5ebfc0024cb31bca$var$lastCapturedEventType = undefined;
        }, $5ebfc0024cb31bca$var$DEBOUNCE_DURATION);
    };
}
function $5ebfc0024cb31bca$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}


var $5QZE4 = parcelRequire("5QZE4");

var $bP4Y8 = parcelRequire("bP4Y8");

var $6HS3j = parcelRequire("6HS3j");

var $l5g2K = parcelRequire("l5g2K");
const $bc641309b3f67a9f$var$WINDOW = (0, $6HS3j.GLOBAL_OBJ);
const $bc641309b3f67a9f$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $bc641309b3f67a9f$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $l5g2K.addHandler)(type, handler);
    (0, $l5g2K.maybeInstrument)(type, $bc641309b3f67a9f$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $bc641309b3f67a9f$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$bc641309b3f67a9f$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $bP4Y8.fill)(xhrproto, 'open', function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $5QZE4.isString)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $bc641309b3f67a9f$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$bc641309b3f67a9f$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$bc641309b3f67a9f$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $l5g2K.triggerHandlers)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') (0, $bP4Y8.fill)(this, 'onreadystatechange', function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $bP4Y8.fill)(this, 'setRequestHeader', function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$bc641309b3f67a9f$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $5QZE4.isString)(header) && (0, $5QZE4.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $bP4Y8.fill)(xhrproto, 'send', function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$bc641309b3f67a9f$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $l5g2K.triggerHandlers)('xhr', handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $bc641309b3f67a9f$var$parseUrl(url) {
    if ((0, $5QZE4.isString)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}


var $bP4Y8 = parcelRequire("bP4Y8");


var $6HS3j = parcelRequire("6HS3j");

var $l5g2K = parcelRequire("l5g2K");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $f72b9d1319ab84b6$export$f75d3c772c923df0(handler) {
    const type = 'fetch';
    (0, $l5g2K.addHandler)(type, handler);
    (0, $l5g2K.maybeInstrument)(type, $f72b9d1319ab84b6$var$instrumentFetch);
}
function $f72b9d1319ab84b6$var$instrumentFetch() {
    if (!(0, $66e623382a10017c$export$c82d238e23c40b21)()) return;
    (0, $bP4Y8.fill)((0, $6HS3j.GLOBAL_OBJ), 'fetch', function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $f72b9d1319ab84b6$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $l5g2K.triggerHandlers)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $6HS3j.GLOBAL_OBJ), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $l5g2K.triggerHandlers)('fetch', finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $l5g2K.triggerHandlers)('fetch', erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $f72b9d1319ab84b6$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $f72b9d1319ab84b6$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($f72b9d1319ab84b6$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $f72b9d1319ab84b6$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $f72b9d1319ab84b6$var$getUrlFromResource(url),
            method: $f72b9d1319ab84b6$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $f72b9d1319ab84b6$var$getUrlFromResource(arg),
        method: $f72b9d1319ab84b6$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}


var $HgoiY = parcelRequire("HgoiY");
var $7htw4 = parcelRequire("7htw4");
var $eAaWR = parcelRequire("eAaWR");// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $c5b6d9b7617d0f9a$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $c5b6d9b7617d0f9a$export$e01cef29b4327697(level) {
    return $c5b6d9b7617d0f9a$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $c5b6d9b7617d0f9a$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : $c5b6d9b7617d0f9a$export$411d0ffdba845b6c.includes(level) ? level : 'log';
}


var $jP2vU = parcelRequire("jP2vU");/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $7da207ca9fea49e7$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $7da207ca9fea49e7$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $7da207ca9fea49e7$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $7da207ca9fea49e7$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $355f8d9981d566ef$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $355f8d9981d566ef$var$INTEGRATION_NAME = 'Breadcrumbs';
const $355f8d9981d566ef$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $355f8d9981d566ef$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $f7aa85832e3a3d95$export$1d6e0d073f9e6723)($355f8d9981d566ef$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $5ebfc0024cb31bca$export$5aeffd3db2cf9df7)($355f8d9981d566ef$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $bc641309b3f67a9f$export$26ace48dd54c9aea)($355f8d9981d566ef$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $f72b9d1319ab84b6$export$f75d3c772c923df0)($355f8d9981d566ef$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $3d019c6a05cabdc5$export$3f18c56c58114e75)($355f8d9981d566ef$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on('beforeSendEvent', $355f8d9981d566ef$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $355f8d9981d566ef$export$c079d904b326663a = (0, $73f29a8c00de1619$export$2323046b9414659f)($355f8d9981d566ef$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $355f8d9981d566ef$export$2dc68d50d56fbbd = (0, $73f29a8c00de1619$export$afa219bf23651160)($355f8d9981d566ef$var$INTEGRATION_NAME, $355f8d9981d566ef$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $355f8d9981d566ef$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $3WK1v.getClient)() !== client) return;
        (0, $3WK1v.addBreadcrumb)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $HgoiY.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $355f8d9981d566ef$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $3WK1v.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $355f8d9981d566ef$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $01ed1ffdc00026d9$export$16a28057038b10ef) && (0, $7htw4.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$355f8d9981d566ef$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$355f8d9981d566ef$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $355f8d9981d566ef$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $355f8d9981d566ef$var$_isEvent(event) ? event.target : event;
            target = (0, $eAaWR.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $eAaWR.getComponentName)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $3WK1v.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $355f8d9981d566ef$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $3WK1v.getClient)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $c5b6d9b7617d0f9a$export$d771ef054122c30a)(handlerData.level),
            message: (0, $jP2vU.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $jP2vU.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $3WK1v.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $355f8d9981d566ef$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $3WK1v.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $bc641309b3f67a9f$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $3WK1v.addBreadcrumb)({
            category: 'xhr',
            data: data,
            type: 'http'
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $355f8d9981d566ef$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $3WK1v.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $3WK1v.addBreadcrumb)({
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $3WK1v.addBreadcrumb)({
                category: 'fetch',
                data: data,
                type: 'http'
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $355f8d9981d566ef$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $3WK1v.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $7da207ca9fea49e7$export$7a5253c0f62e0150)((0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $7da207ca9fea49e7$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $7da207ca9fea49e7$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $3WK1v.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $355f8d9981d566ef$var$_isEvent(event) {
    return !!event && !!event.target;
}




var $7htw4 = parcelRequire("7htw4");

const $64a102a9031d7a8b$var$INTEGRATION_NAME = 'Dedupe';
const $64a102a9031d7a8b$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $64a102a9031d7a8b$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($64a102a9031d7a8b$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $01ed1ffdc00026d9$export$16a28057038b10ef) && (0, $7htw4.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $64a102a9031d7a8b$export$6d39aa44cd0c7567 = (0, $73f29a8c00de1619$export$2323046b9414659f)($64a102a9031d7a8b$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $64a102a9031d7a8b$export$688d98c249d31ad3 = (0, $73f29a8c00de1619$export$afa219bf23651160)($64a102a9031d7a8b$var$INTEGRATION_NAME, $64a102a9031d7a8b$export$6d39aa44cd0c7567);
function $64a102a9031d7a8b$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($64a102a9031d7a8b$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($64a102a9031d7a8b$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $64a102a9031d7a8b$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$64a102a9031d7a8b$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$64a102a9031d7a8b$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $64a102a9031d7a8b$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $64a102a9031d7a8b$var$_getExceptionFromEvent(previousEvent);
    const currentException = $64a102a9031d7a8b$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$64a102a9031d7a8b$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$64a102a9031d7a8b$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $64a102a9031d7a8b$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $64a102a9031d7a8b$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $64a102a9031d7a8b$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $64a102a9031d7a8b$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $64a102a9031d7a8b$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $64a102a9031d7a8b$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}



var $3WK1v = parcelRequire("3WK1v");

var $fsa46 = parcelRequire("fsa46");
var $5QZE4 = parcelRequire("5QZE4");
var $5bX8i = parcelRequire("5bX8i");
var $eAaWR = parcelRequire("eAaWR");
var $7htw4 = parcelRequire("7htw4");



/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $ed3134e690fd7f16$var$INTEGRATION_NAME = 'GlobalHandlers';
const $ed3134e690fd7f16$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $ed3134e690fd7f16$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $ed3134e690fd7f16$var$_installGlobalOnErrorHandler(client);
                $ed3134e690fd7f16$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $ed3134e690fd7f16$var$_installGlobalOnUnhandledRejectionHandler(client);
                $ed3134e690fd7f16$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $ed3134e690fd7f16$export$66acc70e8cf2b71a = (0, $73f29a8c00de1619$export$2323046b9414659f)($ed3134e690fd7f16$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $ed3134e690fd7f16$export$204155decbc90e5a = (0, $73f29a8c00de1619$export$afa219bf23651160)($ed3134e690fd7f16$var$INTEGRATION_NAME, $ed3134e690fd7f16$export$66acc70e8cf2b71a);
function $ed3134e690fd7f16$var$_installGlobalOnErrorHandler(client) {
    (0, $fsa46.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $ed3134e690fd7f16$var$getOptions();
        if ((0, $3WK1v.getClient)() !== client || (0, $b69ee834d2d8bdf6$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $5QZE4.isString)(msg) ? $ed3134e690fd7f16$var$_eventFromIncompleteOnError(msg, url, line, column) : $ed3134e690fd7f16$var$_enhanceEventWithInitialFrame((0, $36956b5a37b0d668$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $3WK1v.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $ed3134e690fd7f16$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $5bX8i.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $ed3134e690fd7f16$var$getOptions();
        if ((0, $3WK1v.getClient)() !== client || (0, $b69ee834d2d8bdf6$export$b79738ab10c590b2)()) return;
        const error = $ed3134e690fd7f16$var$_getUnhandledRejectionError(e);
        const event = (0, $5QZE4.isPrimitive)(error) ? $ed3134e690fd7f16$var$_eventFromRejectionWithPrimitive(error) : (0, $36956b5a37b0d668$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $3WK1v.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $ed3134e690fd7f16$var$_getUnhandledRejectionError(error) {
    if ((0, $5QZE4.isPrimitive)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) return e.reason;
        else if ('detail' in e && 'reason' in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $ed3134e690fd7f16$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ed3134e690fd7f16$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $5QZE4.isErrorEvent)(msg) ? msg.message : msg;
    let name = 'Error';
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $ed3134e690fd7f16$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ed3134e690fd7f16$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $5QZE4.isString)(url) && url.length > 0 ? url : (0, $eAaWR.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $ed3134e690fd7f16$var$globalHandlerLog(type) {
    (0, $01ed1ffdc00026d9$export$16a28057038b10ef) && (0, $7htw4.logger).log(`Global Handler attached: ${type}`);
}
function $ed3134e690fd7f16$var$getOptions() {
    const client = (0, $3WK1v.getClient)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




const $2dac98dc53011638$var$INTEGRATION_NAME = 'HttpContext';
const $2dac98dc53011638$var$_httpContextIntegration = ()=>{
    return {
        name: $2dac98dc53011638$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).navigator && !(0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).location && !(0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).location && (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $2dac98dc53011638$export$1378794447170364 = (0, $73f29a8c00de1619$export$2323046b9414659f)($2dac98dc53011638$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $2dac98dc53011638$export$5d2ee9a544b09a94 = (0, $73f29a8c00de1619$export$afa219bf23651160)($2dac98dc53011638$var$INTEGRATION_NAME, $2dac98dc53011638$export$1378794447170364);




var $5QZE4 = parcelRequire("5QZE4");

var $jP2vU = parcelRequire("jP2vU");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $bd661dbf8877f50f$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $5QZE4.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $bd661dbf8877f50f$var$truncateAggregateExceptions($bd661dbf8877f50f$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $bd661dbf8877f50f$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $5QZE4.isInstanceOf)(error[key], Error)) {
        $bd661dbf8877f50f$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $bd661dbf8877f50f$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $bd661dbf8877f50f$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $5QZE4.isInstanceOf)(childError, Error)) {
            $bd661dbf8877f50f$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $bd661dbf8877f50f$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $bd661dbf8877f50f$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $bd661dbf8877f50f$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $bd661dbf8877f50f$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $bd661dbf8877f50f$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $jP2vU.truncate)(exception.value, maxValueLength);
        return exception;
    });
}



const $06bb7854fa0f7190$var$DEFAULT_KEY = 'cause';
const $06bb7854fa0f7190$var$DEFAULT_LIMIT = 5;
const $06bb7854fa0f7190$var$INTEGRATION_NAME = 'LinkedErrors';
const $06bb7854fa0f7190$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $06bb7854fa0f7190$var$DEFAULT_LIMIT;
    const key = options.key || $06bb7854fa0f7190$var$DEFAULT_KEY;
    return {
        name: $06bb7854fa0f7190$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $bd661dbf8877f50f$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $36956b5a37b0d668$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $06bb7854fa0f7190$export$ebabb00eb7f3a395 = (0, $73f29a8c00de1619$export$2323046b9414659f)($06bb7854fa0f7190$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $06bb7854fa0f7190$export$8d1e60aaf616fb4f = (0, $73f29a8c00de1619$export$afa219bf23651160)($06bb7854fa0f7190$var$INTEGRATION_NAME, $06bb7854fa0f7190$export$ebabb00eb7f3a395);




var $bP4Y8 = parcelRequire("bP4Y8");
var $6Iopj = parcelRequire("6Iopj");

const $82c2736be09e13bf$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $82c2736be09e13bf$var$INTEGRATION_NAME = 'TryCatch';
const $82c2736be09e13bf$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $82c2736be09e13bf$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $bP4Y8.fill)((0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81), 'setTimeout', $82c2736be09e13bf$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $bP4Y8.fill)((0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81), 'setInterval', $82c2736be09e13bf$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $bP4Y8.fill)((0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81), 'requestAnimationFrame', $82c2736be09e13bf$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81)) (0, $bP4Y8.fill)(XMLHttpRequest.prototype, 'send', $82c2736be09e13bf$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $82c2736be09e13bf$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($82c2736be09e13bf$var$_wrapEventTarget);
            }
        }
    };
};
const $82c2736be09e13bf$export$59bfe9f1c76150e = (0, $73f29a8c00de1619$export$2323046b9414659f)($82c2736be09e13bf$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $82c2736be09e13bf$export$f1a018517668e6d3 = (0, $73f29a8c00de1619$export$afa219bf23651160)($82c2736be09e13bf$var$INTEGRATION_NAME, $82c2736be09e13bf$export$59bfe9f1c76150e);
function $82c2736be09e13bf$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $b69ee834d2d8bdf6$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $6Iopj.getFunctionName)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $82c2736be09e13bf$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $b69ee834d2d8bdf6$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $6Iopj.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $82c2736be09e13bf$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $bP4Y8.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $6Iopj.getFunctionName)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $bP4Y8.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $6Iopj.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $b69ee834d2d8bdf6$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $82c2736be09e13bf$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $bP4Y8.fill)(proto, 'addEventListener', function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $b69ee834d2d8bdf6$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $6Iopj.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $b69ee834d2d8bdf6$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $6Iopj.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $bP4Y8.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}



var $6Iopj = parcelRequire("6Iopj");
// global reference to slice
const $8b14e65fd7f0660b$var$UNKNOWN_FUNCTION = '?';
const $8b14e65fd7f0660b$var$OPERA10_PRIORITY = 10;
const $8b14e65fd7f0660b$var$OPERA11_PRIORITY = 20;
const $8b14e65fd7f0660b$var$CHROME_PRIORITY = 30;
const $8b14e65fd7f0660b$var$WINJS_PRIORITY = 40;
const $8b14e65fd7f0660b$var$GECKO_PRIORITY = 50;
function $8b14e65fd7f0660b$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $8b14e65fd7f0660b$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $8b14e65fd7f0660b$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $8b14e65fd7f0660b$var$chromeStackParserFn = (line)=>{
    const parts = $8b14e65fd7f0660b$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $8b14e65fd7f0660b$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $8b14e65fd7f0660b$var$extractSafariExtensionDetails(parts[1] || $8b14e65fd7f0660b$var$UNKNOWN_FUNCTION, parts[2]);
        return $8b14e65fd7f0660b$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $8b14e65fd7f0660b$export$263a749fff749872 = [
    $8b14e65fd7f0660b$var$CHROME_PRIORITY,
    $8b14e65fd7f0660b$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $8b14e65fd7f0660b$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $8b14e65fd7f0660b$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $8b14e65fd7f0660b$var$gecko = (line)=>{
    const parts = $8b14e65fd7f0660b$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $8b14e65fd7f0660b$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $8b14e65fd7f0660b$var$UNKNOWN_FUNCTION;
        [func, filename] = $8b14e65fd7f0660b$var$extractSafariExtensionDetails(func, filename);
        return $8b14e65fd7f0660b$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $8b14e65fd7f0660b$export$cdba47a5dd2804d = [
    $8b14e65fd7f0660b$var$GECKO_PRIORITY,
    $8b14e65fd7f0660b$var$gecko
];
const $8b14e65fd7f0660b$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $8b14e65fd7f0660b$var$winjs = (line)=>{
    const parts = $8b14e65fd7f0660b$var$winjsRegex.exec(line);
    return parts ? $8b14e65fd7f0660b$var$createFrame(parts[2], parts[1] || $8b14e65fd7f0660b$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $8b14e65fd7f0660b$export$179460296da408e8 = [
    $8b14e65fd7f0660b$var$WINJS_PRIORITY,
    $8b14e65fd7f0660b$var$winjs
];
const $8b14e65fd7f0660b$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $8b14e65fd7f0660b$var$opera10 = (line)=>{
    const parts = $8b14e65fd7f0660b$var$opera10Regex.exec(line);
    return parts ? $8b14e65fd7f0660b$var$createFrame(parts[2], parts[3] || $8b14e65fd7f0660b$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $8b14e65fd7f0660b$export$f892b52c880ffc7a = [
    $8b14e65fd7f0660b$var$OPERA10_PRIORITY,
    $8b14e65fd7f0660b$var$opera10
];
const $8b14e65fd7f0660b$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $8b14e65fd7f0660b$var$opera11 = (line)=>{
    const parts = $8b14e65fd7f0660b$var$opera11Regex.exec(line);
    return parts ? $8b14e65fd7f0660b$var$createFrame(parts[5], parts[3] || parts[4] || $8b14e65fd7f0660b$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $8b14e65fd7f0660b$export$af11af13f09fb0dc = [
    $8b14e65fd7f0660b$var$OPERA11_PRIORITY,
    $8b14e65fd7f0660b$var$opera11
];
const $8b14e65fd7f0660b$export$7197c0fe6554c079 = [
    $8b14e65fd7f0660b$export$263a749fff749872,
    $8b14e65fd7f0660b$export$cdba47a5dd2804d,
    $8b14e65fd7f0660b$export$179460296da408e8
];
const $8b14e65fd7f0660b$export$2b2b997d81bf3907 = (0, $6Iopj.createStackParser)(...$8b14e65fd7f0660b$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $8b14e65fd7f0660b$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $8b14e65fd7f0660b$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};




var $i7ar8 = parcelRequire("i7ar8");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $89d0dcf1088279a8$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $i7ar8.rejectedSyncPromise)(new (0, $c6fd45cff0488a2d$export$5949942ba2a7c0e2)('Not adding Promise because buffer limit was reached.'));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $i7ar8.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $i7ar8.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $d8edbed396e0ce87$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $d8edbed396e0ce87$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $d8edbed396e0ce87$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $d8edbed396e0ce87$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $d8edbed396e0ce87$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $d8edbed396e0ce87$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $d8edbed396e0ce87$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers && headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $d8edbed396e0ce87$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}


var $i7ar8 = parcelRequire("i7ar8");
var $7htw4 = parcelRequire("7htw4");

var $cEq52 = parcelRequire("cEq52");
const $e5443b9a37f1db5b$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $e5443b9a37f1db5b$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $89d0dcf1088279a8$export$85a4f67f852183e6)(options.bufferSize || $e5443b9a37f1db5b$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $e49341fc8a37f226$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $e49341fc8a37f226$export$b11169581eeaf237)(type);
            if ((0, $d8edbed396e0ce87$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $e5443b9a37f1db5b$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $i7ar8.resolvedSyncPromise)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $e49341fc8a37f226$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $e49341fc8a37f226$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $e5443b9a37f1db5b$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $e49341fc8a37f226$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $e49341fc8a37f226$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $d8edbed396e0ce87$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $c6fd45cff0488a2d$export$5949942ba2a7c0e2)) {
                (0, $cEq52.DEBUG_BUILD) && (0, $7htw4.logger).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $i7ar8.resolvedSyncPromise)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $e5443b9a37f1db5b$var$getEventForEnvelopeItem(item, type) {
    if (type !== 'event' && type !== 'transaction') return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}



var $i7ar8 = parcelRequire("i7ar8");

var $7htw4 = parcelRequire("7htw4");


let $89ea36f69881f583$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $89ea36f69881f583$export$8be2119ce08e3379() {
    if ($89ea36f69881f583$var$cachedFetchImpl) return $89ea36f69881f583$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $66e623382a10017c$export$18cf36ed71d733e7)((0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).fetch)) return $89ea36f69881f583$var$cachedFetchImpl = (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).fetch.bind((0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81));
    const document = (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $01ed1ffdc00026d9$export$16a28057038b10ef) && (0, $7htw4.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $89ea36f69881f583$var$cachedFetchImpl = fetchImpl.bind((0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $89ea36f69881f583$export$d499686d2dd738c6() {
    $89ea36f69881f583$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $99d026d71c642708$export$b2311068c46d7cc8(options, nativeFetch = (0, $89ea36f69881f583$export$8be2119ce08e3379)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $89ea36f69881f583$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $i7ar8.rejectedSyncPromise)(e);
        }
    }
    return (0, $e5443b9a37f1db5b$export$d09f50d9ab7f7b69)(options, makeRequest);
}




var $i7ar8 = parcelRequire("i7ar8");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $ca2901e77e0aacab$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $ca2901e77e0aacab$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $i7ar8.SyncPromise)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $ca2901e77e0aacab$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                        'retry-after': xhr.getResponseHeader('Retry-After')
                    }
                });
            };
            xhr.open('POST', options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $e5443b9a37f1db5b$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $3892e5b7960d5b8e$export$5ef831fccfce35e5 = [
    (0, $7074340826553a9d$export$cb3c5c2ceb9818ba)(),
    (0, $009f5c88bbd2ff13$export$7918117e9202e4fb)(),
    (0, $82c2736be09e13bf$export$59bfe9f1c76150e)(),
    (0, $355f8d9981d566ef$export$c079d904b326663a)(),
    (0, $ed3134e690fd7f16$export$66acc70e8cf2b71a)(),
    (0, $06bb7854fa0f7190$export$ebabb00eb7f3a395)(),
    (0, $64a102a9031d7a8b$export$6d39aa44cd0c7567)(),
    (0, $2dac98dc53011638$export$1378794447170364)()
];
/** Get the default integrations for the browser SDK. */ function $3892e5b7960d5b8e$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$3892e5b7960d5b8e$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $3892e5b7960d5b8e$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $3892e5b7960d5b8e$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === 'string') options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $6Iopj.stackParserFromStackParserOptions)(options.stackParser || (0, $8b14e65fd7f0660b$export$2b2b997d81bf3907)),
        integrations: (0, $73f29a8c00de1619$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $66e623382a10017c$export$edf3cb81fd7d2a3e)() ? (0, $99d026d71c642708$export$b2311068c46d7cc8) : (0, $ca2901e77e0aacab$export$5e1441cee30d5a39))
    };
    (0, $ec20e29fc539f943$export$5333c3f1c58d9bc1)((0, $7b33da84303847bc$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $3892e5b7960d5b8e$var$startSessionTracking();
}
const $3892e5b7960d5b8e$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $gUaXH.getCurrentHub)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).document) {
        (0, $01ed1ffdc00026d9$export$16a28057038b10ef) && (0, $7htw4.logger).error('Global document not defined in showReportDialog call');
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $01ed1ffdc00026d9$export$16a28057038b10ef) && (0, $7htw4.logger).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $da298c0570fc4a2c$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).document.head || (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $01ed1ffdc00026d9$export$16a28057038b10ef) && (0, $7htw4.logger).error('Not injecting report dialog. No injection point found in HTML');
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $3892e5b7960d5b8e$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $3892e5b7960d5b8e$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3892e5b7960d5b8e$export$4997ffc0176396a6(fn) {
    return (0, $b69ee834d2d8bdf6$export$4997ffc0176396a6)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $3892e5b7960d5b8e$var$startSessionTracking() {
    if (typeof (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).document === 'undefined') {
        (0, $01ed1ffdc00026d9$export$16a28057038b10ef) && (0, $7htw4.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $3WK1v.startSession)({
        ignoreDuration: true
    });
    (0, $3WK1v.captureSession)();
    // We want to create a session for every navigation as well
    (0, $3d019c6a05cabdc5$export$3f18c56c58114e75)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $3WK1v.startSession)({
                ignoreDuration: true
            });
            (0, $3WK1v.captureSession)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $3892e5b7960d5b8e$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $3WK1v.getClient)();
    if (client) client.captureUserFeedback(feedback);
}


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $ab67e3fd78f640cb$export$18ce0697a983be9b = function() {
    $ab67e3fd78f640cb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ab67e3fd78f640cb$export$18ce0697a983be9b.apply(this, arguments);
};
function $ab67e3fd78f640cb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ab67e3fd78f640cb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ab67e3fd78f640cb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ab67e3fd78f640cb$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}


var $0b6f1a86dae6b1f9$export$f06e977173f1857c;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($0b6f1a86dae6b1f9$export$f06e977173f1857c || ($0b6f1a86dae6b1f9$export$f06e977173f1857c = {}));
function $0b6f1a86dae6b1f9$export$45a5e7f76e0caa8d(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $0b6f1a86dae6b1f9$export$af51f0f06c0f328a(n) {
    var _a;
    var host = (_a = n) === null || _a === void 0 ? void 0 : _a.host;
    return Boolean(host && host.shadowRoot && host.shadowRoot === n);
}
function $0b6f1a86dae6b1f9$export$b547f2d5941e071e(_a) {
    var maskInputOptions = _a.maskInputOptions, tagName = _a.tagName, type = _a.type, value = _a.value, maskInputFn = _a.maskInputFn;
    var text = value || '';
    if (maskInputOptions[tagName.toLowerCase()] || maskInputOptions[type]) {
        if (maskInputFn) text = maskInputFn(text);
        else text = '*'.repeat(text.length);
    }
    return text;
}
var $0b6f1a86dae6b1f9$var$ORIGINAL_ATTRIBUTE_NAME = '__rrweb_original__';
function $0b6f1a86dae6b1f9$export$4604fdf2f9aabdf2(canvas) {
    var ctx = canvas.getContext('2d');
    if (!ctx) return true;
    var chunkSize = 50;
    for(var x = 0; x < canvas.width; x += chunkSize)for(var y = 0; y < canvas.height; y += chunkSize){
        var getImageData = ctx.getImageData;
        var originalGetImageData = $0b6f1a86dae6b1f9$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$0b6f1a86dae6b1f9$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        var pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some(function(pixel) {
            return pixel !== 0;
        })) return false;
    }
    return true;
}
var $0b6f1a86dae6b1f9$var$_id = 1;
var $0b6f1a86dae6b1f9$var$tagNameRegex = new RegExp('[^a-z0-9-_:]');
var $0b6f1a86dae6b1f9$export$e4e7f8ddf3795ddb = -2;
function $0b6f1a86dae6b1f9$var$genId() {
    return $0b6f1a86dae6b1f9$var$_id++;
}
function $0b6f1a86dae6b1f9$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return 'form';
    var processedTagName = element.tagName.toLowerCase().trim();
    if ($0b6f1a86dae6b1f9$var$tagNameRegex.test(processedTagName)) return 'div';
    return processedTagName;
}
function $0b6f1a86dae6b1f9$var$getCssRulesString(s) {
    try {
        var rules = s.rules || s.cssRules;
        return rules ? Array.from(rules).map($0b6f1a86dae6b1f9$var$getCssRuleString).join('') : null;
    } catch (error) {
        return null;
    }
}
function $0b6f1a86dae6b1f9$var$getCssRuleString(rule) {
    var cssStringified = rule.cssText;
    if ($0b6f1a86dae6b1f9$var$isCSSImportRule(rule)) try {
        cssStringified = $0b6f1a86dae6b1f9$var$getCssRulesString(rule.styleSheet) || cssStringified;
    } catch (_a) {}
    return cssStringified;
}
function $0b6f1a86dae6b1f9$var$isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function $0b6f1a86dae6b1f9$var$stringifyStyleSheet(sheet) {
    return sheet.cssRules ? Array.from(sheet.cssRules).map(function(rule) {
        return rule.cssText || '';
    }).join('') : '';
}
function $0b6f1a86dae6b1f9$var$extractOrigin(url) {
    var origin = '';
    if (url.indexOf('//') > -1) origin = url.split('/').slice(0, 3).join('/');
    else origin = url.split('/')[0];
    origin = origin.split('?')[0];
    return origin;
}
var $0b6f1a86dae6b1f9$var$canvasService;
var $0b6f1a86dae6b1f9$var$canvasCtx;
var $0b6f1a86dae6b1f9$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
var $0b6f1a86dae6b1f9$var$RELATIVE_PATH = /^(?!www\.|(?:http|ftp)s?:\/\/|[A-Za-z]:\\|\/\/|#).*/;
var $0b6f1a86dae6b1f9$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $0b6f1a86dae6b1f9$var$absoluteToStylesheet(cssText, href) {
    return (cssText || '').replace($0b6f1a86dae6b1f9$var$URL_IN_CSS_REF, function(origin, quote1, path1, quote2, path2, path3) {
        var filePath = path1 || path2 || path3;
        var maybeQuote = quote1 || quote2 || '';
        if (!filePath) return origin;
        if (!$0b6f1a86dae6b1f9$var$RELATIVE_PATH.test(filePath)) return "url(" + maybeQuote + filePath + maybeQuote + ")";
        if ($0b6f1a86dae6b1f9$var$DATA_URI.test(filePath)) return "url(" + maybeQuote + filePath + maybeQuote + ")";
        if (filePath[0] === '/') return "url(" + maybeQuote + ($0b6f1a86dae6b1f9$var$extractOrigin(href) + filePath) + maybeQuote + ")";
        var stack = href.split('/');
        var parts = filePath.split('/');
        stack.pop();
        for(var _i = 0, parts_1 = parts; _i < parts_1.length; _i++){
            var part = parts_1[_i];
            if (part === '.') continue;
            else if (part === '..') stack.pop();
            else stack.push(part);
        }
        return "url(" + maybeQuote + stack.join('/') + maybeQuote + ")";
    });
}
var $0b6f1a86dae6b1f9$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
var $0b6f1a86dae6b1f9$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $0b6f1a86dae6b1f9$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === '') return attributeValue;
    var pos = 0;
    function collectCharacters(regEx) {
        var chars;
        var match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return '';
    }
    var output = [];
    while(true){
        collectCharacters($0b6f1a86dae6b1f9$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        var url = collectCharacters($0b6f1a86dae6b1f9$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ',') {
            url = $0b6f1a86dae6b1f9$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            var descriptorsStr = '';
            url = $0b6f1a86dae6b1f9$var$absoluteToDoc(doc, url);
            var inParens = false;
            while(true){
                var c = attributeValue.charAt(pos);
                if (c === '') {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ',') {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === '(') inParens = true;
                } else if (c === ')') inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(', ');
}
function $0b6f1a86dae6b1f9$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === '') return attributeValue;
    var a = doc.createElement('a');
    a.href = attributeValue;
    return a.href;
}
function $0b6f1a86dae6b1f9$var$isSVGElement(el) {
    return Boolean(el.tagName === 'svg' || el.ownerSVGElement);
}
function $0b6f1a86dae6b1f9$var$getHref() {
    var a = document.createElement('a');
    a.href = '';
    return a.href;
}
function $0b6f1a86dae6b1f9$export$cb0776038f0c16b2(doc, tagName, name, value) {
    if (name === 'src' || name === 'href' && value) return $0b6f1a86dae6b1f9$var$absoluteToDoc(doc, value);
    else if (name === 'xlink:href' && value && value[0] !== '#') return $0b6f1a86dae6b1f9$var$absoluteToDoc(doc, value);
    else if (name === 'background' && value && (tagName === 'table' || tagName === 'td' || tagName === 'th')) return $0b6f1a86dae6b1f9$var$absoluteToDoc(doc, value);
    else if (name === 'srcset' && value) return $0b6f1a86dae6b1f9$var$getAbsoluteSrcsetString(doc, value);
    else if (name === 'style' && value) return $0b6f1a86dae6b1f9$var$absoluteToStylesheet(value, $0b6f1a86dae6b1f9$var$getHref());
    else if (tagName === 'object' && name === 'data' && value) return $0b6f1a86dae6b1f9$var$absoluteToDoc(doc, value);
    else return value;
}
function $0b6f1a86dae6b1f9$var$_isBlockedElement(element, blockClass, blockSelector) {
    if (typeof blockClass === 'string') {
        if (element.classList.contains(blockClass)) return true;
    } else for(var eIndex = 0; eIndex < element.classList.length; eIndex++){
        var className = element.classList[eIndex];
        if (blockClass.test(className)) return true;
    }
    if (blockSelector) return element.matches(blockSelector);
    return false;
}
function $0b6f1a86dae6b1f9$export$80849672af49d9a0(node, maskTextClass, maskTextSelector) {
    if (!node) return false;
    if (node.nodeType === node.ELEMENT_NODE) {
        if (typeof maskTextClass === 'string') {
            if (node.classList.contains(maskTextClass)) return true;
        } else for(var eIndex = 0; eIndex < node.classList.length; eIndex++){
            var className = node.classList[eIndex];
            if (maskTextClass.test(className)) return true;
        }
        if (maskTextSelector) {
            if (node.matches(maskTextSelector)) return true;
        }
        return $0b6f1a86dae6b1f9$export$80849672af49d9a0(node.parentNode, maskTextClass, maskTextSelector);
    }
    if (node.nodeType === node.TEXT_NODE) return $0b6f1a86dae6b1f9$export$80849672af49d9a0(node.parentNode, maskTextClass, maskTextSelector);
    return $0b6f1a86dae6b1f9$export$80849672af49d9a0(node.parentNode, maskTextClass, maskTextSelector);
}
function $0b6f1a86dae6b1f9$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    var win = iframeEl.contentWindow;
    if (!win) return;
    var fired = false;
    var readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== 'complete') {
        var timer_1 = setTimeout(function() {
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener('load', function() {
            clearTimeout(timer_1);
            fired = true;
            listener();
        });
        return;
    }
    var blankUrl = 'about:blank';
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === '') {
        setTimeout(listener, 0);
        return;
    }
    iframeEl.addEventListener('load', listener);
}
function $0b6f1a86dae6b1f9$var$serializeNode(n, options) {
    var _a;
    var doc = options.doc, blockClass = options.blockClass, blockSelector = options.blockSelector, maskTextClass = options.maskTextClass, maskTextSelector = options.maskTextSelector, inlineStylesheet = options.inlineStylesheet, _b = options.maskInputOptions, maskInputOptions = _b === void 0 ? {} : _b, maskTextFn = options.maskTextFn, maskInputFn = options.maskInputFn, _c = options.dataURLOptions, dataURLOptions = _c === void 0 ? {} : _c, inlineImages = options.inlineImages, recordCanvas = options.recordCanvas, keepIframeSrcFn = options.keepIframeSrcFn;
    var rootId;
    if (doc.__sn) {
        var docId = doc.__sn.id;
        rootId = docId === 1 ? undefined : docId;
    }
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== 'CSS1Compat') return {
                type: $0b6f1a86dae6b1f9$export$f06e977173f1857c.Document,
                childNodes: [],
                compatMode: n.compatMode,
                rootId: rootId
            };
            else return {
                type: $0b6f1a86dae6b1f9$export$f06e977173f1857c.Document,
                childNodes: [],
                rootId: rootId
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $0b6f1a86dae6b1f9$export$f06e977173f1857c.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            var needBlock = $0b6f1a86dae6b1f9$var$_isBlockedElement(n, blockClass, blockSelector);
            var tagName = $0b6f1a86dae6b1f9$var$getValidTagName(n);
            var attributes_1 = {};
            for(var _i = 0, _d = Array.from(n.attributes); _i < _d.length; _i++){
                var _e = _d[_i], name_1 = _e.name, value = _e.value;
                attributes_1[name_1] = $0b6f1a86dae6b1f9$export$cb0776038f0c16b2(doc, tagName, name_1, value);
            }
            if (tagName === 'link' && inlineStylesheet) {
                var stylesheet = Array.from(doc.styleSheets).find(function(s) {
                    return s.href === n.href;
                });
                var cssText = null;
                if (stylesheet) cssText = $0b6f1a86dae6b1f9$var$getCssRulesString(stylesheet);
                if (cssText) {
                    delete attributes_1.rel;
                    delete attributes_1.href;
                    attributes_1._cssText = $0b6f1a86dae6b1f9$var$absoluteToStylesheet(cssText, stylesheet.href);
                }
            }
            if (tagName === 'style' && n.sheet && !(n.innerText || n.textContent || '').trim().length) {
                var cssText = $0b6f1a86dae6b1f9$var$getCssRulesString(n.sheet);
                if (cssText) attributes_1._cssText = $0b6f1a86dae6b1f9$var$absoluteToStylesheet(cssText, $0b6f1a86dae6b1f9$var$getHref());
            }
            if (tagName === 'input' || tagName === 'textarea' || tagName === 'select') {
                var value = n.value;
                if (attributes_1.type !== 'radio' && attributes_1.type !== 'checkbox' && attributes_1.type !== 'submit' && attributes_1.type !== 'button' && value) attributes_1.value = $0b6f1a86dae6b1f9$export$b547f2d5941e071e({
                    type: attributes_1.type,
                    tagName: tagName,
                    value: value,
                    maskInputOptions: maskInputOptions,
                    maskInputFn: maskInputFn
                });
                else if (n.checked) attributes_1.checked = n.checked;
            }
            if (tagName === 'option') {
                if (n.selected && !maskInputOptions['select']) attributes_1.selected = true;
                else delete attributes_1.selected;
            }
            if (tagName === 'canvas' && recordCanvas) {
                if (n.__context === '2d') {
                    if (!$0b6f1a86dae6b1f9$export$4604fdf2f9aabdf2(n)) attributes_1.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                } else if (!('__context' in n)) {
                    var canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    var blankCanvas = document.createElement('canvas');
                    blankCanvas.width = n.width;
                    blankCanvas.height = n.height;
                    var blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    if (canvasDataURL !== blankCanvasDataURL) attributes_1.rr_dataURL = canvasDataURL;
                }
            }
            if (tagName === 'img' && inlineImages) {
                if (!$0b6f1a86dae6b1f9$var$canvasService) {
                    $0b6f1a86dae6b1f9$var$canvasService = doc.createElement('canvas');
                    $0b6f1a86dae6b1f9$var$canvasCtx = $0b6f1a86dae6b1f9$var$canvasService.getContext('2d');
                }
                var image_1 = n;
                var oldValue_1 = image_1.crossOrigin;
                image_1.crossOrigin = 'anonymous';
                var recordInlineImage = function() {
                    try {
                        $0b6f1a86dae6b1f9$var$canvasService.width = image_1.naturalWidth;
                        $0b6f1a86dae6b1f9$var$canvasService.height = image_1.naturalHeight;
                        $0b6f1a86dae6b1f9$var$canvasCtx.drawImage(image_1, 0, 0);
                        attributes_1.rr_dataURL = $0b6f1a86dae6b1f9$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    } catch (err) {
                        console.warn("Cannot inline img src=" + image_1.currentSrc + "! Error: " + err);
                    }
                    oldValue_1 ? attributes_1.crossOrigin = oldValue_1 : delete attributes_1.crossOrigin;
                };
                if (image_1.complete && image_1.naturalWidth !== 0) recordInlineImage();
                else image_1.onload = recordInlineImage;
            }
            if (tagName === 'audio' || tagName === 'video') {
                attributes_1.rr_mediaState = n.paused ? 'paused' : 'played';
                attributes_1.rr_mediaCurrentTime = n.currentTime;
            }
            if (n.scrollLeft) attributes_1.rr_scrollLeft = n.scrollLeft;
            if (n.scrollTop) attributes_1.rr_scrollTop = n.scrollTop;
            if (needBlock) {
                var _f = n.getBoundingClientRect(), width = _f.width, height = _f.height;
                attributes_1 = {
                    "class": attributes_1["class"],
                    rr_width: width + "px",
                    rr_height: height + "px"
                };
            }
            if (tagName === 'iframe' && !keepIframeSrcFn(attributes_1.src)) {
                if (!n.contentDocument) attributes_1.rr_src = attributes_1.src;
                delete attributes_1.src;
            }
            return {
                type: $0b6f1a86dae6b1f9$export$f06e977173f1857c.Element,
                tagName: tagName,
                attributes: attributes_1,
                childNodes: [],
                isSVG: $0b6f1a86dae6b1f9$var$isSVGElement(n) || undefined,
                needBlock: needBlock,
                rootId: rootId
            };
        case n.TEXT_NODE:
            var parentTagName = n.parentNode && n.parentNode.tagName;
            var textContent = n.textContent;
            var isStyle = parentTagName === 'STYLE' ? true : undefined;
            var isScript = parentTagName === 'SCRIPT' ? true : undefined;
            if (isStyle && textContent) {
                try {
                    if (n.nextSibling || n.previousSibling) ;
                    else if ((_a = n.parentNode.sheet) === null || _a === void 0 ? void 0 : _a.cssRules) textContent = $0b6f1a86dae6b1f9$var$stringifyStyleSheet(n.parentNode.sheet);
                } catch (err) {
                    console.warn("Cannot get CSS styles from text's parentNode. Error: " + err, n);
                }
                textContent = $0b6f1a86dae6b1f9$var$absoluteToStylesheet(textContent, $0b6f1a86dae6b1f9$var$getHref());
            }
            if (isScript) textContent = 'SCRIPT_PLACEHOLDER';
            if (!isStyle && !isScript && $0b6f1a86dae6b1f9$export$80849672af49d9a0(n, maskTextClass, maskTextSelector) && textContent) textContent = maskTextFn ? maskTextFn(textContent) : textContent.replace(/[\S]/g, '*');
            return {
                type: $0b6f1a86dae6b1f9$export$f06e977173f1857c.Text,
                textContent: textContent || '',
                isStyle: isStyle,
                rootId: rootId
            };
        case n.CDATA_SECTION_NODE:
            return {
                type: $0b6f1a86dae6b1f9$export$f06e977173f1857c.CDATA,
                textContent: '',
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $0b6f1a86dae6b1f9$export$f06e977173f1857c.Comment,
                textContent: n.textContent || '',
                rootId: rootId
            };
        default:
            return false;
    }
}
function $0b6f1a86dae6b1f9$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined) return '';
    else return maybeAttr.toLowerCase();
}
function $0b6f1a86dae6b1f9$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $0b6f1a86dae6b1f9$export$f06e977173f1857c.Comment) return true;
    else if (sn.type === $0b6f1a86dae6b1f9$export$f06e977173f1857c.Element) {
        if (slimDOMOptions.script && (sn.tagName === 'script' || sn.tagName === 'link' && sn.attributes.rel === 'preload' && sn.attributes.as === 'script' || sn.tagName === 'link' && sn.attributes.rel === 'prefetch' && typeof sn.attributes.href === 'string' && sn.attributes.href.endsWith('.js'))) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === 'link' && sn.attributes.rel === 'shortcut icon' || sn.tagName === 'meta' && ($0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.name) === 'application-name' || $0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.rel) === 'icon' || $0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.rel) === 'apple-touch-icon' || $0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.rel) === 'shortcut icon'))) return true;
        else if (sn.tagName === 'meta') {
            if (slimDOMOptions.headMetaDescKeywords && $0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.name) === 'pinterest')) return true;
            else if (slimDOMOptions.headMetaRobots && ($0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.name) === 'robots' || $0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.name) === 'googlebot' || $0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.name) === 'bingbot')) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes['http-equiv'] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.name) === 'author' || $0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.name) === 'generator' || $0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.name) === 'framework' || $0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.name) === 'publisher' || $0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.name) === 'progid' || $0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.name) === 'google-site-verification' || $0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.name) === 'yandex-verification' || $0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.name) === 'csrf-token' || $0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.name) === 'p:domain_verify' || $0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.name) === 'verify-v1' || $0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.name) === 'verification' || $0b6f1a86dae6b1f9$var$lowerIfExists(sn.attributes.name) === 'shopify-checkout-api-token')) return true;
        }
    }
    return false;
}
function $0b6f1a86dae6b1f9$export$27792c824d895cd4(n, options) {
    var doc = options.doc, map = options.map, blockClass = options.blockClass, blockSelector = options.blockSelector, maskTextClass = options.maskTextClass, maskTextSelector = options.maskTextSelector, _a = options.skipChild, skipChild = _a === void 0 ? false : _a, _b = options.inlineStylesheet, inlineStylesheet = _b === void 0 ? true : _b, _c = options.maskInputOptions, maskInputOptions = _c === void 0 ? {} : _c, maskTextFn = options.maskTextFn, maskInputFn = options.maskInputFn, slimDOMOptions = options.slimDOMOptions, _d = options.dataURLOptions, dataURLOptions = _d === void 0 ? {} : _d, _e = options.inlineImages, inlineImages = _e === void 0 ? false : _e, _f = options.recordCanvas, recordCanvas = _f === void 0 ? false : _f, onSerialize = options.onSerialize, onIframeLoad = options.onIframeLoad, _g = options.iframeLoadTimeout, iframeLoadTimeout = _g === void 0 ? 5000 : _g, _h = options.keepIframeSrcFn, keepIframeSrcFn = _h === void 0 ? function() {
        return false;
    } : _h;
    var _j = options.preserveWhiteSpace, preserveWhiteSpace = _j === void 0 ? true : _j;
    var _serializedNode = $0b6f1a86dae6b1f9$var$serializeNode(n, {
        doc: doc,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskTextClass: maskTextClass,
        maskTextSelector: maskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn
    });
    if (!_serializedNode) {
        console.warn(n, 'not serialized');
        return null;
    }
    var id;
    if ('__sn' in n) id = n.__sn.id;
    else if ($0b6f1a86dae6b1f9$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $0b6f1a86dae6b1f9$export$f06e977173f1857c.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, '').length) id = $0b6f1a86dae6b1f9$export$e4e7f8ddf3795ddb;
    else id = $0b6f1a86dae6b1f9$var$genId();
    var serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    n.__sn = serializedNode;
    if (id === $0b6f1a86dae6b1f9$export$e4e7f8ddf3795ddb) return null;
    map[id] = n;
    if (onSerialize) onSerialize(n);
    var recordChild = !skipChild;
    if (serializedNode.type === $0b6f1a86dae6b1f9$export$f06e977173f1857c.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        if (n.shadowRoot) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $0b6f1a86dae6b1f9$export$f06e977173f1857c.Document || serializedNode.type === $0b6f1a86dae6b1f9$export$f06e977173f1857c.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && _serializedNode.type === $0b6f1a86dae6b1f9$export$f06e977173f1857c.Element && _serializedNode.tagName === 'head') preserveWhiteSpace = false;
        var bypassOptions = {
            doc: doc,
            map: map,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for(var _i = 0, _k = Array.from(n.childNodes); _i < _k.length; _i++){
            var childN = _k[_i];
            var serializedChildNode = $0b6f1a86dae6b1f9$export$27792c824d895cd4(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if ($0b6f1a86dae6b1f9$export$45a5e7f76e0caa8d(n) && n.shadowRoot) for(var _l = 0, _m = Array.from(n.shadowRoot.childNodes); _l < _m.length; _l++){
            var childN = _m[_l];
            var serializedChildNode = $0b6f1a86dae6b1f9$export$27792c824d895cd4(childN, bypassOptions);
            if (serializedChildNode) {
                serializedChildNode.isShadow = true;
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $0b6f1a86dae6b1f9$export$af51f0f06c0f328a(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $0b6f1a86dae6b1f9$export$f06e977173f1857c.Element && serializedNode.tagName === 'iframe') $0b6f1a86dae6b1f9$var$onceIframeLoaded(n, function() {
        var iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            var serializedIframeNode = $0b6f1a86dae6b1f9$export$27792c824d895cd4(iframeDoc, {
                doc: iframeDoc,
                map: map,
                blockClass: blockClass,
                blockSelector: blockSelector,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    return serializedNode;
}
function $0b6f1a86dae6b1f9$export$b8801ea43165ed7d(n, options) {
    var _a = options || {}, _b = _a.blockClass, blockClass = _b === void 0 ? 'rr-block' : _b, _c = _a.blockSelector, blockSelector = _c === void 0 ? null : _c, _d = _a.maskTextClass, maskTextClass = _d === void 0 ? 'rr-mask' : _d, _e = _a.maskTextSelector, maskTextSelector = _e === void 0 ? null : _e, _f = _a.inlineStylesheet, inlineStylesheet = _f === void 0 ? true : _f, _g = _a.inlineImages, inlineImages = _g === void 0 ? false : _g, _h = _a.recordCanvas, recordCanvas = _h === void 0 ? false : _h, _j = _a.maskAllInputs, maskAllInputs = _j === void 0 ? false : _j, maskTextFn = _a.maskTextFn, maskInputFn = _a.maskInputFn, _k = _a.slimDOM, slimDOM = _k === void 0 ? false : _k, dataURLOptions = _a.dataURLOptions, preserveWhiteSpace = _a.preserveWhiteSpace, onSerialize = _a.onSerialize, onIframeLoad = _a.onIframeLoad, iframeLoadTimeout = _a.iframeLoadTimeout, _l = _a.keepIframeSrcFn, keepIframeSrcFn = _l === void 0 ? function() {
        return false;
    } : _l;
    var idNodeMap = {};
    var maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        password: true
    } : maskAllInputs === false ? {
        password: true
    } : maskAllInputs;
    var slimDOMOptions = slimDOM === true || slimDOM === 'all' ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === 'all',
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return [
        $0b6f1a86dae6b1f9$export$27792c824d895cd4(n, {
            doc: n,
            map: idNodeMap,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            skipChild: false,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        }),
        idNodeMap
    ];
}
var $0b6f1a86dae6b1f9$var$commentre = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
function $0b6f1a86dae6b1f9$var$parse(css, options) {
    if (options === void 0) options = {};
    var lineno = 1;
    var column = 1;
    function updatePosition(str) {
        var lines = str.match(/\n/g);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf('\n');
        column = i === -1 ? column + str.length : str.length - i;
    }
    function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    var Position = function() {
        function Position(start) {
            this.start = start;
            this.end = {
                line: lineno,
                column: column
            };
            this.source = options.source;
        }
        return Position;
    }();
    Position.prototype.content = css;
    var errorsList = [];
    function error(msg) {
        var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = css;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    function stylesheet() {
        var rulesList = rules();
        return {
            type: 'stylesheet',
            stylesheet: {
                source: options.source,
                rules: rulesList,
                parsingErrors: errorsList
            }
        };
    }
    function open() {
        return match(/^{\s*/);
    }
    function close() {
        return match(/^}/);
    }
    function rules() {
        var node;
        var rules = [];
        whitespace();
        comments(rules);
        while(css.length && css.charAt(0) !== '}' && (node = atrule() || rule()))if (node !== false) {
            rules.push(node);
            comments(rules);
        }
        return rules;
    }
    function match(re) {
        var m = re.exec(css);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        css = css.slice(str.length);
        return m;
    }
    function whitespace() {
        match(/^\s*/);
    }
    function comments(rules) {
        if (rules === void 0) rules = [];
        var c;
        while(c = comment()){
            if (c !== false) rules.push(c);
            c = comment();
        }
        return rules;
    }
    function comment() {
        var pos = position();
        if ('/' !== css.charAt(0) || '*' !== css.charAt(1)) return;
        var i = 2;
        while('' !== css.charAt(i) && ('*' !== css.charAt(i) || '/' !== css.charAt(i + 1)))++i;
        i += 2;
        if ('' === css.charAt(i - 1)) return error('End of comment missing');
        var str = css.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        css = css.slice(i);
        column += 2;
        return pos({
            type: 'comment',
            comment: str
        });
    }
    function selector() {
        var m = match(/^([^{]+)/);
        if (!m) return;
        return $0b6f1a86dae6b1f9$var$trim(m[0]).replace(/\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*\/+/g, '').replace(/"(?:\\"|[^"])*"|'(?:\\'|[^'])*'/g, function(m) {
            return m.replace(/,/g, '\u200C');
        }).split(/\s*(?![^(]*\)),\s*/).map(function(s) {
            return s.replace(/\u200C/g, ',');
        });
    }
    function declaration() {
        var pos = position();
        var propMatch = match(/^(\*?[-#\/\*\\\w]+(\[[0-9a-z_-]+\])?)\s*/);
        if (!propMatch) return;
        var prop = $0b6f1a86dae6b1f9$var$trim(propMatch[0]);
        if (!match(/^:\s*/)) return error("property missing ':'");
        var val = match(/^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^\)]*?\)|[^};])+)/);
        var ret = pos({
            type: 'declaration',
            property: prop.replace($0b6f1a86dae6b1f9$var$commentre, ''),
            value: val ? $0b6f1a86dae6b1f9$var$trim(val[0]).replace($0b6f1a86dae6b1f9$var$commentre, '') : ''
        });
        match(/^[;\s]*/);
        return ret;
    }
    function declarations() {
        var decls = [];
        if (!open()) return error("missing '{'");
        comments(decls);
        var decl;
        while(decl = declaration()){
            if (decl !== false) {
                decls.push(decl);
                comments(decls);
            }
            decl = declaration();
        }
        if (!close()) return error("missing '}'");
        return decls;
    }
    function keyframe() {
        var m;
        var vals = [];
        var pos = position();
        while(m = match(/^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/)){
            vals.push(m[1]);
            match(/^,\s*/);
        }
        if (!vals.length) return;
        return pos({
            type: 'keyframe',
            values: vals,
            declarations: declarations()
        });
    }
    function atkeyframes() {
        var pos = position();
        var m = match(/^@([-\w]+)?keyframes\s*/);
        if (!m) return;
        var vendor = m[1];
        m = match(/^([-\w]+)\s*/);
        if (!m) return error('@keyframes missing name');
        var name = m[1];
        if (!open()) return error("@keyframes missing '{'");
        var frame;
        var frames = comments();
        while(frame = keyframe()){
            frames.push(frame);
            frames = frames.concat(comments());
        }
        if (!close()) return error("@keyframes missing '}'");
        return pos({
            type: 'keyframes',
            name: name,
            vendor: vendor,
            keyframes: frames
        });
    }
    function atsupports() {
        var pos = position();
        var m = match(/^@supports *([^{]+)/);
        if (!m) return;
        var supports = $0b6f1a86dae6b1f9$var$trim(m[1]);
        if (!open()) return error("@supports missing '{'");
        var style = comments().concat(rules());
        if (!close()) return error("@supports missing '}'");
        return pos({
            type: 'supports',
            supports: supports,
            rules: style
        });
    }
    function athost() {
        var pos = position();
        var m = match(/^@host\s*/);
        if (!m) return;
        if (!open()) return error("@host missing '{'");
        var style = comments().concat(rules());
        if (!close()) return error("@host missing '}'");
        return pos({
            type: 'host',
            rules: style
        });
    }
    function atmedia() {
        var pos = position();
        var m = match(/^@media *([^{]+)/);
        if (!m) return;
        var media = $0b6f1a86dae6b1f9$var$trim(m[1]);
        if (!open()) return error("@media missing '{'");
        var style = comments().concat(rules());
        if (!close()) return error("@media missing '}'");
        return pos({
            type: 'media',
            media: media,
            rules: style
        });
    }
    function atcustommedia() {
        var pos = position();
        var m = match(/^@custom-media\s+(--[^\s]+)\s*([^{;]+);/);
        if (!m) return;
        return pos({
            type: 'custom-media',
            name: $0b6f1a86dae6b1f9$var$trim(m[1]),
            media: $0b6f1a86dae6b1f9$var$trim(m[2])
        });
    }
    function atpage() {
        var pos = position();
        var m = match(/^@page */);
        if (!m) return;
        var sel = selector() || [];
        if (!open()) return error("@page missing '{'");
        var decls = comments();
        var decl;
        while(decl = declaration()){
            decls.push(decl);
            decls = decls.concat(comments());
        }
        if (!close()) return error("@page missing '}'");
        return pos({
            type: 'page',
            selectors: sel,
            declarations: decls
        });
    }
    function atdocument() {
        var pos = position();
        var m = match(/^@([-\w]+)?document *([^{]+)/);
        if (!m) return;
        var vendor = $0b6f1a86dae6b1f9$var$trim(m[1]);
        var doc = $0b6f1a86dae6b1f9$var$trim(m[2]);
        if (!open()) return error("@document missing '{'");
        var style = comments().concat(rules());
        if (!close()) return error("@document missing '}'");
        return pos({
            type: 'document',
            document: doc,
            vendor: vendor,
            rules: style
        });
    }
    function atfontface() {
        var pos = position();
        var m = match(/^@font-face\s*/);
        if (!m) return;
        if (!open()) return error("@font-face missing '{'");
        var decls = comments();
        var decl;
        while(decl = declaration()){
            decls.push(decl);
            decls = decls.concat(comments());
        }
        if (!close()) return error("@font-face missing '}'");
        return pos({
            type: 'font-face',
            declarations: decls
        });
    }
    var atimport = _compileAtrule('import');
    var atcharset = _compileAtrule('charset');
    var atnamespace = _compileAtrule('namespace');
    function _compileAtrule(name) {
        var re = new RegExp('^@' + name + '\\s*([^;]+);');
        return function() {
            var pos = position();
            var m = match(re);
            if (!m) return;
            var ret = {
                type: name
            };
            ret[name] = m[1].trim();
            return pos(ret);
        };
    }
    function atrule() {
        if (css[0] !== '@') return;
        return atkeyframes() || atmedia() || atcustommedia() || atsupports() || atimport() || atcharset() || atnamespace() || atdocument() || atpage() || athost() || atfontface();
    }
    function rule() {
        var pos = position();
        var sel = selector();
        if (!sel) return error('selector missing');
        comments();
        return pos({
            type: 'rule',
            selectors: sel,
            declarations: declarations()
        });
    }
    return $0b6f1a86dae6b1f9$var$addParent(stylesheet());
}
function $0b6f1a86dae6b1f9$var$trim(str) {
    return str ? str.replace(/^\s+|\s+$/g, '') : '';
}
function $0b6f1a86dae6b1f9$var$addParent(obj, parent) {
    var isNode = obj && typeof obj.type === 'string';
    var childParent = isNode ? obj : parent;
    for(var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++){
        var k = _a[_i];
        var value = obj[k];
        if (Array.isArray(value)) value.forEach(function(v) {
            $0b6f1a86dae6b1f9$var$addParent(v, childParent);
        });
        else if (value && typeof value === 'object') $0b6f1a86dae6b1f9$var$addParent(value, childParent);
    }
    if (isNode) Object.defineProperty(obj, 'parent', {
        configurable: true,
        writable: true,
        enumerable: false,
        value: parent || null
    });
    return obj;
}
var $0b6f1a86dae6b1f9$var$tagMap = {
    script: 'noscript',
    altglyph: 'altGlyph',
    altglyphdef: 'altGlyphDef',
    altglyphitem: 'altGlyphItem',
    animatecolor: 'animateColor',
    animatemotion: 'animateMotion',
    animatetransform: 'animateTransform',
    clippath: 'clipPath',
    feblend: 'feBlend',
    fecolormatrix: 'feColorMatrix',
    fecomponenttransfer: 'feComponentTransfer',
    fecomposite: 'feComposite',
    feconvolvematrix: 'feConvolveMatrix',
    fediffuselighting: 'feDiffuseLighting',
    fedisplacementmap: 'feDisplacementMap',
    fedistantlight: 'feDistantLight',
    fedropshadow: 'feDropShadow',
    feflood: 'feFlood',
    fefunca: 'feFuncA',
    fefuncb: 'feFuncB',
    fefuncg: 'feFuncG',
    fefuncr: 'feFuncR',
    fegaussianblur: 'feGaussianBlur',
    feimage: 'feImage',
    femerge: 'feMerge',
    femergenode: 'feMergeNode',
    femorphology: 'feMorphology',
    feoffset: 'feOffset',
    fepointlight: 'fePointLight',
    fespecularlighting: 'feSpecularLighting',
    fespotlight: 'feSpotLight',
    fetile: 'feTile',
    feturbulence: 'feTurbulence',
    foreignobject: 'foreignObject',
    glyphref: 'glyphRef',
    lineargradient: 'linearGradient',
    radialgradient: 'radialGradient'
};
function $0b6f1a86dae6b1f9$var$getTagName(n) {
    var tagName = $0b6f1a86dae6b1f9$var$tagMap[n.tagName] ? $0b6f1a86dae6b1f9$var$tagMap[n.tagName] : n.tagName;
    if (tagName === 'link' && n.attributes._cssText) tagName = 'style';
    return tagName;
}
function $0b6f1a86dae6b1f9$var$escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
var $0b6f1a86dae6b1f9$var$HOVER_SELECTOR = /([^\\]):hover/;
var $0b6f1a86dae6b1f9$var$HOVER_SELECTOR_GLOBAL = new RegExp($0b6f1a86dae6b1f9$var$HOVER_SELECTOR.source, 'g');
function $0b6f1a86dae6b1f9$export$3ce47eb8e1d1461d(cssText, cache) {
    var cachedStyle = cache === null || cache === void 0 ? void 0 : cache.stylesWithHoverClass.get(cssText);
    if (cachedStyle) return cachedStyle;
    var ast = $0b6f1a86dae6b1f9$var$parse(cssText, {
        silent: true
    });
    if (!ast.stylesheet) return cssText;
    var selectors = [];
    ast.stylesheet.rules.forEach(function(rule) {
        if ('selectors' in rule) (rule.selectors || []).forEach(function(selector) {
            if ($0b6f1a86dae6b1f9$var$HOVER_SELECTOR.test(selector)) selectors.push(selector);
        });
    });
    if (selectors.length === 0) return cssText;
    var selectorMatcher = new RegExp(selectors.filter(function(selector, index) {
        return selectors.indexOf(selector) === index;
    }).sort(function(a, b) {
        return b.length - a.length;
    }).map(function(selector) {
        return $0b6f1a86dae6b1f9$var$escapeRegExp(selector);
    }).join('|'), 'g');
    var result = cssText.replace(selectorMatcher, function(selector) {
        var newSelector = selector.replace($0b6f1a86dae6b1f9$var$HOVER_SELECTOR_GLOBAL, '$1.\\:hover');
        return selector + ", " + newSelector;
    });
    cache === null || cache === void 0 || cache.stylesWithHoverClass.set(cssText, result);
    return result;
}
function $0b6f1a86dae6b1f9$export$cf6fa0bbcc94b912() {
    var stylesWithHoverClass = new Map();
    return {
        stylesWithHoverClass: stylesWithHoverClass
    };
}
function $0b6f1a86dae6b1f9$var$buildNode(n, options) {
    var doc = options.doc, hackCss = options.hackCss, cache = options.cache;
    switch(n.type){
        case $0b6f1a86dae6b1f9$export$f06e977173f1857c.Document:
            return doc.implementation.createDocument(null, '', null);
        case $0b6f1a86dae6b1f9$export$f06e977173f1857c.DocumentType:
            return doc.implementation.createDocumentType(n.name || 'html', n.publicId, n.systemId);
        case $0b6f1a86dae6b1f9$export$f06e977173f1857c.Element:
            var tagName = $0b6f1a86dae6b1f9$var$getTagName(n);
            var node_1;
            if (n.isSVG) node_1 = doc.createElementNS('http://www.w3.org/2000/svg', tagName);
            else node_1 = doc.createElement(tagName);
            var _loop_1 = function(name_1) {
                if (!n.attributes.hasOwnProperty(name_1)) return "continue";
                var value = n.attributes[name_1];
                if (tagName === 'option' && name_1 === 'selected' && value === false) return "continue";
                value = typeof value === 'boolean' || typeof value === 'number' ? '' : value;
                if (!name_1.startsWith('rr_')) {
                    var isTextarea = tagName === 'textarea' && name_1 === 'value';
                    var isRemoteOrDynamicCss = tagName === 'style' && name_1 === '_cssText';
                    if (isRemoteOrDynamicCss && hackCss) value = $0b6f1a86dae6b1f9$export$3ce47eb8e1d1461d(value, cache);
                    if (isTextarea || isRemoteOrDynamicCss) {
                        var child = doc.createTextNode(value);
                        for(var _i = 0, _a = Array.from(node_1.childNodes); _i < _a.length; _i++){
                            var c = _a[_i];
                            if (c.nodeType === node_1.TEXT_NODE) node_1.removeChild(c);
                        }
                        node_1.appendChild(child);
                        return "continue";
                    }
                    try {
                        if (n.isSVG && name_1 === 'xlink:href') node_1.setAttributeNS('http://www.w3.org/1999/xlink', name_1, value);
                        else if (name_1 === 'onload' || name_1 === 'onclick' || name_1.substring(0, 7) === 'onmouse') node_1.setAttribute('_' + name_1, value);
                        else if (tagName === 'meta' && n.attributes['http-equiv'] === 'Content-Security-Policy' && name_1 === 'content') {
                            node_1.setAttribute('csp-content', value);
                            return "continue";
                        } else if (tagName === 'link' && n.attributes.rel === 'preload' && n.attributes.as === 'script') ;
                        else if (tagName === 'link' && n.attributes.rel === 'prefetch' && typeof n.attributes.href === 'string' && n.attributes.href.endsWith('.js')) ;
                        else if (tagName === 'img' && n.attributes.srcset && n.attributes.rr_dataURL) node_1.setAttribute('rrweb-original-srcset', n.attributes.srcset);
                        else node_1.setAttribute(name_1, value);
                    } catch (error) {}
                } else {
                    if (tagName === 'canvas' && name_1 === 'rr_dataURL') {
                        var image_1 = document.createElement('img');
                        image_1.src = value;
                        image_1.onload = function() {
                            var ctx = node_1.getContext('2d');
                            if (ctx) ctx.drawImage(image_1, 0, 0, image_1.width, image_1.height);
                        };
                    } else if (tagName === 'img' && name_1 === 'rr_dataURL') {
                        var image = node_1;
                        if (!image.currentSrc.startsWith('data:')) {
                            image.setAttribute('rrweb-original-src', n.attributes.src);
                            image.src = value;
                        }
                    }
                    if (name_1 === 'rr_width') node_1.style.width = value;
                    else if (name_1 === 'rr_height') node_1.style.height = value;
                    else if (name_1 === 'rr_mediaCurrentTime') node_1.currentTime = n.attributes.rr_mediaCurrentTime;
                    else if (name_1 === 'rr_mediaState') switch(value){
                        case 'played':
                            node_1.play()["catch"](function(e) {
                                return console.warn('media playback error', e);
                            });
                            break;
                        case 'paused':
                            node_1.pause();
                            break;
                    }
                }
            };
            for(var name_1 in n.attributes)_loop_1(name_1);
            if (n.isShadowHost) {
                if (!node_1.shadowRoot) node_1.attachShadow({
                    mode: 'open'
                });
                else while(node_1.shadowRoot.firstChild)node_1.shadowRoot.removeChild(node_1.shadowRoot.firstChild);
            }
            return node_1;
        case $0b6f1a86dae6b1f9$export$f06e977173f1857c.Text:
            return doc.createTextNode(n.isStyle && hackCss ? $0b6f1a86dae6b1f9$export$3ce47eb8e1d1461d(n.textContent, cache) : n.textContent);
        case $0b6f1a86dae6b1f9$export$f06e977173f1857c.CDATA:
            return doc.createCDATASection(n.textContent);
        case $0b6f1a86dae6b1f9$export$f06e977173f1857c.Comment:
            return doc.createComment(n.textContent);
        default:
            return null;
    }
}
function $0b6f1a86dae6b1f9$export$24ec8ca0cae8790(n, options) {
    var doc = options.doc, map = options.map, _a = options.skipChild, skipChild = _a === void 0 ? false : _a, _b = options.hackCss, hackCss = _b === void 0 ? true : _b, afterAppend = options.afterAppend, cache = options.cache;
    var node = $0b6f1a86dae6b1f9$var$buildNode(n, {
        doc: doc,
        hackCss: hackCss,
        cache: cache
    });
    if (!node) return null;
    if (n.rootId) console.assert(map[n.rootId] === doc, 'Target document should has the same root id.');
    if (n.type === $0b6f1a86dae6b1f9$export$f06e977173f1857c.Document) {
        doc.close();
        doc.open();
        if (n.compatMode === 'BackCompat' && n.childNodes && n.childNodes[0].type !== $0b6f1a86dae6b1f9$export$f06e977173f1857c.DocumentType) {
            if (n.childNodes[0].type === $0b6f1a86dae6b1f9$export$f06e977173f1857c.Element && 'xmlns' in n.childNodes[0].attributes && n.childNodes[0].attributes.xmlns === 'http://www.w3.org/1999/xhtml') doc.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "">');
            else doc.write('<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN" "">');
        }
        node = doc;
    }
    node.__sn = n;
    map[n.id] = node;
    if ((n.type === $0b6f1a86dae6b1f9$export$f06e977173f1857c.Document || n.type === $0b6f1a86dae6b1f9$export$f06e977173f1857c.Element) && !skipChild) for(var _i = 0, _c = n.childNodes; _i < _c.length; _i++){
        var childN = _c[_i];
        var childNode = $0b6f1a86dae6b1f9$export$24ec8ca0cae8790(childN, {
            doc: doc,
            map: map,
            skipChild: false,
            hackCss: hackCss,
            afterAppend: afterAppend,
            cache: cache
        });
        if (!childNode) {
            console.warn('Failed to rebuild', childN);
            continue;
        }
        if (childN.isShadow && $0b6f1a86dae6b1f9$export$45a5e7f76e0caa8d(node) && node.shadowRoot) node.shadowRoot.appendChild(childNode);
        else node.appendChild(childNode);
        if (afterAppend) afterAppend(childNode);
    }
    return node;
}
function $0b6f1a86dae6b1f9$var$visit(idNodeMap, onVisit) {
    function walk(node) {
        onVisit(node);
    }
    for(var key in idNodeMap)if (idNodeMap[key]) walk(idNodeMap[key]);
}
function $0b6f1a86dae6b1f9$var$handleScroll(node) {
    var n = node.__sn;
    if (n.type !== $0b6f1a86dae6b1f9$export$f06e977173f1857c.Element) return;
    var el = node;
    for(var name_2 in n.attributes){
        if (!(n.attributes.hasOwnProperty(name_2) && name_2.startsWith('rr_'))) continue;
        var value = n.attributes[name_2];
        if (name_2 === 'rr_scrollLeft') el.scrollLeft = value;
        if (name_2 === 'rr_scrollTop') el.scrollTop = value;
    }
}
function $0b6f1a86dae6b1f9$export$e95decb5aab14503(n, options) {
    var doc = options.doc, onVisit = options.onVisit, _a = options.hackCss, hackCss = _a === void 0 ? true : _a, afterAppend = options.afterAppend, cache = options.cache;
    var idNodeMap = {};
    var node = $0b6f1a86dae6b1f9$export$24ec8ca0cae8790(n, {
        doc: doc,
        map: idNodeMap,
        skipChild: false,
        hackCss: hackCss,
        afterAppend: afterAppend,
        cache: cache
    });
    $0b6f1a86dae6b1f9$var$visit(idNodeMap, function(visitedNode) {
        if (onVisit) onVisit(visitedNode);
        $0b6f1a86dae6b1f9$var$handleScroll(visitedNode);
    });
    return [
        node,
        idNodeMap
    ];
}





var $490d855006fd9373$export$3d7865934588d77e;
(function(EventType) {
    EventType[EventType["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType[EventType["Load"] = 1] = "Load";
    EventType[EventType["FullSnapshot"] = 2] = "FullSnapshot";
    EventType[EventType["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType[EventType["Meta"] = 4] = "Meta";
    EventType[EventType["Custom"] = 5] = "Custom";
    EventType[EventType["Plugin"] = 6] = "Plugin";
})($490d855006fd9373$export$3d7865934588d77e || ($490d855006fd9373$export$3d7865934588d77e = {}));
var $490d855006fd9373$export$24bb3ebc067ff5e1;
(function(IncrementalSource) {
    IncrementalSource[IncrementalSource["Mutation"] = 0] = "Mutation";
    IncrementalSource[IncrementalSource["MouseMove"] = 1] = "MouseMove";
    IncrementalSource[IncrementalSource["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource[IncrementalSource["Scroll"] = 3] = "Scroll";
    IncrementalSource[IncrementalSource["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource[IncrementalSource["Input"] = 5] = "Input";
    IncrementalSource[IncrementalSource["TouchMove"] = 6] = "TouchMove";
    IncrementalSource[IncrementalSource["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource[IncrementalSource["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource[IncrementalSource["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource[IncrementalSource["Font"] = 10] = "Font";
    IncrementalSource[IncrementalSource["Log"] = 11] = "Log";
    IncrementalSource[IncrementalSource["Drag"] = 12] = "Drag";
    IncrementalSource[IncrementalSource["StyleDeclaration"] = 13] = "StyleDeclaration";
})($490d855006fd9373$export$24bb3ebc067ff5e1 || ($490d855006fd9373$export$24bb3ebc067ff5e1 = {}));
var $490d855006fd9373$export$d87e674dba09af70;
(function(MouseInteractions) {
    MouseInteractions[MouseInteractions["MouseUp"] = 0] = "MouseUp";
    MouseInteractions[MouseInteractions["MouseDown"] = 1] = "MouseDown";
    MouseInteractions[MouseInteractions["Click"] = 2] = "Click";
    MouseInteractions[MouseInteractions["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions[MouseInteractions["DblClick"] = 4] = "DblClick";
    MouseInteractions[MouseInteractions["Focus"] = 5] = "Focus";
    MouseInteractions[MouseInteractions["Blur"] = 6] = "Blur";
    MouseInteractions[MouseInteractions["TouchStart"] = 7] = "TouchStart";
    MouseInteractions[MouseInteractions["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions[MouseInteractions["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions[MouseInteractions["TouchCancel"] = 10] = "TouchCancel";
})($490d855006fd9373$export$d87e674dba09af70 || ($490d855006fd9373$export$d87e674dba09af70 = {}));
var $490d855006fd9373$export$eefcd8ea59422f9d;
(function(CanvasContext) {
    CanvasContext[CanvasContext["2D"] = 0] = "2D";
    CanvasContext[CanvasContext["WebGL"] = 1] = "WebGL";
    CanvasContext[CanvasContext["WebGL2"] = 2] = "WebGL2";
})($490d855006fd9373$export$eefcd8ea59422f9d || ($490d855006fd9373$export$eefcd8ea59422f9d = {}));
var $490d855006fd9373$export$737e227e26e615d9;
(function(MediaInteractions) {
    MediaInteractions[MediaInteractions["Play"] = 0] = "Play";
    MediaInteractions[MediaInteractions["Pause"] = 1] = "Pause";
    MediaInteractions[MediaInteractions["Seeked"] = 2] = "Seeked";
    MediaInteractions[MediaInteractions["VolumeChange"] = 3] = "VolumeChange";
})($490d855006fd9373$export$737e227e26e615d9 || ($490d855006fd9373$export$737e227e26e615d9 = {}));
var $490d855006fd9373$export$7b5ca317a0cad55c;
(function(ReplayerEvents) {
    ReplayerEvents["Start"] = "start";
    ReplayerEvents["Pause"] = "pause";
    ReplayerEvents["Resume"] = "resume";
    ReplayerEvents["Resize"] = "resize";
    ReplayerEvents["Finish"] = "finish";
    ReplayerEvents["FullsnapshotRebuilded"] = "fullsnapshot-rebuilded";
    ReplayerEvents["LoadStylesheetStart"] = "load-stylesheet-start";
    ReplayerEvents["LoadStylesheetEnd"] = "load-stylesheet-end";
    ReplayerEvents["SkipStart"] = "skip-start";
    ReplayerEvents["SkipEnd"] = "skip-end";
    ReplayerEvents["MouseInteraction"] = "mouse-interaction";
    ReplayerEvents["EventCast"] = "event-cast";
    ReplayerEvents["CustomEvent"] = "custom-event";
    ReplayerEvents["Flush"] = "flush";
    ReplayerEvents["StateChange"] = "state-change";
    ReplayerEvents["PlayBack"] = "play-back";
})($490d855006fd9373$export$7b5ca317a0cad55c || ($490d855006fd9373$export$7b5ca317a0cad55c = {}));



function $29f3f202b3ae6fbc$export$af631764ddc44097(type, fn, target) {
    if (target === void 0) target = document;
    var options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return function() {
        return target.removeEventListener(type, fn, options);
    };
}
function $29f3f202b3ae6fbc$export$b307838285d1a62e() {
    return {
        map: {},
        getId: function(n) {
            if (!n || !n.__sn) return -1;
            return n.__sn.id;
        },
        getNode: function(id) {
            return this.map[id] || null;
        },
        removeNodeFromMap: function(n) {
            var _this = this;
            var id = n.__sn && n.__sn.id;
            delete this.map[id];
            if (n.childNodes) n.childNodes.forEach(function(child) {
                return _this.removeNodeFromMap(child);
            });
        },
        has: function(id) {
            return this.map.hasOwnProperty(id);
        },
        reset: function() {
            this.map = {};
        }
    };
}
var $29f3f202b3ae6fbc$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
var $29f3f202b3ae6fbc$export$7fae4a0f2ef38689 = {
    map: {},
    getId: function() {
        console.error($29f3f202b3ae6fbc$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode: function() {
        console.error($29f3f202b3ae6fbc$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap: function() {
        console.error($29f3f202b3ae6fbc$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has: function() {
        console.error($29f3f202b3ae6fbc$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset: function() {
        console.error($29f3f202b3ae6fbc$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== 'undefined' && window.Proxy && window.Reflect) $29f3f202b3ae6fbc$export$7fae4a0f2ef38689 = new Proxy($29f3f202b3ae6fbc$export$7fae4a0f2ef38689, {
    get: function(target, prop, receiver) {
        if (prop === 'map') console.error($29f3f202b3ae6fbc$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $29f3f202b3ae6fbc$export$de363e709c412c8a(func, wait, options) {
    if (options === void 0) options = {};
    var timeout = null;
    var previous = 0;
    return function(arg) {
        var now = Date.now();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        var context = this;
        var args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(function() {
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $29f3f202b3ae6fbc$export$d80dc7d100d862ab(target, key, d, isRevoked, win) {
    if (win === void 0) win = window;
    var original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set: function(value) {
            var _this = this;
            setTimeout(function() {
                d.set.call(_this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return function() {
        return $29f3f202b3ae6fbc$export$d80dc7d100d862ab(target, key, original || {}, true);
    };
}
function $29f3f202b3ae6fbc$export$b76953f99ab2be78(source, name, replacement) {
    try {
        if (!(name in source)) return function() {};
        var original_1 = source[name];
        var wrapped = replacement(original_1);
        if (typeof wrapped === 'function') {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original_1
                }
            });
        }
        source[name] = wrapped;
        return function() {
            source[name] = original_1;
        };
    } catch (_a) {
        return function() {};
    }
}
function $29f3f202b3ae6fbc$export$a3648dbc3769cbf4() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $29f3f202b3ae6fbc$export$91cf85d6c980faa0() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $29f3f202b3ae6fbc$export$548f076b7581caed(node, blockClass) {
    if (!node) return false;
    if (node.nodeType === node.ELEMENT_NODE) {
        var needBlock_1 = false;
        if (typeof blockClass === 'string') {
            if (node.closest !== undefined) return node.closest('.' + blockClass) !== null;
            else needBlock_1 = node.classList.contains(blockClass);
        } else node.classList.forEach(function(className) {
            if (blockClass.test(className)) needBlock_1 = true;
        });
        return needBlock_1 || $29f3f202b3ae6fbc$export$548f076b7581caed(node.parentNode, blockClass);
    }
    if (node.nodeType === node.TEXT_NODE) return $29f3f202b3ae6fbc$export$548f076b7581caed(node.parentNode, blockClass);
    return $29f3f202b3ae6fbc$export$548f076b7581caed(node.parentNode, blockClass);
}
function $29f3f202b3ae6fbc$export$ac3f691269cd6d9b(n) {
    if ('__sn' in n) return n.__sn.id === (0, $0b6f1a86dae6b1f9$export$e4e7f8ddf3795ddb);
    return false;
}
function $29f3f202b3ae6fbc$export$e5f7d27071a3eb16(target, mirror) {
    if ((0, $0b6f1a86dae6b1f9$export$af51f0f06c0f328a)(target)) return false;
    var id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $29f3f202b3ae6fbc$export$e5f7d27071a3eb16(target.parentNode, mirror);
}
function $29f3f202b3ae6fbc$export$c4dfce035d43d1e0(event) {
    return Boolean(event.changedTouches);
}
function $29f3f202b3ae6fbc$export$cea1c58a6db52bca(win) {
    if (win === void 0) win = window;
    if ('NodeList' in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ('DOMTokenList' in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = function contains(node) {
        if (!(0 in arguments)) throw new TypeError('1 argument is required');
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
var $29f3f202b3ae6fbc$export$f2454a917775f8b9 = function() {
    function TreeIndex() {
        this.reset();
    }
    TreeIndex.prototype.add = function(mutation) {
        var parentTreeNode = this.indexes.get(mutation.parentId);
        var treeNode = {
            id: mutation.node.id,
            mutation: mutation,
            children: [],
            texts: [],
            attributes: []
        };
        if (!parentTreeNode) this.tree[treeNode.id] = treeNode;
        else {
            treeNode.parent = parentTreeNode;
            parentTreeNode.children[treeNode.id] = treeNode;
        }
        this.indexes.set(treeNode.id, treeNode);
    };
    TreeIndex.prototype.remove = function(mutation, mirror) {
        var _this = this;
        var parentTreeNode = this.indexes.get(mutation.parentId);
        var treeNode = this.indexes.get(mutation.id);
        var deepRemoveFromMirror = function(id) {
            _this.removeIdSet.add(id);
            var node = mirror.getNode(id);
            node === null || node === void 0 || node.childNodes.forEach(function(childNode) {
                if ('__sn' in childNode) deepRemoveFromMirror(childNode.__sn.id);
            });
        };
        var deepRemoveFromTreeIndex = function(node) {
            _this.removeIdSet.add(node.id);
            Object.values(node.children).forEach(function(n) {
                return deepRemoveFromTreeIndex(n);
            });
            var _treeNode = _this.indexes.get(node.id);
            if (_treeNode) {
                var _parentTreeNode = _treeNode.parent;
                if (_parentTreeNode) {
                    delete _treeNode.parent;
                    delete _parentTreeNode.children[_treeNode.id];
                    _this.indexes.delete(mutation.id);
                }
            }
        };
        if (!treeNode) {
            this.removeNodeMutations.push(mutation);
            deepRemoveFromMirror(mutation.id);
        } else if (!parentTreeNode) {
            delete this.tree[treeNode.id];
            this.indexes.delete(treeNode.id);
            deepRemoveFromTreeIndex(treeNode);
        } else {
            delete treeNode.parent;
            delete parentTreeNode.children[treeNode.id];
            this.indexes.delete(mutation.id);
            deepRemoveFromTreeIndex(treeNode);
        }
    };
    TreeIndex.prototype.text = function(mutation) {
        var treeNode = this.indexes.get(mutation.id);
        if (treeNode) treeNode.texts.push(mutation);
        else this.textMutations.push(mutation);
    };
    TreeIndex.prototype.attribute = function(mutation) {
        var treeNode = this.indexes.get(mutation.id);
        if (treeNode) treeNode.attributes.push(mutation);
        else this.attributeMutations.push(mutation);
    };
    TreeIndex.prototype.scroll = function(d) {
        this.scrollMap.set(d.id, d);
    };
    TreeIndex.prototype.input = function(d) {
        this.inputMap.set(d.id, d);
    };
    TreeIndex.prototype.flush = function() {
        var e_1, _a, e_2, _b;
        var _this = this;
        var _c = this, tree = _c.tree, removeNodeMutations = _c.removeNodeMutations, textMutations = _c.textMutations, attributeMutations = _c.attributeMutations;
        var batchMutationData = {
            source: (0, $490d855006fd9373$export$24bb3ebc067ff5e1).Mutation,
            removes: removeNodeMutations,
            texts: textMutations,
            attributes: attributeMutations,
            adds: []
        };
        var walk = function(treeNode, removed) {
            if (removed) _this.removeIdSet.add(treeNode.id);
            batchMutationData.texts = batchMutationData.texts.concat(removed ? [] : treeNode.texts).filter(function(m) {
                return !_this.removeIdSet.has(m.id);
            });
            batchMutationData.attributes = batchMutationData.attributes.concat(removed ? [] : treeNode.attributes).filter(function(m) {
                return !_this.removeIdSet.has(m.id);
            });
            if (!_this.removeIdSet.has(treeNode.id) && !_this.removeIdSet.has(treeNode.mutation.parentId) && !removed) {
                batchMutationData.adds.push(treeNode.mutation);
                if (treeNode.children) Object.values(treeNode.children).forEach(function(n) {
                    return walk(n, false);
                });
            } else Object.values(treeNode.children).forEach(function(n) {
                return walk(n, true);
            });
        };
        Object.values(tree).forEach(function(n) {
            return walk(n, false);
        });
        try {
            for(var _d = (0, $ab67e3fd78f640cb$export$19a8beecd37a4c45)(this.scrollMap.keys()), _e = _d.next(); !_e.done; _e = _d.next()){
                var id = _e.value;
                if (this.removeIdSet.has(id)) this.scrollMap.delete(id);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        try {
            for(var _f = (0, $ab67e3fd78f640cb$export$19a8beecd37a4c45)(this.inputMap.keys()), _g = _f.next(); !_g.done; _g = _f.next()){
                var id = _g.value;
                if (this.removeIdSet.has(id)) this.inputMap.delete(id);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        var scrollMap = new Map(this.scrollMap);
        var inputMap = new Map(this.inputMap);
        this.reset();
        return {
            mutationData: batchMutationData,
            scrollMap: scrollMap,
            inputMap: inputMap
        };
    };
    TreeIndex.prototype.reset = function() {
        this.tree = [];
        this.indexes = new Map();
        this.removeNodeMutations = [];
        this.textMutations = [];
        this.attributeMutations = [];
        this.removeIdSet = new Set();
        this.scrollMap = new Map();
        this.inputMap = new Map();
    };
    TreeIndex.prototype.idRemoved = function(id) {
        return this.removeIdSet.has(id);
    };
    return TreeIndex;
}();
function $29f3f202b3ae6fbc$export$8452c1b1ebecb974(queue) {
    var e_3, _a;
    var queueNodeMap = {};
    var putIntoMap = function(m, parent) {
        var nodeInTree = {
            value: m,
            parent: parent,
            children: []
        };
        queueNodeMap[m.node.id] = nodeInTree;
        return nodeInTree;
    };
    var queueNodeTrees = [];
    try {
        for(var queue_1 = (0, $ab67e3fd78f640cb$export$19a8beecd37a4c45)(queue), queue_1_1 = queue_1.next(); !queue_1_1.done; queue_1_1 = queue_1.next()){
            var mutation = queue_1_1.value;
            var nextId = mutation.nextId, parentId = mutation.parentId;
            if (nextId && nextId in queueNodeMap) {
                var nextInTree = queueNodeMap[nextId];
                if (nextInTree.parent) {
                    var idx = nextInTree.parent.children.indexOf(nextInTree);
                    nextInTree.parent.children.splice(idx, 0, putIntoMap(mutation, nextInTree.parent));
                } else {
                    var idx = queueNodeTrees.indexOf(nextInTree);
                    queueNodeTrees.splice(idx, 0, putIntoMap(mutation, null));
                }
                continue;
            }
            if (parentId in queueNodeMap) {
                var parentInTree = queueNodeMap[parentId];
                parentInTree.children.push(putIntoMap(mutation, parentInTree));
                continue;
            }
            queueNodeTrees.push(putIntoMap(mutation, null));
        }
    } catch (e_3_1) {
        e_3 = {
            error: e_3_1
        };
    } finally{
        try {
            if (queue_1_1 && !queue_1_1.done && (_a = queue_1.return)) _a.call(queue_1);
        } finally{
            if (e_3) throw e_3.error;
        }
    }
    return queueNodeTrees;
}
function $29f3f202b3ae6fbc$export$4e319cca3803633(tree, cb) {
    cb(tree.value);
    for(var i = tree.children.length - 1; i >= 0; i--)$29f3f202b3ae6fbc$export$4e319cca3803633(tree.children[i], cb);
}
function $29f3f202b3ae6fbc$export$5fbba895fb12280c(node) {
    if ('__sn' in node) return node.__sn.type === (0, $0b6f1a86dae6b1f9$export$f06e977173f1857c).Element && node.__sn.tagName === 'iframe';
    return false;
}
function $29f3f202b3ae6fbc$export$fe3c6903da92b949(node, rootIframe) {
    var _a, _b;
    var frameElement = (_b = (_a = node.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView) === null || _b === void 0 ? void 0 : _b.frameElement;
    if (!frameElement || frameElement === rootIframe) return {
        x: 0,
        y: 0,
        relativeScale: 1,
        absoluteScale: 1
    };
    var frameDimension = frameElement.getBoundingClientRect();
    var frameBaseDimension = $29f3f202b3ae6fbc$export$fe3c6903da92b949(frameElement, rootIframe);
    var relativeScale = frameDimension.height / frameElement.clientHeight;
    return {
        x: frameDimension.x * frameBaseDimension.relativeScale + frameBaseDimension.x,
        y: frameDimension.y * frameBaseDimension.relativeScale + frameBaseDimension.y,
        relativeScale: relativeScale,
        absoluteScale: frameBaseDimension.absoluteScale * relativeScale
    };
}
function $29f3f202b3ae6fbc$export$e4bead7f22725bce(n) {
    return Boolean(n === null || n === void 0 ? void 0 : n.shadowRoot);
}






function $f0367c09c5046614$var$isNodeInLinkedList(n) {
    return '__ln' in n;
}
var $f0367c09c5046614$var$DoubleLinkedList = function() {
    function DoubleLinkedList() {
        this.length = 0;
        this.head = null;
    }
    DoubleLinkedList.prototype.get = function(position) {
        if (position >= this.length) throw new Error('Position outside of list range');
        var current = this.head;
        for(var index = 0; index < position; index++)current = (current === null || current === void 0 ? void 0 : current.next) || null;
        return current;
    };
    DoubleLinkedList.prototype.addNode = function(n) {
        var node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && $f0367c09c5046614$var$isNodeInLinkedList(n.previousSibling)) {
            var current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && $f0367c09c5046614$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            var current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        this.length++;
    };
    DoubleLinkedList.prototype.removeNode = function(n) {
        var current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    };
    return DoubleLinkedList;
}();
var $f0367c09c5046614$var$moveKey = function(id, parentId) {
    return "".concat(id, "@").concat(parentId);
};
function $f0367c09c5046614$var$isINode(n) {
    return '__sn' in n;
}
var $f0367c09c5046614$var$MutationBuffer = function() {
    function MutationBuffer() {
        var _this = this;
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = function(mutations) {
            mutations.forEach(_this.processMutation);
            _this.emit();
        };
        this.emit = function() {
            var e_1, _a, e_2, _b;
            if (_this.frozen || _this.locked) return;
            var adds = [];
            var addList = new $f0367c09c5046614$var$DoubleLinkedList();
            var getNextId = function(n) {
                var ns = n;
                var nextId = (0, $0b6f1a86dae6b1f9$export$e4e7f8ddf3795ddb);
                while(nextId === (0, $0b6f1a86dae6b1f9$export$e4e7f8ddf3795ddb)){
                    ns = ns && ns.nextSibling;
                    nextId = ns && _this.mirror.getId(ns);
                }
                return nextId;
            };
            var pushAdd = function(n) {
                var _a, _b, _c, _d, _e;
                var shadowHost = n.getRootNode ? (_a = n.getRootNode()) === null || _a === void 0 ? void 0 : _a.host : null;
                var rootShadowHost = shadowHost;
                while((_c = (_b = rootShadowHost === null || rootShadowHost === void 0 ? void 0 : rootShadowHost.getRootNode) === null || _b === void 0 ? void 0 : _b.call(rootShadowHost)) === null || _c === void 0 ? void 0 : _c.host)rootShadowHost = ((_e = (_d = rootShadowHost === null || rootShadowHost === void 0 ? void 0 : rootShadowHost.getRootNode) === null || _d === void 0 ? void 0 : _d.call(rootShadowHost)) === null || _e === void 0 ? void 0 : _e.host) || null;
                var notInDoc = !_this.doc.contains(n) && (rootShadowHost === null || !_this.doc.contains(rootShadowHost));
                if (!n.parentNode || notInDoc) return;
                var parentId = (0, $0b6f1a86dae6b1f9$export$af51f0f06c0f328a)(n.parentNode) ? _this.mirror.getId(shadowHost) : _this.mirror.getId(n.parentNode);
                var nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                var sn = (0, $0b6f1a86dae6b1f9$export$27792c824d895cd4)(n, {
                    doc: _this.doc,
                    map: _this.mirror.map,
                    blockClass: _this.blockClass,
                    blockSelector: _this.blockSelector,
                    maskTextClass: _this.maskTextClass,
                    maskTextSelector: _this.maskTextSelector,
                    skipChild: true,
                    inlineStylesheet: _this.inlineStylesheet,
                    maskInputOptions: _this.maskInputOptions,
                    maskTextFn: _this.maskTextFn,
                    maskInputFn: _this.maskInputFn,
                    slimDOMOptions: _this.slimDOMOptions,
                    recordCanvas: _this.recordCanvas,
                    inlineImages: _this.inlineImages,
                    onSerialize: function(currentN) {
                        if ((0, $29f3f202b3ae6fbc$export$5fbba895fb12280c)(currentN)) _this.iframeManager.addIframe(currentN);
                        if ((0, $29f3f202b3ae6fbc$export$e4bead7f22725bce)(n)) _this.shadowDomManager.addShadowRoot(n.shadowRoot, document);
                    },
                    onIframeLoad: function(iframe, childSn) {
                        _this.iframeManager.attachIframe(iframe, childSn);
                        _this.shadowDomManager.observeAttachShadow(iframe);
                    }
                });
                if (sn) adds.push({
                    parentId: parentId,
                    nextId: nextId,
                    node: sn
                });
            };
            while(_this.mapRemoves.length)_this.mirror.removeNodeFromMap(_this.mapRemoves.shift());
            try {
                for(var _c = (0, $ab67e3fd78f640cb$export$19a8beecd37a4c45)(_this.movedSet), _d = _c.next(); !_d.done; _d = _c.next()){
                    var n = _d.value;
                    if ($f0367c09c5046614$var$isParentRemoved(_this.removes, n, _this.mirror) && !_this.movedSet.has(n.parentNode)) continue;
                    pushAdd(n);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            try {
                for(var _e = (0, $ab67e3fd78f640cb$export$19a8beecd37a4c45)(_this.addedSet), _f = _e.next(); !_f.done; _f = _e.next()){
                    var n = _f.value;
                    if (!$f0367c09c5046614$var$isAncestorInSet(_this.droppedSet, n) && !$f0367c09c5046614$var$isParentRemoved(_this.removes, n, _this.mirror)) pushAdd(n);
                    else if ($f0367c09c5046614$var$isAncestorInSet(_this.movedSet, n)) pushAdd(n);
                    else _this.droppedSet.add(n);
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
            var candidate = null;
            while(addList.length){
                var node = null;
                if (candidate) {
                    var parentId = _this.mirror.getId(candidate.value.parentNode);
                    var nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) for(var index = addList.length - 1; index >= 0; index--){
                    var _node = addList.get(index);
                    if (_node) {
                        var parentId = _this.mirror.getId(_node.value.parentNode);
                        var nextId = getNextId(_node.value);
                        if (parentId !== -1 && nextId !== -1) {
                            node = _node;
                            break;
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            var payload = {
                texts: _this.texts.map(function(text) {
                    return {
                        id: _this.mirror.getId(text.node),
                        value: text.value
                    };
                }).filter(function(text) {
                    return _this.mirror.has(text.id);
                }),
                attributes: _this.attributes.map(function(attribute) {
                    return {
                        id: _this.mirror.getId(attribute.node),
                        attributes: attribute.attributes
                    };
                }).filter(function(attribute) {
                    return _this.mirror.has(attribute.id);
                }),
                removes: _this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            _this.texts = [];
            _this.attributes = [];
            _this.removes = [];
            _this.addedSet = new Set();
            _this.movedSet = new Set();
            _this.droppedSet = new Set();
            _this.movedMap = {};
            _this.mutationCb(payload);
        };
        this.processMutation = function(m) {
            var e_3, _a, e_4, _b;
            if ((0, $29f3f202b3ae6fbc$export$ac3f691269cd6d9b)(m.target)) return;
            switch(m.type){
                case 'characterData':
                    var value = m.target.textContent;
                    if (!(0, $29f3f202b3ae6fbc$export$548f076b7581caed)(m.target, _this.blockClass) && value !== m.oldValue) _this.texts.push({
                        value: (0, $0b6f1a86dae6b1f9$export$80849672af49d9a0)(m.target, _this.maskTextClass, _this.maskTextSelector) && value ? _this.maskTextFn ? _this.maskTextFn(value) : value.replace(/[\S]/g, '*') : value,
                        node: m.target
                    });
                    break;
                case 'attributes':
                    var target = m.target;
                    var value = m.target.getAttribute(m.attributeName);
                    if (m.attributeName === 'value') value = (0, $0b6f1a86dae6b1f9$export$b547f2d5941e071e)({
                        maskInputOptions: _this.maskInputOptions,
                        tagName: m.target.tagName,
                        type: m.target.getAttribute('type'),
                        value: value,
                        maskInputFn: _this.maskInputFn
                    });
                    if ((0, $29f3f202b3ae6fbc$export$548f076b7581caed)(m.target, _this.blockClass) || value === m.oldValue) return;
                    var item = _this.attributes.find(function(a) {
                        return a.node === m.target;
                    });
                    if (!item) {
                        item = {
                            node: m.target,
                            attributes: {}
                        };
                        _this.attributes.push(item);
                    }
                    if (m.attributeName === 'style') {
                        var old = _this.doc.createElement('span');
                        if (m.oldValue) old.setAttribute('style', m.oldValue);
                        if (item.attributes.style === undefined || item.attributes.style === null) item.attributes.style = {};
                        var styleObj = item.attributes.style;
                        try {
                            for(var _c = (0, $ab67e3fd78f640cb$export$19a8beecd37a4c45)(Array.from(target.style)), _d = _c.next(); !_d.done; _d = _c.next()){
                                var pname = _d.value;
                                var newValue = target.style.getPropertyValue(pname);
                                var newPriority = target.style.getPropertyPriority(pname);
                                if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                    if (newPriority === '') styleObj[pname] = newValue;
                                    else styleObj[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                            }
                        } catch (e_3_1) {
                            e_3 = {
                                error: e_3_1
                            };
                        } finally{
                            try {
                                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                            } finally{
                                if (e_3) throw e_3.error;
                            }
                        }
                        try {
                            for(var _e = (0, $ab67e3fd78f640cb$export$19a8beecd37a4c45)(Array.from(old.style)), _f = _e.next(); !_f.done; _f = _e.next()){
                                var pname = _f.value;
                                if (target.style.getPropertyValue(pname) === '') styleObj[pname] = false;
                            }
                        } catch (e_4_1) {
                            e_4 = {
                                error: e_4_1
                            };
                        } finally{
                            try {
                                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                            } finally{
                                if (e_4) throw e_4.error;
                            }
                        }
                    } else item.attributes[m.attributeName] = (0, $0b6f1a86dae6b1f9$export$cb0776038f0c16b2)(_this.doc, m.target.tagName, m.attributeName, value);
                    break;
                case 'childList':
                    m.addedNodes.forEach(function(n) {
                        return _this.genAdds(n, m.target);
                    });
                    m.removedNodes.forEach(function(n) {
                        var nodeId = _this.mirror.getId(n);
                        var parentId = (0, $0b6f1a86dae6b1f9$export$af51f0f06c0f328a)(m.target) ? _this.mirror.getId(m.target.host) : _this.mirror.getId(m.target);
                        if ((0, $29f3f202b3ae6fbc$export$548f076b7581caed)(m.target, _this.blockClass) || (0, $29f3f202b3ae6fbc$export$ac3f691269cd6d9b)(n)) return;
                        if (_this.addedSet.has(n)) {
                            $f0367c09c5046614$var$deepDelete(_this.addedSet, n);
                            _this.droppedSet.add(n);
                        } else if (_this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ((0, $29f3f202b3ae6fbc$export$e5f7d27071a3eb16)(m.target, _this.mirror)) ;
                        else if (_this.movedSet.has(n) && _this.movedMap[$f0367c09c5046614$var$moveKey(nodeId, parentId)]) $f0367c09c5046614$var$deepDelete(_this.movedSet, n);
                        else _this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: (0, $0b6f1a86dae6b1f9$export$af51f0f06c0f328a)(m.target) ? true : undefined
                        });
                        _this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = function(n, target) {
            if (target && (0, $29f3f202b3ae6fbc$export$548f076b7581caed)(target, _this.blockClass)) return;
            if ($f0367c09c5046614$var$isINode(n)) {
                if ((0, $29f3f202b3ae6fbc$export$ac3f691269cd6d9b)(n)) return;
                _this.movedSet.add(n);
                var targetId = null;
                if (target && $f0367c09c5046614$var$isINode(target)) targetId = target.__sn.id;
                if (targetId) _this.movedMap[$f0367c09c5046614$var$moveKey(n.__sn.id, targetId)] = true;
            } else {
                _this.addedSet.add(n);
                _this.droppedSet.delete(n);
            }
            if (!(0, $29f3f202b3ae6fbc$export$548f076b7581caed)(n, _this.blockClass)) n.childNodes.forEach(function(childN) {
                return _this.genAdds(childN);
            });
        };
    }
    MutationBuffer.prototype.init = function(options) {
        var _this = this;
        [
            'mutationCb',
            'blockClass',
            'blockSelector',
            'maskTextClass',
            'maskTextSelector',
            'inlineStylesheet',
            'maskInputOptions',
            'maskTextFn',
            'maskInputFn',
            'recordCanvas',
            'inlineImages',
            'slimDOMOptions',
            'doc',
            'mirror',
            'iframeManager',
            'shadowDomManager',
            'canvasManager'
        ].forEach(function(key) {
            _this[key] = options[key];
        });
    };
    MutationBuffer.prototype.freeze = function() {
        this.frozen = true;
        this.canvasManager.freeze();
    };
    MutationBuffer.prototype.unfreeze = function() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    };
    MutationBuffer.prototype.isFrozen = function() {
        return this.frozen;
    };
    MutationBuffer.prototype.lock = function() {
        this.locked = true;
        this.canvasManager.lock();
    };
    MutationBuffer.prototype.unlock = function() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    };
    MutationBuffer.prototype.reset = function() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    };
    return MutationBuffer;
}();
function $f0367c09c5046614$var$deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach(function(childN) {
        return $f0367c09c5046614$var$deepDelete(addsSet, childN);
    });
}
function $f0367c09c5046614$var$isParentRemoved(removes, n, mirror) {
    var parentNode = n.parentNode;
    if (!parentNode) return false;
    var parentId = mirror.getId(parentNode);
    if (removes.some(function(r) {
        return r.id === parentId;
    })) return true;
    return $f0367c09c5046614$var$isParentRemoved(removes, parentNode, mirror);
}
function $f0367c09c5046614$var$isAncestorInSet(set, n) {
    var parentNode = n.parentNode;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $f0367c09c5046614$var$isAncestorInSet(set, parentNode);
}
var $f0367c09c5046614$export$2e2bcd8739ae039 = $f0367c09c5046614$var$MutationBuffer;


var $00ee310cb3f8711d$export$74a0db8061aafa7c = [];
var $00ee310cb3f8711d$var$isCSSGroupingRuleSupported = typeof CSSGroupingRule !== 'undefined';
var $00ee310cb3f8711d$var$isCSSMediaRuleSupported = typeof CSSMediaRule !== 'undefined';
var $00ee310cb3f8711d$var$isCSSSupportsRuleSupported = typeof CSSSupportsRule !== 'undefined';
var $00ee310cb3f8711d$var$isCSSConditionRuleSupported = typeof CSSConditionRule !== 'undefined';
function $00ee310cb3f8711d$var$getEventTarget(event) {
    try {
        if ('composedPath' in event) {
            var path = event.composedPath();
            if (path.length) return path[0];
        } else if ('path' in event && event.path.length) return event.path[0];
        return event.target;
    } catch (_a) {
        return event.target;
    }
}
function $00ee310cb3f8711d$export$b21bab7142e10832(options, rootEl) {
    var _a, _b;
    var mutationBuffer = new (0, $f0367c09c5046614$export$2e2bcd8739ae039)();
    $00ee310cb3f8711d$export$74a0db8061aafa7c.push(mutationBuffer);
    mutationBuffer.init(options);
    var mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    var angularZoneSymbol = (_b = (_a = window === null || window === void 0 ? void 0 : window.Zone) === null || _a === void 0 ? void 0 : _a.__symbol__) === null || _b === void 0 ? void 0 : _b.call(_a, 'MutationObserver');
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    var observer = new mutationObserverCtor(mutationBuffer.processMutations.bind(mutationBuffer));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $00ee310cb3f8711d$var$initMoveObserver(_a) {
    var mousemoveCb = _a.mousemoveCb, sampling = _a.sampling, doc = _a.doc, mirror = _a.mirror;
    if (sampling.mousemove === false) return function() {};
    var threshold = typeof sampling.mousemove === 'number' ? sampling.mousemove : 50;
    var callbackThreshold = typeof sampling.mousemoveCallback === 'number' ? sampling.mousemoveCallback : 500;
    var positions = [];
    var timeBaseline;
    var wrappedCb = (0, $29f3f202b3ae6fbc$export$de363e709c412c8a)(function(source) {
        var totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map(function(p) {
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }, callbackThreshold);
    var updatePosition = (0, $29f3f202b3ae6fbc$export$de363e709c412c8a)(function(evt) {
        var target = $00ee310cb3f8711d$var$getEventTarget(evt);
        var _a = (0, $29f3f202b3ae6fbc$export$c4dfce035d43d1e0)(evt) ? evt.changedTouches[0] : evt, clientX = _a.clientX, clientY = _a.clientY;
        if (!timeBaseline) timeBaseline = Date.now();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: Date.now() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== 'undefined' && evt instanceof DragEvent ? (0, $490d855006fd9373$export$24bb3ebc067ff5e1).Drag : evt instanceof MouseEvent ? (0, $490d855006fd9373$export$24bb3ebc067ff5e1).MouseMove : (0, $490d855006fd9373$export$24bb3ebc067ff5e1).TouchMove);
    }, threshold, {
        trailing: false
    });
    var handlers = [
        (0, $29f3f202b3ae6fbc$export$af631764ddc44097)('mousemove', updatePosition, doc),
        (0, $29f3f202b3ae6fbc$export$af631764ddc44097)('touchmove', updatePosition, doc),
        (0, $29f3f202b3ae6fbc$export$af631764ddc44097)('drag', updatePosition, doc)
    ];
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
function $00ee310cb3f8711d$var$initMouseInteractionObserver(_a) {
    var mouseInteractionCb = _a.mouseInteractionCb, doc = _a.doc, mirror = _a.mirror, blockClass = _a.blockClass, sampling = _a.sampling;
    if (sampling.mouseInteraction === false) return function() {};
    var disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    var handlers = [];
    var getHandler = function(eventKey) {
        return function(event) {
            var target = $00ee310cb3f8711d$var$getEventTarget(event);
            if ((0, $29f3f202b3ae6fbc$export$548f076b7581caed)(target, blockClass)) return;
            var e = (0, $29f3f202b3ae6fbc$export$c4dfce035d43d1e0)(event) ? event.changedTouches[0] : event;
            if (!e) return;
            var id = mirror.getId(target);
            var clientX = e.clientX, clientY = e.clientY;
            mouseInteractionCb({
                type: (0, $490d855006fd9373$export$d87e674dba09af70)[eventKey],
                id: id,
                x: clientX,
                y: clientY
            });
        };
    };
    Object.keys((0, $490d855006fd9373$export$d87e674dba09af70)).filter(function(key) {
        return Number.isNaN(Number(key)) && !key.endsWith('_Departed') && disableMap[key] !== false;
    }).forEach(function(eventKey) {
        var eventName = eventKey.toLowerCase();
        var handler = getHandler(eventKey);
        handlers.push((0, $29f3f202b3ae6fbc$export$af631764ddc44097)(eventName, handler, doc));
    });
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
function $00ee310cb3f8711d$export$7b5afab92e22e83a(_a) {
    var scrollCb = _a.scrollCb, doc = _a.doc, mirror = _a.mirror, blockClass = _a.blockClass, sampling = _a.sampling;
    var updatePosition = (0, $29f3f202b3ae6fbc$export$de363e709c412c8a)(function(evt) {
        var target = $00ee310cb3f8711d$var$getEventTarget(evt);
        if (!target || (0, $29f3f202b3ae6fbc$export$548f076b7581caed)(target, blockClass)) return;
        var id = mirror.getId(target);
        if (target === doc) {
            var scrollEl = doc.scrollingElement || doc.documentElement;
            scrollCb({
                id: id,
                x: scrollEl.scrollLeft,
                y: scrollEl.scrollTop
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }, sampling.scroll || 100);
    return (0, $29f3f202b3ae6fbc$export$af631764ddc44097)('scroll', updatePosition, doc);
}
function $00ee310cb3f8711d$var$initViewportResizeObserver(_a) {
    var viewportResizeCb = _a.viewportResizeCb;
    var lastH = -1;
    var lastW = -1;
    var updateDimension = (0, $29f3f202b3ae6fbc$export$de363e709c412c8a)(function() {
        var height = (0, $29f3f202b3ae6fbc$export$a3648dbc3769cbf4)();
        var width = (0, $29f3f202b3ae6fbc$export$91cf85d6c980faa0)();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }, 200);
    return (0, $29f3f202b3ae6fbc$export$af631764ddc44097)('resize', updateDimension, window);
}
function $00ee310cb3f8711d$var$wrapEventWithUserTriggeredFlag(v, enable) {
    var value = (0, $ab67e3fd78f640cb$export$18ce0697a983be9b)({}, v);
    if (!enable) delete value.userTriggered;
    return value;
}
var $00ee310cb3f8711d$export$f36e59675a538c13 = [
    'INPUT',
    'TEXTAREA',
    'SELECT'
];
var $00ee310cb3f8711d$var$lastInputValueMap = new WeakMap();
function $00ee310cb3f8711d$var$initInputObserver(_a) {
    var inputCb = _a.inputCb, doc = _a.doc, mirror = _a.mirror, blockClass = _a.blockClass, ignoreClass = _a.ignoreClass, maskInputOptions = _a.maskInputOptions, maskInputFn = _a.maskInputFn, sampling = _a.sampling, userTriggeredOnInput = _a.userTriggeredOnInput;
    function eventHandler(event) {
        var target = $00ee310cb3f8711d$var$getEventTarget(event);
        var userTriggered = event.isTrusted;
        if (target && target.tagName === 'OPTION') target = target.parentElement;
        if (!target || !target.tagName || $00ee310cb3f8711d$export$f36e59675a538c13.indexOf(target.tagName) < 0 || (0, $29f3f202b3ae6fbc$export$548f076b7581caed)(target, blockClass)) return;
        var type = target.type;
        if (target.classList.contains(ignoreClass)) return;
        var text = target.value;
        var isChecked = false;
        if (type === 'radio' || type === 'checkbox') isChecked = target.checked;
        else if (maskInputOptions[target.tagName.toLowerCase()] || maskInputOptions[type]) text = (0, $0b6f1a86dae6b1f9$export$b547f2d5941e071e)({
            maskInputOptions: maskInputOptions,
            tagName: target.tagName,
            type: type,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, $00ee310cb3f8711d$var$wrapEventWithUserTriggeredFlag({
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        }, userTriggeredOnInput));
        var name = target.name;
        if (type === 'radio' && name && isChecked) doc.querySelectorAll("input[type=\"radio\"][name=\"".concat(name, "\"]")).forEach(function(el) {
            if (el !== target) cbWithDedup(el, $00ee310cb3f8711d$var$wrapEventWithUserTriggeredFlag({
                text: el.value,
                isChecked: !isChecked,
                userTriggered: false
            }, userTriggeredOnInput));
        });
    }
    function cbWithDedup(target, v) {
        var lastInputValue = $00ee310cb3f8711d$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $00ee310cb3f8711d$var$lastInputValueMap.set(target, v);
            var id = mirror.getId(target);
            inputCb((0, $ab67e3fd78f640cb$export$18ce0697a983be9b)((0, $ab67e3fd78f640cb$export$18ce0697a983be9b)({}, v), {
                id: id
            }));
        }
    }
    var events = sampling.input === 'last' ? [
        'change'
    ] : [
        'input',
        'change'
    ];
    var handlers = events.map(function(eventName) {
        return (0, $29f3f202b3ae6fbc$export$af631764ddc44097)(eventName, eventHandler, doc);
    });
    var propertyDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    var hookProperties = [
        [
            HTMLInputElement.prototype,
            'value'
        ],
        [
            HTMLInputElement.prototype,
            'checked'
        ],
        [
            HTMLSelectElement.prototype,
            'value'
        ],
        [
            HTMLTextAreaElement.prototype,
            'value'
        ],
        [
            HTMLSelectElement.prototype,
            'selectedIndex'
        ],
        [
            HTMLOptionElement.prototype,
            'selected'
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push.apply(handlers, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(hookProperties.map(function(p) {
        return (0, $29f3f202b3ae6fbc$export$d80dc7d100d862ab)(p[0], p[1], {
            set: function() {
                eventHandler({
                    target: this
                });
            }
        });
    })), false));
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
function $00ee310cb3f8711d$var$getNestedCSSRulePositions(rule) {
    var positions = [];
    function recurse(childRule, pos) {
        if ($00ee310cb3f8711d$var$isCSSGroupingRuleSupported && childRule.parentRule instanceof CSSGroupingRule || $00ee310cb3f8711d$var$isCSSMediaRuleSupported && childRule.parentRule instanceof CSSMediaRule || $00ee310cb3f8711d$var$isCSSSupportsRuleSupported && childRule.parentRule instanceof CSSSupportsRule || $00ee310cb3f8711d$var$isCSSConditionRuleSupported && childRule.parentRule instanceof CSSConditionRule) {
            var rules = Array.from(childRule.parentRule.cssRules);
            var index = rules.indexOf(childRule);
            pos.unshift(index);
        } else {
            var rules = Array.from(childRule.parentStyleSheet.cssRules);
            var index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $00ee310cb3f8711d$var$initStyleSheetObserver(_a, _b) {
    var styleSheetRuleCb = _a.styleSheetRuleCb, mirror = _a.mirror;
    var win = _b.win;
    var insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = function(rule, index) {
        var id = mirror.getId(this.ownerNode);
        if (id !== -1) styleSheetRuleCb({
            id: id,
            adds: [
                {
                    rule: rule,
                    index: index
                }
            ]
        });
        return insertRule.apply(this, arguments);
    };
    var deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = function(index) {
        var id = mirror.getId(this.ownerNode);
        if (id !== -1) styleSheetRuleCb({
            id: id,
            removes: [
                {
                    index: index
                }
            ]
        });
        return deleteRule.apply(this, arguments);
    };
    var supportedNestedCSSRuleTypes = {};
    if ($00ee310cb3f8711d$var$isCSSGroupingRuleSupported) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($00ee310cb3f8711d$var$isCSSMediaRuleSupported) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($00ee310cb3f8711d$var$isCSSConditionRuleSupported) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($00ee310cb3f8711d$var$isCSSSupportsRuleSupported) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    var unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(function(_a) {
        var _b = (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(_a, 2), typeKey = _b[0], type = _b[1];
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = function(rule, index) {
            var id = mirror.getId(this.parentStyleSheet.ownerNode);
            if (id !== -1) styleSheetRuleCb({
                id: id,
                adds: [
                    {
                        rule: rule,
                        index: (0, $ab67e3fd78f640cb$export$1216008129fb82ed)((0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)($00ee310cb3f8711d$var$getNestedCSSRulePositions(this)), false), [
                            index || 0
                        ], false)
                    }
                ]
            });
            return unmodifiedFunctions[typeKey].insertRule.apply(this, arguments);
        };
        type.prototype.deleteRule = function(index) {
            var id = mirror.getId(this.parentStyleSheet.ownerNode);
            if (id !== -1) styleSheetRuleCb({
                id: id,
                removes: [
                    {
                        index: (0, $ab67e3fd78f640cb$export$1216008129fb82ed)((0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)($00ee310cb3f8711d$var$getNestedCSSRulePositions(this)), false), [
                            index
                        ], false)
                    }
                ]
            });
            return unmodifiedFunctions[typeKey].deleteRule.apply(this, arguments);
        };
    });
    return function() {
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        Object.entries(supportedNestedCSSRuleTypes).forEach(function(_a) {
            var _b = (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(_a, 2), typeKey = _b[0], type = _b[1];
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    };
}
function $00ee310cb3f8711d$var$initStyleDeclarationObserver(_a, _b) {
    var styleDeclarationCb = _a.styleDeclarationCb, mirror = _a.mirror;
    var win = _b.win;
    var setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = function(property, value, priority) {
        var _a, _b;
        var id = mirror.getId((_b = (_a = this.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet) === null || _b === void 0 ? void 0 : _b.ownerNode);
        if (id !== -1) styleDeclarationCb({
            id: id,
            set: {
                property: property,
                value: value,
                priority: priority
            },
            index: $00ee310cb3f8711d$var$getNestedCSSRulePositions(this.parentRule)
        });
        return setProperty.apply(this, arguments);
    };
    var removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = function(property) {
        var _a, _b;
        var id = mirror.getId((_b = (_a = this.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet) === null || _b === void 0 ? void 0 : _b.ownerNode);
        if (id !== -1) styleDeclarationCb({
            id: id,
            remove: {
                property: property
            },
            index: $00ee310cb3f8711d$var$getNestedCSSRulePositions(this.parentRule)
        });
        return removeProperty.apply(this, arguments);
    };
    return function() {
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    };
}
function $00ee310cb3f8711d$var$initMediaInteractionObserver(_a) {
    var mediaInteractionCb = _a.mediaInteractionCb, blockClass = _a.blockClass, mirror = _a.mirror, sampling = _a.sampling;
    var handler = function(type) {
        return (0, $29f3f202b3ae6fbc$export$de363e709c412c8a)(function(event) {
            var target = $00ee310cb3f8711d$var$getEventTarget(event);
            if (!target || (0, $29f3f202b3ae6fbc$export$548f076b7581caed)(target, blockClass)) return;
            var _a = target, currentTime = _a.currentTime, volume = _a.volume, muted = _a.muted;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted
            });
        }, sampling.media || 500);
    };
    var handlers = [
        (0, $29f3f202b3ae6fbc$export$af631764ddc44097)('play', handler(0)),
        (0, $29f3f202b3ae6fbc$export$af631764ddc44097)('pause', handler(1)),
        (0, $29f3f202b3ae6fbc$export$af631764ddc44097)('seeked', handler(2)),
        (0, $29f3f202b3ae6fbc$export$af631764ddc44097)('volumechange', handler(3))
    ];
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
function $00ee310cb3f8711d$var$initFontObserver(_a) {
    var fontCb = _a.fontCb, doc = _a.doc;
    var win = doc.defaultView;
    if (!win) return function() {};
    var handlers = [];
    var fontMap = new WeakMap();
    var originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        var fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== 'string',
            descriptors: descriptors,
            fontSource: typeof source === 'string' ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    var restoreHandler = (0, $29f3f202b3ae6fbc$export$b76953f99ab2be78)(doc.fonts, 'add', function(original) {
        return function(fontFace) {
            setTimeout(function() {
                var p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }, 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(function() {
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
function $00ee310cb3f8711d$var$mergeHooks(o, hooks) {
    var mutationCb = o.mutationCb, mousemoveCb = o.mousemoveCb, mouseInteractionCb = o.mouseInteractionCb, scrollCb = o.scrollCb, viewportResizeCb = o.viewportResizeCb, inputCb = o.inputCb, mediaInteractionCb = o.mediaInteractionCb, styleSheetRuleCb = o.styleSheetRuleCb, styleDeclarationCb = o.styleDeclarationCb, canvasMutationCb = o.canvasMutationCb, fontCb = o.fontCb;
    o.mutationCb = function() {
        var p = [];
        for(var _i = 0; _i < arguments.length; _i++)p[_i] = arguments[_i];
        if (hooks.mutation) hooks.mutation.apply(hooks, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(p), false));
        mutationCb.apply(void 0, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(p), false));
    };
    o.mousemoveCb = function() {
        var p = [];
        for(var _i = 0; _i < arguments.length; _i++)p[_i] = arguments[_i];
        if (hooks.mousemove) hooks.mousemove.apply(hooks, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(p), false));
        mousemoveCb.apply(void 0, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(p), false));
    };
    o.mouseInteractionCb = function() {
        var p = [];
        for(var _i = 0; _i < arguments.length; _i++)p[_i] = arguments[_i];
        if (hooks.mouseInteraction) hooks.mouseInteraction.apply(hooks, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(p), false));
        mouseInteractionCb.apply(void 0, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(p), false));
    };
    o.scrollCb = function() {
        var p = [];
        for(var _i = 0; _i < arguments.length; _i++)p[_i] = arguments[_i];
        if (hooks.scroll) hooks.scroll.apply(hooks, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(p), false));
        scrollCb.apply(void 0, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(p), false));
    };
    o.viewportResizeCb = function() {
        var p = [];
        for(var _i = 0; _i < arguments.length; _i++)p[_i] = arguments[_i];
        if (hooks.viewportResize) hooks.viewportResize.apply(hooks, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(p), false));
        viewportResizeCb.apply(void 0, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(p), false));
    };
    o.inputCb = function() {
        var p = [];
        for(var _i = 0; _i < arguments.length; _i++)p[_i] = arguments[_i];
        if (hooks.input) hooks.input.apply(hooks, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(p), false));
        inputCb.apply(void 0, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(p), false));
    };
    o.mediaInteractionCb = function() {
        var p = [];
        for(var _i = 0; _i < arguments.length; _i++)p[_i] = arguments[_i];
        if (hooks.mediaInteaction) hooks.mediaInteaction.apply(hooks, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(p), false));
        mediaInteractionCb.apply(void 0, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(p), false));
    };
    o.styleSheetRuleCb = function() {
        var p = [];
        for(var _i = 0; _i < arguments.length; _i++)p[_i] = arguments[_i];
        if (hooks.styleSheetRule) hooks.styleSheetRule.apply(hooks, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(p), false));
        styleSheetRuleCb.apply(void 0, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(p), false));
    };
    o.styleDeclarationCb = function() {
        var p = [];
        for(var _i = 0; _i < arguments.length; _i++)p[_i] = arguments[_i];
        if (hooks.styleDeclaration) hooks.styleDeclaration.apply(hooks, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(p), false));
        styleDeclarationCb.apply(void 0, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(p), false));
    };
    o.canvasMutationCb = function() {
        var p = [];
        for(var _i = 0; _i < arguments.length; _i++)p[_i] = arguments[_i];
        if (hooks.canvasMutation) hooks.canvasMutation.apply(hooks, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(p), false));
        canvasMutationCb.apply(void 0, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(p), false));
    };
    o.fontCb = function() {
        var p = [];
        for(var _i = 0; _i < arguments.length; _i++)p[_i] = arguments[_i];
        if (hooks.font) hooks.font.apply(hooks, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(p), false));
        fontCb.apply(void 0, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(p), false));
    };
}
function $00ee310cb3f8711d$export$7cb79bd6aa7dcd4d(o, hooks) {
    var e_1, _a;
    if (hooks === void 0) hooks = {};
    var currentWindow = o.doc.defaultView;
    if (!currentWindow) return function() {};
    $00ee310cb3f8711d$var$mergeHooks(o, hooks);
    var mutationObserver = $00ee310cb3f8711d$export$b21bab7142e10832(o, o.doc);
    var mousemoveHandler = $00ee310cb3f8711d$var$initMoveObserver(o);
    var mouseInteractionHandler = $00ee310cb3f8711d$var$initMouseInteractionObserver(o);
    var scrollHandler = $00ee310cb3f8711d$export$7b5afab92e22e83a(o);
    var viewportResizeHandler = $00ee310cb3f8711d$var$initViewportResizeObserver(o);
    var inputHandler = $00ee310cb3f8711d$var$initInputObserver(o);
    var mediaInteractionHandler = $00ee310cb3f8711d$var$initMediaInteractionObserver(o);
    var styleSheetObserver = $00ee310cb3f8711d$var$initStyleSheetObserver(o, {
        win: currentWindow
    });
    var styleDeclarationObserver = $00ee310cb3f8711d$var$initStyleDeclarationObserver(o, {
        win: currentWindow
    });
    var fontObserver = o.collectFonts ? $00ee310cb3f8711d$var$initFontObserver(o) : function() {};
    var pluginHandlers = [];
    try {
        for(var _b = (0, $ab67e3fd78f640cb$export$19a8beecd37a4c45)(o.plugins), _c = _b.next(); !_c.done; _c = _b.next()){
            var plugin = _c.value;
            pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return function() {
        $00ee310cb3f8711d$export$74a0db8061aafa7c.forEach(function(b) {
            return b.reset();
        });
        mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        pluginHandlers.forEach(function(h) {
            return h();
        });
    };
}




var $61bd5d38d8b57b33$export$400ead150bbd22b4 = function() {
    function IframeManager(options) {
        this.iframes = new WeakMap();
        this.mutationCb = options.mutationCb;
    }
    IframeManager.prototype.addIframe = function(iframeEl) {
        this.iframes.set(iframeEl, true);
    };
    IframeManager.prototype.addLoadListener = function(cb) {
        this.loadListener = cb;
    };
    IframeManager.prototype.attachIframe = function(iframeEl, childSn) {
        var _a;
        this.mutationCb({
            adds: [
                {
                    parentId: iframeEl.__sn.id,
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        (_a = this.loadListener) === null || _a === void 0 || _a.call(this, iframeEl);
    };
    return IframeManager;
}();





var $fd877a955dfca900$export$7230f7151b45af61 = function() {
    function ShadowDomManager(options) {
        this.restorePatches = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        var manager = this;
        this.restorePatches.push((0, $29f3f202b3ae6fbc$export$b76953f99ab2be78)(HTMLElement.prototype, 'attachShadow', function(original) {
            return function() {
                var shadowRoot = original.apply(this, arguments);
                if (this.shadowRoot) manager.addShadowRoot(this.shadowRoot, this.ownerDocument);
                return shadowRoot;
            };
        }));
    }
    ShadowDomManager.prototype.addShadowRoot = function(shadowRoot, doc) {
        (0, $00ee310cb3f8711d$export$b21bab7142e10832)((0, $ab67e3fd78f640cb$export$18ce0697a983be9b)((0, $ab67e3fd78f640cb$export$18ce0697a983be9b)({}, this.bypassOptions), {
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }), shadowRoot);
        (0, $00ee310cb3f8711d$export$7b5afab92e22e83a)((0, $ab67e3fd78f640cb$export$18ce0697a983be9b)((0, $ab67e3fd78f640cb$export$18ce0697a983be9b)({}, this.bypassOptions), {
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        }));
    };
    ShadowDomManager.prototype.observeAttachShadow = function(iframeElement) {
        if (iframeElement.contentWindow) {
            var manager_1 = this;
            this.restorePatches.push((0, $29f3f202b3ae6fbc$export$b76953f99ab2be78)(iframeElement.contentWindow.HTMLElement.prototype, 'attachShadow', function(original) {
                return function() {
                    var shadowRoot = original.apply(this, arguments);
                    if (this.shadowRoot) manager_1.addShadowRoot(this.shadowRoot, iframeElement.contentDocument);
                    return shadowRoot;
                };
            }));
        }
    };
    ShadowDomManager.prototype.reset = function() {
        this.restorePatches.forEach(function(restorePatch) {
            return restorePatch();
        });
    };
    return ShadowDomManager;
}();






function $46db59f5d546d419$var$initCanvas2DMutationObserver(cb, win, blockClass, mirror) {
    var e_1, _a;
    var handlers = [];
    var props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    var _loop_1 = function(prop) {
        try {
            if (typeof win.CanvasRenderingContext2D.prototype[prop] !== 'function') return "continue";
            var restoreHandler = (0, $29f3f202b3ae6fbc$export$b76953f99ab2be78)(win.CanvasRenderingContext2D.prototype, prop, function(original) {
                return function() {
                    var _this = this;
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    if (!(0, $29f3f202b3ae6fbc$export$548f076b7581caed)(this.canvas, blockClass)) setTimeout(function() {
                        var recordArgs = (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(args), false);
                        if (prop === 'drawImage') {
                            if (recordArgs[0] && recordArgs[0] instanceof HTMLCanvasElement) {
                                var canvas = recordArgs[0];
                                var ctx = canvas.getContext('2d');
                                var imgd = ctx === null || ctx === void 0 ? void 0 : ctx.getImageData(0, 0, canvas.width, canvas.height);
                                var pix = imgd === null || imgd === void 0 ? void 0 : imgd.data;
                                recordArgs[0] = JSON.stringify(pix);
                            }
                        }
                        cb(_this.canvas, {
                            type: (0, $490d855006fd9373$export$eefcd8ea59422f9d)['2D'],
                            property: prop,
                            args: recordArgs
                        });
                    }, 0);
                    return original.apply(this, args);
                };
            });
            handlers.push(restoreHandler);
        } catch (_b) {
            var hookHandler = (0, $29f3f202b3ae6fbc$export$d80dc7d100d862ab)(win.CanvasRenderingContext2D.prototype, prop, {
                set: function(v) {
                    cb(this.canvas, {
                        type: (0, $490d855006fd9373$export$eefcd8ea59422f9d)['2D'],
                        property: prop,
                        args: [
                            v
                        ],
                        setter: true
                    });
                }
            });
            handlers.push(hookHandler);
        }
    };
    try {
        for(var props2D_1 = (0, $ab67e3fd78f640cb$export$19a8beecd37a4c45)(props2D), props2D_1_1 = props2D_1.next(); !props2D_1_1.done; props2D_1_1 = props2D_1.next()){
            var prop = props2D_1_1.value;
            _loop_1(prop);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (props2D_1_1 && !props2D_1_1.done && (_a = props2D_1.return)) _a.call(props2D_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
var $46db59f5d546d419$export$2e2bcd8739ae039 = $46db59f5d546d419$var$initCanvas2DMutationObserver;




function $b4a0e578c30cf394$var$initCanvasContextObserver(win, blockClass) {
    var handlers = [];
    try {
        var restoreHandler = (0, $29f3f202b3ae6fbc$export$b76953f99ab2be78)(win.HTMLCanvasElement.prototype, 'getContext', function(original) {
            return function(contextType) {
                var args = [];
                for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                if (!(0, $29f3f202b3ae6fbc$export$548f076b7581caed)(this, blockClass)) {
                    if (!('__context' in this)) this.__context = contextType;
                }
                return original.apply(this, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([
                    contextType
                ], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(args), false));
            };
        });
        handlers.push(restoreHandler);
    } catch (_a) {
        console.error('failed to patch HTMLCanvasElement.prototype.getContext');
    }
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
var $b4a0e578c30cf394$export$2e2bcd8739ae039 = $b4a0e578c30cf394$var$initCanvasContextObserver;






/*
 * base64-arraybuffer 1.0.1 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ var $ee9364d93dacc1d0$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var $ee9364d93dacc1d0$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(var $ee9364d93dacc1d0$var$i = 0; $ee9364d93dacc1d0$var$i < $ee9364d93dacc1d0$var$chars.length; $ee9364d93dacc1d0$var$i++)$ee9364d93dacc1d0$var$lookup[$ee9364d93dacc1d0$var$chars.charCodeAt($ee9364d93dacc1d0$var$i)] = $ee9364d93dacc1d0$var$i;
var $ee9364d93dacc1d0$export$c564cdbbe6da493 = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $ee9364d93dacc1d0$var$chars[bytes[i] >> 2];
        base64 += $ee9364d93dacc1d0$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $ee9364d93dacc1d0$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $ee9364d93dacc1d0$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
var $ee9364d93dacc1d0$export$2f872c0f2117be69 = function(base64) {
    var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    var arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $ee9364d93dacc1d0$var$lookup[base64.charCodeAt(i)];
        encoded2 = $ee9364d93dacc1d0$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $ee9364d93dacc1d0$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $ee9364d93dacc1d0$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};


var $7f2de7704a617628$var$webGLVarMap = new Map();
function $7f2de7704a617628$export$bcb32feaea389632(ctx, ctor) {
    var contextMap = $7f2de7704a617628$var$webGLVarMap.get(ctx);
    if (!contextMap) {
        contextMap = new Map();
        $7f2de7704a617628$var$webGLVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) contextMap.set(ctor, []);
    return contextMap.get(ctor);
}
var $7f2de7704a617628$export$83fc63e798ed818e = function(value, win, ctx) {
    if (!value || !($7f2de7704a617628$export$51c48d2c709935db(value, win) || typeof value === 'object')) return;
    var name = value.constructor.name;
    var list = $7f2de7704a617628$export$bcb32feaea389632(ctx, name);
    var index = list.indexOf(value);
    if (index === -1) {
        index = list.length;
        list.push(value);
    }
    return index;
};
function $7f2de7704a617628$export$3cd9720e5a96e0bd(value, win, ctx) {
    if (value instanceof Array) return value.map(function(arg) {
        return $7f2de7704a617628$export$3cd9720e5a96e0bd(arg, win, ctx);
    });
    else if (value === null) return value;
    else if (value instanceof Float32Array || value instanceof Float64Array || value instanceof Int32Array || value instanceof Uint32Array || value instanceof Uint8Array || value instanceof Uint16Array || value instanceof Int16Array || value instanceof Int8Array || value instanceof Uint8ClampedArray) {
        var name_1 = value.constructor.name;
        return {
            rr_type: name_1,
            args: [
                Object.values(value)
            ]
        };
    } else if (value instanceof ArrayBuffer) {
        var name_2 = value.constructor.name;
        var base64 = (0, $ee9364d93dacc1d0$export$c564cdbbe6da493)(value);
        return {
            rr_type: name_2,
            base64: base64
        };
    } else if (value instanceof DataView) {
        var name_3 = value.constructor.name;
        return {
            rr_type: name_3,
            args: [
                $7f2de7704a617628$export$3cd9720e5a96e0bd(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength
            ]
        };
    } else if (value instanceof HTMLImageElement) {
        var name_4 = value.constructor.name;
        var src = value.src;
        return {
            rr_type: name_4,
            src: src
        };
    } else if (value instanceof ImageData) {
        var name_5 = value.constructor.name;
        return {
            rr_type: name_5,
            args: [
                $7f2de7704a617628$export$3cd9720e5a96e0bd(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if ($7f2de7704a617628$export$51c48d2c709935db(value, win) || typeof value === 'object') {
        var name_6 = value.constructor.name;
        var index = $7f2de7704a617628$export$83fc63e798ed818e(value, win, ctx);
        return {
            rr_type: name_6,
            index: index
        };
    }
    return value;
}
var $7f2de7704a617628$export$79f4f158cfc0938d = function(args, win, ctx) {
    return (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(args), false).map(function(arg) {
        return $7f2de7704a617628$export$3cd9720e5a96e0bd(arg, win, ctx);
    });
};
var $7f2de7704a617628$export$51c48d2c709935db = function(value, win) {
    var webGLConstructorNames = [
        'WebGLActiveInfo',
        'WebGLBuffer',
        'WebGLFramebuffer',
        'WebGLProgram',
        'WebGLRenderbuffer',
        'WebGLShader',
        'WebGLShaderPrecisionFormat',
        'WebGLTexture',
        'WebGLUniformLocation',
        'WebGLVertexArrayObject',
        'WebGLVertexArrayObjectOES'
    ];
    var supportedWebGLConstructorNames = webGLConstructorNames.filter(function(name) {
        return typeof win[name] === 'function';
    });
    return Boolean(supportedWebGLConstructorNames.find(function(name) {
        return value instanceof win[name];
    }));
};


function $0c0fb4afc7bbc1e7$var$patchGLPrototype(prototype, type, cb, blockClass, mirror, win) {
    var e_1, _a;
    var handlers = [];
    var props = Object.getOwnPropertyNames(prototype);
    var _loop_1 = function(prop) {
        try {
            if (typeof prototype[prop] !== 'function') return "continue";
            var restoreHandler = (0, $29f3f202b3ae6fbc$export$b76953f99ab2be78)(prototype, prop, function(original) {
                return function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var result = original.apply(this, args);
                    (0, $7f2de7704a617628$export$83fc63e798ed818e)(result, win, prototype);
                    if (!(0, $29f3f202b3ae6fbc$export$548f076b7581caed)(this.canvas, blockClass)) {
                        var id = mirror.getId(this.canvas);
                        var recordArgs = (0, $7f2de7704a617628$export$79f4f158cfc0938d)((0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)(args), false), win, prototype);
                        var mutation = {
                            type: type,
                            property: prop,
                            args: recordArgs
                        };
                        cb(this.canvas, mutation);
                    }
                    return result;
                };
            });
            handlers.push(restoreHandler);
        } catch (_b) {
            var hookHandler = (0, $29f3f202b3ae6fbc$export$d80dc7d100d862ab)(prototype, prop, {
                set: function(v) {
                    cb(this.canvas, {
                        type: type,
                        property: prop,
                        args: [
                            v
                        ],
                        setter: true
                    });
                }
            });
            handlers.push(hookHandler);
        }
    };
    try {
        for(var props_1 = (0, $ab67e3fd78f640cb$export$19a8beecd37a4c45)(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()){
            var prop = props_1_1.value;
            _loop_1(prop);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return handlers;
}
function $0c0fb4afc7bbc1e7$var$initCanvasWebGLMutationObserver(cb, win, blockClass, mirror) {
    var handlers = [];
    handlers.push.apply(handlers, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)($0c0fb4afc7bbc1e7$var$patchGLPrototype(win.WebGLRenderingContext.prototype, (0, $490d855006fd9373$export$eefcd8ea59422f9d).WebGL, cb, blockClass, mirror, win)), false));
    if (typeof win.WebGL2RenderingContext !== 'undefined') handlers.push.apply(handlers, (0, $ab67e3fd78f640cb$export$1216008129fb82ed)([], (0, $ab67e3fd78f640cb$export$8d051b38c9118094)($0c0fb4afc7bbc1e7$var$patchGLPrototype(win.WebGL2RenderingContext.prototype, (0, $490d855006fd9373$export$eefcd8ea59422f9d).WebGL2, cb, blockClass, mirror, win)), false));
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
var $0c0fb4afc7bbc1e7$export$2e2bcd8739ae039 = $0c0fb4afc7bbc1e7$var$initCanvasWebGLMutationObserver;


var $888a716c4c9ed4de$export$4ee6706e93ed0e72 = function() {
    function CanvasManager(options) {
        this.pendingCanvasMutations = new Map();
        this.rafStamps = {
            latestId: 0,
            invokeId: null
        };
        this.frozen = false;
        this.locked = false;
        this.processMutation = function(target, mutation) {
            var newFrame = this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId;
            if (newFrame || !this.rafStamps.invokeId) this.rafStamps.invokeId = this.rafStamps.latestId;
            if (!this.pendingCanvasMutations.has(target)) this.pendingCanvasMutations.set(target, []);
            this.pendingCanvasMutations.get(target).push(mutation);
        };
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        if (options.recordCanvas === true) this.initCanvasMutationObserver(options.win, options.blockClass);
    }
    CanvasManager.prototype.reset = function() {
        this.pendingCanvasMutations.clear();
        this.resetObservers && this.resetObservers();
    };
    CanvasManager.prototype.freeze = function() {
        this.frozen = true;
    };
    CanvasManager.prototype.unfreeze = function() {
        this.frozen = false;
    };
    CanvasManager.prototype.lock = function() {
        this.locked = true;
    };
    CanvasManager.prototype.unlock = function() {
        this.locked = false;
    };
    CanvasManager.prototype.initCanvasMutationObserver = function(win, blockClass) {
        this.startRAFTimestamping();
        this.startPendingCanvasMutationFlusher();
        var canvasContextReset = (0, $b4a0e578c30cf394$export$2e2bcd8739ae039)(win, blockClass);
        var canvas2DReset = (0, $46db59f5d546d419$export$2e2bcd8739ae039)(this.processMutation.bind(this), win, blockClass, this.mirror);
        var canvasWebGL1and2Reset = (0, $0c0fb4afc7bbc1e7$export$2e2bcd8739ae039)(this.processMutation.bind(this), win, blockClass, this.mirror);
        this.resetObservers = function() {
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        };
    };
    CanvasManager.prototype.startPendingCanvasMutationFlusher = function() {
        var _this = this;
        requestAnimationFrame(function() {
            return _this.flushPendingCanvasMutations();
        });
    };
    CanvasManager.prototype.startRAFTimestamping = function() {
        var _this = this;
        var setLatestRAFTimestamp = function(timestamp) {
            _this.rafStamps.latestId = timestamp;
            requestAnimationFrame(setLatestRAFTimestamp);
        };
        requestAnimationFrame(setLatestRAFTimestamp);
    };
    CanvasManager.prototype.flushPendingCanvasMutations = function() {
        var _this = this;
        this.pendingCanvasMutations.forEach(function(values, canvas) {
            var id = _this.mirror.getId(canvas);
            _this.flushPendingCanvasMutationFor(canvas, id);
        });
        requestAnimationFrame(function() {
            return _this.flushPendingCanvasMutations();
        });
    };
    CanvasManager.prototype.flushPendingCanvasMutationFor = function(canvas, id) {
        if (this.frozen || this.locked) return;
        var valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1) return;
        var values = valuesWithType.map(function(value) {
            value.type;
            var rest = (0, $ab67e3fd78f640cb$export$3c9a16f847548506)(value, [
                "type"
            ]);
            return rest;
        });
        var type = valuesWithType[0].type;
        this.mutationCb({
            id: id,
            type: type,
            commands: values
        });
        this.pendingCanvasMutations.delete(canvas);
    };
    return CanvasManager;
}();


function $074a3ce417f53d15$var$wrapEvent(e) {
    return (0, $ab67e3fd78f640cb$export$18ce0697a983be9b)((0, $ab67e3fd78f640cb$export$18ce0697a983be9b)({}, e), {
        timestamp: Date.now()
    });
}
var $074a3ce417f53d15$var$wrappedEmit;
var $074a3ce417f53d15$var$takeFullSnapshot;
var $074a3ce417f53d15$var$mirror = (0, $29f3f202b3ae6fbc$export$b307838285d1a62e)();
function $074a3ce417f53d15$var$record(options) {
    if (options === void 0) options = {};
    var emit = options.emit, checkoutEveryNms = options.checkoutEveryNms, checkoutEveryNth = options.checkoutEveryNth, _a = options.blockClass, blockClass = _a === void 0 ? 'rr-block' : _a, _b = options.blockSelector, blockSelector = _b === void 0 ? null : _b, _c = options.ignoreClass, ignoreClass = _c === void 0 ? 'rr-ignore' : _c, _d = options.maskTextClass, maskTextClass = _d === void 0 ? 'rr-mask' : _d, _e = options.maskTextSelector, maskTextSelector = _e === void 0 ? null : _e, _f = options.inlineStylesheet, inlineStylesheet = _f === void 0 ? true : _f, maskAllInputs = options.maskAllInputs, _maskInputOptions = options.maskInputOptions, _slimDOMOptions = options.slimDOMOptions, maskInputFn = options.maskInputFn, maskTextFn = options.maskTextFn, hooks = options.hooks, packFn = options.packFn, _g = options.sampling, sampling = _g === void 0 ? {} : _g, mousemoveWait = options.mousemoveWait, _h = options.recordCanvas, recordCanvas = _h === void 0 ? false : _h, _j = options.userTriggeredOnInput, userTriggeredOnInput = _j === void 0 ? false : _j, _k = options.collectFonts, collectFonts = _k === void 0 ? false : _k, _l = options.inlineImages, inlineImages = _l === void 0 ? false : _l, plugins = options.plugins, _m = options.keepIframeSrcFn, keepIframeSrcFn = _m === void 0 ? function() {
        return false;
    } : _m;
    if (!emit) throw new Error('emit function is required');
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    var maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        password: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {
        password: true
    };
    var slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === 'all' ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === 'all',
        headMetaDescKeywords: _slimDOMOptions === 'all'
    } : _slimDOMOptions ? _slimDOMOptions : {};
    (0, $29f3f202b3ae6fbc$export$cea1c58a6db52bca)();
    var lastFullSnapshotEvent;
    var incrementalSnapshotCount = 0;
    var eventProcessor = function(e) {
        var e_1, _a;
        try {
            for(var _b = (0, $ab67e3fd78f640cb$export$19a8beecd37a4c45)(plugins || []), _c = _b.next(); !_c.done; _c = _b.next()){
                var plugin = _c.value;
                if (plugin.eventProcessor) e = plugin.eventProcessor(e);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        if (packFn) e = packFn(e);
        return e;
    };
    $074a3ce417f53d15$var$wrappedEmit = function(e, isCheckout) {
        var _a;
        if (((_a = (0, $00ee310cb3f8711d$export$74a0db8061aafa7c)[0]) === null || _a === void 0 ? void 0 : _a.isFrozen()) && e.type !== (0, $490d855006fd9373$export$3d7865934588d77e).FullSnapshot && !(e.type === (0, $490d855006fd9373$export$3d7865934588d77e).IncrementalSnapshot && e.data.source === (0, $490d855006fd9373$export$24bb3ebc067ff5e1).Mutation)) (0, $00ee310cb3f8711d$export$74a0db8061aafa7c).forEach(function(buf) {
            return buf.unfreeze();
        });
        emit(eventProcessor(e), isCheckout);
        if (e.type === (0, $490d855006fd9373$export$3d7865934588d77e).FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === (0, $490d855006fd9373$export$3d7865934588d77e).IncrementalSnapshot) {
            if (e.data.source === (0, $490d855006fd9373$export$24bb3ebc067ff5e1).Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            var exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            var exceedTime = checkoutEveryNms && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) $074a3ce417f53d15$var$takeFullSnapshot(true);
        }
    };
    var wrappedMutationEmit = function(m) {
        $074a3ce417f53d15$var$wrappedEmit($074a3ce417f53d15$var$wrapEvent({
            type: (0, $490d855006fd9373$export$3d7865934588d77e).IncrementalSnapshot,
            data: (0, $ab67e3fd78f640cb$export$18ce0697a983be9b)({
                source: (0, $490d855006fd9373$export$24bb3ebc067ff5e1).Mutation
            }, m)
        }));
    };
    var wrappedScrollEmit = function(p) {
        return $074a3ce417f53d15$var$wrappedEmit($074a3ce417f53d15$var$wrapEvent({
            type: (0, $490d855006fd9373$export$3d7865934588d77e).IncrementalSnapshot,
            data: (0, $ab67e3fd78f640cb$export$18ce0697a983be9b)({
                source: (0, $490d855006fd9373$export$24bb3ebc067ff5e1).Scroll
            }, p)
        }));
    };
    var wrappedCanvasMutationEmit = function(p) {
        return $074a3ce417f53d15$var$wrappedEmit($074a3ce417f53d15$var$wrapEvent({
            type: (0, $490d855006fd9373$export$3d7865934588d77e).IncrementalSnapshot,
            data: (0, $ab67e3fd78f640cb$export$18ce0697a983be9b)({
                source: (0, $490d855006fd9373$export$24bb3ebc067ff5e1).CanvasMutation
            }, p)
        }));
    };
    var iframeManager = new (0, $61bd5d38d8b57b33$export$400ead150bbd22b4)({
        mutationCb: wrappedMutationEmit
    });
    var canvasManager = new (0, $888a716c4c9ed4de$export$4ee6706e93ed0e72)({
        recordCanvas: recordCanvas,
        mutationCb: wrappedCanvasMutationEmit,
        win: window,
        blockClass: blockClass,
        mirror: $074a3ce417f53d15$var$mirror
    });
    var shadowDomManager = new (0, $fd877a955dfca900$export$7230f7151b45af61)({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            canvasManager: canvasManager
        },
        mirror: $074a3ce417f53d15$var$mirror
    });
    $074a3ce417f53d15$var$takeFullSnapshot = function(isCheckout) {
        var _a, _b, _c, _d;
        if (isCheckout === void 0) isCheckout = false;
        $074a3ce417f53d15$var$wrappedEmit($074a3ce417f53d15$var$wrapEvent({
            type: (0, $490d855006fd9373$export$3d7865934588d77e).Meta,
            data: {
                href: window.location.href,
                width: (0, $29f3f202b3ae6fbc$export$91cf85d6c980faa0)(),
                height: (0, $29f3f202b3ae6fbc$export$a3648dbc3769cbf4)()
            }
        }), isCheckout);
        (0, $00ee310cb3f8711d$export$74a0db8061aafa7c).forEach(function(buf) {
            return buf.lock();
        });
        var _e = (0, $ab67e3fd78f640cb$export$8d051b38c9118094)((0, $0b6f1a86dae6b1f9$export$b8801ea43165ed7d)(document, {
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: function(n) {
                if ((0, $29f3f202b3ae6fbc$export$5fbba895fb12280c)(n)) iframeManager.addIframe(n);
                if ((0, $29f3f202b3ae6fbc$export$e4bead7f22725bce)(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: function(iframe, childSn) {
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            keepIframeSrcFn: keepIframeSrcFn
        }), 2), node = _e[0], idNodeMap = _e[1];
        if (!node) return console.warn('Failed to snapshot the document');
        $074a3ce417f53d15$var$mirror.map = idNodeMap;
        $074a3ce417f53d15$var$wrappedEmit($074a3ce417f53d15$var$wrapEvent({
            type: (0, $490d855006fd9373$export$3d7865934588d77e).FullSnapshot,
            data: {
                node: node,
                initialOffset: {
                    left: window.pageXOffset !== undefined ? window.pageXOffset : (document === null || document === void 0 ? void 0 : document.documentElement.scrollLeft) || ((_b = (_a = document === null || document === void 0 ? void 0 : document.body) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.scrollLeft) || (document === null || document === void 0 ? void 0 : document.body.scrollLeft) || 0,
                    top: window.pageYOffset !== undefined ? window.pageYOffset : (document === null || document === void 0 ? void 0 : document.documentElement.scrollTop) || ((_d = (_c = document === null || document === void 0 ? void 0 : document.body) === null || _c === void 0 ? void 0 : _c.parentElement) === null || _d === void 0 ? void 0 : _d.scrollTop) || (document === null || document === void 0 ? void 0 : document.body.scrollTop) || 0
                }
            }
        }));
        (0, $00ee310cb3f8711d$export$74a0db8061aafa7c).forEach(function(buf) {
            return buf.unlock();
        });
    };
    try {
        var handlers_1 = [];
        handlers_1.push((0, $29f3f202b3ae6fbc$export$af631764ddc44097)('DOMContentLoaded', function() {
            $074a3ce417f53d15$var$wrappedEmit($074a3ce417f53d15$var$wrapEvent({
                type: (0, $490d855006fd9373$export$3d7865934588d77e).DomContentLoaded,
                data: {}
            }));
        }));
        var observe_1 = function(doc) {
            var _a;
            return (0, $00ee310cb3f8711d$export$7cb79bd6aa7dcd4d)({
                mutationCb: wrappedMutationEmit,
                mousemoveCb: function(positions, source) {
                    return $074a3ce417f53d15$var$wrappedEmit($074a3ce417f53d15$var$wrapEvent({
                        type: (0, $490d855006fd9373$export$3d7865934588d77e).IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    }));
                },
                mouseInteractionCb: function(d) {
                    return $074a3ce417f53d15$var$wrappedEmit($074a3ce417f53d15$var$wrapEvent({
                        type: (0, $490d855006fd9373$export$3d7865934588d77e).IncrementalSnapshot,
                        data: (0, $ab67e3fd78f640cb$export$18ce0697a983be9b)({
                            source: (0, $490d855006fd9373$export$24bb3ebc067ff5e1).MouseInteraction
                        }, d)
                    }));
                },
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: function(d) {
                    return $074a3ce417f53d15$var$wrappedEmit($074a3ce417f53d15$var$wrapEvent({
                        type: (0, $490d855006fd9373$export$3d7865934588d77e).IncrementalSnapshot,
                        data: (0, $ab67e3fd78f640cb$export$18ce0697a983be9b)({
                            source: (0, $490d855006fd9373$export$24bb3ebc067ff5e1).ViewportResize
                        }, d)
                    }));
                },
                inputCb: function(v) {
                    return $074a3ce417f53d15$var$wrappedEmit($074a3ce417f53d15$var$wrapEvent({
                        type: (0, $490d855006fd9373$export$3d7865934588d77e).IncrementalSnapshot,
                        data: (0, $ab67e3fd78f640cb$export$18ce0697a983be9b)({
                            source: (0, $490d855006fd9373$export$24bb3ebc067ff5e1).Input
                        }, v)
                    }));
                },
                mediaInteractionCb: function(p) {
                    return $074a3ce417f53d15$var$wrappedEmit($074a3ce417f53d15$var$wrapEvent({
                        type: (0, $490d855006fd9373$export$3d7865934588d77e).IncrementalSnapshot,
                        data: (0, $ab67e3fd78f640cb$export$18ce0697a983be9b)({
                            source: (0, $490d855006fd9373$export$24bb3ebc067ff5e1).MediaInteraction
                        }, p)
                    }));
                },
                styleSheetRuleCb: function(r) {
                    return $074a3ce417f53d15$var$wrappedEmit($074a3ce417f53d15$var$wrapEvent({
                        type: (0, $490d855006fd9373$export$3d7865934588d77e).IncrementalSnapshot,
                        data: (0, $ab67e3fd78f640cb$export$18ce0697a983be9b)({
                            source: (0, $490d855006fd9373$export$24bb3ebc067ff5e1).StyleSheetRule
                        }, r)
                    }));
                },
                styleDeclarationCb: function(r) {
                    return $074a3ce417f53d15$var$wrappedEmit($074a3ce417f53d15$var$wrapEvent({
                        type: (0, $490d855006fd9373$export$3d7865934588d77e).IncrementalSnapshot,
                        data: (0, $ab67e3fd78f640cb$export$18ce0697a983be9b)({
                            source: (0, $490d855006fd9373$export$24bb3ebc067ff5e1).StyleDeclaration
                        }, r)
                    }));
                },
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: function(p) {
                    return $074a3ce417f53d15$var$wrappedEmit($074a3ce417f53d15$var$wrapEvent({
                        type: (0, $490d855006fd9373$export$3d7865934588d77e).IncrementalSnapshot,
                        data: (0, $ab67e3fd78f640cb$export$18ce0697a983be9b)({
                            source: (0, $490d855006fd9373$export$24bb3ebc067ff5e1).Font
                        }, p)
                    }));
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                blockSelector: blockSelector,
                slimDOMOptions: slimDOMOptions,
                mirror: $074a3ce417f53d15$var$mirror,
                iframeManager: iframeManager,
                shadowDomManager: shadowDomManager,
                canvasManager: canvasManager,
                plugins: ((_a = plugins === null || plugins === void 0 ? void 0 : plugins.filter(function(p) {
                    return p.observer;
                })) === null || _a === void 0 ? void 0 : _a.map(function(p) {
                    return {
                        observer: p.observer,
                        options: p.options,
                        callback: function(payload) {
                            return $074a3ce417f53d15$var$wrappedEmit($074a3ce417f53d15$var$wrapEvent({
                                type: (0, $490d855006fd9373$export$3d7865934588d77e).Plugin,
                                data: {
                                    plugin: p.name,
                                    payload: payload
                                }
                            }));
                        }
                    };
                })) || []
            }, hooks);
        };
        iframeManager.addLoadListener(function(iframeEl) {
            handlers_1.push(observe_1(iframeEl.contentDocument));
        });
        var init_1 = function() {
            $074a3ce417f53d15$var$takeFullSnapshot();
            handlers_1.push(observe_1(document));
        };
        if (document.readyState === 'interactive' || document.readyState === 'complete') init_1();
        else handlers_1.push((0, $29f3f202b3ae6fbc$export$af631764ddc44097)('load', function() {
            $074a3ce417f53d15$var$wrappedEmit($074a3ce417f53d15$var$wrapEvent({
                type: (0, $490d855006fd9373$export$3d7865934588d77e).Load,
                data: {}
            }));
            init_1();
        }, window));
        return function() {
            handlers_1.forEach(function(h) {
                return h();
            });
        };
    } catch (error) {
        console.warn(error);
    }
}
$074a3ce417f53d15$var$record.addCustomEvent = function(tag, payload) {
    if (!$074a3ce417f53d15$var$wrappedEmit) throw new Error('please add custom event after start recording');
    $074a3ce417f53d15$var$wrappedEmit($074a3ce417f53d15$var$wrapEvent({
        type: (0, $490d855006fd9373$export$3d7865934588d77e).Custom,
        data: {
            tag: tag,
            payload: payload
        }
    }));
};
$074a3ce417f53d15$var$record.freezePage = function() {
    (0, $00ee310cb3f8711d$export$74a0db8061aafa7c).forEach(function(buf) {
        return buf.freeze();
    });
};
$074a3ce417f53d15$var$record.takeFullSnapshot = function(isCheckout) {
    if (!$074a3ce417f53d15$var$takeFullSnapshot) throw new Error('please take full snapshot after start recording');
    $074a3ce417f53d15$var$takeFullSnapshot(isCheckout);
};
$074a3ce417f53d15$var$record.mirror = $074a3ce417f53d15$var$mirror;
var $074a3ce417f53d15$export$2e2bcd8739ae039 = $074a3ce417f53d15$var$record;



var $la2Of = parcelRequire("la2Of");
var $gUaXH = parcelRequire("gUaXH");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ var $9d2a72deec55a3e4$var$__assign = function() {
    $9d2a72deec55a3e4$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9d2a72deec55a3e4$var$__assign.apply(this, arguments);
};
function $9d2a72deec55a3e4$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var $9d2a72deec55a3e4$var$SentryRRWeb = /** @class */ function() {
    function SentryRRWeb(_a) {
        var _this = this;
        if (_a === void 0) _a = {};
        var _b = _a.checkoutEveryNms, checkoutEveryNms = _b === void 0 ? 300000 : _b, _c = _a.maskAllInputs, maskAllInputs = _c === void 0 ? true : _c, recordOptions = $9d2a72deec55a3e4$var$__rest(_a, [
            "checkoutEveryNms",
            "maskAllInputs"
        ]);
        this.name = SentryRRWeb.id;
        this.events = [];
        // default checkout time of 5 minutes
        this.recordOptions = $9d2a72deec55a3e4$var$__assign({
            checkoutEveryNms: checkoutEveryNms,
            maskAllInputs: maskAllInputs
        }, recordOptions);
        this.events = [];
        (0, $074a3ce417f53d15$export$2e2bcd8739ae039)($9d2a72deec55a3e4$var$__assign($9d2a72deec55a3e4$var$__assign({}, this.recordOptions), {
            emit: function(event, isCheckout) {
                if (isCheckout) _this.events = [
                    event
                ];
                else _this.events.push(event);
            }
        }));
    }
    SentryRRWeb.prototype.setupOnce = function() {
        var _this = this;
        (0, $la2Of.addGlobalEventProcessor)(function(event) {
            return _this.processEvent(event);
        });
    };
    // In version 6.10 of the JS SDK, `dsn.publicKey` was introduced to replace
    // `dsn.user`, and in version 7.0.0, `dsn.user` was removed. Further, 7.0.0
    // removed the `Dsn` type in favor of the `DsnComponents` type. Since for now
    // our peer dependency is marked as >=4.0.0, we type `dsn` as `any` and look
    // for both properties, to cover our bases as much as possible.
    SentryRRWeb.prototype.attachmentUrlFromDsn = function(dsn, eventId) {
        var host = dsn.host, path = dsn.path, projectId = dsn.projectId, port = dsn.port, protocol = dsn.protocol;
        var publicKey = dsn.publicKey || dsn.user;
        return protocol + "://" + host + (port !== '' ? ":" + port : '') + (path !== '' ? "/" + path : '') + "/api/" + projectId + "/events/" + eventId + "/attachments/?sentry_key=" + publicKey + "&sentry_version=7&sentry_client=rrweb";
    };
    SentryRRWeb.prototype.processEvent = function(event) {
        var self = (0, $gUaXH.getCurrentHub)().getIntegration(SentryRRWeb);
        if (!self) return;
        try {
            // short circuit if theres no events to replay
            if (!this.events.length) return;
            var client = (0, $gUaXH.getCurrentHub)().getClient();
            var endpoint = self.attachmentUrlFromDsn(client.getDsn(), event.event_id);
            var formData = new FormData();
            formData.append('rrweb', new Blob([
                JSON.stringify({
                    events: self.events
                })
            ], {
                type: 'application/json'
            }), 'rrweb.json');
            fetch(endpoint, {
                method: 'POST',
                body: formData
            }).catch(function(ex) {
                // we have to catch this otherwise it throws an infinite loop in Sentry
                console.error(ex);
            });
            return event;
        } catch (ex) {
            console.error(ex);
        }
    };
    SentryRRWeb.id = 'SentryRRWeb';
    return SentryRRWeb;
}();
var $9d2a72deec55a3e4$export$2e2bcd8739ae039 = $9d2a72deec55a3e4$var$SentryRRWeb;



var $jVs0C = parcelRequire("jVs0C");
var $dtmCD = parcelRequire("dtmCD");
var $ki8Su = parcelRequire("ki8Su");
var $2Y7aX = parcelRequire("2Y7aX");
var $3WK1v = parcelRequire("3WK1v");

var $7htw4 = parcelRequire("7htw4");
var $lS7eK = parcelRequire("lS7eK");
var $eAaWR = parcelRequire("eAaWR");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $c19fecb3210bca7d$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



var $ki8Su = parcelRequire("ki8Su");
var $5NO4E = parcelRequire("5NO4E");

var $7htw4 = parcelRequire("7htw4");


var $6HS3j = parcelRequire("6HS3j");
const $8afec3b77151cb8f$export$56d8a8a25bd48b81 = (0, $6HS3j.GLOBAL_OBJ);


/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $8e74d225bb62d30f$export$6f18f55521af71a1() {
    if ((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document) (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $ki8Su.getActiveTransaction)();
        if ((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document.hidden && activeTransaction) {
            const statusType = 'cancelled';
            const { op: op, status: status } = (0, $5NO4E.spanToJSON)(activeTransaction);
            (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag('visibilitychange', 'document.hidden');
            activeTransaction.end();
        }
    });
    else (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}



var $7htw4 = parcelRequire("7htw4");
var $6Iopj = parcelRequire("6Iopj");

const $7b7513317f3aade6$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $7f95c1862b128b5f$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d99d2cd5a5818608$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).performance.navigation.type;
    const navigationEntry = {
        entryType: 'navigation',
        startTime: 0,
        type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate'
    };
    for(const key in timing)if (key !== 'navigationStart' && key !== 'toJSON') // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $d99d2cd5a5818608$export$6431553786c94949 = ()=>{
    if ((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).__WEB_VITALS_POLYFILL__) return (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).performance && (performance.getEntriesByType && performance.getEntriesByType('navigation')[0] || $d99d2cd5a5818608$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2c0acaa1cee7fc15$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $d99d2cd5a5818608$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b148181b8a6a8e84$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $d99d2cd5a5818608$export$6431553786c94949)();
    let navigationType = 'navigate';
    if (navEntry) {
        if ((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document && (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document.prerendering || (0, $2c0acaa1cee7fc15$export$d3e828b3c7b5b845)() > 0) navigationType = 'prerender';
        else navigationType = navEntry.type.replace(/_/g, '-');
    }
    return {
        name: name,
        value: typeof value === 'undefined' ? -1 : value,
        rating: 'good',
        delta: 0,
        entries: [],
        id: (0, $7f95c1862b128b5f$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $878bc14767ac8952$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe({
                type: type,
                buffered: true,
                ...opts
            });
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7b22b521e987c1c9$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === 'pagehide' || (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') {
            cb(event);
            if (once) {
                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
                removeEventListener('pagehide', onHiddenOrPageHide, true);
            }
        }
    };
    if ((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document) {
        addEventListener('visibilitychange', onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener('pagehide', onHiddenOrPageHide, true);
    }
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $616a74ac103e3781$export$a7873055838e5ad8 = (onReport, options = {})=>{
    const metric = (0, $b148181b8a6a8e84$export$3c29b44508a0612b)('CLS', 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $878bc14767ac8952$export$d1203567a167490e)('layout-shift', handleEntries);
    if (po) {
        report = (0, $7b7513317f3aade6$export$17679dccdd551979)(onReport, metric, options.reportAllChanges);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $7b22b521e987c1c9$export$91ec2be6fdd8f1b4)(stopListening);
        return stopListening;
    }
    return;
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $5e601800040eecc5$var$firstHiddenTime = -1;
const $5e601800040eecc5$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    if ((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document && (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document.visibilityState) $5e601800040eecc5$var$firstHiddenTime = (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document.visibilityState === 'hidden' && !(0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $5e601800040eecc5$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $7b22b521e987c1c9$export$91ec2be6fdd8f1b4)(({ timeStamp: timeStamp })=>{
        $5e601800040eecc5$var$firstHiddenTime = timeStamp;
    }, true);
};
const $5e601800040eecc5$export$443f86b2c77012c4 = ()=>{
    if ($5e601800040eecc5$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $5e601800040eecc5$var$initHiddenTime();
        $5e601800040eecc5$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $5e601800040eecc5$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $43ca0f91ec0f5996$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $5e601800040eecc5$export$443f86b2c77012c4)();
    const metric = (0, $b148181b8a6a8e84$export$3c29b44508a0612b)('FID');
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $878bc14767ac8952$export$d1203567a167490e)('first-input', handleEntries);
    report = (0, $7b7513317f3aade6$export$17679dccdd551979)(onReport, metric);
    if (po) (0, $7b22b521e987c1c9$export$91ec2be6fdd8f1b4)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};







let $0e3737a4cba67521$var$interactionCountEstimate = 0;
let $0e3737a4cba67521$var$minKnownInteractionId = Infinity;
let $0e3737a4cba67521$var$maxKnownInteractionId = 0;
const $0e3737a4cba67521$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $0e3737a4cba67521$var$minKnownInteractionId = Math.min($0e3737a4cba67521$var$minKnownInteractionId, e.interactionId);
            $0e3737a4cba67521$var$maxKnownInteractionId = Math.max($0e3737a4cba67521$var$maxKnownInteractionId, e.interactionId);
            $0e3737a4cba67521$var$interactionCountEstimate = $0e3737a4cba67521$var$maxKnownInteractionId ? ($0e3737a4cba67521$var$maxKnownInteractionId - $0e3737a4cba67521$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $0e3737a4cba67521$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $0e3737a4cba67521$export$8a962f2683a476d1 = ()=>{
    return $0e3737a4cba67521$var$po ? $0e3737a4cba67521$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $0e3737a4cba67521$export$67d90cda6b78a2eb = ()=>{
    if ('interactionCount' in performance || $0e3737a4cba67521$var$po) return;
    $0e3737a4cba67521$var$po = (0, $878bc14767ac8952$export$d1203567a167490e)('event', $0e3737a4cba67521$var$updateEstimate, {
        type: 'event',
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $3ccc30bc8061eb73$var$getInteractionCountForNavigation = ()=>{
    return (0, $0e3737a4cba67521$export$8a962f2683a476d1)();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $3ccc30bc8061eb73$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $3ccc30bc8061eb73$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $3ccc30bc8061eb73$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $3ccc30bc8061eb73$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $3ccc30bc8061eb73$var$longestInteractionList[$3ccc30bc8061eb73$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $3ccc30bc8061eb73$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $3ccc30bc8061eb73$var$longestInteractionList.length < $3ccc30bc8061eb73$var$MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $3ccc30bc8061eb73$var$longestInteractionMap[interaction.id] = interaction;
            $3ccc30bc8061eb73$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $3ccc30bc8061eb73$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $3ccc30bc8061eb73$var$longestInteractionList.splice($3ccc30bc8061eb73$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $3ccc30bc8061eb73$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $3ccc30bc8061eb73$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($3ccc30bc8061eb73$var$longestInteractionList.length - 1, Math.floor($3ccc30bc8061eb73$var$getInteractionCountForNavigation() / 50));
    return $3ccc30bc8061eb73$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $3ccc30bc8061eb73$export$7df4b36ecaed99e1 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    (0, $0e3737a4cba67521$export$67d90cda6b78a2eb)();
    const metric = (0, $b148181b8a6a8e84$export$3c29b44508a0612b)('INP');
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.interactionId) $3ccc30bc8061eb73$var$processEntry(entry);
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === 'first-input') {
                const noMatchingEntry = !$3ccc30bc8061eb73$var$longestInteractionList.some((interaction)=>{
                    return interaction.entries.some((prevEntry)=>{
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) $3ccc30bc8061eb73$var$processEntry(entry);
            }
        });
        const inp = $3ccc30bc8061eb73$var$estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    const po = (0, $878bc14767ac8952$export$d1203567a167490e)('event', handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = (0, $7b7513317f3aade6$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: 'first-input',
            buffered: true
        });
        (0, $7b22b521e987c1c9$export$91ec2be6fdd8f1b4)(()=>{
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && $3ccc30bc8061eb73$var$getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $89b7eb81e7eb2d1b$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $89b7eb81e7eb2d1b$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $5e601800040eecc5$export$443f86b2c77012c4)();
    const metric = (0, $b148181b8a6a8e84$export$3c29b44508a0612b)('LCP');
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $2c0acaa1cee7fc15$export$d3e828b3c7b5b845)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $878bc14767ac8952$export$d1203567a167490e)('largest-contentful-paint', handleEntries);
    if (po) {
        report = (0, $7b7513317f3aade6$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            if (!$89b7eb81e7eb2d1b$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $89b7eb81e7eb2d1b$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            'keydown',
            'click'
        ].forEach((type)=>{
            if ((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document) addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $7b22b521e987c1c9$export$91ec2be6fdd8f1b4)(stopListening, true);
        return stopListening;
    }
    return;
};








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $3e42606ce4686bc2$var$whenReady = (callback)=>{
    if (!(0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document) return;
    if ((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document.prerendering) addEventListener('prerenderingchange', ()=>$3e42606ce4686bc2$var$whenReady(callback), true);
    else if ((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document.readyState !== 'complete') addEventListener('load', ()=>$3e42606ce4686bc2$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $3e42606ce4686bc2$export$33a01e6c5f2c7e33 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/ttfb/#what-is-a-good-ttfb-score
    // const thresholds = [800, 1800];
    const metric = (0, $b148181b8a6a8e84$export$3c29b44508a0612b)('TTFB');
    const report = (0, $7b7513317f3aade6$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    $3e42606ce4686bc2$var$whenReady(()=>{
        const navEntry = (0, $d99d2cd5a5818608$export$6431553786c94949)();
        if (navEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navEntry.responseStart - (0, $2c0acaa1cee7fc15$export$d3e828b3c7b5b845)(), 0);
            // In some cases the value reported is negative or is larger
            // than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            if (metric.value < 0 || metric.value > performance.now()) return;
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};


const $962fbd100584c218$var$handlers = {};
const $962fbd100584c218$var$instrumented = {};
let $962fbd100584c218$var$_previousCls;
let $962fbd100584c218$var$_previousFid;
let $962fbd100584c218$var$_previousLcp;
let $962fbd100584c218$var$_previousTtfb;
let $962fbd100584c218$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $962fbd100584c218$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $962fbd100584c218$var$addMetricObserver('cls', callback, $962fbd100584c218$var$instrumentCls, $962fbd100584c218$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $962fbd100584c218$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $962fbd100584c218$var$addMetricObserver('lcp', callback, $962fbd100584c218$var$instrumentLcp, $962fbd100584c218$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $962fbd100584c218$export$699d9529c099a797(callback) {
    return $962fbd100584c218$var$addMetricObserver('ttfb', callback, $962fbd100584c218$var$instrumentTtfb, $962fbd100584c218$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $962fbd100584c218$export$2707d7471c0b918f(callback) {
    return $962fbd100584c218$var$addMetricObserver('fid', callback, $962fbd100584c218$var$instrumentFid, $962fbd100584c218$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $962fbd100584c218$export$da3b76aa2022cbd7(callback) {
    return $962fbd100584c218$var$addMetricObserver('inp', callback, $962fbd100584c218$var$instrumentInp, $962fbd100584c218$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $962fbd100584c218$export$69816c1a049f8db6(type, callback) {
    $962fbd100584c218$var$addHandler(type, callback);
    if (!$962fbd100584c218$var$instrumented[type]) {
        $962fbd100584c218$var$instrumentPerformanceObserver(type);
        $962fbd100584c218$var$instrumented[type] = true;
    }
    return $962fbd100584c218$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $962fbd100584c218$var$triggerHandlers(type, data) {
    const typeHandlers = $962fbd100584c218$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $6Iopj.getFunctionName)(handler)}\nError:`, e);
    }
}
function $962fbd100584c218$var$instrumentCls() {
    return (0, $616a74ac103e3781$export$a7873055838e5ad8)((metric)=>{
        $962fbd100584c218$var$triggerHandlers('cls', {
            metric: metric
        });
        $962fbd100584c218$var$_previousCls = metric;
    }, {
        reportAllChanges: true
    });
}
function $962fbd100584c218$var$instrumentFid() {
    return (0, $43ca0f91ec0f5996$export$39705a25c49af873)((metric)=>{
        $962fbd100584c218$var$triggerHandlers('fid', {
            metric: metric
        });
        $962fbd100584c218$var$_previousFid = metric;
    });
}
function $962fbd100584c218$var$instrumentLcp() {
    return (0, $89b7eb81e7eb2d1b$export$947b1626ab8d5632)((metric)=>{
        $962fbd100584c218$var$triggerHandlers('lcp', {
            metric: metric
        });
        $962fbd100584c218$var$_previousLcp = metric;
    });
}
function $962fbd100584c218$var$instrumentTtfb() {
    return (0, $3e42606ce4686bc2$export$33a01e6c5f2c7e33)((metric)=>{
        $962fbd100584c218$var$triggerHandlers('ttfb', {
            metric: metric
        });
        $962fbd100584c218$var$_previousTtfb = metric;
    });
}
function $962fbd100584c218$var$instrumentInp() {
    return (0, $3ccc30bc8061eb73$export$7df4b36ecaed99e1)((metric)=>{
        $962fbd100584c218$var$triggerHandlers('inp', {
            metric: metric
        });
        $962fbd100584c218$var$_previousInp = metric;
    });
}
function $962fbd100584c218$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $962fbd100584c218$var$addHandler(type, callback);
    let stopListening;
    if (!$962fbd100584c218$var$instrumented[type]) {
        stopListening = instrumentFn();
        $962fbd100584c218$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $962fbd100584c218$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $962fbd100584c218$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === 'event') options.durationThreshold = 0;
    (0, $878bc14767ac8952$export$d1203567a167490e)(type, (entries)=>{
        $962fbd100584c218$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $962fbd100584c218$var$addHandler(type, handler) {
    $962fbd100584c218$var$handlers[type] = $962fbd100584c218$var$handlers[type] || [];
    $962fbd100584c218$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $962fbd100584c218$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $962fbd100584c218$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}



var $ki8Su = parcelRequire("ki8Su");
var $3WK1v = parcelRequire("3WK1v");
var $chdgs = parcelRequire("chdgs");
/**
 * Create envelope from Span item.
 */ function $c464b67ae647da57$export$19a0081d4b39d77(spans, dsn) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (dsn) headers.dsn = (0, $0aaaa6c30c5fe7e9$export$44d472fbb931a776)(dsn);
    const items = spans.map($c464b67ae647da57$var$createSpanItem);
    return (0, $e49341fc8a37f226$export$f93f7f385160c44e)(headers, items);
}
function $c464b67ae647da57$var$createSpanItem(span) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        span
    ];
}


var $5NO4E = parcelRequire("5NO4E");
var $ki8Su = parcelRequire("ki8Su");
/**
 * Adds a measurement to the current active transaction.
 */ function $e8a7046dd5e8a784$export$7cc31b475d33a706(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    const transaction = (0, $ki8Su.getActiveTransaction)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}


var $3qQZ3 = parcelRequire("3qQZ3");
var $1fiFu = parcelRequire("1fiFu");

var $cQg0t = parcelRequire("cQg0t");
var $eAaWR = parcelRequire("eAaWR");
var $7htw4 = parcelRequire("7htw4");




/**
 * Checks if a given value is a valid measurement value.
 */ function $33db85a956902625$export$27169ccae1b439e3(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function $33db85a956902625$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}



const $0508804b2b05ab07$var$MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $0508804b2b05ab07$var$msToSec(time) {
    return time / 1000;
}
function $0508804b2b05ab07$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81) && (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).addEventListener && (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).performance;
}
let $0508804b2b05ab07$var$_performanceCursor = 0;
let $0508804b2b05ab07$var$_measurements = {};
let $0508804b2b05ab07$var$_lcpEntry;
let $0508804b2b05ab07$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $0508804b2b05ab07$export$7c69f0412d101b88() {
    const performance = $0508804b2b05ab07$var$getBrowserPerformanceAPI();
    if (performance && (0, $cQg0t.browserPerformanceTimeOrigin)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).performance.mark('sentry-tracing-init');
        const fidCallback = $0508804b2b05ab07$var$_trackFID();
        const clsCallback = $0508804b2b05ab07$var$_trackCLS();
        const lcpCallback = $0508804b2b05ab07$var$_trackLCP();
        const ttfbCallback = $0508804b2b05ab07$var$_trackTtfb();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
            ttfbCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $0508804b2b05ab07$export$f396d19077034ad2() {
    (0, $962fbd100584c218$export$69816c1a049f8db6)('longtask', ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $ki8Su.getActiveTransaction)();
            if (!transaction) return;
            const startTime = $0508804b2b05ab07$var$msToSec((0, $cQg0t.browserPerformanceTimeOrigin) + entry.startTime);
            const duration = $0508804b2b05ab07$var$msToSec(entry.duration);
            // eslint-disable-next-line deprecation/deprecation
            transaction.startChild({
                description: 'Main UI thread blocked',
                op: 'ui.long-task',
                origin: 'auto.ui.browser.metrics',
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $0508804b2b05ab07$export$e27543e0976315e4() {
    (0, $962fbd100584c218$export$69816c1a049f8db6)('event', ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $ki8Su.getActiveTransaction)();
            if (!transaction) return;
            if (entry.name === 'click') {
                const startTime = $0508804b2b05ab07$var$msToSec((0, $cQg0t.browserPerformanceTimeOrigin) + entry.startTime);
                const duration = $0508804b2b05ab07$var$msToSec(entry.duration);
                const span = {
                    description: (0, $eAaWR.htmlTreeAsString)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: 'auto.ui.browser.metrics',
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                };
                const componentName = (0, $eAaWR.getComponentName)(entry.target);
                if (componentName) span.attributes = {
                    'ui.component_name': componentName
                };
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild(span);
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function $0508804b2b05ab07$export$f17d06681a4744a3(interactionIdtoRouteNameMapping, interactionsSampleRate) {
    const performance = $0508804b2b05ab07$var$getBrowserPerformanceAPI();
    if (performance && (0, $cQg0t.browserPerformanceTimeOrigin)) {
        const inpCallback = $0508804b2b05ab07$var$_trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $0508804b2b05ab07$var$_trackCLS() {
    return (0, $962fbd100584c218$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).log('[Measurements] Adding CLS');
        $0508804b2b05ab07$var$_measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        $0508804b2b05ab07$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $0508804b2b05ab07$var$_trackLCP() {
    return (0, $962fbd100584c218$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).log('[Measurements] Adding LCP');
        $0508804b2b05ab07$var$_measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $0508804b2b05ab07$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $0508804b2b05ab07$var$_trackFID() {
    return (0, $962fbd100584c218$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = $0508804b2b05ab07$var$msToSec((0, $cQg0t.browserPerformanceTimeOrigin));
        const startTime = $0508804b2b05ab07$var$msToSec(entry.startTime);
        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).log('[Measurements] Adding FID');
        $0508804b2b05ab07$var$_measurements['fid'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $0508804b2b05ab07$var$_measurements['mark.fid'] = {
            value: timeOrigin + startTime,
            unit: 'second'
        };
    });
}
function $0508804b2b05ab07$var$_trackTtfb() {
    return (0, $962fbd100584c218$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).log('[Measurements] Adding TTFB');
        $0508804b2b05ab07$var$_measurements['ttfb'] = {
            value: metric.value,
            unit: 'millisecond'
        };
    });
}
const $0508804b2b05ab07$var$INP_ENTRY_MAP = {
    click: 'click',
    pointerdown: 'click',
    pointerup: 'click',
    mousedown: 'click',
    mouseup: 'click',
    touchstart: 'click',
    touchend: 'click',
    mouseover: 'hover',
    mouseout: 'hover',
    mouseenter: 'hover',
    mouseleave: 'hover',
    pointerover: 'hover',
    pointerout: 'hover',
    pointerenter: 'hover',
    pointerleave: 'hover',
    dragstart: 'drag',
    dragend: 'drag',
    drag: 'drag',
    dragenter: 'drag',
    dragleave: 'drag',
    dragover: 'drag',
    drop: 'drag',
    keydown: 'press',
    keyup: 'press',
    keypress: 'press',
    input: 'press'
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $0508804b2b05ab07$var$_trackINP(interactionIdToRouteNameMapping, interactionsSampleRate) {
    return (0, $962fbd100584c218$export$da3b76aa2022cbd7)(({ metric: metric })=>{
        if (metric.value === undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $0508804b2b05ab07$var$INP_ENTRY_MAP[entry.name] !== undefined);
        const client = (0, $3WK1v.getClient)();
        if (!entry || !client) return;
        const interactionType = $0508804b2b05ab07$var$INP_ENTRY_MAP[entry.name];
        const options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = $0508804b2b05ab07$var$msToSec((0, $cQg0t.browserPerformanceTimeOrigin) + entry.startTime);
        const duration = $0508804b2b05ab07$var$msToSec(metric.value);
        const interaction = entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
        if (interaction === undefined) return;
        const { routeName: routeName, parentContext: parentContext, activeTransaction: activeTransaction, user: user, replayId: replayId } = interaction;
        const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        const span = new (0, $chdgs.Span)({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: `ui.interaction.${interactionType}`,
            name: (0, $eAaWR.htmlTreeAsString)(entry.target),
            attributes: {
                release: options.release,
                environment: options.environment,
                transaction: routeName,
                ...userDisplay !== undefined && userDisplay !== '' ? {
                    user: userDisplay
                } : {},
                ...profileId !== undefined ? {
                    profile_id: profileId
                } : {},
                ...replayId !== undefined ? {
                    replay_id: replayId
                } : {}
            },
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: 'millisecond'
                }
            }
        });
        /** Check to see if the span should be sampled */ const sampleRate = $0508804b2b05ab07$var$getSampleRate(parentContext, options, interactionsSampleRate);
        if (!sampleRate) return;
        if (Math.random() < sampleRate) {
            const envelope = span ? (0, $c464b67ae647da57$export$19a0081d4b39d77)([
                span
            ], client.getDsn()) : undefined;
            const transport = client && client.getTransport();
            if (transport && envelope) transport.send(envelope).then(null, (reason)=>{
                (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).error('Error while sending interaction:', reason);
            });
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function $0508804b2b05ab07$export$5f8fa6b3467a7443(transaction) {
    const performance = $0508804b2b05ab07$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).performance.getEntries || !(0, $cQg0t.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
    return;
    (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).log('[Tracing] Adding & adjusting spans using Performance API');
    const timeOrigin = $0508804b2b05ab07$var$msToSec((0, $cQg0t.browserPerformanceTimeOrigin));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $5NO4E.spanToJSON)(transaction);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($0508804b2b05ab07$var$_performanceCursor).forEach((entry)=>{
        const startTime = $0508804b2b05ab07$var$msToSec(entry.startTime);
        const duration = $0508804b2b05ab07$var$msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case 'navigation':
                $0508804b2b05ab07$var$_addNavigationSpans(transaction, entry, timeOrigin);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    $0508804b2b05ab07$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $5e601800040eecc5$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) {
                        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).log('[Measurements] Adding FP');
                        $0508804b2b05ab07$var$_measurements['fp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
                        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).log('[Measurements] Adding FCP');
                        $0508804b2b05ab07$var$_measurements['fcp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    break;
                }
            case 'resource':
                $0508804b2b05ab07$export$c82fe1a70634f317(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $0508804b2b05ab07$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $0508804b2b05ab07$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === 'pageload') {
        $0508804b2b05ab07$var$_addTtfbRequestTimeToMeasurements($0508804b2b05ab07$var$_measurements);
        [
            'fcp',
            'fp',
            'lcp'
        ].forEach((name)=>{
            if (!$0508804b2b05ab07$var$_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $0508804b2b05ab07$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $0508804b2b05ab07$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $0508804b2b05ab07$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $0508804b2b05ab07$var$_measurements['mark.fid'];
        if (fidMark && $0508804b2b05ab07$var$_measurements['fid']) {
            // create span for FID
            (0, $33db85a956902625$export$8bd469e1f37aa721)(transaction, {
                description: 'first input delay',
                endTimestamp: fidMark.value + $0508804b2b05ab07$var$msToSec($0508804b2b05ab07$var$_measurements['fid'].value),
                op: 'ui.action',
                origin: 'auto.ui.browser.metrics',
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $0508804b2b05ab07$var$_measurements['mark.fid'];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!('fcp' in $0508804b2b05ab07$var$_measurements)) delete $0508804b2b05ab07$var$_measurements.cls;
        Object.keys($0508804b2b05ab07$var$_measurements).forEach((measurementName)=>{
            (0, $e8a7046dd5e8a784$export$7cc31b475d33a706)(measurementName, $0508804b2b05ab07$var$_measurements[measurementName].value, $0508804b2b05ab07$var$_measurements[measurementName].unit);
        });
        $0508804b2b05ab07$var$_tagMetricInfo(transaction);
    }
    $0508804b2b05ab07$var$_lcpEntry = undefined;
    $0508804b2b05ab07$var$_clsEntry = undefined;
    $0508804b2b05ab07$var$_measurements = {};
}
/** Create measure related spans */ function $0508804b2b05ab07$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $33db85a956902625$export$8bd469e1f37aa721)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: 'auto.resource.browser.metrics',
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0508804b2b05ab07$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach((event)=>{
        $0508804b2b05ab07$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $0508804b2b05ab07$var$_addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
    $0508804b2b05ab07$var$_addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
    $0508804b2b05ab07$var$_addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
    $0508804b2b05ab07$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $0508804b2b05ab07$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $33db85a956902625$export$8bd469e1f37aa721)(transaction, {
        op: 'browser',
        origin: 'auto.browser.browser.metrics',
        description: description || event,
        startTimestamp: timeOrigin + $0508804b2b05ab07$var$msToSec(start),
        endTimestamp: timeOrigin + $0508804b2b05ab07$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0508804b2b05ab07$var$_addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, $33db85a956902625$export$8bd469e1f37aa721)(transaction, {
            op: 'browser',
            origin: 'auto.browser.browser.metrics',
            description: 'request',
            startTimestamp: timeOrigin + $0508804b2b05ab07$var$msToSec(entry.requestStart),
            endTimestamp: timeOrigin + $0508804b2b05ab07$var$msToSec(entry.responseEnd)
        });
        (0, $33db85a956902625$export$8bd469e1f37aa721)(transaction, {
            op: 'browser',
            origin: 'auto.browser.browser.metrics',
            description: 'response',
            startTimestamp: timeOrigin + $0508804b2b05ab07$var$msToSec(entry.responseStart),
            endTimestamp: timeOrigin + $0508804b2b05ab07$var$msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function $0508804b2b05ab07$export$c82fe1a70634f317(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    const parsedUrl = (0, $7da207ca9fea49e7$export$7a5253c0f62e0150)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    $0508804b2b05ab07$var$setResourceEntrySizeData(data, entry, 'transferSize', 'http.response_transfer_size');
    $0508804b2b05ab07$var$setResourceEntrySizeData(data, entry, 'encodedBodySize', 'http.response_content_length');
    $0508804b2b05ab07$var$setResourceEntrySizeData(data, entry, 'decodedBodySize', 'http.decoded_response_content_length');
    if ('renderBlockingStatus' in entry) data['resource.render_blocking_status'] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data['server.address'] = parsedUrl.host;
    data['url.same_origin'] = resourceUrl.includes((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $33db85a956902625$export$8bd469e1f37aa721)(transaction, {
        description: resourceUrl.replace((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).location.origin, ''),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
        origin: 'auto.resource.browser.metrics',
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $0508804b2b05ab07$var$_trackNavigator(transaction) {
    const navigator = (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('effectiveConnectionType', connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('connectionType', connection.type);
        if ((0, $33db85a956902625$export$27169ccae1b439e3)(connection.rtt)) $0508804b2b05ab07$var$_measurements['connection.rtt'] = {
            value: connection.rtt,
            unit: 'millisecond'
        };
    }
    if ((0, $33db85a956902625$export$27169ccae1b439e3)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
    if ((0, $33db85a956902625$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $0508804b2b05ab07$var$_tagMetricInfo(transaction) {
    if ($0508804b2b05ab07$var$_lcpEntry) {
        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).log('[Measurements] Adding LCP Data');
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($0508804b2b05ab07$var$_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.element', (0, $eAaWR.htmlTreeAsString)($0508804b2b05ab07$var$_lcpEntry.element));
        if ($0508804b2b05ab07$var$_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.id', $0508804b2b05ab07$var$_lcpEntry.id);
        if ($0508804b2b05ab07$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.url', $0508804b2b05ab07$var$_lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.size', $0508804b2b05ab07$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($0508804b2b05ab07$var$_clsEntry && $0508804b2b05ab07$var$_clsEntry.sources) {
        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).log('[Measurements] Adding CLS Data');
        $0508804b2b05ab07$var$_clsEntry.sources.forEach((source, index)=>// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag(`cls.source.${index + 1}`, (0, $eAaWR.htmlTreeAsString)(source.node)));
    }
}
function $0508804b2b05ab07$var$setResourceEntrySizeData(data, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $0508804b2b05ab07$var$MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $0508804b2b05ab07$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $d99d2cd5a5818608$export$6431553786c94949)();
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) {
        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).log('[Measurements] Adding TTFB Request Time');
        _measurements['ttfb.requestTime'] = {
            value: responseStart - requestStart,
            unit: 'millisecond'
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function $0508804b2b05ab07$var$getSampleRate(transactionContext, options, interactionsSampleRate) {
    if (!(0, $3qQZ3.hasTracingEnabled)(options)) return false;
    let sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === 'function') sampleRate = options.tracesSampler({
        transactionContext: transactionContext,
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        location: (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).location
    });
    else if (transactionContext !== undefined && transactionContext.sampled !== undefined) sampleRate = transactionContext.sampled;
    else if (typeof options.tracesSampleRate !== 'undefined') sampleRate = options.tracesSampleRate;
    else sampleRate = 1;
    if (!(0, $1fiFu.isValidSampleRate)(sampleRate)) {
        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).warn('[Tracing] Discarding interaction span because of invalid sample rate.');
        return false;
    }
    if (sampleRate === true) return interactionsSampleRate;
    else if (sampleRate === false) return 0;
    return sampleRate * interactionsSampleRate;
}



var $5NO4E = parcelRequire("5NO4E");
var $3qQZ3 = parcelRequire("3qQZ3");
var $9JbAT = parcelRequire("9JbAT");
var $3WK1v = parcelRequire("3WK1v");
var $gUaXH = parcelRequire("gUaXH");
var $4DAh4 = parcelRequire("4DAh4");
var $2Y7aX = parcelRequire("2Y7aX");
var $iJP5v = parcelRequire("iJP5v");

var $cQg0t = parcelRequire("cQg0t");
var $jP2vU = parcelRequire("jP2vU");
var $lS7eK = parcelRequire("lS7eK");
var $9I0DN = parcelRequire("9I0DN");

var $3qQZ3 = parcelRequire("3qQZ3");
var $3WK1v = parcelRequire("3WK1v");
var $4DAh4 = parcelRequire("4DAh4");
var $2Y7aX = parcelRequire("2Y7aX");
var $gUaXH = parcelRequire("gUaXH");
var $5NO4E = parcelRequire("5NO4E");
var $iJP5v = parcelRequire("iJP5v");
var $9JbAT = parcelRequire("9JbAT");

var $lS7eK = parcelRequire("lS7eK");
var $9I0DN = parcelRequire("9I0DN");
var $5QZE4 = parcelRequire("5QZE4");
/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $fcf10fbbd8b206ce$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = 'auto.http.browser') {
    if (!(0, $3qQZ3.hasTracingEnabled)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $fcf10fbbd8b206ce$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $3WK1v.getCurrentScope)();
    const client = (0, $3WK1v.getClient)();
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $fcf10fbbd8b206ce$var$getFullURL(url);
    const host = fullUrl ? (0, $7da207ca9fea49e7$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $4DAh4.startInactiveSpan)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
            url: url,
            type: 'fetch',
            'http.method': method,
            'http.url': fullUrl,
            'server.address': host,
            [(0, $2Y7aX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin
        },
        op: 'http.client'
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanContext().spanId;
        spans[span.spanContext().spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $fcf10fbbd8b206ce$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $fcf10fbbd8b206ce$export$6717acf674206871(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    const span = requestSpan || scope.getSpan();
    const isolationScope = (0, $gUaXH.getIsolationScope)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $5NO4E.spanToTraceHeader)(span) : (0, $lS7eK.generateSentryTraceHeader)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $9I0DN.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span ? (0, $iJP5v.getDynamicSamplingContextFromSpan)(span) : (0, $iJP5v.getDynamicSamplingContextFromClient)(traceId, client, scope)));
    const headers = options.headers || (typeof Request !== 'undefined' && (0, $5QZE4.isInstanceOf)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        'sentry-trace': sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== 'undefined' && (0, $5QZE4.isInstanceOf)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $9I0DN.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                'sentry-trace',
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $9I0DN.BAGGAGE_HEADER_NAME),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            'sentry-trace': sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        };
    }
}
function $fcf10fbbd8b206ce$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $fcf10fbbd8b206ce$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $9JbAT.setHttpStatus)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute('http.response_content_length', contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus('internal_error');
    span.end();
}




/* eslint-disable max-lines */ const $f8f18e67dc9a164f$export$15bd0305d05ad07b = [
    'localhost',
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $f8f18e67dc9a164f$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $f8f18e67dc9a164f$export$15bd0305d05ad07b,
    tracePropagationTargets: $f8f18e67dc9a164f$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $f8f18e67dc9a164f$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $f8f18e67dc9a164f$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $f8f18e67dc9a164f$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$f8f18e67dc9a164f$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $f72b9d1319ab84b6$export$f75d3c772c923df0)((handlerData)=>{
        const createdSpan = (0, $fcf10fbbd8b206ce$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        // We cannot use `window.location` in the generic fetch instrumentation,
        // but we need it for reliable `server.address` attribute.
        // so we extend this in here
        if (createdSpan) {
            const fullUrl = $f8f18e67dc9a164f$var$getFullURL(handlerData.fetchData.url);
            const host = fullUrl ? (0, $7da207ca9fea49e7$export$7a5253c0f62e0150)(fullUrl).host : undefined;
            createdSpan.setAttributes({
                'http.url': fullUrl,
                'server.address': host
            });
        }
        if (enableHTTPTimings && createdSpan) $f8f18e67dc9a164f$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $bc641309b3f67a9f$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $f8f18e67dc9a164f$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $f8f18e67dc9a164f$var$addHTTPTimings(createdSpan);
    });
}
function $f8f18e67dc9a164f$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === 'resource' && 'initiatorType' in entry && typeof entry.nextHopProtocol === 'string' && (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest');
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $f8f18e67dc9a164f$var$addHTTPTimings(span) {
    const { url: url } = (0, $5NO4E.spanToJSON)(span).data || {};
    if (!url || typeof url !== 'string') return;
    const cleanup = (0, $962fbd100584c218$export$69816c1a049f8db6)('resource', ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($f8f18e67dc9a164f$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $f8f18e67dc9a164f$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $f8f18e67dc9a164f$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = 'unknown';
    let version = 'unknown';
    let _name = '';
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === '/') {
            [name, version] = nextHopProtocol.split('/');
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === 'h' ? 'http' : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $f8f18e67dc9a164f$var$getAbsoluteTime(time = 0) {
    return (((0, $cQg0t.browserPerformanceTimeOrigin) || performance.timeOrigin) + time) / 1000;
}
function $f8f18e67dc9a164f$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $f8f18e67dc9a164f$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        'network.protocol.version',
        version
    ], [
        'network.protocol.name',
        name
    ]);
    if (!(0, $cQg0t.browserPerformanceTimeOrigin)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            'http.request.redirect_start',
            $f8f18e67dc9a164f$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            'http.request.fetch_start',
            $f8f18e67dc9a164f$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            'http.request.domain_lookup_start',
            $f8f18e67dc9a164f$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            'http.request.domain_lookup_end',
            $f8f18e67dc9a164f$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            'http.request.connect_start',
            $f8f18e67dc9a164f$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            'http.request.secure_connection_start',
            $f8f18e67dc9a164f$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            'http.request.connection_end',
            $f8f18e67dc9a164f$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            'http.request.request_start',
            $f8f18e67dc9a164f$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            'http.request.response_start',
            $f8f18e67dc9a164f$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            'http.request.response_end',
            $f8f18e67dc9a164f$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $f8f18e67dc9a164f$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $jP2vU.stringMatchesSomePattern)(url, tracePropagationTargets || $f8f18e67dc9a164f$export$15bd0305d05ad07b);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $f8f18e67dc9a164f$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $bc641309b3f67a9f$export$55b6bb1e45c6cf59];
    if (!(0, $3qQZ3.hasTracingEnabled)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $9JbAT.setHttpStatus)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $3WK1v.getCurrentScope)();
    const isolationScope = (0, $gUaXH.getIsolationScope)();
    const fullUrl = $f8f18e67dc9a164f$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $7da207ca9fea49e7$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $4DAh4.startInactiveSpan)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
            type: 'xhr',
            'http.method': sentryXhrData.method,
            'http.url': fullUrl,
            url: sentryXhrData.url,
            'server.address': host,
            [(0, $2Y7aX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.http.browser'
        },
        op: 'http.client'
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    const client = (0, $3WK1v.getClient)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const sentryTraceHeader = span ? (0, $5NO4E.spanToTraceHeader)(span) : (0, $lS7eK.generateSentryTraceHeader)(traceId, spanId, sampled);
        const sentryBaggageHeader = (0, $9I0DN.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span ? (0, $iJP5v.getDynamicSamplingContextFromSpan)(span) : (0, $iJP5v.getDynamicSamplingContextFromClient)(traceId, client, scope)));
        $f8f18e67dc9a164f$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span;
}
function $f8f18e67dc9a164f$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $9I0DN.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $f8f18e67dc9a164f$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}



var $7htw4 = parcelRequire("7htw4");
var $cQg0t = parcelRequire("cQg0t");


/**
 * Default function implementing pageload and navigation transactions
 */ function $115a0d458d4b2d87$export$86649cc09fe75143(customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) {
    if (!(0, $8afec3b77151cb8f$export$56d8a8a25bd48b81) || !(0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).location) {
        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).warn('Could not initialize routing instrumentation due to invalid location');
        return;
    }
    let startingUrl = (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).location.href;
    let activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTimestamp: (0, $cQg0t.browserPerformanceTimeOrigin) ? (0, $cQg0t.browserPerformanceTimeOrigin) / 1000 : undefined,
        op: 'pageload',
        origin: 'auto.pageload.browser',
        metadata: {
            source: 'url'
        }
    });
    if (startTransactionOnLocationChange) (0, $3d019c6a05cabdc5$export$3f18c56c58114e75)(({ to: to, from: from })=>{
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.end();
            }
            activeTransaction = customStartTransaction({
                name: (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).location.pathname,
                op: 'navigation',
                origin: 'auto.navigation.browser',
                metadata: {
                    source: 'url'
                }
            });
        }
    });
}



const $bec676217ef4cd96$export$bbd2089f30bd3708 = 'BrowserTracing';
/** Options for Browser Tracing integration */ const $bec676217ef4cd96$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $jVs0C.TRACING_DEFAULTS),
    markBackgroundTransactions: true,
    routingInstrumentation: (0, $115a0d458d4b2d87$export$86649cc09fe75143),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {},
    ...(0, $f8f18e67dc9a164f$export$cc17fb3c0bc95cd7)
};
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $bec676217ef4cd96$var$MAX_INTERACTIONS = 10;
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * @deprecated Use `browserTracingIntegration()` instead.
 */ class $bec676217ef4cd96$export$46d3bbd0375f5fa4 {
    // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
    // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
    // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
    // integrations.
    /** Browser Tracing integration options */ /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(_options){
        this.name = $bec676217ef4cd96$export$bbd2089f30bd3708;
        this._hasSetTracePropagationTargets = false;
        (0, $dtmCD.addTracingExtensions)();
        if (0, $c19fecb3210bca7d$export$16a28057038b10ef) this._hasSetTracePropagationTargets = !!(_options && // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins));
        this.options = {
            ...$bec676217ef4cd96$var$DEFAULT_BROWSER_TRACING_OPTIONS,
            ..._options
        };
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, $0508804b2b05ab07$export$7c69f0412d101b88)();
        /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ this._interactionIdToRouteNameMapping = {};
        if (this.options.enableInp) (0, $0508804b2b05ab07$export$f17d06681a4744a3)(this._interactionIdToRouteNameMapping, this.options.interactionsSampleRate);
        if (this.options.enableLongTask) (0, $0508804b2b05ab07$export$f396d19077034ad2)();
        if (this.options._experiments.enableInteractions) (0, $0508804b2b05ab07$export$e27543e0976315e4)();
        this._latestRoute = {
            name: undefined,
            context: undefined
        };
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        this._getCurrentHub = getCurrentHub;
        const hub = getCurrentHub();
        // eslint-disable-next-line deprecation/deprecation
        const client = hub.getClient();
        const clientOptions = client && client.getOptions();
        const { routingInstrumentation: instrumentRouting, startTransactionOnLocationChange: startTransactionOnLocationChange, startTransactionOnPageLoad: startTransactionOnPageLoad, markBackgroundTransactions: markBackgroundTransactions, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = this.options;
        const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
        // There are three ways to configure tracePropagationTargets:
        // 1. via top level client option `tracePropagationTargets`
        // 2. via BrowserTracing option `tracePropagationTargets`
        // 3. via BrowserTracing option `tracingOrigins` (deprecated)
        //
        // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
        // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
        // This is done as it minimizes bundle size (we don't have to have undefined checks).
        //
        // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
        // eslint-disable-next-line deprecation/deprecation
        const tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
        if ((0, $c19fecb3210bca7d$export$16a28057038b10ef) && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $7htw4.logger).warn('[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.');
        instrumentRouting((context)=>{
            const transaction = this._createRouteTransaction(context);
            this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
            return transaction;
        }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, $8e74d225bb62d30f$export$6f18f55521af71a1)();
        if (_experiments.enableInteractions) this._registerInteractionListener();
        if (this.options.enableInp) this._registerInpInteractionListener();
        (0, $f8f18e67dc9a164f$export$864489cb3478db3e)({
            traceFetch: traceFetch,
            traceXHR: traceXHR,
            tracePropagationTargets: tracePropagationTargets,
            shouldCreateSpanForRequest: shouldCreateSpanForRequest,
            enableHTTPTimings: enableHTTPTimings
        });
    }
    /** Create routing idle transaction. */ _createRouteTransaction(context) {
        if (!this._getCurrentHub) {
            (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
            return undefined;
        }
        const hub = this._getCurrentHub();
        const { beforeNavigate: beforeNavigate, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
        const isPageloadTransaction = context.op === 'pageload';
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $bec676217ef4cd96$export$f147b32b03c9cf11('sentry-trace') : '';
            const baggage = isPageloadTransaction ? $bec676217ef4cd96$export$f147b32b03c9cf11('baggage') : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $lS7eK.propagationContextFromHeaders)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        const finalContext = modifiedContext === undefined ? {
            ...expandedContext,
            sampled: false
        } : modifiedContext;
        // If `beforeNavigate` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: 'custom'
        } : finalContext.metadata;
        this._latestRoute.name = finalContext.name;
        this._latestRoute.context = finalContext;
        // eslint-disable-next-line deprecation/deprecation
        if (finalContext.sampled === false) (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81);
        const idleTransaction = (0, $dtmCD.startIdleTransaction)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction) {
            if ((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document) {
                (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document.addEventListener('readystatechange', ()=>{
                    if ([
                        'interactive',
                        'complete'
                    ].includes((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
                });
                if ([
                    'interactive',
                    'complete'
                ].includes((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
            }
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            this._collectWebVitals();
            (0, $0508804b2b05ab07$export$5f8fa6b3467a7443)(transaction);
        });
        return idleTransaction;
    }
    /** Start listener for interaction transactions */ _registerInteractionListener() {
        let inflightInteractionTransaction;
        const registerInteractionTransaction = ()=>{
            const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
            const op = 'ui.action.click';
            // eslint-disable-next-line deprecation/deprecation
            const currentTransaction = (0, $ki8Su.getActiveTransaction)();
            if (currentTransaction && currentTransaction.op && [
                'navigation',
                'pageload'
            ].includes(currentTransaction.op)) {
                (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
                return undefined;
            }
            if (inflightInteractionTransaction) {
                inflightInteractionTransaction.setFinishReason('interactionInterrupted');
                inflightInteractionTransaction.end();
                inflightInteractionTransaction = undefined;
            }
            if (!this._getCurrentHub) {
                (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
                return undefined;
            }
            if (!this._latestRoute.name) {
                (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
                return undefined;
            }
            const hub = this._getCurrentHub();
            const { location: location } = (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81);
            const context = {
                name: this._latestRoute.name,
                op: op,
                trimEnd: true,
                data: {
                    [(0, $2Y7aX.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: this._latestRoute.context ? $bec676217ef4cd96$var$getSource(this._latestRoute.context) : 'url'
                }
            };
            inflightInteractionTransaction = (0, $dtmCD.startIdleTransaction)(hub, context, idleTimeout, finalTimeout, true, {
                location: location
            }, heartbeatInterval);
        };
        [
            'click'
        ].forEach((type)=>{
            if ((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document) addEventListener(type, registerInteractionTransaction, {
                once: false,
                capture: true
            });
        });
    }
    /** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ _registerInpInteractionListener() {
        const handleEntries = ({ entries: entries })=>{
            const client = (0, $3WK1v.getClient)();
            // We need to get the replay, user, and activeTransaction from the current scope
            // so that we can associate replay id, profile id, and a user display to the span
            const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName('Replay') : undefined;
            const replayId = replay !== undefined ? replay.getReplayId() : undefined;
            // eslint-disable-next-line deprecation/deprecation
            const activeTransaction = (0, $ki8Su.getActiveTransaction)();
            const currentScope = (0, $3WK1v.getCurrentScope)();
            const user = currentScope !== undefined ? currentScope.getUser() : undefined;
            entries.forEach((entry)=>{
                if ($bec676217ef4cd96$var$isPerformanceEventTiming(entry)) {
                    const interactionId = entry.interactionId;
                    if (interactionId === undefined) return;
                    const existingInteraction = this._interactionIdToRouteNameMapping[interactionId];
                    const duration = entry.duration;
                    const startTime = entry.startTime;
                    const keys = Object.keys(this._interactionIdToRouteNameMapping);
                    const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                        return this._interactionIdToRouteNameMapping[a].duration < this._interactionIdToRouteNameMapping[b].duration ? a : b;
                    }) : undefined;
                    // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                    // This is also checked in the web-vitals library.
                    if (entry.entryType === 'first-input') {
                        const matchingEntry = keys.map((key)=>this._interactionIdToRouteNameMapping[key]).some((interaction)=>{
                            return interaction.duration === duration && interaction.startTime === startTime;
                        });
                        if (matchingEntry) return;
                    }
                    // Interactions with an id of 0 and are not first-input are not valid.
                    if (!interactionId) return;
                    // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                    if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                    else if (keys.length < $bec676217ef4cd96$var$MAX_INTERACTIONS || minInteractionId === undefined || duration > this._interactionIdToRouteNameMapping[minInteractionId].duration) {
                        // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                        const routeName = this._latestRoute.name;
                        const parentContext = this._latestRoute.context;
                        if (routeName && parentContext) {
                            if (minInteractionId && Object.keys(this._interactionIdToRouteNameMapping).length >= $bec676217ef4cd96$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                            delete this._interactionIdToRouteNameMapping[minInteractionId];
                            this._interactionIdToRouteNameMapping[interactionId] = {
                                routeName: routeName,
                                duration: duration,
                                parentContext: parentContext,
                                user: user,
                                activeTransaction: activeTransaction,
                                replayId: replayId,
                                startTime: startTime
                            };
                        }
                    }
                }
            });
        };
        (0, $962fbd100584c218$export$69816c1a049f8db6)('event', handleEntries);
        (0, $962fbd100584c218$export$69816c1a049f8db6)('first-input', handleEntries);
    }
}
/** Returns the value of a meta tag */ function $bec676217ef4cd96$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $eAaWR.getDomElement)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute('content') : undefined;
}
function $bec676217ef4cd96$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $2Y7aX.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $2Y7aX.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}
function $bec676217ef4cd96$var$isPerformanceEventTiming(entry) {
    return 'duration' in entry;
}


var $PHezF = parcelRequire("PHezF");
var $ki8Su = parcelRequire("ki8Su");
var $9JbAT = parcelRequire("9JbAT");
var $htdtT = parcelRequire("htdtT");
var $chdgs = parcelRequire("chdgs");
var $3qQZ3 = parcelRequire("3qQZ3");
var $lS7eK = parcelRequire("lS7eK");
var $jVs0C = parcelRequire("jVs0C");
var $dtmCD = parcelRequire("dtmCD");
var $8upap = parcelRequire("8upap");
var $7htw4 = parcelRequire("7htw4");
var $bP4Y8 = parcelRequire("bP4Y8");
var $HgoiY = parcelRequire("HgoiY");/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}


var $5QZE4 = parcelRequire("5QZE4");


/**
 * Check if Sentry auto-instrumentation should be disabled.
 *
 * @param getCurrentHub A method to fetch the current hub
 * @returns boolean
 */ // eslint-disable-next-line deprecation/deprecation
function $e4d0735f97e9263d$export$34db76d03eb96b7e(getCurrentHub) {
    // eslint-disable-next-line deprecation/deprecation
    const clientOptions = (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
        getCurrentHub,
        'call',
        (_)=>_(),
        'access',
        (_2)=>_2.getClient,
        'call',
        (_3)=>_3(),
        'optionalAccess',
        (_4)=>_4.getOptions,
        'call',
        (_5)=>_5()
    ]);
    const instrumenter = (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
        clientOptions,
        'optionalAccess',
        (_6)=>_6.instrumenter
    ]) || 'sentry';
    return instrumenter !== 'sentry';
}


/** Tracing integration for Apollo */ class $c110a4f216c23ca3$export$3db3e396472fda8d {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Apollo';
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {
        useNestjs: false
    }){
        this.name = $c110a4f216c23ca3$export$3db3e396472fda8d.id;
        this._useNest = !!options.useNestjs;
    }
    /** @inheritdoc */ loadDependency() {
        if (this._useNest) this._module = this._module || (0, $8upap.loadModule)('@nestjs/graphql');
        else this._module = this._module || (0, $8upap.loadModule)('apollo-server-core');
        return this._module;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if ((0, $e4d0735f97e9263d$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).log('Apollo Integration is skipped because of instrumenter configuration.');
            return;
        }
        if (this._useNest) {
            const pkg = this.loadDependency();
            if (!pkg) {
                (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).error('Apollo-NestJS Integration was unable to require @nestjs/graphql package.');
                return;
            }
            /**
       * Iterate over resolvers of NestJS ResolversExplorerService before schemas are constructed.
       */ (0, $bP4Y8.fill)(pkg.GraphQLFactory.prototype, 'mergeWithSchema', function(orig) {
                return function(...args) {
                    (0, $bP4Y8.fill)(this.resolversExplorerService, 'explore', function(orig) {
                        return function() {
                            const resolvers = (0, $HgoiY.arrayify)(orig.call(this));
                            const instrumentedResolvers = $c110a4f216c23ca3$var$instrumentResolvers(resolvers, getCurrentHub);
                            return instrumentedResolvers;
                        };
                    });
                    return orig.call(this, ...args);
                };
            });
        } else {
            const pkg = this.loadDependency();
            if (!pkg) {
                (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).error('Apollo Integration was unable to require apollo-server-core package.');
                return;
            }
            /**
       * Iterate over resolvers of the ApolloServer instance before schemas are constructed.
       */ (0, $bP4Y8.fill)(pkg.ApolloServerBase.prototype, 'constructSchema', function(orig) {
                return function() {
                    if (!this.config.resolvers) {
                        if (0, $c19fecb3210bca7d$export$16a28057038b10ef) {
                            if (this.config.schema) {
                                (0, $7htw4.logger).warn("Apollo integration is not able to trace `ApolloServer` instances constructed via `schema` property.If you are using NestJS with Apollo, please use `Sentry.Integrations.Apollo({ useNestjs: true })` instead.");
                                (0, $7htw4.logger).warn();
                            } else if (this.config.modules) (0, $7htw4.logger).warn('Apollo integration is not able to trace `ApolloServer` instances constructed via `modules` property.');
                            (0, $7htw4.logger).error('Skipping tracing as no resolvers found on the `ApolloServer` instance.');
                        }
                        return orig.call(this);
                    }
                    const resolvers = (0, $HgoiY.arrayify)(this.config.resolvers);
                    this.config.resolvers = $c110a4f216c23ca3$var$instrumentResolvers(resolvers, getCurrentHub);
                    return orig.call(this);
                };
            });
        }
    }
}
$c110a4f216c23ca3$export$3db3e396472fda8d.__initStatic();
// eslint-disable-next-line deprecation/deprecation
function $c110a4f216c23ca3$var$instrumentResolvers(resolvers, getCurrentHub) {
    return resolvers.map((model)=>{
        Object.keys(model).forEach((resolverGroupName)=>{
            Object.keys(model[resolverGroupName]).forEach((resolverName)=>{
                if (typeof model[resolverGroupName][resolverName] !== 'function') return;
                $c110a4f216c23ca3$var$wrapResolver(model, resolverGroupName, resolverName, getCurrentHub);
            });
        });
        return model;
    });
}
/**
 * Wrap a single resolver which can be a parent of other resolvers and/or db operations.
 */ function $c110a4f216c23ca3$var$wrapResolver(model, resolverGroupName, resolverName, // eslint-disable-next-line deprecation/deprecation
getCurrentHub) {
    (0, $bP4Y8.fill)(model[resolverGroupName], resolverName, function(orig) {
        return function(...args) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = getCurrentHub().getScope();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            // eslint-disable-next-line deprecation/deprecation
            const span = (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                parentSpan,
                'optionalAccess',
                (_2)=>_2.startChild,
                'call',
                (_3)=>_3({
                        description: `${resolverGroupName}.${resolverName}`,
                        op: 'graphql.resolve',
                        origin: 'auto.graphql.apollo'
                    })
            ]);
            const rv = orig.call(this, ...args);
            if ((0, $5QZE4.isThenable)(rv)) return rv.then((res)=>{
                (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                    span,
                    'optionalAccess',
                    (_4)=>_4.end,
                    'call',
                    (_5)=>_5()
                ]);
                return res;
            });
            (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                span,
                'optionalAccess',
                (_6)=>_6.end,
                'call',
                (_7)=>_7()
            ]);
            return rv;
        };
    });
}


var $7htw4 = parcelRequire("7htw4");/**
 * This code was originally copied from the 'cookie` module at v0.5.0 and was simplified for our use case.
 * https://github.com/jshttp/cookie/blob/a0c84147aab6266bdb3996cf4062e93907c0b0fc/index.js
 * It had the following license:
 *
 * (The MIT License)
 *
 * Copyright (c) 2012-2014 Roman Shtylman <shtylman@gmail.com>
 * Copyright (c) 2015 Douglas Christopher Wilson <doug@somethingdoug.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ /**
 * Parses a cookie string
 */ function $f39cd9e508f0a984$export$d0eaf3e94be578f6(str) {
    const obj = {};
    let index = 0;
    while(index < str.length){
        const eqIdx = str.indexOf('=', index);
        // no more cookie pairs
        if (eqIdx === -1) break;
        let endIdx = str.indexOf(';', index);
        if (endIdx === -1) endIdx = str.length;
        else if (endIdx < eqIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(';', eqIdx - 1) + 1;
            continue;
        }
        const key = str.slice(index, eqIdx).trim();
        // only assign once
        if (undefined === obj[key]) {
            let val = str.slice(eqIdx + 1, endIdx).trim();
            // quoted values
            if (val.charCodeAt(0) === 0x22) val = val.slice(1, -1);
            try {
                obj[key] = val.indexOf('%') !== -1 ? decodeURIComponent(val) : val;
            } catch (e) {
                obj[key] = val;
            }
        }
        index = endIdx + 1;
    }
    return obj;
}



var $8FmHF = parcelRequire("8FmHF");

var $5QZE4 = parcelRequire("5QZE4");

var $7htw4 = parcelRequire("7htw4");

var $jn5uz = parcelRequire("jn5uz");

const $b1ab576f40d005a1$var$DEFAULT_INCLUDES = {
    ip: false,
    request: true,
    transaction: true,
    user: true
};
const $b1ab576f40d005a1$var$DEFAULT_REQUEST_INCLUDES = [
    'cookies',
    'data',
    'headers',
    'method',
    'query_string',
    'url'
];
const $b1ab576f40d005a1$export$33c1c602a3538e5e = [
    'id',
    'username',
    'email'
];
/**
 * Sets parameterized route as transaction name e.g.: `GET /users/:id`
 * Also adds more context data on the transaction from the request.
 *
 * @deprecated This utility will be removed in v8.
 */ function $b1ab576f40d005a1$export$1973410ef8793cd6(transaction, req, deps) {
    if (!transaction) return;
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.metadata.source || transaction.metadata.source === 'url') {
        // Attempt to grab a parameterized route off of the request
        const [name, source] = $b1ab576f40d005a1$export$8c5ebee2e5bb9575(req, {
            path: true,
            method: true
        });
        transaction.updateName(name);
        // TODO: SEMANTIC_ATTRIBUTE_SENTRY_SOURCE is in core, align this once we merge utils & core
        // eslint-disable-next-line deprecation/deprecation
        transaction.setMetadata({
            source: source
        });
    }
    transaction.setAttribute('url', req.originalUrl || req.url);
    if (req.baseUrl) transaction.setAttribute('baseUrl', req.baseUrl);
    // TODO: We need to rewrite this to a flat format?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setData('query', $b1ab576f40d005a1$var$extractQueryParams(req, deps));
}
/**
 * Extracts a complete and parameterized path from the request object and uses it to construct transaction name.
 * If the parameterized transaction name cannot be extracted, we fall back to the raw URL.
 *
 * Additionally, this function determines and returns the transaction name source
 *
 * eg. GET /mountpoint/user/:id
 *
 * @param req A request object
 * @param options What to include in the transaction name (method, path, or a custom route name to be
 *                used instead of the request's route)
 *
 * @returns A tuple of the fully constructed transaction name [0] and its source [1] (can be either 'route' or 'url')
 */ function $b1ab576f40d005a1$export$8c5ebee2e5bb9575(req, options = {}) {
    const method = req.method && req.method.toUpperCase();
    let path = '';
    let source = 'url';
    // Check to see if there's a parameterized route we can use (as there is in Express)
    if (options.customRoute || req.route) {
        path = options.customRoute || `${req.baseUrl || ''}${req.route && req.route.path}`;
        source = 'route';
    } else if (req.originalUrl || req.url) path = (0, $7da207ca9fea49e7$export$ce084c78234bd35)(req.originalUrl || req.url || '');
    let name = '';
    if (options.method && method) name += method;
    if (options.method && options.path) name += ' ';
    if (options.path && path) name += path;
    return [
        name,
        source
    ];
}
/** JSDoc */ function $b1ab576f40d005a1$var$extractTransaction(req, type) {
    switch(type){
        case 'path':
            return $b1ab576f40d005a1$export$8c5ebee2e5bb9575(req, {
                path: true
            })[0];
        case 'handler':
            return req.route && req.route.stack && req.route.stack[0] && req.route.stack[0].name || '<anonymous>';
        case 'methodPath':
        default:
            {
                // if exist _reconstructedRoute return that path instead of route.path
                const customRoute = req._reconstructedRoute ? req._reconstructedRoute : undefined;
                return $b1ab576f40d005a1$export$8c5ebee2e5bb9575(req, {
                    path: true,
                    method: true,
                    customRoute: customRoute
                })[0];
            }
    }
}
/** JSDoc */ function $b1ab576f40d005a1$var$extractUserData(user, keys) {
    const extractedUser = {};
    const attributes = Array.isArray(keys) ? keys : $b1ab576f40d005a1$export$33c1c602a3538e5e;
    attributes.forEach((key)=>{
        if (user && key in user) extractedUser[key] = user[key];
    });
    return extractedUser;
}
/**
 * Normalize data from the request object, accounting for framework differences.
 *
 * @param req The request object from which to extract data
 * @param options.include An optional array of keys to include in the normalized data. Defaults to
 * DEFAULT_REQUEST_INCLUDES if not provided.
 * @param options.deps Injected, platform-specific dependencies
 * @returns An object containing normalized request data
 */ function $b1ab576f40d005a1$export$b5c5d78255f11c84(req, options) {
    const { include: include = $b1ab576f40d005a1$var$DEFAULT_REQUEST_INCLUDES, deps: deps } = options || {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const requestData = {};
    // headers:
    //   node, express, koa, nextjs: req.headers
    const headers = req.headers || {};
    // method:
    //   node, express, koa, nextjs: req.method
    const method = req.method;
    // host:
    //   express: req.hostname in > 4 and req.host in < 4
    //   koa: req.host
    //   node, nextjs: req.headers.host
    // Express 4 mistakenly strips off port number from req.host / req.hostname so we can't rely on them
    // See: https://github.com/expressjs/express/issues/3047#issuecomment-236653223
    // Also: https://github.com/getsentry/sentry-javascript/issues/1917
    const host = headers.host || req.hostname || req.host || '<no host>';
    // protocol:
    //   node, nextjs: <n/a>
    //   express, koa: req.protocol
    const protocol = req.protocol === 'https' || req.socket && req.socket.encrypted ? 'https' : 'http';
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    const originalUrl = req.originalUrl || req.url || '';
    // absolute url
    const absoluteUrl = originalUrl.startsWith(protocol) ? originalUrl : `${protocol}://${host}${originalUrl}`;
    include.forEach((key)=>{
        switch(key){
            case 'headers':
                requestData.headers = headers;
                // Remove the Cookie header in case cookie data should not be included in the event
                if (!include.includes('cookies')) delete requestData.headers.cookie;
                break;
            case 'method':
                requestData.method = method;
                break;
            case 'url':
                requestData.url = absoluteUrl;
                break;
            case 'cookies':
                // cookies:
                //   node, express, koa: req.headers.cookie
                //   vercel, sails.js, express (w/ cookie middleware), nextjs: req.cookies
                requestData.cookies = // TODO (v8 / #5257): We're only sending the empty object for backwards compatibility, so the last bit can
                // come off in v8
                req.cookies || headers.cookie && (0, $f39cd9e508f0a984$export$d0eaf3e94be578f6)(headers.cookie) || {};
                break;
            case 'query_string':
                // query string:
                //   node: req.url (raw)
                //   express, koa, nextjs: req.query
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                requestData.query_string = $b1ab576f40d005a1$var$extractQueryParams(req, deps);
                break;
            case 'data':
                if (method === 'GET' || method === 'HEAD') break;
                // body data:
                //   express, koa, nextjs: req.body
                //
                //   when using node by itself, you have to read the incoming stream(see
                //   https://nodejs.dev/learn/get-http-request-body-data-using-nodejs); if a user is doing that, we can't know
                //   where they're going to store the final result, so they'll have to capture this data themselves
                if (req.body !== undefined) requestData.data = (0, $5QZE4.isString)(req.body) ? req.body : JSON.stringify((0, $jn5uz.normalize)(req.body));
                break;
            default:
                if (({}).hasOwnProperty.call(req, key)) requestData[key] = req[key];
        }
    });
    return requestData;
}
/**
 * Add data from the given request to the given event
 *
 * @param event The event to which the request data will be added
 * @param req Request object
 * @param options.include Flags to control what data is included
 * @param options.deps Injected platform-specific dependencies
 * @returns The mutated `Event` object
 */ function $b1ab576f40d005a1$export$e560aeb323d2791d(event, req, options) {
    const include = {
        ...$b1ab576f40d005a1$var$DEFAULT_INCLUDES,
        ...options && options.include
    };
    if (include.request) {
        const extractedRequestData = Array.isArray(include.request) ? $b1ab576f40d005a1$export$b5c5d78255f11c84(req, {
            include: include.request,
            deps: options && options.deps
        }) : $b1ab576f40d005a1$export$b5c5d78255f11c84(req, {
            deps: options && options.deps
        });
        event.request = {
            ...event.request,
            ...extractedRequestData
        };
    }
    if (include.user) {
        const extractedUser = req.user && (0, $5QZE4.isPlainObject)(req.user) ? $b1ab576f40d005a1$var$extractUserData(req.user, include.user) : {};
        if (Object.keys(extractedUser).length) event.user = {
            ...event.user,
            ...extractedUser
        };
    }
    // client ip:
    //   node, nextjs: req.socket.remoteAddress
    //   express, koa: req.ip
    if (include.ip) {
        const ip = req.ip || req.socket && req.socket.remoteAddress;
        if (ip) event.user = {
            ...event.user,
            ip_address: ip
        };
    }
    if (include.transaction && !event.transaction) // TODO do we even need this anymore?
    // TODO make this work for nextjs
    event.transaction = $b1ab576f40d005a1$var$extractTransaction(req, include.transaction);
    return event;
}
function $b1ab576f40d005a1$var$extractQueryParams(req, deps) {
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    let originalUrl = req.originalUrl || req.url || '';
    if (!originalUrl) return;
    // The `URL` constructor can't handle internal URLs of the form `/some/path/here`, so stick a dummy protocol and
    // hostname on the beginning. Since the point here is just to grab the query string, it doesn't matter what we use.
    if (originalUrl.startsWith('/')) originalUrl = `http://dogs.are.great${originalUrl}`;
    try {
        return req.query || typeof URL !== 'undefined' && new URL(originalUrl).search.slice(1) || // In Node 8, `URL` isn't in the global scope, so we have to use the built-in module from Node
        deps && deps.url && deps.url.parse(originalUrl).query || undefined;
    } catch (e2) {
        return undefined;
    }
}
/**
 * Transforms a `Headers` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into a simple key-value dict.
 * The header keys will be lower case: e.g. A "Content-Type" header will be stored as "content-type".
 */ // TODO(v8): Make this function return undefined when the extraction fails.
function $b1ab576f40d005a1$export$fee0927b05379c23(winterCGHeaders) {
    const headers = {};
    try {
        winterCGHeaders.forEach((value, key)=>{
            if (typeof value === 'string') // We check that value is a string even though it might be redundant to make sure prototype pollution is not possible.
            headers[key] = value;
        });
    } catch (e) {
        (0, $8FmHF.DEBUG_BUILD) && (0, $7htw4.logger).warn('Sentry failed extracting headers from a request object. If you see this, please file an issue.');
    }
    return headers;
}
/**
 * Converts a `Request` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into the format that the `RequestData` integration understands.
 */ function $b1ab576f40d005a1$export$49a11ed11911fd29(req) {
    const headers = $b1ab576f40d005a1$export$fee0927b05379c23(req.headers);
    return {
        method: req.method,
        url: req.url,
        headers: headers
    };
}


var $5QZE4 = parcelRequire("5QZE4");
var $6HS3j = parcelRequire("6HS3j");

var $5NO4E = parcelRequire("5NO4E");
var $2Y7aX = parcelRequire("2Y7aX");


/* eslint-disable max-lines */ /**
 * Express integration
 *
 * Provides an request and error handler for Express framework as well as tracing capabilities
 */ class $21f5079ecaa54eb0$export$6dafdd8fec05099d {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Express';
    }
    /**
   * @inheritDoc
   */ /**
   * Express App instance
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $21f5079ecaa54eb0$export$6dafdd8fec05099d.id;
        this._router = options.router || options.app;
        this._methods = (Array.isArray(options.methods) ? options.methods : []).concat('use');
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if (!this._router) {
            (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).error('ExpressIntegration is missing an Express instance');
            return;
        }
        if ((0, $e4d0735f97e9263d$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).log('Express Integration is skipped because of instrumenter configuration.');
            return;
        }
        $21f5079ecaa54eb0$var$instrumentMiddlewares(this._router, this._methods);
        $21f5079ecaa54eb0$var$instrumentRouter(this._router);
    }
}
$21f5079ecaa54eb0$export$6dafdd8fec05099d.__initStatic();
/**
 * Wraps original middleware function in a tracing call, which stores the info about the call as a span,
 * and finishes it once the middleware is done invoking.
 *
 * Express middlewares have 3 various forms, thus we have to take care of all of them:
 * // sync
 * app.use(function (req, res) { ... })
 * // async
 * app.use(function (req, res, next) { ... })
 * // error handler
 * app.use(function (err, req, res, next) { ... })
 *
 * They all internally delegate to the `router[method]` of the given application instance.
 */ // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
function $21f5079ecaa54eb0$var$wrap(fn, method) {
    const arity = fn.length;
    switch(arity){
        case 2:
            return function(req, res) {
                const transaction = res.__sentry_transaction;
                if (transaction) {
                    // eslint-disable-next-line deprecation/deprecation
                    const span = transaction.startChild({
                        description: fn.name,
                        op: `middleware.express.${method}`,
                        origin: 'auto.middleware.express'
                    });
                    res.once('finish', ()=>{
                        span.end();
                    });
                }
                return fn.call(this, req, res);
            };
        case 3:
            return function(req, res, next) {
                const transaction = res.__sentry_transaction;
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                    transaction,
                    'optionalAccess',
                    (_2)=>_2.startChild,
                    'call',
                    (_3)=>_3({
                            description: fn.name,
                            op: `middleware.express.${method}`,
                            origin: 'auto.middleware.express'
                        })
                ]);
                fn.call(this, req, res, function(...args) {
                    (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                        span,
                        'optionalAccess',
                        (_4)=>_4.end,
                        'call',
                        (_5)=>_5()
                    ]);
                    next.call(this, ...args);
                });
            };
        case 4:
            return function(err, req, res, next) {
                const transaction = res.__sentry_transaction;
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                    transaction,
                    'optionalAccess',
                    (_6)=>_6.startChild,
                    'call',
                    (_7)=>_7({
                            description: fn.name,
                            op: `middleware.express.${method}`,
                            origin: 'auto.middleware.express'
                        })
                ]);
                fn.call(this, err, req, res, function(...args) {
                    (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                        span,
                        'optionalAccess',
                        (_8)=>_8.end,
                        'call',
                        (_9)=>_9()
                    ]);
                    next.call(this, ...args);
                });
            };
        default:
            throw new Error(`Express middleware takes 2-4 arguments. Got: ${arity}`);
    }
}
/**
 * Takes all the function arguments passed to the original `app` or `router` method, eg. `app.use` or `router.use`
 * and wraps every function, as well as array of functions with a call to our `wrap` method.
 * We have to take care of the arrays as well as iterate over all of the arguments,
 * as `app.use` can accept middlewares in few various forms.
 *
 * app.use([<path>], <fn>)
 * app.use([<path>], <fn>, ...<fn>)
 * app.use([<path>], ...<fn>[])
 */ function $21f5079ecaa54eb0$var$wrapMiddlewareArgs(args, method) {
    return args.map((arg)=>{
        if (typeof arg === 'function') return $21f5079ecaa54eb0$var$wrap(arg, method);
        if (Array.isArray(arg)) return arg.map((a)=>{
            if (typeof a === 'function') return $21f5079ecaa54eb0$var$wrap(a, method);
            return a;
        });
        return arg;
    });
}
/**
 * Patches original router to utilize our tracing functionality
 */ function $21f5079ecaa54eb0$var$patchMiddleware(router, method) {
    const originalCallback = router[method];
    router[method] = function(...args) {
        return originalCallback.call(this, ...$21f5079ecaa54eb0$var$wrapMiddlewareArgs(args, method));
    };
    return router;
}
/**
 * Patches original router methods
 */ function $21f5079ecaa54eb0$var$instrumentMiddlewares(router, methods = []) {
    methods.forEach((method)=>$21f5079ecaa54eb0$var$patchMiddleware(router, method));
}
/**
 * Patches the prototype of Express.Router to accumulate the resolved route
 * if a layer instance's `match` function was called and it returned a successful match.
 *
 * @see https://github.com/expressjs/express/blob/master/lib/router/index.js
 *
 * @param appOrRouter the router instance which can either be an app (i.e. top-level) or a (nested) router.
 */ function $21f5079ecaa54eb0$var$instrumentRouter(appOrRouter) {
    // This is how we can distinguish between app and routers
    const isApp = 'settings' in appOrRouter;
    // In case the app's top-level router hasn't been initialized yet, we have to do it now
    if (isApp && appOrRouter._router === undefined && appOrRouter.lazyrouter) appOrRouter.lazyrouter();
    const router = isApp ? appOrRouter._router : appOrRouter;
    if (!router) {
        /*
    If we end up here, this means likely that this integration is used with Express 3 or Express 5.
    For now, we don't support these versions (3 is very old and 5 is still in beta). To support Express 5,
    we'd need to make more changes to the routing instrumentation because the router is no longer part of
    the Express core package but maintained in its own package. The new router has different function
    signatures and works slightly differently, demanding more changes than just taking the router from
    `app.router` instead of `app._router`.
    @see https://github.com/pillarjs/router

    TODO: Proper Express 5 support
    */ (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).debug('Cannot instrument router for URL Parameterization (did not find a valid router).');
        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).debug('Routing instrumentation is currently only supported in Express 4.');
        return;
    }
    const routerProto = Object.getPrototypeOf(router);
    const originalProcessParams = routerProto.process_params;
    routerProto.process_params = function process_params(layer, called, req, res, done) {
        // Base case: We're in the first part of the URL (thus we start with the root '/')
        if (!req._reconstructedRoute) req._reconstructedRoute = '';
        // If the layer's partial route has params, is a regex or an array, the route is stored in layer.route.
        const { layerRoutePath: layerRoutePath, isRegex: isRegex, isArray: isArray, numExtraSegments: numExtraSegments } = $21f5079ecaa54eb0$var$getLayerRoutePathInfo(layer);
        if (layerRoutePath || isRegex || isArray) req._hasParameters = true;
        // Otherwise, the hardcoded path (i.e. a partial route without params) is stored in layer.path
        let partialRoute;
        if (layerRoutePath) partialRoute = layerRoutePath;
        else /**
       * prevent duplicate segment in _reconstructedRoute param if router match multiple routes before final path
       * example:
       * original url: /api/v1/1234
       * prevent: /api/api/v1/:userId
       * router structure
       * /api -> middleware
       * /api/v1 -> middleware
       * /1234 -> endpoint with param :userId
       * final _reconstructedRoute is /api/v1/:userId
       */ partialRoute = $21f5079ecaa54eb0$export$ea5dbbfd8423c1fa(req.originalUrl, req._reconstructedRoute, layer.path) || '';
        // Normalize the partial route so that it doesn't contain leading or trailing slashes
        // and exclude empty or '*' wildcard routes.
        // The exclusion of '*' routes is our best effort to not "pollute" the transaction name
        // with interim handlers (e.g. ones that check authentication or do other middleware stuff).
        // We want to end up with the parameterized URL of the incoming request without any extraneous path segments.
        const finalPartialRoute = partialRoute.split('/').filter((segment)=>segment.length > 0 && (isRegex || isArray || !segment.includes('*'))).join('/');
        // If we found a valid partial URL, we append it to the reconstructed route
        if (finalPartialRoute && finalPartialRoute.length > 0) // If the partial route is from a regex route, we append a '/' to close the regex
        req._reconstructedRoute += `/${finalPartialRoute}${isRegex ? '/' : ''}`;
        // Now we check if we are in the "last" part of the route. We determine this by comparing the
        // number of URL segments from the original URL to that of our reconstructed parameterized URL.
        // If we've reached our final destination, we update the transaction name.
        const urlLength = (0, $7da207ca9fea49e7$export$69dd85280a8d374c)((0, $7da207ca9fea49e7$export$ce084c78234bd35)(req.originalUrl || '')) + numExtraSegments;
        const routeLength = (0, $7da207ca9fea49e7$export$69dd85280a8d374c)(req._reconstructedRoute);
        if (urlLength === routeLength) {
            if (!req._hasParameters) {
                if (req._reconstructedRoute !== req.originalUrl) req._reconstructedRoute = req.originalUrl ? (0, $7da207ca9fea49e7$export$ce084c78234bd35)(req.originalUrl) : req.originalUrl;
            }
            const transaction = res.__sentry_transaction;
            const attributes = transaction && (0, $5NO4E.spanToJSON)(transaction).data || {};
            if (transaction && attributes[0, $2Y7aX.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] !== 'custom') {
                // If the request URL is '/' or empty, the reconstructed route will be empty.
                // Therefore, we fall back to setting the final route to '/' in this case.
                const finalRoute = req._reconstructedRoute || '/';
                const [name, source] = (0, $b1ab576f40d005a1$export$8c5ebee2e5bb9575)(req, {
                    path: true,
                    method: true,
                    customRoute: finalRoute
                });
                transaction.updateName(name);
                transaction.setAttribute((0, $2Y7aX.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
            }
        }
        return originalProcessParams.call(this, layer, called, req, res, done);
    };
}
/**
 * Recreate layer.route.path from layer.regexp and layer.keys.
 * Works until express.js used package path-to-regexp@0.1.7
 * or until layer.keys contain offset attribute
 *
 * @param layer the layer to extract the stringified route from
 *
 * @returns string in layer.route.path structure 'router/:pathParam' or undefined
 */ const $21f5079ecaa54eb0$export$bde9c19304d7dbd3 = (path, regexp, keys)=>{
    if (!path || !regexp || !keys || Object.keys(keys).length === 0 || (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
        keys,
        'access',
        (_10)=>_10[0],
        'optionalAccess',
        (_11)=>_11.offset
    ]) === undefined || (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
        keys,
        'access',
        (_12)=>_12[0],
        'optionalAccess',
        (_13)=>_13.offset
    ]) === null) return undefined;
    const orderedKeys = keys.sort((a, b)=>a.offset - b.offset);
    // add d flag for getting indices from regexp result
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- regexp comes from express.js
    const pathRegex = new RegExp(regexp, `${regexp.flags}d`);
    /**
   * use custom type cause of TS error with missing indices in RegExpExecArray
   */ const execResult = pathRegex.exec(path);
    if (!execResult || !execResult.indices) return undefined;
    /**
   * remove first match from regex cause contain whole layer.path
   */ const [, ...paramIndices] = execResult.indices;
    if (paramIndices.length !== orderedKeys.length) return undefined;
    let resultPath = path;
    let indexShift = 0;
    /**
   * iterate param matches from regexp.exec
   */ paramIndices.forEach((item, index)=>{
        /** check if offsets is define because in some cases regex d flag returns undefined */ if (item) {
            const [startOffset, endOffset] = item;
            /**
       * isolate part before param
       */ const substr1 = resultPath.substring(0, startOffset - indexShift);
            /**
       * define paramName as replacement in format :pathParam
       */ const replacement = `:${orderedKeys[index].name}`;
            /**
       * isolate part after param
       */ const substr2 = resultPath.substring(endOffset - indexShift);
            /**
       * recreate original path but with param replacement
       */ resultPath = substr1 + replacement + substr2;
            /**
       * calculate new index shift after resultPath was modified
       */ indexShift = indexShift + (endOffset - startOffset - replacement.length);
        }
    });
    return resultPath;
};
/**
 * Extracts and stringifies the layer's route which can either be a string with parameters (`users/:id`),
 * a RegEx (`/test/`) or an array of strings and regexes (`['/path1', /\/path[2-5]/, /path/:id]`). Additionally
 * returns extra information about the route, such as if the route is defined as regex or as an array.
 *
 * @param layer the layer to extract the stringified route from
 *
 * @returns an object containing the stringified route, a flag determining if the route was a regex
 *          and the number of extra segments to the matched path that are additionally in the route,
 *          if the route was an array (defaults to 0).
 */ function $21f5079ecaa54eb0$var$getLayerRoutePathInfo(layer) {
    let lrp = (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
        layer,
        'access',
        (_14)=>_14.route,
        'optionalAccess',
        (_15)=>_15.path
    ]);
    const isRegex = (0, $5QZE4.isRegExp)(lrp);
    const isArray = Array.isArray(lrp);
    if (!lrp) {
        // parse node.js major version
        // Next.js will complain if we directly use `proces.versions` here because of edge runtime.
        const [major] = (0, $6HS3j.GLOBAL_OBJ).process.versions.node.split('.').map(Number);
        // allow call extractOriginalRoute only if node version support Regex d flag, node 16+
        if (major >= 16) /**
       * If lrp does not exist try to recreate original layer path from route regexp
       */ lrp = $21f5079ecaa54eb0$export$bde9c19304d7dbd3(layer.path, layer.regexp, layer.keys);
    }
    if (!lrp) return {
        isRegex: isRegex,
        isArray: isArray,
        numExtraSegments: 0
    };
    const numExtraSegments = isArray ? Math.max($21f5079ecaa54eb0$var$getNumberOfArrayUrlSegments(lrp) - (0, $7da207ca9fea49e7$export$69dd85280a8d374c)(layer.path || ''), 0) : 0;
    const layerRoutePath = $21f5079ecaa54eb0$var$getLayerRoutePathString(isArray, lrp);
    return {
        layerRoutePath: layerRoutePath,
        isRegex: isRegex,
        isArray: isArray,
        numExtraSegments: numExtraSegments
    };
}
/**
 * Returns the number of URL segments in an array of routes
 *
 * Example: ['/api/test', /\/api\/post[0-9]/, '/users/:id/details`] -> 7
 */ function $21f5079ecaa54eb0$var$getNumberOfArrayUrlSegments(routesArray) {
    return routesArray.reduce((accNumSegments, currentRoute)=>{
        // array members can be a RegEx -> convert them toString
        return accNumSegments + (0, $7da207ca9fea49e7$export$69dd85280a8d374c)(currentRoute.toString());
    }, 0);
}
/**
 * Extracts and returns the stringified version of the layers route path
 * Handles route arrays (by joining the paths together) as well as RegExp and normal
 * string values (in the latter case the toString conversion is technically unnecessary but
 * it doesn't hurt us either).
 */ function $21f5079ecaa54eb0$var$getLayerRoutePathString(isArray, lrp) {
    if (isArray) return lrp.map((r)=>r.toString()).join(',');
    return lrp && lrp.toString();
}
/**
 * remove duplicate segment contain in layerPath against reconstructedRoute,
 * and return only unique segment that can be added into reconstructedRoute
 */ function $21f5079ecaa54eb0$export$ea5dbbfd8423c1fa(originalUrl, reconstructedRoute, layerPath) {
    // filter query params
    const normalizeURL = (0, $7da207ca9fea49e7$export$ce084c78234bd35)(originalUrl || '');
    const originalUrlSplit = (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
        normalizeURL,
        'optionalAccess',
        (_16)=>_16.split,
        'call',
        (_17)=>_17('/'),
        'access',
        (_18)=>_18.filter,
        'call',
        (_19)=>_19((v)=>!!v)
    ]);
    let tempCounter = 0;
    const currentOffset = (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
        reconstructedRoute,
        'optionalAccess',
        (_20)=>_20.split,
        'call',
        (_21)=>_21('/'),
        'access',
        (_22)=>_22.filter,
        'call',
        (_23)=>_23((v)=>!!v),
        'access',
        (_24)=>_24.length
    ]) || 0;
    const result = (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
        layerPath,
        'optionalAccess',
        (_25)=>_25.split,
        'call',
        (_26)=>_26('/'),
        'access',
        (_27)=>_27.filter,
        'call',
        (_28)=>_28((segment)=>{
                if ((0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                    originalUrlSplit,
                    'optionalAccess',
                    (_29)=>_29[currentOffset + tempCounter]
                ]) === segment) {
                    tempCounter += 1;
                    return true;
                }
                return false;
            }),
        'access',
        (_30)=>_30.join,
        'call',
        (_31)=>_31('/')
    ]);
    return result;
}


var $8upap = parcelRequire("8upap");
var $7htw4 = parcelRequire("7htw4");
var $bP4Y8 = parcelRequire("bP4Y8");
var $5QZE4 = parcelRequire("5QZE4");


/** Tracing integration for graphql package */ class $878796551b21cf4f$export$b735d011553f1049 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'GraphQL';
    }
    /**
   * @inheritDoc
   */ constructor(){
        this.name = $878796551b21cf4f$export$b735d011553f1049.id;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $8upap.loadModule)('graphql/execution/execute.js');
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if ((0, $e4d0735f97e9263d$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).log('GraphQL Integration is skipped because of instrumenter configuration.');
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).error('GraphQL Integration was unable to require graphql/execution package.');
            return;
        }
        (0, $bP4Y8.fill)(pkg, 'execute', function(orig) {
            return function(...args) {
                // eslint-disable-next-line deprecation/deprecation
                const scope = getCurrentHub().getScope();
                // eslint-disable-next-line deprecation/deprecation
                const parentSpan = scope.getSpan();
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                    parentSpan,
                    'optionalAccess',
                    (_2)=>_2.startChild,
                    'call',
                    (_3)=>_3({
                            description: 'execute',
                            op: 'graphql.execute',
                            origin: 'auto.graphql.graphql'
                        })
                ]);
                // eslint-disable-next-line deprecation/deprecation
                (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                    scope,
                    'optionalAccess',
                    (_4)=>_4.setSpan,
                    'call',
                    (_5)=>_5(span)
                ]);
                const rv = orig.call(this, ...args);
                if ((0, $5QZE4.isThenable)(rv)) return rv.then((res)=>{
                    (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                        span,
                        'optionalAccess',
                        (_6)=>_6.end,
                        'call',
                        (_7)=>_7()
                    ]);
                    // eslint-disable-next-line deprecation/deprecation
                    (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                        scope,
                        'optionalAccess',
                        (_8)=>_8.setSpan,
                        'call',
                        (_9)=>_9(parentSpan)
                    ]);
                    return res;
                });
                (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                    span,
                    'optionalAccess',
                    (_10)=>_10.end,
                    'call',
                    (_11)=>_11()
                ]);
                // eslint-disable-next-line deprecation/deprecation
                (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                    scope,
                    'optionalAccess',
                    (_12)=>_12.setSpan,
                    'call',
                    (_13)=>_13(parentSpan)
                ]);
                return rv;
            };
        });
    }
}
$878796551b21cf4f$export$b735d011553f1049.__initStatic();


var $8upap = parcelRequire("8upap");
var $7htw4 = parcelRequire("7htw4");
var $bP4Y8 = parcelRequire("bP4Y8");
var $5QZE4 = parcelRequire("5QZE4");


// This allows us to use the same array for both defaults options and the type itself.
// (note `as const` at the end to make it a union of string literal types (i.e. "a" | "b" | ... )
// and not just a string[])
const $8a5bd31083ad79fe$var$OPERATIONS = [
    'aggregate',
    'bulkWrite',
    'countDocuments',
    'createIndex',
    'createIndexes',
    'deleteMany',
    'deleteOne',
    'distinct',
    'drop',
    'dropIndex',
    'dropIndexes',
    'estimatedDocumentCount',
    'find',
    'findOne',
    'findOneAndDelete',
    'findOneAndReplace',
    'findOneAndUpdate',
    'indexes',
    'indexExists',
    'indexInformation',
    'initializeOrderedBulkOp',
    'insertMany',
    'insertOne',
    'isCapped',
    'mapReduce',
    'options',
    'parallelCollectionScan',
    'rename',
    'replaceOne',
    'stats',
    'updateMany',
    'updateOne'
];
// All of the operations above take `options` and `callback` as their final parameters, but some of them
// take additional parameters as well. For those operations, this is a map of
// { <operation name>:  [<names of additional parameters>] }, as a way to know what to call the operation's
// positional arguments when we add them to the span's `data` object later
const $8a5bd31083ad79fe$var$OPERATION_SIGNATURES = {
    // aggregate intentionally not included because `pipeline` arguments are too complex to serialize well
    // see https://github.com/getsentry/sentry-javascript/pull/3102
    bulkWrite: [
        'operations'
    ],
    countDocuments: [
        'query'
    ],
    createIndex: [
        'fieldOrSpec'
    ],
    createIndexes: [
        'indexSpecs'
    ],
    deleteMany: [
        'filter'
    ],
    deleteOne: [
        'filter'
    ],
    distinct: [
        'key',
        'query'
    ],
    dropIndex: [
        'indexName'
    ],
    find: [
        'query'
    ],
    findOne: [
        'query'
    ],
    findOneAndDelete: [
        'filter'
    ],
    findOneAndReplace: [
        'filter',
        'replacement'
    ],
    findOneAndUpdate: [
        'filter',
        'update'
    ],
    indexExists: [
        'indexes'
    ],
    insertMany: [
        'docs'
    ],
    insertOne: [
        'doc'
    ],
    mapReduce: [
        'map',
        'reduce'
    ],
    rename: [
        'newName'
    ],
    replaceOne: [
        'filter',
        'doc'
    ],
    updateMany: [
        'filter',
        'update'
    ],
    updateOne: [
        'filter',
        'update'
    ]
};
function $8a5bd31083ad79fe$var$isCursor(maybeCursor) {
    return maybeCursor && typeof maybeCursor === 'object' && maybeCursor.once && typeof maybeCursor.once === 'function';
}
/** Tracing integration for mongo package */ class $8a5bd31083ad79fe$export$968aa4360b02a334 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Mongo';
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $8a5bd31083ad79fe$export$968aa4360b02a334.id;
        this._operations = Array.isArray(options.operations) ? options.operations : $8a5bd31083ad79fe$var$OPERATIONS;
        this._describeOperations = 'describeOperations' in options ? options.describeOperations : true;
        this._useMongoose = !!options.useMongoose;
    }
    /** @inheritdoc */ loadDependency() {
        const moduleName = this._useMongoose ? 'mongoose' : 'mongodb';
        return this._module = this._module || (0, $8upap.loadModule)(moduleName);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if ((0, $e4d0735f97e9263d$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).log('Mongo Integration is skipped because of instrumenter configuration.');
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            const moduleName = this._useMongoose ? 'mongoose' : 'mongodb';
            (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).error(`Mongo Integration was unable to require \`${moduleName}\` package.`);
            return;
        }
        this._instrumentOperations(pkg.Collection, this._operations, getCurrentHub);
    }
    /**
   * Patches original collection methods
   */ // eslint-disable-next-line deprecation/deprecation
    _instrumentOperations(collection, operations, getCurrentHub) {
        operations.forEach((operation)=>this._patchOperation(collection, operation, getCurrentHub));
    }
    /**
   * Patches original collection to utilize our tracing functionality
   */ // eslint-disable-next-line deprecation/deprecation
    _patchOperation(collection, operation, getCurrentHub) {
        if (!(operation in collection.prototype)) return;
        const getSpanContext = this._getSpanContextFromOperationArguments.bind(this);
        (0, $bP4Y8.fill)(collection.prototype, operation, function(orig) {
            return function(...args) {
                const lastArg = args[args.length - 1];
                // eslint-disable-next-line deprecation/deprecation
                const hub = getCurrentHub();
                // eslint-disable-next-line deprecation/deprecation
                const scope = hub.getScope();
                // eslint-disable-next-line deprecation/deprecation
                const client = hub.getClient();
                // eslint-disable-next-line deprecation/deprecation
                const parentSpan = scope.getSpan();
                const sendDefaultPii = (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                    client,
                    'optionalAccess',
                    (_2)=>_2.getOptions,
                    'call',
                    (_3)=>_3(),
                    'access',
                    (_4)=>_4.sendDefaultPii
                ]);
                // Check if the operation was passed a callback. (mapReduce requires a different check, as
                // its (non-callback) arguments can also be functions.)
                if (typeof lastArg !== 'function' || operation === 'mapReduce' && args.length === 2) {
                    // eslint-disable-next-line deprecation/deprecation
                    const span = (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                        parentSpan,
                        'optionalAccess',
                        (_5)=>_5.startChild,
                        'call',
                        (_6)=>_6(getSpanContext(this, operation, args, sendDefaultPii))
                    ]);
                    const maybePromiseOrCursor = orig.call(this, ...args);
                    if ((0, $5QZE4.isThenable)(maybePromiseOrCursor)) return maybePromiseOrCursor.then((res)=>{
                        (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                            span,
                            'optionalAccess',
                            (_7)=>_7.end,
                            'call',
                            (_8)=>_8()
                        ]);
                        return res;
                    });
                    else if ($8a5bd31083ad79fe$var$isCursor(maybePromiseOrCursor)) {
                        const cursor = maybePromiseOrCursor;
                        try {
                            cursor.once('close', ()=>{
                                (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                                    span,
                                    'optionalAccess',
                                    (_9)=>_9.end,
                                    'call',
                                    (_10)=>_10()
                                ]);
                            });
                        } catch (e) {
                            // If the cursor is already closed, `once` will throw an error. In that case, we can
                            // finish the span immediately.
                            (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                                span,
                                'optionalAccess',
                                (_11)=>_11.end,
                                'call',
                                (_12)=>_12()
                            ]);
                        }
                        return cursor;
                    } else {
                        (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                            span,
                            'optionalAccess',
                            (_13)=>_13.end,
                            'call',
                            (_14)=>_14()
                        ]);
                        return maybePromiseOrCursor;
                    }
                }
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                    parentSpan,
                    'optionalAccess',
                    (_15)=>_15.startChild,
                    'call',
                    (_16)=>_16(getSpanContext(this, operation, args.slice(0, -1)))
                ]);
                return orig.call(this, ...args.slice(0, -1), function(err, result) {
                    (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                        span,
                        'optionalAccess',
                        (_17)=>_17.end,
                        'call',
                        (_18)=>_18()
                    ]);
                    lastArg(err, result);
                });
            };
        });
    }
    /**
   * Form a SpanContext based on the user input to a given operation.
   */ _getSpanContextFromOperationArguments(collection, operation, args, sendDefaultPii = false) {
        const data = {
            'db.system': 'mongodb',
            'db.name': collection.dbName,
            'db.operation': operation,
            'db.mongodb.collection': collection.collectionName
        };
        const spanContext = {
            op: 'db',
            // TODO v8: Use `${collection.collectionName}.${operation}`
            origin: 'auto.db.mongo',
            description: operation,
            data: data
        };
        // If the operation takes no arguments besides `options` and `callback`, or if argument
        // collection is disabled for this operation, just return early.
        const signature = $8a5bd31083ad79fe$var$OPERATION_SIGNATURES[operation];
        const shouldDescribe = Array.isArray(this._describeOperations) ? this._describeOperations.includes(operation) : this._describeOperations;
        if (!signature || !shouldDescribe || !sendDefaultPii) return spanContext;
        try {
            // Special case for `mapReduce`, as the only one accepting functions as arguments.
            if (operation === 'mapReduce') {
                const [map, reduce] = args;
                data[signature[0]] = typeof map === 'string' ? map : map.name || '<anonymous>';
                data[signature[1]] = typeof reduce === 'string' ? reduce : reduce.name || '<anonymous>';
            } else for(let i = 0; i < signature.length; i++)data[`db.mongodb.${signature[i]}`] = JSON.stringify(args[i]);
        } catch (_oO) {
        // no-empty
        }
        return spanContext;
    }
}
$8a5bd31083ad79fe$export$968aa4360b02a334.__initStatic();


var $8upap = parcelRequire("8upap");
var $7htw4 = parcelRequire("7htw4");
var $bP4Y8 = parcelRequire("bP4Y8");


/** Tracing integration for node-mysql package */ class $89e31c484273d689$export$a2cc26ff91a3f8ad {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Mysql';
    }
    /**
   * @inheritDoc
   */ constructor(){
        this.name = $89e31c484273d689$export$a2cc26ff91a3f8ad.id;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $8upap.loadModule)('mysql/lib/Connection.js');
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if ((0, $e4d0735f97e9263d$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).log('Mysql Integration is skipped because of instrumenter configuration.');
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).error('Mysql Integration was unable to require `mysql` package.');
            return;
        }
        let mySqlConfig = undefined;
        try {
            pkg.prototype.connect = new Proxy(pkg.prototype.connect, {
                apply (wrappingTarget, thisArg, args) {
                    if (!mySqlConfig) mySqlConfig = thisArg.config;
                    return wrappingTarget.apply(thisArg, args);
                }
            });
        } catch (e) {
            (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).error('Mysql Integration was unable to instrument `mysql` config.');
        }
        function spanDataFromConfig() {
            if (!mySqlConfig) return {};
            return {
                'server.address': mySqlConfig.host,
                'server.port': mySqlConfig.port,
                'db.user': mySqlConfig.user
            };
        }
        function finishSpan(span) {
            if (!span) return;
            const data = spanDataFromConfig();
            Object.keys(data).forEach((key)=>{
                span.setAttribute(key, data[key]);
            });
            span.end();
        }
        // The original function will have one of these signatures:
        //    function (callback) => void
        //    function (options, callback) => void
        //    function (options, values, callback) => void
        (0, $bP4Y8.fill)(pkg, 'createQuery', function(orig) {
            return function(options, values, callback) {
                // eslint-disable-next-line deprecation/deprecation
                const scope = getCurrentHub().getScope();
                // eslint-disable-next-line deprecation/deprecation
                const parentSpan = scope.getSpan();
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                    parentSpan,
                    'optionalAccess',
                    (_2)=>_2.startChild,
                    'call',
                    (_3)=>_3({
                            description: typeof options === 'string' ? options : options.sql,
                            op: 'db',
                            origin: 'auto.db.mysql',
                            data: {
                                'db.system': 'mysql'
                            }
                        })
                ]);
                if (typeof callback === 'function') return orig.call(this, options, values, function(err, result, fields) {
                    finishSpan(span);
                    callback(err, result, fields);
                });
                if (typeof values === 'function') return orig.call(this, options, function(err, result, fields) {
                    finishSpan(span);
                    values(err, result, fields);
                });
                // streaming, no callback!
                const query = orig.call(this, options, values);
                query.on('end', ()=>{
                    finishSpan(span);
                });
                return query;
            };
        });
    }
}
$89e31c484273d689$export$a2cc26ff91a3f8ad.__initStatic();


var $8upap = parcelRequire("8upap");
var $7htw4 = parcelRequire("7htw4");
var $bP4Y8 = parcelRequire("bP4Y8");
var $5QZE4 = parcelRequire("5QZE4");


/** Tracing integration for node-postgres package */ class $8e82cbe7f73987c6$export$806ddb599177abc4 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Postgres';
    }
    /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $8e82cbe7f73987c6$export$806ddb599177abc4.id;
        this._usePgNative = !!options.usePgNative;
        this._module = options.module;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $8upap.loadModule)('pg');
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if ((0, $e4d0735f97e9263d$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).log('Postgres Integration is skipped because of instrumenter configuration.');
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).error('Postgres Integration was unable to require `pg` package.');
            return;
        }
        const Client = this._usePgNative ? (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
            pkg,
            'access',
            (_2)=>_2.native,
            'optionalAccess',
            (_3)=>_3.Client
        ]) : pkg.Client;
        if (!Client) {
            (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).error("Postgres Integration was unable to access 'pg-native' bindings.");
            return;
        }
        /**
     * function (query, callback) => void
     * function (query, params, callback) => void
     * function (query) => Promise
     * function (query, params) => Promise
     * function (pg.Cursor) => pg.Cursor
     */ (0, $bP4Y8.fill)(Client.prototype, 'query', function(orig) {
            return function(config, values, callback) {
                // eslint-disable-next-line deprecation/deprecation
                const scope = getCurrentHub().getScope();
                // eslint-disable-next-line deprecation/deprecation
                const parentSpan = scope.getSpan();
                const data = {
                    'db.system': 'postgresql'
                };
                try {
                    if (this.database) data['db.name'] = this.database;
                    if (this.host) data['server.address'] = this.host;
                    if (this.port) data['server.port'] = this.port;
                    if (this.user) data['db.user'] = this.user;
                } catch (e) {
                // ignore
                }
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                    parentSpan,
                    'optionalAccess',
                    (_4)=>_4.startChild,
                    'call',
                    (_5)=>_5({
                            description: typeof config === 'string' ? config : config.text,
                            op: 'db',
                            origin: 'auto.db.postgres',
                            data: data
                        })
                ]);
                if (typeof callback === 'function') return orig.call(this, config, values, function(err, result) {
                    (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                        span,
                        'optionalAccess',
                        (_6)=>_6.end,
                        'call',
                        (_7)=>_7()
                    ]);
                    callback(err, result);
                });
                if (typeof values === 'function') return orig.call(this, config, function(err, result) {
                    (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                        span,
                        'optionalAccess',
                        (_8)=>_8.end,
                        'call',
                        (_9)=>_9()
                    ]);
                    values(err, result);
                });
                const rv = typeof values !== 'undefined' ? orig.call(this, config, values) : orig.call(this, config);
                if ((0, $5QZE4.isThenable)(rv)) return rv.then((res)=>{
                    (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                        span,
                        'optionalAccess',
                        (_10)=>_10.end,
                        'call',
                        (_11)=>_11()
                    ]);
                    return res;
                });
                (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                    span,
                    'optionalAccess',
                    (_12)=>_12.end,
                    'call',
                    (_13)=>_13()
                ]);
                return rv;
            };
        });
    }
}
$8e82cbe7f73987c6$export$806ddb599177abc4.__initStatic();


var $gUaXH = parcelRequire("gUaXH");
var $4DAh4 = parcelRequire("4DAh4");
var $2Y7aX = parcelRequire("2Y7aX");

var $bP4Y8 = parcelRequire("bP4Y8");
var $7htw4 = parcelRequire("7htw4");


function $2e88fe1d8fd8d85d$var$isValidPrismaClient(possibleClient) {
    return !!possibleClient && !!possibleClient['$use'];
}
/** Tracing integration for @prisma/client package */ class $2e88fe1d8fd8d85d$export$e300e6f4779d55c2 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Prisma';
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $2e88fe1d8fd8d85d$export$e300e6f4779d55c2.id;
        // We instrument the PrismaClient inside the constructor and not inside `setupOnce` because in some cases of server-side
        // bundling (Next.js) multiple Prisma clients can be instantiated, even though users don't intend to. When instrumenting
        // in setupOnce we can only ever instrument one client.
        // https://github.com/getsentry/sentry-javascript/issues/7216#issuecomment-1602375012
        // In the future we might explore providing a dedicated PrismaClient middleware instead of this hack.
        if ($2e88fe1d8fd8d85d$var$isValidPrismaClient(options.client) && !options.client._sentryInstrumented) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $bP4Y8.addNonEnumerableProperty)(options.client, '_sentryInstrumented', true);
            const clientData = {};
            try {
                const engineConfig = options.client._engineConfig;
                if (engineConfig) {
                    const { activeProvider: activeProvider, clientVersion: clientVersion } = engineConfig;
                    if (activeProvider) clientData['db.system'] = activeProvider;
                    if (clientVersion) clientData['db.prisma.version'] = clientVersion;
                }
            } catch (e) {
            // ignore
            }
            options.client.$use((params, next)=>{
                // eslint-disable-next-line deprecation/deprecation
                if ((0, $e4d0735f97e9263d$export$34db76d03eb96b7e)((0, $gUaXH.getCurrentHub))) return next(params);
                const action = params.action;
                const model = params.model;
                return (0, $4DAh4.startSpan)({
                    name: model ? `${model} ${action}` : action,
                    onlyIfParent: true,
                    op: 'db.prisma',
                    attributes: {
                        [(0, $2Y7aX.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.db.prisma'
                    },
                    data: {
                        ...clientData,
                        'db.operation': action
                    }
                }, ()=>next(params));
            });
        } else (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $7htw4.logger).warn('Unsupported Prisma client provided to PrismaIntegration. Provided client:', options.client);
    }
    /**
   * @inheritDoc
   */ setupOnce() {
    // Noop - here for backwards compatibility
    }
}
$2e88fe1d8fd8d85d$export$e300e6f4779d55c2.__initStatic();


// BrowserTracing is already exported as part of `Integrations` below (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
 *
 * import { BrowserTracing } from '@sentry/browser';
 * new BrowserTracing()
 */ // eslint-disable-next-line deprecation/deprecation
const $233db8b147e121d8$export$46d3bbd0375f5fa4 = (0, $bec676217ef4cd96$export$46d3bbd0375f5fa4);
// BrowserTracing is already exported as part of `Integrations` below (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
 *
 * import { BrowserTracing } from '@sentry/browser';
 * new BrowserTracing()
 */ // eslint-disable-next-line deprecation/deprecation
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $233db8b147e121d8$export$5a20b45239a3c0a6 = (0, $PHezF.addExtensionMethods);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `getActiveTransaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ // eslint-disable-next-line deprecation/deprecation
const $233db8b147e121d8$export$a7feb32fdd923295 = (0, $ki8Su.getActiveTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `extractTraceparentData` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ // eslint-disable-next-line deprecation/deprecation
const $233db8b147e121d8$export$8e9a29865c0a1226 = (0, $ki8Su.extractTraceparentData);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `spanStatusfromHttpCode` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ // eslint-disable-next-line deprecation/deprecation
const $233db8b147e121d8$export$ac65c70d78fcdb55 = (0, $9JbAT.spanStatusfromHttpCode);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `SpanStatusType` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Transaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $233db8b147e121d8$export$febc5573c75cefb0 = (0, $htdtT.Transaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Transaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Span` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $233db8b147e121d8$export$5f1714a13ed34c01 = (0, $chdgs.Span);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Span` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $233db8b147e121d8$export$bbd2089f30bd3708 = (0, $bec676217ef4cd96$export$bbd2089f30bd3708);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `defaultRequestInstrumentationOptions` can be imported from `@sentry/browser`, or your framework SDK
 */ const $233db8b147e121d8$export$cc17fb3c0bc95cd7 = (0, $f8f18e67dc9a164f$export$cc17fb3c0bc95cd7);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `hasTracingEnabled` can be imported from `@sentry/utils`
 */ const $233db8b147e121d8$export$5008da00b1b6dee6 = (0, $3qQZ3.hasTracingEnabled);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `stripUrlQueryAndFragment` can be imported from `@sentry/utils`
 */ const $233db8b147e121d8$export$ce084c78234bd35 = (0, $7da207ca9fea49e7$export$ce084c78234bd35);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `TRACEPARENT_REGEXP` can be imported from `@sentry/utils`
 */ const $233db8b147e121d8$export$394a210812ba3012 = (0, $lS7eK.TRACEPARENT_REGEXP);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $233db8b147e121d8$export$b279e6bd7040371f = (0, $jVs0C.IdleTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $233db8b147e121d8$export$864489cb3478db3e = (0, $f8f18e67dc9a164f$export$864489cb3478db3e);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $233db8b147e121d8$export$479dbd817e392a4f = (0, $dtmCD.startIdleTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ // eslint-disable-next-line deprecation/deprecation
const $233db8b147e121d8$export$beb8e6a823e89c5d = (0, $9JbAT.SpanStatus);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ // eslint-disable-next-line deprecation/deprecation
const $233db8b147e121d8$export$99d02219d259eb94 = {
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
   *
   * import { BrowserTracing } from '@sentry/browser';
   * new BrowserTracing()
   */ // eslint-disable-next-line deprecation/deprecation
    BrowserTracing: $233db8b147e121d8$export$46d3bbd0375f5fa4,
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Apollo` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Apollo({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Apollo: (0, $c110a4f216c23ca3$export$3db3e396472fda8d),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Express` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Express({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Express: (0, $21f5079ecaa54eb0$export$6dafdd8fec05099d),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `GraphQL` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.GraphQL({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    GraphQL: (0, $878796551b21cf4f$export$b735d011553f1049),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Mongo` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Mongo({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Mongo: (0, $8a5bd31083ad79fe$export$968aa4360b02a334),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Mysql` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Mysql({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Mysql: (0, $89e31c484273d689$export$a2cc26ff91a3f8ad),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Postgres` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Postgres({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Postgres: (0, $8e82cbe7f73987c6$export$806ddb599177abc4),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Prisma` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Prisma({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Prisma: (0, $2e88fe1d8fd8d85d$export$e300e6f4779d55c2)
};
// Treeshakable guard to remove all code related to tracing
// Guard for tree
if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) // We are patching the global object with our hub extension methods
(0, $PHezF.addExtensionMethods)();


const $d168884506ac480e$export$29cd7b75162a9425 = {
    environment: 'production',
    sentry: {
        dsn: 'https://ebd4e227e4f544749dfc99701332ae09@trace.windware.net/4',
        sample_rate: 0.1
    }
};


$3892e5b7960d5b8e$export$2cd8252107eb640b({
    dsn: (0, $d168884506ac480e$export$29cd7b75162a9425).sentry.dsn,
    environment: (0, $d168884506ac480e$export$29cd7b75162a9425).environment,
    tracesSampleRate: (0, $d168884506ac480e$export$29cd7b75162a9425).sentry.sample_rate,
    integrations: [
        new (0, $233db8b147e121d8$export$46d3bbd0375f5fa4)(),
        new (0, $9d2a72deec55a3e4$export$2e2bcd8739ae039)()
    ]
});


window.$ = window.jQuery = (parcelRequire("iUSsr"));


var $5191b54d61fdc732$exports = {};
/*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */ !function(t, e) {
    $5191b54d61fdc732$exports = e();
}($5191b54d61fdc732$exports, function() {
    "use strict";
    function t() {}
    const e = function() {
        let t = 0;
        return function() {
            return t++;
        };
    }();
    function i(t) {
        return null == t;
    }
    function s(t) {
        if (Array.isArray && Array.isArray(t)) return !0;
        const e = Object.prototype.toString.call(t);
        return "[object" === e.slice(0, 7) && "Array]" === e.slice(-6);
    }
    function n(t) {
        return null !== t && "[object Object]" === Object.prototype.toString.call(t);
    }
    const o = (t)=>("number" == typeof t || t instanceof Number) && isFinite(+t);
    function a(t, e) {
        return o(t) ? t : e;
    }
    function r(t, e) {
        return void 0 === t ? e : t;
    }
    const l = (t, e)=>"string" == typeof t && t.endsWith("%") ? parseFloat(t) / 100 : t / e, h = (t, e)=>"string" == typeof t && t.endsWith("%") ? parseFloat(t) / 100 * e : +t;
    function c(t, e, i) {
        if (t && "function" == typeof t.call) return t.apply(i, e);
    }
    function d(t, e, i, o) {
        let a, r, l;
        if (s(t)) {
            if (r = t.length, o) for(a = r - 1; a >= 0; a--)e.call(i, t[a], a);
            else for(a = 0; a < r; a++)e.call(i, t[a], a);
        } else if (n(t)) for(l = Object.keys(t), r = l.length, a = 0; a < r; a++)e.call(i, t[l[a]], l[a]);
    }
    function u(t, e) {
        let i, s, n, o;
        if (!t || !e || t.length !== e.length) return !1;
        for(i = 0, s = t.length; i < s; ++i)if (n = t[i], o = e[i], n.datasetIndex !== o.datasetIndex || n.index !== o.index) return !1;
        return !0;
    }
    function f(t) {
        if (s(t)) return t.map(f);
        if (n(t)) {
            const e = Object.create(null), i = Object.keys(t), s = i.length;
            let n = 0;
            for(; n < s; ++n)e[i[n]] = f(t[i[n]]);
            return e;
        }
        return t;
    }
    function g(t) {
        return -1 === [
            "__proto__",
            "prototype",
            "constructor"
        ].indexOf(t);
    }
    function p(t, e, i, s) {
        if (!g(t)) return;
        const o = e[t], a = i[t];
        n(o) && n(a) ? m(o, a, s) : e[t] = f(a);
    }
    function m(t, e, i) {
        const o = s(e) ? e : [
            e
        ], a = o.length;
        if (!n(t)) return t;
        const r = (i = i || {}).merger || p;
        for(let s = 0; s < a; ++s){
            if (!n(e = o[s])) continue;
            const a = Object.keys(e);
            for(let s = 0, n = a.length; s < n; ++s)r(a[s], t, e, i);
        }
        return t;
    }
    function b(t, e) {
        return m(t, e, {
            merger: x
        });
    }
    function x(t, e, i) {
        if (!g(t)) return;
        const s = e[t], o = i[t];
        n(s) && n(o) ? b(s, o) : Object.prototype.hasOwnProperty.call(e, t) || (e[t] = f(o));
    }
    const _ = {
        "": (t)=>t,
        x: (t)=>t.x,
        y: (t)=>t.y
    };
    function y(t, e) {
        const i = _[e] || (_[e] = function(t) {
            const e = v(t);
            return (t)=>{
                for (const i of e){
                    if ("" === i) break;
                    t = t && t[i];
                }
                return t;
            };
        }(e));
        return i(t);
    }
    function v(t) {
        const e = t.split("."), i = [];
        let s = "";
        for (const t of e)s += t, s.endsWith("\\") ? s = s.slice(0, -1) + "." : (i.push(s), s = "");
        return i;
    }
    function w(t) {
        return t.charAt(0).toUpperCase() + t.slice(1);
    }
    const M = (t)=>void 0 !== t, k = (t)=>"function" == typeof t, S = (t, e)=>{
        if (t.size !== e.size) return !1;
        for (const i of t)if (!e.has(i)) return !1;
        return !0;
    };
    function P(t) {
        return "mouseup" === t.type || "click" === t.type || "contextmenu" === t.type;
    }
    const D = Math.PI, O = 2 * D, C = O + D, A = Number.POSITIVE_INFINITY, T = D / 180, L = D / 2, E = D / 4, R = 2 * D / 3, I = Math.log10, z = Math.sign;
    function F(t) {
        const e = Math.round(t);
        t = N(t, e, t / 1e3) ? e : t;
        const i = Math.pow(10, Math.floor(I(t))), s = t / i;
        return (s <= 1 ? 1 : s <= 2 ? 2 : s <= 5 ? 5 : 10) * i;
    }
    function V(t) {
        const e = [], i = Math.sqrt(t);
        let s;
        for(s = 1; s < i; s++)t % s == 0 && (e.push(s), e.push(t / s));
        return i === (0 | i) && e.push(i), e.sort((t, e)=>t - e).pop(), e;
    }
    function B(t) {
        return !isNaN(parseFloat(t)) && isFinite(t);
    }
    function N(t, e, i) {
        return Math.abs(t - e) < i;
    }
    function W(t, e) {
        const i = Math.round(t);
        return i - e <= t && i + e >= t;
    }
    function j(t, e, i) {
        let s, n, o;
        for(s = 0, n = t.length; s < n; s++)o = t[s][i], isNaN(o) || (e.min = Math.min(e.min, o), e.max = Math.max(e.max, o));
    }
    function H(t) {
        return t * (D / 180);
    }
    function $(t) {
        return t * (180 / D);
    }
    function Y(t) {
        if (!o(t)) return;
        let e = 1, i = 0;
        for(; Math.round(t * e) / e !== t;)e *= 10, i++;
        return i;
    }
    function U(t, e) {
        const i = e.x - t.x, s = e.y - t.y, n = Math.sqrt(i * i + s * s);
        let o = Math.atan2(s, i);
        return o < -0.5 * D && (o += O), {
            angle: o,
            distance: n
        };
    }
    function X(t, e) {
        return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
    }
    function q(t, e) {
        return (t - e + C) % O - D;
    }
    function K(t) {
        return (t % O + O) % O;
    }
    function G(t, e, i, s) {
        const n = K(t), o = K(e), a = K(i), r = K(o - n), l = K(a - n), h = K(n - o), c = K(n - a);
        return n === o || n === a || s && o === a || r > l && h < c;
    }
    function Z(t, e, i) {
        return Math.max(e, Math.min(i, t));
    }
    function J(t) {
        return Z(t, -32768, 32767);
    }
    function Q(t, e, i, s = 1e-6) {
        return t >= Math.min(e, i) - s && t <= Math.max(e, i) + s;
    }
    function tt(t, e, i) {
        i = i || ((i)=>t[i] < e);
        let s, n = t.length - 1, o = 0;
        for(; n - o > 1;)s = o + n >> 1, i(s) ? o = s : n = s;
        return {
            lo: o,
            hi: n
        };
    }
    const et = (t, e, i, s)=>tt(t, i, s ? (s)=>t[s][e] <= i : (s)=>t[s][e] < i), it = (t, e, i)=>tt(t, i, (s)=>t[s][e] >= i);
    function st(t, e, i) {
        let s = 0, n = t.length;
        for(; s < n && t[s] < e;)s++;
        for(; n > s && t[n - 1] > i;)n--;
        return s > 0 || n < t.length ? t.slice(s, n) : t;
    }
    const nt = [
        "push",
        "pop",
        "shift",
        "splice",
        "unshift"
    ];
    function ot(t, e) {
        t._chartjs ? t._chartjs.listeners.push(e) : (Object.defineProperty(t, "_chartjs", {
            configurable: !0,
            enumerable: !1,
            value: {
                listeners: [
                    e
                ]
            }
        }), nt.forEach((e)=>{
            const i = "_onData" + w(e), s = t[e];
            Object.defineProperty(t, e, {
                configurable: !0,
                enumerable: !1,
                value (...e) {
                    const n = s.apply(this, e);
                    return t._chartjs.listeners.forEach((t)=>{
                        "function" == typeof t[i] && t[i](...e);
                    }), n;
                }
            });
        }));
    }
    function at(t, e) {
        const i = t._chartjs;
        if (!i) return;
        const s = i.listeners, n = s.indexOf(e);
        -1 !== n && s.splice(n, 1), s.length > 0 || (nt.forEach((e)=>{
            delete t[e];
        }), delete t._chartjs);
    }
    function rt(t) {
        const e = new Set;
        let i, s;
        for(i = 0, s = t.length; i < s; ++i)e.add(t[i]);
        return e.size === s ? t : Array.from(e);
    }
    const lt = "undefined" == typeof window ? function(t) {
        return t();
    } : window.requestAnimationFrame;
    function ht(t, e, i) {
        const s = i || ((t)=>Array.prototype.slice.call(t));
        let n = !1, o = [];
        return function(...i) {
            o = s(i), n || (n = !0, lt.call(window, ()=>{
                n = !1, t.apply(e, o);
            }));
        };
    }
    function ct(t, e) {
        let i;
        return function(...s) {
            return e ? (clearTimeout(i), i = setTimeout(t, e, s)) : t.apply(this, s), e;
        };
    }
    const dt = (t)=>"start" === t ? "left" : "end" === t ? "right" : "center", ut = (t, e, i)=>"start" === t ? e : "end" === t ? i : (e + i) / 2, ft = (t, e, i, s)=>t === (s ? "left" : "right") ? i : "center" === t ? (e + i) / 2 : e;
    function gt(t, e, i) {
        const s = e.length;
        let n = 0, o = s;
        if (t._sorted) {
            const { iScale: a, _parsed: r } = t, l = a.axis, { min: h, max: c, minDefined: d, maxDefined: u } = a.getUserBounds();
            d && (n = Z(Math.min(et(r, a.axis, h).lo, i ? s : et(e, l, a.getPixelForValue(h)).lo), 0, s - 1)), o = u ? Z(Math.max(et(r, a.axis, c, !0).hi + 1, i ? 0 : et(e, l, a.getPixelForValue(c), !0).hi + 1), n, s) - n : s - n;
        }
        return {
            start: n,
            count: o
        };
    }
    function pt(t) {
        const { xScale: e, yScale: i, _scaleRanges: s } = t, n = {
            xmin: e.min,
            xmax: e.max,
            ymin: i.min,
            ymax: i.max
        };
        if (!s) return t._scaleRanges = n, !0;
        const o = s.xmin !== e.min || s.xmax !== e.max || s.ymin !== i.min || s.ymax !== i.max;
        return Object.assign(s, n), o;
    }
    var mt = new class {
        constructor(){
            this._request = null, this._charts = new Map, this._running = !1, this._lastDate = void 0;
        }
        _notify(t, e, i, s) {
            const n = e.listeners[s], o = e.duration;
            n.forEach((s)=>s({
                    chart: t,
                    initial: e.initial,
                    numSteps: o,
                    currentStep: Math.min(i - e.start, o)
                }));
        }
        _refresh() {
            this._request || (this._running = !0, this._request = lt.call(window, ()=>{
                this._update(), this._request = null, this._running && this._refresh();
            }));
        }
        _update(t = Date.now()) {
            let e = 0;
            this._charts.forEach((i, s)=>{
                if (!i.running || !i.items.length) return;
                const n = i.items;
                let o, a = n.length - 1, r = !1;
                for(; a >= 0; --a)o = n[a], o._active ? (o._total > i.duration && (i.duration = o._total), o.tick(t), r = !0) : (n[a] = n[n.length - 1], n.pop());
                r && (s.draw(), this._notify(s, i, t, "progress")), n.length || (i.running = !1, this._notify(s, i, t, "complete"), i.initial = !1), e += n.length;
            }), this._lastDate = t, 0 === e && (this._running = !1);
        }
        _getAnims(t) {
            const e = this._charts;
            let i = e.get(t);
            return i || (i = {
                running: !1,
                initial: !0,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            }, e.set(t, i)), i;
        }
        listen(t, e, i) {
            this._getAnims(t).listeners[e].push(i);
        }
        add(t, e) {
            e && e.length && this._getAnims(t).items.push(...e);
        }
        has(t) {
            return this._getAnims(t).items.length > 0;
        }
        start(t) {
            const e = this._charts.get(t);
            e && (e.running = !0, e.start = Date.now(), e.duration = e.items.reduce((t, e)=>Math.max(t, e._duration), 0), this._refresh());
        }
        running(t) {
            if (!this._running) return !1;
            const e = this._charts.get(t);
            return !!(e && e.running && e.items.length);
        }
        stop(t) {
            const e = this._charts.get(t);
            if (!e || !e.items.length) return;
            const i = e.items;
            let s = i.length - 1;
            for(; s >= 0; --s)i[s].cancel();
            e.items = [], this._notify(t, e, Date.now(), "complete");
        }
        remove(t) {
            return this._charts.delete(t);
        }
    };
    /*!
 * @kurkle/color v0.2.1
 * https://github.com/kurkle/color#readme
 * (c) 2022 Jukka Kurkela
 * Released under the MIT License
 */ function bt(t) {
        return t + .5 | 0;
    }
    const xt = (t, e, i)=>Math.max(Math.min(t, i), e);
    function _t(t) {
        return xt(bt(2.55 * t), 0, 255);
    }
    function yt(t) {
        return xt(bt(255 * t), 0, 255);
    }
    function vt(t) {
        return xt(bt(t / 2.55) / 100, 0, 1);
    }
    function wt(t) {
        return xt(bt(100 * t), 0, 100);
    }
    const Mt = {
        0: 0,
        1: 1,
        2: 2,
        3: 3,
        4: 4,
        5: 5,
        6: 6,
        7: 7,
        8: 8,
        9: 9,
        A: 10,
        B: 11,
        C: 12,
        D: 13,
        E: 14,
        F: 15,
        a: 10,
        b: 11,
        c: 12,
        d: 13,
        e: 14,
        f: 15
    }, kt = [
        ..."0123456789ABCDEF"
    ], St = (t)=>kt[15 & t], Pt = (t)=>kt[(240 & t) >> 4] + kt[15 & t], Dt = (t)=>(240 & t) >> 4 == (15 & t);
    function Ot(t) {
        var e = ((t)=>Dt(t.r) && Dt(t.g) && Dt(t.b) && Dt(t.a))(t) ? St : Pt;
        return t ? "#" + e(t.r) + e(t.g) + e(t.b) + ((t, e)=>t < 255 ? e(t) : "")(t.a, e) : void 0;
    }
    const Ct = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
    function At(t, e, i) {
        const s = e * Math.min(i, 1 - i), n = (e, n = (e + t / 30) % 12)=>i - s * Math.max(Math.min(n - 3, 9 - n, 1), -1);
        return [
            n(0),
            n(8),
            n(4)
        ];
    }
    function Tt(t, e, i) {
        const s = (s, n = (s + t / 60) % 6)=>i - i * e * Math.max(Math.min(n, 4 - n, 1), 0);
        return [
            s(5),
            s(3),
            s(1)
        ];
    }
    function Lt(t, e, i) {
        const s = At(t, 1, .5);
        let n;
        for(e + i > 1 && (n = 1 / (e + i), e *= n, i *= n), n = 0; n < 3; n++)s[n] *= 1 - e - i, s[n] += e;
        return s;
    }
    function Et(t) {
        const e = t.r / 255, i = t.g / 255, s = t.b / 255, n = Math.max(e, i, s), o = Math.min(e, i, s), a = (n + o) / 2;
        let r, l, h;
        return n !== o && (h = n - o, l = a > .5 ? h / (2 - n - o) : h / (n + o), r = function(t, e, i, s, n) {
            return t === n ? (e - i) / s + (e < i ? 6 : 0) : e === n ? (i - t) / s + 2 : (t - e) / s + 4;
        }(e, i, s, h, n), r = 60 * r + .5), [
            0 | r,
            l || 0,
            a
        ];
    }
    function Rt(t, e, i, s) {
        return (Array.isArray(e) ? t(e[0], e[1], e[2]) : t(e, i, s)).map(yt);
    }
    function It(t, e, i) {
        return Rt(At, t, e, i);
    }
    function zt(t) {
        return (t % 360 + 360) % 360;
    }
    function Ft(t) {
        const e = Ct.exec(t);
        let i, s = 255;
        if (!e) return;
        e[5] !== i && (s = e[6] ? _t(+e[5]) : yt(+e[5]));
        const n = zt(+e[2]), o = +e[3] / 100, a = +e[4] / 100;
        return i = "hwb" === e[1] ? function(t, e, i) {
            return Rt(Lt, t, e, i);
        }(n, o, a) : "hsv" === e[1] ? function(t, e, i) {
            return Rt(Tt, t, e, i);
        }(n, o, a) : It(n, o, a), {
            r: i[0],
            g: i[1],
            b: i[2],
            a: s
        };
    }
    const Vt = {
        x: "dark",
        Z: "light",
        Y: "re",
        X: "blu",
        W: "gr",
        V: "medium",
        U: "slate",
        A: "ee",
        T: "ol",
        S: "or",
        B: "ra",
        C: "lateg",
        D: "ights",
        R: "in",
        Q: "turquois",
        E: "hi",
        P: "ro",
        O: "al",
        N: "le",
        M: "de",
        L: "yello",
        F: "en",
        K: "ch",
        G: "arks",
        H: "ea",
        I: "ightg",
        J: "wh"
    }, Bt = {
        OiceXe: "f0f8ff",
        antiquewEte: "faebd7",
        aqua: "ffff",
        aquamarRe: "7fffd4",
        azuY: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "0",
        blanKedOmond: "ffebcd",
        Xe: "ff",
        XeviTet: "8a2be2",
        bPwn: "a52a2a",
        burlywood: "deb887",
        caMtXe: "5f9ea0",
        KartYuse: "7fff00",
        KocTate: "d2691e",
        cSO: "ff7f50",
        cSnflowerXe: "6495ed",
        cSnsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "ffff",
        xXe: "8b",
        xcyan: "8b8b",
        xgTMnPd: "b8860b",
        xWay: "a9a9a9",
        xgYF: "6400",
        xgYy: "a9a9a9",
        xkhaki: "bdb76b",
        xmagFta: "8b008b",
        xTivegYF: "556b2f",
        xSange: "ff8c00",
        xScEd: "9932cc",
        xYd: "8b0000",
        xsOmon: "e9967a",
        xsHgYF: "8fbc8f",
        xUXe: "483d8b",
        xUWay: "2f4f4f",
        xUgYy: "2f4f4f",
        xQe: "ced1",
        xviTet: "9400d3",
        dAppRk: "ff1493",
        dApskyXe: "bfff",
        dimWay: "696969",
        dimgYy: "696969",
        dodgerXe: "1e90ff",
        fiYbrick: "b22222",
        flSOwEte: "fffaf0",
        foYstWAn: "228b22",
        fuKsia: "ff00ff",
        gaRsbSo: "dcdcdc",
        ghostwEte: "f8f8ff",
        gTd: "ffd700",
        gTMnPd: "daa520",
        Way: "808080",
        gYF: "8000",
        gYFLw: "adff2f",
        gYy: "808080",
        honeyMw: "f0fff0",
        hotpRk: "ff69b4",
        RdianYd: "cd5c5c",
        Rdigo: "4b0082",
        ivSy: "fffff0",
        khaki: "f0e68c",
        lavFMr: "e6e6fa",
        lavFMrXsh: "fff0f5",
        lawngYF: "7cfc00",
        NmoncEffon: "fffacd",
        ZXe: "add8e6",
        ZcSO: "f08080",
        Zcyan: "e0ffff",
        ZgTMnPdLw: "fafad2",
        ZWay: "d3d3d3",
        ZgYF: "90ee90",
        ZgYy: "d3d3d3",
        ZpRk: "ffb6c1",
        ZsOmon: "ffa07a",
        ZsHgYF: "20b2aa",
        ZskyXe: "87cefa",
        ZUWay: "778899",
        ZUgYy: "778899",
        ZstAlXe: "b0c4de",
        ZLw: "ffffe0",
        lime: "ff00",
        limegYF: "32cd32",
        lRF: "faf0e6",
        magFta: "ff00ff",
        maPon: "800000",
        VaquamarRe: "66cdaa",
        VXe: "cd",
        VScEd: "ba55d3",
        VpurpN: "9370db",
        VsHgYF: "3cb371",
        VUXe: "7b68ee",
        VsprRggYF: "fa9a",
        VQe: "48d1cc",
        VviTetYd: "c71585",
        midnightXe: "191970",
        mRtcYam: "f5fffa",
        mistyPse: "ffe4e1",
        moccasR: "ffe4b5",
        navajowEte: "ffdead",
        navy: "80",
        Tdlace: "fdf5e6",
        Tive: "808000",
        TivedBb: "6b8e23",
        Sange: "ffa500",
        SangeYd: "ff4500",
        ScEd: "da70d6",
        pOegTMnPd: "eee8aa",
        pOegYF: "98fb98",
        pOeQe: "afeeee",
        pOeviTetYd: "db7093",
        papayawEp: "ffefd5",
        pHKpuff: "ffdab9",
        peru: "cd853f",
        pRk: "ffc0cb",
        plum: "dda0dd",
        powMrXe: "b0e0e6",
        purpN: "800080",
        YbeccapurpN: "663399",
        Yd: "ff0000",
        Psybrown: "bc8f8f",
        PyOXe: "4169e1",
        saddNbPwn: "8b4513",
        sOmon: "fa8072",
        sandybPwn: "f4a460",
        sHgYF: "2e8b57",
        sHshell: "fff5ee",
        siFna: "a0522d",
        silver: "c0c0c0",
        skyXe: "87ceeb",
        UXe: "6a5acd",
        UWay: "708090",
        UgYy: "708090",
        snow: "fffafa",
        sprRggYF: "ff7f",
        stAlXe: "4682b4",
        tan: "d2b48c",
        teO: "8080",
        tEstN: "d8bfd8",
        tomato: "ff6347",
        Qe: "40e0d0",
        viTet: "ee82ee",
        JHt: "f5deb3",
        wEte: "ffffff",
        wEtesmoke: "f5f5f5",
        Lw: "ffff00",
        LwgYF: "9acd32"
    };
    let Nt;
    function Wt(t) {
        Nt || (Nt = function() {
            const t = {}, e = Object.keys(Bt), i = Object.keys(Vt);
            let s, n, o, a, r;
            for(s = 0; s < e.length; s++){
                for(a = r = e[s], n = 0; n < i.length; n++)o = i[n], r = r.replace(o, Vt[o]);
                o = parseInt(Bt[a], 16), t[r] = [
                    o >> 16 & 255,
                    o >> 8 & 255,
                    255 & o
                ];
            }
            return t;
        }(), Nt.transparent = [
            0,
            0,
            0,
            0
        ]);
        const e = Nt[t.toLowerCase()];
        return e && {
            r: e[0],
            g: e[1],
            b: e[2],
            a: 4 === e.length ? e[3] : 255
        };
    }
    const jt = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
    const Ht = (t)=>t <= .0031308 ? 12.92 * t : 1.055 * Math.pow(t, 1 / 2.4) - .055, $t = (t)=>t <= .04045 ? t / 12.92 : Math.pow((t + .055) / 1.055, 2.4);
    function Yt(t, e, i) {
        if (t) {
            let s = Et(t);
            s[e] = Math.max(0, Math.min(s[e] + s[e] * i, 0 === e ? 360 : 1)), s = It(s), t.r = s[0], t.g = s[1], t.b = s[2];
        }
    }
    function Ut(t, e) {
        return t ? Object.assign(e || {}, t) : t;
    }
    function Xt(t) {
        var e = {
            r: 0,
            g: 0,
            b: 0,
            a: 255
        };
        return Array.isArray(t) ? t.length >= 3 && (e = {
            r: t[0],
            g: t[1],
            b: t[2],
            a: 255
        }, t.length > 3 && (e.a = yt(t[3]))) : (e = Ut(t, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        })).a = yt(e.a), e;
    }
    function qt(t) {
        return "r" === t.charAt(0) ? function(t) {
            const e = jt.exec(t);
            let i, s, n, o = 255;
            if (e) {
                if (e[7] !== i) {
                    const t = +e[7];
                    o = e[8] ? _t(t) : xt(255 * t, 0, 255);
                }
                return i = +e[1], s = +e[3], n = +e[5], i = 255 & (e[2] ? _t(i) : xt(i, 0, 255)), s = 255 & (e[4] ? _t(s) : xt(s, 0, 255)), n = 255 & (e[6] ? _t(n) : xt(n, 0, 255)), {
                    r: i,
                    g: s,
                    b: n,
                    a: o
                };
            }
        }(t) : Ft(t);
    }
    class Kt {
        constructor(t){
            if (t instanceof Kt) return t;
            const e = typeof t;
            let i;
            var s, n, o;
            "object" === e ? i = Xt(t) : "string" === e && (o = (s = t).length, "#" === s[0] && (4 === o || 5 === o ? n = {
                r: 255 & 17 * Mt[s[1]],
                g: 255 & 17 * Mt[s[2]],
                b: 255 & 17 * Mt[s[3]],
                a: 5 === o ? 17 * Mt[s[4]] : 255
            } : 7 !== o && 9 !== o || (n = {
                r: Mt[s[1]] << 4 | Mt[s[2]],
                g: Mt[s[3]] << 4 | Mt[s[4]],
                b: Mt[s[5]] << 4 | Mt[s[6]],
                a: 9 === o ? Mt[s[7]] << 4 | Mt[s[8]] : 255
            })), i = n || Wt(t) || qt(t)), this._rgb = i, this._valid = !!i;
        }
        get valid() {
            return this._valid;
        }
        get rgb() {
            var t = Ut(this._rgb);
            return t && (t.a = vt(t.a)), t;
        }
        set rgb(t) {
            this._rgb = Xt(t);
        }
        rgbString() {
            var t;
            return this._valid ? (t = this._rgb) && (t.a < 255 ? `rgba(${t.r}, ${t.g}, ${t.b}, ${vt(t.a)})` : `rgb(${t.r}, ${t.g}, ${t.b})`) : void 0;
        }
        hexString() {
            return this._valid ? Ot(this._rgb) : void 0;
        }
        hslString() {
            return this._valid ? function(t) {
                if (!t) return;
                const e = Et(t), i = e[0], s = wt(e[1]), n = wt(e[2]);
                return t.a < 255 ? `hsla(${i}, ${s}%, ${n}%, ${vt(t.a)})` : `hsl(${i}, ${s}%, ${n}%)`;
            }(this._rgb) : void 0;
        }
        mix(t, e) {
            if (t) {
                const i = this.rgb, s = t.rgb;
                let n;
                const o = e === n ? .5 : e, a = 2 * o - 1, r = i.a - s.a, l = ((a * r == -1 ? a : (a + r) / (1 + a * r)) + 1) / 2;
                n = 1 - l, i.r = 255 & l * i.r + n * s.r + .5, i.g = 255 & l * i.g + n * s.g + .5, i.b = 255 & l * i.b + n * s.b + .5, i.a = o * i.a + (1 - o) * s.a, this.rgb = i;
            }
            return this;
        }
        interpolate(t, e) {
            return t && (this._rgb = function(t, e, i) {
                const s = $t(vt(t.r)), n = $t(vt(t.g)), o = $t(vt(t.b));
                return {
                    r: yt(Ht(s + i * ($t(vt(e.r)) - s))),
                    g: yt(Ht(n + i * ($t(vt(e.g)) - n))),
                    b: yt(Ht(o + i * ($t(vt(e.b)) - o))),
                    a: t.a + i * (e.a - t.a)
                };
            }(this._rgb, t._rgb, e)), this;
        }
        clone() {
            return new Kt(this.rgb);
        }
        alpha(t) {
            return this._rgb.a = yt(t), this;
        }
        clearer(t) {
            return this._rgb.a *= 1 - t, this;
        }
        greyscale() {
            const t = this._rgb, e = bt(.3 * t.r + .59 * t.g + .11 * t.b);
            return t.r = t.g = t.b = e, this;
        }
        opaquer(t) {
            return this._rgb.a *= 1 + t, this;
        }
        negate() {
            const t = this._rgb;
            return t.r = 255 - t.r, t.g = 255 - t.g, t.b = 255 - t.b, this;
        }
        lighten(t) {
            return Yt(this._rgb, 2, t), this;
        }
        darken(t) {
            return Yt(this._rgb, 2, -t), this;
        }
        saturate(t) {
            return Yt(this._rgb, 1, t), this;
        }
        desaturate(t) {
            return Yt(this._rgb, 1, -t), this;
        }
        rotate(t) {
            return function(t, e) {
                var i = Et(t);
                i[0] = zt(i[0] + e), i = It(i), t.r = i[0], t.g = i[1], t.b = i[2];
            }(this._rgb, t), this;
        }
    }
    function Gt(t) {
        return new Kt(t);
    }
    function Zt(t) {
        if (t && "object" == typeof t) {
            const e = t.toString();
            return "[object CanvasPattern]" === e || "[object CanvasGradient]" === e;
        }
        return !1;
    }
    function Jt(t) {
        return Zt(t) ? t : Gt(t);
    }
    function Qt(t) {
        return Zt(t) ? t : Gt(t).saturate(.5).darken(.1).hexString();
    }
    const te = Object.create(null), ee = Object.create(null);
    function ie(t, e) {
        if (!e) return t;
        const i = e.split(".");
        for(let e = 0, s = i.length; e < s; ++e){
            const s = i[e];
            t = t[s] || (t[s] = Object.create(null));
        }
        return t;
    }
    function se(t, e, i) {
        return "string" == typeof e ? m(ie(t, e), i) : m(ie(t, ""), e);
    }
    var ne = new class {
        constructor(t){
            this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (t)=>t.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
                "mousemove",
                "mouseout",
                "click",
                "touchstart",
                "touchmove"
            ], this.font = {
                family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                size: 12,
                style: "normal",
                lineHeight: 1.2,
                weight: null
            }, this.hover = {}, this.hoverBackgroundColor = (t, e)=>Qt(e.backgroundColor), this.hoverBorderColor = (t, e)=>Qt(e.borderColor), this.hoverColor = (t, e)=>Qt(e.color), this.indexAxis = "x", this.interaction = {
                mode: "nearest",
                intersect: !0,
                includeInvisible: !1
            }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(t);
        }
        set(t, e) {
            return se(this, t, e);
        }
        get(t) {
            return ie(this, t);
        }
        describe(t, e) {
            return se(ee, t, e);
        }
        override(t, e) {
            return se(te, t, e);
        }
        route(t, e, i, s) {
            const o = ie(this, t), a = ie(this, i), l = "_" + e;
            Object.defineProperties(o, {
                [l]: {
                    value: o[e],
                    writable: !0
                },
                [e]: {
                    enumerable: !0,
                    get () {
                        const t = this[l], e = a[s];
                        return n(t) ? Object.assign({}, e, t) : r(t, e);
                    },
                    set (t) {
                        this[l] = t;
                    }
                }
            });
        }
    }({
        _scriptable: (t)=>!t.startsWith("on"),
        _indexable: (t)=>"events" !== t,
        hover: {
            _fallback: "interaction"
        },
        interaction: {
            _scriptable: !1,
            _indexable: !1
        }
    });
    function oe() {
        return "undefined" != typeof window && "undefined" != typeof document;
    }
    function ae(t) {
        let e = t.parentNode;
        return e && "[object ShadowRoot]" === e.toString() && (e = e.host), e;
    }
    function re(t, e, i) {
        let s;
        return "string" == typeof t ? (s = parseInt(t, 10), -1 !== t.indexOf("%") && (s = s / 100 * e.parentNode[i])) : s = t, s;
    }
    const le = (t)=>window.getComputedStyle(t, null);
    function he(t, e) {
        return le(t).getPropertyValue(e);
    }
    const ce = [
        "top",
        "right",
        "bottom",
        "left"
    ];
    function de(t, e, i) {
        const s = {};
        i = i ? "-" + i : "";
        for(let n = 0; n < 4; n++){
            const o = ce[n];
            s[o] = parseFloat(t[e + "-" + o + i]) || 0;
        }
        return s.width = s.left + s.right, s.height = s.top + s.bottom, s;
    }
    function ue(t, e) {
        if ("native" in t) return t;
        const { canvas: i, currentDevicePixelRatio: s } = e, n = le(i), o = "border-box" === n.boxSizing, a = de(n, "padding"), r = de(n, "border", "width"), { x: l, y: h, box: c } = function(t, e) {
            const i = t.touches, s = i && i.length ? i[0] : t, { offsetX: n, offsetY: o } = s;
            let a, r, l = !1;
            if (((t, e, i)=>(t > 0 || e > 0) && (!i || !i.shadowRoot))(n, o, t.target)) a = n, r = o;
            else {
                const t = e.getBoundingClientRect();
                a = s.clientX - t.left, r = s.clientY - t.top, l = !0;
            }
            return {
                x: a,
                y: r,
                box: l
            };
        }(t, i), d = a.left + (c && r.left), u = a.top + (c && r.top);
        let { width: f, height: g } = e;
        return o && (f -= a.width + r.width, g -= a.height + r.height), {
            x: Math.round((l - d) / f * i.width / s),
            y: Math.round((h - u) / g * i.height / s)
        };
    }
    const fe = (t)=>Math.round(10 * t) / 10;
    function ge(t, e, i, s) {
        const n = le(t), o = de(n, "margin"), a = re(n.maxWidth, t, "clientWidth") || A, r = re(n.maxHeight, t, "clientHeight") || A, l = function(t, e, i) {
            let s, n;
            if (void 0 === e || void 0 === i) {
                const o = ae(t);
                if (o) {
                    const t = o.getBoundingClientRect(), a = le(o), r = de(a, "border", "width"), l = de(a, "padding");
                    e = t.width - l.width - r.width, i = t.height - l.height - r.height, s = re(a.maxWidth, o, "clientWidth"), n = re(a.maxHeight, o, "clientHeight");
                } else e = t.clientWidth, i = t.clientHeight;
            }
            return {
                width: e,
                height: i,
                maxWidth: s || A,
                maxHeight: n || A
            };
        }(t, e, i);
        let { width: h, height: c } = l;
        if ("content-box" === n.boxSizing) {
            const t = de(n, "border", "width"), e = de(n, "padding");
            h -= e.width + t.width, c -= e.height + t.height;
        }
        return h = Math.max(0, h - o.width), c = Math.max(0, s ? Math.floor(h / s) : c - o.height), h = fe(Math.min(h, a, l.maxWidth)), c = fe(Math.min(c, r, l.maxHeight)), h && !c && (c = fe(h / 2)), {
            width: h,
            height: c
        };
    }
    function pe(t, e, i) {
        const s = e || 1, n = Math.floor(t.height * s), o = Math.floor(t.width * s);
        t.height = n / s, t.width = o / s;
        const a = t.canvas;
        return a.style && (i || !a.style.height && !a.style.width) && (a.style.height = `${t.height}px`, a.style.width = `${t.width}px`), (t.currentDevicePixelRatio !== s || a.height !== n || a.width !== o) && (t.currentDevicePixelRatio = s, a.height = n, a.width = o, t.ctx.setTransform(s, 0, 0, s, 0, 0), !0);
    }
    const me = function() {
        let t = !1;
        try {
            const e = {
                get passive () {
                    return t = !0, !1;
                }
            };
            window.addEventListener("test", null, e), window.removeEventListener("test", null, e);
        } catch (t) {}
        return t;
    }();
    function be(t, e) {
        const i = he(t, e), s = i && i.match(/^(\d+)(\.\d+)?px$/);
        return s ? +s[1] : void 0;
    }
    function xe(t) {
        return !t || i(t.size) || i(t.family) ? null : (t.style ? t.style + " " : "") + (t.weight ? t.weight + " " : "") + t.size + "px " + t.family;
    }
    function _e(t, e, i, s, n) {
        let o = e[n];
        return o || (o = e[n] = t.measureText(n).width, i.push(n)), o > s && (s = o), s;
    }
    function ye(t, e, i, n) {
        let o = (n = n || {}).data = n.data || {}, a = n.garbageCollect = n.garbageCollect || [];
        n.font !== e && (o = n.data = {}, a = n.garbageCollect = [], n.font = e), t.save(), t.font = e;
        let r = 0;
        const l = i.length;
        let h, c, d, u, f;
        for(h = 0; h < l; h++)if (u = i[h], null != u && !0 !== s(u)) r = _e(t, o, a, r, u);
        else if (s(u)) for(c = 0, d = u.length; c < d; c++)f = u[c], null == f || s(f) || (r = _e(t, o, a, r, f));
        t.restore();
        const g = a.length / 2;
        if (g > i.length) {
            for(h = 0; h < g; h++)delete o[a[h]];
            a.splice(0, g);
        }
        return r;
    }
    function ve(t, e, i) {
        const s = t.currentDevicePixelRatio, n = 0 !== i ? Math.max(i / 2, .5) : 0;
        return Math.round((e - n) * s) / s + n;
    }
    function we(t, e) {
        (e = e || t.getContext("2d")).save(), e.resetTransform(), e.clearRect(0, 0, t.width, t.height), e.restore();
    }
    function Me(t, e, i, s) {
        ke(t, e, i, s, null);
    }
    function ke(t, e, i, s, n) {
        let o, a, r, l, h, c;
        const d = e.pointStyle, u = e.rotation, f = e.radius;
        let g = (u || 0) * T;
        if (d && "object" == typeof d && (o = d.toString(), "[object HTMLImageElement]" === o || "[object HTMLCanvasElement]" === o)) return t.save(), t.translate(i, s), t.rotate(g), t.drawImage(d, -d.width / 2, -d.height / 2, d.width, d.height), void t.restore();
        if (!(isNaN(f) || f <= 0)) {
            switch(t.beginPath(), d){
                default:
                    n ? t.ellipse(i, s, n / 2, f, 0, 0, O) : t.arc(i, s, f, 0, O), t.closePath();
                    break;
                case "triangle":
                    t.moveTo(i + Math.sin(g) * f, s - Math.cos(g) * f), g += R, t.lineTo(i + Math.sin(g) * f, s - Math.cos(g) * f), g += R, t.lineTo(i + Math.sin(g) * f, s - Math.cos(g) * f), t.closePath();
                    break;
                case "rectRounded":
                    h = .516 * f, l = f - h, a = Math.cos(g + E) * l, r = Math.sin(g + E) * l, t.arc(i - a, s - r, h, g - D, g - L), t.arc(i + r, s - a, h, g - L, g), t.arc(i + a, s + r, h, g, g + L), t.arc(i - r, s + a, h, g + L, g + D), t.closePath();
                    break;
                case "rect":
                    if (!u) {
                        l = Math.SQRT1_2 * f, c = n ? n / 2 : l, t.rect(i - c, s - l, 2 * c, 2 * l);
                        break;
                    }
                    g += E;
                case "rectRot":
                    a = Math.cos(g) * f, r = Math.sin(g) * f, t.moveTo(i - a, s - r), t.lineTo(i + r, s - a), t.lineTo(i + a, s + r), t.lineTo(i - r, s + a), t.closePath();
                    break;
                case "crossRot":
                    g += E;
                case "cross":
                    a = Math.cos(g) * f, r = Math.sin(g) * f, t.moveTo(i - a, s - r), t.lineTo(i + a, s + r), t.moveTo(i + r, s - a), t.lineTo(i - r, s + a);
                    break;
                case "star":
                    a = Math.cos(g) * f, r = Math.sin(g) * f, t.moveTo(i - a, s - r), t.lineTo(i + a, s + r), t.moveTo(i + r, s - a), t.lineTo(i - r, s + a), g += E, a = Math.cos(g) * f, r = Math.sin(g) * f, t.moveTo(i - a, s - r), t.lineTo(i + a, s + r), t.moveTo(i + r, s - a), t.lineTo(i - r, s + a);
                    break;
                case "line":
                    a = n ? n / 2 : Math.cos(g) * f, r = Math.sin(g) * f, t.moveTo(i - a, s - r), t.lineTo(i + a, s + r);
                    break;
                case "dash":
                    t.moveTo(i, s), t.lineTo(i + Math.cos(g) * f, s + Math.sin(g) * f);
            }
            t.fill(), e.borderWidth > 0 && t.stroke();
        }
    }
    function Se(t, e, i) {
        return i = i || .5, !e || t && t.x > e.left - i && t.x < e.right + i && t.y > e.top - i && t.y < e.bottom + i;
    }
    function Pe(t, e) {
        t.save(), t.beginPath(), t.rect(e.left, e.top, e.right - e.left, e.bottom - e.top), t.clip();
    }
    function De(t) {
        t.restore();
    }
    function Oe(t, e, i, s, n) {
        if (!e) return t.lineTo(i.x, i.y);
        if ("middle" === n) {
            const s = (e.x + i.x) / 2;
            t.lineTo(s, e.y), t.lineTo(s, i.y);
        } else "after" === n != !!s ? t.lineTo(e.x, i.y) : t.lineTo(i.x, e.y);
        t.lineTo(i.x, i.y);
    }
    function Ce(t, e, i, s) {
        if (!e) return t.lineTo(i.x, i.y);
        t.bezierCurveTo(s ? e.cp1x : e.cp2x, s ? e.cp1y : e.cp2y, s ? i.cp2x : i.cp1x, s ? i.cp2y : i.cp1y, i.x, i.y);
    }
    function Ae(t, e, n, o, a, r = {}) {
        const l = s(e) ? e : [
            e
        ], h = r.strokeWidth > 0 && "" !== r.strokeColor;
        let c, d;
        for(t.save(), t.font = a.string, function(t, e) {
            e.translation && t.translate(e.translation[0], e.translation[1]);
            i(e.rotation) || t.rotate(e.rotation);
            e.color && (t.fillStyle = e.color);
            e.textAlign && (t.textAlign = e.textAlign);
            e.textBaseline && (t.textBaseline = e.textBaseline);
        }(t, r), c = 0; c < l.length; ++c)d = l[c], h && (r.strokeColor && (t.strokeStyle = r.strokeColor), i(r.strokeWidth) || (t.lineWidth = r.strokeWidth), t.strokeText(d, n, o, r.maxWidth)), t.fillText(d, n, o, r.maxWidth), Te(t, n, o, d, r), o += a.lineHeight;
        t.restore();
    }
    function Te(t, e, i, s, n) {
        if (n.strikethrough || n.underline) {
            const o = t.measureText(s), a = e - o.actualBoundingBoxLeft, r = e + o.actualBoundingBoxRight, l = i - o.actualBoundingBoxAscent, h = i + o.actualBoundingBoxDescent, c = n.strikethrough ? (l + h) / 2 : h;
            t.strokeStyle = t.fillStyle, t.beginPath(), t.lineWidth = n.decorationWidth || 2, t.moveTo(a, c), t.lineTo(r, c), t.stroke();
        }
    }
    function Le(t, e) {
        const { x: i, y: s, w: n, h: o, radius: a } = e;
        t.arc(i + a.topLeft, s + a.topLeft, a.topLeft, -L, D, !0), t.lineTo(i, s + o - a.bottomLeft), t.arc(i + a.bottomLeft, s + o - a.bottomLeft, a.bottomLeft, D, L, !0), t.lineTo(i + n - a.bottomRight, s + o), t.arc(i + n - a.bottomRight, s + o - a.bottomRight, a.bottomRight, L, 0, !0), t.lineTo(i + n, s + a.topRight), t.arc(i + n - a.topRight, s + a.topRight, a.topRight, 0, -L, !0), t.lineTo(i + a.topLeft, s);
    }
    function Ee(t, e = [
        ""
    ], i = t, s, n = ()=>t[0]) {
        M(s) || (s = $e("_fallback", t));
        const o = {
            [Symbol.toStringTag]: "Object",
            _cacheable: !0,
            _scopes: t,
            _rootScopes: i,
            _fallback: s,
            _getTarget: n,
            override: (n)=>Ee([
                    n,
                    ...t
                ], e, i, s)
        };
        return new Proxy(o, {
            deleteProperty: (e, i)=>(delete e[i], delete e._keys, delete t[0][i], !0),
            get: (i, s)=>Ve(i, s, ()=>(function(t, e, i, s) {
                        let n;
                        for (const o of e)if (n = $e(ze(o, t), i), M(n)) return Fe(t, n) ? je(i, s, t, n) : n;
                    })(s, e, t, i)),
            getOwnPropertyDescriptor: (t, e)=>Reflect.getOwnPropertyDescriptor(t._scopes[0], e),
            getPrototypeOf: ()=>Reflect.getPrototypeOf(t[0]),
            has: (t, e)=>Ye(t).includes(e),
            ownKeys: (t)=>Ye(t),
            set (t, e, i) {
                const s = t._storage || (t._storage = n());
                return t[e] = s[e] = i, delete t._keys, !0;
            }
        });
    }
    function Re(t, e, i, o) {
        const a = {
            _cacheable: !1,
            _proxy: t,
            _context: e,
            _subProxy: i,
            _stack: new Set,
            _descriptors: Ie(t, o),
            setContext: (e)=>Re(t, e, i, o),
            override: (s)=>Re(t.override(s), e, i, o)
        };
        return new Proxy(a, {
            deleteProperty: (e, i)=>(delete e[i], delete t[i], !0),
            get: (t, e, i)=>Ve(t, e, ()=>(function(t, e, i) {
                        const { _proxy: o, _context: a, _subProxy: r, _descriptors: l } = t;
                        let h = o[e];
                        k(h) && l.isScriptable(e) && (h = function(t, e, i, s) {
                            const { _proxy: n, _context: o, _subProxy: a, _stack: r } = i;
                            if (r.has(t)) throw new Error("Recursion detected: " + Array.from(r).join("->") + "->" + t);
                            r.add(t), e = e(o, a || s), r.delete(t), Fe(t, e) && (e = je(n._scopes, n, t, e));
                            return e;
                        }(e, h, t, i));
                        s(h) && h.length && (h = function(t, e, i, s) {
                            const { _proxy: o, _context: a, _subProxy: r, _descriptors: l } = i;
                            if (M(a.index) && s(t)) e = e[a.index % e.length];
                            else if (n(e[0])) {
                                const i = e, s = o._scopes.filter((t)=>t !== i);
                                e = [];
                                for (const n of i){
                                    const i = je(s, o, t, n);
                                    e.push(Re(i, a, r && r[t], l));
                                }
                            }
                            return e;
                        }(e, h, t, l.isIndexable));
                        Fe(e, h) && (h = Re(h, a, r && r[e], l));
                        return h;
                    })(t, e, i)),
            getOwnPropertyDescriptor: (e, i)=>e._descriptors.allKeys ? Reflect.has(t, i) ? {
                    enumerable: !0,
                    configurable: !0
                } : void 0 : Reflect.getOwnPropertyDescriptor(t, i),
            getPrototypeOf: ()=>Reflect.getPrototypeOf(t),
            has: (e, i)=>Reflect.has(t, i),
            ownKeys: ()=>Reflect.ownKeys(t),
            set: (e, i, s)=>(t[i] = s, delete e[i], !0)
        });
    }
    function Ie(t, e = {
        scriptable: !0,
        indexable: !0
    }) {
        const { _scriptable: i = e.scriptable, _indexable: s = e.indexable, _allKeys: n = e.allKeys } = t;
        return {
            allKeys: n,
            scriptable: i,
            indexable: s,
            isScriptable: k(i) ? i : ()=>i,
            isIndexable: k(s) ? s : ()=>s
        };
    }
    const ze = (t, e)=>t ? t + w(e) : e, Fe = (t, e)=>n(e) && "adapters" !== t && (null === Object.getPrototypeOf(e) || e.constructor === Object);
    function Ve(t, e, i) {
        if (Object.prototype.hasOwnProperty.call(t, e)) return t[e];
        const s = i();
        return t[e] = s, s;
    }
    function Be(t, e, i) {
        return k(t) ? t(e, i) : t;
    }
    const Ne = (t, e)=>!0 === t ? e : "string" == typeof t ? y(e, t) : void 0;
    function We(t, e, i, s, n) {
        for (const o of e){
            const e = Ne(i, o);
            if (e) {
                t.add(e);
                const o = Be(e._fallback, i, n);
                if (M(o) && o !== i && o !== s) return o;
            } else if (!1 === e && M(s) && i !== s) return null;
        }
        return !1;
    }
    function je(t, e, i, o) {
        const a = e._rootScopes, r = Be(e._fallback, i, o), l = [
            ...t,
            ...a
        ], h = new Set;
        h.add(o);
        let c = He(h, l, i, r || i, o);
        return null !== c && (!M(r) || r === i || (c = He(h, l, r, c, o), null !== c)) && Ee(Array.from(h), [
            ""
        ], a, r, ()=>(function(t, e, i) {
                const o = t._getTarget();
                e in o || (o[e] = {});
                const a = o[e];
                if (s(a) && n(i)) return i;
                return a;
            })(e, i, o));
    }
    function He(t, e, i, s, n) {
        for(; i;)i = We(t, e, i, s, n);
        return i;
    }
    function $e(t, e) {
        for (const i of e){
            if (!i) continue;
            const e = i[t];
            if (M(e)) return e;
        }
    }
    function Ye(t) {
        let e = t._keys;
        return e || (e = t._keys = function(t) {
            const e = new Set;
            for (const i of t)for (const t of Object.keys(i).filter((t)=>!t.startsWith("_")))e.add(t);
            return Array.from(e);
        }(t._scopes)), e;
    }
    function Ue(t, e, i, s) {
        const { iScale: n } = t, { key: o = "r" } = this._parsing, a = new Array(s);
        let r, l, h, c;
        for(r = 0, l = s; r < l; ++r)h = r + i, c = e[h], a[r] = {
            r: n.parse(y(c, o), h)
        };
        return a;
    }
    const Xe = Number.EPSILON || 1e-14, qe = (t, e)=>e < t.length && !t[e].skip && t[e], Ke = (t)=>"x" === t ? "y" : "x";
    function Ge(t, e, i, s) {
        const n = t.skip ? e : t, o = e, a = i.skip ? e : i, r = X(o, n), l = X(a, o);
        let h = r / (r + l), c = l / (r + l);
        h = isNaN(h) ? 0 : h, c = isNaN(c) ? 0 : c;
        const d = s * h, u = s * c;
        return {
            previous: {
                x: o.x - d * (a.x - n.x),
                y: o.y - d * (a.y - n.y)
            },
            next: {
                x: o.x + u * (a.x - n.x),
                y: o.y + u * (a.y - n.y)
            }
        };
    }
    function Ze(t, e = "x") {
        const i = Ke(e), s = t.length, n = Array(s).fill(0), o = Array(s);
        let a, r, l, h = qe(t, 0);
        for(a = 0; a < s; ++a)if (r = l, l = h, h = qe(t, a + 1), l) {
            if (h) {
                const t = h[e] - l[e];
                n[a] = 0 !== t ? (h[i] - l[i]) / t : 0;
            }
            o[a] = r ? h ? z(n[a - 1]) !== z(n[a]) ? 0 : (n[a - 1] + n[a]) / 2 : n[a - 1] : n[a];
        }
        !function(t, e, i) {
            const s = t.length;
            let n, o, a, r, l, h = qe(t, 0);
            for(let c = 0; c < s - 1; ++c)l = h, h = qe(t, c + 1), l && h && (N(e[c], 0, Xe) ? i[c] = i[c + 1] = 0 : (n = i[c] / e[c], o = i[c + 1] / e[c], r = Math.pow(n, 2) + Math.pow(o, 2), r <= 9 || (a = 3 / Math.sqrt(r), i[c] = n * a * e[c], i[c + 1] = o * a * e[c])));
        }(t, n, o), function(t, e, i = "x") {
            const s = Ke(i), n = t.length;
            let o, a, r, l = qe(t, 0);
            for(let h = 0; h < n; ++h){
                if (a = r, r = l, l = qe(t, h + 1), !r) continue;
                const n = r[i], c = r[s];
                a && (o = (n - a[i]) / 3, r[`cp1${i}`] = n - o, r[`cp1${s}`] = c - o * e[h]), l && (o = (l[i] - n) / 3, r[`cp2${i}`] = n + o, r[`cp2${s}`] = c + o * e[h]);
            }
        }(t, o, e);
    }
    function Je(t, e, i) {
        return Math.max(Math.min(t, i), e);
    }
    function Qe(t, e, i, s, n) {
        let o, a, r, l;
        if (e.spanGaps && (t = t.filter((t)=>!t.skip)), "monotone" === e.cubicInterpolationMode) Ze(t, n);
        else {
            let i = s ? t[t.length - 1] : t[0];
            for(o = 0, a = t.length; o < a; ++o)r = t[o], l = Ge(i, r, t[Math.min(o + 1, a - (s ? 0 : 1)) % a], e.tension), r.cp1x = l.previous.x, r.cp1y = l.previous.y, r.cp2x = l.next.x, r.cp2y = l.next.y, i = r;
        }
        e.capBezierPoints && function(t, e) {
            let i, s, n, o, a, r = Se(t[0], e);
            for(i = 0, s = t.length; i < s; ++i)a = o, o = r, r = i < s - 1 && Se(t[i + 1], e), o && (n = t[i], a && (n.cp1x = Je(n.cp1x, e.left, e.right), n.cp1y = Je(n.cp1y, e.top, e.bottom)), r && (n.cp2x = Je(n.cp2x, e.left, e.right), n.cp2y = Je(n.cp2y, e.top, e.bottom)));
        }(t, i);
    }
    const ti = (t)=>0 === t || 1 === t, ei = (t, e, i)=>-Math.pow(2, 10 * (t -= 1)) * Math.sin((t - e) * O / i), ii = (t, e, i)=>Math.pow(2, -10 * t) * Math.sin((t - e) * O / i) + 1, si = {
        linear: (t)=>t,
        easeInQuad: (t)=>t * t,
        easeOutQuad: (t)=>-t * (t - 2),
        easeInOutQuad: (t)=>(t /= .5) < 1 ? .5 * t * t : -0.5 * (--t * (t - 2) - 1),
        easeInCubic: (t)=>t * t * t,
        easeOutCubic: (t)=>(t -= 1) * t * t + 1,
        easeInOutCubic: (t)=>(t /= .5) < 1 ? .5 * t * t * t : .5 * ((t -= 2) * t * t + 2),
        easeInQuart: (t)=>t * t * t * t,
        easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
        easeInOutQuart: (t)=>(t /= .5) < 1 ? .5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
        easeInQuint: (t)=>t * t * t * t * t,
        easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
        easeInOutQuint: (t)=>(t /= .5) < 1 ? .5 * t * t * t * t * t : .5 * ((t -= 2) * t * t * t * t + 2),
        easeInSine: (t)=>1 - Math.cos(t * L),
        easeOutSine: (t)=>Math.sin(t * L),
        easeInOutSine: (t)=>-0.5 * (Math.cos(D * t) - 1),
        easeInExpo: (t)=>0 === t ? 0 : Math.pow(2, 10 * (t - 1)),
        easeOutExpo: (t)=>1 === t ? 1 : 1 - Math.pow(2, -10 * t),
        easeInOutExpo: (t)=>ti(t) ? t : t < .5 ? .5 * Math.pow(2, 10 * (2 * t - 1)) : .5 * (2 - Math.pow(2, -10 * (2 * t - 1))),
        easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
        easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
        easeInOutCirc: (t)=>(t /= .5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : .5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
        easeInElastic: (t)=>ti(t) ? t : ei(t, .075, .3),
        easeOutElastic: (t)=>ti(t) ? t : ii(t, .075, .3),
        easeInOutElastic (t) {
            const e = .1125;
            return ti(t) ? t : t < .5 ? .5 * ei(2 * t, e, .45) : .5 + .5 * ii(2 * t - 1, e, .45);
        },
        easeInBack (t) {
            const e = 1.70158;
            return t * t * ((e + 1) * t - e);
        },
        easeOutBack (t) {
            const e = 1.70158;
            return (t -= 1) * t * ((e + 1) * t + e) + 1;
        },
        easeInOutBack (t) {
            let e = 1.70158;
            return (t /= .5) < 1 ? t * t * ((1 + (e *= 1.525)) * t - e) * .5 : .5 * ((t -= 2) * t * ((1 + (e *= 1.525)) * t + e) + 2);
        },
        easeInBounce: (t)=>1 - si.easeOutBounce(1 - t),
        easeOutBounce (t) {
            const e = 7.5625, i = 2.75;
            return t < 1 / i ? e * t * t : t < 2 / i ? e * (t -= 1.5 / i) * t + .75 : t < 2.5 / i ? e * (t -= 2.25 / i) * t + .9375 : e * (t -= 2.625 / i) * t + .984375;
        },
        easeInOutBounce: (t)=>t < .5 ? .5 * si.easeInBounce(2 * t) : .5 * si.easeOutBounce(2 * t - 1) + .5
    };
    function ni(t, e, i, s) {
        return {
            x: t.x + i * (e.x - t.x),
            y: t.y + i * (e.y - t.y)
        };
    }
    function oi(t, e, i, s) {
        return {
            x: t.x + i * (e.x - t.x),
            y: "middle" === s ? i < .5 ? t.y : e.y : "after" === s ? i < 1 ? t.y : e.y : i > 0 ? e.y : t.y
        };
    }
    function ai(t, e, i, s) {
        const n = {
            x: t.cp2x,
            y: t.cp2y
        }, o = {
            x: e.cp1x,
            y: e.cp1y
        }, a = ni(t, n, i), r = ni(n, o, i), l = ni(o, e, i), h = ni(a, r, i), c = ni(r, l, i);
        return ni(h, c, i);
    }
    const ri = new Map;
    function li(t, e, i) {
        return (function(t, e) {
            e = e || {};
            const i = t + JSON.stringify(e);
            let s = ri.get(i);
            return s || (s = new Intl.NumberFormat(t, e), ri.set(i, s)), s;
        })(e, i).format(t);
    }
    const hi = new RegExp(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/), ci = new RegExp(/^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/);
    function di(t, e) {
        const i = ("" + t).match(hi);
        if (!i || "normal" === i[1]) return 1.2 * e;
        switch(t = +i[2], i[3]){
            case "px":
                return t;
            case "%":
                t /= 100;
        }
        return e * t;
    }
    function ui(t, e) {
        const i = {}, s = n(e), o = s ? Object.keys(e) : e, a = n(t) ? s ? (i)=>r(t[i], t[e[i]]) : (e)=>t[e] : ()=>t;
        for (const t of o)i[t] = +a(t) || 0;
        return i;
    }
    function fi(t) {
        return ui(t, {
            top: "y",
            right: "x",
            bottom: "y",
            left: "x"
        });
    }
    function gi(t) {
        return ui(t, [
            "topLeft",
            "topRight",
            "bottomLeft",
            "bottomRight"
        ]);
    }
    function pi(t) {
        const e = fi(t);
        return e.width = e.left + e.right, e.height = e.top + e.bottom, e;
    }
    function mi(t, e) {
        t = t || {}, e = e || ne.font;
        let i = r(t.size, e.size);
        "string" == typeof i && (i = parseInt(i, 10));
        let s = r(t.style, e.style);
        s && !("" + s).match(ci) && (console.warn('Invalid font style specified: "' + s + '"'), s = "");
        const n = {
            family: r(t.family, e.family),
            lineHeight: di(r(t.lineHeight, e.lineHeight), i),
            size: i,
            style: s,
            weight: r(t.weight, e.weight),
            string: ""
        };
        return n.string = xe(n), n;
    }
    function bi(t, e, i, n) {
        let o, a, r, l = !0;
        for(o = 0, a = t.length; o < a; ++o)if (r = t[o], void 0 !== r && (void 0 !== e && "function" == typeof r && (r = r(e), l = !1), void 0 !== i && s(r) && (r = r[i % r.length], l = !1), void 0 !== r)) return n && !l && (n.cacheable = !1), r;
    }
    function xi(t, e, i) {
        const { min: s, max: n } = t, o = h(e, (n - s) / 2), a = (t, e)=>i && 0 === t ? 0 : t + e;
        return {
            min: a(s, -Math.abs(o)),
            max: a(n, o)
        };
    }
    function _i(t, e) {
        return Object.assign(Object.create(t), e);
    }
    function yi(t, e, i) {
        return t ? function(t, e) {
            return {
                x: (i)=>t + t + e - i,
                setWidth (t) {
                    e = t;
                },
                textAlign: (t)=>"center" === t ? t : "right" === t ? "left" : "right",
                xPlus: (t, e)=>t - e,
                leftForLtr: (t, e)=>t - e
            };
        }(e, i) : {
            x: (t)=>t,
            setWidth (t) {},
            textAlign: (t)=>t,
            xPlus: (t, e)=>t + e,
            leftForLtr: (t, e)=>t
        };
    }
    function vi(t, e) {
        let i, s;
        "ltr" !== e && "rtl" !== e || (i = t.canvas.style, s = [
            i.getPropertyValue("direction"),
            i.getPropertyPriority("direction")
        ], i.setProperty("direction", e, "important"), t.prevTextDirection = s);
    }
    function wi(t, e) {
        void 0 !== e && (delete t.prevTextDirection, t.canvas.style.setProperty("direction", e[0], e[1]));
    }
    function Mi(t) {
        return "angle" === t ? {
            between: G,
            compare: q,
            normalize: K
        } : {
            between: Q,
            compare: (t, e)=>t - e,
            normalize: (t)=>t
        };
    }
    function ki({ start: t, end: e, count: i, loop: s, style: n }) {
        return {
            start: t % i,
            end: e % i,
            loop: s && (e - t + 1) % i == 0,
            style: n
        };
    }
    function Si(t, e, i) {
        if (!i) return [
            t
        ];
        const { property: s, start: n, end: o } = i, a = e.length, { compare: r, between: l, normalize: h } = Mi(s), { start: c, end: d, loop: u, style: f } = function(t, e, i) {
            const { property: s, start: n, end: o } = i, { between: a, normalize: r } = Mi(s), l = e.length;
            let h, c, { start: d, end: u, loop: f } = t;
            if (f) {
                for(d += l, u += l, h = 0, c = l; h < c && a(r(e[d % l][s]), n, o); ++h)d--, u--;
                d %= l, u %= l;
            }
            return u < d && (u += l), {
                start: d,
                end: u,
                loop: f,
                style: t.style
            };
        }(t, e, i), g = [];
        let p, m, b, x = !1, _ = null;
        const y = ()=>x || l(n, b, p) && 0 !== r(n, b), v = ()=>!x || 0 === r(o, p) || l(o, b, p);
        for(let t = c, i = c; t <= d; ++t)m = e[t % a], m.skip || (p = h(m[s]), p !== b && (x = l(p, n, o), null === _ && y() && (_ = 0 === r(p, n) ? t : i), null !== _ && v() && (g.push(ki({
            start: _,
            end: t,
            loop: u,
            count: a,
            style: f
        })), _ = null), i = t, b = p));
        return null !== _ && g.push(ki({
            start: _,
            end: d,
            loop: u,
            count: a,
            style: f
        })), g;
    }
    function Pi(t, e) {
        const i = [], s = t.segments;
        for(let n = 0; n < s.length; n++){
            const o = Si(s[n], t.points, e);
            o.length && i.push(...o);
        }
        return i;
    }
    function Di(t, e) {
        const i = t.points, s = t.options.spanGaps, n = i.length;
        if (!n) return [];
        const o = !!t._loop, { start: a, end: r } = function(t, e, i, s) {
            let n = 0, o = e - 1;
            if (i && !s) for(; n < e && !t[n].skip;)n++;
            for(; n < e && t[n].skip;)n++;
            for(n %= e, i && (o += n); o > n && t[o % e].skip;)o--;
            return o %= e, {
                start: n,
                end: o
            };
        }(i, n, o, s);
        if (!0 === s) return Oi(t, [
            {
                start: a,
                end: r,
                loop: o
            }
        ], i, e);
        return Oi(t, function(t, e, i, s) {
            const n = t.length, o = [];
            let a, r = e, l = t[e];
            for(a = e + 1; a <= i; ++a){
                const i = t[a % n];
                i.skip || i.stop ? l.skip || (s = !1, o.push({
                    start: e % n,
                    end: (a - 1) % n,
                    loop: s
                }), e = r = i.stop ? a : null) : (r = a, l.skip && (e = a)), l = i;
            }
            return null !== r && o.push({
                start: e % n,
                end: r % n,
                loop: s
            }), o;
        }(i, a, r < a ? r + n : r, !!t._fullLoop && 0 === a && r === n - 1), i, e);
    }
    function Oi(t, e, i, s) {
        return s && s.setContext && i ? function(t, e, i, s) {
            const n = t._chart.getContext(), o = Ci(t.options), { _datasetIndex: a, options: { spanGaps: r } } = t, l = i.length, h = [];
            let c = o, d = e[0].start, u = d;
            function f(t, e, s, n) {
                const o = r ? -1 : 1;
                if (t !== e) {
                    for(t += l; i[t % l].skip;)t -= o;
                    for(; i[e % l].skip;)e += o;
                    t % l != e % l && (h.push({
                        start: t % l,
                        end: e % l,
                        loop: s,
                        style: n
                    }), c = n, d = e % l);
                }
            }
            for (const t of e){
                d = r ? d : t.start;
                let e, o = i[d % l];
                for(u = d + 1; u <= t.end; u++){
                    const r = i[u % l];
                    e = Ci(s.setContext(_i(n, {
                        type: "segment",
                        p0: o,
                        p1: r,
                        p0DataIndex: (u - 1) % l,
                        p1DataIndex: u % l,
                        datasetIndex: a
                    }))), Ai(e, c) && f(d, u - 1, t.loop, c), o = r, c = e;
                }
                d < u - 1 && f(d, u - 1, t.loop, c);
            }
            return h;
        }(t, e, i, s) : e;
    }
    function Ci(t) {
        return {
            backgroundColor: t.backgroundColor,
            borderCapStyle: t.borderCapStyle,
            borderDash: t.borderDash,
            borderDashOffset: t.borderDashOffset,
            borderJoinStyle: t.borderJoinStyle,
            borderWidth: t.borderWidth,
            borderColor: t.borderColor
        };
    }
    function Ai(t, e) {
        return e && JSON.stringify(t) !== JSON.stringify(e);
    }
    var Ti = Object.freeze({
        __proto__: null,
        easingEffects: si,
        isPatternOrGradient: Zt,
        color: Jt,
        getHoverColor: Qt,
        noop: t,
        uid: e,
        isNullOrUndef: i,
        isArray: s,
        isObject: n,
        isFinite: o,
        finiteOrDefault: a,
        valueOrDefault: r,
        toPercentage: l,
        toDimension: h,
        callback: c,
        each: d,
        _elementsEqual: u,
        clone: f,
        _merger: p,
        merge: m,
        mergeIf: b,
        _mergerIf: x,
        _deprecated: function(t, e, i, s) {
            void 0 !== e && console.warn(t + ': "' + i + '" is deprecated. Please use "' + s + '" instead');
        },
        resolveObjectKey: y,
        _splitKey: v,
        _capitalize: w,
        defined: M,
        isFunction: k,
        setsEqual: S,
        _isClickEvent: P,
        toFontString: xe,
        _measureText: _e,
        _longestText: ye,
        _alignPixel: ve,
        clearCanvas: we,
        drawPoint: Me,
        drawPointLegend: ke,
        _isPointInArea: Se,
        clipArea: Pe,
        unclipArea: De,
        _steppedLineTo: Oe,
        _bezierCurveTo: Ce,
        renderText: Ae,
        addRoundedRectPath: Le,
        _lookup: tt,
        _lookupByKey: et,
        _rlookupByKey: it,
        _filterBetween: st,
        listenArrayEvents: ot,
        unlistenArrayEvents: at,
        _arrayUnique: rt,
        _createResolver: Ee,
        _attachContext: Re,
        _descriptors: Ie,
        _parseObjectDataRadialScale: Ue,
        splineCurve: Ge,
        splineCurveMonotone: Ze,
        _updateBezierControlPoints: Qe,
        _isDomSupported: oe,
        _getParentNode: ae,
        getStyle: he,
        getRelativePosition: ue,
        getMaximumSize: ge,
        retinaScale: pe,
        supportsEventListenerOptions: me,
        readUsedSize: be,
        fontString: function(t, e, i) {
            return e + " " + t + "px " + i;
        },
        requestAnimFrame: lt,
        throttled: ht,
        debounce: ct,
        _toLeftRightCenter: dt,
        _alignStartEnd: ut,
        _textX: ft,
        _getStartAndCountOfVisiblePoints: gt,
        _scaleRangesChanged: pt,
        _pointInLine: ni,
        _steppedInterpolation: oi,
        _bezierInterpolation: ai,
        formatNumber: li,
        toLineHeight: di,
        _readValueToProps: ui,
        toTRBL: fi,
        toTRBLCorners: gi,
        toPadding: pi,
        toFont: mi,
        resolve: bi,
        _addGrace: xi,
        createContext: _i,
        PI: D,
        TAU: O,
        PITAU: C,
        INFINITY: A,
        RAD_PER_DEG: T,
        HALF_PI: L,
        QUARTER_PI: E,
        TWO_THIRDS_PI: R,
        log10: I,
        sign: z,
        niceNum: F,
        _factorize: V,
        isNumber: B,
        almostEquals: N,
        almostWhole: W,
        _setMinAndMaxByKey: j,
        toRadians: H,
        toDegrees: $,
        _decimalPlaces: Y,
        getAngleFromPoint: U,
        distanceBetweenPoints: X,
        _angleDiff: q,
        _normalizeAngle: K,
        _angleBetween: G,
        _limitValue: Z,
        _int16Range: J,
        _isBetween: Q,
        getRtlAdapter: yi,
        overrideTextDirection: vi,
        restoreTextDirection: wi,
        _boundSegment: Si,
        _boundSegments: Pi,
        _computeSegments: Di
    });
    function Li(t, e, i, s) {
        const { controller: n, data: o, _sorted: a } = t, r = n._cachedMeta.iScale;
        if (r && e === r.axis && "r" !== e && a && o.length) {
            const t = r._reversePixels ? it : et;
            if (!s) return t(o, e, i);
            if (n._sharedOptions) {
                const s = o[0], n = "function" == typeof s.getRange && s.getRange(e);
                if (n) {
                    const s = t(o, e, i - n), a = t(o, e, i + n);
                    return {
                        lo: s.lo,
                        hi: a.hi
                    };
                }
            }
        }
        return {
            lo: 0,
            hi: o.length - 1
        };
    }
    function Ei(t, e, i, s, n) {
        const o = t.getSortedVisibleDatasetMetas(), a = i[e];
        for(let t = 0, i = o.length; t < i; ++t){
            const { index: i, data: r } = o[t], { lo: l, hi: h } = Li(o[t], e, a, n);
            for(let t = l; t <= h; ++t){
                const e = r[t];
                e.skip || s(e, i, t);
            }
        }
    }
    function Ri(t, e, i, s, n) {
        const o = [];
        if (!n && !t.isPointInArea(e)) return o;
        return Ei(t, i, e, function(i, a, r) {
            (n || Se(i, t.chartArea, 0)) && i.inRange(e.x, e.y, s) && o.push({
                element: i,
                datasetIndex: a,
                index: r
            });
        }, !0), o;
    }
    function Ii(t, e, i, s, n, o) {
        let a = [];
        const r = function(t) {
            const e = -1 !== t.indexOf("x"), i = -1 !== t.indexOf("y");
            return function(t, s) {
                const n = e ? Math.abs(t.x - s.x) : 0, o = i ? Math.abs(t.y - s.y) : 0;
                return Math.sqrt(Math.pow(n, 2) + Math.pow(o, 2));
            };
        }(i);
        let l = Number.POSITIVE_INFINITY;
        return Ei(t, i, e, function(i, h, c) {
            const d = i.inRange(e.x, e.y, n);
            if (s && !d) return;
            const u = i.getCenterPoint(n);
            if (!(!!o || t.isPointInArea(u)) && !d) return;
            const f = r(e, u);
            f < l ? (a = [
                {
                    element: i,
                    datasetIndex: h,
                    index: c
                }
            ], l = f) : f === l && a.push({
                element: i,
                datasetIndex: h,
                index: c
            });
        }), a;
    }
    function zi(t, e, i, s, n, o) {
        return o || t.isPointInArea(e) ? "r" !== i || s ? Ii(t, e, i, s, n, o) : function(t, e, i, s) {
            let n = [];
            return Ei(t, i, e, function(t, i, o) {
                const { startAngle: a, endAngle: r } = t.getProps([
                    "startAngle",
                    "endAngle"
                ], s), { angle: l } = U(t, {
                    x: e.x,
                    y: e.y
                });
                G(l, a, r) && n.push({
                    element: t,
                    datasetIndex: i,
                    index: o
                });
            }), n;
        }(t, e, i, n) : [];
    }
    function Fi(t, e, i, s, n) {
        const o = [], a = "x" === i ? "inXRange" : "inYRange";
        let r = !1;
        return Ei(t, i, e, (t, s, l)=>{
            t[a](e[i], n) && (o.push({
                element: t,
                datasetIndex: s,
                index: l
            }), r = r || t.inRange(e.x, e.y, n));
        }), s && !r ? [] : o;
    }
    var Vi = {
        evaluateInteractionItems: Ei,
        modes: {
            index (t, e, i, s) {
                const n = ue(e, t), o = i.axis || "x", a = i.includeInvisible || !1, r = i.intersect ? Ri(t, n, o, s, a) : zi(t, n, o, !1, s, a), l = [];
                return r.length ? (t.getSortedVisibleDatasetMetas().forEach((t)=>{
                    const e = r[0].index, i = t.data[e];
                    i && !i.skip && l.push({
                        element: i,
                        datasetIndex: t.index,
                        index: e
                    });
                }), l) : [];
            },
            dataset (t, e, i, s) {
                const n = ue(e, t), o = i.axis || "xy", a = i.includeInvisible || !1;
                let r = i.intersect ? Ri(t, n, o, s, a) : zi(t, n, o, !1, s, a);
                if (r.length > 0) {
                    const e = r[0].datasetIndex, i = t.getDatasetMeta(e).data;
                    r = [];
                    for(let t = 0; t < i.length; ++t)r.push({
                        element: i[t],
                        datasetIndex: e,
                        index: t
                    });
                }
                return r;
            },
            point: (t, e, i, s)=>Ri(t, ue(e, t), i.axis || "xy", s, i.includeInvisible || !1),
            nearest (t, e, i, s) {
                const n = ue(e, t), o = i.axis || "xy", a = i.includeInvisible || !1;
                return zi(t, n, o, i.intersect, s, a);
            },
            x: (t, e, i, s)=>Fi(t, ue(e, t), "x", i.intersect, s),
            y: (t, e, i, s)=>Fi(t, ue(e, t), "y", i.intersect, s)
        }
    };
    const Bi = [
        "left",
        "top",
        "right",
        "bottom"
    ];
    function Ni(t, e) {
        return t.filter((t)=>t.pos === e);
    }
    function Wi(t, e) {
        return t.filter((t)=>-1 === Bi.indexOf(t.pos) && t.box.axis === e);
    }
    function ji(t, e) {
        return t.sort((t, i)=>{
            const s = e ? i : t, n = e ? t : i;
            return s.weight === n.weight ? s.index - n.index : s.weight - n.weight;
        });
    }
    function Hi(t, e) {
        const i = function(t) {
            const e = {};
            for (const i of t){
                const { stack: t, pos: s, stackWeight: n } = i;
                if (!t || !Bi.includes(s)) continue;
                const o = e[t] || (e[t] = {
                    count: 0,
                    placed: 0,
                    weight: 0,
                    size: 0
                });
                o.count++, o.weight += n;
            }
            return e;
        }(t), { vBoxMaxWidth: s, hBoxMaxHeight: n } = e;
        let o, a, r;
        for(o = 0, a = t.length; o < a; ++o){
            r = t[o];
            const { fullSize: a } = r.box, l = i[r.stack], h = l && r.stackWeight / l.weight;
            r.horizontal ? (r.width = h ? h * s : a && e.availableWidth, r.height = n) : (r.width = s, r.height = h ? h * n : a && e.availableHeight);
        }
        return i;
    }
    function $i(t, e, i, s) {
        return Math.max(t[i], e[i]) + Math.max(t[s], e[s]);
    }
    function Yi(t, e) {
        t.top = Math.max(t.top, e.top), t.left = Math.max(t.left, e.left), t.bottom = Math.max(t.bottom, e.bottom), t.right = Math.max(t.right, e.right);
    }
    function Ui(t, e, i, s) {
        const { pos: o, box: a } = i, r = t.maxPadding;
        if (!n(o)) {
            i.size && (t[o] -= i.size);
            const e = s[i.stack] || {
                size: 0,
                count: 1
            };
            e.size = Math.max(e.size, i.horizontal ? a.height : a.width), i.size = e.size / e.count, t[o] += i.size;
        }
        a.getPadding && Yi(r, a.getPadding());
        const l = Math.max(0, e.outerWidth - $i(r, t, "left", "right")), h = Math.max(0, e.outerHeight - $i(r, t, "top", "bottom")), c = l !== t.w, d = h !== t.h;
        return t.w = l, t.h = h, i.horizontal ? {
            same: c,
            other: d
        } : {
            same: d,
            other: c
        };
    }
    function Xi(t, e) {
        const i = e.maxPadding;
        function s(t) {
            const s = {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            };
            return t.forEach((t)=>{
                s[t] = Math.max(e[t], i[t]);
            }), s;
        }
        return s(t ? [
            "left",
            "right"
        ] : [
            "top",
            "bottom"
        ]);
    }
    function qi(t, e, i, s) {
        const n = [];
        let o, a, r, l, h, c;
        for(o = 0, a = t.length, h = 0; o < a; ++o){
            r = t[o], l = r.box, l.update(r.width || e.w, r.height || e.h, Xi(r.horizontal, e));
            const { same: a, other: d } = Ui(e, i, r, s);
            h |= a && n.length, c = c || d, l.fullSize || n.push(r);
        }
        return h && qi(n, e, i, s) || c;
    }
    function Ki(t, e, i, s, n) {
        t.top = i, t.left = e, t.right = e + s, t.bottom = i + n, t.width = s, t.height = n;
    }
    function Gi(t, e, i, s) {
        const n = i.padding;
        let { x: o, y: a } = e;
        for (const r of t){
            const t = r.box, l = s[r.stack] || {
                count: 1,
                placed: 0,
                weight: 1
            }, h = r.stackWeight / l.weight || 1;
            if (r.horizontal) {
                const s = e.w * h, o = l.size || t.height;
                M(l.start) && (a = l.start), t.fullSize ? Ki(t, n.left, a, i.outerWidth - n.right - n.left, o) : Ki(t, e.left + l.placed, a, s, o), l.start = a, l.placed += s, a = t.bottom;
            } else {
                const s = e.h * h, a = l.size || t.width;
                M(l.start) && (o = l.start), t.fullSize ? Ki(t, o, n.top, a, i.outerHeight - n.bottom - n.top) : Ki(t, o, e.top + l.placed, a, s), l.start = o, l.placed += s, o = t.right;
            }
        }
        e.x = o, e.y = a;
    }
    ne.set("layout", {
        autoPadding: !0,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
    var Zi = {
        addBox (t, e) {
            t.boxes || (t.boxes = []), e.fullSize = e.fullSize || !1, e.position = e.position || "top", e.weight = e.weight || 0, e._layers = e._layers || function() {
                return [
                    {
                        z: 0,
                        draw (t) {
                            e.draw(t);
                        }
                    }
                ];
            }, t.boxes.push(e);
        },
        removeBox (t, e) {
            const i = t.boxes ? t.boxes.indexOf(e) : -1;
            -1 !== i && t.boxes.splice(i, 1);
        },
        configure (t, e, i) {
            e.fullSize = i.fullSize, e.position = i.position, e.weight = i.weight;
        },
        update (t, e, i, s) {
            if (!t) return;
            const n = pi(t.options.layout.padding), o = Math.max(e - n.width, 0), a = Math.max(i - n.height, 0), r = function(t) {
                const e = function(t) {
                    const e = [];
                    let i, s, n, o, a, r;
                    for(i = 0, s = (t || []).length; i < s; ++i)n = t[i], ({ position: o, options: { stack: a, stackWeight: r = 1 } } = n), e.push({
                        index: i,
                        box: n,
                        pos: o,
                        horizontal: n.isHorizontal(),
                        weight: n.weight,
                        stack: a && o + a,
                        stackWeight: r
                    });
                    return e;
                }(t), i = ji(e.filter((t)=>t.box.fullSize), !0), s = ji(Ni(e, "left"), !0), n = ji(Ni(e, "right")), o = ji(Ni(e, "top"), !0), a = ji(Ni(e, "bottom")), r = Wi(e, "x"), l = Wi(e, "y");
                return {
                    fullSize: i,
                    leftAndTop: s.concat(o),
                    rightAndBottom: n.concat(l).concat(a).concat(r),
                    chartArea: Ni(e, "chartArea"),
                    vertical: s.concat(n).concat(l),
                    horizontal: o.concat(a).concat(r)
                };
            }(t.boxes), l = r.vertical, h = r.horizontal;
            d(t.boxes, (t)=>{
                "function" == typeof t.beforeLayout && t.beforeLayout();
            });
            const c = l.reduce((t, e)=>e.box.options && !1 === e.box.options.display ? t : t + 1, 0) || 1, u = Object.freeze({
                outerWidth: e,
                outerHeight: i,
                padding: n,
                availableWidth: o,
                availableHeight: a,
                vBoxMaxWidth: o / 2 / c,
                hBoxMaxHeight: a / 2
            }), f = Object.assign({}, n);
            Yi(f, pi(s));
            const g = Object.assign({
                maxPadding: f,
                w: o,
                h: a,
                x: n.left,
                y: n.top
            }, n), p = Hi(l.concat(h), u);
            qi(r.fullSize, g, u, p), qi(l, g, u, p), qi(h, g, u, p) && qi(l, g, u, p), function(t) {
                const e = t.maxPadding;
                function i(i) {
                    const s = Math.max(e[i] - t[i], 0);
                    return t[i] += s, s;
                }
                t.y += i("top"), t.x += i("left"), i("right"), i("bottom");
            }(g), Gi(r.leftAndTop, g, u, p), g.x += g.w, g.y += g.h, Gi(r.rightAndBottom, g, u, p), t.chartArea = {
                left: g.left,
                top: g.top,
                right: g.left + g.w,
                bottom: g.top + g.h,
                height: g.h,
                width: g.w
            }, d(r.chartArea, (e)=>{
                const i = e.box;
                Object.assign(i, t.chartArea), i.update(g.w, g.h, {
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0
                });
            });
        }
    };
    class Ji {
        acquireContext(t, e) {}
        releaseContext(t) {
            return !1;
        }
        addEventListener(t, e, i) {}
        removeEventListener(t, e, i) {}
        getDevicePixelRatio() {
            return 1;
        }
        getMaximumSize(t, e, i, s) {
            return e = Math.max(0, e || t.width), i = i || t.height, {
                width: e,
                height: Math.max(0, s ? Math.floor(e / s) : i)
            };
        }
        isAttached(t) {
            return !0;
        }
        updateConfig(t) {}
    }
    class Qi extends Ji {
        acquireContext(t) {
            return t && t.getContext && t.getContext("2d") || null;
        }
        updateConfig(t) {
            t.options.animation = !1;
        }
    }
    const ts = {
        touchstart: "mousedown",
        touchmove: "mousemove",
        touchend: "mouseup",
        pointerenter: "mouseenter",
        pointerdown: "mousedown",
        pointermove: "mousemove",
        pointerup: "mouseup",
        pointerleave: "mouseout",
        pointerout: "mouseout"
    }, es = (t)=>null === t || "" === t;
    const is = !!me && {
        passive: !0
    };
    function ss(t, e, i) {
        t.canvas.removeEventListener(e, i, is);
    }
    function ns(t, e) {
        for (const i of t)if (i === e || i.contains(e)) return !0;
    }
    function os(t, e, i) {
        const s = t.canvas, n = new MutationObserver((t)=>{
            let e = !1;
            for (const i of t)e = e || ns(i.addedNodes, s), e = e && !ns(i.removedNodes, s);
            e && i();
        });
        return n.observe(document, {
            childList: !0,
            subtree: !0
        }), n;
    }
    function as(t, e, i) {
        const s = t.canvas, n = new MutationObserver((t)=>{
            let e = !1;
            for (const i of t)e = e || ns(i.removedNodes, s), e = e && !ns(i.addedNodes, s);
            e && i();
        });
        return n.observe(document, {
            childList: !0,
            subtree: !0
        }), n;
    }
    const rs = new Map;
    let ls = 0;
    function hs() {
        const t = window.devicePixelRatio;
        t !== ls && (ls = t, rs.forEach((e, i)=>{
            i.currentDevicePixelRatio !== t && e();
        }));
    }
    function cs(t, e, i) {
        const s = t.canvas, n = s && ae(s);
        if (!n) return;
        const o = ht((t, e)=>{
            const s = n.clientWidth;
            i(t, e), s < n.clientWidth && i();
        }, window), a = new ResizeObserver((t)=>{
            const e = t[0], i = e.contentRect.width, s = e.contentRect.height;
            0 === i && 0 === s || o(i, s);
        });
        return a.observe(n), function(t, e) {
            rs.size || window.addEventListener("resize", hs), rs.set(t, e);
        }(t, o), a;
    }
    function ds(t, e, i) {
        i && i.disconnect(), "resize" === e && function(t) {
            rs.delete(t), rs.size || window.removeEventListener("resize", hs);
        }(t);
    }
    function us(t, e, i) {
        const s = t.canvas, n = ht((e)=>{
            null !== t.ctx && i(function(t, e) {
                const i = ts[t.type] || t.type, { x: s, y: n } = ue(t, e);
                return {
                    type: i,
                    chart: e,
                    native: t,
                    x: void 0 !== s ? s : null,
                    y: void 0 !== n ? n : null
                };
            }(e, t));
        }, t, (t)=>{
            const e = t[0];
            return [
                e,
                e.offsetX,
                e.offsetY
            ];
        });
        return function(t, e, i) {
            t.addEventListener(e, i, is);
        }(s, e, n), n;
    }
    class fs extends Ji {
        acquireContext(t, e) {
            const i = t && t.getContext && t.getContext("2d");
            return i && i.canvas === t ? (function(t, e) {
                const i = t.style, s = t.getAttribute("height"), n = t.getAttribute("width");
                if (t.$chartjs = {
                    initial: {
                        height: s,
                        width: n,
                        style: {
                            display: i.display,
                            height: i.height,
                            width: i.width
                        }
                    }
                }, i.display = i.display || "block", i.boxSizing = i.boxSizing || "border-box", es(n)) {
                    const e = be(t, "width");
                    void 0 !== e && (t.width = e);
                }
                if (es(s)) {
                    if ("" === t.style.height) t.height = t.width / (e || 2);
                    else {
                        const e = be(t, "height");
                        void 0 !== e && (t.height = e);
                    }
                }
            }(t, e), i) : null;
        }
        releaseContext(t) {
            const e = t.canvas;
            if (!e.$chartjs) return !1;
            const s = e.$chartjs.initial;
            [
                "height",
                "width"
            ].forEach((t)=>{
                const n = s[t];
                i(n) ? e.removeAttribute(t) : e.setAttribute(t, n);
            });
            const n = s.style || {};
            return Object.keys(n).forEach((t)=>{
                e.style[t] = n[t];
            }), e.width = e.width, delete e.$chartjs, !0;
        }
        addEventListener(t, e, i) {
            this.removeEventListener(t, e);
            const s = t.$proxies || (t.$proxies = {}), n = {
                attach: os,
                detach: as,
                resize: cs
            }[e] || us;
            s[e] = n(t, e, i);
        }
        removeEventListener(t, e) {
            const i = t.$proxies || (t.$proxies = {}), s = i[e];
            if (!s) return;
            (({
                attach: ds,
                detach: ds,
                resize: ds
            })[e] || ss)(t, e, s), i[e] = void 0;
        }
        getDevicePixelRatio() {
            return window.devicePixelRatio;
        }
        getMaximumSize(t, e, i, s) {
            return ge(t, e, i, s);
        }
        isAttached(t) {
            const e = ae(t);
            return !(!e || !e.isConnected);
        }
    }
    function gs(t) {
        return !oe() || "undefined" != typeof OffscreenCanvas && t instanceof OffscreenCanvas ? Qi : fs;
    }
    var ps = Object.freeze({
        __proto__: null,
        _detectPlatform: gs,
        BasePlatform: Ji,
        BasicPlatform: Qi,
        DomPlatform: fs
    });
    const ms = "transparent", bs = {
        boolean: (t, e, i)=>i > .5 ? e : t,
        color (t, e, i) {
            const s = Jt(t || ms), n = s.valid && Jt(e || ms);
            return n && n.valid ? n.mix(s, i).hexString() : e;
        },
        number: (t, e, i)=>t + (e - t) * i
    };
    class xs {
        constructor(t, e, i, s){
            const n = e[i];
            s = bi([
                t.to,
                s,
                n,
                t.from
            ]);
            const o = bi([
                t.from,
                n,
                s
            ]);
            this._active = !0, this._fn = t.fn || bs[t.type || typeof o], this._easing = si[t.easing] || si.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = e, this._prop = i, this._from = o, this._to = s, this._promises = void 0;
        }
        active() {
            return this._active;
        }
        update(t, e, i) {
            if (this._active) {
                this._notify(!1);
                const s = this._target[this._prop], n = i - this._start, o = this._duration - n;
                this._start = i, this._duration = Math.floor(Math.max(o, t.duration)), this._total += n, this._loop = !!t.loop, this._to = bi([
                    t.to,
                    e,
                    s,
                    t.from
                ]), this._from = bi([
                    t.from,
                    s,
                    e
                ]);
            }
        }
        cancel() {
            this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
        }
        tick(t) {
            const e = t - this._start, i = this._duration, s = this._prop, n = this._from, o = this._loop, a = this._to;
            let r;
            if (this._active = n !== a && (o || e < i), !this._active) return this._target[s] = a, void this._notify(!0);
            e < 0 ? this._target[s] = n : (r = e / i % 2, r = o && r > 1 ? 2 - r : r, r = this._easing(Math.min(1, Math.max(0, r))), this._target[s] = this._fn(n, a, r));
        }
        wait() {
            const t = this._promises || (this._promises = []);
            return new Promise((e, i)=>{
                t.push({
                    res: e,
                    rej: i
                });
            });
        }
        _notify(t) {
            const e = t ? "res" : "rej", i = this._promises || [];
            for(let t = 0; t < i.length; t++)i[t][e]();
        }
    }
    ne.set("animation", {
        delay: void 0,
        duration: 1e3,
        easing: "easeOutQuart",
        fn: void 0,
        from: void 0,
        loop: void 0,
        to: void 0,
        type: void 0
    });
    const _s = Object.keys(ne.animation);
    ne.describe("animation", {
        _fallback: !1,
        _indexable: !1,
        _scriptable: (t)=>"onProgress" !== t && "onComplete" !== t && "fn" !== t
    }), ne.set("animations", {
        colors: {
            type: "color",
            properties: [
                "color",
                "borderColor",
                "backgroundColor"
            ]
        },
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "borderWidth",
                "radius",
                "tension"
            ]
        }
    }), ne.describe("animations", {
        _fallback: "animation"
    }), ne.set("transitions", {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: "transparent"
                },
                visible: {
                    type: "boolean",
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: "transparent"
                },
                visible: {
                    type: "boolean",
                    easing: "linear",
                    fn: (t)=>0 | t
                }
            }
        }
    });
    class ys {
        constructor(t, e){
            this._chart = t, this._properties = new Map, this.configure(e);
        }
        configure(t) {
            if (!n(t)) return;
            const e = this._properties;
            Object.getOwnPropertyNames(t).forEach((i)=>{
                const o = t[i];
                if (!n(o)) return;
                const a = {};
                for (const t of _s)a[t] = o[t];
                (s(o.properties) && o.properties || [
                    i
                ]).forEach((t)=>{
                    t !== i && e.has(t) || e.set(t, a);
                });
            });
        }
        _animateOptions(t, e) {
            const i = e.options, s = function(t, e) {
                if (!e) return;
                let i = t.options;
                if (!i) return void (t.options = e);
                i.$shared && (t.options = i = Object.assign({}, i, {
                    $shared: !1,
                    $animations: {}
                }));
                return i;
            }(t, i);
            if (!s) return [];
            const n = this._createAnimations(s, i);
            return i.$shared && (function(t, e) {
                const i = [], s = Object.keys(e);
                for(let e = 0; e < s.length; e++){
                    const n = t[s[e]];
                    n && n.active() && i.push(n.wait());
                }
                return Promise.all(i);
            })(t.options.$animations, i).then(()=>{
                t.options = i;
            }, ()=>{}), n;
        }
        _createAnimations(t, e) {
            const i = this._properties, s = [], n = t.$animations || (t.$animations = {}), o = Object.keys(e), a = Date.now();
            let r;
            for(r = o.length - 1; r >= 0; --r){
                const l = o[r];
                if ("$" === l.charAt(0)) continue;
                if ("options" === l) {
                    s.push(...this._animateOptions(t, e));
                    continue;
                }
                const h = e[l];
                let c = n[l];
                const d = i.get(l);
                if (c) {
                    if (d && c.active()) {
                        c.update(d, h, a);
                        continue;
                    }
                    c.cancel();
                }
                d && d.duration ? (n[l] = c = new xs(d, t, l, h), s.push(c)) : t[l] = h;
            }
            return s;
        }
        update(t, e) {
            if (0 === this._properties.size) return void Object.assign(t, e);
            const i = this._createAnimations(t, e);
            return i.length ? (mt.add(this._chart, i), !0) : void 0;
        }
    }
    function vs(t, e) {
        const i = t && t.options || {}, s = i.reverse, n = void 0 === i.min ? e : 0, o = void 0 === i.max ? e : 0;
        return {
            start: s ? o : n,
            end: s ? n : o
        };
    }
    function ws(t, e) {
        const i = [], s = t._getSortedDatasetMetas(e);
        let n, o;
        for(n = 0, o = s.length; n < o; ++n)i.push(s[n].index);
        return i;
    }
    function Ms(t, e, i, s = {}) {
        const n = t.keys, a = "single" === s.mode;
        let r, l, h, c;
        if (null !== e) {
            for(r = 0, l = n.length; r < l; ++r){
                if (h = +n[r], h === i) {
                    if (s.all) continue;
                    break;
                }
                c = t.values[h], o(c) && (a || 0 === e || z(e) === z(c)) && (e += c);
            }
            return e;
        }
    }
    function ks(t, e) {
        const i = t && t.options.stacked;
        return i || void 0 === i && void 0 !== e.stack;
    }
    function Ss(t, e, i) {
        const s = t[e] || (t[e] = {});
        return s[i] || (s[i] = {});
    }
    function Ps(t, e, i, s) {
        for (const n of e.getMatchingVisibleMetas(s).reverse()){
            const e = t[n.index];
            if (i && e > 0 || !i && e < 0) return n.index;
        }
        return null;
    }
    function Ds(t, e) {
        const { chart: i, _cachedMeta: s } = t, n = i._stacks || (i._stacks = {}), { iScale: o, vScale: a, index: r } = s, l = o.axis, h = a.axis, c = function(t, e, i) {
            return `${t.id}.${e.id}.${i.stack || i.type}`;
        }(o, a, s), d = e.length;
        let u;
        for(let t = 0; t < d; ++t){
            const i = e[t], { [l]: o, [h]: d } = i;
            u = (i._stacks || (i._stacks = {}))[h] = Ss(n, c, o), u[r] = d, u._top = Ps(u, a, !0, s.type), u._bottom = Ps(u, a, !1, s.type);
        }
    }
    function Os(t, e) {
        const i = t.scales;
        return Object.keys(i).filter((t)=>i[t].axis === e).shift();
    }
    function Cs(t, e) {
        const i = t.controller.index, s = t.vScale && t.vScale.axis;
        if (s) {
            e = e || t._parsed;
            for (const t of e){
                const e = t._stacks;
                if (!e || void 0 === e[s] || void 0 === e[s][i]) return;
                delete e[s][i];
            }
        }
    }
    const As = (t)=>"reset" === t || "none" === t, Ts = (t, e)=>e ? t : Object.assign({}, t);
    class Ls {
        constructor(t, e){
            this.chart = t, this._ctx = t.ctx, this.index = e, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.initialize();
        }
        initialize() {
            const t = this._cachedMeta;
            this.configure(), this.linkScales(), t._stacked = ks(t.vScale, t), this.addElements();
        }
        updateIndex(t) {
            this.index !== t && Cs(this._cachedMeta), this.index = t;
        }
        linkScales() {
            const t = this.chart, e = this._cachedMeta, i = this.getDataset(), s = (t, e, i, s)=>"x" === t ? e : "r" === t ? s : i, n = e.xAxisID = r(i.xAxisID, Os(t, "x")), o = e.yAxisID = r(i.yAxisID, Os(t, "y")), a = e.rAxisID = r(i.rAxisID, Os(t, "r")), l = e.indexAxis, h = e.iAxisID = s(l, n, o, a), c = e.vAxisID = s(l, o, n, a);
            e.xScale = this.getScaleForId(n), e.yScale = this.getScaleForId(o), e.rScale = this.getScaleForId(a), e.iScale = this.getScaleForId(h), e.vScale = this.getScaleForId(c);
        }
        getDataset() {
            return this.chart.data.datasets[this.index];
        }
        getMeta() {
            return this.chart.getDatasetMeta(this.index);
        }
        getScaleForId(t) {
            return this.chart.scales[t];
        }
        _getOtherScale(t) {
            const e = this._cachedMeta;
            return t === e.iScale ? e.vScale : e.iScale;
        }
        reset() {
            this._update("reset");
        }
        _destroy() {
            const t = this._cachedMeta;
            this._data && at(this._data, this), t._stacked && Cs(t);
        }
        _dataCheck() {
            const t = this.getDataset(), e = t.data || (t.data = []), i = this._data;
            if (n(e)) this._data = function(t) {
                const e = Object.keys(t), i = new Array(e.length);
                let s, n, o;
                for(s = 0, n = e.length; s < n; ++s)o = e[s], i[s] = {
                    x: o,
                    y: t[o]
                };
                return i;
            }(e);
            else if (i !== e) {
                if (i) {
                    at(i, this);
                    const t = this._cachedMeta;
                    Cs(t), t._parsed = [];
                }
                e && Object.isExtensible(e) && ot(e, this), this._syncList = [], this._data = e;
            }
        }
        addElements() {
            const t = this._cachedMeta;
            this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType);
        }
        buildOrUpdateElements(t) {
            const e = this._cachedMeta, i = this.getDataset();
            let s = !1;
            this._dataCheck();
            const n = e._stacked;
            e._stacked = ks(e.vScale, e), e.stack !== i.stack && (s = !0, Cs(e), e.stack = i.stack), this._resyncElements(t), (s || n !== e._stacked) && Ds(this, e._parsed);
        }
        configure() {
            const t = this.chart.config, e = t.datasetScopeKeys(this._type), i = t.getOptionScopes(this.getDataset(), e, !0);
            this.options = t.createResolver(i, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
        }
        parse(t, e) {
            const { _cachedMeta: i, _data: o } = this, { iScale: a, _stacked: r } = i, l = a.axis;
            let h, c, d, u = 0 === t && e === o.length || i._sorted, f = t > 0 && i._parsed[t - 1];
            if (!1 === this._parsing) i._parsed = o, i._sorted = !0, d = o;
            else {
                d = s(o[t]) ? this.parseArrayData(i, o, t, e) : n(o[t]) ? this.parseObjectData(i, o, t, e) : this.parsePrimitiveData(i, o, t, e);
                const a = ()=>null === c[l] || f && c[l] < f[l];
                for(h = 0; h < e; ++h)i._parsed[h + t] = c = d[h], u && (a() && (u = !1), f = c);
                i._sorted = u;
            }
            r && Ds(this, d);
        }
        parsePrimitiveData(t, e, i, s) {
            const { iScale: n, vScale: o } = t, a = n.axis, r = o.axis, l = n.getLabels(), h = n === o, c = new Array(s);
            let d, u, f;
            for(d = 0, u = s; d < u; ++d)f = d + i, c[d] = {
                [a]: h || n.parse(l[f], f),
                [r]: o.parse(e[f], f)
            };
            return c;
        }
        parseArrayData(t, e, i, s) {
            const { xScale: n, yScale: o } = t, a = new Array(s);
            let r, l, h, c;
            for(r = 0, l = s; r < l; ++r)h = r + i, c = e[h], a[r] = {
                x: n.parse(c[0], h),
                y: o.parse(c[1], h)
            };
            return a;
        }
        parseObjectData(t, e, i, s) {
            const { xScale: n, yScale: o } = t, { xAxisKey: a = "x", yAxisKey: r = "y" } = this._parsing, l = new Array(s);
            let h, c, d, u;
            for(h = 0, c = s; h < c; ++h)d = h + i, u = e[d], l[h] = {
                x: n.parse(y(u, a), d),
                y: o.parse(y(u, r), d)
            };
            return l;
        }
        getParsed(t) {
            return this._cachedMeta._parsed[t];
        }
        getDataElement(t) {
            return this._cachedMeta.data[t];
        }
        applyStack(t, e, i) {
            const s = this.chart, n = this._cachedMeta, o = e[t.axis];
            return Ms({
                keys: ws(s, !0),
                values: e._stacks[t.axis]
            }, o, n.index, {
                mode: i
            });
        }
        updateRangeFromParsed(t, e, i, s) {
            const n = i[e.axis];
            let o = null === n ? NaN : n;
            const a = s && i._stacks[e.axis];
            s && a && (s.values = a, o = Ms(s, n, this._cachedMeta.index)), t.min = Math.min(t.min, o), t.max = Math.max(t.max, o);
        }
        getMinMax(t, e) {
            const i = this._cachedMeta, s = i._parsed, n = i._sorted && t === i.iScale, a = s.length, r = this._getOtherScale(t), l = ((t, e, i)=>t && !e.hidden && e._stacked && {
                    keys: ws(i, !0),
                    values: null
                })(e, i, this.chart), h = {
                min: Number.POSITIVE_INFINITY,
                max: Number.NEGATIVE_INFINITY
            }, { min: c, max: d } = function(t) {
                const { min: e, max: i, minDefined: s, maxDefined: n } = t.getUserBounds();
                return {
                    min: s ? e : Number.NEGATIVE_INFINITY,
                    max: n ? i : Number.POSITIVE_INFINITY
                };
            }(r);
            let u, f;
            function g() {
                f = s[u];
                const e = f[r.axis];
                return !o(f[t.axis]) || c > e || d < e;
            }
            for(u = 0; u < a && (g() || (this.updateRangeFromParsed(h, t, f, l), !n)); ++u);
            if (n) {
                for(u = a - 1; u >= 0; --u)if (!g()) {
                    this.updateRangeFromParsed(h, t, f, l);
                    break;
                }
            }
            return h;
        }
        getAllParsedValues(t) {
            const e = this._cachedMeta._parsed, i = [];
            let s, n, a;
            for(s = 0, n = e.length; s < n; ++s)a = e[s][t.axis], o(a) && i.push(a);
            return i;
        }
        getMaxOverflow() {
            return !1;
        }
        getLabelAndValue(t) {
            const e = this._cachedMeta, i = e.iScale, s = e.vScale, n = this.getParsed(t);
            return {
                label: i ? "" + i.getLabelForValue(n[i.axis]) : "",
                value: s ? "" + s.getLabelForValue(n[s.axis]) : ""
            };
        }
        _update(t) {
            const e = this._cachedMeta;
            this.update(t || "default"), e._clip = function(t) {
                let e, i, s, o;
                return n(t) ? (e = t.top, i = t.right, s = t.bottom, o = t.left) : e = i = s = o = t, {
                    top: e,
                    right: i,
                    bottom: s,
                    left: o,
                    disabled: !1 === t
                };
            }(r(this.options.clip, function(t, e, i) {
                if (!1 === i) return !1;
                const s = vs(t, i), n = vs(e, i);
                return {
                    top: n.end,
                    right: s.end,
                    bottom: n.start,
                    left: s.start
                };
            }(e.xScale, e.yScale, this.getMaxOverflow())));
        }
        update(t) {}
        draw() {
            const t = this._ctx, e = this.chart, i = this._cachedMeta, s = i.data || [], n = e.chartArea, o = [], a = this._drawStart || 0, r = this._drawCount || s.length - a, l = this.options.drawActiveElementsOnTop;
            let h;
            for(i.dataset && i.dataset.draw(t, n, a, r), h = a; h < a + r; ++h){
                const e = s[h];
                e.hidden || (e.active && l ? o.push(e) : e.draw(t, n));
            }
            for(h = 0; h < o.length; ++h)o[h].draw(t, n);
        }
        getStyle(t, e) {
            const i = e ? "active" : "default";
            return void 0 === t && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(i) : this.resolveDataElementOptions(t || 0, i);
        }
        getContext(t, e, i) {
            const s = this.getDataset();
            let n;
            if (t >= 0 && t < this._cachedMeta.data.length) {
                const e = this._cachedMeta.data[t];
                n = e.$context || (e.$context = function(t, e, i) {
                    return _i(t, {
                        active: !1,
                        dataIndex: e,
                        parsed: void 0,
                        raw: void 0,
                        element: i,
                        index: e,
                        mode: "default",
                        type: "data"
                    });
                }(this.getContext(), t, e)), n.parsed = this.getParsed(t), n.raw = s.data[t], n.index = n.dataIndex = t;
            } else n = this.$context || (this.$context = function(t, e) {
                return _i(t, {
                    active: !1,
                    dataset: void 0,
                    datasetIndex: e,
                    index: e,
                    mode: "default",
                    type: "dataset"
                });
            }(this.chart.getContext(), this.index)), n.dataset = s, n.index = n.datasetIndex = this.index;
            return n.active = !!e, n.mode = i, n;
        }
        resolveDatasetElementOptions(t) {
            return this._resolveElementOptions(this.datasetElementType.id, t);
        }
        resolveDataElementOptions(t, e) {
            return this._resolveElementOptions(this.dataElementType.id, e, t);
        }
        _resolveElementOptions(t, e = "default", i) {
            const s = "active" === e, n = this._cachedDataOpts, o = t + "-" + e, a = n[o], r = this.enableOptionSharing && M(i);
            if (a) return Ts(a, r);
            const l = this.chart.config, h = l.datasetElementScopeKeys(this._type, t), c = s ? [
                `${t}Hover`,
                "hover",
                t,
                ""
            ] : [
                t,
                ""
            ], d = l.getOptionScopes(this.getDataset(), h), u = Object.keys(ne.elements[t]), f = l.resolveNamedOptions(d, u, ()=>this.getContext(i, s), c);
            return f.$shared && (f.$shared = r, n[o] = Object.freeze(Ts(f, r))), f;
        }
        _resolveAnimations(t, e, i) {
            const s = this.chart, n = this._cachedDataOpts, o = `animation-${e}`, a = n[o];
            if (a) return a;
            let r;
            if (!1 !== s.options.animation) {
                const s = this.chart.config, n = s.datasetAnimationScopeKeys(this._type, e), o = s.getOptionScopes(this.getDataset(), n);
                r = s.createResolver(o, this.getContext(t, i, e));
            }
            const l = new ys(s, r && r.animations);
            return r && r._cacheable && (n[o] = Object.freeze(l)), l;
        }
        getSharedOptions(t) {
            if (t.$shared) return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
        }
        includeOptions(t, e) {
            return !e || As(t) || this.chart._animationsDisabled;
        }
        _getSharedOptions(t, e) {
            const i = this.resolveDataElementOptions(t, e), s = this._sharedOptions, n = this.getSharedOptions(i), o = this.includeOptions(e, n) || n !== s;
            return this.updateSharedOptions(n, e, i), {
                sharedOptions: n,
                includeOptions: o
            };
        }
        updateElement(t, e, i, s) {
            As(s) ? Object.assign(t, i) : this._resolveAnimations(e, s).update(t, i);
        }
        updateSharedOptions(t, e, i) {
            t && !As(e) && this._resolveAnimations(void 0, e).update(t, i);
        }
        _setStyle(t, e, i, s) {
            t.active = s;
            const n = this.getStyle(e, s);
            this._resolveAnimations(e, i, s).update(t, {
                options: !s && this.getSharedOptions(n) || n
            });
        }
        removeHoverStyle(t, e, i) {
            this._setStyle(t, i, "active", !1);
        }
        setHoverStyle(t, e, i) {
            this._setStyle(t, i, "active", !0);
        }
        _removeDatasetHoverStyle() {
            const t = this._cachedMeta.dataset;
            t && this._setStyle(t, void 0, "active", !1);
        }
        _setDatasetHoverStyle() {
            const t = this._cachedMeta.dataset;
            t && this._setStyle(t, void 0, "active", !0);
        }
        _resyncElements(t) {
            const e = this._data, i = this._cachedMeta.data;
            for (const [t, e, i] of this._syncList)this[t](e, i);
            this._syncList = [];
            const s = i.length, n = e.length, o = Math.min(n, s);
            o && this.parse(0, o), n > s ? this._insertElements(s, n - s, t) : n < s && this._removeElements(n, s - n);
        }
        _insertElements(t, e, i = !0) {
            const s = this._cachedMeta, n = s.data, o = t + e;
            let a;
            const r = (t)=>{
                for(t.length += e, a = t.length - 1; a >= o; a--)t[a] = t[a - e];
            };
            for(r(n), a = t; a < o; ++a)n[a] = new this.dataElementType;
            this._parsing && r(s._parsed), this.parse(t, e), i && this.updateElements(n, t, e, "reset");
        }
        updateElements(t, e, i, s) {}
        _removeElements(t, e) {
            const i = this._cachedMeta;
            if (this._parsing) {
                const s = i._parsed.splice(t, e);
                i._stacked && Cs(i, s);
            }
            i.data.splice(t, e);
        }
        _sync(t) {
            if (this._parsing) this._syncList.push(t);
            else {
                const [e, i, s] = t;
                this[e](i, s);
            }
            this.chart._dataChanges.push([
                this.index,
                ...t
            ]);
        }
        _onDataPush() {
            const t = arguments.length;
            this._sync([
                "_insertElements",
                this.getDataset().data.length - t,
                t
            ]);
        }
        _onDataPop() {
            this._sync([
                "_removeElements",
                this._cachedMeta.data.length - 1,
                1
            ]);
        }
        _onDataShift() {
            this._sync([
                "_removeElements",
                0,
                1
            ]);
        }
        _onDataSplice(t, e) {
            e && this._sync([
                "_removeElements",
                t,
                e
            ]);
            const i = arguments.length - 2;
            i && this._sync([
                "_insertElements",
                t,
                i
            ]);
        }
        _onDataUnshift() {
            this._sync([
                "_insertElements",
                0,
                arguments.length
            ]);
        }
    }
    Ls.defaults = {}, Ls.prototype.datasetElementType = null, Ls.prototype.dataElementType = null;
    class Es {
        constructor(){
            this.x = void 0, this.y = void 0, this.active = !1, this.options = void 0, this.$animations = void 0;
        }
        tooltipPosition(t) {
            const { x: e, y: i } = this.getProps([
                "x",
                "y"
            ], t);
            return {
                x: e,
                y: i
            };
        }
        hasValue() {
            return B(this.x) && B(this.y);
        }
        getProps(t, e) {
            const i = this.$animations;
            if (!e || !i) return this;
            const s = {};
            return t.forEach((t)=>{
                s[t] = i[t] && i[t].active() ? i[t]._to : this[t];
            }), s;
        }
    }
    Es.defaults = {}, Es.defaultRoutes = void 0;
    const Rs = {
        values: (t)=>s(t) ? t : "" + t,
        numeric (t, e, i) {
            if (0 === t) return "0";
            const s = this.chart.options.locale;
            let n, o = t;
            if (i.length > 1) {
                const e = Math.max(Math.abs(i[0].value), Math.abs(i[i.length - 1].value));
                (e < 1e-4 || e > 1e15) && (n = "scientific"), o = function(t, e) {
                    let i = e.length > 3 ? e[2].value - e[1].value : e[1].value - e[0].value;
                    Math.abs(i) >= 1 && t !== Math.floor(t) && (i = t - Math.floor(t));
                    return i;
                }(t, i);
            }
            const a = I(Math.abs(o)), r = Math.max(Math.min(-1 * Math.floor(a), 20), 0), l = {
                notation: n,
                minimumFractionDigits: r,
                maximumFractionDigits: r
            };
            return Object.assign(l, this.options.ticks.format), li(t, s, l);
        },
        logarithmic (t, e, i) {
            if (0 === t) return "0";
            const s = t / Math.pow(10, Math.floor(I(t)));
            return 1 === s || 2 === s || 5 === s ? Rs.numeric.call(this, t, e, i) : "";
        }
    };
    var Is = {
        formatters: Rs
    };
    function zs(t, e) {
        const s = t.options.ticks, n = s.maxTicksLimit || function(t) {
            const e = t.options.offset, i = t._tickSize(), s = t._length / i + (e ? 0 : 1), n = t._maxLength / i;
            return Math.floor(Math.min(s, n));
        }(t), o = s.major.enabled ? function(t) {
            const e = [];
            let i, s;
            for(i = 0, s = t.length; i < s; i++)t[i].major && e.push(i);
            return e;
        }(e) : [], a = o.length, r = o[0], l = o[a - 1], h = [];
        if (a > n) return function(t, e, i, s) {
            let n, o = 0, a = i[0];
            for(s = Math.ceil(s), n = 0; n < t.length; n++)n === a && (e.push(t[n]), o++, a = i[o * s]);
        }(e, h, o, a / n), h;
        const c = function(t, e, i) {
            const s = function(t) {
                const e = t.length;
                let i, s;
                if (e < 2) return !1;
                for(s = t[0], i = 1; i < e; ++i)if (t[i] - t[i - 1] !== s) return !1;
                return s;
            }(t), n = e.length / i;
            if (!s) return Math.max(n, 1);
            const o = V(s);
            for(let t = 0, e = o.length - 1; t < e; t++){
                const e = o[t];
                if (e > n) return e;
            }
            return Math.max(n, 1);
        }(o, e, n);
        if (a > 0) {
            let t, s;
            const n = a > 1 ? Math.round((l - r) / (a - 1)) : null;
            for(Fs(e, h, c, i(n) ? 0 : r - n, r), t = 0, s = a - 1; t < s; t++)Fs(e, h, c, o[t], o[t + 1]);
            return Fs(e, h, c, l, i(n) ? e.length : l + n), h;
        }
        return Fs(e, h, c), h;
    }
    function Fs(t, e, i, s, n) {
        const o = r(s, 0), a = Math.min(r(n, t.length), t.length);
        let l, h, c, d = 0;
        for(i = Math.ceil(i), n && (l = n - s, i = l / Math.floor(l / i)), c = o; c < 0;)d++, c = Math.round(o + d * i);
        for(h = Math.max(o, 0); h < a; h++)h === c && (e.push(t[h]), d++, c = Math.round(o + d * i));
    }
    ne.set("scale", {
        display: !0,
        offset: !1,
        reverse: !1,
        beginAtZero: !1,
        bounds: "ticks",
        grace: 0,
        grid: {
            display: !0,
            lineWidth: 1,
            drawBorder: !0,
            drawOnChartArea: !0,
            drawTicks: !0,
            tickLength: 8,
            tickWidth: (t, e)=>e.lineWidth,
            tickColor: (t, e)=>e.color,
            offset: !1,
            borderDash: [],
            borderDashOffset: 0,
            borderWidth: 1
        },
        title: {
            display: !1,
            text: "",
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: !1,
            textStrokeWidth: 0,
            textStrokeColor: "",
            padding: 3,
            display: !0,
            autoSkip: !0,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: Is.formatters.values,
            minor: {},
            major: {},
            align: "center",
            crossAlign: "near",
            showLabelBackdrop: !1,
            backdropColor: "rgba(255, 255, 255, 0.75)",
            backdropPadding: 2
        }
    }), ne.route("scale.ticks", "color", "", "color"), ne.route("scale.grid", "color", "", "borderColor"), ne.route("scale.grid", "borderColor", "", "borderColor"), ne.route("scale.title", "color", "", "color"), ne.describe("scale", {
        _fallback: !1,
        _scriptable: (t)=>!t.startsWith("before") && !t.startsWith("after") && "callback" !== t && "parser" !== t,
        _indexable: (t)=>"borderDash" !== t && "tickBorderDash" !== t
    }), ne.describe("scales", {
        _fallback: "scale"
    }), ne.describe("scale.ticks", {
        _scriptable: (t)=>"backdropPadding" !== t && "callback" !== t,
        _indexable: (t)=>"backdropPadding" !== t
    });
    const Vs = (t, e, i)=>"top" === e || "left" === e ? t[e] + i : t[e] - i;
    function Bs(t, e) {
        const i = [], s = t.length / e, n = t.length;
        let o = 0;
        for(; o < n; o += s)i.push(t[Math.floor(o)]);
        return i;
    }
    function Ns(t, e, i) {
        const s = t.ticks.length, n = Math.min(e, s - 1), o = t._startPixel, a = t._endPixel, r = 1e-6;
        let l, h = t.getPixelForTick(n);
        if (!(i && (l = 1 === s ? Math.max(h - o, a - h) : 0 === e ? (t.getPixelForTick(1) - h) / 2 : (h - t.getPixelForTick(n - 1)) / 2, h += n < e ? l : -l, h < o - r || h > a + r))) return h;
    }
    function Ws(t) {
        return t.drawTicks ? t.tickLength : 0;
    }
    function js(t, e) {
        if (!t.display) return 0;
        const i = mi(t.font, e), n = pi(t.padding);
        return (s(t.text) ? t.text.length : 1) * i.lineHeight + n.height;
    }
    function Hs(t, e, i) {
        let s = dt(t);
        return (i && "right" !== e || !i && "right" === e) && (s = ((t)=>"left" === t ? "right" : "right" === t ? "left" : t)(s)), s;
    }
    class $s extends Es {
        constructor(t){
            super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
        }
        init(t) {
            this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
        }
        parse(t, e) {
            return t;
        }
        getUserBounds() {
            let { _userMin: t, _userMax: e, _suggestedMin: i, _suggestedMax: s } = this;
            return t = a(t, Number.POSITIVE_INFINITY), e = a(e, Number.NEGATIVE_INFINITY), i = a(i, Number.POSITIVE_INFINITY), s = a(s, Number.NEGATIVE_INFINITY), {
                min: a(t, i),
                max: a(e, s),
                minDefined: o(t),
                maxDefined: o(e)
            };
        }
        getMinMax(t) {
            let e, { min: i, max: s, minDefined: n, maxDefined: o } = this.getUserBounds();
            if (n && o) return {
                min: i,
                max: s
            };
            const r = this.getMatchingVisibleMetas();
            for(let a = 0, l = r.length; a < l; ++a)e = r[a].controller.getMinMax(this, t), n || (i = Math.min(i, e.min)), o || (s = Math.max(s, e.max));
            return i = o && i > s ? s : i, s = n && i > s ? i : s, {
                min: a(i, a(s, i)),
                max: a(s, a(i, s))
            };
        }
        getPadding() {
            return {
                left: this.paddingLeft || 0,
                top: this.paddingTop || 0,
                right: this.paddingRight || 0,
                bottom: this.paddingBottom || 0
            };
        }
        getTicks() {
            return this.ticks;
        }
        getLabels() {
            const t = this.chart.data;
            return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
        }
        beforeLayout() {
            this._cache = {}, this._dataLimitsCached = !1;
        }
        beforeUpdate() {
            c(this.options.beforeUpdate, [
                this
            ]);
        }
        update(t, e, i) {
            const { beginAtZero: s, grace: n, ticks: o } = this.options, a = o.sampleSize;
            this.beforeUpdate(), this.maxWidth = t, this.maxHeight = e, this._margins = i = Object.assign({
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }, i), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + i.left + i.right : this.height + i.top + i.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = xi(this, n, s), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
            const r = a < this.ticks.length;
            this._convertTicksToLabels(r ? Bs(this.ticks, a) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), o.display && (o.autoSkip || "auto" === o.source) && (this.ticks = zs(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), r && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
        }
        configure() {
            let t, e, i = this.options.reverse;
            this.isHorizontal() ? (t = this.left, e = this.right) : (t = this.top, e = this.bottom, i = !i), this._startPixel = t, this._endPixel = e, this._reversePixels = i, this._length = e - t, this._alignToPixels = this.options.alignToPixels;
        }
        afterUpdate() {
            c(this.options.afterUpdate, [
                this
            ]);
        }
        beforeSetDimensions() {
            c(this.options.beforeSetDimensions, [
                this
            ]);
        }
        setDimensions() {
            this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
        }
        afterSetDimensions() {
            c(this.options.afterSetDimensions, [
                this
            ]);
        }
        _callHooks(t) {
            this.chart.notifyPlugins(t, this.getContext()), c(this.options[t], [
                this
            ]);
        }
        beforeDataLimits() {
            this._callHooks("beforeDataLimits");
        }
        determineDataLimits() {}
        afterDataLimits() {
            this._callHooks("afterDataLimits");
        }
        beforeBuildTicks() {
            this._callHooks("beforeBuildTicks");
        }
        buildTicks() {
            return [];
        }
        afterBuildTicks() {
            this._callHooks("afterBuildTicks");
        }
        beforeTickToLabelConversion() {
            c(this.options.beforeTickToLabelConversion, [
                this
            ]);
        }
        generateTickLabels(t) {
            const e = this.options.ticks;
            let i, s, n;
            for(i = 0, s = t.length; i < s; i++)n = t[i], n.label = c(e.callback, [
                n.value,
                i,
                t
            ], this);
        }
        afterTickToLabelConversion() {
            c(this.options.afterTickToLabelConversion, [
                this
            ]);
        }
        beforeCalculateLabelRotation() {
            c(this.options.beforeCalculateLabelRotation, [
                this
            ]);
        }
        calculateLabelRotation() {
            const t = this.options, e = t.ticks, i = this.ticks.length, s = e.minRotation || 0, n = e.maxRotation;
            let o, a, r, l = s;
            if (!this._isVisible() || !e.display || s >= n || i <= 1 || !this.isHorizontal()) return void (this.labelRotation = s);
            const h = this._getLabelSizes(), c = h.widest.width, d = h.highest.height, u = Z(this.chart.width - c, 0, this.maxWidth);
            o = t.offset ? this.maxWidth / i : u / (i - 1), c + 6 > o && (o = u / (i - (t.offset ? .5 : 1)), a = this.maxHeight - Ws(t.grid) - e.padding - js(t.title, this.chart.options.font), r = Math.sqrt(c * c + d * d), l = $(Math.min(Math.asin(Z((h.highest.height + 6) / o, -1, 1)), Math.asin(Z(a / r, -1, 1)) - Math.asin(Z(d / r, -1, 1)))), l = Math.max(s, Math.min(n, l))), this.labelRotation = l;
        }
        afterCalculateLabelRotation() {
            c(this.options.afterCalculateLabelRotation, [
                this
            ]);
        }
        afterAutoSkip() {}
        beforeFit() {
            c(this.options.beforeFit, [
                this
            ]);
        }
        fit() {
            const t = {
                width: 0,
                height: 0
            }, { chart: e, options: { ticks: i, title: s, grid: n } } = this, o = this._isVisible(), a = this.isHorizontal();
            if (o) {
                const o = js(s, e.options.font);
                if (a ? (t.width = this.maxWidth, t.height = Ws(n) + o) : (t.height = this.maxHeight, t.width = Ws(n) + o), i.display && this.ticks.length) {
                    const { first: e, last: s, widest: n, highest: o } = this._getLabelSizes(), r = 2 * i.padding, l = H(this.labelRotation), h = Math.cos(l), c = Math.sin(l);
                    if (a) {
                        const e = i.mirror ? 0 : c * n.width + h * o.height;
                        t.height = Math.min(this.maxHeight, t.height + e + r);
                    } else {
                        const e = i.mirror ? 0 : h * n.width + c * o.height;
                        t.width = Math.min(this.maxWidth, t.width + e + r);
                    }
                    this._calculatePadding(e, s, c, h);
                }
            }
            this._handleMargins(), a ? (this.width = this._length = e.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = e.height - this._margins.top - this._margins.bottom);
        }
        _calculatePadding(t, e, i, s) {
            const { ticks: { align: n, padding: o }, position: a } = this.options, r = 0 !== this.labelRotation, l = "top" !== a && "x" === this.axis;
            if (this.isHorizontal()) {
                const a = this.getPixelForTick(0) - this.left, h = this.right - this.getPixelForTick(this.ticks.length - 1);
                let c = 0, d = 0;
                r ? l ? (c = s * t.width, d = i * e.height) : (c = i * t.height, d = s * e.width) : "start" === n ? d = e.width : "end" === n ? c = t.width : "inner" !== n && (c = t.width / 2, d = e.width / 2), this.paddingLeft = Math.max((c - a + o) * this.width / (this.width - a), 0), this.paddingRight = Math.max((d - h + o) * this.width / (this.width - h), 0);
            } else {
                let i = e.height / 2, s = t.height / 2;
                "start" === n ? (i = 0, s = t.height) : "end" === n && (i = e.height, s = 0), this.paddingTop = i + o, this.paddingBottom = s + o;
            }
        }
        _handleMargins() {
            this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
        }
        afterFit() {
            c(this.options.afterFit, [
                this
            ]);
        }
        isHorizontal() {
            const { axis: t, position: e } = this.options;
            return "top" === e || "bottom" === e || "x" === t;
        }
        isFullSize() {
            return this.options.fullSize;
        }
        _convertTicksToLabels(t) {
            let e, s;
            for(this.beforeTickToLabelConversion(), this.generateTickLabels(t), e = 0, s = t.length; e < s; e++)i(t[e].label) && (t.splice(e, 1), s--, e--);
            this.afterTickToLabelConversion();
        }
        _getLabelSizes() {
            let t = this._labelSizes;
            if (!t) {
                const e = this.options.ticks.sampleSize;
                let i = this.ticks;
                e < i.length && (i = Bs(i, e)), this._labelSizes = t = this._computeLabelSizes(i, i.length);
            }
            return t;
        }
        _computeLabelSizes(t, e) {
            const { ctx: n, _longestTextCache: o } = this, a = [], r = [];
            let l, h, c, u, f, g, p, m, b, x, _, y = 0, v = 0;
            for(l = 0; l < e; ++l){
                if (u = t[l].label, f = this._resolveTickFontOptions(l), n.font = g = f.string, p = o[g] = o[g] || {
                    data: {},
                    gc: []
                }, m = f.lineHeight, b = x = 0, i(u) || s(u)) {
                    if (s(u)) for(h = 0, c = u.length; h < c; ++h)_ = u[h], i(_) || s(_) || (b = _e(n, p.data, p.gc, b, _), x += m);
                } else b = _e(n, p.data, p.gc, b, u), x = m;
                a.push(b), r.push(x), y = Math.max(b, y), v = Math.max(x, v);
            }
            !function(t, e) {
                d(t, (t)=>{
                    const i = t.gc, s = i.length / 2;
                    let n;
                    if (s > e) {
                        for(n = 0; n < s; ++n)delete t.data[i[n]];
                        i.splice(0, s);
                    }
                });
            }(o, e);
            const w = a.indexOf(y), M = r.indexOf(v), k = (t)=>({
                    width: a[t] || 0,
                    height: r[t] || 0
                });
            return {
                first: k(0),
                last: k(e - 1),
                widest: k(w),
                highest: k(M),
                widths: a,
                heights: r
            };
        }
        getLabelForValue(t) {
            return t;
        }
        getPixelForValue(t, e) {
            return NaN;
        }
        getValueForPixel(t) {}
        getPixelForTick(t) {
            const e = this.ticks;
            return t < 0 || t > e.length - 1 ? null : this.getPixelForValue(e[t].value);
        }
        getPixelForDecimal(t) {
            this._reversePixels && (t = 1 - t);
            const e = this._startPixel + t * this._length;
            return J(this._alignToPixels ? ve(this.chart, e, 0) : e);
        }
        getDecimalForPixel(t) {
            const e = (t - this._startPixel) / this._length;
            return this._reversePixels ? 1 - e : e;
        }
        getBasePixel() {
            return this.getPixelForValue(this.getBaseValue());
        }
        getBaseValue() {
            const { min: t, max: e } = this;
            return t < 0 && e < 0 ? e : t > 0 && e > 0 ? t : 0;
        }
        getContext(t) {
            const e = this.ticks || [];
            if (t >= 0 && t < e.length) {
                const i = e[t];
                return i.$context || (i.$context = function(t, e, i) {
                    return _i(t, {
                        tick: i,
                        index: e,
                        type: "tick"
                    });
                }(this.getContext(), t, i));
            }
            return this.$context || (this.$context = _i(this.chart.getContext(), {
                scale: this,
                type: "scale"
            }));
        }
        _tickSize() {
            const t = this.options.ticks, e = H(this.labelRotation), i = Math.abs(Math.cos(e)), s = Math.abs(Math.sin(e)), n = this._getLabelSizes(), o = t.autoSkipPadding || 0, a = n ? n.widest.width + o : 0, r = n ? n.highest.height + o : 0;
            return this.isHorizontal() ? r * i > a * s ? a / i : r / s : r * s < a * i ? r / i : a / s;
        }
        _isVisible() {
            const t = this.options.display;
            return "auto" !== t ? !!t : this.getMatchingVisibleMetas().length > 0;
        }
        _computeGridLineItems(t) {
            const e = this.axis, i = this.chart, s = this.options, { grid: o, position: a } = s, l = o.offset, h = this.isHorizontal(), c = this.ticks.length + (l ? 1 : 0), d = Ws(o), u = [], f = o.setContext(this.getContext()), g = f.drawBorder ? f.borderWidth : 0, p = g / 2, m = function(t) {
                return ve(i, t, g);
            };
            let b, x, _, y, v, w, M, k, S, P, D, O;
            if ("top" === a) b = m(this.bottom), w = this.bottom - d, k = b - p, P = m(t.top) + p, O = t.bottom;
            else if ("bottom" === a) b = m(this.top), P = t.top, O = m(t.bottom) - p, w = b + p, k = this.top + d;
            else if ("left" === a) b = m(this.right), v = this.right - d, M = b - p, S = m(t.left) + p, D = t.right;
            else if ("right" === a) b = m(this.left), S = t.left, D = m(t.right) - p, v = b + p, M = this.left + d;
            else if ("x" === e) {
                if ("center" === a) b = m((t.top + t.bottom) / 2 + .5);
                else if (n(a)) {
                    const t = Object.keys(a)[0], e = a[t];
                    b = m(this.chart.scales[t].getPixelForValue(e));
                }
                P = t.top, O = t.bottom, w = b + p, k = w + d;
            } else if ("y" === e) {
                if ("center" === a) b = m((t.left + t.right) / 2);
                else if (n(a)) {
                    const t = Object.keys(a)[0], e = a[t];
                    b = m(this.chart.scales[t].getPixelForValue(e));
                }
                v = b - p, M = v - d, S = t.left, D = t.right;
            }
            const C = r(s.ticks.maxTicksLimit, c), A = Math.max(1, Math.ceil(c / C));
            for(x = 0; x < c; x += A){
                const t = o.setContext(this.getContext(x)), e = t.lineWidth, s = t.color, n = t.borderDash || [], a = t.borderDashOffset, r = t.tickWidth, c = t.tickColor, d = t.tickBorderDash || [], f = t.tickBorderDashOffset;
                _ = Ns(this, x, l), void 0 !== _ && (y = ve(i, _, e), h ? v = M = S = D = y : w = k = P = O = y, u.push({
                    tx1: v,
                    ty1: w,
                    tx2: M,
                    ty2: k,
                    x1: S,
                    y1: P,
                    x2: D,
                    y2: O,
                    width: e,
                    color: s,
                    borderDash: n,
                    borderDashOffset: a,
                    tickWidth: r,
                    tickColor: c,
                    tickBorderDash: d,
                    tickBorderDashOffset: f
                }));
            }
            return this._ticksLength = c, this._borderValue = b, u;
        }
        _computeLabelItems(t) {
            const e = this.axis, i = this.options, { position: o, ticks: a } = i, r = this.isHorizontal(), l = this.ticks, { align: h, crossAlign: c, padding: d, mirror: u } = a, f = Ws(i.grid), g = f + d, p = u ? -d : g, m = -H(this.labelRotation), b = [];
            let x, _, y, v, w, M, k, S, P, D, O, C, A = "middle";
            if ("top" === o) M = this.bottom - p, k = this._getXAxisLabelAlignment();
            else if ("bottom" === o) M = this.top + p, k = this._getXAxisLabelAlignment();
            else if ("left" === o) {
                const t = this._getYAxisLabelAlignment(f);
                k = t.textAlign, w = t.x;
            } else if ("right" === o) {
                const t = this._getYAxisLabelAlignment(f);
                k = t.textAlign, w = t.x;
            } else if ("x" === e) {
                if ("center" === o) M = (t.top + t.bottom) / 2 + g;
                else if (n(o)) {
                    const t = Object.keys(o)[0], e = o[t];
                    M = this.chart.scales[t].getPixelForValue(e) + g;
                }
                k = this._getXAxisLabelAlignment();
            } else if ("y" === e) {
                if ("center" === o) w = (t.left + t.right) / 2 - g;
                else if (n(o)) {
                    const t = Object.keys(o)[0], e = o[t];
                    w = this.chart.scales[t].getPixelForValue(e);
                }
                k = this._getYAxisLabelAlignment(f).textAlign;
            }
            "y" === e && ("start" === h ? A = "top" : "end" === h && (A = "bottom"));
            const T = this._getLabelSizes();
            for(x = 0, _ = l.length; x < _; ++x){
                y = l[x], v = y.label;
                const t = a.setContext(this.getContext(x));
                S = this.getPixelForTick(x) + a.labelOffset, P = this._resolveTickFontOptions(x), D = P.lineHeight, O = s(v) ? v.length : 1;
                const e = O / 2, i = t.color, n = t.textStrokeColor, h = t.textStrokeWidth;
                let d, f = k;
                if (r ? (w = S, "inner" === k && (f = x === _ - 1 ? this.options.reverse ? "left" : "right" : 0 === x ? this.options.reverse ? "right" : "left" : "center"), C = "top" === o ? "near" === c || 0 !== m ? -O * D + D / 2 : "center" === c ? -T.highest.height / 2 - e * D + D : -T.highest.height + D / 2 : "near" === c || 0 !== m ? D / 2 : "center" === c ? T.highest.height / 2 - e * D : T.highest.height - O * D, u && (C *= -1)) : (M = S, C = (1 - O) * D / 2), t.showLabelBackdrop) {
                    const e = pi(t.backdropPadding), i = T.heights[x], s = T.widths[x];
                    let n = M + C - e.top, o = w - e.left;
                    switch(A){
                        case "middle":
                            n -= i / 2;
                            break;
                        case "bottom":
                            n -= i;
                    }
                    switch(k){
                        case "center":
                            o -= s / 2;
                            break;
                        case "right":
                            o -= s;
                    }
                    d = {
                        left: o,
                        top: n,
                        width: s + e.width,
                        height: i + e.height,
                        color: t.backdropColor
                    };
                }
                b.push({
                    rotation: m,
                    label: v,
                    font: P,
                    color: i,
                    strokeColor: n,
                    strokeWidth: h,
                    textOffset: C,
                    textAlign: f,
                    textBaseline: A,
                    translation: [
                        w,
                        M
                    ],
                    backdrop: d
                });
            }
            return b;
        }
        _getXAxisLabelAlignment() {
            const { position: t, ticks: e } = this.options;
            if (-H(this.labelRotation)) return "top" === t ? "left" : "right";
            let i = "center";
            return "start" === e.align ? i = "left" : "end" === e.align ? i = "right" : "inner" === e.align && (i = "inner"), i;
        }
        _getYAxisLabelAlignment(t) {
            const { position: e, ticks: { crossAlign: i, mirror: s, padding: n } } = this.options, o = t + n, a = this._getLabelSizes().widest.width;
            let r, l;
            return "left" === e ? s ? (l = this.right + n, "near" === i ? r = "left" : "center" === i ? (r = "center", l += a / 2) : (r = "right", l += a)) : (l = this.right - o, "near" === i ? r = "right" : "center" === i ? (r = "center", l -= a / 2) : (r = "left", l = this.left)) : "right" === e ? s ? (l = this.left + n, "near" === i ? r = "right" : "center" === i ? (r = "center", l -= a / 2) : (r = "left", l -= a)) : (l = this.left + o, "near" === i ? r = "left" : "center" === i ? (r = "center", l += a / 2) : (r = "right", l = this.right)) : r = "right", {
                textAlign: r,
                x: l
            };
        }
        _computeLabelArea() {
            if (this.options.ticks.mirror) return;
            const t = this.chart, e = this.options.position;
            return "left" === e || "right" === e ? {
                top: 0,
                left: this.left,
                bottom: t.height,
                right: this.right
            } : "top" === e || "bottom" === e ? {
                top: this.top,
                left: 0,
                bottom: this.bottom,
                right: t.width
            } : void 0;
        }
        drawBackground() {
            const { ctx: t, options: { backgroundColor: e }, left: i, top: s, width: n, height: o } = this;
            e && (t.save(), t.fillStyle = e, t.fillRect(i, s, n, o), t.restore());
        }
        getLineWidthForValue(t) {
            const e = this.options.grid;
            if (!this._isVisible() || !e.display) return 0;
            const i = this.ticks.findIndex((e)=>e.value === t);
            if (i >= 0) return e.setContext(this.getContext(i)).lineWidth;
            return 0;
        }
        drawGrid(t) {
            const e = this.options.grid, i = this.ctx, s = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
            let n, o;
            const a = (t, e, s)=>{
                s.width && s.color && (i.save(), i.lineWidth = s.width, i.strokeStyle = s.color, i.setLineDash(s.borderDash || []), i.lineDashOffset = s.borderDashOffset, i.beginPath(), i.moveTo(t.x, t.y), i.lineTo(e.x, e.y), i.stroke(), i.restore());
            };
            if (e.display) for(n = 0, o = s.length; n < o; ++n){
                const t = s[n];
                e.drawOnChartArea && a({
                    x: t.x1,
                    y: t.y1
                }, {
                    x: t.x2,
                    y: t.y2
                }, t), e.drawTicks && a({
                    x: t.tx1,
                    y: t.ty1
                }, {
                    x: t.tx2,
                    y: t.ty2
                }, {
                    color: t.tickColor,
                    width: t.tickWidth,
                    borderDash: t.tickBorderDash,
                    borderDashOffset: t.tickBorderDashOffset
                });
            }
        }
        drawBorder() {
            const { chart: t, ctx: e, options: { grid: i } } = this, s = i.setContext(this.getContext()), n = i.drawBorder ? s.borderWidth : 0;
            if (!n) return;
            const o = i.setContext(this.getContext(0)).lineWidth, a = this._borderValue;
            let r, l, h, c;
            this.isHorizontal() ? (r = ve(t, this.left, n) - n / 2, l = ve(t, this.right, o) + o / 2, h = c = a) : (h = ve(t, this.top, n) - n / 2, c = ve(t, this.bottom, o) + o / 2, r = l = a), e.save(), e.lineWidth = s.borderWidth, e.strokeStyle = s.borderColor, e.beginPath(), e.moveTo(r, h), e.lineTo(l, c), e.stroke(), e.restore();
        }
        drawLabels(t) {
            if (!this.options.ticks.display) return;
            const e = this.ctx, i = this._computeLabelArea();
            i && Pe(e, i);
            const s = this._labelItems || (this._labelItems = this._computeLabelItems(t));
            let n, o;
            for(n = 0, o = s.length; n < o; ++n){
                const t = s[n], i = t.font, o = t.label;
                t.backdrop && (e.fillStyle = t.backdrop.color, e.fillRect(t.backdrop.left, t.backdrop.top, t.backdrop.width, t.backdrop.height)), Ae(e, o, 0, t.textOffset, i, t);
            }
            i && De(e);
        }
        drawTitle() {
            const { ctx: t, options: { position: e, title: i, reverse: o } } = this;
            if (!i.display) return;
            const a = mi(i.font), r = pi(i.padding), l = i.align;
            let h = a.lineHeight / 2;
            "bottom" === e || "center" === e || n(e) ? (h += r.bottom, s(i.text) && (h += a.lineHeight * (i.text.length - 1))) : h += r.top;
            const { titleX: c, titleY: d, maxWidth: u, rotation: f } = function(t, e, i, s) {
                const { top: o, left: a, bottom: r, right: l, chart: h } = t, { chartArea: c, scales: d } = h;
                let u, f, g, p = 0;
                const m = r - o, b = l - a;
                if (t.isHorizontal()) {
                    if (f = ut(s, a, l), n(i)) {
                        const t = Object.keys(i)[0], s = i[t];
                        g = d[t].getPixelForValue(s) + m - e;
                    } else g = "center" === i ? (c.bottom + c.top) / 2 + m - e : Vs(t, i, e);
                    u = l - a;
                } else {
                    if (n(i)) {
                        const t = Object.keys(i)[0], s = i[t];
                        f = d[t].getPixelForValue(s) - b + e;
                    } else f = "center" === i ? (c.left + c.right) / 2 - b + e : Vs(t, i, e);
                    g = ut(s, r, o), p = "left" === i ? -L : L;
                }
                return {
                    titleX: f,
                    titleY: g,
                    maxWidth: u,
                    rotation: p
                };
            }(this, h, e, l);
            Ae(t, i.text, 0, 0, a, {
                color: i.color,
                maxWidth: u,
                rotation: f,
                textAlign: Hs(l, e, o),
                textBaseline: "middle",
                translation: [
                    c,
                    d
                ]
            });
        }
        draw(t) {
            this._isVisible() && (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
        }
        _layers() {
            const t = this.options, e = t.ticks && t.ticks.z || 0, i = r(t.grid && t.grid.z, -1);
            return this._isVisible() && this.draw === $s.prototype.draw ? [
                {
                    z: i,
                    draw: (t)=>{
                        this.drawBackground(), this.drawGrid(t), this.drawTitle();
                    }
                },
                {
                    z: i + 1,
                    draw: ()=>{
                        this.drawBorder();
                    }
                },
                {
                    z: e,
                    draw: (t)=>{
                        this.drawLabels(t);
                    }
                }
            ] : [
                {
                    z: e,
                    draw: (t)=>{
                        this.draw(t);
                    }
                }
            ];
        }
        getMatchingVisibleMetas(t) {
            const e = this.chart.getSortedVisibleDatasetMetas(), i = this.axis + "AxisID", s = [];
            let n, o;
            for(n = 0, o = e.length; n < o; ++n){
                const o = e[n];
                o[i] !== this.id || t && o.type !== t || s.push(o);
            }
            return s;
        }
        _resolveTickFontOptions(t) {
            return mi(this.options.ticks.setContext(this.getContext(t)).font);
        }
        _maxDigits() {
            const t = this._resolveTickFontOptions(0).lineHeight;
            return (this.isHorizontal() ? this.width : this.height) / t;
        }
    }
    class Ys {
        constructor(t, e, i){
            this.type = t, this.scope = e, this.override = i, this.items = Object.create(null);
        }
        isForType(t) {
            return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
        }
        register(t) {
            const e = Object.getPrototypeOf(t);
            let i;
            (function(t) {
                return "id" in t && "defaults" in t;
            })(e) && (i = this.register(e));
            const s = this.items, n = t.id, o = this.scope + "." + n;
            if (!n) throw new Error("class does not have id: " + t);
            return n in s || (s[n] = t, function(t, e, i) {
                const s = m(Object.create(null), [
                    i ? ne.get(i) : {},
                    ne.get(e),
                    t.defaults
                ]);
                ne.set(e, s), t.defaultRoutes && function(t, e) {
                    Object.keys(e).forEach((i)=>{
                        const s = i.split("."), n = s.pop(), o = [
                            t
                        ].concat(s).join("."), a = e[i].split("."), r = a.pop(), l = a.join(".");
                        ne.route(o, n, l, r);
                    });
                }(e, t.defaultRoutes);
                t.descriptors && ne.describe(e, t.descriptors);
            }(t, o, i), this.override && ne.override(t.id, t.overrides)), o;
        }
        get(t) {
            return this.items[t];
        }
        unregister(t) {
            const e = this.items, i = t.id, s = this.scope;
            i in e && delete e[i], s && i in ne[s] && (delete ne[s][i], this.override && delete te[i]);
        }
    }
    var Us = new class {
        constructor(){
            this.controllers = new Ys(Ls, "datasets", !0), this.elements = new Ys(Es, "elements"), this.plugins = new Ys(Object, "plugins"), this.scales = new Ys($s, "scales"), this._typedRegistries = [
                this.controllers,
                this.scales,
                this.elements
            ];
        }
        add(...t) {
            this._each("register", t);
        }
        remove(...t) {
            this._each("unregister", t);
        }
        addControllers(...t) {
            this._each("register", t, this.controllers);
        }
        addElements(...t) {
            this._each("register", t, this.elements);
        }
        addPlugins(...t) {
            this._each("register", t, this.plugins);
        }
        addScales(...t) {
            this._each("register", t, this.scales);
        }
        getController(t) {
            return this._get(t, this.controllers, "controller");
        }
        getElement(t) {
            return this._get(t, this.elements, "element");
        }
        getPlugin(t) {
            return this._get(t, this.plugins, "plugin");
        }
        getScale(t) {
            return this._get(t, this.scales, "scale");
        }
        removeControllers(...t) {
            this._each("unregister", t, this.controllers);
        }
        removeElements(...t) {
            this._each("unregister", t, this.elements);
        }
        removePlugins(...t) {
            this._each("unregister", t, this.plugins);
        }
        removeScales(...t) {
            this._each("unregister", t, this.scales);
        }
        _each(t, e, i) {
            [
                ...e
            ].forEach((e)=>{
                const s = i || this._getRegistryForType(e);
                i || s.isForType(e) || s === this.plugins && e.id ? this._exec(t, s, e) : d(e, (e)=>{
                    const s = i || this._getRegistryForType(e);
                    this._exec(t, s, e);
                });
            });
        }
        _exec(t, e, i) {
            const s = w(t);
            c(i["before" + s], [], i), e[t](i), c(i["after" + s], [], i);
        }
        _getRegistryForType(t) {
            for(let e = 0; e < this._typedRegistries.length; e++){
                const i = this._typedRegistries[e];
                if (i.isForType(t)) return i;
            }
            return this.plugins;
        }
        _get(t, e, i) {
            const s = e.get(t);
            if (void 0 === s) throw new Error('"' + t + '" is not a registered ' + i + ".");
            return s;
        }
    };
    class Xs {
        constructor(){
            this._init = [];
        }
        notify(t, e, i, s) {
            "beforeInit" === e && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install"));
            const n = s ? this._descriptors(t).filter(s) : this._descriptors(t), o = this._notify(n, t, e, i);
            return "afterDestroy" === e && (this._notify(n, t, "stop"), this._notify(this._init, t, "uninstall")), o;
        }
        _notify(t, e, i, s) {
            s = s || {};
            for (const n of t){
                const t = n.plugin;
                if (!1 === c(t[i], [
                    e,
                    s,
                    n.options
                ], t) && s.cancelable) return !1;
            }
            return !0;
        }
        invalidate() {
            i(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
        }
        _descriptors(t) {
            if (this._cache) return this._cache;
            const e = this._cache = this._createDescriptors(t);
            return this._notifyStateChanges(t), e;
        }
        _createDescriptors(t, e) {
            const i = t && t.config, s = r(i.options && i.options.plugins, {}), n = function(t) {
                const e = {}, i = [], s = Object.keys(Us.plugins.items);
                for(let t = 0; t < s.length; t++)i.push(Us.getPlugin(s[t]));
                const n = t.plugins || [];
                for(let t = 0; t < n.length; t++){
                    const s = n[t];
                    -1 === i.indexOf(s) && (i.push(s), e[s.id] = !0);
                }
                return {
                    plugins: i,
                    localIds: e
                };
            }(i);
            return !1 !== s || e ? function(t, { plugins: e, localIds: i }, s, n) {
                const o = [], a = t.getContext();
                for (const r of e){
                    const e = r.id, l = qs(s[e], n);
                    null !== l && o.push({
                        plugin: r,
                        options: Ks(t.config, {
                            plugin: r,
                            local: i[e]
                        }, l, a)
                    });
                }
                return o;
            }(t, n, s, e) : [];
        }
        _notifyStateChanges(t) {
            const e = this._oldCache || [], i = this._cache, s = (t, e)=>t.filter((t)=>!e.some((e)=>t.plugin.id === e.plugin.id));
            this._notify(s(e, i), t, "stop"), this._notify(s(i, e), t, "start");
        }
    }
    function qs(t, e) {
        return e || !1 !== t ? !0 === t ? {} : t : null;
    }
    function Ks(t, { plugin: e, local: i }, s, n) {
        const o = t.pluginScopeKeys(e), a = t.getOptionScopes(s, o);
        return i && e.defaults && a.push(e.defaults), t.createResolver(a, n, [
            ""
        ], {
            scriptable: !1,
            indexable: !1,
            allKeys: !0
        });
    }
    function Gs(t, e) {
        const i = ne.datasets[t] || {};
        return ((e.datasets || {})[t] || {}).indexAxis || e.indexAxis || i.indexAxis || "x";
    }
    function Zs(t, e) {
        var i;
        return "x" === t || "y" === t ? t : e.axis || ("top" === (i = e.position) || "bottom" === i ? "x" : "left" === i || "right" === i ? "y" : void 0) || t.charAt(0).toLowerCase();
    }
    function Js(t) {
        const e = t.options || (t.options = {});
        e.plugins = r(e.plugins, {}), e.scales = function(t, e) {
            const i = te[t.type] || {
                scales: {}
            }, s = e.scales || {}, o = Gs(t.type, e), a = Object.create(null), r = Object.create(null);
            return Object.keys(s).forEach((t)=>{
                const e = s[t];
                if (!n(e)) return console.error(`Invalid scale configuration for scale: ${t}`);
                if (e._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${t}`);
                const l = Zs(t, e), h = function(t, e) {
                    return t === e ? "_index_" : "_value_";
                }(l, o), c = i.scales || {};
                a[l] = a[l] || t, r[t] = b(Object.create(null), [
                    {
                        axis: l
                    },
                    e,
                    c[l],
                    c[h]
                ]);
            }), t.data.datasets.forEach((i)=>{
                const n = i.type || t.type, o = i.indexAxis || Gs(n, e), l = (te[n] || {}).scales || {};
                Object.keys(l).forEach((t)=>{
                    const e = function(t, e) {
                        let i = t;
                        return "_index_" === t ? i = e : "_value_" === t && (i = "x" === e ? "y" : "x"), i;
                    }(t, o), n = i[e + "AxisID"] || a[e] || e;
                    r[n] = r[n] || Object.create(null), b(r[n], [
                        {
                            axis: e
                        },
                        s[n],
                        l[t]
                    ]);
                });
            }), Object.keys(r).forEach((t)=>{
                const e = r[t];
                b(e, [
                    ne.scales[e.type],
                    ne.scale
                ]);
            }), r;
        }(t, e);
    }
    function Qs(t) {
        return (t = t || {}).datasets = t.datasets || [], t.labels = t.labels || [], t;
    }
    const tn = new Map, en = new Set;
    function sn(t, e) {
        let i = tn.get(t);
        return i || (i = e(), tn.set(t, i), en.add(i)), i;
    }
    const nn = (t, e, i)=>{
        const s = y(e, i);
        void 0 !== s && t.add(s);
    };
    class on {
        constructor(t){
            this._config = function(t) {
                return (t = t || {}).data = Qs(t.data), Js(t), t;
            }(t), this._scopeCache = new Map, this._resolverCache = new Map;
        }
        get platform() {
            return this._config.platform;
        }
        get type() {
            return this._config.type;
        }
        set type(t) {
            this._config.type = t;
        }
        get data() {
            return this._config.data;
        }
        set data(t) {
            this._config.data = Qs(t);
        }
        get options() {
            return this._config.options;
        }
        set options(t) {
            this._config.options = t;
        }
        get plugins() {
            return this._config.plugins;
        }
        update() {
            const t = this._config;
            this.clearCache(), Js(t);
        }
        clearCache() {
            this._scopeCache.clear(), this._resolverCache.clear();
        }
        datasetScopeKeys(t) {
            return sn(t, ()=>[
                    [
                        `datasets.${t}`,
                        ""
                    ]
                ]);
        }
        datasetAnimationScopeKeys(t, e) {
            return sn(`${t}.transition.${e}`, ()=>[
                    [
                        `datasets.${t}.transitions.${e}`,
                        `transitions.${e}`
                    ],
                    [
                        `datasets.${t}`,
                        ""
                    ]
                ]);
        }
        datasetElementScopeKeys(t, e) {
            return sn(`${t}-${e}`, ()=>[
                    [
                        `datasets.${t}.elements.${e}`,
                        `datasets.${t}`,
                        `elements.${e}`,
                        ""
                    ]
                ]);
        }
        pluginScopeKeys(t) {
            const e = t.id;
            return sn(`${this.type}-plugin-${e}`, ()=>[
                    [
                        `plugins.${e}`,
                        ...t.additionalOptionScopes || []
                    ]
                ]);
        }
        _cachedScopes(t, e) {
            const i = this._scopeCache;
            let s = i.get(t);
            return s && !e || (s = new Map, i.set(t, s)), s;
        }
        getOptionScopes(t, e, i) {
            const { options: s, type: n } = this, o = this._cachedScopes(t, i), a = o.get(e);
            if (a) return a;
            const r = new Set;
            e.forEach((e)=>{
                t && (r.add(t), e.forEach((e)=>nn(r, t, e))), e.forEach((t)=>nn(r, s, t)), e.forEach((t)=>nn(r, te[n] || {}, t)), e.forEach((t)=>nn(r, ne, t)), e.forEach((t)=>nn(r, ee, t));
            });
            const l = Array.from(r);
            return 0 === l.length && l.push(Object.create(null)), en.has(e) && o.set(e, l), l;
        }
        chartOptionScopes() {
            const { options: t, type: e } = this;
            return [
                t,
                te[e] || {},
                ne.datasets[e] || {},
                {
                    type: e
                },
                ne,
                ee
            ];
        }
        resolveNamedOptions(t, e, i, n = [
            ""
        ]) {
            const o = {
                $shared: !0
            }, { resolver: a, subPrefixes: r } = an(this._resolverCache, t, n);
            let l = a;
            if (function(t, e) {
                const { isScriptable: i, isIndexable: n } = Ie(t);
                for (const o of e){
                    const e = i(o), a = n(o), r = (a || e) && t[o];
                    if (e && (k(r) || rn(r)) || a && s(r)) return !0;
                }
                return !1;
            }(a, e)) {
                o.$shared = !1;
                l = Re(a, i = k(i) ? i() : i, this.createResolver(t, i, r));
            }
            for (const t of e)o[t] = l[t];
            return o;
        }
        createResolver(t, e, i = [
            ""
        ], s) {
            const { resolver: o } = an(this._resolverCache, t, i);
            return n(e) ? Re(o, e, void 0, s) : o;
        }
    }
    function an(t, e, i) {
        let s = t.get(e);
        s || (s = new Map, t.set(e, s));
        const n = i.join();
        let o = s.get(n);
        if (!o) o = {
            resolver: Ee(e, i),
            subPrefixes: i.filter((t)=>!t.toLowerCase().includes("hover"))
        }, s.set(n, o);
        return o;
    }
    const rn = (t)=>n(t) && Object.getOwnPropertyNames(t).reduce((e, i)=>e || k(t[i]), !1);
    const ln = [
        "top",
        "bottom",
        "left",
        "right",
        "chartArea"
    ];
    function hn(t, e) {
        return "top" === t || "bottom" === t || -1 === ln.indexOf(t) && "x" === e;
    }
    function cn(t, e) {
        return function(i, s) {
            return i[t] === s[t] ? i[e] - s[e] : i[t] - s[t];
        };
    }
    function dn(t) {
        const e = t.chart, i = e.options.animation;
        e.notifyPlugins("afterRender"), c(i && i.onComplete, [
            t
        ], e);
    }
    function un(t) {
        const e = t.chart, i = e.options.animation;
        c(i && i.onProgress, [
            t
        ], e);
    }
    function fn(t) {
        return oe() && "string" == typeof t ? t = document.getElementById(t) : t && t.length && (t = t[0]), t && t.canvas && (t = t.canvas), t;
    }
    const gn = {}, pn = (t)=>{
        const e = fn(t);
        return Object.values(gn).filter((t)=>t.canvas === e).pop();
    };
    function mn(t, e, i) {
        const s = Object.keys(t);
        for (const n of s){
            const s = +n;
            if (s >= e) {
                const o = t[n];
                delete t[n], (i > 0 || s > e) && (t[s + i] = o);
            }
        }
    }
    class bn {
        constructor(t, i){
            const s = this.config = new on(i), n = fn(t), o = pn(n);
            if (o) throw new Error("Canvas is already in use. Chart with ID '" + o.id + "' must be destroyed before the canvas with ID '" + o.canvas.id + "' can be reused.");
            const a = s.createResolver(s.chartOptionScopes(), this.getContext());
            this.platform = new (s.platform || gs(n)), this.platform.updateConfig(s);
            const r = this.platform.acquireContext(n, a.aspectRatio), l = r && r.canvas, h = l && l.height, c = l && l.width;
            this.id = e(), this.ctx = r, this.canvas = l, this.width = c, this.height = h, this._options = a, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new Xs, this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = ct((t)=>this.update(t), a.resizeDelay || 0), this._dataChanges = [], gn[this.id] = this, r && l ? (mt.listen(this, "complete", dn), mt.listen(this, "progress", un), this._initialize(), this.attached && this.update()) : console.error("Failed to create chart: can't acquire context from the given item");
        }
        get aspectRatio() {
            const { options: { aspectRatio: t, maintainAspectRatio: e }, width: s, height: n, _aspectRatio: o } = this;
            return i(t) ? e && o ? o : n ? s / n : null : t;
        }
        get data() {
            return this.config.data;
        }
        set data(t) {
            this.config.data = t;
        }
        get options() {
            return this._options;
        }
        set options(t) {
            this.config.options = t;
        }
        _initialize() {
            return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : pe(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
        }
        clear() {
            return we(this.canvas, this.ctx), this;
        }
        stop() {
            return mt.stop(this), this;
        }
        resize(t, e) {
            mt.running(this) ? this._resizeBeforeDraw = {
                width: t,
                height: e
            } : this._resize(t, e);
        }
        _resize(t, e) {
            const i = this.options, s = this.canvas, n = i.maintainAspectRatio && this.aspectRatio, o = this.platform.getMaximumSize(s, t, e, n), a = i.devicePixelRatio || this.platform.getDevicePixelRatio(), r = this.width ? "resize" : "attach";
            this.width = o.width, this.height = o.height, this._aspectRatio = this.aspectRatio, pe(this, a, !0) && (this.notifyPlugins("resize", {
                size: o
            }), c(i.onResize, [
                this,
                o
            ], this), this.attached && this._doResize(r) && this.render());
        }
        ensureScalesHaveIDs() {
            d(this.options.scales || {}, (t, e)=>{
                t.id = e;
            });
        }
        buildOrUpdateScales() {
            const t = this.options, e = t.scales, i = this.scales, s = Object.keys(i).reduce((t, e)=>(t[e] = !1, t), {});
            let n = [];
            e && (n = n.concat(Object.keys(e).map((t)=>{
                const i = e[t], s = Zs(t, i), n = "r" === s, o = "x" === s;
                return {
                    options: i,
                    dposition: n ? "chartArea" : o ? "bottom" : "left",
                    dtype: n ? "radialLinear" : o ? "category" : "linear"
                };
            }))), d(n, (e)=>{
                const n = e.options, o = n.id, a = Zs(o, n), l = r(n.type, e.dtype);
                void 0 !== n.position && hn(n.position, a) === hn(e.dposition) || (n.position = e.dposition), s[o] = !0;
                let h = null;
                if (o in i && i[o].type === l) h = i[o];
                else h = new (Us.getScale(l))({
                    id: o,
                    type: l,
                    ctx: this.ctx,
                    chart: this
                }), i[h.id] = h;
                h.init(n, t);
            }), d(s, (t, e)=>{
                t || delete i[e];
            }), d(i, (t)=>{
                Zi.configure(this, t, t.options), Zi.addBox(this, t);
            });
        }
        _updateMetasets() {
            const t = this._metasets, e = this.data.datasets.length, i = t.length;
            if (t.sort((t, e)=>t.index - e.index), i > e) {
                for(let t = e; t < i; ++t)this._destroyDatasetMeta(t);
                t.splice(e, i - e);
            }
            this._sortedMetasets = t.slice(0).sort(cn("order", "index"));
        }
        _removeUnreferencedMetasets() {
            const { _metasets: t, data: { datasets: e } } = this;
            t.length > e.length && delete this._stacks, t.forEach((t, i)=>{
                0 === e.filter((e)=>e === t._dataset).length && this._destroyDatasetMeta(i);
            });
        }
        buildOrUpdateControllers() {
            const t = [], e = this.data.datasets;
            let i, s;
            for(this._removeUnreferencedMetasets(), i = 0, s = e.length; i < s; i++){
                const s = e[i];
                let n = this.getDatasetMeta(i);
                const o = s.type || this.config.type;
                if (n.type && n.type !== o && (this._destroyDatasetMeta(i), n = this.getDatasetMeta(i)), n.type = o, n.indexAxis = s.indexAxis || Gs(o, this.options), n.order = s.order || 0, n.index = i, n.label = "" + s.label, n.visible = this.isDatasetVisible(i), n.controller) n.controller.updateIndex(i), n.controller.linkScales();
                else {
                    const e = Us.getController(o), { datasetElementType: s, dataElementType: a } = ne.datasets[o];
                    Object.assign(e.prototype, {
                        dataElementType: Us.getElement(a),
                        datasetElementType: s && Us.getElement(s)
                    }), n.controller = new e(this, i), t.push(n.controller);
                }
            }
            return this._updateMetasets(), t;
        }
        _resetElements() {
            d(this.data.datasets, (t, e)=>{
                this.getDatasetMeta(e).controller.reset();
            }, this);
        }
        reset() {
            this._resetElements(), this.notifyPlugins("reset");
        }
        update(t) {
            const e = this.config;
            e.update();
            const i = this._options = e.createResolver(e.chartOptionScopes(), this.getContext()), s = this._animationsDisabled = !i.animation;
            if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), !1 === this.notifyPlugins("beforeUpdate", {
                mode: t,
                cancelable: !0
            })) return;
            const n = this.buildOrUpdateControllers();
            this.notifyPlugins("beforeElementsUpdate");
            let o = 0;
            for(let t = 0, e = this.data.datasets.length; t < e; t++){
                const { controller: e } = this.getDatasetMeta(t), i = !s && -1 === n.indexOf(e);
                e.buildOrUpdateElements(i), o = Math.max(+e.getMaxOverflow(), o);
            }
            o = this._minPadding = i.layout.autoPadding ? o : 0, this._updateLayout(o), s || d(n, (t)=>{
                t.reset();
            }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", {
                mode: t
            }), this._layers.sort(cn("z", "_idx"));
            const { _active: a, _lastEvent: r } = this;
            r ? this._eventHandler(r, !0) : a.length && this._updateHoverStyles(a, a, !0), this.render();
        }
        _updateScales() {
            d(this.scales, (t)=>{
                Zi.removeBox(this, t);
            }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
        }
        _checkEventBindings() {
            const t = this.options, e = new Set(Object.keys(this._listeners)), i = new Set(t.events);
            S(e, i) && !!this._responsiveListeners === t.responsive || (this.unbindEvents(), this.bindEvents());
        }
        _updateHiddenIndices() {
            const { _hiddenIndices: t } = this, e = this._getUniformDataChanges() || [];
            for (const { method: i, start: s, count: n } of e)mn(t, s, "_removeElements" === i ? -n : n);
        }
        _getUniformDataChanges() {
            const t = this._dataChanges;
            if (!t || !t.length) return;
            this._dataChanges = [];
            const e = this.data.datasets.length, i = (e)=>new Set(t.filter((t)=>t[0] === e).map((t, e)=>e + "," + t.splice(1).join(","))), s = i(0);
            for(let t = 1; t < e; t++)if (!S(s, i(t))) return;
            return Array.from(s).map((t)=>t.split(",")).map((t)=>({
                    method: t[1],
                    start: +t[2],
                    count: +t[3]
                }));
        }
        _updateLayout(t) {
            if (!1 === this.notifyPlugins("beforeLayout", {
                cancelable: !0
            })) return;
            Zi.update(this, this.width, this.height, t);
            const e = this.chartArea, i = e.width <= 0 || e.height <= 0;
            this._layers = [], d(this.boxes, (t)=>{
                i && "chartArea" === t.position || (t.configure && t.configure(), this._layers.push(...t._layers()));
            }, this), this._layers.forEach((t, e)=>{
                t._idx = e;
            }), this.notifyPlugins("afterLayout");
        }
        _updateDatasets(t) {
            if (!1 !== this.notifyPlugins("beforeDatasetsUpdate", {
                mode: t,
                cancelable: !0
            })) {
                for(let t = 0, e = this.data.datasets.length; t < e; ++t)this.getDatasetMeta(t).controller.configure();
                for(let e = 0, i = this.data.datasets.length; e < i; ++e)this._updateDataset(e, k(t) ? t({
                    datasetIndex: e
                }) : t);
                this.notifyPlugins("afterDatasetsUpdate", {
                    mode: t
                });
            }
        }
        _updateDataset(t, e) {
            const i = this.getDatasetMeta(t), s = {
                meta: i,
                index: t,
                mode: e,
                cancelable: !0
            };
            !1 !== this.notifyPlugins("beforeDatasetUpdate", s) && (i.controller._update(e), s.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", s));
        }
        render() {
            !1 !== this.notifyPlugins("beforeRender", {
                cancelable: !0
            }) && (mt.has(this) ? this.attached && !mt.running(this) && mt.start(this) : (this.draw(), dn({
                chart: this
            })));
        }
        draw() {
            let t;
            if (this._resizeBeforeDraw) {
                const { width: t, height: e } = this._resizeBeforeDraw;
                this._resize(t, e), this._resizeBeforeDraw = null;
            }
            if (this.clear(), this.width <= 0 || this.height <= 0) return;
            if (!1 === this.notifyPlugins("beforeDraw", {
                cancelable: !0
            })) return;
            const e = this._layers;
            for(t = 0; t < e.length && e[t].z <= 0; ++t)e[t].draw(this.chartArea);
            for(this._drawDatasets(); t < e.length; ++t)e[t].draw(this.chartArea);
            this.notifyPlugins("afterDraw");
        }
        _getSortedDatasetMetas(t) {
            const e = this._sortedMetasets, i = [];
            let s, n;
            for(s = 0, n = e.length; s < n; ++s){
                const n = e[s];
                t && !n.visible || i.push(n);
            }
            return i;
        }
        getSortedVisibleDatasetMetas() {
            return this._getSortedDatasetMetas(!0);
        }
        _drawDatasets() {
            if (!1 === this.notifyPlugins("beforeDatasetsDraw", {
                cancelable: !0
            })) return;
            const t = this.getSortedVisibleDatasetMetas();
            for(let e = t.length - 1; e >= 0; --e)this._drawDataset(t[e]);
            this.notifyPlugins("afterDatasetsDraw");
        }
        _drawDataset(t) {
            const e = this.ctx, i = t._clip, s = !i.disabled, n = this.chartArea, o = {
                meta: t,
                index: t.index,
                cancelable: !0
            };
            !1 !== this.notifyPlugins("beforeDatasetDraw", o) && (s && Pe(e, {
                left: !1 === i.left ? 0 : n.left - i.left,
                right: !1 === i.right ? this.width : n.right + i.right,
                top: !1 === i.top ? 0 : n.top - i.top,
                bottom: !1 === i.bottom ? this.height : n.bottom + i.bottom
            }), t.controller.draw(), s && De(e), o.cancelable = !1, this.notifyPlugins("afterDatasetDraw", o));
        }
        isPointInArea(t) {
            return Se(t, this.chartArea, this._minPadding);
        }
        getElementsAtEventForMode(t, e, i, s) {
            const n = Vi.modes[e];
            return "function" == typeof n ? n(this, t, i, s) : [];
        }
        getDatasetMeta(t) {
            const e = this.data.datasets[t], i = this._metasets;
            let s = i.filter((t)=>t && t._dataset === e).pop();
            return s || (s = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: e && e.order || 0,
                index: t,
                _dataset: e,
                _parsed: [],
                _sorted: !1
            }, i.push(s)), s;
        }
        getContext() {
            return this.$context || (this.$context = _i(null, {
                chart: this,
                type: "chart"
            }));
        }
        getVisibleDatasetCount() {
            return this.getSortedVisibleDatasetMetas().length;
        }
        isDatasetVisible(t) {
            const e = this.data.datasets[t];
            if (!e) return !1;
            const i = this.getDatasetMeta(t);
            return "boolean" == typeof i.hidden ? !i.hidden : !e.hidden;
        }
        setDatasetVisibility(t, e) {
            this.getDatasetMeta(t).hidden = !e;
        }
        toggleDataVisibility(t) {
            this._hiddenIndices[t] = !this._hiddenIndices[t];
        }
        getDataVisibility(t) {
            return !this._hiddenIndices[t];
        }
        _updateVisibility(t, e, i) {
            const s = i ? "show" : "hide", n = this.getDatasetMeta(t), o = n.controller._resolveAnimations(void 0, s);
            M(e) ? (n.data[e].hidden = !i, this.update()) : (this.setDatasetVisibility(t, i), o.update(n, {
                visible: i
            }), this.update((e)=>e.datasetIndex === t ? s : void 0));
        }
        hide(t, e) {
            this._updateVisibility(t, e, !1);
        }
        show(t, e) {
            this._updateVisibility(t, e, !0);
        }
        _destroyDatasetMeta(t) {
            const e = this._metasets[t];
            e && e.controller && e.controller._destroy(), delete this._metasets[t];
        }
        _stop() {
            let t, e;
            for(this.stop(), mt.remove(this), t = 0, e = this.data.datasets.length; t < e; ++t)this._destroyDatasetMeta(t);
        }
        destroy() {
            this.notifyPlugins("beforeDestroy");
            const { canvas: t, ctx: e } = this;
            this._stop(), this.config.clearCache(), t && (this.unbindEvents(), we(t, e), this.platform.releaseContext(e), this.canvas = null, this.ctx = null), this.notifyPlugins("destroy"), delete gn[this.id], this.notifyPlugins("afterDestroy");
        }
        toBase64Image(...t) {
            return this.canvas.toDataURL(...t);
        }
        bindEvents() {
            this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
        }
        bindUserEvents() {
            const t = this._listeners, e = this.platform, i = (i, s)=>{
                e.addEventListener(this, i, s), t[i] = s;
            }, s = (t, e, i)=>{
                t.offsetX = e, t.offsetY = i, this._eventHandler(t);
            };
            d(this.options.events, (t)=>i(t, s));
        }
        bindResponsiveEvents() {
            this._responsiveListeners || (this._responsiveListeners = {});
            const t = this._responsiveListeners, e = this.platform, i = (i, s)=>{
                e.addEventListener(this, i, s), t[i] = s;
            }, s = (i, s)=>{
                t[i] && (e.removeEventListener(this, i, s), delete t[i]);
            }, n = (t, e)=>{
                this.canvas && this.resize(t, e);
            };
            let o;
            const a = ()=>{
                s("attach", a), this.attached = !0, this.resize(), i("resize", n), i("detach", o);
            };
            o = ()=>{
                this.attached = !1, s("resize", n), this._stop(), this._resize(0, 0), i("attach", a);
            }, e.isAttached(this.canvas) ? a() : o();
        }
        unbindEvents() {
            d(this._listeners, (t, e)=>{
                this.platform.removeEventListener(this, e, t);
            }), this._listeners = {}, d(this._responsiveListeners, (t, e)=>{
                this.platform.removeEventListener(this, e, t);
            }), this._responsiveListeners = void 0;
        }
        updateHoverStyle(t, e, i) {
            const s = i ? "set" : "remove";
            let n, o, a, r;
            for("dataset" === e && (n = this.getDatasetMeta(t[0].datasetIndex), n.controller["_" + s + "DatasetHoverStyle"]()), a = 0, r = t.length; a < r; ++a){
                o = t[a];
                const e = o && this.getDatasetMeta(o.datasetIndex).controller;
                e && e[s + "HoverStyle"](o.element, o.datasetIndex, o.index);
            }
        }
        getActiveElements() {
            return this._active || [];
        }
        setActiveElements(t) {
            const e = this._active || [], i = t.map(({ datasetIndex: t, index: e })=>{
                const i = this.getDatasetMeta(t);
                if (!i) throw new Error("No dataset found at index " + t);
                return {
                    datasetIndex: t,
                    element: i.data[e],
                    index: e
                };
            });
            !u(i, e) && (this._active = i, this._lastEvent = null, this._updateHoverStyles(i, e));
        }
        notifyPlugins(t, e, i) {
            return this._plugins.notify(this, t, e, i);
        }
        _updateHoverStyles(t, e, i) {
            const s = this.options.hover, n = (t, e)=>t.filter((t)=>!e.some((e)=>t.datasetIndex === e.datasetIndex && t.index === e.index)), o = n(e, t), a = i ? t : n(t, e);
            o.length && this.updateHoverStyle(o, s.mode, !1), a.length && s.mode && this.updateHoverStyle(a, s.mode, !0);
        }
        _eventHandler(t, e) {
            const i = {
                event: t,
                replay: e,
                cancelable: !0,
                inChartArea: this.isPointInArea(t)
            }, s = (e)=>(e.options.events || this.options.events).includes(t.native.type);
            if (!1 === this.notifyPlugins("beforeEvent", i, s)) return;
            const n = this._handleEvent(t, e, i.inChartArea);
            return i.cancelable = !1, this.notifyPlugins("afterEvent", i, s), (n || i.changed) && this.render(), this;
        }
        _handleEvent(t, e, i) {
            const { _active: s = [], options: n } = this, o = e, a = this._getActiveElements(t, s, i, o), r = P(t), l = function(t, e, i, s) {
                return i && "mouseout" !== t.type ? s ? e : t : null;
            }(t, this._lastEvent, i, r);
            i && (this._lastEvent = null, c(n.onHover, [
                t,
                a,
                this
            ], this), r && c(n.onClick, [
                t,
                a,
                this
            ], this));
            const h = !u(a, s);
            return (h || e) && (this._active = a, this._updateHoverStyles(a, s, e)), this._lastEvent = l, h;
        }
        _getActiveElements(t, e, i, s) {
            if ("mouseout" === t.type) return [];
            if (!i) return e;
            const n = this.options.hover;
            return this.getElementsAtEventForMode(t, n.mode, n, s);
        }
    }
    const xn = ()=>d(bn.instances, (t)=>t._plugins.invalidate()), _n = !0;
    function yn() {
        throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
    }
    Object.defineProperties(bn, {
        defaults: {
            enumerable: _n,
            value: ne
        },
        instances: {
            enumerable: _n,
            value: gn
        },
        overrides: {
            enumerable: _n,
            value: te
        },
        registry: {
            enumerable: _n,
            value: Us
        },
        version: {
            enumerable: _n,
            value: "3.9.1"
        },
        getChart: {
            enumerable: _n,
            value: pn
        },
        register: {
            enumerable: _n,
            value: (...t)=>{
                Us.add(...t), xn();
            }
        },
        unregister: {
            enumerable: _n,
            value: (...t)=>{
                Us.remove(...t), xn();
            }
        }
    });
    class vn {
        constructor(t){
            this.options = t || {};
        }
        init(t) {}
        formats() {
            return yn();
        }
        parse(t, e) {
            return yn();
        }
        format(t, e) {
            return yn();
        }
        add(t, e, i) {
            return yn();
        }
        diff(t, e, i) {
            return yn();
        }
        startOf(t, e, i) {
            return yn();
        }
        endOf(t, e) {
            return yn();
        }
    }
    vn.override = function(t) {
        Object.assign(vn.prototype, t);
    };
    var wn = {
        _date: vn
    };
    function Mn(t) {
        const e = t.iScale, i = function(t, e) {
            if (!t._cache.$bar) {
                const i = t.getMatchingVisibleMetas(e);
                let s = [];
                for(let e = 0, n = i.length; e < n; e++)s = s.concat(i[e].controller.getAllParsedValues(t));
                t._cache.$bar = rt(s.sort((t, e)=>t - e));
            }
            return t._cache.$bar;
        }(e, t.type);
        let s, n, o, a, r = e._length;
        const l = ()=>{
            32767 !== o && -32768 !== o && (M(a) && (r = Math.min(r, Math.abs(o - a) || r)), a = o);
        };
        for(s = 0, n = i.length; s < n; ++s)o = e.getPixelForValue(i[s]), l();
        for(a = void 0, s = 0, n = e.ticks.length; s < n; ++s)o = e.getPixelForTick(s), l();
        return r;
    }
    function kn(t, e, i, n) {
        return s(t) ? function(t, e, i, s) {
            const n = i.parse(t[0], s), o = i.parse(t[1], s), a = Math.min(n, o), r = Math.max(n, o);
            let l = a, h = r;
            Math.abs(a) > Math.abs(r) && (l = r, h = a), e[i.axis] = h, e._custom = {
                barStart: l,
                barEnd: h,
                start: n,
                end: o,
                min: a,
                max: r
            };
        }(t, e, i, n) : e[i.axis] = i.parse(t, n), e;
    }
    function Sn(t, e, i, s) {
        const n = t.iScale, o = t.vScale, a = n.getLabels(), r = n === o, l = [];
        let h, c, d, u;
        for(h = i, c = i + s; h < c; ++h)u = e[h], d = {}, d[n.axis] = r || n.parse(a[h], h), l.push(kn(u, d, o, h));
        return l;
    }
    function Pn(t) {
        return t && void 0 !== t.barStart && void 0 !== t.barEnd;
    }
    function Dn(t, e, i, s) {
        let n = e.borderSkipped;
        const o = {};
        if (!n) return void (t.borderSkipped = o);
        if (!0 === n) return void (t.borderSkipped = {
            top: !0,
            right: !0,
            bottom: !0,
            left: !0
        });
        const { start: a, end: r, reverse: l, top: h, bottom: c } = function(t) {
            let e, i, s, n, o;
            return t.horizontal ? (e = t.base > t.x, i = "left", s = "right") : (e = t.base < t.y, i = "bottom", s = "top"), e ? (n = "end", o = "start") : (n = "start", o = "end"), {
                start: i,
                end: s,
                reverse: e,
                top: n,
                bottom: o
            };
        }(t);
        "middle" === n && i && (t.enableBorderRadius = !0, (i._top || 0) === s ? n = h : (i._bottom || 0) === s ? n = c : (o[On(c, a, r, l)] = !0, n = h)), o[On(n, a, r, l)] = !0, t.borderSkipped = o;
    }
    function On(t, e, i, s) {
        var n, o, a;
        return s ? (a = i, t = Cn(t = (n = t) === (o = e) ? a : n === a ? o : n, i, e)) : t = Cn(t, e, i), t;
    }
    function Cn(t, e, i) {
        return "start" === t ? e : "end" === t ? i : t;
    }
    function An(t, { inflateAmount: e }, i) {
        t.inflateAmount = "auto" === e ? 1 === i ? .33 : 0 : e;
    }
    class Tn extends Ls {
        parsePrimitiveData(t, e, i, s) {
            return Sn(t, e, i, s);
        }
        parseArrayData(t, e, i, s) {
            return Sn(t, e, i, s);
        }
        parseObjectData(t, e, i, s) {
            const { iScale: n, vScale: o } = t, { xAxisKey: a = "x", yAxisKey: r = "y" } = this._parsing, l = "x" === n.axis ? a : r, h = "x" === o.axis ? a : r, c = [];
            let d, u, f, g;
            for(d = i, u = i + s; d < u; ++d)g = e[d], f = {}, f[n.axis] = n.parse(y(g, l), d), c.push(kn(y(g, h), f, o, d));
            return c;
        }
        updateRangeFromParsed(t, e, i, s) {
            super.updateRangeFromParsed(t, e, i, s);
            const n = i._custom;
            n && e === this._cachedMeta.vScale && (t.min = Math.min(t.min, n.min), t.max = Math.max(t.max, n.max));
        }
        getMaxOverflow() {
            return 0;
        }
        getLabelAndValue(t) {
            const e = this._cachedMeta, { iScale: i, vScale: s } = e, n = this.getParsed(t), o = n._custom, a = Pn(o) ? "[" + o.start + ", " + o.end + "]" : "" + s.getLabelForValue(n[s.axis]);
            return {
                label: "" + i.getLabelForValue(n[i.axis]),
                value: a
            };
        }
        initialize() {
            this.enableOptionSharing = !0, super.initialize();
            this._cachedMeta.stack = this.getDataset().stack;
        }
        update(t) {
            const e = this._cachedMeta;
            this.updateElements(e.data, 0, e.data.length, t);
        }
        updateElements(t, e, s, n) {
            const o = "reset" === n, { index: a, _cachedMeta: { vScale: r } } = this, l = r.getBasePixel(), h = r.isHorizontal(), c = this._getRuler(), { sharedOptions: d, includeOptions: u } = this._getSharedOptions(e, n);
            for(let f = e; f < e + s; f++){
                const e = this.getParsed(f), s = o || i(e[r.axis]) ? {
                    base: l,
                    head: l
                } : this._calculateBarValuePixels(f), g = this._calculateBarIndexPixels(f, c), p = (e._stacks || {})[r.axis], m = {
                    horizontal: h,
                    base: s.base,
                    enableBorderRadius: !p || Pn(e._custom) || a === p._top || a === p._bottom,
                    x: h ? s.head : g.center,
                    y: h ? g.center : s.head,
                    height: h ? g.size : Math.abs(s.size),
                    width: h ? Math.abs(s.size) : g.size
                };
                u && (m.options = d || this.resolveDataElementOptions(f, t[f].active ? "active" : n));
                const b = m.options || t[f].options;
                Dn(m, b, p, a), An(m, b, c.ratio), this.updateElement(t[f], f, m, n);
            }
        }
        _getStacks(t, e) {
            const { iScale: s } = this._cachedMeta, n = s.getMatchingVisibleMetas(this._type).filter((t)=>t.controller.options.grouped), o = s.options.stacked, a = [], r = (t)=>{
                const s = t.controller.getParsed(e), n = s && s[t.vScale.axis];
                if (i(n) || isNaN(n)) return !0;
            };
            for (const i of n)if ((void 0 === e || !r(i)) && ((!1 === o || -1 === a.indexOf(i.stack) || void 0 === o && void 0 === i.stack) && a.push(i.stack), i.index === t)) break;
            return a.length || a.push(void 0), a;
        }
        _getStackCount(t) {
            return this._getStacks(void 0, t).length;
        }
        _getStackIndex(t, e, i) {
            const s = this._getStacks(t, i), n = void 0 !== e ? s.indexOf(e) : -1;
            return -1 === n ? s.length - 1 : n;
        }
        _getRuler() {
            const t = this.options, e = this._cachedMeta, i = e.iScale, s = [];
            let n, o;
            for(n = 0, o = e.data.length; n < o; ++n)s.push(i.getPixelForValue(this.getParsed(n)[i.axis], n));
            const a = t.barThickness;
            return {
                min: a || Mn(e),
                pixels: s,
                start: i._startPixel,
                end: i._endPixel,
                stackCount: this._getStackCount(),
                scale: i,
                grouped: t.grouped,
                ratio: a ? 1 : t.categoryPercentage * t.barPercentage
            };
        }
        _calculateBarValuePixels(t) {
            const { _cachedMeta: { vScale: e, _stacked: s }, options: { base: n, minBarLength: o } } = this, a = n || 0, r = this.getParsed(t), l = r._custom, h = Pn(l);
            let c, d, u = r[e.axis], f = 0, g = s ? this.applyStack(e, r, s) : u;
            g !== u && (f = g - u, g = u), h && (u = l.barStart, g = l.barEnd - l.barStart, 0 !== u && z(u) !== z(l.barEnd) && (f = 0), f += u);
            const p = i(n) || h ? f : n;
            let m = e.getPixelForValue(p);
            if (c = this.chart.getDataVisibility(t) ? e.getPixelForValue(f + g) : m, d = c - m, Math.abs(d) < o) {
                d = function(t, e, i) {
                    return 0 !== t ? z(t) : (e.isHorizontal() ? 1 : -1) * (e.min >= i ? 1 : -1);
                }(d, e, a) * o, u === a && (m -= d / 2);
                const t = e.getPixelForDecimal(0), i = e.getPixelForDecimal(1), s = Math.min(t, i), n = Math.max(t, i);
                m = Math.max(Math.min(m, n), s), c = m + d;
            }
            if (m === e.getPixelForValue(a)) {
                const t = z(d) * e.getLineWidthForValue(a) / 2;
                m += t, d -= t;
            }
            return {
                size: d,
                base: m,
                head: c,
                center: c + d / 2
            };
        }
        _calculateBarIndexPixels(t, e) {
            const s = e.scale, n = this.options, o = n.skipNull, a = r(n.maxBarThickness, 1 / 0);
            let l, h;
            if (e.grouped) {
                const s = o ? this._getStackCount(t) : e.stackCount, r = "flex" === n.barThickness ? function(t, e, i, s) {
                    const n = e.pixels, o = n[t];
                    let a = t > 0 ? n[t - 1] : null, r = t < n.length - 1 ? n[t + 1] : null;
                    const l = i.categoryPercentage;
                    null === a && (a = o - (null === r ? e.end - e.start : r - o)), null === r && (r = o + o - a);
                    const h = o - (o - Math.min(a, r)) / 2 * l;
                    return {
                        chunk: Math.abs(r - a) / 2 * l / s,
                        ratio: i.barPercentage,
                        start: h
                    };
                }(t, e, n, s) : function(t, e, s, n) {
                    const o = s.barThickness;
                    let a, r;
                    return i(o) ? (a = e.min * s.categoryPercentage, r = s.barPercentage) : (a = o * n, r = 1), {
                        chunk: a / n,
                        ratio: r,
                        start: e.pixels[t] - a / 2
                    };
                }(t, e, n, s), c = this._getStackIndex(this.index, this._cachedMeta.stack, o ? t : void 0);
                l = r.start + r.chunk * c + r.chunk / 2, h = Math.min(a, r.chunk * r.ratio);
            } else l = s.getPixelForValue(this.getParsed(t)[s.axis], t), h = Math.min(a, e.min * e.ratio);
            return {
                base: l - h / 2,
                head: l + h / 2,
                center: l,
                size: h
            };
        }
        draw() {
            const t = this._cachedMeta, e = t.vScale, i = t.data, s = i.length;
            let n = 0;
            for(; n < s; ++n)null !== this.getParsed(n)[e.axis] && i[n].draw(this._ctx);
        }
    }
    Tn.id = "bar", Tn.defaults = {
        datasetElementType: !1,
        dataElementType: "bar",
        categoryPercentage: .8,
        barPercentage: .9,
        grouped: !0,
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "base",
                    "width",
                    "height"
                ]
            }
        }
    }, Tn.overrides = {
        scales: {
            _index_: {
                type: "category",
                offset: !0,
                grid: {
                    offset: !0
                }
            },
            _value_: {
                type: "linear",
                beginAtZero: !0
            }
        }
    };
    class Ln extends Ls {
        initialize() {
            this.enableOptionSharing = !0, super.initialize();
        }
        parsePrimitiveData(t, e, i, s) {
            const n = super.parsePrimitiveData(t, e, i, s);
            for(let t = 0; t < n.length; t++)n[t]._custom = this.resolveDataElementOptions(t + i).radius;
            return n;
        }
        parseArrayData(t, e, i, s) {
            const n = super.parseArrayData(t, e, i, s);
            for(let t = 0; t < n.length; t++){
                const s = e[i + t];
                n[t]._custom = r(s[2], this.resolveDataElementOptions(t + i).radius);
            }
            return n;
        }
        parseObjectData(t, e, i, s) {
            const n = super.parseObjectData(t, e, i, s);
            for(let t = 0; t < n.length; t++){
                const s = e[i + t];
                n[t]._custom = r(s && s.r && +s.r, this.resolveDataElementOptions(t + i).radius);
            }
            return n;
        }
        getMaxOverflow() {
            const t = this._cachedMeta.data;
            let e = 0;
            for(let i = t.length - 1; i >= 0; --i)e = Math.max(e, t[i].size(this.resolveDataElementOptions(i)) / 2);
            return e > 0 && e;
        }
        getLabelAndValue(t) {
            const e = this._cachedMeta, { xScale: i, yScale: s } = e, n = this.getParsed(t), o = i.getLabelForValue(n.x), a = s.getLabelForValue(n.y), r = n._custom;
            return {
                label: e.label,
                value: "(" + o + ", " + a + (r ? ", " + r : "") + ")"
            };
        }
        update(t) {
            const e = this._cachedMeta.data;
            this.updateElements(e, 0, e.length, t);
        }
        updateElements(t, e, i, s) {
            const n = "reset" === s, { iScale: o, vScale: a } = this._cachedMeta, { sharedOptions: r, includeOptions: l } = this._getSharedOptions(e, s), h = o.axis, c = a.axis;
            for(let d = e; d < e + i; d++){
                const e = t[d], i = !n && this.getParsed(d), u = {}, f = u[h] = n ? o.getPixelForDecimal(.5) : o.getPixelForValue(i[h]), g = u[c] = n ? a.getBasePixel() : a.getPixelForValue(i[c]);
                u.skip = isNaN(f) || isNaN(g), l && (u.options = r || this.resolveDataElementOptions(d, e.active ? "active" : s), n && (u.options.radius = 0)), this.updateElement(e, d, u, s);
            }
        }
        resolveDataElementOptions(t, e) {
            const i = this.getParsed(t);
            let s = super.resolveDataElementOptions(t, e);
            s.$shared && (s = Object.assign({}, s, {
                $shared: !1
            }));
            const n = s.radius;
            return "active" !== e && (s.radius = 0), s.radius += r(i && i._custom, n), s;
        }
    }
    Ln.id = "bubble", Ln.defaults = {
        datasetElementType: !1,
        dataElementType: "point",
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "borderWidth",
                    "radius"
                ]
            }
        }
    }, Ln.overrides = {
        scales: {
            x: {
                type: "linear"
            },
            y: {
                type: "linear"
            }
        },
        plugins: {
            tooltip: {
                callbacks: {
                    title: ()=>""
                }
            }
        }
    };
    class En extends Ls {
        constructor(t, e){
            super(t, e), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
        }
        linkScales() {}
        parse(t, e) {
            const i = this.getDataset().data, s = this._cachedMeta;
            if (!1 === this._parsing) s._parsed = i;
            else {
                let o, a, r = (t)=>+i[t];
                if (n(i[t])) {
                    const { key: t = "value" } = this._parsing;
                    r = (e)=>+y(i[e], t);
                }
                for(o = t, a = t + e; o < a; ++o)s._parsed[o] = r(o);
            }
        }
        _getRotation() {
            return H(this.options.rotation - 90);
        }
        _getCircumference() {
            return H(this.options.circumference);
        }
        _getRotationExtents() {
            let t = O, e = -O;
            for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i)) {
                const s = this.chart.getDatasetMeta(i).controller, n = s._getRotation(), o = s._getCircumference();
                t = Math.min(t, n), e = Math.max(e, n + o);
            }
            return {
                rotation: t,
                circumference: e - t
            };
        }
        update(t) {
            const e = this.chart, { chartArea: i } = e, s = this._cachedMeta, n = s.data, o = this.getMaxBorderWidth() + this.getMaxOffset(n) + this.options.spacing, a = Math.max((Math.min(i.width, i.height) - o) / 2, 0), r = Math.min(l(this.options.cutout, a), 1), c = this._getRingWeight(this.index), { circumference: d, rotation: u } = this._getRotationExtents(), { ratioX: f, ratioY: g, offsetX: p, offsetY: m } = function(t, e, i) {
                let s = 1, n = 1, o = 0, a = 0;
                if (e < O) {
                    const r = t, l = r + e, h = Math.cos(r), c = Math.sin(r), d = Math.cos(l), u = Math.sin(l), f = (t, e, s)=>G(t, r, l, !0) ? 1 : Math.max(e, e * i, s, s * i), g = (t, e, s)=>G(t, r, l, !0) ? -1 : Math.min(e, e * i, s, s * i), p = f(0, h, d), m = f(L, c, u), b = g(D, h, d), x = g(D + L, c, u);
                    s = (p - b) / 2, n = (m - x) / 2, o = -(p + b) / 2, a = -(m + x) / 2;
                }
                return {
                    ratioX: s,
                    ratioY: n,
                    offsetX: o,
                    offsetY: a
                };
            }(u, d, r), b = (i.width - o) / f, x = (i.height - o) / g, _ = Math.max(Math.min(b, x) / 2, 0), y = h(this.options.radius, _), v = (y - Math.max(y * r, 0)) / this._getVisibleDatasetWeightTotal();
            this.offsetX = p * y, this.offsetY = m * y, s.total = this.calculateTotal(), this.outerRadius = y - v * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - v * c, 0), this.updateElements(n, 0, n.length, t);
        }
        _circumference(t, e) {
            const i = this.options, s = this._cachedMeta, n = this._getCircumference();
            return e && i.animation.animateRotate || !this.chart.getDataVisibility(t) || null === s._parsed[t] || s.data[t].hidden ? 0 : this.calculateCircumference(s._parsed[t] * n / O);
        }
        updateElements(t, e, i, s) {
            const n = "reset" === s, o = this.chart, a = o.chartArea, r = o.options.animation, l = (a.left + a.right) / 2, h = (a.top + a.bottom) / 2, c = n && r.animateScale, d = c ? 0 : this.innerRadius, u = c ? 0 : this.outerRadius, { sharedOptions: f, includeOptions: g } = this._getSharedOptions(e, s);
            let p, m = this._getRotation();
            for(p = 0; p < e; ++p)m += this._circumference(p, n);
            for(p = e; p < e + i; ++p){
                const e = this._circumference(p, n), i = t[p], o = {
                    x: l + this.offsetX,
                    y: h + this.offsetY,
                    startAngle: m,
                    endAngle: m + e,
                    circumference: e,
                    outerRadius: u,
                    innerRadius: d
                };
                g && (o.options = f || this.resolveDataElementOptions(p, i.active ? "active" : s)), m += e, this.updateElement(i, p, o, s);
            }
        }
        calculateTotal() {
            const t = this._cachedMeta, e = t.data;
            let i, s = 0;
            for(i = 0; i < e.length; i++){
                const n = t._parsed[i];
                null === n || isNaN(n) || !this.chart.getDataVisibility(i) || e[i].hidden || (s += Math.abs(n));
            }
            return s;
        }
        calculateCircumference(t) {
            const e = this._cachedMeta.total;
            return e > 0 && !isNaN(t) ? O * (Math.abs(t) / e) : 0;
        }
        getLabelAndValue(t) {
            const e = this._cachedMeta, i = this.chart, s = i.data.labels || [], n = li(e._parsed[t], i.options.locale);
            return {
                label: s[t] || "",
                value: n
            };
        }
        getMaxBorderWidth(t) {
            let e = 0;
            const i = this.chart;
            let s, n, o, a, r;
            if (!t) {
                for(s = 0, n = i.data.datasets.length; s < n; ++s)if (i.isDatasetVisible(s)) {
                    o = i.getDatasetMeta(s), t = o.data, a = o.controller;
                    break;
                }
            }
            if (!t) return 0;
            for(s = 0, n = t.length; s < n; ++s)r = a.resolveDataElementOptions(s), "inner" !== r.borderAlign && (e = Math.max(e, r.borderWidth || 0, r.hoverBorderWidth || 0));
            return e;
        }
        getMaxOffset(t) {
            let e = 0;
            for(let i = 0, s = t.length; i < s; ++i){
                const t = this.resolveDataElementOptions(i);
                e = Math.max(e, t.offset || 0, t.hoverOffset || 0);
            }
            return e;
        }
        _getRingWeightOffset(t) {
            let e = 0;
            for(let i = 0; i < t; ++i)this.chart.isDatasetVisible(i) && (e += this._getRingWeight(i));
            return e;
        }
        _getRingWeight(t) {
            return Math.max(r(this.chart.data.datasets[t].weight, 1), 0);
        }
        _getVisibleDatasetWeightTotal() {
            return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
        }
    }
    En.id = "doughnut", En.defaults = {
        datasetElementType: !1,
        dataElementType: "arc",
        animation: {
            animateRotate: !0,
            animateScale: !1
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "circumference",
                    "endAngle",
                    "innerRadius",
                    "outerRadius",
                    "startAngle",
                    "x",
                    "y",
                    "offset",
                    "borderWidth",
                    "spacing"
                ]
            }
        },
        cutout: "50%",
        rotation: 0,
        circumference: 360,
        radius: "100%",
        spacing: 0,
        indexAxis: "r"
    }, En.descriptors = {
        _scriptable: (t)=>"spacing" !== t,
        _indexable: (t)=>"spacing" !== t
    }, En.overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (t) {
                        const e = t.data;
                        if (e.labels.length && e.datasets.length) {
                            const { labels: { pointStyle: i } } = t.legend.options;
                            return e.labels.map((e, s)=>{
                                const n = t.getDatasetMeta(0).controller.getStyle(s);
                                return {
                                    text: e,
                                    fillStyle: n.backgroundColor,
                                    strokeStyle: n.borderColor,
                                    lineWidth: n.borderWidth,
                                    pointStyle: i,
                                    hidden: !t.getDataVisibility(s),
                                    index: s
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (t, e, i) {
                    i.chart.toggleDataVisibility(e.index), i.chart.update();
                }
            },
            tooltip: {
                callbacks: {
                    title: ()=>"",
                    label (t) {
                        let e = t.label;
                        const i = ": " + t.formattedValue;
                        return s(e) ? (e = e.slice(), e[0] += i) : e += i, e;
                    }
                }
            }
        }
    };
    class Rn extends Ls {
        initialize() {
            this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
        }
        update(t) {
            const e = this._cachedMeta, { dataset: i, data: s = [], _dataset: n } = e, o = this.chart._animationsDisabled;
            let { start: a, count: r } = gt(e, s, o);
            this._drawStart = a, this._drawCount = r, pt(e) && (a = 0, r = s.length), i._chart = this.chart, i._datasetIndex = this.index, i._decimated = !!n._decimated, i.points = s;
            const l = this.resolveDatasetElementOptions(t);
            this.options.showLine || (l.borderWidth = 0), l.segment = this.options.segment, this.updateElement(i, void 0, {
                animated: !o,
                options: l
            }, t), this.updateElements(s, a, r, t);
        }
        updateElements(t, e, s, n) {
            const o = "reset" === n, { iScale: a, vScale: r, _stacked: l, _dataset: h } = this._cachedMeta, { sharedOptions: c, includeOptions: d } = this._getSharedOptions(e, n), u = a.axis, f = r.axis, { spanGaps: g, segment: p } = this.options, m = B(g) ? g : Number.POSITIVE_INFINITY, b = this.chart._animationsDisabled || o || "none" === n;
            let x = e > 0 && this.getParsed(e - 1);
            for(let g = e; g < e + s; ++g){
                const e = t[g], s = this.getParsed(g), _ = b ? e : {}, y = i(s[f]), v = _[u] = a.getPixelForValue(s[u], g), w = _[f] = o || y ? r.getBasePixel() : r.getPixelForValue(l ? this.applyStack(r, s, l) : s[f], g);
                _.skip = isNaN(v) || isNaN(w) || y, _.stop = g > 0 && Math.abs(s[u] - x[u]) > m, p && (_.parsed = s, _.raw = h.data[g]), d && (_.options = c || this.resolveDataElementOptions(g, e.active ? "active" : n)), b || this.updateElement(e, g, _, n), x = s;
            }
        }
        getMaxOverflow() {
            const t = this._cachedMeta, e = t.dataset, i = e.options && e.options.borderWidth || 0, s = t.data || [];
            if (!s.length) return i;
            const n = s[0].size(this.resolveDataElementOptions(0)), o = s[s.length - 1].size(this.resolveDataElementOptions(s.length - 1));
            return Math.max(i, n, o) / 2;
        }
        draw() {
            const t = this._cachedMeta;
            t.dataset.updateControlPoints(this.chart.chartArea, t.iScale.axis), super.draw();
        }
    }
    Rn.id = "line", Rn.defaults = {
        datasetElementType: "line",
        dataElementType: "point",
        showLine: !0,
        spanGaps: !1
    }, Rn.overrides = {
        scales: {
            _index_: {
                type: "category"
            },
            _value_: {
                type: "linear"
            }
        }
    };
    class In extends Ls {
        constructor(t, e){
            super(t, e), this.innerRadius = void 0, this.outerRadius = void 0;
        }
        getLabelAndValue(t) {
            const e = this._cachedMeta, i = this.chart, s = i.data.labels || [], n = li(e._parsed[t].r, i.options.locale);
            return {
                label: s[t] || "",
                value: n
            };
        }
        parseObjectData(t, e, i, s) {
            return Ue.bind(this)(t, e, i, s);
        }
        update(t) {
            const e = this._cachedMeta.data;
            this._updateRadius(), this.updateElements(e, 0, e.length, t);
        }
        getMinMax() {
            const t = this._cachedMeta, e = {
                min: Number.POSITIVE_INFINITY,
                max: Number.NEGATIVE_INFINITY
            };
            return t.data.forEach((t, i)=>{
                const s = this.getParsed(i).r;
                !isNaN(s) && this.chart.getDataVisibility(i) && (s < e.min && (e.min = s), s > e.max && (e.max = s));
            }), e;
        }
        _updateRadius() {
            const t = this.chart, e = t.chartArea, i = t.options, s = Math.min(e.right - e.left, e.bottom - e.top), n = Math.max(s / 2, 0), o = (n - Math.max(i.cutoutPercentage ? n / 100 * i.cutoutPercentage : 1, 0)) / t.getVisibleDatasetCount();
            this.outerRadius = n - o * this.index, this.innerRadius = this.outerRadius - o;
        }
        updateElements(t, e, i, s) {
            const n = "reset" === s, o = this.chart, a = o.options.animation, r = this._cachedMeta.rScale, l = r.xCenter, h = r.yCenter, c = r.getIndexAngle(0) - .5 * D;
            let d, u = c;
            const f = 360 / this.countVisibleElements();
            for(d = 0; d < e; ++d)u += this._computeAngle(d, s, f);
            for(d = e; d < e + i; d++){
                const e = t[d];
                let i = u, g = u + this._computeAngle(d, s, f), p = o.getDataVisibility(d) ? r.getDistanceFromCenterForValue(this.getParsed(d).r) : 0;
                u = g, n && (a.animateScale && (p = 0), a.animateRotate && (i = g = c));
                const m = {
                    x: l,
                    y: h,
                    innerRadius: 0,
                    outerRadius: p,
                    startAngle: i,
                    endAngle: g,
                    options: this.resolveDataElementOptions(d, e.active ? "active" : s)
                };
                this.updateElement(e, d, m, s);
            }
        }
        countVisibleElements() {
            const t = this._cachedMeta;
            let e = 0;
            return t.data.forEach((t, i)=>{
                !isNaN(this.getParsed(i).r) && this.chart.getDataVisibility(i) && e++;
            }), e;
        }
        _computeAngle(t, e, i) {
            return this.chart.getDataVisibility(t) ? H(this.resolveDataElementOptions(t, e).angle || i) : 0;
        }
    }
    In.id = "polarArea", In.defaults = {
        dataElementType: "arc",
        animation: {
            animateRotate: !0,
            animateScale: !0
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "startAngle",
                    "endAngle",
                    "innerRadius",
                    "outerRadius"
                ]
            }
        },
        indexAxis: "r",
        startAngle: 0
    }, In.overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (t) {
                        const e = t.data;
                        if (e.labels.length && e.datasets.length) {
                            const { labels: { pointStyle: i } } = t.legend.options;
                            return e.labels.map((e, s)=>{
                                const n = t.getDatasetMeta(0).controller.getStyle(s);
                                return {
                                    text: e,
                                    fillStyle: n.backgroundColor,
                                    strokeStyle: n.borderColor,
                                    lineWidth: n.borderWidth,
                                    pointStyle: i,
                                    hidden: !t.getDataVisibility(s),
                                    index: s
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (t, e, i) {
                    i.chart.toggleDataVisibility(e.index), i.chart.update();
                }
            },
            tooltip: {
                callbacks: {
                    title: ()=>"",
                    label: (t)=>t.chart.data.labels[t.dataIndex] + ": " + t.formattedValue
                }
            }
        },
        scales: {
            r: {
                type: "radialLinear",
                angleLines: {
                    display: !1
                },
                beginAtZero: !0,
                grid: {
                    circular: !0
                },
                pointLabels: {
                    display: !1
                },
                startAngle: 0
            }
        }
    };
    class zn extends En {
    }
    zn.id = "pie", zn.defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: "100%"
    };
    class Fn extends Ls {
        getLabelAndValue(t) {
            const e = this._cachedMeta.vScale, i = this.getParsed(t);
            return {
                label: e.getLabels()[t],
                value: "" + e.getLabelForValue(i[e.axis])
            };
        }
        parseObjectData(t, e, i, s) {
            return Ue.bind(this)(t, e, i, s);
        }
        update(t) {
            const e = this._cachedMeta, i = e.dataset, s = e.data || [], n = e.iScale.getLabels();
            if (i.points = s, "resize" !== t) {
                const e = this.resolveDatasetElementOptions(t);
                this.options.showLine || (e.borderWidth = 0);
                const o = {
                    _loop: !0,
                    _fullLoop: n.length === s.length,
                    options: e
                };
                this.updateElement(i, void 0, o, t);
            }
            this.updateElements(s, 0, s.length, t);
        }
        updateElements(t, e, i, s) {
            const n = this._cachedMeta.rScale, o = "reset" === s;
            for(let a = e; a < e + i; a++){
                const e = t[a], i = this.resolveDataElementOptions(a, e.active ? "active" : s), r = n.getPointPositionForValue(a, this.getParsed(a).r), l = o ? n.xCenter : r.x, h = o ? n.yCenter : r.y, c = {
                    x: l,
                    y: h,
                    angle: r.angle,
                    skip: isNaN(l) || isNaN(h),
                    options: i
                };
                this.updateElement(e, a, c, s);
            }
        }
    }
    Fn.id = "radar", Fn.defaults = {
        datasetElementType: "line",
        dataElementType: "point",
        indexAxis: "r",
        showLine: !0,
        elements: {
            line: {
                fill: "start"
            }
        }
    }, Fn.overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: "radialLinear"
            }
        }
    };
    class Vn extends Ls {
        update(t) {
            const e = this._cachedMeta, { data: i = [] } = e, s = this.chart._animationsDisabled;
            let { start: n, count: o } = gt(e, i, s);
            if (this._drawStart = n, this._drawCount = o, pt(e) && (n = 0, o = i.length), this.options.showLine) {
                const { dataset: n, _dataset: o } = e;
                n._chart = this.chart, n._datasetIndex = this.index, n._decimated = !!o._decimated, n.points = i;
                const a = this.resolveDatasetElementOptions(t);
                a.segment = this.options.segment, this.updateElement(n, void 0, {
                    animated: !s,
                    options: a
                }, t);
            }
            this.updateElements(i, n, o, t);
        }
        addElements() {
            const { showLine: t } = this.options;
            !this.datasetElementType && t && (this.datasetElementType = Us.getElement("line")), super.addElements();
        }
        updateElements(t, e, s, n) {
            const o = "reset" === n, { iScale: a, vScale: r, _stacked: l, _dataset: h } = this._cachedMeta, c = this.resolveDataElementOptions(e, n), d = this.getSharedOptions(c), u = this.includeOptions(n, d), f = a.axis, g = r.axis, { spanGaps: p, segment: m } = this.options, b = B(p) ? p : Number.POSITIVE_INFINITY, x = this.chart._animationsDisabled || o || "none" === n;
            let _ = e > 0 && this.getParsed(e - 1);
            for(let c = e; c < e + s; ++c){
                const e = t[c], s = this.getParsed(c), p = x ? e : {}, y = i(s[g]), v = p[f] = a.getPixelForValue(s[f], c), w = p[g] = o || y ? r.getBasePixel() : r.getPixelForValue(l ? this.applyStack(r, s, l) : s[g], c);
                p.skip = isNaN(v) || isNaN(w) || y, p.stop = c > 0 && Math.abs(s[f] - _[f]) > b, m && (p.parsed = s, p.raw = h.data[c]), u && (p.options = d || this.resolveDataElementOptions(c, e.active ? "active" : n)), x || this.updateElement(e, c, p, n), _ = s;
            }
            this.updateSharedOptions(d, n, c);
        }
        getMaxOverflow() {
            const t = this._cachedMeta, e = t.data || [];
            if (!this.options.showLine) {
                let t = 0;
                for(let i = e.length - 1; i >= 0; --i)t = Math.max(t, e[i].size(this.resolveDataElementOptions(i)) / 2);
                return t > 0 && t;
            }
            const i = t.dataset, s = i.options && i.options.borderWidth || 0;
            if (!e.length) return s;
            const n = e[0].size(this.resolveDataElementOptions(0)), o = e[e.length - 1].size(this.resolveDataElementOptions(e.length - 1));
            return Math.max(s, n, o) / 2;
        }
    }
    Vn.id = "scatter", Vn.defaults = {
        datasetElementType: !1,
        dataElementType: "point",
        showLine: !1,
        fill: !1
    }, Vn.overrides = {
        interaction: {
            mode: "point"
        },
        plugins: {
            tooltip: {
                callbacks: {
                    title: ()=>"",
                    label: (t)=>"(" + t.label + ", " + t.formattedValue + ")"
                }
            }
        },
        scales: {
            x: {
                type: "linear"
            },
            y: {
                type: "linear"
            }
        }
    };
    var Bn = Object.freeze({
        __proto__: null,
        BarController: Tn,
        BubbleController: Ln,
        DoughnutController: En,
        LineController: Rn,
        PolarAreaController: In,
        PieController: zn,
        RadarController: Fn,
        ScatterController: Vn
    });
    function Nn(t, e, i) {
        const { startAngle: s, pixelMargin: n, x: o, y: a, outerRadius: r, innerRadius: l } = e;
        let h = n / r;
        t.beginPath(), t.arc(o, a, r, s - h, i + h), l > n ? (h = n / l, t.arc(o, a, l, i + h, s - h, !0)) : t.arc(o, a, n, i + L, s - L), t.closePath(), t.clip();
    }
    function Wn(t, e, i, s) {
        const n = ui(t.options.borderRadius, [
            "outerStart",
            "outerEnd",
            "innerStart",
            "innerEnd"
        ]);
        const o = (i - e) / 2, a = Math.min(o, s * e / 2), r = (t)=>{
            const e = (i - Math.min(o, t)) * s / 2;
            return Z(t, 0, Math.min(o, e));
        };
        return {
            outerStart: r(n.outerStart),
            outerEnd: r(n.outerEnd),
            innerStart: Z(n.innerStart, 0, a),
            innerEnd: Z(n.innerEnd, 0, a)
        };
    }
    function jn(t, e, i, s) {
        return {
            x: i + t * Math.cos(e),
            y: s + t * Math.sin(e)
        };
    }
    function Hn(t, e, i, s, n, o) {
        const { x: a, y: r, startAngle: l, pixelMargin: h, innerRadius: c } = e, d = Math.max(e.outerRadius + s + i - h, 0), u = c > 0 ? c + s + i + h : 0;
        let f = 0;
        const g = n - l;
        if (s) {
            const t = ((c > 0 ? c - s : 0) + (d > 0 ? d - s : 0)) / 2;
            f = (g - (0 !== t ? g * t / (t + s) : g)) / 2;
        }
        const p = (g - Math.max(.001, g * d - i / D) / d) / 2, m = l + p + f, b = n - p - f, { outerStart: x, outerEnd: _, innerStart: y, innerEnd: v } = Wn(e, u, d, b - m), w = d - x, M = d - _, k = m + x / w, S = b - _ / M, P = u + y, O = u + v, C = m + y / P, A = b - v / O;
        if (t.beginPath(), o) {
            if (t.arc(a, r, d, k, S), _ > 0) {
                const e = jn(M, S, a, r);
                t.arc(e.x, e.y, _, S, b + L);
            }
            const e = jn(O, b, a, r);
            if (t.lineTo(e.x, e.y), v > 0) {
                const e = jn(O, A, a, r);
                t.arc(e.x, e.y, v, b + L, A + Math.PI);
            }
            if (t.arc(a, r, u, b - v / u, m + y / u, !0), y > 0) {
                const e = jn(P, C, a, r);
                t.arc(e.x, e.y, y, C + Math.PI, m - L);
            }
            const i = jn(w, m, a, r);
            if (t.lineTo(i.x, i.y), x > 0) {
                const e = jn(w, k, a, r);
                t.arc(e.x, e.y, x, m - L, k);
            }
        } else {
            t.moveTo(a, r);
            const e = Math.cos(k) * d + a, i = Math.sin(k) * d + r;
            t.lineTo(e, i);
            const s = Math.cos(S) * d + a, n = Math.sin(S) * d + r;
            t.lineTo(s, n);
        }
        t.closePath();
    }
    function $n(t, e, i, s, n, o) {
        const { options: a } = e, { borderWidth: r, borderJoinStyle: l } = a, h = "inner" === a.borderAlign;
        r && (h ? (t.lineWidth = 2 * r, t.lineJoin = l || "round") : (t.lineWidth = r, t.lineJoin = l || "bevel"), e.fullCircles && function(t, e, i) {
            const { x: s, y: n, startAngle: o, pixelMargin: a, fullCircles: r } = e, l = Math.max(e.outerRadius - a, 0), h = e.innerRadius + a;
            let c;
            for(i && Nn(t, e, o + O), t.beginPath(), t.arc(s, n, h, o + O, o, !0), c = 0; c < r; ++c)t.stroke();
            for(t.beginPath(), t.arc(s, n, l, o, o + O), c = 0; c < r; ++c)t.stroke();
        }(t, e, h), h && Nn(t, e, n), Hn(t, e, i, s, n, o), t.stroke());
    }
    class Yn extends Es {
        constructor(t){
            super(), this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, t && Object.assign(this, t);
        }
        inRange(t, e, i) {
            const s = this.getProps([
                "x",
                "y"
            ], i), { angle: n, distance: o } = U(s, {
                x: t,
                y: e
            }), { startAngle: a, endAngle: l, innerRadius: h, outerRadius: c, circumference: d } = this.getProps([
                "startAngle",
                "endAngle",
                "innerRadius",
                "outerRadius",
                "circumference"
            ], i), u = this.options.spacing / 2, f = r(d, l - a) >= O || G(n, a, l), g = Q(o, h + u, c + u);
            return f && g;
        }
        getCenterPoint(t) {
            const { x: e, y: i, startAngle: s, endAngle: n, innerRadius: o, outerRadius: a } = this.getProps([
                "x",
                "y",
                "startAngle",
                "endAngle",
                "innerRadius",
                "outerRadius",
                "circumference"
            ], t), { offset: r, spacing: l } = this.options, h = (s + n) / 2, c = (o + a + l + r) / 2;
            return {
                x: e + Math.cos(h) * c,
                y: i + Math.sin(h) * c
            };
        }
        tooltipPosition(t) {
            return this.getCenterPoint(t);
        }
        draw(t) {
            const { options: e, circumference: i } = this, s = (e.offset || 0) / 2, n = (e.spacing || 0) / 2, o = e.circular;
            if (this.pixelMargin = "inner" === e.borderAlign ? .33 : 0, this.fullCircles = i > O ? Math.floor(i / O) : 0, 0 === i || this.innerRadius < 0 || this.outerRadius < 0) return;
            t.save();
            let a = 0;
            if (s) {
                a = s / 2;
                const e = (this.startAngle + this.endAngle) / 2;
                t.translate(Math.cos(e) * a, Math.sin(e) * a), this.circumference >= D && (a = s);
            }
            t.fillStyle = e.backgroundColor, t.strokeStyle = e.borderColor;
            const r = function(t, e, i, s, n) {
                const { fullCircles: o, startAngle: a, circumference: r } = e;
                let l = e.endAngle;
                if (o) {
                    Hn(t, e, i, s, a + O, n);
                    for(let e = 0; e < o; ++e)t.fill();
                    isNaN(r) || (l = a + r % O, r % O == 0 && (l += O));
                }
                return Hn(t, e, i, s, l, n), t.fill(), l;
            }(t, this, a, n, o);
            $n(t, this, a, n, r, o), t.restore();
        }
    }
    function Un(t, e, i = e) {
        t.lineCap = r(i.borderCapStyle, e.borderCapStyle), t.setLineDash(r(i.borderDash, e.borderDash)), t.lineDashOffset = r(i.borderDashOffset, e.borderDashOffset), t.lineJoin = r(i.borderJoinStyle, e.borderJoinStyle), t.lineWidth = r(i.borderWidth, e.borderWidth), t.strokeStyle = r(i.borderColor, e.borderColor);
    }
    function Xn(t, e, i) {
        t.lineTo(i.x, i.y);
    }
    function qn(t, e, i = {}) {
        const s = t.length, { start: n = 0, end: o = s - 1 } = i, { start: a, end: r } = e, l = Math.max(n, a), h = Math.min(o, r), c = n < a && o < a || n > r && o > r;
        return {
            count: s,
            start: l,
            loop: e.loop,
            ilen: h < l && !c ? s + h - l : h - l
        };
    }
    function Kn(t, e, i, s) {
        const { points: n, options: o } = e, { count: a, start: r, loop: l, ilen: h } = qn(n, i, s), c = function(t) {
            return t.stepped ? Oe : t.tension || "monotone" === t.cubicInterpolationMode ? Ce : Xn;
        }(o);
        let d, u, f, { move: g = !0, reverse: p } = s || {};
        for(d = 0; d <= h; ++d)u = n[(r + (p ? h - d : d)) % a], u.skip || (g ? (t.moveTo(u.x, u.y), g = !1) : c(t, f, u, p, o.stepped), f = u);
        return l && (u = n[(r + (p ? h : 0)) % a], c(t, f, u, p, o.stepped)), !!l;
    }
    function Gn(t, e, i, s) {
        const n = e.points, { count: o, start: a, ilen: r } = qn(n, i, s), { move: l = !0, reverse: h } = s || {};
        let c, d, u, f, g, p, m = 0, b = 0;
        const x = (t)=>(a + (h ? r - t : t)) % o, _ = ()=>{
            f !== g && (t.lineTo(m, g), t.lineTo(m, f), t.lineTo(m, p));
        };
        for(l && (d = n[x(0)], t.moveTo(d.x, d.y)), c = 0; c <= r; ++c){
            if (d = n[x(c)], d.skip) continue;
            const e = d.x, i = d.y, s = 0 | e;
            s === u ? (i < f ? f = i : i > g && (g = i), m = (b * m + e) / ++b) : (_(), t.lineTo(e, i), u = s, b = 0, f = g = i), p = i;
        }
        _();
    }
    function Zn(t) {
        const e = t.options, i = e.borderDash && e.borderDash.length;
        return !(t._decimated || t._loop || e.tension || "monotone" === e.cubicInterpolationMode || e.stepped || i) ? Gn : Kn;
    }
    Yn.id = "arc", Yn.defaults = {
        borderAlign: "center",
        borderColor: "#fff",
        borderJoinStyle: void 0,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: void 0,
        circular: !0
    }, Yn.defaultRoutes = {
        backgroundColor: "backgroundColor"
    };
    const Jn = "function" == typeof Path2D;
    function Qn(t, e, i, s) {
        Jn && !e.options.segment ? function(t, e, i, s) {
            let n = e._path;
            n || (n = e._path = new Path2D, e.path(n, i, s) && n.closePath()), Un(t, e.options), t.stroke(n);
        }(t, e, i, s) : function(t, e, i, s) {
            const { segments: n, options: o } = e, a = Zn(e);
            for (const r of n)Un(t, o, r.style), t.beginPath(), a(t, e, r, {
                start: i,
                end: i + s - 1
            }) && t.closePath(), t.stroke();
        }(t, e, i, s);
    }
    class to extends Es {
        constructor(t){
            super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, t && Object.assign(this, t);
        }
        updateControlPoints(t, e) {
            const i = this.options;
            if ((i.tension || "monotone" === i.cubicInterpolationMode) && !i.stepped && !this._pointsUpdated) {
                const s = i.spanGaps ? this._loop : this._fullLoop;
                Qe(this._points, i, t, s, e), this._pointsUpdated = !0;
            }
        }
        set points(t) {
            this._points = t, delete this._segments, delete this._path, this._pointsUpdated = !1;
        }
        get points() {
            return this._points;
        }
        get segments() {
            return this._segments || (this._segments = Di(this, this.options.segment));
        }
        first() {
            const t = this.segments, e = this.points;
            return t.length && e[t[0].start];
        }
        last() {
            const t = this.segments, e = this.points, i = t.length;
            return i && e[t[i - 1].end];
        }
        interpolate(t, e) {
            const i = this.options, s = t[e], n = this.points, o = Pi(this, {
                property: e,
                start: s,
                end: s
            });
            if (!o.length) return;
            const a = [], r = function(t) {
                return t.stepped ? oi : t.tension || "monotone" === t.cubicInterpolationMode ? ai : ni;
            }(i);
            let l, h;
            for(l = 0, h = o.length; l < h; ++l){
                const { start: h, end: c } = o[l], d = n[h], u = n[c];
                if (d === u) {
                    a.push(d);
                    continue;
                }
                const f = r(d, u, Math.abs((s - d[e]) / (u[e] - d[e])), i.stepped);
                f[e] = t[e], a.push(f);
            }
            return 1 === a.length ? a[0] : a;
        }
        pathSegment(t, e, i) {
            return Zn(this)(t, this, e, i);
        }
        path(t, e, i) {
            const s = this.segments, n = Zn(this);
            let o = this._loop;
            e = e || 0, i = i || this.points.length - e;
            for (const a of s)o &= n(t, this, a, {
                start: e,
                end: e + i - 1
            });
            return !!o;
        }
        draw(t, e, i, s) {
            const n = this.options || {};
            (this.points || []).length && n.borderWidth && (t.save(), Qn(t, this, i, s), t.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
        }
    }
    function eo(t, e, i, s) {
        const n = t.options, { [i]: o } = t.getProps([
            i
        ], s);
        return Math.abs(e - o) < n.radius + n.hitRadius;
    }
    to.id = "line", to.defaults = {
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: "miter",
        borderWidth: 3,
        capBezierPoints: !0,
        cubicInterpolationMode: "default",
        fill: !1,
        spanGaps: !1,
        stepped: !1,
        tension: 0
    }, to.defaultRoutes = {
        backgroundColor: "backgroundColor",
        borderColor: "borderColor"
    }, to.descriptors = {
        _scriptable: !0,
        _indexable: (t)=>"borderDash" !== t && "fill" !== t
    };
    class io extends Es {
        constructor(t){
            super(), this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, t && Object.assign(this, t);
        }
        inRange(t, e, i) {
            const s = this.options, { x: n, y: o } = this.getProps([
                "x",
                "y"
            ], i);
            return Math.pow(t - n, 2) + Math.pow(e - o, 2) < Math.pow(s.hitRadius + s.radius, 2);
        }
        inXRange(t, e) {
            return eo(this, t, "x", e);
        }
        inYRange(t, e) {
            return eo(this, t, "y", e);
        }
        getCenterPoint(t) {
            const { x: e, y: i } = this.getProps([
                "x",
                "y"
            ], t);
            return {
                x: e,
                y: i
            };
        }
        size(t) {
            let e = (t = t || this.options || {}).radius || 0;
            e = Math.max(e, e && t.hoverRadius || 0);
            return 2 * (e + (e && t.borderWidth || 0));
        }
        draw(t, e) {
            const i = this.options;
            this.skip || i.radius < .1 || !Se(this, e, this.size(i) / 2) || (t.strokeStyle = i.borderColor, t.lineWidth = i.borderWidth, t.fillStyle = i.backgroundColor, Me(t, i, this.x, this.y));
        }
        getRange() {
            const t = this.options || {};
            return t.radius + t.hitRadius;
        }
    }
    function so(t, e) {
        const { x: i, y: s, base: n, width: o, height: a } = t.getProps([
            "x",
            "y",
            "base",
            "width",
            "height"
        ], e);
        let r, l, h, c, d;
        return t.horizontal ? (d = a / 2, r = Math.min(i, n), l = Math.max(i, n), h = s - d, c = s + d) : (d = o / 2, r = i - d, l = i + d, h = Math.min(s, n), c = Math.max(s, n)), {
            left: r,
            top: h,
            right: l,
            bottom: c
        };
    }
    function no(t, e, i, s) {
        return t ? 0 : Z(e, i, s);
    }
    function oo(t) {
        const e = so(t), i = e.right - e.left, s = e.bottom - e.top, o = function(t, e, i) {
            const s = t.options.borderWidth, n = t.borderSkipped, o = fi(s);
            return {
                t: no(n.top, o.top, 0, i),
                r: no(n.right, o.right, 0, e),
                b: no(n.bottom, o.bottom, 0, i),
                l: no(n.left, o.left, 0, e)
            };
        }(t, i / 2, s / 2), a = function(t, e, i) {
            const { enableBorderRadius: s } = t.getProps([
                "enableBorderRadius"
            ]), o = t.options.borderRadius, a = gi(o), r = Math.min(e, i), l = t.borderSkipped, h = s || n(o);
            return {
                topLeft: no(!h || l.top || l.left, a.topLeft, 0, r),
                topRight: no(!h || l.top || l.right, a.topRight, 0, r),
                bottomLeft: no(!h || l.bottom || l.left, a.bottomLeft, 0, r),
                bottomRight: no(!h || l.bottom || l.right, a.bottomRight, 0, r)
            };
        }(t, i / 2, s / 2);
        return {
            outer: {
                x: e.left,
                y: e.top,
                w: i,
                h: s,
                radius: a
            },
            inner: {
                x: e.left + o.l,
                y: e.top + o.t,
                w: i - o.l - o.r,
                h: s - o.t - o.b,
                radius: {
                    topLeft: Math.max(0, a.topLeft - Math.max(o.t, o.l)),
                    topRight: Math.max(0, a.topRight - Math.max(o.t, o.r)),
                    bottomLeft: Math.max(0, a.bottomLeft - Math.max(o.b, o.l)),
                    bottomRight: Math.max(0, a.bottomRight - Math.max(o.b, o.r))
                }
            }
        };
    }
    function ao(t, e, i, s) {
        const n = null === e, o = null === i, a = t && !(n && o) && so(t, s);
        return a && (n || Q(e, a.left, a.right)) && (o || Q(i, a.top, a.bottom));
    }
    function ro(t, e) {
        t.rect(e.x, e.y, e.w, e.h);
    }
    function lo(t, e, i = {}) {
        const s = t.x !== i.x ? -e : 0, n = t.y !== i.y ? -e : 0, o = (t.x + t.w !== i.x + i.w ? e : 0) - s, a = (t.y + t.h !== i.y + i.h ? e : 0) - n;
        return {
            x: t.x + s,
            y: t.y + n,
            w: t.w + o,
            h: t.h + a,
            radius: t.radius
        };
    }
    io.id = "point", io.defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: "circle",
        radius: 3,
        rotation: 0
    }, io.defaultRoutes = {
        backgroundColor: "backgroundColor",
        borderColor: "borderColor"
    };
    class ho extends Es {
        constructor(t){
            super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, t && Object.assign(this, t);
        }
        draw(t) {
            const { inflateAmount: e, options: { borderColor: i, backgroundColor: s } } = this, { inner: n, outer: o } = oo(this), a = (r = o.radius).topLeft || r.topRight || r.bottomLeft || r.bottomRight ? Le : ro;
            var r;
            t.save(), o.w === n.w && o.h === n.h || (t.beginPath(), a(t, lo(o, e, n)), t.clip(), a(t, lo(n, -e, o)), t.fillStyle = i, t.fill("evenodd")), t.beginPath(), a(t, lo(n, e)), t.fillStyle = s, t.fill(), t.restore();
        }
        inRange(t, e, i) {
            return ao(this, t, e, i);
        }
        inXRange(t, e) {
            return ao(this, t, null, e);
        }
        inYRange(t, e) {
            return ao(this, null, t, e);
        }
        getCenterPoint(t) {
            const { x: e, y: i, base: s, horizontal: n } = this.getProps([
                "x",
                "y",
                "base",
                "horizontal"
            ], t);
            return {
                x: n ? (e + s) / 2 : e,
                y: n ? i : (i + s) / 2
            };
        }
        getRange(t) {
            return "x" === t ? this.width / 2 : this.height / 2;
        }
    }
    ho.id = "bar", ho.defaults = {
        borderSkipped: "start",
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: "auto",
        pointStyle: void 0
    }, ho.defaultRoutes = {
        backgroundColor: "backgroundColor",
        borderColor: "borderColor"
    };
    var co = Object.freeze({
        __proto__: null,
        ArcElement: Yn,
        LineElement: to,
        PointElement: io,
        BarElement: ho
    });
    function uo(t) {
        if (t._decimated) {
            const e = t._data;
            delete t._decimated, delete t._data, Object.defineProperty(t, "data", {
                value: e
            });
        }
    }
    function fo(t) {
        t.data.datasets.forEach((t)=>{
            uo(t);
        });
    }
    var go = {
        id: "decimation",
        defaults: {
            algorithm: "min-max",
            enabled: !1
        },
        beforeElementsUpdate: (t, e, s)=>{
            if (!s.enabled) return void fo(t);
            const n = t.width;
            t.data.datasets.forEach((e, o)=>{
                const { _data: a, indexAxis: r } = e, l = t.getDatasetMeta(o), h = a || e.data;
                if ("y" === bi([
                    r,
                    t.options.indexAxis
                ])) return;
                if (!l.controller.supportsDecimation) return;
                const c = t.scales[l.xAxisID];
                if ("linear" !== c.type && "time" !== c.type) return;
                if (t.options.parsing) return;
                let { start: d, count: u } = function(t, e) {
                    const i = e.length;
                    let s, n = 0;
                    const { iScale: o } = t, { min: a, max: r, minDefined: l, maxDefined: h } = o.getUserBounds();
                    return l && (n = Z(et(e, o.axis, a).lo, 0, i - 1)), s = h ? Z(et(e, o.axis, r).hi + 1, n, i) - n : i - n, {
                        start: n,
                        count: s
                    };
                }(l, h);
                if (u <= (s.threshold || 4 * n)) return void uo(e);
                let f;
                switch(i(a) && (e._data = h, delete e.data, Object.defineProperty(e, "data", {
                    configurable: !0,
                    enumerable: !0,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(t) {
                        this._data = t;
                    }
                })), s.algorithm){
                    case "lttb":
                        f = function(t, e, i, s, n) {
                            const o = n.samples || s;
                            if (o >= i) return t.slice(e, e + i);
                            const a = [], r = (i - 2) / (o - 2);
                            let l = 0;
                            const h = e + i - 1;
                            let c, d, u, f, g, p = e;
                            for(a[l++] = t[p], c = 0; c < o - 2; c++){
                                let s, n = 0, o = 0;
                                const h = Math.floor((c + 1) * r) + 1 + e, m = Math.min(Math.floor((c + 2) * r) + 1, i) + e, b = m - h;
                                for(s = h; s < m; s++)n += t[s].x, o += t[s].y;
                                n /= b, o /= b;
                                const x = Math.floor(c * r) + 1 + e, _ = Math.min(Math.floor((c + 1) * r) + 1, i) + e, { x: y, y: v } = t[p];
                                for(u = f = -1, s = x; s < _; s++)f = .5 * Math.abs((y - n) * (t[s].y - v) - (y - t[s].x) * (o - v)), f > u && (u = f, d = t[s], g = s);
                                a[l++] = d, p = g;
                            }
                            return a[l++] = t[h], a;
                        }(h, d, u, n, s);
                        break;
                    case "min-max":
                        f = function(t, e, s, n) {
                            let o, a, r, l, h, c, d, u, f, g, p = 0, m = 0;
                            const b = [], x = e + s - 1, _ = t[e].x, y = t[x].x - _;
                            for(o = e; o < e + s; ++o){
                                a = t[o], r = (a.x - _) / y * n, l = a.y;
                                const e = 0 | r;
                                if (e === h) l < f ? (f = l, c = o) : l > g && (g = l, d = o), p = (m * p + a.x) / ++m;
                                else {
                                    const s = o - 1;
                                    if (!i(c) && !i(d)) {
                                        const e = Math.min(c, d), i = Math.max(c, d);
                                        e !== u && e !== s && b.push({
                                            ...t[e],
                                            x: p
                                        }), i !== u && i !== s && b.push({
                                            ...t[i],
                                            x: p
                                        });
                                    }
                                    o > 0 && s !== u && b.push(t[s]), b.push(a), h = e, m = 0, f = g = l, c = d = u = o;
                                }
                            }
                            return b;
                        }(h, d, u, n);
                        break;
                    default:
                        throw new Error(`Unsupported decimation algorithm '${s.algorithm}'`);
                }
                e._decimated = f;
            });
        },
        destroy (t) {
            fo(t);
        }
    };
    function po(t, e, i, s) {
        if (s) return;
        let n = e[t], o = i[t];
        return "angle" === t && (n = K(n), o = K(o)), {
            property: t,
            start: n,
            end: o
        };
    }
    function mo(t, e, i) {
        for(; e > t; e--){
            const t = i[e];
            if (!isNaN(t.x) && !isNaN(t.y)) break;
        }
        return e;
    }
    function bo(t, e, i, s) {
        return t && e ? s(t[i], e[i]) : t ? t[i] : e ? e[i] : 0;
    }
    function xo(t, e) {
        let i = [], n = !1;
        return s(t) ? (n = !0, i = t) : i = function(t, e) {
            const { x: i = null, y: s = null } = t || {}, n = e.points, o = [];
            return e.segments.forEach(({ start: t, end: e })=>{
                e = mo(t, e, n);
                const a = n[t], r = n[e];
                null !== s ? (o.push({
                    x: a.x,
                    y: s
                }), o.push({
                    x: r.x,
                    y: s
                })) : null !== i && (o.push({
                    x: i,
                    y: a.y
                }), o.push({
                    x: i,
                    y: r.y
                }));
            }), o;
        }(t, e), i.length ? new to({
            points: i,
            options: {
                tension: 0
            },
            _loop: n,
            _fullLoop: n
        }) : null;
    }
    function _o(t) {
        return t && !1 !== t.fill;
    }
    function yo(t, e, i) {
        let s = t[e].fill;
        const n = [
            e
        ];
        let a;
        if (!i) return s;
        for(; !1 !== s && -1 === n.indexOf(s);){
            if (!o(s)) return s;
            if (a = t[s], !a) return !1;
            if (a.visible) return s;
            n.push(s), s = a.fill;
        }
        return !1;
    }
    function vo(t, e, i) {
        const s = function(t) {
            const e = t.options, i = e.fill;
            let s = r(i && i.target, i);
            void 0 === s && (s = !!e.backgroundColor);
            if (!1 === s || null === s) return !1;
            if (!0 === s) return "origin";
            return s;
        }(t);
        if (n(s)) return !isNaN(s.value) && s;
        let a = parseFloat(s);
        return o(a) && Math.floor(a) === a ? function(t, e, i, s) {
            "-" !== t && "+" !== t || (i = e + i);
            if (i === e || i < 0 || i >= s) return !1;
            return i;
        }(s[0], e, a, i) : [
            "origin",
            "start",
            "end",
            "stack",
            "shape"
        ].indexOf(s) >= 0 && s;
    }
    function wo(t, e, i) {
        const s = [];
        for(let n = 0; n < i.length; n++){
            const o = i[n], { first: a, last: r, point: l } = Mo(o, e, "x");
            if (!(!l || a && r)) {
                if (a) s.unshift(l);
                else if (t.push(l), !r) break;
            }
        }
        t.push(...s);
    }
    function Mo(t, e, i) {
        const s = t.interpolate(e, i);
        if (!s) return {};
        const n = s[i], o = t.segments, a = t.points;
        let r = !1, l = !1;
        for(let t = 0; t < o.length; t++){
            const e = o[t], s = a[e.start][i], h = a[e.end][i];
            if (Q(n, s, h)) {
                r = n === s, l = n === h;
                break;
            }
        }
        return {
            first: r,
            last: l,
            point: s
        };
    }
    class ko {
        constructor(t){
            this.x = t.x, this.y = t.y, this.radius = t.radius;
        }
        pathSegment(t, e, i) {
            const { x: s, y: n, radius: o } = this;
            return e = e || {
                start: 0,
                end: O
            }, t.arc(s, n, o, e.end, e.start, !0), !i.bounds;
        }
        interpolate(t) {
            const { x: e, y: i, radius: s } = this, n = t.angle;
            return {
                x: e + Math.cos(n) * s,
                y: i + Math.sin(n) * s,
                angle: n
            };
        }
    }
    function So(t) {
        const { chart: e, fill: i, line: s } = t;
        if (o(i)) return function(t, e) {
            const i = t.getDatasetMeta(e);
            return i && t.isDatasetVisible(e) ? i.dataset : null;
        }(e, i);
        if ("stack" === i) return function(t) {
            const { scale: e, index: i, line: s } = t, n = [], o = s.segments, a = s.points, r = function(t, e) {
                const i = [], s = t.getMatchingVisibleMetas("line");
                for(let t = 0; t < s.length; t++){
                    const n = s[t];
                    if (n.index === e) break;
                    n.hidden || i.unshift(n.dataset);
                }
                return i;
            }(e, i);
            r.push(xo({
                x: null,
                y: e.bottom
            }, s));
            for(let t = 0; t < o.length; t++){
                const e = o[t];
                for(let t = e.start; t <= e.end; t++)wo(n, a[t], r);
            }
            return new to({
                points: n,
                options: {}
            });
        }(t);
        if ("shape" === i) return !0;
        const a = function(t) {
            if ((t.scale || {}).getPointPositionForValue) return function(t) {
                const { scale: e, fill: i } = t, s = e.options, o = e.getLabels().length, a = s.reverse ? e.max : e.min, r = function(t, e, i) {
                    let s;
                    return s = "start" === t ? i : "end" === t ? e.options.reverse ? e.min : e.max : n(t) ? t.value : e.getBaseValue(), s;
                }(i, e, a), l = [];
                if (s.grid.circular) {
                    const t = e.getPointPositionForValue(0, a);
                    return new ko({
                        x: t.x,
                        y: t.y,
                        radius: e.getDistanceFromCenterForValue(r)
                    });
                }
                for(let t = 0; t < o; ++t)l.push(e.getPointPositionForValue(t, r));
                return l;
            }(t);
            return function(t) {
                const { scale: e = {}, fill: i } = t, s = function(t, e) {
                    let i = null;
                    return "start" === t ? i = e.bottom : "end" === t ? i = e.top : n(t) ? i = e.getPixelForValue(t.value) : e.getBasePixel && (i = e.getBasePixel()), i;
                }(i, e);
                if (o(s)) {
                    const t = e.isHorizontal();
                    return {
                        x: t ? s : null,
                        y: t ? null : s
                    };
                }
                return null;
            }(t);
        }(t);
        return a instanceof ko ? a : xo(a, s);
    }
    function Po(t, e, i) {
        const s = So(e), { line: n, scale: o, axis: a } = e, r = n.options, l = r.fill, h = r.backgroundColor, { above: c = h, below: d = h } = l || {};
        s && n.points.length && (Pe(t, i), function(t, e) {
            const { line: i, target: s, above: n, below: o, area: a, scale: r } = e, l = i._loop ? "angle" : e.axis;
            t.save(), "x" === l && o !== n && (Do(t, s, a.top), Oo(t, {
                line: i,
                target: s,
                color: n,
                scale: r,
                property: l
            }), t.restore(), t.save(), Do(t, s, a.bottom));
            Oo(t, {
                line: i,
                target: s,
                color: o,
                scale: r,
                property: l
            }), t.restore();
        }(t, {
            line: n,
            target: s,
            above: c,
            below: d,
            area: i,
            scale: o,
            axis: a
        }), De(t));
    }
    function Do(t, e, i) {
        const { segments: s, points: n } = e;
        let o = !0, a = !1;
        t.beginPath();
        for (const r of s){
            const { start: s, end: l } = r, h = n[s], c = n[mo(s, l, n)];
            o ? (t.moveTo(h.x, h.y), o = !1) : (t.lineTo(h.x, i), t.lineTo(h.x, h.y)), a = !!e.pathSegment(t, r, {
                move: a
            }), a ? t.closePath() : t.lineTo(c.x, i);
        }
        t.lineTo(e.first().x, i), t.closePath(), t.clip();
    }
    function Oo(t, e) {
        const { line: i, target: s, property: n, color: o, scale: a } = e, r = function(t, e, i) {
            const s = t.segments, n = t.points, o = e.points, a = [];
            for (const t of s){
                let { start: s, end: r } = t;
                r = mo(s, r, n);
                const l = po(i, n[s], n[r], t.loop);
                if (!e.segments) {
                    a.push({
                        source: t,
                        target: l,
                        start: n[s],
                        end: n[r]
                    });
                    continue;
                }
                const h = Pi(e, l);
                for (const e of h){
                    const s = po(i, o[e.start], o[e.end], e.loop), r = Si(t, n, s);
                    for (const t of r)a.push({
                        source: t,
                        target: e,
                        start: {
                            [i]: bo(l, s, "start", Math.max)
                        },
                        end: {
                            [i]: bo(l, s, "end", Math.min)
                        }
                    });
                }
            }
            return a;
        }(i, s, n);
        for (const { source: e, target: l, start: h, end: c } of r){
            const { style: { backgroundColor: r = o } = {} } = e, d = !0 !== s;
            t.save(), t.fillStyle = r, Co(t, a, d && po(n, h, c)), t.beginPath();
            const u = !!i.pathSegment(t, e);
            let f;
            if (d) {
                u ? t.closePath() : Ao(t, s, c, n);
                const e = !!s.pathSegment(t, l, {
                    move: u,
                    reverse: !0
                });
                f = u && e, f || Ao(t, s, h, n);
            }
            t.closePath(), t.fill(f ? "evenodd" : "nonzero"), t.restore();
        }
    }
    function Co(t, e, i) {
        const { top: s, bottom: n } = e.chart.chartArea, { property: o, start: a, end: r } = i || {};
        "x" === o && (t.beginPath(), t.rect(a, s, r - a, n - s), t.clip());
    }
    function Ao(t, e, i, s) {
        const n = e.interpolate(i, s);
        n && t.lineTo(n.x, n.y);
    }
    var To = {
        id: "filler",
        afterDatasetsUpdate (t, e, i) {
            const s = (t.data.datasets || []).length, n = [];
            let o, a, r, l;
            for(a = 0; a < s; ++a)o = t.getDatasetMeta(a), r = o.dataset, l = null, r && r.options && r instanceof to && (l = {
                visible: t.isDatasetVisible(a),
                index: a,
                fill: vo(r, a, s),
                chart: t,
                axis: o.controller.options.indexAxis,
                scale: o.vScale,
                line: r
            }), o.$filler = l, n.push(l);
            for(a = 0; a < s; ++a)l = n[a], l && !1 !== l.fill && (l.fill = yo(n, a, i.propagate));
        },
        beforeDraw (t, e, i) {
            const s = "beforeDraw" === i.drawTime, n = t.getSortedVisibleDatasetMetas(), o = t.chartArea;
            for(let e = n.length - 1; e >= 0; --e){
                const i = n[e].$filler;
                i && (i.line.updateControlPoints(o, i.axis), s && i.fill && Po(t.ctx, i, o));
            }
        },
        beforeDatasetsDraw (t, e, i) {
            if ("beforeDatasetsDraw" !== i.drawTime) return;
            const s = t.getSortedVisibleDatasetMetas();
            for(let e = s.length - 1; e >= 0; --e){
                const i = s[e].$filler;
                _o(i) && Po(t.ctx, i, t.chartArea);
            }
        },
        beforeDatasetDraw (t, e, i) {
            const s = e.meta.$filler;
            _o(s) && "beforeDatasetDraw" === i.drawTime && Po(t.ctx, s, t.chartArea);
        },
        defaults: {
            propagate: !0,
            drawTime: "beforeDatasetDraw"
        }
    };
    const Lo = (t, e)=>{
        let { boxHeight: i = e, boxWidth: s = e } = t;
        return t.usePointStyle && (i = Math.min(i, e), s = t.pointStyleWidth || Math.min(s, e)), {
            boxWidth: s,
            boxHeight: i,
            itemHeight: Math.max(e, i)
        };
    };
    class Eo extends Es {
        constructor(t){
            super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
        }
        update(t, e, i) {
            this.maxWidth = t, this.maxHeight = e, this._margins = i, this.setDimensions(), this.buildLabels(), this.fit();
        }
        setDimensions() {
            this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
        }
        buildLabels() {
            const t = this.options.labels || {};
            let e = c(t.generateLabels, [
                this.chart
            ], this) || [];
            t.filter && (e = e.filter((e)=>t.filter(e, this.chart.data))), t.sort && (e = e.sort((e, i)=>t.sort(e, i, this.chart.data))), this.options.reverse && e.reverse(), this.legendItems = e;
        }
        fit() {
            const { options: t, ctx: e } = this;
            if (!t.display) return void (this.width = this.height = 0);
            const i = t.labels, s = mi(i.font), n = s.size, o = this._computeTitleHeight(), { boxWidth: a, itemHeight: r } = Lo(i, n);
            let l, h;
            e.font = s.string, this.isHorizontal() ? (l = this.maxWidth, h = this._fitRows(o, n, a, r) + 10) : (h = this.maxHeight, l = this._fitCols(o, n, a, r) + 10), this.width = Math.min(l, t.maxWidth || this.maxWidth), this.height = Math.min(h, t.maxHeight || this.maxHeight);
        }
        _fitRows(t, e, i, s) {
            const { ctx: n, maxWidth: o, options: { labels: { padding: a } } } = this, r = this.legendHitBoxes = [], l = this.lineWidths = [
                0
            ], h = s + a;
            let c = t;
            n.textAlign = "left", n.textBaseline = "middle";
            let d = -1, u = -h;
            return this.legendItems.forEach((t, f)=>{
                const g = i + e / 2 + n.measureText(t.text).width;
                (0 === f || l[l.length - 1] + g + 2 * a > o) && (c += h, l[l.length - (f > 0 ? 0 : 1)] = 0, u += h, d++), r[f] = {
                    left: 0,
                    top: u,
                    row: d,
                    width: g,
                    height: s
                }, l[l.length - 1] += g + a;
            }), c;
        }
        _fitCols(t, e, i, s) {
            const { ctx: n, maxHeight: o, options: { labels: { padding: a } } } = this, r = this.legendHitBoxes = [], l = this.columnSizes = [], h = o - t;
            let c = a, d = 0, u = 0, f = 0, g = 0;
            return this.legendItems.forEach((t, o)=>{
                const p = i + e / 2 + n.measureText(t.text).width;
                o > 0 && u + s + 2 * a > h && (c += d + a, l.push({
                    width: d,
                    height: u
                }), f += d + a, g++, d = u = 0), r[o] = {
                    left: f,
                    top: u,
                    col: g,
                    width: p,
                    height: s
                }, d = Math.max(d, p), u += s + a;
            }), c += d, l.push({
                width: d,
                height: u
            }), c;
        }
        adjustHitBoxes() {
            if (!this.options.display) return;
            const t = this._computeTitleHeight(), { legendHitBoxes: e, options: { align: i, labels: { padding: s }, rtl: n } } = this, o = yi(n, this.left, this.width);
            if (this.isHorizontal()) {
                let n = 0, a = ut(i, this.left + s, this.right - this.lineWidths[n]);
                for (const r of e)n !== r.row && (n = r.row, a = ut(i, this.left + s, this.right - this.lineWidths[n])), r.top += this.top + t + s, r.left = o.leftForLtr(o.x(a), r.width), a += r.width + s;
            } else {
                let n = 0, a = ut(i, this.top + t + s, this.bottom - this.columnSizes[n].height);
                for (const r of e)r.col !== n && (n = r.col, a = ut(i, this.top + t + s, this.bottom - this.columnSizes[n].height)), r.top = a, r.left += this.left + s, r.left = o.leftForLtr(o.x(r.left), r.width), a += r.height + s;
            }
        }
        isHorizontal() {
            return "top" === this.options.position || "bottom" === this.options.position;
        }
        draw() {
            if (this.options.display) {
                const t = this.ctx;
                Pe(t, this), this._draw(), De(t);
            }
        }
        _draw() {
            const { options: t, columnSizes: e, lineWidths: i, ctx: s } = this, { align: n, labels: o } = t, a = ne.color, l = yi(t.rtl, this.left, this.width), h = mi(o.font), { color: c, padding: d } = o, u = h.size, f = u / 2;
            let g;
            this.drawTitle(), s.textAlign = l.textAlign("left"), s.textBaseline = "middle", s.lineWidth = .5, s.font = h.string;
            const { boxWidth: p, boxHeight: m, itemHeight: b } = Lo(o, u), x = this.isHorizontal(), _ = this._computeTitleHeight();
            g = x ? {
                x: ut(n, this.left + d, this.right - i[0]),
                y: this.top + d + _,
                line: 0
            } : {
                x: this.left + d,
                y: ut(n, this.top + _ + d, this.bottom - e[0].height),
                line: 0
            }, vi(this.ctx, t.textDirection);
            const y = b + d;
            this.legendItems.forEach((v, w)=>{
                s.strokeStyle = v.fontColor || c, s.fillStyle = v.fontColor || c;
                const M = s.measureText(v.text).width, k = l.textAlign(v.textAlign || (v.textAlign = o.textAlign)), S = p + f + M;
                let P = g.x, D = g.y;
                l.setWidth(this.width), x ? w > 0 && P + S + d > this.right && (D = g.y += y, g.line++, P = g.x = ut(n, this.left + d, this.right - i[g.line])) : w > 0 && D + y > this.bottom && (P = g.x = P + e[g.line].width + d, g.line++, D = g.y = ut(n, this.top + _ + d, this.bottom - e[g.line].height));
                !function(t, e, i) {
                    if (isNaN(p) || p <= 0 || isNaN(m) || m < 0) return;
                    s.save();
                    const n = r(i.lineWidth, 1);
                    if (s.fillStyle = r(i.fillStyle, a), s.lineCap = r(i.lineCap, "butt"), s.lineDashOffset = r(i.lineDashOffset, 0), s.lineJoin = r(i.lineJoin, "miter"), s.lineWidth = n, s.strokeStyle = r(i.strokeStyle, a), s.setLineDash(r(i.lineDash, [])), o.usePointStyle) {
                        const a = {
                            radius: m * Math.SQRT2 / 2,
                            pointStyle: i.pointStyle,
                            rotation: i.rotation,
                            borderWidth: n
                        }, r = l.xPlus(t, p / 2);
                        ke(s, a, r, e + f, o.pointStyleWidth && p);
                    } else {
                        const o = e + Math.max((u - m) / 2, 0), a = l.leftForLtr(t, p), r = gi(i.borderRadius);
                        s.beginPath(), Object.values(r).some((t)=>0 !== t) ? Le(s, {
                            x: a,
                            y: o,
                            w: p,
                            h: m,
                            radius: r
                        }) : s.rect(a, o, p, m), s.fill(), 0 !== n && s.stroke();
                    }
                    s.restore();
                }(l.x(P), D, v), P = ft(k, P + p + f, x ? P + S : this.right, t.rtl), function(t, e, i) {
                    Ae(s, i.text, t, e + b / 2, h, {
                        strikethrough: i.hidden,
                        textAlign: l.textAlign(i.textAlign)
                    });
                }(l.x(P), D, v), x ? g.x += S + d : g.y += y;
            }), wi(this.ctx, t.textDirection);
        }
        drawTitle() {
            const t = this.options, e = t.title, i = mi(e.font), s = pi(e.padding);
            if (!e.display) return;
            const n = yi(t.rtl, this.left, this.width), o = this.ctx, a = e.position, r = i.size / 2, l = s.top + r;
            let h, c = this.left, d = this.width;
            if (this.isHorizontal()) d = Math.max(...this.lineWidths), h = this.top + l, c = ut(t.align, c, this.right - d);
            else {
                const e = this.columnSizes.reduce((t, e)=>Math.max(t, e.height), 0);
                h = l + ut(t.align, this.top, this.bottom - e - t.labels.padding - this._computeTitleHeight());
            }
            const u = ut(a, c, c + d);
            o.textAlign = n.textAlign(dt(a)), o.textBaseline = "middle", o.strokeStyle = e.color, o.fillStyle = e.color, o.font = i.string, Ae(o, e.text, u, h, i);
        }
        _computeTitleHeight() {
            const t = this.options.title, e = mi(t.font), i = pi(t.padding);
            return t.display ? e.lineHeight + i.height : 0;
        }
        _getLegendItemAt(t, e) {
            let i, s, n;
            if (Q(t, this.left, this.right) && Q(e, this.top, this.bottom)) {
                for(n = this.legendHitBoxes, i = 0; i < n.length; ++i)if (s = n[i], Q(t, s.left, s.left + s.width) && Q(e, s.top, s.top + s.height)) return this.legendItems[i];
            }
            return null;
        }
        handleEvent(t) {
            const e = this.options;
            if (!function(t, e) {
                if (("mousemove" === t || "mouseout" === t) && (e.onHover || e.onLeave)) return !0;
                if (e.onClick && ("click" === t || "mouseup" === t)) return !0;
                return !1;
            }(t.type, e)) return;
            const i = this._getLegendItemAt(t.x, t.y);
            if ("mousemove" === t.type || "mouseout" === t.type) {
                const o = this._hoveredItem, a = (n = i, null !== (s = o) && null !== n && s.datasetIndex === n.datasetIndex && s.index === n.index);
                o && !a && c(e.onLeave, [
                    t,
                    o,
                    this
                ], this), this._hoveredItem = i, i && !a && c(e.onHover, [
                    t,
                    i,
                    this
                ], this);
            } else i && c(e.onClick, [
                t,
                i,
                this
            ], this);
            var s, n;
        }
    }
    var Ro = {
        id: "legend",
        _element: Eo,
        start (t, e, i) {
            const s = t.legend = new Eo({
                ctx: t.ctx,
                options: i,
                chart: t
            });
            Zi.configure(t, s, i), Zi.addBox(t, s);
        },
        stop (t) {
            Zi.removeBox(t, t.legend), delete t.legend;
        },
        beforeUpdate (t, e, i) {
            const s = t.legend;
            Zi.configure(t, s, i), s.options = i;
        },
        afterUpdate (t) {
            const e = t.legend;
            e.buildLabels(), e.adjustHitBoxes();
        },
        afterEvent (t, e) {
            e.replay || t.legend.handleEvent(e.event);
        },
        defaults: {
            display: !0,
            position: "top",
            align: "center",
            fullSize: !0,
            reverse: !1,
            weight: 1e3,
            onClick (t, e, i) {
                const s = e.datasetIndex, n = i.chart;
                n.isDatasetVisible(s) ? (n.hide(s), e.hidden = !0) : (n.show(s), e.hidden = !1);
            },
            onHover: null,
            onLeave: null,
            labels: {
                color: (t)=>t.chart.options.color,
                boxWidth: 40,
                padding: 10,
                generateLabels (t) {
                    const e = t.data.datasets, { labels: { usePointStyle: i, pointStyle: s, textAlign: n, color: o } } = t.legend.options;
                    return t._getSortedDatasetMetas().map((t)=>{
                        const a = t.controller.getStyle(i ? 0 : void 0), r = pi(a.borderWidth);
                        return {
                            text: e[t.index].label,
                            fillStyle: a.backgroundColor,
                            fontColor: o,
                            hidden: !t.visible,
                            lineCap: a.borderCapStyle,
                            lineDash: a.borderDash,
                            lineDashOffset: a.borderDashOffset,
                            lineJoin: a.borderJoinStyle,
                            lineWidth: (r.width + r.height) / 4,
                            strokeStyle: a.borderColor,
                            pointStyle: s || a.pointStyle,
                            rotation: a.rotation,
                            textAlign: n || a.textAlign,
                            borderRadius: 0,
                            datasetIndex: t.index
                        };
                    }, this);
                }
            },
            title: {
                color: (t)=>t.chart.options.color,
                display: !1,
                position: "center",
                text: ""
            }
        },
        descriptors: {
            _scriptable: (t)=>!t.startsWith("on"),
            labels: {
                _scriptable: (t)=>![
                        "generateLabels",
                        "filter",
                        "sort"
                    ].includes(t)
            }
        }
    };
    class Io extends Es {
        constructor(t){
            super(), this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
        }
        update(t, e) {
            const i = this.options;
            if (this.left = 0, this.top = 0, !i.display) return void (this.width = this.height = this.right = this.bottom = 0);
            this.width = this.right = t, this.height = this.bottom = e;
            const n = s(i.text) ? i.text.length : 1;
            this._padding = pi(i.padding);
            const o = n * mi(i.font).lineHeight + this._padding.height;
            this.isHorizontal() ? this.height = o : this.width = o;
        }
        isHorizontal() {
            const t = this.options.position;
            return "top" === t || "bottom" === t;
        }
        _drawArgs(t) {
            const { top: e, left: i, bottom: s, right: n, options: o } = this, a = o.align;
            let r, l, h, c = 0;
            return this.isHorizontal() ? (l = ut(a, i, n), h = e + t, r = n - i) : ("left" === o.position ? (l = i + t, h = ut(a, s, e), c = -0.5 * D) : (l = n - t, h = ut(a, e, s), c = .5 * D), r = s - e), {
                titleX: l,
                titleY: h,
                maxWidth: r,
                rotation: c
            };
        }
        draw() {
            const t = this.ctx, e = this.options;
            if (!e.display) return;
            const i = mi(e.font), s = i.lineHeight / 2 + this._padding.top, { titleX: n, titleY: o, maxWidth: a, rotation: r } = this._drawArgs(s);
            Ae(t, e.text, 0, 0, i, {
                color: e.color,
                maxWidth: a,
                rotation: r,
                textAlign: dt(e.align),
                textBaseline: "middle",
                translation: [
                    n,
                    o
                ]
            });
        }
    }
    var zo = {
        id: "title",
        _element: Io,
        start (t, e, i) {
            !function(t, e) {
                const i = new Io({
                    ctx: t.ctx,
                    options: e,
                    chart: t
                });
                Zi.configure(t, i, e), Zi.addBox(t, i), t.titleBlock = i;
            }(t, i);
        },
        stop (t) {
            const e = t.titleBlock;
            Zi.removeBox(t, e), delete t.titleBlock;
        },
        beforeUpdate (t, e, i) {
            const s = t.titleBlock;
            Zi.configure(t, s, i), s.options = i;
        },
        defaults: {
            align: "center",
            display: !1,
            font: {
                weight: "bold"
            },
            fullSize: !0,
            padding: 10,
            position: "top",
            text: "",
            weight: 2e3
        },
        defaultRoutes: {
            color: "color"
        },
        descriptors: {
            _scriptable: !0,
            _indexable: !1
        }
    };
    const Fo = new WeakMap;
    var Vo = {
        id: "subtitle",
        start (t, e, i) {
            const s = new Io({
                ctx: t.ctx,
                options: i,
                chart: t
            });
            Zi.configure(t, s, i), Zi.addBox(t, s), Fo.set(t, s);
        },
        stop (t) {
            Zi.removeBox(t, Fo.get(t)), Fo.delete(t);
        },
        beforeUpdate (t, e, i) {
            const s = Fo.get(t);
            Zi.configure(t, s, i), s.options = i;
        },
        defaults: {
            align: "center",
            display: !1,
            font: {
                weight: "normal"
            },
            fullSize: !0,
            padding: 0,
            position: "top",
            text: "",
            weight: 1500
        },
        defaultRoutes: {
            color: "color"
        },
        descriptors: {
            _scriptable: !0,
            _indexable: !1
        }
    };
    const Bo = {
        average (t) {
            if (!t.length) return !1;
            let e, i, s = 0, n = 0, o = 0;
            for(e = 0, i = t.length; e < i; ++e){
                const i = t[e].element;
                if (i && i.hasValue()) {
                    const t = i.tooltipPosition();
                    s += t.x, n += t.y, ++o;
                }
            }
            return {
                x: s / o,
                y: n / o
            };
        },
        nearest (t, e) {
            if (!t.length) return !1;
            let i, s, n, o = e.x, a = e.y, r = Number.POSITIVE_INFINITY;
            for(i = 0, s = t.length; i < s; ++i){
                const s = t[i].element;
                if (s && s.hasValue()) {
                    const t = X(e, s.getCenterPoint());
                    t < r && (r = t, n = s);
                }
            }
            if (n) {
                const t = n.tooltipPosition();
                o = t.x, a = t.y;
            }
            return {
                x: o,
                y: a
            };
        }
    };
    function No(t, e) {
        return e && (s(e) ? Array.prototype.push.apply(t, e) : t.push(e)), t;
    }
    function Wo(t) {
        return ("string" == typeof t || t instanceof String) && t.indexOf("\n") > -1 ? t.split("\n") : t;
    }
    function jo(t, e) {
        const { element: i, datasetIndex: s, index: n } = e, o = t.getDatasetMeta(s).controller, { label: a, value: r } = o.getLabelAndValue(n);
        return {
            chart: t,
            label: a,
            parsed: o.getParsed(n),
            raw: t.data.datasets[s].data[n],
            formattedValue: r,
            dataset: o.getDataset(),
            dataIndex: n,
            datasetIndex: s,
            element: i
        };
    }
    function Ho(t, e) {
        const i = t.chart.ctx, { body: s, footer: n, title: o } = t, { boxWidth: a, boxHeight: r } = e, l = mi(e.bodyFont), h = mi(e.titleFont), c = mi(e.footerFont), u = o.length, f = n.length, g = s.length, p = pi(e.padding);
        let m = p.height, b = 0, x = s.reduce((t, e)=>t + e.before.length + e.lines.length + e.after.length, 0);
        if (x += t.beforeBody.length + t.afterBody.length, u && (m += u * h.lineHeight + (u - 1) * e.titleSpacing + e.titleMarginBottom), x) m += g * (e.displayColors ? Math.max(r, l.lineHeight) : l.lineHeight) + (x - g) * l.lineHeight + (x - 1) * e.bodySpacing;
        f && (m += e.footerMarginTop + f * c.lineHeight + (f - 1) * e.footerSpacing);
        let _ = 0;
        const y = function(t) {
            b = Math.max(b, i.measureText(t).width + _);
        };
        return i.save(), i.font = h.string, d(t.title, y), i.font = l.string, d(t.beforeBody.concat(t.afterBody), y), _ = e.displayColors ? a + 2 + e.boxPadding : 0, d(s, (t)=>{
            d(t.before, y), d(t.lines, y), d(t.after, y);
        }), _ = 0, i.font = c.string, d(t.footer, y), i.restore(), b += p.width, {
            width: b,
            height: m
        };
    }
    function $o(t, e, i, s) {
        const { x: n, width: o } = i, { width: a, chartArea: { left: r, right: l } } = t;
        let h = "center";
        return "center" === s ? h = n <= (r + l) / 2 ? "left" : "right" : n <= o / 2 ? h = "left" : n >= a - o / 2 && (h = "right"), function(t, e, i, s) {
            const { x: n, width: o } = s, a = i.caretSize + i.caretPadding;
            return "left" === t && n + o + a > e.width || "right" === t && n - o - a < 0 || void 0;
        }(h, t, e, i) && (h = "center"), h;
    }
    function Yo(t, e, i) {
        const s = i.yAlign || e.yAlign || function(t, e) {
            const { y: i, height: s } = e;
            return i < s / 2 ? "top" : i > t.height - s / 2 ? "bottom" : "center";
        }(t, i);
        return {
            xAlign: i.xAlign || e.xAlign || $o(t, e, i, s),
            yAlign: s
        };
    }
    function Uo(t, e, i, s) {
        const { caretSize: n, caretPadding: o, cornerRadius: a } = t, { xAlign: r, yAlign: l } = i, h = n + o, { topLeft: c, topRight: d, bottomLeft: u, bottomRight: f } = gi(a);
        let g = function(t, e) {
            let { x: i, width: s } = t;
            return "right" === e ? i -= s : "center" === e && (i -= s / 2), i;
        }(e, r);
        const p = function(t, e, i) {
            let { y: s, height: n } = t;
            return "top" === e ? s += i : s -= "bottom" === e ? n + i : n / 2, s;
        }(e, l, h);
        return "center" === l ? "left" === r ? g += h : "right" === r && (g -= h) : "left" === r ? g -= Math.max(c, u) + n : "right" === r && (g += Math.max(d, f) + n), {
            x: Z(g, 0, s.width - e.width),
            y: Z(p, 0, s.height - e.height)
        };
    }
    function Xo(t, e, i) {
        const s = pi(i.padding);
        return "center" === e ? t.x + t.width / 2 : "right" === e ? t.x + t.width - s.right : t.x + s.left;
    }
    function qo(t) {
        return No([], Wo(t));
    }
    function Ko(t, e) {
        const i = e && e.dataset && e.dataset.tooltip && e.dataset.tooltip.callbacks;
        return i ? t.override(i) : t;
    }
    class Go extends Es {
        constructor(t){
            super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = t.chart || t._chart, this._chart = this.chart, this.options = t.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
        }
        initialize(t) {
            this.options = t, this._cachedAnimations = void 0, this.$context = void 0;
        }
        _resolveAnimations() {
            const t = this._cachedAnimations;
            if (t) return t;
            const e = this.chart, i = this.options.setContext(this.getContext()), s = i.enabled && e.options.animation && i.animations, n = new ys(this.chart, s);
            return s._cacheable && (this._cachedAnimations = Object.freeze(n)), n;
        }
        getContext() {
            var t, e, i;
            return this.$context || (this.$context = (t = this.chart.getContext(), e = this, i = this._tooltipItems, _i(t, {
                tooltip: e,
                tooltipItems: i,
                type: "tooltip"
            })));
        }
        getTitle(t, e) {
            const { callbacks: i } = e, s = i.beforeTitle.apply(this, [
                t
            ]), n = i.title.apply(this, [
                t
            ]), o = i.afterTitle.apply(this, [
                t
            ]);
            let a = [];
            return a = No(a, Wo(s)), a = No(a, Wo(n)), a = No(a, Wo(o)), a;
        }
        getBeforeBody(t, e) {
            return qo(e.callbacks.beforeBody.apply(this, [
                t
            ]));
        }
        getBody(t, e) {
            const { callbacks: i } = e, s = [];
            return d(t, (t)=>{
                const e = {
                    before: [],
                    lines: [],
                    after: []
                }, n = Ko(i, t);
                No(e.before, Wo(n.beforeLabel.call(this, t))), No(e.lines, n.label.call(this, t)), No(e.after, Wo(n.afterLabel.call(this, t))), s.push(e);
            }), s;
        }
        getAfterBody(t, e) {
            return qo(e.callbacks.afterBody.apply(this, [
                t
            ]));
        }
        getFooter(t, e) {
            const { callbacks: i } = e, s = i.beforeFooter.apply(this, [
                t
            ]), n = i.footer.apply(this, [
                t
            ]), o = i.afterFooter.apply(this, [
                t
            ]);
            let a = [];
            return a = No(a, Wo(s)), a = No(a, Wo(n)), a = No(a, Wo(o)), a;
        }
        _createItems(t) {
            const e = this._active, i = this.chart.data, s = [], n = [], o = [];
            let a, r, l = [];
            for(a = 0, r = e.length; a < r; ++a)l.push(jo(this.chart, e[a]));
            return t.filter && (l = l.filter((e, s, n)=>t.filter(e, s, n, i))), t.itemSort && (l = l.sort((e, s)=>t.itemSort(e, s, i))), d(l, (e)=>{
                const i = Ko(t.callbacks, e);
                s.push(i.labelColor.call(this, e)), n.push(i.labelPointStyle.call(this, e)), o.push(i.labelTextColor.call(this, e));
            }), this.labelColors = s, this.labelPointStyles = n, this.labelTextColors = o, this.dataPoints = l, l;
        }
        update(t, e) {
            const i = this.options.setContext(this.getContext()), s = this._active;
            let n, o = [];
            if (s.length) {
                const t = Bo[i.position].call(this, s, this._eventPosition);
                o = this._createItems(i), this.title = this.getTitle(o, i), this.beforeBody = this.getBeforeBody(o, i), this.body = this.getBody(o, i), this.afterBody = this.getAfterBody(o, i), this.footer = this.getFooter(o, i);
                const e = this._size = Ho(this, i), a = Object.assign({}, t, e), r = Yo(this.chart, i, a), l = Uo(i, a, r, this.chart);
                this.xAlign = r.xAlign, this.yAlign = r.yAlign, n = {
                    opacity: 1,
                    x: l.x,
                    y: l.y,
                    width: e.width,
                    height: e.height,
                    caretX: t.x,
                    caretY: t.y
                };
            } else 0 !== this.opacity && (n = {
                opacity: 0
            });
            this._tooltipItems = o, this.$context = void 0, n && this._resolveAnimations().update(this, n), t && i.external && i.external.call(this, {
                chart: this.chart,
                tooltip: this,
                replay: e
            });
        }
        drawCaret(t, e, i, s) {
            const n = this.getCaretPosition(t, i, s);
            e.lineTo(n.x1, n.y1), e.lineTo(n.x2, n.y2), e.lineTo(n.x3, n.y3);
        }
        getCaretPosition(t, e, i) {
            const { xAlign: s, yAlign: n } = this, { caretSize: o, cornerRadius: a } = i, { topLeft: r, topRight: l, bottomLeft: h, bottomRight: c } = gi(a), { x: d, y: u } = t, { width: f, height: g } = e;
            let p, m, b, x, _, y;
            return "center" === n ? (_ = u + g / 2, "left" === s ? (p = d, m = p - o, x = _ + o, y = _ - o) : (p = d + f, m = p + o, x = _ - o, y = _ + o), b = p) : (m = "left" === s ? d + Math.max(r, h) + o : "right" === s ? d + f - Math.max(l, c) - o : this.caretX, "top" === n ? (x = u, _ = x - o, p = m - o, b = m + o) : (x = u + g, _ = x + o, p = m + o, b = m - o), y = x), {
                x1: p,
                x2: m,
                x3: b,
                y1: x,
                y2: _,
                y3: y
            };
        }
        drawTitle(t, e, i) {
            const s = this.title, n = s.length;
            let o, a, r;
            if (n) {
                const l = yi(i.rtl, this.x, this.width);
                for(t.x = Xo(this, i.titleAlign, i), e.textAlign = l.textAlign(i.titleAlign), e.textBaseline = "middle", o = mi(i.titleFont), a = i.titleSpacing, e.fillStyle = i.titleColor, e.font = o.string, r = 0; r < n; ++r)e.fillText(s[r], l.x(t.x), t.y + o.lineHeight / 2), t.y += o.lineHeight + a, r + 1 === n && (t.y += i.titleMarginBottom - a);
            }
        }
        _drawColorBox(t, e, i, s, o) {
            const a = this.labelColors[i], r = this.labelPointStyles[i], { boxHeight: l, boxWidth: h, boxPadding: c } = o, d = mi(o.bodyFont), u = Xo(this, "left", o), f = s.x(u), g = l < d.lineHeight ? (d.lineHeight - l) / 2 : 0, p = e.y + g;
            if (o.usePointStyle) {
                const e = {
                    radius: Math.min(h, l) / 2,
                    pointStyle: r.pointStyle,
                    rotation: r.rotation,
                    borderWidth: 1
                }, i = s.leftForLtr(f, h) + h / 2, n = p + l / 2;
                t.strokeStyle = o.multiKeyBackground, t.fillStyle = o.multiKeyBackground, Me(t, e, i, n), t.strokeStyle = a.borderColor, t.fillStyle = a.backgroundColor, Me(t, e, i, n);
            } else {
                t.lineWidth = n(a.borderWidth) ? Math.max(...Object.values(a.borderWidth)) : a.borderWidth || 1, t.strokeStyle = a.borderColor, t.setLineDash(a.borderDash || []), t.lineDashOffset = a.borderDashOffset || 0;
                const e = s.leftForLtr(f, h - c), i = s.leftForLtr(s.xPlus(f, 1), h - c - 2), r = gi(a.borderRadius);
                Object.values(r).some((t)=>0 !== t) ? (t.beginPath(), t.fillStyle = o.multiKeyBackground, Le(t, {
                    x: e,
                    y: p,
                    w: h,
                    h: l,
                    radius: r
                }), t.fill(), t.stroke(), t.fillStyle = a.backgroundColor, t.beginPath(), Le(t, {
                    x: i,
                    y: p + 1,
                    w: h - 2,
                    h: l - 2,
                    radius: r
                }), t.fill()) : (t.fillStyle = o.multiKeyBackground, t.fillRect(e, p, h, l), t.strokeRect(e, p, h, l), t.fillStyle = a.backgroundColor, t.fillRect(i, p + 1, h - 2, l - 2));
            }
            t.fillStyle = this.labelTextColors[i];
        }
        drawBody(t, e, i) {
            const { body: s } = this, { bodySpacing: n, bodyAlign: o, displayColors: a, boxHeight: r, boxWidth: l, boxPadding: h } = i, c = mi(i.bodyFont);
            let u = c.lineHeight, f = 0;
            const g = yi(i.rtl, this.x, this.width), p = function(i) {
                e.fillText(i, g.x(t.x + f), t.y + u / 2), t.y += u + n;
            }, m = g.textAlign(o);
            let b, x, _, y, v, w, M;
            for(e.textAlign = o, e.textBaseline = "middle", e.font = c.string, t.x = Xo(this, m, i), e.fillStyle = i.bodyColor, d(this.beforeBody, p), f = a && "right" !== m ? "center" === o ? l / 2 + h : l + 2 + h : 0, y = 0, w = s.length; y < w; ++y){
                for(b = s[y], x = this.labelTextColors[y], e.fillStyle = x, d(b.before, p), _ = b.lines, a && _.length && (this._drawColorBox(e, t, y, g, i), u = Math.max(c.lineHeight, r)), v = 0, M = _.length; v < M; ++v)p(_[v]), u = c.lineHeight;
                d(b.after, p);
            }
            f = 0, u = c.lineHeight, d(this.afterBody, p), t.y -= n;
        }
        drawFooter(t, e, i) {
            const s = this.footer, n = s.length;
            let o, a;
            if (n) {
                const r = yi(i.rtl, this.x, this.width);
                for(t.x = Xo(this, i.footerAlign, i), t.y += i.footerMarginTop, e.textAlign = r.textAlign(i.footerAlign), e.textBaseline = "middle", o = mi(i.footerFont), e.fillStyle = i.footerColor, e.font = o.string, a = 0; a < n; ++a)e.fillText(s[a], r.x(t.x), t.y + o.lineHeight / 2), t.y += o.lineHeight + i.footerSpacing;
            }
        }
        drawBackground(t, e, i, s) {
            const { xAlign: n, yAlign: o } = this, { x: a, y: r } = t, { width: l, height: h } = i, { topLeft: c, topRight: d, bottomLeft: u, bottomRight: f } = gi(s.cornerRadius);
            e.fillStyle = s.backgroundColor, e.strokeStyle = s.borderColor, e.lineWidth = s.borderWidth, e.beginPath(), e.moveTo(a + c, r), "top" === o && this.drawCaret(t, e, i, s), e.lineTo(a + l - d, r), e.quadraticCurveTo(a + l, r, a + l, r + d), "center" === o && "right" === n && this.drawCaret(t, e, i, s), e.lineTo(a + l, r + h - f), e.quadraticCurveTo(a + l, r + h, a + l - f, r + h), "bottom" === o && this.drawCaret(t, e, i, s), e.lineTo(a + u, r + h), e.quadraticCurveTo(a, r + h, a, r + h - u), "center" === o && "left" === n && this.drawCaret(t, e, i, s), e.lineTo(a, r + c), e.quadraticCurveTo(a, r, a + c, r), e.closePath(), e.fill(), s.borderWidth > 0 && e.stroke();
        }
        _updateAnimationTarget(t) {
            const e = this.chart, i = this.$animations, s = i && i.x, n = i && i.y;
            if (s || n) {
                const i = Bo[t.position].call(this, this._active, this._eventPosition);
                if (!i) return;
                const o = this._size = Ho(this, t), a = Object.assign({}, i, this._size), r = Yo(e, t, a), l = Uo(t, a, r, e);
                s._to === l.x && n._to === l.y || (this.xAlign = r.xAlign, this.yAlign = r.yAlign, this.width = o.width, this.height = o.height, this.caretX = i.x, this.caretY = i.y, this._resolveAnimations().update(this, l));
            }
        }
        _willRender() {
            return !!this.opacity;
        }
        draw(t) {
            const e = this.options.setContext(this.getContext());
            let i = this.opacity;
            if (!i) return;
            this._updateAnimationTarget(e);
            const s = {
                width: this.width,
                height: this.height
            }, n = {
                x: this.x,
                y: this.y
            };
            i = Math.abs(i) < .001 ? 0 : i;
            const o = pi(e.padding), a = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
            e.enabled && a && (t.save(), t.globalAlpha = i, this.drawBackground(n, t, s, e), vi(t, e.textDirection), n.y += o.top, this.drawTitle(n, t, e), this.drawBody(n, t, e), this.drawFooter(n, t, e), wi(t, e.textDirection), t.restore());
        }
        getActiveElements() {
            return this._active || [];
        }
        setActiveElements(t, e) {
            const i = this._active, s = t.map(({ datasetIndex: t, index: e })=>{
                const i = this.chart.getDatasetMeta(t);
                if (!i) throw new Error("Cannot find a dataset at index " + t);
                return {
                    datasetIndex: t,
                    element: i.data[e],
                    index: e
                };
            }), n = !u(i, s), o = this._positionChanged(s, e);
            (n || o) && (this._active = s, this._eventPosition = e, this._ignoreReplayEvents = !0, this.update(!0));
        }
        handleEvent(t, e, i = !0) {
            if (e && this._ignoreReplayEvents) return !1;
            this._ignoreReplayEvents = !1;
            const s = this.options, n = this._active || [], o = this._getActiveElements(t, n, e, i), a = this._positionChanged(o, t), r = e || !u(o, n) || a;
            return r && (this._active = o, (s.enabled || s.external) && (this._eventPosition = {
                x: t.x,
                y: t.y
            }, this.update(!0, e))), r;
        }
        _getActiveElements(t, e, i, s) {
            const n = this.options;
            if ("mouseout" === t.type) return [];
            if (!s) return e;
            const o = this.chart.getElementsAtEventForMode(t, n.mode, n, i);
            return n.reverse && o.reverse(), o;
        }
        _positionChanged(t, e) {
            const { caretX: i, caretY: s, options: n } = this, o = Bo[n.position].call(this, t, e);
            return !1 !== o && (i !== o.x || s !== o.y);
        }
    }
    Go.positioners = Bo;
    var Zo = {
        id: "tooltip",
        _element: Go,
        positioners: Bo,
        afterInit (t, e, i) {
            i && (t.tooltip = new Go({
                chart: t,
                options: i
            }));
        },
        beforeUpdate (t, e, i) {
            t.tooltip && t.tooltip.initialize(i);
        },
        reset (t, e, i) {
            t.tooltip && t.tooltip.initialize(i);
        },
        afterDraw (t) {
            const e = t.tooltip;
            if (e && e._willRender()) {
                const i = {
                    tooltip: e
                };
                if (!1 === t.notifyPlugins("beforeTooltipDraw", i)) return;
                e.draw(t.ctx), t.notifyPlugins("afterTooltipDraw", i);
            }
        },
        afterEvent (t, e) {
            if (t.tooltip) {
                const i = e.replay;
                t.tooltip.handleEvent(e.event, i, e.inChartArea) && (e.changed = !0);
            }
        },
        defaults: {
            enabled: !0,
            external: null,
            position: "average",
            backgroundColor: "rgba(0,0,0,0.8)",
            titleColor: "#fff",
            titleFont: {
                weight: "bold"
            },
            titleSpacing: 2,
            titleMarginBottom: 6,
            titleAlign: "left",
            bodyColor: "#fff",
            bodySpacing: 2,
            bodyFont: {},
            bodyAlign: "left",
            footerColor: "#fff",
            footerSpacing: 2,
            footerMarginTop: 6,
            footerFont: {
                weight: "bold"
            },
            footerAlign: "left",
            padding: 6,
            caretPadding: 2,
            caretSize: 5,
            cornerRadius: 6,
            boxHeight: (t, e)=>e.bodyFont.size,
            boxWidth: (t, e)=>e.bodyFont.size,
            multiKeyBackground: "#fff",
            displayColors: !0,
            boxPadding: 0,
            borderColor: "rgba(0,0,0,0)",
            borderWidth: 0,
            animation: {
                duration: 400,
                easing: "easeOutQuart"
            },
            animations: {
                numbers: {
                    type: "number",
                    properties: [
                        "x",
                        "y",
                        "width",
                        "height",
                        "caretX",
                        "caretY"
                    ]
                },
                opacity: {
                    easing: "linear",
                    duration: 200
                }
            },
            callbacks: {
                beforeTitle: t,
                title (t) {
                    if (t.length > 0) {
                        const e = t[0], i = e.chart.data.labels, s = i ? i.length : 0;
                        if (this && this.options && "dataset" === this.options.mode) return e.dataset.label || "";
                        if (e.label) return e.label;
                        if (s > 0 && e.dataIndex < s) return i[e.dataIndex];
                    }
                    return "";
                },
                afterTitle: t,
                beforeBody: t,
                beforeLabel: t,
                label (t) {
                    if (this && this.options && "dataset" === this.options.mode) return t.label + ": " + t.formattedValue || t.formattedValue;
                    let e = t.dataset.label || "";
                    e && (e += ": ");
                    const s = t.formattedValue;
                    return i(s) || (e += s), e;
                },
                labelColor (t) {
                    const e = t.chart.getDatasetMeta(t.datasetIndex).controller.getStyle(t.dataIndex);
                    return {
                        borderColor: e.borderColor,
                        backgroundColor: e.backgroundColor,
                        borderWidth: e.borderWidth,
                        borderDash: e.borderDash,
                        borderDashOffset: e.borderDashOffset,
                        borderRadius: 0
                    };
                },
                labelTextColor () {
                    return this.options.bodyColor;
                },
                labelPointStyle (t) {
                    const e = t.chart.getDatasetMeta(t.datasetIndex).controller.getStyle(t.dataIndex);
                    return {
                        pointStyle: e.pointStyle,
                        rotation: e.rotation
                    };
                },
                afterLabel: t,
                afterBody: t,
                beforeFooter: t,
                footer: t,
                afterFooter: t
            }
        },
        defaultRoutes: {
            bodyFont: "font",
            footerFont: "font",
            titleFont: "font"
        },
        descriptors: {
            _scriptable: (t)=>"filter" !== t && "itemSort" !== t && "external" !== t,
            _indexable: !1,
            callbacks: {
                _scriptable: !1,
                _indexable: !1
            },
            animation: {
                _fallback: !1
            },
            animations: {
                _fallback: "animation"
            }
        },
        additionalOptionScopes: [
            "interaction"
        ]
    }, Jo = Object.freeze({
        __proto__: null,
        Decimation: go,
        Filler: To,
        Legend: Ro,
        SubTitle: Vo,
        Title: zo,
        Tooltip: Zo
    });
    function Qo(t, e, i, s) {
        const n = t.indexOf(e);
        if (-1 === n) return ((t, e, i, s)=>("string" == typeof e ? (i = t.push(e) - 1, s.unshift({
                index: i,
                label: e
            })) : isNaN(e) && (i = null), i))(t, e, i, s);
        return n !== t.lastIndexOf(e) ? i : n;
    }
    class ta extends $s {
        constructor(t){
            super(t), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
        }
        init(t) {
            const e = this._addedLabels;
            if (e.length) {
                const t = this.getLabels();
                for (const { index: i, label: s } of e)t[i] === s && t.splice(i, 1);
                this._addedLabels = [];
            }
            super.init(t);
        }
        parse(t, e) {
            if (i(t)) return null;
            const s = this.getLabels();
            return ((t, e)=>null === t ? null : Z(Math.round(t), 0, e))(e = isFinite(e) && s[e] === t ? e : Qo(s, t, r(e, t), this._addedLabels), s.length - 1);
        }
        determineDataLimits() {
            const { minDefined: t, maxDefined: e } = this.getUserBounds();
            let { min: i, max: s } = this.getMinMax(!0);
            "ticks" === this.options.bounds && (t || (i = 0), e || (s = this.getLabels().length - 1)), this.min = i, this.max = s;
        }
        buildTicks() {
            const t = this.min, e = this.max, i = this.options.offset, s = [];
            let n = this.getLabels();
            n = 0 === t && e === n.length - 1 ? n : n.slice(t, e + 1), this._valueRange = Math.max(n.length - (i ? 0 : 1), 1), this._startValue = this.min - (i ? .5 : 0);
            for(let i = t; i <= e; i++)s.push({
                value: i
            });
            return s;
        }
        getLabelForValue(t) {
            const e = this.getLabels();
            return t >= 0 && t < e.length ? e[t] : t;
        }
        configure() {
            super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
        }
        getPixelForValue(t) {
            return "number" != typeof t && (t = this.parse(t)), null === t ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
        }
        getPixelForTick(t) {
            const e = this.ticks;
            return t < 0 || t > e.length - 1 ? null : this.getPixelForValue(e[t].value);
        }
        getValueForPixel(t) {
            return Math.round(this._startValue + this.getDecimalForPixel(t) * this._valueRange);
        }
        getBasePixel() {
            return this.bottom;
        }
    }
    function ea(t, e, { horizontal: i, minRotation: s }) {
        const n = H(s), o = (i ? Math.sin(n) : Math.cos(n)) || .001, a = .75 * e * ("" + t).length;
        return Math.min(e / o, a);
    }
    ta.id = "category", ta.defaults = {
        ticks: {
            callback: ta.prototype.getLabelForValue
        }
    };
    class ia extends $s {
        constructor(t){
            super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
        }
        parse(t, e) {
            return i(t) || ("number" == typeof t || t instanceof Number) && !isFinite(+t) ? null : +t;
        }
        handleTickRangeOptions() {
            const { beginAtZero: t } = this.options, { minDefined: e, maxDefined: i } = this.getUserBounds();
            let { min: s, max: n } = this;
            const o = (t)=>s = e ? s : t, a = (t)=>n = i ? n : t;
            if (t) {
                const t = z(s), e = z(n);
                t < 0 && e < 0 ? a(0) : t > 0 && e > 0 && o(0);
            }
            if (s === n) {
                let e = 1;
                (n >= Number.MAX_SAFE_INTEGER || s <= Number.MIN_SAFE_INTEGER) && (e = Math.abs(.05 * n)), a(n + e), t || o(s - e);
            }
            this.min = s, this.max = n;
        }
        getTickLimit() {
            const t = this.options.ticks;
            let e, { maxTicksLimit: i, stepSize: s } = t;
            return s ? (e = Math.ceil(this.max / s) - Math.floor(this.min / s) + 1, e > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${s} would result generating up to ${e} ticks. Limiting to 1000.`), e = 1e3)) : (e = this.computeTickLimit(), i = i || 11), i && (e = Math.min(i, e)), e;
        }
        computeTickLimit() {
            return Number.POSITIVE_INFINITY;
        }
        buildTicks() {
            const t = this.options, e = t.ticks;
            let s = this.getTickLimit();
            s = Math.max(2, s);
            const n = function(t, e) {
                const s = [], { bounds: n, step: o, min: a, max: r, precision: l, count: h, maxTicks: c, maxDigits: d, includeBounds: u } = t, f = o || 1, g = c - 1, { min: p, max: m } = e, b = !i(a), x = !i(r), _ = !i(h), y = (m - p) / (d + 1);
                let v, w, M, k, S = F((m - p) / g / f) * f;
                if (S < 1e-14 && !b && !x) return [
                    {
                        value: p
                    },
                    {
                        value: m
                    }
                ];
                k = Math.ceil(m / S) - Math.floor(p / S), k > g && (S = F(k * S / g / f) * f), i(l) || (v = Math.pow(10, l), S = Math.ceil(S * v) / v), "ticks" === n ? (w = Math.floor(p / S) * S, M = Math.ceil(m / S) * S) : (w = p, M = m), b && x && o && W((r - a) / o, S / 1e3) ? (k = Math.round(Math.min((r - a) / S, c)), S = (r - a) / k, w = a, M = r) : _ ? (w = b ? a : w, M = x ? r : M, k = h - 1, S = (M - w) / k) : (k = (M - w) / S, k = N(k, Math.round(k), S / 1e3) ? Math.round(k) : Math.ceil(k));
                const P = Math.max(Y(S), Y(w));
                v = Math.pow(10, i(l) ? P : l), w = Math.round(w * v) / v, M = Math.round(M * v) / v;
                let D = 0;
                for(b && (u && w !== a ? (s.push({
                    value: a
                }), w < a && D++, N(Math.round((w + D * S) * v) / v, a, ea(a, y, t)) && D++) : w < a && D++); D < k; ++D)s.push({
                    value: Math.round((w + D * S) * v) / v
                });
                return x && u && M !== r ? s.length && N(s[s.length - 1].value, r, ea(r, y, t)) ? s[s.length - 1].value = r : s.push({
                    value: r
                }) : x && M !== r || s.push({
                    value: M
                }), s;
            }({
                maxTicks: s,
                bounds: t.bounds,
                min: t.min,
                max: t.max,
                precision: e.precision,
                step: e.stepSize,
                count: e.count,
                maxDigits: this._maxDigits(),
                horizontal: this.isHorizontal(),
                minRotation: e.minRotation || 0,
                includeBounds: !1 !== e.includeBounds
            }, this._range || this);
            return "ticks" === t.bounds && j(n, this, "value"), t.reverse ? (n.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), n;
        }
        configure() {
            const t = this.ticks;
            let e = this.min, i = this.max;
            if (super.configure(), this.options.offset && t.length) {
                const s = (i - e) / Math.max(t.length - 1, 1) / 2;
                e -= s, i += s;
            }
            this._startValue = e, this._endValue = i, this._valueRange = i - e;
        }
        getLabelForValue(t) {
            return li(t, this.chart.options.locale, this.options.ticks.format);
        }
    }
    class sa extends ia {
        determineDataLimits() {
            const { min: t, max: e } = this.getMinMax(!0);
            this.min = o(t) ? t : 0, this.max = o(e) ? e : 1, this.handleTickRangeOptions();
        }
        computeTickLimit() {
            const t = this.isHorizontal(), e = t ? this.width : this.height, i = H(this.options.ticks.minRotation), s = (t ? Math.sin(i) : Math.cos(i)) || .001, n = this._resolveTickFontOptions(0);
            return Math.ceil(e / Math.min(40, n.lineHeight / s));
        }
        getPixelForValue(t) {
            return null === t ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
        }
        getValueForPixel(t) {
            return this._startValue + this.getDecimalForPixel(t) * this._valueRange;
        }
    }
    function na(t) {
        return 1 === t / Math.pow(10, Math.floor(I(t)));
    }
    sa.id = "linear", sa.defaults = {
        ticks: {
            callback: Is.formatters.numeric
        }
    };
    class oa extends $s {
        constructor(t){
            super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
        }
        parse(t, e) {
            const i = ia.prototype.parse.apply(this, [
                t,
                e
            ]);
            if (0 !== i) return o(i) && i > 0 ? i : null;
            this._zero = !0;
        }
        determineDataLimits() {
            const { min: t, max: e } = this.getMinMax(!0);
            this.min = o(t) ? Math.max(0, t) : null, this.max = o(e) ? Math.max(0, e) : null, this.options.beginAtZero && (this._zero = !0), this.handleTickRangeOptions();
        }
        handleTickRangeOptions() {
            const { minDefined: t, maxDefined: e } = this.getUserBounds();
            let i = this.min, s = this.max;
            const n = (e)=>i = t ? i : e, o = (t)=>s = e ? s : t, a = (t, e)=>Math.pow(10, Math.floor(I(t)) + e);
            i === s && (i <= 0 ? (n(1), o(10)) : (n(a(i, -1)), o(a(s, 1)))), i <= 0 && n(a(s, -1)), s <= 0 && o(a(i, 1)), this._zero && this.min !== this._suggestedMin && i === a(this.min, 0) && n(a(i, -1)), this.min = i, this.max = s;
        }
        buildTicks() {
            const t = this.options, e = function(t, e) {
                const i = Math.floor(I(e.max)), s = Math.ceil(e.max / Math.pow(10, i)), n = [];
                let o = a(t.min, Math.pow(10, Math.floor(I(e.min)))), r = Math.floor(I(o)), l = Math.floor(o / Math.pow(10, r)), h = r < 0 ? Math.pow(10, Math.abs(r)) : 1;
                do n.push({
                    value: o,
                    major: na(o)
                }), ++l, 10 === l && (l = 1, ++r, h = r >= 0 ? 1 : h), o = Math.round(l * Math.pow(10, r) * h) / h;
                while (r < i || r === i && l < s);
                const c = a(t.max, o);
                return n.push({
                    value: c,
                    major: na(o)
                }), n;
            }({
                min: this._userMin,
                max: this._userMax
            }, this);
            return "ticks" === t.bounds && j(e, this, "value"), t.reverse ? (e.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), e;
        }
        getLabelForValue(t) {
            return void 0 === t ? "0" : li(t, this.chart.options.locale, this.options.ticks.format);
        }
        configure() {
            const t = this.min;
            super.configure(), this._startValue = I(t), this._valueRange = I(this.max) - I(t);
        }
        getPixelForValue(t) {
            return void 0 !== t && 0 !== t || (t = this.min), null === t || isNaN(t) ? NaN : this.getPixelForDecimal(t === this.min ? 0 : (I(t) - this._startValue) / this._valueRange);
        }
        getValueForPixel(t) {
            const e = this.getDecimalForPixel(t);
            return Math.pow(10, this._startValue + e * this._valueRange);
        }
    }
    function aa(t) {
        const e = t.ticks;
        if (e.display && t.display) {
            const t = pi(e.backdropPadding);
            return r(e.font && e.font.size, ne.font.size) + t.height;
        }
        return 0;
    }
    function ra(t, e, i, s, n) {
        return t === s || t === n ? {
            start: e - i / 2,
            end: e + i / 2
        } : t < s || t > n ? {
            start: e - i,
            end: e
        } : {
            start: e,
            end: e + i
        };
    }
    function la(t) {
        const e = {
            l: t.left + t._padding.left,
            r: t.right - t._padding.right,
            t: t.top + t._padding.top,
            b: t.bottom - t._padding.bottom
        }, i = Object.assign({}, e), n = [], o = [], a = t._pointLabels.length, r = t.options.pointLabels, l = r.centerPointLabels ? D / a : 0;
        for(let u = 0; u < a; u++){
            const a = r.setContext(t.getPointLabelContext(u));
            o[u] = a.padding;
            const f = t.getPointPosition(u, t.drawingArea + o[u], l), g = mi(a.font), p = (h = t.ctx, c = g, d = s(d = t._pointLabels[u]) ? d : [
                d
            ], {
                w: ye(h, c.string, d),
                h: d.length * c.lineHeight
            });
            n[u] = p;
            const m = K(t.getIndexAngle(u) + l), b = Math.round($(m));
            ha(i, e, m, ra(b, f.x, p.w, 0, 180), ra(b, f.y, p.h, 90, 270));
        }
        var h, c, d;
        t.setCenterPoint(e.l - i.l, i.r - e.r, e.t - i.t, i.b - e.b), t._pointLabelItems = function(t, e, i) {
            const s = [], n = t._pointLabels.length, o = t.options, a = aa(o) / 2, r = t.drawingArea, l = o.pointLabels.centerPointLabels ? D / n : 0;
            for(let o = 0; o < n; o++){
                const n = t.getPointPosition(o, r + a + i[o], l), h = Math.round($(K(n.angle + L))), c = e[o], d = ua(n.y, c.h, h), u = ca(h), f = da(n.x, c.w, u);
                s.push({
                    x: n.x,
                    y: d,
                    textAlign: u,
                    left: f,
                    top: d,
                    right: f + c.w,
                    bottom: d + c.h
                });
            }
            return s;
        }(t, n, o);
    }
    function ha(t, e, i, s, n) {
        const o = Math.abs(Math.sin(i)), a = Math.abs(Math.cos(i));
        let r = 0, l = 0;
        s.start < e.l ? (r = (e.l - s.start) / o, t.l = Math.min(t.l, e.l - r)) : s.end > e.r && (r = (s.end - e.r) / o, t.r = Math.max(t.r, e.r + r)), n.start < e.t ? (l = (e.t - n.start) / a, t.t = Math.min(t.t, e.t - l)) : n.end > e.b && (l = (n.end - e.b) / a, t.b = Math.max(t.b, e.b + l));
    }
    function ca(t) {
        return 0 === t || 180 === t ? "center" : t < 180 ? "left" : "right";
    }
    function da(t, e, i) {
        return "right" === i ? t -= e : "center" === i && (t -= e / 2), t;
    }
    function ua(t, e, i) {
        return 90 === i || 270 === i ? t -= e / 2 : (i > 270 || i < 90) && (t -= e), t;
    }
    function fa(t, e, i, s) {
        const { ctx: n } = t;
        if (i) n.arc(t.xCenter, t.yCenter, e, 0, O);
        else {
            let i = t.getPointPosition(0, e);
            n.moveTo(i.x, i.y);
            for(let o = 1; o < s; o++)i = t.getPointPosition(o, e), n.lineTo(i.x, i.y);
        }
    }
    oa.id = "logarithmic", oa.defaults = {
        ticks: {
            callback: Is.formatters.logarithmic,
            major: {
                enabled: !0
            }
        }
    };
    class ga extends ia {
        constructor(t){
            super(t), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
        }
        setDimensions() {
            const t = this._padding = pi(aa(this.options) / 2), e = this.width = this.maxWidth - t.width, i = this.height = this.maxHeight - t.height;
            this.xCenter = Math.floor(this.left + e / 2 + t.left), this.yCenter = Math.floor(this.top + i / 2 + t.top), this.drawingArea = Math.floor(Math.min(e, i) / 2);
        }
        determineDataLimits() {
            const { min: t, max: e } = this.getMinMax(!1);
            this.min = o(t) && !isNaN(t) ? t : 0, this.max = o(e) && !isNaN(e) ? e : 0, this.handleTickRangeOptions();
        }
        computeTickLimit() {
            return Math.ceil(this.drawingArea / aa(this.options));
        }
        generateTickLabels(t) {
            ia.prototype.generateTickLabels.call(this, t), this._pointLabels = this.getLabels().map((t, e)=>{
                const i = c(this.options.pointLabels.callback, [
                    t,
                    e
                ], this);
                return i || 0 === i ? i : "";
            }).filter((t, e)=>this.chart.getDataVisibility(e));
        }
        fit() {
            const t = this.options;
            t.display && t.pointLabels.display ? la(this) : this.setCenterPoint(0, 0, 0, 0);
        }
        setCenterPoint(t, e, i, s) {
            this.xCenter += Math.floor((t - e) / 2), this.yCenter += Math.floor((i - s) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(t, e, i, s));
        }
        getIndexAngle(t) {
            return K(t * (O / (this._pointLabels.length || 1)) + H(this.options.startAngle || 0));
        }
        getDistanceFromCenterForValue(t) {
            if (i(t)) return NaN;
            const e = this.drawingArea / (this.max - this.min);
            return this.options.reverse ? (this.max - t) * e : (t - this.min) * e;
        }
        getValueForDistanceFromCenter(t) {
            if (i(t)) return NaN;
            const e = t / (this.drawingArea / (this.max - this.min));
            return this.options.reverse ? this.max - e : this.min + e;
        }
        getPointLabelContext(t) {
            const e = this._pointLabels || [];
            if (t >= 0 && t < e.length) {
                const i = e[t];
                return function(t, e, i) {
                    return _i(t, {
                        label: i,
                        index: e,
                        type: "pointLabel"
                    });
                }(this.getContext(), t, i);
            }
        }
        getPointPosition(t, e, i = 0) {
            const s = this.getIndexAngle(t) - L + i;
            return {
                x: Math.cos(s) * e + this.xCenter,
                y: Math.sin(s) * e + this.yCenter,
                angle: s
            };
        }
        getPointPositionForValue(t, e) {
            return this.getPointPosition(t, this.getDistanceFromCenterForValue(e));
        }
        getBasePosition(t) {
            return this.getPointPositionForValue(t || 0, this.getBaseValue());
        }
        getPointLabelPosition(t) {
            const { left: e, top: i, right: s, bottom: n } = this._pointLabelItems[t];
            return {
                left: e,
                top: i,
                right: s,
                bottom: n
            };
        }
        drawBackground() {
            const { backgroundColor: t, grid: { circular: e } } = this.options;
            if (t) {
                const i = this.ctx;
                i.save(), i.beginPath(), fa(this, this.getDistanceFromCenterForValue(this._endValue), e, this._pointLabels.length), i.closePath(), i.fillStyle = t, i.fill(), i.restore();
            }
        }
        drawGrid() {
            const t = this.ctx, e = this.options, { angleLines: s, grid: n } = e, o = this._pointLabels.length;
            let a, r, l;
            if (e.pointLabels.display && function(t, e) {
                const { ctx: s, options: { pointLabels: n } } = t;
                for(let o = e - 1; o >= 0; o--){
                    const e = n.setContext(t.getPointLabelContext(o)), a = mi(e.font), { x: r, y: l, textAlign: h, left: c, top: d, right: u, bottom: f } = t._pointLabelItems[o], { backdropColor: g } = e;
                    if (!i(g)) {
                        const t = gi(e.borderRadius), i = pi(e.backdropPadding);
                        s.fillStyle = g;
                        const n = c - i.left, o = d - i.top, a = u - c + i.width, r = f - d + i.height;
                        Object.values(t).some((t)=>0 !== t) ? (s.beginPath(), Le(s, {
                            x: n,
                            y: o,
                            w: a,
                            h: r,
                            radius: t
                        }), s.fill()) : s.fillRect(n, o, a, r);
                    }
                    Ae(s, t._pointLabels[o], r, l + a.lineHeight / 2, a, {
                        color: e.color,
                        textAlign: h,
                        textBaseline: "middle"
                    });
                }
            }(this, o), n.display && this.ticks.forEach((t, e)=>{
                if (0 !== e) {
                    r = this.getDistanceFromCenterForValue(t.value);
                    !function(t, e, i, s) {
                        const n = t.ctx, o = e.circular, { color: a, lineWidth: r } = e;
                        !o && !s || !a || !r || i < 0 || (n.save(), n.strokeStyle = a, n.lineWidth = r, n.setLineDash(e.borderDash), n.lineDashOffset = e.borderDashOffset, n.beginPath(), fa(t, i, o, s), n.closePath(), n.stroke(), n.restore());
                    }(this, n.setContext(this.getContext(e - 1)), r, o);
                }
            }), s.display) {
                for(t.save(), a = o - 1; a >= 0; a--){
                    const i = s.setContext(this.getPointLabelContext(a)), { color: n, lineWidth: o } = i;
                    o && n && (t.lineWidth = o, t.strokeStyle = n, t.setLineDash(i.borderDash), t.lineDashOffset = i.borderDashOffset, r = this.getDistanceFromCenterForValue(e.ticks.reverse ? this.min : this.max), l = this.getPointPosition(a, r), t.beginPath(), t.moveTo(this.xCenter, this.yCenter), t.lineTo(l.x, l.y), t.stroke());
                }
                t.restore();
            }
        }
        drawBorder() {}
        drawLabels() {
            const t = this.ctx, e = this.options, i = e.ticks;
            if (!i.display) return;
            const s = this.getIndexAngle(0);
            let n, o;
            t.save(), t.translate(this.xCenter, this.yCenter), t.rotate(s), t.textAlign = "center", t.textBaseline = "middle", this.ticks.forEach((s, a)=>{
                if (0 === a && !e.reverse) return;
                const r = i.setContext(this.getContext(a)), l = mi(r.font);
                if (n = this.getDistanceFromCenterForValue(this.ticks[a].value), r.showLabelBackdrop) {
                    t.font = l.string, o = t.measureText(s.label).width, t.fillStyle = r.backdropColor;
                    const e = pi(r.backdropPadding);
                    t.fillRect(-o / 2 - e.left, -n - l.size / 2 - e.top, o + e.width, l.size + e.height);
                }
                Ae(t, s.label, 0, -n, l, {
                    color: r.color
                });
            }), t.restore();
        }
        drawTitle() {}
    }
    ga.id = "radialLinear", ga.defaults = {
        display: !0,
        animate: !0,
        position: "chartArea",
        angleLines: {
            display: !0,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0
        },
        grid: {
            circular: !1
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: !0,
            callback: Is.formatters.numeric
        },
        pointLabels: {
            backdropColor: void 0,
            backdropPadding: 2,
            display: !0,
            font: {
                size: 10
            },
            callback: (t)=>t,
            padding: 5,
            centerPointLabels: !1
        }
    }, ga.defaultRoutes = {
        "angleLines.color": "borderColor",
        "pointLabels.color": "color",
        "ticks.color": "color"
    }, ga.descriptors = {
        angleLines: {
            _fallback: "grid"
        }
    };
    const pa = {
        millisecond: {
            common: !0,
            size: 1,
            steps: 1e3
        },
        second: {
            common: !0,
            size: 1e3,
            steps: 60
        },
        minute: {
            common: !0,
            size: 6e4,
            steps: 60
        },
        hour: {
            common: !0,
            size: 36e5,
            steps: 24
        },
        day: {
            common: !0,
            size: 864e5,
            steps: 30
        },
        week: {
            common: !1,
            size: 6048e5,
            steps: 4
        },
        month: {
            common: !0,
            size: 2628e6,
            steps: 12
        },
        quarter: {
            common: !1,
            size: 7884e6,
            steps: 4
        },
        year: {
            common: !0,
            size: 3154e7
        }
    }, ma = Object.keys(pa);
    function ba(t, e) {
        return t - e;
    }
    function xa(t, e) {
        if (i(e)) return null;
        const s = t._adapter, { parser: n, round: a, isoWeekday: r } = t._parseOpts;
        let l = e;
        return "function" == typeof n && (l = n(l)), o(l) || (l = "string" == typeof n ? s.parse(l, n) : s.parse(l)), null === l ? null : (a && (l = "week" !== a || !B(r) && !0 !== r ? s.startOf(l, a) : s.startOf(l, "isoWeek", r)), +l);
    }
    function _a(t, e, i, s) {
        const n = ma.length;
        for(let o = ma.indexOf(t); o < n - 1; ++o){
            const t = pa[ma[o]], n = t.steps ? t.steps : Number.MAX_SAFE_INTEGER;
            if (t.common && Math.ceil((i - e) / (n * t.size)) <= s) return ma[o];
        }
        return ma[n - 1];
    }
    function ya(t, e, i) {
        if (i) {
            if (i.length) {
                const { lo: s, hi: n } = tt(i, e);
                t[i[s] >= e ? i[s] : i[n]] = !0;
            }
        } else t[e] = !0;
    }
    function va(t, e, i) {
        const s = [], n = {}, o = e.length;
        let a, r;
        for(a = 0; a < o; ++a)r = e[a], n[r] = a, s.push({
            value: r,
            major: !1
        });
        return 0 !== o && i ? function(t, e, i, s) {
            const n = t._adapter, o = +n.startOf(e[0].value, s), a = e[e.length - 1].value;
            let r, l;
            for(r = o; r <= a; r = +n.add(r, 1, s))l = i[r], l >= 0 && (e[l].major = !0);
            return e;
        }(t, s, n, i) : s;
    }
    class wa extends $s {
        constructor(t){
            super(t), this._cache = {
                data: [],
                labels: [],
                all: []
            }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
        }
        init(t, e) {
            const i = t.time || (t.time = {}), s = this._adapter = new wn._date(t.adapters.date);
            s.init(e), b(i.displayFormats, s.formats()), this._parseOpts = {
                parser: i.parser,
                round: i.round,
                isoWeekday: i.isoWeekday
            }, super.init(t), this._normalized = e.normalized;
        }
        parse(t, e) {
            return void 0 === t ? null : xa(this, t);
        }
        beforeLayout() {
            super.beforeLayout(), this._cache = {
                data: [],
                labels: [],
                all: []
            };
        }
        determineDataLimits() {
            const t = this.options, e = this._adapter, i = t.time.unit || "day";
            let { min: s, max: n, minDefined: a, maxDefined: r } = this.getUserBounds();
            function l(t) {
                a || isNaN(t.min) || (s = Math.min(s, t.min)), r || isNaN(t.max) || (n = Math.max(n, t.max));
            }
            a && r || (l(this._getLabelBounds()), "ticks" === t.bounds && "labels" === t.ticks.source || l(this.getMinMax(!1))), s = o(s) && !isNaN(s) ? s : +e.startOf(Date.now(), i), n = o(n) && !isNaN(n) ? n : +e.endOf(Date.now(), i) + 1, this.min = Math.min(s, n - 1), this.max = Math.max(s + 1, n);
        }
        _getLabelBounds() {
            const t = this.getLabelTimestamps();
            let e = Number.POSITIVE_INFINITY, i = Number.NEGATIVE_INFINITY;
            return t.length && (e = t[0], i = t[t.length - 1]), {
                min: e,
                max: i
            };
        }
        buildTicks() {
            const t = this.options, e = t.time, i = t.ticks, s = "labels" === i.source ? this.getLabelTimestamps() : this._generate();
            "ticks" === t.bounds && s.length && (this.min = this._userMin || s[0], this.max = this._userMax || s[s.length - 1]);
            const n = this.min, o = st(s, n, this.max);
            return this._unit = e.unit || (i.autoSkip ? _a(e.minUnit, this.min, this.max, this._getLabelCapacity(n)) : function(t, e, i, s, n) {
                for(let o = ma.length - 1; o >= ma.indexOf(i); o--){
                    const i = ma[o];
                    if (pa[i].common && t._adapter.diff(n, s, i) >= e - 1) return i;
                }
                return ma[i ? ma.indexOf(i) : 0];
            }(this, o.length, e.minUnit, this.min, this.max)), this._majorUnit = i.major.enabled && "year" !== this._unit ? function(t) {
                for(let e = ma.indexOf(t) + 1, i = ma.length; e < i; ++e)if (pa[ma[e]].common) return ma[e];
            }(this._unit) : void 0, this.initOffsets(s), t.reverse && o.reverse(), va(this, o, this._majorUnit);
        }
        afterAutoSkip() {
            this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((t)=>+t.value));
        }
        initOffsets(t) {
            let e, i, s = 0, n = 0;
            this.options.offset && t.length && (e = this.getDecimalForValue(t[0]), s = 1 === t.length ? 1 - e : (this.getDecimalForValue(t[1]) - e) / 2, i = this.getDecimalForValue(t[t.length - 1]), n = 1 === t.length ? i : (i - this.getDecimalForValue(t[t.length - 2])) / 2);
            const o = t.length < 3 ? .5 : .25;
            s = Z(s, 0, o), n = Z(n, 0, o), this._offsets = {
                start: s,
                end: n,
                factor: 1 / (s + 1 + n)
            };
        }
        _generate() {
            const t = this._adapter, e = this.min, i = this.max, s = this.options, n = s.time, o = n.unit || _a(n.minUnit, e, i, this._getLabelCapacity(e)), a = r(n.stepSize, 1), l = "week" === o && n.isoWeekday, h = B(l) || !0 === l, c = {};
            let d, u, f = e;
            if (h && (f = +t.startOf(f, "isoWeek", l)), f = +t.startOf(f, h ? "day" : o), t.diff(i, e, o) > 1e5 * a) throw new Error(e + " and " + i + " are too far apart with stepSize of " + a + " " + o);
            const g = "data" === s.ticks.source && this.getDataTimestamps();
            for(d = f, u = 0; d < i; d = +t.add(d, a, o), u++)ya(c, d, g);
            return d !== i && "ticks" !== s.bounds && 1 !== u || ya(c, d, g), Object.keys(c).sort((t, e)=>t - e).map((t)=>+t);
        }
        getLabelForValue(t) {
            const e = this._adapter, i = this.options.time;
            return i.tooltipFormat ? e.format(t, i.tooltipFormat) : e.format(t, i.displayFormats.datetime);
        }
        _tickFormatFunction(t, e, i, s) {
            const n = this.options, o = n.time.displayFormats, a = this._unit, r = this._majorUnit, l = a && o[a], h = r && o[r], d = i[e], u = r && h && d && d.major, f = this._adapter.format(t, s || (u ? h : l)), g = n.ticks.callback;
            return g ? c(g, [
                f,
                e,
                i
            ], this) : f;
        }
        generateTickLabels(t) {
            let e, i, s;
            for(e = 0, i = t.length; e < i; ++e)s = t[e], s.label = this._tickFormatFunction(s.value, e, t);
        }
        getDecimalForValue(t) {
            return null === t ? NaN : (t - this.min) / (this.max - this.min);
        }
        getPixelForValue(t) {
            const e = this._offsets, i = this.getDecimalForValue(t);
            return this.getPixelForDecimal((e.start + i) * e.factor);
        }
        getValueForPixel(t) {
            const e = this._offsets, i = this.getDecimalForPixel(t) / e.factor - e.end;
            return this.min + i * (this.max - this.min);
        }
        _getLabelSize(t) {
            const e = this.options.ticks, i = this.ctx.measureText(t).width, s = H(this.isHorizontal() ? e.maxRotation : e.minRotation), n = Math.cos(s), o = Math.sin(s), a = this._resolveTickFontOptions(0).size;
            return {
                w: i * n + a * o,
                h: i * o + a * n
            };
        }
        _getLabelCapacity(t) {
            const e = this.options.time, i = e.displayFormats, s = i[e.unit] || i.millisecond, n = this._tickFormatFunction(t, 0, va(this, [
                t
            ], this._majorUnit), s), o = this._getLabelSize(n), a = Math.floor(this.isHorizontal() ? this.width / o.w : this.height / o.h) - 1;
            return a > 0 ? a : 1;
        }
        getDataTimestamps() {
            let t, e, i = this._cache.data || [];
            if (i.length) return i;
            const s = this.getMatchingVisibleMetas();
            if (this._normalized && s.length) return this._cache.data = s[0].controller.getAllParsedValues(this);
            for(t = 0, e = s.length; t < e; ++t)i = i.concat(s[t].controller.getAllParsedValues(this));
            return this._cache.data = this.normalize(i);
        }
        getLabelTimestamps() {
            const t = this._cache.labels || [];
            let e, i;
            if (t.length) return t;
            const s = this.getLabels();
            for(e = 0, i = s.length; e < i; ++e)t.push(xa(this, s[e]));
            return this._cache.labels = this._normalized ? t : this.normalize(t);
        }
        normalize(t) {
            return rt(t.sort(ba));
        }
    }
    function Ma(t, e, i) {
        let s, n, o, a, r = 0, l = t.length - 1;
        i ? (e >= t[r].pos && e <= t[l].pos && ({ lo: r, hi: l } = et(t, "pos", e)), { pos: s, time: o } = t[r], { pos: n, time: a } = t[l]) : (e >= t[r].time && e <= t[l].time && ({ lo: r, hi: l } = et(t, "time", e)), { time: s, pos: o } = t[r], { time: n, pos: a } = t[l]);
        const h = n - s;
        return h ? o + (a - o) * (e - s) / h : o;
    }
    wa.id = "time", wa.defaults = {
        bounds: "data",
        adapters: {},
        time: {
            parser: !1,
            unit: !1,
            round: !1,
            isoWeekday: !1,
            minUnit: "millisecond",
            displayFormats: {}
        },
        ticks: {
            source: "auto",
            major: {
                enabled: !1
            }
        }
    };
    class ka extends wa {
        constructor(t){
            super(t), this._table = [], this._minPos = void 0, this._tableRange = void 0;
        }
        initOffsets() {
            const t = this._getTimestampsForTable(), e = this._table = this.buildLookupTable(t);
            this._minPos = Ma(e, this.min), this._tableRange = Ma(e, this.max) - this._minPos, super.initOffsets(t);
        }
        buildLookupTable(t) {
            const { min: e, max: i } = this, s = [], n = [];
            let o, a, r, l, h;
            for(o = 0, a = t.length; o < a; ++o)l = t[o], l >= e && l <= i && s.push(l);
            if (s.length < 2) return [
                {
                    time: e,
                    pos: 0
                },
                {
                    time: i,
                    pos: 1
                }
            ];
            for(o = 0, a = s.length; o < a; ++o)h = s[o + 1], r = s[o - 1], l = s[o], Math.round((h + r) / 2) !== l && n.push({
                time: l,
                pos: o / (a - 1)
            });
            return n;
        }
        _getTimestampsForTable() {
            let t = this._cache.all || [];
            if (t.length) return t;
            const e = this.getDataTimestamps(), i = this.getLabelTimestamps();
            return t = e.length && i.length ? this.normalize(e.concat(i)) : e.length ? e : i, t = this._cache.all = t, t;
        }
        getDecimalForValue(t) {
            return (Ma(this._table, t) - this._minPos) / this._tableRange;
        }
        getValueForPixel(t) {
            const e = this._offsets, i = this.getDecimalForPixel(t) / e.factor - e.end;
            return Ma(this._table, i * this._tableRange + this._minPos, !0);
        }
    }
    ka.id = "timeseries", ka.defaults = wa.defaults;
    var Sa = Object.freeze({
        __proto__: null,
        CategoryScale: ta,
        LinearScale: sa,
        LogarithmicScale: oa,
        RadialLinearScale: ga,
        TimeScale: wa,
        TimeSeriesScale: ka
    });
    return bn.register(Bn, Sa, co, Jo), bn.helpers = {
        ...Ti
    }, bn._adapters = wn, bn.Animation = xs, bn.Animations = ys, bn.animator = mt, bn.controllers = Us.controllers.items, bn.DatasetController = Ls, bn.Element = Es, bn.elements = co, bn.Interaction = Vi, bn.layouts = Zi, bn.platforms = ps, bn.Scale = $s, bn.Ticks = Is, Object.assign(bn, Bn, Sa, co, Jo, ps), bn.Chart = bn, "undefined" != typeof window && (window.Chart = bn), bn;
});



var $b528e95d53049f90$exports = {};


/**
* @version: 3.1
* @author: Dan Grossman http://www.dangrossman.info/
* @copyright: Copyright (c) 2012-2019 Dan Grossman. All rights reserved.
* @license: Licensed under the MIT license. See http://www.opensource.org/licenses/mit-license.php
* @website: http://www.daterangepicker.com/
*/ // Following the UMD template https://github.com/umdjs/umd/blob/master/templates/returnExportsGlobal.js
(function(root, factory) {
    if (typeof define === 'function' && define.amd) // AMD. Make globaly available as well
    define([
        'moment',
        'jquery'
    ], function(moment, jquery) {
        if (!jquery.fn) jquery.fn = {}; // webpack server rendering
        if (typeof moment !== 'function' && moment.hasOwnProperty('default')) moment = moment['default'];
        return factory(moment, jquery);
    });
    else if ($b528e95d53049f90$exports) {
        // Node / Browserify
        //isomorphic issue
        var jQuery = typeof window != 'undefined' ? window.jQuery : undefined;
        if (!jQuery) {
            jQuery = (parcelRequire("iUSsr"));
            if (!jQuery.fn) jQuery.fn = {};
        }
        var moment = typeof window != 'undefined' && typeof window.moment != 'undefined' ? window.moment : (parcelRequire("YChVI"));
        $b528e95d53049f90$exports = factory(moment, jQuery);
    } else // Browser globals
    root.daterangepicker = factory(root.moment, root.jQuery);
})($b528e95d53049f90$exports, function(moment, $) {
    var DateRangePicker = function(element, options, cb) {
        //default settings for options
        this.parentEl = 'body';
        this.element = $(element);
        this.startDate = moment().startOf('day');
        this.endDate = moment().endOf('day');
        this.minDate = false;
        this.maxDate = false;
        this.maxSpan = false;
        this.autoApply = false;
        this.singleDatePicker = false;
        this.showDropdowns = false;
        this.minYear = moment().subtract(100, 'year').format('YYYY');
        this.maxYear = moment().add(100, 'year').format('YYYY');
        this.showWeekNumbers = false;
        this.showISOWeekNumbers = false;
        this.showCustomRangeLabel = true;
        this.timePicker = false;
        this.timePicker24Hour = false;
        this.timePickerIncrement = 1;
        this.timePickerSeconds = false;
        this.linkedCalendars = true;
        this.autoUpdateInput = true;
        this.alwaysShowCalendars = false;
        this.ranges = {};
        this.opens = 'right';
        if (this.element.hasClass('pull-right')) this.opens = 'left';
        this.drops = 'down';
        if (this.element.hasClass('dropup')) this.drops = 'up';
        this.buttonClasses = 'btn btn-sm';
        this.applyButtonClasses = 'btn-primary';
        this.cancelButtonClasses = 'btn-default';
        this.locale = {
            direction: 'ltr',
            format: moment.localeData().longDateFormat('L'),
            separator: ' - ',
            applyLabel: 'Apply',
            cancelLabel: 'Cancel',
            weekLabel: 'W',
            customRangeLabel: 'Custom Range',
            daysOfWeek: moment.weekdaysMin(),
            monthNames: moment.monthsShort(),
            firstDay: moment.localeData().firstDayOfWeek()
        };
        this.callback = function() {};
        //some state information
        this.isShowing = false;
        this.leftCalendar = {};
        this.rightCalendar = {};
        //custom options from user
        if (typeof options !== 'object' || options === null) options = {};
        //allow setting options with data attributes
        //data-api options will be overwritten with custom javascript options
        options = $.extend(this.element.data(), options);
        //html template for the picker UI
        if (typeof options.template !== 'string' && !(options.template instanceof $)) options.template = '<div class="daterangepicker"><div class="ranges"></div><div class="drp-calendar left"><div class="calendar-table"></div><div class="calendar-time"></div></div><div class="drp-calendar right"><div class="calendar-table"></div><div class="calendar-time"></div></div><div class="drp-buttons"><span class="drp-selected"></span><button class="cancelBtn" type="button"></button><button class="applyBtn" disabled="disabled" type="button"></button> </div></div>';
        this.parentEl = options.parentEl && $(options.parentEl).length ? $(options.parentEl) : $(this.parentEl);
        this.container = $(options.template).appendTo(this.parentEl);
        //
        // handle all the possible options overriding defaults
        //
        if (typeof options.locale === 'object') {
            if (typeof options.locale.direction === 'string') this.locale.direction = options.locale.direction;
            if (typeof options.locale.format === 'string') this.locale.format = options.locale.format;
            if (typeof options.locale.separator === 'string') this.locale.separator = options.locale.separator;
            if (typeof options.locale.daysOfWeek === 'object') this.locale.daysOfWeek = options.locale.daysOfWeek.slice();
            if (typeof options.locale.monthNames === 'object') this.locale.monthNames = options.locale.monthNames.slice();
            if (typeof options.locale.firstDay === 'number') this.locale.firstDay = options.locale.firstDay;
            if (typeof options.locale.applyLabel === 'string') this.locale.applyLabel = options.locale.applyLabel;
            if (typeof options.locale.cancelLabel === 'string') this.locale.cancelLabel = options.locale.cancelLabel;
            if (typeof options.locale.weekLabel === 'string') this.locale.weekLabel = options.locale.weekLabel;
            if (typeof options.locale.customRangeLabel === 'string') {
                //Support unicode chars in the custom range name.
                var elem = document.createElement('textarea');
                elem.innerHTML = options.locale.customRangeLabel;
                var rangeHtml = elem.value;
                this.locale.customRangeLabel = rangeHtml;
            }
        }
        this.container.addClass(this.locale.direction);
        if (typeof options.startDate === 'string') this.startDate = moment(options.startDate, this.locale.format);
        if (typeof options.endDate === 'string') this.endDate = moment(options.endDate, this.locale.format);
        if (typeof options.minDate === 'string') this.minDate = moment(options.minDate, this.locale.format);
        if (typeof options.maxDate === 'string') this.maxDate = moment(options.maxDate, this.locale.format);
        if (typeof options.startDate === 'object') this.startDate = moment(options.startDate);
        if (typeof options.endDate === 'object') this.endDate = moment(options.endDate);
        if (typeof options.minDate === 'object') this.minDate = moment(options.minDate);
        if (typeof options.maxDate === 'object') this.maxDate = moment(options.maxDate);
        // sanity check for bad options
        if (this.minDate && this.startDate.isBefore(this.minDate)) this.startDate = this.minDate.clone();
        // sanity check for bad options
        if (this.maxDate && this.endDate.isAfter(this.maxDate)) this.endDate = this.maxDate.clone();
        if (typeof options.applyButtonClasses === 'string') this.applyButtonClasses = options.applyButtonClasses;
        if (typeof options.applyClass === 'string') this.applyButtonClasses = options.applyClass;
        if (typeof options.cancelButtonClasses === 'string') this.cancelButtonClasses = options.cancelButtonClasses;
        if (typeof options.cancelClass === 'string') this.cancelButtonClasses = options.cancelClass;
        if (typeof options.maxSpan === 'object') this.maxSpan = options.maxSpan;
        if (typeof options.dateLimit === 'object') this.maxSpan = options.dateLimit;
        if (typeof options.opens === 'string') this.opens = options.opens;
        if (typeof options.drops === 'string') this.drops = options.drops;
        if (typeof options.showWeekNumbers === 'boolean') this.showWeekNumbers = options.showWeekNumbers;
        if (typeof options.showISOWeekNumbers === 'boolean') this.showISOWeekNumbers = options.showISOWeekNumbers;
        if (typeof options.buttonClasses === 'string') this.buttonClasses = options.buttonClasses;
        if (typeof options.buttonClasses === 'object') this.buttonClasses = options.buttonClasses.join(' ');
        if (typeof options.showDropdowns === 'boolean') this.showDropdowns = options.showDropdowns;
        if (typeof options.minYear === 'number') this.minYear = options.minYear;
        if (typeof options.maxYear === 'number') this.maxYear = options.maxYear;
        if (typeof options.showCustomRangeLabel === 'boolean') this.showCustomRangeLabel = options.showCustomRangeLabel;
        if (typeof options.singleDatePicker === 'boolean') {
            this.singleDatePicker = options.singleDatePicker;
            if (this.singleDatePicker) this.endDate = this.startDate.clone();
        }
        if (typeof options.timePicker === 'boolean') this.timePicker = options.timePicker;
        if (typeof options.timePickerSeconds === 'boolean') this.timePickerSeconds = options.timePickerSeconds;
        if (typeof options.timePickerIncrement === 'number') this.timePickerIncrement = options.timePickerIncrement;
        if (typeof options.timePicker24Hour === 'boolean') this.timePicker24Hour = options.timePicker24Hour;
        if (typeof options.autoApply === 'boolean') this.autoApply = options.autoApply;
        if (typeof options.autoUpdateInput === 'boolean') this.autoUpdateInput = options.autoUpdateInput;
        if (typeof options.linkedCalendars === 'boolean') this.linkedCalendars = options.linkedCalendars;
        if (typeof options.isInvalidDate === 'function') this.isInvalidDate = options.isInvalidDate;
        if (typeof options.isCustomDate === 'function') this.isCustomDate = options.isCustomDate;
        if (typeof options.alwaysShowCalendars === 'boolean') this.alwaysShowCalendars = options.alwaysShowCalendars;
        // update day names order to firstDay
        if (this.locale.firstDay != 0) {
            var iterator = this.locale.firstDay;
            while(iterator > 0){
                this.locale.daysOfWeek.push(this.locale.daysOfWeek.shift());
                iterator--;
            }
        }
        var start, end, range;
        //if no start/end dates set, check if an input element contains initial values
        if (typeof options.startDate === 'undefined' && typeof options.endDate === 'undefined') {
            if ($(this.element).is(':text')) {
                var val = $(this.element).val(), split = val.split(this.locale.separator);
                start = end = null;
                if (split.length == 2) {
                    start = moment(split[0], this.locale.format);
                    end = moment(split[1], this.locale.format);
                } else if (this.singleDatePicker && val !== "") {
                    start = moment(val, this.locale.format);
                    end = moment(val, this.locale.format);
                }
                if (start !== null && end !== null) {
                    this.setStartDate(start);
                    this.setEndDate(end);
                }
            }
        }
        if (typeof options.ranges === 'object') {
            for(range in options.ranges){
                if (typeof options.ranges[range][0] === 'string') start = moment(options.ranges[range][0], this.locale.format);
                else start = moment(options.ranges[range][0]);
                if (typeof options.ranges[range][1] === 'string') end = moment(options.ranges[range][1], this.locale.format);
                else end = moment(options.ranges[range][1]);
                // If the start or end date exceed those allowed by the minDate or maxSpan
                // options, shorten the range to the allowable period.
                if (this.minDate && start.isBefore(this.minDate)) start = this.minDate.clone();
                var maxDate = this.maxDate;
                if (this.maxSpan && maxDate && start.clone().add(this.maxSpan).isAfter(maxDate)) maxDate = start.clone().add(this.maxSpan);
                if (maxDate && end.isAfter(maxDate)) end = maxDate.clone();
                // If the end of the range is before the minimum or the start of the range is
                // after the maximum, don't display this range option at all.
                if (this.minDate && end.isBefore(this.minDate, this.timepicker ? 'minute' : 'day') || maxDate && start.isAfter(maxDate, this.timepicker ? 'minute' : 'day')) continue;
                //Support unicode chars in the range names.
                var elem = document.createElement('textarea');
                elem.innerHTML = range;
                var rangeHtml = elem.value;
                this.ranges[rangeHtml] = [
                    start,
                    end
                ];
            }
            var list = '<ul>';
            for(range in this.ranges)list += '<li data-range-key="' + range + '">' + range + '</li>';
            if (this.showCustomRangeLabel) list += '<li data-range-key="' + this.locale.customRangeLabel + '">' + this.locale.customRangeLabel + '</li>';
            list += '</ul>';
            this.container.find('.ranges').prepend(list);
        }
        if (typeof cb === 'function') this.callback = cb;
        if (!this.timePicker) {
            this.startDate = this.startDate.startOf('day');
            this.endDate = this.endDate.endOf('day');
            this.container.find('.calendar-time').hide();
        }
        //can't be used together for now
        if (this.timePicker && this.autoApply) this.autoApply = false;
        if (this.autoApply) this.container.addClass('auto-apply');
        if (typeof options.ranges === 'object') this.container.addClass('show-ranges');
        if (this.singleDatePicker) {
            this.container.addClass('single');
            this.container.find('.drp-calendar.left').addClass('single');
            this.container.find('.drp-calendar.left').show();
            this.container.find('.drp-calendar.right').hide();
            if (!this.timePicker && this.autoApply) this.container.addClass('auto-apply');
        }
        if (typeof options.ranges === 'undefined' && !this.singleDatePicker || this.alwaysShowCalendars) this.container.addClass('show-calendar');
        this.container.addClass('opens' + this.opens);
        //apply CSS classes and labels to buttons
        this.container.find('.applyBtn, .cancelBtn').addClass(this.buttonClasses);
        if (this.applyButtonClasses.length) this.container.find('.applyBtn').addClass(this.applyButtonClasses);
        if (this.cancelButtonClasses.length) this.container.find('.cancelBtn').addClass(this.cancelButtonClasses);
        this.container.find('.applyBtn').html(this.locale.applyLabel);
        this.container.find('.cancelBtn').html(this.locale.cancelLabel);
        //
        // event listeners
        //
        this.container.find('.drp-calendar').on('click.daterangepicker', '.prev', $.proxy(this.clickPrev, this)).on('click.daterangepicker', '.next', $.proxy(this.clickNext, this)).on('mousedown.daterangepicker', 'td.available', $.proxy(this.clickDate, this)).on('mouseenter.daterangepicker', 'td.available', $.proxy(this.hoverDate, this)).on('change.daterangepicker', 'select.yearselect', $.proxy(this.monthOrYearChanged, this)).on('change.daterangepicker', 'select.monthselect', $.proxy(this.monthOrYearChanged, this)).on('change.daterangepicker', 'select.hourselect,select.minuteselect,select.secondselect,select.ampmselect', $.proxy(this.timeChanged, this));
        this.container.find('.ranges').on('click.daterangepicker', 'li', $.proxy(this.clickRange, this));
        this.container.find('.drp-buttons').on('click.daterangepicker', 'button.applyBtn', $.proxy(this.clickApply, this)).on('click.daterangepicker', 'button.cancelBtn', $.proxy(this.clickCancel, this));
        if (this.element.is('input') || this.element.is('button')) this.element.on({
            'click.daterangepicker': $.proxy(this.show, this),
            'focus.daterangepicker': $.proxy(this.show, this),
            'keyup.daterangepicker': $.proxy(this.elementChanged, this),
            'keydown.daterangepicker': $.proxy(this.keydown, this) //IE 11 compatibility
        });
        else {
            this.element.on('click.daterangepicker', $.proxy(this.toggle, this));
            this.element.on('keydown.daterangepicker', $.proxy(this.toggle, this));
        }
        //
        // if attached to a text input, set the initial value
        //
        this.updateElement();
    };
    DateRangePicker.prototype = {
        constructor: DateRangePicker,
        setStartDate: function(startDate) {
            if (typeof startDate === 'string') this.startDate = moment(startDate, this.locale.format);
            if (typeof startDate === 'object') this.startDate = moment(startDate);
            if (!this.timePicker) this.startDate = this.startDate.startOf('day');
            if (this.timePicker && this.timePickerIncrement) this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            if (this.minDate && this.startDate.isBefore(this.minDate)) {
                this.startDate = this.minDate.clone();
                if (this.timePicker && this.timePickerIncrement) this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            }
            if (this.maxDate && this.startDate.isAfter(this.maxDate)) {
                this.startDate = this.maxDate.clone();
                if (this.timePicker && this.timePickerIncrement) this.startDate.minute(Math.floor(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            }
            if (!this.isShowing) this.updateElement();
            this.updateMonthsInView();
        },
        setEndDate: function(endDate) {
            if (typeof endDate === 'string') this.endDate = moment(endDate, this.locale.format);
            if (typeof endDate === 'object') this.endDate = moment(endDate);
            if (!this.timePicker) this.endDate = this.endDate.endOf('day');
            if (this.timePicker && this.timePickerIncrement) this.endDate.minute(Math.round(this.endDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            if (this.endDate.isBefore(this.startDate)) this.endDate = this.startDate.clone();
            if (this.maxDate && this.endDate.isAfter(this.maxDate)) this.endDate = this.maxDate.clone();
            if (this.maxSpan && this.startDate.clone().add(this.maxSpan).isBefore(this.endDate)) this.endDate = this.startDate.clone().add(this.maxSpan);
            this.previousRightTime = this.endDate.clone();
            this.container.find('.drp-selected').html(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
            if (!this.isShowing) this.updateElement();
            this.updateMonthsInView();
        },
        isInvalidDate: function() {
            return false;
        },
        isCustomDate: function() {
            return false;
        },
        updateView: function() {
            if (this.timePicker) {
                this.renderTimePicker('left');
                this.renderTimePicker('right');
                if (!this.endDate) this.container.find('.right .calendar-time select').prop('disabled', true).addClass('disabled');
                else this.container.find('.right .calendar-time select').prop('disabled', false).removeClass('disabled');
            }
            if (this.endDate) this.container.find('.drp-selected').html(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
            this.updateMonthsInView();
            this.updateCalendars();
            this.updateFormInputs();
        },
        updateMonthsInView: function() {
            if (this.endDate) {
                //if both dates are visible already, do nothing
                if (!this.singleDatePicker && this.leftCalendar.month && this.rightCalendar.month && (this.startDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.startDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM')) && (this.endDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.endDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))) return;
                this.leftCalendar.month = this.startDate.clone().date(2);
                if (!this.linkedCalendars && (this.endDate.month() != this.startDate.month() || this.endDate.year() != this.startDate.year())) this.rightCalendar.month = this.endDate.clone().date(2);
                else this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
            } else if (this.leftCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM') && this.rightCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM')) {
                this.leftCalendar.month = this.startDate.clone().date(2);
                this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
            }
            if (this.maxDate && this.linkedCalendars && !this.singleDatePicker && this.rightCalendar.month > this.maxDate) {
                this.rightCalendar.month = this.maxDate.clone().date(2);
                this.leftCalendar.month = this.maxDate.clone().date(2).subtract(1, 'month');
            }
        },
        updateCalendars: function() {
            if (this.timePicker) {
                var hour, minute, second;
                if (this.endDate) {
                    hour = parseInt(this.container.find('.left .hourselect').val(), 10);
                    minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
                    if (isNaN(minute)) minute = parseInt(this.container.find('.left .minuteselect option:last').val(), 10);
                    second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.left .ampmselect').val();
                        if (ampm === 'PM' && hour < 12) hour += 12;
                        if (ampm === 'AM' && hour === 12) hour = 0;
                    }
                } else {
                    hour = parseInt(this.container.find('.right .hourselect').val(), 10);
                    minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
                    if (isNaN(minute)) minute = parseInt(this.container.find('.right .minuteselect option:last').val(), 10);
                    second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.right .ampmselect').val();
                        if (ampm === 'PM' && hour < 12) hour += 12;
                        if (ampm === 'AM' && hour === 12) hour = 0;
                    }
                }
                this.leftCalendar.month.hour(hour).minute(minute).second(second);
                this.rightCalendar.month.hour(hour).minute(minute).second(second);
            }
            this.renderCalendar('left');
            this.renderCalendar('right');
            //highlight any predefined range matching the current start and end dates
            this.container.find('.ranges li').removeClass('active');
            if (this.endDate == null) return;
            this.calculateChosenLabel();
        },
        renderCalendar: function(side) {
            //
            // Build the matrix of dates that will populate the calendar
            //
            var calendar = side == 'left' ? this.leftCalendar : this.rightCalendar;
            var month = calendar.month.month();
            var year = calendar.month.year();
            var hour = calendar.month.hour();
            var minute = calendar.month.minute();
            var second = calendar.month.second();
            var daysInMonth = moment([
                year,
                month
            ]).daysInMonth();
            var firstDay = moment([
                year,
                month,
                1
            ]);
            var lastDay = moment([
                year,
                month,
                daysInMonth
            ]);
            var lastMonth = moment(firstDay).subtract(1, 'month').month();
            var lastYear = moment(firstDay).subtract(1, 'month').year();
            var daysInLastMonth = moment([
                lastYear,
                lastMonth
            ]).daysInMonth();
            var dayOfWeek = firstDay.day();
            //initialize a 6 rows x 7 columns array for the calendar
            var calendar = [];
            calendar.firstDay = firstDay;
            calendar.lastDay = lastDay;
            for(var i = 0; i < 6; i++)calendar[i] = [];
            //populate the calendar with date objects
            var startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
            if (startDay > daysInLastMonth) startDay -= 7;
            if (dayOfWeek == this.locale.firstDay) startDay = daysInLastMonth - 6;
            var curDate = moment([
                lastYear,
                lastMonth,
                startDay,
                12,
                minute,
                second
            ]);
            var col, row;
            for(var i = 0, col = 0, row = 0; i < 42; i++, col++, curDate = moment(curDate).add(24, 'hour')){
                if (i > 0 && col % 7 === 0) {
                    col = 0;
                    row++;
                }
                calendar[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
                curDate.hour(12);
                if (this.minDate && calendar[row][col].format('YYYY-MM-DD') == this.minDate.format('YYYY-MM-DD') && calendar[row][col].isBefore(this.minDate) && side == 'left') calendar[row][col] = this.minDate.clone();
                if (this.maxDate && calendar[row][col].format('YYYY-MM-DD') == this.maxDate.format('YYYY-MM-DD') && calendar[row][col].isAfter(this.maxDate) && side == 'right') calendar[row][col] = this.maxDate.clone();
            }
            //make the calendar object available to hoverDate/clickDate
            if (side == 'left') this.leftCalendar.calendar = calendar;
            else this.rightCalendar.calendar = calendar;
            //
            // Display the calendar
            //
            var minDate = side == 'left' ? this.minDate : this.startDate;
            var maxDate = this.maxDate;
            var selected = side == 'left' ? this.startDate : this.endDate;
            var arrow = this.locale.direction == 'ltr' ? {
                left: 'chevron-left',
                right: 'chevron-right'
            } : {
                left: 'chevron-right',
                right: 'chevron-left'
            };
            var html = '<table class="table-condensed">';
            html += '<thead>';
            html += '<tr>';
            // add empty cell for week number
            if (this.showWeekNumbers || this.showISOWeekNumbers) html += '<th></th>';
            if ((!minDate || minDate.isBefore(calendar.firstDay)) && (!this.linkedCalendars || side == 'left')) html += '<th class="prev available"><span></span></th>';
            else html += '<th></th>';
            var dateHtml = this.locale.monthNames[calendar[1][1].month()] + calendar[1][1].format(" YYYY");
            if (this.showDropdowns) {
                var currentMonth = calendar[1][1].month();
                var currentYear = calendar[1][1].year();
                var maxYear = maxDate && maxDate.year() || this.maxYear;
                var minYear = minDate && minDate.year() || this.minYear;
                var inMinYear = currentYear == minYear;
                var inMaxYear = currentYear == maxYear;
                var monthHtml = '<select class="monthselect">';
                for(var m = 0; m < 12; m++)if ((!inMinYear || minDate && m >= minDate.month()) && (!inMaxYear || maxDate && m <= maxDate.month())) monthHtml += "<option value='" + m + "'" + (m === currentMonth ? " selected='selected'" : "") + ">" + this.locale.monthNames[m] + "</option>";
                else monthHtml += "<option value='" + m + "'" + (m === currentMonth ? " selected='selected'" : "") + " disabled='disabled'>" + this.locale.monthNames[m] + "</option>";
                monthHtml += "</select>";
                var yearHtml = '<select class="yearselect">';
                for(var y = minYear; y <= maxYear; y++)yearHtml += '<option value="' + y + '"' + (y === currentYear ? ' selected="selected"' : '') + '>' + y + '</option>';
                yearHtml += '</select>';
                dateHtml = monthHtml + yearHtml;
            }
            html += '<th colspan="5" class="month">' + dateHtml + '</th>';
            if ((!maxDate || maxDate.isAfter(calendar.lastDay)) && (!this.linkedCalendars || side == 'right' || this.singleDatePicker)) html += '<th class="next available"><span></span></th>';
            else html += '<th></th>';
            html += '</tr>';
            html += '<tr>';
            // add week number label
            if (this.showWeekNumbers || this.showISOWeekNumbers) html += '<th class="week">' + this.locale.weekLabel + '</th>';
            $.each(this.locale.daysOfWeek, function(index, dayOfWeek) {
                html += '<th>' + dayOfWeek + '</th>';
            });
            html += '</tr>';
            html += '</thead>';
            html += '<tbody>';
            //adjust maxDate to reflect the maxSpan setting in order to
            //grey out end dates beyond the maxSpan
            if (this.endDate == null && this.maxSpan) {
                var maxLimit = this.startDate.clone().add(this.maxSpan).endOf('day');
                if (!maxDate || maxLimit.isBefore(maxDate)) maxDate = maxLimit;
            }
            for(var row = 0; row < 6; row++){
                html += '<tr>';
                // add week number
                if (this.showWeekNumbers) html += '<td class="week">' + calendar[row][0].week() + '</td>';
                else if (this.showISOWeekNumbers) html += '<td class="week">' + calendar[row][0].isoWeek() + '</td>';
                for(var col = 0; col < 7; col++){
                    var classes = [];
                    //highlight today's date
                    if (calendar[row][col].isSame(new Date(), "day")) classes.push('today');
                    //highlight weekends
                    if (calendar[row][col].isoWeekday() > 5) classes.push('weekend');
                    //grey out the dates in other months displayed at beginning and end of this calendar
                    if (calendar[row][col].month() != calendar[1][1].month()) classes.push('off', 'ends');
                    //don't allow selection of dates before the minimum date
                    if (this.minDate && calendar[row][col].isBefore(this.minDate, 'day')) classes.push('off', 'disabled');
                    //don't allow selection of dates after the maximum date
                    if (maxDate && calendar[row][col].isAfter(maxDate, 'day')) classes.push('off', 'disabled');
                    //don't allow selection of date if a custom function decides it's invalid
                    if (this.isInvalidDate(calendar[row][col])) classes.push('off', 'disabled');
                    //highlight the currently selected start date
                    if (calendar[row][col].format('YYYY-MM-DD') == this.startDate.format('YYYY-MM-DD')) classes.push('active', 'start-date');
                    //highlight the currently selected end date
                    if (this.endDate != null && calendar[row][col].format('YYYY-MM-DD') == this.endDate.format('YYYY-MM-DD')) classes.push('active', 'end-date');
                    //highlight dates in-between the selected dates
                    if (this.endDate != null && calendar[row][col] > this.startDate && calendar[row][col] < this.endDate) classes.push('in-range');
                    //apply custom classes for this date
                    var isCustom = this.isCustomDate(calendar[row][col]);
                    if (isCustom !== false) {
                        if (typeof isCustom === 'string') classes.push(isCustom);
                        else Array.prototype.push.apply(classes, isCustom);
                    }
                    var cname = '', disabled = false;
                    for(var i = 0; i < classes.length; i++){
                        cname += classes[i] + ' ';
                        if (classes[i] == 'disabled') disabled = true;
                    }
                    if (!disabled) cname += 'available';
                    html += '<td class="' + cname.replace(/^\s+|\s+$/g, '') + '" data-title="' + 'r' + row + 'c' + col + '">' + calendar[row][col].date() + '</td>';
                }
                html += '</tr>';
            }
            html += '</tbody>';
            html += '</table>';
            this.container.find('.drp-calendar.' + side + ' .calendar-table').html(html);
        },
        renderTimePicker: function(side) {
            // Don't bother updating the time picker if it's currently disabled
            // because an end date hasn't been clicked yet
            if (side == 'right' && !this.endDate) return;
            var html, selected, minDate, maxDate = this.maxDate;
            if (this.maxSpan && (!this.maxDate || this.startDate.clone().add(this.maxSpan).isBefore(this.maxDate))) maxDate = this.startDate.clone().add(this.maxSpan);
            if (side == 'left') {
                selected = this.startDate.clone();
                minDate = this.minDate;
            } else if (side == 'right') {
                selected = this.endDate.clone();
                minDate = this.startDate;
                //Preserve the time already selected
                var timeSelector = this.container.find('.drp-calendar.right .calendar-time');
                if (timeSelector.html() != '') {
                    selected.hour(!isNaN(selected.hour()) ? selected.hour() : timeSelector.find('.hourselect option:selected').val());
                    selected.minute(!isNaN(selected.minute()) ? selected.minute() : timeSelector.find('.minuteselect option:selected').val());
                    selected.second(!isNaN(selected.second()) ? selected.second() : timeSelector.find('.secondselect option:selected').val());
                    if (!this.timePicker24Hour) {
                        var ampm = timeSelector.find('.ampmselect option:selected').val();
                        if (ampm === 'PM' && selected.hour() < 12) selected.hour(selected.hour() + 12);
                        if (ampm === 'AM' && selected.hour() === 12) selected.hour(0);
                    }
                }
                if (selected.isBefore(this.startDate)) selected = this.startDate.clone();
                if (maxDate && selected.isAfter(maxDate)) selected = maxDate.clone();
            }
            //
            // hours
            //
            html = '<select class="hourselect">';
            var start = this.timePicker24Hour ? 0 : 1;
            var end = this.timePicker24Hour ? 23 : 12;
            for(var i = start; i <= end; i++){
                var i_in_24 = i;
                if (!this.timePicker24Hour) i_in_24 = selected.hour() >= 12 ? i == 12 ? 12 : i + 12 : i == 12 ? 0 : i;
                var time = selected.clone().hour(i_in_24);
                var disabled = false;
                if (minDate && time.minute(59).isBefore(minDate)) disabled = true;
                if (maxDate && time.minute(0).isAfter(maxDate)) disabled = true;
                if (i_in_24 == selected.hour() && !disabled) html += '<option value="' + i + '" selected="selected">' + i + '</option>';
                else if (disabled) html += '<option value="' + i + '" disabled="disabled" class="disabled">' + i + '</option>';
                else html += '<option value="' + i + '">' + i + '</option>';
            }
            html += '</select> ';
            //
            // minutes
            //
            html += ': <select class="minuteselect">';
            for(var i = 0; i < 60; i += this.timePickerIncrement){
                var padded = i < 10 ? '0' + i : i;
                var time = selected.clone().minute(i);
                var disabled = false;
                if (minDate && time.second(59).isBefore(minDate)) disabled = true;
                if (maxDate && time.second(0).isAfter(maxDate)) disabled = true;
                if (selected.minute() == i && !disabled) html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
                else if (disabled) html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
                else html += '<option value="' + i + '">' + padded + '</option>';
            }
            html += '</select> ';
            //
            // seconds
            //
            if (this.timePickerSeconds) {
                html += ': <select class="secondselect">';
                for(var i = 0; i < 60; i++){
                    var padded = i < 10 ? '0' + i : i;
                    var time = selected.clone().second(i);
                    var disabled = false;
                    if (minDate && time.isBefore(minDate)) disabled = true;
                    if (maxDate && time.isAfter(maxDate)) disabled = true;
                    if (selected.second() == i && !disabled) html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
                    else if (disabled) html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
                    else html += '<option value="' + i + '">' + padded + '</option>';
                }
                html += '</select> ';
            }
            //
            // AM/PM
            //
            if (!this.timePicker24Hour) {
                html += '<select class="ampmselect">';
                var am_html = '';
                var pm_html = '';
                if (minDate && selected.clone().hour(12).minute(0).second(0).isBefore(minDate)) am_html = ' disabled="disabled" class="disabled"';
                if (maxDate && selected.clone().hour(0).minute(0).second(0).isAfter(maxDate)) pm_html = ' disabled="disabled" class="disabled"';
                if (selected.hour() >= 12) html += '<option value="AM"' + am_html + '>AM</option><option value="PM" selected="selected"' + pm_html + '>PM</option>';
                else html += '<option value="AM" selected="selected"' + am_html + '>AM</option><option value="PM"' + pm_html + '>PM</option>';
                html += '</select>';
            }
            this.container.find('.drp-calendar.' + side + ' .calendar-time').html(html);
        },
        updateFormInputs: function() {
            if (this.singleDatePicker || this.endDate && (this.startDate.isBefore(this.endDate) || this.startDate.isSame(this.endDate))) this.container.find('button.applyBtn').prop('disabled', false);
            else this.container.find('button.applyBtn').prop('disabled', true);
        },
        move: function() {
            var parentOffset = {
                top: 0,
                left: 0
            }, containerTop, drops = this.drops;
            var parentRightEdge = $(window).width();
            if (!this.parentEl.is('body')) {
                parentOffset = {
                    top: this.parentEl.offset().top - this.parentEl.scrollTop(),
                    left: this.parentEl.offset().left - this.parentEl.scrollLeft()
                };
                parentRightEdge = this.parentEl[0].clientWidth + this.parentEl.offset().left;
            }
            switch(drops){
                case 'auto':
                    containerTop = this.element.offset().top + this.element.outerHeight() - parentOffset.top;
                    if (containerTop + this.container.outerHeight() >= this.parentEl[0].scrollHeight) {
                        containerTop = this.element.offset().top - this.container.outerHeight() - parentOffset.top;
                        drops = 'up';
                    }
                    break;
                case 'up':
                    containerTop = this.element.offset().top - this.container.outerHeight() - parentOffset.top;
                    break;
                default:
                    containerTop = this.element.offset().top + this.element.outerHeight() - parentOffset.top;
                    break;
            }
            // Force the container to it's actual width
            this.container.css({
                top: 0,
                left: 0,
                right: 'auto'
            });
            var containerWidth = this.container.outerWidth();
            this.container.toggleClass('drop-up', drops == 'up');
            if (this.opens == 'left') {
                var containerRight = parentRightEdge - this.element.offset().left - this.element.outerWidth();
                if (containerWidth + containerRight > $(window).width()) this.container.css({
                    top: containerTop,
                    right: 'auto',
                    left: 9
                });
                else this.container.css({
                    top: containerTop,
                    right: containerRight,
                    left: 'auto'
                });
            } else if (this.opens == 'center') {
                var containerLeft = this.element.offset().left - parentOffset.left + this.element.outerWidth() / 2 - containerWidth / 2;
                if (containerLeft < 0) this.container.css({
                    top: containerTop,
                    right: 'auto',
                    left: 9
                });
                else if (containerLeft + containerWidth > $(window).width()) this.container.css({
                    top: containerTop,
                    left: 'auto',
                    right: 0
                });
                else this.container.css({
                    top: containerTop,
                    left: containerLeft,
                    right: 'auto'
                });
            } else {
                var containerLeft = this.element.offset().left - parentOffset.left;
                if (containerLeft + containerWidth > $(window).width()) this.container.css({
                    top: containerTop,
                    left: 'auto',
                    right: 0
                });
                else this.container.css({
                    top: containerTop,
                    left: containerLeft,
                    right: 'auto'
                });
            }
        },
        show: function(e) {
            if (this.isShowing) return;
            // Create a click proxy that is private to this instance of datepicker, for unbinding
            this._outsideClickProxy = $.proxy(function(e) {
                this.outsideClick(e);
            }, this);
            // Bind global datepicker mousedown for hiding and
            $(document).on('mousedown.daterangepicker', this._outsideClickProxy)// also support mobile devices
            .on('touchend.daterangepicker', this._outsideClickProxy)// also explicitly play nice with Bootstrap dropdowns, which stopPropagation when clicking them
            .on('click.daterangepicker', '[data-toggle=dropdown]', this._outsideClickProxy)// and also close when focus changes to outside the picker (eg. tabbing between controls)
            .on('focusin.daterangepicker', this._outsideClickProxy);
            // Reposition the picker if the window is resized while it's open
            $(window).on('resize.daterangepicker', $.proxy(function(e) {
                this.move(e);
            }, this));
            this.oldStartDate = this.startDate.clone();
            this.oldEndDate = this.endDate.clone();
            this.previousRightTime = this.endDate.clone();
            this.updateView();
            this.container.show();
            this.move();
            this.element.trigger('show.daterangepicker', this);
            this.isShowing = true;
        },
        hide: function(e) {
            if (!this.isShowing) return;
            //incomplete date selection, revert to last values
            if (!this.endDate) {
                this.startDate = this.oldStartDate.clone();
                this.endDate = this.oldEndDate.clone();
            }
            //if a new date range was selected, invoke the user callback function
            if (!this.startDate.isSame(this.oldStartDate) || !this.endDate.isSame(this.oldEndDate)) this.callback(this.startDate.clone(), this.endDate.clone(), this.chosenLabel);
            //if picker is attached to a text input, update it
            this.updateElement();
            $(document).off('.daterangepicker');
            $(window).off('.daterangepicker');
            this.container.hide();
            this.element.trigger('hide.daterangepicker', this);
            this.isShowing = false;
        },
        toggle: function(e) {
            if (this.isShowing) this.hide();
            else this.show();
        },
        outsideClick: function(e) {
            var target = $(e.target);
            // if the page is clicked anywhere except within the daterangerpicker/button
            // itself then call this.hide()
            if (// ie modal dialog fix
            e.type == "focusin" || target.closest(this.element).length || target.closest(this.container).length || target.closest('.calendar-table').length) return;
            this.hide();
            this.element.trigger('outsideClick.daterangepicker', this);
        },
        showCalendars: function() {
            this.container.addClass('show-calendar');
            this.move();
            this.element.trigger('showCalendar.daterangepicker', this);
        },
        hideCalendars: function() {
            this.container.removeClass('show-calendar');
            this.element.trigger('hideCalendar.daterangepicker', this);
        },
        clickRange: function(e) {
            var label = e.target.getAttribute('data-range-key');
            this.chosenLabel = label;
            if (label == this.locale.customRangeLabel) this.showCalendars();
            else {
                var dates = this.ranges[label];
                this.startDate = dates[0];
                this.endDate = dates[1];
                if (!this.timePicker) {
                    this.startDate.startOf('day');
                    this.endDate.endOf('day');
                }
                if (!this.alwaysShowCalendars) this.hideCalendars();
                this.clickApply();
            }
        },
        clickPrev: function(e) {
            var cal = $(e.target).parents('.drp-calendar');
            if (cal.hasClass('left')) {
                this.leftCalendar.month.subtract(1, 'month');
                if (this.linkedCalendars) this.rightCalendar.month.subtract(1, 'month');
            } else this.rightCalendar.month.subtract(1, 'month');
            this.updateCalendars();
        },
        clickNext: function(e) {
            var cal = $(e.target).parents('.drp-calendar');
            if (cal.hasClass('left')) this.leftCalendar.month.add(1, 'month');
            else {
                this.rightCalendar.month.add(1, 'month');
                if (this.linkedCalendars) this.leftCalendar.month.add(1, 'month');
            }
            this.updateCalendars();
        },
        hoverDate: function(e) {
            //ignore dates that can't be selected
            if (!$(e.target).hasClass('available')) return;
            var title = $(e.target).attr('data-title');
            var row = title.substr(1, 1);
            var col = title.substr(3, 1);
            var cal = $(e.target).parents('.drp-calendar');
            var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
            //highlight the dates between the start date and the date being hovered as a potential end date
            var leftCalendar = this.leftCalendar;
            var rightCalendar = this.rightCalendar;
            var startDate = this.startDate;
            if (!this.endDate) this.container.find('.drp-calendar tbody td').each(function(index, el) {
                //skip week numbers, only look at dates
                if ($(el).hasClass('week')) return;
                var title = $(el).attr('data-title');
                var row = title.substr(1, 1);
                var col = title.substr(3, 1);
                var cal = $(el).parents('.drp-calendar');
                var dt = cal.hasClass('left') ? leftCalendar.calendar[row][col] : rightCalendar.calendar[row][col];
                if (dt.isAfter(startDate) && dt.isBefore(date) || dt.isSame(date, 'day')) $(el).addClass('in-range');
                else $(el).removeClass('in-range');
            });
        },
        clickDate: function(e) {
            if (!$(e.target).hasClass('available')) return;
            var title = $(e.target).attr('data-title');
            var row = title.substr(1, 1);
            var col = title.substr(3, 1);
            var cal = $(e.target).parents('.drp-calendar');
            var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
            //
            // this function needs to do a few things:
            // * alternate between selecting a start and end date for the range,
            // * if the time picker is enabled, apply the hour/minute/second from the select boxes to the clicked date
            // * if autoapply is enabled, and an end date was chosen, apply the selection
            // * if single date picker mode, and time picker isn't enabled, apply the selection immediately
            // * if one of the inputs above the calendars was focused, cancel that manual input
            //
            if (this.endDate || date.isBefore(this.startDate, 'day')) {
                if (this.timePicker) {
                    var hour = parseInt(this.container.find('.left .hourselect').val(), 10);
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.left .ampmselect').val();
                        if (ampm === 'PM' && hour < 12) hour += 12;
                        if (ampm === 'AM' && hour === 12) hour = 0;
                    }
                    var minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
                    if (isNaN(minute)) minute = parseInt(this.container.find('.left .minuteselect option:last').val(), 10);
                    var second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
                    date = date.clone().hour(hour).minute(minute).second(second);
                }
                this.endDate = null;
                this.setStartDate(date.clone());
            } else if (!this.endDate && date.isBefore(this.startDate)) //special case: clicking the same date for start/end,
            //but the time of the end date is before the start date
            this.setEndDate(this.startDate.clone());
            else {
                if (this.timePicker) {
                    var hour = parseInt(this.container.find('.right .hourselect').val(), 10);
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.right .ampmselect').val();
                        if (ampm === 'PM' && hour < 12) hour += 12;
                        if (ampm === 'AM' && hour === 12) hour = 0;
                    }
                    var minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
                    if (isNaN(minute)) minute = parseInt(this.container.find('.right .minuteselect option:last').val(), 10);
                    var second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
                    date = date.clone().hour(hour).minute(minute).second(second);
                }
                this.setEndDate(date.clone());
                if (this.autoApply) {
                    this.calculateChosenLabel();
                    this.clickApply();
                }
            }
            if (this.singleDatePicker) {
                this.setEndDate(this.startDate);
                if (!this.timePicker && this.autoApply) this.clickApply();
            }
            this.updateView();
            //This is to cancel the blur event handler if the mouse was in one of the inputs
            e.stopPropagation();
        },
        calculateChosenLabel: function() {
            var customRange = true;
            var i = 0;
            for(var range in this.ranges){
                if (this.timePicker) {
                    var format = this.timePickerSeconds ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD HH:mm";
                    //ignore times when comparing dates if time picker seconds is not enabled
                    if (this.startDate.format(format) == this.ranges[range][0].format(format) && this.endDate.format(format) == this.ranges[range][1].format(format)) {
                        customRange = false;
                        this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').attr('data-range-key');
                        break;
                    }
                } else //ignore times when comparing dates if time picker is not enabled
                if (this.startDate.format('YYYY-MM-DD') == this.ranges[range][0].format('YYYY-MM-DD') && this.endDate.format('YYYY-MM-DD') == this.ranges[range][1].format('YYYY-MM-DD')) {
                    customRange = false;
                    this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').attr('data-range-key');
                    break;
                }
                i++;
            }
            if (customRange) {
                if (this.showCustomRangeLabel) this.chosenLabel = this.container.find('.ranges li:last').addClass('active').attr('data-range-key');
                else this.chosenLabel = null;
                this.showCalendars();
            }
        },
        clickApply: function(e) {
            this.hide();
            this.element.trigger('apply.daterangepicker', this);
        },
        clickCancel: function(e) {
            this.startDate = this.oldStartDate;
            this.endDate = this.oldEndDate;
            this.hide();
            this.element.trigger('cancel.daterangepicker', this);
        },
        monthOrYearChanged: function(e) {
            var isLeft = $(e.target).closest('.drp-calendar').hasClass('left'), leftOrRight = isLeft ? 'left' : 'right', cal = this.container.find('.drp-calendar.' + leftOrRight);
            // Month must be Number for new moment versions
            var month = parseInt(cal.find('.monthselect').val(), 10);
            var year = cal.find('.yearselect').val();
            if (!isLeft) {
                if (year < this.startDate.year() || year == this.startDate.year() && month < this.startDate.month()) {
                    month = this.startDate.month();
                    year = this.startDate.year();
                }
            }
            if (this.minDate) {
                if (year < this.minDate.year() || year == this.minDate.year() && month < this.minDate.month()) {
                    month = this.minDate.month();
                    year = this.minDate.year();
                }
            }
            if (this.maxDate) {
                if (year > this.maxDate.year() || year == this.maxDate.year() && month > this.maxDate.month()) {
                    month = this.maxDate.month();
                    year = this.maxDate.year();
                }
            }
            if (isLeft) {
                this.leftCalendar.month.month(month).year(year);
                if (this.linkedCalendars) this.rightCalendar.month = this.leftCalendar.month.clone().add(1, 'month');
            } else {
                this.rightCalendar.month.month(month).year(year);
                if (this.linkedCalendars) this.leftCalendar.month = this.rightCalendar.month.clone().subtract(1, 'month');
            }
            this.updateCalendars();
        },
        timeChanged: function(e) {
            var cal = $(e.target).closest('.drp-calendar'), isLeft = cal.hasClass('left');
            var hour = parseInt(cal.find('.hourselect').val(), 10);
            var minute = parseInt(cal.find('.minuteselect').val(), 10);
            if (isNaN(minute)) minute = parseInt(cal.find('.minuteselect option:last').val(), 10);
            var second = this.timePickerSeconds ? parseInt(cal.find('.secondselect').val(), 10) : 0;
            if (!this.timePicker24Hour) {
                var ampm = cal.find('.ampmselect').val();
                if (ampm === 'PM' && hour < 12) hour += 12;
                if (ampm === 'AM' && hour === 12) hour = 0;
            }
            if (isLeft) {
                var start = this.startDate.clone();
                start.hour(hour);
                start.minute(minute);
                start.second(second);
                this.setStartDate(start);
                if (this.singleDatePicker) this.endDate = this.startDate.clone();
                else if (this.endDate && this.endDate.format('YYYY-MM-DD') == start.format('YYYY-MM-DD') && this.endDate.isBefore(start)) this.setEndDate(start.clone());
            } else if (this.endDate) {
                var end = this.endDate.clone();
                end.hour(hour);
                end.minute(minute);
                end.second(second);
                this.setEndDate(end);
            }
            //update the calendars so all clickable dates reflect the new time component
            this.updateCalendars();
            //update the form inputs above the calendars with the new time
            this.updateFormInputs();
            //re-render the time pickers because changing one selection can affect what's enabled in another
            this.renderTimePicker('left');
            this.renderTimePicker('right');
        },
        elementChanged: function() {
            if (!this.element.is('input')) return;
            if (!this.element.val().length) return;
            var dateString = this.element.val().split(this.locale.separator), start = null, end = null;
            if (dateString.length === 2) {
                start = moment(dateString[0], this.locale.format);
                end = moment(dateString[1], this.locale.format);
            }
            if (this.singleDatePicker || start === null || end === null) {
                start = moment(this.element.val(), this.locale.format);
                end = start;
            }
            if (!start.isValid() || !end.isValid()) return;
            this.setStartDate(start);
            this.setEndDate(end);
            this.updateView();
        },
        keydown: function(e) {
            //hide on tab or enter
            if (e.keyCode === 9 || e.keyCode === 13) this.hide();
            //hide on esc and prevent propagation
            if (e.keyCode === 27) {
                e.preventDefault();
                e.stopPropagation();
                this.hide();
            }
        },
        updateElement: function() {
            if (this.element.is('input') && this.autoUpdateInput) {
                var newValue = this.startDate.format(this.locale.format);
                if (!this.singleDatePicker) newValue += this.locale.separator + this.endDate.format(this.locale.format);
                if (newValue !== this.element.val()) this.element.val(newValue).trigger('change');
            }
        },
        remove: function() {
            this.container.remove();
            this.element.off('.daterangepicker');
            this.element.removeData();
        }
    };
    $.fn.daterangepicker = function(options, callback) {
        var implementOptions = $.extend(true, {}, $.fn.daterangepicker.defaultOptions, options);
        this.each(function() {
            var el = $(this);
            if (el.data('daterangepicker')) el.data('daterangepicker').remove();
            el.data('daterangepicker', new DateRangePicker(el, implementOptions, callback));
        });
        return this;
    };
    return DateRangePicker;
});



var $80e0893b836904ea$exports = {};
/*
* iziToast | v1.4.0
* http://izitoast.marcelodolce.com
* by Marcelo Dolce.
*/ !function(t, e) {
    "function" == typeof define && define.amd ? define([], e(t)) : $80e0893b836904ea$exports = e(t);
}("undefined" != typeof $parcel$global ? $parcel$global : window || $80e0893b836904ea$exports.window || $80e0893b836904ea$exports.global, function(t) {
    "use strict";
    var e = {}, n = "iziToast", o = (document.querySelector("body"), !!/Mobi/.test(navigator.userAgent)), i = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor), s = "undefined" != typeof InstallTrigger, a = "ontouchstart" in document.documentElement, r = [
        "bottomRight",
        "bottomLeft",
        "bottomCenter",
        "topRight",
        "topLeft",
        "topCenter",
        "center"
    ], l = {
        info: {
            color: "blue",
            icon: "ico-info"
        },
        success: {
            color: "green",
            icon: "ico-success"
        },
        warning: {
            color: "orange",
            icon: "ico-warning"
        },
        error: {
            color: "red",
            icon: "ico-error"
        },
        question: {
            color: "yellow",
            icon: "ico-question"
        }
    }, d = 568, c = {};
    e.children = {};
    var u = {
        id: null,
        "class": "",
        title: "",
        titleColor: "",
        titleSize: "",
        titleLineHeight: "",
        message: "",
        messageColor: "",
        messageSize: "",
        messageLineHeight: "",
        backgroundColor: "",
        theme: "light",
        color: "",
        icon: "",
        iconText: "",
        iconColor: "",
        iconUrl: null,
        image: "",
        imageWidth: 50,
        maxWidth: null,
        zindex: null,
        layout: 1,
        balloon: !1,
        close: !0,
        closeOnEscape: !1,
        closeOnClick: !1,
        displayMode: 0,
        position: "bottomRight",
        target: "",
        targetFirst: !0,
        timeout: 5e3,
        rtl: !1,
        animateInside: !0,
        drag: !0,
        pauseOnHover: !0,
        resetOnHover: !1,
        progressBar: !0,
        progressBarColor: "",
        progressBarEasing: "linear",
        overlay: !1,
        overlayClose: !1,
        overlayColor: "rgba(0, 0, 0, 0.6)",
        transitionIn: "fadeInUp",
        transitionOut: "fadeOut",
        transitionInMobile: "fadeInUp",
        transitionOutMobile: "fadeOutDown",
        buttons: {},
        inputs: {},
        onOpening: function() {},
        onOpened: function() {},
        onClosing: function() {},
        onClosed: function() {}
    };
    if ("remove" in Element.prototype || (Element.prototype.remove = function() {
        this.parentNode && this.parentNode.removeChild(this);
    }), "function" != typeof window.CustomEvent) {
        var p = function(t, e) {
            e = e || {
                bubbles: !1,
                cancelable: !1,
                detail: void 0
            };
            var n = document.createEvent("CustomEvent");
            return n.initCustomEvent(t, e.bubbles, e.cancelable, e.detail), n;
        };
        p.prototype = window.Event.prototype, window.CustomEvent = p;
    }
    var m = function(t, e, n) {
        if ("[object Object]" === Object.prototype.toString.call(t)) for(var o in t)Object.prototype.hasOwnProperty.call(t, o) && e.call(n, t[o], o, t);
        else if (t) for(var i = 0, s = t.length; s > i; i++)e.call(n, t[i], i, t);
    }, g = function(t, e) {
        var n = {};
        return m(t, function(e, o) {
            n[o] = t[o];
        }), m(e, function(t, o) {
            n[o] = e[o];
        }), n;
    }, f = function(t) {
        var e = document.createDocumentFragment(), n = document.createElement("div");
        for(n.innerHTML = t; n.firstChild;)e.appendChild(n.firstChild);
        return e;
    }, v = function(t) {
        var e = btoa(encodeURIComponent(t));
        return e.replace(/=/g, "");
    }, y = function(t) {
        return "#" == t.substring(0, 1) || "rgb" == t.substring(0, 3) || "hsl" == t.substring(0, 3);
    }, h = function(t) {
        try {
            return btoa(atob(t)) == t;
        } catch (e) {
            return !1;
        }
    }, b = function() {
        return {
            move: function(t, e, o, a) {
                var r, l = .3, d = 180;
                0 !== a && (t.classList.add(n + "-dragged"), t.style.transform = "translateX(" + a + "px)", a > 0 ? (r = (d - a) / d, l > r && e.hide(g(o, {
                    transitionOut: "fadeOutRight",
                    transitionOutMobile: "fadeOutRight"
                }), t, "drag")) : (r = (d + a) / d, l > r && e.hide(g(o, {
                    transitionOut: "fadeOutLeft",
                    transitionOutMobile: "fadeOutLeft"
                }), t, "drag")), t.style.opacity = r, l > r && ((i || s) && (t.style.left = a + "px"), t.parentNode.style.opacity = l, this.stopMoving(t, null)));
            },
            startMoving: function(t, e, n, o) {
                o = o || window.event;
                var i = a ? o.touches[0].clientX : o.clientX, s = t.style.transform.replace("px)", "");
                s = s.replace("translateX(", "");
                var r = i - s;
                n.transitionIn && t.classList.remove(n.transitionIn), n.transitionInMobile && t.classList.remove(n.transitionInMobile), t.style.transition = "", a ? document.ontouchmove = function(o) {
                    o.preventDefault(), o = o || window.event;
                    var i = o.touches[0].clientX, s = i - r;
                    b.move(t, e, n, s);
                } : document.onmousemove = function(o) {
                    o.preventDefault(), o = o || window.event;
                    var i = o.clientX, s = i - r;
                    b.move(t, e, n, s);
                };
            },
            stopMoving: function(t, e) {
                a ? document.ontouchmove = function() {} : document.onmousemove = function() {}, t.style.opacity = "", t.style.transform = "", t.classList.contains(n + "-dragged") && (t.classList.remove(n + "-dragged"), t.style.transition = "transform 0.4s ease, opacity 0.4s ease", setTimeout(function() {
                    t.style.transition = "";
                }, 400));
            }
        };
    }();
    return e.setSetting = function(t, n, o) {
        e.children[t][n] = o;
    }, e.getSetting = function(t, n) {
        return e.children[t][n];
    }, e.destroy = function() {
        m(document.querySelectorAll("." + n + "-overlay"), function(t, e) {
            t.remove();
        }), m(document.querySelectorAll("." + n + "-wrapper"), function(t, e) {
            t.remove();
        }), m(document.querySelectorAll("." + n), function(t, e) {
            t.remove();
        }), this.children = {}, document.removeEventListener(n + "-opened", {}, !1), document.removeEventListener(n + "-opening", {}, !1), document.removeEventListener(n + "-closing", {}, !1), document.removeEventListener(n + "-closed", {}, !1), document.removeEventListener("keyup", {}, !1), c = {};
    }, e.settings = function(t) {
        e.destroy(), c = t, u = g(u, t || {});
    }, m(l, function(t, n) {
        e[n] = function(e) {
            var n = g(c, e || {});
            n = g(t, n || {}), this.show(n);
        };
    }), e.progress = function(t, e, o) {
        var i = this, s = e.getAttribute("data-iziToast-ref"), a = g(this.children[s], t || {}), r = e.querySelector("." + n + "-progressbar div");
        return {
            start: function() {
                "undefined" == typeof a.time.REMAINING && (e.classList.remove(n + "-reseted"), null !== r && (r.style.transition = "width " + a.timeout + "ms " + a.progressBarEasing, r.style.width = "0%"), a.time.START = (new Date).getTime(), a.time.END = a.time.START + a.timeout, a.time.TIMER = setTimeout(function() {
                    clearTimeout(a.time.TIMER), e.classList.contains(n + "-closing") || (i.hide(a, e, "timeout"), "function" == typeof o && o.apply(i));
                }, a.timeout), i.setSetting(s, "time", a.time));
            },
            pause: function() {
                if ("undefined" != typeof a.time.START && !e.classList.contains(n + "-paused") && !e.classList.contains(n + "-reseted")) {
                    if (e.classList.add(n + "-paused"), a.time.REMAINING = a.time.END - (new Date).getTime(), clearTimeout(a.time.TIMER), i.setSetting(s, "time", a.time), null !== r) {
                        var t = window.getComputedStyle(r), l = t.getPropertyValue("width");
                        r.style.transition = "none", r.style.width = l;
                    }
                    "function" == typeof o && setTimeout(function() {
                        o.apply(i);
                    }, 10);
                }
            },
            resume: function() {
                "undefined" != typeof a.time.REMAINING ? (e.classList.remove(n + "-paused"), null !== r && (r.style.transition = "width " + a.time.REMAINING + "ms " + a.progressBarEasing, r.style.width = "0%"), a.time.END = (new Date).getTime() + a.time.REMAINING, a.time.TIMER = setTimeout(function() {
                    clearTimeout(a.time.TIMER), e.classList.contains(n + "-closing") || (i.hide(a, e, "timeout"), "function" == typeof o && o.apply(i));
                }, a.time.REMAINING), i.setSetting(s, "time", a.time)) : this.start();
            },
            reset: function() {
                clearTimeout(a.time.TIMER), delete a.time.REMAINING, i.setSetting(s, "time", a.time), e.classList.add(n + "-reseted"), e.classList.remove(n + "-paused"), null !== r && (r.style.transition = "none", r.style.width = "100%"), "function" == typeof o && setTimeout(function() {
                    o.apply(i);
                }, 10);
            }
        };
    }, e.hide = function(t, e, i) {
        "object" != typeof e && (e = document.querySelector(e));
        var s = this, a = g(this.children[e.getAttribute("data-iziToast-ref")], t || {});
        a.closedBy = i || null, delete a.time.REMAINING, e.classList.add(n + "-closing"), function() {
            var t = document.querySelector("." + n + "-overlay");
            if (null !== t) {
                var e = t.getAttribute("data-iziToast-ref");
                e = e.split(",");
                var o = e.indexOf(String(a.ref));
                -1 !== o && e.splice(o, 1), t.setAttribute("data-iziToast-ref", e.join()), 0 === e.length && (t.classList.remove("fadeIn"), t.classList.add("fadeOut"), setTimeout(function() {
                    t.remove();
                }, 700));
            }
        }(), a.transitionIn && e.classList.remove(a.transitionIn), a.transitionInMobile && e.classList.remove(a.transitionInMobile), o || window.innerWidth <= d ? a.transitionOutMobile && e.classList.add(a.transitionOutMobile) : a.transitionOut && e.classList.add(a.transitionOut);
        var r = e.parentNode.offsetHeight;
        e.parentNode.style.height = r + "px", e.style.pointerEvents = "none", (!o || window.innerWidth > d) && (e.parentNode.style.transitionDelay = "0.2s");
        try {
            var l = new CustomEvent(n + "-closing", {
                detail: a,
                bubbles: !0,
                cancelable: !0
            });
            document.dispatchEvent(l);
        } catch (c) {
            console.warn(c);
        }
        setTimeout(function() {
            e.parentNode.style.height = "0px", e.parentNode.style.overflow = "", setTimeout(function() {
                delete s.children[a.ref], e.parentNode.remove();
                try {
                    var t = new CustomEvent(n + "-closed", {
                        detail: a,
                        bubbles: !0,
                        cancelable: !0
                    });
                    document.dispatchEvent(t);
                } catch (o) {
                    console.warn(o);
                }
                "undefined" != typeof a.onClosed && a.onClosed.apply(null, [
                    a,
                    e,
                    i
                ]);
            }, 1e3);
        }, 200), "undefined" != typeof a.onClosing && a.onClosing.apply(null, [
            a,
            e,
            i
        ]);
    }, e.show = function(t) {
        var i = this, s = g(c, t || {});
        if (s = g(u, s), s.time = {}, null === s.id && (s.id = v(s.title + s.message + s.color)), 1 === s.displayMode || "once" == s.displayMode) try {
            if (document.querySelectorAll("." + n + "#" + s.id).length > 0) return !1;
        } catch (l) {
            console.warn("[" + n + "] Could not find an element with this selector: #" + s.id + ". Try to set an valid id.");
        }
        if (2 === s.displayMode || "replace" == s.displayMode) try {
            m(document.querySelectorAll("." + n + "#" + s.id), function(t, e) {
                i.hide(s, t, "replaced");
            });
        } catch (l) {
            console.warn("[" + n + "] Could not find an element with this selector: #" + s.id + ". Try to set an valid id.");
        }
        s.ref = (new Date).getTime() + Math.floor(1e7 * Math.random() + 1), e.children[s.ref] = s;
        var p = {
            body: document.querySelector("body"),
            overlay: document.createElement("div"),
            toast: document.createElement("div"),
            toastBody: document.createElement("div"),
            toastTexts: document.createElement("div"),
            toastCapsule: document.createElement("div"),
            cover: document.createElement("div"),
            buttons: document.createElement("div"),
            inputs: document.createElement("div"),
            icon: s.iconUrl ? document.createElement("img") : document.createElement("i"),
            wrapper: null
        };
        p.toast.setAttribute("data-iziToast-ref", s.ref), p.toast.appendChild(p.toastBody), p.toastCapsule.appendChild(p.toast), function() {
            if (p.toast.classList.add(n), p.toast.classList.add(n + "-opening"), p.toastCapsule.classList.add(n + "-capsule"), p.toastBody.classList.add(n + "-body"), p.toastTexts.classList.add(n + "-texts"), o || window.innerWidth <= d ? s.transitionInMobile && p.toast.classList.add(s.transitionInMobile) : s.transitionIn && p.toast.classList.add(s.transitionIn), s["class"]) {
                var t = s["class"].split(" ");
                m(t, function(t, e) {
                    p.toast.classList.add(t);
                });
            }
            s.id && (p.toast.id = s.id), s.rtl && (p.toast.classList.add(n + "-rtl"), p.toast.setAttribute("dir", "rtl")), s.layout > 1 && p.toast.classList.add(n + "-layout" + s.layout), s.balloon && p.toast.classList.add(n + "-balloon"), s.maxWidth && (isNaN(s.maxWidth) ? p.toast.style.maxWidth = s.maxWidth : p.toast.style.maxWidth = s.maxWidth + "px"), "" === s.theme && "light" === s.theme || p.toast.classList.add(n + "-theme-" + s.theme), s.color && (y(s.color) ? p.toast.style.background = s.color : p.toast.classList.add(n + "-color-" + s.color)), s.backgroundColor && (p.toast.style.background = s.backgroundColor, s.balloon && (p.toast.style.borderColor = s.backgroundColor));
        }(), function() {
            s.image && (p.cover.classList.add(n + "-cover"), p.cover.style.width = s.imageWidth + "px", h(s.image.replace(/ /g, "")) ? p.cover.style.backgroundImage = "url(data:image/png;base64," + s.image.replace(/ /g, "") + ")" : p.cover.style.backgroundImage = "url(" + s.image + ")", s.rtl ? p.toastBody.style.marginRight = s.imageWidth + 10 + "px" : p.toastBody.style.marginLeft = s.imageWidth + 10 + "px", p.toast.appendChild(p.cover));
        }(), function() {
            s.close ? (p.buttonClose = document.createElement("button"), p.buttonClose.type = "button", p.buttonClose.classList.add(n + "-close"), p.buttonClose.addEventListener("click", function(t) {
                t.target;
                i.hide(s, p.toast, "button");
            }), p.toast.appendChild(p.buttonClose)) : s.rtl ? p.toast.style.paddingLeft = "18px" : p.toast.style.paddingRight = "18px";
        }(), function() {
            s.progressBar && (p.progressBar = document.createElement("div"), p.progressBarDiv = document.createElement("div"), p.progressBar.classList.add(n + "-progressbar"), p.progressBarDiv.style.background = s.progressBarColor, p.progressBar.appendChild(p.progressBarDiv), p.toast.appendChild(p.progressBar)), s.timeout && (s.pauseOnHover && !s.resetOnHover && (p.toast.addEventListener("mouseenter", function(t) {
                i.progress(s, p.toast).pause();
            }), p.toast.addEventListener("mouseleave", function(t) {
                i.progress(s, p.toast).resume();
            })), s.resetOnHover && (p.toast.addEventListener("mouseenter", function(t) {
                i.progress(s, p.toast).reset();
            }), p.toast.addEventListener("mouseleave", function(t) {
                i.progress(s, p.toast).start();
            })));
        }(), function() {
            s.iconUrl ? (p.icon.setAttribute("class", n + "-icon"), p.icon.setAttribute("src", s.iconUrl)) : s.icon && (p.icon.setAttribute("class", n + "-icon " + s.icon), s.iconText && p.icon.appendChild(document.createTextNode(s.iconText)), s.iconColor && (p.icon.style.color = s.iconColor)), (s.icon || s.iconUrl) && (s.rtl ? p.toastBody.style.paddingRight = "33px" : p.toastBody.style.paddingLeft = "33px", p.toastBody.appendChild(p.icon));
        }(), function() {
            s.title.length > 0 && (p.strong = document.createElement("strong"), p.strong.classList.add(n + "-title"), p.strong.appendChild(f(s.title)), p.toastTexts.appendChild(p.strong), s.titleColor && (p.strong.style.color = s.titleColor), s.titleSize && (isNaN(s.titleSize) ? p.strong.style.fontSize = s.titleSize : p.strong.style.fontSize = s.titleSize + "px"), s.titleLineHeight && (isNaN(s.titleSize) ? p.strong.style.lineHeight = s.titleLineHeight : p.strong.style.lineHeight = s.titleLineHeight + "px")), s.message.length > 0 && (p.p = document.createElement("p"), p.p.classList.add(n + "-message"), p.p.appendChild(f(s.message)), p.toastTexts.appendChild(p.p), s.messageColor && (p.p.style.color = s.messageColor), s.messageSize && (isNaN(s.titleSize) ? p.p.style.fontSize = s.messageSize : p.p.style.fontSize = s.messageSize + "px"), s.messageLineHeight && (isNaN(s.titleSize) ? p.p.style.lineHeight = s.messageLineHeight : p.p.style.lineHeight = s.messageLineHeight + "px")), s.title.length > 0 && s.message.length > 0 && (s.rtl ? p.strong.style.marginLeft = "10px" : 2 === s.layout || s.rtl || (p.strong.style.marginRight = "10px"));
        }(), p.toastBody.appendChild(p.toastTexts);
        var L;
        !function() {
            s.inputs.length > 0 && (p.inputs.classList.add(n + "-inputs"), m(s.inputs, function(t, e) {
                p.inputs.appendChild(f(t[0])), L = p.inputs.childNodes, L[e].classList.add(n + "-inputs-child"), t[3] && setTimeout(function() {
                    L[e].focus();
                }, 300), L[e].addEventListener(t[1], function(e) {
                    var n = t[2];
                    return n(i, p.toast, this, e);
                });
            }), p.toastBody.appendChild(p.inputs));
        }(), function() {
            s.buttons.length > 0 && (p.buttons.classList.add(n + "-buttons"), m(s.buttons, function(t, e) {
                p.buttons.appendChild(f(t[0]));
                var o = p.buttons.childNodes;
                o[e].classList.add(n + "-buttons-child"), t[2] && setTimeout(function() {
                    o[e].focus();
                }, 300), o[e].addEventListener("click", function(e) {
                    e.preventDefault();
                    var n = t[1];
                    return n(i, p.toast, this, e, L);
                });
            })), p.toastBody.appendChild(p.buttons);
        }(), s.message.length > 0 && (s.inputs.length > 0 || s.buttons.length > 0) && (p.p.style.marginBottom = "0"), (s.inputs.length > 0 || s.buttons.length > 0) && (s.rtl ? p.toastTexts.style.marginLeft = "10px" : p.toastTexts.style.marginRight = "10px", s.inputs.length > 0 && s.buttons.length > 0 && (s.rtl ? p.inputs.style.marginLeft = "8px" : p.inputs.style.marginRight = "8px")), function() {
            p.toastCapsule.style.visibility = "hidden", setTimeout(function() {
                var t = p.toast.offsetHeight, e = p.toast.currentStyle || window.getComputedStyle(p.toast), n = e.marginTop;
                n = n.split("px"), n = parseInt(n[0]);
                var o = e.marginBottom;
                o = o.split("px"), o = parseInt(o[0]), p.toastCapsule.style.visibility = "", p.toastCapsule.style.height = t + o + n + "px", setTimeout(function() {
                    p.toastCapsule.style.height = "auto", s.target && (p.toastCapsule.style.overflow = "visible");
                }, 500), s.timeout && i.progress(s, p.toast).start();
            }, 100);
        }(), function() {
            var t = s.position;
            if (s.target) p.wrapper = document.querySelector(s.target), p.wrapper.classList.add(n + "-target"), s.targetFirst ? p.wrapper.insertBefore(p.toastCapsule, p.wrapper.firstChild) : p.wrapper.appendChild(p.toastCapsule);
            else {
                if (-1 == r.indexOf(s.position)) return void console.warn("[" + n + "] Incorrect position.\nIt can be \u203A " + r);
                t = o || window.innerWidth <= d ? "bottomLeft" == s.position || "bottomRight" == s.position || "bottomCenter" == s.position ? n + "-wrapper-bottomCenter" : "topLeft" == s.position || "topRight" == s.position || "topCenter" == s.position ? n + "-wrapper-topCenter" : n + "-wrapper-center" : n + "-wrapper-" + t, p.wrapper = document.querySelector("." + n + "-wrapper." + t), p.wrapper || (p.wrapper = document.createElement("div"), p.wrapper.classList.add(n + "-wrapper"), p.wrapper.classList.add(t), document.body.appendChild(p.wrapper)), "topLeft" == s.position || "topCenter" == s.position || "topRight" == s.position ? p.wrapper.insertBefore(p.toastCapsule, p.wrapper.firstChild) : p.wrapper.appendChild(p.toastCapsule);
            }
            isNaN(s.zindex) ? console.warn("[" + n + "] Invalid zIndex.") : p.wrapper.style.zIndex = s.zindex;
        }(), function() {
            s.overlay && (null !== document.querySelector("." + n + "-overlay.fadeIn") ? (p.overlay = document.querySelector("." + n + "-overlay"), p.overlay.setAttribute("data-iziToast-ref", p.overlay.getAttribute("data-iziToast-ref") + "," + s.ref), isNaN(s.zindex) || null === s.zindex || (p.overlay.style.zIndex = s.zindex - 1)) : (p.overlay.classList.add(n + "-overlay"), p.overlay.classList.add("fadeIn"), p.overlay.style.background = s.overlayColor, p.overlay.setAttribute("data-iziToast-ref", s.ref), isNaN(s.zindex) || null === s.zindex || (p.overlay.style.zIndex = s.zindex - 1), document.querySelector("body").appendChild(p.overlay)), s.overlayClose ? (p.overlay.removeEventListener("click", {}), p.overlay.addEventListener("click", function(t) {
                i.hide(s, p.toast, "overlay");
            })) : p.overlay.removeEventListener("click", {}));
        }(), function() {
            if (s.animateInside) {
                p.toast.classList.add(n + "-animateInside");
                var t = [
                    200,
                    100,
                    300
                ];
                "bounceInLeft" != s.transitionIn && "bounceInRight" != s.transitionIn || (t = [
                    400,
                    200,
                    400
                ]), s.title.length > 0 && setTimeout(function() {
                    p.strong.classList.add("slideIn");
                }, t[0]), s.message.length > 0 && setTimeout(function() {
                    p.p.classList.add("slideIn");
                }, t[1]), (s.icon || s.iconUrl) && setTimeout(function() {
                    p.icon.classList.add("revealIn");
                }, t[2]);
                var e = 150;
                s.buttons.length > 0 && p.buttons && setTimeout(function() {
                    m(p.buttons.childNodes, function(t, n) {
                        setTimeout(function() {
                            t.classList.add("revealIn");
                        }, e), e += 150;
                    });
                }, s.inputs.length > 0 ? 150 : 0), s.inputs.length > 0 && p.inputs && (e = 150, m(p.inputs.childNodes, function(t, n) {
                    setTimeout(function() {
                        t.classList.add("revealIn");
                    }, e), e += 150;
                }));
            }
        }(), s.onOpening.apply(null, [
            s,
            p.toast
        ]);
        try {
            var C = new CustomEvent(n + "-opening", {
                detail: s,
                bubbles: !0,
                cancelable: !0
            });
            document.dispatchEvent(C);
        } catch (w) {
            console.warn(w);
        }
        setTimeout(function() {
            p.toast.classList.remove(n + "-opening"), p.toast.classList.add(n + "-opened");
            try {
                var t = new CustomEvent(n + "-opened", {
                    detail: s,
                    bubbles: !0,
                    cancelable: !0
                });
                document.dispatchEvent(t);
            } catch (e) {
                console.warn(e);
            }
            s.onOpened.apply(null, [
                s,
                p.toast
            ]);
        }, 1e3), s.drag && (a ? (p.toast.addEventListener("touchstart", function(t) {
            b.startMoving(this, i, s, t);
        }, !1), p.toast.addEventListener("touchend", function(t) {
            b.stopMoving(this, t);
        }, !1)) : (p.toast.addEventListener("mousedown", function(t) {
            t.preventDefault(), b.startMoving(this, i, s, t);
        }, !1), p.toast.addEventListener("mouseup", function(t) {
            t.preventDefault(), b.stopMoving(this, t);
        }, !1))), s.closeOnEscape && document.addEventListener("keyup", function(t) {
            t = t || window.event, 27 == t.keyCode && i.hide(s, p.toast, "esc");
        }), s.closeOnClick && p.toast.addEventListener("click", function(t) {
            i.hide(s, p.toast, "toast");
        }), i.toast = p.toast;
    }, e;
});



/*
 * jquery-filestyle
 * doc: http://markusslima.github.io/jquery-filestyle/
 * github: https://github.com/markusslima/jquery-filestyle
 *
 * Copyright (c) 2017 Markus Vinicius da Silva Lima
 * Version 2.1.0
 * Licensed under the MIT license.
 */ !function(e) {
    "use strict";
    var t = 0, i = function(t, i) {
        this.options = i, this.$elementjFilestyle = [], this.$element = e(t);
    };
    i.prototype = {
        clear: function() {
            this.$element.val(""), this.$elementjFilestyle.find(":text").val(""), this.$elementjFilestyle.find(".count-jfilestyle").remove();
        },
        destroy: function() {
            this.$element.removeAttr("style").removeData("jfilestyle").val(""), this.$elementjFilestyle.remove();
        },
        dragdrop: function(e) {
            return e !== !0 && e !== !1 ? this.options.dragdrop : void (this.options.dragdrop = e);
        },
        disabled: function(e) {
            if (e === !0) this.options.disabled || (this.$element.attr("disabled", "true"), this.$elementjFilestyle.find("label").attr("disabled", "true"), this.options.disabled = !0);
            else {
                if (e !== !1) return this.options.disabled;
                this.options.disabled && (this.$element.removeAttr("disabled"), this.$elementjFilestyle.find("label").removeAttr("disabled"), this.options.disabled = !1);
            }
        },
        buttonBefore: function(e) {
            if (e === !0) this.options.buttonBefore || (this.options.buttonBefore = !0, this.options.input && (this.$elementjFilestyle.remove(), this.constructor(), this.pushNameFiles()));
            else {
                if (e !== !1) return this.options.buttonBefore;
                this.options.buttonBefore && (this.options.buttonBefore = !1, this.options.input && (this.$elementjFilestyle.remove(), this.constructor(), this.pushNameFiles()));
            }
        },
        input: function(e) {
            if (e === !0) this.options.input || (this.options.input = !0, this.$elementjFilestyle.find("label").before(this.htmlInput()), this.$elementjFilestyle.find(".count-jfilestyle").remove(), this.pushNameFiles());
            else {
                if (e !== !1) return this.options.input;
                if (this.options.input) {
                    this.options.input = !1, this.$elementjFilestyle.find(":text").remove();
                    var t = this.pushNameFiles();
                    t.length > 0 && this.$elementjFilestyle.find("label").append(' <span class="count-jfilestyle">' + t.length + "</span>");
                }
            }
        },
        text: function(e) {
            return void 0 === e ? this.options.text : (this.options.text = e, void this.$elementjFilestyle.find("label span").html(this.options.text));
        },
        theme: function(e) {
            return void 0 === e ? this.options.theme : (console.log(this.$elementjFilestyle.attr("class").replace(/.*(jfilestyle-theme-.*).*/, "$1")), this.$elementjFilestyle.removeClass(this.$elementjFilestyle.attr("class").replace(/.*(jfilestyle-theme-.*).*/, "$1")), this.options.theme = e, this.$elementjFilestyle.addClass("jfilestyle-theme-" + this.options.theme), void 0);
        },
        inputSize: function(e) {
            return void 0 === e ? this.options.inputSize : (this.options.inputSize = e, void this.$elementjFilestyle.find(":text").css("width", this.options.inputSize));
        },
        placeholder: function(e) {
            return void 0 === e ? this.options.placeholder : (this.options.placeholder = e, void this.$elementjFilestyle.find(":text").attr("placeholder", e));
        },
        htmlInput: function() {
            return this.options.input ? '<input type="text" style="width:' + this.options.inputSize + '" placeholder="' + this.options.placeholder + '" disabled> ' : "";
        },
        pushNameFiles: function() {
            var e = "", t = [];
            void 0 === this.$element[0].files ? t[0] = {
                name: this.$element.value
            } : t = this.$element[0].files;
            for(var i = 0; i < t.length; i++)e += t[i].name.split("\\").pop() + ", ";
            return "" !== e ? this.$elementjFilestyle.find(":text").val(e.replace(/\, $/g, "")) : this.$elementjFilestyle.find(":text").val(""), t;
        },
        constructor: function() {
            var i = this, n = "", l = i.$element.attr("id");
            "" !== l && l || (l = "jfilestyle-" + t, i.$element.attr({
                id: l
            }), t++), n = '<span class="focus-jfilestyle"><label for="' + l + '" ' + (i.options.disabled ? 'disabled="true"' : "") + "><span>" + i.options.text + "</span></label></span>", i.options.buttonBefore === !0 ? n += i.htmlInput() : n = i.htmlInput() + n, i.$elementjFilestyle = e('<div class="jfilestyle ' + (i.options.input ? "jfilestyle-corner" : "") + " " + (this.options.buttonBefore ? " jfilestyle-buttonbefore" : "") + " " + (i.options.theme ? "jfilestyle-theme-" + i.options.theme : "") + '"><div name="filedrag"></div>' + n + "</div>"), i.$elementjFilestyle.find(".focus-jfilestyle").attr("tabindex", "0").keypress(function(e) {
                return 13 === e.keyCode || 32 === e.charCode ? (i.$elementjFilestyle.find("label").click(), !1) : void 0;
            }), i.$element.css({
                position: "absolute",
                clip: "rect(0px 0px 0px 0px)"
            }).attr("tabindex", "-1").after(i.$elementjFilestyle), i.options.disabled && i.$element.attr("disabled", "true"), i.$elementjFilestyle.find('[name="filedrag"]').css({
                position: "absolute",
                width: "100%",
                height: i.$elementjFilestyle.height() + "px",
                "z-index": -1
            }), i.$element.change(function() {
                var e = i.pushNameFiles();
                0 == i.options.input ? 0 == i.$elementjFilestyle.find(".count-jfilestyle").length ? i.$elementjFilestyle.find("label").append(' <span class="count-jfilestyle">' + e.length + "</span>") : 0 == e.length ? i.$elementjFilestyle.find(".count-jfilestyle").remove() : i.$elementjFilestyle.find(".count-jfilestyle").html(e.length) : i.$elementjFilestyle.find(".count-jfilestyle").remove(), i.options.onChange(e);
            }), window.navigator.userAgent.search(/firefox/i) > -1 && this.$elementjFilestyle.find("label").click(function() {
                return i.$element.click(), !1;
            }), e(document).on("dragover", function(t) {
                t.preventDefault(), t.stopPropagation(), i.options.dragdrop || e('[name="filedrag"]').css("z-index", "9");
            }).on("drop", function(t) {
                t.preventDefault(), t.stopPropagation(), i.options.dragdrop || e('[name="filedrag"]').css("z-index", "-1");
            }), i.$elementjFilestyle.find('[name="filedrag"]').on("dragover", function(e) {
                e.preventDefault(), e.stopPropagation();
            }).on("dragenter", function(e) {
                e.preventDefault(), e.stopPropagation();
            }).on("drop", function(t) {
                if (t.originalEvent.dataTransfer && !i.options.disabled && i.options.dragdrop && t.originalEvent.dataTransfer.files.length) {
                    t.preventDefault(), t.stopPropagation(), i.$element[0].files = t.originalEvent.dataTransfer.files;
                    var n = i.pushNameFiles();
                    0 == i.options.input ? 0 == i.$elementjFilestyle.find(".count-jfilestyle").length ? i.$elementjFilestyle.find("label").append(' <span class="count-jfilestyle">' + n.length + "</span>") : 0 == n.length ? i.$elementjFilestyle.find(".count-jfilestyle").remove() : i.$elementjFilestyle.find(".count-jfilestyle").html(n.length) : i.$elementjFilestyle.find(".count-jfilestyle").remove(), e('[name="filedrag"]').css("z-index", "-1");
                }
            });
        }
    };
    var n = e.fn.jfilestyle;
    e.fn.jfilestyle = function(t, n) {
        var l = "", s = this.each(function() {
            if ("file" === e(this).attr("type")) {
                var s = e(this), o = s.data("jfilestyle"), a = e.extend({}, e.fn.jfilestyle.defaults, t, "object" == typeof t && t);
                o || (s.data("jfilestyle", o = new i(this, a)), o.constructor()), "string" == typeof t && (l = o[t](n));
            }
        });
        return l;
    }, e.fn.jfilestyle.defaults = {
        text: "Choose file",
        input: !0,
        disabled: !1,
        buttonBefore: !1,
        inputSize: "200px",
        placeholder: "",
        dragdrop: !0,
        theme: "default",
        onChange: function() {}
    }, e.fn.jfilestyle.noConflict = function() {
        return e.fn.jfilestyle = n, this;
    }, e(function() {
        e(".jfilestyle").each(function() {
            var t = e(this), i = {
                text: t.attr("data-text"),
                input: "false" !== t.attr("data-input"),
                disabled: "true" === t.attr("data-disabled"),
                buttonBefore: "true" === t.attr("data-buttonBefore"),
                inputSize: t.attr("data-inputSize"),
                placeholder: t.attr("data-placeholder"),
                theme: t.attr("data-theme"),
                dragdrop: "false" !== t.attr("data-dragdrop")
            };
            t.jfilestyle(i);
        });
    });
}(window.jQuery);


var $29e5617af0985d67$exports = {};
/*! Lazy Load 2.0.0-rc.2 - MIT license - Copyright 2007-2019 Mika Tuupola */ !function(t, e) {
    $29e5617af0985d67$exports = e(t);
}("undefined" != typeof $parcel$global ? $parcel$global : $29e5617af0985d67$exports.window || $29e5617af0985d67$exports.global, function(t) {
    "use strict";
    function e(t, e) {
        this.settings = s(r, e || {}), this.images = t || document.querySelectorAll(this.settings.selector), this.observer = null, this.init();
    }
    "function" == typeof define && define.amd && (t = window);
    const r = {
        src: "data-src",
        srcset: "data-srcset",
        selector: ".lazyload",
        root: null,
        rootMargin: "0px",
        threshold: 0
    }, s = function() {
        let t = {}, e = !1, r = 0, o = arguments.length;
        "[object Boolean]" === Object.prototype.toString.call(arguments[0]) && (e = arguments[0], r++);
        for(; r < o; r++)!function(r) {
            for(let o in r)Object.prototype.hasOwnProperty.call(r, o) && (e && "[object Object]" === Object.prototype.toString.call(r[o]) ? t[o] = s(!0, t[o], r[o]) : t[o] = r[o]);
        }(arguments[r]);
        return t;
    };
    if (e.prototype = {
        init: function() {
            if (!t.IntersectionObserver) return void this.loadImages();
            let e = this, r = {
                root: this.settings.root,
                rootMargin: this.settings.rootMargin,
                threshold: [
                    this.settings.threshold
                ]
            };
            this.observer = new IntersectionObserver(function(t) {
                Array.prototype.forEach.call(t, function(t) {
                    if (t.isIntersecting) {
                        e.observer.unobserve(t.target);
                        let r = t.target.getAttribute(e.settings.src), s = t.target.getAttribute(e.settings.srcset);
                        "img" === t.target.tagName.toLowerCase() ? (r && (t.target.src = r), s && (t.target.srcset = s)) : t.target.style.backgroundImage = "url(" + r + ")";
                    }
                });
            }, r), Array.prototype.forEach.call(this.images, function(t) {
                e.observer.observe(t);
            });
        },
        loadAndDestroy: function() {
            this.settings && (this.loadImages(), this.destroy());
        },
        loadImages: function() {
            if (!this.settings) return;
            let t = this;
            Array.prototype.forEach.call(this.images, function(e) {
                let r = e.getAttribute(t.settings.src), s = e.getAttribute(t.settings.srcset);
                "img" === e.tagName.toLowerCase() ? (r && (e.src = r), s && (e.srcset = s)) : e.style.backgroundImage = "url('" + r + "')";
            });
        },
        destroy: function() {
            this.settings && (this.observer.disconnect(), this.settings = null);
        }
    }, t.lazyload = function(t, r) {
        return new e(t, r);
    }, t.jQuery) {
        const r = t.jQuery;
        r.fn.lazyload = function(t) {
            return t = t || {}, t.attribute = t.attribute || "data-src", new e(r.makeArray(this), t), this;
        };
    }
    return e;
});





var $e30d6ba95bea1a03$exports = {};
/*
 *  Remodal - v1.1.1
 *  Responsive, lightweight, fast, synchronized with CSS animations, fully customizable modal window plugin with declarative configuration and hash tracking.
 *  http://vodkabears.github.io/remodal/
 *
 *  Made by Ilya Makarov
 *  Under MIT License
 */ 
!function(a, b) {
    "function" == typeof define && define.amd ? define([
        "jquery"
    ], function(c) {
        return b(a, c);
    }) : b(a, (parcelRequire("iUSsr")));
}($e30d6ba95bea1a03$exports, function(a, b) {
    "use strict";
    function c(a) {
        if (w && "none" === a.css("animation-name") && "none" === a.css("-webkit-animation-name") && "none" === a.css("-moz-animation-name") && "none" === a.css("-o-animation-name") && "none" === a.css("-ms-animation-name")) return 0;
        var b, c, d, e, f = a.css("animation-duration") || a.css("-webkit-animation-duration") || a.css("-moz-animation-duration") || a.css("-o-animation-duration") || a.css("-ms-animation-duration") || "0s", g = a.css("animation-delay") || a.css("-webkit-animation-delay") || a.css("-moz-animation-delay") || a.css("-o-animation-delay") || a.css("-ms-animation-delay") || "0s", h = a.css("animation-iteration-count") || a.css("-webkit-animation-iteration-count") || a.css("-moz-animation-iteration-count") || a.css("-o-animation-iteration-count") || a.css("-ms-animation-iteration-count") || "1";
        for(f = f.split(", "), g = g.split(", "), h = h.split(", "), e = 0, c = f.length, b = Number.NEGATIVE_INFINITY; e < c; e++)d = parseFloat(f[e]) * parseInt(h[e], 10) + parseFloat(g[e]), d > b && (b = d);
        return b;
    }
    function d() {
        if (b(document).height() <= b(window).height()) return 0;
        var a, c, d = document.createElement("div"), e = document.createElement("div");
        return d.style.visibility = "hidden", d.style.width = "100px", document.body.appendChild(d), a = d.offsetWidth, d.style.overflow = "scroll", e.style.width = "100%", d.appendChild(e), c = e.offsetWidth, d.parentNode.removeChild(d), a - c;
    }
    function e() {
        if (!x) {
            var a, c, e = b("html"), f = k("is-locked");
            e.hasClass(f) || (c = b(document.body), a = parseInt(c.css("padding-right"), 10) + d(), c.css("padding-right", a + "px"), e.addClass(f));
        }
    }
    function f() {
        if (!x) {
            var a, c, e = b("html"), f = k("is-locked");
            e.hasClass(f) && (c = b(document.body), a = parseInt(c.css("padding-right"), 10) - d(), c.css("padding-right", a + "px"), e.removeClass(f));
        }
    }
    function g(a, b, c, d) {
        var e = k("is", b), f = [
            k("is", u.CLOSING),
            k("is", u.OPENING),
            k("is", u.CLOSED),
            k("is", u.OPENED)
        ].join(" ");
        a.$bg.removeClass(f).addClass(e), a.$overlay.removeClass(f).addClass(e), a.$wrapper.removeClass(f).addClass(e), a.$modal.removeClass(f).addClass(e), a.state = b, !c && a.$modal.trigger({
            type: b,
            reason: d
        }, [
            {
                reason: d
            }
        ]);
    }
    function h(a, d, e) {
        var f = 0, g = function(a) {
            a.target === this && f++;
        }, h = function(a) {
            a.target === this && 0 === --f && (b.each([
                "$bg",
                "$overlay",
                "$wrapper",
                "$modal"
            ], function(a, b) {
                e[b].off(r + " " + s);
            }), d());
        };
        b.each([
            "$bg",
            "$overlay",
            "$wrapper",
            "$modal"
        ], function(a, b) {
            e[b].on(r, g).on(s, h);
        }), a(), 0 === c(e.$bg) && 0 === c(e.$overlay) && 0 === c(e.$wrapper) && 0 === c(e.$modal) && (b.each([
            "$bg",
            "$overlay",
            "$wrapper",
            "$modal"
        ], function(a, b) {
            e[b].off(r + " " + s);
        }), d());
    }
    function i(a) {
        a.state !== u.CLOSED && (b.each([
            "$bg",
            "$overlay",
            "$wrapper",
            "$modal"
        ], function(b, c) {
            a[c].off(r + " " + s);
        }), a.$bg.removeClass(a.settings.modifier), a.$overlay.removeClass(a.settings.modifier).hide(), a.$wrapper.hide(), f(), g(a, u.CLOSED, !0));
    }
    function j(a) {
        var b, c, d, e, f = {};
        for(a = a.replace(/\s*:\s*/g, ":").replace(/\s*,\s*/g, ","), b = a.split(","), e = 0, c = b.length; e < c; e++)b[e] = b[e].split(":"), d = b[e][1], ("string" == typeof d || d instanceof String) && (d = "true" === d || "false" !== d && d), ("string" == typeof d || d instanceof String) && (d = isNaN(d) ? d : +d), f[b[e][0]] = d;
        return f;
    }
    function k() {
        for(var a = q, b = 0; b < arguments.length; ++b)a += "-" + arguments[b];
        return a;
    }
    function l() {
        var a, c, d = location.hash.replace("#", "");
        if (d) {
            try {
                c = b('[data-remodal-id="' + d + '"]');
            } catch (e) {}
            c && c.length && (a = b[p].lookup[c.data(p)], a && a.settings.hashTracking && a.open());
        } else n && n.state === u.OPENED && n.settings.hashTracking && n.close();
    }
    function m(a, c) {
        var d = b(document.body), e = d, f = this;
        f.settings = b.extend({}, t, c), f.index = b[p].lookup.push(f) - 1, f.state = u.CLOSED, f.$overlay = b("." + k("overlay")), null !== f.settings.appendTo && f.settings.appendTo.length && (e = b(f.settings.appendTo)), f.$overlay.length || (f.$overlay = b("<div>").addClass(k("overlay") + " " + k("is", u.CLOSED)).hide(), e.append(f.$overlay)), f.$bg = b("." + k("bg")).addClass(k("is", u.CLOSED)), f.$modal = a.addClass(q + " " + k("is-initialized") + " " + f.settings.modifier + " " + k("is", u.CLOSED)).attr("tabindex", "-1"), f.$wrapper = b("<div>").addClass(k("wrapper") + " " + f.settings.modifier + " " + k("is", u.CLOSED)).hide().append(f.$modal), e.append(f.$wrapper), f.$wrapper.on("click." + q, '[data-remodal-action="close"]', function(a) {
            a.preventDefault(), f.close();
        }), f.$wrapper.on("click." + q, '[data-remodal-action="cancel"]', function(a) {
            a.preventDefault(), f.$modal.trigger(v.CANCELLATION), f.settings.closeOnCancel && f.close(v.CANCELLATION);
        }), f.$wrapper.on("click." + q, '[data-remodal-action="confirm"]', function(a) {
            a.preventDefault(), f.$modal.trigger(v.CONFIRMATION), f.settings.closeOnConfirm && f.close(v.CONFIRMATION);
        }), f.$wrapper.on("click." + q, function(a) {
            var c = b(a.target);
            c.hasClass(k("wrapper")) && f.settings.closeOnOutsideClick && f.close();
        });
    }
    var n, o, p = "remodal", q = a.REMODAL_GLOBALS && a.REMODAL_GLOBALS.NAMESPACE || p, r = b.map([
        "animationstart",
        "webkitAnimationStart",
        "MSAnimationStart",
        "oAnimationStart"
    ], function(a) {
        return a + "." + q;
    }).join(" "), s = b.map([
        "animationend",
        "webkitAnimationEnd",
        "MSAnimationEnd",
        "oAnimationEnd"
    ], function(a) {
        return a + "." + q;
    }).join(" "), t = b.extend({
        hashTracking: !0,
        closeOnConfirm: !0,
        closeOnCancel: !0,
        closeOnEscape: !0,
        closeOnOutsideClick: !0,
        modifier: "",
        appendTo: null
    }, a.REMODAL_GLOBALS && a.REMODAL_GLOBALS.DEFAULTS), u = {
        CLOSING: "closing",
        CLOSED: "closed",
        OPENING: "opening",
        OPENED: "opened"
    }, v = {
        CONFIRMATION: "confirmation",
        CANCELLATION: "cancellation"
    }, w = function() {
        var a = document.createElement("div").style;
        return void 0 !== a.animationName || void 0 !== a.WebkitAnimationName || void 0 !== a.MozAnimationName || void 0 !== a.msAnimationName || void 0 !== a.OAnimationName;
    }(), x = /iPad|iPhone|iPod/.test(navigator.platform);
    m.prototype.open = function() {
        var a, c = this;
        c.state !== u.OPENING && c.state !== u.CLOSING && (a = c.$modal.attr("data-remodal-id"), a && c.settings.hashTracking && (o = b(window).scrollTop(), location.hash = a), n && n !== c && i(n), n = c, e(), c.$bg.addClass(c.settings.modifier), c.$overlay.addClass(c.settings.modifier).show(), c.$wrapper.show().scrollTop(0), c.$modal.focus(), h(function() {
            g(c, u.OPENING);
        }, function() {
            g(c, u.OPENED);
        }, c));
    }, m.prototype.close = function(a) {
        var c = this;
        c.state !== u.OPENING && c.state !== u.CLOSING && c.state !== u.CLOSED && (c.settings.hashTracking && c.$modal.attr("data-remodal-id") === location.hash.substr(1) && (location.hash = "", b(window).scrollTop(o)), h(function() {
            g(c, u.CLOSING, !1, a);
        }, function() {
            c.$bg.removeClass(c.settings.modifier), c.$overlay.removeClass(c.settings.modifier).hide(), c.$wrapper.hide(), f(), g(c, u.CLOSED, !1, a);
        }, c));
    }, m.prototype.getState = function() {
        return this.state;
    }, m.prototype.destroy = function() {
        var a, c = b[p].lookup;
        i(this), this.$wrapper.remove(), delete c[this.index], a = b.grep(c, function(a) {
            return !!a;
        }).length, 0 === a && (this.$overlay.remove(), this.$bg.removeClass(k("is", u.CLOSING) + " " + k("is", u.OPENING) + " " + k("is", u.CLOSED) + " " + k("is", u.OPENED)));
    }, b[p] = {
        lookup: []
    }, b.fn[p] = function(a) {
        var c, d;
        return this.each(function(e, f) {
            d = b(f), null == d.data(p) ? (c = new m(d, a), d.data(p, c.index), c.settings.hashTracking && d.attr("data-remodal-id") === location.hash.substr(1) && c.open()) : c = b[p].lookup[d.data(p)];
        }), c;
    }, b(document).ready(function() {
        b(document).on("click", "[data-remodal-target]", function(a) {
            a.preventDefault();
            var c = a.currentTarget, d = c.getAttribute("data-remodal-target"), e = b('[data-remodal-id="' + d + '"]');
            b[p].lookup[e.data(p)].open();
        }), b(document).find("." + q).each(function(a, c) {
            var d = b(c), e = d.data("remodal-options");
            e ? ("string" == typeof e || e instanceof String) && (e = j(e)) : e = {}, d[p](e);
        }), b(document).on("keydown." + q, function(a) {
            n && n.settings.closeOnEscape && n.state === u.OPENED && 27 === a.keyCode && n.close();
        }), b(window).on("hashchange." + q, l);
    });
});


var $c6423ec4b5d465d5$exports = {};
/*! Sortable 1.15.6 - MIT | git://github.com/SortableJS/Sortable.git */ !function(t, e) {
    $c6423ec4b5d465d5$exports = e();
}($c6423ec4b5d465d5$exports, function() {
    "use strict";
    function e(e, t) {
        var n, o = Object.keys(e);
        return Object.getOwnPropertySymbols && (n = Object.getOwnPropertySymbols(e), t && (n = n.filter(function(t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), o.push.apply(o, n)), o;
    }
    function I(o) {
        for(var t = 1; t < arguments.length; t++){
            var i = null != arguments[t] ? arguments[t] : {};
            t % 2 ? e(Object(i), !0).forEach(function(t) {
                var e, n;
                e = o, t = i[n = t], n in e ? Object.defineProperty(e, n, {
                    value: t,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[n] = t;
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(i)) : e(Object(i)).forEach(function(t) {
                Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(i, t));
            });
        }
        return o;
    }
    function o(t) {
        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t;
        } : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        })(t);
    }
    function a() {
        return (a = Object.assign || function(t) {
            for(var e = 1; e < arguments.length; e++){
                var n, o = arguments[e];
                for(n in o)Object.prototype.hasOwnProperty.call(o, n) && (t[n] = o[n]);
            }
            return t;
        }).apply(this, arguments);
    }
    function i(t, e) {
        if (null == t) return {};
        var n, o = function(t, e) {
            if (null == t) return {};
            for(var n, o = {}, i = Object.keys(t), r = 0; r < i.length; r++)n = i[r], 0 <= e.indexOf(n) || (o[n] = t[n]);
            return o;
        }(t, e);
        if (Object.getOwnPropertySymbols) for(var i = Object.getOwnPropertySymbols(t), r = 0; r < i.length; r++)n = i[r], 0 <= e.indexOf(n) || Object.prototype.propertyIsEnumerable.call(t, n) && (o[n] = t[n]);
        return o;
    }
    function r(t) {
        return function(t) {
            if (Array.isArray(t)) return l(t);
        }(t) || function(t) {
            if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
        }(t) || function(t, e) {
            if (t) {
                if ("string" == typeof t) return l(t, e);
                var n = Object.prototype.toString.call(t).slice(8, -1);
                return "Map" === (n = "Object" === n && t.constructor ? t.constructor.name : n) || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? l(t, e) : void 0;
            }
        }(t) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function l(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for(var n = 0, o = new Array(e); n < e; n++)o[n] = t[n];
        return o;
    }
    function t(t) {
        if ("undefined" != typeof window && window.navigator) return !!navigator.userAgent.match(t);
    }
    var y = t(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), w = t(/Edge/i), s = t(/firefox/i), u = t(/safari/i) && !t(/chrome/i) && !t(/android/i), c = t(/iP(ad|od|hone)/i), n = t(/chrome/i) && t(/android/i), d = {
        capture: !1,
        passive: !1
    };
    function h(t, e, n) {
        t.addEventListener(e, n, !y && d);
    }
    function p(t, e, n) {
        t.removeEventListener(e, n, !y && d);
    }
    function f(t, e) {
        if (e && (">" === e[0] && (e = e.substring(1)), t)) try {
            if (t.matches) return t.matches(e);
            if (t.msMatchesSelector) return t.msMatchesSelector(e);
            if (t.webkitMatchesSelector) return t.webkitMatchesSelector(e);
        } catch (t) {
            return;
        }
    }
    function g(t) {
        return t.host && t !== document && t.host.nodeType ? t.host : t.parentNode;
    }
    function P(t, e, n, o) {
        if (t) {
            n = n || document;
            do {
                if (null != e && (">" !== e[0] || t.parentNode === n) && f(t, e) || o && t === n) return t;
            }while (t !== n && (t = g(t)));
        }
        return null;
    }
    var m, v = /\s+/g;
    function k(t, e, n) {
        var o;
        t && e && (t.classList ? t.classList[n ? "add" : "remove"](e) : (o = (" " + t.className + " ").replace(v, " ").replace(" " + e + " ", " "), t.className = (o + (n ? " " + e : "")).replace(v, " ")));
    }
    function R(t, e, n) {
        var o = t && t.style;
        if (o) {
            if (void 0 === n) return document.defaultView && document.defaultView.getComputedStyle ? n = document.defaultView.getComputedStyle(t, "") : t.currentStyle && (n = t.currentStyle), void 0 === e ? n : n[e];
            o[e = !(e in o || -1 !== e.indexOf("webkit")) ? "-webkit-" + e : e] = n + ("string" == typeof n ? "" : "px");
        }
    }
    function b(t, e) {
        var n = "";
        if ("string" == typeof t) n = t;
        else do var o = R(t, "transform");
        while (o && "none" !== o && (n = o + " " + n), !e && (t = t.parentNode));
        var i = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
        return i && new i(n);
    }
    function D(t, e, n) {
        if (t) {
            var o = t.getElementsByTagName(e), i = 0, r = o.length;
            if (n) for(; i < r; i++)n(o[i], i);
            return o;
        }
        return [];
    }
    function O() {
        var t = document.scrollingElement;
        return t || document.documentElement;
    }
    function X(t, e, n, o, i) {
        if (t.getBoundingClientRect || t === window) {
            var r, a, l, s, c, u, d = t !== window && t.parentNode && t !== O() ? (a = (r = t.getBoundingClientRect()).top, l = r.left, s = r.bottom, c = r.right, u = r.height, r.width) : (l = a = 0, s = window.innerHeight, c = window.innerWidth, u = window.innerHeight, window.innerWidth);
            if ((e || n) && t !== window && (i = i || t.parentNode, !y)) do if (i && i.getBoundingClientRect && ("none" !== R(i, "transform") || n && "static" !== R(i, "position"))) {
                var h = i.getBoundingClientRect();
                a -= h.top + parseInt(R(i, "border-top-width")), l -= h.left + parseInt(R(i, "border-left-width")), s = a + r.height, c = l + r.width;
                break;
            }
            while (i = i.parentNode);
            return o && t !== window && (o = (e = b(i || t)) && e.a, t = e && e.d, e && (s = (a /= t) + (u /= t), c = (l /= o) + (d /= o))), {
                top: a,
                left: l,
                bottom: s,
                right: c,
                width: d,
                height: u
            };
        }
    }
    function Y(t, e, n) {
        for(var o = M(t, !0), i = X(t)[e]; o;){
            var r = X(o)[n];
            if (!("top" === n || "left" === n ? r <= i : i <= r)) return o;
            if (o === O()) break;
            o = M(o, !1);
        }
        return !1;
    }
    function B(t, e, n, o) {
        for(var i = 0, r = 0, a = t.children; r < a.length;){
            if ("none" !== a[r].style.display && a[r] !== jt.ghost && (o || a[r] !== jt.dragged) && P(a[r], n.draggable, t, !1)) {
                if (i === e) return a[r];
                i++;
            }
            r++;
        }
        return null;
    }
    function F(t, e) {
        for(var n = t.lastElementChild; n && (n === jt.ghost || "none" === R(n, "display") || e && !f(n, e));)n = n.previousElementSibling;
        return n || null;
    }
    function j(t, e) {
        var n = 0;
        if (!t || !t.parentNode) return -1;
        for(; t = t.previousElementSibling;)"TEMPLATE" === t.nodeName.toUpperCase() || t === jt.clone || e && !f(t, e) || n++;
        return n;
    }
    function E(t) {
        var e = 0, n = 0, o = O();
        if (t) do var i = b(t), r = i.a, i = i.d;
        while (e += t.scrollLeft * r, n += t.scrollTop * i, t !== o && (t = t.parentNode));
        return [
            e,
            n
        ];
    }
    function M(t, e) {
        if (!t || !t.getBoundingClientRect) return O();
        var n = t, o = !1;
        do if (n.clientWidth < n.scrollWidth || n.clientHeight < n.scrollHeight) {
            var i = R(n);
            if (n.clientWidth < n.scrollWidth && ("auto" == i.overflowX || "scroll" == i.overflowX) || n.clientHeight < n.scrollHeight && ("auto" == i.overflowY || "scroll" == i.overflowY)) {
                if (!n.getBoundingClientRect || n === document.body) return O();
                if (o || e) return n;
                o = !0;
            }
        }
        while (n = n.parentNode);
        return O();
    }
    function S(t, e) {
        return Math.round(t.top) === Math.round(e.top) && Math.round(t.left) === Math.round(e.left) && Math.round(t.height) === Math.round(e.height) && Math.round(t.width) === Math.round(e.width);
    }
    function _(e, n) {
        return function() {
            var t;
            m || (1 === (t = arguments).length ? e.call(this, t[0]) : e.apply(this, t), m = setTimeout(function() {
                m = void 0;
            }, n));
        };
    }
    function H(t, e, n) {
        t.scrollLeft += e, t.scrollTop += n;
    }
    function C(t) {
        var e = window.Polymer, n = window.jQuery || window.Zepto;
        return e && e.dom ? e.dom(t).cloneNode(!0) : n ? n(t).clone(!0)[0] : t.cloneNode(!0);
    }
    function T(t, e) {
        R(t, "position", "absolute"), R(t, "top", e.top), R(t, "left", e.left), R(t, "width", e.width), R(t, "height", e.height);
    }
    function x(t) {
        R(t, "position", ""), R(t, "top", ""), R(t, "left", ""), R(t, "width", ""), R(t, "height", "");
    }
    function L(n, o, i) {
        var r = {};
        return Array.from(n.children).forEach(function(t) {
            var e;
            P(t, o.draggable, n, !1) && !t.animated && t !== i && (e = X(t), r.left = Math.min(null !== (t = r.left) && void 0 !== t ? t : 1 / 0, e.left), r.top = Math.min(null !== (t = r.top) && void 0 !== t ? t : 1 / 0, e.top), r.right = Math.max(null !== (t = r.right) && void 0 !== t ? t : -1 / 0, e.right), r.bottom = Math.max(null !== (t = r.bottom) && void 0 !== t ? t : -1 / 0, e.bottom));
        }), r.width = r.right - r.left, r.height = r.bottom - r.top, r.x = r.left, r.y = r.top, r;
    }
    var K = "Sortable" + (new Date).getTime();
    function A() {
        var e, o = [];
        return {
            captureAnimationState: function() {
                o = [], this.options.animation && [].slice.call(this.el.children).forEach(function(t) {
                    var e, n;
                    "none" !== R(t, "display") && t !== jt.ghost && (o.push({
                        target: t,
                        rect: X(t)
                    }), e = I({}, o[o.length - 1].rect), !t.thisAnimationDuration || (n = b(t, !0)) && (e.top -= n.f, e.left -= n.e), t.fromRect = e);
                });
            },
            addAnimationState: function(t) {
                o.push(t);
            },
            removeAnimationState: function(t) {
                o.splice(function(t, e) {
                    for(var n in t)if (t.hasOwnProperty(n)) {
                        for(var o in e)if (e.hasOwnProperty(o) && e[o] === t[n][o]) return Number(n);
                    }
                    return -1;
                }(o, {
                    target: t
                }), 1);
            },
            animateAll: function(t) {
                var c = this;
                if (!this.options.animation) return clearTimeout(e), void ("function" == typeof t && t());
                var u = !1, d = 0;
                o.forEach(function(t) {
                    var e = 0, n = t.target, o = n.fromRect, i = X(n), r = n.prevFromRect, a = n.prevToRect, l = t.rect, s = b(n, !0);
                    s && (i.top -= s.f, i.left -= s.e), n.toRect = i, n.thisAnimationDuration && S(r, i) && !S(o, i) && (l.top - i.top) / (l.left - i.left) == (o.top - i.top) / (o.left - i.left) && (t = l, s = r, r = a, a = c.options, e = Math.sqrt(Math.pow(s.top - t.top, 2) + Math.pow(s.left - t.left, 2)) / Math.sqrt(Math.pow(s.top - r.top, 2) + Math.pow(s.left - r.left, 2)) * a.animation), S(i, o) || (n.prevFromRect = o, n.prevToRect = i, e = e || c.options.animation, c.animate(n, l, i, e)), e && (u = !0, d = Math.max(d, e), clearTimeout(n.animationResetTimer), n.animationResetTimer = setTimeout(function() {
                        n.animationTime = 0, n.prevFromRect = null, n.fromRect = null, n.prevToRect = null, n.thisAnimationDuration = null;
                    }, e), n.thisAnimationDuration = e);
                }), clearTimeout(e), u ? e = setTimeout(function() {
                    "function" == typeof t && t();
                }, d) : "function" == typeof t && t(), o = [];
            },
            animate: function(t, e, n, o) {
                var i, r;
                o && (R(t, "transition", ""), R(t, "transform", ""), i = (r = b(this.el)) && r.a, r = r && r.d, i = (e.left - n.left) / (i || 1), r = (e.top - n.top) / (r || 1), t.animatingX = !!i, t.animatingY = !!r, R(t, "transform", "translate3d(" + i + "px," + r + "px,0)"), this.forRepaintDummy = t.offsetWidth, R(t, "transition", "transform " + o + "ms" + (this.options.easing ? " " + this.options.easing : "")), R(t, "transform", "translate3d(0,0,0)"), "number" == typeof t.animated && clearTimeout(t.animated), t.animated = setTimeout(function() {
                    R(t, "transition", ""), R(t, "transform", ""), t.animated = !1, t.animatingX = !1, t.animatingY = !1;
                }, o));
            }
        };
    }
    var N = [], W = {
        initializeByDefault: !0
    }, z = {
        mount: function(e) {
            for(var t in W)!W.hasOwnProperty(t) || t in e || (e[t] = W[t]);
            N.forEach(function(t) {
                if (t.pluginName === e.pluginName) throw "Sortable: Cannot mount plugin ".concat(e.pluginName, " more than once");
            }), N.push(e);
        },
        pluginEvent: function(e, n, o) {
            var t = this;
            this.eventCanceled = !1, o.cancel = function() {
                t.eventCanceled = !0;
            };
            var i = e + "Global";
            N.forEach(function(t) {
                n[t.pluginName] && (n[t.pluginName][i] && n[t.pluginName][i](I({
                    sortable: n
                }, o)), n.options[t.pluginName] && n[t.pluginName][e] && n[t.pluginName][e](I({
                    sortable: n
                }, o)));
            });
        },
        initializePlugins: function(n, o, i, t) {
            for(var e in N.forEach(function(t) {
                var e = t.pluginName;
                (n.options[e] || t.initializeByDefault) && ((t = new t(n, o, n.options)).sortable = n, t.options = n.options, n[e] = t, a(i, t.defaults));
            }), n.options){
                var r;
                n.options.hasOwnProperty(e) && void 0 !== (r = this.modifyOption(n, e, n.options[e])) && (n.options[e] = r);
            }
        },
        getEventProperties: function(e, n) {
            var o = {};
            return N.forEach(function(t) {
                "function" == typeof t.eventProperties && a(o, t.eventProperties.call(n[t.pluginName], e));
            }), o;
        },
        modifyOption: function(e, n, o) {
            var i;
            return N.forEach(function(t) {
                e[t.pluginName] && t.optionListeners && "function" == typeof t.optionListeners[n] && (i = t.optionListeners[n].call(e[t.pluginName], o));
            }), i;
        }
    };
    function G(t) {
        var e = t.sortable, n = t.rootEl, o = t.name, i = t.targetEl, r = t.cloneEl, a = t.toEl, l = t.fromEl, s = t.oldIndex, c = t.newIndex, u = t.oldDraggableIndex, d = t.newDraggableIndex, h = t.originalEvent, p = t.putSortable, f = t.extraEventProperties;
        if (e = e || n && n[K]) {
            var g, m = e.options, t = "on" + o.charAt(0).toUpperCase() + o.substr(1);
            !window.CustomEvent || y || w ? (g = document.createEvent("Event")).initEvent(o, !0, !0) : g = new CustomEvent(o, {
                bubbles: !0,
                cancelable: !0
            }), g.to = a || n, g.from = l || n, g.item = i || n, g.clone = r, g.oldIndex = s, g.newIndex = c, g.oldDraggableIndex = u, g.newDraggableIndex = d, g.originalEvent = h, g.pullMode = p ? p.lastPutMode : void 0;
            var v, b = I(I({}, f), z.getEventProperties(o, e));
            for(v in b)g[v] = b[v];
            n && n.dispatchEvent(g), m[t] && m[t].call(e, g);
        }
    }
    function U(t, e) {
        var n = (o = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {}).evt, o = i(o, q);
        z.pluginEvent.bind(jt)(t, e, I({
            dragEl: Z,
            parentEl: $,
            ghostEl: Q,
            rootEl: J,
            nextEl: tt,
            lastDownEl: et,
            cloneEl: nt,
            cloneHidden: ot,
            dragStarted: mt,
            putSortable: ct,
            activeSortable: jt.active,
            originalEvent: n,
            oldIndex: it,
            oldDraggableIndex: at,
            newIndex: rt,
            newDraggableIndex: lt,
            hideGhostForTarget: Xt,
            unhideGhostForTarget: Yt,
            cloneNowHidden: function() {
                ot = !0;
            },
            cloneNowShown: function() {
                ot = !1;
            },
            dispatchSortableEvent: function(t) {
                V({
                    sortable: e,
                    name: t,
                    originalEvent: n
                });
            }
        }, o));
    }
    var q = [
        "evt"
    ];
    function V(t) {
        G(I({
            putSortable: ct,
            cloneEl: nt,
            targetEl: Z,
            rootEl: J,
            oldIndex: it,
            oldDraggableIndex: at,
            newIndex: rt,
            newDraggableIndex: lt
        }, t));
    }
    var Z, $, Q, J, tt, et, nt, ot, it, rt, at, lt, st, ct, ut, dt, ht, pt, ft, gt, mt, vt, bt, yt, wt, Dt = !1, Et = !1, St = [], _t = !1, Ct = !1, Tt = [], xt = !1, Ot = [], Mt = "undefined" != typeof document, At = c, Nt = w || y ? "cssFloat" : "float", It = Mt && !n && !c && "draggable" in document.createElement("div"), Pt = function() {
        if (Mt) {
            if (y) return !1;
            var t = document.createElement("x");
            return t.style.cssText = "pointer-events:auto", "auto" === t.style.pointerEvents;
        }
    }(), kt = function(t, e) {
        var n = R(t), o = parseInt(n.width) - parseInt(n.paddingLeft) - parseInt(n.paddingRight) - parseInt(n.borderLeftWidth) - parseInt(n.borderRightWidth), i = B(t, 0, e), r = B(t, 1, e), a = i && R(i), l = r && R(r), s = a && parseInt(a.marginLeft) + parseInt(a.marginRight) + X(i).width, t = l && parseInt(l.marginLeft) + parseInt(l.marginRight) + X(r).width;
        if ("flex" === n.display) return "column" === n.flexDirection || "column-reverse" === n.flexDirection ? "vertical" : "horizontal";
        if ("grid" === n.display) return n.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
        if (i && a.float && "none" !== a.float) {
            e = "left" === a.float ? "left" : "right";
            return !r || "both" !== l.clear && l.clear !== e ? "horizontal" : "vertical";
        }
        return i && ("block" === a.display || "flex" === a.display || "table" === a.display || "grid" === a.display || o <= s && "none" === n[Nt] || r && "none" === n[Nt] && o < s + t) ? "vertical" : "horizontal";
    }, Rt = function(t) {
        function l(r, a) {
            return function(t, e, n, o) {
                var i = t.options.group.name && e.options.group.name && t.options.group.name === e.options.group.name;
                if (null == r && (a || i)) return !0;
                if (null == r || !1 === r) return !1;
                if (a && "clone" === r) return r;
                if ("function" == typeof r) return l(r(t, e, n, o), a)(t, e, n, o);
                e = (a ? t : e).options.group.name;
                return !0 === r || "string" == typeof r && r === e || r.join && -1 < r.indexOf(e);
            };
        }
        var e = {}, n = t.group;
        n && "object" == o(n) || (n = {
            name: n
        }), e.name = n.name, e.checkPull = l(n.pull, !0), e.checkPut = l(n.put), e.revertClone = n.revertClone, t.group = e;
    }, Xt = function() {
        !Pt && Q && R(Q, "display", "none");
    }, Yt = function() {
        !Pt && Q && R(Q, "display", "");
    };
    Mt && !n && document.addEventListener("click", function(t) {
        if (Et) return t.preventDefault(), t.stopPropagation && t.stopPropagation(), t.stopImmediatePropagation && t.stopImmediatePropagation(), Et = !1;
    }, !0);
    function Bt(t) {
        if (Z) {
            t = t.touches ? t.touches[0] : t;
            var e = (i = t.clientX, r = t.clientY, St.some(function(t) {
                var e = t[K].options.emptyInsertThreshold;
                if (e && !F(t)) {
                    var n = X(t), o = i >= n.left - e && i <= n.right + e, e = r >= n.top - e && r <= n.bottom + e;
                    return o && e ? a = t : void 0;
                }
            }), a);
            if (e) {
                var n, o = {};
                for(n in t)t.hasOwnProperty(n) && (o[n] = t[n]);
                o.target = o.rootEl = e, o.preventDefault = void 0, o.stopPropagation = void 0, e[K]._onDragOver(o);
            }
        }
        var i, r, a;
    }
    function Ft(t) {
        Z && Z.parentNode[K]._isOutsideThisEl(t.target);
    }
    function jt(t, e) {
        if (!t || !t.nodeType || 1 !== t.nodeType) throw "Sortable: `el` must be an HTMLElement, not ".concat(({}).toString.call(t));
        this.el = t, this.options = e = a({}, e), t[K] = this;
        var n, o, i = {
            group: null,
            sort: !0,
            disabled: !1,
            store: null,
            handle: null,
            draggable: /^[uo]l$/i.test(t.nodeName) ? ">li" : ">*",
            swapThreshold: 1,
            invertSwap: !1,
            invertedSwapThreshold: null,
            removeCloneOnHide: !0,
            direction: function() {
                return kt(t, this.options);
            },
            ghostClass: "sortable-ghost",
            chosenClass: "sortable-chosen",
            dragClass: "sortable-drag",
            ignore: "a, img",
            filter: null,
            preventOnFilter: !0,
            animation: 0,
            easing: null,
            setData: function(t, e) {
                t.setData("Text", e.textContent);
            },
            dropBubble: !1,
            dragoverBubble: !1,
            dataIdAttr: "data-id",
            delay: 0,
            delayOnTouchOnly: !1,
            touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
            forceFallback: !1,
            fallbackClass: "sortable-fallback",
            fallbackOnBody: !1,
            fallbackTolerance: 0,
            fallbackOffset: {
                x: 0,
                y: 0
            },
            supportPointer: !1 !== jt.supportPointer && "PointerEvent" in window && (!u || c),
            emptyInsertThreshold: 5
        };
        for(n in z.initializePlugins(this, t, i), i)n in e || (e[n] = i[n]);
        for(o in Rt(e), this)"_" === o.charAt(0) && "function" == typeof this[o] && (this[o] = this[o].bind(this));
        this.nativeDraggable = !e.forceFallback && It, this.nativeDraggable && (this.options.touchStartThreshold = 1), e.supportPointer ? h(t, "pointerdown", this._onTapStart) : (h(t, "mousedown", this._onTapStart), h(t, "touchstart", this._onTapStart)), this.nativeDraggable && (h(t, "dragover", this), h(t, "dragenter", this)), St.push(this.el), e.store && e.store.get && this.sort(e.store.get(this) || []), a(this, A());
    }
    function Ht(t, e, n, o, i, r, a, l) {
        var s, c, u = t[K], d = u.options.onMove;
        return !window.CustomEvent || y || w ? (s = document.createEvent("Event")).initEvent("move", !0, !0) : s = new CustomEvent("move", {
            bubbles: !0,
            cancelable: !0
        }), s.to = e, s.from = t, s.dragged = n, s.draggedRect = o, s.related = i || e, s.relatedRect = r || X(e), s.willInsertAfter = l, s.originalEvent = a, t.dispatchEvent(s), c = d ? d.call(u, s, a) : c;
    }
    function Lt(t) {
        t.draggable = !1;
    }
    function Kt() {
        xt = !1;
    }
    function Wt(t) {
        return setTimeout(t, 0);
    }
    function zt(t) {
        return clearTimeout(t);
    }
    jt.prototype = {
        constructor: jt,
        _isOutsideThisEl: function(t) {
            this.el.contains(t) || t === this.el || (vt = null);
        },
        _getDirection: function(t, e) {
            return "function" == typeof this.options.direction ? this.options.direction.call(this, t, e, Z) : this.options.direction;
        },
        _onTapStart: function(e) {
            if (e.cancelable) {
                var n = this, o = this.el, t = this.options, i = t.preventOnFilter, r = e.type, a = e.touches && e.touches[0] || e.pointerType && "touch" === e.pointerType && e, l = (a || e).target, s = e.target.shadowRoot && (e.path && e.path[0] || e.composedPath && e.composedPath()[0]) || l, c = t.filter;
                if (!function(t) {
                    Ot.length = 0;
                    var e = t.getElementsByTagName("input"), n = e.length;
                    for(; n--;){
                        var o = e[n];
                        o.checked && Ot.push(o);
                    }
                }(o), !Z && !(/mousedown|pointerdown/.test(r) && 0 !== e.button || t.disabled) && !s.isContentEditable && (this.nativeDraggable || !u || !l || "SELECT" !== l.tagName.toUpperCase()) && !((l = P(l, t.draggable, o, !1)) && l.animated || et === l)) {
                    if (it = j(l), at = j(l, t.draggable), "function" == typeof c) {
                        if (c.call(this, e, l, this)) return V({
                            sortable: n,
                            rootEl: s,
                            name: "filter",
                            targetEl: l,
                            toEl: o,
                            fromEl: o
                        }), U("filter", n, {
                            evt: e
                        }), void (i && e.preventDefault());
                    } else if (c = c && c.split(",").some(function(t) {
                        if (t = P(s, t.trim(), o, !1)) return V({
                            sortable: n,
                            rootEl: t,
                            name: "filter",
                            targetEl: l,
                            fromEl: o,
                            toEl: o
                        }), U("filter", n, {
                            evt: e
                        }), !0;
                    })) return void (i && e.preventDefault());
                    t.handle && !P(s, t.handle, o, !1) || this._prepareDragStart(e, a, l);
                }
            }
        },
        _prepareDragStart: function(t, e, n) {
            var o, i = this, r = i.el, a = i.options, l = r.ownerDocument;
            n && !Z && n.parentNode === r && (o = X(n), J = r, $ = (Z = n).parentNode, tt = Z.nextSibling, et = n, st = a.group, ut = {
                target: jt.dragged = Z,
                clientX: (e || t).clientX,
                clientY: (e || t).clientY
            }, ft = ut.clientX - o.left, gt = ut.clientY - o.top, this._lastX = (e || t).clientX, this._lastY = (e || t).clientY, Z.style["will-change"] = "all", o = function() {
                U("delayEnded", i, {
                    evt: t
                }), jt.eventCanceled ? i._onDrop() : (i._disableDelayedDragEvents(), !s && i.nativeDraggable && (Z.draggable = !0), i._triggerDragStart(t, e), V({
                    sortable: i,
                    name: "choose",
                    originalEvent: t
                }), k(Z, a.chosenClass, !0));
            }, a.ignore.split(",").forEach(function(t) {
                D(Z, t.trim(), Lt);
            }), h(l, "dragover", Bt), h(l, "mousemove", Bt), h(l, "touchmove", Bt), a.supportPointer ? (h(l, "pointerup", i._onDrop), this.nativeDraggable || h(l, "pointercancel", i._onDrop)) : (h(l, "mouseup", i._onDrop), h(l, "touchend", i._onDrop), h(l, "touchcancel", i._onDrop)), s && this.nativeDraggable && (this.options.touchStartThreshold = 4, Z.draggable = !0), U("delayStart", this, {
                evt: t
            }), !a.delay || a.delayOnTouchOnly && !e || this.nativeDraggable && (w || y) ? o() : jt.eventCanceled ? this._onDrop() : (a.supportPointer ? (h(l, "pointerup", i._disableDelayedDrag), h(l, "pointercancel", i._disableDelayedDrag)) : (h(l, "mouseup", i._disableDelayedDrag), h(l, "touchend", i._disableDelayedDrag), h(l, "touchcancel", i._disableDelayedDrag)), h(l, "mousemove", i._delayedDragTouchMoveHandler), h(l, "touchmove", i._delayedDragTouchMoveHandler), a.supportPointer && h(l, "pointermove", i._delayedDragTouchMoveHandler), i._dragStartTimer = setTimeout(o, a.delay)));
        },
        _delayedDragTouchMoveHandler: function(t) {
            t = t.touches ? t.touches[0] : t;
            Math.max(Math.abs(t.clientX - this._lastX), Math.abs(t.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
        },
        _disableDelayedDrag: function() {
            Z && Lt(Z), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
        },
        _disableDelayedDragEvents: function() {
            var t = this.el.ownerDocument;
            p(t, "mouseup", this._disableDelayedDrag), p(t, "touchend", this._disableDelayedDrag), p(t, "touchcancel", this._disableDelayedDrag), p(t, "pointerup", this._disableDelayedDrag), p(t, "pointercancel", this._disableDelayedDrag), p(t, "mousemove", this._delayedDragTouchMoveHandler), p(t, "touchmove", this._delayedDragTouchMoveHandler), p(t, "pointermove", this._delayedDragTouchMoveHandler);
        },
        _triggerDragStart: function(t, e) {
            e = e || "touch" == t.pointerType && t, !this.nativeDraggable || e ? this.options.supportPointer ? h(document, "pointermove", this._onTouchMove) : h(document, e ? "touchmove" : "mousemove", this._onTouchMove) : (h(Z, "dragend", this), h(J, "dragstart", this._onDragStart));
            try {
                document.selection ? Wt(function() {
                    document.selection.empty();
                }) : window.getSelection().removeAllRanges();
            } catch (t) {}
        },
        _dragStarted: function(t, e) {
            var n;
            Dt = !1, J && Z ? (U("dragStarted", this, {
                evt: e
            }), this.nativeDraggable && h(document, "dragover", Ft), n = this.options, t || k(Z, n.dragClass, !1), k(Z, n.ghostClass, !0), jt.active = this, t && this._appendGhost(), V({
                sortable: this,
                name: "start",
                originalEvent: e
            })) : this._nulling();
        },
        _emulateDragOver: function() {
            if (dt) {
                this._lastX = dt.clientX, this._lastY = dt.clientY, Xt();
                for(var t = document.elementFromPoint(dt.clientX, dt.clientY), e = t; t && t.shadowRoot && (t = t.shadowRoot.elementFromPoint(dt.clientX, dt.clientY)) !== e;)e = t;
                if (Z.parentNode[K]._isOutsideThisEl(t), e) do if (e[K]) {
                    if (e[K]._onDragOver({
                        clientX: dt.clientX,
                        clientY: dt.clientY,
                        target: t,
                        rootEl: e
                    }) && !this.options.dragoverBubble) break;
                }
                while (e = g(t = e));
                Yt();
            }
        },
        _onTouchMove: function(t) {
            if (ut) {
                var e = this.options, n = e.fallbackTolerance, o = e.fallbackOffset, i = t.touches ? t.touches[0] : t, r = Q && b(Q, !0), a = Q && r && r.a, l = Q && r && r.d, e = At && wt && E(wt), a = (i.clientX - ut.clientX + o.x) / (a || 1) + (e ? e[0] - Tt[0] : 0) / (a || 1), l = (i.clientY - ut.clientY + o.y) / (l || 1) + (e ? e[1] - Tt[1] : 0) / (l || 1);
                if (!jt.active && !Dt) {
                    if (n && Math.max(Math.abs(i.clientX - this._lastX), Math.abs(i.clientY - this._lastY)) < n) return;
                    this._onDragStart(t, !0);
                }
                Q && (r ? (r.e += a - (ht || 0), r.f += l - (pt || 0)) : r = {
                    a: 1,
                    b: 0,
                    c: 0,
                    d: 1,
                    e: a,
                    f: l
                }, r = "matrix(".concat(r.a, ",").concat(r.b, ",").concat(r.c, ",").concat(r.d, ",").concat(r.e, ",").concat(r.f, ")"), R(Q, "webkitTransform", r), R(Q, "mozTransform", r), R(Q, "msTransform", r), R(Q, "transform", r), ht = a, pt = l, dt = i), t.cancelable && t.preventDefault();
            }
        },
        _appendGhost: function() {
            if (!Q) {
                var t = this.options.fallbackOnBody ? document.body : J, e = X(Z, !0, At, !0, t), n = this.options;
                if (At) {
                    for(wt = t; "static" === R(wt, "position") && "none" === R(wt, "transform") && wt !== document;)wt = wt.parentNode;
                    wt !== document.body && wt !== document.documentElement ? (wt === document && (wt = O()), e.top += wt.scrollTop, e.left += wt.scrollLeft) : wt = O(), Tt = E(wt);
                }
                k(Q = Z.cloneNode(!0), n.ghostClass, !1), k(Q, n.fallbackClass, !0), k(Q, n.dragClass, !0), R(Q, "transition", ""), R(Q, "transform", ""), R(Q, "box-sizing", "border-box"), R(Q, "margin", 0), R(Q, "top", e.top), R(Q, "left", e.left), R(Q, "width", e.width), R(Q, "height", e.height), R(Q, "opacity", "0.8"), R(Q, "position", At ? "absolute" : "fixed"), R(Q, "zIndex", "100000"), R(Q, "pointerEvents", "none"), jt.ghost = Q, t.appendChild(Q), R(Q, "transform-origin", ft / parseInt(Q.style.width) * 100 + "% " + gt / parseInt(Q.style.height) * 100 + "%");
            }
        },
        _onDragStart: function(t, e) {
            var n = this, o = t.dataTransfer, i = n.options;
            U("dragStart", this, {
                evt: t
            }), jt.eventCanceled ? this._onDrop() : (U("setupClone", this), jt.eventCanceled || ((nt = C(Z)).removeAttribute("id"), nt.draggable = !1, nt.style["will-change"] = "", this._hideClone(), k(nt, this.options.chosenClass, !1), jt.clone = nt), n.cloneId = Wt(function() {
                U("clone", n), jt.eventCanceled || (n.options.removeCloneOnHide || J.insertBefore(nt, Z), n._hideClone(), V({
                    sortable: n,
                    name: "clone"
                }));
            }), e || k(Z, i.dragClass, !0), e ? (Et = !0, n._loopId = setInterval(n._emulateDragOver, 50)) : (p(document, "mouseup", n._onDrop), p(document, "touchend", n._onDrop), p(document, "touchcancel", n._onDrop), o && (o.effectAllowed = "move", i.setData && i.setData.call(n, o, Z)), h(document, "drop", n), R(Z, "transform", "translateZ(0)")), Dt = !0, n._dragStartId = Wt(n._dragStarted.bind(n, e, t)), h(document, "selectstart", n), mt = !0, window.getSelection().removeAllRanges(), u && R(document.body, "user-select", "none"));
        },
        _onDragOver: function(n) {
            var o, i, r, t, e, a = this.el, l = n.target, s = this.options, c = s.group, u = jt.active, d = st === c, h = s.sort, p = ct || u, f = this, g = !1;
            if (!xt) {
                if (void 0 !== n.preventDefault && n.cancelable && n.preventDefault(), l = P(l, s.draggable, a, !0), O("dragOver"), jt.eventCanceled) return g;
                if (Z.contains(n.target) || l.animated && l.animatingX && l.animatingY || f._ignoreWhileAnimating === l) return A(!1);
                if (Et = !1, u && !s.disabled && (d ? h || (i = $ !== J) : ct === this || (this.lastPutMode = st.checkPull(this, u, Z, n)) && c.checkPut(this, u, Z, n))) {
                    if (r = "vertical" === this._getDirection(n, l), o = X(Z), O("dragOverValid"), jt.eventCanceled) return g;
                    if (i) return $ = J, M(), this._hideClone(), O("revert"), jt.eventCanceled || (tt ? J.insertBefore(Z, tt) : J.appendChild(Z)), A(!0);
                    var m = F(a, s.draggable);
                    if (m && (S = n, c = r, x = X(F((E = this).el, E.options.draggable)), E = L(E.el, E.options, Q), !(c ? S.clientX > E.right + 10 || S.clientY > x.bottom && S.clientX > x.left : S.clientY > E.bottom + 10 || S.clientX > x.right && S.clientY > x.top) || m.animated)) {
                        if (m && (t = n, e = r, C = X(B((_ = this).el, 0, _.options, !0)), _ = L(_.el, _.options, Q), e ? t.clientX < _.left - 10 || t.clientY < C.top && t.clientX < C.right : t.clientY < _.top - 10 || t.clientY < C.bottom && t.clientX < C.left)) {
                            var v = B(a, 0, s, !0);
                            if (v === Z) return A(!1);
                            if (D = X(l = v), !1 !== Ht(J, a, Z, o, l, D, n, !1)) return M(), a.insertBefore(Z, v), $ = a, N(), A(!0);
                        } else if (l.parentNode === a) {
                            var b, y, w, D = X(l), E = Z.parentNode !== a, S = (S = Z.animated && Z.toRect || o, x = l.animated && l.toRect || D, _ = (e = r) ? S.left : S.top, t = e ? S.right : S.bottom, C = e ? S.width : S.height, v = e ? x.left : x.top, S = e ? x.right : x.bottom, x = e ? x.width : x.height, !(_ === v || t === S || _ + C / 2 === v + x / 2)), _ = r ? "top" : "left", C = Y(l, "top", "top") || Y(Z, "top", "top"), v = C ? C.scrollTop : void 0;
                            if (vt !== l && (y = D[_], _t = !1, Ct = !S && s.invertSwap || E), 0 !== (b = function(t, e, n, o, i, r, a, l) {
                                var s = o ? t.clientY : t.clientX, c = o ? n.height : n.width, t = o ? n.top : n.left, o = o ? n.bottom : n.right, n = !1;
                                if (!a) {
                                    if (l && yt < c * i) {
                                        if (_t = !_t && (1 === bt ? t + c * r / 2 < s : s < o - c * r / 2) ? !0 : _t) n = !0;
                                        else if (1 === bt ? s < t + yt : o - yt < s) return -bt;
                                    } else if (t + c * (1 - i) / 2 < s && s < o - c * (1 - i) / 2) return function(t) {
                                        return j(Z) < j(t) ? 1 : -1;
                                    }(e);
                                }
                                if ((n = n || a) && (s < t + c * r / 2 || o - c * r / 2 < s)) return t + c / 2 < s ? 1 : -1;
                                return 0;
                            }(n, l, D, r, S ? 1 : s.swapThreshold, null == s.invertedSwapThreshold ? s.swapThreshold : s.invertedSwapThreshold, Ct, vt === l))) for(var T = j(Z); (w = $.children[T -= b]) && ("none" === R(w, "display") || w === Q););
                            if (0 === b || w === l) return A(!1);
                            bt = b;
                            var x = (vt = l).nextElementSibling, E = !1, S = Ht(J, a, Z, o, l, D, n, E = 1 === b);
                            if (!1 !== S) return 1 !== S && -1 !== S || (E = 1 === S), xt = !0, setTimeout(Kt, 30), M(), E && !x ? a.appendChild(Z) : l.parentNode.insertBefore(Z, E ? x : l), C && H(C, 0, v - C.scrollTop), $ = Z.parentNode, void 0 === y || Ct || (yt = Math.abs(y - X(l)[_])), N(), A(!0);
                        }
                    } else {
                        if (m === Z) return A(!1);
                        if ((l = m && a === n.target ? m : l) && (D = X(l)), !1 !== Ht(J, a, Z, o, l, D, n, !!l)) return M(), m && m.nextSibling ? a.insertBefore(Z, m.nextSibling) : a.appendChild(Z), $ = a, N(), A(!0);
                    }
                    if (a.contains(Z)) return A(!1);
                }
                return !1;
            }
            function O(t, e) {
                U(t, f, I({
                    evt: n,
                    isOwner: d,
                    axis: r ? "vertical" : "horizontal",
                    revert: i,
                    dragRect: o,
                    targetRect: D,
                    canSort: h,
                    fromSortable: p,
                    target: l,
                    completed: A,
                    onMove: function(t, e) {
                        return Ht(J, a, Z, o, t, X(t), n, e);
                    },
                    changed: N
                }, e));
            }
            function M() {
                O("dragOverAnimationCapture"), f.captureAnimationState(), f !== p && p.captureAnimationState();
            }
            function A(t) {
                return O("dragOverCompleted", {
                    insertion: t
                }), t && (d ? u._hideClone() : u._showClone(f), f !== p && (k(Z, (ct || u).options.ghostClass, !1), k(Z, s.ghostClass, !0)), ct !== f && f !== jt.active ? ct = f : f === jt.active && ct && (ct = null), p === f && (f._ignoreWhileAnimating = l), f.animateAll(function() {
                    O("dragOverAnimationComplete"), f._ignoreWhileAnimating = null;
                }), f !== p && (p.animateAll(), p._ignoreWhileAnimating = null)), (l === Z && !Z.animated || l === a && !l.animated) && (vt = null), s.dragoverBubble || n.rootEl || l === document || (Z.parentNode[K]._isOutsideThisEl(n.target), t || Bt(n)), !s.dragoverBubble && n.stopPropagation && n.stopPropagation(), g = !0;
            }
            function N() {
                rt = j(Z), lt = j(Z, s.draggable), V({
                    sortable: f,
                    name: "change",
                    toEl: a,
                    newIndex: rt,
                    newDraggableIndex: lt,
                    originalEvent: n
                });
            }
        },
        _ignoreWhileAnimating: null,
        _offMoveEvents: function() {
            p(document, "mousemove", this._onTouchMove), p(document, "touchmove", this._onTouchMove), p(document, "pointermove", this._onTouchMove), p(document, "dragover", Bt), p(document, "mousemove", Bt), p(document, "touchmove", Bt);
        },
        _offUpEvents: function() {
            var t = this.el.ownerDocument;
            p(t, "mouseup", this._onDrop), p(t, "touchend", this._onDrop), p(t, "pointerup", this._onDrop), p(t, "pointercancel", this._onDrop), p(t, "touchcancel", this._onDrop), p(document, "selectstart", this);
        },
        _onDrop: function(t) {
            var e = this.el, n = this.options;
            rt = j(Z), lt = j(Z, n.draggable), U("drop", this, {
                evt: t
            }), $ = Z && Z.parentNode, rt = j(Z), lt = j(Z, n.draggable), jt.eventCanceled || (_t = Ct = Dt = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), zt(this.cloneId), zt(this._dragStartId), this.nativeDraggable && (p(document, "drop", this), p(e, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), u && R(document.body, "user-select", ""), R(Z, "transform", ""), t && (mt && (t.cancelable && t.preventDefault(), n.dropBubble || t.stopPropagation()), Q && Q.parentNode && Q.parentNode.removeChild(Q), (J === $ || ct && "clone" !== ct.lastPutMode) && nt && nt.parentNode && nt.parentNode.removeChild(nt), Z && (this.nativeDraggable && p(Z, "dragend", this), Lt(Z), Z.style["will-change"] = "", mt && !Dt && k(Z, (ct || this).options.ghostClass, !1), k(Z, this.options.chosenClass, !1), V({
                sortable: this,
                name: "unchoose",
                toEl: $,
                newIndex: null,
                newDraggableIndex: null,
                originalEvent: t
            }), J !== $ ? (0 <= rt && (V({
                rootEl: $,
                name: "add",
                toEl: $,
                fromEl: J,
                originalEvent: t
            }), V({
                sortable: this,
                name: "remove",
                toEl: $,
                originalEvent: t
            }), V({
                rootEl: $,
                name: "sort",
                toEl: $,
                fromEl: J,
                originalEvent: t
            }), V({
                sortable: this,
                name: "sort",
                toEl: $,
                originalEvent: t
            })), ct && ct.save()) : rt !== it && 0 <= rt && (V({
                sortable: this,
                name: "update",
                toEl: $,
                originalEvent: t
            }), V({
                sortable: this,
                name: "sort",
                toEl: $,
                originalEvent: t
            })), jt.active && (null != rt && -1 !== rt || (rt = it, lt = at), V({
                sortable: this,
                name: "end",
                toEl: $,
                originalEvent: t
            }), this.save())))), this._nulling();
        },
        _nulling: function() {
            U("nulling", this), J = Z = $ = Q = tt = nt = et = ot = ut = dt = mt = rt = lt = it = at = vt = bt = ct = st = jt.dragged = jt.ghost = jt.clone = jt.active = null, Ot.forEach(function(t) {
                t.checked = !0;
            }), Ot.length = ht = pt = 0;
        },
        handleEvent: function(t) {
            switch(t.type){
                case "drop":
                case "dragend":
                    this._onDrop(t);
                    break;
                case "dragenter":
                case "dragover":
                    Z && (this._onDragOver(t), function(t) {
                        t.dataTransfer && (t.dataTransfer.dropEffect = "move");
                        t.cancelable && t.preventDefault();
                    }(t));
                    break;
                case "selectstart":
                    t.preventDefault();
            }
        },
        toArray: function() {
            for(var t, e = [], n = this.el.children, o = 0, i = n.length, r = this.options; o < i; o++)P(t = n[o], r.draggable, this.el, !1) && e.push(t.getAttribute(r.dataIdAttr) || function(t) {
                var e = t.tagName + t.className + t.src + t.href + t.textContent, n = e.length, o = 0;
                for(; n--;)o += e.charCodeAt(n);
                return o.toString(36);
            }(t));
            return e;
        },
        sort: function(t, e) {
            var n = {}, o = this.el;
            this.toArray().forEach(function(t, e) {
                e = o.children[e];
                P(e, this.options.draggable, o, !1) && (n[t] = e);
            }, this), e && this.captureAnimationState(), t.forEach(function(t) {
                n[t] && (o.removeChild(n[t]), o.appendChild(n[t]));
            }), e && this.animateAll();
        },
        save: function() {
            var t = this.options.store;
            t && t.set && t.set(this);
        },
        closest: function(t, e) {
            return P(t, e || this.options.draggable, this.el, !1);
        },
        option: function(t, e) {
            var n = this.options;
            if (void 0 === e) return n[t];
            var o = z.modifyOption(this, t, e);
            n[t] = void 0 !== o ? o : e, "group" === t && Rt(n);
        },
        destroy: function() {
            U("destroy", this);
            var t = this.el;
            t[K] = null, p(t, "mousedown", this._onTapStart), p(t, "touchstart", this._onTapStart), p(t, "pointerdown", this._onTapStart), this.nativeDraggable && (p(t, "dragover", this), p(t, "dragenter", this)), Array.prototype.forEach.call(t.querySelectorAll("[draggable]"), function(t) {
                t.removeAttribute("draggable");
            }), this._onDrop(), this._disableDelayedDragEvents(), St.splice(St.indexOf(this.el), 1), this.el = t = null;
        },
        _hideClone: function() {
            ot || (U("hideClone", this), jt.eventCanceled || (R(nt, "display", "none"), this.options.removeCloneOnHide && nt.parentNode && nt.parentNode.removeChild(nt), ot = !0));
        },
        _showClone: function(t) {
            "clone" === t.lastPutMode ? ot && (U("showClone", this), jt.eventCanceled || (Z.parentNode != J || this.options.group.revertClone ? tt ? J.insertBefore(nt, tt) : J.appendChild(nt) : J.insertBefore(nt, Z), this.options.group.revertClone && this.animate(Z, nt), R(nt, "display", ""), ot = !1)) : this._hideClone();
        }
    }, Mt && h(document, "touchmove", function(t) {
        (jt.active || Dt) && t.cancelable && t.preventDefault();
    }), jt.utils = {
        on: h,
        off: p,
        css: R,
        find: D,
        is: function(t, e) {
            return !!P(t, e, t, !1);
        },
        extend: function(t, e) {
            if (t && e) for(var n in e)e.hasOwnProperty(n) && (t[n] = e[n]);
            return t;
        },
        throttle: _,
        closest: P,
        toggleClass: k,
        clone: C,
        index: j,
        nextTick: Wt,
        cancelNextTick: zt,
        detectDirection: kt,
        getChild: B,
        expando: K
    }, jt.get = function(t) {
        return t[K];
    }, jt.mount = function() {
        for(var t = arguments.length, e = new Array(t), n = 0; n < t; n++)e[n] = arguments[n];
        (e = e[0].constructor === Array ? e[0] : e).forEach(function(t) {
            if (!t.prototype || !t.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not ".concat(({}).toString.call(t));
            t.utils && (jt.utils = I(I({}, jt.utils), t.utils)), z.mount(t);
        });
    }, jt.create = function(t, e) {
        return new jt(t, e);
    };
    var Gt, Ut, qt, Vt, Zt, $t, Qt = [], Jt = (jt.version = "1.15.6", false);
    function te() {
        Qt.forEach(function(t) {
            clearInterval(t.pid);
        }), Qt = [];
    }
    function ee() {
        clearInterval($t);
    }
    var ne, oe = _(function(n, t, e, o) {
        if (t.scroll) {
            var i, r = (n.touches ? n.touches[0] : n).clientX, a = (n.touches ? n.touches[0] : n).clientY, l = t.scrollSensitivity, s = t.scrollSpeed, c = O(), u = !1;
            Ut !== e && (Ut = e, te(), Gt = t.scroll, i = t.scrollFn, !0 === Gt && (Gt = M(e, !0)));
            var d = 0, h = Gt;
            do {
                var p = h, f = X(p), g = f.top, m = f.bottom, v = f.left, b = f.right, y = f.width, w = f.height, D = void 0, E = void 0, S = p.scrollWidth, _ = p.scrollHeight, C = R(p), T = p.scrollLeft, f = p.scrollTop, E = p === c ? (D = y < S && ("auto" === C.overflowX || "scroll" === C.overflowX || "visible" === C.overflowX), w < _ && ("auto" === C.overflowY || "scroll" === C.overflowY || "visible" === C.overflowY)) : (D = y < S && ("auto" === C.overflowX || "scroll" === C.overflowX), w < _ && ("auto" === C.overflowY || "scroll" === C.overflowY)), T = D && (Math.abs(b - r) <= l && T + y < S) - (Math.abs(v - r) <= l && !!T), f = E && (Math.abs(m - a) <= l && f + w < _) - (Math.abs(g - a) <= l && !!f);
                if (!Qt[d]) for(var x = 0; x <= d; x++)Qt[x] || (Qt[x] = {});
                Qt[d].vx == T && Qt[d].vy == f && Qt[d].el === p || (Qt[d].el = p, Qt[d].vx = T, Qt[d].vy = f, clearInterval(Qt[d].pid), 0 == T && 0 == f || (u = !0, Qt[d].pid = setInterval((function() {
                    o && 0 === this.layer && jt.active._onTouchMove(Zt);
                    var t = Qt[this.layer].vy ? Qt[this.layer].vy * s : 0, e = Qt[this.layer].vx ? Qt[this.layer].vx * s : 0;
                    "function" == typeof i && "continue" !== i.call(jt.dragged.parentNode[K], e, t, n, Zt, Qt[this.layer].el) || H(Qt[this.layer].el, e, t);
                }).bind({
                    layer: d
                }), 24))), d++;
            }while (t.bubbleScroll && h !== c && (h = M(h, !1)));
            Jt = u;
        }
    }, 30), n = function(t) {
        var e = t.originalEvent, n = t.putSortable, o = t.dragEl, i = t.activeSortable, r = t.dispatchSortableEvent, a = t.hideGhostForTarget, t = t.unhideGhostForTarget;
        e && (i = n || i, a(), e = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e, e = document.elementFromPoint(e.clientX, e.clientY), t(), i && !i.el.contains(e) && (r("spill"), this.onSpill({
            dragEl: o,
            putSortable: n
        })));
    };
    function ie() {}
    function re() {}
    ie.prototype = {
        startIndex: null,
        dragStart: function(t) {
            t = t.oldDraggableIndex;
            this.startIndex = t;
        },
        onSpill: function(t) {
            var e = t.dragEl, n = t.putSortable;
            this.sortable.captureAnimationState(), n && n.captureAnimationState();
            t = B(this.sortable.el, this.startIndex, this.options);
            t ? this.sortable.el.insertBefore(e, t) : this.sortable.el.appendChild(e), this.sortable.animateAll(), n && n.animateAll();
        },
        drop: n
    }, a(ie, {
        pluginName: "revertOnSpill"
    }), re.prototype = {
        onSpill: function(t) {
            var e = t.dragEl, t = t.putSortable || this.sortable;
            t.captureAnimationState(), e.parentNode && e.parentNode.removeChild(e), t.animateAll();
        },
        drop: n
    }, a(re, {
        pluginName: "removeOnSpill"
    });
    var ae, le, se, ce, ue, de = [], he = [], pe = !1, fe = !1, ge = !1;
    function me(n, o) {
        he.forEach(function(t, e) {
            e = o.children[t.sortableIndex + (n ? Number(e) : 0)];
            e ? o.insertBefore(t, e) : o.appendChild(t);
        });
    }
    function ve() {
        de.forEach(function(t) {
            t !== se && t.parentNode && t.parentNode.removeChild(t);
        });
    }
    return jt.mount(new function() {
        function t() {
            for(var t in this.defaults = {
                scroll: !0,
                forceAutoScrollFallback: !1,
                scrollSensitivity: 30,
                scrollSpeed: 10,
                bubbleScroll: !0
            }, this)"_" === t.charAt(0) && "function" == typeof this[t] && (this[t] = this[t].bind(this));
        }
        return t.prototype = {
            dragStarted: function(t) {
                t = t.originalEvent;
                this.sortable.nativeDraggable ? h(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? h(document, "pointermove", this._handleFallbackAutoScroll) : t.touches ? h(document, "touchmove", this._handleFallbackAutoScroll) : h(document, "mousemove", this._handleFallbackAutoScroll);
            },
            dragOverCompleted: function(t) {
                t = t.originalEvent;
                this.options.dragOverBubble || t.rootEl || this._handleAutoScroll(t);
            },
            drop: function() {
                this.sortable.nativeDraggable ? p(document, "dragover", this._handleAutoScroll) : (p(document, "pointermove", this._handleFallbackAutoScroll), p(document, "touchmove", this._handleFallbackAutoScroll), p(document, "mousemove", this._handleFallbackAutoScroll)), ee(), te(), clearTimeout(m), m = void 0;
            },
            nulling: function() {
                Zt = Ut = Gt = Jt = $t = qt = Vt = null, Qt.length = 0;
            },
            _handleFallbackAutoScroll: function(t) {
                this._handleAutoScroll(t, !0);
            },
            _handleAutoScroll: function(e, n) {
                var o, i = this, r = (e.touches ? e.touches[0] : e).clientX, a = (e.touches ? e.touches[0] : e).clientY, t = document.elementFromPoint(r, a);
                Zt = e, n || this.options.forceAutoScrollFallback || w || y || u ? (oe(e, this.options, t, n), o = M(t, !0), !Jt || $t && r === qt && a === Vt || ($t && ee(), $t = setInterval(function() {
                    var t = M(document.elementFromPoint(r, a), !0);
                    t !== o && (o = t, te()), oe(e, i.options, t, n);
                }, 10), qt = r, Vt = a)) : this.options.bubbleScroll && M(t, !0) !== O() ? oe(e, this.options, M(t, !1), !1) : te();
            }
        }, a(t, {
            pluginName: "scroll",
            initializeByDefault: !0
        });
    }), jt.mount(re, ie), jt.mount(new function() {
        function t() {
            this.defaults = {
                swapClass: "sortable-swap-highlight"
            };
        }
        return t.prototype = {
            dragStart: function(t) {
                t = t.dragEl;
                ne = t;
            },
            dragOverValid: function(t) {
                var e = t.completed, n = t.target, o = t.onMove, i = t.activeSortable, r = t.changed, a = t.cancel;
                i.options.swap && (t = this.sortable.el, i = this.options, n && n !== t && (t = ne, ne = !1 !== o(n) ? (k(n, i.swapClass, !0), n) : null, t && t !== ne && k(t, i.swapClass, !1)), r(), e(!0), a());
            },
            drop: function(t) {
                var e, n, o = t.activeSortable, i = t.putSortable, r = t.dragEl, a = i || this.sortable, l = this.options;
                ne && k(ne, l.swapClass, !1), ne && (l.swap || i && i.options.swap) && r !== ne && (a.captureAnimationState(), a !== o && o.captureAnimationState(), n = ne, t = (e = r).parentNode, l = n.parentNode, t && l && !t.isEqualNode(n) && !l.isEqualNode(e) && (i = j(e), r = j(n), t.isEqualNode(l) && i < r && r++, t.insertBefore(n, t.children[i]), l.insertBefore(e, l.children[r])), a.animateAll(), a !== o && o.animateAll());
            },
            nulling: function() {
                ne = null;
            }
        }, a(t, {
            pluginName: "swap",
            eventProperties: function() {
                return {
                    swapItem: ne
                };
            }
        });
    }), jt.mount(new function() {
        function t(o) {
            for(var t in this)"_" === t.charAt(0) && "function" == typeof this[t] && (this[t] = this[t].bind(this));
            o.options.avoidImplicitDeselect || (o.options.supportPointer ? h(document, "pointerup", this._deselectMultiDrag) : (h(document, "mouseup", this._deselectMultiDrag), h(document, "touchend", this._deselectMultiDrag))), h(document, "keydown", this._checkKeyDown), h(document, "keyup", this._checkKeyUp), this.defaults = {
                selectedClass: "sortable-selected",
                multiDragKey: null,
                avoidImplicitDeselect: !1,
                setData: function(t, e) {
                    var n = "";
                    de.length && le === o ? de.forEach(function(t, e) {
                        n += (e ? ", " : "") + t.textContent;
                    }) : n = e.textContent, t.setData("Text", n);
                }
            };
        }
        return t.prototype = {
            multiDragKeyDown: !1,
            isMultiDrag: !1,
            delayStartGlobal: function(t) {
                t = t.dragEl;
                se = t;
            },
            delayEnded: function() {
                this.isMultiDrag = ~de.indexOf(se);
            },
            setupClone: function(t) {
                var e = t.sortable, t = t.cancel;
                if (this.isMultiDrag) {
                    for(var n = 0; n < de.length; n++)he.push(C(de[n])), he[n].sortableIndex = de[n].sortableIndex, he[n].draggable = !1, he[n].style["will-change"] = "", k(he[n], this.options.selectedClass, !1), de[n] === se && k(he[n], this.options.chosenClass, !1);
                    e._hideClone(), t();
                }
            },
            clone: function(t) {
                var e = t.sortable, n = t.rootEl, o = t.dispatchSortableEvent, t = t.cancel;
                this.isMultiDrag && (this.options.removeCloneOnHide || de.length && le === e && (me(!0, n), o("clone"), t()));
            },
            showClone: function(t) {
                var e = t.cloneNowShown, n = t.rootEl, t = t.cancel;
                this.isMultiDrag && (me(!1, n), he.forEach(function(t) {
                    R(t, "display", "");
                }), e(), ue = !1, t());
            },
            hideClone: function(t) {
                var e = this, n = (t.sortable, t.cloneNowHidden), t = t.cancel;
                this.isMultiDrag && (he.forEach(function(t) {
                    R(t, "display", "none"), e.options.removeCloneOnHide && t.parentNode && t.parentNode.removeChild(t);
                }), n(), ue = !0, t());
            },
            dragStartGlobal: function(t) {
                t.sortable;
                !this.isMultiDrag && le && le.multiDrag._deselectMultiDrag(), de.forEach(function(t) {
                    t.sortableIndex = j(t);
                }), de = de.sort(function(t, e) {
                    return t.sortableIndex - e.sortableIndex;
                }), ge = !0;
            },
            dragStarted: function(t) {
                var e, n = this, t = t.sortable;
                this.isMultiDrag && (this.options.sort && (t.captureAnimationState(), this.options.animation && (de.forEach(function(t) {
                    t !== se && R(t, "position", "absolute");
                }), e = X(se, !1, !0, !0), de.forEach(function(t) {
                    t !== se && T(t, e);
                }), pe = fe = !0)), t.animateAll(function() {
                    pe = fe = !1, n.options.animation && de.forEach(function(t) {
                        x(t);
                    }), n.options.sort && ve();
                }));
            },
            dragOver: function(t) {
                var e = t.target, n = t.completed, t = t.cancel;
                fe && ~de.indexOf(e) && (n(!1), t());
            },
            revert: function(t) {
                var n, o, e = t.fromSortable, i = t.rootEl, r = t.sortable, a = t.dragRect;
                1 < de.length && (de.forEach(function(t) {
                    r.addAnimationState({
                        target: t,
                        rect: fe ? X(t) : a
                    }), x(t), t.fromRect = a, e.removeAnimationState(t);
                }), fe = !1, n = !this.options.removeCloneOnHide, o = i, de.forEach(function(t, e) {
                    e = o.children[t.sortableIndex + (n ? Number(e) : 0)];
                    e ? o.insertBefore(t, e) : o.appendChild(t);
                }));
            },
            dragOverCompleted: function(t) {
                var e, n = t.sortable, o = t.isOwner, i = t.insertion, r = t.activeSortable, a = t.parentEl, l = t.putSortable, t = this.options;
                i && (o && r._hideClone(), pe = !1, t.animation && 1 < de.length && (fe || !o && !r.options.sort && !l) && (e = X(se, !1, !0, !0), de.forEach(function(t) {
                    t !== se && (T(t, e), a.appendChild(t));
                }), fe = !0), o || (fe || ve(), 1 < de.length ? (o = ue, r._showClone(n), r.options.animation && !ue && o && he.forEach(function(t) {
                    r.addAnimationState({
                        target: t,
                        rect: ce
                    }), t.fromRect = ce, t.thisAnimationDuration = null;
                })) : r._showClone(n)));
            },
            dragOverAnimationCapture: function(t) {
                var e = t.dragRect, n = t.isOwner, t = t.activeSortable;
                de.forEach(function(t) {
                    t.thisAnimationDuration = null;
                }), t.options.animation && !n && t.multiDrag.isMultiDrag && (ce = a({}, e), e = b(se, !0), ce.top -= e.f, ce.left -= e.e);
            },
            dragOverAnimationComplete: function() {
                fe && (fe = !1, ve());
            },
            drop: function(t) {
                var o, i, r, a, n, e, l, s = t.originalEvent, c = t.rootEl, u = t.parentEl, d = t.sortable, h = t.dispatchSortableEvent, p = t.oldIndex, t = t.putSortable, f = t || this.sortable;
                s && (o = this.options, i = u.children, ge || (o.multiDragKey && !this.multiDragKeyDown && this._deselectMultiDrag(), k(se, o.selectedClass, !~de.indexOf(se)), ~de.indexOf(se) ? (de.splice(de.indexOf(se), 1), ae = null, G({
                    sortable: d,
                    rootEl: c,
                    name: "deselect",
                    targetEl: se,
                    originalEvent: s
                })) : (de.push(se), G({
                    sortable: d,
                    rootEl: c,
                    name: "select",
                    targetEl: se,
                    originalEvent: s
                }), s.shiftKey && ae && d.el.contains(ae) ? (r = j(ae), a = j(se), ~r && ~a && r !== a && function() {
                    for(var e, t = r < a ? (e = r, a) : (e = a, r + 1), n = o.filter; e < t; e++)~de.indexOf(i[e]) || P(i[e], o.draggable, u, !1) && (n && ("function" == typeof n ? n.call(d, s, i[e], d) : n.split(",").some(function(t) {
                        return P(i[e], t.trim(), u, !1);
                    })) || (k(i[e], o.selectedClass, !0), de.push(i[e]), G({
                        sortable: d,
                        rootEl: c,
                        name: "select",
                        targetEl: i[e],
                        originalEvent: s
                    })));
                }()) : ae = se, le = f)), ge && this.isMultiDrag && (fe = !1, (u[K].options.sort || u !== c) && 1 < de.length && (n = X(se), e = j(se, ":not(." + this.options.selectedClass + ")"), !pe && o.animation && (se.thisAnimationDuration = null), f.captureAnimationState(), pe || (o.animation && (se.fromRect = n, de.forEach(function(t) {
                    var e;
                    t.thisAnimationDuration = null, t !== se && (e = fe ? X(t) : n, t.fromRect = e, f.addAnimationState({
                        target: t,
                        rect: e
                    }));
                })), ve(), de.forEach(function(t) {
                    i[e] ? u.insertBefore(t, i[e]) : u.appendChild(t), e++;
                }), p === j(se) && (l = !1, de.forEach(function(t) {
                    t.sortableIndex !== j(t) && (l = !0);
                }), l && (h("update"), h("sort")))), de.forEach(function(t) {
                    x(t);
                }), f.animateAll()), le = f), (c === u || t && "clone" !== t.lastPutMode) && he.forEach(function(t) {
                    t.parentNode && t.parentNode.removeChild(t);
                }));
            },
            nullingGlobal: function() {
                this.isMultiDrag = ge = !1, he.length = 0;
            },
            destroyGlobal: function() {
                this._deselectMultiDrag(), p(document, "pointerup", this._deselectMultiDrag), p(document, "mouseup", this._deselectMultiDrag), p(document, "touchend", this._deselectMultiDrag), p(document, "keydown", this._checkKeyDown), p(document, "keyup", this._checkKeyUp);
            },
            _deselectMultiDrag: function(t) {
                if (!(void 0 !== ge && ge || le !== this.sortable || t && P(t.target, this.options.draggable, this.sortable.el, !1) || t && 0 !== t.button)) for(; de.length;){
                    var e = de[0];
                    k(e, this.options.selectedClass, !1), de.shift(), G({
                        sortable: this.sortable,
                        rootEl: this.sortable.el,
                        name: "deselect",
                        targetEl: e,
                        originalEvent: t
                    });
                }
            },
            _checkKeyDown: function(t) {
                t.key === this.options.multiDragKey && (this.multiDragKeyDown = !0);
            },
            _checkKeyUp: function(t) {
                t.key === this.options.multiDragKey && (this.multiDragKeyDown = !1);
            }
        }, a(t, {
            pluginName: "multiDrag",
            utils: {
                select: function(t) {
                    var e = t.parentNode[K];
                    e && e.options.multiDrag && !~de.indexOf(t) && (le && le !== e && (le.multiDrag._deselectMultiDrag(), le = e), k(t, e.options.selectedClass, !0), de.push(t));
                },
                deselect: function(t) {
                    var e = t.parentNode[K], n = de.indexOf(t);
                    e && e.options.multiDrag && ~n && (k(t, e.options.selectedClass, !1), de.splice(n, 1));
                }
            },
            eventProperties: function() {
                var n = this, o = [], i = [];
                return de.forEach(function(t) {
                    var e;
                    o.push({
                        multiDragElement: t,
                        index: t.sortableIndex
                    }), e = fe && t !== se ? -1 : fe ? j(t, ":not(." + n.options.selectedClass + ")") : j(t), i.push({
                        multiDragElement: t,
                        index: e
                    });
                }), {
                    items: r(de),
                    clones: [].concat(he),
                    oldIndicies: o,
                    newIndicies: i
                };
            },
            optionListeners: {
                multiDragKey: function(t) {
                    return "ctrl" === (t = t.toLowerCase()) ? t = "Control" : 1 < t.length && (t = t.charAt(0).toUpperCase() + t.substr(1)), t;
                }
            }
        });
    }), jt;
});



var $c881059c43e9596b$exports = {};
/*!
* sweetalert2 v11.24.0
* Released under the MIT License.
*/ !function(e, t) {
    $c881059c43e9596b$exports = t();
}($c881059c43e9596b$exports, function() {
    "use strict";
    function e(e, t, n) {
        if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
        throw new TypeError("Private element is not present on this object");
    }
    function t(t, n) {
        return t.get(e(t, n));
    }
    function n(e, t, n) {
        (function(e, t) {
            if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
        })(e, t), t.set(e, n);
    }
    const o = {}, i = (e)=>new Promise((t)=>{
            if (!e) return t();
            const n = window.scrollX, i = window.scrollY;
            o.restoreFocusTimeout = setTimeout(()=>{
                o.previousActiveElement instanceof HTMLElement ? (o.previousActiveElement.focus(), o.previousActiveElement = null) : document.body && document.body.focus(), t();
            }, 100), window.scrollTo(n, i);
        }), s = "swal2-", r = [
        "container",
        "shown",
        "height-auto",
        "iosfix",
        "popup",
        "modal",
        "no-backdrop",
        "no-transition",
        "toast",
        "toast-shown",
        "show",
        "hide",
        "close",
        "title",
        "html-container",
        "actions",
        "confirm",
        "deny",
        "cancel",
        "footer",
        "icon",
        "icon-content",
        "image",
        "input",
        "file",
        "range",
        "select",
        "radio",
        "checkbox",
        "label",
        "textarea",
        "inputerror",
        "input-label",
        "validation-message",
        "progress-steps",
        "active-progress-step",
        "progress-step",
        "progress-step-line",
        "loader",
        "loading",
        "styled",
        "top",
        "top-start",
        "top-end",
        "top-left",
        "top-right",
        "center",
        "center-start",
        "center-end",
        "center-left",
        "center-right",
        "bottom",
        "bottom-start",
        "bottom-end",
        "bottom-left",
        "bottom-right",
        "grow-row",
        "grow-column",
        "grow-fullscreen",
        "rtl",
        "timer-progress-bar",
        "timer-progress-bar-container",
        "scrollbar-measure",
        "icon-success",
        "icon-warning",
        "icon-info",
        "icon-question",
        "icon-error",
        "draggable",
        "dragging"
    ].reduce((e, t)=>(e[t] = s + t, e), {}), a = [
        "success",
        "warning",
        "info",
        "question",
        "error"
    ].reduce((e, t)=>(e[t] = s + t, e), {}), l = "SweetAlert2:", c = (e)=>e.charAt(0).toUpperCase() + e.slice(1), u = (e)=>{
        console.warn(`${l} ${"object" == typeof e ? e.join(" ") : e}`);
    }, d = (e)=>{
        console.error(`${l} ${e}`);
    }, p = [], m = (e, t = null)=>{
        var n;
        n = `"${e}" is deprecated and will be removed in the next major release.${t ? ` Use "${t}" instead.` : ""}`, p.includes(n) || (p.push(n), u(n));
    }, h = (e)=>"function" == typeof e ? e() : e, g = (e)=>e && "function" == typeof e.toPromise, f = (e)=>g(e) ? e.toPromise() : Promise.resolve(e), b = (e)=>e && Promise.resolve(e) === e, y = ()=>document.body.querySelector(`.${r.container}`), v = (e)=>{
        const t = y();
        return t ? t.querySelector(e) : null;
    }, w = (e)=>v(`.${e}`), C = ()=>w(r.popup), A = ()=>w(r.icon), E = ()=>w(r.title), k = ()=>w(r["html-container"]), B = ()=>w(r.image), $ = ()=>w(r["progress-steps"]), L = ()=>w(r["validation-message"]), P = ()=>v(`.${r.actions} .${r.confirm}`), x = ()=>v(`.${r.actions} .${r.cancel}`), T = ()=>v(`.${r.actions} .${r.deny}`), S = ()=>v(`.${r.loader}`), O = ()=>w(r.actions), M = ()=>w(r.footer), j = ()=>w(r["timer-progress-bar"]), H = ()=>w(r.close), I = ()=>{
        const e = C();
        if (!e) return [];
        const t = e.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'), n = Array.from(t).sort((e, t)=>{
            const n = parseInt(e.getAttribute("tabindex") || "0"), o = parseInt(t.getAttribute("tabindex") || "0");
            return n > o ? 1 : n < o ? -1 : 0;
        }), o = e.querySelectorAll('\n  a[href],\n  area[href],\n  input:not([disabled]),\n  select:not([disabled]),\n  textarea:not([disabled]),\n  button:not([disabled]),\n  iframe,\n  object,\n  embed,\n  [tabindex="0"],\n  [contenteditable],\n  audio[controls],\n  video[controls],\n  summary\n'), i = Array.from(o).filter((e)=>"-1" !== e.getAttribute("tabindex"));
        return [
            ...new Set(n.concat(i))
        ].filter((e)=>ee(e));
    }, D = ()=>N(document.body, r.shown) && !N(document.body, r["toast-shown"]) && !N(document.body, r["no-backdrop"]), V = ()=>{
        const e = C();
        return !!e && N(e, r.toast);
    }, q = (e, t)=>{
        if (e.textContent = "", t) {
            const n = (new DOMParser).parseFromString(t, "text/html"), o = n.querySelector("head");
            o && Array.from(o.childNodes).forEach((t)=>{
                e.appendChild(t);
            });
            const i = n.querySelector("body");
            i && Array.from(i.childNodes).forEach((t)=>{
                t instanceof HTMLVideoElement || t instanceof HTMLAudioElement ? e.appendChild(t.cloneNode(!0)) : e.appendChild(t);
            });
        }
    }, N = (e, t)=>{
        if (!t) return !1;
        const n = t.split(/\s+/);
        for(let t = 0; t < n.length; t++)if (!e.classList.contains(n[t])) return !1;
        return !0;
    }, _ = (e, t, n)=>{
        if (((e, t)=>{
            Array.from(e.classList).forEach((n)=>{
                Object.values(r).includes(n) || Object.values(a).includes(n) || Object.values(t.showClass || {}).includes(n) || e.classList.remove(n);
            });
        })(e, t), !t.customClass) return;
        const o = t.customClass[n];
        o && ("string" == typeof o || o.forEach ? z(e, o) : u(`Invalid type of customClass.${n}! Expected string or iterable object, got "${typeof o}"`));
    }, F = (e, t)=>{
        if (!t) return null;
        switch(t){
            case "select":
            case "textarea":
            case "file":
                return e.querySelector(`.${r.popup} > .${r[t]}`);
            case "checkbox":
                return e.querySelector(`.${r.popup} > .${r.checkbox} input`);
            case "radio":
                return e.querySelector(`.${r.popup} > .${r.radio} input:checked`) || e.querySelector(`.${r.popup} > .${r.radio} input:first-child`);
            case "range":
                return e.querySelector(`.${r.popup} > .${r.range} input`);
            default:
                return e.querySelector(`.${r.popup} > .${r.input}`);
        }
    }, R = (e)=>{
        if (e.focus(), "file" !== e.type) {
            const t = e.value;
            e.value = "", e.value = t;
        }
    }, U = (e, t, n)=>{
        e && t && ("string" == typeof t && (t = t.split(/\s+/).filter(Boolean)), t.forEach((t)=>{
            Array.isArray(e) ? e.forEach((e)=>{
                n ? e.classList.add(t) : e.classList.remove(t);
            }) : n ? e.classList.add(t) : e.classList.remove(t);
        }));
    }, z = (e, t)=>{
        U(e, t, !0);
    }, W = (e, t)=>{
        U(e, t, !1);
    }, K = (e, t)=>{
        const n = Array.from(e.children);
        for(let e = 0; e < n.length; e++){
            const o = n[e];
            if (o instanceof HTMLElement && N(o, t)) return o;
        }
    }, Y = (e, t, n)=>{
        n === `${parseInt(n)}` && (n = parseInt(n)), n || 0 === parseInt(n) ? e.style.setProperty(t, "number" == typeof n ? `${n}px` : n) : e.style.removeProperty(t);
    }, X = (e, t = "flex")=>{
        e && (e.style.display = t);
    }, Z = (e)=>{
        e && (e.style.display = "none");
    }, J = (e, t = "block")=>{
        e && new MutationObserver(()=>{
            Q(e, e.innerHTML, t);
        }).observe(e, {
            childList: !0,
            subtree: !0
        });
    }, G = (e, t, n, o)=>{
        const i = e.querySelector(t);
        i && i.style.setProperty(n, o);
    }, Q = (e, t, n = "flex")=>{
        t ? X(e, n) : Z(e);
    }, ee = (e)=>!(!e || !(e.offsetWidth || e.offsetHeight || e.getClientRects().length)), te = (e)=>!!(e.scrollHeight > e.clientHeight), ne = (e)=>{
        const t = window.getComputedStyle(e), n = parseFloat(t.getPropertyValue("animation-duration") || "0"), o = parseFloat(t.getPropertyValue("transition-duration") || "0");
        return n > 0 || o > 0;
    }, oe = (e, t = !1)=>{
        const n = j();
        n && ee(n) && (t && (n.style.transition = "none", n.style.width = "100%"), setTimeout(()=>{
            n.style.transition = `width ${e / 1e3}s linear`, n.style.width = "0%";
        }, 10));
    }, ie = `\n <div aria-labelledby="${r.title}" aria-describedby="${r["html-container"]}" class="${r.popup}" tabindex="-1">\n   <button type="button" class="${r.close}"></button>\n   <ul class="${r["progress-steps"]}"></ul>\n   <div class="${r.icon}"></div>\n   <img class="${r.image}" />\n   <h2 class="${r.title}" id="${r.title}"></h2>\n   <div class="${r["html-container"]}" id="${r["html-container"]}"></div>\n   <input class="${r.input}" id="${r.input}" />\n   <input type="file" class="${r.file}" />\n   <div class="${r.range}">\n     <input type="range" />\n     <output></output>\n   </div>\n   <select class="${r.select}" id="${r.select}"></select>\n   <div class="${r.radio}"></div>\n   <label class="${r.checkbox}">\n     <input type="checkbox" id="${r.checkbox}" />\n     <span class="${r.label}"></span>\n   </label>\n   <textarea class="${r.textarea}" id="${r.textarea}"></textarea>\n   <div class="${r["validation-message"]}" id="${r["validation-message"]}"></div>\n   <div class="${r.actions}">\n     <div class="${r.loader}"></div>\n     <button type="button" class="${r.confirm}"></button>\n     <button type="button" class="${r.deny}"></button>\n     <button type="button" class="${r.cancel}"></button>\n   </div>\n   <div class="${r.footer}"></div>\n   <div class="${r["timer-progress-bar-container"]}">\n     <div class="${r["timer-progress-bar"]}"></div>\n   </div>\n </div>\n`.replace(/(^|\n)\s*/g, ""), se = ()=>{
        o.currentInstance.resetValidationMessage();
    }, re = (e)=>{
        const t = (()=>{
            const e = y();
            return !!e && (e.remove(), W([
                document.documentElement,
                document.body
            ], [
                r["no-backdrop"],
                r["toast-shown"],
                r["has-column"]
            ]), !0);
        })();
        if ("undefined" == typeof window || "undefined" == typeof document) return void d("SweetAlert2 requires document to initialize");
        const n = document.createElement("div");
        n.className = r.container, t && z(n, r["no-transition"]), q(n, ie), n.dataset.swal2Theme = e.theme;
        const o = "string" == typeof (i = e.target) ? document.querySelector(i) : i;
        var i;
        o.appendChild(n), e.topLayer && (n.setAttribute("popover", ""), n.showPopover()), ((e)=>{
            const t = C();
            t.setAttribute("role", e.toast ? "alert" : "dialog"), t.setAttribute("aria-live", e.toast ? "polite" : "assertive"), e.toast || t.setAttribute("aria-modal", "true");
        })(e), ((e)=>{
            "rtl" === window.getComputedStyle(e).direction && z(y(), r.rtl);
        })(o), (()=>{
            const e = C(), t = K(e, r.input), n = K(e, r.file), o = e.querySelector(`.${r.range} input`), i = e.querySelector(`.${r.range} output`), s = K(e, r.select), a = e.querySelector(`.${r.checkbox} input`), l = K(e, r.textarea);
            t.oninput = se, n.onchange = se, s.onchange = se, a.onchange = se, l.oninput = se, o.oninput = ()=>{
                se(), i.value = o.value;
            }, o.onchange = ()=>{
                se(), i.value = o.value;
            };
        })();
    }, ae = (e, t)=>{
        e instanceof HTMLElement ? t.appendChild(e) : "object" == typeof e ? le(e, t) : e && q(t, e);
    }, le = (e, t)=>{
        e.jquery ? ce(t, e) : q(t, e.toString());
    }, ce = (e, t)=>{
        if (e.textContent = "", 0 in t) for(let n = 0; n in t; n++)e.appendChild(t[n].cloneNode(!0));
        else e.appendChild(t.cloneNode(!0));
    }, ue = (e, t)=>{
        const n = O(), o = S();
        n && o && (t.showConfirmButton || t.showDenyButton || t.showCancelButton ? X(n) : Z(n), _(n, t, "actions"), function(e, t, n) {
            const o = P(), i = T(), s = x();
            if (!o || !i || !s) return;
            pe(o, "confirm", n), pe(i, "deny", n), pe(s, "cancel", n), function(e, t, n, o) {
                if (!o.buttonsStyling) return void W([
                    e,
                    t,
                    n
                ], r.styled);
                z([
                    e,
                    t,
                    n
                ], r.styled), o.confirmButtonColor && e.style.setProperty("--swal2-confirm-button-background-color", o.confirmButtonColor);
                o.denyButtonColor && t.style.setProperty("--swal2-deny-button-background-color", o.denyButtonColor);
                o.cancelButtonColor && n.style.setProperty("--swal2-cancel-button-background-color", o.cancelButtonColor);
                de(e), de(t), de(n);
            }(o, i, s, n), n.reverseButtons && (n.toast ? (e.insertBefore(s, o), e.insertBefore(i, o)) : (e.insertBefore(s, t), e.insertBefore(i, t), e.insertBefore(o, t)));
        }(n, o, t), q(o, t.loaderHtml || ""), _(o, t, "loader"));
    };
    function de(e) {
        const t = window.getComputedStyle(e);
        if (t.getPropertyValue("--swal2-action-button-focus-box-shadow")) return;
        const n = t.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/, "rgba($1, $2, $3, 0.5)");
        e.style.setProperty("--swal2-action-button-focus-box-shadow", t.getPropertyValue("--swal2-outline").replace(/ rgba\(.*/, ` ${n}`));
    }
    function pe(e, t, n) {
        const o = c(t);
        Q(e, n[`show${o}Button`], "inline-block"), q(e, n[`${t}ButtonText`] || ""), e.setAttribute("aria-label", n[`${t}ButtonAriaLabel`] || ""), e.className = r[t], _(e, n, `${t}Button`);
    }
    const me = (e, t)=>{
        const n = y();
        n && (!function(e, t) {
            "string" == typeof t ? e.style.background = t : t || z([
                document.documentElement,
                document.body
            ], r["no-backdrop"]);
        }(n, t.backdrop), function(e, t) {
            if (!t) return;
            t in r ? z(e, r[t]) : (u('The "position" parameter is not valid, defaulting to "center"'), z(e, r.center));
        }(n, t.position), function(e, t) {
            if (!t) return;
            z(e, r[`grow-${t}`]);
        }(n, t.grow), _(n, t, "container"));
    };
    var he = {
        innerParams: new WeakMap,
        domCache: new WeakMap
    };
    const ge = [
        "input",
        "file",
        "range",
        "select",
        "radio",
        "checkbox",
        "textarea"
    ], fe = (e)=>{
        if (!e.input) return;
        if (!Ee[e.input]) return void d(`Unexpected type of input! Expected ${Object.keys(Ee).join(" | ")}, got "${e.input}"`);
        const t = Ce(e.input);
        if (!t) return;
        const n = Ee[e.input](t, e);
        X(t), e.inputAutoFocus && setTimeout(()=>{
            R(n);
        });
    }, be = (e, t)=>{
        const n = C();
        if (!n) return;
        const o = F(n, e);
        if (o) {
            ((e)=>{
                for(let t = 0; t < e.attributes.length; t++){
                    const n = e.attributes[t].name;
                    [
                        "id",
                        "type",
                        "value",
                        "style"
                    ].includes(n) || e.removeAttribute(n);
                }
            })(o);
            for(const e in t)o.setAttribute(e, t[e]);
        }
    }, ye = (e)=>{
        if (!e.input) return;
        const t = Ce(e.input);
        t && _(t, e, "input");
    }, ve = (e, t)=>{
        !e.placeholder && t.inputPlaceholder && (e.placeholder = t.inputPlaceholder);
    }, we = (e, t, n)=>{
        if (n.inputLabel) {
            const o = document.createElement("label"), i = r["input-label"];
            o.setAttribute("for", e.id), o.className = i, "object" == typeof n.customClass && z(o, n.customClass.inputLabel), o.innerText = n.inputLabel, t.insertAdjacentElement("beforebegin", o);
        }
    }, Ce = (e)=>{
        const t = C();
        if (t) return K(t, r[e] || r.input);
    }, Ae = (e, t)=>{
        [
            "string",
            "number"
        ].includes(typeof t) ? e.value = `${t}` : b(t) || u(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof t}"`);
    }, Ee = {};
    Ee.text = Ee.email = Ee.password = Ee.number = Ee.tel = Ee.url = Ee.search = Ee.date = Ee["datetime-local"] = Ee.time = Ee.week = Ee.month = (e, t)=>(Ae(e, t.inputValue), we(e, e, t), ve(e, t), e.type = t.input, e), Ee.file = (e, t)=>(we(e, e, t), ve(e, t), e), Ee.range = (e, t)=>{
        const n = e.querySelector("input"), o = e.querySelector("output");
        return Ae(n, t.inputValue), n.type = t.input, Ae(o, t.inputValue), we(n, e, t), e;
    }, Ee.select = (e, t)=>{
        if (e.textContent = "", t.inputPlaceholder) {
            const n = document.createElement("option");
            q(n, t.inputPlaceholder), n.value = "", n.disabled = !0, n.selected = !0, e.appendChild(n);
        }
        return we(e, e, t), e;
    }, Ee.radio = (e)=>(e.textContent = "", e), Ee.checkbox = (e, t)=>{
        const n = F(C(), "checkbox");
        n.value = "1", n.checked = Boolean(t.inputValue);
        const o = e.querySelector("span");
        return q(o, t.inputPlaceholder || t.inputLabel), n;
    }, Ee.textarea = (e, t)=>{
        Ae(e, t.inputValue), ve(e, t), we(e, e, t);
        return setTimeout(()=>{
            if ("MutationObserver" in window) {
                const n = parseInt(window.getComputedStyle(C()).width);
                new MutationObserver(()=>{
                    if (!document.body.contains(e)) return;
                    const o = e.offsetWidth + (i = e, parseInt(window.getComputedStyle(i).marginLeft) + parseInt(window.getComputedStyle(i).marginRight));
                    var i;
                    o > n ? C().style.width = `${o}px` : Y(C(), "width", t.width);
                }).observe(e, {
                    attributes: !0,
                    attributeFilter: [
                        "style"
                    ]
                });
            }
        }), e;
    };
    const ke = (e, t)=>{
        const n = k();
        n && (J(n), _(n, t, "htmlContainer"), t.html ? (ae(t.html, n), X(n, "block")) : t.text ? (n.textContent = t.text, X(n, "block")) : Z(n), ((e, t)=>{
            const n = C();
            if (!n) return;
            const o = he.innerParams.get(e), i = !o || t.input !== o.input;
            ge.forEach((e)=>{
                const o = K(n, r[e]);
                o && (be(e, t.inputAttributes), o.className = r[e], i && Z(o));
            }), t.input && (i && fe(t), ye(t));
        })(e, t));
    }, Be = (e, t)=>{
        for (const [n, o] of Object.entries(a))t.icon !== n && W(e, o);
        z(e, t.icon && a[t.icon]), Pe(e, t), $e(), _(e, t, "icon");
    }, $e = ()=>{
        const e = C();
        if (!e) return;
        const t = window.getComputedStyle(e).getPropertyValue("background-color"), n = e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix");
        for(let e = 0; e < n.length; e++)n[e].style.backgroundColor = t;
    }, Le = (e, t)=>{
        if (!t.icon && !t.iconHtml) return;
        let n = e.innerHTML, o = "";
        if (t.iconHtml) o = xe(t.iconHtml);
        else if ("success" === t.icon) o = ((e)=>`\n  ${e.animation ? '<div class="swal2-success-circular-line-left"></div>' : ""}\n  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>\n  <div class="swal2-success-ring"></div>\n  ${e.animation ? '<div class="swal2-success-fix"></div>' : ""}\n  ${e.animation ? '<div class="swal2-success-circular-line-right"></div>' : ""}\n`)(t), n = n.replace(/ style=".*?"/g, "");
        else if ("error" === t.icon) o = '\n  <span class="swal2-x-mark">\n    <span class="swal2-x-mark-line-left"></span>\n    <span class="swal2-x-mark-line-right"></span>\n  </span>\n';
        else if (t.icon) o = xe({
            question: "?",
            warning: "!",
            info: "i"
        }[t.icon]);
        n.trim() !== o.trim() && q(e, o);
    }, Pe = (e, t)=>{
        if (t.iconColor) {
            e.style.color = t.iconColor, e.style.borderColor = t.iconColor;
            for (const n of [
                ".swal2-success-line-tip",
                ".swal2-success-line-long",
                ".swal2-x-mark-line-left",
                ".swal2-x-mark-line-right"
            ])G(e, n, "background-color", t.iconColor);
            G(e, ".swal2-success-ring", "border-color", t.iconColor);
        }
    }, xe = (e)=>`<div class="${r["icon-content"]}">${e}</div>`;
    let Te = !1, Se = 0, Oe = 0, Me = 0, je = 0;
    const He = (e)=>{
        const t = C();
        if (e.target === t || A().contains(e.target)) {
            Te = !0;
            const n = Ve(e);
            Se = n.clientX, Oe = n.clientY, Me = parseInt(t.style.insetInlineStart) || 0, je = parseInt(t.style.insetBlockStart) || 0, z(t, "swal2-dragging");
        }
    }, Ie = (e)=>{
        const t = C();
        if (Te) {
            let { clientX: n, clientY: o } = Ve(e);
            t.style.insetInlineStart = `${Me + (n - Se)}px`, t.style.insetBlockStart = `${je + (o - Oe)}px`;
        }
    }, De = ()=>{
        const e = C();
        Te = !1, W(e, "swal2-dragging");
    }, Ve = (e)=>{
        let t = 0, n = 0;
        return e.type.startsWith("mouse") ? (t = e.clientX, n = e.clientY) : e.type.startsWith("touch") && (t = e.touches[0].clientX, n = e.touches[0].clientY), {
            clientX: t,
            clientY: n
        };
    }, qe = (e, t)=>{
        const n = y(), o = C();
        if (n && o) {
            if (t.toast) {
                Y(n, "width", t.width), o.style.width = "100%";
                const e = S();
                e && o.insertBefore(e, A());
            } else Y(o, "width", t.width);
            Y(o, "padding", t.padding), t.color && (o.style.color = t.color), t.background && (o.style.background = t.background), Z(L()), Ne(o, t), t.draggable && !t.toast ? (z(o, r.draggable), ((e)=>{
                e.addEventListener("mousedown", He), document.body.addEventListener("mousemove", Ie), e.addEventListener("mouseup", De), e.addEventListener("touchstart", He), document.body.addEventListener("touchmove", Ie), e.addEventListener("touchend", De);
            })(o)) : (W(o, r.draggable), ((e)=>{
                e.removeEventListener("mousedown", He), document.body.removeEventListener("mousemove", Ie), e.removeEventListener("mouseup", De), e.removeEventListener("touchstart", He), document.body.removeEventListener("touchmove", Ie), e.removeEventListener("touchend", De);
            })(o));
        }
    }, Ne = (e, t)=>{
        const n = t.showClass || {};
        e.className = `${r.popup} ${ee(e) ? n.popup : ""}`, t.toast ? (z([
            document.documentElement,
            document.body
        ], r["toast-shown"]), z(e, r.toast)) : z(e, r.modal), _(e, t, "popup"), "string" == typeof t.customClass && z(e, t.customClass), t.icon && z(e, r[`icon-${t.icon}`]);
    }, _e = (e)=>{
        const t = document.createElement("li");
        return z(t, r["progress-step"]), q(t, e), t;
    }, Fe = (e)=>{
        const t = document.createElement("li");
        return z(t, r["progress-step-line"]), e.progressStepsDistance && Y(t, "width", e.progressStepsDistance), t;
    }, Re = (e, t)=>{
        qe(0, t), me(0, t), ((e, t)=>{
            const n = $();
            if (!n) return;
            const { progressSteps: o, currentProgressStep: i } = t;
            o && 0 !== o.length && void 0 !== i ? (X(n), n.textContent = "", i >= o.length && u("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"), o.forEach((e, s)=>{
                const a = _e(e);
                if (n.appendChild(a), s === i && z(a, r["active-progress-step"]), s !== o.length - 1) {
                    const e = Fe(t);
                    n.appendChild(e);
                }
            })) : Z(n);
        })(0, t), ((e, t)=>{
            const n = he.innerParams.get(e), o = A();
            if (!o) return;
            if (n && t.icon === n.icon) return Le(o, t), void Be(o, t);
            if (!t.icon && !t.iconHtml) return void Z(o);
            if (t.icon && -1 === Object.keys(a).indexOf(t.icon)) return d(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${t.icon}"`), void Z(o);
            X(o), Le(o, t), Be(o, t), z(o, t.showClass && t.showClass.icon), window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", $e);
        })(e, t), ((e, t)=>{
            const n = B();
            n && (t.imageUrl ? (X(n, ""), n.setAttribute("src", t.imageUrl), n.setAttribute("alt", t.imageAlt || ""), Y(n, "width", t.imageWidth), Y(n, "height", t.imageHeight), n.className = r.image, _(n, t, "image")) : Z(n));
        })(0, t), ((e, t)=>{
            const n = E();
            n && (J(n), Q(n, t.title || t.titleText, "block"), t.title && ae(t.title, n), t.titleText && (n.innerText = t.titleText), _(n, t, "title"));
        })(0, t), ((e, t)=>{
            const n = H();
            n && (q(n, t.closeButtonHtml || ""), _(n, t, "closeButton"), Q(n, t.showCloseButton), n.setAttribute("aria-label", t.closeButtonAriaLabel || ""));
        })(0, t), ke(e, t), ue(0, t), ((e, t)=>{
            const n = M();
            n && (J(n), Q(n, t.footer, "block"), t.footer && ae(t.footer, n), _(n, t, "footer"));
        })(0, t);
        const n = C();
        "function" == typeof t.didRender && n && t.didRender(n), o.eventEmitter.emit("didRender", n);
    }, Ue = ()=>{
        var e;
        return null === (e = P()) || void 0 === e ? void 0 : e.click();
    }, ze = Object.freeze({
        cancel: "cancel",
        backdrop: "backdrop",
        close: "close",
        esc: "esc",
        timer: "timer"
    }), We = (e)=>{
        e.keydownTarget && e.keydownHandlerAdded && (e.keydownTarget.removeEventListener("keydown", e.keydownHandler, {
            capture: e.keydownListenerCapture
        }), e.keydownHandlerAdded = !1);
    }, Ke = (e, t)=>{
        var n;
        const o = I();
        if (o.length) return -2 === (e += t) && (e = o.length - 1), e === o.length ? e = 0 : -1 === e && (e = o.length - 1), void o[e].focus();
        null === (n = C()) || void 0 === n || n.focus();
    }, Ye = [
        "ArrowRight",
        "ArrowDown"
    ], Xe = [
        "ArrowLeft",
        "ArrowUp"
    ], Ze = (e, t, n)=>{
        e && (t.isComposing || 229 === t.keyCode || (e.stopKeydownPropagation && t.stopPropagation(), "Enter" === t.key ? Je(t, e) : "Tab" === t.key ? Ge(t) : [
            ...Ye,
            ...Xe
        ].includes(t.key) ? Qe(t.key) : "Escape" === t.key && et(t, e, n)));
    }, Je = (e, t)=>{
        if (!h(t.allowEnterKey)) return;
        const n = F(C(), t.input);
        if (e.target && n && e.target instanceof HTMLElement && e.target.outerHTML === n.outerHTML) {
            if ([
                "textarea",
                "file"
            ].includes(t.input)) return;
            Ue(), e.preventDefault();
        }
    }, Ge = (e)=>{
        const t = e.target, n = I();
        let o = -1;
        for(let e = 0; e < n.length; e++)if (t === n[e]) {
            o = e;
            break;
        }
        e.shiftKey ? Ke(o, -1) : Ke(o, 1), e.stopPropagation(), e.preventDefault();
    }, Qe = (e)=>{
        const t = O(), n = P(), o = T(), i = x();
        if (!(t && n && o && i)) return;
        const s = [
            n,
            o,
            i
        ];
        if (document.activeElement instanceof HTMLElement && !s.includes(document.activeElement)) return;
        const r = Ye.includes(e) ? "nextElementSibling" : "previousElementSibling";
        let a = document.activeElement;
        if (a) {
            for(let e = 0; e < t.children.length; e++){
                if (a = a[r], !a) return;
                if (a instanceof HTMLButtonElement && ee(a)) break;
            }
            a instanceof HTMLButtonElement && a.focus();
        }
    }, et = (e, t, n)=>{
        e.preventDefault(), h(t.allowEscapeKey) && n(ze.esc);
    };
    var tt = {
        swalPromiseResolve: new WeakMap,
        swalPromiseReject: new WeakMap
    };
    const nt = ()=>{
        Array.from(document.body.children).forEach((e)=>{
            e.hasAttribute("data-previous-aria-hidden") ? (e.setAttribute("aria-hidden", e.getAttribute("data-previous-aria-hidden") || ""), e.removeAttribute("data-previous-aria-hidden")) : e.removeAttribute("aria-hidden");
        });
    }, ot = "undefined" != typeof window && !!window.GestureEvent, it = ()=>{
        const e = y();
        if (!e) return;
        let t;
        e.ontouchstart = (e)=>{
            t = st(e);
        }, e.ontouchmove = (e)=>{
            t && (e.preventDefault(), e.stopPropagation());
        };
    }, st = (e)=>{
        const t = e.target, n = y(), o = k();
        return !(!n || !o) && !rt(e) && !at(e) && (t === n || !(te(n) || !(t instanceof HTMLElement) || ((e, t)=>{
            let n = e;
            for(; n && n !== t;){
                if (te(n)) return !0;
                n = n.parentElement;
            }
            return !1;
        })(t, o) || "INPUT" === t.tagName || "TEXTAREA" === t.tagName || te(o) && o.contains(t)));
    }, rt = (e)=>e.touches && e.touches.length && "stylus" === e.touches[0].touchType, at = (e)=>e.touches && e.touches.length > 1;
    let lt = null;
    const ct = (e)=>{
        null === lt && (document.body.scrollHeight > window.innerHeight || "scroll" === e) && (lt = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")), document.body.style.paddingRight = `${lt + (()=>{
            const e = document.createElement("div");
            e.className = r["scrollbar-measure"], document.body.appendChild(e);
            const t = e.getBoundingClientRect().width - e.clientWidth;
            return document.body.removeChild(e), t;
        })()}px`);
    };
    function ut(e, t, n, s) {
        V() ? yt(e, s) : (i(n).then(()=>yt(e, s)), We(o)), ot ? (t.setAttribute("style", "display:none !important"), t.removeAttribute("class"), t.innerHTML = "") : t.remove(), D() && (null !== lt && (document.body.style.paddingRight = `${lt}px`, lt = null), (()=>{
            if (N(document.body, r.iosfix)) {
                const e = parseInt(document.body.style.top, 10);
                W(document.body, r.iosfix), document.body.style.top = "", document.body.scrollTop = -1 * e;
            }
        })(), nt()), W([
            document.documentElement,
            document.body
        ], [
            r.shown,
            r["height-auto"],
            r["no-backdrop"],
            r["toast-shown"]
        ]);
    }
    function dt(e) {
        e = gt(e);
        const t = tt.swalPromiseResolve.get(this), n = pt(this);
        this.isAwaitingPromise ? e.isDismissed || (ht(this), t(e)) : n && t(e);
    }
    const pt = (e)=>{
        const t = C();
        if (!t) return !1;
        const n = he.innerParams.get(e);
        if (!n || N(t, n.hideClass.popup)) return !1;
        W(t, n.showClass.popup), z(t, n.hideClass.popup);
        const o = y();
        return W(o, n.showClass.backdrop), z(o, n.hideClass.backdrop), ft(e, t, n), !0;
    };
    function mt(e) {
        const t = tt.swalPromiseReject.get(this);
        ht(this), t && t(e);
    }
    const ht = (e)=>{
        e.isAwaitingPromise && (delete e.isAwaitingPromise, he.innerParams.get(e) || e._destroy());
    }, gt = (e)=>void 0 === e ? {
            isConfirmed: !1,
            isDenied: !1,
            isDismissed: !0
        } : Object.assign({
            isConfirmed: !1,
            isDenied: !1,
            isDismissed: !1
        }, e), ft = (e, t, n)=>{
        var i;
        const s = y(), r = ne(t);
        "function" == typeof n.willClose && n.willClose(t), null === (i = o.eventEmitter) || void 0 === i || i.emit("willClose", t), r ? bt(e, t, s, n.returnFocus, n.didClose) : ut(e, s, n.returnFocus, n.didClose);
    }, bt = (e, t, n, i, s)=>{
        o.swalCloseEventFinishedCallback = ut.bind(null, e, n, i, s);
        const r = function(e) {
            var n;
            e.target === t && (null === (n = o.swalCloseEventFinishedCallback) || void 0 === n || n.call(o), delete o.swalCloseEventFinishedCallback, t.removeEventListener("animationend", r), t.removeEventListener("transitionend", r));
        };
        t.addEventListener("animationend", r), t.addEventListener("transitionend", r);
    }, yt = (e, t)=>{
        setTimeout(()=>{
            var n;
            "function" == typeof t && t.bind(e.params)(), null === (n = o.eventEmitter) || void 0 === n || n.emit("didClose"), e._destroy && e._destroy();
        });
    }, vt = (e)=>{
        let t = C();
        if (t || new Qn, t = C(), !t) return;
        const n = S();
        V() ? Z(A()) : wt(t, e), X(n), t.setAttribute("data-loading", "true"), t.setAttribute("aria-busy", "true"), t.focus();
    }, wt = (e, t)=>{
        const n = O(), o = S();
        n && o && (!t && ee(P()) && (t = P()), X(n), t && (Z(t), o.setAttribute("data-button-to-replace", t.className), n.insertBefore(o, t)), z([
            e,
            n
        ], r.loading));
    }, Ct = (e)=>e.checked ? 1 : 0, At = (e)=>e.checked ? e.value : null, Et = (e)=>e.files && e.files.length ? null !== e.getAttribute("multiple") ? e.files : e.files[0] : null, kt = (e, t)=>{
        const n = C();
        if (!n) return;
        const o = (e)=>{
            "select" === t.input ? function(e, t, n) {
                const o = K(e, r.select);
                if (!o) return;
                const i = (e, t, o)=>{
                    const i = document.createElement("option");
                    i.value = o, q(i, t), i.selected = Lt(o, n.inputValue), e.appendChild(i);
                };
                t.forEach((e)=>{
                    const t = e[0], n = e[1];
                    if (Array.isArray(n)) {
                        const e = document.createElement("optgroup");
                        e.label = t, e.disabled = !1, o.appendChild(e), n.forEach((t)=>i(e, t[1], t[0]));
                    } else i(o, n, t);
                }), o.focus();
            }(n, $t(e), t) : "radio" === t.input && function(e, t, n) {
                const o = K(e, r.radio);
                if (!o) return;
                t.forEach((e)=>{
                    const t = e[0], i = e[1], s = document.createElement("input"), a = document.createElement("label");
                    s.type = "radio", s.name = r.radio, s.value = t, Lt(t, n.inputValue) && (s.checked = !0);
                    const l = document.createElement("span");
                    q(l, i), l.className = r.label, a.appendChild(s), a.appendChild(l), o.appendChild(a);
                });
                const i = o.querySelectorAll("input");
                i.length && i[0].focus();
            }(n, $t(e), t);
        };
        g(t.inputOptions) || b(t.inputOptions) ? (vt(P()), f(t.inputOptions).then((t)=>{
            e.hideLoading(), o(t);
        })) : "object" == typeof t.inputOptions ? o(t.inputOptions) : d("Unexpected type of inputOptions! Expected object, Map or Promise, got " + typeof t.inputOptions);
    }, Bt = (e, t)=>{
        const n = e.getInput();
        n && (Z(n), f(t.inputValue).then((o)=>{
            n.value = "number" === t.input ? `${parseFloat(o) || 0}` : `${o}`, X(n), n.focus(), e.hideLoading();
        }).catch((t)=>{
            d(`Error in inputValue promise: ${t}`), n.value = "", X(n), n.focus(), e.hideLoading();
        }));
    };
    const $t = (e)=>{
        const t = [];
        return e instanceof Map ? e.forEach((e, n)=>{
            let o = e;
            "object" == typeof o && (o = $t(o)), t.push([
                n,
                o
            ]);
        }) : Object.keys(e).forEach((n)=>{
            let o = e[n];
            "object" == typeof o && (o = $t(o)), t.push([
                n,
                o
            ]);
        }), t;
    }, Lt = (e, t)=>!!t && t.toString() === e.toString(), Pt = (e, t)=>{
        const n = he.innerParams.get(e);
        if (!n.input) return void d(`The "input" parameter is needed to be set when using returnInputValueOn${c(t)}`);
        const o = e.getInput(), i = ((e, t)=>{
            const n = e.getInput();
            if (!n) return null;
            switch(t.input){
                case "checkbox":
                    return Ct(n);
                case "radio":
                    return At(n);
                case "file":
                    return Et(n);
                default:
                    return t.inputAutoTrim ? n.value.trim() : n.value;
            }
        })(e, n);
        n.inputValidator ? xt(e, i, t) : o && !o.checkValidity() ? (e.enableButtons(), e.showValidationMessage(n.validationMessage || o.validationMessage)) : "deny" === t ? Tt(e, i) : Mt(e, i);
    }, xt = (e, t, n)=>{
        const o = he.innerParams.get(e);
        e.disableInput();
        Promise.resolve().then(()=>f(o.inputValidator(t, o.validationMessage))).then((o)=>{
            e.enableButtons(), e.enableInput(), o ? e.showValidationMessage(o) : "deny" === n ? Tt(e, t) : Mt(e, t);
        });
    }, Tt = (e, t)=>{
        const n = he.innerParams.get(e || void 0);
        if (n.showLoaderOnDeny && vt(T()), n.preDeny) {
            e.isAwaitingPromise = !0;
            Promise.resolve().then(()=>f(n.preDeny(t, n.validationMessage))).then((n)=>{
                !1 === n ? (e.hideLoading(), ht(e)) : e.close({
                    isDenied: !0,
                    value: void 0 === n ? t : n
                });
            }).catch((t)=>Ot(e || void 0, t));
        } else e.close({
            isDenied: !0,
            value: t
        });
    }, St = (e, t)=>{
        e.close({
            isConfirmed: !0,
            value: t
        });
    }, Ot = (e, t)=>{
        e.rejectPromise(t);
    }, Mt = (e, t)=>{
        const n = he.innerParams.get(e || void 0);
        if (n.showLoaderOnConfirm && vt(), n.preConfirm) {
            e.resetValidationMessage(), e.isAwaitingPromise = !0;
            Promise.resolve().then(()=>f(n.preConfirm(t, n.validationMessage))).then((n)=>{
                ee(L()) || !1 === n ? (e.hideLoading(), ht(e)) : St(e, void 0 === n ? t : n);
            }).catch((t)=>Ot(e || void 0, t));
        } else St(e, t);
    };
    function jt() {
        const e = he.innerParams.get(this);
        if (!e) return;
        const t = he.domCache.get(this);
        Z(t.loader), V() ? e.icon && X(A()) : Ht(t), W([
            t.popup,
            t.actions
        ], r.loading), t.popup.removeAttribute("aria-busy"), t.popup.removeAttribute("data-loading"), t.confirmButton.disabled = !1, t.denyButton.disabled = !1, t.cancelButton.disabled = !1;
    }
    const Ht = (e)=>{
        const t = e.popup.getElementsByClassName(e.loader.getAttribute("data-button-to-replace"));
        t.length ? X(t[0], "inline-block") : ee(P()) || ee(T()) || ee(x()) || Z(e.actions);
    };
    function It() {
        const e = he.innerParams.get(this), t = he.domCache.get(this);
        return t ? F(t.popup, e.input) : null;
    }
    function Dt(e, t, n) {
        const o = he.domCache.get(e);
        t.forEach((e)=>{
            o[e].disabled = n;
        });
    }
    function Vt(e, t) {
        const n = C();
        if (n && e) {
            if ("radio" === e.type) {
                const e = n.querySelectorAll(`[name="${r.radio}"]`);
                for(let n = 0; n < e.length; n++)e[n].disabled = t;
            } else e.disabled = t;
        }
    }
    function qt() {
        Dt(this, [
            "confirmButton",
            "denyButton",
            "cancelButton"
        ], !1);
    }
    function Nt() {
        Dt(this, [
            "confirmButton",
            "denyButton",
            "cancelButton"
        ], !0);
    }
    function _t() {
        Vt(this.getInput(), !1);
    }
    function Ft() {
        Vt(this.getInput(), !0);
    }
    function Rt(e) {
        const t = he.domCache.get(this), n = he.innerParams.get(this);
        q(t.validationMessage, e), t.validationMessage.className = r["validation-message"], n.customClass && n.customClass.validationMessage && z(t.validationMessage, n.customClass.validationMessage), X(t.validationMessage);
        const o = this.getInput();
        o && (o.setAttribute("aria-invalid", "true"), o.setAttribute("aria-describedby", r["validation-message"]), R(o), z(o, r.inputerror));
    }
    function Ut() {
        const e = he.domCache.get(this);
        e.validationMessage && Z(e.validationMessage);
        const t = this.getInput();
        t && (t.removeAttribute("aria-invalid"), t.removeAttribute("aria-describedby"), W(t, r.inputerror));
    }
    const zt = {
        title: "",
        titleText: "",
        text: "",
        html: "",
        footer: "",
        icon: void 0,
        iconColor: void 0,
        iconHtml: void 0,
        template: void 0,
        toast: !1,
        draggable: !1,
        animation: !0,
        theme: "light",
        showClass: {
            popup: "swal2-show",
            backdrop: "swal2-backdrop-show",
            icon: "swal2-icon-show"
        },
        hideClass: {
            popup: "swal2-hide",
            backdrop: "swal2-backdrop-hide",
            icon: "swal2-icon-hide"
        },
        customClass: {},
        target: "body",
        color: void 0,
        backdrop: !0,
        heightAuto: !0,
        allowOutsideClick: !0,
        allowEscapeKey: !0,
        allowEnterKey: !0,
        stopKeydownPropagation: !0,
        keydownListenerCapture: !1,
        showConfirmButton: !0,
        showDenyButton: !1,
        showCancelButton: !1,
        preConfirm: void 0,
        preDeny: void 0,
        confirmButtonText: "OK",
        confirmButtonAriaLabel: "",
        confirmButtonColor: void 0,
        denyButtonText: "No",
        denyButtonAriaLabel: "",
        denyButtonColor: void 0,
        cancelButtonText: "Cancel",
        cancelButtonAriaLabel: "",
        cancelButtonColor: void 0,
        buttonsStyling: !0,
        reverseButtons: !1,
        focusConfirm: !0,
        focusDeny: !1,
        focusCancel: !1,
        returnFocus: !0,
        showCloseButton: !1,
        closeButtonHtml: "&times;",
        closeButtonAriaLabel: "Close this dialog",
        loaderHtml: "",
        showLoaderOnConfirm: !1,
        showLoaderOnDeny: !1,
        imageUrl: void 0,
        imageWidth: void 0,
        imageHeight: void 0,
        imageAlt: "",
        timer: void 0,
        timerProgressBar: !1,
        width: void 0,
        padding: void 0,
        background: void 0,
        input: void 0,
        inputPlaceholder: "",
        inputLabel: "",
        inputValue: "",
        inputOptions: {},
        inputAutoFocus: !0,
        inputAutoTrim: !0,
        inputAttributes: {},
        inputValidator: void 0,
        returnInputValueOnDeny: !1,
        validationMessage: void 0,
        grow: !1,
        position: "center",
        progressSteps: [],
        currentProgressStep: void 0,
        progressStepsDistance: void 0,
        willOpen: void 0,
        didOpen: void 0,
        didRender: void 0,
        willClose: void 0,
        didClose: void 0,
        didDestroy: void 0,
        scrollbarPadding: !0,
        topLayer: !1
    }, Wt = [
        "allowEscapeKey",
        "allowOutsideClick",
        "background",
        "buttonsStyling",
        "cancelButtonAriaLabel",
        "cancelButtonColor",
        "cancelButtonText",
        "closeButtonAriaLabel",
        "closeButtonHtml",
        "color",
        "confirmButtonAriaLabel",
        "confirmButtonColor",
        "confirmButtonText",
        "currentProgressStep",
        "customClass",
        "denyButtonAriaLabel",
        "denyButtonColor",
        "denyButtonText",
        "didClose",
        "didDestroy",
        "draggable",
        "footer",
        "hideClass",
        "html",
        "icon",
        "iconColor",
        "iconHtml",
        "imageAlt",
        "imageHeight",
        "imageUrl",
        "imageWidth",
        "preConfirm",
        "preDeny",
        "progressSteps",
        "returnFocus",
        "reverseButtons",
        "showCancelButton",
        "showCloseButton",
        "showConfirmButton",
        "showDenyButton",
        "text",
        "title",
        "titleText",
        "theme",
        "willClose"
    ], Kt = {
        allowEnterKey: void 0
    }, Yt = [
        "allowOutsideClick",
        "allowEnterKey",
        "backdrop",
        "draggable",
        "focusConfirm",
        "focusDeny",
        "focusCancel",
        "returnFocus",
        "heightAuto",
        "keydownListenerCapture"
    ], Xt = (e)=>Object.prototype.hasOwnProperty.call(zt, e), Zt = (e)=>-1 !== Wt.indexOf(e), Jt = (e)=>Kt[e], Gt = (e)=>{
        Xt(e) || u(`Unknown parameter "${e}"`);
    }, Qt = (e)=>{
        Yt.includes(e) && u(`The parameter "${e}" is incompatible with toasts`);
    }, en = (e)=>{
        const t = Jt(e);
        t && m(e, t);
    }, tn = (e)=>{
        !1 === e.backdrop && e.allowOutsideClick && u('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'), e.theme && ![
            "light",
            "dark",
            "auto",
            "minimal",
            "borderless",
            "bootstrap-4",
            "bootstrap-4-light",
            "bootstrap-4-dark",
            "embed-iframe",
            "bulma",
            "bulma-light",
            "bulma-dark"
        ].includes(e.theme) && u(`Invalid theme "${e.theme}"`);
        for(const t in e)Gt(t), e.toast && Qt(t), en(t);
    };
    function nn(e) {
        const t = y(), n = C(), o = he.innerParams.get(this);
        if (!n || N(n, o.hideClass.popup)) return void u("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
        const i = on(e), s = Object.assign({}, o, i);
        tn(s), t.dataset.swal2Theme = s.theme, Re(this, s), he.innerParams.set(this, s), Object.defineProperties(this, {
            params: {
                value: Object.assign({}, this.params, e),
                writable: !1,
                enumerable: !0
            }
        });
    }
    const on = (e)=>{
        const t = {};
        return Object.keys(e).forEach((n)=>{
            Zt(n) ? t[n] = e[n] : u(`Invalid parameter to update: ${n}`);
        }), t;
    };
    function sn() {
        const e = he.domCache.get(this), t = he.innerParams.get(this);
        t ? (e.popup && o.swalCloseEventFinishedCallback && (o.swalCloseEventFinishedCallback(), delete o.swalCloseEventFinishedCallback), "function" == typeof t.didDestroy && t.didDestroy(), o.eventEmitter.emit("didDestroy"), rn(this)) : an(this);
    }
    const rn = (e)=>{
        an(e), delete e.params, delete o.keydownHandler, delete o.keydownTarget, delete o.currentInstance;
    }, an = (e)=>{
        e.isAwaitingPromise ? (ln(he, e), e.isAwaitingPromise = !0) : (ln(tt, e), ln(he, e), delete e.isAwaitingPromise, delete e.disableButtons, delete e.enableButtons, delete e.getInput, delete e.disableInput, delete e.enableInput, delete e.hideLoading, delete e.disableLoading, delete e.showValidationMessage, delete e.resetValidationMessage, delete e.close, delete e.closePopup, delete e.closeModal, delete e.closeToast, delete e.rejectPromise, delete e.update, delete e._destroy);
    }, ln = (e, t)=>{
        for(const n in e)e[n].delete(t);
    };
    var cn = Object.freeze({
        __proto__: null,
        _destroy: sn,
        close: dt,
        closeModal: dt,
        closePopup: dt,
        closeToast: dt,
        disableButtons: Nt,
        disableInput: Ft,
        disableLoading: jt,
        enableButtons: qt,
        enableInput: _t,
        getInput: It,
        handleAwaitingPromise: ht,
        hideLoading: jt,
        rejectPromise: mt,
        resetValidationMessage: Ut,
        showValidationMessage: Rt,
        update: nn
    });
    const un = (e, t, n)=>{
        t.popup.onclick = ()=>{
            e && (dn(e) || e.timer || e.input) || n(ze.close);
        };
    }, dn = (e)=>!!(e.showConfirmButton || e.showDenyButton || e.showCancelButton || e.showCloseButton);
    let pn = !1;
    const mn = (e)=>{
        e.popup.onmousedown = ()=>{
            e.container.onmouseup = function(t) {
                e.container.onmouseup = ()=>{}, t.target === e.container && (pn = !0);
            };
        };
    }, hn = (e)=>{
        e.container.onmousedown = (t)=>{
            t.target === e.container && t.preventDefault(), e.popup.onmouseup = function(t) {
                e.popup.onmouseup = ()=>{}, (t.target === e.popup || t.target instanceof HTMLElement && e.popup.contains(t.target)) && (pn = !0);
            };
        };
    }, gn = (e, t, n)=>{
        t.container.onclick = (o)=>{
            pn ? pn = !1 : o.target === t.container && h(e.allowOutsideClick) && n(ze.backdrop);
        };
    }, fn = (e)=>e instanceof Element || ((e)=>"object" == typeof e && e.jquery)(e);
    const bn = ()=>{
        if (o.timeout) return (()=>{
            const e = j();
            if (!e) return;
            const t = parseInt(window.getComputedStyle(e).width);
            e.style.removeProperty("transition"), e.style.width = "100%";
            const n = t / parseInt(window.getComputedStyle(e).width) * 100;
            e.style.width = `${n}%`;
        })(), o.timeout.stop();
    }, yn = ()=>{
        if (o.timeout) {
            const e = o.timeout.start();
            return oe(e), e;
        }
    };
    let vn = !1;
    const wn = {};
    const Cn = (e)=>{
        for(let t = e.target; t && t !== document; t = t.parentNode)for(const e in wn){
            const n = t.getAttribute(e);
            if (n) return void wn[e].fire({
                template: n
            });
        }
    };
    o.eventEmitter = new class {
        constructor(){
            this.events = {};
        }
        _getHandlersByEventName(e) {
            return void 0 === this.events[e] && (this.events[e] = []), this.events[e];
        }
        on(e, t) {
            const n = this._getHandlersByEventName(e);
            n.includes(t) || n.push(t);
        }
        once(e, t) {
            const n = (...o)=>{
                this.removeListener(e, n), t.apply(this, o);
            };
            this.on(e, n);
        }
        emit(e, ...t) {
            this._getHandlersByEventName(e).forEach((e)=>{
                try {
                    e.apply(this, t);
                } catch (e) {
                    console.error(e);
                }
            });
        }
        removeListener(e, t) {
            const n = this._getHandlersByEventName(e), o = n.indexOf(t);
            o > -1 && n.splice(o, 1);
        }
        removeAllListeners(e) {
            void 0 !== this.events[e] && (this.events[e].length = 0);
        }
        reset() {
            this.events = {};
        }
    };
    var An = Object.freeze({
        __proto__: null,
        argsToParams: (e)=>{
            const t = {};
            return "object" != typeof e[0] || fn(e[0]) ? [
                "title",
                "html",
                "icon"
            ].forEach((n, o)=>{
                const i = e[o];
                "string" == typeof i || fn(i) ? t[n] = i : void 0 !== i && d(`Unexpected type of ${n}! Expected "string" or "Element", got ${typeof i}`);
            }) : Object.assign(t, e[0]), t;
        },
        bindClickHandler: function(e = "data-swal-template") {
            wn[e] = this, vn || (document.body.addEventListener("click", Cn), vn = !0);
        },
        clickCancel: ()=>{
            var e;
            return null === (e = x()) || void 0 === e ? void 0 : e.click();
        },
        clickConfirm: Ue,
        clickDeny: ()=>{
            var e;
            return null === (e = T()) || void 0 === e ? void 0 : e.click();
        },
        enableLoading: vt,
        fire: function(...e) {
            return new this(...e);
        },
        getActions: O,
        getCancelButton: x,
        getCloseButton: H,
        getConfirmButton: P,
        getContainer: y,
        getDenyButton: T,
        getFocusableElements: I,
        getFooter: M,
        getHtmlContainer: k,
        getIcon: A,
        getIconContent: ()=>w(r["icon-content"]),
        getImage: B,
        getInputLabel: ()=>w(r["input-label"]),
        getLoader: S,
        getPopup: C,
        getProgressSteps: $,
        getTimerLeft: ()=>o.timeout && o.timeout.getTimerLeft(),
        getTimerProgressBar: j,
        getTitle: E,
        getValidationMessage: L,
        increaseTimer: (e)=>{
            if (o.timeout) {
                const t = o.timeout.increase(e);
                return oe(t, !0), t;
            }
        },
        isDeprecatedParameter: Jt,
        isLoading: ()=>{
            const e = C();
            return !!e && e.hasAttribute("data-loading");
        },
        isTimerRunning: ()=>!(!o.timeout || !o.timeout.isRunning()),
        isUpdatableParameter: Zt,
        isValidParameter: Xt,
        isVisible: ()=>ee(C()),
        mixin: function(e) {
            return class extends this {
                _main(t, n) {
                    return super._main(t, Object.assign({}, e, n));
                }
            };
        },
        off: (e, t)=>{
            e ? t ? o.eventEmitter.removeListener(e, t) : o.eventEmitter.removeAllListeners(e) : o.eventEmitter.reset();
        },
        on: (e, t)=>{
            o.eventEmitter.on(e, t);
        },
        once: (e, t)=>{
            o.eventEmitter.once(e, t);
        },
        resumeTimer: yn,
        showLoading: vt,
        stopTimer: bn,
        toggleTimer: ()=>{
            const e = o.timeout;
            return e && (e.running ? bn() : yn());
        }
    });
    class En {
        constructor(e, t){
            this.callback = e, this.remaining = t, this.running = !1, this.start();
        }
        start() {
            return this.running || (this.running = !0, this.started = new Date, this.id = setTimeout(this.callback, this.remaining)), this.remaining;
        }
        stop() {
            return this.started && this.running && (this.running = !1, clearTimeout(this.id), this.remaining -= (new Date).getTime() - this.started.getTime()), this.remaining;
        }
        increase(e) {
            const t = this.running;
            return t && this.stop(), this.remaining += e, t && this.start(), this.remaining;
        }
        getTimerLeft() {
            return this.running && (this.stop(), this.start()), this.remaining;
        }
        isRunning() {
            return this.running;
        }
    }
    const kn = [
        "swal-title",
        "swal-html",
        "swal-footer"
    ], Bn = (e)=>{
        const t = {};
        return Array.from(e.querySelectorAll("swal-param")).forEach((e)=>{
            Mn(e, [
                "name",
                "value"
            ]);
            const n = e.getAttribute("name"), o = e.getAttribute("value");
            n && o && (t[n] = "boolean" == typeof zt[n] ? "false" !== o : "object" == typeof zt[n] ? JSON.parse(o) : o);
        }), t;
    }, $n = (e)=>{
        const t = {};
        return Array.from(e.querySelectorAll("swal-function-param")).forEach((e)=>{
            const n = e.getAttribute("name"), o = e.getAttribute("value");
            n && o && (t[n] = new Function(`return ${o}`)());
        }), t;
    }, Ln = (e)=>{
        const t = {};
        return Array.from(e.querySelectorAll("swal-button")).forEach((e)=>{
            Mn(e, [
                "type",
                "color",
                "aria-label"
            ]);
            const n = e.getAttribute("type");
            n && [
                "confirm",
                "cancel",
                "deny"
            ].includes(n) && (t[`${n}ButtonText`] = e.innerHTML, t[`show${c(n)}Button`] = !0, e.hasAttribute("color") && (t[`${n}ButtonColor`] = e.getAttribute("color")), e.hasAttribute("aria-label") && (t[`${n}ButtonAriaLabel`] = e.getAttribute("aria-label")));
        }), t;
    }, Pn = (e)=>{
        const t = {}, n = e.querySelector("swal-image");
        return n && (Mn(n, [
            "src",
            "width",
            "height",
            "alt"
        ]), n.hasAttribute("src") && (t.imageUrl = n.getAttribute("src") || void 0), n.hasAttribute("width") && (t.imageWidth = n.getAttribute("width") || void 0), n.hasAttribute("height") && (t.imageHeight = n.getAttribute("height") || void 0), n.hasAttribute("alt") && (t.imageAlt = n.getAttribute("alt") || void 0)), t;
    }, xn = (e)=>{
        const t = {}, n = e.querySelector("swal-icon");
        return n && (Mn(n, [
            "type",
            "color"
        ]), n.hasAttribute("type") && (t.icon = n.getAttribute("type")), n.hasAttribute("color") && (t.iconColor = n.getAttribute("color")), t.iconHtml = n.innerHTML), t;
    }, Tn = (e)=>{
        const t = {}, n = e.querySelector("swal-input");
        n && (Mn(n, [
            "type",
            "label",
            "placeholder",
            "value"
        ]), t.input = n.getAttribute("type") || "text", n.hasAttribute("label") && (t.inputLabel = n.getAttribute("label")), n.hasAttribute("placeholder") && (t.inputPlaceholder = n.getAttribute("placeholder")), n.hasAttribute("value") && (t.inputValue = n.getAttribute("value")));
        const o = Array.from(e.querySelectorAll("swal-input-option"));
        return o.length && (t.inputOptions = {}, o.forEach((e)=>{
            Mn(e, [
                "value"
            ]);
            const n = e.getAttribute("value");
            if (!n) return;
            const o = e.innerHTML;
            t.inputOptions[n] = o;
        })), t;
    }, Sn = (e, t)=>{
        const n = {};
        for(const o in t){
            const i = t[o], s = e.querySelector(i);
            s && (Mn(s, []), n[i.replace(/^swal-/, "")] = s.innerHTML.trim());
        }
        return n;
    }, On = (e)=>{
        const t = kn.concat([
            "swal-param",
            "swal-function-param",
            "swal-button",
            "swal-image",
            "swal-icon",
            "swal-input",
            "swal-input-option"
        ]);
        Array.from(e.children).forEach((e)=>{
            const n = e.tagName.toLowerCase();
            t.includes(n) || u(`Unrecognized element <${n}>`);
        });
    }, Mn = (e, t)=>{
        Array.from(e.attributes).forEach((n)=>{
            -1 === t.indexOf(n.name) && u([
                `Unrecognized attribute "${n.name}" on <${e.tagName.toLowerCase()}>.`,
                "" + (t.length ? `Allowed attributes are: ${t.join(", ")}` : "To set the value, use HTML within the element.")
            ]);
        });
    }, jn = (e)=>{
        const t = y(), n = C();
        "function" == typeof e.willOpen && e.willOpen(n), o.eventEmitter.emit("willOpen", n);
        const i = window.getComputedStyle(document.body).overflowY;
        Vn(t, n, e), setTimeout(()=>{
            In(t, n);
        }, 10), D() && (Dn(t, e.scrollbarPadding, i), (()=>{
            const e = y();
            Array.from(document.body.children).forEach((t)=>{
                t.contains(e) || (t.hasAttribute("aria-hidden") && t.setAttribute("data-previous-aria-hidden", t.getAttribute("aria-hidden") || ""), t.setAttribute("aria-hidden", "true"));
            });
        })()), V() || o.previousActiveElement || (o.previousActiveElement = document.activeElement), "function" == typeof e.didOpen && setTimeout(()=>e.didOpen(n)), o.eventEmitter.emit("didOpen", n), W(t, r["no-transition"]);
    }, Hn = (e)=>{
        const t = C();
        if (e.target !== t) return;
        const n = y();
        t.removeEventListener("animationend", Hn), t.removeEventListener("transitionend", Hn), n.style.overflowY = "auto";
    }, In = (e, t)=>{
        ne(t) ? (e.style.overflowY = "hidden", t.addEventListener("animationend", Hn), t.addEventListener("transitionend", Hn)) : e.style.overflowY = "auto";
    }, Dn = (e, t, n)=>{
        (()=>{
            if (ot && !N(document.body, r.iosfix)) {
                const e = document.body.scrollTop;
                document.body.style.top = -1 * e + "px", z(document.body, r.iosfix), it();
            }
        })(), t && "hidden" !== n && ct(n), setTimeout(()=>{
            e.scrollTop = 0;
        });
    }, Vn = (e, t, n)=>{
        z(e, n.showClass.backdrop), n.animation ? (t.style.setProperty("opacity", "0", "important"), X(t, "grid"), setTimeout(()=>{
            z(t, n.showClass.popup), t.style.removeProperty("opacity");
        }, 10)) : X(t, "grid"), z([
            document.documentElement,
            document.body
        ], r.shown), n.heightAuto && n.backdrop && !n.toast && z([
            document.documentElement,
            document.body
        ], r["height-auto"]);
    };
    var qn = (e, t)=>/^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid email address"), Nn = (e, t)=>/^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid URL");
    function _n(e) {
        !function(e) {
            e.inputValidator || ("email" === e.input && (e.inputValidator = qn), "url" === e.input && (e.inputValidator = Nn));
        }(e), e.showLoaderOnConfirm && !e.preConfirm && u("showLoaderOnConfirm is set to true, but preConfirm is not defined.\nshowLoaderOnConfirm should be used together with preConfirm, see usage example:\nhttps://sweetalert2.github.io/#ajax-request"), function(e) {
            (!e.target || "string" == typeof e.target && !document.querySelector(e.target) || "string" != typeof e.target && !e.target.appendChild) && (u('Target parameter is not valid, defaulting to "body"'), e.target = "body");
        }(e), "string" == typeof e.title && (e.title = e.title.split("\n").join("<br />")), re(e);
    }
    let Fn;
    var Rn = new WeakMap;
    class Un {
        constructor(...t){
            if (n(this, Rn, void 0), "undefined" == typeof window) return;
            Fn = this;
            const o = Object.freeze(this.constructor.argsToParams(t));
            var i, s, r;
            this.params = o, this.isAwaitingPromise = !1, i = Rn, s = this, r = this._main(Fn.params), i.set(e(i, s), r);
        }
        _main(e, t = {}) {
            if (tn(Object.assign({}, t, e)), o.currentInstance) {
                const e = tt.swalPromiseResolve.get(o.currentInstance), { isAwaitingPromise: t } = o.currentInstance;
                o.currentInstance._destroy(), t || e({
                    isDismissed: !0
                }), D() && nt();
            }
            o.currentInstance = Fn;
            const n = Wn(e, t);
            _n(n), Object.freeze(n), o.timeout && (o.timeout.stop(), delete o.timeout), clearTimeout(o.restoreFocusTimeout);
            const i = Kn(Fn);
            return Re(Fn, n), he.innerParams.set(Fn, n), zn(Fn, i, n);
        }
        then(e) {
            return t(Rn, this).then(e);
        }
        finally(e) {
            return t(Rn, this).finally(e);
        }
    }
    const zn = (e, t, n)=>new Promise((i, s)=>{
            const r = (t)=>{
                e.close({
                    isDismissed: !0,
                    dismiss: t
                });
            };
            tt.swalPromiseResolve.set(e, i), tt.swalPromiseReject.set(e, s), t.confirmButton.onclick = ()=>{
                ((e)=>{
                    const t = he.innerParams.get(e);
                    e.disableButtons(), t.input ? Pt(e, "confirm") : Mt(e, !0);
                })(e);
            }, t.denyButton.onclick = ()=>{
                ((e)=>{
                    const t = he.innerParams.get(e);
                    e.disableButtons(), t.returnInputValueOnDeny ? Pt(e, "deny") : Tt(e, !1);
                })(e);
            }, t.cancelButton.onclick = ()=>{
                ((e, t)=>{
                    e.disableButtons(), t(ze.cancel);
                })(e, r);
            }, t.closeButton.onclick = ()=>{
                r(ze.close);
            }, ((e, t, n)=>{
                e.toast ? un(e, t, n) : (mn(t), hn(t), gn(e, t, n));
            })(n, t, r), ((e, t, n)=>{
                We(e), t.toast || (e.keydownHandler = (e)=>Ze(t, e, n), e.keydownTarget = t.keydownListenerCapture ? window : C(), e.keydownListenerCapture = t.keydownListenerCapture, e.keydownTarget.addEventListener("keydown", e.keydownHandler, {
                    capture: e.keydownListenerCapture
                }), e.keydownHandlerAdded = !0);
            })(o, n, r), ((e, t)=>{
                "select" === t.input || "radio" === t.input ? kt(e, t) : [
                    "text",
                    "email",
                    "number",
                    "tel",
                    "textarea"
                ].some((e)=>e === t.input) && (g(t.inputValue) || b(t.inputValue)) && (vt(P()), Bt(e, t));
            })(e, n), jn(n), Yn(o, n, r), Xn(t, n), setTimeout(()=>{
                t.container.scrollTop = 0;
            });
        }), Wn = (e, t)=>{
        const n = ((e)=>{
            const t = "string" == typeof e.template ? document.querySelector(e.template) : e.template;
            if (!t) return {};
            const n = t.content;
            return On(n), Object.assign(Bn(n), $n(n), Ln(n), Pn(n), xn(n), Tn(n), Sn(n, kn));
        })(e), o = Object.assign({}, zt, t, n, e);
        return o.showClass = Object.assign({}, zt.showClass, o.showClass), o.hideClass = Object.assign({}, zt.hideClass, o.hideClass), !1 === o.animation && (o.showClass = {
            backdrop: "swal2-noanimation"
        }, o.hideClass = {}), o;
    }, Kn = (e)=>{
        const t = {
            popup: C(),
            container: y(),
            actions: O(),
            confirmButton: P(),
            denyButton: T(),
            cancelButton: x(),
            loader: S(),
            closeButton: H(),
            validationMessage: L(),
            progressSteps: $()
        };
        return he.domCache.set(e, t), t;
    }, Yn = (e, t, n)=>{
        const o = j();
        Z(o), t.timer && (e.timeout = new En(()=>{
            n("timer"), delete e.timeout;
        }, t.timer), t.timerProgressBar && (X(o), _(o, t, "timerProgressBar"), setTimeout(()=>{
            e.timeout && e.timeout.running && oe(t.timer);
        })));
    }, Xn = (e, t)=>{
        if (!t.toast) return h(t.allowEnterKey) ? void (Zn(e) || Jn(e, t) || Ke(-1, 1)) : (m("allowEnterKey"), void Gn());
    }, Zn = (e)=>{
        const t = Array.from(e.popup.querySelectorAll("[autofocus]"));
        for (const e of t)if (e instanceof HTMLElement && ee(e)) return e.focus(), !0;
        return !1;
    }, Jn = (e, t)=>t.focusDeny && ee(e.denyButton) ? (e.denyButton.focus(), !0) : t.focusCancel && ee(e.cancelButton) ? (e.cancelButton.focus(), !0) : !(!t.focusConfirm || !ee(e.confirmButton)) && (e.confirmButton.focus(), !0), Gn = ()=>{
        document.activeElement instanceof HTMLElement && "function" == typeof document.activeElement.blur && document.activeElement.blur();
    };
    Un.prototype.disableButtons = Nt, Un.prototype.enableButtons = qt, Un.prototype.getInput = It, Un.prototype.disableInput = Ft, Un.prototype.enableInput = _t, Un.prototype.hideLoading = jt, Un.prototype.disableLoading = jt, Un.prototype.showValidationMessage = Rt, Un.prototype.resetValidationMessage = Ut, Un.prototype.close = dt, Un.prototype.closePopup = dt, Un.prototype.closeModal = dt, Un.prototype.closeToast = dt, Un.prototype.rejectPromise = mt, Un.prototype.update = nn, Un.prototype._destroy = sn, Object.assign(Un, An), Object.keys(cn).forEach((e)=>{
        Un[e] = function(...t) {
            return Fn && Fn[e] ? Fn[e](...t) : null;
        };
    }), Un.DismissReason = ze, Un.version = "11.24.0";
    const Qn = Un;
    return Qn.default = Qn, Qn;
}), void 0 !== $c881059c43e9596b$exports && $c881059c43e9596b$exports.Sweetalert2 && ($c881059c43e9596b$exports.swal = $c881059c43e9596b$exports.sweetAlert = $c881059c43e9596b$exports.Swal = $c881059c43e9596b$exports.SweetAlert = $c881059c43e9596b$exports.Sweetalert2);


parcelRequire("krIeN");
var $2d752713a4ef31cf$exports = {};

!function(e) {
    "function" == typeof define && define.amd ? define([
        "jquery"
    ], e) : "object" == typeof $2d752713a4ef31cf$exports ? $2d752713a4ef31cf$exports = e((parcelRequire("iUSsr"))) : e(jQuery);
}(function(e) {
    return function(A) {
        "use strict";
        var L = A.tablesorter = {
            version: "2.32.0",
            parsers: [],
            widgets: [],
            defaults: {
                theme: "default",
                widthFixed: !1,
                showProcessing: !1,
                headerTemplate: "{content}",
                onRenderTemplate: null,
                onRenderHeader: null,
                cancelSelection: !0,
                tabIndex: !0,
                dateFormat: "mmddyyyy",
                sortMultiSortKey: "shiftKey",
                sortResetKey: "ctrlKey",
                usNumberFormat: !0,
                delayInit: !1,
                serverSideSorting: !1,
                resort: !0,
                headers: null,
                ignoreCase: !0,
                sortForce: null,
                sortList: [],
                sortAppend: null,
                sortStable: !1,
                sortInitialOrder: "asc",
                sortLocaleCompare: !1,
                sortReset: !1,
                sortRestart: !1,
                emptyTo: "bottom",
                stringTo: "max",
                duplicateSpan: !0,
                textExtraction: "basic",
                textAttribute: "data-text",
                textSorter: null,
                numberSorter: null,
                initWidgets: !0,
                widgetClass: "widget-{name}",
                widgets: [],
                widgetOptions: {
                    zebra: [
                        "even",
                        "odd"
                    ]
                },
                initialized: null,
                tableClass: "",
                cssAsc: "",
                cssDesc: "",
                cssNone: "",
                cssHeader: "",
                cssHeaderRow: "",
                cssProcessing: "",
                cssChildRow: "tablesorter-childRow",
                cssInfoBlock: "tablesorter-infoOnly",
                cssNoSort: "tablesorter-noSort",
                cssIgnoreRow: "tablesorter-ignoreRow",
                cssIcon: "tablesorter-icon",
                cssIconNone: "",
                cssIconAsc: "",
                cssIconDesc: "",
                cssIconDisabled: "",
                pointerClick: "click",
                pointerDown: "mousedown",
                pointerUp: "mouseup",
                selectorHeaders: "> thead th, > thead td",
                selectorSort: "th, td",
                selectorRemove: ".remove-me",
                debug: !1,
                headerList: [],
                empties: {},
                strings: {},
                parsers: [],
                globalize: 0,
                imgAttr: 0
            },
            css: {
                table: "tablesorter",
                cssHasChild: "tablesorter-hasChildRow",
                childRow: "tablesorter-childRow",
                colgroup: "tablesorter-colgroup",
                header: "tablesorter-header",
                headerRow: "tablesorter-headerRow",
                headerIn: "tablesorter-header-inner",
                icon: "tablesorter-icon",
                processing: "tablesorter-processing",
                sortAsc: "tablesorter-headerAsc",
                sortDesc: "tablesorter-headerDesc",
                sortNone: "tablesorter-headerUnSorted"
            },
            language: {
                sortAsc: "Ascending sort applied, ",
                sortDesc: "Descending sort applied, ",
                sortNone: "No sort applied, ",
                sortDisabled: "sorting is disabled",
                nextAsc: "activate to apply an ascending sort",
                nextDesc: "activate to apply a descending sort",
                nextNone: "activate to remove the sort"
            },
            regex: {
                templateContent: /\{content\}/g,
                templateIcon: /\{icon\}/g,
                templateName: /\{name\}/i,
                spaces: /\s+/g,
                nonWord: /\W/g,
                formElements: /(input|select|button|textarea)/i,
                chunk: /(^([+\-]?(?:\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi,
                chunks: /(^\\0|\\0$)/,
                hex: /^0x[0-9a-f]+$/i,
                comma: /,/g,
                digitNonUS: /[\s|\.]/g,
                digitNegativeTest: /^\s*\([.\d]+\)/,
                digitNegativeReplace: /^\s*\(([.\d]+)\)/,
                digitTest: /^[\-+(]?\d+[)]?$/,
                digitReplace: /[,.'"\s]/g
            },
            string: {
                max: 1,
                min: -1,
                emptymin: 1,
                emptymax: -1,
                zero: 0,
                none: 0,
                null: 0,
                top: !0,
                bottom: !1
            },
            keyCodes: {
                enter: 13
            },
            dates: {},
            instanceMethods: {},
            setup: function(t, r) {
                var e, o, s, a;
                t && t.tHead && 0 !== t.tBodies.length && !0 !== t.hasInitialized ? (e = "", o = A(t), s = A.metadata, t.hasInitialized = !1, t.isProcessing = !0, t.config = r, A.data(t, "tablesorter", r), L.debug(r, "core") && (console[console.group ? "group" : "log"]("Initializing tablesorter v" + L.version), A.data(t, "startoveralltimer", new Date)), r.supportsDataObject = ((a = A.fn.jquery.split("."))[0] = parseInt(a[0], 10), 1 < a[0] || 1 === a[0] && 4 <= parseInt(a[1], 10)), r.emptyTo = r.emptyTo.toLowerCase(), r.stringTo = r.stringTo.toLowerCase(), r.last = {
                    sortList: [],
                    clickedIndex: -1
                }, /tablesorter\-/.test(o.attr("class")) || (e = "" !== r.theme ? " tablesorter-" + r.theme : ""), r.namespace ? r.namespace = "." + r.namespace.replace(L.regex.nonWord, "") : r.namespace = ".tablesorter" + Math.random().toString(16).slice(2), r.table = t, r.$table = o.addClass(L.css.table + " " + r.tableClass + e + " " + r.namespace.slice(1)).attr("role", "grid"), r.$headers = o.find(r.selectorHeaders), r.$table.children().children("tr").attr("role", "row"), r.$tbodies = o.children("tbody:not(." + r.cssInfoBlock + ")").attr({
                    "aria-live": "polite",
                    "aria-relevant": "all"
                }), r.$table.children("caption").length && ((e = r.$table.children("caption")[0]).id || (e.id = r.namespace.slice(1) + "caption"), r.$table.attr("aria-labelledby", e.id)), r.widgetInit = {}, r.textExtraction = r.$table.attr("data-text-extraction") || r.textExtraction || "basic", L.buildHeaders(r), L.fixColumnWidth(t), L.addWidgetFromClass(t), L.applyWidgetOptions(t), L.setupParsers(r), r.totalRows = 0, r.debug && L.validateOptions(r), r.delayInit || L.buildCache(r), L.bindEvents(t, r.$headers, !0), L.bindMethods(r), r.supportsDataObject && void 0 !== o.data().sortlist ? r.sortList = o.data().sortlist : s && o.metadata() && o.metadata().sortlist && (r.sortList = o.metadata().sortlist), L.applyWidget(t, !0), 0 < r.sortList.length ? (r.last.sortList = r.sortList, L.sortOn(r, r.sortList, {}, !r.initWidgets)) : (L.setHeadersCss(r), r.initWidgets && L.applyWidget(t, !1)), r.showProcessing && o.unbind("sortBegin" + r.namespace + " sortEnd" + r.namespace).bind("sortBegin" + r.namespace + " sortEnd" + r.namespace, function(e) {
                    clearTimeout(r.timerProcessing), L.isProcessing(t), "sortBegin" === e.type && (r.timerProcessing = setTimeout(function() {
                        L.isProcessing(t, !0);
                    }, 500));
                }), t.hasInitialized = !0, t.isProcessing = !1, L.debug(r, "core") && (console.log("Overall initialization time:" + L.benchmark(A.data(t, "startoveralltimer"))), L.debug(r, "core")) && console.groupEnd && console.groupEnd(), o.triggerHandler("tablesorter-initialized", t), "function" == typeof r.initialized && r.initialized(t)) : L.debug(r, "core") && (t.hasInitialized ? console.warn("Stopping initialization. Tablesorter has already been initialized") : console.error("Stopping initialization! No table, thead or tbody", t));
            },
            bindMethods: function(t) {
                var e = t.$table, r = t.namespace, o = "sortReset update updateRows updateAll updateHeaders addRows updateCell updateComplete sorton appendCache updateCache applyWidgetId applyWidgets refreshWidgets destroy mouseup mouseleave ".split(" ").join(r + " ");
                e.unbind(o.replace(L.regex.spaces, " ")).bind("sortReset" + r, function(e, t) {
                    e.stopPropagation(), L.sortReset(this.config, function(e) {
                        e.isApplyingWidgets ? setTimeout(function() {
                            L.applyWidget(e, "", t);
                        }, 100) : L.applyWidget(e, "", t);
                    });
                }).bind("updateAll" + r, function(e, t, r) {
                    e.stopPropagation(), L.updateAll(this.config, t, r);
                }).bind("update" + r + " updateRows" + r, function(e, t, r) {
                    e.stopPropagation(), L.update(this.config, t, r);
                }).bind("updateHeaders" + r, function(e, t) {
                    e.stopPropagation(), L.updateHeaders(this.config, t);
                }).bind("updateCell" + r, function(e, t, r, o) {
                    e.stopPropagation(), L.updateCell(this.config, t, r, o);
                }).bind("addRows" + r, function(e, t, r, o) {
                    e.stopPropagation(), L.addRows(this.config, t, r, o);
                }).bind("updateComplete" + r, function() {
                    this.isUpdating = !1;
                }).bind("sorton" + r, function(e, t, r, o) {
                    e.stopPropagation(), L.sortOn(this.config, t, r, o);
                }).bind("appendCache" + r, function(e, t, r) {
                    e.stopPropagation(), L.appendCache(this.config, r), A.isFunction(t) && t(this);
                }).bind("updateCache" + r, function(e, t, r) {
                    e.stopPropagation(), L.updateCache(this.config, t, r);
                }).bind("applyWidgetId" + r, function(e, t) {
                    e.stopPropagation(), L.applyWidgetId(this, t);
                }).bind("applyWidgets" + r, function(e, t) {
                    e.stopPropagation(), L.applyWidget(this, !1, t);
                }).bind("refreshWidgets" + r, function(e, t, r) {
                    e.stopPropagation(), L.refreshWidgets(this, t, r);
                }).bind("removeWidget" + r, function(e, t, r) {
                    e.stopPropagation(), L.removeWidget(this, t, r);
                }).bind("destroy" + r, function(e, t, r) {
                    e.stopPropagation(), L.destroy(this, t, r);
                }).bind("resetToLoadState" + r, function(e) {
                    e.stopPropagation(), L.removeWidget(this, !0, !1);
                    e = A.extend(!0, {}, t.originalSettings);
                    (t = A.extend(!0, {}, L.defaults, e)).originalSettings = e, this.hasInitialized = !1, L.setup(this, t);
                });
            },
            bindEvents: function(e, t, r) {
                var o, s = (e = A(e)[0]).config, a = s.namespace, n = null;
                !0 !== r && (t.addClass(a.slice(1) + "_extra_headers"), (o = L.getClosest(t, "table")).length) && "TABLE" === o[0].nodeName && o[0] !== e && A(o[0]).addClass(a.slice(1) + "_extra_table"), o = (s.pointerDown + " " + s.pointerUp + " " + s.pointerClick + " sort keyup ").replace(L.regex.spaces, " ").split(" ").join(a + " "), t.find(s.selectorSort).add(t.filter(s.selectorSort)).unbind(o).bind(o, function(e, t) {
                    var r = A(e.target), o = " " + e.type + " ";
                    if (!(1 !== (e.which || e.button) && !o.match(" " + s.pointerClick + " | sort | keyup ") || " keyup " === o && e.which !== L.keyCodes.enter || o.match(" " + s.pointerClick + " ") && void 0 !== e.which || o.match(" " + s.pointerUp + " ") && n !== e.target && !0 !== t)) {
                        if (o.match(" " + s.pointerDown + " ")) n = e.target, "1" === (t = r.jquery.split("."))[0] && t[1] < 4 && e.preventDefault();
                        else {
                            if (n = null, o = L.getClosest(A(this), "." + L.css.header), L.regex.formElements.test(e.target.nodeName) || r.hasClass(s.cssNoSort) || 0 < r.parents("." + s.cssNoSort).length || o.hasClass("sorter-false") || 0 < r.parents("button").length) return !s.cancelSelection;
                            s.delayInit && L.isEmptyObject(s.cache) && L.buildCache(s), s.last.clickedIndex = o.attr("data-column") || o.index(), (t = s.$headerIndexed[s.last.clickedIndex][0]) && !t.sortDisabled && L.initSort(s, t, e);
                        }
                    }
                }), s.cancelSelection && t.attr("unselectable", "on").bind("selectstart", !1).css({
                    "user-select": "none",
                    MozUserSelect: "none"
                });
            },
            buildHeaders: function(i) {
                var e, l, t, r;
                for(i.headerList = [], i.headerContent = [], i.sortVars = [], L.debug(i, "core") && (t = new Date), i.columns = L.computeColumnIndex(i.$table.children("thead, tfoot").children("tr")), l = i.cssIcon ? '<i class="' + (i.cssIcon === L.css.icon ? L.css.icon : i.cssIcon + " " + L.css.icon) + '"></i>' : "", i.$headers = A(A.map(i.$table.find(i.selectorHeaders), function(e, t) {
                    var r, o, s, a, n = A(e);
                    if (!L.getClosest(n, "tr").hasClass(i.cssIgnoreRow)) return /(th|td)/i.test(e.nodeName) || (a = L.getClosest(n, "th, td"), n.attr("data-column", a.attr("data-column"))), r = L.getColumnData(i.table, i.headers, t, !0), i.headerContent[t] = n.html(), "" === i.headerTemplate || n.find("." + L.css.headerIn).length || (s = i.headerTemplate.replace(L.regex.templateContent, n.html()).replace(L.regex.templateIcon, n.find("." + L.css.icon).length ? "" : l), i.onRenderTemplate && (o = i.onRenderTemplate.apply(n, [
                        t,
                        s
                    ])) && "string" == typeof o && (s = o), n.html('<div class="' + L.css.headerIn + '">' + s + "</div>")), i.onRenderHeader && i.onRenderHeader.apply(n, [
                        t,
                        i,
                        i.$table
                    ]), o = parseInt(n.attr("data-column"), 10), e.column = o, a = L.getOrder(L.getData(n, r, "sortInitialOrder") || i.sortInitialOrder), i.sortVars[o] = {
                        count: -1,
                        order: a ? i.sortReset ? [
                            1,
                            0,
                            2
                        ] : [
                            1,
                            0
                        ] : i.sortReset ? [
                            0,
                            1,
                            2
                        ] : [
                            0,
                            1
                        ],
                        lockedOrder: !1,
                        sortedBy: ""
                    }, void 0 !== (a = L.getData(n, r, "lockedOrder") || !1) && !1 !== a && (i.sortVars[o].lockedOrder = !0, i.sortVars[o].order = L.getOrder(a) ? [
                        1,
                        1
                    ] : [
                        0,
                        0
                    ]), i.headerList[t] = e, n.addClass(L.css.header + " " + i.cssHeader), L.getClosest(n, "tr").addClass(L.css.headerRow + " " + i.cssHeaderRow).attr("role", "row"), i.tabIndex && n.attr("tabindex", 0), e;
                })), i.$headerIndexed = [], r = 0; r < i.columns; r++)L.isEmptyObject(i.sortVars[r]) && (i.sortVars[r] = {}), e = i.$headers.filter('[data-column="' + r + '"]'), i.$headerIndexed[r] = e.length ? (e.not(".sorter-false").length ? e.not(".sorter-false") : e).filter(":last") : A();
                i.$table.find(i.selectorHeaders).attr({
                    scope: "col",
                    role: "columnheader"
                }), L.updateHeader(i), L.debug(i, "core") && (console.log("Built headers:" + L.benchmark(t)), console.log(i.$headers));
            },
            addInstanceMethods: function(e) {
                A.extend(L.instanceMethods, e);
            },
            setupParsers: function(e, t) {
                var r, o, s, a, n, i, l, d, c, g, p, u, f, h, m = e.table, b = 0, y = L.debug(e, "core"), w = {};
                if (e.$tbodies = e.$table.children("tbody:not(." + e.cssInfoBlock + ")"), 0 === (h = (f = void 0 === t ? e.$tbodies : t).length)) return y ? console.warn("Warning: *Empty table!* Not building a parser cache") : "";
                for(y && (u = new Date, console[console.group ? "group" : "log"]("Detecting parsers for each column")), o = {
                    extractors: [],
                    parsers: []
                }; b < h;){
                    if ((r = f[b].rows).length) for(a = e.columns, i = n = 0; i < a; i++){
                        if ((l = e.$headerIndexed[n]) && l.length && (d = L.getColumnData(m, e.headers, n), p = L.getParserById(L.getData(l, d, "extractor")), g = L.getParserById(L.getData(l, d, "sorter")), c = "false" === L.getData(l, d, "parser"), e.empties[n] = (L.getData(l, d, "empty") || e.emptyTo || (e.emptyToBottom ? "bottom" : "top")).toLowerCase(), e.strings[n] = (L.getData(l, d, "string") || e.stringTo || "max").toLowerCase(), p = p || !1, g = (g = c ? L.getParserById("no-parser") : g) || L.detectParserForColumn(e, r, -1, n), y && (w["(" + n + ") " + l.text()] = {
                            parser: g.id,
                            extractor: p ? p.id : "none",
                            string: e.strings[n],
                            empty: e.empties[n]
                        }), o.parsers[n] = g, o.extractors[n] = p, 0 < (s = l[0].colSpan - 1))) for(n += s, a += s; 0 < s + 1;)o.parsers[n - s] = g, o.extractors[n - s] = p, s--;
                        n++;
                    }
                    b += o.parsers.length ? h : 1;
                }
                y && (L.isEmptyObject(w) ? console.warn("  No parsers detected!") : console[console.table ? "table" : "log"](w), console.log("Completed detecting parsers" + L.benchmark(u)), console.groupEnd) && console.groupEnd(), e.parsers = o.parsers, e.extractors = o.extractors;
            },
            addParser: function(e) {
                for(var t = L.parsers.length, r = !0, o = 0; o < t; o++)L.parsers[o].id.toLowerCase() === e.id.toLowerCase() && (r = !1);
                r && (L.parsers[L.parsers.length] = e);
            },
            getParserById: function(e) {
                if ("false" != e) {
                    for(var t = L.parsers.length, r = 0; r < t; r++)if (L.parsers[r].id.toLowerCase() === e.toString().toLowerCase()) return L.parsers[r];
                }
                return !1;
            },
            detectParserForColumn: function(e, t, r, o) {
                for(var s, a, n, i = L.parsers.length, l = !1, d = "", c = L.debug(e, "core"), g = !0; "" === d && g;)(n = t[++r]) && r < 50 ? n.className.indexOf(L.cssIgnoreRow) < 0 && (l = t[r].cells[o], d = L.getElementText(e, l, o), a = A(l), c) && console.log("Checking if value was empty on row " + r + ", column: " + o + ': "' + d + '"') : g = !1;
                for(; 0 <= --i;)if ((s = L.parsers[i]) && "text" !== s.id && s.is && s.is(d, e.table, l, a)) return s;
                return L.getParserById("text");
            },
            getElementText: function(e, t, r) {
                var o, s, a;
                return t ? (s = e.textExtraction || "", a = t.jquery ? t : A(t), "string" == typeof s ? "basic" === s && void 0 !== (o = a.attr(e.textAttribute)) ? A.trim(o) : A.trim(t.textContent || a.text()) : "function" == typeof s ? A.trim(s(a[0], e.table, r)) : "function" == typeof (o = L.getColumnData(e.table, s, r)) ? A.trim(o(a[0], e.table, r)) : A.trim(a[0].textContent || a.text())) : "";
            },
            getParsedText: function(e, t, r, o) {
                var s = "" + (o = void 0 === o ? L.getElementText(e, t, r) : o), a = e.parsers[r], n = e.extractors[r];
                return s = a && (n && "function" == typeof n.format && (o = n.format(o, e.table, t, r)), s = "no-parser" === a.id ? "" : a.format("" + o, e.table, t, r), e.ignoreCase) && "string" == typeof s ? s.toLowerCase() : s;
            },
            buildCache: function(e, t, r) {
                var o, s, a, n, i, l, d, c, g, p, u, f, h, m, b, y, w, x, C, v, $, I, D = e.table, R = e.parsers, T = L.debug(e, "core");
                if (e.$tbodies = e.$table.children("tbody:not(." + e.cssInfoBlock + ")"), d = void 0 === r ? e.$tbodies : r, e.cache = {}, e.totalRows = 0, !R) return T ? console.warn("Warning: *Empty table!* Not building a cache") : "";
                for(T && (f = new Date), e.showProcessing && L.isProcessing(D, !0), l = 0; l < d.length; l++){
                    for(y = [], o = e.cache[l] = {
                        normalized: []
                    }, h = d[l] && d[l].rows.length || 0, n = 0; n < h; ++n)if (m = {
                        child: [],
                        raw: []
                    }, g = [], !(c = A(d[l].rows[n])).hasClass(e.selectorRemove.slice(1))) {
                        if (c.hasClass(e.cssChildRow) && 0 !== n) for($ = o.normalized.length - 1, (b = o.normalized[$][e.columns]).$row = b.$row.add(c), c.prev().hasClass(e.cssChildRow) || c.prev().addClass(L.css.cssHasChild), p = c.children("th, td"), $ = b.child.length, b.child[$] = [], v = e.columns, i = x = 0; i < v; i++)(u = p[i]) && (b.child[$][i] = L.getParsedText(e, u, i), 0 < (w = p[i].colSpan - 1)) && (x += w, v += w), x++;
                        else {
                            for(m.$row = c, m.order = n, v = e.columns, i = x = 0; i < v; ++i){
                                if ((u = c[0].cells[i]) && x < e.columns && (!(C = void 0 !== R[x]) && T && console.warn("No parser found for row: " + n + ", column: " + i + '; cell containing: "' + A(u).text() + '"; does it have a header?'), s = L.getElementText(e, u, x), m.raw[x] = s, a = L.getParsedText(e, u, x, s), g[x] = a, C && "numeric" === (R[x].type || "").toLowerCase() && (y[x] = Math.max(Math.abs(a) || 0, y[x] || 0)), 0 < (w = u.colSpan - 1))) {
                                    for(I = 0; I <= w;)a = e.duplicateSpan || 0 === I ? a : "string" != typeof e.textExtraction && L.getElementText(e, u, x + I) || "", m.raw[x + I] = a, g[x + I] = a, I++;
                                    x += w, v += w;
                                }
                                x++;
                            }
                            g[e.columns] = m, o.normalized[o.normalized.length] = g;
                        }
                    }
                    o.colMax = y, e.totalRows += o.normalized.length;
                }
                if (e.showProcessing && L.isProcessing(D), T) {
                    for($ = Math.min(5, e.cache[0].normalized.length), console[console.group ? "group" : "log"]("Building cache for " + e.totalRows + " rows (showing " + $ + " rows in log) and " + e.columns + " columns" + L.benchmark(f)), s = {}, i = 0; i < e.columns; i++)for(x = 0; x < $; x++)s["row: " + x] || (s["row: " + x] = {}), s["row: " + x][e.$headerIndexed[i].text()] = e.cache[0].normalized[x][i];
                    console[console.table ? "table" : "log"](s), console.groupEnd && console.groupEnd();
                }
                A.isFunction(t) && t(D);
            },
            getColumnText: function(e, t, r, o) {
                var s, a, n, i, l, d, c, g, p, u, f = "function" == typeof r, h = "all" === t, m = {
                    raw: [],
                    parsed: [],
                    $cell: []
                }, b = (e = A(e)[0]).config;
                if (!L.isEmptyObject(b)) {
                    for(l = b.$tbodies.length, s = 0; s < l; s++)for(d = (n = b.cache[s].normalized).length, a = 0; a < d; a++)i = n[a], o && !i[b.columns].$row.is(o) || (u = !0, g = h ? i.slice(0, b.columns) : i[t], i = i[b.columns], c = h ? i.raw : i.raw[t], p = h ? i.$row.children() : i.$row.children().eq(t), !1 !== (u = f ? r({
                        tbodyIndex: s,
                        rowIndex: a,
                        parsed: g,
                        raw: c,
                        $row: i.$row,
                        $cell: p
                    }) : u) && (m.parsed[m.parsed.length] = g, m.raw[m.raw.length] = c, m.$cell[m.$cell.length] = p));
                    return m;
                }
                L.debug(b, "core") && console.warn("No cache found - aborting getColumnText function!");
            },
            setHeadersCss: function(s) {
                function e(e, t) {
                    e.removeClass(n).addClass(i[t]).attr("aria-sort", d[t]).find("." + L.css.icon).removeClass(l[2]).addClass(l[t]);
                }
                var t, r, o = s.sortList, a = o.length, n = L.css.sortNone + " " + s.cssNone, i = [
                    L.css.sortAsc + " " + s.cssAsc,
                    L.css.sortDesc + " " + s.cssDesc
                ], l = [
                    s.cssIconAsc,
                    s.cssIconDesc,
                    s.cssIconNone
                ], d = [
                    "ascending",
                    "descending"
                ], c = s.$table.find("tfoot tr").children("td, th").add(A(s.namespace + "_extra_headers")).removeClass(i.join(" ")), g = s.$headers.add(A("thead " + s.namespace + "_extra_headers")).removeClass(i.join(" ")).addClass(n).attr("aria-sort", "none").find("." + L.css.icon).removeClass(l.join(" ")).end();
                for(g.not(".sorter-false").find("." + L.css.icon).addClass(l[2]), s.cssIconDisabled && g.filter(".sorter-false").find("." + L.css.icon).addClass(s.cssIconDisabled), t = 0; t < a; t++)if (2 !== o[t][1]) {
                    if ((g = (g = s.$headers.filter(function(e) {
                        for(var t = !0, e = s.$headers.eq(e), r = parseInt(e.attr("data-column"), 10), o = r + L.getClosest(e, "th, td")[0].colSpan; r < o; r++)t = t || !1;
                        return t;
                    })).not(".sorter-false").filter('[data-column="' + o[t][0] + '"]' + (1 === a ? ":last" : ""))).length) for(r = 0; r < g.length; r++)g[r].sortDisabled || e(g.eq(r), o[t][1]);
                    c.length && e(c.filter('[data-column="' + o[t][0] + '"]'), o[t][1]);
                }
                for(a = s.$headers.length, t = 0; t < a; t++)L.setColumnAriaLabel(s, s.$headers.eq(t));
            },
            getClosest: function(e, t) {
                return A.fn.closest ? e.closest(t) : e.is(t) ? e : e.parents(t).filter(":first");
            },
            setColumnAriaLabel: function(e, t, r) {
                var o, s;
                t.length && (o = parseInt(t.attr("data-column"), 10), e = e.sortVars[o], o = t.hasClass(L.css.sortAsc) ? "sortAsc" : t.hasClass(L.css.sortDesc) ? "sortDesc" : "sortNone", s = A.trim(t.text()) + ": " + L.language[o], t.hasClass("sorter-false") || !1 === r ? s += L.language.sortDisabled : (o = (e.count + 1) % e.order.length, r = e.order[o], s += L.language[0 === r ? "nextAsc" : 1 === r ? "nextDesc" : "nextNone"]), t.attr("aria-label", s), e.sortedBy ? t.attr("data-sortedBy", e.sortedBy) : t.removeAttr("data-sortedBy"));
            },
            updateHeader: function(e) {
                for(var t, r, o = e.table, s = e.$headers.length, a = 0; a < s; a++)t = e.$headers.eq(a), r = L.getColumnData(o, e.headers, a, !0), r = "false" === L.getData(t, r, "sorter") || "false" === L.getData(t, r, "parser"), L.setColumnSort(e, t, r);
            },
            setColumnSort: function(e, t, r) {
                var o = e.table.id;
                t[0].sortDisabled = r, t[r ? "addClass" : "removeClass"]("sorter-false").attr("aria-disabled", "" + r), e.tabIndex && (r ? t.removeAttr("tabindex") : t.attr("tabindex", "0")), o && (r ? t.removeAttr("aria-controls") : t.attr("aria-controls", o));
            },
            updateHeaderSortCount: function(e, t) {
                var r, o, s, a, n, i, l, d = t || e.sortList, c = d.length;
                for(e.sortList = [], s = 0; s < c; s++)if (i = d[s], (r = parseInt(i[0], 10)) < e.columns) {
                    switch(e.sortVars[r].order || (l = L.getOrder(e.sortInitialOrder) ? e.sortReset ? [
                        1,
                        0,
                        2
                    ] : [
                        1,
                        0
                    ] : e.sortReset ? [
                        0,
                        1,
                        2
                    ] : [
                        0,
                        1
                    ], e.sortVars[r].order = l, e.sortVars[r].count = 0), l = e.sortVars[r].order, o = (o = ("" + i[1]).match(/^(1|d|s|o|n)/)) ? o[0] : ""){
                        case "1":
                        case "d":
                            o = 1;
                            break;
                        case "s":
                            o = a || 0;
                            break;
                        case "o":
                            o = 0 === (n = l[(a || 0) % l.length]) ? 1 : 1 === n ? 0 : 2;
                            break;
                        case "n":
                            o = l[++e.sortVars[r].count % l.length];
                            break;
                        default:
                            o = 0;
                    }
                    a = 0 === s ? o : a, i = [
                        r,
                        parseInt(o, 10) || 0
                    ], e.sortList[e.sortList.length] = i, o = A.inArray(i[1], l), e.sortVars[r].count = 0 <= o ? o : i[1] % l.length;
                }
            },
            updateAll: function(e, t, r) {
                var o = e.table;
                o.isUpdating = !0, L.refreshWidgets(o, !0, !0), L.buildHeaders(e), L.bindEvents(o, e.$headers, !0), L.bindMethods(e), L.commonUpdate(e, t, r);
            },
            update: function(e, t, r) {
                e.table.isUpdating = !0, L.updateHeader(e), L.commonUpdate(e, t, r);
            },
            updateHeaders: function(e, t) {
                e.table.isUpdating = !0, L.buildHeaders(e), L.bindEvents(e.table, e.$headers, !0), L.resortComplete(e, t);
            },
            updateCell: function(e, t, r, o) {
                if (A(t).closest("tr").hasClass(e.cssChildRow)) console.warn('Tablesorter Warning! "updateCell" for child row content has been disabled, use "update" instead');
                else if (L.isEmptyObject(e.cache)) L.updateHeader(e), L.commonUpdate(e, r, o);
                else {
                    e.table.isUpdating = !0, e.$table.find(e.selectorRemove).remove();
                    var s, a, n, i, l = e.$tbodies, d = A(t), c = l.index(L.getClosest(d, "tbody")), g = e.cache[c], p = L.getClosest(d, "tr");
                    if (t = d[0], l.length && 0 <= c) {
                        if (l = l.eq(c).find("tr").not("." + e.cssChildRow).index(p), c = g.normalized[l], (i = p[0].cells.length) !== e.columns) for(s = !1, a = n = 0; a < i; a++)s || p[0].cells[a] === t ? s = !0 : n += p[0].cells[a].colSpan;
                        else n = d.index();
                        s = L.getElementText(e, t, n), c[e.columns].raw[n] = s, s = L.getParsedText(e, t, n, s), c[n] = s, "numeric" === (e.parsers[n].type || "").toLowerCase() && (g.colMax[n] = Math.max(Math.abs(s) || 0, g.colMax[n] || 0)), !1 !== (s = "undefined" !== r ? r : e.resort) ? L.checkResort(e, s, o) : L.resortComplete(e, o);
                    } else L.debug(e, "core") && console.error("updateCell aborted, tbody missing or not within the indicated table"), e.table.isUpdating = !1;
                }
            },
            addRows: function(e, t, r, o) {
                var s, a, n, i, l, d, c, g, p, u, f, h = "string" == typeof t && 1 === e.$tbodies.length && /<tr/.test(t || ""), m = e.table;
                if (h) t = A(t), e.$tbodies.append(t);
                else if (!(t && t instanceof A && L.getClosest(t, "table")[0] === e.table)) return L.debug(e, "core") && console.error("addRows method requires (1) a jQuery selector reference to rows that have already been added to the table, or (2) row HTML string to be added to a table with only one tbody"), !1;
                if (m.isUpdating = !0, L.isEmptyObject(e.cache)) L.updateHeader(e), L.commonUpdate(e, r, o);
                else {
                    for(n = t.filter("tr").attr("role", "row").length, s = e.$tbodies.index(t.parents("tbody").filter(":first")), e.parsers && e.parsers.length || L.setupParsers(e), a = 0; a < n; a++){
                        for(c = 0, l = t[a].cells.length, d = e.cache[s].normalized.length, p = [], g = {
                            child: [],
                            raw: [],
                            $row: t.eq(a),
                            order: d
                        }, i = 0; i < l; i++)u = t[a].cells[i], f = L.getElementText(e, u, c), g.raw[c] = f, f = L.getParsedText(e, u, c, f), p[c] = f, "numeric" === (e.parsers[c].type || "").toLowerCase() && (e.cache[s].colMax[c] = Math.max(Math.abs(f) || 0, e.cache[s].colMax[c] || 0)), 0 < (f = u.colSpan - 1) && (c += f), c++;
                        p[e.columns] = g, e.cache[s].normalized[d] = p;
                    }
                    L.checkResort(e, r, o);
                }
            },
            updateCache: function(e, t, r) {
                e.parsers && e.parsers.length || L.setupParsers(e, r), L.buildCache(e, t, r);
            },
            appendCache: function(e, t) {
                var r, o, s, a, n, i, l, d = e.table, c = e.$tbodies, g = [], p = e.cache;
                if (L.isEmptyObject(p)) return e.appender ? e.appender(d, g) : d.isUpdating ? e.$table.triggerHandler("updateComplete", d) : "";
                for(L.debug(e, "core") && (l = new Date), i = 0; i < c.length; i++)if ((s = c.eq(i)).length) {
                    for(a = L.processTbody(d, s, !0), o = (r = p[i].normalized).length, n = 0; n < o; n++)g[g.length] = r[n][e.columns].$row, e.appender && (!e.pager || e.pager.removeRows || e.pager.ajax) || a.append(r[n][e.columns].$row);
                    L.processTbody(d, a, !1);
                }
                e.appender && e.appender(d, g), L.debug(e, "core") && console.log("Rebuilt table" + L.benchmark(l)), t || e.appender || L.applyWidget(d), d.isUpdating && e.$table.triggerHandler("updateComplete", d);
            },
            commonUpdate: function(e, t, r) {
                e.$table.find(e.selectorRemove).remove(), L.setupParsers(e), L.buildCache(e), L.checkResort(e, t, r);
            },
            initSort: function(t, e, r) {
                if (t.table.isUpdating) return setTimeout(function() {
                    L.initSort(t, e, r);
                }, 50);
                var o, s, a, n, i, l, d, c = !r[t.sortMultiSortKey], g = t.table, p = t.$headers.length, u = L.getClosest(A(e), "th, td"), f = parseInt(u.attr("data-column"), 10), h = "mouseup" === r.type ? "user" : r.type, m = t.sortVars[f].order, u = u[0];
                if (t.$table.triggerHandler("sortStart", g), l = (t.sortVars[f].count + 1) % m.length, t.sortVars[f].count = r[t.sortResetKey] ? 2 : l, t.sortRestart) for(a = 0; a < p; a++)d = t.$headers.eq(a), f !== (l = parseInt(d.attr("data-column"), 10)) && (c || d.hasClass(L.css.sortNone)) && (t.sortVars[l].count = -1);
                if (c) {
                    if (A.each(t.sortVars, function(e) {
                        t.sortVars[e].sortedBy = "";
                    }), t.sortList = [], t.last.sortList = [], null !== t.sortForce) for(o = t.sortForce, s = 0; s < o.length; s++)o[s][0] !== f && (t.sortList[t.sortList.length] = o[s], t.sortVars[o[s][0]].sortedBy = "sortForce");
                    if ((n = m[t.sortVars[f].count]) < 2 && (t.sortList[t.sortList.length] = [
                        f,
                        n
                    ], t.sortVars[f].sortedBy = h, 1 < u.colSpan)) for(s = 1; s < u.colSpan; s++)t.sortList[t.sortList.length] = [
                        f + s,
                        n
                    ], t.sortVars[f + s].count = A.inArray(n, m), t.sortVars[f + s].sortedBy = h;
                } else if (t.sortList = A.extend([], t.last.sortList), 0 <= L.isValueInArray(f, t.sortList)) for(t.sortVars[f].sortedBy = h, s = 0; s < t.sortList.length; s++)(l = t.sortList[s])[0] === f && (l[1] = m[t.sortVars[f].count], 2 === l[1]) && (t.sortList.splice(s, 1), t.sortVars[f].count = -1);
                else if (n = m[t.sortVars[f].count], t.sortVars[f].sortedBy = h, n < 2 && (t.sortList[t.sortList.length] = [
                    f,
                    n
                ], 1 < u.colSpan)) for(s = 1; s < u.colSpan; s++)t.sortList[t.sortList.length] = [
                    f + s,
                    n
                ], t.sortVars[f + s].count = A.inArray(n, m), t.sortVars[f + s].sortedBy = h;
                if (t.last.sortList = A.extend([], t.sortList), t.sortList.length && t.sortAppend && (o = A.isArray(t.sortAppend) ? t.sortAppend : t.sortAppend[t.sortList[0][0]], !L.isEmptyObject(o))) {
                    for(s = 0; s < o.length; s++)if (o[s][0] !== f && L.isValueInArray(o[s][0], t.sortList) < 0) {
                        if (i = ("" + (n = o[s][1])).match(/^(a|d|s|o|n)/)) switch(l = t.sortList[0][1], i[0]){
                            case "d":
                                n = 1;
                                break;
                            case "s":
                                n = l;
                                break;
                            case "o":
                                n = 0 === l ? 1 : 0;
                                break;
                            case "n":
                                n = (l + 1) % m.length;
                                break;
                            default:
                                n = 0;
                        }
                        t.sortList[t.sortList.length] = [
                            o[s][0],
                            n
                        ], t.sortVars[o[s][0]].sortedBy = "sortAppend";
                    }
                }
                t.$table.triggerHandler("sortBegin", g), setTimeout(function() {
                    L.setHeadersCss(t), L.multisort(t), L.appendCache(t), t.$table.triggerHandler("sortBeforeEnd", g), t.$table.triggerHandler("sortEnd", g);
                }, 1);
            },
            multisort: function(n) {
                var e, t, i, r, l = n.table, d = [], c = 0, g = n.textSorter || "", p = n.sortList, u = p.length, o = n.$tbodies.length;
                if (!n.serverSideSorting && !L.isEmptyObject(n.cache)) {
                    if (L.debug(n, "core") && (t = new Date), "object" == typeof g) for(i = n.columns; i--;)"function" == typeof (r = L.getColumnData(l, g, i)) && (d[i] = r);
                    for(e = 0; e < o; e++)i = n.cache[e].colMax, n.cache[e].normalized.sort(function(e, t) {
                        for(var r, o, s, a = 0; a < u; a++){
                            if (r = p[a][0], o = p[a][1], c = 0 === o, n.sortStable && e[r] === t[r] && 1 === u) return e[n.columns].order - t[n.columns].order;
                            if (o = (o = /n/i.test(L.getSortType(n.parsers, r))) && n.strings[r] ? (o = "boolean" == typeof L.string[n.strings[r]] ? (c ? 1 : -1) * (L.string[n.strings[r]] ? -1 : 1) : n.strings[r] && L.string[n.strings[r]] || 0, n.numberSorter ? n.numberSorter(e[r], t[r], c, i[r], l) : L["sortNumeric" + (c ? "Asc" : "Desc")](e[r], t[r], o, i[r], r, n)) : (o = c ? e : t, s = c ? t : e, "function" == typeof g ? g(o[r], s[r], c, r, l) : "function" == typeof d[r] ? d[r](o[r], s[r], c, r, l) : L["sortNatural" + (c ? "Asc" : "Desc")](e[r] || "", t[r] || "", r, n))) return o;
                        }
                        return e[n.columns].order - t[n.columns].order;
                    });
                    L.debug(n, "core") && console.log("Applying sort " + p.toString() + L.benchmark(t));
                }
            },
            resortComplete: function(e, t) {
                e.table.isUpdating && e.$table.triggerHandler("updateComplete", e.table), A.isFunction(t) && t(e.table);
            },
            checkResort: function(e, t, r) {
                var o = A.isArray(t) ? t : e.sortList;
                !1 === (void 0 === t ? e.resort : t) || e.serverSideSorting || e.table.isProcessing ? (L.resortComplete(e, r), L.applyWidget(e.table, !1)) : o.length ? L.sortOn(e, o, function() {
                    L.resortComplete(e, r);
                }, !0) : L.sortReset(e, function() {
                    L.resortComplete(e, r), L.applyWidget(e.table, !1);
                });
            },
            sortOn: function(e, t, r, o) {
                var s, a = e.table;
                for(e.$table.triggerHandler("sortStart", a), s = 0; s < e.columns; s++)e.sortVars[s].sortedBy = -1 < L.isValueInArray(s, t) ? "sorton" : "";
                L.updateHeaderSortCount(e, t), L.setHeadersCss(e), e.delayInit && L.isEmptyObject(e.cache) && L.buildCache(e), e.$table.triggerHandler("sortBegin", a), L.multisort(e), L.appendCache(e, o), e.$table.triggerHandler("sortBeforeEnd", a), e.$table.triggerHandler("sortEnd", a), L.applyWidget(a), A.isFunction(r) && r(a);
            },
            sortReset: function(e, t) {
                var r;
                for(e.sortList = [], r = 0; r < e.columns; r++)e.sortVars[r].count = -1, e.sortVars[r].sortedBy = "";
                L.setHeadersCss(e), L.multisort(e), L.appendCache(e), A.isFunction(t) && t(e.table);
            },
            getSortType: function(e, t) {
                return e && e[t] && e[t].type || "";
            },
            getOrder: function(e) {
                return /^d/i.test(e) || 1 === e;
            },
            sortNatural: function(e, t) {
                if (e !== t) {
                    e = (e || "").toString(), t = (t || "").toString();
                    var r, o, s, a, n, i, l = L.regex;
                    if (l.hex.test(t)) {
                        if ((r = parseInt(e.match(l.hex), 16)) < (o = parseInt(t.match(l.hex), 16))) return -1;
                        if (o < r) return 1;
                    }
                    for(r = e.replace(l.chunk, "\\0$1\\0").replace(l.chunks, "").split("\\0"), o = t.replace(l.chunk, "\\0$1\\0").replace(l.chunks, "").split("\\0"), i = Math.max(r.length, o.length), n = 0; n < i; n++){
                        if (s = isNaN(r[n]) ? r[n] || 0 : parseFloat(r[n]) || 0, a = isNaN(o[n]) ? o[n] || 0 : parseFloat(o[n]) || 0, isNaN(s) !== isNaN(a)) return isNaN(s) ? 1 : -1;
                        if (typeof s != typeof a && (s += "", a += ""), s < a) return -1;
                        if (a < s) return 1;
                    }
                }
                return 0;
            },
            sortNaturalAsc: function(e, t, r, o) {
                return e === t ? 0 : (r = L.string[o.empties[r] || o.emptyTo], "" === e && 0 !== r ? "boolean" == typeof r ? r ? -1 : 1 : -r || -1 : "" === t && 0 !== r ? "boolean" == typeof r ? r ? 1 : -1 : r || 1 : L.sortNatural(e, t));
            },
            sortNaturalDesc: function(e, t, r, o) {
                return e === t ? 0 : (r = L.string[o.empties[r] || o.emptyTo], "" === e && 0 !== r ? "boolean" == typeof r ? r ? -1 : 1 : r || 1 : "" === t && 0 !== r ? "boolean" == typeof r ? r ? 1 : -1 : -r || -1 : L.sortNatural(t, e));
            },
            sortText: function(e, t) {
                return t < e ? 1 : e < t ? -1 : 0;
            },
            getTextValue: function(e, t, r) {
                if (r) {
                    for(var o = e ? e.length : 0, s = r + t, a = 0; a < o; a++)s += e.charCodeAt(a);
                    return t * s;
                }
                return 0;
            },
            sortNumericAsc: function(e, t, r, o, s, a) {
                return e === t ? 0 : (s = L.string[a.empties[s] || a.emptyTo], "" === e && 0 !== s ? "boolean" == typeof s ? s ? -1 : 1 : -s || -1 : "" === t && 0 !== s ? "boolean" == typeof s ? s ? 1 : -1 : s || 1 : (e = isNaN(e) ? L.getTextValue(e, r, o) : e) - (t = isNaN(t) ? L.getTextValue(t, r, o) : t));
            },
            sortNumericDesc: function(e, t, r, o, s, a) {
                return e === t ? 0 : (s = L.string[a.empties[s] || a.emptyTo], "" === e && 0 !== s ? "boolean" == typeof s ? s ? -1 : 1 : s || 1 : "" === t && 0 !== s ? "boolean" == typeof s ? s ? 1 : -1 : -s || -1 : (isNaN(e) && (e = L.getTextValue(e, r, o)), (t = isNaN(t) ? L.getTextValue(t, r, o) : t) - e));
            },
            sortNumeric: function(e, t) {
                return e - t;
            },
            addWidget: function(e) {
                e.id && !L.isEmptyObject(L.getWidgetById(e.id)) && console.warn('"' + e.id + '" widget was loaded more than once!'), L.widgets[L.widgets.length] = e;
            },
            hasWidget: function(e, t) {
                return (e = A(e)).length && e[0].config && e[0].config.widgetInit[t] || !1;
            },
            getWidgetById: function(e) {
                for(var t, r = L.widgets.length, o = 0; o < r; o++)if ((t = L.widgets[o]) && t.id && t.id.toLowerCase() === e.toLowerCase()) return t;
            },
            applyWidgetOptions: function(e) {
                var t, r, o, s = e.config, a = s.widgets.length;
                if (a) for(t = 0; t < a; t++)(r = L.getWidgetById(s.widgets[t])) && r.options && (o = A.extend(!0, {}, r.options), s.widgetOptions = A.extend(!0, o, s.widgetOptions), A.extend(!0, L.defaults.widgetOptions, r.options));
            },
            addWidgetFromClass: function(e) {
                var t, r, o = e.config, s = "^" + o.widgetClass.replace(L.regex.templateName, "(\\S+)+") + "$", a = new RegExp(s, "g"), n = (e.className || "").split(L.regex.spaces);
                if (n.length) for(t = n.length, r = 0; r < t; r++)n[r].match(a) && (o.widgets[o.widgets.length] = n[r].replace(a, "$1"));
            },
            applyWidgetId: function(e, t, r) {
                var o, s, a, n = (e = A(e)[0]).config, i = n.widgetOptions, l = L.debug(n, "core"), t = L.getWidgetById(t);
                t && (a = t.id, o = !1, A.inArray(a, n.widgets) < 0 && (n.widgets[n.widgets.length] = a), l && (s = new Date), !r && n.widgetInit[a] || (n.widgetInit[a] = !0, e.hasInitialized && L.applyWidgetOptions(e), "function" == typeof t.init && (o = !0, l && console[console.group ? "group" : "log"]("Initializing " + a + " widget"), t.init(e, t, n, i))), r || "function" != typeof t.format || (o = !0, l && console[console.group ? "group" : "log"]("Updating " + a + " widget"), t.format(e, n, i, !1)), l) && o && (console.log("Completed " + (r ? "initializing " : "applying ") + a + " widget" + L.benchmark(s)), console.groupEnd) && console.groupEnd();
            },
            applyWidget: function(e, t, r) {
                var o, s, a, n, i, l = (e = A(e)[0]).config, d = L.debug(l, "core"), c = [];
                if (!1 === t || !e.hasInitialized || !e.isApplyingWidgets && !e.isUpdating) {
                    if (d && (i = new Date), L.addWidgetFromClass(e), clearTimeout(l.timerReady), l.widgets.length) {
                        for(e.isApplyingWidgets = !0, l.widgets = A.grep(l.widgets, function(e, t) {
                            return A.inArray(e, l.widgets) === t;
                        }), s = (a = l.widgets || []).length, o = 0; o < s; o++)(n = L.getWidgetById(a[o])) && n.id ? (n.priority || (n.priority = 10), c[o] = n) : d && console.warn('"' + a[o] + '" was enabled, but the widget code has not been loaded!');
                        for(c.sort(function(e, t) {
                            return e.priority < t.priority ? -1 : e.priority === t.priority ? 0 : 1;
                        }), s = c.length, d && console[console.group ? "group" : "log"]("Start " + (t ? "initializing" : "applying") + " widgets"), o = 0; o < s; o++)(n = c[o]) && n.id && L.applyWidgetId(e, n.id, t);
                        d && console.groupEnd && console.groupEnd();
                    }
                    l.timerReady = setTimeout(function() {
                        e.isApplyingWidgets = !1, A.data(e, "lastWidgetApplication", new Date), l.$table.triggerHandler("tablesorter-ready"), t || "function" != typeof r || r(e), d && (n = l.widgets.length, console.log("Completed " + (!0 === t ? "initializing " : "applying ") + n + " widget" + (1 !== n ? "s" : "") + L.benchmark(i)));
                    }, 10);
                }
            },
            removeWidget: function(e, t, r) {
                var o, s, a, n, i = (e = A(e)[0]).config;
                if (!0 === t) for(t = [], n = L.widgets.length, a = 0; a < n; a++)(s = L.widgets[a]) && s.id && (t[t.length] = s.id);
                else t = (A.isArray(t) ? t.join(",") : t || "").toLowerCase().split(/[\s,]+/);
                for(n = t.length, o = 0; o < n; o++)s = L.getWidgetById(t[o]), 0 <= (a = A.inArray(t[o], i.widgets)) && !0 !== r && i.widgets.splice(a, 1), s && s.remove && (L.debug(i, "core") && console.log((r ? "Refreshing" : "Removing") + ' "' + t[o] + '" widget'), s.remove(e, i, i.widgetOptions, r), i.widgetInit[t[o]] = !1);
                i.$table.triggerHandler("widgetRemoveEnd", e);
            },
            refreshWidgets: function(e, t, r) {
                for(var o, s = (e = A(e)[0]).config.widgets, a = L.widgets, n = a.length, i = [], l = function(e) {
                    A(e).triggerHandler("refreshComplete");
                }, d = 0; d < n; d++)(o = a[d]) && o.id && (t || A.inArray(o.id, s) < 0) && (i[i.length] = o.id);
                L.removeWidget(e, i.join(","), !0), !0 !== r ? (L.applyWidget(e, t || !1, l), t && L.applyWidget(e, !1, l)) : l(e);
            },
            benchmark: function(e) {
                return " (" + ((new Date).getTime() - e.getTime()) + " ms)";
            },
            log: function() {
                console.log(arguments);
            },
            debug: function(e, t) {
                return e && (!0 === e.debug || "string" == typeof e.debug && -1 < e.debug.indexOf(t));
            },
            isEmptyObject: function(e) {
                for(var t in e)return !1;
                return !0;
            },
            isValueInArray: function(e, t) {
                for(var r = t && t.length || 0, o = 0; o < r; o++)if (t[o][0] === e) return o;
                return -1;
            },
            formatFloat: function(e, t) {
                return "string" != typeof e || "" === e ? e : (e = (t && t.config ? !1 !== t.config.usNumberFormat : void 0 === t || t) ? e.replace(L.regex.comma, "") : e.replace(L.regex.digitNonUS, "").replace(L.regex.comma, "."), L.regex.digitNegativeTest.test(e) && (e = e.replace(L.regex.digitNegativeReplace, "-$1")), t = parseFloat(e), isNaN(t) ? A.trim(e) : t);
            },
            isDigit: function(e) {
                return isNaN(e) ? L.regex.digitTest.test(e.toString().replace(L.regex.digitReplace, "")) : "" !== e;
            },
            computeColumnIndex: function(e, t) {
                for(var r, o, s, a, n, i, l, d, c, g = t && t.columns || 0, p = [], u = new Array(g), f = 0; f < e.length; f++)for(n = e[f].cells, r = 0; r < n.length; r++){
                    for(i = f, l = (a = n[r]).rowSpan || 1, d = a.colSpan || 1, void 0 === p[i] && (p[i] = []), o = 0; o < p[i].length + 1; o++)if (void 0 === p[i][o]) {
                        c = o;
                        break;
                    }
                    for(g && a.cellIndex === c || (a.setAttribute ? a.setAttribute("data-column", c) : A(a).attr("data-column", c)), o = i; o < i + l; o++)for(void 0 === p[o] && (p[o] = []), u = p[o], s = c; s < c + d; s++)u[s] = "x";
                }
                return L.checkColumnCount(e, p, u.length), u.length;
            },
            checkColumnCount: function(e, t, r) {
                for(var o, s = !0, a = [], n = 0; n < t.length; n++)if (t[n] && (o = t[n].length, t[n].length !== r)) {
                    s = !1;
                    break;
                }
                s || (e.each(function(e, t) {
                    t = t.parentElement.nodeName;
                    a.indexOf(t) < 0 && a.push(t);
                }), console.error("Invalid or incorrect number of columns in the " + a.join(" or ") + "; expected " + r + ", but found " + o + " columns"));
            },
            fixColumnWidth: function(e) {
                var t, r, o, s, a, e = (e = A(e)[0]).config, n = e.$table.children("colgroup");
                if (n.length && n.hasClass(L.css.colgroup) && n.remove(), e.widthFixed && 0 === e.$table.children("colgroup").length) {
                    for(n = A('<colgroup class="' + L.css.colgroup + '">'), t = e.$table.width(), s = (o = e.$tbodies.find("tr:first").children(":visible")).length, a = 0; a < s; a++)r = parseInt(o.eq(a).width() / t * 1e3, 10) / 10 + "%", n.append(A("<col>").css("width", r));
                    e.$table.prepend(n);
                }
            },
            getData: function(e, t, r) {
                var o, s, a = "", e = A(e);
                return e.length ? (o = !!A.metadata && e.metadata(), s = " " + (e.attr("class") || ""), void 0 !== e.data(r) || void 0 !== e.data(r.toLowerCase()) ? a += e.data(r) || e.data(r.toLowerCase()) : o && void 0 !== o[r] ? a += o[r] : t && void 0 !== t[r] ? a += t[r] : " " !== s && s.match(" " + r + "-") && (a = s.match(new RegExp("\\s" + r + "-([\\w-]+)"))[1] || ""), A.trim(a)) : "";
            },
            getColumnData: function(e, t, r, o, s) {
                if ("object" != typeof t || null === t) return t;
                var a, e = (e = A(e)[0]).config, s = s || e.$headers, n = e.$headerIndexed && e.$headerIndexed[r] || s.find('[data-column="' + r + '"]:last');
                if (void 0 !== t[r]) return o ? t[r] : t[s.index(n)];
                for(a in t)if ("string" == typeof a && n.filter(a).add(n.find(a)).length) return t[a];
            },
            isProcessing: function(e, t, r) {
                var o = (e = A(e))[0].config, s = r || e.find("." + L.css.header);
                t ? (void 0 !== r && 0 < o.sortList.length && (s = s.filter(function() {
                    return !this.sortDisabled && 0 <= L.isValueInArray(parseFloat(A(this).attr("data-column")), o.sortList);
                })), e.add(s).addClass(L.css.processing + " " + o.cssProcessing)) : e.add(s).removeClass(L.css.processing + " " + o.cssProcessing);
            },
            processTbody: function(e, t, r) {
                if (e = A(e)[0], r) return e.isProcessing = !0, t.before('<colgroup class="tablesorter-savemyplace"/>'), A.fn.detach ? t.detach() : t.remove();
                r = A(e).find("colgroup.tablesorter-savemyplace");
                t.insertAfter(r), r.remove(), e.isProcessing = !1;
            },
            clearTableBody: function(e) {
                A(e)[0].config.$tbodies.children().detach();
            },
            characterEquivalents: {
                a: "\xe1\xe0\xe2\xe3\xe4\u0105\xe5",
                A: "\xc1\xc0\xc2\xc3\xc4\u0104\xc5",
                c: "\xe7\u0107\u010D",
                C: "\xc7\u0106\u010C",
                e: "\xe9\xe8\xea\xeb\u011B\u0119",
                E: "\xc9\xc8\xca\xcb\u011A\u0118",
                i: "\xed\xec\u0130\xee\xef\u0131",
                I: "\xcd\xcc\u0130\xce\xcf",
                o: "\xf3\xf2\xf4\xf5\xf6\u014D",
                O: "\xd3\xd2\xd4\xd5\xd6\u014C",
                ss: "\xdf",
                SS: "\u1E9E",
                u: "\xfa\xf9\xfb\xfc\u016F",
                U: "\xda\xd9\xdb\xdc\u016E"
            },
            replaceAccents: function(e) {
                var t, r = "[", o = L.characterEquivalents;
                if (!L.characterRegex) {
                    for(t in L.characterRegexArray = {}, o)"string" == typeof t && (r += o[t], L.characterRegexArray[t] = new RegExp("[" + o[t] + "]", "g"));
                    L.characterRegex = new RegExp(r + "]");
                }
                if (L.characterRegex.test(e)) for(t in o)"string" == typeof t && (e = e.replace(L.characterRegexArray[t], t));
                return e;
            },
            validateOptions: function(e) {
                var t, r, o, s, a = "headers sortForce sortList sortAppend widgets".split(" "), n = e.originalSettings;
                if (n) {
                    for(t in L.debug(e, "core") && (s = new Date), n)if ("undefined" === (o = typeof L.defaults[t])) console.warn('Tablesorter Warning! "table.config.' + t + '" option not recognized');
                    else if ("object" === o) for(r in n[t])o = L.defaults[t] && typeof L.defaults[t][r], A.inArray(t, a) < 0 && "undefined" === o && console.warn('Tablesorter Warning! "table.config.' + t + "." + r + '" option not recognized');
                    L.debug(e, "core") && console.log("validate options time:" + L.benchmark(s));
                }
            },
            restoreHeaders: function(e) {
                for(var t, r = A(e)[0].config, o = r.$table.find(r.selectorHeaders), s = o.length, a = 0; a < s; a++)(t = o.eq(a)).find("." + L.css.headerIn).length && t.html(r.headerContent[a]);
            },
            destroy: function(e, t, r) {
                var o, s, a, n, i;
                (e = A(e)[0]).hasInitialized && (L.removeWidget(e, !0, !1), o = A(e), s = e.config, n = (a = o.find("thead:first")).find("tr." + L.css.headerRow).removeClass(L.css.headerRow + " " + s.cssHeaderRow), i = o.find("tfoot:first > tr").children("th, td"), !1 === t && 0 <= A.inArray("uitheme", s.widgets) && (o.triggerHandler("applyWidgetId", [
                    "uitheme"
                ]), o.triggerHandler("applyWidgetId", [
                    "zebra"
                ])), a.find("tr").not(n).remove(), a = "sortReset update updateRows updateAll updateHeaders updateCell addRows updateComplete sorton appendCache updateCache applyWidgetId applyWidgets refreshWidgets removeWidget destroy mouseup mouseleave " + "keypress sortBegin sortEnd resetToLoadState ".split(" ").join(s.namespace + " "), o.removeData("tablesorter").unbind(a.replace(L.regex.spaces, " ")), s.$headers.add(i).removeClass([
                    L.css.header,
                    s.cssHeader,
                    s.cssAsc,
                    s.cssDesc,
                    L.css.sortAsc,
                    L.css.sortDesc,
                    L.css.sortNone
                ].join(" ")).removeAttr("data-column").removeAttr("aria-label").attr("aria-disabled", "true"), n.find(s.selectorSort).unbind("mousedown mouseup keypress ".split(" ").join(s.namespace + " ").replace(L.regex.spaces, " ")), L.restoreHeaders(e), o.toggleClass(L.css.table + " " + s.tableClass + " tablesorter-" + s.theme, !1 === t), o.removeClass(s.namespace.slice(1)), e.hasInitialized = !1, delete e.config.cache, "function" == typeof r && r(e), L.debug(s, "core")) && console.log("tablesorter has been removed");
            }
        };
        A.fn.tablesorter = function(t) {
            return this.each(function() {
                var e = A.extend(!0, {}, L.defaults, t, L.instanceMethods);
                e.originalSettings = t, !this.hasInitialized && L.buildTable && "TABLE" !== this.nodeName ? L.buildTable(this, e) : L.setup(this, e);
            });
        }, window.console && window.console.log || (L.logs = [], (console = {}).log = console.warn = console.error = console.table = function() {
            var e = 1 < arguments.length ? arguments : arguments[0];
            L.logs[L.logs.length] = {
                date: Date.now(),
                log: e
            };
        }), L.addParser({
            id: "no-parser",
            is: function() {
                return !1;
            },
            format: function() {
                return "";
            },
            type: "text"
        }), L.addParser({
            id: "text",
            is: function() {
                return !0;
            },
            format: function(e, t) {
                t = t.config;
                return e && (e = A.trim(t.ignoreCase ? e.toLocaleLowerCase() : e), e = t.sortLocaleCompare ? L.replaceAccents(e) : e), e;
            },
            type: "text"
        }), L.regex.nondigit = /[^\w,. \-()]/g, L.addParser({
            id: "digit",
            is: function(e) {
                return L.isDigit(e);
            },
            format: function(e, t) {
                var r = L.formatFloat((e || "").replace(L.regex.nondigit, ""), t);
                return e && "number" == typeof r ? r : e && A.trim(e && t.config.ignoreCase ? e.toLocaleLowerCase() : e);
            },
            type: "numeric"
        }), L.regex.currencyReplace = /[+\-,. ]/g, L.regex.currencyTest = /^\(?\d+[\u00a3$\u20ac\u00a4\u00a5\u00a2?.]|[\u00a3$\u20ac\u00a4\u00a5\u00a2?.]\d+\)?$/, L.addParser({
            id: "currency",
            is: function(e) {
                return e = (e || "").replace(L.regex.currencyReplace, ""), L.regex.currencyTest.test(e);
            },
            format: function(e, t) {
                var r = L.formatFloat((e || "").replace(L.regex.nondigit, ""), t);
                return e && "number" == typeof r ? r : e && A.trim(e && t.config.ignoreCase ? e.toLocaleLowerCase() : e);
            },
            type: "numeric"
        }), L.regex.urlProtocolTest = /^(https?|ftp|file):\/\//, L.regex.urlProtocolReplace = /(https?|ftp|file):\/\/(www\.)?/, L.addParser({
            id: "url",
            is: function(e) {
                return L.regex.urlProtocolTest.test(e);
            },
            format: function(e) {
                return e && A.trim(e.replace(L.regex.urlProtocolReplace, ""));
            },
            type: "text"
        }), L.regex.dash = /-/g, L.regex.isoDate = /^\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}/, L.addParser({
            id: "isoDate",
            is: function(e) {
                return L.regex.isoDate.test(e);
            },
            format: function(e) {
                var t = e && new Date(e.replace(L.regex.dash, "/"));
                return t instanceof Date && isFinite(t) ? t.getTime() : e;
            },
            type: "numeric"
        }), L.regex.percent = /%/g, L.regex.percentTest = /(\d\s*?%|%\s*?\d)/, L.addParser({
            id: "percent",
            is: function(e) {
                return L.regex.percentTest.test(e) && e.length < 15;
            },
            format: function(e, t) {
                return e && L.formatFloat(e.replace(L.regex.percent, ""), t);
            },
            type: "numeric"
        }), L.addParser({
            id: "image",
            is: function(e, t, r, o) {
                return 0 < o.find("img").length;
            },
            format: function(e, t, r) {
                return A(r).find("img").attr(t.config.imgAttr || "alt") || e;
            },
            parsed: !0,
            type: "text"
        }), L.regex.dateReplace = /(\S)([AP]M)$/i, L.regex.usLongDateTest1 = /^[A-Z]{3,10}\.?\s+\d{1,2},?\s+(\d{4})(\s+\d{1,2}:\d{2}(:\d{2})?(\s+[AP]M)?)?$/i, L.regex.usLongDateTest2 = /^\d{1,2}\s+[A-Z]{3,10}\s+\d{4}/i, L.addParser({
            id: "usLongDate",
            is: function(e) {
                return L.regex.usLongDateTest1.test(e) || L.regex.usLongDateTest2.test(e);
            },
            format: function(e) {
                var t = e && new Date(e.replace(L.regex.dateReplace, "$1 $2"));
                return t instanceof Date && isFinite(t) ? t.getTime() : e;
            },
            type: "numeric"
        }), L.regex.shortDateTest = /(^\d{1,2}[\/\s]\d{1,2}[\/\s]\d{4})|(^\d{4}[\/\s]\d{1,2}[\/\s]\d{1,2})/, L.regex.shortDateReplace = /[\-.,]/g, L.regex.shortDateXXY = /(\d{1,2})[\/\s](\d{1,2})[\/\s](\d{4})/, L.regex.shortDateYMD = /(\d{4})[\/\s](\d{1,2})[\/\s](\d{1,2})/, L.convertFormat = function(e, t) {
            e = (e || "").replace(L.regex.spaces, " ").replace(L.regex.shortDateReplace, "/"), "mmddyyyy" === t ? e = e.replace(L.regex.shortDateXXY, "$3/$1/$2") : "ddmmyyyy" === t ? e = e.replace(L.regex.shortDateXXY, "$3/$2/$1") : "yyyymmdd" === t && (e = e.replace(L.regex.shortDateYMD, "$1/$2/$3"));
            t = new Date(e);
            return t instanceof Date && isFinite(t) ? t.getTime() : "";
        }, L.addParser({
            id: "shortDate",
            is: function(e) {
                return e = (e || "").replace(L.regex.spaces, " ").replace(L.regex.shortDateReplace, "/"), L.regex.shortDateTest.test(e);
            },
            format: function(e, t, r, o) {
                var s, a;
                return e && (t = (a = (s = t.config).$headerIndexed[o]).length && a.data("dateFormat") || L.getData(a, L.getColumnData(t, s.headers, o), "dateFormat") || s.dateFormat, a.length && a.data("dateFormat", t), L.convertFormat(e, t) || e);
            },
            type: "numeric"
        }), L.regex.timeTest = /^(0?[1-9]|1[0-2]):([0-5]\d)(\s[AP]M)$|^((?:[01]\d|[2][0-4]):[0-5]\d)$/i, L.regex.timeMatch = /(0?[1-9]|1[0-2]):([0-5]\d)(\s[AP]M)|((?:[01]\d|[2][0-4]):[0-5]\d)/i, L.addParser({
            id: "time",
            is: function(e) {
                return L.regex.timeTest.test(e);
            },
            format: function(e) {
                var t = (e || "").match(L.regex.timeMatch), r = new Date(e), t = e && (null !== t ? t[0] : "00:00 AM"), t = t && new Date("2000/01/01 " + t.replace(L.regex.dateReplace, "$1 $2"));
                return t instanceof Date && isFinite(t) ? (r instanceof Date && isFinite(r) ? r.getTime() : 0) ? parseFloat(t.getTime() + "." + r.getTime()) : t.getTime() : e;
            },
            type: "numeric"
        }), L.addParser({
            id: "metadata",
            is: function() {
                return !1;
            },
            format: function(e, t, r) {
                t = t.config, t = t.parserMetadataName || "sortValue";
                return A(r).metadata()[t];
            },
            type: "numeric"
        }), L.addWidget({
            id: "zebra",
            priority: 90,
            format: function(e, t, r) {
                for(var o, s, a, n, i, l = new RegExp(t.cssChildRow, "i"), d = t.$tbodies.add(A(t.namespace + "_extra_table").children("tbody:not(." + t.cssInfoBlock + ")")), c = 0; c < d.length; c++)for(s = 0, i = (o = d.eq(c).children("tr:visible").not(t.selectorRemove)).length, n = 0; n < i; n++)a = o.eq(n), l.test(a[0].className) || s++, a.removeClass(r.zebra[(a = s % 2 == 0) ? 1 : 0]).addClass(r.zebra[a ? 0 : 1]);
            },
            remove: function(e, t, r, o) {
                if (!o) for(var s, a = t.$tbodies, n = (r.zebra || [
                    "even",
                    "odd"
                ]).join(" "), i = 0; i < a.length; i++)(s = L.processTbody(e, a.eq(i), !0)).children().removeClass(n), L.processTbody(e, s, !1);
            }
        });
    }(e), e.tablesorter;
});



var $873d83480dd9dfc8$exports = {};
/**
* Tom Select v2.4.3
* Licensed under the Apache License, Version 2.0 (the "License");
*/ !function(e, t) {
    $873d83480dd9dfc8$exports = t();
}($873d83480dd9dfc8$exports, function() {
    "use strict";
    function e(e, t) {
        e.split(/\s+/).forEach((e)=>{
            t(e);
        });
    }
    class t {
        constructor(){
            this._events = {};
        }
        on(t, s) {
            e(t, (e)=>{
                const t = this._events[e] || [];
                t.push(s), this._events[e] = t;
            });
        }
        off(t, s) {
            var i = arguments.length;
            0 !== i ? e(t, (e)=>{
                if (1 === i) return void delete this._events[e];
                const t = this._events[e];
                void 0 !== t && (t.splice(t.indexOf(s), 1), this._events[e] = t);
            }) : this._events = {};
        }
        trigger(t, ...s) {
            var i = this;
            e(t, (e)=>{
                const t = i._events[e];
                void 0 !== t && t.forEach((e)=>{
                    e.apply(i, s);
                });
            });
        }
    }
    const s = (e)=>(e = e.filter(Boolean)).length < 2 ? e[0] || "" : 1 == l(e) ? "[" + e.join("") + "]" : "(?:" + e.join("|") + ")", i = (e)=>{
        if (!o(e)) return e.join("");
        let t = "", s = 0;
        const i = ()=>{
            s > 1 && (t += "{" + s + "}");
        };
        return e.forEach((n, o)=>{
            n !== e[o - 1] ? (i(), t += n, s = 1) : s++;
        }), i(), t;
    }, n = (e)=>{
        let t = Array.from(e);
        return s(t);
    }, o = (e)=>new Set(e).size !== e.length, r = (e)=>(e + "").replace(/([\$\(\)\*\+\.\?\[\]\^\{\|\}\\])/gu, "\\$1"), l = (e)=>e.reduce((e, t)=>Math.max(e, a(t)), 0), a = (e)=>Array.from(e).length, c = (e)=>{
        if (1 === e.length) return [
            [
                e
            ]
        ];
        let t = [];
        const s = e.substring(1);
        return c(s).forEach(function(s) {
            let i = s.slice(0);
            i[0] = e.charAt(0) + i[0], t.push(i), i = s.slice(0), i.unshift(e.charAt(0)), t.push(i);
        }), t;
    }, d = [
        [
            0,
            65535
        ]
    ];
    let u, p;
    const h = {}, g = {
        "/": "\u2044\u2215",
        0: "\u07C0",
        a: "\u2C65\u0250\u0251",
        aa: "\uA733",
        ae: "\xe6\u01FD\u01E3",
        ao: "\uA735",
        au: "\uA737",
        av: "\uA739\uA73B",
        ay: "\uA73D",
        b: "\u0180\u0253\u0183",
        c: "\uA73F\u0188\u023C\u2184",
        d: "\u0111\u0257\u0256\u1D05\u018C\uABB7\u0501\u0266",
        e: "\u025B\u01DD\u1D07\u0247",
        f: "\uA77C\u0192",
        g: "\u01E5\u0260\uA7A1\u1D79\uA77F\u0262",
        h: "\u0127\u2C68\u2C76\u0265",
        i: "\u0268\u0131",
        j: "\u0249\u0237",
        k: "\u0199\u2C6A\uA741\uA743\uA745\uA7A3",
        l: "\u0142\u019A\u026B\u2C61\uA749\uA747\uA781\u026D",
        m: "\u0271\u026F\u03FB",
        n: "\uA7A5\u019E\u0272\uA791\u1D0E\u043B\u0509",
        o: "\xf8\u01FF\u0254\u0275\uA74B\uA74D\u1D11",
        oe: "\u0153",
        oi: "\u01A3",
        oo: "\uA74F",
        ou: "\u0223",
        p: "\u01A5\u1D7D\uA751\uA753\uA755\u03C1",
        q: "\uA757\uA759\u024B",
        r: "\u024D\u027D\uA75B\uA7A7\uA783",
        s: "\xdf\u023F\uA7A9\uA785\u0282",
        t: "\u0167\u01AD\u0288\u2C66\uA787",
        th: "\xfe",
        tz: "\uA729",
        u: "\u0289",
        v: "\u028B\uA75F\u028C",
        vy: "\uA761",
        w: "\u2C73",
        y: "\u01B4\u024F\u1EFF",
        z: "\u01B6\u0225\u0240\u2C6C\uA763",
        hv: "\u0195"
    };
    for(let e in g){
        let t = g[e] || "";
        for(let s = 0; s < t.length; s++){
            let i = t.substring(s, s + 1);
            h[i] = e;
        }
    }
    const f = new RegExp(Object.keys(h).join("|") + "|[\u0300-\u036F\xb7\u02BE\u02BC]", "gu"), m = (e, t = "NFKD")=>e.normalize(t), v = (e)=>Array.from(e).reduce((e, t)=>e + y(t), ""), y = (e)=>(e = m(e).toLowerCase().replace(f, (e)=>h[e] || ""), m(e, "NFC"));
    const O = (e)=>{
        const t = {}, s = (e, s)=>{
            const i = t[e] || new Set, o = new RegExp("^" + n(i) + "$", "iu");
            s.match(o) || (i.add(r(s)), t[e] = i);
        };
        for (let t of function*(e) {
            for (const [t, s] of e)for(let e = t; e <= s; e++){
                let t = String.fromCharCode(e), s = v(t);
                s != t.toLowerCase() && (s.length > 3 || 0 != s.length && (yield {
                    folded: s,
                    composed: t,
                    code_point: e
                }));
            }
        }(e))s(t.folded, t.folded), s(t.folded, t.composed);
        return t;
    }, b = (e)=>{
        const t = O(e), i = {};
        let o = [];
        for(let e in t){
            let s = t[e];
            s && (i[e] = n(s)), e.length > 1 && o.push(r(e));
        }
        o.sort((e, t)=>t.length - e.length);
        const l = s(o);
        return p = new RegExp("^" + l, "u"), i;
    }, w = (e, t = 1)=>(t = Math.max(t, e.length - 1), s(c(e).map((e)=>((e, t = 1)=>{
                let s = 0;
                return e = e.map((e)=>(u[e] && (s += e.length), u[e] || e)), s >= t ? i(e) : "";
            })(e, t)))), _ = (e, t = !0)=>{
        let n = e.length > 1 ? 1 : 0;
        return s(e.map((e)=>{
            let s = [];
            const o = t ? e.length() : e.length() - 1;
            for(let t = 0; t < o; t++)s.push(w(e.substrs[t] || "", n));
            return i(s);
        }));
    }, C = (e, t)=>{
        for (const s of t){
            if (s.start != e.start || s.end != e.end) continue;
            if (s.substrs.join("") !== e.substrs.join("")) continue;
            let t = e.parts;
            const i = (e)=>{
                for (const s of t){
                    if (s.start === e.start && s.substr === e.substr) return !1;
                    if (1 != e.length && 1 != s.length) {
                        if (e.start < s.start && e.end > s.start) return !0;
                        if (s.start < e.start && s.end > e.start) return !0;
                    }
                }
                return !1;
            };
            if (!(s.parts.filter(i).length > 0)) return !0;
        }
        return !1;
    };
    class S {
        parts;
        substrs;
        start;
        end;
        constructor(){
            this.parts = [], this.substrs = [], this.start = 0, this.end = 0;
        }
        add(e) {
            e && (this.parts.push(e), this.substrs.push(e.substr), this.start = Math.min(e.start, this.start), this.end = Math.max(e.end, this.end));
        }
        last() {
            return this.parts[this.parts.length - 1];
        }
        length() {
            return this.parts.length;
        }
        clone(e, t) {
            let s = new S, i = JSON.parse(JSON.stringify(this.parts)), n = i.pop();
            for (const e of i)s.add(e);
            let o = t.substr.substring(0, e - n.start), r = o.length;
            return s.add({
                start: n.start,
                end: n.start + r,
                length: r,
                substr: o
            }), s;
        }
    }
    const I = (e)=>{
        void 0 === u && (u = b(d)), e = v(e);
        let t = "", s = [
            new S
        ];
        for(let i = 0; i < e.length; i++){
            let n = e.substring(i).match(p);
            const o = e.substring(i, i + 1), r = n ? n[0] : null;
            let l = [], a = new Set;
            for (const e of s){
                const t = e.last();
                if (!t || 1 == t.length || t.end <= i) {
                    if (r) {
                        const t = r.length;
                        e.add({
                            start: i,
                            end: i + t,
                            length: t,
                            substr: r
                        }), a.add("1");
                    } else e.add({
                        start: i,
                        end: i + 1,
                        length: 1,
                        substr: o
                    }), a.add("2");
                } else if (r) {
                    let s = e.clone(i, t);
                    const n = r.length;
                    s.add({
                        start: i,
                        end: i + n,
                        length: n,
                        substr: r
                    }), l.push(s);
                } else a.add("3");
            }
            if (l.length > 0) {
                l = l.sort((e, t)=>e.length() - t.length());
                for (let e of l)C(e, s) || s.push(e);
            } else if (i > 0 && 1 == a.size && !a.has("3")) {
                t += _(s, !1);
                let e = new S;
                const i = s[0];
                i && e.add(i.last()), s = [
                    e
                ];
            }
        }
        return t += _(s, !0), t;
    }, A = (e, t)=>{
        if (e) return e[t];
    }, k = (e, t)=>{
        if (e) {
            for(var s, i = t.split("."); (s = i.shift()) && (e = e[s]););
            return e;
        }
    }, x = (e, t, s)=>{
        var i, n;
        return e ? (e += "", null == t.regex || -1 === (n = e.search(t.regex)) ? 0 : (i = t.string.length / e.length, 0 === n && (i += .5), i * s)) : 0;
    }, F = (e, t)=>{
        var s = e[t];
        if ("function" == typeof s) return s;
        s && !Array.isArray(s) && (e[t] = [
            s
        ]);
    }, L = (e, t)=>{
        if (Array.isArray(e)) e.forEach(t);
        else for(var s in e)e.hasOwnProperty(s) && t(e[s], s);
    }, E = (e, t)=>"number" == typeof e && "number" == typeof t ? e > t ? 1 : e < t ? -1 : 0 : (e = v(e + "").toLowerCase()) > (t = v(t + "").toLowerCase()) ? 1 : t > e ? -1 : 0;
    class T {
        items;
        settings;
        constructor(e, t){
            this.items = e, this.settings = t || {
                diacritics: !0
            };
        }
        tokenize(e, t, s) {
            if (!e || !e.length) return [];
            const i = [], n = e.split(/\s+/);
            var o;
            return s && (o = new RegExp("^(" + Object.keys(s).map(r).join("|") + "):(.*)$")), n.forEach((e)=>{
                let s, n = null, l = null;
                o && (s = e.match(o)) && (n = s[1], e = s[2]), e.length > 0 && (l = this.settings.diacritics ? I(e) || null : r(e), l && t && (l = "\\b" + l)), i.push({
                    string: e,
                    regex: l ? new RegExp(l, "iu") : null,
                    field: n
                });
            }), i;
        }
        getScoreFunction(e, t) {
            var s = this.prepareSearch(e, t);
            return this._getScoreFunction(s);
        }
        _getScoreFunction(e) {
            const t = e.tokens, s = t.length;
            if (!s) return function() {
                return 0;
            };
            const i = e.options.fields, n = e.weights, o = i.length, r = e.getAttrFn;
            if (!o) return function() {
                return 1;
            };
            const l = 1 === o ? function(e, t) {
                const s = i[0].field;
                return x(r(t, s), e, n[s] || 1);
            } : function(e, t) {
                var s = 0;
                if (e.field) {
                    const i = r(t, e.field);
                    !e.regex && i ? s += 1 / o : s += x(i, e, 1);
                } else L(n, (i, n)=>{
                    s += x(r(t, n), e, i);
                });
                return s / o;
            };
            return 1 === s ? function(e) {
                return l(t[0], e);
            } : "and" === e.options.conjunction ? function(e) {
                var i, n = 0;
                for (let s of t){
                    if ((i = l(s, e)) <= 0) return 0;
                    n += i;
                }
                return n / s;
            } : function(e) {
                var i = 0;
                return L(t, (t)=>{
                    i += l(t, e);
                }), i / s;
            };
        }
        getSortFunction(e, t) {
            var s = this.prepareSearch(e, t);
            return this._getSortFunction(s);
        }
        _getSortFunction(e) {
            var t, s = [];
            const i = this, n = e.options, o = !e.query && n.sort_empty ? n.sort_empty : n.sort;
            if ("function" == typeof o) return o.bind(this);
            const r = function(t, s) {
                return "$score" === t ? s.score : e.getAttrFn(i.items[s.id], t);
            };
            if (o) for (let t of o)(e.query || "$score" !== t.field) && s.push(t);
            if (e.query) {
                t = !0;
                for (let e of s)if ("$score" === e.field) {
                    t = !1;
                    break;
                }
                t && s.unshift({
                    field: "$score",
                    direction: "desc"
                });
            } else s = s.filter((e)=>"$score" !== e.field);
            return s.length ? function(e, t) {
                var i, n;
                for (let o of s){
                    if (n = o.field, i = ("desc" === o.direction ? -1 : 1) * E(r(n, e), r(n, t))) return i;
                }
                return 0;
            } : null;
        }
        prepareSearch(e, t) {
            const s = {};
            var i = Object.assign({}, t);
            if (F(i, "sort"), F(i, "sort_empty"), i.fields) {
                F(i, "fields");
                const e = [];
                i.fields.forEach((t)=>{
                    "string" == typeof t && (t = {
                        field: t,
                        weight: 1
                    }), e.push(t), s[t.field] = "weight" in t ? t.weight : 1;
                }), i.fields = e;
            }
            return {
                options: i,
                query: e.toLowerCase().trim(),
                tokens: this.tokenize(e, i.respect_word_boundaries, s),
                total: 0,
                items: [],
                weights: s,
                getAttrFn: i.nesting ? k : A
            };
        }
        search(e, t) {
            var s, i, n = this;
            i = this.prepareSearch(e, t), t = i.options, e = i.query;
            const o = t.score || n._getScoreFunction(i);
            e.length ? L(n.items, (e, n)=>{
                s = o(e), (!1 === t.filter || s > 0) && i.items.push({
                    score: s,
                    id: n
                });
            }) : L(n.items, (e, t)=>{
                i.items.push({
                    score: 1,
                    id: t
                });
            });
            const r = n._getSortFunction(i);
            return r && i.items.sort(r), i.total = i.items.length, "number" == typeof t.limit && (i.items = i.items.slice(0, t.limit)), i;
        }
    }
    const P = (e)=>null == e ? null : N(e), N = (e)=>"boolean" == typeof e ? e ? "1" : "0" : e + "", j = (e)=>(e + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;"), $ = (e, t)=>{
        var s;
        return function(i, n) {
            var o = this;
            s && (o.loading = Math.max(o.loading - 1, 0), clearTimeout(s)), s = setTimeout(function() {
                s = null, o.loadedSearches[i] = !0, e.call(o, i, n);
            }, t);
        };
    }, V = (e, t, s)=>{
        var i, n = e.trigger, o = {};
        for (i of (e.trigger = function() {
            var s = arguments[0];
            if (-1 === t.indexOf(s)) return n.apply(e, arguments);
            o[s] = arguments;
        }, s.apply(e, []), e.trigger = n, t))i in o && n.apply(e, o[i]);
    }, q = (e, t = !1)=>{
        e && (e.preventDefault(), t && e.stopPropagation());
    }, D = (e, t, s, i)=>{
        e.addEventListener(t, s, i);
    }, H = (e, t)=>!!t && !!t[e] && 1 === (t.altKey ? 1 : 0) + (t.ctrlKey ? 1 : 0) + (t.shiftKey ? 1 : 0) + (t.metaKey ? 1 : 0), R = (e, t)=>{
        const s = e.getAttribute("id");
        return s || (e.setAttribute("id", t), t);
    }, M = (e)=>e.replace(/[\\"']/g, "\\$&"), z = (e, t)=>{
        t && e.append(t);
    }, B = (e, t)=>{
        if (Array.isArray(e)) e.forEach(t);
        else for(var s in e)e.hasOwnProperty(s) && t(e[s], s);
    }, K = (e)=>{
        if (e.jquery) return e[0];
        if (e instanceof HTMLElement) return e;
        if (Q(e)) {
            var t = document.createElement("template");
            return t.innerHTML = e.trim(), t.content.firstChild;
        }
        return document.querySelector(e);
    }, Q = (e)=>"string" == typeof e && e.indexOf("<") > -1, G = (e, t)=>{
        var s = document.createEvent("HTMLEvents");
        s.initEvent(t, !0, !1), e.dispatchEvent(s);
    }, U = (e, t)=>{
        Object.assign(e.style, t);
    }, J = (e, ...t)=>{
        var s = X(t);
        (e = Y(e)).map((e)=>{
            s.map((t)=>{
                e.classList.add(t);
            });
        });
    }, W = (e, ...t)=>{
        var s = X(t);
        (e = Y(e)).map((e)=>{
            s.map((t)=>{
                e.classList.remove(t);
            });
        });
    }, X = (e)=>{
        var t = [];
        return B(e, (e)=>{
            "string" == typeof e && (e = e.trim().split(/[\t\n\f\r\s]/)), Array.isArray(e) && (t = t.concat(e));
        }), t.filter(Boolean);
    }, Y = (e)=>(Array.isArray(e) || (e = [
            e
        ]), e), Z = (e, t, s)=>{
        if (!s || s.contains(e)) for(; e && e.matches;){
            if (e.matches(t)) return e;
            e = e.parentNode;
        }
    }, ee = (e, t = 0)=>t > 0 ? e[e.length - 1] : e[0], te = (e, t)=>{
        if (!e) return -1;
        t = t || e.nodeName;
        for(var s = 0; e = e.previousElementSibling;)e.matches(t) && s++;
        return s;
    }, se = (e, t)=>{
        B(t, (t, s)=>{
            null == t ? e.removeAttribute(s) : e.setAttribute(s, "" + t);
        });
    }, ie = (e, t)=>{
        e.parentNode && e.parentNode.replaceChild(t, e);
    }, ne = (e, t)=>{
        if (null === t) return;
        if ("string" == typeof t) {
            if (!t.length) return;
            t = new RegExp(t, "i");
        }
        const s = (e)=>3 === e.nodeType ? ((e)=>{
                var s = e.data.match(t);
                if (s && e.data.length > 0) {
                    var i = document.createElement("span");
                    i.className = "highlight";
                    var n = e.splitText(s.index);
                    n.splitText(s[0].length);
                    var o = n.cloneNode(!0);
                    return i.appendChild(o), ie(n, i), 1;
                }
                return 0;
            })(e) : (((e)=>{
                1 !== e.nodeType || !e.childNodes || /(script|style)/i.test(e.tagName) || "highlight" === e.className && "SPAN" === e.tagName || Array.from(e.childNodes).forEach((e)=>{
                    s(e);
                });
            })(e), 0);
        s(e);
    }, oe = "undefined" != typeof navigator && /Mac/.test(navigator.userAgent) ? "metaKey" : "ctrlKey";
    var re = {
        options: [],
        optgroups: [],
        plugins: [],
        delimiter: ",",
        splitOn: null,
        persist: !0,
        diacritics: !0,
        create: null,
        createOnBlur: !1,
        createFilter: null,
        highlight: !0,
        openOnFocus: !0,
        shouldOpen: null,
        maxOptions: 50,
        maxItems: null,
        hideSelected: null,
        duplicates: !1,
        addPrecedence: !1,
        selectOnTab: !1,
        preload: null,
        allowEmptyOption: !1,
        refreshThrottle: 300,
        loadThrottle: 300,
        loadingClass: "loading",
        dataAttr: null,
        optgroupField: "optgroup",
        valueField: "value",
        labelField: "text",
        disabledField: "disabled",
        optgroupLabelField: "label",
        optgroupValueField: "value",
        lockOptgroupOrder: !1,
        sortField: "$order",
        searchField: [
            "text"
        ],
        searchConjunction: "and",
        mode: null,
        wrapperClass: "ts-wrapper",
        controlClass: "ts-control",
        dropdownClass: "ts-dropdown",
        dropdownContentClass: "ts-dropdown-content",
        itemClass: "item",
        optionClass: "option",
        dropdownParent: null,
        controlInput: '<input type="text" autocomplete="off" size="1" />',
        copyClassesToDropdown: !1,
        placeholder: null,
        hidePlaceholder: null,
        shouldLoad: function(e) {
            return e.length > 0;
        },
        render: {}
    };
    function le(e, t) {
        var s = Object.assign({}, re, t), i = s.dataAttr, n = s.labelField, o = s.valueField, r = s.disabledField, l = s.optgroupField, a = s.optgroupLabelField, c = s.optgroupValueField, d = e.tagName.toLowerCase(), u = e.getAttribute("placeholder") || e.getAttribute("data-placeholder");
        if (!u && !s.allowEmptyOption) {
            let t = e.querySelector('option[value=""]');
            t && (u = t.textContent);
        }
        var p = {
            placeholder: u,
            options: [],
            optgroups: [],
            items: [],
            maxItems: null
        };
        return "select" === d ? (()=>{
            var t, d = p.options, u = {}, h = 1;
            let g = 0;
            var f = (e)=>{
                var t = Object.assign({}, e.dataset), s = i && t[i];
                return "string" == typeof s && s.length && (t = Object.assign(t, JSON.parse(s))), t;
            }, m = (e, t)=>{
                var i = P(e.value);
                if (null != i && (i || s.allowEmptyOption)) {
                    if (u.hasOwnProperty(i)) {
                        if (t) {
                            var a = u[i][l];
                            a ? Array.isArray(a) ? a.push(t) : u[i][l] = [
                                a,
                                t
                            ] : u[i][l] = t;
                        }
                    } else {
                        var c = f(e);
                        c[n] = c[n] || e.textContent, c[o] = c[o] || i, c[r] = c[r] || e.disabled, c[l] = c[l] || t, c.$option = e, c.$order = c.$order || ++g, u[i] = c, d.push(c);
                    }
                    e.selected && p.items.push(i);
                }
            };
            p.maxItems = e.hasAttribute("multiple") ? null : 1, B(e.children, (e)=>{
                var s, i, n;
                "optgroup" === (t = e.tagName.toLowerCase()) ? ((n = f(s = e))[a] = n[a] || s.getAttribute("label") || "", n[c] = n[c] || h++, n[r] = n[r] || s.disabled, n.$order = n.$order || ++g, p.optgroups.push(n), i = n[c], B(s.children, (e)=>{
                    m(e, i);
                })) : "option" === t && m(e);
            });
        })() : (()=>{
            const t = e.getAttribute(i);
            if (t) p.options = JSON.parse(t), B(p.options, (e)=>{
                p.items.push(e[o]);
            });
            else {
                var r = e.value.trim() || "";
                if (!s.allowEmptyOption && !r.length) return;
                const t = r.split(s.delimiter);
                B(t, (e)=>{
                    const t = {};
                    t[n] = e, t[o] = e, p.options.push(t);
                }), p.items = t;
            }
        })(), Object.assign({}, re, p, t);
    }
    var ae = 0;
    class ce extends (function(e) {
        return e.plugins = {}, class extends e {
            constructor(...e){
                super(...e), this.plugins = {
                    names: [],
                    settings: {},
                    requested: {},
                    loaded: {}
                };
            }
            static define(t, s) {
                e.plugins[t] = {
                    name: t,
                    fn: s
                };
            }
            initializePlugins(e) {
                var t, s;
                const i = this, n = [];
                if (Array.isArray(e)) e.forEach((e)=>{
                    "string" == typeof e ? n.push(e) : (i.plugins.settings[e.name] = e.options, n.push(e.name));
                });
                else if (e) for(t in e)e.hasOwnProperty(t) && (i.plugins.settings[t] = e[t], n.push(t));
                for(; s = n.shift();)i.require(s);
            }
            loadPlugin(t) {
                var s = this, i = s.plugins, n = e.plugins[t];
                if (!e.plugins.hasOwnProperty(t)) throw new Error('Unable to find "' + t + '" plugin');
                i.requested[t] = !0, i.loaded[t] = n.fn.apply(s, [
                    s.plugins.settings[t] || {}
                ]), i.names.push(t);
            }
            require(e) {
                var t = this, s = t.plugins;
                if (!t.plugins.loaded.hasOwnProperty(e)) {
                    if (s.requested[e]) throw new Error('Plugin has circular dependency ("' + e + '")');
                    t.loadPlugin(e);
                }
                return s.loaded[e];
            }
        };
    })(t) {
        constructor(e, t){
            var s;
            super(), this.order = 0, this.isOpen = !1, this.isDisabled = !1, this.isReadOnly = !1, this.isInvalid = !1, this.isValid = !0, this.isLocked = !1, this.isFocused = !1, this.isInputHidden = !1, this.isSetup = !1, this.ignoreFocus = !1, this.ignoreHover = !1, this.hasOptions = !1, this.lastValue = "", this.caretPos = 0, this.loading = 0, this.loadedSearches = {}, this.activeOption = null, this.activeItems = [], this.optgroups = {}, this.options = {}, this.userOptions = {}, this.items = [], this.refreshTimeout = null, ae++;
            var i = K(e);
            if (i.tomselect) throw new Error("Tom Select already initialized on this element");
            i.tomselect = this, s = (window.getComputedStyle && window.getComputedStyle(i, null)).getPropertyValue("direction");
            const n = le(i, t);
            this.settings = n, this.input = i, this.tabIndex = i.tabIndex || 0, this.is_select_tag = "select" === i.tagName.toLowerCase(), this.rtl = /rtl/i.test(s), this.inputId = R(i, "tomselect-" + ae), this.isRequired = i.required, this.sifter = new T(this.options, {
                diacritics: n.diacritics
            }), n.mode = n.mode || (1 === n.maxItems ? "single" : "multi"), "boolean" != typeof n.hideSelected && (n.hideSelected = "multi" === n.mode), "boolean" != typeof n.hidePlaceholder && (n.hidePlaceholder = "multi" !== n.mode);
            var o = n.createFilter;
            "function" != typeof o && ("string" == typeof o && (o = new RegExp(o)), o instanceof RegExp ? n.createFilter = (e)=>o.test(e) : n.createFilter = (e)=>this.settings.duplicates || !this.options[e]), this.initializePlugins(n.plugins), this.setupCallbacks(), this.setupTemplates();
            const r = K("<div>"), l = K("<div>"), a = this._render("dropdown"), c = K('<div role="listbox" tabindex="-1">'), d = this.input.getAttribute("class") || "", u = n.mode;
            var p;
            if (J(r, n.wrapperClass, d, u), J(l, n.controlClass), z(r, l), J(a, n.dropdownClass, u), n.copyClassesToDropdown && J(a, d), J(c, n.dropdownContentClass), z(a, c), K(n.dropdownParent || r).appendChild(a), Q(n.controlInput)) {
                p = K(n.controlInput);
                B([
                    "autocorrect",
                    "autocapitalize",
                    "autocomplete",
                    "spellcheck"
                ], (e)=>{
                    i.getAttribute(e) && se(p, {
                        [e]: i.getAttribute(e)
                    });
                }), p.tabIndex = -1, l.appendChild(p), this.focus_node = p;
            } else n.controlInput ? (p = K(n.controlInput), this.focus_node = p) : (p = K("<input/>"), this.focus_node = l);
            this.wrapper = r, this.dropdown = a, this.dropdown_content = c, this.control = l, this.control_input = p, this.setup();
        }
        setup() {
            const e = this, t = e.settings, s = e.control_input, i = e.dropdown, n = e.dropdown_content, o = e.wrapper, l = e.control, a = e.input, c = e.focus_node, d = {
                passive: !0
            }, u = e.inputId + "-ts-dropdown";
            se(n, {
                id: u
            }), se(c, {
                role: "combobox",
                "aria-haspopup": "listbox",
                "aria-expanded": "false",
                "aria-controls": u
            });
            const p = R(c, e.inputId + "-ts-control"), h = "label[for='" + ((e)=>e.replace(/['"\\]/g, "\\$&"))(e.inputId) + "']", g = document.querySelector(h), f = e.focus.bind(e);
            if (g) {
                D(g, "click", f), se(g, {
                    for: p
                });
                const t = R(g, e.inputId + "-ts-label");
                se(c, {
                    "aria-labelledby": t
                }), se(n, {
                    "aria-labelledby": t
                });
            }
            if (o.style.width = a.style.width, e.plugins.names.length) {
                const t = "plugin-" + e.plugins.names.join(" plugin-");
                J([
                    o,
                    i
                ], t);
            }
            (null === t.maxItems || t.maxItems > 1) && e.is_select_tag && se(a, {
                multiple: "multiple"
            }), t.placeholder && se(s, {
                placeholder: t.placeholder
            }), !t.splitOn && t.delimiter && (t.splitOn = new RegExp("\\s*" + r(t.delimiter) + "+\\s*")), t.load && t.loadThrottle && (t.load = $(t.load, t.loadThrottle)), D(i, "mousemove", ()=>{
                e.ignoreHover = !1;
            }), D(i, "mouseenter", (t)=>{
                var s = Z(t.target, "[data-selectable]", i);
                s && e.onOptionHover(t, s);
            }, {
                capture: !0
            }), D(i, "click", (t)=>{
                const s = Z(t.target, "[data-selectable]");
                s && (e.onOptionSelect(t, s), q(t, !0));
            }), D(l, "click", (t)=>{
                var i = Z(t.target, "[data-ts-item]", l);
                i && e.onItemSelect(t, i) ? q(t, !0) : "" == s.value && (e.onClick(), q(t, !0));
            }), D(c, "keydown", (t)=>e.onKeyDown(t)), D(s, "keypress", (t)=>e.onKeyPress(t)), D(s, "input", (t)=>e.onInput(t)), D(c, "blur", (t)=>e.onBlur(t)), D(c, "focus", (t)=>e.onFocus(t)), D(s, "paste", (t)=>e.onPaste(t));
            const m = (t)=>{
                const n = t.composedPath()[0];
                if (!o.contains(n) && !i.contains(n)) return e.isFocused && e.blur(), void e.inputState();
                n == s && e.isOpen ? t.stopPropagation() : q(t, !0);
            }, v = ()=>{
                e.isOpen && e.positionDropdown();
            };
            D(document, "mousedown", m), D(window, "scroll", v, d), D(window, "resize", v, d), this._destroy = ()=>{
                document.removeEventListener("mousedown", m), window.removeEventListener("scroll", v), window.removeEventListener("resize", v), g && g.removeEventListener("click", f);
            }, this.revertSettings = {
                innerHTML: a.innerHTML,
                tabIndex: a.tabIndex
            }, a.tabIndex = -1, a.insertAdjacentElement("afterend", e.wrapper), e.sync(!1), t.items = [], delete t.optgroups, delete t.options, D(a, "invalid", ()=>{
                e.isValid && (e.isValid = !1, e.isInvalid = !0, e.refreshState());
            }), e.updateOriginalInput(), e.refreshItems(), e.close(!1), e.inputState(), e.isSetup = !0, a.disabled ? e.disable() : a.readOnly ? e.setReadOnly(!0) : e.enable(), e.on("change", this.onChange), J(a, "tomselected", "ts-hidden-accessible"), e.trigger("initialize"), !0 === t.preload && e.preload();
        }
        setupOptions(e = [], t = []) {
            this.addOptions(e), B(t, (e)=>{
                this.registerOptionGroup(e);
            });
        }
        setupTemplates() {
            var e = this, t = e.settings.labelField, s = e.settings.optgroupLabelField, i = {
                optgroup: (e)=>{
                    let t = document.createElement("div");
                    return t.className = "optgroup", t.appendChild(e.options), t;
                },
                optgroup_header: (e, t)=>'<div class="optgroup-header">' + t(e[s]) + "</div>",
                option: (e, s)=>"<div>" + s(e[t]) + "</div>",
                item: (e, s)=>"<div>" + s(e[t]) + "</div>",
                option_create: (e, t)=>'<div class="create">Add <strong>' + t(e.input) + "</strong>&hellip;</div>",
                no_results: ()=>'<div class="no-results">No results found</div>',
                loading: ()=>'<div class="spinner"></div>',
                not_loading: ()=>{},
                dropdown: ()=>"<div></div>"
            };
            e.settings.render = Object.assign({}, i, e.settings.render);
        }
        setupCallbacks() {
            var e, t, s = {
                initialize: "onInitialize",
                change: "onChange",
                item_add: "onItemAdd",
                item_remove: "onItemRemove",
                item_select: "onItemSelect",
                clear: "onClear",
                option_add: "onOptionAdd",
                option_remove: "onOptionRemove",
                option_clear: "onOptionClear",
                optgroup_add: "onOptionGroupAdd",
                optgroup_remove: "onOptionGroupRemove",
                optgroup_clear: "onOptionGroupClear",
                dropdown_open: "onDropdownOpen",
                dropdown_close: "onDropdownClose",
                type: "onType",
                load: "onLoad",
                focus: "onFocus",
                blur: "onBlur"
            };
            for(e in s)(t = this.settings[s[e]]) && this.on(e, t);
        }
        sync(e = !0) {
            const t = this, s = e ? le(t.input, {
                delimiter: t.settings.delimiter
            }) : t.settings;
            t.setupOptions(s.options, s.optgroups), t.setValue(s.items || [], !0), t.lastQuery = null;
        }
        onClick() {
            var e = this;
            if (e.activeItems.length > 0) return e.clearActiveItems(), void e.focus();
            e.isFocused && e.isOpen ? e.blur() : e.focus();
        }
        onMouseDown() {}
        onChange() {
            G(this.input, "input"), G(this.input, "change");
        }
        onPaste(e) {
            var t = this;
            t.isInputHidden || t.isLocked ? q(e) : t.settings.splitOn && setTimeout(()=>{
                var e = t.inputValue();
                if (e.match(t.settings.splitOn)) {
                    var s = e.trim().split(t.settings.splitOn);
                    B(s, (e)=>{
                        P(e) && (this.options[e] ? t.addItem(e) : t.createItem(e));
                    });
                }
            }, 0);
        }
        onKeyPress(e) {
            var t = this;
            if (!t.isLocked) {
                var s = String.fromCharCode(e.keyCode || e.which);
                return t.settings.create && "multi" === t.settings.mode && s === t.settings.delimiter ? (t.createItem(), void q(e)) : void 0;
            }
            q(e);
        }
        onKeyDown(e) {
            var t = this;
            if (t.ignoreHover = !0, t.isLocked) 9 !== e.keyCode && q(e);
            else {
                switch(e.keyCode){
                    case 65:
                        if (H(oe, e) && "" == t.control_input.value) return q(e), void t.selectAll();
                        break;
                    case 27:
                        return t.isOpen && (q(e, !0), t.close()), void t.clearActiveItems();
                    case 40:
                        if (!t.isOpen && t.hasOptions) t.open();
                        else if (t.activeOption) {
                            let e = t.getAdjacent(t.activeOption, 1);
                            e && t.setActiveOption(e);
                        }
                        return void q(e);
                    case 38:
                        if (t.activeOption) {
                            let e = t.getAdjacent(t.activeOption, -1);
                            e && t.setActiveOption(e);
                        }
                        return void q(e);
                    case 13:
                        return void (t.canSelect(t.activeOption) ? (t.onOptionSelect(e, t.activeOption), q(e)) : (t.settings.create && t.createItem() || document.activeElement == t.control_input && t.isOpen) && q(e));
                    case 37:
                        return void t.advanceSelection(-1, e);
                    case 39:
                        return void t.advanceSelection(1, e);
                    case 9:
                        return void (t.settings.selectOnTab && (t.canSelect(t.activeOption) && (t.onOptionSelect(e, t.activeOption), q(e)), t.settings.create && t.createItem() && q(e)));
                    case 8:
                    case 46:
                        return void t.deleteSelection(e);
                }
                t.isInputHidden && !H(oe, e) && q(e);
            }
        }
        onInput(e) {
            if (this.isLocked) return;
            const t = this.inputValue();
            this.lastValue !== t && (this.lastValue = t, "" != t ? (this.refreshTimeout && window.clearTimeout(this.refreshTimeout), this.refreshTimeout = ((e, t)=>t > 0 ? window.setTimeout(e, t) : (e.call(null), null))(()=>{
                this.refreshTimeout = null, this._onInput();
            }, this.settings.refreshThrottle)) : this._onInput());
        }
        _onInput() {
            const e = this.lastValue;
            this.settings.shouldLoad.call(this, e) && this.load(e), this.refreshOptions(), this.trigger("type", e);
        }
        onOptionHover(e, t) {
            this.ignoreHover || this.setActiveOption(t, !1);
        }
        onFocus(e) {
            var t = this, s = t.isFocused;
            if (t.isDisabled || t.isReadOnly) return t.blur(), void q(e);
            t.ignoreFocus || (t.isFocused = !0, "focus" === t.settings.preload && t.preload(), s || t.trigger("focus"), t.activeItems.length || (t.inputState(), t.refreshOptions(!!t.settings.openOnFocus)), t.refreshState());
        }
        onBlur(e) {
            if (!1 !== document.hasFocus()) {
                var t = this;
                if (t.isFocused) {
                    t.isFocused = !1, t.ignoreFocus = !1;
                    var s = ()=>{
                        t.close(), t.setActiveItem(), t.setCaret(t.items.length), t.trigger("blur");
                    };
                    t.settings.create && t.settings.createOnBlur ? t.createItem(null, s) : s();
                }
            }
        }
        onOptionSelect(e, t) {
            var s, i = this;
            t.parentElement && t.parentElement.matches("[data-disabled]") || (t.classList.contains("create") ? i.createItem(null, ()=>{
                i.settings.closeAfterSelect && i.close();
            }) : void 0 !== (s = t.dataset.value) && (i.lastQuery = null, i.addItem(s), i.settings.closeAfterSelect && i.close(), !i.settings.hideSelected && e.type && /click/.test(e.type) && i.setActiveOption(t)));
        }
        canSelect(e) {
            return !!(this.isOpen && e && this.dropdown_content.contains(e));
        }
        onItemSelect(e, t) {
            var s = this;
            return !s.isLocked && "multi" === s.settings.mode && (q(e), s.setActiveItem(t, e), !0);
        }
        canLoad(e) {
            return !!this.settings.load && !this.loadedSearches.hasOwnProperty(e);
        }
        load(e) {
            const t = this;
            if (!t.canLoad(e)) return;
            J(t.wrapper, t.settings.loadingClass), t.loading++;
            const s = t.loadCallback.bind(t);
            t.settings.load.call(t, e, s);
        }
        loadCallback(e, t) {
            const s = this;
            s.loading = Math.max(s.loading - 1, 0), s.lastQuery = null, s.clearActiveOption(), s.setupOptions(e, t), s.refreshOptions(s.isFocused && !s.isInputHidden), s.loading || W(s.wrapper, s.settings.loadingClass), s.trigger("load", e, t);
        }
        preload() {
            var e = this.wrapper.classList;
            e.contains("preloaded") || (e.add("preloaded"), this.load(""));
        }
        setTextboxValue(e = "") {
            var t = this.control_input;
            t.value !== e && (t.value = e, G(t, "update"), this.lastValue = e);
        }
        getValue() {
            return this.is_select_tag && this.input.hasAttribute("multiple") ? this.items : this.items.join(this.settings.delimiter);
        }
        setValue(e, t) {
            V(this, t ? [] : [
                "change"
            ], ()=>{
                this.clear(t), this.addItems(e, t);
            });
        }
        setMaxItems(e) {
            0 === e && (e = null), this.settings.maxItems = e, this.refreshState();
        }
        setActiveItem(e, t) {
            var s, i, n, o, r, l, a = this;
            if ("single" !== a.settings.mode) {
                if (!e) return a.clearActiveItems(), void (a.isFocused && a.inputState());
                if ("click" === (s = t && t.type.toLowerCase()) && H("shiftKey", t) && a.activeItems.length) {
                    for(l = a.getLastActive(), (n = Array.prototype.indexOf.call(a.control.children, l)) > (o = Array.prototype.indexOf.call(a.control.children, e)) && (r = n, n = o, o = r), i = n; i <= o; i++)e = a.control.children[i], -1 === a.activeItems.indexOf(e) && a.setActiveItemClass(e);
                    q(t);
                } else "click" === s && H(oe, t) || "keydown" === s && H("shiftKey", t) ? e.classList.contains("active") ? a.removeActiveItem(e) : a.setActiveItemClass(e) : (a.clearActiveItems(), a.setActiveItemClass(e));
                a.inputState(), a.isFocused || a.focus();
            }
        }
        setActiveItemClass(e) {
            const t = this, s = t.control.querySelector(".last-active");
            s && W(s, "last-active"), J(e, "active last-active"), t.trigger("item_select", e), -1 == t.activeItems.indexOf(e) && t.activeItems.push(e);
        }
        removeActiveItem(e) {
            var t = this.activeItems.indexOf(e);
            this.activeItems.splice(t, 1), W(e, "active");
        }
        clearActiveItems() {
            W(this.activeItems, "active"), this.activeItems = [];
        }
        setActiveOption(e, t = !0) {
            e !== this.activeOption && (this.clearActiveOption(), e && (this.activeOption = e, se(this.focus_node, {
                "aria-activedescendant": e.getAttribute("id")
            }), se(e, {
                "aria-selected": "true"
            }), J(e, "active"), t && this.scrollToOption(e)));
        }
        scrollToOption(e, t) {
            if (!e) return;
            const s = this.dropdown_content, i = s.clientHeight, n = s.scrollTop || 0, o = e.offsetHeight, r = e.getBoundingClientRect().top - s.getBoundingClientRect().top + n;
            r + o > i + n ? this.scroll(r - i + o, t) : r < n && this.scroll(r, t);
        }
        scroll(e, t) {
            const s = this.dropdown_content;
            t && (s.style.scrollBehavior = t), s.scrollTop = e, s.style.scrollBehavior = "";
        }
        clearActiveOption() {
            this.activeOption && (W(this.activeOption, "active"), se(this.activeOption, {
                "aria-selected": null
            })), this.activeOption = null, se(this.focus_node, {
                "aria-activedescendant": null
            });
        }
        selectAll() {
            const e = this;
            if ("single" === e.settings.mode) return;
            const t = e.controlChildren();
            t.length && (e.inputState(), e.close(), e.activeItems = t, B(t, (t)=>{
                e.setActiveItemClass(t);
            }));
        }
        inputState() {
            var e = this;
            e.control.contains(e.control_input) && (se(e.control_input, {
                placeholder: e.settings.placeholder
            }), e.activeItems.length > 0 || !e.isFocused && e.settings.hidePlaceholder && e.items.length > 0 ? (e.setTextboxValue(), e.isInputHidden = !0) : (e.settings.hidePlaceholder && e.items.length > 0 && se(e.control_input, {
                placeholder: ""
            }), e.isInputHidden = !1), e.wrapper.classList.toggle("input-hidden", e.isInputHidden));
        }
        inputValue() {
            return this.control_input.value.trim();
        }
        focus() {
            var e = this;
            e.isDisabled || e.isReadOnly || (e.ignoreFocus = !0, e.control_input.offsetWidth ? e.control_input.focus() : e.focus_node.focus(), setTimeout(()=>{
                e.ignoreFocus = !1, e.onFocus();
            }, 0));
        }
        blur() {
            this.focus_node.blur(), this.onBlur();
        }
        getScoreFunction(e) {
            return this.sifter.getScoreFunction(e, this.getSearchOptions());
        }
        getSearchOptions() {
            var e = this.settings, t = e.sortField;
            return "string" == typeof e.sortField && (t = [
                {
                    field: e.sortField
                }
            ]), {
                fields: e.searchField,
                conjunction: e.searchConjunction,
                sort: t,
                nesting: e.nesting
            };
        }
        search(e) {
            var t, s, i = this, n = this.getSearchOptions();
            if (i.settings.score && "function" != typeof (s = i.settings.score.call(i, e))) throw new Error('Tom Select "score" setting must be a function that returns a function');
            return e !== i.lastQuery ? (i.lastQuery = e, t = i.sifter.search(e, Object.assign(n, {
                score: s
            })), i.currentResults = t) : t = Object.assign({}, i.currentResults), i.settings.hideSelected && (t.items = t.items.filter((e)=>{
                let t = P(e.id);
                return !(t && -1 !== i.items.indexOf(t));
            })), t;
        }
        refreshOptions(e = !0) {
            var t, s, i, n, o, r, l, a, c, d;
            const u = {}, p = [];
            var h = this, g = h.inputValue();
            const f = g === h.lastQuery || "" == g && null == h.lastQuery;
            var m = h.search(g), v = null, y = h.settings.shouldOpen || !1, O = h.dropdown_content;
            f && (v = h.activeOption) && (c = v.closest("[data-group]")), n = m.items.length, "number" == typeof h.settings.maxOptions && (n = Math.min(n, h.settings.maxOptions)), n > 0 && (y = !0);
            const b = (e, t)=>{
                let s = u[e];
                if (void 0 !== s) {
                    let e = p[s];
                    if (void 0 !== e) return [
                        s,
                        e.fragment
                    ];
                }
                let i = document.createDocumentFragment();
                return s = p.length, p.push({
                    fragment: i,
                    order: t,
                    optgroup: e
                }), [
                    s,
                    i
                ];
            };
            for(t = 0; t < n; t++){
                let e = m.items[t];
                if (!e) continue;
                let n = e.id, l = h.options[n];
                if (void 0 === l) continue;
                let a = N(n), d = h.getOption(a, !0);
                for(h.settings.hideSelected || d.classList.toggle("selected", h.items.includes(a)), o = l[h.settings.optgroupField] || "", s = 0, i = (r = Array.isArray(o) ? o : [
                    o
                ]) && r.length; s < i; s++){
                    o = r[s];
                    let e = l.$order, t = h.optgroups[o];
                    void 0 === t ? o = "" : e = t.$order;
                    const [i, a] = b(o, e);
                    s > 0 && (d = d.cloneNode(!0), se(d, {
                        id: l.$id + "-clone-" + s,
                        "aria-selected": null
                    }), d.classList.add("ts-cloned"), W(d, "active"), h.activeOption && h.activeOption.dataset.value == n && c && c.dataset.group === o.toString() && (v = d)), a.appendChild(d), "" != o && (u[o] = i);
                }
            }
            var w;
            h.settings.lockOptgroupOrder && p.sort((e, t)=>e.order - t.order), l = document.createDocumentFragment(), B(p, (e)=>{
                let t = e.fragment, s = e.optgroup;
                if (!t || !t.children.length) return;
                let i = h.optgroups[s];
                if (void 0 !== i) {
                    let e = document.createDocumentFragment(), s = h.render("optgroup_header", i);
                    z(e, s), z(e, t);
                    let n = h.render("optgroup", {
                        group: i,
                        options: e
                    });
                    z(l, n);
                } else z(l, t);
            }), O.innerHTML = "", z(O, l), h.settings.highlight && (w = O.querySelectorAll("span.highlight"), Array.prototype.forEach.call(w, function(e) {
                var t = e.parentNode;
                t.replaceChild(e.firstChild, e), t.normalize();
            }), m.query.length && m.tokens.length && B(m.tokens, (e)=>{
                ne(O, e.regex);
            }));
            var _ = (e)=>{
                let t = h.render(e, {
                    input: g
                });
                return t && (y = !0, O.insertBefore(t, O.firstChild)), t;
            };
            if (h.loading ? _("loading") : h.settings.shouldLoad.call(h, g) ? 0 === m.items.length && _("no_results") : _("not_loading"), (a = h.canCreate(g)) && (d = _("option_create")), h.hasOptions = m.items.length > 0 || a, y) {
                if (m.items.length > 0) {
                    if (v || "single" !== h.settings.mode || null == h.items[0] || (v = h.getOption(h.items[0])), !O.contains(v)) {
                        let e = 0;
                        d && !h.settings.addPrecedence && (e = 1), v = h.selectable()[e];
                    }
                } else d && (v = d);
                e && !h.isOpen && (h.open(), h.scrollToOption(v, "auto")), h.setActiveOption(v);
            } else h.clearActiveOption(), e && h.isOpen && h.close(!1);
        }
        selectable() {
            return this.dropdown_content.querySelectorAll("[data-selectable]");
        }
        addOption(e, t = !1) {
            const s = this;
            if (Array.isArray(e)) return s.addOptions(e, t), !1;
            const i = P(e[s.settings.valueField]);
            return null !== i && !s.options.hasOwnProperty(i) && (e.$order = e.$order || ++s.order, e.$id = s.inputId + "-opt-" + e.$order, s.options[i] = e, s.lastQuery = null, t && (s.userOptions[i] = t, s.trigger("option_add", i, e)), i);
        }
        addOptions(e, t = !1) {
            B(e, (e)=>{
                this.addOption(e, t);
            });
        }
        registerOption(e) {
            return this.addOption(e);
        }
        registerOptionGroup(e) {
            var t = P(e[this.settings.optgroupValueField]);
            return null !== t && (e.$order = e.$order || ++this.order, this.optgroups[t] = e, t);
        }
        addOptionGroup(e, t) {
            var s;
            t[this.settings.optgroupValueField] = e, (s = this.registerOptionGroup(t)) && this.trigger("optgroup_add", s, t);
        }
        removeOptionGroup(e) {
            this.optgroups.hasOwnProperty(e) && (delete this.optgroups[e], this.clearCache(), this.trigger("optgroup_remove", e));
        }
        clearOptionGroups() {
            this.optgroups = {}, this.clearCache(), this.trigger("optgroup_clear");
        }
        updateOption(e, t) {
            const s = this;
            var i, n;
            const o = P(e), r = P(t[s.settings.valueField]);
            if (null === o) return;
            const l = s.options[o];
            if (null == l) return;
            if ("string" != typeof r) throw new Error("Value must be set in option data");
            const a = s.getOption(o), c = s.getItem(o);
            if (t.$order = t.$order || l.$order, delete s.options[o], s.uncacheValue(r), s.options[r] = t, a) {
                if (s.dropdown_content.contains(a)) {
                    const e = s._render("option", t);
                    ie(a, e), s.activeOption === a && s.setActiveOption(e);
                }
                a.remove();
            }
            c && (-1 !== (n = s.items.indexOf(o)) && s.items.splice(n, 1, r), i = s._render("item", t), c.classList.contains("active") && J(i, "active"), ie(c, i)), s.lastQuery = null;
        }
        removeOption(e, t) {
            const s = this;
            e = N(e), s.uncacheValue(e), delete s.userOptions[e], delete s.options[e], s.lastQuery = null, s.trigger("option_remove", e), s.removeItem(e, t);
        }
        clearOptions(e) {
            const t = (e || this.clearFilter).bind(this);
            this.loadedSearches = {}, this.userOptions = {}, this.clearCache();
            const s = {};
            B(this.options, (e, i)=>{
                t(e, i) && (s[i] = e);
            }), this.options = this.sifter.items = s, this.lastQuery = null, this.trigger("option_clear");
        }
        clearFilter(e, t) {
            return this.items.indexOf(t) >= 0;
        }
        getOption(e, t = !1) {
            const s = P(e);
            if (null === s) return null;
            const i = this.options[s];
            if (null != i) {
                if (i.$div) return i.$div;
                if (t) return this._render("option", i);
            }
            return null;
        }
        getAdjacent(e, t, s = "option") {
            var i;
            if (!e) return null;
            i = "item" == s ? this.controlChildren() : this.dropdown_content.querySelectorAll("[data-selectable]");
            for(let s = 0; s < i.length; s++)if (i[s] == e) return t > 0 ? i[s + 1] : i[s - 1];
            return null;
        }
        getItem(e) {
            if ("object" == typeof e) return e;
            var t = P(e);
            return null !== t ? this.control.querySelector(`[data-value="${M(t)}"]`) : null;
        }
        addItems(e, t) {
            var s = this, i = Array.isArray(e) ? e : [
                e
            ];
            const n = (i = i.filter((e)=>-1 === s.items.indexOf(e)))[i.length - 1];
            i.forEach((e)=>{
                s.isPending = e !== n, s.addItem(e, t);
            });
        }
        addItem(e, t) {
            V(this, t ? [] : [
                "change",
                "dropdown_close"
            ], ()=>{
                var s, i;
                const n = this, o = n.settings.mode, r = P(e);
                if ((!r || -1 === n.items.indexOf(r) || ("single" === o && n.close(), "single" !== o && n.settings.duplicates)) && null !== r && n.options.hasOwnProperty(r) && ("single" === o && n.clear(t), "multi" !== o || !n.isFull())) {
                    if (s = n._render("item", n.options[r]), n.control.contains(s) && (s = s.cloneNode(!0)), i = n.isFull(), n.items.splice(n.caretPos, 0, r), n.insertAtCaret(s), n.isSetup) {
                        if (!n.isPending && n.settings.hideSelected) {
                            let e = n.getOption(r), t = n.getAdjacent(e, 1);
                            t && n.setActiveOption(t);
                        }
                        n.isPending || n.settings.closeAfterSelect || n.refreshOptions(n.isFocused && "single" !== o), 0 != n.settings.closeAfterSelect && n.isFull() ? n.close() : n.isPending || n.positionDropdown(), n.trigger("item_add", r, s), n.isPending || n.updateOriginalInput({
                            silent: t
                        });
                    }
                    (!n.isPending || !i && n.isFull()) && (n.inputState(), n.refreshState());
                }
            });
        }
        removeItem(e = null, t) {
            const s = this;
            if (!(e = s.getItem(e))) return;
            var i, n;
            const o = e.dataset.value;
            i = te(e), e.remove(), e.classList.contains("active") && (n = s.activeItems.indexOf(e), s.activeItems.splice(n, 1), W(e, "active")), s.items.splice(i, 1), s.lastQuery = null, !s.settings.persist && s.userOptions.hasOwnProperty(o) && s.removeOption(o, t), i < s.caretPos && s.setCaret(s.caretPos - 1), s.updateOriginalInput({
                silent: t
            }), s.refreshState(), s.positionDropdown(), s.trigger("item_remove", o, e);
        }
        createItem(e = null, t = ()=>{}) {
            3 === arguments.length && (t = arguments[2]), "function" != typeof t && (t = ()=>{});
            var s, i = this, n = i.caretPos;
            if (e = e || i.inputValue(), !i.canCreate(e)) return t(), !1;
            i.lock();
            var o = !1, r = (e)=>{
                if (i.unlock(), !e || "object" != typeof e) return t();
                var s = P(e[i.settings.valueField]);
                if ("string" != typeof s) return t();
                i.setTextboxValue(), i.addOption(e, !0), i.setCaret(n), i.addItem(s), t(e), o = !0;
            };
            return s = "function" == typeof i.settings.create ? i.settings.create.call(this, e, r) : {
                [i.settings.labelField]: e,
                [i.settings.valueField]: e
            }, o || r(s), !0;
        }
        refreshItems() {
            var e = this;
            e.lastQuery = null, e.isSetup && e.addItems(e.items), e.updateOriginalInput(), e.refreshState();
        }
        refreshState() {
            const e = this;
            e.refreshValidityState();
            const t = e.isFull(), s = e.isLocked;
            e.wrapper.classList.toggle("rtl", e.rtl);
            const i = e.wrapper.classList;
            var n;
            i.toggle("focus", e.isFocused), i.toggle("disabled", e.isDisabled), i.toggle("readonly", e.isReadOnly), i.toggle("required", e.isRequired), i.toggle("invalid", !e.isValid), i.toggle("locked", s), i.toggle("full", t), i.toggle("input-active", e.isFocused && !e.isInputHidden), i.toggle("dropdown-active", e.isOpen), i.toggle("has-options", (n = e.options, 0 === Object.keys(n).length)), i.toggle("has-items", e.items.length > 0);
        }
        refreshValidityState() {
            var e = this;
            e.input.validity && (e.isValid = e.input.validity.valid, e.isInvalid = !e.isValid);
        }
        isFull() {
            return null !== this.settings.maxItems && this.items.length >= this.settings.maxItems;
        }
        updateOriginalInput(e = {}) {
            const t = this;
            var s, i;
            const n = t.input.querySelector('option[value=""]');
            if (t.is_select_tag) {
                const o = [], r = t.input.querySelectorAll("option:checked").length;
                function l(e, s, i) {
                    return e || (e = K('<option value="' + j(s) + '">' + j(i) + "</option>")), e != n && t.input.append(e), o.push(e), (e != n || r > 0) && (e.selected = !0), e;
                }
                t.input.querySelectorAll("option:checked").forEach((e)=>{
                    e.selected = !1;
                }), 0 == t.items.length && "single" == t.settings.mode ? l(n, "", "") : t.items.forEach((e)=>{
                    if (s = t.options[e], i = s[t.settings.labelField] || "", o.includes(s.$option)) l(t.input.querySelector(`option[value="${M(e)}"]:not(:checked)`), e, i);
                    else s.$option = l(s.$option, e, i);
                });
            } else t.input.value = t.getValue();
            t.isSetup && (e.silent || t.trigger("change", t.getValue()));
        }
        open() {
            var e = this;
            e.isLocked || e.isOpen || "multi" === e.settings.mode && e.isFull() || (e.isOpen = !0, se(e.focus_node, {
                "aria-expanded": "true"
            }), e.refreshState(), U(e.dropdown, {
                visibility: "hidden",
                display: "block"
            }), e.positionDropdown(), U(e.dropdown, {
                visibility: "visible",
                display: "block"
            }), e.focus(), e.trigger("dropdown_open", e.dropdown));
        }
        close(e = !0) {
            var t = this, s = t.isOpen;
            e && (t.setTextboxValue(), "single" === t.settings.mode && t.items.length && t.inputState()), t.isOpen = !1, se(t.focus_node, {
                "aria-expanded": "false"
            }), U(t.dropdown, {
                display: "none"
            }), t.settings.hideSelected && t.clearActiveOption(), t.refreshState(), s && t.trigger("dropdown_close", t.dropdown);
        }
        positionDropdown() {
            if ("body" === this.settings.dropdownParent) {
                var e = this.control, t = e.getBoundingClientRect(), s = e.offsetHeight + t.top + window.scrollY, i = t.left + window.scrollX;
                U(this.dropdown, {
                    width: t.width + "px",
                    top: s + "px",
                    left: i + "px"
                });
            }
        }
        clear(e) {
            var t = this;
            if (t.items.length) {
                var s = t.controlChildren();
                B(s, (e)=>{
                    t.removeItem(e, !0);
                }), t.inputState(), e || t.updateOriginalInput(), t.trigger("clear");
            }
        }
        insertAtCaret(e) {
            const t = this, s = t.caretPos, i = t.control;
            i.insertBefore(e, i.children[s] || null), t.setCaret(s + 1);
        }
        deleteSelection(e) {
            var t, s, i, n, o, r = this;
            t = e && 8 === e.keyCode ? -1 : 1, s = {
                start: (o = r.control_input).selectionStart || 0,
                length: (o.selectionEnd || 0) - (o.selectionStart || 0)
            };
            const l = [];
            if (r.activeItems.length) n = ee(r.activeItems, t), i = te(n), t > 0 && i++, B(r.activeItems, (e)=>l.push(e));
            else if ((r.isFocused || "single" === r.settings.mode) && r.items.length) {
                const e = r.controlChildren();
                let i;
                t < 0 && 0 === s.start && 0 === s.length ? i = e[r.caretPos - 1] : t > 0 && s.start === r.inputValue().length && (i = e[r.caretPos]), void 0 !== i && l.push(i);
            }
            if (!r.shouldDelete(l, e)) return !1;
            for(q(e, !0), void 0 !== i && r.setCaret(i); l.length;)r.removeItem(l.pop());
            return r.inputState(), r.positionDropdown(), r.refreshOptions(!1), !0;
        }
        shouldDelete(e, t) {
            const s = e.map((e)=>e.dataset.value);
            return !(!s.length || "function" == typeof this.settings.onDelete && !1 === this.settings.onDelete(s, t));
        }
        advanceSelection(e, t) {
            var s, i, n = this;
            n.rtl && (e *= -1), n.inputValue().length || (H(oe, t) || H("shiftKey", t) ? (i = (s = n.getLastActive(e)) ? s.classList.contains("active") ? n.getAdjacent(s, e, "item") : s : e > 0 ? n.control_input.nextElementSibling : n.control_input.previousElementSibling) && (i.classList.contains("active") && n.removeActiveItem(s), n.setActiveItemClass(i)) : n.moveCaret(e));
        }
        moveCaret(e) {}
        getLastActive(e) {
            let t = this.control.querySelector(".last-active");
            if (t) return t;
            var s = this.control.querySelectorAll(".active");
            return s ? ee(s, e) : void 0;
        }
        setCaret(e) {
            this.caretPos = this.items.length;
        }
        controlChildren() {
            return Array.from(this.control.querySelectorAll("[data-ts-item]"));
        }
        lock() {
            this.setLocked(!0);
        }
        unlock() {
            this.setLocked(!1);
        }
        setLocked(e = this.isReadOnly || this.isDisabled) {
            this.isLocked = e, this.refreshState();
        }
        disable() {
            this.setDisabled(!0), this.close();
        }
        enable() {
            this.setDisabled(!1);
        }
        setDisabled(e) {
            this.focus_node.tabIndex = e ? -1 : this.tabIndex, this.isDisabled = e, this.input.disabled = e, this.control_input.disabled = e, this.setLocked();
        }
        setReadOnly(e) {
            this.isReadOnly = e, this.input.readOnly = e, this.control_input.readOnly = e, this.setLocked();
        }
        destroy() {
            var e = this, t = e.revertSettings;
            e.trigger("destroy"), e.off(), e.wrapper.remove(), e.dropdown.remove(), e.input.innerHTML = t.innerHTML, e.input.tabIndex = t.tabIndex, W(e.input, "tomselected", "ts-hidden-accessible"), e._destroy(), delete e.input.tomselect;
        }
        render(e, t) {
            var s, i;
            const n = this;
            if ("function" != typeof this.settings.render[e]) return null;
            if (!(i = n.settings.render[e].call(this, t, j))) return null;
            if (i = K(i), "option" === e || "option_create" === e ? t[n.settings.disabledField] ? se(i, {
                "aria-disabled": "true"
            }) : se(i, {
                "data-selectable": ""
            }) : "optgroup" === e && (s = t.group[n.settings.optgroupValueField], se(i, {
                "data-group": s
            }), t.group[n.settings.disabledField] && se(i, {
                "data-disabled": ""
            })), "option" === e || "item" === e) {
                const s = N(t[n.settings.valueField]);
                se(i, {
                    "data-value": s
                }), "item" === e ? (J(i, n.settings.itemClass), se(i, {
                    "data-ts-item": ""
                })) : (J(i, n.settings.optionClass), se(i, {
                    role: "option",
                    id: t.$id
                }), t.$div = i, n.options[s] = t);
            }
            return i;
        }
        _render(e, t) {
            const s = this.render(e, t);
            if (null == s) throw "HTMLElement expected";
            return s;
        }
        clearCache() {
            B(this.options, (e)=>{
                e.$div && (e.$div.remove(), delete e.$div);
            });
        }
        uncacheValue(e) {
            const t = this.getOption(e);
            t && t.remove();
        }
        canCreate(e) {
            return this.settings.create && e.length > 0 && this.settings.createFilter.call(this, e);
        }
        hook(e, t, s) {
            var i = this, n = i[t];
            i[t] = function() {
                var t, o;
                return "after" === e && (t = n.apply(i, arguments)), o = s.apply(i, arguments), "instead" === e ? o : ("before" === e && (t = n.apply(i, arguments)), t);
            };
        }
    }
    return ce.define("change_listener", function() {
        D(this.input, "change", ()=>{
            this.sync();
        });
    }), ce.define("checkbox_options", function(e) {
        var t = this, s = t.onOptionSelect;
        t.settings.hideSelected = !1;
        const i = Object.assign({
            className: "tomselect-checkbox",
            checkedClassNames: void 0,
            uncheckedClassNames: void 0
        }, e);
        var n = function(e, t) {
            t ? (e.checked = !0, i.uncheckedClassNames && e.classList.remove(...i.uncheckedClassNames), i.checkedClassNames && e.classList.add(...i.checkedClassNames)) : (e.checked = !1, i.checkedClassNames && e.classList.remove(...i.checkedClassNames), i.uncheckedClassNames && e.classList.add(...i.uncheckedClassNames));
        }, o = function(e) {
            setTimeout(()=>{
                var t = e.querySelector("input." + i.className);
                t instanceof HTMLInputElement && n(t, e.classList.contains("selected"));
            }, 1);
        };
        t.hook("after", "setupTemplates", ()=>{
            var e = t.settings.render.option;
            t.settings.render.option = (s, o)=>{
                var r = K(e.call(t, s, o)), l = document.createElement("input");
                i.className && l.classList.add(i.className), l.addEventListener("click", function(e) {
                    q(e);
                }), l.type = "checkbox";
                const a = P(s[t.settings.valueField]);
                return n(l, !!(a && t.items.indexOf(a) > -1)), r.prepend(l), r;
            };
        }), t.on("item_remove", (e)=>{
            var s = t.getOption(e);
            s && (s.classList.remove("selected"), o(s));
        }), t.on("item_add", (e)=>{
            var s = t.getOption(e);
            s && o(s);
        }), t.hook("instead", "onOptionSelect", (e, i)=>{
            if (i.classList.contains("selected")) return i.classList.remove("selected"), t.removeItem(i.dataset.value), t.refreshOptions(), void q(e, !0);
            s.call(t, e, i), o(i);
        });
    }), ce.define("clear_button", function(e) {
        const t = this, s = Object.assign({
            className: "clear-button",
            title: "Clear All",
            html: (e)=>`<div class="${e.className}" title="${e.title}">&#10799;</div>`
        }, e);
        t.on("initialize", ()=>{
            var e = K(s.html(s));
            e.addEventListener("click", (e)=>{
                t.isLocked || (t.clear(), "single" === t.settings.mode && t.settings.allowEmptyOption && t.addItem(""), e.preventDefault(), e.stopPropagation());
            }), t.control.appendChild(e);
        });
    }), ce.define("drag_drop", function() {
        var e = this;
        if ("multi" !== e.settings.mode) return;
        var t = e.lock, s = e.unlock;
        let i, n = !0;
        e.hook("after", "setupTemplates", ()=>{
            var t = e.settings.render.item;
            e.settings.render.item = (s, o)=>{
                const r = K(t.call(e, s, o));
                se(r, {
                    draggable: "true"
                });
                const l = (e)=>{
                    e.preventDefault(), r.classList.add("ts-drag-over"), a(r, i);
                }, a = (e, t)=>{
                    var s, i, n;
                    void 0 !== t && (((e, t)=>{
                        do {
                            var s;
                            if (e == (t = null == (s = t) ? void 0 : s.previousElementSibling)) return !0;
                        }while (t && t.previousElementSibling);
                        return !1;
                    })(t, r) ? (i = t, null == (n = (s = e).parentNode) || n.insertBefore(i, s.nextSibling)) : ((e, t)=>{
                        var s;
                        null == (s = e.parentNode) || s.insertBefore(t, e);
                    })(e, t));
                };
                return D(r, "mousedown", (e)=>{
                    n || q(e), e.stopPropagation();
                }), D(r, "dragstart", (e)=>{
                    i = r, setTimeout(()=>{
                        r.classList.add("ts-dragging");
                    }, 0);
                }), D(r, "dragenter", l), D(r, "dragover", l), D(r, "dragleave", ()=>{
                    r.classList.remove("ts-drag-over");
                }), D(r, "dragend", ()=>{
                    var t;
                    document.querySelectorAll(".ts-drag-over").forEach((e)=>e.classList.remove("ts-drag-over")), null == (t = i) || t.classList.remove("ts-dragging"), i = void 0;
                    var s = [];
                    e.control.querySelectorAll("[data-value]").forEach((e)=>{
                        if (e.dataset.value) {
                            let t = e.dataset.value;
                            t && s.push(t);
                        }
                    }), e.setValue(s);
                }), r;
            };
        }), e.hook("instead", "lock", ()=>(n = !1, t.call(e))), e.hook("instead", "unlock", ()=>(n = !0, s.call(e)));
    }), ce.define("dropdown_header", function(e) {
        const t = this, s = Object.assign({
            title: "Untitled",
            headerClass: "dropdown-header",
            titleRowClass: "dropdown-header-title",
            labelClass: "dropdown-header-label",
            closeClass: "dropdown-header-close",
            html: (e)=>'<div class="' + e.headerClass + '"><div class="' + e.titleRowClass + '"><span class="' + e.labelClass + '">' + e.title + '</span><a class="' + e.closeClass + '">&times;</a></div></div>'
        }, e);
        t.on("initialize", ()=>{
            var e = K(s.html(s)), i = e.querySelector("." + s.closeClass);
            i && i.addEventListener("click", (e)=>{
                q(e, !0), t.close();
            }), t.dropdown.insertBefore(e, t.dropdown.firstChild);
        });
    }), ce.define("caret_position", function() {
        var e = this;
        e.hook("instead", "setCaret", (t)=>{
            "single" !== e.settings.mode && e.control.contains(e.control_input) ? (t = Math.max(0, Math.min(e.items.length, t))) == e.caretPos || e.isPending || e.controlChildren().forEach((s, i)=>{
                i < t ? e.control_input.insertAdjacentElement("beforebegin", s) : e.control.appendChild(s);
            }) : t = e.items.length, e.caretPos = t;
        }), e.hook("instead", "moveCaret", (t)=>{
            if (!e.isFocused) return;
            const s = e.getLastActive(t);
            if (s) {
                const i = te(s);
                e.setCaret(t > 0 ? i + 1 : i), e.setActiveItem(), W(s, "last-active");
            } else e.setCaret(e.caretPos + t);
        });
    }), ce.define("dropdown_input", function() {
        const e = this;
        e.settings.shouldOpen = !0, e.hook("before", "setup", ()=>{
            e.focus_node = e.control, J(e.control_input, "dropdown-input");
            const t = K('<div class="dropdown-input-wrap">');
            t.append(e.control_input), e.dropdown.insertBefore(t, e.dropdown.firstChild);
            const s = K('<input class="items-placeholder" tabindex="-1" />');
            s.placeholder = e.settings.placeholder || "", e.control.append(s);
        }), e.on("initialize", ()=>{
            e.control_input.addEventListener("keydown", (t)=>{
                switch(t.keyCode){
                    case 27:
                        return e.isOpen && (q(t, !0), e.close()), void e.clearActiveItems();
                    case 9:
                        e.focus_node.tabIndex = -1;
                }
                return e.onKeyDown.call(e, t);
            }), e.on("blur", ()=>{
                e.focus_node.tabIndex = e.isDisabled ? -1 : e.tabIndex;
            }), e.on("dropdown_open", ()=>{
                e.control_input.focus();
            });
            const t = e.onBlur;
            e.hook("instead", "onBlur", (s)=>{
                if (!s || s.relatedTarget != e.control_input) return t.call(e);
            }), D(e.control_input, "blur", ()=>e.onBlur()), e.hook("before", "close", ()=>{
                e.isOpen && e.focus_node.focus({
                    preventScroll: !0
                });
            });
        });
    }), ce.define("input_autogrow", function() {
        var e = this;
        e.on("initialize", ()=>{
            var t = document.createElement("span"), s = e.control_input;
            t.style.cssText = "position:absolute; top:-99999px; left:-99999px; width:auto; padding:0; white-space:pre; ", e.wrapper.appendChild(t);
            for (const e of [
                "letterSpacing",
                "fontSize",
                "fontFamily",
                "fontWeight",
                "textTransform"
            ])t.style[e] = s.style[e];
            var i = ()=>{
                t.textContent = s.value, s.style.width = t.clientWidth + "px";
            };
            i(), e.on("update item_add item_remove", i), D(s, "input", i), D(s, "keyup", i), D(s, "blur", i), D(s, "update", i);
        });
    }), ce.define("no_backspace_delete", function() {
        var e = this, t = e.deleteSelection;
        this.hook("instead", "deleteSelection", (s)=>!!e.activeItems.length && t.call(e, s));
    }), ce.define("no_active_items", function() {
        this.hook("instead", "setActiveItem", ()=>{}), this.hook("instead", "selectAll", ()=>{});
    }), ce.define("optgroup_columns", function() {
        var e = this, t = e.onKeyDown;
        e.hook("instead", "onKeyDown", (s)=>{
            var i, n, o, r;
            if (!e.isOpen || 37 !== s.keyCode && 39 !== s.keyCode) return t.call(e, s);
            e.ignoreHover = !0, r = Z(e.activeOption, "[data-group]"), i = te(e.activeOption, "[data-selectable]"), r && (r = 37 === s.keyCode ? r.previousSibling : r.nextSibling) && (n = (o = r.querySelectorAll("[data-selectable]"))[Math.min(o.length - 1, i)]) && e.setActiveOption(n);
        });
    }), ce.define("remove_button", function(e) {
        const t = Object.assign({
            label: "&times;",
            title: "Remove",
            className: "remove",
            append: !0
        }, e);
        var s = this;
        if (t.append) {
            var i = '<a href="javascript:void(0)" class="' + t.className + '" tabindex="-1" title="' + j(t.title) + '">' + t.label + "</a>";
            s.hook("after", "setupTemplates", ()=>{
                var e = s.settings.render.item;
                s.settings.render.item = (t, n)=>{
                    var o = K(e.call(s, t, n)), r = K(i);
                    return o.appendChild(r), D(r, "mousedown", (e)=>{
                        q(e, !0);
                    }), D(r, "click", (e)=>{
                        s.isLocked || (q(e, !0), s.isLocked || s.shouldDelete([
                            o
                        ], e) && (s.removeItem(o), s.refreshOptions(!1), s.inputState()));
                    }), o;
                };
            });
        }
    }), ce.define("restore_on_backspace", function(e) {
        const t = this, s = Object.assign({
            text: (e)=>e[t.settings.labelField]
        }, e);
        t.on("item_remove", function(e) {
            if (t.isFocused && "" === t.control_input.value.trim()) {
                var i = t.options[e];
                i && t.setTextboxValue(s.text.call(t, i));
            }
        });
    }), ce.define("virtual_scroll", function() {
        const e = this, t = e.canLoad, s = e.clearActiveOption, i = e.loadCallback;
        var n, o, r = {}, l = !1, a = [];
        if (e.settings.shouldLoadMore || (e.settings.shouldLoadMore = ()=>{
            if (n.clientHeight / (n.scrollHeight - n.scrollTop) > .9) return !0;
            if (e.activeOption) {
                var t = e.selectable();
                if (Array.from(t).indexOf(e.activeOption) >= t.length - 2) return !0;
            }
            return !1;
        }), !e.settings.firstUrl) throw "virtual_scroll plugin requires a firstUrl() method";
        e.settings.sortField = [
            {
                field: "$order"
            },
            {
                field: "$score"
            }
        ];
        const c = (t)=>!("number" == typeof e.settings.maxOptions && n.children.length >= e.settings.maxOptions) && !(!(t in r) || !r[t]), d = (t, s)=>e.items.indexOf(s) >= 0 || a.indexOf(s) >= 0;
        e.setNextUrl = (e, t)=>{
            r[e] = t;
        }, e.getUrl = (t)=>{
            if (t in r) {
                const e = r[t];
                return r[t] = !1, e;
            }
            return e.clearPagination(), e.settings.firstUrl.call(e, t);
        }, e.clearPagination = ()=>{
            r = {};
        }, e.hook("instead", "clearActiveOption", ()=>{
            if (!l) return s.call(e);
        }), e.hook("instead", "canLoad", (s)=>s in r ? c(s) : t.call(e, s)), e.hook("instead", "loadCallback", (t, s)=>{
            if (l) {
                if (o) {
                    const s = t[0];
                    void 0 !== s && (o.dataset.value = s[e.settings.valueField]);
                }
            } else e.clearOptions(d);
            i.call(e, t, s), l = !1;
        }), e.hook("after", "refreshOptions", ()=>{
            const t = e.lastValue;
            var s;
            c(t) ? (s = e.render("loading_more", {
                query: t
            })) && (s.setAttribute("data-selectable", ""), o = s) : t in r && !n.querySelector(".no-results") && (s = e.render("no_more_results", {
                query: t
            })), s && (J(s, e.settings.optionClass), n.append(s));
        }), e.on("initialize", ()=>{
            a = Object.keys(e.options), n = e.dropdown_content, e.settings.render = Object.assign({}, {
                loading_more: ()=>'<div class="loading-more-results">Loading more results ... </div>',
                no_more_results: ()=>'<div class="no-more-results">No more results</div>'
            }, e.settings.render), n.addEventListener("scroll", ()=>{
                e.settings.shouldLoadMore.call(e) && c(e.lastValue) && (l || (l = !0, e.load.call(e, e.lastValue)));
            });
        });
    }), ce;
});
var $873d83480dd9dfc8$var$tomSelect = function(e, t) {
    return new TomSelect(e, t);
};


var $244e729732b6045d$exports = {};











$244e729732b6045d$exports = {
    "_config": {},
    "a": {},
    "body": {},
    "header": {},
    "input": {},
    "label": {},
    "main": {},
    "nav": {},
    "select": {},
    "table": {},
    "textarea": {}
};


var $ddd6fae3d4cfd0de$exports = {};











$ddd6fae3d4cfd0de$exports = {
    "ckeditor": {},
    "daterangepicker": {},
    "izitoast": {},
    "jfilestyle": {},
    "pretty-checkbox": {},
    "remodal": {},
    "splide": {},
    "sweetalert2": {},
    "tablefilter": {},
    "tablesorter": {},
    "tom-select": {}
};


var $edb0510636fd4b0f$exports = {};

$edb0510636fd4b0f$exports = {
    "_layout": {}
};














window.App = {
    _common: (parcelRequire("1ISRg")).default,
    Index: (parcelRequire("84Cg4")).default,
    common: {
        Date: (parcelRequire("exbAN")).default,
        Form: (parcelRequire("aa4j7")).default,
        Helper: (parcelRequire("hA9uH")).default,
        Image: (parcelRequire("5hw4O")).default,
        Is: (parcelRequire("lSH1h")).default,
        Log: (parcelRequire("cAZeM")).default,
        Network: (parcelRequire("gIIrM")).default,
        Table: (parcelRequire("f1dSb")).default,
        Toast: (parcelRequire("jdFcE")).default,
        Ui: (parcelRequire("2S3Qm")).default
    }
};

})();
//# sourceMappingURL=bundle.js.map
